
customisationOptionController.$inject = ["$scope", "$mdDialog", "RestManager", "$mdToast", "Utils", "$rootScope"];(function () {
    'use strict';

    angular
        .module('app.materials', ['mdColorPicker']);
})(angular);

(function () {
    'use strict';
    stockReturned.$inject = ["$scope", "$mdDialog", "leasedQuantity", "materialId", "stockHistoryId", "batchId", "Materials", "$mdToast"];
    angular.module('app.materials')
        .controller("stockReturned.controller", stockReturned);

    function stockReturned($scope, $mdDialog, leasedQuantity, materialId, stockHistoryId, batchId, Materials,
                           $mdToast) {
        $scope.returnedStock = {
            batchId: batchId,
            leftQuantity: 0,
            stockHistoryId: stockHistoryId
        };
        $scope.fullyExhausted = true;
        $scope.leasedQuantity = leasedQuantity;

        console.log("stockReturned.js", "stockReturned", $scope.leasedQuantity);


        $scope.closeDialog = closeDialog;
        $scope.updateQuantity = updateQuantity;


        function closeDialog() {
            $mdDialog.cancel();
        }

        function updateQuantity() {
            if ($scope.fullyExhausted) {
                $scope.returnedStock.leftQuantity = 0;
            }
            $scope.returnedStock.updateType = 'lease';
            $scope.updating = true;
            Materials.editBatchStock(materialId, $scope.returnedStock)
                .then(function (res) {
                    console.log("stockReturned.js", "RES", res);
                    $scope.updating = false;
                    $mdDialog.hide({updatedData: res[0]});
                })
                .catch(function (err) {
                    $scope.updating = false;
                    $mdToast.showSimple('Error updating the stock : ' + err.message);
                })
        }
    }

})(angular);

/**
 * Created by Abhinav on 7/12/2019 at 3:34 pm
 * */

(function () {
    'use strict';
    addItemToPurchaseList.$inject = ["$scope", "$mdDialog", "newPurchase", "RestManager", "materialId", "$mdToast"];
    angular.module('app.materials')
        .controller('addItemToPurchaseList.controller', addItemToPurchaseList);

    function addItemToPurchaseList($scope, $mdDialog, newPurchase, RestManager, materialId, $mdToast) {
        $scope.newPurchase = newPurchase;
        console.log("addItemToPurchaseList.controller.js", "addItemToPurchaseList", newPurchase);
        $scope.addingItemToList = false;
        $scope.fetchingPreviousPurchases = false;
        $scope.minimumQuantity = null;
        $scope.maximumQuantity = null;
        $scope.dueDate = '';
        $scope.addedFor = '';
        $scope.priority = '';
        $scope.purchaseId = null;
        $scope.vendorSearch = '';
        $scope.loadingVendors = false;

        $scope.priorities = ["Urgent", "Normal"];


        $scope.close = close;
        $scope.addItemToList = addItemToList;
        $scope.fetchPreviousPurchases = fetchPreviousPurchases;
        $scope.selectMerchandiser = selectMerchandiser;
        $scope.fetchAllMerchandiser = fetchAllMerchandiser;
        $scope.setPriority = setPriority;
        $scope.fetchVendors = fetchVendors;
        $scope.setVendor = setVendor;

        function close() {
            $mdDialog.cancel();
        }

        function addItemToList() {
            $scope.addingItemToList = true;
            var payload = {
                minimumQuantity: $scope.minimumQuantity,
                maximumQuantity: $scope.maximumQuantity ? $scope.maximumQuantity : null,
                dueDate: $scope.dueDate,
                addedFor: {
                    _id: $scope.addedFor._id,
                    name: $scope.addedFor.name,
                    mobile: $scope.addedFor.mobile
                },
                material: materialId,
                purchaseId: $scope.purchaseId ? $scope.purchaseId : null,
                priority: $scope.priority,
                vendor: $scope.vendor ? $scope.vendor : null
            };
            RestManager.postResource('/purchaseList/createPurchaseList', payload, 'purchaseList', {
                service: 'scm'
            })
                .then(function (response) {
                    $scope.addingItemToList = false;
                    if (response) {
                        $mdToast.showSimple("New item added to purchase list");
                        $mdDialog.hide({newItem: response});
                    }
                })
                .catch(function (err) {
                    $scope.addingItemToList = false;
                    $mdDialog.hide();
                    $mdToast.showSimple("Error in adding new item to purchase list: " + err.message);
                });
        }

        function fetchPreviousPurchases() {
            $scope.fetchingPreviousPurchases = true;
            RestManager.getResource('/purchaseList', 'purchaseList', {
                query: {material: materialId},
                service: 'scm'
            })
                .then(function (response) {
                    $scope.fetchingPreviousPurchases = false;
                    $scope.listItems = response;
                })
                .catch(function (err) {
                    $scope.fetchingPreviousPurchases = false;
                    $mdToast.showSimple("Error in fetching list items :" + err.message);
                });
        }

        function selectMerchandiser(merchandiser) {
            $scope.addedFor = merchandiser;
        }

        function fetchAllMerchandiser() {
            var query = {
                roles: 'admin',
                page: 1,
                limit: 50
            };
            RestManager.getResource('/users/filter', 'users', {
                query: query
            })
                .then(function (response) {
                    $scope.merchandisers = response;
                })
                .catch(function (err) {
                    $mdToast.showSimple("Error in fetching Merchandisers: " + err.message);
                });
        }

        function setPriority(priority) {
            $scope.priority = priority;
        }

        function fetchVendors() {
            $scope.loadingVendors = true;
            RestManager.getResource('/vendors', 'vendors', {
                query: {
                    q: $scope.vendorSearch
                },
                service: 'scm'
            })
                .then(function (response) {
                    $scope.loadingVendors = false;
                    $scope.vendors = response;
                })
                .catch(function (err) {
                    $scope.loadingVendors = false;
                    $mdToast.showSimple("Error in fetching vendor with name, " + $scope.vendorSearch, +': ' + err.message);
                });

        }

        function setVendor(vendor){
            $scope.vendor = vendor;
        }


        $scope.fetchPreviousPurchases();
        $scope.fetchAllMerchandiser();
    }

})(angular);

(function () {
    'use strict';

    angular
        .module('app.tasks', []);

})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 12/03/20, 11:57 PM
 *
 */

(function () {
    'use strict';

    TaskUpdateTime.$inject = ["$scope", "$mdDialog", "Workforce", "$mdToast", "task", "RestManager", "Utils"];
    angular.module('app.tasks')
        .controller('task-update-time.dialog.controller', TaskUpdateTime);

    function TaskUpdateTime($scope, $mdDialog, Workforce, $mdToast, task, RestManager,
                            Utils) {
        $scope.timeUpdate = {
            days : 0
        };
        $scope.selectedReason = null;
        $scope.task = task;
        $scope.reasons = [
            {
                title: 'Estimated Incorrectly Initially',
                value: 'Estimated Incorrectly Initially'
            },
            {
                title: 'More important task was prioritised',
                value: 'More important task was prioritised'
            },
            {
                title: 'Operator requested time update',
                value: 'Operator requested time update'
            },
            {
                title: 'Others',
                showDescription: true,
                value: ''
            }
        ];

        $scope.cancel = cancel;
        $scope.updateTime = updateTime;

        $scope.updateTimeDuration = updateTimeDuration;

        function updateTimeDuration() {
            $scope.timeUpdate.duration = (((((($scope.timeUpdate.days || 0) * 24) + ($scope.timeUpdate.hours || 0)) * 60) + ($scope.timeUpdate.minutes || 0)) * 60);
            $scope.timeUpdate.updatedDurationObject = Utils.secondsToDHM($scope.timeUpdate.duration + $scope.task.allottedDuration);
        }

        function updateTime() {
            $scope.savingTime = true;
            RestManager.patchResource('/tasks/time', {
                comment: $scope.selectedReason.value,
                taskId : $scope.task._id,
                addedTime: $scope.timeUpdate.duration
            }, 'tasks', {service: 'workforce'})
                .then(function (tasks) {
                    $scope.savingTime = false;
                    $mdToast.showSimple('Updated time for task');
                    $mdDialog.hide(tasks[0])
                })
                .catch(function (error) {
                    $scope.savingTime = false;
                    $mdToast.showSimple('Error saving added time : ' + error.message);
                })
        }

        function cancel() {
            $mdDialog.cancel();
        }

        $scope.updateTimeDuration();
    }

})(angular);

(function () {
    'use strict';
    taskHistoryController.$inject = ["$scope", "$mdDialog", "notes"];
    angular.module('app.tasks')
        .controller('taskHistoryDialog.controller', taskHistoryController);

    function taskHistoryController($scope, $mdDialog, notes) {
        console.log("task-history-dialog.controller.js", "taskHistoryController", notes);
        $scope.notes = notes;

        $scope.close = close;

        function close() {
            $mdDialog.cancel();
        }
    }

})(angular);

/**
 * Created by kumardivyarajat on 04/12/16.
 */
angular.module("app.users", [])
    .controller("users.controller", ["$scope", "$log", function ($scope, $log) {
        $log.info("Entered Users Module");

        $scope.pageTitle = "";
        $scope.nestedState = false;
        $scope.backState = "app.home";
        $scope.backParams = null;
    }]);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 3/9/19 1:37 AM
 *
 */

(function () {
    'use strict';


    UserOffersController.$inject = ["$scope", "RestManager", "$state"];
    angular.module('app.users')
        .controller('user.details.offers.controller', UserOffersController);


    function UserOffersController($scope, RestManager, $state) {

        $scope.fetchGiftCards = fetchGiftCards;
        $scope.navigateGiftCard = navigateGiftCard;

        function navigateGiftCard(card) {
            if (card.code === 'dummy') {
                $state.go('app.offers.giftCards.add');
            } else {
                $state.go('app.offers.giftCards.details', {
                    cardId: card._id,
                    backState: 'app.users.details.offers',
                    backParams: JSON.stringify({userId: $scope.userId})
                })
            }
        }

        function fetchGiftCards() {
            var query = {
                user: $scope.userId
            };
            $scope.promise = RestManager.getResource("/giftCards/admin", "cards", {query: query, extras: ["total"]});

            $scope.promise
                .then(function (result) {
                    $scope.total = result.total;
                    $scope.cards = result.cards.map(function (card) {
                        card.code = card.code.replace(/-/g, ' ');
                        return card;
                    });
                    if (result.cards.length) {
                        $scope.cards.push({code: 'dummy'});
                    }
                })
                .catch(function (err) {
                    console.log(err);
                });
        }

        $scope.fetchGiftCards();
    }
})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 28/4/19 10:19 PM
 *
 */

(function () {
    'use strict';

    userDetailsTransactionsController.$inject = ["$scope", "RestManager", "$stateParams"];
    angular.module('app.users')
        .controller('user.details.transactions.controller', userDetailsTransactionsController);

    function userDetailsTransactionsController($scope, RestManager, $stateParams) {
        $scope.$parent.currentNavItem = 'transactions';

        $scope.fetchTransactions = fetchTransactions;

        function fetchTransactions() {
            RestManager.getResource("/txn/admin/user/" + $stateParams.userId, "transactions")
                .then(function (transactions) {
                    $scope.transactions = transactions;
                    console.log(transactions);
                })
                .catch(function (err) {
                    console.log(err);
                })
        }

        $scope.fetchTransactions();
    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 28/4/19 10:21 PM
 *
 */

(function () {
    'use strict';

    userDetailsOrdersController.$inject = ["$scope", "RestManager"];
    angular.module('app.users')
        .controller('user.details.orders.controller', userDetailsOrdersController);

    function userDetailsOrdersController($scope, RestManager) {

        var vm = this;
        vm.fetchingOrders = false;
        vm.user = $scope.user;
        $scope.$parent.currentNavItem = 'orders';

        vm.fetchOrders = fetchOrders;


        function fetchOrders() {
            vm.fetchingOrders = true;
            RestManager.postResource("/order/admin/getOrders", {
                page : 1,
                limit : 500,
                sort : '-createdAt',
                filter : {
                    user : $scope.userId
                }
            }, "orders")
                .then(function (orders) {
                    vm.fetchingOrders = false;
                    vm.orders = orders;
                    console.log('Orders', $scope.orders);
                })
                .catch(function (err) {
                    vm.fetchingOrders = false;
                    console.log(err);
                })
        }

        vm.fetchOrders();
    }

})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 29/02/20, 8:13 PM
 *
 */

(function () {
    'use strict';


    UserJobController.$inject = ["$scope", "RestManager", "$mdToast"];
    angular.module('app.users')
        .controller('user.details.job.controller', UserJobController);


    function UserJobController($scope, RestManager, $mdToast) {
        var vm = this;

        vm.meta = {
            canViewTasks: false,
            canStartTasks: true
        };
        vm.saving = false;
        vm.user = $scope.$parent.user;
        vm.tabs = [
            {title: 'All', value: 'all'},
            {title: 'Marking', value: 'marking'},
            {title: 'Embroidery', value: 'embroidery'},
            {title: 'Cutting', value: 'cutting'},
            {title: 'Stitching', value: 'stitching'},
            {title: 'Alteration', value: 'alteration'},
            {title: 'Tags Attachment', value: 'tags-attachment'}
        ];
        vm.fetchUserMeta = fetchUserMeta;
        vm.saveMeta = saveMeta;

        function saveMeta() {
            vm.saving = true;
            RestManager.patchResource('/user-meta/' + vm.user._id, vm.meta, 'meta', {
                service: 'workforce'
            })
                .then(function (meta) {
                    vm.saving = false;
                    vm.meta = meta[0];
                    $mdToast.showSimple('Updated Job Details');
                })
                .catch(function (err) {
                    vm.saving = false;
                    $mdToast.showSimple('Error updating the Job Details: ' + err.message);
                })
        }

        function fetchUserMeta() {
            RestManager.getResource('/user-meta/' + vm.user._id, 'meta', {
                service: 'workforce'
            })
                .then(function (meta) {
                    if (meta && meta.length) {
                        vm.meta = meta[0];
                    }
                })
                .catch(function (error) {

                })
        }

        vm.fetchUserMeta();
    }
})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 28/4/19 9:49 PM
 *
 */

(function () {
    'use strict';

    userDetailsHomeController.$inject = ["$scope", "RestManager", "$mdDialog"];
    angular.module('app.users')
        .controller('user.details.home.controller', userDetailsHomeController);

    function userDetailsHomeController($scope, RestManager, $mdDialog) {
        var vm = this;

        $scope.$parent.currentNavItem = 'home';
        vm.user = $scope.user;

        vm.fetchAddresses = fetchAddresses;
        vm.openUserEditDialog = openUserEditDialog;

        function fetchAddresses() {
            vm.addressQuery = {
                page: 1,
                limit: 10,
                user: vm.user._id
            };
            RestManager.getResource('/address/admin', 'address', {query: vm.addressQuery})
                .then(function (addresses) {
                    vm.addresses = addresses;
                    console.log('Addresses', vm.addresses);
                })
                .catch(function (err) {
                    console.log('Error fetching Addresses', err);
                })
        }

        function openUserEditDialog(event) {
            var user = {};
            angular.copy(vm.user, user);

            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true,
                locals: {
                    newUser: user
                },
                controller: 'add-users.controller',
                templateUrl: 'app/modules/users/dialogs/add-user/add-user.tmpl.html'
            })
                .then(function (result) {
                    if (result.user) {
                        vm.user = result.user;
                        vm.$parent.user = result.user;
                    }
                })
        }

        vm.fetchAddresses();
    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 28/4/19 10:17 PM
 *
 */

(function () {
    'use strict';

    userDetailsCartController.$inject = ["$scope", "RestManager", "$mdDialog"];
    angular.module('app.users')
        .controller('user.details.cart.controller', userDetailsCartController);

    function userDetailsCartController($scope, RestManager, $mdDialog) {
        $scope.$parent.currentNavItem = 'cart';
        $scope.fetchingCarts = false;
        $scope.query = {
            page: 1,
            limit: 25,
            sort: '-createdAt',
            user : $scope.userId
        };

        $scope.fetchCarts = fetchCarts;
        $scope.showProductListDialog = showProductListDialog;

        function fetchCarts() {
            $scope.fetchingCarts = true;
            RestManager.getResource("/cart/admin", "cart", {query: $scope.query, extras : ['total']})
                .then(function (result) {
                    console.log('asa', result);
                    $scope.fetchingCarts = false;
                    $scope.carts = result.cart;
                    $scope.total = result.total;
                    console.log('carts', $scope.carts);
                })
                .catch(function (err) {
                    $scope.fetchingCarts = false;
                    console.log(err);
                })
        }


        function showProductListDialog(cart) {
            $mdDialog.show({
                locals: {
                    products: cart.products
                },
                controller: "ProductListCtrl",
                fullscreen : true,
                templateUrl: 'app/modules/products/productListDialog/product-list.dialog.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true
            })
        }

        $scope.fetchCarts();
    }

})(angular);

(function () {
    'use strict';

    CustController.$inject = ["$scope", "RestManager", "Materials", "$mdDialog", "selectedMaterials", "Utils", "$mdToast", "Base"];
    angular.module('app.materials')
        .controller('materials-selector.controller', CustController);


    function CustController($scope, RestManager, Materials, $mdDialog, selectedMaterials, Utils, $mdToast, Base) {
        $scope.editing = !!selectedMaterials;

        $scope.selectedMaterials = selectedMaterials || [];
        $scope.mediaUrl = Base.getMediaUrl();
        $scope.hexCodes = [];
        $scope.hasFilters = false;
        $scope.colorNames = [];
        $scope.categories = [];
        $scope.fetchingFilters = false;
        $scope.query = {
            page: 1,
            limit: 25,
            search: '',
            order: '-updatedAt',
            hexCodes: [],
            category: [],
            colorNames : []
        };
        $scope.selectedMaterialsPanelCollapsed = false;

        $scope.cancel = cancel;
        $scope.save = save;
        $scope.fetchMaterials = fetchMaterials;
        $scope.selectMaterial = selectMaterial;
        $scope.updateStock = updateStock;
        $scope.removeMaterial = removeMaterial;
        $scope.checkIfHasToBeRemoved = checkIfHasToBeRemoved;
        $scope.fetchFilters = fetchFilters;
        $scope.toggleColor = toggleColor;
        $scope.toggleCategory = toggleCategory;
        $scope.clearFilters = clearFilters;
        $scope.capitalize = Utils.getProperName;

        function fetchMaterials() {
            //
            // if(!$scope.query.hexCodes.length) {
            //     delete $scope.query.hexCodes;
            // }

            $scope.hasFilters = !!($scope.query.category.length || $scope.query.hexCodes.length || $scope.query.colorNames.length);

            Materials.getAllMaterials($scope.query)
                .then(function (data) {
                    $scope.materials = data.materials.map(function (material) {
                        var foundMaterial = _.find($scope.selectedMaterials, function (m) {
                            return m.materialId === material._id;
                        });
                        if (foundMaterial) {
                            material.quantity = foundMaterial.quantity;
                            material.isSelected = true;
                        }
                        return material;
                    });
                    $scope.totalCount = data.total;
                })
                .catch(function (err) {
                    $scope.fetchError = err;
                })
        }

        function selectMaterial(material) {
            var isAlreadyPresent = _.findIndex($scope.selectedMaterials, function (m) {
                return m.materialId === material._id;
            });

            if (isAlreadyPresent === -1) {
                material.isSelected = true;
                material.quantity = 1;
                $scope.selectedMaterials.unshift({
                    materialId: material._id,
                    materialName: material.name,
                    image: material.image,
                    price: material.salePrice,
                    totalPrice: material.salePrice,
                    quantity: 1
                });
            }
        }

        function checkIfHasToBeRemoved(material, index) {
            material.totalPrice = _.round(material.quantity * material.price, 2);
            if (material.quantity <= 0) {
                $scope.removeMaterial(material, index);
            }
        }

        function updateStock(material, updateQuantity, $event, index) {
            $event.stopPropagation();
            material.quantity = material.quantity + updateQuantity;
            $scope.checkIfHasToBeRemoved(material, index);
        }

        function removeMaterial(material, index) {
            $scope.selectedMaterials.splice(index, 1);
            var listIndex = _.findIndex($scope.materials, function (m) {
                return m._id === material.materialId;
            });
            if (listIndex !== -1) {
                $scope.materials[listIndex].isSelected = false;
            }
        }

        function fetchFilters() {
            $scope.fetchingFilters = true;
            Materials.getMaterialFilters()
                .then(function (filters) {
                    var filter = filters[0];
                    $scope.hexCodes = filter.hexCodes;
                    $scope.categories = filter.categories;
                    $scope.colorNames = filter.colorNames;
                    $scope.fetchingFilters = false;
                })
                .catch(function (err) {
                    $scope.fetchingFilters = false;
                    console.log("materials-selector.dialog.js", "ERROR fetchFilters", err);
                })
        }

        function toggleColor(hexCode) {
            if (hexCode.selected) {
                $scope.query.hexCodes = _.remove($scope.query.hexCodes, function (h) {
                    return h === hexCode.color;
                })
            } else {
                $scope.query.hexCodes.push(hexCode.color.replace('#', ''));
            }
            hexCode.selected = !hexCode.selected;
            $scope.fetchMaterials();
        }

        function toggleCategory(category) {
            console.log("materials-selector.dialog.js", "toggleCategory", category.selected);
            if (category.selected) {
                var index = _.findIndex($scope.query.category, function (h) {
                    return h === category.id;
                });
                if (index !== -1) {
                    $scope.query.category.splice(index, 1);
                }
                console.log("materials-selector.dialog.js", "toggleCategory", $scope.query.category);
            } else {
                $scope.query.category.push(category.id);
            }
            category.selected = !category.selected;
            $scope.fetchMaterials();
        }

        function clearFilters() {
            $scope.query.category = [];
            $scope.query.hexCodes = [];
            $scope.query.colorNames = [];
            $scope.fetchMaterials();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function save() {
            $mdDialog.hide({selectedMaterials: $scope.selectedMaterials})
        }

        $scope.fetchMaterials();
        $scope.fetchFilters();
    }

})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 11/03/20, 2:32 PM
 *
 */

(function () {
    'use strict';

    MaterialController.$inject = ["$scope", "materialId", "Utils", "$mdMedia", "Materials", "$mdDialog"];
    angular.module('app.materials')
        .controller('material-quickview.controller', MaterialController);


    function MaterialController($scope, materialId, Utils, $mdMedia, Materials,
                                $mdDialog) {
        $scope.loadingMaterial = true;
        $scope.isSmall = !$mdMedia('gt-sm');


        $scope.close = close;
        $scope.dateAgo = Utils.dateAgo;
        $scope.fetchMaterial = fetchMaterial;
        $scope.selectImage = selectImage;
        $scope.gallery = [];

        function fetchMaterial() {
            Materials.getSingleMaterialById(materialId)
                .then(function (materials) {
                    $scope.loadingMaterial = false;
                    $scope.material = materials[0];
                    $scope.gallery.push({image: $scope.material.image, type: 'material', active: true});
                    $scope.selectedImage = $scope.material.image;
                    $scope.material.batches.forEach(function (batch) {
                        $scope.gallery.push({
                            image: batch.image,
                            type: 'batch',
                            id: batch._id,
                            code : batch.barcode,
                            active: false
                        });
                    });

                })
        }

        function selectImage(media, index) {
            $scope.selectedImage = media.image;
            $scope.gallery = $scope.gallery.map(function (g) {
                g.active = false;
                return g;
            });
            media.active = true;
        }

        function close() {
            $mdDialog.cancel();
        }

        $scope.fetchMaterial();
    }

})(angular);

(function () {
    'use strict';
    addVendorModel.$inject = ["$scope", "$mdDialog", "Materials", "vendor", "Utils"];
    angular.module("app.materials")
        .controller("addVendorModel.controller", addVendorModel);

    function addVendorModel($scope, $mdDialog, Materials, vendor, Utils) {

        $scope.vendor = vendor || {};
        console.log('!!vendor || (vendor && vendor._id)', !!vendor || (vendor && vendor._id))
        $scope.editingVendor = vendor && vendor._id;

        $scope.cancelDialog = cancelDialog;
        $scope.saveVendor = saveVendor;
        $scope.transform = transform;
        $scope.capitalize = capitalize;


        function capitalize() {
            $scope.vendor.name = Utils.capitalize($scope.vendor.name)
        }

        function transform() {
            console.log('Re', $scope.vendor.gstNumber);
            $scope.vendor.gstNumber = Utils.getProperName($scope.vendor.gstNumber);
        }

        function cancelDialog() {
            $mdDialog.cancel();
        }

        function saveVendor() {
            $scope.saving = true;
            var promises;
            if ($scope.editingVendor) {
                promises = Materials.editVendor($scope.vendor, $scope.vendor._id)
            } else {
                promises = Materials.saveVendor($scope.vendor);
            }

            promises
                .then(function (data) {
                    $scope.saving = false;
                    $mdDialog.hide({newVendor: data[0]});
                })
                .catch(function (err) {
                    $scope.saving = false;
                    console.log("addVendorModel.controller.js", "Error", err);
                });
        }

        if ($scope.vendor.name) {
            $scope.capitalize();
        }


    }

})(angular);

(function () {
    'use strict';

    addMaterialModelController.$inject = ["$scope", "$mdDialog", "Materials", "material", "Utils"];
    angular.module("app.materials")
        .controller("addMaterialModel.controller", addMaterialModelController);

    function addMaterialModelController($scope, $mdDialog, Materials, material, Utils) {
        $scope.material = material || {
            categorySearch: ''
        };
        $scope.editingMaterial = !!(material && material._id);
        $scope.parentCategories = [];
        $scope.rawCategories = [];
        $scope.categorySearch = '';
        $scope.showDuplicateConfirmation = false;

        $scope.cancelDialog = cancelDialog;
        $scope.saveMaterial = saveMaterial;
        $scope.fetchAllCategories = fetchAllCategories;
        $scope.openCategoryDialog = openCategoryDialog;
        $scope.detectDuplicates = detectDuplicates;
        $scope.denyDuplicate = denyDuplicate;
        $scope.acceptDuplicate = acceptDuplicate;
        $scope.capitalize = capitalize;

        function capitalize() {
            $scope.material.name = Utils.capitalize($scope.material.name)
        }


        function cancelDialog() {
            $mdDialog.cancel();
        }

        function fetchAllCategories() {
            var promises = Materials.getAllMaterialCategories({page: 1, limit: 100});

            promises
                .then(function (data) {
                    $scope.materialCategories = Utils.categoriesToTreeString(data);
                    console.log('Material Categories', $scope.materialCategories);
                    $scope.rawCategories = data;
                    $scope.parentCategories = $scope.materialCategories.filter(function (category) {
                        return !category.parent;
                    })
                })
                .catch(function (err) {
                    console.log("addMaterialModel.controller.js", "ERROR", err);
                });
        }

        function openCategoryDialog(event) {
            Materials.openCreateMaterialCategoryDialog(event, {
                category: null,
                editingIndex: null,
                parentCategory: null,
                parentCategories: $scope.parentCategories
            })
                .then(function (data) {
                    if (data.category) {
                        $scope.fetchAllCategories();
                    }
                })
        }


        function saveMaterial() {
            var promises;
            var payload = {};
            angular.copy($scope.material, payload);
            $scope.savingMaterial = true;
            payload.categoryString = Materials.generateCategoryString(payload, $scope.materialCategories);
            if (payload.image && payload.image._id) {
                payload.image = payload.image._id;
            }
            if (!$scope.editingMaterial) {
                payload.sku = 'DUMMY';
                promises = Materials.saveMaterial(payload);
            } else {
                promises = Materials.editMaterial(payload, $scope.material._id);
            }

            promises.then(function (result) {
                console.log("addMaterialModel.controller.js", "Result", result);
                $scope.savingMaterial = false;
                $mdDialog.hide({materials: result[0]});
            });
        }

        function detectDuplicates() {
            Materials.autoCompleteMaterialByName($scope.material.name)
                .then(function (results) {
                    if (results && results.length) {
                        $scope.duplicates = results;
                        $scope.showDuplicateConfirmation = true;
                    }
                })
                .catch(function (err) {
                    console.log(err)
                })
        }

        function acceptDuplicate() {
            $mdDialog.cancel();
        }

        function denyDuplicate() {
            $scope.showDuplicateConfirmation = false;
        }

        if ($scope.material && $scope.material.name) {
            $scope.capitalize();
        }

        $scope.fetchAllCategories();
    }
})(angular);

(function () {
    'use strict';
    addCategoryModel.$inject = ["$scope", "RestManager", "$mdToast", "Materials", "Utils", "parentCategory", "parentCategories", "category", "editingIndex", "$mdDialog"];
    angular.module("app.materials")
        .controller("addCategoryModel.controller", addCategoryModel);

    function addCategoryModel($scope, RestManager, $mdToast, Materials, Utils, parentCategory, parentCategories, category, editingIndex, $mdDialog) {

        $scope.newCategory = category || {
            name: '',
            parent: parentCategory
        };

        $scope.parentCategories = parentCategories;

        $scope.editingMode = !!category;

        $scope.cancelDialog = cancelDialog;
        $scope.saveCategory = saveCategory;
        $scope.capitalize = capitalize;

        function capitalize() {
            $scope.category.name = Utils.capitalize($scope.category.name)
        }

        function saveCategory(index) {
            var newCategory = {};
            angular.copy($scope.newCategory, newCategory);

            if (!newCategory.parent) {
                delete newCategory.parent;
            }

            delete newCategory.children;

            $scope.saving = true;

            if ($scope.editingMode) {
                $scope.promise = RestManager.putResource("/materialCategories/" + newCategory._id, newCategory, "categories", {service: 'scm'});
            } else {
                $scope.promise = RestManager.postResource("/materialCategories", newCategory, "categories", {service: 'scm'});
            }

            $scope.promise
                .then(function (categories) {
                    $scope.saving = false;
                    $mdDialog.hide({
                        category: categories[0],
                        editingMode: $scope.editingMode,
                        editingIndex: editingIndex
                    })
                })
                .catch(function (err) {
                    $scope.saving = false;
                    $mdToast.show($mdToast.simple().textContent("Error while saving category"));
                });
        }


        function cancelDialog() {
            $mdDialog.cancel();
        }

        if ($scope.category && $scope.category.name) {
            $scope.capitalize();
        }
    }

})(angular);

(function () {
    'use strict';
    addBatch.$inject = ["$scope", "$mdDialog", "materialId", "$mdToast", "RestManager", "Materials", "batch"];
    angular.module('app.materials')
        .controller("addBatchDialog.controller", addBatch);

    function addBatch($scope, $mdDialog, materialId, $mdToast, RestManager, Materials, batch) {

        console.log("addBatchDialog.controller.js", "addBatch", batch);

        $scope.batch = batch || {
            materialId: materialId,
            batchTax: {isInclusive: true}
        };
        $scope.editingBatch = !!batch;
        $scope.selectedVendor = '';
        $scope.vendorSearchText = '';

        $scope.taxGroups = {
            GST: [
                {
                    value: 'GST:0',
                    actualValue: 0
                },
                {
                    value: 'GST:5',
                    actualValue: 5
                },
                {
                    value: 'GST:12',
                    actualValue: 12
                },
                {
                    value: 'GST:18',
                    actualValue: 18
                },
                {
                    value: 'GST:28',
                    actualValue: 18
                }
            ],
            IGST: [
                {
                    value: 'IGST:0',
                    actualValue: 0
                },
                {
                    value: 'IGST:5',
                    actualValue: 5
                },
                {
                    value: 'IGST:12',
                    actualValue: 12
                },
                {
                    value: 'IGST:18',
                    actualValue: 18
                },
                {
                    value: 'IGST:28',
                    actualValue: 28
                }
            ]
        };


        if ($scope.editingBatch) {
            if (!$scope.batch.batchTax) {
                $scope.batch.batchTax = {};
            }
            $scope.batch.taxString = $scope.batch.batchTax.CGST ? 'GST:' + ($scope.batch.batchTax.CGST_Percent * 2) : 'IGST:' + $scope.batch.batchTax.IGST_Percent
        }

        $scope.getVendorById = getVendorById;
        $scope.cancelDialog = cancelDialog;
        $scope.saveBatch = saveBatch;
        $scope.reCalculateData = reCalculateData;
        $scope.addVendorToData = addVendorToData;
        $scope.vendorQuery = vendorQuery;
        $scope.createVendor = createVendor;
        $scope.removeVendor = removeVendor;
        $scope.selectSuggestedVendor = selectSuggestedVendor;

        function selectSuggestedVendor(vendorName) {
            $scope.vendorQuery(vendorName)
                .then(function (vendors) {
                    if (vendors && vendors.length) {
                        $scope.addVendorToData(vendors[0]);
                    } else {
                        $mdToast.show($mdToast.showSimple('No Vendor Matching the name ' + vendorName + ' found', 4000))
                    }
                })
                .catch(function (err) {
                    $mdToast.show($mdToast.showSimple('Error fetching suggestion for vendor : ' + err.message))
                })
        }

        function removeVendor() {
            $scope.batch.vendor = null;
        }

        function createVendor(vendorName) {
            Materials.openCreateVendorDialog(event, {
                name: vendorName
            })
                .then(function (data) {
                    if (data.newVendor) {
                        $scope.batch.vendor = data.newVendor;
                    }
                })
        }

        function addVendorToData(vendor) {
            if (vendor) {
                $scope.batch.vendor = vendor;
            }
        }

        function vendorQuery(queryText) {
            return RestManager.getResource('/vendors?q=' + encodeURIComponent(queryText) + '&page=1&limit=3', 'vendors', {service: 'scm'})
        }

        function cancelDialog() {
            $mdDialog.cancel();
        }

        function saveBatch() {
            $scope.saving = true;
            var promises;

            //TODO: will fail if multiple images are selected, write logic for saving multiple hexcode in backend after discussion.
            if ($scope.batch.image && $scope.batch.image.swatch) {
                $scope.batch.hexCode = $scope.batch.image.swatch.css;
            }

            //TODO: will fail if multiple images are selected, write logic for saving multiple images in backend after discussion.
            $scope.batch.image = $scope.batch.image._id;

            if ($scope.editingBatch) {
                console.log("addBatchDialog.controller.js", "saveBatch", $scope.batch);
                promises = Materials.editBatch(materialId, $scope.batch);
            } else {
                promises = Materials.saveBatch($scope.batch);
            }

            promises
                .then(function (data) {
                    $scope.saving = false;
                    $mdDialog.hide({material: data[0]});
                })
                .catch(function (err) {
                    console.log("ERROR", err);
                    $scope.saving = false;
                });
        }

        function getVendorById() {
            Materials.getSingleVendorById($scope.batch.vendor)
                .then(function (result) {
                    console.log('result', result);
                    if (result && result.length) {
                        $scope.batch.vendor = result[0];
                    }
                })
                .catch(function (err) {
                    console.log("addBatchDialog.controller.js", "ERROR", err);
                });
        }

        function reCalculateData() {
            var totalAmt = 0;
            var totalTax = 0;
            if (!$scope.batch.batchTax) {
                $scope.batch.batchTax = {};
            }
            if ($scope.batch.taxString) {
                var tax = $scope.batch.taxString.split(":");
                $scope.batch.taxType = tax[0];
                $scope.batch.taxPercentage = tax[1];
            }

            var subTotal = _.round(($scope.batch.entryStock * $scope.batch.inRate), 2);
            console.log("addBatchDialog.controller.js", "reCalculateData", $scope.batch.entryStock, $scope.batch.inRate, subTotal);
            $scope.batch.batchTax.totalTax = _.round((subTotal * ($scope.batch.taxPercentage / 100)), 2);
            if (!$scope.batch.taxPercentage) {
                $scope.batch.batchTax.totalTax = 0;
                $scope.batch.amount = subTotal + $scope.batch.batchTax.totalTax;
            }
            if ($scope.batch.taxPercentage && $scope.batch.batchTax.isInclusive) {
                $scope.batch.amount = subTotal;
            }
            if ($scope.batch.taxPercentage && !$scope.batch.batchTax.isInclusive) {
                $scope.batch.amount = subTotal + $scope.batch.batchTax.totalTax;
            }
            if ($scope.batch.taxType === 'IGST') {
                $scope.batch.batchTax.IGST = $scope.batch.batchTax.totalTax;
                $scope.batch.batchTax.IGST_Percent = $scope.batch.taxPercentage;
            }
            if ($scope.batch.taxType === 'GST') {
                $scope.batch.batchTax.SGST = _.round(($scope.batch.batchTax.totalTax / 2), 2);
                $scope.batch.batchTax.SGST_Percent = _.round(($scope.batch.taxPercentage / 2), 2);
                $scope.batch.batchTax.CGST = _.round(($scope.batch.batchTax.totalTax / 2), 2);
                $scope.batch.batchTax.CGST_Percent = _.round(($scope.batch.taxPercentage / 2), 2);
            }
            totalAmt += $scope.batch.amount;
            totalTax += $scope.batch.batchTax.totalTax;


            $scope.batch.price = _.round(totalAmt, 2);
            $scope.batch.tax = _.round(totalTax, 2);
        }

        if ($scope.editingBatch) {
            $scope.getVendorById();
            // $scope.batch.taxString = value.batchTax.CGST ? 'GST:' + (value.batchTax.CGST_Percent * 2) : 'IGST:' + value.batchTax.IGST_Percent
            // $scope.purchase.vendor = purchase.vendor._id;

        }
    }

})(angular);

(function () {
    'use strict';
    unleaseStock.$inject = ["$scope", "$mdDialog", "batch", "materialId", "$mdToast"];
    angular.module('app.materials')
        .controller('unleaseStock.controller', unleaseStock);

    function unleaseStock($scope, $mdDialog, batch, materialId, $mdToast) {

        $scope.history = batch.stockHistory.filter(function (history) {
            return history.updateType === 'lease' && !history.isUnleased;
        }).reverse();


        $scope.closeDialog = closeDialog;
        $scope.unleaseStock = unleaseStock;


        function closeDialog() {
            $mdDialog.cancel();
        }

        function unleaseStock(e, index, quantity, id) {
            $mdDialog.show({
                controller: "stockReturned.controller",
                templateUrl: 'app/modules/scm/materials/details/unleaseStock/stockReturnedBeforeUnleasing/partial/stockReturned.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: e,
                fullscreen: true,
                clickOutsideToClose: true,
                multiple: true,
                locals: {
                    leasedQuantity: quantity,
                    materialId: materialId,
                    batchId: batch._id,
                    stockHistoryId: id
                }
            })
                .then(function(res){
                    $scope.history.splice(index, 1);
                    $mdDialog.hide({updatedData : res.updatedData});
                })
                .catch(function(err){
                    $mdToast.showSimple("Error in unleasing batch: " + err.message);
                });
        }


    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 28/7/19 6:37 PM
 *
 */

(function () {
    'use strict';

    BatchHistoryController.$inject = ["$scope", "$mdDialog", "stockHistory", "Utils", "availableStock"];
    angular.module('app.materials')
        .controller('batch.history.dialog.controller', BatchHistoryController);

    function BatchHistoryController($scope, $mdDialog, stockHistory, Utils, availableStock) {
        console.log("stock-history-dialog.js", "BatchHistoryController", stockHistory);
        $scope.stockHistory = stockHistory;
        $scope.availableStock = availableStock;

        $scope.close = close;
        $scope.dateAgo = Utils.dateAgo;

        function close() {
            $mdDialog.cancel();
        }
    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 26/6/19 1:44 AM
 *
 */

(function () {
    'use strict';
    deductStockController.$inject = ["$scope", "$mdDialog", "Materials", "stock", "index", "batchId", "stockHistory", "material", "$mdToast", "RestManager"];
    angular.module("app.materials")
        .controller("deductStock.controller", deductStockController);

    function deductStockController($scope, $mdDialog, Materials, stock, index, batchId, stockHistory, material, $mdToast, RestManager) {
        $scope.newBatchStock = {
            quantity: null,
            remarks: '',
            batchId: batchId,
            operator: {
                name: '',
                _id: ''
            },
            updateType: 'dec'
        };

        $scope.orderQuery = {
            queryType: "find",
            queryParams: {
                status: {$in: ["placed", "approved", "processing", "packed", "shipped", "delivered", "partially shipped"]},
            },
            queryOptions: {
                select: "orderNumber _id fullUser fullUser.name",
                sort: "-createdAt",
                limit: 5
            }
        };

        $scope.orderSearch = null;

        $scope.stockHistory = stockHistory;
        $scope.selectedOperator = {};
        $scope.material = material;

        $scope.stock = stock;
        $scope.remainingStock = $scope.stock;
        $scope.loadingOrders = false;


        $scope.closeDialog = closeDialog;
        $scope.updateStock = updateStock;
        $scope.fetchOperators = fetchOperators;
        $scope.changeOperator = changeOperator;
        $scope.calculateRemainingStock = calculateRemainingStock;
        // $scope.fetchAllOpenOrders = fetchAllOpenOrders;
        $scope.setOrderInStock = setOrderInStock;
        $scope.getOrders = getOrders;
        $scope.generateRemark = generateRemark;


        $scope.fetchOperators();

        // $scope.fetchAllOpenOrders();

        function closeDialog() {
            $mdDialog.cancel();
        }

        function updateStock() {
            var batchStock = {};
            angular.copy($scope.newBatchStock, batchStock);
            var newStock = null;
            if ($scope.newBatchStock.updateType === 'dec' || $scope.newBatchStock.updateType === 'lease') {
                newStock = stock - $scope.newBatchStock.quantity;
            } else {
                newStock = stock + $scope.newBatchStock.quantity;
                batchStock.quantity = -batchStock.quantity
            }
            if ($scope.newBatchStock.order) {
                batchStock.orderId = $scope.newBatchStock.order._id;
                delete batchStock.order;
            }
            $scope.updatingStock = true;
            Materials.editBatchStock(material._id, batchStock)
                .then(function (data) {
                    $scope.updatingStock = false;
                    _.forEach(data[0].batches, function(b){
                        if(b._id === batchId){
                            b.index = index;
                        }
                    });
                    var result = {
                        updatedStock: newStock,
                        updatedData: data
                    };
                    $mdDialog.hide({data: result});
                })
                .catch(function (err) {
                    $scope.updatingStock = false;
                    $mdToast.showSimple("Some Error occurred while updating stock:" + err.message);
                });
        }

        function calculateRemainingStock() {
            $scope.remainingStock = _.round(_[$scope.newBatchStock.updateType === 'inc' ? 'add' : 'subtract']
            ($scope.stock, $scope.newBatchStock.quantity || 0), 2);

        }

        function fetchOperators() {
            var query = {
                order: 'name',
                query: {
                    role: {$in: 'operator'}
                },
                page: 1,
                limit: 50
            };
            RestManager.postResource("/users/admin", query, "users")
                .then(function (users) {
                    console.log("users", users);
                    $scope.operators = users;
                })
                .catch(function (err) {
                    console.log(err);
                });
        }

        function changeOperator() {
            $scope.newBatchStock.operator.name = $scope.selectedOperator.details.name;
            $scope.newBatchStock.operator._id = $scope.selectedOperator.details._id;
        }

        function setOrderInStock(order) {
            $scope.newBatchStock.order = order;
            console.log("deductStock.controller.js", "setOrderInStock", order);
        }

        function getOrders() {
            $scope.loadingOrders = true;
            $scope.orderQuery.queryParams.$or = [
                {
                    orderNumber: {$regex: $scope.orderSearch, $options: 'ig'}
                },
                {
                    'cachedAddress.name': {$regex: $scope.orderSearch, $options: 'ig'}
                },
                {
                    'fullUser.name': {$regex: $scope.orderSearch, $options: 'ig'}
                },
                {
                    'cachedAddress.mobile': {$regex: $scope.orderSearch, $options: 'ig'}
                },
                {
                    'orderData.products.product.name': {$regex: $scope.orderSearch, $options: 'ig'}
                },
                {
                    'orderData.products.product.sku': {$regex: $scope.orderSearch, $options: 'ig'}
                },
                {
                    'cachedDesignerName': {$regex: $scope.orderSearch, $options: 'ig'}
                }
            ]


            RestManager.postResource("/analytics/Order", $scope.orderQuery, "analytics")
                .then(function (result) {
                    $scope.loadingOrders = false;
                    $scope.orders = result;
                    console.log("deductStock.controller.js", "RESULT", $scope.orders);


                })
                .catch(function (err) {
                    $scope.loadingOrders = false;
                    console.log("err", err);
                });
        }

        function generateRemark() {
            if ($scope.newBatchStock.order) {
                $scope.newBatchStock.remarks = "Stock Deducted for Order Number " + $scope.newBatchStock.order.orderNumber;
                if ($scope.newBatchStock.order && $scope.newBatchStock.order.fullUser) {
                    $scope.newBatchStock.remarks += " (User: " + $scope.newBatchStock.order.fullUser.name + ")";
                }
            } else {
                $scope.newBatchStock.remarks = "";
            }

        }

    }

})(angular);

/**
 * Created by Abhinav on 3rd Dec, 7:19 p.m.
 * */

(function () {
    'use strict';
    manageProductStock.$inject = ["$scope", "variations", "materialId", "totalAvailableStock", "$mdDialog", "Base", "RestManager", "$mdToast"];
    angular.module('app.materials')
        .controller('manageProductStock.controller', manageProductStock);

    function manageProductStock($scope, variations, materialId, totalAvailableStock, $mdDialog, Base, RestManager, $mdToast){

        $scope.variations = variations;
        $scope.totalAvailableStock = totalAvailableStock;
        $scope.loadingOrders = false;
        $scope.mediaUrl = Base.getMediaUrl();
        console.log("manage-product-stock.controller.js", "manageProductStock", $scope.variations, totalAvailableStock);

        $scope.close = close;
        $scope.openMakeOutOfStockDialog = openMakeOutOfStockDialog;
        $scope.fetchAllProductThatUsesThisMaterial = fetchAllProductThatUsesThisMaterial;
        $scope.fetchAllOrdersThatUsesThisMaterial = fetchAllOrdersThatUsesThisMaterial;
        $scope.showToast = showToast;
        $scope.openAddMaterialToPurchaseListDialog = openAddMaterialToPurchaseListDialog;


        function close(){
            $mdDialog.cancel();
        }

        function openMakeOutOfStockDialog(variation, e){
            $mdDialog.show({
                locals: {
                    product: variation.product,
                    variationId: variation._id,
                    // totalAvailableStock:  totalAvailableStock
                },
                controller: "makeProductOutOfStock.controller",
                templateUrl: 'app/modules/scm/materials/details/manageProductStockDialog/partial/make-product-out-of-stock.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: e,
                fullscreen: true,
                clickOutsideToClose: false,
                multiple: true
            })
        }

        function fetchAllProductThatUsesThisMaterial() {
            RestManager.postResource('/variations/getProductByFabricId', {materialId: materialId}, 'variations')
                .then(function (variations) {
                    console.log("materialDetails.controller.js", "VARIATIONS", variations);
                    $scope.variations = variations;
                })
                .catch(function (err) {
                    console.log("materialDetails.controller.js", "errr", err);
                    $mdToast.showSimple("Error in fetching products " + err.message);
                });
        }

        function fetchAllOrdersThatUsesThisMaterial(){
            $scope.loadingOrders = true;
            RestManager.postResource('/order/getOrderBasedOnFabricId', {materialId: materialId, currentStock: totalAvailableStock}, 'orders')
                .then(function(orders){
                    $scope.orders = orders;
                    $scope.loadingOrders = false;
                    console.log("manage-product-stock.controller.js", "ORDERS", orders);
                })
                .catch(function(err){
                    $scope.loadingOrders = false;
                    console.log("manage-product-stock.controller.js", "Error", err);
                    $mdToast.showSimple("Error in fetching orders" +err.message);
                });
        }

        function showToast(message) {
            $mdToast.showSimple(message);
        }

        function openAddMaterialToPurchaseListDialog(e){
            var confirm = $mdDialog.confirm()
                .title("Do you want to create a new purchase list or update an existing one ?")
                .multiple(true)
                .textContent("Creating a new purchase list will add a new entry in the 'Purchase List' of the merchandiser you will select, " +
                    "while updating a previous entry will add the amount of quantity you enter to the existing quantity.")
                .ariaLabel("Is your decision final ?")
                .targetEvent(e)
                .ok("Create a new list")
                .cancel("Update an existing list.");
            console.log('Show', confirm);
            return $mdDialog.show(confirm)
                .then(function(response){
                        $mdDialog.show({
                            locals: {
                                materialId: materialId,
                                newPurchase: true
                            },
                            controller: "addItemToPurchaseList.controller",
                            templateUrl: 'app/modules/scm/materials/details/manageProductStockDialog/addItemToPurchaseList/partials/add-item-to-purchase-list.tmpl.html',
                            parent: angular.element(document.body),
                            targetEvent: e,
                            fullscreen: true,
                            clickOutsideToClose: false,
                            multiple: true
                        });
                })
                .catch(function(err){
                    $mdDialog.show({
                        locals: {
                            materialId: materialId,
                            newPurchase: false
                        },
                        controller: "addItemToPurchaseList.controller",
                        templateUrl: 'app/modules/scm/materials/details/manageProductStockDialog/addItemToPurchaseList/partials/add-item-to-purchase-list.tmpl.html',
                        parent: angular.element(document.body),
                        targetEvent: e,
                        fullscreen: true,
                        clickOutsideToClose: false,
                        multiple: true
                    });

                })
        }


        $scope.fetchAllProductThatUsesThisMaterial();
        $scope.fetchAllOrdersThatUsesThisMaterial();

    }

})(angular);

/**
 * Created by Abhinav on 3rd Dec, 8:42 p.m.
 * */
(function () {
    'use strict';
        makeProductOutOfStock.$inject = ["$scope", "$mdDialog", "variationId", "product", "RestManager", "$mdToast", "Base"];
        angular.module('app.materials')
            .controller('makeProductOutOfStock.controller', makeProductOutOfStock);

        function makeProductOutOfStock($scope, $mdDialog, variationId, product, RestManager, $mdToast, Base) {
            console.log("make-product-out-of-stock.controller.js", "makeProductOutOfStock", product);
            console.log("make-product-out-of-stock.controller.js", "makeProductOutOfStock", variationId);
            $scope.makingOutOfStock = false;
            $scope.product = product;
            $scope.reasons = [
                {
                    text: "REASON 1"
                },
                {
                    text: "REASON 2"
                },
                {
                    text: "REASON 3"
                },
                {
                    text: "REASON 4"
                },
                {
                    text: "REASON 5"
                },
                {
                    text: "REASON 6"
                }
            ];
            $scope.mediaUrl = Base.getMediaUrl();


            $scope.close = close;
            $scope.makeProductVariationOutOfStock = makeProductVariationOutOfStock;


            function close(){
                $mdDialog.cancel();
            }

            function makeProductVariationOutOfStock(){
                $scope.makingOutOfStock = true;

                RestManager.patchResource('/variations/makeVariationOutOfStock/', {vid: variationId}, 'variations')
                    .then(function(response){
                        $scope.makingOutOfStock = false;
                        console.log("make-product-out-of-stock.controller.js", "RESPONSE", response);
                    })
                    .catch(function(err){
                        $scope.makingOutOfStock = false;
                        $mdToast("Error in making variation out of stock: " + err.message);
                    });
            }
        }

})(angular);

/**
 * Created by kumardivyarajat on 04/12/16.
 */
angular.module("app.products", ["angular-js-xlsx", "ui.mention"])
    .controller("products.controller", ["$scope", "$log", "$rootScope", function ($scope, $log, $rootScope) {
        $log.info("Entered Products Module");
        // $scope.pageTitle = "";
        // $scope.nestedState = false;
        // $scope.backState = "app.home";

        $rootScope.$on('$stateChangeSuccess', function (ev, to) {
            $scope.$parent.copyTitleButton = to.name.indexOf('app.products.add') !== -1;
        });
    }]);

(function () {
    'use strict';


    angular.module('app.products')
        .factory('OptionsService', OptionsService);

    function OptionsService() {

        var generateOption = function (id, url, name) {
            return {
                image: {
                    "urls": {
                        "c_large": url,
                        "c_medium": url,
                        "c_thumbnail": url,
                        "c_full": url,
                        "large": url,
                        "medium": url,
                        "thumbnail": url,
                        "full": url
                    },
                    _id: id
                },
                stockAndPrice: {
                    price: {
                        mrp: 0,
                        salePrice: 0
                    }
                },
                name: name
            };
        };

        var sleeveOptions = [
            generateOption('589c6adf92f02f279981c670', '/uploads/elbow_length_sleeves_–_1-1486645983659.svg', 'Elbow Length'),
            generateOption('589c6ea2604e1729efb8ff26', '/uploads/sleeveless_–_1-1486646946742.svg', 'Sleeveless'),
            generateOption('589c6adf92f02f279981c67d', '/uploads/short_sleeves_%E2%80%93_1-1486645983672.svg', 'Short Sleeves'),
            generateOption('589c6adf92f02f279981c679', '/uploads/quarter_sleeves_–_1-1486645983667.svg', 'Quarter Sleeves'),
            generateOption('589c6adf92f02f279981c66f', '/uploads/cap_sleeves_–_1-1486645983657.svg', 'Cap Sleeves'),
            generateOption('589c6adf92f02f279981c673', '/uploads/full_sleeves_–_1-1486645983662.svg', 'Full Sleeves')
        ];


        var neckOptions = [
            generateOption('589c6adf92f02f279981c67e', '/uploads/square_–_1-1486645983673.svg', 'Square Neck'),
            generateOption('589c6adf92f02f279981c67b', '/uploads/scoop_–_1-1486645983671.svg', 'Scoop Neck'),
            generateOption('589c6adf92f02f279981c67a', '/uploads/round_neck-1486645983670.svg', 'Round Neck'),
            generateOption('589c6adf92f02f279981c675', '/uploads/jewel-neck_–_1-1486645983663.svg', 'Jewel Neck'),
            generateOption('589c6adf92f02f279981c676', '/uploads/keyhole_–_1-1486645983664.svg', 'Keyhole Neck'),
            generateOption('589c6adf92f02f279981c678', '/uploads/no_placket_–_1-1486645983666.svg', 'No Placket'),
            generateOption('589c6adf92f02f279981c672', '/uploads/full_placket_–_1-1486645983661.svg', 'Full Placket'),
            generateOption('589c6adf92f02f279981c674', '/uploads/half_placket_–_1-1486645983662.svg', 'Half Placket')

        ];

        var lengthOptions = [
            generateOption('589c6adf92f02f279981c671', '/uploads/full_length_–_1-1486645983660.svg', 'Full Length'),
            generateOption('589c6adf92f02f279981c677', '/uploads/knee_length_–_1-1486645983666.svg', 'Knee Length'),
            generateOption('589c6adf92f02f279981c67c', '/uploads/short_–_1-1486645983672.svg', 'Short Length')

        ]


        return {
            sleeveOptions: sleeveOptions,
            neckOptions: neckOptions,
            lengthOptions: lengthOptions
        }
    }


})(angular);

/**
 * Created by kumardivyarajat on 05/12/16.
 */

angular.module("app.products")
    .controller("products.add.variations.controller", ["$scope", "Utils", "RestManager", "Materials", "$log", "$mdToast", "$mdDialog", "StockUpdates", function ($scope, Utils, RestManager, Materials,
                                                                $log, $mdToast, $mdDialog, StockUpdates) {
        var vm = this;
        vm.product = $scope.$parent.product;
        $log.debug("From Product Variations controller", vm.product);
        vm.varyingAttributes = [];
        vm.sameValueForAll = true;
        vm.sideBarOpen = false;
        vm.selectedVariation = null;
        vm.sameMaterialsForAll = false;
        vm.sameStockForAll = false;

        // var a = $scope.$watchCollection("product.variations", function (newVal, oldVal) {
        //     console.log("Update", newVal);
        // });

        vm.getSingleMaterialById = Materials.getSingleMaterialById;
        vm.round = _.round;

        vm.openSidebar = function (variation) {
            vm.sideBarOpen = true;
            vm.selectedVariation = variation;
            vm.selectedVariation.prevProductionCost = (variation.stockAndPrice && variation.stockAndPrice.price) ? variation.stockAndPrice.price.productionCost : 0;
        };

        vm.addMaterial = function (variation) {
            if (vm.sameMaterialsForAll) {
                vm.product.variations = vm.product.variations.map(function (v) {
                    if (!v.materials) {
                        v.materials = [];
                    }
                    v.materials.unshift({materialId: null, consumption: 0});
                    return v;
                });
            } else {
                if (!variation.materials) {
                    variation.materials = [];
                }
                variation.materials.unshift({materialId: null, consumption: 0});
            }
        };

        vm.addMaterialToLineItem = function (selectedMaterial, materialLineItem, index) {
            if (vm.sameMaterialsForAll) {
                vm.product.variations = vm.product.variations.map(function (variation, i) {
                    if (!variation.materials) {
                        variation.materials = [];
                    }
                    variation.materials[index].materialId = selectedMaterial._id;
                    variation.materials[index].material = selectedMaterial;
                    return variation;
                });
            } else {
                materialLineItem.materialId = selectedMaterial._id;
                materialLineItem.material = selectedMaterial;
            }
            vm.generateMaterialString();
        };

        vm.removeMaterialFromItem = function (materialLineItem, index) {
            if (vm.sameMaterialsForAll) {
                vm.product.variations = vm.product.variations.map(function (variation) {
                    if (!variation.materials) {
                        variation.materials = [];
                    }
                    if (i !== index) {
                        variation.materials[index].materialId = null;
                        variation.materials[index].material = null;
                    }
                    return variation;
                });
            } else {
                materialLineItem.material = null;
                materialLineItem.materialId = null;
            }
        };

        vm.deleteLineItem = function (variation, index) {
            if (vm.sameMaterialsForAll) {
                vm.product.variations = vm.product.variations.map(function (variation) {
                    if (!variation.materials) {
                        variation.materials = [];
                    }
                    if (i !== index) {
                        variation.materials.splice(index, 1);
                    }
                    return variation;
                });
            } else {
                variation.materials.splice(index, 1);
            }
            vm.generateMaterialString();
        };

        vm.fetchMaterials = function (searchText) {
            return RestManager.getResource("/materials", 'materials', {
                query: {page: 1, limit: 5, search: searchText, fields: 'name,salePrice,stock,image'},
                service: 'scm'
            });
        };


        vm.openAddNewMaterial = function openAddNewMaterial(event, searchText, lineItem) {
            Materials
                .openCreateMaterialDialog(event, {
                    name: searchText
                })
                .then(function (result) {
                    if (result && result.materials) {
                        lineItem.material = result.materials;
                        lineItem.material = result.materials._id;
                        console.log('Updated', lineItem);
                    }
                })
        }

        vm.closeSidebar = function () {
            vm.sideBarOpen = false;
            vm.selectedVariation = null;
        };

        vm.checkMadi = function (variation) {
            var a = variation.stockAndPrice.price;
            var b = variation.stockAndPrice.stock;
            if (vm.sameMaterialsForAll || vm.sameStockForAll || vm.sameValueForAll) {
                _.forEach(vm.product.variations, function (o) {
                    o.modified = true;
                    if (vm.sameValueForAll) {
                        o.stockAndPrice.price.mrp = a.mrp;
                        o.stockAndPrice.price.photoShoot = a.photoShoot;
                        o.stockAndPrice.price.msp = a.msp;
                        o.stockAndPrice.price.tax = a.tax;
                        o.stockAndPrice.price.fabricCost = a.fabricCost;
                        o.stockAndPrice.price.productionCost = a.productionCost;
                        o.stockAndPrice.price.salePrice = a.salePrice;
                        o.stockAndPrice.price.stitching = a.stitching;
                        o.stockAndPrice.price.designing = a.designing;
                        o.stockAndPrice.price.embroidery = a.embroidery;
                        o.stockAndPrice.price.trims = a.trims;
                    }

                    if (vm.sameStockForAll) {
                        o.stockAndPrice.stock.manageStock = b.manageStock;
                        o.stockAndPrice.stock.quantity = b.quantity;
                        o.stockAndPrice.stock.backOrder = b.backOrder;
                        o.stockAndPrice.stock.threshold = b.threshold;
                    }

                    if (vm.sameMaterialsForAll) {
                        o.materials = variation.materials.map(function (materialData) {
                            return {
                                materialId: materialData.materialId,
                                material: materialData.material,
                                consumption: materialData.consumption,
                            }
                        });
                    }

                    vm.totalTaxPercenteage = function () {
                        if ((a.fabricCost + a.productionCost + a.stitching + a.designing + a.photoShoot) > 0 && (a.fabricCost + a.productionCost + a.stitching + a.designing + a.photoShoot) < 999) {
                            return 5;
                        } else {
                            return 12;
                        }
                    };
                    o.stockAndPrice.price.tax = vm.totalTaxPercenteage();
                });
            }
            // else {
            //     _.forEach(vm.product.variations, function (o) {
            //         o.stockAndPrice.price = {
            //             price: {},
            //             stock: {}
            //         };
            //     })
            // }
        };

        vm.getVariationValues = function (variation) {
            if (variation.attributes[0]) {
                var varId = variation.attributes[0].selectedValue[0];

                var a = _.find(variation.attributes[0].attribute.meta_values, function (meta_value) {
                    return meta_value._id === varId;
                });
                if (a) {
                    return a.value;
                }
            }

        };

        vm.markAsModified = function (newVal, oldVal) {
            newVal.modified = newVal !== oldVal;
            // $log.debug(newVal == oldVal);
            vm.checkMadi(newVal);
        };

        vm.generateVariations = function (event) {
            if (vm.product.variations.length > 0) {
                var confirm = $mdDialog.confirm()
                    .title('Do you want to regenerate all the variations?')
                    .textContent('If you click on regenerate, all the previous stored data will be reset. But you can force the retain state by clicking the Retain state button.')
                    .ariaLabel('check variations regeneration')
                    .targetEvent(event)
                    .ok('Retain State')
                    .cancel('Regenerate All Variations');

                $mdDialog.show(confirm).then(function () {
                    vm._regenerateVariations(true);
                }, function () {
                    vm._regenerateVariations(false);
                });
            } else {
                vm._regenerateVariations(false);
            }
        };

        vm._regenerateVariations = function (retainState) {
            switch (vm.evaluateNumberOfVaryingAttributes()) {
                case 0:
                    var data = {};
                    if (retainState) {
                        var previousVariation = [];
                        angular.copy(vm.product.variations, previousVariation);
                        vm.product.variations = [];
                        data = previousVariation[0];
                    } else {
                        data = {
                            new: true,
                            stockAndPrice: {
                                price: {},
                                stock: {}
                            }
                        };
                    }
                    vm.product.variations.push(data);
                    break;

                case 1:
                    if (retainState) {
                        var previousVariations = [];
                        angular.copy(vm.product.variations, previousVariations);
                        vm.product.variations = [];
                        _.forEach(vm.varyingAttributes[0].selectedValues, function (selectedValue) {
                            var previousVariation = _.find(previousVariations, function (o) {
                                return _.toUpper(o.attributes[0].selectedValue[0]) === _.toUpper(selectedValue);
                            });
                            if (previousVariation) {
                                vm.product.variations.push(previousVariation);
                            } else {
                                vm._pushEmptyVariation(selectedValue, true);
                            }
                        })
                    } else {
                        _.forEach(vm.varyingAttributes[0].selectedValues, function (selectedValue) {
                            vm._pushEmptyVariation(selectedValue, true);
                        });
                    }
                    break;

                default:
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Multiple Varying attributes are not supported yet.\n Please go back to attributes and uncheck "Used for variations"\n from one of the attributes to continue.\n' +
                                'Please contact the admin for more details.')
                            .position("bottom right")
                            .capsule(false)
                            .highlightClass('md-primary')
                            .hideDelay(5000)
                    );
                    break;
            }
            $log.info(vm.product.variations);
        };

        vm._pushEmptyVariation = function (selectedValue, markAsNew, modified) {
            vm.product.variations.push({
                attributes: [
                    {
                        attribute: vm.varyingAttributes[0].attribute,
                        selectedValue: [selectedValue]
                    }
                ],
                new: markAsNew,
                modified: modified,
                stockAndPrice: {
                    price: {},
                    stock: {}
                }
            });
        };


        vm.evaluateNumberOfVaryingAttributes = function () {
            var count = 0;
            _.forEach(vm.product.attributes, function (attributeData) {
                if (attributeData.isVariation) {
                    vm.varyingAttributes.push(attributeData);
                    count++;
                }
            });
            $log.info("evaluateNumberOfVaryingAttributes", count);
            return count;
        };


        vm.init = function () {
            vm.product.variations = vm.product.variations.map(function (variation) {
                variation.selectedValueText = vm.getVariationValues(variation);
                return variation;
            });
            Promise
                .map(vm.product.variations, function (variation) {
                    if (variation.materials) {
                        return Promise.map(variation.materials, function (materialData) {
                            return new Promise(function (resolve, reject) {
                                vm.getSingleMaterialById(materialData.materialId, 'name')
                                    .then(function (materials) {
                                        materialData.material = materials[0];
                                        resolve(materialData);
                                    })
                                    .catch(reject)
                            })
                        })
                    } else {
                        return '';
                    }
                })
                .then(function (result) {
                    vm.generateMaterialString();
                })
                .catch(function (err) {
                    console.log('Error populating material data', err);
                })
        };

        vm.generateMaterialString = function () {
            vm.product.variations = vm.product.variations.map(function (variation) {
                if (variation.materials) {
                    variation.materialString = Utils.replaceEnd(variation.materials.reduce(function (acc, material) {
                        return acc + Utils.getProperName(material.material.name) + ', '
                    }, ''), ',');
                }
                return variation;
            });
        };

        vm.moveUp = function (variation, index) {
            if (index !== 0) {
                var temp = vm.product.variations[index - 1];
                vm.product.variations[index - 1] = variation;
                vm.product.variations[index] = temp;
            }
        };

        vm.moveDown = function (variation, index) {
            if (index !== vm.product.variations.length - 1) {
                var temp = vm.product.variations[index + 1];
                vm.product.variations[index + 1] = variation;
                vm.product.variations[index] = temp;
            }
        };


        vm.openPriceModificationDialog = function (ev) {
            // if(vm.selectedVariation.stockAndPrice.price.productionCost !== vm.selectedVariation.prevProductionCost) {
            vm.mspFactor = 1.5;
            vm.salePriceFactor = vm.mrpFactor = 3;
            $mdDialog.show({
                contentElement: '#priceUpdateDialog',
                preserveScope: true,
                fullscreen: true,
                scope: $scope,
                targetEvent: ev
            })
            // }
        }

        vm.getSuggestedPricing = function (factor, roundOffToNines) {
            if (vm.selectedVariation) {
                var price = vm.round(vm.selectedVariation.stockAndPrice.price.productionCost * factor, 2);
                if (roundOffToNines) {
                    if (price % 100 > 10 && price % 100 <= 50) {
                        // Round to nearest 50
                        price = _.round(Math.ceil(price / 50) * 50, 0) - 1;
                    } else if (price % 100 <= 10) {
                        // Round to previous 100
                        price = _.round(Math.floor(price / 100) * 100, 0) - 1;
                    } else {
                        // Round up to next 100
                        price = _.round(Math.ceil(price / 100) * 100, 0) - 1;
                    }
                }
                return price;
            } else {
                return 0;
            }
        };

        vm.applyPrices = function () {
            var oldVal = {};
            angular.copy(vm.selectedVariation, oldVal);
            vm.selectedVariation.stockAndPrice.price.msp = vm.getSuggestedPricing(vm.mspFactor);
            vm.selectedVariation.stockAndPrice.price.salePrice = vm.getSuggestedPricing(vm.salePriceFactor, true);
            vm.selectedVariation.stockAndPrice.price.mrp = vm.getSuggestedPricing(vm.mrpFactor, true);
            vm.markAsModified(vm.selectedVariation, oldVal);
            vm.cancel();
        }

        vm.cancel = function () {
            $mdDialog.cancel();
        }

        vm.viewStockHistory = function (event, variation) {
            if (variation) {
                StockUpdates.openStockUpdateDialog(event, {variationId: variation._id})
            } else {
                StockUpdates.openStockUpdateDialog(event, {productId: vm.product._id})
            }
        }

        vm.init();

        $scope.$on("$destroy", function () {
            $log.info("Destructor -> ", "variations ctrl");
        });
    }]);

/**
 * Created by kumardivyarajat on 05/12/16.
 */
angular.module("app.products")
    .controller("products.add.tags.controller", ["$scope", "$log", "RestManager", "$mdToast", function ($scope, $log, RestManager, $mdToast) {
        var vm = this;
        vm.product = $scope.$parent.product;
        $log.debug("From Product Tags controller", vm.product);

        if ($scope.$parent.editingMode) {
            RestManager.getResource("/tags/admin/product/" + vm.product._id, "tags")
                .then(function (tags) {
                    vm.product.tags = tags;
                    // if (tags.length === 0) {
                    //     vm.autoGenerateTags();
                    // }
                })
                .catch(function (err) {
                    $log.error("Error while fetching tags for product " + vm.product.name, err);
                })
        } else {
            vm.product.tags = [];
        }

        vm.autoGenerateTags = function () {
            var tags = [];
            console.log("autoGenerateTags", vm.product.name.split(" "));
            tags = _.map(vm.product.name.split(" "), function (o) {
                return {value: _.toLower(o)};
            });
            tags = tags.concat(vm.getAttributeValues());
            vm.product.tags = tags;
            // tags = tags.concat()
        };

        vm.getAttributeValues = function () {
            return _.chain(vm.product.attributes)
                .tap(_.bind(console.log, console))
                .filter(function (o) {
                    return /(?:Color|Fabric|Fit|Occasion)/.test(o.attribute.meta_key)
                })
                .tap(_.bind(console.log, console))
                .map(function (attrD) {
                    return _.map(attrD.selectedValues, function (o) {
                        return {
                            value: _.toLower(_.find(attrD.attribute.meta_values, function (i) {
                                return i._id === o;
                            }).value)
                        };
                    })
                })
                .flatten()
                .value();
        };

        if (!vm.product.seo) {
            vm.product.seo = {
                keywords: [],
                description: ""
            };
        }

        vm.selectedItem = null;
        vm.searchText = null;
        vm.transformChip = transformChip;

        function transformChip(chip) {
            if (angular.isObject(chip)) {
                return chip;
            }
            return {value: chip}
        }

        vm.onAdd = function (chip, index) {
            console.log("onAdd", chip);
        };

        vm.onRemove = function (chip, index) {
            if (chip._id) {
                RestManager.getResource("/tags/admin/removeReference/" + chip._id + "/" + vm.product._id, "tags")
                    .then(function (tags) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Remove tag " + chip.value)
                                .position("bottom right")
                                .capsule(false)
                                .highlightClass('md-primary')
                                .hideDelay(3000)
                        );
                    })
                    .catch(function (err) {
                        $log.error("Error while removing reference of tag for product " + vm.product.name, err);
                    });
            }
        };

        vm.querySearch = function () {
            return RestManager.getResource("/tags/admin/search/" + vm.searchText, "tags");
        }

    }]);
/**
 * Created by abhinav on 27/07/19.
 */


angular.module('app.products')
    .controller("products.add.quality.controller", ["$scope", "$log", function ($scope, $log) {
        var vm = this;
        vm.product = $scope.$parent.product;
        $log.debug("From Product Quality controller", vm.product);

        if(!vm.product.qualityRating) {
            vm.product.qualityRating = 0;
        }

        $scope.calculateQualityRating = calculateQualityRating;

        function calculateQualityRating(mode) {
            switch (mode) {
                case 'minus':
                    vm.product.qualityRating -= 1;
                    break;

                case 'plus':
                    vm.product.qualityRating += 1;
                    break;
            }

        }


    }]);

/**
 * Created by abhinav on 26/07/19.
 */

(function () {
    'use strict';
    packagingCtrl.$inject = ["$scope"];
    angular.module("app.products")
        .controller("packagingCtrl", packagingCtrl);

    function packagingCtrl($scope) {
        $scope.product = $scope.$parent.product;
        console.log("products.add.packaging.controller.js", "packagingCtrl", $scope.product);


        $scope.calculateVolumetricWeight = calculateVolumetricWeight;
        $scope.updateSla = updateSla;

        function updateSla() {
            if ($scope.product.sla && $scope.product.sla !== 'custom') {
                switch ($scope.product.sla) {
                    case '2 to 6 days':
                        $scope.product.slaStart = 2;
                        $scope.product.slaEnd = 5;
                        break;

                    case '6 to 10 days':
                        $scope.product.slaStart = 6;
                        $scope.product.slaEnd = 10;
                        break;

                    case '12 to 24 days':
                        $scope.product.slaStart = 12;
                        $scope.product.slaEnd = 24;
                        break;
                }
            }
        }

        function calculateVolumetricWeight() {
            $scope.product.packaging.volumetricWeight = _.round((($scope.product.packaging.length *
                $scope.product.packaging.breadth *
                $scope.product.packaging.height) / 5000), 2);
        }


    }

})(angular);

/**
 * Created by kumardivyarajat on 05/12/16.
 */
angular.module("app.products")
    .controller("products.add.images.controller", ["$scope", "$log", "$mdDialog", "RestManager", "$http", "Base", "Users", function ($scope, $log, $mdDialog, RestManager, $http, Base, Users) {
        var vm = this;
        vm.product = $scope.$parent.product;
        $log.debug("From Product Images controller", vm.product);

        vm.addNewImage = addNewCustomerImage;
        vm.removeCustomerImage = removeCustomerImage;
        vm.selectUser = selectUser;

        function addNewCustomerImage(index) {
            if (!vm.product.customerImages) {
                vm.product.customerImages = [];
            }
            vm.product.customerImages.splice(index + 1, 0, {date : new Date()});
        }

        function removeCustomerImage(index) {
            vm.product.customerImages.splice(index, 1);
        }

        function selectUser(event, imageData) {
            Users.selectUserDialog(event, {
                fields: 'name,facebookProfile,instagramProfile,role',
                multiple: false
            })
                .then(function (user) {
                    console.log("products.add.images.controller.js", "user", user);
                    if(user) {
                        imageData.user = user._id;
                        imageData.name = user.name;
                        imageData.link = user.instagramProfile || user.facebookProfile || '';
                        if(user.instagramProfile) {
                            imageData.linkType = 'Instagram';
                        } else if(user.facebookProfile) {
                            imageData.linkType = 'Facebook';
                        }
                        imageData.isInfluencer = (user.role === 'influencer');
                    }
                })
                .catch(function (err) {

                })
        }

        vm.removeImage = function (id, event) {
            vm.product.gallery.splice(_.findIndex(vm.product.gallery, function (o) {
                return o._id === id;
            }), 1);
            event.stopPropagation();
        };

        vm.openSingleUploader = function (ev, mode, index) {
            $mdDialog.show({
                locals: {
                    multipleSelect: false,
                    select: '',
                    options: null
                },
                controller: "upload.controller",
                templateUrl: 'app/modules/base/partials/uploader.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                fullscreen: true,
                clickOutsideToClose: true
            })
                .then(function (images) {
                    if (mode === "featured image") {
                        vm.product.featured_image = images[0];
                    } else if (mode === "gallery") {
                        vm.product.gallery[index] = images[0];
                    } else if (mode === 'customerImages') {
                        vm.product.customerImages[index].image = images[0];
                    }
                }, function () {
                    $scope.status = 'You cancelled the dialog.';

                });

        };

        vm.fetchPhotoShootDetailsForProduct = function () {
            var q = {
                projection: {
                    'batch.product.$': 1,
                    "collectionName": 1,
                    'cost': 1,
                    'photographer': 1,
                    'location': 1,
                    'date': 1
                },
                populate: [
                    {
                        path: "photographer",
                        select: "name",
                        options: {lean: true}
                    },
                    {
                        path: "image",
                        select: "urls",
                        options: {lean: true}
                    },
                    {
                        path: "batch.product",
                        select: "name featured_image",
                        options: {lean: true},
                        populate: {
                            path: "featured_image",
                            select: "urls",
                            options: {lean: true},
                        }
                    },
                    {
                        path: "batch.model",
                        select: "name profileImageURL",
                        options: {lean: true}
                    }
                ],
                query: {
                    search: "batch.product",
                    text: vm.product._id
                }
            };
            RestManager.postResource("/shoots/query", q, "shoots")
                .then(function (shoots) {
                    vm.shoots = _.flatten(shoots);
                    console.log("Shoots", vm.shoots);
                })
                .catch(function (err) {
                    console.log(err);
                })
        };

        vm.openMultipleUploader = function (ev, append) {
            $mdDialog.show({
                locals: {
                    multipleSelect: true,
                    select: "jpeg",
                    options: null
                },
                controller: "upload.controller",
                templateUrl: 'app/modules/base/partials/uploader.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                fullscreen: true,
                clickOutsideToClose: true
            })
                .then(function (images) {
                    if (append) {
                        _.forEach(images, function (image) {
                            vm.product.gallery.push(image);
                        })
                    } else {
                        vm.product.gallery = images;
                    }
                }, function () {
                    $scope.status = 'You cancelled the dialog.';
                });

        };

        vm.formatData = function () {
            if (!vm.product.featured_image) {
                vm.product.featured_image = {};
            }
            console.log('Featured image', vm.product.featured_image);
            console.log(vm.product.featured_image._id);
            if (vm.product.featured_image && vm.product.featured_image._id) {
                console.log("ke");
                vm.product.featured_image = vm.product.featured_image._id;
            }
            console.log('Featured image 1', vm.product.featured_image);
        };

        // vm.updateInParent = function (product) {
        //     vm.$parent.product = product;
        // }

        vm.downloadImages = function () {
            vm.downloadingImages = true;
            var data = vm.product.gallery.map(function (o) {
                return o._id;
            });
            $http.post(Base.getBaseUrl() + "/images/download", {files: data}, {responseType: 'arraybuffer'})
                .then(function (res) {
                    console.log(res);
                    saveAs(new Blob([res.data], {type: "application/octet-stream"}), _.replace(vm.product.name, /\s/g, '-') + ".zip");
                    vm.downloadingImages = false;
                    console.log(res);
                })
                .catch(function (err) {
                    console.log(err);

                })
        };

        vm.formatData();
        vm.fetchPhotoShootDetailsForProduct();
    }]);

/**
 * Created by kumardivyarajat on 05/12/16.
 */
angular.module("app.products")
    .controller("products.add.general.controller", ["$scope", "$log", "RestManager", "Utils", "$timeout", "CriticalUpdateConfirmation", function ($scope, $log, RestManager, Utils, $timeout, CriticalUpdateConfirmation) {
        var vm = this;

        $timeout(function () {
            vm.product = $scope.$parent.product;
            $log.debug("From Product General controller", vm.product);

            if ($scope.$parent.editingMode) {
                vm.slug_avaliable = true;
            }

            vm.product.name = Utils.capitalize(vm.product.name);
        }, 0);

        vm.showPreview = false;

        vm.openProductSlugDialog = openProductSlugDialog;

        function openProductSlugDialog(ev) {
            CriticalUpdateConfirmation.showDialog({
                targetEvent: ev,
                title: 'Product Name Change Detected',
                description: 'The product name has been changed to ' + vm.product.name + '. Do you want to update the slug as well?',
                infoMessage: 'Linking from external providers like Facebook and Google will break. Please make sure that you understand what you are doing.',
                inputValidatorString: vm.product.name
            })
                .then(function (result) {
                    if (result) {
                        vm.getSlug();
                    }
                })
                .catch(function (err) {

                })
        }


        vm.getSlug = function () {
            vm.product.name = Utils.capitalize(vm.product.name);
            vm.product.slug = _.replace(_.toLower(vm.product.name), /\s/g, '-');
            $scope.$parent.product = vm.product;
            vm.getSuggestedSlugAvailability();
        };

        vm.getSuggestedSlugAvailability = function () {
            vm.checkingSlug = true;
            RestManager.getResource("/products/checkSlug/" + vm.product.slug, "available")
                .then(function (isAvailable) {
                    vm.checkingSlug = false;
                    $log.info(isAvailable);
                    vm.slug_avaliable = isAvailable;
                })
                .catch(function (err) {
                    vm.checkingSlug = false;
                    $log.error(err);
                })
        };

        vm.checkSpelling = function (text) {
            var regex = /\s/;
            console.log("text", text);
            if (regex.test(text.slice(-1))) {
                console.log("text", text);
            } else {
                console.log("illa");
            }
        };

        vm.generateDescription = function () {
            vm.product.description = "<div layout-gt-sm='row' layout-sm='column' layout-xs='column' class='row layout-gt-sm-row'>";
            var attributes = vm.product.attributes;
            vm.product.description += "<ul flex class='col md 6 flex-50'>";
            for (var i = 0; i < attributes.length / 2; i++) {
                var attr = attributes[i].attribute;
                vm.product.description += "<li><span class='md-subhead'>" + attr.meta_key + " : " + vm.getSelectedAttribute(attributes[i]) + "</span></li>"
            }
            vm.product.description += "</ul>";
            vm.product.description += "<ul flex class='col md 6 flex-50'>";
            for (var i = (attributes.length / 2); i < attributes.length; i++) {
                var attr = attributes[i].attribute;
                vm.product.description += "<li><span class='md-body-1'>" + attr.meta_key + " : " + vm.getSelectedAttribute(attributes[i]) + "</span></li>"
            }
            vm.product.description += "</ul>";
            vm.product.description += "</div>";
        };


        vm.parseInt = function (value) {
            return parseInt(value);
        };

        // vm.generateDescription();
    }]);

/**
 * Created by kumardivyarajat on 05/12/16.
 */
angular.module("app.products")
    .controller("products.add.finish.controller", ["$scope", "$log", "RestManager", "CriticalUpdateConfirmation", function ($scope, $log, RestManager, CriticalUpdateConfirmation) {
        var vm = this;
        vm.product = $scope.$parent.product;
        $log.debug("From Product Finish controller", vm.product);
        if (typeof vm.product.isFeatured === "undefined") {
            vm.product.isFeatured = false;
        }

        if (!vm.product.qualityRating) {
            vm.product.qualityRating = 10;
        }

        vm.finishOptions = {
            startAngle: 90,
            endAngle: 180,
            displayPrevious: true,
            prevBarColor: 'rgba(255,0,0,.2)',
            trackColor: 'rgba(255,0,0,.2)',
            skin: {
                type: 'tron'
            },
            scale: {
                enabled: true,
                type: 'lines',
                width: 2,
                quantity: 5
            }
        };

        vm.transformCapital = function () {
            console.log("transformCapital", "Buee", _.toUpper(vm.product.sku));
            vm.product.sku = _.toUpper(vm.product.sku);
        };

        vm.promise = RestManager.getResource("/settings/size_charts", "size_charts")
            .then(function (data) {
                data = data.map(function (sizeChart) {
                    sizeChart.values = sizeChart.values.values;
                    return sizeChart;
                });
                vm.sizeCharts = data;
            })
            .catch(function (err) {
                console.log(err);
            });

        vm.openSkuChangeConfirm = function (ev) {
            CriticalUpdateConfirmation.showDialog({
                targetEvent: ev,
                title: 'Do you want to change the SKU?',
                description: 'Regenerating the SKU will break the existing functionality where external and internal providers like Facebook and Google link back to Aarida.',
                infoMessage: 'Please make sure that you understand what you are doing.',
                inputValidatorString: vm.product.name
            })
                .then(function (result) {
                    if (result) {
                        vm.getSku();
                    }
                })
                .catch(function (err) {

                })
        };

        vm.getSku = function () {
            RestManager.getResource("/products/admin/sku", "sku")
                .then(function (sku) {
                    vm.product.sku = sku;
                    console.log(sku);
                })
                .catch(function (err) {

                })
        };

        vm.getUsers = function () {
            var query = {
                query: {
                    $or: [
                        {
                            role: "admin"
                        },
                        {
                            role: "designer"
                        }
                    ]
                },
                page: 1,
                limit: 50,
                order: {},
                searchTerm: ""
            };
            RestManager.postResource("/users/admin", query, "users")
                .then(function (users) {
                    console.log("users", users);
                    vm.users = users;
                })
                .catch(function (err) {
                    console.log(err);
                })
        };

        vm.getUsers();

        vm.removeSizeChart = function () {
            delete vm.product.sizeChart;
        };
    }]);

/**
 * Created by kumardivyarajat on 05/12/16.
 */
angular.module("app.products")
    .controller("products.add.customisation.controller", ["$scope", "$mdToast", "OptionsService", "$log", "$mdDialog", "$mdSidenav", "RestManager", "Utils", "Base", function ($scope, $mdToast, OptionsService, $log, $mdDialog, $mdSidenav, RestManager, Utils, Base) {
        var vm = this;
        var editingParent, editingIndex;

        vm.url = Base.getMediaUrl();
        vm.neckOptions = OptionsService.neckOptions;
        vm.sleevesOptions = OptionsService.sleeveOptions;

        vm.optionsObject = {
            Neck: OptionsService.neckOptions,
            Sleeves: OptionsService.sleeveOptions,
            Length: OptionsService.lengthOptions,
            Buttons: OptionsService.neckOptions
        };

        vm.editorTypes = [
            {
                name: 'Simple Editor',
                description: "Choose this editor type if we don't have the images ready for customisation.",
                image: "/assets/images/simple-editor.gif",
                value: 'simple'
            }, {
                name: 'Intermediate Editor',
                description: "Choose this editor type if you want the users to change only neck, sleeves.",
                image: "/assets/images/intermediate-editor-preview.gif",
                value: 'intermediate'
            }, {
                name: 'Advanced Editor',
                description: "Choose this editor type if you want the users to be able to change fabric / color too.",
                image: "/assets/images/Kurti-Design.gif",
                value: 'advanced'
            }
        ];

        vm.onboard = {
            title: '',
            subtitle: '',
            currentForm: ''
        };
        vm.templates = [];

        vm.expandAll = true;
        vm.showOptionPreview = false;
        vm.layers = ['Fabric', 'Neck', 'Sleeves', 'Length', 'Buttons'];


        vm.product = $scope.$parent.product;
        vm.layerTemplates = [
            {
                name: "Size",
                preview: false,
                options: []
            }
        ];

        if (!vm.product.customisation) {
            vm.product.customisation = {
                data: [],
                preview: true
            };
        } else {
            vm.product.customisation.data.sort(function (o) {
                o.width = (o.options.length * 310) + 'px';
                return getPos(o.name, vm.product.customisation.data.length);
            });
            vm.selectedLayer = vm.product.customisation.data[0];
            vm.selectedIndex = 0;
        }


        vm.getPrice = getPrice;
        vm.clearDefaults = clearDefaults;
        vm.addTriggers = addTriggers;
        vm.getOptions = getOptions;
        vm.removeTrigger = removeTrigger;
        vm.getBackgroundScale = getBackgroundScale;
        vm.getSelectedPosition = getSelectedPosition;
        vm.toggleFullScreen = toggleFullScreen;
        vm.correctName = correctName;
        vm.openProductTemplatesDialog = openProductTemplatesDialog;
        vm.fetchTemplatesCount = fetchTemplatesCount;

        function fetchTemplatesCount() {
            if (vm.product.customisation && vm.product.customisation._id) {
                vm.fetchingTemplatesCount = true;
                RestManager
                    .getResource('/ucData/templates/count', 'ucData', {
                        query: {
                            isTemplate: true,
                            product: vm.product._id,
                            customisation: vm.product.customisation._id || vm.product.customisation
                        },
                        extras: ['total']
                    })
                    .then(function (result) {
                        console.log('Toal', result);
                        vm.templatesCount = result.total;
                        vm.fetchingTemplatesCount = false;
                    })
                    .catch(function (err) {
                        console.log(err);
                        vm.fetchingTemplatesCount = false;
                    })
            } else {
                vm.noCustomisation = true;
            }
        }


        function openProductTemplatesDialog(event) {
            var product = {};
            angular.copy(vm.product, product);
            $mdDialog.show({
                locals: {
                    product: product,
                    ucData: null
                },
                controller: "product-templates.controller",
                templateUrl: 'app/modules/products/productTemplates/product-templates.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: event,
                fullscreen: true,
                clickOutsideToClose: true
            })

        }

        function correctName(option) {
            option.name = Utils.getProperName(option.name, 40);
        }

        function toggleFullScreen() {
            var classes = ['main-toolbar', 'product-navbar', 'product-section-title'];
            classes.forEach(function (className) {
                document.querySelector('.' + className).classList.toggle('ng-hide');
            })
        }

        function getBackgroundScale(datum) {
            if (datum && datum.extras && datum.extras.backgroundScale) {
                return datum.extras.backgroundScale + '%';
            }
            var name = datum ? datum.name : vm.selectedLayer.name;
            switch (name) {
                case "Pattern" :
                    return "100%";

                case "Sleeves" :
                    return "175%";

                case "Length" :
                    return "100%";

                case "Neck" :
                    return "175%";

                case "Necks":
                    return "175%";

                case "Product Type":
                    return "100%";

                default :
                    return "center";
            }
        }

        function getSelectedPosition(datum) {
            if (datum && datum.extras && datum.extras.backgroundPosition) {
                return datum.extras.backgroundPosition;
            }
            var name = datum ? datum.name : vm.selectedLayer.name;
            switch (name) {
                case "Pattern" :
                    return "center";

                case "Sleeves" :
                    return "top";

                case "Length" :
                    return "bottom";

                case "Neck" :
                    return "top";

                case "Necks":
                    return "top";

                default :
                    return "center";
            }
        }

        function removeTrigger(option, index) {
            option.triggers.splice(index, 1);
        }

        function addTriggers(option) {
            if (!option.triggers) {
                option.triggers = []
            }
            option.triggers.unshift({
                triggerType: '',
                linkedLayer: '',
                options: []
            });
        }

        function getOptions(linkedLayer) {
            if (!linkedLayer) {
                return [];
            }
            var layer = _.find(vm.product.customisation.data, function (datum) {
                return datum._id === linkedLayer;
            });
            return layer.options;
        }


        function getPrice(stockAndPrice) {
            return Utils.getPrice(stockAndPrice);
        }

        function getPos(name, lastIndex) {
            switch (name) {
                case "Fabric" :
                    return 0;

                case "Borders" :
                    return lastIndex + 1;

                case "Button" :
                    return lastIndex + 1;

                case "Pockets" :
                    return lastIndex + 1;

                default :
                    return lastIndex;
            }
        }

        $log.debug("From Product Customisation controller", vm.product);

        vm.openSingleUploader = function (event, context, childIndex, parentIndex) {
            console.log("context", context, childIndex, parentIndex);
            $mdDialog.show({
                locals: {
                    multipleSelect: false,
                    select: "customisable",
                    options : null
                },
                controller: "upload.controller",
                templateUrl: 'app/modules/base/partials/uploader.html',
                parent: angular.element(document.body),
                targetEvent: event,
                fullscreen : true,
                clickOutsideToClose: true
            })
                .then(function (images) {
                    if (context == "base") {
                        vm.product.customisation.baseImage = images[0];
                    } else if (context == "option") {
                        vm.product.customisation.data[parentIndex].options[childIndex].image = images[0];
                    }
                }, function () {
                    $scope.status = 'You cancelled the dialog.';
                });
        };

        vm.openMultipleUploader = function (event, context, childIndex, parentIndex) {
            console.log("context", context, childIndex, parentIndex);
            $mdDialog.show({
                locals: {
                    multipleSelect: true,
                    select: "customisable",
                    options : null
                },
                controller: "upload.controller",
                templateUrl: 'app/modules/base/partials/uploader.html',
                parent: angular.element(document.body),
                targetEvent: event,
                fullscreen : true,
                clickOutsideToClose: true
            })
                .then(function (images) {
                    images.forEach(function (image, i) {
                        console.log(image);
                        var name = Utils.getProperName(image.filename.split('.')[0].replace(/\d+/g, ''));
                        var cur = childIndex + i;
                        if (cur !== 0 && cur !== childIndex &&
                            (!vm.product.customisation.data[parentIndex].options[cur] || !vm.product.customisation.data[parentIndex].options[cur].image)) {
                            vm.addOption(name);
                        }
                        vm.product.customisation.data[parentIndex].options[cur].image = image;
                        if (!vm.product.customisation.data[parentIndex].options[cur].name) {
                            vm.product.customisation.data[parentIndex].options[cur].name = name;
                        }
                        console.log(cur, childIndex, i, vm.product.customisation.data[parentIndex], image);
                    });
                }, function () {
                    $scope.status = 'You cancelled the dialog.';
                });
        };

        vm.editOption = function (layer, e) {
            vm.editingLayer = layer;
            $mdDialog.show({
                contentElement: "#layerDialog",
                parent: angular.element(document.body),
                targetEvent: e,
                fullscreen : true,
                clickOutsideToClose: true
            });
            e.stopPropagation();
        };


        vm.addLayer = function (cData, index) {
            // var editingMode = false;
            // if (!cData) {
            //     vm.newCData = {
            //         name: vm.getRecommendedName(vm.product.customisation.data.length)
            //     };
            //     editingMode = true;
            // } else {
            //     angular.copy(cData, vm.newCData);
            // }
            // console.log("addLayer", vm.newCData);
            // $scope.editName = false;
            // $mdDialog.show({
            //     scope: $scope,
            //     preserveScope: true,
            //     contentElement: '#optionsDialog',
            //     parent: angular.element(document.body),
            //     targetEvent: event,
            //     clickOutsideToClose: true
            // })
            //     .then(function (cData) {
            //         if (editingMode) {
            //             vm.product.customisation.data.splice(index, 1, cData);
            //         } else {
            //             vm.product.customisation.data.push(cData);
            //         }
            //     }, function () {
            //         $scope.status = 'You cancelled the dialog.';
            //     });


            vm.product.customisation.data.push({
                name: vm.getRecommendedName(vm.product.customisation.data.length),
                preview: false,
                options: []
            });
            // vm.addOption(vm.product.customisation.data.length - 1);
        };

        vm.selectLayer = function (layer, index) {
            console.log("selectLayer", layer, index);
            vm.selectedLayer = layer;
            vm.selectedIndex = index;
            vm.toggleOptions();
        };

        vm.optionsFetched = false;

        vm.import = function () {
            vm.optionsFetched = false;
            $mdSidenav('right').toggle()
                .then(function () {
                    if ($mdSidenav('right').isOpen() && !vm.optionsFetched) {
                        switch (vm.selectedLayer.name) {
                            case  "Fabric" :
                                RestManager.getResource("/c/customisationOptions/fabric", "customisations")
                                    .then(function (data) {
                                        vm.options = data.filter(function (fabric) {
                                            return !_.find(vm.product.customisation.data[0].options, function (o) {
                                                return o._id === fabric._id;
                                            });
                                        });

                                        console.log(vm.options);
                                        vm.optionsFetched = true;
                                    })
                                    .catch(function (err) {
                                        console.log(err);
                                    });
                                break;


                            case "Size":
                                var promise;
                                if (vm.product.sizeChart) {
                                    promise = RestManager.getResource("/settings/" + vm.product.sizeChart, "settings");
                                    promise.then(function (data) {
                                        console.log(data);
                                        vm.options = data[0].values.values.charts;
                                        console.log(vm.options);
                                        vm.optionsFetched = true;
                                    })
                                        .catch(function (err) {
                                            console.log(err);
                                        });
                                } else {

                                }
                                break;
                        }

                    }
                });
        };

        vm.getMin = function (values) {
            var a = _.sortBy(values, function (o) {
                return o.value;
            });
            return a[0].value;
        };

        vm.getMax = function (values) {
            var a = _.sortBy(values, function (o) {
                return o.value;
            });
            return a[a.length - 1].value;
        };

        vm.moveSize = function (value) {
            vm.selectedLayer.options.push({
                    stockAndPrice: {
                        price: {
                            productionCost: "",
                            salePrice: "",
                            mrp: ""
                        },
                        stock: {
                            manageStock: false,
                            backOrder: {
                                limit: "",
                                status: false
                            },
                            threshold: "",
                            quantity: ""
                        }
                    },
                    extras: {
                        min: vm.getMin(value.values),
                        max: vm.getMax(value.values)
                    },
                    isFabric: false,
                    name: value.key
                }
            );
            vm.options.values.splice($index, 1);
        };

        vm.getRecommendedName = function (layerIndex) {

            switch (layerIndex) {
                case 0:
                    return "Fabric";

                case 1 :
                    return "Neck";

                case 2 :
                    return "Sleeves";

                case 3 :
                    return "Length";

                case 4 :
                    return "Buttons";

                default :
                    return "";
            }
        };

        vm.removeLayer = function (index) {
            vm.product.customisation.data.splice(index, 1);
            if (vm.product.customisation.data[0]) {
                vm.selectLayer(vm.product.customisation.data[0], 0);
            } else {
                vm.selectLayer(null, null);
            }
        };

        vm.addOption = function (recommendedName) {
            var index = vm.selectedIndex;
            if (!vm.product.customisation.data[index].options) {
                vm.product.customisation.data[index].options = [];
            }
            vm.product.customisation.data[index].options.push({
                stockAndPrice: {
                    price: {
                        productionCost: 0,
                        salePrice: 0,
                        mrp: 0
                    },
                    stock: {
                        manageStock: false,
                        backOrder: {
                            limit: "",
                            status: false
                        },
                        threshold: "",
                        quantity: ""
                    }
                },
                name: recommendedName ? recommendedName : '',
                alias: recommendedName ? recommendedName : ''
            });
            console.log('vm.product.customisation.data[index]', vm.product.customisation.data[index]);
            vm.product.customisation.data[index].width = ((vm.product.customisation.data[index].options.length * 350) + 30) + 'px';
        };

        vm.removeOption = function (parent, index, ev) {
            ev.stopPropagation();
            vm.product.customisation.data[parent].options.splice(index, 1);
            vm.product.customisation.data[parent].width = ((vm.product.customisation.data[parent].options.length * 350) + 30) + 'px';
        };

        vm.toggleOptions = function (value) {
            if (vm.selectedLayer) {
                vm.selectedLayer.options = vm.selectedLayer.options.map(function (option) {
                    option.expanded = vm.expandAll;
                    return option;
                })
            }
        };

        vm.openOptionsDialog = function (parent, index) {
            vm.editingData = {};
            angular.copy(vm.product.customisation.data[parent], vm.editingData);
            editingIndex = index;
            editingParent = parent;
            console.log('openOptionsDialog', vm.editingData);
            $mdDialog.show({
                scope: $scope,
                fullscreen : true,
                preserveScope: true,
                contentElement: '#optionsDialog',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true
            });
        };


        vm.duplicateOption = function (parent, index, ev) {
            ev.stopPropagation();
            var option = vm.product.customisation.data[parent].options[index];

            if (!option.stockAndPrice) {
                option.stockAndPrice = {
                    stock: {},
                    price: {}
                }
            }

            if (!option.stockAndPrice.stock) {
                option.stockAndPrice.stock = {
                    backOrder: {}
                }
            }

            vm.product.customisation.data[parent].options.splice(index + 1, 0, {
                stockAndPrice: {
                    price: {
                        productionCost: option.stockAndPrice.price.productionCost,
                        salePrice: option.stockAndPrice.price.salePrice,
                        mrp: option.stockAndPrice.price.mrp
                    },
                    stock: {
                        manageStock: option.stockAndPrice.stock.manageStock,
                        backOrder: {
                            limit: option.stockAndPrice.stock.backOrder.limit,
                            status: option.stockAndPrice.stock.backOrder.status
                        },
                        threshold: option.stockAndPrice.stock.threshold,
                        quantity: option.stockAndPrice.stock.quantity
                    }
                },
                name: option.name + ' -  Copy',
                extras: {
                    alias: (option.extras && option.extras.alias) ? option.extras.alias + ' -  Copy' : ''
                },
                image: option.image,
                expanded: option.expanded,
                triggers: option.triggers
            });

            ev.stopPropagation();

        };

        vm.updateEditingOptionIndex = function (index) {
            vm.editingOptionIndex = index;
            vm.editingOption = vm.editingData.options[index];
        };


        vm.answer = function () {
            vm.product.customisation.data.splice(editingParent, 1, vm.editingData);
            $mdDialog.hide();
        };

        vm.buildToggler = function () {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav("right")
                    .toggle()
                    .then(function () {
                        $log.debug("toggle " + navID + " is done");
                    });
            }
        };

        function clearDefaults(updatedOption, event) {
            vm.selectedLayer.options = vm.selectedLayer.options.map(function (option) {
                option.isDefault = false;
                return option;
            });

            updatedOption.isDefault = true;

            vm.selectedLayer.default = updatedOption;
            console.log('clear defaults', vm.selectedLayer);
        }

        vm.closeSideNav = function () {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav('right').close()
                .then(function () {
                    $log.debug("close RIGHT is done");
                });

        };


        vm.selectEditor = function (editor) {
            vm.product.editorType = editor.value;
            vm.startEditing();
        };


        vm.changeForm = function (ctx) {
            switch (ctx) {
                case 'editor_type' :
                    vm.onboard.title = 'Select Customisation Editor';
                    vm.onboard.subtitle = 'Different customisation editors provide different types of experience to you as well as to our customers';
                    vm.onboard.currentForm = 'editor_type';
                    break;

                case 'simple_layers':
                    vm.onboard.title = 'Select Supported Customisation Layers';
                    vm.onboard.subtitle = 'Which options can the customer edit for this product?';
                    vm.onboard.currentForm = 'simple_layers';
                    break;

                case 'simple_options' :
                    vm.onboard.title = 'Select Customisation Options';
                    vm.onboard.subtitle = 'Half-Sleeve, Full-Pleated etc';
                    vm.onboard.currentForm = 'simple_options';
                    vm.selectedLayers = vm.supportedLayers.simple.filter(function (layer) {
                        return layer.checked;
                    });
                    console.log('Rege', vm.selectedLayers);
                    break;

                case 'select_defaults':
                    vm.onboard.title = 'Select Defaults and Pricing for Options';
                    vm.onboard.subtitle = 'Select the default option for each layer and then set the pricing for the options';
                    vm.onboard.currentForm = 'select_defaults';
                    vm.product.customisation.data = vm.selectedLayers.map(function (layer) {
                        layer.options = vm.optionsObject[layer.name]
                            .filter(function (option) {
                                return option.selected;
                            });
                        return layer
                    });
                    console.log('Product Customisation', vm.product.customisation);
                    vm.evalDefaultsFormDisabled();
                    break;


                case 'editor_pricing' :
                    vm.onboard.title = 'Set Customisation Pricing For the Product';
                    vm.onboard.subtitle = '';
                    vm.onboard.currentForm = 'editor_pricing';
                    vm.evalPricingFormDisabled();
                    break;

            }
        };

        vm.evalDefaultsFormDisabled = function () {
            var formDisabled;
            vm.defaultFormError = '';


            formDisabled = !vm.product.customisation.data.every(function (data) {
                if (!data.default) {
                    vm.defaultFormError = 'Please select a default option for layer : ' + data.name;
                }
                if (!data.options.length) {
                    vm.defaultFormError = 'There are no options present in ' + data.name + '. Please go back and select an option or remove the layer from the list.';
                }
                if (data.default && data.default.stockAndPrice.price.mrp) {
                    vm.defaultFormError = 'The default option for ' + data.name + ' has a MRP set. It should be 0 as it is sold for free.';
                }

                if (data.default && data.default.stockAndPrice.price.salePrice) {
                    vm.defaultFormError = 'The default option for ' + data.name + ' has a Sale Price set. It should be 0 as it is sold for free.';
                }
                if (data.default && data.default.stockAndPrice.price.salePrice) {
                    vm.defaultFormError = 'The default option for ' + data.name + ' has an Sale Price set. It should be 0 as it is sold for free.';
                }
                if (data.default && data.default.stockAndPrice.price.mrp) {
                    vm.defaultFormError = 'The default option for ' + data.name + ' has an MRP set. It should be 0 as it is sold for free.';
                }

                var otherPricing = data.options
                    .filter(function (option) {
                        return data.default !== option;
                    })
                    .every(function (option) {
                        if (typeof option.stockAndPrice.price.mrp === "undefined") {
                            vm.defaultFormError = 'The option with name ' + option.name + ' in ' + data.name + ' does not have an MRP set.';
                        }

                        if (typeof option.stockAndPrice.price.salePrice === 'undefined') {
                            vm.defaultFormError = 'The option with name  ' + option.name + ' in ' + data.name + ' does not have an sale price set.';
                        }

                        if (option.stockAndPrice.price.salePrice > option.stockAndPrice.price.mrp) {
                            vm.defaultFormError = 'The option with name  ' + option.name + ' in ' + data.name + ' has its Sale Price greater than the MRP. Not possible. Fix it please.';
                        }

                        return typeof option.stockAndPrice.price.salePrice !== "undefined" && typeof option.stockAndPrice.price.mrp !== 'undefined' && (option.stockAndPrice.price.salePrice <= option.stockAndPrice.price.mrp);
                    });


                return data.default && !data.default.stockAndPrice.price.mrp && !data.default.stockAndPrice.price.salePrice && otherPricing;
            });
            vm.defaultsFormDisabled = formDisabled;
            console.log('Evaling State', formDisabled, vm.defaultFormError);
        };

        vm.evalPricingFormDisabled = function () {
            vm.pricingFormError = '';

            if (!vm.product.customisation.basePrice) {
                vm.pricingFormError = 'The base price for customisation is not set. Please set it to continue.'
            }

            if (!vm.product.customisation.mrp) {
                vm.pricingFormError = 'The MRP for customisation is not set. Please set it to continue.'
            }

            if (vm.product.customisation.mrp < vm.product.customisation.basePrice) {
                vm.pricingFormError = 'The MRP for customisation is less than the base price. MRP should always be greater than or equal to the basePrice.'
            }

            vm.pricingFormDisabled = !vm.product.customisation.basePrice || !vm.product.customisation.mrp;

        };

        vm.startEditing = function () {
            if (vm.product.editorType === 'simple') {
                vm.changeForm('simple_layers');
            } else if (vm.product.editorType === 'intermediate') {
                vm.changeForm('simple_layers');
            } else if (vm.product.editorType === 'intermediate') {
                vm.changeForm('simple_layers');
            }
        };


        vm.getLayers = function (ctx, existingCustomisationData) {
            switch (ctx) {
                case 'simple' :
                    var layers = [];
                    layers = vm.layers
                        .filter(function (value) {
                            return ['Sleeves', 'Neck', 'Length', 'Buttons'].includes(value)
                        })
                        .map(function (value) {
                            var layerData = {
                                name: value,
                                preview: false,
                                checked: false
                            };
                            if (existingCustomisationData._id) {
                                var d = _.find(existingCustomisationData.data, function (data) {
                                    return data.name === value;
                                });
                                if (d) {
                                    d.checked = true;
                                    layerData = d;
                                }
                            }
                            return layerData
                        });
                    console.log('A', layers);
                    return layers;

            }
        };

        vm.showImages = function ($ev) {
            $mdDialog.show({
                contentElement: '#product-image-preview',
                preserveScope: true,
                scope: $scope,
                ev: $ev,
                allowMultiple: true,
                fullscreen: true,
                escapeToClose: true,
                clickOutSideToClose: true
            });
            vm.selectedImage = vm.product.gallery[0];
        };


        vm.hideOnboardingTool = function () {
            vm.product.isOnboardingDone = true;
            vm.product.editorType = 'simple';
        };

        vm.supportedLayers = {
            simple: vm.getLayers('simple', vm.product.customisation)
        };

        vm.init = function () {
            try {
                if (!vm.product.customisation.basePrice) {
                    vm.product.customisation.basePrice = _.minBy(vm.product.variations, function (variation) {
                        return (variation.stockAndPrice && variation.stockAndPrice.price) ? variation.stockAndPrice.price.salePrice : 0;
                    }).stockAndPrice.price.salePrice;

                    console.log("products.add.customisation.controller.js", "init base", vm.product.customisation.basePrice);
                }

                if (!vm.product.customisation.mrp) {
                    vm.product.customisation.mrp = _.minBy(vm.product.variations, function (variation) {
                        return (variation.stockAndPrice && variation.stockAndPrice.price) ? variation.stockAndPrice.price.mrp : 0;
                    }).stockAndPrice.price.mrp;
                    console.log("products.add.customisation.controller.js", "init mrp", vm.product.customisation.mrp);
                }
            } catch (e) {
                $log.error('Error with the init method of product add customisation controller', e);
            }
        };

        vm.changeForm('editor_type');

        vm.toggleOptions();
        vm.fetchTemplatesCount()
        vm.init()

    }]);

/**
 * Created by kumardivyarajat on 05/12/16.
 */
angular.module("app.products")
    .controller("products.add.categories.controller", ["$scope", "$log", "RestManager", function ($scope, $log, RestManager) {
        var vm = this;
        vm.product = $scope.$parent.product;
        $log.debug("From Product Categories controller", vm.product);
        $scope.searchModel = '';

        RestManager.getResource("/categories/all", "categories")
            .then(function (categories) {
                var s = _.chain(categories)
                    .sortBy(function (c) {
                        return c.name;
                    })
                    .groupBy(function (b) {
                        return b.parent;
                    })
                    .value();

                console.log(s);
                var cat = s["undefined"];
                console.log(cat);
                _.forOwn(s, function (value, key) {
                    if (key !== "undefined") {
                        var index = _.findIndex(cat, function (o) {
                            return o._id === key;
                        });
                        _.forEach(value, function (v) {
                            cat.splice(index + 1, 0, v);
                        });
                    }
                });
                console.log(cat);
                vm.categories = cat;
            })
            .catch(function (err) {
                $log.error(err);
            });


        vm.checkInfo = function (category, index) {
            console.log("categoru", category, index);
            var foundIndex = _.findIndex(vm.product.categories, {'_id': category._id});
            if (foundIndex === -1) {
                vm.product.categories.push(category);
            } else {
                vm.product.categories.splice(foundIndex, 1);
            }
        };

        vm.checkPresent = function (category) {
            return _.findIndex(vm.product.categories, {'_id': category._id}) !== -1;
        }
    }]);

/**
 * Created by kumardivyarajat on 05/12/16.
 */
angular.module("app.products")
    .controller("products.add.attributes.controller", ["$scope", "$log", "RestManager", "$mdDialog", "$mdToast", function ($scope, $log, RestManager, $mdDialog, $mdToast) {
        var vm = this;
        vm.product = $scope.$parent.product;
        $log.debug("From Product Attributes controller", vm.product);
        vm.searchTerm = '';
        vm.loadingAttributes = true;

        vm.addAttribute = function () {
            vm.product.attributes.unshift({attribute: {}});
        };

        vm.removeAttribute = function (index) {
            vm.product.attributes.splice(index, 1);
        };

        vm.log = function (data) {
            console.log('DATA', data);
        };

        vm.searchProducts = function () {
            return RestManager.getResource("/products/admin/search/" + vm.searchQuery, "products");
        };

        vm.clearSearchTerm = function () {
            vm.searchTerm = '';
        };

        vm.copyAttributes = function () {
            RestManager.getResource("/products/admin/" + vm.selectedProduct._id, "products")
                .then(function (products) {
                    console.log(products);
                    vm.product.attributes = products[0].attributes;
                })
                .catch(function (err) {
                    console.log(err);
                })
        };

        vm.showMissingAttributesDialog = showMissingAttributesDialog;

        function showMissingAttributesDialog(ev) {
            var htmlContent = '<p>Some of the mandatory attributes are missing from the product.</p>' +
                '<ul>';

            vm.missingAttributes.forEach(function (attribute) {
                htmlContent += '<li>' +
                    attribute.meta_key +
                    '</li>'
            });
            htmlContent += '</ul>' +
                '<p>Would you like to add it to the product right now?</p>';

            var confirm = $mdDialog.confirm()
                .title('Mandatory attributes missing')
                .htmlContent(htmlContent)
                .ariaLabel('Missing Attributes')
                .targetEvent(ev)
                .ok('Add Attributes')
                .cancel('Cancel');

            $mdDialog.show(confirm)
                .then(function () {
                    vm.missingAttributes.forEach(function (attribute) {
                        vm.product.attributes.unshift({attribute: attribute});
                    });

                    $mdToast.showSimple('Added missing attributes successfully');
                });
        }


        RestManager.getResource("/attributes", "attributes")
            .then(function (attributes) {
                vm.attributes = attributes;
                var tabsGroup = _.chain(attributes)
                    .groupBy(function (attribute) {
                        return attribute.vendorName;
                    })
                    .value();

                if (!tabsGroup['undefined']) {
                    tabsGroup['undefined'] = [];
                }

                tabsGroup['undefined'] = tabsGroup['undefined'].concat(tabsGroup['']);
                delete tabsGroup[''];

                vm.tabs = [];
                _.forOwn(tabsGroup, function (val, key) {
                    return vm.tabs.push({
                        key: key,
                        value: val
                    })
                });

                vm.missingAttributes = vm.attributes.filter(function (attribute) {
                    return attribute.isMandatory && !_.some(vm.product.attributes, function (attributeData) {
                        return attributeData.attribute._id === attribute._id;
                    });
                });

                console.log('missingAttributes', vm.missingAttributes);

                if (vm.missingAttributes.length) {
                    vm.showMissingAttributesDialog();
                }

                vm.loadingAttributes = false;
            })
            .catch(function (err) {
                console.log(err, "Err");
            })
    }]);

(function () {
    'use strict';
    angular.module("app.offers.giftCards",[]);

})(angular);

(function () {
    'use strict';

    activateCard.$inject = ["$scope", "$mdDialog", "RestManager", "$q", "cardId", "$mdToast", "Base"];
    angular.module("app.offers.giftCards")
        .controller("activateCard.controller", activateCard);

    function activateCard($scope, $mdDialog, RestManager, $q, cardId, $mdToast, Base) {

        $scope.agent = '';
        $scope.organisations = [];
        $scope.selectedAgent = '';
        $scope.selectedUser = '';
        $scope.editUserBox = false;
        $scope.editAgentBox = false;
        $scope.agentSearch = '';
        $scope.loadingAgents = false;
        $scope.status = [
            {
                "type": "Created",
                "value": "created"
            },
            {
                "type": "Generated",
                "value": "generated"
            },
            {
                "type": "Activated",
                "value": "activated"
            },
            // {
            //     "type": "Redeemed",
            //     "value": "redeemed"
            // },
            {
                "type": "Blocked",
                "value": "blocked"
            }

        ];
        $scope.customerUrl = "/users/admin/create";

        $scope.newCustomer = {
            flags: {
                "onboardUser": true
            },
            // status: 1,
            // points: 0,
            mobile: '',
            email: '',
            name: ''
        }

        $scope.query = query;
        // $scope.changeAgent = changeAgent;
        $scope.addCustomers = addCustomers;
        $scope.selectedCustomerChange = selectedCustomerChange;
        $scope.close = close;
        $scope.completeAgentDetails = completeAgentDetails;
        $scope.activateCard = activateCard;
        $scope.fetchAllOrgs = fetchAllOrgs;
        $scope.selectAgent = selectAgent;
        $scope.newCustomerModal = newCustomerModal;
        $scope.addCustomer = addCustomer;
        $scope.initUser = initUser;
        $scope.generateShortUrl = generateShortUrl;
        $scope.checkAndSave = checkAndSave;

        function selectAgent() {
            $scope.selectedAgent = _.find($scope.agents, function (agent) {
                console.log("activateCard.controller.js", "AgentID", $scope.cardDetails.agent);
                return agent._id === $scope.cardDetails.agent;
            });
        }

        function initUser() {
            $scope.editUserBox = !($scope.cardDetails.user && $scope.cardDetails.user._id);
        }


        function fetchAllOrgs() {
            RestManager.getResource("/org", "organisations")
                .then(function (result) {
                    $scope.organisations = result.map(function (org) {
                        return {
                            name: org.name,
                            _id: org._id
                        };
                    });
                })
                .catch(function (err) {
                    console.log(err);
                });
        }

        function close() {
            $mdDialog.cancel();
        }


        function newCustomerModal(e, searchText) {
            var parentEl = angular.element(document.body)
            $scope.newCustomer.mobile = searchText;
            $mdDialog.show({
                parentEl: parentEl,
                targetEvent: e,
                fullscreen : true,
                templateUrl: "app/modules/offers/giftCards/all/activateCard/partials/newCustomer.tmpl.html",
                scope: $scope,
                preserveScope: true,
                multiple: true
            })

        }


        function addCustomer() {
            $scope.isAdding = true;
            RestManager.postResource($scope.customerUrl, $scope.newCustomer, "user")
                .then(function (data) {
                    $scope.isAdding = false;
                    $scope.cardDetails.user = data[0];
                    $mdToast.show($mdToast.simple()
                        .textContent('New Customer Added')
                        .position('bottom-left')
                    );
                    $scope.close();
                })
                .catch(function (err) {
                    console.log("giftCardsAll.controller.js", "ERR", err);
                    $scope.isAdding = false;
                    $mdDialog.hide();
                });


        }

        function generateShortUrl() {
            return new $q(function (resolve, reject) {
                var data = {};
                angular.copy($scope.cardDetails, data);
                if (!data.shortLink
                    && data.user
                    // ) {
                    && Base.getEnv() === 'prod') {
                    $scope.savingShortLink = true;
                    var url = Base.getAppUrl() + '/account/gift-cards?openRedeem=true&h=' + window.btoa(data.user.mobile) + '&c=' + window.btoa(data.code) + '&utm_source=aarida-shortlinks&utm_campaign=shortlinksGiftCard&utm_medium=sms&utm_content=sms';
                    RestManager.postResource('', {url: url}, 'urls', {service: 'shortUrl'})
                        .then(function (result) {
                            $scope.savingShortLink = false;
                            $scope.cardDetails.shortLink = result[0].url;
                            resolve(result[0].url)
                        })
                        .catch(function (err) {
                            $scope.savingShortLink = false;
                            $mdToast.showSimple('Error generating short link : ', err.message || err);
                            reject(err);
                        })
                } else {
                    $scope.loading = false;
                    resolve();
                }
            })
        }


        // function changeAgent(i) {
        //     Sscope.selectedAgent
        // }

        function addCustomers() {
            $scope.selectedUser = {};
        }

        $scope.getAgents = function () {
            if (!$scope.cardDetails.organisation) {
                return;
            }
            var query = {
                query: {
                    role: "org-agent",
                    organisation: $scope.cardDetails.organisation
                },
                page: 1,
                limit: 100,
                order: {},
                searchTerm: $scope.agentSearch
            };
            $scope.agents = [];
            $scope.loadingAgents = true;
            RestManager.postResource("/users/admin", query, "users")
                .then(function (users) {
                    console.log("agents", users);
                    $scope.agents = users.map(function (user) {
                        return {
                            mobile: user.mobile,
                            email: user.email,
                            _id: user._id,
                            name: user.name
                        };
                    });
                    $scope.loadingAgents = false;
                })
                .catch(function (err) {
                    console.log(err);
                    $scope.loadingAgents = false;
                });
        };

        function query(searchText) {
            return $scope.getAllUsers(searchText);
        }

        function selectedCustomerChange(user) {
            $scope.cardDetails.user = user;
            $scope.selectedUser = {};
            console.log("activateCard.controller.js", "selectedCustomerChange", user.name);
            // console.log("activateCard.controller.js", "selectedCustomerChange", user);
        }


        $scope.fetchCardsById = function () {
            console.log("activateCard.controller.js", "fetchCardsById", cardId);
            var url = "/giftCards/";
            $scope.promise = RestManager.getResource(url + cardId, "cards");
            $scope.loading = true;
            $scope.promise
                .then(function (data) {
                    $scope.cardDetails = data[0];
                    $scope.selectedUser = $scope.cardDetails.user;
                    $scope.selectedAgent = $scope.cardDetails.agent;
                    if ($scope.cardDetails.organisation) {
                        $scope.cardDetails.organisation = $scope.cardDetails.organisation._id;
                    }
                    if ($scope.cardDetails.agent) {
                        $scope.cardDetails.agent = $scope.cardDetails.agent._id;
                    }
                    $scope.getAgents();
                    $scope.fetchAllOrgs();
                    $scope.initUser();

                    console.log("activateCard.controller.js", "USER & AGENT", $scope.selectedUser, $scope.selectedAgent);
                    console.log("activateCard.controller.js", "Card Details", $scope.cardDetails);

                    return $scope.generateShortUrl()
                })
                .then(function (shortLink) {
                    if(shortLink) {
                        $scope.activateCard();
                    }
                })
                .catch(function (err) {
                    console.log("giftCardsDetails.controller.js", "CARD DETAILS ERROR", err);
                });

        };


        $scope.getAllUsers = function (searchText) {
            var query = {
                query: {
                    // role: "customer"
                },
                page: 1,
                limit: 50,
                order: {},
                searchTerm: searchText,
            };

            return $q(function (resolve, reject) {
                $scope.promise = RestManager.postResource("/users/admin", query, "users");
                $scope.promise
                    .then(function (users) {
                        users = users.map(function (user) {
                            return {
                                mobile: user.mobile,
                                email: user.email,
                                _id: user._id,
                                name: user.name
                            };
                        });
                        resolve(users);
                    })
                    .catch(reject);
            });
        };


        function completeAgentDetails(agent) {
            console.log("activateCard.controller.js", "completeAgentDetails", agent);
            //     $scope.email = agent.email;
            //
            //     $scope.contactNumber = agent.mobile;
            //     console.log("activateCard.controller.js", "completeAgentDetails", agent.email);
            //
        }

        function checkAndSave() {
            $scope.isActivating = true;
            $scope.generateShortUrl()
                .then(function (shortLink) {
                    console.log('SHort libk', shortLink);
                    $scope.activateCard(true);
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error while saving gift card : ', err);
                })
        }

        function activateCard(hide) {
            console.log('Giftcard', $scope.cardDetails);
            $scope.isActivating = true;

            var payload = {
                _id: $scope.cardDetails._id,
                status: $scope.cardDetails.status,
                rechargeAmount: $scope.cardDetails.rechargeAmount,
                agent: $scope.cardDetails.agent,
                user: $scope.cardDetails.user ? $scope.cardDetails.user._id : null,
                organisation: $scope.cardDetails.organisation,
                shortLink: $scope.cardDetails.shortLink
            };

            if ($scope.cardDetails.isActive) {
                payload.status = 'activated';
            }

            RestManager.putResource('/giftCards', payload, 'cards')
                .then(function (cards) {
                    console.log('cards', cards);
                    $scope.isActivating = false;
                    $scope.loading = false;
                    if(hide) {
                        $mdDialog.hide({updatedCard: cards[0]});
                    }

                })
                .catch(function (err) {
                    console.log('err', err);
                    $mdToast.showSimple('Error while saving gift card : '+ err);
                    $scope.isActivating = false;
                });
        }


        $scope.fetchCardsById();
    }

})
(angular);

(function () {
    'use strict';
  angular.module("app.offers", ["app.offers.giftCards"]);

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 04/12/19, 11:14 PM
 *
 */

(function () {
    'use strict';

    UpdateExpiry.$inject = ["$scope", "RestManager", "$mdDialog", "$mdToast", "cards"];
    angular.module('app.offers')
        .controller('updateExpiry.controller', UpdateExpiry);

    /** @ngInject **/
    function UpdateExpiry($scope, RestManager, $mdDialog, $mdToast, cards) {
        $scope.dateRange = 'redemptionDate';
        $scope.selectedTemplate = null;
        $scope.expiryDate = null;

        $scope.dateTemplates = [
            {
                label: '1 month from Selected Date Type',
                fn: 'add',
                amount: 1,
                unit: 'month',
                value: '1_month'
            },
            {
                label: '3 months from Selected Date Type',
                fn: 'add',
                amount: 3,
                unit: 'month',
                value: '3_month'
            },
            {
                label: '6 months from Selected Date Type',
                fn: 'add',
                amount: 6,
                unit: 'month',
                value: '6_month'
            },
            {
                label: '1 year from Selected Date Type',
                fn: 'add',
                amount: 1,
                unit: 'year',
                value: '3_year'
            },
            {
                label: 'Custom Date',
                value: 'custom'
            }
        ];

        $scope.cards = cards;
        $scope.close = $mdDialog.cancel;
        $scope.updateExpiryDate = updateExpiryDate;
        $scope.saveExpiryDate = saveExpiryDate;

        function updateExpiryDate() {
            $scope.cards.forEach(function (card) {
                if ($scope.selectedTemplate.value === 'custom') {
                    card.expiryDate = moment($scope.expiryDate).endOf('day').toISOString();
                } else {
                    card.expiryDate = moment(card[$scope.dateRange]).endOf('day')[$scope.selectedTemplate.fn]($scope.selectedTemplate.amount, $scope.selectedTemplate.unit).toISOString()
                }
            })
        }

        function saveExpiryDate() {
            $scope.savingExpiry = true;
            Promise.map($scope.cards, function (card) {
                return new Promise(function (resolve, reject) {
                    card.updated = false;
                    if(!card.expiryDate) {
                        card.updated = true;
                        card.success = false;
                        card.error = 'Expiry Date not set';
                        resolve(card);
                    } else {
                        RestManager.patchResource('/giftCards/expiryDate/' + card._id, {date: card.expiryDate}, 'expiryDate')
                            .then(function (data) {
                                card.updated = true;
                                card.success = true;
                                resolve(card);
                            })
                            .catch(function (err) {
                                card.updated = true;
                                card.success = false;
                                card.error = err.message;
                                resolve(card);
                            });
                    }
                })
            })
                .then(function (results) {
                    $scope.savingExpiry = false;
                    var allSuccess = _.every(results, function (card) {
                        return card.success;
                    });
                    console.log("updateExpiryDate.controller.js", "allS", allSuccess);
                    if (allSuccess) {
                        $mdDialog.hide(results);
                    }
                    $mdToast.showSimple('Updated Expiry Date');
                })
                .catch(function (error) {
                    console.log("updateExpiryDate.controller.js", "err", error);
                    $mdToast.showSimple('Error updating expiry date : '  + error.message);
                })

        }

    }

})(angular);

(function () {
    'use strict';
    taskDetailsController.$inject = ["$scope", "$mdToast", "$stateParams", "RestManager", "$mdDialog"];
    angular.module('app.tasks')
        .controller('taskDetails.controller', taskDetailsController);

    function taskDetailsController($scope, $mdToast, $stateParams, RestManager, $mdDialog) {
        $scope.$parent.nestedState = true;
        $scope.$parent.showActionButton = false;
        $scope.$parent.$parent.backParams = {};
        $scope.$parent.backState = $stateParams.backState || "app.tasks.all";
        $scope.$parent.pageTitle = "Task Details";


        $scope.fetchSingleTask = fetchSingleTask;
        $scope.showHistory = showHistory;
        $scope.completeTask = completeTask;
        $scope.selectImage = selectImage;

        function selectImage(image, index) {
            $scope.selectedImage = image;
            $scope.task.images = $scope.task.images.map(function (image) {
                image.active = false;
                return image;
            });
            $scope.task.images[index].active = true;
        }

        function fetchSingleTask() {
            RestManager.getResource('/tasks/' + $stateParams.id, 'tasks', {service: 'workforce'})
                .then(function (response) {
                    $scope.task = response[0];
                    var index = _.findIndex($scope.task.images, function (image) {
                        return image.urls.thumbnail === $scope.task.previewImageUrl;
                    });

                    if (index === -1 && $scope.task.images.length) {
                        index = 0;
                    }
                    if (index !== -1) {
                        $scope.selectedImage = $scope.task.images[index];
                        $scope.task.images[index].active = true;
                    }

                    console.log('image', index, $scope.selectedImage);
                    //TODO: will not work if seconds exceeds 86400, i.e, 1 day
                    $scope.allottedTime = moment.utc($scope.task.allottedDuration * 1000).format('HH:mm');
                })
                .catch(function (err) {
                    console.log(err);
                    $mdToast.showSimple("Error in fetching task :" + err.message);
                });
        }

        function completeTask() {
            $scope.completingTasks = true;
            RestManager.patchResource('/tasks/status', {
                taskId: $scope.task._id,
                status: 'completed'
            }, 'tasks', {service: 'workforce'})
                .then(function (tasks) {
                    $scope.task = tasks[0];
                    $scope.completingTasks = false;
                })
                .catch(function (err) {
                    $scope.completingTasks = false;
                    $mdToast.showSimple("Error completing task :" + err.message);
                });
        }

        function showHistory(event) {
            $mdDialog.show({
                templateUrl: 'app/modules/workforce/tasks/dialogs/task-history/task-history-dialog.html',
                controller: 'taskHistoryDialog.controller',
                fullscreen: true,
                multiple: true,
                locals: {
                    notes: $scope.task.notes
                },
                targetEvent: event
            });
        }

        $scope.fetchSingleTask();
    }

})(angular);

(function () {
    'use strict';
    allTasksController.$inject = ["$scope", "RestManager", "$mdToast", "Workforce", "Design"];
    angular.module('app.tasks')
        .controller('all-tasks.controller', allTasksController);

    function allTasksController($scope, RestManager, $mdToast, Workforce, Design) {
        $scope.$parent.nestedState = false;
        $scope.$parent.showActionButton = false;
        $scope.$parent.pageTitle = "Task List";
        $scope.$parent.$parent.backParams = {};

        $scope.fetchingOrders = false;
        $scope.orderQuery = {
            page: 1,
            limit: 10,
            orderBy: "-createdAt",
            search: '',
            filter: {
                'lineItems.hasTasks': true
            }
        };

        $scope.designQuery = {
            page: 1,
            limit: 10,
            sort: '-createdAt',
            // hasTasks:
        };

        $scope.fetchOrders = fetchOrders;
        $scope.fetchDesigns = fetchDesigns;
        $scope.toggleLineItem = toggleLineItem;
        $scope.toggleLineItemTasks = toggleLineItemTasks;
        $scope.fetchTasks = fetchTasks;
        $scope.fetchTasksForDesign = fetchTasksForDesign;
        $scope.toggleDesignTasks = toggleDesignTasks;


        function fetchOrders() {
            $scope.fetchingOrders = true;
            $scope.orders = [];
            RestManager.postResource('/order/admin/getOrders', $scope.orderQuery, "orders", ["total"])
                .then(function (response) {
                    $scope.fetchingOrders = false;
                    $scope.orders = response.orders;
                    console.log("all-tasks.controller.js", "Tasks", $scope.orders);
                    $scope.totalCount = response.total;
                })
                .catch(function (err) {
                    $scope.fetchingOrders = false;
                    $mdToast.showSimple('Error in fetching tasks :' + err.message);
                });
        }

        function toggleLineItem(order) {
            order.showLineItems = !order.showLineItems;
        }

        function toggleLineItemTasks(lineItem) {
            lineItem.showTasks = !lineItem.showTasks;

            if (lineItem.showTasks) {
                $scope.fetchTasks(lineItem);
            }
        }

        function toggleDesignTasks(design) {
            design.showTasks = !design.showTasks;
            if (design.showTasks) {
                $scope.fetchTasksForDesign(design);
            }
        }

        function fetchTasks(lineItem) {
            lineItem.loading = true;
            Workforce.fetchTasksForLineItem({
                lineItems: lineItem._id,
                page: 1,
                limit: 10,
                sort: '-createdAt'
            })
                .then(function (tasks) {
                    lineItem.hydratedTasks = tasks;
                    lineItem.loading = false;
                })
                .catch(function (err) {
                    lineItem.loading = false;
                    $mdToast.showSimple('Error loading tasks:' + err.message);
                })
        }

        function fetchTasksForDesign(design) {
            design.loading = true;
            Workforce.fetchTasksForDesign({
                designs: design._id,
                page: 1,
                limit: 10,
                sort: '-createdAt'
            })
                .then(function (tasks) {
                    design.hydratedTasks = tasks;
                    design.loading = false;
                })
                .catch(function (err) {
                    design.loading = false;
                    $mdToast.showSimple('Error loading tasks:' + err.message);
                })
        }


        function fetchDesigns() {
            $scope.fetchingDesign = true;
            $scope.designs = [];
            Design.getAllDesigns($scope.designQuery)
                .then(function (result) {
                    console.log('designs', result);
                    $scope.designs = result.designs;
                    $scope.fetchingDesign = false;
                })
                .catch(function (err) {
                    $scope.fetchingDesign = false;
                    $mdToast.showSimple('Error in fetching designs :' + err.message);
                });
        }

        $scope.fetchOrders();
    }

})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 21/02/20, 6:16 PM
 *
 */

(function () {
    'use strict';

    angular.module('app.workforce', []);
})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 22/02/20, 7:04 PM
 *
 */

(function () {
    'use strict';

    angular.module('app.workforce')
        .component('taskList', {
            replace: true,
            templateUrl: "app/modules/workforce/components/task-list/task-list.component.tmpl.html",
            bindings: {
                tasks: '<',
                dynamic: '<'
            },
            controller: ["Utils", "RestManager", "Workforce", "$interval", "Users", "$mdToast", function (Utils, RestManager, Workforce, $interval,
                                  Users, $mdToast) {
                this.taskTypes = [
                    {
                        title: 'All',
                        value: 'all'
                    },
                    {
                        title: 'Marking',
                        value: 'marking'
                    },
                    {
                        title: 'Embroidery',
                        value: 'embroidery'
                    },
                    {
                        title: 'Cutting',
                        value: 'cutting'
                    },
                    {
                        title: 'Stitching',
                        value: 'stitching'
                    },
                    {
                        title: 'Alteration',
                        value: 'alteration'
                    },
                    {
                        title: 'Tags Attachment',
                        value: 'tags-attachment'
                    }
                ];

                this.$onInit = function () {
                    if (this.dynamic) {
                        this.query = {
                            page: 1,
                            limit: 10,
                            sort: '-createdAt',
                            taskTypes: 'all'
                        };
                        this.fetchTasks();
                    }
                    if (this.tasks) {
                        this.tasks = this.transformTasks(this.tasks);
                    }
                };

                this.$onDestroy = function () {
                    this.tasks.forEach(function (task) {
                        if (typeof task.interval !== 'undefined') {
                            $interval.cancel(task.interval);
                        }
                    })
                }

                this.applyFilter = function (taskType) {
                    this.query.taskTypes = taskType;
                    this.fetchTasks();
                };

                var scope = this;
                this.selectAssignee = function (task, index, event) {
                    Users.selectUserDialog(event, {
                        fields: 'name,mobile,role', roles: 'operator', multiple: false
                    })
                        .then(function (user) {
                            if (user) {
                                task.updatingAssignee = true;
                                return RestManager.patchResource('/tasks/assignee', {
                                    taskId: task._id,
                                    assignee: user
                                }, 'tasks', {service: 'workforce'})
                            } else {
                                return null;
                            }
                        })
                        .then(function (tasks) {
                            if(tasks) {
                                task.updatingAssignee = false;
                                scope.tasks[index] = scope.transformTasks(tasks)[0];
                                $mdToast.showSimple('Updated Assignee');
                            }
                        })
                        .catch(function (error) {
                            task.updatingAssignee = false;
                            $mdToast.showSimple('Error updating Assignee: ' + error.message);
                            console.log('Error updating Assignee', error);
                        })
                };

                this.fetchTasks = function () {
                    var payloadQuery = {};
                    angular.copy(scope.query, payloadQuery);
                    if (payloadQuery.taskTypes === 'all') {
                        delete payloadQuery.taskTypes;
                    }
                    scope.promise = RestManager.getResource('/tasks', 'tasks', {
                        query: payloadQuery, service: 'workforce',
                        extras: ['total']
                    });
                    scope.promise
                        .then(function (result) {
                            console.log('result', result);
                            scope.tasks = scope.transformTasks(result.tasks);
                            scope.total = result.total;
                            console.log('tasks', scope.tasks)
                        })
                        .catch(function (err) {
                            console.log('Error', err);
                        })
                };

                this.openUpdateTimeDialog = function (ev, task, index) {
                    var self = this;
                    console.log(task, index)
                    Workforce.openUpdateTimeDialog(ev, task)
                        .then(function (result) {
                            console.log('result', result, self.transformTasks([result]));
                            if (result) {
                                self.tasks[index] = self.transformTasks([result])[0];
                            }
                        })
                        .catch(function (err) {
                            console.log('Error', err);
                        })
                };

                this.transformTasks = function (tasks) {
                    var self = this;
                    return tasks.map(function (task) {
                        task.allottedDurationObject = Utils.secondsToDHM(task.allottedDuration);
                        if (task.status === 'paused' || task.status === 'completed' || task.status === 'cancelled') {
                            task.currentDuration = task.finalDuration;
                        } else {
                            task.currentDuration = moment().diff(moment(task.taskStartDate), 'seconds') - task.pausedDuration;
                        }
                        task.isStarted = _.includes(['in-progress', 'paused'], task.status);
                        task.currentDurationObject = Utils.secondsToDHM(task.currentDuration);
                        if (task.assignee && task.assignee.length) {
                            task.assigneeList = Utils.replaceEnd(task.assignee.reduce(function (acc, user) {
                                return acc + user.name + ', ';
                            }, ''), ',');
                        }

                        task = self.getDurationPercent(task);
                        task.progressColor = self.getTimerColor(task);
                        if (task.productionCost) {
                            task.productionCost = _.round(task.productionCost, 2);
                        }
                        if (task.status === 'in-progress') {
                            task.interval = $interval(function () {
                                task.currentDuration = moment().diff(moment(task.taskStartDate), 'seconds') - task.pausedDuration;
                                task.currentDurationObject = Utils.secondsToDHM(task.currentDuration);
                                task = self.getDurationPercent(task);
                                task.progressColor = self.getTimerColor(task);
                            }, 1000);
                        }
                        return task;
                    })
                };

                this.getDurationPercent = function (task) {
                    var durationPercent = (task.currentDuration / task.allottedDuration) * 100;
                    task.actualPercent = durationPercent;
                    task.durationPercent = durationPercent > 100 ? 100 : Math.round(durationPercent);
                    return task;
                };

                this.getTimerColor = function (task) {
                    var timerColor;
                    if (task.actualPercent < 85) {
                        timerColor = 'success';
                    } else if (task.actualPercent >= 85 && task.actualPercent <= 110) {
                        timerColor = 'warning';
                    } else {
                        timerColor = 'error';
                    }
                    return timerColor;
                };

                this.getColor = function (type, value) {
                    switch (type) {
                        case 'status' :
                            // created', 'in-progress', 'paused', 'completed', 'cancelled'
                            if (value === 'created') {
                                return '#8e8cf4';
                            } else if (value === 'in-progress') {
                                return '#d6a848';
                            } else if (value === 'paused') {
                                return '#f49182';
                            } else if (value === 'completed') {
                                return '#068f04';
                            } else {
                                return '#f45a67';
                            }

                        case 'priority':
                            if (value === 'low') {
                                return '#0af405';
                            } else if (value === 'medium') {
                                return '#aab510';
                            } else if (value === 'high') {
                                return '#f49182';
                            } else {
                                return '#f45a67';
                            }
                    }
                }
            }]
        });

})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 22/02/20, 6:16 PM
 *
 */

(function () {
    'use strict';

    angular.module('app.workforce')
        .component('taskItem', TaskItem());

    function TaskItem() {
        return {
            replace:  true,
            templateUrl: "app/modules/workforce/components/task-item/task-item.component.tmpl.html",
            bindings: {task: '<'},
            controller: function () {
                console.log(this)
            }
        }
    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 26/7/19 11:02 PM
 *
 */

(function () {
    'use strict';

    TransactionsController.$inject = ["$scope", "$mdDialog", "RestManager", "org"];
    angular.module('app.users')
        .controller('transactions.dialog.controller', TransactionsController);

    function TransactionsController($scope, $mdDialog, RestManager, org) {
        $scope.loading = true;
        $scope.total = 0;
        $scope.txns = [];
        $scope.query = {
            organisation: org._id,
            page: 1,
            limit: 10,
            sort: '-createdAt'
        };
        $scope.org = org;

        $scope.fetchTxns = fetchTxns;
        $scope.nextPage = nextPage;
        $scope.close = close;
        $scope.markAsPaid = markAsPaid;
        $scope.viewBillDetails = viewBillDetails;

        function close() {
            $mdDialog.cancel();
        }

        function nextPage() {
            $scope.query.page++;
            $scope.fetchTxns(true);
        }


        function fetchTxns(concat) {
            $scope.loading = true;
            RestManager
                .getResource('/txn', 'transactions', {
                    query: $scope.query,
                    extras: ['total']
                })
                .then(function (result) {
                    if(concat) {
                        $scope.txns = $scope.txns.concat(result.transactions);
                    } else {
                        $scope.txns = result.transactions;
                    }
                    $scope.total = result.total;
                    $scope.loading = false;
                })
                .catch(function (err) {
                    $scope.loading = true;
                })
        }

        function markAsPaid(ev, txn) {
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: ev,
                fullscreen : true,
                multiple : true,
                controller: "recharge.wallet.controller",
                templateUrl: 'app/modules/users/organisations/rechargeWallet/recharge-wallet.html',
                clickOutsideToClose: true,
                locals: {
                    org: org,
                    txn :txn
                }
            })
                .then(function (amount) {
                    $mdDialog.hide(amount);
                })
        }

        function viewBillDetails(ev, txn) {
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: ev,
                fullscreen : true,
                multiple : true,
                controller: "bill.details.controller",
                templateUrl: 'app/modules/users/organisations/bill-details/bill-details.html',
                clickOutsideToClose: true,
                locals: {
                    txnId :txn._id
                }
            })
        }

        $scope.fetchTxns(false);
    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 26/7/19 7:06 PM
 *
 */

(function () {
    'use strict';

    RechargeWallet.$inject = ["$scope", "$mdDialog", "org", "txn", "RestManager", "$mdToast"];
    angular.module('app.users')
        .controller('recharge.wallet.controller', RechargeWallet);


    function RechargeWallet($scope, $mdDialog, org, txn, RestManager, $mdToast) {

        $scope.org = org;
        $scope.payingTxn = txn;
        $scope.isDebit = !!txn;
        $scope.loadingLastRecharge = false;
        $scope.rechargeData = {
            amount: $scope.payingTxn ? $scope.payingTxn.amount : 0,
            description: ''
        };

        $scope.close = close;
        $scope.recharge = recharge;
        $scope.getLastRecharge = getLastRecharge;


        function getLastRecharge() {
            $scope.loadingLastRecharge = true;
            RestManager.getResource('/txn', 'transactions', {
                query: {
                    organisation: $scope.org._id,
                    sort: '-createdAt',
                    limit: 1,
                    page: 1
                }
            })
                .then(function (txns) {
                    $scope.lastTxn = txns[0];
                    $scope.loadingLastRecharge = false;
                })
                .catch(function (err) {
                    $scope.loadingLastRecharge = true;
                })
        }

        function recharge() {
            $scope.saving = true;
            var payload = {};
            angular.copy($scope.rechargeData, payload);
            console.log('Debit', $scope.isDebit);
            if ($scope.isDebit) {
                payload.amount = 0 - payload.amount;
            }
            var promise;
            if($scope.payingTxn) {
                promise =  RestManager.patchResource('/txn/markPaid/' + $scope.payingTxn._id, {paymentDescription : payload.description}, 'transactions')
            } else {
                promise =  RestManager.putResource('/org/recharge/' + $scope.org._id, payload, 'organisations')
            }
            promise
                .then(function (result) {
                    $scope.saving = false;
                    $mdDialog.hide($scope.org.walletBalance + payload.amount);
                })
                .catch(function (err) {
                    $scope.saving = false;
                    $mdToast.showSimple('Error while recharging the wallet : ' + err.message);
                })
        }

        function close() {
            $mdDialog.cancel();
        }

        if(!$scope.payingTxn) {
            $scope.getLastRecharge();
        }
    }

})(angular);

(function () {
    'use strict';

    BillController.$inject = ["$scope", "$mdDialog", "RestManager", "txnId", "$mdToast", "Utils"];
    angular.module('app.users')
        .controller('bill.details.controller', BillController);

    function BillController($scope, $mdDialog, RestManager, txnId, $mdToast, Utils) {
        $scope.getDetails = getDetails;
        $scope.cancel = cancel;
        $scope.downloadInvoice = downloadInvoice;
        $scope.formatAddress = Utils.formatAddress;
        $scope.reduxBankAccount = {
            number : '50200006866213',
            name : 'REDUX X-PRESS PRIVATE LIMITED',
            accountType : 'Current Account',
            ifscCode : 'HDFC0002307'
        };

        function getDetails() {
            $scope.loading = true;
            RestManager.getResource('/txn/' + txnId, 'transactions')
                .then(function (transactions) {
                    $scope.transaction = transactions[0];
                    $scope.transaction.bankAccount = $scope.reduxBankAccount;
                    $scope.loading = false;
                    console.log("bill-details.js", "TTTTE", $scope.transaction);
                })
                .catch(function (err) {
                    $scope.loading = false;
                    $mdToast.showSimple('Error loading Bill Details : ' + err.message);
                })
        }

        function downloadInvoice(event) {
            RestManager.postResource('/', {invoker: 'order-invoice-org', payload: $scope.transaction}, '', {
                service: 'pdf',
                download: true
            })
                .then(function (result) {
                    var blob = new Blob([result], {type: 'application/pdf'});
                    saveAs(blob, 'INV-' + $scope.transaction.txnId || 'Export.pdf');
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error download bill : ' + err.message);
                })
        }

        function cancel() {
            $mdDialog.cancel();
        }

        $scope.getDetails();
    }

})(angular);

(function () {
    'use strict';
    addOrgController.$inject = ["$scope", "$mdDialog", "RestManager", "$mdToast", "org", "Address"];
    angular.module("app.users")
        .controller("addOrg.dialog.controller", addOrgController);

    function addOrgController($scope, $mdDialog, RestManager, $mdToast, org, Address) {

        $scope.updatePassword = false;
        $scope.defaultPasswordType = true;
        $scope.confirmPasswordType = true;

        $scope.close = close;
        $scope.createNewOrganisation = createNewOrganisation;
        $scope.getAdminsAndOrgUsers = getAdminsAndOrgUsers;
        $scope.openAddressSelector = openAddressSelector;
        $scope.clearPassword = clearPassword;

        $scope.organisation = org;
        $scope.editingOrg = (org && org._id);

        $scope.statusList = ['active', 'blocked', 'pendingApproval'];

        if ($scope.organisation && $scope.organisation.adminUser && $scope.organisation.adminUser.name) {
            $scope.organisation.adminUser = $scope.organisation.adminUser._id;
        }

        if ($scope.organisation && !$scope.organisation.settings) {
            $scope.organisation.settings = {};
        }

        function close() {
            $mdDialog.hide();
        }

        function clearPassword() {
            if ($scope.organisation.settings && $scope.organisation.settings.defaultPassword) {
                delete $scope.organisation.settings.defaultPassword;
            }
        }

        function openAddressSelector(event) {
            Address.showAddressSelector({
                event: event,
                user: $scope.organisation,
                selected: $scope.organisation.address ? $scope.organisation.address._id : null
            })
                .then(function (result) {
                    console.log('Selected address', result);
                    if (result && result.address) {
                        $scope.organisation.address = result.address;
                    }
                })
                .catch(function (err) {

                })
        }

        function createNewOrganisation() {
            console.log("addOrg.controller.js", "createNewOrganisation", $scope.organisation);
            var promise = '';

            $scope.saving = true;
            if ($scope.editingOrg) {
                promise = RestManager.putResource("/org/" + $scope.organisation._id, $scope.organisation, 'organisations');
            } else {
                promise = RestManager.postResource("/org", $scope.organisation, 'organisations');
            }
            promise
                .then(function (result) {
                    $scope.orgs = result;
                    console.log("users.all.controller.js", $scope.orgs);
                    $mdDialog.hide({updatedOrg: result[0]});
                    $scope.saving = false;

                    // $scope.fetchAllOrg();
                    // not working here as it is out of scope
                    /*
                    * #TODO: Write a service fetchAllOrgs to fetch all organisation data
                    *        in addOrgController as well as user.org.controller
                    * */
                })
                .catch(function (err) {
                    $mdToast.showSimple("Something broke, please contact Alok for help");
                    console.log("users.all.controller.js", err);
                    $scope.saving = false;
                    $mdDialog.hide();
                });
        }


        function getAdminsAndOrgUsers() {
            var query = {
                query: {
                    role: {$in: ['org-admin', 'admin', 'org-user']}
                },
                page: 1,
                limit: 50,
                order: {},
                searchTerm: ""
            };
            RestManager.postResource("/users/admin", query, "users")
                .then(function (users) {
                    console.log("users", users);
                    $scope.users = users;
                })
                .catch(function (err) {
                    console.log(err);
                })
        }

        $scope.getAdminsAndOrgUsers();
    }

})(angular);

(function () {
    'use strict';
    tagUserController.$inject = ["$scope", "RestManager", "$mdDialog", "users", "$mdToast"];
    angular.module('app.users')
        .controller('tagUsersController', tagUserController);

    function tagUserController($scope, RestManager, $mdDialog, users, $mdToast){
        $scope.users = users.map(function(user){
            return user._id;
        });
        $scope.readonly = false;
        $scope.tags= {
            names:[]
        };

        $scope.close = close;
        $scope.tagUsers = tagUsers;

        function close(){
            $mdDialog.cancel();
        }

        function tagUsers(){
            RestManager.postResource('/users/tagUsers', {users: $scope.users, tags: $scope.tags.names}, 'user')
                .then(function(response){
                    $mdDialog.hide({tagNames: $scope.tags.names});
                })
                .catch(function(err){
                    $mdToast.showSimple("Error in segmenting users : " + err.message);
                    $mdDialog.cancel();
                });
        }

    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 11/9/19 2:26 PM
 *
 */

(function () {
    'use strict';

    SelectUsersController.$inject = ["$scope", "$mdDialog", "multipleSelect", "roles", "fields", "search", "selected", "RestManager", "$mdToast"];
    angular.module('app.users')
        .controller('select-users.dialog.controller', SelectUsersController);


    function SelectUsersController($scope, $mdDialog, multipleSelect, roles, fields, search, selected, RestManager, $mdToast) {
        $scope.selectedUsers = selected || '';
        $scope.multiple = multipleSelect;
        $scope.total = 0;
        $scope.title = 'Select ' + ($scope.multiple ? 'Users' : 'User');
        $scope.query = {
            page: 1,
            limit: 5,
            order: 'name',
            fields: fields,
            q: search,
            roles: roles
        };

        $scope.close = close;
        $scope.done = done;
        $scope.fetchUsers = fetchUsers;
        $scope.updateSelected = updateSelected;

        function close() {
            $mdDialog.cancel();
        }

        function fetchUsers() {

            if (!$scope.query.roles) {
                delete $scope.query.roles
            }

            if (!$scope.query.q) {
                delete $scope.query.q
            }

            if (!$scope.query.fields) {
                delete $scope.query.fields;
            }
            $scope.loadingUsers = true;
            return RestManager.getResource("/users/filter", "users", {query: $scope.query})
                .then(function (users) {
                    $scope.users = users.map(function (user) {
                        user.id = user._id;
                        if($scope.multiple) {
                            var isSelected = _.findIndex($scope.selectedUsers, function (selectedUser) {
                                return selectedUser._id === user._id;
                            });
                            user.selected = isSelected !== -1;
                        }
                        return user;
                    });
                    $scope.loadingUsers = false;
                })
                .catch(function (err) {
                    $scope.loadingUsers = false;
                    $mdToast.showSimple('Error loading user : ' + err.message);
                })
        }

        function updateSelected(user) {
            if(!$scope.selectedUsers) {
                $scope.selectedUsers = []
            }
            if(user.selected) {
                $scope.selectedUsers.push(user);
            } else {
                _.remove($scope.selectedUsers, function (selectedUser) {
                    return selectedUser._id === user._id;
                })
            }
        }

        function done() {
            if ($scope.multiple) {
                return $mdDialog.hide($scope.selectedUsers)
            } else {
                return $mdDialog.hide($scope.selectedUsers)
            }
        }

        $scope.fetchUsers();
    }

})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 09/01/20, 1:11 AM
 *
 */

(function () {
    'use strict';

    InfluencerDetails.$inject = ["$scope", "userId", "$mdDialog", "RestManager", "$mdToast", "Base", "Users", "Influencers"];
    angular.module('app.users')
        .controller('influencer-details', InfluencerDetails);


    function InfluencerDetails($scope, userId, $mdDialog, RestManager, $mdToast, Base, Users, Influencers) {
        $scope.loading = true;
        $scope.editUser = editUser;
        $scope.fetchUser = fetchUser;
        $scope.cancel = cancel;
        $scope.showFollowList = Influencers.openFollowList;

        function editUser(event) {
            Users.editUserDialog(event, {
                user: $scope.influencer
            })
                .then(function (result) {
                    if (result && result.user) {
                        $scope.influencer = result.user;
                    }
                })
        }

        function fetchUser() {
            RestManager.getResource("/users/filter", "users", {
                query: {
                    ids: userId,
                    limit: 1,
                    page: 1,
                    fields: 'mobile,email,name,influencerRequest,instagramProfile,facebookProfile,youtubeProfile,website,bio,dob,basedIn,metrics,followers,following,points,role,profileImage,userName' +
                        ',profileImageURL,public,status,flags,age'
                }
            })
                .then(function (users) {
                    $scope.influencer = users[0];
                    $scope.loading = false;
                })
                .catch(function (err) {
                    $scope.loading = false;
                    $mdToast.showSimple('Error loading influencer details : ' + err.message);
                    $scope.cancel();
                })
        }

        function cancel() {
            $mdDialog.cancel();
        }

        $scope.fetchUser();
    }

})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 11/01/20, 2:27 PM
 *
 */

(function () {
    'use strict';

    FollowDetails.$inject = ["$scope", "userId", "$mdDialog", "RestManager", "$mdToast", "Base", "Users"];
    angular.module('app.users')
        .controller('follow-details', FollowDetails);


    function FollowDetails($scope, userId, $mdDialog, RestManager, $mdToast, Base, Users) {
        $scope.loading = true;
        $scope.searchText = '';


        $scope.editUser = editUser;
        $scope.fetchList = fetchList;
        $scope.cancel = cancel;
        $scope.clearFilters = clearFilters;

        function clearFilters() {
            $scope.searchText = null;
        }

        function editUser(event) {
            Users.editUserDialog(event, {
                user: $scope.influencer
            })
                .then(function (result) {
                    if (result && result.user) {
                        $scope.influencer = result.user;
                    }
                })
        }

        function fetchList(scope) {
            RestManager.getResource("/users/followlist", scope, {
                query: {
                    scope : scope,
                    user : userId
                }
            })
                .then(function (list) {
                    $scope.list = list;
                    $scope.loading = false;
                })
                .catch(function (err) {
                    $scope.loading = false;
                    $mdToast.showSimple('Error loading influencer follow list : ' + err.message);
                    $scope.cancel();
                })
        }

        function cancel() {
            $mdDialog.cancel();
        }

        $scope.fetchList('followers');
    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 18/11/19, 2:12 AM
 *
 */
(function () {
    'use strict';

    AddUserController.$inject = ["$scope", "RestManager", "newUser", "Address", "$mdDialog", "$mdToast"];
    angular.module('app.users')
        .controller('add-users.controller', AddUserController);

    function AddUserController($scope, RestManager, newUser, Address, $mdDialog, $mdToast) {
        $scope.newUser = newUser || {flags: {onboardUser: true}};
        $scope.editingMode = !!newUser;
        $scope.userNameDisabled = $scope.newUser && $scope.newUser.userName;
        $scope.userRoles = [
            'admin',
            'hr',
            'marketing',
            'designer',
            'shop-manager',
            'model',
            'operator',
            'sales-staff',
            'photographer',
            'org-admin',
            'org-agent',
            'influencer',
            'customer'
        ];
        $scope.profileImageSizes = [
            {
                width: 320,
                height: 320,
                attributeName: 'profile_m'
            },
            {
                width: 320,
                height: 320,
                attributeName: 'profile_m'
            },
            {
                width: 100,
                height: 100,
                attributeName: 'profile_s'
            }
        ];

        $scope.openAddressSelector = openAddressSelector;
        $scope.fetchAllWarehouse = fetchAllWarehouse;
        $scope.fetchAllOrg = fetchAllOrg;
        $scope.getOption = getOption;
        $scope.cancel = cancel;
        $scope.saveUser = saveUser;
        $scope.checkAvailable = checkAvailable;

        function checkAvailable(userName) {
            $scope.checking = true;
            RestManager.getResource('/users/userName/available/' + userName, 'check')
                .then(function (result) {
                    console.log("add-user.controller.js", "results", result);
                    $scope.checking = false;
                    $scope.userNameAvailable = result[0].available;
                    $scope.newUserForm.userName.$setValidity('unavailable', $scope.userNameAvailable );

                })
                .catch(function (err) {
                    $scope.checking = false;
                })
        }

        function fetchAllWarehouse() {
            $scope.promise = RestManager.getResource('/warehouse', 'warehouses', {
                query: {page: 1, limit: 10},
                extras: ['total']
            })
                .then(function (result) {
                    $scope.warehouses = result.warehouses;
                    $scope.total = result.total;
                })
                .catch(function (err) {
                    console.log(err);
                });
        }

        function openAddressSelector(event) {
            Address.showAddressSelector({
                event: event,
                user: $scope.newUser,
                selected: $scope.newUser.dispatchAddress ? $scope.newUser.dispatchAddress._id : null
            })
                .then(function (result) {
                    console.log('Selected address', result);
                    if (result && result.address) {
                        $scope.newUser.dispatchAddress = result.address;
                    }
                })
                .catch(function (err) {

                })
        }

        function fetchAllOrg() {
            RestManager.getResource("/org", "organisations")
                .then(function (result) {
                    $scope.orgs = result;
                    console.log("users.all.controller.js", $scope.orgs);
                })
                .catch(function (err) {
                    console.log("users.all.controller.js", err);
                });
        }


        function getOption(numberString) {
            return parseInt(numberString);
        }


        function cancel() {
            $mdDialog.hide();
        }


        function saveUser($event) {
            var promise;
            if ($scope.editingMode) {
                console.log("users.all.controller.js", "saveUser", $scope.newUser);
                promise = RestManager.putResource("/users/admin/update/" + $scope.newUser._id, $scope.newUser, "user")
            } else {
                promise = RestManager.postResource("/users/admin/create", $scope.newUser, "user");
            }
            $scope.saving = true;
            promise
                .then(function (data) {
                    $scope.saving = false;
                    console.log('Updated User', data);
                    $mdToast.simple()
                        .textContent('Successfully updated user')
                        .position("bottom right")
                        .hideDelay(3000);
                    $mdDialog.hide({user : $scope.editingMode ? data[0].user : data[0]});
                })
                .catch(function (err) {
                    console.log("err", err);
                    $scope.saving = false;
                    $mdToast.showSimple('Error saving user profile : ' + err.message);
                });
        }



        $scope.fetchAllWarehouse();
        $scope.fetchAllOrg();
    }

})(angular);

/**
 * Created by kumardivyarajat on 05/05/17.
 */
angular.module("app.users")
    .controller("users.details.controller", ["$scope", "$stateParams", "user", "RestManager", "$state", function ($scope, $stateParams, user, RestManager, $state) {
        $scope.$parent.pageTitle = "User Details";
        $scope.$parent.nestedState = true;
        $scope.$parent.backState = $stateParams.backState || "app.users.all";
        $scope.$parent.backParams = $stateParams.backParams ? JSON.parse($stateParams.backParams) : {};
        console.log("userDetails.controller.js", "$scope.$parent.backParams", $scope.$parent.backParams);
        $scope.userId = $stateParams.userId;
        $scope.tabIndex = 0;
        $scope.$parent.pageTitle = user.name + '( ' + user.mobile + ' )';

        $scope.user = user;


        $scope.$parent.onActionButtonClick = onActionButtonClick;
        $scope.updateUser = updateUser;
        $scope.goto = goto;
        $scope.getStatusText = getStatusText;

        $scope.$parent.showActionButton = true;

        function onActionButtonClick() {
            $scope.updateUser();
        }

        function getStatusText(status) {
            switch (status) {
                case 1 :
                    return 'Active';

                case 0:
                    return 'Pending Auth';

                case -1:
                    return 'Blocked';
            }
        }

        function updateUser() {

        }

        function goto(where, tabName, tabIndex) {
            // $scope.currentNavItem = tabName;
            $scope.tabIndex = tabIndex;
            $state.go(where, {
                userId: $scope.user._id
            })
        }

        $scope.user.statusText = $scope.getStatusText(user.status);

    }]);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 2/9/19 6:35 PM
 *
 */

(function () {
    'use strict';

    angular.module('app.address', []);

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 2/9/19 6:43 PM
 *
 */

(function () {
    'use strict';

    AddressSelectController.$inject = ["$scope", "$mdDialog", "user", "selected", "RestManager", "$mdToast", "Address"];
    angular.module('app.address')
        .controller('address-selector.controller', AddressSelectController);

    function AddressSelectController($scope, $mdDialog, user, selected, RestManager, $mdToast, Address) {
        $scope.addresses = [];
        $scope.userId = user._id;
        $scope.loadingAddressses = true;
        $scope.selectedAddress = selected;

        $scope.close = $mdDialog.cancel;
        $scope.selectOrg = selectOrg;
        $scope.fetchUserAddresses = fetchUserAddresses;
        $scope.openNewAddressDialog = openNewAddressDialog;
        $scope.deleteAddress = deleteAddress;
        $scope.isNotDeleted = isNotDeleted;

        function isNotDeleted(item) {
            return !item.deleted;
        }

        function fetchUserAddresses() {
            RestManager.getResource('/address/admin?user=' + $scope.userId, 'address')
                .then(function (addresses) {
                    $scope.addresses = addresses || [];
                    $scope.loadingAddressses = false;
                })
                .catch(function (err) {
                    $scope.loadingAddressses = false;
                    $mdToast.showSimple('Error fetching addresses ' + err.message);
                })
        }

        function openNewAddressDialog($event, idx, address) {
            Address.showAddressEditDialog({event: $event, address: address, user: user})
                .then(function (address) {
                    if (address) {
                        if (typeof idx !== 'undefined') {
                            var index = _.findIndex($scope.addresses, function (address) {
                                return address._id === address.data._id;
                            });
                            if (index !== -1) {
                                $scope.addresses[index] = address.data;
                            }
                        } else {
                            $scope.addresses.unshift(address.data);
                        }
                        $mdToast.showSimple('Saved address');
                    } else {
                        $mdToast.showSimple('Address not added');
                    }
                })
                .catch(function (err) {

                })
        }

        function deleteAddress($event, index, address) {
            $scope.deleting = true;
            Address.deleteAddress(address._id)
                .then(function () {
                    $scope.addresses.splice(index, 1);
                    $scope.deleting = false;
                    $mdToast.showSimple('Address deleted successfully');
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error deleting address: ' + err.message);
                })
        }

        function selectOrg() {
            var selectedAddress = _.find($scope.addresses, function (address) {
                console.log("address-select-dialog.controller.js", "add", address._id, $scope.selectedAddress);
                return address._id === $scope.selectedAddress;
            });
            console.log("address-select-dialog.controller.js", "selectOrg", $scope.addresses, $scope.selectedAddress);
            $mdDialog.hide({address: selectedAddress})
        }

        $scope.fetchUserAddresses();
    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 2/9/19 6:43 PM
 *
 */

(function () {
    'use strict';

    AddressAddController.$inject = ["$scope", "address", "user", "Address", "$mdToast", "$mdDialog"];
    angular.module('app.address')
        .controller('address-add.controller', AddressAddController);

    function AddressAddController($scope, address, user, Address, $mdToast, $mdDialog) {
        console.log("address-add-dialog.controller.js", "AddressAddController", user, address);
        if (address) {
            $scope.editingMode = true;
        }
        $scope.user = user;

        $scope.newAddress = address || {
            user : user._id
        };

        $scope.populateCity = function () {
            if (!$scope.newAddress.pinCode || $scope.newAddress.pinCode.length !== 6) {
                return;
            }
            $scope.populatingCity = true;
            $scope.querySearch($scope.newAddress.pinCode)
                .then(function (data) {
                    $scope.populatingCity = false;
                    if (data) {
                        $scope.newAddress.city = data.city;
                        $scope.newAddress.state = data.state;
                    }
                    console.log(data)
                })
                .catch(function (err) {
                    $scope.populatingCity = false;
                    console.log(err)
                })
        };

        $scope.closeDialog = function (data) {
            $mdDialog.hide({data: data});
        };

        $scope.cancelDialog = function (err) {
            $mdDialog.cancel(err);
        };

        $scope.querySearch = function (query) {
            return Address.queryPinCode(query);
        };

        $scope.saveAddress = function () {
            $scope.addressSaving = true;
            var promise = null;
            $scope.newAddress.user = user._id;
            if ($scope.editingMode) {
                promise = Address.updateAddress($scope.newAddress)
            } else {
                promise = Address.addNewAddress($scope.newAddress)
            }
            promise
                .then(function (address) {
                    $scope.addressSaving = false;
                    $scope.closeDialog(address);
                })
                .catch(function (err) {
                    $scope.addressSaving = false;
                    // $log.error(err);
                    $mdToast.showSimple('Error saving address :' + err.message);
                })

        };
    }

})(angular);

/**
 * Created by kumardivyarajat on 04/12/16.
 */
angular.module("app.users")
    .controller("users.all.controller", ["$scope", "RestManager", "$mdDialog", "$mdToast", "$stateParams", "$state", "Address", function ($scope, RestManager, $mdDialog, $mdToast,
                                                  $stateParams, $state, Address) {
        $scope.$parent.pageTitle = "All Users";
        $scope.$parent.nestedState = false;
        $scope.$parent.backState = "app.home";
        $scope.params = {};
        $scope.selected = [];
        $scope.containsTags = false;
        $scope.action = "";

        $scope.filters = {};

        $scope.query = {
            order: $stateParams.order || '-createdAt',
            limit: $stateParams.limit ? parseInt($stateParams.limit) : 25,
            page: $stateParams.page ? parseInt($stateParams.page) : 1,
            searchTerm: "",
            query: {}
        };

        $scope.userRoles = [
            'admin',
            'hr',
            'marketing',
            'designer',
            'shop-manager',
            'model',
            'operator',
            'sales-staff',
            'photographer',
            'org-admin',
            'org-agent',
            'influencer',
            'customer'
        ];
        $scope.tags = [];

        $scope.exportUsers = exportUsers;
        $scope.init = init;
        $scope.parseFilters = parseFilters;
        $scope.selectAll = selectAll;
        $scope.clearFilters = clearFilters;
        $scope.openNotifications = openNotifications;
        $scope.openTagUserDialog = openTagUserDialog;
        $scope.fetchAllOrg = fetchAllOrg;
        $scope.getAllTags = getAllTags;

        function init() {
            if ($stateParams.organisation) {
                $scope.query.query.organisation = {$in: $stateParams.organisation.split(',')};
                $scope.filters.organisation = $stateParams.organisation.split(',');
                $scope.hasFilters = true;
            }

            if ($stateParams.roles) {
                $scope.query.query.role = {$in: $stateParams.roles.split(',')};
                $scope.filters.role = $stateParams.roles.split(',');
                $scope.hasFilters = true;
            }

            if ($stateParams.q) {
                $scope.query.searchTerm = $stateParams.q;
                $scope.hasFilters = true;
            }

            if($stateParams.validMobile) {
                $scope.query.query.virtualMobile = false;
                $scope.hasFilters = true;
            }
            console.log("users.all.controller.js", "init", $stateParams.tags, $scope.filters.tags);
            if($stateParams.tags){
                $scope.query.query.tags = {$in: [$stateParams.tags] };
                $scope.filters.tags = $stateParams.tags.split(',');
                $scope.hasFilters = true;
            }

            $scope.getAllUsers();
            $scope.getAllTags();
        }

        function selectAll(model, dataSet) {
            console.log("users.all.controller.js", "selectAll", dataSet);
            $scope.filters[model] = dataSet.map(function (data) {
                return data._id || data;
            })
        }

        function parseFilters(tag) {
            if ($scope.filters.organisation && $scope.filters.organisation.length) {
                $scope.query.query.organisation = {$in: $scope.filters.organisation};
                $scope.hasFilters = true;
            } else {
                delete $scope.query.query.organisation;
                $scope.hasFilters = false;
            }

            if ($scope.filters.role && $scope.filters.role.length) {
                $scope.query.query.role = {$in: $scope.filters.role};
                $scope.hasFilters = true;
            } else {
                delete $scope.query.query.role;
                $scope.hasFilters = false;
            }

            if($scope.filters.hasValidMobile) {
                $scope.query.query.virtualMobile = false;
                $scope.hasFilters = true;
            } else {
                delete  $scope.query.query.virtualMobile;
                $scope.hasFilters = false;
            }
            if ($scope.filters.type) {
                if ($scope.filters.type === 'in') {
                    $scope.query.query.organisation = {$in: $scope.filters.organisation};
                } else if ($scope.filters.type === 'nin') {
                    $scope.query.query.organisation = {$nin: $scope.filters.organisation};
                }
            }
            console.log("users.all.controller.js", "parseFilters", tag);
            if (tag) {
                $scope.filters.tags = tag
                $scope.query.query.tags = {$in: [$scope.filters.tags] };
                $scope.hasFilters = true;
            }else{
               delete  $scope.query.query.tags;
            }

            $scope.getAllUsers();
        }

        function clearFilters() {
            $scope.filters = {};
            $scope.hasFilters = false;
            $scope.parseFilters(null);
        }

        $scope.getAllUsers = function () {
            $scope.promise = RestManager.postResource("/users/admin", $scope.query, "users", ["totalCount"]);

            $scope.promise
                .then(function (data) {
                    $scope.totalCount = data.totalCount;
                    $scope.users = data.users.map(function (user) {
                        if (user.expiry) {
                            user.expiry = new Date(user.expiry);
                        }
                        return user;
                    });
                    $scope.params = {
                        q: $scope.query.searchTerm,
                        page: $scope.query.page,
                        limit: $scope.query.limit,
                        order: $scope.query.order,
                        organisation: $scope.filters.organisation ? $scope.filters.organisation.join(',') : null,
                        roles: $scope.filters.role ? $scope.filters.role.join(',') : null,
                        validMobile : $scope.filters.hasValidMobile,
                        tags: $scope.filters.tags
                    };
                    console.log("users.all.controller.js", "PARAM", $scope.params);
                    $scope.jsonParams = JSON.stringify($scope.params);
                    $state.transitionTo('app.users.all', $scope.params, {
                        location: 'replace',
                        reload: false,
                        notify: false
                    })
                    // $scope.users = data.users;
                })
                .catch(function (err) {
                    console.log("err", err);
                });
        };


        $scope.$watch("selected", function (newVal, oldVal) {
            console.log(newVal, oldVal);
            if (newVal.length !== 0 && oldVal.length !== newVal.length) {
                $scope.showDropdown = true;
            } else {
                $scope.showDropdown = false;
            }
        }, true);

        function exportUsers() {
            if ($scope.selected && $scope.selected.length) {
                var wb = {
                    SheetNames: [],
                    Sheets: []
                };
                var dataToExport = $scope.selected.map(function (data) {
                    delete data['$$hashKey'];
                    return {
                        name: data.name,
                        mobile: data.mobile,
                        email: data.email,
                    };
                });
                var headers = Object.keys(dataToExport[0]);
                var fileName = "Aarida User List";
                wb.SheetNames.push('Users');
                var jsonToSheetOptions = {header: headers, skipHeader: false};
                var ws = XLSX.utils.json_to_sheet(dataToExport, jsonToSheetOptions);
                var wopts = {bookType: 'xlsx', bookSST: false, type: 'binary'};

                wb.Sheets['Users'] = ws;

                var wbout = XLSX.write(wb, wopts);

                // noinspection JSAnnotator
                function s2ab(s) {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }

                // /* the saveAs call downloads a file on the local machine */
                saveAs(new Blob([s2ab(wbout)],
                    {type: "application/octet-stream"}),
                    fileName + '-' + moment().toString() + '.xlsx');
            }

        }

        $scope.showImportDialog = function (event) {
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                controller: 'importSheet.dialog.controller',
                templateUrl: 'app/modules/base/dialogs/import-sheet-dialog.html',
                fullScreen: true
            })
                .then(function (res) {
                    res.newUsers.forEach(function (user) {
                        $scope.users.unshift(user);
                    });

                })
                .catch(function (err) {
                    $mdToast.showSimple('Error in creating new Users :' + err.message)
                });
        }

        $scope.showDialog = function (event, user, index) {
            $scope.newUser = null
            if (user) {
                $scope.newUser = {};
                angular.copy(user, $scope.newUser);
            }

            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true,
                locals: {
                    newUser: $scope.newUser
                },
                controller: 'add-users.controller',
                templateUrl: 'app/modules/users/dialogs/add-user/add-user.tmpl.html'
            })
                .then(function (result) {
                    console.log("users.all.controller.js", "resukt", result);
                    if (result.user) {
                        console.log("users.all.controller.js", "index", index);
                        if (typeof index === 'undefined') {
                            $scope.users.unshift(result.user);
                        } else {
                            $scope.users[index] = result.user;
                        }
                    }
                })
            event.stopPropagation();
        };

        $scope.cancel = function () {
            $mdDialog.hide();
        };

        function fetchAllOrg() {
            RestManager.getResource("/org", "organisations")
                .then(function (result) {
                    $scope.orgs = result;
                    console.log("users.all.controller.js", $scope.orgs);
                })
                .catch(function (err) {
                    console.log("users.all.controller.js", err);
                });
        }

        $scope.performAction = function (ev) {
            switch ($scope.action) {
                case  "send_mail" :
                    $scope.showMailDialog(ev);

            }
        };


        $scope.querySearch = function (query) {
            return _.filter($scope.users, function (o) {
                return (new RegExp(query, "i").test(o.name) || new RegExp(query, "i").test(o.email));
            })
        };


        $scope.showMailDialog = function (ev) {

            $scope.screenTwo = false;
            $scope.email = {
                users: [],
                message: "",
                subject: "",
                buttonText: "",
                buttonUrl: "",
                transform: []
            };


            $scope.formFields = [
                {
                    title: "Name",
                    exp: "{{user.name}}"
                },
                {
                    title: "Email",
                    exp: "{{user.email}}"
                },
                {
                    title: "aadira Cash",
                    exp: "{{user.points}}"
                },
                {
                    title: "Mobile",
                    exp: "{{user.mobile}}"
                }
            ];

            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                scope: $scope,
                preserveScope: true,
                contentElement: "#emailDialog"
            });
        };

        function openNotifications(user, $event) {
            console.log("users.all.controller.js", "openNotifications", user);
            var order = {
                orderData: {
                    products: []
                },
                user: user,
                amount: null,
                shortLink: null,
                code: null
            };
            if (Array.isArray(user)) {
                order = user.map(function (u) {
                    return {
                        orderData: {
                            products: []
                        },
                        user: u,
                        amount: null,
                        shortLink: null,
                        code: null
                    }
                })
            }
            $event.stopPropagation();
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: $event,
                fullscreen : true,
                templateUrl: 'app/modules/components/notifications/user-notifications.html',
                locals: {
                    options: {
                        allowedTags: ['all']
                    },
                    order: order
                },
                controller: 'notificationsController',
                clickOutsideToClose: true
            })
                .then(function (data) {

                })
                .catch(function (err) {
                    console.log(err)
                })
        }

        function openTagUserDialog(user, event){
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                fullscreen : true,
                templateUrl: 'app/modules/users/dialogs/tag-users-dialog/tag-users-dialog.html',
                locals: {
                    users: user
                },
                controller: 'tagUsersController'
            })
                .then(function (data) {
                    $scope.tags = data.tagNames;
                })
                .catch(function (err) {
                    console.log(err);
                });
        }


        $scope.sendMail = function () {

            $scope.email.users = $scope.selected.map(function (user) {
                return user._id;
            });

            $scope.email.transform = $scope.email.message.match(new RegExp(/{{\w+\.\w+}}/, "gi"));

            // console.log(exprs);
            console.log("sendMail", $scope.email);
            $scope.emailForm.$disabled = true;
            $scope.sendingMail = true;
            RestManager.postResource("/mailer/notifications", $scope.email, "result")
                .then(function (result) {
                    $scope.cancel();
                    $scope.sendingMail = false;
                    $mdToast.showSimple("Sent Emails to " + $scope.selected.length + " people.");
                    $scope.selected = [];
                    $scope.email = {};
                    console.log(result);
                    $scope.action = "";
                    $scope.emailForm.$setPristine();
                })
                .catch(function (err) {
                    $mdToast.showSimple("Some error occurred -" + err);
                    console.log(err);
                })
        };

        $scope.addData = function (exp) {
            $scope.email.message += " " + exp + " ";
            angular.element(document.querySelector('#message')).focus()
        };

        $scope.next = function () {
            $scope.screenTwo = true;
        };

        $scope.prev = function () {
            $scope.screenTwo = false;
        };

        function getAllTags(){
            RestManager.getResource('/users/getAllTags', 'users')
                .then(function(response){
                    $scope.containsTags = true;
                    $scope.tags = response;
                })
                .catch(function(err){
                    $mdToast.showSimple("Error in fetching tags : " + err.message);
                });
        }


        $scope.init();
        $scope.fetchAllOrg();
    }]);

(function () {
    'use strict';

    angular
        .module('app.schedule', ['material.components.eventCalendar']);

})(angular);

(function () {
    'use strict';
        scheduleTask.$inject = ["$scope", "$mdDialog"];
        angular.module("app.schedule")
            .controller("scheduleController.controller", scheduleTask);


        function scheduleTask($scope, $mdDialog) {

            $scope.events = [
                {
                    title: 'Order 1',
                    start: new Date(),
                    end: moment().add(1, 'days').toDate(),
                    allDay: false,
                    id: '123'
                },
                {
                    title: 'Order 2',
                    start: new Date(),
                    end: new Date(),
                    allDay: false,
                    id: '1234'
                }
            ];


            $scope.eventClicked = eventClicked;
            $scope.eventCreated = eventCreated;
            $scope.openEventDialog = openEventDialog;

            function openEventDialog(e){
                var parentEl = angular.element(document.body);
                $mdDialog.show({
                    parentEl: parentEl,
                    fullscreen : true,
                    controller: "eventEdit.controller",
                    templateUrl: 'app/modules/scm/schedule/partials/edit-event.html',
                    clickOutsideToClose: true,
                    locals: {
                        event: e
                    }
                });
            }


            function eventClicked(selectedEvent) {
                $scope.openEventDialog(selectedEvent);
            }


            function eventCreated(date) {
                $scope.openEventDialog({start: date });

            }
        }

})(angular);

(function () {
    'use strict';
    eventEdit.$inject = ["$scope", "$mdDialog", "RestManager", "event"];
    angular.module("app.schedule")
        .controller('eventEdit.controller', eventEdit);

    function eventEdit($scope, $mdDialog, RestManager, event) {

        $scope.event = event;

        if($scope.event.id){
            $scope.editMode = true;
        }else{
            $scope.editMode = false;
        }

        console.log("edit.event.controller.js", "eventEdit", $scope.event);
        var query = {
            query: {
                $or: [
                    {
                        // status: 'approved'
                    }

                ]
            }

        };

        $scope.closeDialog = closeDialog;

        function closeDialog() {
            $mdDialog.cancel();
        }


        $scope.fetchOrders = function () {
            $scope.promise = RestManager.getResource("/order/admin/getOrders", query, "orders");

            $scope.promise
                .then(function (result) {
                    console.log("orders", result);
                })
                .catch(function (err) {
                    console.log("err", err);
                });
        };


        $scope.fetchOrders();
    }

})(angular);

(function () {
    'use strict';
    vendorsController.$inject = ["$scope", "$mdDialog", "Materials", "CriticalUpdateConfirmation"];
    angular.module("app.materials")
        .controller("materialsVendors.controller", vendorsController);

    /** @ngInject **/
    function vendorsController($scope, $mdDialog, Materials, CriticalUpdateConfirmation) {

        $scope.vendors = [];
        $scope.$parent.nestedState = false;
        $scope.$parent.showActionButton = false;
        $scope.$parent.pageTitle = "Vendors";
        $scope.$parent.$parent.backParams = {};
        $scope.promise = '';
        $scope.totalCount = 0;
        $scope.query = {
            page : 1,
            limit : 25,
            sort : '-createdAt',
            q : ''
        };


        $scope.showDialog = showDialog;
        $scope.fetchVendors = fetchVendors;
        $scope.deleteVendor = deleteVendor;


        function showDialog(event, vendor, i) {
            var shallowVendorCopy = {};
            angular.copy(vendor, shallowVendorCopy);
            Materials.openCreateVendorDialog(event, vendor ? shallowVendorCopy : null)
                .then(function (data) {
                    if (i === null) {
                        $scope.vendors.unshift(data.newVendor);
                    } else {
                        $scope.vendors[i] = data.newVendor;
                    }
                })
        }


        function fetchVendors() {
           $scope.promise = Materials.getAllVendors($scope.query);
            $scope.promise
                .then(function (data) {
                    console.log("vendors.controller.js", "DATA", data);
                    $scope.vendors = data.vendors;
                    $scope.totalCount = data.total;
                })
                .catch(function (err) {
                    console.log("vendors.controller.js", "ERROR", err);
                });
        }


        function deleteVendor(ev, vendor, index) {
            CriticalUpdateConfirmation.showDialog({
                targetEvent: ev,
                title: 'Delete Vendor',
                description: 'You opt to delete the vendor ' + vendor.name + '. Do you want to continue?',
                infoMessage: 'Deleting the vendor will completely unlink all Purchases from this vendor',
                inputValidatorString: vendor.name,
                confirmText: 'Delete'
            })
                .then(function (result) {
                    if (result) {
                        Materials.deleteVendorById(vendor._id)
                            .then(function (data) {
                                $scope.vendors.splice(index, 1);
                            })
                            .catch(function (err) {
                                console.log(err)
                            });
                    }
                })
                .catch(function (err) {

                })


        }

        $scope.fetchVendors();

    }

})(angular);

(function () {
    'use strict';


    materialsService.$inject = ["$q", "RestManager", "$mdDialog", "Utils"];
    angular.module('app.materials')
        .service('Materials', materialsService);

    /** @ngInject **/
    function materialsService($q, RestManager, $mdDialog, Utils) {

        //Utils
        this.generateCategoryString = generateCategoryString;
        this.openCreateVendorDialog = openCreateVendorDialog;
        this.quickViewDialog = quickViewDialog;
        this.openCreateMaterialCategoryDialog = openCreateMaterialCategoryDialog;
        this.openCreateMaterialDialog = openCreateMaterialDialog;


        function generateCategoryString(material, categories) {
            var string = material.category.reduce(function (acc, categoryId) {
                var category = _.find(categories, function (category) {
                    return category._id === categoryId;
                });
                if (category) {
                    return acc + category.name + ', ';
                } else {
                    return acc;
                }

            }, '');

            string = Utils.replaceEnd(string, ',');

            return string;
        }

        // Dialogs

        function openCreateVendorDialog(event, vendor) {
            return $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                multiple: true,
                fullscreen: true,
                templateUrl: 'app/modules/scm/materials/modals/addVendorModel/partials/addVendor.tmpl.html',
                controller: "addVendorModel.controller",
                clickOutsideToClose: false,
                locals: {
                    vendor: vendor ? vendor : null
                }
            })
        }


        /**
         * @methodOf Materials
         * @memberOf Materials
         * @method openCreateMaterialCategoryDialog
         * @param event
         * @param locals
         * @param locals.category
         * @param locals.editingIndex
         * @param locals.parentCategory
         * @param locals.parentCategories
         * @returns {*}
         */
        function openCreateMaterialCategoryDialog(event, locals) {
            return $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                locals: locals,
                multiple: true,
                fullscreen: true,
                clickOutsideToClose: false,
                templateUrl: 'app/modules/scm/materials/modals/addCategoryModel/partials/addCategory.tmpl.html',
                controller: "addCategoryModel.controller"
            })
        }


        /**
         * @methodOf Materials
         * @memberOf Materials
         * @method openCreateMaterialDialog
         * @param event
         * @param material
         * @returns {*}
         */
        function openCreateMaterialDialog(event, material) {
            return $mdDialog.show({
                controller: "addMaterialModel.controller",
                templateUrl: 'app/modules/scm/materials/modals/addMaterialModel/partials/addMaterial.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                eventTarget: event,
                fullscreen: true,
                multiple: true,
                locals: {
                    material: material
                }
            })
        }


        function quickViewDialog(materialId, event) {
            return $mdDialog.show({
                controller: "material-quickview.controller",
                templateUrl: 'app/modules/scm/materials/modals/material-quickview/material-quickview.dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                eventTarget: event,
                fullscreen: true,
                multiple: true,
                locals: {
                    materialId: materialId
                }
            })
        }

        this.openDeductStockDialog = function (ev, oldStock, batchId, material) {
            return $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: ev,
                multiple: true,
                clickOutsideToClose: false,
                fullscreen: true,
                controller: "deductStock.controller",
                templateUrl: "app/modules/scm/materials/details/deductStockDialog/partials/deductStock.tmpl.html",
                locals: {
                    stock: oldStock,
                    batchId: batchId,
                    material: material
                }
            })
        }

        this.openMaterialSelectorDialog = function (ev, selected) {
            return $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: ev,
                multiple: true,
                clickOutsideToClose: false,
                fullscreen: true,
                controller: "materials-selector.controller",
                templateUrl: "app/modules/scm/materials/modals/materials-selector/materials-selector.dialog.html",
                locals: {
                    selectedMaterials: selected || null
                }
            })
        }

        //GET REQUESTS

        this.getAllMaterials = function (query, cursor, select) {
            return RestManager.getResource('/materials', 'materials', {
                query: query,
                service: 'scm',
                extras: ['total']
            });
        };

        this.getSingleMaterialById = function (data, fields) {
            return RestManager.getResource('/materials/' + data, 'materials', {
                service: 'scm',
                fields: fields
            });
        };

        this.getMaterialFilters = function () {
            return RestManager.getResource('/materials/filters', 'filters', {
                service: 'scm'
            });
        };

        this.getSinglePurchaseById = function (purchaseId) {
            return RestManager.getResource('/purchases/' + purchaseId, 'purchases', {
                service: 'scm'
            });
        };

        this.getAllMaterialCategories = function (query, cursor, select) {
            return RestManager.getResource('/materialCategories', 'categories', {service: 'scm', query: query});
        };

        this.getAllVendors = function (query, cursor, select) {
            return RestManager.getResource('/vendors', 'vendors', {
                query: query,
                service: 'scm',
                extras: ['total', 'count', 'status']
            });
        };

        this.getSingleVendorById = function (id) {
            return RestManager.getResource('/vendors/' + id, 'vendors', {
                service: 'scm'
            });
        }

        this.autoCompleteMaterialByName = function (text) {
            if (!text) {
                return
            }
            return RestManager.getResource('/materials/search/' + text, 'materials', {
                service: 'scm'
            })
        }

        this.getBatchBySku = function (sku) {
            if (!sku) {
                return
            }
            return RestManager.getResource('/materials/batch/' + sku, 'materials', {
                service: 'scm'
            })
        }

        //POST REQUESTS

        this.saveMaterial = function (data) {
            return RestManager.postResource('/materials', data, 'materials', {service: 'scm'});
        };

        this.saveCategory = function (data) {
            return RestManager.postResource('/materialCategories', data, 'categories', {service: 'scm'});
        };

        this.saveVendor = function (data) {
            return RestManager.postResource('/vendors', data, 'vendors', {service: 'scm'});
        };

        this.saveBatch = function (data) {
            return RestManager.postResource('/materials/batch', data, 'materials', {service: 'scm'});
        }


        //DELETE REQUESTS

        this.deleteVendorById = function (data) {
            return RestManager.deleteResource('/vendors/' + data, 'vendors', {service: 'scm'});
        }


        this.deleteMaterialById = function (data) {
            return RestManager.deleteResource('/materials/' + data, 'materials', {service: 'scm'});
        }

        this.deletePurchaseById = function (data) {
            console.log('asas', data)
            return RestManager.deleteResource('/purchases/' + data, 'purchases', {service: 'scm'});
        }

        this.deleteBatchById = function (batchId, materialId) {
            console.log("material.service.js", "deleteBatchById", materialId, batchId);
            return RestManager.deleteResource('/materials/batch/' + batchId + '/' + materialId, 'materials', {service: 'scm'});
        }

        //PUT REQUESTS

        this.editMaterial = function (data, id) {
            return RestManager.putResource('/materials/' + id, data, 'materials', {
                service: 'scm'
            });
        };


        this.editVendor = function (data, id) {
            return RestManager.putResource('/vendors/' + id, data, 'vendors', {
                service: 'scm'
            })
        }

        this.editBatchStock = function (id, data) {
            return RestManager.putResource('/materials/updateStock/' + id, data, 'materials', {
                service: 'scm'
            });
        }

        this.editBatch = function (id, data) {
            return RestManager.putResource('/materials/batch/' + id, data, 'materials', {
                service: 'scm'
            })
        }


    }

})(angular);

(function () {
    'use strict';
    detailsController.$inject = ["$scope", "Materials", "$timeout", "Images", "Utils", "$templateRequest", "$sce", "$stateParams", "$mdDialog", "AuthManager", "$rootScope", "CriticalUpdateConfirmation", "$mdToast", "RestManager"];
    angular.module('app.materials')
        .controller("materialDetails.controller", detailsController);

    function detailsController($scope, Materials, $timeout, Images, Utils, $templateRequest, $sce, $stateParams, $mdDialog, AuthManager, $rootScope, CriticalUpdateConfirmation, $mdToast, RestManager) {
        $scope.materialId = $stateParams.materialId;
        $scope.query = {
            sort: '-createdAt'
        };
        $scope.batches = [];

        $scope.$parent.pageTitle = "Material Details";
        $scope.$parent.nestedState = true;
        $scope.$parent.showActionButton = false;
        $scope.$parent.backState = $stateParams.backState || "app.materials.all";
        $scope.$parent.backParams = {};
        $scope.isOnleash = false;
        $scope.quantityLeased = 0;
        $scope.currentUser = AuthManager.getCurrentUser();


        $scope.fetchSingleMaterial = fetchSingleMaterial;
        $scope.createBatch = createBatch;
        $scope.deleteBatchById = deleteBatchById;
        $scope.openDeductStockDialog = openDeductStockDialog;
        $scope.print = print;
        $scope.exportData = exportData;
        $scope.openImage = openImage;
        $scope.showHistory = showHistory;
        $scope.openUnleaseStockDialog = openUnleaseStockDialog;
        $scope.saveColor = saveColor;
        $scope.dateAgo = Utils.dateAgo;
        $scope.manageProductStocks = manageProductStocks;

        function showHistory($event, index, batch) {
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: $event,
                fullscreen: true,
                controller: "batch.history.dialog.controller",
                templateUrl: 'app/modules/scm/materials/details/stockHistoryDialog/stock-history-dialog.html',
                clickOutsideToClose: false,
                locals: {
                    stockHistory: batch.stockHistory,
                    availableStock: batch.availableStock
                }
            });
        }

        function openImage(e, image) {
            e.stopPropagation();
            Images.openImageGallery(e, [image]);
        }

        function print() {
            // var innerContents = document.getElementById('print').innerHTML;
            var tmpl = '';

            var templateUrl = $sce.getTrustedResourceUrl('app/modules/printTemplates/material-batch-barcode.html');

            $templateRequest(templateUrl)
                .then(function (html) {
                    console.log('tmpl', html);
                    var popupWindow = window.open('', 'Print');
                    popupWindow.document.write(html);

                    $timeout(function () {
                        popupWindow.focus();
                        popupWindow.print();
                        popupWindow.close();
                    });

                });

        }

        function fetchSingleMaterial() {
            var promises = Materials.getSingleMaterialById($scope.materialId);

            promises
                .then(function (data) {
                    $scope.material = data[0];
                    $scope.$parent.pageTitle = $scope.material.name;

                    $scope.batches = data[0].batches;

                    if ($scope.batches && $scope.batches.length) {
                        // $scope.batches.reverse();
                        $scope.totalBatchCount = $scope.batches.length;
                        _.forEach($scope.batches, function (b, i) {
                            b.index = i;
                        });
                    }

                })
                .catch(function (err) {
                    $mdToast.showSimple("Error in fetching material: " + err.message);
                });

        }


        function createBatch(ev, i, batch) {
            var shallowCopyBatch = {};
            if (batch) {
                angular.copy(batch, shallowCopyBatch);
                shallowCopyBatch.vendor = shallowCopyBatch.vendor ? shallowCopyBatch.vendor._id : null;
            }
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: ev,
                fullscreen: true,
                controller: "addBatchDialog.controller",
                templateUrl: 'app/modules/scm/materials/modals/addBatchDialog/partials/addBatch.tmpl.html',
                clickOutsideToClose: false,
                locals: {
                    materialId: $scope.materialId,
                    batch: batch ? shallowCopyBatch : null,
                }
            })
                .then(function (data) {
                    if (data && data.material) {
                        console.log('da', data.material);
                        $scope.material = data.material;
                       var index =  _.findIndex(data.material.batches, function(b){
                           return !b.index;
                        });
                        $scope.batches = data.material.batches;
                        // $scope.batches.reverse();
                        $scope.totalBatchCount = $scope.batches.length;
                    }
                });
        }

        function exportData(batches) {
            if (batches && batches.length) {
                var wb = {
                    SheetNames: [],
                    Sheets: []
                };
                var dataToExport = batches.map(function (data) {
                    delete data['$$hashKey'];
                    return {
                        name: $scope.material.name,
                        code: data.barcode,
                        friendlyDate: moment(data.createdAt).fromNow(),
                        time: moment(data.createdAt).format('HH:mm:SS').toString(),
                        purchaseDate: moment(data.createdAt).format('DD-MMM-YYYY').toString(),
                        category: $scope.material.categoryString,
                        entryStock: data.entryStock,
                        currentStock: data.availableStock
                    };
                });
                var headers = Object.keys(dataToExport[0]);
                var fileName = $scope.material.name;
                wb.SheetNames.push('Batches');
                var jsonToSheetOptions = {header: headers, skipHeader: false};
                var ws = XLSX.utils.json_to_sheet(dataToExport, jsonToSheetOptions);
                var wopts = {bookType: 'csv', bookSST: false, type: 'binary'};

                wb.Sheets['Batches'] = ws;

                var wbout = XLSX.write(wb, wopts);

                // noinspection JSAnnotator
                function s2ab(s) {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }

                // /* the saveAs call downloads a file on the local machine */
                saveAs(new Blob([s2ab(wbout)],
                    {type: "application/octet-stream"}),
                    fileName + '.csv');
            }

        }


        function openDeductStockDialog(ev, batch) {
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: ev,
                fullscreen: true,
                clickOutsideToClose: false,
                controller: "deductStock.controller",
                templateUrl: "app/modules/scm/materials/details/deductStockDialog/partials/deductStock.tmpl.html",
                locals: {
                    stock: batch.availableStock,
                    batchId: batch._id,
                    material: $scope.material,
                    stockHistory: batch.stockHistory,
                    index: batch.index
                }
            })
                .then(function (data) {
                    _.forEach($scope.batches, function (b) {
                        _.forEach(data.data.updatedData[0].batches, function (d) {
                            if (d._id === b._id) {
                                d.index = b.index;
                            }
                        });
                    });
                    $scope.batches[batch.index].availableStock = data.data.updatedStock;
                    $scope.batches = data.data.updatedData[0].batches;
                });
        }


        function deleteBatchById(e, i, batch) {
            e.stopPropagation();
            CriticalUpdateConfirmation.showDialog({
                targetEvent: e,
                title: 'Delete Batch',
                description: 'You opt to delete the batch with SKU' + batch.sku + '. Do you want to continue?',
                infoMessage: 'Deleting the batch will completely remove it from our system',
                inputValidatorString: batch.sku,
                confirmText: 'Delete'
            })
                .then(function (result) {
                    if (result) {
                        Materials.deleteBatchById(batch._id, $scope.materialId)
                            .then(function (data) {
                                $scope.batches.splice(i, 1);
                            })
                            .catch(function (err) {
                                console.log(err);
                            });
                    }
                })
                .catch(function (err) {
                    $mdToast.showSimple("Error in deleting batch: " + err.message);
                });
        }

        function openUnleaseStockDialog(e, batch, index) {
            $mdDialog.show({
                locals: {
                    batch: batch,
                    materialId:  $scope.materialId
                },
                controller: "unleaseStock.controller",
                templateUrl: 'app/modules/scm/materials/details/unleaseStock/partial/unleaseStock.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: e,
                fullscreen: true,
                clickOutsideToClose: true,
                multiple: true
            })
                .then(function (res) {
                    if (res.updatedData) {
                        var batchIndex = _.findIndex(res.updatedData.batches, function (b) {
                            return  b._id === batch._id;
                        })
                        if(batchIndex !== -1) {
                            $scope.batches[index].leasedQuantity = res.updatedData.batches[batchIndex].leasedQuantity;
                            $scope.batches[index].availableStock = res.updatedData.batches[batchIndex].availableStock;
                            $scope.batches[index].stockHistory = res.updatedData.batches[batchIndex].stockHistory;
                        }
                    }
                })
                .catch(function (err) {
                    $mdToast.showSimple("Error in leasing batch: " + err.message);
                });

        }

        function saveColor(id, hexCode) {
            RestManager.patchResource('/materials/batch/updateColor/' + id, {
                hexCode: hexCode,
                materialId: $scope.materialId
            }, 'materials', {
                service: 'scm'
            })
                .then(function (res) {
                    console.log(res, "------------------")
                    $scope.material.colorNames = res[0].colorNames;
                    $scope.material.hexCodes = res[0].hexCodes;
                    $mdToast.showSimple("Color changes successfully");
                })
                .catch(function (err) {
                    $mdToast.showSimple("Error in saving the color " + err.message);
                });
        }

        function manageProductStocks(e){
            $mdDialog.show({
                locals: {
                    variations: $scope.variations,
                    totalAvailableStock:  $scope.material.stock,
                    materialId: $scope.materialId
                },
                controller: "manageProductStock.controller",
                templateUrl: 'app/modules/scm/materials/details/manageProductStockDialog/partial/manage-product-stock.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: e,
                fullscreen: true,
                clickOutsideToClose: false,
                multiple: true
            })
                .then(function(response){
                    console.log("materialDetails.controller.js", "response", response);
                })
                .catch(function(err){
                    $mdToast.showSimple("Error in managing product stock: " + err.message);
                })
        }

        $scope.fetchSingleMaterial();
    }
})
(angular);

(function () {
    'use strict';

    designController.$inject = ["$scope", "Materials", "ScannerDialog", "$mdDialog", "Utils", "$mdToast", "CriticalUpdateConfirmation", "Images", "hotkeys"];
    angular.module('app.materials')
        .controller('materials.controller', designController);

    /** @ngInject **/
    function designController($scope, Materials, ScannerDialog, $mdDialog, Utils, $mdToast,
                              CriticalUpdateConfirmation, Images, hotkeys) {
        $scope.$parent.nestedState = false;
        $scope.$parent.showActionButton = false;
        $scope.$parent.pageTitle = "Materials";
        $scope.$parent.$parent.backParams = {};

        $scope.materials = [];
        $scope.selected = [];
        $scope.query = {
            search: '',
            limit: 25,
            page: 1,
            sort: '-updatedAt'
        };
        $scope.fetchError = '';
        $scope.promise = '';
        $scope.totalCount = 0;
        $scope.editingMode = '';
        $scope.editingIndex = '';
        $scope.editingMaterial = '';
        $scope.savingMaterial = false;

        hotkeys.bindTo($scope)
            .add({
                combo: 'mod+left',
                description: 'Navigate to previous page',
                callback: function (e) {
                    e.preventDefault();
                    if ($scope.query.page !== 1) {
                        $scope.query.page -= 1;
                        $scope.fetchMaterials();
                        $mdToast.show($mdToast.simple('Showing page ' + $scope.filters.page + ' of ' + $scope.totalPages))
                    } else {
                        $mdToast.show($mdToast.simple('This is already the first page in the list'));
                    }
                }
            })
            .add({
                combo: 'mod+right',
                description: 'Navigate to next page',
                callback: function (e) {
                    e.preventDefault();
                    if ($scope.query.page !== ($scope.totalPages)) {
                        $scope.query.page += 1;
                        $scope.fetchMaterials();
                        $mdToast.show($mdToast.simple('Showing page ' + $scope.filters.page + ' of ' + $scope.totalPages))
                    } else {
                        $mdToast.show($mdToast.simple('This is already the last page in the list'));
                    }
                }
            });


        $scope.fetchMaterials = fetchMaterials;
        $scope.showDialog = showDialog;
        $scope.deleteMaterial = deleteMaterial;
        $scope.getClass = getClass;
        $scope.openImage = openImage;
        $scope.exportData = exportData;
        $scope.openScanner = openScanner;
        $scope.clearSelections = clearSelections;
        $scope.dateAgo = Utils.dateAgo;
        $scope.quickView = Materials.quickViewDialog;

        function clearSelections() {
            $scope.selected = [];
        }

        function getClass(material) {
            if (material.stock >= 10) {
                return 'success'
            } else if (material.stock > 0 && material.stock < 10) {
                return 'pending'
            } else {
                return 'error';
            }
        }

        function fetchMaterials() {
            $scope.fetchError = '';
            if (!$scope.query.search) {
                delete $scope.query.search;
            }
            $scope.promise = Materials.getAllMaterials($scope.query);

            $scope.promise
                .then(function (data) {
                    console.log(data);
                    $scope.materials = data.materials;
                    $scope.totalCount = data.total;
                    $scope.totalPages = Math.ceil($scope.totalCount / $scope.query.limit);
                })
                .catch(function (err) {
                    $scope.fetchError = err;
                })
        }

        function showDialog(ev, material, i) {
            ev.stopPropagation();
            var materialShallowCopy = {}
            angular.copy(material, materialShallowCopy);
            $mdDialog.show({
                controller: "addMaterialModel.controller",
                templateUrl: 'app/modules/scm/materials/modals/addMaterialModel/partials/addMaterial.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                eventTarget: ev,
                fullscreen : true,
                locals: {
                    material: material ? materialShallowCopy : null
                }
            })
                .then(function (data) {
                    if (i === null) {
                        $scope.materials.unshift(data.materials);
                    } else {
                        $scope.materials[i] = data.materials;

                    }

                });
        }

        function exportData(materials) {
            if (materials && materials.length) {
                var wb = {
                    SheetNames: [],
                    Sheets: []
                };
                // if(material.batches && material.batches.length)
                var dataToExport = [];
                materials.forEach(function (material) {
                    var data = material.batches.map(function (data) {
                        delete data['$$hashKey'];
                        var categories = '';
                        if (material.categoryString) {
                            categories = material.categoryString.split(',').reduce(function (acc, categoryName) {
                                return acc + ',' + categoryName.substring(categoryName.lastIndexOf(">") + 1);
                            }, '');

                            categories = categories.replace(',', '');
                        }

                        return {
                            name: material.name,
                            code: data.barcode,
                            friendlyDate : moment(data.createdAt).fromNow(),
                            time : moment(data.createdAt).format('HH:mm:SS').toString(),
                            purchaseDate: moment(data.createdAt).format('DD-MMM-YYYY').toString(),
                            category: categories,
                            entryStock: data.entryStock,
                            currentStock: data.availableStock
                        };
                    });

                    dataToExport = dataToExport.concat(data);
                });

                var headers = Object.keys(dataToExport[0]);
                var fileName = 'Materials List';
                wb.SheetNames.push('Batches');
                var jsonToSheetOptions = {header: headers, skipHeader: false};
                var ws = XLSX.utils.json_to_sheet(dataToExport, jsonToSheetOptions);
                var wopts = {bookType: 'csv', bookSST: false, type: 'binary'};

                wb.Sheets['Batches'] = ws;

                var wbout = XLSX.write(wb, wopts);

                // noinspection JSAnnotator
                function s2ab(s) {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }

                // /* the saveAs call downloads a file on the local machine */
                saveAs(new Blob([s2ab(wbout)],
                    {type: "application/octet-stream"}),
                    fileName + '-' + moment().toString() + '.csv');
            }

        }


        function deleteMaterial(ev, material, index) {
            ev.stopPropagation();
            CriticalUpdateConfirmation.showDialog({
                targetEvent: ev,
                title: 'Delete Material',
                description: 'You opt to delete the material ' + material.name + '. Do you want to continue?',
                infoMessage: 'Deleting the material will completely remove it from our system',
                inputValidatorString: material.name,
                confirmText: 'Delete'
            })
                .then(function (result) {
                    if (result) {
                        Materials.deleteMaterialById(material._id)
                            .then(function (data) {
                                $scope.materials.splice(index, 1);
                            })
                            .catch(function (err) {
                                console.log(err)
                            });
                    }
                })
                .catch(function (err) {

                });
        }

        function openImage(e, image) {
            e.stopPropagation();
            Images.openImageGallery(e, [image]);
        }

        function openScanner(e) {
            ScannerDialog.openDialog(e)
                .then(function (code) {
                    return Materials.getBatchBySku(code);
                })
                .then(function (material) {
                    if(material && material.length) {
                        var batch = material[0].batches[0];
                        return Materials.openDeductStockDialog(e, batch.availableStock, batch._id, material[0]);
                    } else {
                        return null;
                    }
                })
                .then(function (result) {
                    if(result) {
                        $mdToast.showSimple('Deducted Stock Successfully');
                        $scope.fetchMaterials();
                    } else {
                        $mdToast.show('Error with Barcode Scanner');
                    }
                })
                .catch(function (err) {
                    console.log('Error', err);
                    $mdToast.show('Error fetching barcode :' + err.message);
                })
        }


        $scope.fetchMaterials();

    }

})(angular);

(function () {
    'use strict';

    categoriesController.$inject = ["$scope", "$log", "RestManager", "Materials", "$mdDialog", "$mdToast"];
    angular.module('app.materials')
        .controller('materialsCategories.controller', categoriesController);

    /** @ngInject **/
    function categoriesController($scope, $log, RestManager, Materials, $mdDialog, $mdToast) {
        $scope.$parent.nestedState = false;
        $scope.$parent.showActionButton = false;
        $scope.$parent.pageTitle = "Material Categories";
        $scope.$parent.$parent.backParams = {};


        $scope.query = {
            search: '',
            limit: 25,
            page: 1
        };
        $scope.newCategory = '';
        $scope.editingMode = '';
        $scope.editingIndex = '';
        $scope.a = '';
        $scope.categories = '';
        $scope.promise = '';
        $scope.selectedParent = '';
        $scope.selectedChildren = '';
        $scope.selectedIndex = '';
        $scope.parentCategories = [];
        $scope.loading = false;

        $scope.fetchCategories = fetchCategories;
        $scope.editCategory = editCategory;
        $scope.addNewCategory = addNewCategory;
        $scope.removeCategory = removeCategory;
        $scope.getParentCategoryName = getParentCategoryName;
        $scope.reOrder = reOrder;
        $scope.selectParent = selectParent;
        $scope.selectChildren = selectChildren;
        $scope.restore = restore;
        $scope.onDrop = onDrop;
        $scope.addSubcategory = addSubcategory;
        $scope.handleResult = handleResult;

        function fetchCategories() {
            $scope.loading = true;
            $scope.promise = Materials.getAllMaterialCategories($scope.query);
            $scope.promise
                .then(function (categories) {
                    $scope.categories = categories;
                    console.log("materialsCategories.controller.js", "HERE", $scope.categories);
                    $scope.reOrder($scope.categories);
                    $log.info(categories, $scope.parentCategories);
                    $scope.loading = false;
                })
                .catch(function (err) {
                    $log.error(err);
                    $scope.loading = false;
                });
        }


        function editCategory(category, index, event) {
            $scope.newCategory = category;
            $scope.editingMode = true;
            $scope.editingIndex = index;
            Materials
                .openCreateMaterialCategoryDialog(event, {
                    category: category,
                    editingIndex: index,
                    parentCategory: null,
                    parentCategories: $scope.parentCategories
                })
                .then($scope.handleResult);
            event.stopPropagation();
        }

        function addNewCategory(event) {
            $scope.newCategory = {};
            $scope.editingMode = false;
            $scope.editingIndex = "";
            Materials
                .openCreateMaterialCategoryDialog(event, {
                    category: null,
                    editingIndex: null,
                    parentCategory: null,
                    parentCategories: $scope.parentCategories
                })
                .then($scope.handleResult);
        }


        function addSubcategory(category, event) {
            Materials
                .openCreateMaterialCategoryDialog(event, {
                    category: null,
                    editingIndex: null,
                    parentCategory: category._id,
                    parentCategories: $scope.parentCategories
                })
                .then($scope.handleResult);
        }

        function handleResult(data) {
            if (data.editingMode) {
                $scope.categories.splice(data.editingIndex, 1, data.category);
                $mdToast.show($mdToast.simple().textContent("Successfully edited category"));
            } else {
                $scope.categories.unshift(data.category);
                $mdToast.show($mdToast.simple().textContent("Successfully created new category"));
            }
            $scope.reOrder($scope.categories);
        }


        function removeCategory(category, index, event) {

            var confirm = $mdDialog.confirm()
                .title('Would you like to delete the category?')
                .textContent('Note that this action is irreversible and may cause unexpected behaviour.')
                .ariaLabel('Lucky day')
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                RestManager.deleteResource("/categories/" + category._id, "categories")
                    .then(function (result) {
                        console.log(result);
                        var index = _.findIndex($scope.categories, function (o) {
                            return o._id === category._id;
                        });
                        $scope.categories.splice(index, 1);
                        $scope.reOrder($scope.categories);
                        $mdToast.show($mdToast.simple().textContent("Successfully deleted category"));
                    })
                    .catch(function (err) {
                        $mdToast.show($mdToast.simple().textContent("Error while deleting category." + err.message));
                    })
            }, function () {
                console.log("Cancelled");
            });
        }


        function getParentCategoryName(categoryId) {
            return _.find($scope.parentCategories, function (o) {
                return o._id === categoryId;
            });
        }

        function reOrder(categories) {
            $scope.parentCategories = _.sortBy(categories
                    .filter(function (category) {
                        return !category.parent || (category.parent && category.parent === category._id)
                    })
                    .map(function (category) {
                        category.children = categories.filter(function (c) {
                            return c.parent === category._id;
                        })
                        return category;
                    }),
                function (category) {
                    return category.name;
                })

        }

        function selectParent(category, index) {
            $scope.restore();
            category.selected = true;
            $scope.selectedParent = category;
            $scope.selectedIndex = index;
        }


        function selectChildren(category, index) {
            $scope.restore();
            category.selected = true;
            $scope.selectedChildren = category;
            $scope.selectedIndex = index;
        }

        function restore() {
            $scope.parentCategories = _.map($scope.parentCategories, function (cat) {
                cat.selected = false;
                return cat;
            });
            // $scope.parentCategories[$scope.selectedIndex] = false;
            $scope.selectedParent = '';
            $scope.selectedChildren = '';
        }

        function onDrop(list, item, index) {
            console.log('On Drop', list, item, index);
        }

        $scope.fetchCategories();
    }

})(angular);

(function () {
    'use strict';

    angular
        .module('app.purchases', []);

})(angular);

(function () {
        'use strict';
        addPurchaseController.$inject = ["$scope", "$mdDialog", "$mdToast", "RestManager", "purchase", "Materials"];
        angular.module('app.purchases')
            .controller('addPurchaseModel.controller', addPurchaseController);

        function addPurchaseController($scope, $mdDialog, $mdToast, RestManager, purchase, Materials) {

            $scope.purchase = purchase || {
                totalPurchaseAmount: 0,
                totalPurchaseTaxAmount: 0,
                lineItems: []
            };
            console.log("addPurchaseModel.controller.js", "addPurchaseController", purchase);
            $scope.saving = false;
            $scope.materialSearchText = '';

            $scope.maxDate = moment().endOf('day').toDate();

            $scope.taxGroups = {
                GST: [
                    {
                        value: 'GST:0',
                        actualValue: 0
                    },
                    {
                        value: 'GST:5',
                        actualValue: 5
                    },
                    {
                        value: 'GST:12',
                        actualValue: 12
                    },
                    {
                        value: 'GST:18',
                        actualValue: 18
                    },
                    {
                        value: 'GST:28',
                        actualValue: 18
                    }
                ],
                IGST: [
                    {
                        value: 'IGST:0',
                        actualValue: 0
                    },
                    {
                        value: 'IGST:5',
                        actualValue: 5
                    },
                    {
                        value: 'IGST:12',
                        actualValue: 12
                    },
                    {
                        value: 'IGST:18',
                        actualValue: 18
                    },
                    {
                        value: 'IGST:28',
                        actualValue: 28
                    }
                ]
            };

            $scope.editingPurchase = !!purchase;


            $scope.init = init;
            $scope.cancelDialog = cancelDialog;
            $scope.fetchVendor = fetchVendor;
            $scope.fetchMaterial = fetchMaterial;
            $scope.addLineItems = addLineItems;
            $scope.deleteLineItems = deleteLineItems;
            $scope.createPurchase = createPurchase;
            $scope.reCalculateData = reCalculateData;
            $scope.openAddNewMaterial = openAddNewMaterial;
            $scope.populateGstNumber = populateGstNumber;
            $scope.addMaterialToLineItem = addMaterialToLineItem;
            $scope.removeMaterialFromItem = removeMaterialFromItem;
            $scope.addVendorToData = addVendorToData;
            $scope.removeVendor = removeVendor;
            $scope.getVendorById = getVendorById;
            $scope.createVendor = createVendor;
            $scope.selectSuggestedVendor = selectSuggestedVendor;


            function init() {
                $scope.fetchingPurchase = true;
                Materials.getSinglePurchaseById(purchase._id)
                    .then(function (purchases) {
                        if (purchases && purchases.length) {
                            $scope.purchase = purchases[0];
                            $scope.purchase.vendor = purchase.vendor._id;
                            $scope.purchase.lineItems = $scope.purchase.lineItems.map(function (value) {
                                value.isOld = true;
                                value.taxString = value.purchaseTax.CGST ? 'GST:' + (value.purchaseTax.CGST_Percent * 2) : 'IGST:' + value.purchaseTax.IGST_Percent
                                return value;
                            })
                            $scope.fetchingPurchase = false;
                            $scope.getVendorById();
                        }
                    })
                    .catch(function (err) {
                        $scope.fetchingPurchase = false;
                        console.log('Error fetching purcahse', err);
                    })

            }

            function selectSuggestedVendor(vendorName) {
                $scope.fetchVendor(vendorName)
                    .then(function (vendors) {
                        if (vendors && vendors.length) {
                            $scope.addVendorToData(vendors[0]);
                        } else {
                            $mdToast.show($mdToast.showSimple('No Vendor Matching the name ' + vendorName + ' found', 4000))
                        }
                    })
                    .catch(function (err) {
                        $mdToast.show($mdToast.showSimple('Error fetching suggestion for vendor : ' + err.message))
                    })
            }

            function cancelDialog() {
                $mdDialog.cancel();
            }

            function addMaterialToLineItem(material, lineItem) {
                lineItem.material = material;
            }

            function removeMaterialFromItem(lineItem) {
                lineItem.material = null;
            }


            function reCalculateData() {
                var totalAmt = 0;
                var totalTax = 0;
                _.forEach($scope.purchase.lineItems, function (lineItem) {
                    var subTotal = 0;
                    if (!lineItem.purchaseTax) {
                        lineItem.purchaseTax = {};
                    }
                    if (lineItem.taxString) {
                        var tax = lineItem.taxString.split(":");
                        lineItem.taxType = tax[0];
                        lineItem.taxPercentage = tax[1];
                    }

                    if (lineItem.unit === 'pieces') {
                        subTotal = _.round((lineItem.quantity * lineItem.rate), 2);
                    } else {
                        subTotal = lineItem.rate;
                        $scope.costPerKg = _.round(((lineItem.rate / lineItem.quantity) * 1000), 2)
                    }
                    lineItem.purchaseTax.totalTax = _.round((subTotal * (lineItem.taxPercentage / 100)), 2);
                    if (!lineItem.taxPercentage) {
                        lineItem.purchaseTax.totalTax = 0;
                        lineItem.amount = _.round(subTotal + lineItem.purchaseTax.totalTax, 2);
                    }
                    if (lineItem.taxPercentage && lineItem.isInclusive) {
                        lineItem.amount = _.round(subTotal, 2);
                    }
                    if (lineItem.taxPercentage && !lineItem.isInclusive) {
                        lineItem.amount = _.round(subTotal + lineItem.purchaseTax.totalTax, 2);
                    }
                    if (lineItem.taxType === 'IGST') {
                        lineItem.purchaseTax.IGST = _.round(lineItem.purchaseTax.totalTax, 2);
                        lineItem.purchaseTax.IGST_Percent = _.round(lineItem.taxPercentage, 2);
                    }
                    if (lineItem.taxType === 'GST') {
                        lineItem.purchaseTax.SGST = _.round((lineItem.purchaseTax.totalTax / 2), 2);
                        lineItem.purchaseTax.SGST_Percent = _.round((lineItem.taxPercentage / 2), 2);
                        lineItem.purchaseTax.CGST = _.round((lineItem.purchaseTax.totalTax / 2), 2);
                        lineItem.purchaseTax.CGST_Percent = _.round((lineItem.taxPercentage / 2), 2);
                    }
                    totalAmt += lineItem.amount;
                    totalTax += lineItem.purchaseTax.totalTax;

                });

                $scope.purchase.totalPurchaseAmount = _.round(totalAmt, 2);
                $scope.purchase.totalPurchaseTaxAmount = _.round(totalTax, 2);
            }

            function addLineItems(index) {
                if (typeof index === 'undefined') {
                    $scope.purchase.lineItems.unshift({value: [], isInclusive: true});
                } else {
                    $scope.purchase.lineItems.splice(index + 1, 0, {value: [], isInclusive: true});
                }
            }

            function createVendor(vendorName) {
                Materials.openCreateVendorDialog(event, {
                    name: vendorName
                })
                    .then(function (data) {
                        if (data.newVendor) {
                            $scope.purchase.vendor = data.newVendor;
                        }
                    })
            }

            function deleteLineItems(e, index) {
                var confirm = $mdDialog.confirm()
                    .title('Delete Line Item?')
                    .ariaLabel('Lucky day')
                    .targetEvent(e)
                    .ok('Yes')
                    .cancel('No')
                    .multiple(true);

                $mdDialog.show(confirm).then(function () {
                    $scope.purchase.lineItems.splice(index, 1);
                }, function () {
                });
            }

            function createPurchase() {
                var payload = {};
                angular.copy($scope.purchase, payload);
                payload.lineItems = payload.lineItems.map(function (lineItem) {
                    lineItem.material = lineItem.material._id;
                    return lineItem
                });
                $scope.saving = true;
                var promises;
                if ($scope.editingPurchase) {
                    promises = RestManager.putResource('/purchases/' + purchase._id, payload, 'purchases', {service: 'scm'});
                } else {
                    promises = RestManager.postResource('/purchases', payload, "purchases", {service: 'scm'});
                }
                promises
                    .then(function (data) {
                        $scope.saving = false;
                        console.log("addPurchaseModel.controller.js", "DATA", data);
                        console.log("addPurchaseModel.controller.js", "DATA", data[0]);
                        $mdDialog.hide({newPurchase: data[0]});
                    })
                    .catch(function (err) {
                        $scope.saving = false;
                        console.log("addPurchaseModel.controller.js", "ERROR", err);
                    });
            }


            function openAddNewMaterial(event, searchText, lineItem) {
                Materials
                    .openCreateMaterialDialog(event, {
                        name: searchText
                    })
                    .then(function (result) {
                        if (result && result.materials) {
                            lineItem.material = result.materials;
                        }
                    })
            }

            function fetchVendor(queryText) {
                return RestManager.getResource('/vendors?q=' + encodeURIComponent(queryText) + '&page=1&limit=3', 'vendors', {service: 'scm'})
            }

            function addVendorToData(vendor) {
                $scope.purchase.vendor = vendor;
                if (vendor) {
                    console.log("addPurchaseModel.controller.js", "addVendorToData", vendor);
                    $scope.purchase.billGstNumber = $scope.purchase.vendor.gstNumber;
                }
            }

            function removeVendor() {
                $scope.purchase.vendor = null;
                $scope.purchase.billGstNumber = null;
            }

            function getVendorById() {
                Materials.getSingleVendorById($scope.purchase.vendor)
                    .then(function (result) {
                        console.log('result', result);
                        if (result && result.length) {
                            $scope.purchase.vendor = result[0];
                        }
                    })
                    .catch(function (err) {
                        console.log("addBatchDialog.controller.js", "ERROR", err);
                    });
            }

            function populateGstNumber() {
                if ($scope.purchase.vendor) {
                    $scope.purchase.billGstNumber = $scope.purchase.vendor.gstNumber;
                }
            }


            function fetchMaterial(searchText) {
                return RestManager.getResource("/materials", 'materials', {
                    query: {page: 1, limit: 5, search: searchText, fields: 'name'},
                    service: 'scm'
                });
            }

            if ($scope.editingPurchase) {
                $scope.init();
            }
        }

    }

)(angular);

(function () {
    'use strict';
    purchaseController.$inject = ["$scope", "RestManager", "$mdDialog", "CriticalUpdateConfirmation", "Materials"];
    angular.module("app.purchases")
        .controller('purchase.controller', purchaseController);

    function purchaseController($scope, RestManager, $mdDialog, CriticalUpdateConfirmation, Materials) {
        $scope.promise = '';
        $scope.purchases = [];
        $scope.query = {
            search: '',
            limit: 10,
            page: 1,
            sort: "-createdAt"
        };


        $scope.fetchAllPurchase = fetchAllPurchase;
        $scope.showDialog = showDialog;
        $scope.deletePurchase = deletePurchase;

        function fetchAllPurchase() {
            $scope.promise = RestManager.getResource('/purchases', 'purchases', {
                query: $scope.query,
                service: 'scm',
                extras: ['total']
            });
            $scope.promise
                .then(function (data) {
                    $scope.purchases = data.purchases;
                    $scope.totalPurchaseCount = data.total;
                    console.log("purchase.controller.js", "PURCHASES", $scope.purchases);
                })
                .catch(function (err) {
                    console.log("purchase.controller.js", "ERROR", err);
                });
        }


        function showDialog(ev, purchase, i) {
            var shallowCopyPurchase = {};
            if (purchase) {
                angular.copy(purchase, shallowCopyPurchase);
            }
            console.log("purchase.controller.js", "showDialog", i);
            $mdDialog.show({
                parent: angular.element(document.body),
                eventTarget: ev,
                fullscreen : true,
                controller: 'addPurchaseModel.controller',
                templateUrl: 'app/modules/scm/purchase/models/partials/addPurchaseModel.tmpl.html',
                clickOutsideToClose: false,
                locals: {
                    purchase: purchase ? shallowCopyPurchase : null
                }
            })
                .then(function (data) {
                    // if (i === null) {
                    //     console.log("purchase.controller.js", "DATA", data.newPurchase);
                    //     $scope.purchases.unshift(data.newPurchase)
                    // } else {
                    //     $scope.purchases[i] = data.newPurchase;
                    // }
                    $scope.fetchAllPurchase();

                });
        }

        function deletePurchase(ev, purchase, i) {
            CriticalUpdateConfirmation.showDialog({
                targetEvent: ev,
                title: 'Delete Purchase',
                description: 'You opt to delete the purchase. Do you want to continue?',
                infoMessage: 'Deleting the purchase will completely remove it from our system',
                inputValidatorString: 'Delete',
                confirmText: 'Delete'
            })
                .then(function (result) {
                    if (result) {
                        console.log(result, purchase, i)
                        Materials.deletePurchaseById(purchase._id)
                            .then(function (data) {
                                $scope.fetchAllPurchase();
                            })
                            .catch(function (err) {
                                console.log(err)
                            });
                    }
                })
                .catch(function (err) {

                })
        }

        $scope.fetchAllPurchase();

    }

})(angular);

(function () {
    'use strict';

    angular
        .module('app.designs', []);

})(angular);

(function () {
    'use strict';


    designService.$inject = ["$q", "RestManager"];
    angular.module('app.designs')
        .service('Design', designService);

    /** @ngInject **/
    function designService($q, RestManager) {

        this.saveDesign = function (data) {
            var design = {};
            angular.copy(data, design);
            if (!design._id) {
                delete design.designId;
            }
            return RestManager.postResource('/designs', design, 'designs', {
                service: 'scm'
            });
        };

        this.fetchDesignById = function (id) {
            return RestManager.getResource('/designs/' + id, 'designs', {
                service: 'scm'
            });
        };

        this.getAllDesigns = function (query) {
            return RestManager.getResource('/designs', 'designs', {service: 'scm', query: query, extras: ['total']})
        };

        this.getSeasonsSuggestions = function (searchText) {
            console.log("designs.service.js", "getSeasonsSuggestions", searchText);
            return RestManager.getResource('/designs/seasons', 'designs', {
                query: {
                    page: 1,
                    limit: 5,
                    search: searchText
                },
                service: 'scm'
            });
        };

        this.updateDesignStatus = function (id, status) {
            console.log("designs.service.js", "updateDesignStatus", id, status);
            return RestManager.patchResource('/designs/status/' + id, {status: status}, 'designs', {
                service: 'scm'
            });
        };

        this.editDesignById = function (design) {
            return RestManager.postResource('/designs/' + design._id, design, 'designs', {
                service: 'scm'
            });
        };
    }

})(angular);

(function () {
    'use strict';

    angular.module('app.designs')
        .service('addDesignService', addDesignService);

    function addDesignService() {

        /**
         *@memberOf addDesign
         *@param$scope
         * return {allFabric}
         * */
        // var alFabric = [
        //     {
        //         name: "MUSLIN",
        //         cost: "150",
        //     },
        //
        //     {
        //         name: "ORGANZA",
        //         cost: "200"
        //     },
        //
        //     {
        //         name: "ORGANDY",
        //         cost: "250"
        //     },
        //
        //     {
        //         name: "VELVET",
        //         cost: "190"
        //     },
        //
        //     {
        //         name: "DENIM",
        //         cost: "280"
        //     },
        //
        //     {
        //         name: "DAMASK",
        //         cost: "300"
        //     },
        //
        //     {
        //         name: "CHIFFON",
        //         cost: "140"
        //     },
        //
        //     {
        //         name: "FELT",
        //         cost: "500"
        //     }
        // ];
        // return {
        //     loadAllFabric: function () {
        //         return $q.when(alFabric);
        //     }
        // }
    }


})(angular);

(function () {
    'use strict';
    editMeasurements.$inject = ["$scope", "$mdDialog", "Utils", "$mdToast", "RestManager", "design", "Workforce"];
    angular.module('app.designs')
        .controller('editMeasurements.controller', editMeasurements);

    function editMeasurements($scope, $mdDialog, Utils, $mdToast, RestManager, design, Workforce) {
        $scope.design = design;
        $scope.savingMeasurements = false;
        $scope.editMode = !!design.sizeChart;

        $scope.close = close;
        $scope.fetchSizeCharts = fetchSizeCharts;
        $scope.updateSizeChart = updateSizeChart;
        $scope.updateMeasurements = updateMeasurements;
        $scope.saveMeasurements = saveMeasurements;
        $scope.showConfirmDialog = showConfirmDialog;
        $scope.deleteMeasurement = deleteMeasurement;
        $scope.appendMeasurement = appendMeasurement;

        function close() {
            $mdDialog.cancel();
        }

        function fetchSizeCharts() {
            Utils.fetchSizeCharts()
                .then(function (response) {
                    console.log("edit-measurements-dialog.controller.js", "Response", response, $scope.design.sizeChart);
                    $scope.sizeCharts = response;
                    $scope.sizeChartId = $scope.design.sizeChart;
                    $scope.sizeText = $scope.design.sizeText;
                    $scope.updateSizeChart($scope.design.sizeChart, false);
                })
                .catch(function (err) {
                    $mdToast.showSimple('Eror in fetching SIzecharts: ' + err.message);
                });
        }

        function updateSizeChart(sizeChartId, isUpdating) {
            console.log("edit-measurements-dialog.controller.js", "updateSizeChart", sizeChartId);
            if ($scope.editMode && isUpdating) {
                $scope.showConfirmDialog()
                    .then(function (res) {
                        console.log(res);
                        if (res) {
                            $scope.design.sizeChart = sizeChartId;
                            $scope.selectedSizeChart = _.find($scope.sizeCharts, function (s) {
                                return s.id === $scope.design.sizeChart;
                            });
                            $scope.updateMeasurements($scope.design.sizeText, false);
                        }
                    })
                    .catch(function () {
                        $scope.sizeChartId = $scope.design.sizeChart;
                    });
            } else {
                $scope.design.sizeChart = sizeChartId;
                console.log("edit-measurements-dialog.controller.js", "updateSizeChart", $scope);
                $scope.selectedSizeChart = _.find($scope.sizeCharts, function (s) {
                    return s.id === $scope.design.sizeChart;
                });
            }
        }

        function updateMeasurements(sizeText, isUpdating) {
            if ($scope.editMode && isUpdating) {
                $scope.showConfirmDialog()
                    .then(function (res) {
                        if (res) {
                            $scope.design.sizeText = sizeText;
                            $scope.design.measurements = _.find($scope.selectedSizeChart.measurements, function (measurement) {
                                return measurement.key === $scope.design.sizeText;
                            }).values;
                        }
                    })
                    .catch(function(){
                         $scope.sizeText = $scope.design.sizeText;
                    });
            } else {
                console.log("edit-measurements-dialog.controller.js", "updateMeasurements", sizeText);
                $scope.design.sizeText = sizeText;
                $scope.design.measurements = _.find($scope.selectedSizeChart.measurements, function (measurement) {
                    return measurement.key === $scope.design.sizeText;
                }).values;
            }
        }

        function showConfirmDialog() {
            return $mdDialog.show(
                $mdDialog.confirm({
                    title: 'Are you sure?',
                    multiple: true,
                    ok: 'Yes, Change.',
                    cancel: "Cancel",
                    textContent: 'Changing the value will reset the custom measurements to default measurements.'
                })
            );
        }

        function saveMeasurements() {
            $scope.savingMeasurements = true;
            var finalResult
            RestManager.patchResource('/designs/measurement/' + $scope.design._id, {
                measurements: $scope.design.measurements,
                sizeText: $scope.design.sizeText,
                sizeChart: $scope.design.sizeChart
            }, 'designs', {service: 'scm'})
                .then(function (data) {
                    finalResult = data;
                    return Workforce.updateMeasurementForTasks($scope.design.measurements, $scope.design._id);
                })
                .then(function (data) {
                    $scope.savingMeasurements = false;
                    $mdDialog.hide({updatedData: finalResult});
                })
                .catch(function (err) {
                    $scope.savingMeasurements = false;
                    $mdToast.showSimple('Error in :' + err.message);
                });
        }

        function appendMeasurement(index) {
            $scope.design.measurements.splice(index + 1, 0, {key: '', value: ''})
        }

        function deleteMeasurement(index) {
            $scope.design.measurements.splice(index, 1);
        }

        $scope.fetchSizeCharts();

    }

})(angular);

(function () {
    'use strict';
    designDetailsController.$inject = ["$scope", "Design", "$stateParams", "$mdToast", "RestManager", "Workforce", "$mdDialog"];
    angular.module('app.designs')
        .controller('designDetails.controller', designDetailsController);

    function designDetailsController($scope, Design, $stateParams, $mdToast, RestManager, Workforce, $mdDialog) {
        $scope.$parent.nestedState = true;
        $scope.$parent.showActionButton = false;
        $scope.$parent.$parent.backParams = {};
        $scope.$parent.backState = $stateParams.backState || "app.design.all";
        $scope.$parent.pageTitle = "Design Details";


        $scope.fetchDesignById = fetchDesignById;
        $scope.fetchTasks = fetchTasks;
        $scope.createTaskDialog = createTaskDialog;
        $scope.openEditMeasurementsDialog = openEditMeasurementsDialog;
        $scope.selectImage = selectImage;

        function fetchDesignById() {
            $scope.fetchingDesign = true;
            Design.fetchDesignById($stateParams.id)
                .then(function (response) {
                    $scope.fetchingDesign = false;
                    $scope.design = response[0];
                    $scope.design.images = $scope.design.images.map(function (image) {
                        if (image.urls.medium === $scope.design.previewImageUrl) {
                            image.active = true;
                            $scope.previewImage = image;
                        }
                        return image;
                    });
                    console.log("design.details.controller.js", "DESIGN", $scope.design);
                })
                .catch(function (err) {
                    $scope.fetchingDesign = false;
                    $mdToast.showSimple('Error in fetching Design: ' + err.message);
                });
        }

        function createTaskDialog(ev) {
            Workforce.openTaskCreateDialog(ev, {
                design: $scope.design
            })
                .then(function (response) {
                    // console.log(response);
                    // $scope.tasks = response.tasks;
                    $scope.fetchTasks();
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error in creating task: ' + err.message);
                });
        }

        // function changeDesignStatus(){
        //     $scope.changingStatus = true;
        //     console.log("add.design.controller.js", "changeDesignStatus", $scope.design.status);
        //     Design.updateDesignStatus($scope.designId, $scope.design.status)
        //         .then(function(response){
        //             $scope.changingStatus = false;
        //             $mdToast.showSimple("Status Updated");
        //             $state.go('app.designs.details', {id: $scope.designId});
        //         })
        //         .catch(function(err){
        //             $scope.changingStatus = false;
        //             $mdToast.showSimple('Error in updating the status: '+ err.message);
        //         });
        // }


        function openEditMeasurementsDialog(event) {
            var newDesign = {};
            angular.copy($scope.design, newDesign);
            $mdDialog.show({
                templateUrl: 'app/modules/scm/designs/dialog/edit-measurements-dialog.tmpl.html',
                controller: 'editMeasurements.controller',
                fullscreen: true,
                multiple: true,
                locals: {
                    design: newDesign
                },
                targetEvent: event
            })
                .then(function (response) {
                    $scope.design.measurements = response.updatedData[0].measurements;
                    $scope.design.sizeText = response.updatedData[0].sizeText;
                    $scope.design.sizeChart = response.updatedData[0].sizeChart;
                });
        }

        function fetchTasks() {
            $scope.loadingTasks = true;
            RestManager.getResource('/tasks', 'tasks', {
                query: {
                    page: 1,
                    limit: 10,
                    designs: $stateParams.id
                },
                service: 'workforce'
            })
                .then(function (response) {
                    $scope.tasks = response;
                    $scope.loadingTasks = false;
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error in fetching tasks: ' + err.message);
                });
        }

        function selectImage(image) {
            $scope.design.images = $scope.design.images.map(function (image) {
                image.active = false;
                return image;
            });
            image.active = true;
            $scope.previewImage = image;
        }


        $scope.fetchDesignById();
        $scope.fetchTasks();
    }

})(angular);

(function () {
    'use strict';

    designController.$inject = ["$scope", "Design", "$mdDialog", "$mdToast", "Images", "Utils", "CriticalUpdateConfirmation", "RestManager"];
    angular.module('app.designs')
        .controller('designs.controller', designController);

    /** @ngInject **/
    function designController($scope, Design, $mdDialog, $mdToast, Images, Utils,
                              CriticalUpdateConfirmation, RestManager) {
        $scope.$parent.nestedState = false;
        $scope.$parent.showActionButton = false;
        $scope.$parent.pageTitle = "All Designs";
        $scope.$parent.$parent.backParams = {};

        $scope.designs = [];
        $scope.selected = [];
        $scope.query = {
            search: '',
            limit: 25,
            page: 1
        };
        $scope.fetchError = '';
        $scope.promise = '';
        $scope.totalCount = 0;
        $scope.promise = '';
        $scope.editingMode = '';
        $scope.editingIndex = '';
        $scope.editingDesign = '';
        $scope.savingDesign = false;

        $scope.fetchDesigns = fetchDesigns;
        // $scope.showDialog = showDialog;
        $scope.saveDesign = saveDesign;
        $scope.openImage = openImage;
        $scope.removeDesign = removeDesign;
        $scope.startCase = Utils.startCase;

        function fetchDesigns() {
            $scope.fetchError = '';
            $scope.promise = Design.getAllDesigns($scope.query);

            $scope.promise
                .then(function (data) {
                    console.log(data.designs);
                    $scope.designs = data.designs.map(function (design) {
                        if (design.previewImageUrl) {
                            design.previewImage = {
                                urls: {
                                    medium: design.previewImageUrl,
                                    large: design.previewImageUrl.replace('medium', 'large'),
                                    thumbnail: design.previewImageUrl.replace('medium', 'thumbnail'),
                                    full: design.previewImageUrl.replace('-medium', ''),
                                }
                            };
                        }

                        if (design.tasks.length) {
                            var division = 100 / design.tasks.length;
                            design.progress = design.tasks.reduce(function (acc, task) {
                                return acc + (task.isComplete ? division : 0)
                            }, 0);
                            design.completedTasks = design.tasks.filter(function (task) {
                                return task.isComplete;
                            }).length;
                            design.totalTasks = design.tasks.length;
                        }
                        return design;
                    });
                    $scope.totalCount = data.total;
                })
                .catch(function (err) {
                    console.log(err);
                    $scope.fetchError = err;
                });
        }

        function removeDesign(design, index, ev) {
            CriticalUpdateConfirmation.showDialog({
                confirmText : 'Delete Design',
                targetEvent: ev,
                headerClass : 'md-warn',
                title: 'Are you sure?',
                description: 'Deleting the design will permanently remove it from the system. Are you sure you want to delete this design?',
                infoMessage: 'The design will no longer be available. Some linked entities might still refer to this design though. Please make sure that you understand what you are doing.',
                inputValidatorString: design.name
            })
                .then(function (result) {
                    if (result) {
                        return RestManager.deleteResource('/designs/' + design._id, 'designs', {service: 'scm'})
                    } else {
                        return null;
                    }
                })
                .then(function (result) {
                    if (result) {
                        $scope.fetchDesigns();
                        $mdToast.showSimple('Design deleted successfully');
                    }
                })
                .catch(function (err) {
                    if (err) {
                        $mdToast.showSimple('Error while deleting design: ' + err.message);
                        console.log('Error while deleting design: ', err);
                    }
                })
        }

        // function showDialog(ev, design, index) {
        //     $scope.editingDesign = {};
        //     if (design) {
        //         $scope.editingMode = true;
        //         $scope.editingIndex = index;
        //         angular.copy(design, $scope.editingDesign);
        //         if ($scope.editingDesign.owner && $scope.editingDesign.owner._id) {
        //             $scope.editingDesign.owner = $scope.editingDesign.owner._id;
        //         }
        //     } else {
        //         $scope.editingMode = false;
        //         $scope.editingIndex = '';
        //         $scope.editingDesign.designId = 'Will be auto-generated'
        //     }
        //
        //     $mdDialog.show({
        //         templateUrl: "addDesignDialog",
        //         scope: $scope,
        //         preserveScope: true,
        //         fullscreen: true,
        //         targetEvent: ev
        //     });
        // }

        function openImage(e, image) {
            e.stopPropagation();
            Images.openImageGallery(e, [image]);
        }

        function saveDesign() {
            $scope.savingDesign = true;
            var promise;
            if ($scope.editingMode) {
                promise = Design.editDesign($scope.editingDesign);
            } else {
                promise = Design.saveDesign($scope.editingDesign);
            }

            promise
                .then(function (design) {
                    $scope.savingDesign = false;
                    if ($scope.editingMode) {
                        $scope.designs.splice($scope.editingIndex, 1, design[0]);
                    } else {
                        $scope.designs.unshift(design[0]);
                    }
                    $mdDialog.hide();
                })
                .catch(function (err) {
                    $scope.savingDesign = false;
                    $mdToast.showSimple('Error saving collection : ', err.message);
                });
        }

        $scope.fetchDesigns();

    }

})(angular);

(function () {
    'use strict';
    addDesignController.$inject = ["$scope", "OptionsService", "Design", "$mdToast", "RestManager", "Users", "$state", "$stateParams"];
    angular.module('app.designs')
        .controller('addDesignController.controller', addDesignController);

    function addDesignController($scope, OptionsService, Design, $mdToast, RestManager, Users, $state,
                                 $stateParams) {
        $scope.$parent.nestedState = true;
        $scope.$parent.showActionButton = false;
        $scope.$parent.$parent.backParams = {};
        $scope.$parent.backState = $stateParams.backState || "app.design.all";

        $scope.designStatus = [
            {
                name: "Created",
                value: "created"
            },
            {
                name: "Enqueued",
                value: "enqueued"
            },
            {
                name: "Cutting",
                value: "cutting"
            },
            {
                name: "Embroidery",
                value: "embroidery"
            },
            {
                name: "Stitching",
                value: "stitching"
            },
            {
                name: "Sampling Complete",
                value: "samplingComplete"
            },
            {
                name: "Approved",
                value: "approved"
            },
            {
                name: "Rejected",
                value: "rejected"
            },
            {
                name: "Cancelled",
                value: "cancelled"
            }, {
                name: "On-Hold",
                value: "onHold"
            },
        ];
        $scope.design = {
            seasons: [],
            name: '',
            attributes: [],
            images: [],
            categories: [],
            quantity: 1,
        };
        $scope.savingDesign = false;
        $scope.editMode = false;
        $scope.attrInitDone = false;


        $scope.querySeasons = querySeasons;
        $scope.fetchAllCategories = fetchAllCategories;
        $scope.selectDesigner = selectDesigner;
        $scope.addAttribute = addAttribute;
        $scope.removeAttribute = removeAttribute;
        $scope.saveDesign = saveDesign;
        $scope.fetchAllAttributes = fetchAllAttributes;
        $scope.transformChip = transformChip;
        $scope.init = init;
        $scope.setAttribute = setAttribute;
        $scope.updatePreviewImage = updatePreviewImage;
        $scope.editDesign = editDesign;

        $scope.fetchAllCategories();
        $scope.fetchAllAttributes();

        function init() {
            if ($state.current.name === 'app.design.edit') {
                $scope.$parent.pageTitle = "Edit Design";
                $scope.$parent.showActionButton = true;
                $scope.$parent.actionButtonText = 'Add New Design';
                $scope.$parent.onActionButtonClick = function () {
                    $state.go('app.design.add');
                };

                $scope.editMode = true;
                Design.fetchDesignById($state.params.id)
                    .then(function (res) {
                        $scope.design = res[0];
                        $scope.design.seasons = [$scope.design.season];
                        if ($scope.attributes) {
                            $scope.design.attributes.forEach(function (a) {
                                $scope.setAttribute(a);
                            });
                            $scope.attrInitDone = true;
                        }
                    })
                    .catch(function (err) {
                        $mdToast.showSimple('Error in fetching design: ' + err.message);
                    });
            } else {
                $scope.$parent.pageTitle = "Add New Design";
            }
        }

        //Query Seasons function to suggests already exixting seasons to user
        function querySeasons(searchText) {
            return Design.getSeasonsSuggestions(searchText);
        }

        function transformChip(chip) {
            return chip;
        }


        function selectDesigner(event) {
            $scope.updatingDesigner = true;
            Users.selectUserDialog(event, {fields: 'name,mobile,role', roles: 'admin,designer', multiple: false})
                .then(function (user) {
                    if (user) {
                        $scope.updatingDesigner = false;
                        $scope.design.designer = user._id;
                        $scope.design.designerName = user.name;
                    } else {
                        throw new Error('No User Selected');
                    }
                })
                .catch(function (err) {
                    $scope.updatingDesigner = false;
                    $mdToast.showSimple('Error updating designer : ' + err.message);
                });
        }

        function fetchAllCategories() {
            RestManager.getResource('/categories/all', 'categories')
                .then(function (response) {
                    $scope.categories = response;
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error in fetching all categories: ' + err.message);
                });
        }

        function addAttribute() {
            $scope.design.attributes.unshift({attribute: {}});
        }

        function removeAttribute(index) {
            $scope.design.attributes.splice(index, 1);
        }

        function fetchAllAttributes() {
            RestManager.getResource("/attributes", "attributes")
                .then(function (attributes) {
                    $scope.attributes = attributes;
                    $scope.loadingAttributes = false;
                    if ($scope.design && $scope.design.attributes && !$scope.attrInitDone) {
                        $scope.design.attributes.forEach(function (a) {
                            $scope.setAttribute(a);
                        });
                    }
                })
                .catch(function (err) {
                    console.log(err, "Err");
                });

        }

        function saveDesign() {
            $scope.savingDesign = true;
            $scope.design.season = $scope.design.seasons[0];
            delete $scope.design.seasons;
            $scope.design.images = $scope.design.images.map(function (i) {
                return i._id;
            });
            $scope.design.attributes = $scope.design.attributes.map(function (a) {
                console.log("add.design.controller.js", "A", a);
                return {
                    attributeId: a.attributeId,
                    selectedValue: a.selectedValue,
                    selectedValues: a.selectedValues
                };
            });
            console.log("add.design.controller.js", "saveDesign", $scope.design);
            Design.saveDesign($scope.design)
                .then(function (res) {
                    $scope.savingDesign = false;
                    $scope.design = res[0];
                    $scope.design.seasons = [$scope.design.season];
                    $state.go('app.design.details', {id: res[0]._id}, {
                        location: 'replace',
                        reload: false,
                        notify: false
                    });
                    $scope.editMode = true;
                    $scope.design.attributes.forEach(function (a) {
                        $scope.setAttribute(a);
                    });

                })
                .catch(function (err) {
                    $scope.savingDesign = false;
                    $mdToast.showSimple('Error in saving design: ' + err.message);
                });
        }

        function editDesign() {
            $scope.savingDesign = true;
            var newDesign = {};
            angular.copy($scope.design, newDesign);
            Design.editDesignById(newDesign)
                .then(function (response) {
                    $scope.savingDesign = false;
                    $scope.design = response[0];
                })
                .catch(function (err) {
                    $scope.savingDesign = false;
                    $mdToast.showSimple('Error in updating the design : ' + err.message);
                });
        }


        function setAttribute(attributeData) {
            var attributeIndex = _.findIndex($scope.attributes, function (a) {
                return a._id === attributeData.attributeId;
            });
            if (attributeIndex !== -1) {
                attributeData.attribute = $scope.attributes[attributeIndex];
            }
        }

        function updatePreviewImage(data) {
            console.log('ev', data);
            $scope.design.previewImageUrl = data.updated.urls.medium;
        }

        $scope.init();
    }


})(angular);

/**
 * Created by kumardivyarajat on 04/12/16.
 */
angular.module("app.products")
    .controller("products.trash.controller", ["$scope", "$state", "$mdDialog", "$mdToast", "$stateParams", "RestManager", "$log", "$timeout", function ($scope, $state, $mdDialog, $mdToast, $stateParams, RestManager, $log, $timeout) {

        $scope.$parent.pageTitle = "Trash";
        $scope.$parent.nestedState = false;
        $scope.$parent.showActionButton = false;

        $scope.selected = [];
        $scope.query = {
            order: '-updatedAt',
            limit: 25,
            page: 1,
            searchTerm: ""
        };

        if ($stateParams.page) {
            $scope.query.page = $stateParams.page;
        }

        if ($stateParams.limit) {
            $scope.query.limit = $stateParams.limit;
        }

        if ($stateParams.order) {
            $scope.query.order = $stateParams.order;
        }

        if ($stateParams.searchTerm) {
            $scope.query.searchTerm = $stateParams.searchTerm;
        }


        $scope.getProducts = function () {
            var url = "/products/admin/trash";
            $scope.promise = RestManager.postResource(url, $scope.query, "products", ["total"]);

            $scope.promise
                .then(function (result) {
                    $scope.products = result.products;
                    $scope.total = result.total;
                })
                .catch(function (err) {
                    console.log(err);
                })
        };

        $scope.getProducts();


        $scope.getLowestPrice = function (product) {
            switch (product.productType) {
                case 0:
                    var lowestPrice = 0;
                    _.forEach(product.variations, function (variation, i) {
                        var comparePrice = variation.stockAndPrice.price.salePrice ? variation.stockAndPrice.price.salePrice : variation.stockAndPrice.price.mrp;
                        if (lowestPrice > comparePrice) {
                            lowestPrice = i;
                        }
                    });
                    return product.variations[lowestPrice].stockAndPrice.price;

                case 1:
                    return product.customisation.basePrice;
                    break;
            }
        };

        $scope.changeState = function () {
            $state.go("app.products.trash", {
                    page: $scope.query.page,
                    limit: $scope.query.limit,
                    order: $scope.query.order,
                    searchTerms: $scope.query.searchTerm
                },
                {notify: false, reload: false})
        };


        $scope.restoreProduct = function (product, index, event) {
            var confirm = $mdDialog.confirm()
                .title('Do you want to restore ' + product.name + ' from trash ? ')
                .ariaLabel('restore trash')
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm)
                .then(function () {
                    $scope._restoreFromTrash(product, index);
                }, function () {
                    $mdToast.showSimple("Cancelled the action");
                });
        };

        $scope._restoreFromTrash = function (product, index) {
            $scope.promise = RestManager.putResource("/products/restore/" + product._id, {}, "products")
                .then(function (data) {
                    console.log(data);
                    $scope.products.splice(index, 1);
                    $mdToast.showSimple("Successfully restored product from trash ");
                })
                .catch(function (err) {
                    console.log(err);
                })
        };


        $scope.getProductType = function (product) {
            switch (product.productType) {
                case 0:
                    return "Simple";

                case 1:
                    return "Customizable";
            }
        }
    }]);

/**
 * Created by kumardivyarajat on 04/12/16.
 */
angular.module("app.products")
    .controller("products.tags.controller", ["$scope", function ($scope) {

    }]);
/**
 * Created by kumardivyarajat on 09/01/17.
 */
angular.module("app.products")
    .controller("products.sizeCharts.controller", ["$scope", "RestManager", "Utils", "$mdToast", "$mdDialog", function ($scope, RestManager, Utils, $mdToast, $mdDialog) {
        $scope.$parent.nestedState = false;
        $scope.$parent.backState = "app.home";
        $scope.$parent.showActionButton = true;
        $scope.$parent.pageTitle = "Size Chart";
        $scope.$parent.actionButtonText = "Save Size Chart";
        $scope.$parent.onActionButtonClick = saveSizeChart;

        var key = "size_charts";
        $scope.sizeCharts = [];
        $scope.editing = true;
        $scope.selectedIndex = 0;

        $scope.initSizeChart = initSizeChart;
        $scope.update = update;
        $scope.deleteColumn = deleteColumn;
        $scope.deleteRow = deleteRow;
        $scope.fetchSizeCharts = fetchSizeCharts;


        function initSizeChart() {

            var chart = [
                {
                    key: "BUST",
                    values: []
                },
                {
                    key: "HIP",
                    values: []
                },
                {
                    key: "SHOULDER",
                    values: []
                },

                {
                    key: "WAIST",
                    values: []
                },
                {
                    key: "FULL LENGTH",
                    values: []
                }
            ];

            chart = chart.map(function (sizeChart) {
                $scope.sizes.forEach(function (size) {
                    sizeChart.values.push({
                        key: size,
                        value: 0
                    })
                });
                return sizeChart;
            });
            $scope.editing = false;

            return {name: "", charts: chart};
        }

        function deleteColumn(size) {
            var index = _.findIndex($scope.selectedChart.values.charts, function (measurement) {
                return measurement.key === size.key;
            });
            if (index !== -1) {
                $scope.selectedChart.values.charts.splice(index, 1);
            }
        }

        function deleteRow(val, index) {
            console.log('Row', val, index);
            $scope.selectedChart.values.charts.map(function (measurement) {
                console.log('M', measurement);
                measurement.values = measurement.values.filter(function (size) {
                    return size.key !== val.key;
                });
                return measurement;
            })
        }

        function update(index) {
            var value = $scope.selectedChart.values.charts[0].values[index].key;
            console.log('Value', value);
            $scope.selectedChart.values.charts.forEach(function (chart) {
                chart.values[index].key = value;
            });
            console.log('slected', $scope.selectedChart);
        }

        $scope.findValue = function (size, index, parent, key) {
            try {
                return size.values[parent].value ? size.values[parent].value : 0;
            } catch (err) {
                return 0;
            }
        };

        $scope.show = function (size) {
            console.log(size);
        };


        function fetchSizeCharts() {
            $scope.promise = RestManager.getResource("/settings/size_charts", key)
                .then(function (data) {
                    console.log('da', data);
                    data = data.map(function (sizeChart) {
                        sizeChart.values = sizeChart.values.values;
                        return sizeChart;
                    });
                    $scope.sizeCharts = data;
                    if (data[0]) {
                        $scope.selectChart($scope.selectedIndex);
                    }
                    return $scope.getAttributes();
                })
                .then(function (attributes) {
                    console.log(attributes);
                    $scope.sizes = _.sortBy(attributes[0].meta_values.map(function (val) {
                        return val.value;
                    }), function (o) {
                        return Utils.getSizePriority[_.toUpper(o)];
                    });

                    // if (!$scope.sizeCharts.length > 0) {
                    //     $scope.initSizeChart();
                    // }
                })
                .catch(function (err) {
                    console.log(err);
                });
        }


        $scope.getAttributes = function () {
            return RestManager.getResource("/attributes/search/size", "attributes")
        };

        $scope.selectChart = function (index) {
            $scope.selectedIndex = index;
            $scope.selectedChart = $scope.sizeCharts[index];
        };

        $scope.addSizeChart = function (ev) {
            $scope.showNameDialog(ev, '')
                .then(function (result) {
                    var a = $scope.initSizeChart();
                    a.name = result;
                    $scope.sizeCharts.push({values: a});
                    $scope.selectedChart = $scope.sizeCharts[$scope.sizeCharts.length - 1];
                    console.log(a, $scope.sizeCharts);
                }, function () {
                    $mdToast.showSimple("Dismissed");
                });
        };

        $scope.editName = function (index, event) {
            $scope.showNameDialog(event, $scope.sizeCharts[index].values.name)
                .then(function (result) {
                    $scope.sizeCharts[index].values.name = result;
                }, function () {
                    $mdToast.showSimple("Dismissed");
                });
        };


        $scope.showNameDialog = function (ev, value) {
            var confirm = $mdDialog.prompt()
                .title('What would you name the size chart?')
                .textContent('Use a name like Kurti, Dress, Palazzo, etc.')
                .placeholder('Size Chart Name')
                .ariaLabel('Size Chart Name')
                .initialValue(value)
                .targetEvent(ev)
                .ok('Done')
                .cancel('Cancel');

            return $mdDialog.show(confirm);
        };

        $scope.deleteSizeChart = function (index, event) {
            $scope.deletingSizeChart = true;
            RestManager.deleteResource("/settings/size_charts/" + $scope.sizeCharts[index]._id, "settings")
                .then(function () {
                    $scope.deletingSizeChart = false;
                    $scope.sizeCharts.splice(index, 1);
                })
                .catch(function (err) {
                    console.log(err);
                });
            event.stopPropagation();
        };


        $scope.addColumn = function (index) {
            var value = {
                key: "SIZE HERE",
                values: _.map($scope.selectedChart.values.charts[0].values, function (o) {
                    o.value = 0;
                    return o;
                })
            };
            if(typeof index !== 'undefined') {
                $scope.selectedChart.values.charts.splice(index + 1, null, value);
            } else {
                $scope.selectedChart.values.charts.push(value);
            }
            console.log('Add Column', $scope.selectedChart);
        };

        $scope.addRow = function () {
            var end = $scope.sizeCharts.length;
            // $scope.sizeCharts[end] = {
            //     key: "",
            //     values: []
            // };
            console.log('$scope.sizes', $scope.sizes, $scope.selectedChart.values.charts)
            $scope.selectedChart.values.charts.forEach(function (measurement) {
                console.log('Me', measurement);
                measurement.values.push({
                    key: 'SIZE_HERE',
                    value: 0
                })
            })
        };


        function saveSizeChart() {
            var promise;
            if ($scope.editing) {
                promise = RestManager.putResource("/settings/size_charts", {
                    id: $scope.selectedChart._id,
                    key: key,
                    values: $scope.selectedChart
                }, key);
            } else {
                promise = RestManager.postResource("/settings/size_charts", {
                        key: key,
                        values: $scope.selectedChart
                    },
                    key);
            }
            $scope.$parent.actionButtonDisabled = promise;
            promise.then(function (data) {
                $scope.fetchSizeCharts();
                $mdToast.showSimple("Successfully saved size chart")
            })
                .catch(function (err) {
                    console.log(err);
                });
        }

        $scope.fetchSizeCharts();


    }]);

/**
 * Created by kumardivyarajat on 23/02/17.
 */
angular.module("app.products")
    .controller("products.models.controller", ["$scope", "RestManager", "Utils", "$mdToast", "$mdDialog", function ($scope, RestManager, Utils, $mdToast, $mdDialog) {
        $scope.$parent.nestedState = false;
        $scope.$parent.backState = "app.home";
        $scope.$parent.showActionButton = true;
        $scope.$parent.pageTitle = "Models";
        $scope.$parent.actionButtonText = "Save Model";
        $scope.$parent.onActionButtonClick = saveModel;

        var key = "models";


        function addNewModel() {
            $scope.models.push();
        }

        function saveModel() {
            $scope.savingModel = true;
        }


        function Model() {
            this.name = "";
            this.size = [];
            this.mobile = "";
            this.email = "";
            this.profileImage = "";
        }

    }]);
/**
 * Created by kumardivyarajat on 21/05/17.
 */

(function () {
    "use strict";
    ImportController.$inject = ["$scope", "$mdToast", "RestManager", "ProductUtils"];
    angular.module("app.products")
        .controller("products.import.controller", ImportController);

    function ImportController($scope, $mdToast, RestManager, ProductUtils) {
        $scope.$parent.pageTitle = "Import Products";
        $scope.hasFile = false;
        $scope.myLimit = 25;
        $scope.myPage = 1;
        $scope.importing = false;
        var promises;
        $scope.processed = 0;
        var rABS = true; // true: readAsBinaryString ; false: readAsArrayBuffer

        // Functions
        $scope.import = importFn;
        $scope.removeFiles = removeFiles;

        $scope.$watch('file', watchFiles);


        function watchFiles(files) {
            if (files) {
                $scope.hasFile = true;
                handleDrop();
                console.log(files);
            }
        }

        function removeFiles($index) {
            $scope.file = "";
            $scope.hasFile = false;
            $scope.jsonData = "";
            $scope.status = "";
        }


        function importFn() {
            $scope.localErrors = [];
            $scope.serverErrors = [];
            $scope.processed = 0;
            $scope.duplicates = [];
            $scope.importing = true;
            // $scope.status = "Importing..";
            var startTime = new Date();
            console.time("Saving");
            promises = Promise.mapSeries($scope.jsonData, function (data) {
                data.completed = false;
                if (!data.sku || !data.name) {
                    $scope.localErrors.push(data);
                    $scope.processed++;
                    data.completed = false;
                    data.error = "Error";
                    updatePercent();
                    return "";
                } else {
                    return new Promise(function (resolve, reject) {
                        var promise;
                        if (data._id) {
                            promise = RestManager.getResource("/products/admin/" + data._id, "products")
                        } else if (data.sku) {
                            promise = RestManager.getResource("/products/admin/sku/" + data.sku, "products")
                        }
                        promise.then(function (products) {
                            // var a = {};
                            // angular.copy(data,a);
                            return buildData(products, data);
                        })
                            .then(function (result) {
                                data.completed = true;
                                $scope.processed++;
                                updatePercent();
                                resolve(result);
                            })
                            .catch(function (err) {
                                data.completed = false;
                                console.log(err);
                                $scope.processed++;
                                updatePercent();
                                $scope.serverErrors.push({data: data, err: err});
                                resolve({});
                            });
                    });
                }
            }, {concurrency: 10})
                .then(function (result) {
                    console.time("Saving");
                    $scope.imported = true;
                    $scope.importing = false;
                    // $scope.status = "Import Complete";
                    console.log("LocalErrors", $scope.localErrors);
                    console.log("Server Errors", $scope.serverErrors);
                    console.log("Finally", result);
                    var endTime = new Date();
                    $scope.time = (endTime - startTime) / 1000;
                    $scope.$apply();
                });
        }

        function buildData(products, data) {
            return new Promise(function (resolve, reject) {
                var productPromise, product = {}, isNew;
                if (products) {
                    product = products[0];
                    isNew = false;
                } else {
                    angular.copy(data, product);
                    isNew = true;
                }
                // console.log("Data", data);
                if (typeof product.visibility === "undefined") {
                    product.visibility = 3;
                }
                if (typeof product.productType === "undefined") {
                    product.productType = 0;
                }
                product.comingSoon = true;
                product.isFeatured = false;
                product.outOfStock = false;
                product.published = false;
                product = generateAttributes(product, data);
                product = ProductUtils.generateVariations(product, false);
                product.variations = product.variations.map(function (o) {
                    if (!o.stockAndPrice) {
                        o.stockAndPrice = {};
                    }
                    o.stockAndPrice.price = {
                        salePrice: parseInt(data.salePrice) || 0,
                        mrp: parseInt(data.mrp) || 0,
                        productionCost: parseInt(data.productionCost) || 0,
                        msp: parseInt(data.msp) || 0,
                        fabricCost: parseInt(data.fabricCost) || 0,
                        photoShoot: parseInt(data.photoShoot) || 0,
                        stitching: parseInt(data.stitching) || 0,
                        designing: parseInt(data.designing) || 0
                    };
                    o.modified = true;
                    return o;
                });
                console.log('[products.import.controller.js : 140]', 'product', product.name, product);

                addImages(product, data)
                    .then(function (a) {
                        console.log('[products.import.controller.js : 177]', 'product', a);
                        if (!isNew) {
                            productPromise = RestManager.putResource("/products/" + a._id, a, "products");
                        } else {
                            productPromise = RestManager.postResource("/products", a, "products");
                        }
                        return productPromise;
                    })
                    .then(function (result) {
                        console.log('[products.import.controller.js : 182]', product.name + ' done', result);
                        resolve(result);
                    })
                    .catch(function (err) {
                        console.log('[products.import.controller.js : 191]', 'error', product.name, err);
                        reject(err);
                    })

            })
        }

        var sevenDaysBack = moment().subtract(7, "days");

        function addImages(product, data) {
            console.log('[products.import.controller.js : 190]', 'addImages', "Starting images promise", product.name);
            return new Promise(function (resolve, reject) {
                if ((!product.gallery || product.gallery.length === 0) && data.images) {
                    var images = data.images.match(/\b\d{3,4}\b/g);
                    images = images.map(function (image) {
                        return image.length === 3 ? "2" + image : image;
                    });
                    console.log('[products.import.controller.js : 207]', 'images', images);
                    Promise.map(images, function (image) {
                        return new Promise(function (resolve, reject) {
                            RestManager.getResource("/images/search/" + image, "images")
                                .then(function (result) {
                                    // console.log('[products.import.controller.js : 193]', 'result', result);
                                    result = _.filter(result, function (o) {
                                        return moment(o.createdAt).isSameOrAfter(sevenDaysBack, "day");
                                    });
                                    // console.log('[products.import.controller.js : 194]', 'result', result);
                                    resolve(result[0]);
                                })
                                .catch(function (err) {
                                    reject(err);
                                })
                        });
                    })
                        .then(function (results) {
                            product.gallery = results.filter(function (o) {
                                return !!o;
                            });
                            console.log('[products.import.controller.js : 228]', 'product.gallery', product.gallery);
                            product.gallery = product.gallery.map(function (o) {
                                return o._id;
                            });
                            if (product.gallery.length) {
                                product.featured_image = product.gallery[0];
                            }
                            console.log('[products.import.controller.js : 217]', 'Resolving images Promise', product);
                            resolve(product);
                        })
                        .catch(function (err) {
                            console.error("Error  - > " + '[' + product.name + ']' + err)
                        })
                } else {
                    resolve(product);
                }
            });
        }

        function generateAttributes(product, data) {
            if (data.sizes && $scope.sizeAttribute && doesNotHaveSizeAttribute(product)) {
                var sizes = data.sizes.match(/\b\w+\b/g);
                if (!product.attributes) {
                    product.attributes = [];
                }
                product.attributes.push({
                    attribute: $scope.sizeAttribute._id,
                    selectedValues: findSizes(sizes),
                    applyFilters: true,
                    visible: true,
                    featured: true,
                    isVariation: true
                });
            }
            return product;

        }

        function doesNotHaveSizeAttribute(product) {
            if (!product.attributes) {
                return true;
            }
            if (product.attributes.length) {
                return !_.find(product.attributes, function (o) {
                    return o.attribute === $scope.sizeAttribute._id;
                })
            }
            return true;
        }

        function findSizes(sizes) {
            var retData = [];
            sizes.forEach(function (size) {
                var a = _.find($scope.sizeAttribute.meta_values, function (o) {
                    return o.value === size;
                });
                console.log('[products.import.controller.js : 249]', 'size', a);
                if (a) {
                    retData.push(a._id);
                }
            });
            return retData;
        }


        function getAttributes() {
            RestManager.getResource("/attributes", "attributes")
                .then(function (attributes) {
                    $scope.sizeAttribute = _.find(attributes, {'meta_key': 'Size'});
                    console.log('[products.import.controller.js : 173]', 'getAttributes', attributes, $scope.sizeAttribute);
                })
                .catch(function (err) {
                    console.log(err, "Err");
                })
        }

        // Fetch the attributes before hand.
        getAttributes();


        function updatePercent() {
            $scope.percent = parseInt(($scope.processed / $scope.jsonData.length) * 100);
        }


        function fixdata(data) {
            var o = "", l = 0, w = 10240;
            for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
            o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
            return o;
        }

        /* set up drag-and-drop event */
        function handleDrop() {
            // e.stopPropagation();
            // e.preventDefault();
            $mdToast.show({
                template: '<md-toast>' +
                '<div class="md-toast-content" layout layout-align="center center">' +
                '<md-progress-circular md-diameter="20" class="md-warn"></md-progress-circular>' +
                '<span class="md-caption" style="margin-left: 20px;">Reading File</span>' +
                '</div>' +
                '</md-toast>',
                hideDelay: 3000,
                position: 'bottom right'
            });
            $scope.status = "Reading File..";
            var files = [$scope.file];
            var i, f;
            for (i = 0; i != files.length; ++i) {
                f = files[i];
                var reader = new FileReader();
                var name = f.name;
                reader.onload = function (e) {
                    var data = e.target.result;

                    var workbook;
                    if (rABS) {
                        /* if binary string, read with type 'binary' */
                        workbook = XLSX.read(data, {type: 'binary'});
                    } else {
                        /* if array buffer, convert to base64 */
                        var arr = fixdata(data);
                        workbook = XLSX.read(btoa(arr), {type: 'base64'});
                    }
                    /* DO SOMETHING WITH workbook HERE */
                    for (var sheetName in workbook.Sheets) {
                        $scope.jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
                        console.log(sheetName, $scope.jsonData);
                    }
                    $scope.status = "Ready";
                    $mdToast.hide();
                };
                if (rABS) reader.readAsBinaryString(f);
                else reader.readAsArrayBuffer(f);
            }
        }

        $scope.$on('$destroy', DestroyCtrl);


        function DestroyCtrl(event) {
            if ($scope.importing) {
                var answer = confirm("Import is running. The process will be cancelled if you leave the page. Are you sure you want to leave this page?");
                if (!answer) {
                    event.preventDefault();
                } else {
                    promises.cancel();
                }
            }
        }

    }

})(angular);

/**
 * Created by kumardivyarajat on 04/12/16.
 */
angular.module("app.products")
    .controller("products.categories.controller", ["$scope", "$log", "RestManager", "$mdDialog", "$mdToast", function ($scope, $log, RestManager, $mdDialog, $mdToast) {
        $scope.$parent.nestedState = false;
        $scope.$parent.backState = "app.home";
        $scope.$parent.showActionButton = false;
        $scope.$parent.pageTitle = "Categories";
        $log.info("Calling for brothers from Categories page.");


        $scope.newCategory = '';
        $scope.editingMode = '';
        $scope.editingIndex = '';
        $scope.a = '';
        $scope.categories = '';
        $scope.promise = '';
        $scope.selectedParent = '';
        $scope.selectedIndex = '';
        $scope.parentCategories = [];
        $scope.loading = false;

        $scope.fetchCategories = fetchCategories;
        $scope.editCategory = editCategory;
        $scope.addNewCategory = addNewCategory;
        $scope.openUploader = openUploader;
        $scope.saveCategory = saveCategory;
        $scope.removeCategory = removeCategory;
        $scope.getParentCategoryName = getParentCategoryName;
        $scope.reOrder = reOrder;
        $scope.selectParent = selectParent;
        $scope.restore = restore;
        $scope.onDrop = onDrop;
        $scope.addSubcategory = addSubcategory;

        function editCategory(category, index, event) {
            $scope.newCategory = category;
            $scope.editingMode = true;
            $scope.editingIndex = index;
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                scope: $scope,
                fullscreen : true,
                preserveScope: true,
                contentElement: "#editCategoryDialog"
            });

            event.stopPropagation();
        };

        function addNewCategory(event) {
            $scope.newCategory = {};
            $scope.editingMode = false;
            $scope.categoryForm.$setPristine();
            $scope.editingIndex = "";
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                scope: $scope,
                fullscreen : true,
                preserveScope: true,
                contentElement: "#editCategoryDialog"
            });
        };

        function addSubcategory(category) {
            $scope.newCategory = {
                parent: category._id
            };
            $scope.editingMode = false;
            $scope.categoryForm.$setPristine();
            $scope.editingIndex = "";
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                scope: $scope,
                fullscreen : true,
                preserveScope: true,
                contentElement: "#editCategoryDialog"
            });
        }

        function openUploader(select, ev, isImage) {
            $mdDialog.show({
                locals: {
                    multipleSelect: false,
                    select: select,
                    options : null
                },
                controller: "upload.controller",
                templateUrl: 'app/modules/base/partials/uploader.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                fullscreen : true,
                clickOutsideToClose: true
            })
                .then(function (images) {
                    if (isImage) {
                        $scope.newCategory.image = images[0];
                    } else {
                        if (!$scope.newCategory.svg)
                            $scope.newCategory.svg = {};
                        $scope.newCategory.svg.normal = images[0];
                    }
                }, function () {
                    $scope.status = 'You cancelled the dialog.';
                });

        };

        function saveCategory(index) {
            var newCategory = {};
            angular.copy($scope.newCategory, newCategory);

            // if (newCategory.parent) {
            //     newCategory.parent = newCategory.parent._id;
            // }

            delete newCategory.children;

            if (newCategory.image) {
                newCategory.image = newCategory.image._id;
            }

            if (newCategory.svg && newCategory.svg.normal) {
                newCategory.svg.normal = newCategory.svg.normal._id;
            }

            if (newCategory.headerImage) {
                newCategory.headerImage = newCategory.headerImage._id;
            }

            console.log(newCategory);


            if ($scope.editingMode) {
                $scope.promise = RestManager.putResource("/categories/" + newCategory._id, newCategory, "categories");
            } else {
                $scope.promise = RestManager.postResource("/categories", newCategory, "categories");
            }

            $scope.promise
                .then(function (categories) {
                    // if ($scope.editingMode) {
                    //     $scope.categories.splice($scope.editingIndex, 1, categories[0]);
                    //     $mdToast.show($mdToast.simple().textContent("Successfully edited category"));
                    // } else {
                    //     $scope.categories.unshift(categories[0]);
                    //     $mdToast.show($mdToast.simple().textContent("Successfully created new category"));
                    // }
                    // $scope.reOrder($scope.categories);

                    $scope.fetchCategories();

                    $scope.cancel();
                })
                .catch(function (err) {
                    $log.error(err);
                    $mdToast.show($mdToast.simple().textContent("Error while saving category"));
                })
        };

        function removeCategory(category, index, event) {

            var confirm = $mdDialog.confirm()
                .title('Would you like to delete the category?')
                .textContent('Note that this action is irreversible and may cause unexpected behaviour.')
                .ariaLabel('Lucky day')
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                RestManager.deleteResource("/categories/" + category._id, "categories")
                    .then(function (result) {
                        console.log(result);
                        var index = _.findIndex($scope.categories, function (o) {
                            return o._id === category._id;
                        });
                        $scope.categories.splice(index, 1);
                        $scope.reOrder($scope.categories);
                        $mdToast.show($mdToast.simple().textContent("Successfully deleted category"));
                    })
                    .catch(function (err) {
                        $mdToast.show($mdToast.simple().textContent("Error while deleting category." + err.message));
                    })
            }, function () {
                console.log("Cancelled");
            });
        }


        function getParentCategoryName(categoryId) {
            return _.find($scope.parentCategories, function (o) {
                return o._id === categoryId;
            });
        }

        function reOrder(categories) {

            $scope.parentCategories = _.sortBy(categories
                .filter(function (category) {
                    return !category.parent || (category.parent && category.parent === category._id)
                })
                .map(function (category) {
                    category.children = categories.filter(function (c) {
                        return c.parent === category._id;
                    })
                    return category;
                }),
                function (category) {
                    return category.name;
                })

            console.log('Parent Categories', $scope.parentCategories);

        }


        function fetchCategories() {
            $scope.loading = true;
            $scope.promise = RestManager.getResource("/categories", "categories")
            $scope.promise
                .then(function (categories) {
                    $scope.categories = categories;

                    $scope.reOrder($scope.categories);
                    $log.info(categories, $scope.parentCategories);
                    $scope.loading = false;
                })
                .catch(function (err) {
                    $log.error(err);
                    $scope.loading = false;
                })
        }


        function selectParent(category, index) {
            $scope.restore();
            category.selected = true;
            $scope.selectedParent = category;
            $scope.selectedIndex = index;
        }

        function restore() {
            $scope.parentCategories = _.map($scope.parentCategories, function (cat) {
                cat.selected = false;
                return cat;
            });
            // $scope.parentCategories[$scope.selectedIndex] = false;
            $scope.selectedParent = '';
        }

        function onDrop(list, item, index) {
            console.log('On Drop', list, item, index);
        }

        $scope.fetchCategories();
    }]);

/**
 * Created by kumardivyarajat on 04/12/16.
 */
angular.module("app.products")
    .controller("products.attributes.controller", ["$scope", "$mdDialog", "RestManager", "$mdToast", "CriticalUpdateConfirmation", function ($scope, $mdDialog, RestManager, $mdToast,
                                                            CriticalUpdateConfirmation) {
        $scope.$parent.nestedState = false;
        $scope.$parent.backState = "app.home";
        $scope.$parent.showActionButton = false;
        $scope.$parent.pageTitle = "Attributes";
        $scope.plainAttributes = [];
        $scope.selected = [];
        $scope.loadingPlainAttrs = false;
        $scope.searchAttributeText = '';

        $scope.query = {
            limit: 25,
            page: 1,
            order: 'meta_key',
            search: ""
        };

        $scope.vendors = ['Flipkart', 'Amazon', 'Paytm', 'Graftale', 'Ecommdesk', 'Myntra', 'Jabong'];

        $scope.openDeleteConfirmDialog = openDeleteConfirmDialog;
        $scope.deleteAttribute = deleteAttribute;

        function deleteAttribute(attribute, index) {
            RestManager.deleteResource('/attributes/' + attribute._id, 'attributes')
                .then(function (result) {
                    $scope.attributes.splice(index, 1);
                    $mdToast.showSimple('Deleted Attribute ' + attribute.meta_key + ' successfully.');
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error deleting attribute : ' + err.message);
                })
        }

        function openDeleteConfirmDialog(ev, attribute, index) {
            ev.stopPropagation();
            attribute.deleteLoading = true;
            RestManager.postResource('/products/admin/preview', {
                actionType: "count",
                queries: [{
                    enabled: true,
                    entity: "attributes.attribute",
                    operand: "$eq",
                    valType: "String",
                    value: attribute._id
                }]
            }, 'preview', {extras: ['total']})
                .then(function (data) {
                    attribute.deleteLoading = false;
                    if (data && typeof data.total !== 'undefined') {
                        return CriticalUpdateConfirmation.showDialog({
                            targetEvent: ev,
                            title: 'Delete Attribute ' + attribute.meta_key,
                            description: 'Do you want to delete the attribute ' + attribute.meta_key + '? It has ' + attribute.meta_values.length + ' values being used in ' +
                                data.total + ' products.',
                            infoMessage: data.total + ' Products containing this attribute might stop working.',
                            inputValidatorString: attribute.meta_key,
                            confirmText : 'Delete Attribute'
                        })
                    } else {
                        throw new Error('Unable to fetch product count for attribute. Please try later.');
                    }
                })
                .then(function (result) {
                    if (result) {
                        $scope.deleteAttribute(attribute, index);
                    }
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error deleting attribute : ' + err.message);

                })
        }

        $scope.pasteMultipleItems = function (meta_value, index) {
            setTimeout(function () {
                if (meta_value.value) {
                    var values = meta_value.value.split('\n').map(function (val) {
                        return {value: val};
                    });
                    if (values && values.length > 1) {
                        values.forEach(function (value, i) {
                            $scope.newattribute.meta_values.splice(index + i, 1, value);
                        });
                    }
                    $scope.removeDuplicates();
                }
            }, 0);
        };

        $scope.removeDuplicates = function () {
            var beforeLength = $scope.newattribute.meta_values.length;
            $scope.newattribute.meta_values = _.uniqBy($scope.newattribute.meta_values, function (value) {
                return value.value;
            });
            var afterLength = $scope.newattribute.meta_values.length;
            if (beforeLength !== afterLength) {
                $mdToast.showSimple('Removed duplicate values');
            }
        };
        $scope.askDeleteImagesQuestion = function (event) {
            if (!$scope.newattribute.allowImages) {
                $mdDialog.show($mdDialog.confirm()
                    .targetEvent(event)
                    .multiple(true)
                    .title('Delete Images')
                    .textContent('The setting has changed to disallow Images in the attributes. Do you want to delete the contained images for the values as well?')
                    .ok('Yes. Remove Images')
                    .cancel('No. I`ll keep them.')
                )
                    .then(function (result) {
                        if (result) {
                            $scope.newattribute.meta_values = $scope.newattribute.meta_values.map(function (valueMap) {
                                delete valueMap.image;
                                return valueMap;
                            })
                        }
                    })
                    .catch(function (err) {
                        console.log('err', err);
                    })
            }
        };

        $scope.changeOtherSettings = function () {
            if ($scope.newattribute.isScopedForVendor) {
                $scope.newattribute.showInProductsPage = false;
                $scope.newattribute.showAbovePriceBox = false;
                $scope.newattribute.supportFilters = false;
            }
            $scope.changeAttributeName();
        };

        $scope.changeAttributeName = function () {
            if ($scope.newattribute.vendorName) {
                var names = $scope.newattribute.meta_key.split('::');
                $scope.newattribute.meta_key = names.length === 1 ? names[0] : names[1];
                if ($scope.newattribute.isScopedForVendor) {
                    $scope.newattribute.meta_key = $scope.newattribute.vendorName + '::' + $scope.newattribute.meta_key;
                }
            }
        };

        $scope.showDialog = function (event, attribute, index) {
            $scope.newattribute = {
                meta_values: []
            };
            if (attribute) {
                angular.copy(attribute, $scope.newattribute);
                $scope.editingMode = true;
                $scope.currIndex = index;
            } else {
                $scope.editingMode = false;
            }

            if ($scope.newattribute.meta_values.length === 0) {
                $scope.newattribute.meta_values.push({value: ''})
            }

            if (!$scope.newattribute.delimeter) {
                $scope.newattribute.delimeter = ',';
            }

            $scope.newattribute.allowImages = _.some($scope.newattribute.meta_values, function (value) {
                return value.image;
            });

            $scope.searchAttributeText = '';
            $scope.getAllAttributesPlain();

            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                scope: $scope,
                fullscreen : true,
                preserveScope: true,
                contentElement: "#addNewAttributeDialog",
                onComplete: afterShowAnimation
            });


            function afterShowAnimation(scope, element, options) {
                // post-show code here: DOM element focus, etc.

                console.log(scope, element, options);
            }

            event.stopPropagation();
        };

        $scope.cancel = function () {
            $mdDialog.hide();
        };

        $scope.getOption = function (numberString) {
            return parseInt(numberString);
        };

        $scope.saveattribute = function () {
            $scope.removeDuplicates();
            $scope.saving = true;
            console.log("products.attributes.controller.js", "saveattribute", $scope.newattribute);
            var promise;
            var payload = {};
            angular.copy($scope.newattribute, payload);
            payload.meta_values = _.chain(payload.meta_values)
                .sortBy(function (meta_value) {
                    return meta_value.value;
                })
                .map(function (meta_value) {
                    if (!meta_value.linkedAttribute) {
                        delete meta_value.linkedAttribute;
                    }

                    if (!meta_value.linkedValue) {
                        delete meta_value.linkedValue;
                    }
                    return meta_value;
                })
                .value();
            if ($scope.editingMode) {
                promise = RestManager.putResource("/attributes/" + $scope.newattribute._id, payload, "attributes")
            } else {
                promise = RestManager.postResource("/attributes/create", payload, "attributes");
            }
            promise
                .then(function (data) {
                    console.log("da", data);
                    $scope.saving = false;
                    $scope.attributes.splice($scope.currIndex, 1, data[0]);
                    $scope.cancel();
                })
                .catch(function (err) {
                    console.log("err", err);
                    $mdToast.showSimple('Error while saving attribute : ' + err.message);
                });
        };

        $scope.addValue = function (index) {
            $scope.newattribute.meta_values.splice(index + 1, 0, {value: ""});
            console.log('Atta', $scope.newattribute.meta_values);
        };

        $scope.removeValue = function (index) {
            $scope.newattribute.meta_values.splice(index, 1);
        };


        $scope.getAllAttributesPlain = function () {
            $scope.loadingPlainAttrs = true;
            RestManager.getResource('/attributes', 'attributes')
                .then(function (attrs) {
                    $scope.plainAttributes = _.orderBy(attrs, function (attribute) {
                        return attribute.meta_key
                    });
                    $scope.newattribute.meta_values = $scope.newattribute.meta_values.map(function (meta_value) {
                        if (meta_value.linkedAttribute) {
                            meta_value.linkedAttribute = _.find($scope.plainAttributes, function (attribute) {
                                return attribute._id === meta_value.linkedAttribute;
                            })
                        }
                        return meta_value;
                    });
                    $scope.loadingPlainAttrs = false;
                })
                .catch(function (err) {
                    console.log('err', err);
                    $scope.loadingPlainAttrs = false;
                })
        }


        $scope.getAllAttributes = function () {
            $scope.promise = RestManager.postResource("/attributes", $scope.query, "attributes", ["totalCount"]);

            $scope.promise
                .then(function (data) {
                    $scope.attributes = data.attributes;
                    $scope.totalCount = data.totalCount;
                    console.log(data);
                })
                .catch(function (err) {
                    console.log(err);
                })
        };


        $scope.getAllAttributes();
    }]);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 21/7/19 11:36 PM
 *
 */

(function () {
    'use strict';

    ExportUtils.$inject = ["Base", "Utils"];
    angular.module('app.products')
        .service('ExportUtils', ExportUtils);

    function ExportUtils(Base, Utils) {
        this.vendorAttributeOrLocal = _vendorAttributeOrLocal;
        this.findAttributeAndValue = _findAttributeAndValue;
        this.findVariationValue = _findVariationValue;
        this.generateMediaLink = _generateMediaLink;
        this.replaceAttributeWithVendor = _replaceAttributeWithVendor;
        this._getReplacementAttribute = _getReplacementAttribute;
        this._findValInternal = _findValInternal;

        this.setAttributes = function (attributes) {
            this.attributes = attributes;
        };


        function _replaceAttributeWithVendor(attributes, value, exportType) {

        }

        function _vendorAttributeOrLocal(attributes, vendorName, vendorAttributeKey, localAttributeKey) {
            var prefixedVendorAttribute = vendorName + '::' + vendorAttributeKey;
            var vendorAttribute = _.find(attributes, function (o) {
                return o.attribute.meta_key.toLowerCase() === prefixedVendorAttribute.toLowerCase();
            });
            if (vendorAttribute) {
                return _findAttributeAndValue(attributes, prefixedVendorAttribute);
            } else {
                return _findAttributeAndValue(attributes, localAttributeKey);
            }
        }

        function _findAttributeAndValue(attributes, key, vendorName, dbAttributes) {
            if(Array.isArray(key)) {
                var data = key.map(function (k) {
                    return _findValInternal(attributes, k, vendorName, dbAttributes);
                });
                console.log("utils.export.service.js", "_findAttributeAndValue",key, data);
                return _.compact(data)[0];
            } else {
                return _findValInternal(attributes, key, vendorName, dbAttributes);
            }
        }

        function _findValInternal(attributes, key, vendorName, dbAttributes) {
            var obj = _.find(attributes, function (o) {
                return o.attribute.meta_key.toLowerCase() === key.toLowerCase();
            });
            if (obj) {
                var delimeter = (obj && obj.attribute && obj.attribute.delimeter) ? obj.attribute.delimeter : ',';
                var value = "";
                obj.attribute.meta_values.forEach(function (a) {
                    if (_.includes(obj.selectedValues, a._id)) {
                        var replacementAttribute = _getReplacementAttribute(vendorName,  a._id, dbAttributes);
                        if(replacementAttribute) {
                            value += replacementAttribute.attributeValue.value + replacementAttribute.delimeter;
                            delimeter = replacementAttribute.delimeter;
                        } else {
                            value += a.value + delimeter;
                        }
                    }
                });

                return Utils.replaceEnd(value, delimeter);
            } else {
                return "";
            }
        }


        function _getReplacementAttribute(vendorName, valueId, dbAttributes) {
            var replacementAttribute = _.find(dbAttributes, function (attribute) {
                return _.includes(attribute.meta_key.toLowerCase(), vendorName) && _.some(attribute.meta_values, function (meta_value) {
                    return meta_value.linkedValue === valueId;
                })
            });

            if (replacementAttribute) {
                var delimeter = replacementAttribute.delimeter;
                var attributeValue = _.find(replacementAttribute.meta_values, function (meta_value) {
                    return meta_value.linkedValue === valueId;
                })
                return {delimeter: delimeter, attributeValue: attributeValue};
            } else {
                return null;
            }
        }

        function _findVariationValue(variation) {
            var a = _.find(variation.attributes[0].attribute.meta_values, function (value) {
                return value._id === variation.attributes[0].selectedValue[0];
            }).value;
            if (a === 'Free Size') {
                a = 'FS';
            }
            return a;
        }


        function _generateMediaLink(url) {
            return Base.getMediaUrl() + url;
        }
    }

})(angular);

(function () {
    'use strict';

    ProductTaggedFilters.$inject = ["$q"];
    angular.module('app.products')
        .service('ProductTaggedFilters', ProductTaggedFilters);

    function ProductTaggedFilters( $q) {
        var productFilters = localforage.createInstance({
            driver: localforage.INDEXEDDB, // if you want to force a driver
            name: 'aaridaAdmin', // name of the database and prefix for your data
            version: 1.0, // version of the database, you shouldn't have to use this
            storeName: "taggedFilters" // Should be alphanumeric, with underscores.
        });

        var service = {
            get: get,
            getAll: getAll,
            getAllByKeys: getAllByKeys,
            getAllKeys: getAllKeys,
            set: set,
            setItems: setItems,
            removeItem: removeItem,
            clear: clear
        };

        return service;

        /**
         * @memberOf ProductTaggedFilters#
         * @param key
         * @returns {*}
         */
        function get(key) {
            var deferred = $q.defer();
            productFilters.getItem(key).then(function (result) {
                deferred.resolve(JSON.parse(result));
            });
            return deferred.promise;
        }

        /**
         * @memberOf ProductTaggedFilters
         * @returns {*}
         */
        function getAll() {
            var deferred = $q.defer();
            productFilters.getItems().then(function (result) {
                deferred.resolve(result);
            });
            return deferred.promise;
        }

        /**
         * @memberOf ProductTaggedFilters
         * @returns {*}
         */
        function getAllByKeys() {
            var deferred = $q.defer();
            productFilters.getItems().then(function (result) {
                deferred.resolve(result);
            });
            return deferred.promise;
        }

        /**
         * @memberOf ProductTaggedFilters
         * @returns {*}
         */
        function getAllKeys() {
            var deferred = $q.defer();
            productFilters.keys().then(function (result) {
                deferred.resolve(result);
            });
            return deferred.promise;
        }

        /**
         * @memberOf ProductTaggedFilters
         * @param key
         * @param value
         * @returns {*}
         */
        function set(key, value) {
            var deferred = $q.defer();
            value = JSON.stringify(value);
            productFilters.setItem(key, value).then(function (result) {
                deferred.resolve(result);
            }).catch(function (err) {
                // This code runs if there were any errors
                deferred.reject(err);
            });


            return deferred.promise;
        }

        /**
         * @memberOf ProductTaggedFilters
         * @param items
         * @returns {*}
         */
        function setItems(items) {
            var deferred = $q.defer();

            productFilters.setItems(items).then(function (result) {
                deferred.resolve(result);
            }).catch(function (err) {
                // This code runs if there were any errors
                console.log(err);
                deferred.reject(err);
            });

            return deferred.promise;
        }

        /**
         * @memberOf ProductTaggedFilters
         * @param key
         * @returns {*}
         */
        function removeItem(key) {
            var deferred = $q.defer();

            productFilters.removeItem(key).then(function (result) {
                deferred.resolve(result);
            });

            return deferred.promise;
        }

        /**
         * @memberOf ProductTaggedFilters
         * @returns {*}
         */
        function clear() {

            var deferred = $q.defer();

            productFilters.clear().then(function (result) {
                deferred.resolve(result);
            });

            return deferred.promise;

        }
    }
})(angular);

(function () {
    "use strict";
    ProductsExport.$inject = ["$q", "Base", "RestManager", "$mdToast", "FlipkartExporter"];
    angular.module("app.products")
        .service("ProductExport", ProductsExport);


    function ProductsExport($q, Base, RestManager, $mdToast, FlipkartExporter) {

        function _exportData(products, exportType, header, resolve, reject) {
            console.log('Products', products);
            try {
                var wb = {
                    SheetNames: [],
                    Sheets: []
                };

                var extentsion = '';
                var fileName = '';
                var jsonToSheetOptions = {};
                switch (exportType) {
                    case 'retailBeanLite' :
                        fileName = 'RBImport';
                        extentsion = '.xls';
                        products = trimForReatilBean(products);
                        jsonToSheetOptions = {header: b, skipHeader: exportType === 'retailBeanLite'};
                        break;

                    case 'barcode' :
                        fileName = 'BC-Gen'
                        extentsion = '.csv';
                        break;

                    case 'flipkart' :
                        fileName = 'A-FK-' + moment().format('DD-MMM-YY hh-mm-ss a')
                        extentsion = '.xlsx';
                        jsonToSheetOptions = {header: header};
                        break;

                    case 'ecommdesk' :
                        fileName = 'A-EDesk-' + moment().format('DD-MMM-YY hh-mm-ss a')
                        extentsion = '.xlsx';
                        break;

                    case 'graftale' :
                        fileName = 'A-GT-' + moment().format('DD-MMM-YY hh-mm-ss a')
                        extentsion = '.xlsx';
                        break;

                    default:
                        fileName = "A-" + moment().format('DD-MMM-YY hh-mm-ss a');
                        extentsion = '.xlsx';
                        break;
                }

                wb.SheetNames.push("products");


                /* Load the worksheet object */


                var ws = XLSX.utils.json_to_sheet(products, jsonToSheetOptions);
                var wopts = {bookType: 'xlsx', bookSST: false, type: 'binary'};

                if (exportType === 'barcode') {
                    wopts.bookType = 'csv';
                }
                wb.Sheets["products"] = ws;

                var wbout = XLSX.write(wb, wopts);

                // noinspection JSAnnotator
                function s2ab(s) {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }

                // /* the saveAs call downloads a file on the local machine */
                saveAs(new Blob([s2ab(wbout)], {type: "application/octet-stream"}), fileName + extentsion);
                resolve();
            } catch (err) {
                reject(err);
                console.log(err);
            }
        }

        function parseData(products, exportType) {

            console.log('[products.export.service.js : 49]', 'parseData', exportType);

            switch (exportType) {
                case "local" :
                    return _.chain(products)
                        .flatMapDeep(function (o) {
                            var model = {
                                name: null,
                                sku: null,
                                slug: null,
                                isFeatured: null,
                                outOfStock: null,
                                published: null,
                                featured_image: null,
                                gallery: null
                            };
                            var p = {
                                designing: 0,
                                fabricCost: 0,
                                photoShoot: 0,
                                stitching: 0,
                                productionCost: 0,
                                msp: 0,
                                salePrice: 0,
                                price: 0,
                                mrp: 0
                            };
                            model = _.assign(model, p);
                            if (o.variations[0] && o.variations[0].stockAndPrice)
                                o = _.assign(o, o.variations[0].stockAndPrice.price);
                            else
                                o = _.assign(o, p);
                            delete o.price._id;

                            return _.pick(o, _.keys(model));
                        })
                        .value();

                default:
                    return _.chain(products)
                        .flatMapDeep(function (o) {
                            var model = {
                                name: null,
                                sku: null,
                                originalSku: null,
                                slug: null,
                                isFeatured: null,
                                outOfStock: null,
                                published: null,
                                featured_image: null,
                                image1: null,
                                image2: null,
                                image3: null,
                                image4: null,
                                fabric: null,
                                colour: null,
                                sleeves: null,
                                fit: null,
                                size: null,
                                category: null,
                                productType: null
                            };
                            var p = {
                                designing: 0,
                                fabricCost: 0,
                                photoShoot: 0,
                                stitching: 0,
                                productionCost: 0,
                                msp: 0,
                                salePrice: 0,
                                price: 0,
                                mrp: 0,
                                stock: 0
                            };
                            model = _.assign(model, p);


                            if (o.variation && o.variation.stockAndPrice) {
                                o = _.assign(o, o.variation.stockAndPrice.price);
                                o.stock = o.variation.stockAndPrice.stock.quantity;
                            } else
                                o = _.assign(o, p);


                            delete o.price._id;
                            o.featured_image = _generateMediaLink(o.featured_image.urls.full);
                            o.image1 = o.gallery[0] ? _generateMediaLink(o.gallery[0].urls.full) : '';
                            o.image2 = o.gallery[1] ? _generateMediaLink(o.gallery[1].urls.full) : '';
                            o.image3 = o.gallery[2] ? _generateMediaLink(o.gallery[2].urls.full) : '';
                            o.image4 = o.gallery[3] ? _generateMediaLink(o.gallery[3].urls.full) : '';
                            o.image5 = o.gallery[4] ? _generateMediaLink(o.gallery[4].urls.full) : '';
                            o.size = o.sku.slice(10);
                            o.colour = _findAttributeAndValue(o.attributes, "Color");
                            o.fabric = _findAttributeAndValue(o.attributes, "Fabric");
                            o.sleeves = _findAttributeAndValue(o.attributes, "Sleeves");
                            o.fit = _findAttributeAndValue(o.attributes, "Fit");
                            o.category = _removeTrailingComma(_.reduce(o.categories, function (o, c) {
                                o += c.name + ", ";
                                return o;
                            }, ""));
                            if (_.includes(['flipkart', 'graftale', 'ecommdesk'], exportType)) {
                                delete o.designing;
                                delete o.fabricCost;
                                delete o.photoShoot;
                                delete o.stitching;
                                delete o.productionCost;
                                delete o.msp;
                                delete o.salePrice;

                            }
                            switch (exportType) {
                                case "flipkart" :
                                    o.price = o.price * 1.5;
                                    o.mrp = o.mrp * 1.5;
                                    o['Size - Measuring Unit'] = 'Regular';
                                    o['Ideal For'] = 'Women';
                                    o['Sleeve Length'] = _vendorAttributeOrLocal(o.attributes, exportType, "Sleeves", "Sleeves");
                                    o['Pattern'] = _vendorAttributeOrLocal(o.attributes, exportType, "Pattern", "Pattern");
                                    o['Occasion'] = _vendorAttributeOrLocal(o.attributes, exportType, "Occasion", "Occasion");
                                    o['Color'] = _vendorAttributeOrLocal(o.attributes, exportType, "Color", "Color");
                                    o['Brand Color'] = _findAttributeAndValue(o.attributes, "Color");
                                    o['Shape Type'] = _findAttributeAndValue(o.attributes, "Shape Type");
                                    o['Pack of'] = 1;
                                    o['Suitable For'] = _vendorAttributeOrLocal(o.attributes, exportType, 'Suitable For', "Suitable For");
                                    o['Surface Styling'] = _vendorAttributeOrLocal(o.attributes, exportType, 'Surface Styling', "Surface Styling");
                                    o['Neck'] = _vendorAttributeOrLocal(o.attributes, exportType, 'Neck', "Neck");
                                    o['Detail Placement'] = _vendorAttributeOrLocal(o.attributes, exportType, 'Detail Placement', "Detail Placement");
                                    o['Embellishment'] = _vendorAttributeOrLocal(o.attributes, exportType, 'Embellishment', "Embellishment");
                                    o['Embroidered'] = _vendorAttributeOrLocal(o.attributes, exportType, 'Embroidered', "Embroidered");
                                    o['Fabric Care'] = _vendorAttributeOrLocal(o.attributes, exportType, 'Fabric Care', "Fabric Care");
                                    console.log('a', o)
                                    break;

                                case "graftale" :
                                    o.price = o.price * 1.5;
                                    o.mrp = o.mrp * 1.5;
                                    break;

                                case "ecommdesk" :
                                    o.price = o.price * 2;
                                    o.mrp = o.mrp * 2;
                                    break;
                            }

                            return _.pick(o, _.keys(model));
                        })
                        .value();

            }
        }


        function trimForReatilBean(products) {
            products.unshift(map);
            return products.map(function (product) {
                var data = {
                    name: '',
                    barCodeType: 'Vendor Barcode',
                    sku: '',
                    parentCategory: '',
                    category: '',
                    defaultUom: 'Pcs',
                    hsn: '',
                    shortDescription: '',
                    description: '',
                    price: '',
                    mrp: '',
                    discountedPrice: '',
                    brand: 'Aarida',
                    displayUom: 'Pcs',
                    slug: '',
                    manageStock: 'No',
                    reOrderLevel: 0,
                    reOrderQuantity: 0,
                    stock: 1,
                    salesTax: '',
                    taxInclusive: '',
                    purchaseTax: '',
                    purchaseTaxInclusive: '',
                    size: ''
                };
                _.merge(data, product);
                data.category = data.category.split(',')[0];
                _.forOwn(data, function (val, key) {
                    var updatedKey = getColumnMapping(key);
                    data[key] = val;
                    // delete data[key];
                    if (!_.includes(b, updatedKey)) {
                        delete data[updatedKey];
                    }
                });
                return data;
            })
        }

        var a = ["Product Name", "Bar Code Type", "Parent Category",
            "Product Category", "Bar Code",
            "Default UOM", "HSN Code", "Short Description",
            "long Description", "Standard Cost Price", "Standard MRP",
            "Discounted Price",
            "Brand", "Display UOM", "Custom Url", "Inventory Required",
            "Re-order Level", "Re-order Quantity", "Opening Balance Quantity",
            "Sales Tax", "Inclusive/Extra", "ATTR_Size", "Purchase Tax"];

        var map = {
            name: "Product Name",
            barCodeType: "Bar Code Type",
            sku: "Bar Code",
            parentCategory: "Parent Category",
            category: "Product Category",
            defaultUom: "Default UOM",
            hsn: "HSN Code",
            shortDescription: "Short Description",
            description: "long Description",
            price: "Standard Cost Price",
            mrp: "Standard MRP",
            discountedPrice: "Discounted Price",
            brand: "Brand",
            displayUom: "Display UOM",
            slug: "Custom Url",
            manageStock: "Inventory Required",
            reOrderLevel: "Re-order Level",
            reOrderQuantity: "Re-order Quantity",
            stock: "Opening Balance Quantity",
            salesTax: "Sales Tax",
            taxInclusive: "Inclusive/Extra",
            purchaseTax: "Purchase Tax",
            purchaseTaxInclusive: "Inclusive/Extra",
            size: "ATTR_Size",
            color: "ATTR_Colour"
        };

        function getColumnMapping(column) {
            return map[column] || column;
        }

        var b = Object.keys(map);

        function _vendorAttributeOrLocal(attributes, vendorName, vendorAttributeKey, localAttributeKey) {
            var prefixedVendorAttribute = vendorName + '::' + vendorAttributeKey;
            var vendorAttribute = _.find(attributes, function (o) {
                return o.attribute.meta_key.toLowerCase() === prefixedVendorAttribute.toLowerCase();
            });
            if (vendorAttribute) {
                return _findAttributeAndValue(attributes, prefixedVendorAttribute);
            } else {
                return _findAttributeAndValue(attributes, localAttributeKey);
            }
        }

        function _findAttributeAndValue(attributes, key) {
            var obj = _.find(attributes, function (o) {
                return o.attribute.meta_key === key;
            });
            if (obj) {
                var value = "";
                obj.attribute.meta_values.forEach(function (a) {
                    if (_.includes(obj.selectedValues, a._id)) {
                        value += a.value + ", ";
                    }
                });

                return _removeTrailingComma(value);
            } else {
                return "";
            }
            // console.log('[products.export.service.js : 136]', '_findAttributeAndValue', attributes, key);
        }

        function _findVariationValue(variation) {
            var a = _.find(variation.attributes[0].attribute.meta_values, function (value) {
                return value._id === variation.attributes[0].selectedValue[0];
            }).value;
            if (a === 'Free Size') {
                a = 'FS';
            }
            return a;
        }

        function _removeTrailingComma(str) {
            return str.replace(/,\s*$/, "");
        }


        function _generateMediaLink(url) {
            return Base.getMediaUrl() + url;
        }

        function _validMonths(month) {

        }


        /**
         * @memberOf ProductExport
         * @param products
         * @param exportType
         * @return {Promise}
         */
        this.export = function (products, exportType) {
            var vm = this;
            return new $q(function (resolve, reject) {
                var promise = '';
                if(_.includes(['flipkart','amazon'], exportType)) {
                    promise = RestManager.postResource("/attributes", {}, "attributes");
                } else {
                    promise = Promise.resolve()
                }

                promise
                    .then(function (attributes) {
                        if(attributes) {
                            vm.attributes = attributes;
                        }
                        return Promise
                            .map(products, function (product) {
                                return new $q(function (resolve, reject) {
                                    RestManager.getResource("/products/admin/" + product._id, "products")
                                        .then(function (products) {
                                            resolve(products[0])
                                        })
                                        .catch(reject);
                                });
                            })
                    })
                    .then(function (data) {
                        try {
                            var expandedList = [];
                            _.forEach(data, function (product) {
                                if (product.variations && product.variations.length) {
                                    product.variations.forEach(function (variation) {
                                        var p = {};
                                        angular.copy(product, p);
                                        p.variation = variation;
                                        p.originalSku = product.sku;
                                        p.sku = product.sku + _findVariationValue(p.variation);
                                        p.type = 'Variant Product';
                                        expandedList.push(p);
                                    })
                                } else {
                                    expandedList.push(product);
                                }
                            });
                            var p, headers;
                            switch (exportType) {
                                case 'flipkart':
                                    var result = FlipkartExporter.getDataToExport(expandedList, 'kurti', vm.attributes);
                                    p = result.data;
                                    headers = result.headers;
                                    break;

                                case 'amazon' :
                                    break;

                                default :
                                    p = parseData(expandedList, exportType);
                                    break;
                            }
                            _exportData(p, exportType, headers, resolve, reject);

                        } catch (err) {
                            console.log(err);






                            reject(err);
                        }
                    })
                    .catch(reject);
            });
        }
    }
})(angular);

(function () {
    "use strict";


    BulkService.$inject = ["RestManager", "$q"];
    angular
        .module("app.products")
        .service("ProductsBulk", BulkService);

    /** @ngInject **/
    function BulkService(RestManager, $q) {
        this.updateSKU = function (products) {
            return $q(function (resolve, reject) {
                var tfData = products.map(function (o) {
                    return {sku: o.sku};
                });

                RestManager.postResource("/products/admin/bulk", {
                    products: tfData,
                    task: "update_sku"
                }, "products")
                    .then(function (data) {
                        resolve(products.map(function (product) {
                            var a = _.find(data, function (o) {
                                return o._id === product._id;
                            });
                            product.sku = a.sku;
                            return product;
                        }));
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        };


        this.updateBoolFields = function (products, fields) {
            var tfData = products.map(function (product) {
                return product._id;
            });
            return $q(function (resolve, reject) {

                RestManager.postResource("/products/admin/bulk", {
                    products: tfData,
                    task: "change_bool_fields",
                    fields: fields
                }, "products")
                    .then(function (data) {
                        resolve(products.map(function (product) {
                            var a = _.find(data, function (o) {
                                return o._id === product._id;
                            });
                            product.published = a.published;
                            product.isCoupon = a.isCoupon;
                            product.isOnSale = a.isOnSale;
                            product.isFeatured = a.isFeatured;
                            product.outOfStock = a.outOfStock;
                            product.comingSoon = a.comingSoon;
                            product.editorType = a.editorType;
                            product.isAvailableForPreOrder = a.isAvailableForPreOrder;
                            product.virtualVariations = a.virtualVariations;
                            return product;
                        }));
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        }
    }
})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 21/7/19 11:33 PM
 *
 */

(function () {
    'use strict';


    FlipkartExporter.$inject = ["ExportUtils"];
    angular.module('app.products')
        .service('FlipkartExporter', FlipkartExporter);


    function FlipkartExporter(ExportUtils) {
        var kurtiHeaders = ['Flipkart Serial Number', 'QC Status', 'QC Failed Reason (if any)', 'Flipkart Product Link', 'Seller SKU ID', 'Brand', 'Size', 'Size - Measuring Unit', 'Style Code', 'Ideal For', 'Sleeve Length', 'Pattern', 'Occasion', 'Color', 'Brand Color', 'Shape Type', 'Pack of', 'Fabric', 'Suitable For', 'Main Image URL', 'Other Image URL 1', 'Other Image URL 2', 'Other Image URL 3', 'Other Image URL 4', 'Other Image URL 5', 'Other Image URL 6', 'Main Palette Image URL', 'Group ID', 'Pattern/Print Type', 'Surface Styling', 'Embellished', 'Embroidered', 'EAN/UPC', 'Model Name', 'Fabric Care', 'Region', 'Neck', 'Other Details', 'Sales Package', 'Description', 'Search Keywords', 'Key Features', 'Video URL', 'Warranty Summary', 'External Identifier', 'Detail Placement', 'Sleeve Style', 'Style Type', 'Kurti Length', 'Fabric Purity', 'Ornamentation Type', 'Pattern Coverage', 'Trend', 'Secondary Color', 'Trend AW 16']


        this.getDataToExport = function (products, category, attributes) {
            var exportType = 'flipkart';
            console.log('attributes', attributes);
            ExportUtils.setAttributes(attributes);
            var data = _.chain(products)
                .flatMapDeep(function (o) {
                    o['Main Image URL'] = o.gallery[3] ? ExportUtils.generateMediaLink(o.gallery[3].urls.full) : '';
                    o['Other Image URL 1'] = o.gallery[0] ? ExportUtils.generateMediaLink(o.gallery[0].urls.full) : '';
                    o['Other Image URL 2'] = o.gallery[1] ? ExportUtils.generateMediaLink(o.gallery[1].urls.full) : '';
                    o['Other Image URL 3'] = o.gallery[2] ? ExportUtils.generateMediaLink(o.gallery[2].urls.full) : '';
                    o['Other Image URL 4'] = o.gallery[4] ? ExportUtils.generateMediaLink(o.gallery[4].urls.full) : '';
                    o['Other Image URL 5'] = o.gallery[5] ? ExportUtils.generateMediaLink(o.gallery[5].urls.full) : '';
                    o['Size'] = o.sku.slice(10);
                    o['Seller SKU ID'] = o.sku;
                    o['Brand'] = 'Aarida';
                    o['Style Code'] = o.originalSku;
                    o.mrp = o.mrp * 1.5;
                    o['Size - Measuring Unit'] = 'Regular';
                    o['Ideal For'] = 'Women';
                    o['Fabric'] = ExportUtils.findAttributeAndValue(o.attributes, 'Fabric', exportType, attributes);
                    o['Sleeve Length'] = ExportUtils.findAttributeAndValue(o.attributes, 'Sleeves', exportType, attributes);
                    o['Pattern'] = ExportUtils.findAttributeAndValue(o.attributes, 'Print', exportType, attributes);
                    o['Occasion'] = ExportUtils.findAttributeAndValue(o.attributes, ['Occasion', 'Product Type'], exportType, attributes);
                    o['Color'] = ExportUtils.findAttributeAndValue(o.attributes, 'Color', exportType, attributes);
                    o['Brand Color'] = ExportUtils.findAttributeAndValue(o.attributes, 'Color', exportType, attributes);
                    o['Shape Type'] = ExportUtils.findAttributeAndValue(o.attributes, "Fit");
                    o['Pack of'] = 1;
                    o['Suitable For'] = ExportUtils.findAttributeAndValue(o.attributes, 'Occasion', exportType, attributes);
                    o['Surface Styling'] = ExportUtils.findAttributeAndValue(o.attributes, 'Surface Styling', exportType, attributes);
                    o['Neck'] = ExportUtils.findAttributeAndValue(o.attributes, 'Neck', exportType, attributes);
                    o['Detail Placement'] = ExportUtils.findAttributeAndValue(o.attributes, 'Detail Placement', exportType, attributes);
                    o['Embellishment'] = ExportUtils.findAttributeAndValue(o.attributes, 'Embellishment', exportType, attributes);
                    // o['Embroidered'] = ExportUtils.findAttributeAndValue(o.attributes, 'Embroidered', exportType, attributes);
                    o['Fabric Care'] = ExportUtils.findAttributeAndValue(o.attributes, 'Fabric Care', exportType, attributes);
                    o['Search Keywords'] = _.lowerCase(o.name).split(' ').join('::') + '::aarida::' + _.lowerCase(o.name) + '::' + o['Color'] + '::' + o['Occasion'] + '::' + o['Suitable For'] + '::' + o['Fabric'];
                    return o;
                })
                .value();

            console.log('Flipkart Data', data);
            data = data.map(function (product) {
                var object = {};
                kurtiHeaders.forEach(function (header) {
                    object[header] = product[header];
                });
                return object;
            });
            return {data: data, headers: kurtiHeaders};
        }

    }
})(angular);

/**
 * Created by kumardivyarajat on 04/12/16.
 */

(function () {
    'use strict';

    AllController.$inject = ["$scope", "Utils", "Scanner", "$timeout", "ProductTaggedFilters", "RestManager", "$q", "$mdToast", "$mdDialog", "$window", "$state", "$stateParams", "$http", "Base", "ProductsBulk", "ProductExport", "hotkeys", "Notifications"];
    angular
        .module("app.products")
        .controller("products.all.controller", AllController);

    function AllController($scope, Utils, Scanner, $timeout, ProductTaggedFilters,
                           RestManager, $q, $mdToast, $mdDialog,
                           $window, $state, $stateParams, $http, Base, ProductsBulk, ProductExport,
                           hotkeys, Notifications) {


        $scope.productIds = $stateParams.productIds;
        $scope.$parent.pageTitle = "All Products";
        $scope.$parent.nestedState = false;
        $scope.$parent.showActionButton = false;
        $scope.$parent.hideHeader = true;
        hotkeys.bindTo($scope)
            .add({
                combo: 'mod+s',
                description: 'Focus the search bar',
                callback: function (e) {
                    e.preventDefault();
                    document.getElementById('search-bar').focus();
                }
            })
            .add({
                combo: 'mod+f',
                description: 'Open the filters panel',
                callback: function (e) {
                    e.preventDefault();
                    $scope.showFilterDialog();
                }
            })
            .add({
                combo: 'mod+left',
                description: 'Navigate to previous page',
                callback: function (e) {
                    e.preventDefault();
                    if ($scope.filters.page !== 1) {
                        $scope.filters.page -= 1;
                        $scope.getProducts();
                        $mdToast.show($mdToast.simple('Showing page ' + $scope.filters.page + ' of ' + $scope.totalPages))
                    } else {
                        $mdToast.show($mdToast.simple('This is already the first page in the list'));
                    }
                }
            })
            .add({
                combo: 'mod+right',
                description: 'Navigate to next page',
                callback: function (e) {
                    e.preventDefault();
                    if ($scope.filters.page !== ($scope.totalPages)) {
                        $scope.filters.page += 1;
                        $scope.getProducts();
                        $mdToast.show($mdToast.simple('Showing page ' + $scope.filters.page + ' of ' + $scope.totalPages))
                    } else {
                        $mdToast.show($mdToast.simple('This is already the last page in the list'));
                    }
                }
            });

        $scope.searchTerm = '';
        $scope.showFilters = false;
        $scope.selected = [];
        $scope.bulk = {
            actionModel: ''
        };
        $scope.productsSearch = '';
        // $scope.actionModel = '11';
        $scope.exportType = '';
        $scope.filters = {
            showNewSearch: false,
            orderBy: '-updatedAt',
            limit: 25,
            page: 1,
            query: [],
        };
        $scope.taggedFilters = [];
        $scope.totalPages = '';
        $scope.collectionSelected = false;
        $scope.fetchingProducts = false;
        $scope.singleActions = [
            {
                title: 'Edit Product',
                id: 0,
                showOnlyInSingleSelection: true
            },
            {
                title: 'Edit Product In New Tab',
                id: 1,
                showOnlyInSingleSelection: true
            },
            {
                title: 'Duplicate Product',
                id: 2,
                showOnlyInSingleSelection: true
            },
            {
                title: 'Delete Product',
                id: 3,
                showOnlyInSingleSelection: true
            }
        ];

        $scope.actions = [

            {
                title: 'Download Product Images',
                id: 4
            },
            {
                title: 'Export Selected Products',
                id: 5
            },
            {
                title: 'Bulk Update Selected Products',
                id: 6
            }
        ];

        if ($stateParams.productIds && $stateParams.productIds.length) {
            console.log("products.all.controller.js", "AllController", $scope.searchTerm);
            $scope.searchTerm = '';

        }


        $scope.updatePrice = {
            updateType: ''
        };

        if ($stateParams.page) {
            $scope.filters.page = $stateParams.page;
        }

        if ($stateParams.limit) {
            $scope.filters.limit = $stateParams.limit;
        }

        if ($stateParams.orderBy) {
            $scope.filters.orderBy = $stateParams.orderBy;
        }

        if ($stateParams.searchTerm) {
            $scope.filters.searchTerm = $stateParams.searchTerm;
        }

        var lastFilter = $window.localStorage.getItem('lastQuery');

        if (lastFilter) {
            $scope.filters = JSON.parse(lastFilter);
        }

        if($stateParams.query) {
            $scope.filters.query = $stateParams.query;
        }

        // function success(products) {
        //     $scope.products = products;
        //     console.log(products);
        // }


        $scope.applyCollection = applyCollection;
        $scope.resetFilters = resetFilters;
        $scope.saveFiltersAsCollections = saveFiltersAsCollections;
        $scope.searchProducts = searchProducts;
        $scope.fetchProductsFromAnywhere = fetchProductsFromAnywhere;
        $scope.init = init;

        function init() {

        }

        $scope.clearSelected = function () {
            $scope.selected = [];
        };

        $scope.keyAction = function (event) {
            if (event.which === 13)
                $scope.getProducts();
        };

        $scope.getProducts = function () {
            $mdDialog.cancel();
            var url = "/products/admin";
            if (!$scope.fetchingProducts) {
                $scope.fetchingProducts = true;
                // $scope.filters.query = _generateQuery();
                // $scope.filters.query = {deleted : false};
                console.log("products.all.controller.js", "getProducts", $scope.filters);
                $scope.promise = RestManager.postResource(url, $scope.filters, "products", ["total"]);
                $scope.promise
                    .then(function (result) {
                        console.log("products.all.controller.js", "RESULTS", result);
                        $scope.products = result
                        $window.localStorage.setItem('lastQuery', JSON.stringify($scope.filters))
                        $scope.products = result.products.map(function (value) {
                            return _validate(value);
                        });
                        $scope.fetchingProducts = false;
                        $scope.total = result.total;
                        $scope.totalPages = Math.ceil($scope.total / $scope.filters.limit);
                        $scope.changeState();
                        // $scope.showJsonDialog();
                    })
                    .catch(function (err) {
                        console.log(err);
                        $scope.fetchingProducts = false;
                    });
            }
        };

        $scope.fetchCollections = function () {
            $scope.loadingCollections = true;
            RestManager.getResource("/collections", "collections", {query: {currentStatus: 1}})
                .then(function (result) {
                    $scope.collections = result;
                    $scope.collections.forEach(function (collection) {
                        collection.loadingTotal = true;
                        $scope.getProductCountInCollection(collection)
                            .then(function (result) {
                                collection.total = result.total;
                                collection.loadingTotal = false;
                            })
                            .catch(function (err) {
                                console.log('err', err);
                                collection.loadingTotal = false;
                            });
                    });
                    $scope.loadingCollections = false;
                })
                .catch(function (err) {
                    console.log(err);
                    $scope.loadingCollections = false;
                });
        }

        $scope.getProductCountInCollection = function (collection) {
            return RestManager.postResource('/products/admin/preview', _.assign(collection.rules, {actionType: 'count'}), 'preview', {extras: ['total']})
        }

        /***
         * Fetch products from anywhere and display them in all products page
         */

        function fetchProductsFromAnywhere() {
            console.log("products.all.controller.js", "fetchOrderedProducts", "FROM ORDER PAGE");

            console.log("products.all.controller.js", "fetchOrderedProducts", $scope.filters);
            if (!$scope.filters.query) {
                $scope.filters.query = [];
            }
            $scope.filters.query[0] = {
                "values": $scope.productIds,
                "enabled": true,
                "entity": "_id",
                "selectedEntity": {
                    "name": "Products",
                    "value": "_id",
                    "operands": [{
                        "name": "Contained In",
                        "value": "$in",
                        "valType": "Array_String"
                    }, {"name": "Not Contained In", "value": "$nin", "valType": "Array_String"}],
                    "valType": "Array_String",
                    "inputType": "select"
                },
                "selectedOperand": {"name": "Contained In", "value": "$in", "valType": "Array_String"},
                "valType": "Array_String",
                "operand": "$in"
            };
            $scope.getProducts();
        }

        function resetFilters() {
            $scope.filters.query = [];
            $scope.filters.page = 1;
            $scope.filters.limit = 25;
            $scope.filters.orderBy = '-updatedAt';
            $scope.getProducts();
            $scope.collectionSelected = false;
            $scope.collections = $scope.collections.map(function (collection) {
                collection.selected = false;
                return collection;
            })
        }

        function saveFiltersAsCollections(ev) {
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                controller: "editCollectionController",
                templateUrl: "app/modules/collections/modals/edit-collection.tmpl.html",
                multiple: true,
                locals: {
                    collectionId: null,
                    rules: $scope.filters.query
                }
            })
                .then(function (data) {
                    console.log("products.all.controller.js", "", data.collection);
                    data.collection.selected = true;
                    $scope.collections.unshift(data.collection);
                    $scope.collectionSelected = true;
                    data.collection.loadingTotal = true
                    $scope.getProductCountInCollection(data.collection)
                        .then(function (countData) {
                            data.collection.loadingTotal = false;
                            data.collection.total = countData.total;
                        });
                })
        }

        function applyCollection(collection) {
            $scope.filters.query = collection.rules.queries;
            $scope.filters.orderBy = collection.sortBy;
            $scope.collectionSelected = true;
            $scope.collections = $scope.collections.map(function (collection) {
                collection.selected = false;
                return collection;
            });
            collection.selected = true;
            $scope.getProducts();
        }


        function _validate(product) {
            product.errors = [];
            if (!product.featured_image) {
                product.hasError = true;
                product.errors.push('Featured Image not set');
            }

            if (!product.gallery || !product.gallery.length) {
                product.hasError = true;
                product.errors.push('Product Images not set');
            }

            if (product.name === product.name.toUpperCase()) {
                product.hasError = true;
                product.errors.push('Product Name is all caps. Should be capitalized string');
            }

            if (product.published && !product.price) {
                product.hasError = true;
                product.errors.push('The product is published but yet its price is not set correctly.');
            }

            if (!product.variations || !product.variations.length) {
                product.hasError = true;
                product.errors.push('Product does not have any variations yet');
            }

            if (!product.categories || !product.categories.length) {
                product.hasError = true;
                product.errors.push('Product Category is not set');
            }

            if (!product.sizeChart) {
                product.hasError = true;
                product.errors.push("Size chart is not set");
            }

            product.name = _.startCase(_.toLower(product.name));

            return product;
        }


        $scope.clearSearch = function () {
            $scope.filters.searchTerm = '';
            $scope.getProducts();
        };

        $scope.limitOptions = [5, 25, 50, 100, {
            label: 'All',
            value: function () {
                return $scope.total;
            }
        }];

        $scope.getLowestPrice = function (product) {
            switch (product.productType) {
                case 0:
                    var lowestPrice = 0;
                    _.forEach(product.variations, function (variation, i) {
                        var comparePrice = variation.stockAndPrice.price.salePrice ? variation.stockAndPrice.price.salePrice : variation.stockAndPrice.price.mrp;
                        if (lowestPrice > comparePrice) {
                            lowestPrice = i;
                        }
                    });
                    return product.variations[lowestPrice].stockAndPrice.price;

                case 1:
                    return product.customisation.basePrice;

            }
        };

        $scope.changeState = function () {
            $state.go("app.products.all", {
                    page: $scope.filters.page,
                    limit: $scope.filters.limit,
                    orderBy: $scope.filters.orderBy,
                    searchTerms: $scope.filters.searchTerm
                },
                {notify: false, reload: false, location: 'replace'});
        };

        $scope.showDuplicationConfirmation = function (product, ev) {
            var confirm = $mdDialog.confirm()
                .title('Do you want to duplicate ' + product.name + ' ? ')
                .textContent('A new product with the exact same details will be generated.')
                .ariaLabel('duplciate')
                .targetEvent(event)
                .ok('Yes. I want to duplicate the product!')
                .cancel('No. Take me back.');

            $mdDialog.show(confirm)
                .then(function () {
                    $scope.duplicateProduct(product, ev);
                }, function () {
                    $mdToast.showSimple("Cancelled the action");
                });
        };

        $scope.duplicateProduct = function (product, ev) {
            product.duplicating = true;
            $mdToast.show(
                {
                    template: "<md-toast><div class='md-toast-content'><md-progress-circular class='md-warn' md-diameter='20'></md-progress-circular><span>Duplicating Product</span></div> <md-toast>",
                    hideDelay: 0,
                    position: "bottom right"
                }
            );
            RestManager.getResource("/products/admin/dup/" + product._id, "products")
                .then(function (products) {
                    $mdToast.hide();
                    product.duplicating = false;
                    var url = $state.href('app.products.add.home', {slug: products[0]._id, name: products[0].name});
                    $window.open(url, '_blank');
                })
                .catch(function () {
                    product.duplicating = false;
                    $mdToast.hide();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Duplication Failed")
                            .position("bottom right")
                            .hideDelay(3000)
                    );
                });
            ev.preventDefault();
        };

        $scope.openDetailsPage = function (product, where, event) {
            if (where === 1) {
                var url = $state.href('app.products.add.home', {slug: product._id, name: product.name});
                $window.open(url, '_blank');
            } else {
                $state.go('app.products.add.home', {slug: product._id, name: product.name});
            }
            event.stopPropagation();
            // $window.open("/home");
        };


        $scope.moveToTrash = function (product, index, event) {
            var confirm = $mdDialog.confirm()
                .title('Do you want to move ' + product.name + ' to trash ? ')
                .textContent('This action is reversible and the product can be restored from the trash.')
                .ariaLabel('move to trash')
                .targetEvent(event)
                .ok('Yes. I will move it to trash!')
                .cancel('No. Sounds like a scam');

            $mdDialog.show(confirm)
                .then(function () {
                    $scope._moveToTrash(product, index);
                }, function () {
                    $mdToast.showSimple("Cancelled the action");
                });
        };

        $scope._moveToTrash = function (product, index) {
            product.deleted = true;
            $scope.promise = RestManager.deleteResource("/products/trash/" + product._id, product, "products")
                .then(function (data) {
                    $scope.getProducts();
                    // $scope.products.splice(index, 1);
                    $mdToast.showSimple("Successfully moved product to trash ");
                    $scope.selected = [];
                })
                .catch(function (err) {
                    console.log(err);
                });
        };


        $scope.editPrice = function (ev) {
            $mdDialog.show({
                templateUrl: "app/modules/products/editProductPriceDialog/edit-product-price.html",
                controller: 'editProductPriceController',
                fullscreen: true,
                targetEvent: ev,
                locals: {
                    products: $scope.selected
                }
            })
                .then(function (result) {
                    if (result.isUpdated) {
                        $scope.getProducts();
                        $mdToast.showSimple("Successfully updated " + $scope.selected.length + ' products');
                        $scope.selected = [];
                    }
                })
        };


        $scope.showFilterDialog = function (ev) {
            var queries = [];
            angular.copy($scope.filters.query, queries);
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: ev,
                fullscreen : true,
                clickOutsideToClose: false,
                controller: "manageProductsInCollection",
                templateUrl: "app/modules/collections/modals/manage-products.tmpl.html",
                multiple: true,
                locals: {
                    collection: {
                        rules: {
                            queries: queries
                        },
                        sortBy: $scope.filters.orderBy
                    },
                    title: "Filter Products",
                    saveButtonText: "Apply Filters",
                    returnQuery: true
                }
            })
                .then(function (data) {
                    if (data) {
                        console.log("products.all.controller.js", "DATA", data);
                        $scope.filters.query = data.queries;
                        $scope.filters.orderBy = data.sortBy;
                        if (data.modified) {
                            $scope.collectionSelected = false;
                            $scope.collections = $scope.collections.map(function (collection) {
                                collection.selected = false;
                                return collection;
                            });
                        }

                        $scope.getProducts();
                    }
                });
        };

        $scope.showExportDialog = function (ev) {
            $scope.exportType = '';
            $mdDialog.show({
                templateUrl: "exportDialog",
                scope: $scope,
                preserveScope: true,
                fullscreen: true,
                targetEvent: ev
            });
        };

        $scope.showJsonDialog = function () {
            $mdDialog.show({
                templateUrl: "json.html",
                scope: $scope,
                preserveScope: true,
                fullscreen: true
            });
        };

        $scope.openScannerDialog = function () {
            $mdDialog.show({
                templateUrl: "scannerDialog",
                scope: $scope,
                preserveScope: true,
                fullscreen: true
            })
                .finally(function () {
                    Scanner.stop();
                });
            $timeout(function () {
                Scanner.start()
                    .then(function (code) {
                        $scope.filters.searchTerm = code;
                        $scope.getProducts();
                        Scanner.stop();
                        $mdDialog.cancel();
                    })
                    .catch(function (err) {
                        $mdToast.showSimple("Error encountered while scanning : " + err.message);
                    })
            }, 1000);
        };


        $scope.getNewPrice = function (price) {
            return Math.floor(price + (price * ($scope.updatePrice.salePrice / 100)));
        };


        $scope.onUpdate = function () {

        }


        $scope.download = function (ev) {
            if (!$scope.exportType) {
                return;
            }
            $mdDialog.cancel();
            $mdToast.show({
                template: '<md-toast><div layout layout-align="space-between center" class="full-width md-toast-content" flex>' +
                    '<md-progress-circular class="md-warn" md-diameter="20"></md-progress-circular>' +
                    '<span style="margin-left: 20px">Exporting Products ...</span>' +
                    '</div></md-toast>',
                hideDelay: 0,
                position: 'bottom right',
                autoWrap: true
            })
            ProductExport.export($scope.selected, $scope.exportType)
                .then(function () {
                    $mdToast.showSimple("File export complete");
                })
                .catch(function (err) {
                    console.log('err', err);
                    $mdToast.showSimple("Error encountered while saving the file : " + err.message);
                })
        };

        $scope.clearSearchTerm = function () {
            $scope.searchTerm = '';
        };

        $scope.downloadImages = function () {
            $scope.downloadingImages = true;
            var data = $scope.selected.map(function (p) {
                return p.gallery.map(function (o) {
                    return o._id;
                });
            });
            data = _.flatten(data);
            // var data = $scope.product.gallery.map(function (o) {
            //     return o._id;
            // });
            $http.post(Base.getBaseUrl() + "/images/download", {files: data}, {responseType: 'arraybuffer'})
                .then(function (res) {
                    saveAs(new Blob([res.data], {type: "application/zip"}), "Images-Requested-Aarida" + ".zip");
                    $scope.downloadingImages = false;
                })
                .catch(function (err) {
                    console.log(err);

                })
        };

        $scope.quickViewProduct = function ($event, product) {
            $event.stopPropagation();
            $mdDialog.show({
                templateUrl: "app/modules/products/quickViewDialog/quickView.tmpl.html",
                fullscreen: true,
                targetEvent: $event,
                clickOutsideToClose: true,
                escapeToClose: true,
                locals: {
                    product: product._id,
                    getLowestPrice: $scope.getLowestPrice,
                    frontEndUrl: $scope.frontEndUrl,
                    previewProduct: null
                },
                controller: 'product.quickView.controller'
            })
                .then(function (data) {
                    if (data.updatedData) {
                        $scope.getProducts();
                    }
                })
                .catch(function (data) {
                    if (data.updatedData) {
                        $scope.getProducts();
                    }
                    console.log('Updated Error', data)
                });
        };


        $scope.getProductType = function (product) {
            switch (product.productType) {
                case 0:
                    return "Simple";

                case 1:
                    return "Customizable";
            }
        };

        $scope.properName = function (name) {
            return Utils.capitalize(name);
        };


        $scope.performSmartAction = function (ev) {
            switch ($scope.bulk.actionModel) {
                case 0:
                    $scope.openDetailsPage($scope.selected[0], 0, ev);
                    break;

                case 1:
                    $scope.openDetailsPage($scope.selected[0], 0, ev);
                    break;

                case 2:
                    $scope.showDuplicationConfirmation($scope.selected[0], ev);
                    break;

                case 3:
                    $scope.moveToTrash($scope.selected[0], null, ev);
                    break;

                case 4:
                    $scope.downloadImages(ev);
                    break;

                case 5:
                    $scope.showExportDialog(ev);
                    break;


                case 6:
                    $scope.editPrice(ev);
                    break;

            }
        };

        function searchProducts(searchText) {
            if (!searchText) {
                return [];
            }
            return RestManager.getResource('/products/admin/fastSearch/' + searchText, 'products');
        }


        $scope.getProducts();
        $scope.fetchCollections();
        $scope.init();

        if ($scope.productIds) {
            $scope.fetchProductsFromAnywhere();
        }
    }

})();


/**
 * Created by kumardivyarajat on 04/12/16.
 */
angular.module("app.products")
    .controller("products.add.controller", ["$scope", "$location", "AuthManager", "$state", "$log", "$rootScope", "$mdBottomSheet", "Rollbar", "hotkeys", "Utils", "$mdToast", "$stateParams", "product", "RestManager", "$window", "$interval", "$mdDialog", function ($scope, $location, AuthManager, $state, $log, $rootScope, $mdBottomSheet, Rollbar, hotkeys, Utils,
                                                     $mdToast, $stateParams, product, RestManager, $window, $interval, $mdDialog) {
        $log.info("Products Add Home", $stateParams);

        $scope.$parent.backState = "app.products.all";

        $scope.file = null;
        $scope.currentUser = AuthManager.getCurrentUser();
        $scope.dateAgo = Utils.dateAgo;
        console.log("products.add.controller.js", "#qw", $stateParams);
        $scope.showChat = !!$stateParams.openNotes;

        $scope.tabs = [
            {
                name: 'general_information',
                link: 'app.products.add.home',
                shortcutBinding: 'ge'
            }, {
                name: 'categories',
                link: 'app.products.add.categories',
                shortcutBinding: 'ca'
            }, {
                name: 'images',
                link: 'app.products.add.images',
                shortcutBinding: 'im'
            }, {
                name: 'attributes',
                link: 'app.products.add.attributes',
                shortcutBinding: 'at'
            }, {
                name: 'variations',
                link: 'app.products.add.variations',
                shortcutBinding: 'va'
            }, {
                name: 'customisation',
                link: 'app.products.add.customisation',
                shortcutBinding: 'cu'
            }, {
                name: 'delivery',
                link: 'app.products.add.packaging',
                shortcutBinding: 'pk'
            }, {
                name: 'finish',
                link: 'app.products.add.finish',
                shortcutBinding: 'fi'
            }
        ];

        $scope.tabIndex = 0;

        var HotKeys = hotkeys.bindTo($scope);

        HotKeys
            .add({
                combo: 'mod+s',
                description: 'Save/Update Product',
                callback: function (e) {
                    e.preventDefault();
                    $scope.saveProduct(false);
                }
            })
            .add({
                combo: 'mod+left',
                description: 'Move left in the tabs',
                callback: function (e) {
                    e.preventDefault();
                    if ($scope.tabIndex !== 0) {
                        var index = $scope.tabIndex - 1;
                        console.log('Left : Moving to', index);
                        $scope.goto($scope.tabs[index].link, index);
                    }
                }
            })
            .add({
                combo: 'mod+right',
                description: 'Move right in the tabs',
                callback: function (e) {
                    e.preventDefault();
                    if ($scope.tabIndex !== ($scope.tabs.length - 1)) {
                        var index = $scope.tabIndex + 1;
                        console.log('Right : Moving to', index);
                        $scope.goto($scope.tabs[index].link, index);
                    }
                }
            })
            .add({
                combo: 'mod+p',
                description: 'Open Product Preview',
                callback: function (e) {
                    e.preventDefault();
                    $scope.openPreviewDialog();
                }
            });


        if ($stateParams.slug && !$stateParams.newProduct) {
            $scope.slug = $stateParams.slug;

            if (product[0].featured_image && product[0].featured_image._id) {
                product[0].featured_image = product[0].featured_image._id;
            }

            $scope.product = product[0];
            $scope.editingMode = true;
            $scope.$parent.pageTitle = $scope.product.name;
            $scope.$parent.actionButtonText = "Update Product";
            $scope.$parent.copyTitleButton = true;
            $scope.$parent.copyTitleTooltip = 'Copy Product Name';
            if (product.productType !== 1) {
                $scope.tabs.splice(5, 1);
            }
            $scope.tabIndex = _.findIndex($scope.tabs, function (tab) {
                return tab.link === $state.current.name;
            });
            $scope.tabs.forEach(function (tab, index) {
                HotKeys
                    .add({
                        combo: 'mod+' + (index + 1),
                        description: 'Move to the ' + _.capitalize(tab.name) + ' tab',
                        callback: function (e) {
                            console.log('aa');
                            e.preventDefault();
                            $scope.goto(tab.link, index);
                        }
                    });
            });

            console.log('Tabs', $scope.tabs);
            // $scope.$parent.backState = "app.products.all({page : " + $stateParams.page + ", limit : " + $stateParams.limit + ",order : " + $stateParams.order + " })";
        } else {
            $scope.$parent.pageTitle = "Add Product";
            $scope.$parent.actionButtonText = "Save Product";
            $scope.product = {
                categories: [],
                variations: [],
                tags: [],
                attributes: [],
                gallery: [],
                seo: {
                    keywords: [],
                    description: ""
                }
            };
            console.log("From products add home", $stateParams.dupId);
            RestManager.getResource("/products/new", "products")
                .then(function (products) {
                    console.log("/products/add/" + products[0]._id);
                    $scope.product._id = products[0]._id;
                    $scope.editingMode = false;
                    $scope.slug = products[0]._id;
                    // $location.path("/products/add/" + products[0]._id);
                    $state.transitionTo("app.products.add.home", {
                        slug: products[0]._id,
                        newProduct: true
                    }, {reload: true, location: "replace", notify: false});
                })
                .catch(function (err) {
                    console.log(err);
                });
            // $scope.$parent.backState = "app.products.all({page : 1, limit : 5, order : 'name'})";
        }

        $scope.$watch("product", function (newVal, oldVal) {
            console.log(oldVal, newVal);
        }, true);

        // Sub-header Config
        $scope.$parent.nestedState = true;
        $scope.$parent.showActionButton = true;

        // $scope.$parent.backState = $rootScope.previousState + "(" + $rootScope.previousParams + ")";
        $scope.$parent.onActionButtonClick = function () {
            $scope.saveProduct();
        };

        $scope.openPreviewDialog = function (ev) {
            $mdDialog.show({
                templateUrl: "app/modules/products/quickViewDialog/quickView.tmpl.html",
                fullscreen: true,
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                locals: {
                    product: null,
                    getLowestPrice: $scope.getLowestPrice,
                    frontEndUrl: $scope.frontEndUrl,
                    previewProduct: $scope.product
                },
                controller: 'product.quickView.controller'
            })
        }

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.saveProduct = function (byPassValidation) {
            $mdDialog.cancel();
            if ($scope.editingMode && !byPassValidation) {
                var a = $scope.validate($scope.product);
                console.log(a)
                $scope.validationMessages = a.messages;
                $scope.showContinueButton = !a.errors;
                if (a.hasError) {
                    $scope.showBottomSheet();
                    return;
                }
            }
            // if ($scope.product.productType == 1) {
            //     console.log('saveProduct', $scope.product);
            //     return;
            // }
            var data = {};
            angular.copy($scope.product, data);
            data = $scope.formatForBackEnd(data);
            console.log("data", data);
            var logMessage;
            if ($scope.editingMode) {
                logMessage = "Successfully Updated Product";
                $scope.autoPromise = RestManager.putResource("/products/" + data._id, data, "products")
            } else {
                logMessage = "Successfully Saved Product";
                $scope.autoPromise = RestManager.postResource("/products", data, "products")
            }
            $scope.$parent.actionButtonDisabled = $scope.autoPromise;
            $scope.saving = true;
            $scope.autoPromise
                .then(function (product) {
                    $scope.saving = false;
                    $mdToast.hide()
                        .then(function () {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(logMessage)
                                    .position("bottom right")
                                    .capsule(false)
                                    .action("View on Website")
                                    .highlightAction(true)
                                    .highlightClass('md-warn')
                                    .hideDelay(8000)
                            ).then(function (res) {
                                if (res === 'ok') {
                                    var url = $scope.frontEndUrl + "/product/" + product[0].slug;
                                    $window.open(url, '_blank');
                                }
                            });
                        });
                    if (!$scope.editingMode) {
                        $state.go("app.products.add.home", {
                            slug: $scope.product._id,
                            newProduct: false,
                            name: $scope.product.name
                        }, {reload: true, location: "replace", notify: true});
                    }
                    $mdDialog.show({
                        template: '<md-dialog class="relative" flex="40">' +
                            // '<img src="assets/images/success-art.png">' +
                            '<md-dialog-content class="md-padding"><section layout="column" layout-align="center center">' +
                            // '<div class="check_mark">' +
                            // '  <div class="sa-icon sa-success animate">' +
                            // '    <span class="sa-line sa-tip animateSuccessTip"></span>' +
                            // '    <span class="sa-line sa-long animateSuccessLong"></span>' +
                            // '    <div class="sa-placeholder"></div>' +
                            // '    <div class="sa-fix"></div>' +
                            // '  </div>' +
                            // '</div>' +
                            '<div class="svg">' +
                            '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">' +
                            '  <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>' +
                            '  <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>' +
                            '</svg>' +
                            '<p class="text-center success">Saved product successfully</p>' +
                            '</div>' +
                            '<md-button ng-click="cancel();" class="md-warn" style="width: 150px; border-radius: 32px; border: 1px solid currentColor;"> Okay !</md-button>' +
                            '</section> </md-dialog-content>' +
                            '</md-dialog>',
                        scope: $scope,
                        preserveScope: true,
                        clickOutsideToClose: true,
                        escapeToClose: true
                    });
                    $log.info("Saved Products", product, $scope.editingMode);
                })
                .catch(function (err) {
                    $scope.saving = false;
                    if (err.code === 11000) {
                        $scope.error = [err.message];
                    } else if (err.code === 409) {
                        $scope.error = _.map(err.message, function (o) {
                            return o.error
                        })
                    }
                    console.log(err.code, err.message, $scope.error);
                    $mdDialog.show({
                        templateUrl: "errorDialog.html",
                        scope: $scope,
                        preserveScope: true
                    })
                })

        };

        $scope.showBottomSheet = function () {
            $mdDialog.show({
                template: '<md-dialog>' +
                    '<md-dialog-content>' +
                    '<div class="svg">' +
                    '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">' +
                    '<circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>' +
                    '<line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>' +
                    '<line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>' +
                    '</svg>' +
                    '<p class="text-center error">{{showContinueButton ? "Some warnings with the product. Please review." : "Cannot save product. Validation Error with product"}}</p>' +
                    '</div>' +
                    '<md-list ng-cloak>' +
                    '<md-list-item ng-repeat="message in validationMessages" layout layout-align="start center">' +
                    '<div layout layout-align="start center">' +
                    '<md-icon class="pointer" ng-class="{\'red-text\' : message.type == \'error\', \'orange-text\' : message.type == \'warn\'}">' +
                    '{{ message.type == \'error\' ? \'report_problem\' : \'error_outline\' }}' +
                    '<md-tooltip>{{ message.type == \'error\' ? \'Error. Needs to be fixed.\' : \'Warning. Might cause unexpected behaviour.\' }}</md-tooltip>' +
                    '</md-icon>' +
                    '<span style="margin-left: 20px;" class="md-body-1">{{ message.message }}</span>' +
                    '</div>' +
                    ' </md-list-item>' +
                    '</md-list>' +
                    '</md-dialog-content>' +
                    '<md-dialog-actions>' +
                    '<md-button class="md-raised md-primary" ng-if="showContinueButton" ng-click="saveProduct(true)"><md-icon>save</md-icon><span>Save anyway</span></md-button>' +
                    '</md-dialog-actions>' +
                    ' </md-dialog>"',
                scope: $scope,
                preserveScope: true,
                escapeToClose: true,
                parent: angular.element(document.body),
                disableParentScroll: true,
                clickOutsideToClose: true
            })
        };

        $scope.hideBottomSheet = function () {
            $mdBottomSheet.hide();
        };

        $scope.validate = function (product) {
            var hasError = false;
            var messages = [];
            var error = 0;
            var warn = 0;

            console.log(product);

            if (!product.name) {
                hasError = true;
                messages.push({
                    type: "error",
                    message: "PRODUCT NAME : Name cannot be empty for a product"
                });
                error++;
            }

            if (!product.slug) {
                hasError = true;
                messages.push({
                    type: "error",
                    message: "PRODUCT SLUG : Slug cannot be empty for a product"
                });
                error++;
            }

            if (!product.sku) {
                hasError = true;
                messages.push({
                    type: "error",
                    message: "PRODUCT SKU : Sku cannot be empty for a product"
                });
                error++;
            }

            if (!product.published && product.sku && product.sku.length === 4) {
                hasError = true;
                messages.push({
                    type: "warn",
                    message: "PRODUCT SKU : Seems like you are using a temp SKU. This might lead to unexpected behaviour in the future. Please regenerate it before publishing."
                });
                warn++;
            }

            if (product.published && product.sku && product.sku.length === 4) {
                hasError = true;
                messages.push({
                    type: "error",
                    message: "PRODUCT SKU : Seems like you are using a temp SKU. The product cannot be published until the SKU is regenerated."
                });
                error++;
            }

            // if (!product.description) {
            //     messages.push({
            //         type: "warn",
            //         message: "PRODUCT DESCRIPTION : Description is empty. Please fill it up later otherwise the product page will be blank."
            //     });
            // }

            if (product.productType !== 0 && product.productType !== 1) {
                messages.push({
                    type: "warn",
                    message: "PRODUCT TYPE : Product Type has been left blank. Changing it to simple product."
                });
                warn++;
            }

            if (product.categories.length === 0) {
                hasError = true;
                messages.push({
                    type: "error",
                    message: "CATEGORY : The product will not be displayed anywhere as the product category has not been set."
                });
                error++;
            }

            if (!product.published && product.gallery.length === 0) {
                hasError = true;
                messages.push({
                    type: "warn",
                    message: "PRODUCT IMAGES : Please set the product images before publishing."
                });
                warn++;
            }

            if (!product.published && !product.featured_image) {
                hasError = true;
                messages.push({
                    type: "warn",
                    message: "PRODUCT FEATURED IMAGE : Please set a featured image for the product."
                });
                warn++;
            }

            if (product.published && product.gallery.length === 0) {
                hasError = true;
                messages.push({
                    type: "error",
                    message: "PRODUCT IMAGES : Cannot publish product as product images are not set."
                });
                error++;
            }

            if (product.published && !product.featured_image) {
                hasError = true;
                messages.push({
                    type: "warn",
                    message: "PRODUCT FEATURED IMAGE : Cannot publish product as featured image is not set."
                });
                warn++;
            }

            if ((product.productType === 0 || !product.productType) && product.attributes.length === 0) {
                hasError = true;
                messages.push({
                    type: "error",
                    message: "ATTRIBUTES : Attributes for a product must be set to make it visible everywhere"
                });
                error++;
            }

            if ((product.productType === 0 || !product.productType) && product.variations.length === 0) {
                hasError = true;
                messages.push({
                    type: "error",
                    message: "VARIATIONS : Variations are not defined for the product. At least one variation should be present."
                });
                error++;
            }

            if (product.variations) {
                product.variations.every(function (variation) {
                    if ((!variation.stockAndPrice.price.mrp || variation.stockAndPrice.price.mrp === 0) ||
                        (!variation.stockAndPrice.price.salePrice || variation.stockAndPrice.price.salePrice === 0) ||
                        (!variation.stockAndPrice.price.msp || variation.stockAndPrice.price.msp === 0)
                    ) {
                        console.log(variation);
                        hasError = true;
                        messages.push({
                            type: "warn",
                            message: "VARIATIONS : The price of variation is not set properly. Some prices might be 0.Please check and retry if needed."
                        });
                        warn++;
                        return false;
                    } else {
                        return true;
                    }
                })
            }


            if (product.attributes) {
                var attrCount = 0;
                product.attributes.every(function (attributeData) {
                    attributeData.isVariation && attrCount++;
                    if ((!attributeData.attribute) || !attributeData.selectedValues || (!attributeData.selectedValues.length)
                    ) {
                        hasError = true;
                        messages.push({
                            type: "warn",
                            message: "ATTRIBUTE : Some attributes do have a value selected. Either delete them or select values."
                        });
                        warn++;
                        return false;
                    } else {
                        return true;
                    }
                });

                if (attrCount !== 1) {
                    hasError = true;
                    messages.push({
                        type: "error",
                        message: "ATTRIBUTE : Multiple attributes with variation selected is not possible. Please select size as a variation."
                    });
                    error++;
                }
            }

            return {messages: messages, errors: error, warn: warn, hasError: hasError};
        };

        $scope.formatForBackEnd = function (product) {

            if (!product.productType) {
                product.productType = 0;
            }

            if (!product.featured) {
                product.featured = false;
            }

            if (product.attributes) {
                product.hasEmbroidery = !!product.attributes.filter(function (attributeData) {
                    return attributeData.attribute.meta_key === 'Embellishment' && _.some(attributeData.attribute.meta_values, function (valueData) {
                        return valueData.value === 'Hand Embroidery' && _.includes(attributeData.selectedValues, valueData._id);
                    })
                }).length;

                console.log('Product has embroidery', product.hasEmbroidery);
            }

            _.forEach(product.attributes, function (attributeData, i) {
                product.attributes[i].attribute = attributeData.attribute._id;
            });

            _.forEach(product.categories, function (category, i) {
                product.categories[i] = category._id;
            });


            _.forEach(product.tags, function (tag, i) {
                if (tag._id) {
                    product.tags[i] = tag._id;
                }
            });

            product.materials = [];

            _.forEach(product.variations, function (variation, i) {
                if (variation.attributes) {
                    if (variation.attributes.length > 0) {
                        product.variations[i].attributes[0].attribute = variation.attributes[0].attribute._id;
                    }
                }
                if (variation.materials) {
                    product.materials = product.materials.concat(variation.materials.map(function (materialData) {
                        return materialData.materialId
                    }))
                }
            });

            product.materials = _.uniq(product.materials);

            product.visibility = parseInt(product.visibility);
            return product;
        };


        $scope.goto = function (where, tabIndex) {
            var newProduct = !$scope.editingMode;
            $scope.tabIndex = tabIndex;
            $state.go(where, {
                slug: $scope.product._id,
                newProduct: newProduct,
                name: $scope.product.name
            }, {notify: true, location: true})
        };

        $scope.updateUrl = function (index) {
            // console.log("label", index);
        };

        $scope.$watch('product.customisation', function (newVal, oldVal) {
            if ($scope.product.customisation) {
                $scope.product.customisation.isModified = true;
            }
        }, true);


        // var interval = $interval(function () {
        //     if ($scope.editingMode && !$scope.saving) {
        //         $log.info("Auto Save Firing");
        //         $mdToast.show({
        //             hideDelay: 100000,
        //             position: 'bottom right',
        //             template: '<md-toast class="md-accent"><md-progress-circular md-mode="indeterminate" class="md-warn" md-diameter="20"></md-progress-circular> <span class="md-toast-text black-text" flex>Auto Saving Product</span> </md-toast>'
        //         });
        //         $scope.saveProduct();
        //     }
        // }, 60000);

        $scope.$watch('file', function (newVal) {
            if (newVal) {
                $scope.handleDrop()
            }
        });

        /* set up drag-and-drop event */
        $scope.handleDrop = function () {
            // e.stopPropagation();
            // e.preventDefault();
            $mdToast.show({
                template: '<md-toast>' +
                    '<div class="md-toast-content" layout layout-align="center center">' +
                    '<md-progress-circular md-diameter="20" class="md-warn"></md-progress-circular>' +
                    '<span class="md-caption" style="margin-left: 20px;">Reading File</span>' +
                    '</div>' +
                    '</md-toast>',
                hideDelay: 3000,
                position: 'bottom right'
            });
            $scope.status = "Reading File..";
            var files = [$scope.file];
            console.log(files);
            var i, f;
            for (i = 0; i !== files.length; ++i) {
                f = files[i];
                var reader = new FileReader();
                var name = f.name;
                reader.onload = function (e) {
                    var data = e.target.result;
                    $scope.product = JSON.parse(data);
                    console.log('Product', $scope.product);
                    $scope.status = "Ready";
                    $mdToast.hide();
                };
                reader.readAsBinaryString(f)
            }
        }

        $scope.publishNote = function () {
            if ($scope.message) {
                if (!$scope.product.notes) {
                    $scope.product.notes = [];
                }

                var data = {
                    comment: $scope.message,
                    date: new Date(),
                    by: $scope.currentUser._id,
                    byName: $scope.currentUser.name,
                    references : $scope.findReferences($scope.message),
                    saving : true
                };

                var index = $scope.product.notes.length;

                $scope.product.notes.push(data);

                RestManager.patchResource('/products/admin/comments/' + $scope.product._id, data, 'products')
                    .then(function (products) {
                        $scope.product.notes[index].saving = false;
                    })
                    .catch(function (err) {
                        $scope.product.notes[index].error = true;
                    });

                $scope.message = '';
            }
        };


        $scope.findReferences = function (message) {
            var regex = /@\[([\s\w]+):([0-9a-z-]+)\]/gi;
            var m;
            var references = [];
            var i= 0;
            while ((m = regex.exec(message)) !== null) {
                // This is necessary to avoid infinite loops with zero-width matches
                if (m.index === regex.lastIndex) {
                    regex.lastIndex++;
                }

                m.forEach(function(match, groupIndex)  {
                    if(groupIndex === 0) {
                        references.push({});
                    }
                    if(groupIndex === 1) {
                        references[i].name  = _.trim(match);
                    }
                    if(groupIndex === 2) {
                        references[i].user  = _.trim(match);
                    }
                });
                i++;
            }
            return references;
        }

        $scope.$on("$destroy", function () {
            // $interval.cancel(interval);
        });

        // $scope.currentNavItem = "general_information";
        // $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
        //     console.log("State Change USccess", ev, to, toParams, from, fromParams);
        //     console.log(to.url.split("/")[1]);
        //
        //     $scope.currentNavItem = to.url.split("/")[1];
        //     console.log($scope.currentNavItem);
        //     // $scope.currentNavItem = getCurrentLinkFromRoute(current);
        // });
    }]);

/**
 * Created by kumardivyarajat on 06/05/17.
 */
angular.module("app.pages", [])
    .controller("pages.controller", ["$scope", "RestManager", function ($scope, RestManager) {

    }]);
/**
 * Created by kumardivyarajat on 06/05/17.
 */
angular.module("app.pages")
    .controller("pages.all.controller", ["$scope", "RestManager", "$stateParams", function ($scope, RestManager, $stateParams) {


        $scope.selected = [];
        $scope.query = {
            order: '-createdAt',
            limit: 25,
            page: 1,
            search: ""
        };
        if ($stateParams.page) {
            $scope.query.page = $stateParams.page;
        }

        if ($stateParams.limit) {
            $scope.query.limit = $stateParams.limit;
        }

        if ($stateParams.order) {
            $scope.query.sort = $stateParams.order;
        }

        if ($stateParams.searchTerm) {
            $scope.query.search = $stateParams.search;
        }


        $scope.getPages = function () {
            $scope.promise = RestManager.postResource("/static/all", $scope.query, "pages", ["total"]);
            $scope.promise.then(function (result) {
                console.log(result);
                $scope.pages = result.pages;
                $scope.total = result.total;
            }).catch(function (err) {
                console.log(err);
            })
        };
    }]);
/**
 * Created by kumardivyarajat on 06/05/17.
 */
angular.module("app.pages")
    .controller("pages.add.controller", ["$scope", "RestManager", "$stateParams", "$mdToast", "$state", function ($scope, RestManager, $stateParams, $mdToast, $state) {
        $scope.editingMode = !!$stateParams.id;
        $scope.promise = {};
        $scope.codeMirrorOptions = {
            // mode: "text/html",
            autoCloseTags: true,
            extraKeys: {
                "Ctrl-Space": "autocomplete",
                "Ctrl-Q": function (cm) {
                    cm.foldCode(cm.getCursor());
                }
            },
            mode: 'htmlmixed',
            fixedGutters: true,
            lineNumbers: true,
            theme: 'material',
            indentUnit: 4,
            indentWithTabs: true,
            lineWrapping: true,
            styleActiveLine: false,
            matchBrackets: true,
            keyMap: "sublime",
            foldGutter: true,
            gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"]
        };

        $scope.fetchPageData = function () {
            $scope.promise = RestManager.getResource("/static/admin/" + $stateParams.id, "pages");
            $scope.promise.then(function (pages) {
                $scope.page = pages[0];
                $scope.page.content = html_beautify($scope.page.content, {
                    indent_size: 4,
                    indent_with_tabs: true,
                    end_with_newline: true,
                    brace_style: 'expand'
                });
            }).catch(function (err) {
                console.log(err);
            })
        };


        $scope.savePage = function () {
            $scope.promise = "";

            if ($scope.editingMode) {
                $scope.revisions = $scope.page.edits.length;
                delete $scope.page.edits;
                $scope.promise = RestManager.putResource("/static", $scope.page, "pages");
            } else {
                $scope.revisions = 0;
                $scope.promise = RestManager.postResource("/static", $scope.page, "pages");
            }

            $mdToast.show({
                hideDelay: 100000,
                position: 'bottom right',
                template: '<md-toast class="md-accent"><md-progress-circular md-mode="indeterminate" class="md-warn" md-diameter="20"></md-progress-circular> <span class="md-toast-text black-text" flex>Completing Task</span> </md-toast>'
            });

            $scope.promise
                .then(function (pages) {
                    $mdToast.hide();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Saved Data')
                            .position("bottom right")
                            .hideDelay(3000)
                    );
                    $scope.page.edits = new Array($scope.revisions + 1);
                    $state.go("app.pages.edit", {slug: pages[0].slug}, {
                        location: "replace",
                        reload: false,
                        notify: true
                    });
                })
                .catch(function (err) {
                    $mdToast.hide();
                    console.log(err);
                })
        };


        if ($scope.editingMode) {
            $scope.fetchPageData();
        }

    }]);

/**
 * Created by kumardivyarajat on 04/12/16.
 */
angular.module("app.orders", [])
    .controller("orders.controller", ["$scope", "$log", function ($scope, $log) {

    }]);

/**
 * Created by abhinav on 12/11/19.
 */

(function () {
    'use strict';
    updateStock.$inject = ["$scope", "$mdDialog", "lineItem", "orderNumber", "orderId", "Base", "RestManager", "$mdToast", "currentStock"];
    angular.module("app.orders")
        .controller("updateStock-controller", updateStock);

    function updateStock($scope, $mdDialog, lineItem, orderNumber, orderId, Base, RestManager, $mdToast, currentStock) {
        $scope.lineItem = lineItem;
        console.log('updateStock-controller', 'updateStock::12', lineItem);
        $scope.orderNumber = orderNumber;
        $scope.mediaUrl = Base.getMediaUrl();
        $scope.newStock = {
            description: 'Stock update for Order number: ' + orderNumber + '.',
            updateQuantity: $scope.lineItem.quantity,
            orderId: orderId,
            variationText: lineItem.selectedVariationText,
            lineItemId: lineItem._id,
            productId: lineItem.productId,
            productName: lineItem.name
        };
        $scope.currentStock = currentStock;
        $scope.isUpdating = false;


        $scope.close = close;
        $scope.updateStock = updateStock;
        $scope.checkStockStatus = checkStockStatus;

        function close() {
            $mdDialog.cancel();
        }

        function checkStockStatus() {
            RestManager.getResource('/variations/' + lineItem.variationId, 'variations')
                .then(function (res) {
                    if (res[0].stockAndPrice.stock.manageStock) {
                        $scope.currentStock = res[0].stockAndPrice.stock.quantity;
                    } else {
                        return $mdDialog.show(
                            $mdDialog.alert({
                                title: 'STOP',
                                multiple: true,
                                ok: 'OKKKAY',
                                textContent: 'Stock Management is not required for this product as the Manage Stock property of this variation is not set. Kindly consult an admin to know more.'
                            })
                        );
                    }
                })
                .then(function(res){
                    console.log("updateStock-controller.js", "REs", res);
                    if(res){
                        $mdDialog.hide({disableManageStock: true})
                    }
                    // $mdDialog.hide({})
                })
                .catch(function (err) {
                    $mdToast.showSimple("Error in fetching current stock by variationId" + err.message);
                });
        }

        function updateStock() {
            $scope.isUpdating = true;
            var productOos, variationOos, stockUpdate;
            RestManager.postResource('/stockUpdates/' + $scope.lineItem.variationId, $scope.newStock, 'stockUpdates')
                .then(function (res) {
                    if (res && res.length) {
                        productOos = res[0].productOutOfStock;
                        variationOos = res[0].variationOutOfStock;
                        stockUpdate = res[0];
                        return RestManager.patchResource('/order/updateLineItemStock/' + orderId, {
                            lineItemId: $scope.lineItem._id,
                            productName: $scope.lineItem.name,
                            variationText: $scope.lineItem.selectedVariationText,
                            updatedStockId: res[0]._id
                        }, 'orders');
                    } else {
                        return null;
                    }
                })
                .then(function (res) {
                    $scope.isUpdating = false;
                    if (res) {
                        console.log(res)
                        $mdDialog.hide({
                            order: res[0],
                            stockUpdate: stockUpdate,
                            productOos: productOos,
                            variationOos: variationOos
                        });
                        $mdToast.showSimple("Stock Updated");
                    }
                })
                .catch(function (err) {
                    $scope.isUpdating = false;
                    $mdToast.showSimple("Error in updating stock" + err.message);
                });
        }

        $scope.checkStockStatus();
    }
})(angular);


(function () {
    'use strict';

    angular.module('app.orders')
        .service('ReviewService', reviewService);

    function reviewService() {

        function Rating(data) {
            this.key = data.key;
            this.value = data.value;
        }

        function Review(data) {
            this.ratings = data.ratings.map(function (r) {
                return new Rating(r);
            });
            this.product = this.cleanProductData(data.product);
            this.comment = data.comment;
            this.order = data.orderId;
            this.createdBy = data.createdBy;
            this.createdByName = data.createdByName;
            this.savingData = false;
            this.saveError = null;
        }


        Review.prototype.cleanProductData = function (p) {
            var product = p.product;
            console.log(product);
            return {
                _id: product._id,
                name: product.name,
                price: product.price,
                image: product.featured_image.urls.medium,
                isCustomisable: product.isCustomisable
            };
        };


        Review.prototype.json = function () {
            return {
                product: this.product.isCustomisable ? null : this.product._id,
                comment: this.comment,
                order: this.order,
                ratings: this.ratings.map(function (r) {
                    return {
                        key: r.key,
                        value: r.value
                    };
                }),
                createdBy : this.createdBy,
                createdByName : this.createdByName
            };
        };


        var types = {
            Review: Review,
            Rating: Rating
        };


        return {
            types: types
        };
    }

})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 01/01/20, 3:36 PM
 *
 */

(function () {
    'use strict';

    RateController.$inject = ["$scope", "RestManager", "$mdDialog", "$mdToast", "order", "shipmentId"];
    angular.module('app.orders')
        .controller('rate-calculator.controller', RateController);

    function RateController($scope, RestManager, $mdDialog, $mdToast, order, shipmentId) {

        $scope.creatingShipment = false;
        $scope.fetchingRates = true;
        $scope.selectedMode = null;

        $scope.rates = [];
        $scope.save = save;
        $scope.cancel = close;
        $scope.fetchRates = fetchRates;

        function fetchRates() {
            $scope.fetchingRates = true;
            RestManager.postResource('/shipments/checkPrices', {
                orderId: order._id,
                shipmentId: shipmentId
            }, 'rates')
                .then(function (rates) {
                    $scope.rates = _.chain(rates)
                        .map(function (rate) {
                            rate.modeKey = _.capitalize(rate.modeKey);
                            return rate;
                        })
                        .orderBy(['serviceable', 'price'])
                        .value();
                    $scope.fetchingRates = false;
                })
                .catch(function (err) {
                    $scope.fetchingRates = false;
                    $mdToast.showSimple('Error fetching rates: ' + err.message);
                })
        }

        function save() {
            $scope.creatingShipment = true;
            RestManager.postResource('/shipments/createShipment', {
                orderId: order._id,
                shipmentId: shipmentId,
                modeType: $scope.selectedMode
            }, 'shipments')
                .then(function (result) {
                    console.log("rate-calculator.js", "re", result);
                    $scope.creatingShipment = false;
                    $mdToast.showSimple('Shipment created successfully ');
                    $mdDialog.hide(result);
                })
                .catch(function (error) {
                    $scope.creatingShipment = false;
                    $mdToast.showSimple('Error creating shipment: ' + error.message);
                })
        }

        function close(data) {
            if (data) {
                $mdDialog.hide({data: data});
            } else {
                $mdDialog.cancel();
            }
        }

        $scope.fetchRates();
    }

})(angular);

(function () {
    'use strict';
    updatePaymentController.$inject = ["$scope", "$mdDialog", "RestManager", "$mdToast", "paymentDetails", "capturedPayments", "orderId", "paymentMode", "Users", "orderAmount"];
    angular.module("app.orders")
        .controller('update-order-payment.controller', updatePaymentController);

    function updatePaymentController($scope, $mdDialog, RestManager, $mdToast, paymentDetails, capturedPayments, orderId, paymentMode, Users, orderAmount) {
        $scope.paymentDetails = paymentDetails;
        $scope.capturedPayments = capturedPayments;
        $scope.paymentMode = paymentMode;
        $scope.orderAmount = orderAmount;
        $scope.updatingPaymentPerson = false;
        $scope.updatingCapturedPayment = false;
        $scope.updatingOrderPaymentDetails  = false;
        $scope.updatedCapturedPayment  = false;

        $scope.cancel = cancel;
        $scope.reCalculateTotalAmount = reCalculateTotalAmount;
        $scope.changePaymentPerson = changePaymentPerson;
        $scope.updateCapturedPayment = updateCapturedPayment;
        $scope.updateOrderLevelPaymentDetails = updateOrderLevelPaymentDetails;
        $scope.updateParentPage = updateParentPage;


        function cancel() {
            $mdDialog.cancel();
        }

        function reCalculateTotalAmount(amount, mode, i) {
            console.log("order-payment-dialog.controller.js", "reCalculateTotalAmount", amount, mode, i);
            var totalCapturedCardAmount = $scope.capturedPayments.reduce(function (acc, val) {
                console.log("order-payment-dialog.controller.js", "Val", val);
                return acc + val.cardAmount;
            }, 0);
            var totalCapturedCashAmount = $scope.capturedPayments.reduce(function (acc, val) {
                console.log("order-payment-dialog.controller.js", "Val", val);
                return acc + val.cashAmount;
            }, 0);

            var totalCapturedAmount = totalCapturedCardAmount + totalCapturedCashAmount;
            console.log("order-payment-dialog.controller.js", "reCalculateTotalAmount", totalCapturedAmount);
            switch (mode) {
                case "card":
                    $scope.capturedPayments[i].cardAmount = amount;
                    $scope.paymentDetails.totalPaidAmount = totalCapturedAmount;
                    $scope.paymentDetails.totalPendingAmount = $scope.orderAmount - $scope.paymentDetails.totalPaidAmount;
                    console.log("order-payment-dialog.controller.js", "reCalculateTotalAmount", $scope.paymentDetails.totalPaidAmount, $scope.paymentDetails.pendingAmount);
                    break;

                case "cash":
                    $scope.capturedPayments[i].cashAmount = amount;
                    $scope.paymentDetails.totalPaidAmount = totalCapturedAmount;
                    $scope.paymentDetails.totalPendingAmount = $scope.orderAmount - $scope.paymentDetails.totalPaidAmount;
                    break;
            }

        }


        function changePaymentPerson(event, i) {
            $scope.updatingPaymentPerson = true;
            Users.selectUserDialog(event, {fields: 'name,mobile,role', roles: 'admin,designer', multiple: false})
                .then(function (user) {
                    $scope.updatingPaymentPerson = false;
                    $scope.capturedPayments[i].createdBy = user.name;

                })
                .catch(function (err) {
                    $scope.updatingHandler = false;
                    $mdToast.showSimple('Error updating handler : ' + err.message);
                });
        }

        function updateCapturedPayment(e, i) {
            $scope.updatingCapturedPayment = true;
            var payload = {
                cashAmount: $scope.capturedPayments[i].cashAmount,
                cardAmount: $scope.capturedPayments[i].cardAmount,
                paidBy: $scope.capturedPayments[i].createdBy,
                capturedPaymentIndex: i
            };
            RestManager.patchResource('/order/updateCapturedPaymentsDetails/' + orderId, payload, 'orders')
                .then(function (response) {
                    $scope.updatingCapturedPayment = false;
                    $scope.updatedCapturedPayment  = true;
                    console.log("order-payment-dialog.controller.js", "Response", response);
                    $scope.cashAmount = response[0].capturedPayments[i].cashAmount;
                    $scope.cardAmount = response[0].capturedPayments[i].cardAmount;
                    $scope.paidBy = response[0].capturedPayments[i].createdBy;
                    $scope.capturedPaymentIndex = i;
                })
                .catch(function (err) {
                    $scope.updatingCapturedPayment = false;
                    $mdToast.showSimple("Error in updating captured payments: " + err.message);
                });

        }

        function updateOrderLevelPaymentDetails() {
            $scope.updatingOrderPaymentDetails = true;
            var payload = {
                paidAmount: $scope.paymentDetails.totalPaidAmount,
                pendingAmount: $scope.paymentDetails.totalPendingAmount,
                paymentMode: $scope.paymentMode,
                hasPendingAmount: $scope.paymentDetails.totalPendingAmount > 0 ? true : false
            }
            RestManager.patchResource('/order/updateOrderPaymentDetails/' + orderId, payload, "orders")
                .then(function (response) {
                    $scope.updatingOrderPaymentDetails = false;
                    console.log("order-payment-dialog.controller.js", "response", response);
                })
                .catch(function (err) {
                    $scope.updatingOrderPaymentDetails = false;
                    $mdToast.showSimple("Error in updating order payments: " + err.message);
                });
        }

        function updateParentPage(){
           var changes = {
               cashAmount: $scope.cashAmount,
               cardAmount: $scope.cardAmount,
               paidBy: $scope.paidBy,
               index:  $scope.capturedPaymentIndex
           }
            $mdDialog.hide({updatedData: changes});
        }
    }

})(angular);

(function () {
    'use strict';
    lineItemHistory.$inject = ["$scope", "$mdDialog", "lineItem"];
    angular.module("app.orders")
        .controller("lineItem-history.controller", lineItemHistory);

    function lineItemHistory($scope, $mdDialog, lineItem){
        console.log("lineItem-history.controller.js", "lineItemHistory", lineItem);

        $scope.close = close;
        $scope.lineItem = lineItem;


        function close(){
            $mdDialog.cancel();
        }
    }

})(angular);

/**
 *Created by abhinav on 25/01/19.
 */

angular.module("app.orders")

    .directive('starRating', function () {
        return {
            restrict: 'AEC',
            templateUrl: 'app/modules/orders/orderDetails/directives/template/star-rating.html',
            scope: {
                ratingValue: '=',
                onRatingSelected: '&'
            },
            link: function (scope, elem, attrs) {

                scope.ratingValue = 1;
                scope.max = 5;
                scope.stars = [{filled: true}, {filled: false}, {filled: false}, {filled: false}, {filled: false}];

                var updateStars = function () {
                    scope.stars.forEach(function (star, index) {
                        scope.stars[index].filled = (index + 1) <= scope.ratingValue;
                    });
                };

                scope.toggle = function (index) {
                    scope.ratingValue = index + 1;
                    console.log(scope.ratingValue, "Hhhhhhhhhhh---------------")
                    updateStars()
                    scope.onRatingSelected({
                        data: {
                            rating: scope.ratingValue
                        }
                    });
                };

                // scope.$watch('ratingValue', function (oldVal, newVal) {
                //     if (newVal) {
                //         updateStars();
                //     }
                // });
            },
        };
    });


(function () {
    'use strict';

    reviewController.$inject = ["$scope", "products", "order", "$mdDialog", "AuthManager", "$mdToast", "ReviewService", "RestManager"];
    angular.module("app.orders")
        .controller("orders.review.dialog.controller", reviewController)

    function reviewController($scope, products, order, $mdDialog, AuthManager, $mdToast, ReviewService, RestManager) {

        $scope.currentUser = AuthManager.getCurrentUser();

        $scope.order = order;
        if ($scope.order.hasCustOptions) {
            products = products.filter(function (productData) {
                return !productData.categories.includes('Customisation options');
            })
            products.push({
                product: {
                    featured_image: {
                        urls: {
                            thumbnail: ''
                        }
                    },
                    name: "Customised Product From Store",
                    _id: 12,
                    isCustomisable: true
                }
            });
        }

        $scope.products = products;
        $scope.comments = [];
        $scope.reviews = products.map(function (p) {
            return new ReviewService.types.Review({
                productId: p._id,
                product: p,
                ratings: [{key: 'product_review', value: 1}],
                orderId: order._id,
                comment: null,
                createdBy: $scope.currentUser._id,
                createdByName:  $scope.currentUser.name
            });
        });

        $scope.close = function (data) {
            if (data) {
                $mdDialog.hide({data: data});
            } else {
                $mdDialog.cancel();
            }
        }

        $scope.updateRating = function (data, review) {
            review.ratings[0].value = data.rating;
            console.log($scope.reviews);
        }

        $scope.saveReview = function () {
            $scope.savingReview = true;
            Promise.map($scope.reviews, function (rating) {
                return new Promise(function (resolve, reject) {
                    rating.savingData = true;
                    rating.saveError = null;
                    RestManager.postResource('/review', rating.json(), 'review', {service: 'review'})
                        .then(function (data) {
                            rating.savingData = false;
                            console.log('Saved rating', rating);
                            resolve(true);
                        })
                        .catch(function (err) {
                            rating.savingData = false;
                            rating.saveError = err;
                            console.log('Error saving rating', rating, err);
                            resolve(false);
                        });
                });
            })
                .then(function (result) {
                    if (result.includes(false)) {
                        console.log('Some error occurred');
                        throw new Error('Error while saving review. Some error is present.');
                    } else {
                        return RestManager.putResource('/order/updateReview/' + order._id, {}, 'data');
                    }
                })
                .then(function (result) {
                    $scope.savingReview = false;
                    console.log('Updated Status', result);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Thank you for your review")
                            .position("bottom right")
                            .hideDelay(1000)
                    );
                    $scope.close({saved: true});
                })
                .catch(function (err) {
                    $scope.savingReview = false;
                    console.log('Error saving order rating', err);
                    $mdToast.showSimple('Error saving order rating. Please try again later.');
                });

        };


    }

})(angular);

/**
 * Created by kumardivyarajat on 18/01/17.
 */
angular.module("app.orders")
    .controller("orders.details.controller", ["$scope", "$interval", "$timeout", "$location", "Base", "AuthManager", "$state", "Images", "ProductUtils", "RestManager", "$stateParams", "Utils", "$mdDialog", "$mdToast", "Address", "Users", "StockUpdates", "Workforce", function ($scope, $interval, $timeout, $location, Base, AuthManager, $state, Images, ProductUtils,
                                                       RestManager, $stateParams, Utils, $mdDialog, $mdToast, Address, Users, StockUpdates,
                                                       Workforce) {

        $scope.$parent.nestedState = false;
        $scope.$parent.showActionButton = false;
        $scope.$parent.pageTitle = "Order Details";
        $scope.$parent.nestedState = true;
        $scope.$parent.backState = $stateParams.backState || "app.orders.all";
        $scope.$parent.backParams = $stateParams.backParams ? JSON.parse($stateParams.backParams) : {};
        $scope.fetchingSync = true;
        $scope.orderStatusValue = 0;
        $scope.editAgentBox = false;
        $scope.isNewAddress = false;
        $scope.savingAddress = false;
        $scope.updatingOrgDetails = false;
        $scope.agents = [];
        $scope.agentSearch = '';
        $scope.currentUser = AuthManager.getCurrentUser();
        $scope.showOrderChat = !!$stateParams.openNotes;
        $scope.imageSelected = null;
        $scope.updatingDesigner = false;
        $scope.editMeasurements = false;
        $scope.updateMeasurementForAll = false;
        $scope.editChecklist = false;

        $scope.dateAgo = Utils.dateAgo;

        $scope.fetchOrders = function () {
            $scope.fetchingPayments = true;
            $scope.getStatusConstants();
            $scope.getLineItemStatus();
            $scope.promise = RestManager.getResource("/order/admin/getOrdersById/" + $stateParams.orderId, "orders")

            $scope.promise
                .then(function (result) {
                    $scope.fetchingPayments = false;
                    if (!result[0].flags) {
                        result[0].flags = {};
                    }
                    if (result[0].designImages && result[0].designImages.length) {
                        result[0].designImages = result[0].designImages.reverse();
                    }
                    result[0].orderData.products = result[0].orderData.products.map(function (lineItem, index) {
                        lineItem.selectedVariationText = lineItem.variationText || Utils.getVariationValue(lineItem.variation);
                        lineItem.index = index;
                        lineItem.selectedForManifest = result[0].saleChannel !== 'pos';
                        if (!lineItem._id) {
                            lineItem.disableProductActions = true;
                        }
                        return lineItem;
                    });
                    if (result[0].lineItems) {
                        result[0].lineItems = result[0].lineItems.map(function (lineItem, index) {
                            lineItem.manageStock = true;
                            lineItem.index = index;
                            return lineItem;
                        })
                    }

                    result[0].checklistItems = _.map(result[0].checklist, function (value, key) {
                        return {key: key, value: value, description: Utils.getChecklistDescription(key)}
                    });
                    $scope.order = result[0];
                    $scope.completedChecklists = _.filter($scope.order.checklistItems, function (item) {
                        return item.value
                    }).length;
                    $scope.order.oldStatus = [$scope.order.status];
                    if ($scope.order.organisation) {
                        $scope.orgId = $scope.order.organisation._id;
                    }
                    $scope.totalProductLevelDiscount = $scope.order.orderData.products.reduce(function (acc, product) {
                        return _.round((acc + product.product.discountAmount), 2);
                    }, 0);
                    $scope.totalProductPrice = $scope.order.orderData.products.reduce(function (acc, product) {
                        return _.round((acc + product.product.price), 2);
                    }, 0);

                    $scope.productIds = _.uniq($scope.order.orderData.products.map(function (productData) {
                        return productData.product._id;
                    }));
                    if (_.findIndex($scope.order.statusHistory, function (o) {
                        return o.status === 'delivered' && o.status.indexOf('return') === -1;
                    }) !== -1) {
                        $scope.order.isDelivered = true;
                    }

                    if (!$scope.order.capturedPayments.length) {
                        $scope.fetchingPaymentsError = 'No Payments Found';
                    }


                    $scope.fetchSpSyncStatus();
                    $scope.getOrderStatusValue();
                    $scope.fetchNotifications();
                    $scope.fetchReview();
                    // $scope.generateShortUrl();
                    if ($scope.order.organisation) {
                        $scope.loadAgents();
                    }

                })
                .catch(function (err) {
                    $scope.fetchingPayments = true;
                    console.log("err", err);
                });
        };


        function fetchNotifications() {
            $scope.fetchingNotifications = true;
            $scope.notificationsPromise = RestManager.getResource("/notifications/order/" + $scope.order._id, "notifications")
            $scope.notificationsPromise
                .then(function (notifications) {
                    $scope.fetchingNotifications = false;
                    $scope.notifications = notifications[0].sms.concat(notifications[0].mails);
                    if ($scope.notifications.length === 0) {
                        throw new Error("No Notifications Found");
                    }
                })
                .catch(function (err) {
                    $scope.fetchingNotifications = false;
                    $scope.fetchingNotificationsError = err.message;
                    console.log("notifications error", err);
                })

        }

        function showAwbDialog(ev, lineItem, i) {
            // Appending dialog to document.body to cover sidenav in docs app

            showPromprtDialog(
                ev,
                'Set AWB Number for this shipment.',
                'The order has been marked as shipped but the AWB number has not been set. Please enter it to continue.',
                'AWB Number',
                $scope.order.awbCode,
                'Save',
                'Will do it later')
                .then(function (result) {
                    if (!result) {
                        showAwbDialog();
                    } else {
                        updateAwb(result, lineItem, i);
                    }
                })
                .catch(function (err) {

                })

        }


        function updateAwb(awb, lineItem, index) {
            var promise = '';
            $mdToast.show({
                hideDelay: 100000,
                position: 'bottom right',
                template: '<md-toast class="md-accent"><md-progress-circular md-mode="indeterminate" class="md-warn" md-diameter="20"></md-progress-circular> <span class="md-toast-text black-text" flex>Saving AWB</span> </md-toast>'
            });
            if (lineItem) {
                promise = RestManager.patchResource('/order/setLineItemAwbCode/' + $scope.order._id, {
                    lineItemId: lineItem._id,
                    awbCode: awb
                }, 'orders');
            } else {
                promise = RestManager.putResource("/order/admin/awb", {id: $scope.order._id, awb: awb}, "orders");
            }
            promise
                .then(function (result) {
                    console.log("order.details.controller.js", "RSULT", result);
                    $mdToast.hide()
                        .then(function () {
                            $mdToast.show($mdToast.simple()
                                .textContent('Saved AWB')
                                .highlightClass('md-primary')// Accent is used by default, this just demonstrates the usage.
                                .position("bottom right")
                            );
                        });
                    if (lineItem) {
                        lineItem.awbCode = result[0].lineItems[index].awbCode;
                    } else {
                        $scope.order.awbCode = result[0].awbCode;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    $mdToast.showSimple("Some error occurred");
                })
        }


        function getStatusConstants() {
            RestManager.getResource("/settings/constants/orderStatus", "settings")
                .then(function (data) {
                    $scope.orderStatus = data[0];
                })
                .catch(function (err) {
                    console.log(err);
                })
        }

        function getLineItemStatus() {
            RestManager.getResource("/settings/constants/lineItemStatus", "settings")
                .then(function (data) {
                    $scope.lineItemStatus = data[0];
                })
                .catch(function (err) {
                    console.log(err);
                });
        }


        function textFormat(text) {
            return Utils.getProperName(text)
        }

        function capitalize(text) {
            return Utils.capitalize(text);
        }


        function formatAddress(address) {
            return Utils.formatAddress(address);
        }


        function getPMString(value) {
            return Utils.getPaymentModeString(value);
        }

        // TODO - Support for ptoductData vs lineItem format. What to do? Figure out. Not straight fowrward.
        function showCustomisation(productData, event) {
            var productDataObj = {};
            console.log('Product Data', productData);
            angular.copy(productData, productDataObj);
            if (productDataObj.productId) {
                productDataObj.product = {
                    customisation: productDataObj.ucData.customisation,
                    _id: productData.productId,
                    name: productData.name,
                }
            }
            productDataObj.ucData.customisation = productDataObj.ucData.customisation._id;
            console.log('Proid', productDataObj);
            $mdDialog.show({
                locals: {
                    product: productDataObj.product,
                    ucData: productData.ucData
                },
                controller: "product-templates.controller",
                templateUrl: 'app/modules/products/productTemplates/product-templates.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: event,
                fullscreen: true,
                clickOutsideToClose: true
            })

        }

        function getDefault(layer) {
            var c = $scope.showProduct.ucData.data.find(function (a) {
                return a.dataId === layer._id;
            });
            console.log("C", c, layer.options);
            var b = layer.options.find(function (o) {
                return o._id === c.selectedValues[0];
            });
            console.log("b", b);
            return b;
        }

        function showAlertDialog(ev, title, message, postiveAction) {
            var alert = $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title(title)
                .multiple(true)
                .textContent(message)
                .ariaLabel(title)
                .ok(postiveAction)
                .targetEvent(ev);

            $mdDialog.show(alert);
        }

        function showConfirmationDialog(ev, title, message, postiveAction, negativeAction) {
            var confirm = $mdDialog.confirm()
                .title(title)
                .multiple(true)
                .textContent(message)
                .ariaLabel(title)
                .targetEvent(ev)
                .ok(postiveAction)
                .cancel(negativeAction);
            console.log('Show', confirm);
            return $mdDialog.show(confirm)
        }

        function showPromprtDialog(ev, title, message, placeholder, initialValue, postiveAction, negativeAction) {
            var prompt = $mdDialog.prompt()
                .title(title)
                .textContent(message)
                .placeholder(placeholder)
                .ariaLabel(title)
                .multiple(true)
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .initialValue(initialValue)
                .ok(postiveAction)
                .cancel(negativeAction);

            return $mdDialog.show(prompt);
        }

        function showEmailDialog(notification, ev) {
            if (notification.from) {
                $scope.contentHtml = notification.message;
                $mdDialog.show({
                    preserveScope: true,
                    scope: $scope,
                    multiple: true,
                    contentElement: '#customDialog',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true // Only for -xs, -sm breakpoints.
                })
            }
        }


        function viewMeasurementsDialogs(ev, p) {
            var product = {};
            angular.copy(p, product);


            if (!product.measurements) {
                product.measurements = product.variation.measurements;
                $scope.measurements = product.measurements;
            } else {
                $scope.measurements = [];
                if (Array.isArray(product.measurements)) {
                    $scope.measurements = product.measurements;

                } else {
                    _.forOwn(product.measurements, function (value, key) {
                        $scope.measurements.push({
                            key: key,
                            value: _.round(value, 2)
                        });
                    });
                }
            }

            $scope.editMeasurements = false;
            $scope.loadingSizeCharts = true;
            if (p.productId || (p.product && p.product._id)) {
                $scope.productQuery = {
                    queryType: "find",
                    queryParams: {
                        _id: p.productId || p.product._id
                    },
                    queryOptions: {
                        select: 'sizeChart'
                    }
                };
            }
            openMeasurementDialog();
            $scope.fetchSizeCharts()
                .then(function (sizeCharts) {
                    $scope.sizeCharts = sizeCharts;
                    if (p.productId || (p.product && p.product._id)) {
                        if (!p.sizeChart) {
                            return RestManager.postResource("/analytics/Products", $scope.productQuery, "analytics")
                        } else {
                            return [p]
                        }
                    } else {
                        return null;
                    }
                })
                .then(function (products) {
                    if (products && products.length && products[0].sizeChart) {
                        $scope.sizeChartGroupSelected = _.find($scope.sizeCharts, function (chart) {
                            return chart.id === products[0].sizeChart;
                        });
                    } else {
                        $scope.sizeChartGroupSelected = _.find($scope.sizeCharts, function (chart) {
                            return chart.name === "Customisation Size Chart";
                        });
                    }
                    $scope.measurementProduct = p;
                    $scope.loadingSizeCharts = false;
                })
                .catch(function (err) {
                    console.log("order.details.controller.js", "err", err);
                    $mdToast.showSimple('Error loading measurement data : ' + err.message);
                })
        }

        function getMeasurementForSizeChart(sizeChartGroupSelected, sizeText) {
            var data = _.find(sizeChartGroupSelected.measurements, function (m) {
                return m.key === sizeText;
            });
            if (data) {
                return data.values;
            } else {
                return [];
            }
        }

        function fetchSizeCharts() {
            if (!$scope.sizeCharts) {
                return Utils.fetchSizeCharts();
            } else {
                return Promise.resolve($scope.sizeCharts);
            }
        }

        function updateMeasurements() {
            $scope.updatingMeasurements = true;
            var payload = {indexes: [], measurements: $scope.measurements};
            if ($scope.updateMeasurementForAll) {
                payload.indexes = $scope.order.orderData.products.map(function (a, i) {
                    return i;
                })
            } else {
                console.log("order.details.controller.js", "updateMeasurements", $scope.measurementProduct);
                payload.indexes.push($scope.measurementProduct.index);
            }
            RestManager.patchResource('/order/measurements/' + $scope.order._id, payload, 'orders')
                .then(function (orders) {
                    if ($scope.updateMeasurementForAll) {
                        orders[0].orderData.products.forEach(function (lineItem, index) {
                            $scope.order.orderData.products[index].measurements = lineItem.measurements;
                        });
                        if (orders[0].lineItems) {
                            orders[0].lineItems.forEach(function (lineItem, index) {
                                $scope.order.lineItems[index].measurements = lineItem.measurements;
                            })
                        }

                    } else {
                        $scope.order.orderData.products[$scope.measurementProduct.index].measurements = orders[0].orderData.products[$scope.measurementProduct.index].measurements;
                        if (orders[0].lineItems && orders[0].lineItems.length) {
                            $scope.order.lineItems[$scope.measurementProduct.index].measurements = orders[0].lineItems[$scope.measurementProduct.index].measurements;
                        }
                    }
                    $scope.order.notes = orders[0].notes;
                    $scope.updatingMeasurements = false;
                    $mdDialog.cancel();
                    $mdToast.showSimple('Updated measurement');
                })
                .catch(function (err) {
                    $scope.updatingMeasurements = false;
                    console.log("order.details.controller.js", "err", err);
                    $mdToast.showSimple('Error updating measurements :' + err.message);
                })
        }

        function openMeasurementDialog(ev) {
            $mdDialog.show({
                preserveScope: true,
                scope: $scope,
                fullscreen: true,
                contentElement: '#viewMeasurementsDialogs',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,

            });
        }

        function sendAgentNotificationDialog(e) {
            var order = {};
            angular.copy($scope.order, order);

            $scope.sendNotificationDialog(e, {
                order: order,
                forAgent: true,
                options: {
                    context: 'order',
                    selectedIndex: 0
                }
            })
        }

        function sendNotificationDialog(e, passedOptions, selectedIndex) {
            var order = {};
            angular.copy($scope.order, order);

            if (!passedOptions) {
                passedOptions = {
                    order: order,
                    options: {
                        context: 'order',
                        selectedIndex: 0 || selectedIndex
                    }
                }
            }

            passedOptions.order.customer = order.user;

            if (order.agent) {
                var key = passedOptions.forAgent ? 'user' : 'agent';
                passedOptions.order[key] = _.find($scope.agents, function (agent) {
                    return agent._id === order.agent;
                })
            }
            if (order.organisation) {
                passedOptions.order.organisation = _.find($scope.orgs, function (organisation) {
                    return organisation._id === order.organisation;
                })
            }


            if (passedOptions.options.selectedTemplate && passedOptions.options.selectedTemplate === 'Order Delivered' && $scope.order.agent) {
                passedOptions.options.selectedTemplate = 'Order Delivered - To Agent'
            }

            if (passedOptions.forAgent && passedOptions.options.selectedTemplate && passedOptions.options.selectedTemplate === 'Order Delivered' && $scope.order.agent) {
                passedOptions.options.selectedTemplate = 'Agent :: Order Delivered'
            }

            if (passedOptions.options.selectedTemplate && passedOptions.options.selectedTemplate === 'Order Shipped' && $scope.order.agent) {
                passedOptions.options.selectedTemplate = 'Order Shipped - To Agent'
            }

            if (passedOptions.forAgent && passedOptions.options.selectedTemplate && passedOptions.options.selectedTemplate === 'Order Shipped' && $scope.order.agent) {
                passedOptions.options.selectedTemplate = 'Agent :: Order Shipped'
            }

            return $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: e,
                multiple: true,
                fullscreen: true,
                templateUrl: 'app/modules/components/notifications/user-notifications.html',
                locals: passedOptions,
                controller: 'notificationsController',
                clickOutsideToClose: true
            })
                .then(function (data) {
                    console.log('data', data)
                    $scope.notifications = $scope.notifications.concat(data);
                    return data;
                })
                .catch(function (err) {
                    console.log(err)
                })

        }


        function saveOrder(ev) {
            if ($scope.order.statusUpdated) {
                var title = "Are you sure that you want to update the order ? ";
                var message = "The order status will be updated from '" + _.toUpper($scope.order.oldStatus.slice(-1)[0]) + "' to '" + _.toUpper($scope.order.status) + "'. " +
                    "A notification might also be sent to the user if the update is mission critical. Are you sure you want to continue?";
                var positiveAction = "Save Order";
                var negativeAction = "Cancel. Take Me Back";
                showConfirmationDialog(ev, title, message, positiveAction, negativeAction)
                    .then(function () {
                        if ($scope.order.status === 'shipped') {
                            fetchAwb();
                        } else {
                            continueSave();
                        }
                    })
                    .then(function (data) {
                        console.log(data);
                    })
                    .catch(function (err) {
                        console.log(err);
                        $mdToast.showSimple("Action Cancelled");
                        $scope.order.status = $scope.order.oldStatus.slice(-1)[0];
                        $scope.order.oldStatus = [$scope.order.status];
                        $scope.order.statusUpdated = false;
                    })
            } else {
                if ($scope.order.status === 'shipped') {
                    fetchAwb(ev);
                } else {
                    continueSave();
                }
            }
        }

        function continueSave() {
            var data = {};
            angular.copy($scope.order, data);
            delete data.orderData;
            delete data.address;
            if (data.cart) {
                data.cart = data.cart._id;
            }
            data.user = data.user._id;
            data.disableNotification = true;
            $scope.saving = true;
            RestManager.putResource("/order", data, "orders")
                .then(function (data) {
                    $scope.saving = false;
                    $scope.order.statusHistory = data[0].statusHistory;
                    $scope.order.updatedAt = data[0].updatedAt;
                    $scope.order.awbCode = data[0].awbCode;
                    $scope.order.disableNotification = false;
                    if ($scope.order.oldStatus[0] !== $scope.order.status && _.includes(['placed', 'processing', 'packed', 'shipped', 'partially shipped', 'delivered', 'cancelled'], $scope.order.status)) {
                        showConfirmationDialog(null, 'Notify Customer', 'Order Status has been changed. You you want to notify the customer?', 'Notify', 'Cancel')
                            .then(function (result) {
                                if (result) {
                                    var order = {};
                                    angular.copy($scope.order, order);
                                    if (order.agent) {
                                        order.agent = _.find($scope.agents, function (agent) {
                                            return agent._id === order.agent;
                                        })
                                    }
                                    if (order.organisation) {
                                        order.organisation = _.find($scope.orgs, function (organisation) {
                                            return organisation._id === order.organisation;
                                        })
                                    }
                                    return $scope.sendNotificationDialog(null, {
                                        order: order,
                                        options: {
                                            selectedTemplate: 'Order ' + _.capitalize($scope.order.status),
                                            context: 'order status'
                                        }
                                    })
                                } else {
                                    return null;
                                }
                            })
                            .then(function () {
                                if ($scope.order.oldStatus[0] !== $scope.order.status && _.includes(['shipped', 'partially shipped', 'delivered', 'cancelled'], $scope.order.status)) {
                                    return showConfirmationDialog(null, 'Notify Customer', 'Order Status has been changed. You you want to notify the customer?', 'Notify', 'Cancel')
                                } else {
                                    return null;
                                }
                            })
                            .then(function (result) {
                                if (result) {
                                    var order = {};
                                    angular.copy($scope.order, order);
                                    if (order.agent) {
                                        order.user = _.find($scope.agents, function (agent) {
                                            return agent._id === order.agent;
                                        })
                                    }
                                    if (order.user) {
                                        order.customer = $scope.user;
                                    }
                                    if (order.organisation) {
                                        order.organisation = _.find($scope.orgs, function (organisation) {
                                            return organisation._id === order.organisation;
                                        })
                                    }
                                    return $scope.sendNotificationDialog(null, {
                                        order: order,
                                        options: {
                                            selectedTemplate: 'Order ' + _.capitalize($scope.order.status),
                                            context: 'agent order status'
                                        }
                                    })
                                } else {
                                    return null;
                                }
                            })
                            .catch(function (err) {

                            })
                    }
                    $scope.order.oldStatus = [$scope.order.status];
                    $scope.checkToShowPackageDialog();
                    if ($scope.order.status === 'packed' && $scope.order.flags && $scope.order.flags.dispatchToAgent && $scope.order.confirmationStatus.status === 'pending') {
                        $scope.openConfirmOrderShipmentDialog();
                    }
                    $mdToast.showSimple("Saved Order");
                    $scope.getOrderStatusValue();
                    console.log(data);
                })
                .catch(function (err) {
                    $scope.saving = false;
                    $mdToast.showSimple("Error : " + err.message);
                    console.log(err);
                })
        }

        function showShipRocketIdDialog(ev) {
            showPromprtDialog(ev, "Enter Shiprocket ID", "Please provide the shiprocket ID to manually start the syncing process.", "Shiprocket ID", $scope.order.shipRocketId, "Save", "Cancel")
                .then(function (data) {
                    if (data) {
                        $scope.order.shipRocketId = data;
                        continueSave();
                    } else {
                        $mdToast.showSimple("Please provide a Shiprocket ID first");
                    }
                })
                .catch(function (err) {

                })
        }


        function fetchSpSyncStatus() {
            // $scope.fetchingSync = true;
            // $scope.shipRocketSyncPromise = RestManager.getResource("/order/shiprocket/sync/" + $scope.order.shipRocketId, "synced")
            // $scope.shipRocketSyncPromise
            //     .then(function (synced) {
            //         $scope.fetchingSync = false;
            //         $scope.order.syncedWithSp = synced[0].success;
            //     })
            //     .catch(function (err) {
            //         console.log(err);
            //         $scope.fetchingSync = false;
            //         $scope.order.syncedWithSp = false;
            //     });
        }


        function createShiprocketOrder() {
            $scope.creatingOrder = true;
            $mdToast.show({
                hideDelay: 100000,
                position: 'bottom right',
                template: '<md-toast class="md-accent"><md-progress-circular md-mode="indeterminate" class="md-warn" md-diameter="20"></md-progress-circular> <span class="md-toast-text black-text" flex>Syncing Data With ShipRocket</span> </md-toast>'
            });
            RestManager.getResource("/order/shiprocket/resolve/" + $scope.order.orderNumber, "orders")
                .then(function (orders) {
                    $scope.creatingOrder = false;
                    $scope.order.shipRocketId = orders;
                    $mdToast.showSimple("Data Sync Complete");
                    $mdToast.hide();
                })
                .catch(function (err) {
                    $mdToast.hide()
                        .then(function () {
                            $mdToast.showSimple("Error : " + err.message);
                        });
                    $scope.creatingOrder = false;
                });
        }

        function openOrderPaymentsDialog(ev) {
            var order = {};
            angular.copy($scope.order, order)
            console.log("order.details.controller.js", "openOrderPaymentsDialog", order.paidAmount);
            $mdDialog.show({
                controller: "update-order-payment.controller",
                templateUrl: 'app/modules/orders/orderDetails/order-payments-dialog/order-payments-dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                targetEvent: ev,
                locals: {
                    paymentDetails: {
                        totalPaidAmount: order.paidAmount,
                        totalPendingAmount: order.pendingAmount,
                        paidByCard: order.paymentMode === 7,
                        hasPendingAmount: order.hasPendingAmount
                    },
                    orderAmount: order.amount,
                    capturedPayments: order.capturedPayments,
                    orderId: order._id,
                    paymentMode: order.paymentMode

                }
            })
                .then(function(response) {
                    console.log("order.details.controller.js", "response", response);
                    $scope.order.capturedPayments[response.updatedData.index].cashAmount = response.updatedData.cashAmount;
                    $scope.order.capturedPayments[response.updatedData.index].cardAmount = response.updatedData.cardAmount;
                    $scope.order.capturedPayments[response.updatedData.index].createdBy = response.updatedData.paidBy;
                });
        }


        function updateStatus(status, $event) {
            $scope.order.status = status;

            saveOrder($event);
        }

        function fetchAwb(ev, skipSaveIfNotFound) {
            $mdToast.show({
                hideDelay: 100000,
                position: 'bottom right',
                template: '<md-toast class="md-accent"><md-progress-circular md-mode="indeterminate" class="md-warn" md-diameter="20"></md-progress-circular> <span class="md-toast-text black-text" flex>Fetching Data from ShipRocket</span> </md-toast>'
            });
            continueSave();

            // $scope.shipRocketSyncPromise
            //     .then(function (data) {
            //         console.log("Spdata", data);
            //         $mdToast.hide();
            //         if (data[0].success) {
            //             console.log("fetchAwb", data[0].orders[0].awb_number);
            //             if (data[0].orders[0].awb_number !== null) {
            //                 $scope.order.awbCode = data[0].orders[0].awb_number;
            //                 continueSave();
            //             } else {
            //                 console.log("Gere");
            //                 var message = "Syncing Failed. AWB Number is not available on shiprocket.";
            //                 if (skipSaveIfNotFound) {
            //                     console.log("jkajsdbajd");
            //                     showAlertDialog(ev, "Error. AWB Not Found", message, "I understand");
            //                 } else {
            //                     var msg = message;
            //                     msg += " Do you think its a mistake? Do note that tracking info won't be available without AWB. Do you still want to continue?";
            //                     showConfirmationDialog(ev, "Do you want to continue?", msg, "Yes, continue", "Cancel, I will check again")
            //                         .then(function () {
            //                             continueSave();
            //                         })
            //                         .catch(function () {
            //                             $mdToast.showSimple("Action Cancelled");
            //                             if ($scope.order.oldStatus) {
            //                                 $scope.order.status = $scope.order.oldStatus.slice(-1)[0];
            //                                 $scope.order.oldStatus = [];
            //                                 $scope.order.statusUpdated = false;
            //                             }
            //                         })
            //                 }
            //             }
            //         }
            //     })
            //     .catch(function (err) {
            //         console.log(err);
            //     })
        }


        function trackOrder(ev) {
            $scope.trackingData = {};
            $mdToast.show({
                hideDelay: 100000,
                position: 'bottom right',
                template: '<md-toast class="md-accent"><md-progress-circular md-mode="indeterminate" class="md-warn" md-diameter="20"></md-progress-circular> <span class="md-toast-text black-text" flex>Fetching Tracking Data</span> </md-toast>'
            });
            $scope.fetchingTracking = true;
            RestManager.getResource("/order/track/" + $scope.order.orderNumber, "tracking")
                .then(function (result) {
                    $scope.fetchingTracking = false;
                    $mdToast.hide();
                    $mdDialog.show({
                        scope: $scope,
                        preserveScope: true,
                        contentElement: '#trackingDialog',
                        parent: angular.element(document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: true
                    });
                    $scope.trackingData = result[0];
                    console.log("Tracking Data", result[0]);
                })
                .catch(function (err) {
                    $mdToast.hide()
                        .then(function () {
                            $mdToast.showSimple("Error : " + err.message);
                        });
                    $scope.fetchingTracking = false;
                });
            console.log("trackOrder");
        }

        function getColor(status) {
            switch (status) {
                case "placed" :
                    return "#E36B3C";

                case "delivered" :
                    return "#049709";

                case "approved" :
                    return "#E36B3C";

                case "packed" :
                    return "#E36B3C";

                case "processing" :
                    return "#E36B3C";

                case  "incomplete" :
                    return "#A00301";

                case  "cancelled" :
                    return "#A00301";

                default:
                    return "#E36B3C";

            }
        }

        function getVariationValue(product) {
            // console.log(product);
            return Utils.getSelectedVariationFromCartProduct(product);
        }

        function getOrderStatusValue() {

            var a = $timeout(function () {
                console.log($scope.order.status);
                switch ($scope.order.status) {
                    case "placed" :
                        $scope.orderStatusValue = 0;
                        $scope.placedSuccess = true;
                        $scope.approvedSuccess = false;
                        $scope.packedSuccess = false;
                        $scope.shippedSuccess = false;
                        $scope.deliveredSuccess = false;
                        break;

                    case "approved" :
                        $scope.orderStatusValue = 30;
                        $scope.placedSuccess = true;
                        $scope.approvedSuccess = true;
                        $scope.packedSuccess = false;
                        $scope.shippedSuccess = false;
                        $scope.deliveredSuccess = false;
                        break;


                    case "processing" :
                        $scope.orderStatusValue = 40;
                        $scope.placedSuccess = true;
                        $scope.approvedSuccess = true;
                        $scope.packedSuccess = false;
                        $scope.shippedSuccess = false;
                        $scope.deliveredSuccess = false;
                        break;


                    case "packed":
                        $scope.orderStatusValue = 50;
                        $scope.placedSuccess = true;
                        $scope.approvedSuccess = true;
                        $scope.packedSuccess = true;
                        $scope.shippedSuccess = false;
                        $scope.deliveredSuccess = false;
                        break;

                    case "partially shipped":
                        $scope.orderStatusValue = 70;
                        $scope.placedSuccess = true;
                        $scope.approvedSuccess = true;
                        $scope.packedSuccess = true;
                        $scope.shippedSuccess = true;
                        $scope.deliveredSuccess = false;
                        break;


                    case "shipped":
                        $scope.orderStatusValue = 70;
                        $scope.placedSuccess = true;
                        $scope.approvedSuccess = true;
                        $scope.packedSuccess = true;
                        $scope.shippedSuccess = true;
                        $scope.deliveredSuccess = false;
                        break;

                    case "delivered":
                        $scope.orderStatusValue = 100;
                        $scope.placedSuccess = true;
                        $scope.approvedSuccess = true;
                        $scope.packedSuccess = true;
                        $scope.shippedSuccess = true;
                        $scope.deliveredSuccess = true;
                        break;
                }

                var i = 0;
                var b = $interval(function () {
                    switch (i) {
                        case 0:
                            $scope.showPlacedSuccess = true;
                            break;

                        case 1 :
                            $scope.showApprovedSuccess = true;
                            break;

                        case 2:
                            $scope.showPackedSuccess = true;
                            break;

                        case 3:
                            $scope.showShippedSuccess = true;
                            break;

                        case 4:
                            $scope.showDeliveredSuccess = true;
                            break;

                        case 5:
                            $interval.cancel(b);
                            break;
                    }
                    i++;
                }, 50);
            }, 1000);
        }

        function printInvoice() {
            var newWindow = window.open(Base.getBaseUrl() + '/order/invoice/' + $scope.order.orderNumber + "?access_token=" + AuthManager.getCurrentUser()['x-access-token']);
            newWindow.print();
        }

        function fetchReview() {
            $scope.fecthingRview = true;
            RestManager.getResource('/review', 'review', {query: {order: $stateParams.orderId}, service: 'review'})
                .then(function (reviews) {
                    $scope.reviews = reviews;
                    var orderRating = 0;
                    var sourceOfTruthTracker = 0;
                    $scope.order.orderData.products = $scope.order.orderData.products.map(function (product, i) {
                        product.reviews = _.filter($scope.reviews, function (r) {
                            return r.product === product.product._id;
                        });
                        var rating = (product.reviews.reduce(function (a, review) {
                            return a + (review.reviewPoints || 0)
                        }, 0) / product.reviews.length);
                        product.ratingValue = (isNaN(rating) || !rating) ? 0 : rating;
                        product.rating = product.ratingValue.toFixed(2);
                        if (product.ratingValue) {
                            orderRating += product.ratingValue;
                        }

                        if (product.product.discountType === "amount") {
                            product.product.discountValue = ((product.product.discountAmount * 100) / product.product.mrp).toFixed(2);
                        }
                        sourceOfTruthTracker++;
                        return product;
                    });
                    $scope.order.rating = (orderRating / sourceOfTruthTracker).toFixed(2);
                })
                .catch(function (err) {
                    console.log('Error while fetching reviews', err);
                })
        }

        function openReviewListDialog(ev, products) {
            $scope.selectedReviewProducts = products;
            $mdDialog.show({
                contentElement: '#reviewsListDialog',
                scope: $scope,
                fullscreen: true,
                targetEvent: ev,
                preserveScope: true,
                clickOutsideToClose: true
            })
        }


        function openReviewDialog(ev) {
            $mdDialog.show({
                locals: {
                    products: $scope.order.orderData.products,
                    order: $scope.order
                },
                controller: "orders.review.dialog.controller",
                templateUrl: 'app/modules/orders/orderDetails/partials/review-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                fullscreen: true,
                clickOutsideToClose: true
            })
                .then(function (result) {
                    console.log('result', result);
                    if (result.data && result.data.saved) {
                        $state.reload();
                    }
                })
        }

        function requestReview(e) {
            $scope.sendNotificationDialog(e, {
                order: $scope.order,
                options: {
                    selectedTemplate: 'Order Review',
                    context: 'order'
                }
            })
        }

        function generateShortUrl() {
            if (!$scope.order.links) {
                $scope.order.links = {};
            }
            if (!$scope.order.links.shortUrl
                // ) {
                && (!_.includes(['incomplete', 'cancelled', 'returned'], $scope.order.status))
                && (moment($scope.order.createdAt).isAfter(moment().subtract(1, 'year')))
                && Base.getEnv() === 'prod') {
                $scope.savingShortLink = true;
                var url = Base.getAppUrl() + '/account/orders/' + $scope.order.orderNumber + '?askForReview=true&h=' + window.btoa($scope.order.user.mobile) + '&utm_source=aarida-shortlinks&utm_campaign=shortlinks&utm_medium=sms&utm_content=sms';
                RestManager.postResource('', {url: url}, 'urls', {service: 'shortUrl'})
                    .then(function (result) {
                        console.log('Teus', result);
                        $scope.order.links.shortUrl = result[0].url;
                        $scope.order.disableNotification = true;
                        var data = {};
                        angular.copy($scope.order, data);
                        delete data.orderData;
                        delete data.address;
                        if (data.cart) {
                            data.cart = data.cart._id;
                        }
                        data.user = data.user._id;
                        return RestManager.putResource("/order/admin/metaData", data, "orders")
                    })
                    .then(function (result) {
                        $scope.savingShortLink = false;
                        $scope.order.links = result[0].links;
                    })
                    .catch(function (err) {
                        $scope.savingShortLink = false;
                        $mdToast.showSimple('Error generating short link : ', err.message || err);
                    })
            }
        }


        $scope.$watch("order.status", function (newVal, oldVal) {
            if (oldVal && (newVal !== oldVal)) {
                $scope.order.statusUpdated = true;
                if (!$scope.order.oldStatus) {
                    $scope.order.oldStatus = [];
                }
                $scope.order.oldStatus.push(oldVal);
            }
        });

        function loadAgents() {
            $scope.loadingAgents = true;
            $scope.query = {
                order: '-createdAt',
                limit: 100,
                page: 1,
                searchTerm: $scope.agentSearch,
                fields: 'name email mobile',
                query: {
                    role: "org-agent",
                    organisation: $scope.orgId
                }
            };
            RestManager.postResource('/users/admin', $scope.query, "users", ["totalCount"])
                .then(function (response) {
                    $scope.agents = response.users;
                    $scope.loadingAgents = false;
                    console.log("order.details.controller.js", "Response", $scope.agents);
                })
                .catch(function (err) {
                    $scope.loadingAgents = false;
                    console.log("order.details.controller.js", "ERRROR", err);
                })
        }


        function saveOrganisationDetails() {
            $scope.updatingOrgDetails = true;
            RestManager.patchResource('/order/organisation/' + $scope.order._id, {
                agent: $scope.order.agent,
                organisation: $scope.order.organisation,
                dispatchToAgent: $scope.order.flags.dispatchToAgent,
                hideAddress: $scope.order.flags.hideAddress,
                warehouse: $scope.warehouse ? $scope.warehouse : $scope.order.warehouse
            }, "orders")
                .then(function (response) {
                    console.log("order.details.controller.js", "Response", response);
                    $scope.order.flags = response[0].flags;
                    $scope.order.organsiation = response[0].organsiation;
                    $scope.order.warehouse = response[0].warehouse;
                    $scope.order.agent = response[0].agent;
                    $scope.order.address = response[0].address;
                    $scope.order.cachedAddress = response[0].cachedAddress;
                    $mdToast.showSimple('Details Saved');
                    $scope.updatingOrgDetails = false;
                    $scope.order.notes = response[0].notes;
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error updating organisation details : ' + err.message);
                    $scope.updatingOrgDetails = false;
                })
        }


        function openAddressSelectorDialog() {
            var user;
            if (($scope.order.flags && $scope.order.flags.dispatchToAgent)) {
                if (!$scope.order.agent) {
                    $mdToast.showSimple('Please select an agent/organisation first');
                    return;
                }
                user = {_id: $scope.order.agent};
            } else {
                user = $scope.order.user;
            }
            Address.showAddressSelector({user: user, selected: $scope.order.address})
                .then(function (response) {
                    $scope.isNewAddress = true;
                    $scope.order.cachedAddress = response.address;
                    $scope.order.address = response.address._id;
                })
                .catch(function (err) {
                    console.log("order.details.controller.js", "ERROR", err);
                });
        }


        function saveNewAddress(id, address) {
            $scope.savingAddress = true;
            RestManager.patchResource('/order/address/' + id, {address: address._id}, "orders")
                .then(function (response) {
                    $scope.order.address = response[0].address;
                    $scope.order.cachedAddress = response[0].cachedAddress;
                    $mdToast.showSimple('Updated Order Address');
                    $scope.savingAddress = false;
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error updating order address : ' + err.message);
                    $scope.savingAddress = false;
                })
        }


        function fetchAllOrg() {
            RestManager.getResource("/org", "organisations")
                .then(function (result) {
                    $scope.orgs = result;
                })
                .catch(function (err) {
                    console.log(err);
                });
        }

        function publishOrderNote() {
            if ($scope.message || $scope.imageSelected) {
                if (!$scope.order.notes) {
                    $scope.order.notes = [];
                    console.log("order.details.controller.js", "publishOrderNote", $scope.order.notes);
                }

                var data = {
                    comment: $scope.message,
                    images: $scope.imageSelected ? [$scope.imageSelected] : null,
                    date: new Date(),
                    by: $scope.currentUser._id,
                    byName: $scope.currentUser.name,
                    references: $scope.findReferences($scope.message),
                    saving: true
                };

                var index = $scope.order.notes.length;

                $scope.order.notes.push(data);

                RestManager.patchResource('/order/comments/' + $scope.order._id, data, 'orders')
                    .then(function (orders) {
                        $scope.order.notes[index].saving = false;
                        $scope.message = '';
                    })
                    .catch(function (err) {
                        $scope.order.notes[index].error = true;
                    });

                $scope.message = '';
                $scope.imageSelected = null;
            }
        }

        function addDesignImage(index) {
            if (!$scope.order.designImages) {
                $scope.order.designImages = [];
            }
            $scope.order.designImages.splice(0, 0, {newImage: null})
        }

        function saveDesignImage(designImage) {
            designImage.saving = true;

            RestManager.patchResource('/order/design/' + $scope.order._id, {image: designImage.newImage._id}, 'orders')
                .then(function (orders) {
                    designImage.saving = false;
                    if (orders[0].designImages && orders[0].designImages.length) {
                        orders[0].designImages = orders[0].designImages.reverse();
                    }
                    $scope.order.designImages = orders[0].designImages;
                    $mdToast.showSimple('Added design image successfully');
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error uploading design image : ' + err.message);
                });

        }

        function removeImage(index) {
            $scope.order.designImages.splice(index, 1);
        }

        $scope.findReferences = function (message) {
            var regex = /@\[([\s\w]+):([0-9a-z-]+)\]/gi;
            var m;
            var references = [];
            var i = 0;
            while ((m = regex.exec(message)) !== null) {
                // This is necessary to avoid infinite loops with zero-width matches
                if (m.index === regex.lastIndex) {
                    regex.lastIndex++;
                }

                m.forEach(function (match, groupIndex) {
                    if (groupIndex === 0) {
                        references.push({});
                    }
                    if (groupIndex === 1) {
                        references[i].name = _.trim(match);
                    }
                    if (groupIndex === 2) {
                        references[i].user = _.trim(match);
                    }
                });
                i++;
            }
            return references;
        };

        function selectDesigner(event) {
            Users.selectUserDialog(event, {fields: 'name,mobile,role', roles: 'admin,designer', multiple: false})
                .then(function (user) {
                    $scope.updatingDesigner = true;
                    if (user) {
                        return RestManager.patchResource('/order/designer', {
                            orderIds: [$scope.order._id],
                            designer: user._id
                        }, 'orders')
                    } else {
                        throw new Error('No User Selected')
                    }
                })
                .then(function (orders) {
                    $scope.updatingDesigner = false;
                    $scope.order.notes = orders[0].notes;
                    $scope.order.designer = orders[0].designer;
                    $scope.order.cachedDesignerName = orders[0].cachedDesignerName;
                    $mdToast.showSimple('Updated designer successfully');
                })
                .catch(function (err) {
                    $scope.updatingDesigner = false;
                    $mdToast.showSimple('Error updating designer : ' + err.message)
                })
        }

        function downloadInvoice() {
            var payload = {};
            angular.copy($scope.order, payload);
            payload.orderData.products = payload.orderData.products.map(function (lineItem) {
                delete lineItem.product.customisation;
                if (payload.saleChannel === 'pos') {
                    lineItem.price = lineItem.product.price;
                }
                return lineItem;
            });
            delete payload.cart;
            delete payload.lineItems;
            delete payload.giftCard;
            delete payload.designImages;
            delete payload.statusHistory;
            delete payload.statusHistory;
            delete payload.notes;

            RestManager.postResource('/', {invoker: 'order-invoice-customer', payload: payload}, '', {
                service: 'pdf',
                download: true
            })
                .then(function (result) {
                    var blob = new Blob([result], {type: 'application/pdf'});
                    saveAs(blob, 'INV' + $scope.order.orderNumber.slice(-7) || 'Export.pdf');
                    $mdToast.showSimple('Downloaded invoice ' + 'INV' + $scope.order.orderNumber.slice(-7) + ' successfully.');
                    var item = _.find($scope.order.checklistItems, function (item) {
                        return item.key === 'isInvoiced'
                    });
                    item.value = true;
                    $scope.updateChecklistItem(item);
                    // saveAs(new Blob([res.data], {type: "application/zip"}), "Images-Requested-Aarida" + ".zip");
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error generating order invoice : ' + err.message);
                })
        }

        function downloadThanksLetter() {
            RestManager.postResource('/', {
                invoker: 'order-thanks',
                payload: {user: {name: $scope.order.user.name}}
            }, '', {service: 'pdf', download: true})
                .then(function (result) {
                    var blob = new Blob([result], {type: 'application/pdf'});
                    saveAs(blob, 'Thanks Letter-' + $scope.order.orderNumber || 'Export.pdf');
                    $mdToast.showSimple('Downloaded thanks letter for ' + $scope.order.user.name + ' successfully.');
                    var item = _.find($scope.order.checklistItems, function (item) {
                        return item.key === 'isThanksLetterPrinted'
                    });
                    item.value = true;
                    $scope.updateChecklistItem(item);
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error generating order thanks : ' + err.message);
                })
        }

        function openManifestDialog(ev) {
            $scope.manifestOrder = {};
            angular.copy($scope.order, $scope.manifestOrder);
            $scope.manifestOrder.orderData.products = $scope.manifestOrder.orderData.products
                .map(function (lineItem) {
                    delete lineItem.product.customisation;
                    return lineItem;
                });
            delete $scope.manifestOrder.cart;
            delete $scope.manifestOrder.giftCard;
            delete $scope.manifestOrder.statusHistory;
            delete $scope.manifestOrder.cachedAddress;
            delete $scope.manifestOrder.statusHistory;
            delete $scope.manifestOrder.notes;
            if ($scope.manifestOrder.designer && $scope.manifestOrder.cachedDesignerName) {
                $scope.manifestOrder.designer = {
                    name: $scope.manifestOrder.cachedDesignerName
                }
            }
            $mdDialog.show({
                preserveScope: true,
                scope: $scope,
                fullscreen: true,
                contentElement: '#manifestSelector',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function downloadOrderManifest() {
            $scope.downloadingManifest = true;
            var payload = {};
            angular.copy($scope.manifestOrder, payload);
            payload.orderData.products = payload.orderData.products.filter(function (lineItem) {
                return lineItem.selectedForManifest;
            });
            payload.designImages = payload.designImages.filter(function (image) {
                return image.selectedForManifest;
            });
            delete payload.lineItems;
            RestManager.postResource('/', {
                invoker: 'order-manifest',
                payload: payload
            }, '', {service: 'pdf', download: true})
                .then(function (result) {
                    var blob = new Blob([result], {type: 'application/pdf'});
                    saveAs(blob, 'Order Manifest -' + $scope.order.orderNumber || 'Export.pdf');
                    $scope.downloadingManifest = false;

                    // $mdDialog.cancel();
                    // $scope.manifestOrder = null;
                    $mdToast.showSimple('Downloaded order manifest for ' + $scope.order.orderNumber + ' successfully.');
                    var item = _.find($scope.order.checklistItems, function (item) {
                        return item.key === 'isManifested'
                    });
                    item.value = true;
                    $scope.updateChecklistItem(item);
                })
                .catch(function (err) {
                    $scope.downloadingManifest = false;
                    $mdToast.showSimple('Error downloading order manifest : ' + err.message);
                })
        }

        function appendMeasurement(index) {
            $scope.measurements.splice(index + 1, 0, {key: '', value: ''})
        }

        function deleteMeasurement(index) {
            $scope.measurements.splice(index, 1);
        }

        function updateMeasurementForAllValue(value) {
            $scope.updateMeasurementForAll = value;
            console.log("order.details.controller.js", "updateMeasurementForAllValue", $scope.updateMeasurementForAll);
        }

        function updateChecklistItem(item) {
            item.updating = true;
            RestManager.patchResource('/order/checklist/' + $scope.order._id, {
                key: item.key,
                value: item.value,
                description: item.description
            }, 'orders')
                .then(function (orders) {
                    $scope.order.notes = orders[0].notes;
                    item.value = orders[0].checklist[item.key];
                    if (item.value) {
                        $scope.completedChecklists += 1;
                    } else {
                        $scope.completedChecklists -= 1;
                    }
                    item.updating = false;
                })
                .catch(function (err) {
                    item.value = !item.value;
                    item.updating = false;
                    $mdToast.showSimple('Error updating checklist :' + err.message);
                })
        }

        function updateEditChecklist() {
            $scope.editChecklist = !$scope.editChecklist;
        }

        function attachImages(images) {
            if (Array.isArray(images)) {
                $scope.order.designImages.shift();
                images.forEach(function (image) {
                    $scope.order.designImages.unshift({newImage: image});
                })
            } else {
                $scope.order.designImages[0] = {newImage: images};
            }

            Promise.mapSeries($scope.order.designImages, function (imageData) {
                if (imageData.newImage) {
                    return $scope.saveDesignImage(imageData);
                } else {
                    return null
                }
            });
        }


        $scope.$on("$destroy", function () {
            // $interval.cancel(interval);
        });

        function updateStock(ev, lineItem) {
            $mdDialog.show({
                locals: {
                    lineItem: lineItem,
                    orderNumber: $scope.order.orderNumber,
                    orderId: $scope.order._id,
                    currentStock: lineItem.currentStock
                },
                controller: "updateStock-controller",
                templateUrl: 'app/modules/orders/orderDetails/updateStock-dialog/updateStock.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            })
                .then(function (result) {
                    console.log("order.details.controller.js", "result", result);
                    if (result.disableManageStock) {
                        lineItem.manageStock = false;
                    } else {
                        lineItem.isStockDeducted = true;
                        $scope.order.notes = result.order.notes;
                        if (result.productOos || result.variationOos) {
                            // var message = 'After the stock update, the ';
                            // if (result.productOos && result.variationOos) {
                            //     message += 'product and the variation have';
                            // } else if (result.productOos) {
                            //     message += 'product has';
                            // } else if (result.variationOos) {
                            //     message += 'variation has';
                            // }
                            // message += ' been made out of stock. Please review the changes in the quick view dialog.'
                            return $mdDialog.show({
                                    templateUrl: 'app/modules/orders/orderDetails/updateStock-dialog/updated-response.html',
                                    multiple: true,
                                    locals: {
                                        productOos: result.productOos,
                                        variationOos: result.variationOos
                                    },
                                    controller: ["$mdDialog", "$scope", "productOos", "variationOos", function ($mdDialog, $scope, productOos, variationOos) {
                                        $scope.hide = $mdDialog.hide;
                                        $scope.cancel = $mdDialog.cancel;
                                        $scope.productOos = productOos;
                                        $scope.variationOos = variationOos;
                                    }]
                                }
                                // $mdDialog.confirm({
                                //     textContent: message,
                                //     title: 'Out of Stock Notice',
                                //     ok: 'Show the product',
                                //     cancel: 'Cancel',
                                //     multiple: true
                                // })
                            )
                        } else {
                            return null;
                        }
                    }
                })
                .then(function (result) {
                    if (result) {
                        return ProductUtils.openQuickView(ev, lineItem.productId)
                    } else {
                        return null;
                    }
                })
                .catch(function (err) {
                    console.log("order.details.controller.js", "Err", err);
                })
        }

        function updateLineItemStatus(lineItem, status, index) {
            console.log(lineItem, status);
            console.log("updating Line item status", status)
            RestManager.patchResource('/order/updateLineItemStatus/' + $scope.order._id, {
                lineItemId: lineItem._id,
                status: status,
                productName: lineItem.name,
                variationText: lineItem.selectedVariationText
            }, 'orders')
                .then(function (response) {
                    $mdToast.showSimple("Status Updated to:" + status);
                    $scope.lineItems
                })
                .catch(function (err) {
                    console.log(err);
                })
        }

        function viewStockUpdates(event, lineItemId) {
            StockUpdates.openStockUpdateDialog(event, {
                lineItemId: lineItemId,
                orderId: $scope.order._id
            })
        }

        function fetchAllWarehouses() {
            RestManager.getResource('/warehouse', 'warehouses')
                .then(function (result) {
                    $scope.warehouses = result;
                    console.log("order.details.controller.js", "$scope.warehouses", $scope.warehouses);
                })
                .catch(function (err) {
                    console.log("users.all.controller.js Warehouses", err);
                });
        }

        function updateLineItemWarehouse(lineItem, i) {
            RestManager.patchResource('/order/updateLineItemWarehouse/' + $scope.order._id, {
                lineItemId: lineItem._id,
                warehouse: lineItem.warehouse,
                productName: lineItem.name,
                variationText: lineItem.selectedVariationText
            }, 'orders')
                .then(function (res) {
                    var notesArray = res[0].notes.splice(-1);
                    $scope.order.notes.push(notesArray[0]);
                    var itemIndex = _.findIndex(res[0].lineItems, function (item) {
                        return item._id === lineItem._id;
                    });
                    $scope.order.lineItems[i].updates = res[0].lineItems[itemIndex].updates;
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error in updating warehouse, Please check the network ' + err.message)
                })
        }

        function showHistory(ev, lineItem) {
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: ev,
                fullscreen: true,
                controller: "lineItem-history.controller",
                templateUrl: 'app/modules/orders/orderDetails/lineItem-history-dialog/lineItem-history.tmpl.html',
                clickOutsideToClose: false,
                locals: {
                    lineItem: lineItem
                }
            })

        }


        function showLineItemDetails(lineItem, ev) {
            $scope.selectedLineItem = lineItem;
            console.log("order.details.controller.js", "showLineItemDetails", $scope.selectedLineItem);
            $mdDialog.show({
                preserveScope: true,
                scope: $scope,
                multiple: true,
                contentElement: '#lineItemDetails',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true // Only for -xs, -sm br
            })
                .then(function () {
                    $scope.selectedLineItem = null;
                })
                .catch(function (err) {
                    $scope.selectedLineItem = null;
                })

        }

        function changeWarehouse(warehouse) {
            $scope.warehouse = warehouse;
        }

        function openConfirmOrderShipmentDialog(e) {
            var order = {};
            angular.copy($scope.order, order);
            var agent = _.find($scope.agents, function (agent) {
                return agent._id === $scope.order.agent;
            })
            var agentEmail = agent ? agent.email : null;
            var agentName = agent ? agent.name : null;

            order.agent = {
                name: agentName,
                email: agentEmail,
                _id: agent ? agent._id : null
            };

            var passedOptions = {
                order: order,
                options: {
                    context: 'order',
                    selectedIndex: 2,
                    scopes: ['email'],
                    selectedTemplate: 'Shipment Of Orders',
                    //TODO: Add id's of user's whose id is required
                    email: {
                        cc: [
                            {
                                name: "Kumar Divya Rajat",
                                email: "rajat@reduxpress.in"
                            },
                            {
                                name: "Kumar Aditya",
                                email: "kumar.aditya@reduxpress.in"
                            },
                            {
                                name: "Sony Choudhary",
                                email: "sony@aadira.com",
                            }

                        ],
                        to: [
                            {
                                name: "Vikas Kashyap",
                                email: "vikas.kashyap@goddres.com",
                            },
                            {
                                name: "Ajaz Nathani",
                                email: "nathaniajaz@goddres.com",
                            },
                            {
                                name: agentName,
                                email: agentEmail
                            }
                        ],
                        replyTo: {
                            name: "Kumar Divya Rajat",
                            email: "rajat@reduxpress.in",
                        }
                    }
                }
            };
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: e,
                multiple: true,
                fullscreen: true,
                templateUrl: 'app/modules/components/notifications/user-notifications.html',
                locals: passedOptions,
                controller: 'notificationsController',
                clickOutsideToClose: true
            })
                .then(function (response) {
                    $scope.order.confirmationStatus = response[0].confirmationStatus;
                    $mdToast.showSimple('Requested Confirmation for the Shipment successfully');

                })
                .catch(function (err) {
                    $mdToast.showSimple('Error while requesting confirmation : ' + err.message);
                });
        }

        function updateOrderConfirmation(status) {
            $scope.updatingConfirmation = true;
            RestManager.patchResource('/order/setOrderConfirmationStatus/' + $scope.order._id, {status: status}, 'orders')
                .then(function (orders) {
                    $scope.updatingConfirmation = false;
                    $scope.order.confirmationStatus = orders[0].confirmationStatus;
                    $mdToast.showSimple('Updated Order Confirmation Status ');
                })
                .catch(function (err) {
                    $scope.updatingConfirmation = false;
                    $mdToast.showSimple('Error updating the order confirmation status');
                })
        }

        function openPackageGroupManager($event) {
            if (!$scope.order.shipments || !$scope.order.shipments.length) {
                $scope.order.shipments = [];
            }
            $scope.orderShipments = [];
            angular.copy($scope.order.shipments, $scope.orderShipments);
            if (!$scope.orderShipments.length) {
                $scope.appendPackage();
            }
            $mdDialog.show({
                preserveScope: true,
                scope: $scope,
                multiple: true,
                contentElement: '#packageManager',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                fullscreen: true // Only for -xs, -sm breakpoints.
            })
        }

        function appendPackage() {
            var packageId = $scope.order.orderNumber + '-' + ($scope.orderShipments.length + 1);
            $scope.orderShipments.push({
                lineItems: [],
                dimensions: {},
                packageId: packageId
            })
        }

        function removePackageGroup(index) {
            $scope.orderShipments.splice(index, 1);
        }

        function createShipment(ev) {
            $scope.savingPackages = true;
            var shipments = [];
            angular.copy($scope.orderShipments, shipments);
            shipments = shipments.map(function (shipment) {
                shipment.orders = [$scope.order._id];
                shipment.users = [$scope.order.user._id];
                shipment.address = $scope.order.cachedAddress._id;
                shipment.cachedAddress = $scope.order.cachedAddress;
                return shipment;
            });
            RestManager.postResource('/shipments', {shipments: shipments}, 'shipments')
                .then(function (result) {
                    console.log("order.details.controller.js", "re", result);
                    $scope.savingPackages = false;
                    // $scope.order.shipments = result[0].shipments;
                    if (!$scope.order.shipments) {
                        $scope.order.shipments = [];
                    }
                    $scope.order.shipments = $scope.order.shipments.concat(result);
                    $mdDialog.hide();
                    $mdToast.showSimple('Saved Packages for the order');
                })
                .catch(function (err) {
                    $scope.savingPackages = false;
                    $mdToast.showSimple('Error while saving package group for order' + err.message);
                })
        }

        function shippingConfirmationDialog(ev, packageObj) {
            showConfirmationDialog(ev,
                'Ship Package',
                'The package will be shipped by ' + _.camelCase(packageObj.logisticsChannel) + '. Please ensure that the package is ready before shipping.',
                'Ship Now',
                'Cancel'
            )
                .then(function () {
                    switch (packageObj.logisticsChannel) {
                        case 'shyplite' :
                            $scope.showRateCalculatorDialog(ev, packageObj)
                            break;

                        case 'shiprocket':
                            break;
                    }
                })
                .catch(function (err) {

                })
        }

        function checkToShowPackageDialog() {
            if (_.includes(['packed', 'processing', 'packed'], $scope.order.status) &&
                $scope.order.lineItems &&
                $scope.order.lineItems.length &&
                $scope.order.saleChannel === 'website' &&
                (
                    !$scope.order.shipments ||
                    !$scope.order.shipments.length
                )
            ) {
                $scope.openPackageGroupManager();
            }
        }


        function showRateCalculatorDialog(ev, shipment) {
            var payloadOrder = {};
            angular.copy($scope.order, payloadOrder);
            $mdDialog.show({
                controller: 'rate-calculator.controller',
                templateUrl: 'app/modules/orders/orderDetails/rate-calculator/rate-calculator.html',
                locals: {
                    order: payloadOrder,
                    shipmentId: shipment._id
                },
                multiple: true,
                clickOutsideToClose: true,
                escapeToClose: true,
                targetEvent: ev,
                fullscreen: true
            })
                .then(function (data) {
                    if (data) {
                        // Too many things to take care of. Just refresh the page.
                        $state.reload();
                    }
                })
                .catch(function (err) {
                    console.log("order.details.controller.js", "err", err);
                })
        }

        function calculateVolumetricWeight(shipment) {
            if (shipment.dimensions && shipment.dimensions.length && shipment.dimensions.breadth && shipment.dimensions.height) {
                shipment.volumetricWeight = _.round((shipment.dimensions.length * shipment.dimensions.breadth * shipment.dimensions.height) / 5000, 1);
            }
        }

        function updateShipmentDescription(shipment) {
            var lineItems = $scope.order.lineItems.filter(function (lineItem) {
                return _.includes(shipment.lineItems, lineItem._id)
            });
            var result = lineItems.reduce(function (acc, lineItem) {
                return {total: (acc.total + lineItem.totalPrice), description: acc.description + ', ' + lineItem.name};
            }, {total: 0, description: ''});
            shipment.description = result.description.replace(', ', '');
            shipment.invoiceValue = result.total;
        }

        function syncAwb(ev, lineItem, index) {
            lineItem.syncingAwb = true;
            RestManager.getResource('/shipments/sync/' + lineItem.shipment, 'orders')
                .then(function (result) {
                    lineItem.syncingAwb = false;
                    $state.reload();
                })
                .catch(function (err) {
                    lineItem.syncingAwb = false;
                    $mdToast.showSimple('Error while syncing AWB : ' + err.message);
                })
        }

        function getTrackingUrl(shipmentId, awbCode) {
            if (!shipmentId) {
                return 'https://tracklite.in/track/' + awbCode;
            }

            var shipment = _.find($scope.order.shipments, function (sh) {
                return sh._id === shipmentId;
            });

            switch (shipment.logisticsChannel) {
                case  'shyplite':
                    return 'https://tracklite.in/track/' + awbCode;

                case 'shiprocket':
                    return 'https://aarida.shiprocket.co/tracking/' + awbCode;
            }
        }

        function manageTasksDialog(event, lineItem, index) {
            Workforce
                .openTaskCreateDialog(event, {
                    order: $scope.order,
                    product: {
                        _id: lineItem.productId,
                        name: lineItem.name,
                        image: lineItem.image,
                        sku : lineItem.sku
                    },
                    lineItem: lineItem
                })
                .then(function (updatedOrder) {
                    if(updatedOrder) {
                        console.log(updatedOrder, index, $scope.order.lineItems);
                        $scope.order.notes = updatedOrder.notes;
                        $scope.order.lineItems[index].updates = updatedOrder.lineItems[index].updates;
                        $scope.order.lineItems[index].hasTasks = updatedOrder.lineItems[index].hasTasks;
                        $scope.order.lineItems[index].tasks = updatedOrder.lineItems[index].tasks;
                        $mdToast.showSimple('Tasks Created!');
                    }
                })
                .catch(function (err) {
                    if(err) {
                        $mdToast.showSimple('Error creating task: ' + err.message);
                        console.log('Error creating task:', err);
                    }
                })
        }


        $scope.getDefault = getDefault;
        $scope.capitalize = capitalize;
        $scope.formatAddress = formatAddress;
        $scope.textFormat = textFormat;
        $scope.getPMString = getPMString;
        $scope.getOrderStatusValue = getOrderStatusValue;
        $scope.showCustomisation = showCustomisation;
        $scope.getStatusConstants = getStatusConstants;
        $scope.showShipRocketIdDialog = showShipRocketIdDialog;
        $scope.saveOrder = saveOrder;
        $scope.getColor = getColor;
        $scope.fetchAwb = fetchAwb;
        $scope.updateStatus = updateStatus;
        $scope.showEmailDialog = showEmailDialog;
        $scope.fetchNotifications = fetchNotifications;
        $scope.createShiprocketOrder = createShiprocketOrder;
        $scope.fetchSpSyncStatus = fetchSpSyncStatus;
        $scope.getVariationValue = getVariationValue;
        $scope.showAwbDialog = showAwbDialog;
        $scope.trackOrder = trackOrder;
        $scope.printInvoice = printInvoice;
        $scope.viewMeasurementsDialogs = viewMeasurementsDialogs;
        $scope.sendNotificationDialog = sendNotificationDialog;
        $scope.sendAgentNotificationDialog = sendAgentNotificationDialog;
        $scope.fetchReview = fetchReview;
        $scope.openReviewListDialog = openReviewListDialog;
        $scope.openReviewDialog = openReviewDialog;
        $scope.requestReview = requestReview;
        $scope.generateShortUrl = generateShortUrl;
        $scope.openOrderPaymentsDialog = openOrderPaymentsDialog;
        $scope.publishOrderNote = publishOrderNote;
        $scope.loadAgents = loadAgents;
        $scope.saveOrganisationDetails = saveOrganisationDetails;
        $scope.openAddressSelectorDialog = openAddressSelectorDialog;
        $scope.saveNewAddress = saveNewAddress;
        $scope.fetchAllOrg = fetchAllOrg;
        $scope.addDesignImage = addDesignImage;
        $scope.openImages = Images.openImageGallery;
        $scope.saveDesignImage = saveDesignImage;
        $scope.removeImage = removeImage;
        $scope.selectDesigner = selectDesigner;
        $scope.quickView = ProductUtils.openQuickView;
        $scope.downloadInvoice = downloadInvoice;
        $scope.downloadThanksLetter = downloadThanksLetter;
        $scope.downloadOrderManifest = downloadOrderManifest;
        $scope.openManifestDialog = openManifestDialog;
        $scope.appendMeasurement = appendMeasurement;
        $scope.fetchSizeCharts = fetchSizeCharts;
        $scope.getMeasurementForSizeChart = getMeasurementForSizeChart;
        $scope.updateMeasurements = updateMeasurements;
        $scope.deleteMeasurement = deleteMeasurement;
        $scope.updateMeasurementForAllValue = updateMeasurementForAllValue;
        $scope.updateChecklistItem = updateChecklistItem;
        $scope.updateEditCheckList = updateEditChecklist;
        $scope.attachImages = attachImages;
        $scope.updateStock = updateStock;
        $scope.getLineItemStatus = getLineItemStatus;
        $scope.updateLineItemStatus = updateLineItemStatus;
        $scope.viewStockUpdates = viewStockUpdates;
        $scope.fetchAllWarehouses = fetchAllWarehouses;
        $scope.updateLineItemWarehouse = updateLineItemWarehouse;
        $scope.showHistory = showHistory;
        $scope.showLineItemDetails = showLineItemDetails;
        $scope.changeWarehouse = changeWarehouse;
        $scope.openConfirmOrderShipmentDialog = openConfirmOrderShipmentDialog;
        $scope.updateOrderConfirmation = updateOrderConfirmation;
        $scope.openPackageGroupManager = openPackageGroupManager;
        $scope.appendPackage = appendPackage;
        $scope.removePackageGroup = removePackageGroup;
        $scope.createShipment = createShipment;
        $scope.shippingConfirmationDialog = shippingConfirmationDialog;
        $scope.checkToShowPackageDialog = checkToShowPackageDialog;
        $scope.showRateCalculatorDialog = showRateCalculatorDialog;
        $scope.calculateVolumetricWeight = calculateVolumetricWeight;
        $scope.updateShipmentDescription = updateShipmentDescription;
        $scope.syncAwb = syncAwb;
        $scope.getTrackingUrl = getTrackingUrl;
        $scope.manageTasksDialog = manageTasksDialog;
        // $scope.changeOrderWarehouse = changeOrderWarehouse;
        // $scope.changeOrderWarehouse = changeOrderWarehouse;

        $scope.fetchOrders();
        $scope.fetchAllOrg();
        $scope.fetchAllWarehouses();
    }])
;

/**
 * Created by kumardivyarajat on 04/12/16.
 */
angular.module("app.orders")
    .controller("orders.all.controller", ["$scope", "RestManager", "Utils", "$state", "$stateParams", "$mdDialog", "$mdToast", "$window", "SheetClip", function ($scope, RestManager, Utils, $state, $stateParams, $mdDialog, $mdToast,
                                                   $window, SheetClip) {

        $scope.$parent.nestedState = false;
        $scope.$parent.backState = "app.home";
        $scope.$parent.showActionButton = false;
        $scope.$parent.pageTitle = "All Orders";
        $scope.$parent.backText = "Home";
        $scope.filterList = false;
        $scope.showAdminOrders = false;
        $scope.showCancelled = false;
        $scope.totalParkedAmount = 0;
        $scope.selected = [];
        $scope.totalIncompleteOrders = 0;
        $scope.incompleteOrders = [];
        $scope.showSearchBar = false;
        $scope.filterDesigners = [];
        $scope.hasFilters = false;
        $scope.actionModel = null;
        $scope.queryParams = {
            filterDesigners: [],
            startDate: '',
            endDate: '',
            filterOrgs: [],
            filterWarehouses: [],
            filterChannels: [],
            filterBillingPerson: [],
            rangeModel: null
        };
        $scope.newBill = {
            organisation: '',
            lineItems: [],
            amount: 0,
            description: ''
        };
        $scope.rangeModels = [
            {
                name: 'Current',
                models: [
                    {
                        title: 'Today',
                        startDate: moment().startOf('day'),
                        endDate: moment().endOf('day'),
                        value: 'this_day'
                    },
                    {
                        title: 'This Week',
                        startDate: moment().startOf('day').startOf('week'),
                        endDate: moment().endOf('week'),
                        value: 'this_week'
                    },
                    {
                        title: 'This Month',
                        startDate: moment().startOf('day').startOf('month'),
                        endDate: moment().endOf('month'),
                        value: 'this_month'
                    },
                    {
                        title: 'This Quarter',
                        startDate: moment().startOf('day').startOf('quarter'),
                        endDate: moment().endOf('day').endOf('quarter'),
                        value: 'this_quarter'
                    },
                    {
                        title: 'This Year',
                        startDate: moment().startOf('day').startOf('year'),
                        endDate: moment().endOf('year'),
                        value: 'this_year'
                    },
                    {
                        title: 'This Fiscal Year',
                        startDate: moment().month() < 4 ? moment().subtract(1, 'year').month(3).startOf('month') : moment().month(3).startOf('month'),
                        endDate: moment().month() < 4 ? moment().month(2).endOf('month') : moment().month(2).add(1, 'year').endOf('month'),
                        value: 'this_fiscal_year'
                    }
                ]
            },
            {
                name: 'Previous',
                models: [
                    {
                        title: 'Yesterday',
                        startDate: moment().startOf('day').subtract(1, 'day'),
                        endDate: moment().endOf('day').subtract(1, 'day'),
                        value: 'prev_day'
                    },
                    {
                        title: 'Last Week',
                        startDate: moment().subtract(1, 'week').startOf('week'),
                        endDate: moment().subtract(1, 'week').endOf('week'),
                        value: 'prev_week'
                    },
                    {
                        title: 'Last Month',
                        startDate: moment().subtract(1, 'month').startOf('month'),
                        endDate: moment().subtract(1, 'month').endOf('month'),
                        value: 'prev_month'
                    },
                    {
                        title: 'Last Quarter',
                        startDate: moment().subtract(1, 'quarter').startOf('quarter'),
                        endDate: moment().subtract(1, 'quarter').endOf('quarter'),
                        value: 'prev_quarter'
                    },
                    {
                        title: 'Last Year',
                        startDate: moment().subtract(1, 'year').startOf('year'),
                        endDate: moment().subtract(1, 'year').endOf('year'),
                        value: 'prev_year'
                    },
                    {
                        title: 'Last Fiscal Year',
                        startDate: moment().subtract(1, 'year').month(3).startOf('month'),
                        endDate: moment().month(2).endOf('month'),
                        value: 'prev_fiscal_year'
                    }
                ]
            },
            {
                name: 'Custom',
                models: [
                    {
                        title: 'Custom Date',
                        value: 'custom'
                    }
                ]
            }
        ];
        $scope.globalDiscountPercent = 5;

        $scope.columns = [
            {
                name: 'Order Number',
                model: true,
                orderBy: 'orderNumber',
                value: 'orderNumber'
            },
            {
                name: 'Store',
                model: false,
                orderBy: null,
                value: 'store'
            },
            {
                name: 'Shipping Address',
                model: false,
                orderBy: null,
                value: 'address'
            },
            {
                name: '#',
                model: true,
                orderBy: false,
                value: 'productCount'
            },
            {
                name: 'Total',
                model: true,
                orderBy: 'amount',
                value: 'amount'
            },
            {
                name: 'Sale Channel',
                model: true,
                orderBy: 'saleChannel',
                value: 'saleChannel'
            },
            {
                name: 'Status',
                model: true,
                orderBy: 'status',
                value: 'status'
            },
            {
                name: 'Confirmation Status',
                model: false,
                orderBy: 'confirmationStatus.status',
                value: 'confirmationStatus'
            },
            {
                name: 'Designer',
                model: false,
                orderBy: 'designer',
                value: 'designer'
            },
            {
                name: 'Agent',
                model: false,
                orderBy: 'agent',
                value: 'agent'
            },
            {
                name: 'Organisation',
                model: false,
                orderBy: 'organisation',
                value: 'organisation'
            },
            {
                name: 'Order Date',
                model: true,
                orderBy: 'createdAt',
                value: 'createdAt'
            },
            {
                name: 'Last Update',
                model: false,
                orderBy: 'updateAt',
                value: 'updateAt'
            },
            {
                name: 'Reviewed',
                model: false,
                orderBy: 'isReviewDone',
                value: 'isReviewDone'
            },
            {
                name: 'Days Open',
                model: false,
                orderBy: false,
                value: 'daysOpen'
            }
        ];

        $scope.actions = [
            {
                id: 1,
                title: 'Download Shiprocket (CSV)'
            },
            {
                id: 2,
                title: 'Copy Order Entries'
            },
            {
                id: 3,
                title: 'Generate Bill'
            },
            {
                id: 4,
                title: 'Download Shyplite (xlsx)'
            }
        ];

        $scope.formatAddress = Utils.formatAddress;
        $scope.reorder = reorder;
        $scope.keyAction = keyAction;
        $scope.openSearchToolbar = openSearchToolbar;
        $scope.showFilters = showFilters;
        $scope.clearFilters = clearFilters;
        $scope.fetchIncompleteOrders = fetchIncompleteOrders;
        $scope.openIncompleteOrderList = openIncompleteOrderList;
        $scope.applyFilter = applyFilter;
        $scope.close = $mdDialog.cancel;
        $scope.openOrderFilterDialog = openOrderFilterDialog;
        $scope.selectAll = selectAll;
        $scope.fetchAllOrg = fetchAllOrg;
        $scope.fetchAllWarehouses = fetchAllWarehouses;
        $scope.queryUsers = queryUsers;
        $scope.parseFilters = parseFilters;
        $scope.populateUsers = populateUsers;
        $scope.getActiveColumnsCount = getActiveColumnsCount;
        $scope.performSmartAction = performSmartAction;
        $scope.downloadShiprocketOrder = downloadShiprocketOrder;
        $scope.showLoadingToast = showLoadingToast;
        $scope.clearSelection = clearSelection;
        $scope.promptAwbDialog = promptAwbDialog;
        $scope.openBillingDialog = openBillingDialog;
        $scope.getDiscountValue = getDiscountValue;
        $scope.updateLineItem = updateLineItem;
        $scope.removeLineItem = removeLineItem;
        $scope.generateOrgBill = generateOrgBill;
        $scope.detectIssues = detectIssues;
        $scope.updateDiscounts = updateDiscounts;
        $scope.updateDateFilter = updateDateFilter;
        $scope.openConfirmOrderShipmentDialog = openConfirmOrderShipmentDialog;
        $scope.downloadShypliteOrder = downloadShypliteOrder;
        $scope.notify = notify;

        function selectAll(model, dataSet) {
            $scope[model] = dataSet.map(function (data) {
                return data._id || data;
            })
        }

        function getActiveColumnsCount() {
            return $scope.columns.filter(function (column) {
                return column.model;
            }).length
        }


        function fetchAllOrg() {
            RestManager.getResource("/org", "organisations")
                .then(function (result) {
                    $scope.orgs = result;
                })
                .catch(function (err) {
                    console.log("users.all.controller.js", err);
                });
        }

        function fetchAllWarehouses() {
            RestManager.getResource('/warehouse', 'warehouses')
                .then(function (result) {
                    $scope.warehouses = result;
                })
                .catch(function (err) {
                    console.log("users.all.controller.js Warehouses", err);
                });
        }

        function queryUsers(searchText, roles, ids) {
            var query = {
                q: searchText,
                fields: 'name,mobile,role',
                page: 1,
                limit: 5,
                roles: roles,
                ids: ids
            };
            if (!query.q) {
                delete query.q
            }
            if (!query.roles) {
                delete query.roles
            }
            if (!query.ids) {
                delete query.ids
            }
            return RestManager.getResource("/users/filter", "users", {
                query: query
            })
                .then(function (users) {
                    return users;
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error loading user : ' + err.message);
                })
        }

        function showFilters() {
            $scope.filterList = !$scope.filterList;
        }

        function openSearchToolbar() {
            $scope.showSearchBar = !$scope.showSearchBar;
            if (!$scope.showSearchBar) {
                $scope.query.search = '';
                // $scope.fetchPosOrders();
            }
        }

        function keyAction(event) {
            // if (event.which === 13)
            // $scope.fetchPosOrders()
        }

        function clearFilters() {
            $scope.query = {
                page: 1,
                limit: 10,
                orderBy: "-createdAt",
                search: '',
                currentStatus: 'all',
                filter: {}
            };
            $scope.queryParams = {
                filterDesigners: [],
                startDate: '',
                endDate: '',
                filterOrgs: [],
                filterWarehouses: [],
                filterChannels: [],
                filterBillingPerson: [],
                rangeModel: null
            };
            $scope.parseFilters();
        }

        function openOrderFilterDialog(event) {
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                fullscreen: true,
                clickOutsideToClose: true,
                scope: $scope,
                preserveScope: true,
                contentElement: "#ordersFilterDialog"
            });
        }

        $scope.initFilters = function () {
            $scope.query = {
                page: $stateParams.page ? parseInt($stateParams.page) : 1,
                limit: $stateParams.limit ? parseInt($stateParams.limit) : 10,
                orderBy: $stateParams.orderBy || "-createdAt",
                search: $stateParams.q || '',
                currentStatus: $stateParams.currentStatus || 'all',
                filter: $stateParams.filter ? JSON.parse($stateParams.filter) : {}
            };

            $scope.queryParams = {
                filterDesigners: $stateParams.designers ? $stateParams.designers.split(',') : [],
                creator: $stateParams.filterBillingPerson ? $stateParams.filterBillingPerson.split(',') : [],
                startDate: $stateParams.startDate ? moment($stateParams.startDate, 'DD-MM-YYYY').startOf('day') : null,
                endDate: $stateParams.endDate ? moment($stateParams.endDate, 'DD-MM-YYYY').endOf('day') : null,
                filterOrgs: $stateParams.orgs ? $stateParams.orgs.split(',') : [],
                filterWarehouses: $stateParams.warehouses ? $stateParams.warehouses.split(',') : [],
                filterChannels: $stateParams.channels ? $stateParams.channels.split(',') : [],
                rangeModel: $stateParams.rangeModel || null
            };
            var storedColumns = $window.localStorage.getItem('orderColumns');
            if (storedColumns) {
                storedColumns = JSON.parse(storedColumns);

                $scope.columns = $scope.columns.map(function (column) {
                    var stored = _.find(storedColumns, function (storedColumn) {
                        return storedColumn.value === column.value;
                    });
                    if (stored) {
                        column.model = stored.model;
                    }
                    return column;
                })
            }
            $scope.applyFilter($scope.query.currentStatus);
            $scope.parseFilters();
        };


        function parseFilters() {
            $scope.hasFilters = false;
            if ($scope.queryParams.filterOrgs && $scope.queryParams.filterOrgs.length) {
                $scope.query.filter.organisation = {$in: $scope.queryParams.filterOrgs};
                $scope.hasFilters = true;
            } else {
                delete $scope.query.filter.organisation;
            }


            if ($scope.queryParams.filterWarehouses && $scope.queryParams.filterWarehouses.length) {
                $scope.query.filter['warehouse'] = {$in: $scope.queryParams.filterWarehouses};
                $scope.hasFilters = true;
            } else {
                delete $scope.query.filter['warehouse'];
            }

            if ($scope.queryParams.filterChannels && $scope.queryParams.filterChannels.length) {
                $scope.query.filter.saleChannel = {$in: $scope.queryParams.filterChannels};
                $scope.hasFilters = true;
            } else {
                delete $scope.query.filter.saleChannel;
            }

            if ($scope.queryParams.filterDesigners && $scope.queryParams.filterDesigners.length) {
                if ($scope.queryParams.filterDesigners[0]._id) {
                    $scope.query.filter.designer = {
                        $in: $scope.queryParams.filterDesigners.map(function (user) {
                            return user._id
                        })
                    }
                } else {
                    $scope.query.filter.designer = {
                        $in: $scope.queryParams.filterDesigners
                    };
                    $scope.populateUsers($scope.queryParams.filterDesigners);
                }
                $scope.hasFilters = true;
            } else {
                $scope.queryParams.filterDesigners = [];
                delete $scope.query.filter.designer;
            }

            if ($scope.queryParams.startDate && $scope.queryParams.endDate) {
                $scope.query.filter.createdAt = {
                    $gte: moment($scope.queryParams.startDate).startOf('day').toISOString(),
                    $lte: moment($scope.queryParams.endDate).endOf('day').toISOString()
                }
                $scope.hasFilters = true;
            }

            if ($scope.queryParams.startDate && !$scope.queryParams.endDate) {
                $scope.query.filter.createdAt = {
                    $gte: moment($scope.queryParams.startDate).startOf('day').toISOString()
                }
                $scope.hasFilters = true;
            }

            if (!$scope.queryParams.startDate && $scope.queryParams.endDate) {
                $scope.query.filter.createdAt = {
                    $lte: moment($scope.queryParams.endDate).endOf('day').toISOString()
                }
                $scope.hasFilters = true;
            }

            if (!$scope.queryParams.startDate && !$scope.queryParams.endDate) {
                delete $scope.query.filter.createdAt;
            }

            $mdDialog.hide();
            $scope.fetchOrders();
        }

        function applyFilter(status) {
            $scope.query.currentStatus = status;
            if (status !== 'all') {
                if (status === 'placed') {
                    $scope.query.filter.status = {$in: ['placed', 'approved']}
                } else {
                    $scope.query.filter.status = status;
                }
            } else {
                $scope.query.filter.status = {$ne: 'cancelled'};
            }

            $scope.parseFilters();
        }


        function fetchIncompleteOrders() {
            RestManager.postResource("/order/admin/getOrders", {
                page: 1,
                limit: 1,
                filter: {
                    status: 'incomplete',
                    saleChannel: {$ne: 'pos'},
                    createdAt: {$lt: moment().subtract(15, 'minutes').toString()}
                }
            }, "orders", ["total"])
                .then(function (result) {
                    $scope.incompleteOrders = result.orders;
                    $scope.totalIncompleteOrders = result.total;
                })
                .catch(function (err) {
                    console.log("err", err);
                })
        }

        $scope.fetchOrders = function () {
            if ($scope.query.search && $scope.query.search.length <= 2) {
                return;
            } else if ($scope.query.search) {
                $scope.query.filter.$or = [
                    {
                        orderNumber: {$regex: $scope.query.search, $options: 'ig'}
                    },
                    {
                        'cachedAddress.name': {$regex: $scope.query.search, $options: 'ig'}
                    },
                    {
                        'fullUser.name': {$regex: $scope.query.search, $options: 'ig'}
                    },
                    {
                        'cachedAddress.mobile': {$regex: $scope.query.search, $options: 'ig'}
                    },
                    {
                        'orderData.products.product.name': {$regex: $scope.query.search, $options: 'ig'}
                    },
                    {
                        'orderData.products.product.sku': {$regex: $scope.query.search, $options: 'ig'}
                    },
                    {
                        'cachedDesignerName': {$regex: $scope.query.search, $options: 'ig'}
                    }
                ]
            } else {
                delete $scope.query.filter.$or;
            }

            if ($scope.showCancelled) {
                $scope.query.filter = {};
            }

            $scope.promise = RestManager.postResource("/order/admin/getOrders", $scope.query, "orders", ["total"]);

            $scope.promise
                .then(function (result) {
                    $scope.total = result.total;
                    $scope.totalParkedAmount = 0;
                    $scope.orders = result.orders.map(function (order) {
                        if (order.status === 'incomplete' && order.saleChannel === 'pos') {
                            $scope.totalParkedAmount += parseInt(order.orderData.amount);
                            order.status = 'parked';
                        }
                        var keysLength = _.keys(order.checklist).length;
                        order.totalChecklists = keysLength < 10 ? 10 : keysLength;
                        if (!order.giftCard) {
                            order.totalChecklists -= 2;
                        }
                        order.checklistItems = _.chain(order.checklist)
                            .map(function (value, key) {
                                return {key: key, value: value, description: Utils.getChecklistDescription(key)}
                            })
                            .value();
                        order.completedChecklists = order.checklistItems
                            .filter(function (data) {
                                return data.value
                            })
                            .length;
                        order.completedPercent = _.round((order.completedChecklists / order.totalChecklists) * 100, 0);
                        order.daysOpen = moment().diff(moment(order.createdAt).startOf('day'), 'days');
                        return order;
                    });
                    console.log("orders.all.controller.js", "sd", $scope.orders);
                    $scope.changeState();
                    $scope.totalAmount = $scope.orders.reduce(function (a, o) {
                        if (o.status !== 'cancelled' && o.status !== 'incomplete' && o.status !== 'parked' && o.status !== 'returned') {
                            console.log("orders.all.controller.js", "o.orderData.amount", o.orderData.amount);
                            return a + parseInt(o.orderData.amount);
                        } else {
                            return a;
                        }
                    }, 0);

                })
                .catch(function (err) {
                    console.log("err", err);
                });
        };

        $scope.changeState = function () {
            console.log("orders.all.controller.js", "changeState", $scope.queryParams.startDate);
            var params = {
                page: $scope.query.page,
                limit: $scope.query.limit,
                orderBy: $scope.query.orderBy,
                q: $scope.query.search,
                currentStatus: $scope.query.currentStatus,
                rangeModel: $scope.queryParams.rangeModel,
                orgs: $scope.queryParams.filterOrgs.length ? $scope.queryParams.filterOrgs.join(',') : null,
                warehouses: $scope.queryParams.filterWarehouses.length ? $scope.queryParams.filterWarehouses.join(',') : null,
                channels: $scope.queryParams.filterChannels.length ? $scope.queryParams.filterChannels.join(',') : null,
                designers: $scope.query.filter.designer ?
                    $scope.query.filter.designer.$in.join(',') :
                    null,
                creator: $scope.query.filter.creator ?
                    $scope.query.filter.creator.$in.join(',') :
                    null,
                startDate: $scope.queryParams.startDate ? moment($scope.queryParams.startDate).format('DD-MM-YYYY').toString() : null,
                endDate: $scope.queryParams.endDate ? moment($scope.queryParams.endDate).format('DD-MM-YYYY').toString() : null
            };
            console.log("orders.all.controller.js", "changeState", params);
            $window.localStorage.setItem('orderColumns', JSON.stringify($scope.columns));
            $state.transitionTo("app.orders.all", params,
                { // prevent the events onStart and onSuccess from firing
                    notify: false,
                    // prevent reload of the current state
                    reload: false,
                    // replace the last record when changing the params so you don't hit the back button and get old params
                    location: 'replace'
                });
            $scope.backParams = JSON.stringify(params);
        };


        $scope.formatName = function (string) {
            return Utils.capitalize(string);
        };

        function reorder() {
            $scope.query.page = 1;
            $scope.fetchOrders();
        }

        function populateUsers(ids) {
            $scope.queryUsers(null, 'admin,designer', ids)
                .then(function (users) {
                    $scope.queryParams.filterDesigners = users;
                })
                .catch(function (err) {
                    console.log("orders.all.controller.js", "err", err);
                })
        }


        function openIncompleteOrderList(ev, orders) {
            $mdDialog.show({
                controller: "order.incomplete.dialog.controller",
                templateUrl: 'app/modules/orders/allOrders/partials/incomplete-orders-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                fullscreen: true,
                locals: {
                    orders: orders
                },
                clickOutsideToClose: true
            })
                .then(function () {
                    $scope.fetchIncompleteOrders();
                    $scope.fetchOrders();
                    $scope.selected = [];
                })
                .catch(function () {
                    $scope.fetchIncompleteOrders();
                    $scope.fetchOrders();
                    $scope.selected = [];
                })
        }

        function performSmartAction(ev, actionModel) {

            switch (actionModel) {
                case 1:
                    $scope.downloadShiprocketOrder(ev);
                    break;

                case 2:
                    var data = $scope.selected.map(function (order) {
                        return [
                            order.orderNumber,
                            order.user.name,
                            moment(order.createdAt).format('MMM DD, YYYY hh:mm:ss A').toString(),
                            order.giftCard ? order.giftCard.code : '',
                            order.orderData.products.length,
                            order.orderData.amount >= 3000 ? 3000 : order.orderData.amount,
                            order.orderData.amount >= 3000 ? order.orderData.amount - 3000 : 0,
                            order.orderData.amount,
                            order.cachedAddress.name,
                            order.cachedAddress.mobile,
                            Utils.formatAddress(order.cachedAddress, true),
                            _.capitalize(order.status),
                            ''
                        ]
                    });
                    $scope.copyText = SheetClip.stringify(data);
                    $mdDialog.show({
                        contentElement: '#copyOrderDataDialog',
                        preserveScope: true,
                        scope: $scope,
                        targetEvent: ev,
                        fullscreen: true,
                        clickOutsideToClose: true,
                    });
                    break;

                case 3:
                    $scope.openBillingDialog(ev);
                    break;

                case 4:
                    $scope.downloadShypliteOrder(ev);
            }
        }

        function showLoadingToast(message) {
            $mdToast.show(
                {
                    template: "<md-toast><div class='md-toast-content'><md-progress-circular class='md-warn' md-diameter='20'></md-progress-circular><span>" + message + "</span></div> <md-toast>",
                    hideDelay: 0,
                    position: "bottom right"
                }
            );
        }

        function clearSelection() {
            $scope.selected = [];
        }

        function downloadShiprocketOrder(ev) {
            if ($scope.selected && $scope.selected.length) {

                var wb = {
                    SheetNames: [],
                    Sheets: []
                };
                var dataToExport = _.chain($scope.selected)
                    .flatMap(function (order) {
                        return _.map(order.orderData.products, function (lineItem) {
                            var name = _.toUpper(order.cachedAddress.name).split(' ');
                            var firstName = name.slice(0, -1).join(' ');
                            var lastName = name.slice(-1).join(' ');
                            return {
                                '*Order Id': order.orderNumber,
                                'Order Date as dd-mm-yyyy hh:MM': moment(order.createdAt).format('DD-MM-YYYY hh:mm').toString(),
                                '*Channel': 'Manual',
                                '*Payment Method(COD/Prepaid)': order.paymentModeString === 'cod' ? 'COD' : 'Prepaid',
                                '*Customer First Name': firstName,
                                '*Customer Last Name': lastName,
                                '*Email': (order.agent && order.agent.email) || order.user.email || 'rajat@reduxpress.in',
                                '*Customer Mobile': order.cachedAddress.mobile,
                                '*Shipping Address Line 1': _.toUpper(order.cachedAddress.streetAddress),
                                '*Shipping Address Line 2': _.toUpper(order.cachedAddress.landmark),
                                '*Shipping Address Country': 'India',
                                '*Shipping Address State': _.toUpper(order.cachedAddress.state),
                                '*Shipping Address City': _.toUpper(order.cachedAddress.city),
                                '*Shipping Address Postcode': _.toUpper(order.cachedAddress.pinCode),
                                'Billing Address Line 1': _.toUpper(order.cachedAddress.streetAddress),
                                'Billing Address Line 2': _.toUpper(order.cachedAddress.landmark),
                                'Billing Address Country': 'India',
                                'Billing Address State': _.toUpper(order.cachedAddress.state),
                                'Billing Address City': _.toUpper(order.cachedAddress.city),
                                'Billing Address Postcode': _.toUpper(order.cachedAddress.pinCode),
                                '*Master SKU': lineItem.product.sku,
                                '*Product Name': lineItem.product.name,
                                '*Product Quantity': lineItem.quantity,
                                'Tax %': lineItem.totalPrice > 1000 ? 12 : 5,
                                '*Selling Price(Per Unit Item, Inclusive of Tax)': lineItem.price,
                                'Discount(Per Unit Item)': 0,
                                'Shipping Charges(Per Order)': 0,
                                'COD Charges(Per Order)': 0,
                                'Gift Wrap Charges(Per Order)': 0,
                                'Total Discount (Per Order)': 0,
                                'Length (cm)': 24,
                                'Breadth (cm)': 24,
                                'Height (cm)': 4,
                                'Weight Of Shipment(kg)': 0.5,
                                'Send Notification(True/False)': 'FALSE',
                                'Comment': order.user.name,
                                'HSN Code': '',
                                'Pickup Location Id': '',
                                'Reseller Name': '',
                                'Company Name': '',
                                'Ewaybill No': ''
                            };
                        })
                    })
                    .value();
                var headers = Object.keys(dataToExport[0]);
                var fileName = "Orders List";
                wb.SheetNames.push('Orders');
                var jsonToSheetOptions = {header: headers, skipHeader: false};
                var ws = XLSX.utils.json_to_sheet(dataToExport, jsonToSheetOptions);
                var wopts = {bookType: 'csv', bookSST: false, type: 'binary'};

                wb.Sheets['Orders'] = ws;

                var wbout = XLSX.write(wb, wopts);

                // noinspection JSAnnotator
                function s2ab(s) {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }

                // /* the saveAs call downloads a file on the local machine */
                saveAs(new Blob([s2ab(wbout)],
                    {type: "application/octet-stream"}),
                    fileName + '-' + moment().format('llll').toString() + '.csv');

                $mdToast.hide();
                $mdToast.showSimple('Downloaded Shiprocket file successfully!');
            }
        }

        function downloadShypliteOrder(ev) {
            if ($scope.selected && $scope.selected.length) {

                var wb = {
                    SheetNames: [],
                    Sheets: []
                };
                var dataToExport = _.chain($scope.selected)
                    .flatMap(function (order) {
                        var quantity = _.reduce(order.orderData.products, function (acc, val) {
                            console.log(val, acc, '---------------')
                            return acc + val.quantity;
                        }, 0);
                        console.log(quantity, "QUANTITY")
                        var name = _.toUpper(order.cachedAddress.name).split(' ');
                        var firstName = name.slice(0, -1).join(' ');
                        var lastName = name.slice(-1).join(' ');
                        return {
                            'Order ID': order.orderNumber,
                            'Customer Name': firstName + ' ' + lastName,
                            'Customer Address': _.toUpper(order.cachedAddress.streetAddress) + ', ' + _.toUpper(order.cachedAddress.landmark) + ', ' + _.toUpper(order.cachedAddress.state) + ', ' + _.toUpper(order.cachedAddress.city),
                            'Customer City': _.toUpper(order.cachedAddress.city),
                            'Customer Pincode': _.toUpper(order.cachedAddress.pinCode),
                            'Customer Contact Number': order.cachedAddress.mobile,
                            'Shipment Date': moment(order.createdAt).format('DD/MM/YYYY').toString(),
                            'Category': 'Clothing And Accessories',
                            'Item Name': order.user.name,
                            'Quantity': quantity,
                            'Pickup Address Name': 'Flagship',
                            'Order Type': order.paymentModeString === 'cod' ? 'COD' : 'Prepaid',
                            'Total Value (Rs)': order.orderData.amount,
                            'Package Length (cm)': 29,
                            'Package Width (cm)': 27,
                            'Package Height (cm)': 4,
                            'Package Weight (kg)': 0.5,
                            'Mode Type': 'Air'
                        };
                    })
                    .value();
                var headers = Object.keys(dataToExport[0]);
                var fileName = "Orders List";
                wb.SheetNames.push('Orders');
                var jsonToSheetOptions = {header: headers, skipHeader: false};
                var ws = XLSX.utils.json_to_sheet(dataToExport, jsonToSheetOptions);
                var wopts = {bookType: 'xlsx', bookSST: false, type: 'binary'};

                wb.Sheets['Orders'] = ws;

                var wbout = XLSX.write(wb, wopts);

                // noinspection JSAnnotator
                function s2ab(s) {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }

                // /* the saveAs call downloads a file on the local machine */
                saveAs(new Blob([s2ab(wbout)],
                    {type: "application/octet-stream"}),
                    fileName + '-' + moment().format('llll').toString() + '.xlsx');

                $mdToast.hide();
                $mdToast.showSimple('Downloaded Shyplite Order file successfully!');
            }
        }

        function promptAwbDialog(ev, order) {
            $mdDialog.show(
                $mdDialog.prompt()
                    .title('Set AWB Number for this order')
                    .textContent('The order has been marked as shipped but the AWB number has not been set. Please enter it to continue.')
                    .placeholder('AWB Number')
                    .targetEvent(ev)
                    .initialValue(order.awbCode)
                    .required(true)
                    .ok('Save AWB')
                    .cancel('Cancel')
            )
                .then(function (data) {
                    if (data) {
                        $scope.showLoadingToast('Saving AWB');
                        return RestManager.putResource("/order/admin/awb", {id: order._id, awb: data}, "orders")
                    } else {
                        return null
                    }
                })
                .then(function (result) {
                    if (result) {
                        order.awbCode = result[0].awbCode;
                        $mdToast.hide();
                        $mdToast.showSimple('Updated AWB Successfully');
                    }
                })
                .catch(function (err) {
                    $mdToast.hide();
                    $mdToast.showSimple('Error saving AWB for order :' + err.message);
                })
        }

        function openBillingDialog(ev) {
            $scope.newBill.organisation = null;
            $scope.newBill.lineItems = $scope.selected.map(function (order) {
                var amount = order.giftCardAmount ? order.giftCardAmount : order.orderData.amount;
                var discountAmount = $scope.getDiscountValue(amount, $scope.globalDiscountPercent);
                var totalAmount = _.round(amount - discountAmount, 2);
                var issue = null;
                if (order.checklist && order.checklist.isOrgPaymentDone) {
                    issue = 'Payment is already done by organisation';
                } else if (order.checklist && order.checklist.isOrgBillingDone) {
                    issue = 'Billing is already done';
                }
                var productList = order.orderData.products.map(function (lineItem) {
                    console.log("orders.all.controller.js", "lineItem", lineItem);
                    var taxPercent = lineItem.price >= 1000 ? 12 : 5;
                    return {
                        name: lineItem.product.name,
                        sku: lineItem.product.sku,
                        price: lineItem.price,
                        taxPercent: lineItem.taxPercent || taxPercent,
                        taxAmount: lineItem.taxAmount,
                        quantity: lineItem.quantity,
                        hsn: lineItem.product.hsn || '6210100'
                    }
                });
                return {
                    description: Utils.capitalize(order.user.name) + ' (' + order.orderNumber + ')',
                    order: order._id,
                    price: amount,
                    productList: productList,
                    discountPercent: $scope.globalDiscountPercent,
                    discountAmount: discountAmount,
                    quantity: 1,
                    isOrgPaymentDone: order.checklist && order.checklist.isOrgPaymentDone,
                    isOrgBillingDone: order.checklist && order.checklist.isOrgBillingDone,
                    issue: issue,
                    totalPrice: totalAmount,
                    organisation: order.organisation ? order.organisation._id : null
                }
            });
            $scope.newBill.amount = _.round($scope.newBill.lineItems.reduce(function (acc, val) {
                return acc + val.totalPrice;
            }, 0), 2);
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: ev,
                fullscreen: true,
                clickOutsideToClose: true,
                scope: $scope,
                preserveScope: true,
                contentElement: "#orgBillingDialog"
            });
        }

        function getDiscountValue(amount, percent) {
            return _.round(amount * (percent / 100), 2);
        }

        function updateLineItem(lineItem) {
            lineItem.discountAmount = $scope.getDiscountValue(lineItem.price, lineItem.discountPercent);
            lineItem.totalPrice = _.round(lineItem.price - lineItem.discountAmount, 2);
            $scope.newBill.amount = _.round($scope.newBill.lineItems.reduce(function (acc, val) {
                return acc + val.totalPrice;
            }, 0), 2);
        }

        function removeLineItem(index) {
            $scope.newBill.lineItems.splice(index, 1);
            $scope.newBill.amount = _.round($scope.newBill.lineItems.reduce(function (acc, val) {
                return acc + val.totalPrice;
            }, 0), 2);
        }

        function detectIssues() {
            $scope.newBill.lineItems = $scope.newBill.lineItems.map(function (lineItem) {
                if (lineItem.organisation !== $scope.newBill.organisation) {
                    lineItem.issue = 'Order does not belong to this organisation'
                } else if (lineItem.isOrgPaymentDone) {
                    lineItem.issue = 'Payment is already done by organisation';
                } else if (lineItem.isOrgBillingDone) {
                    lineItem.issue = 'Billing is already done';
                } else {
                    lineItem.issue = null;
                }
                return lineItem;
            })
        }

        function generateOrgBill() {
            $scope.generatingBill = true;
            var transaction;
            RestManager.postResource('/txn/bill', $scope.newBill, 'transactions')
                .then(function (transactions) {
                    transaction = transactions[0];
                    var orderIds = transaction.lineItems.map(function (item) {
                        return item.order;
                    });
                    return RestManager.patchResource('/order/updateBillingInfo', {
                        ids: orderIds,
                        data: {transactionId: transaction.txnId, transaction: transaction._id}
                    }, 'orders')
                })
                .then(function (orders) {
                    $scope.generatingBill = false;
                    $mdDialog.cancel();
                    $scope.fetchOrders();
                    $mdToast.showSimple('Generated Bill');
                    $scope.selected = [];
                })
                .catch(function (err) {
                    $scope.generatingBill = false;
                    $mdToast.showSimple('Error generating bill : ' + err.message);
                })
        }

        function updateDiscounts() {
            $scope.newBill.lineItems = $scope.newBill.lineItems.map(function (lineItem) {
                var discountAmount = $scope.getDiscountValue(lineItem.price, $scope.globalDiscountPercent);
                lineItem.totalPrice = _.round(lineItem.price - discountAmount, 2);
                lineItem.discountAmount = discountAmount;
                lineItem.discountPercent = $scope.globalDiscountPercent;
                return lineItem;
            });
            $scope.newBill.amount = _.round($scope.newBill.lineItems.reduce(function (acc, val) {
                return acc + val.totalPrice;
            }, 0), 2);
        }

        function updateDateFilter() {
            if ($scope.queryParams.rangeModel !== 'custom') {
                var selectedModel = null;
                $scope.rangeModels.forEach(function (a) {
                    _.forEach(a.models, function (model) {
                        if (model.value === $scope.queryParams.rangeModel) {
                            selectedModel = model;
                        }
                    })
                });

                if (selectedModel) {
                    $scope.queryParams.startDate = selectedModel.startDate;
                    $scope.queryParams.endDate = selectedModel.endDate;
                }
            }
        }

        function openConfirmOrderShipmentDialog(e, order) {
            // var gOrder = {};
            // angular.copy(order, gOrder);
            // var agent = _.find($scope.agents, function (agent) {
            //     return agent._id === $scope.order.agent;
            // })
            var passedOptions = {
                order: order,
                options: {
                    context: 'order',
                    selectedIndex: 2,
                    scopes: ['email'],
                    selectedTemplate: 'Shipment Of Orders',
                    //TODO: Add id's of user's whose id is required
                    email: {
                        cc: [
                            {
                                name: "Kumar Divya Rajat",
                                email: "rajat@reduxpress.in"
                            },
                            {
                                name: "Kumar Aditya",
                                email: "kumar.aditya@reduxpress.in"
                            },
                            {
                                name: "Sony Choudhary",
                                email: "sony@aadira.com",
                            }
                        ],
                        to: [
                            {
                                name: "Vikas Kashyap",
                                email: "vikas.kashyap@goddres.com",
                            },
                            {
                                name: "Ajaz Nathani",
                                email: "nathaniajaz@goddres.com",
                            },
                            {
                                name: order.agent.name,
                                email: order.agent.email
                            }
                        ],
                        replyTo: {
                            name: "Kumar Divya Rajat",
                            email: "rajat@reduxpress.in",
                        }
                    }
                }
            };
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: e,
                multiple: true,
                fullscreen: true,
                templateUrl: 'app/modules/components/notifications/user-notifications.html',
                locals: passedOptions,
                controller: 'notificationsController',
                clickOutsideToClose: true
            })
                .then(function (response) {
                    order.confirmationStatus = response[0].confirmationStatus;
                    $mdToast.showSimple('Requested Confirmation for the Shipment successfully');
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error while requesting confirmation : ' + err.message);
                });
        }


        function notify(orders, event) {
            var selectedOrders = [];
            angular.copy(orders, selectedOrders);
            orders = _.uniqBy(orders, function (order) {
                return order.user._id;
            });
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                fullscreen: true,
                templateUrl: 'app/modules/components/notifications/user-notifications.html',
                locals: {
                    options: {
                        context: 'order',
                        selectedIndex: 0
                    },
                    order: orders
                },
                controller: 'notificationsController',
                clickOutsideToClose: true
            })
                .then(function (data) {

                })
                .catch(function (err) {
                    console.log(err)
                })
        }

        $scope.initFilters();
        $scope.fetchIncompleteOrders();
        $scope.fetchAllOrg();
        $scope.fetchAllWarehouses();

    }]);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 26/4/19 4:56 PM
 *
 */

(function () {
    'use strict';

    OrderIncompleteCtrl.$inject = ["$scope", "$mdDialog", "orders", "RestManager", "Utils", "$mdToast"];
    angular.module('app.orders')
        .controller('order.incomplete.dialog.controller', OrderIncompleteCtrl);

    function OrderIncompleteCtrl($scope, $mdDialog, orders, RestManager, Utils, $mdToast) {
        $scope.query = {
            page: 1,
            limit: 10,
            orderBy: "-createdAt",
            filter: {
                status: 'incomplete',
                saleChannel: {$ne: 'pos'},
                createdAt : {$lt : moment().subtract(15, 'minutes').toString()}
            }
        };

        $scope.fetchIncompleteOrders = fetchIncompleteOrders;
        $scope.close = close;
        $scope.formatName = formatName;
        $scope.cancelOrder = cancelOrder;

        function formatName(string) {
            return Utils.capitalize(string);
        }

        function fetchIncompleteOrders() {
            $scope.promise = RestManager.postResource("/order/admin/getOrders", $scope.query, "orders", ["total"]);

            $scope.promise
                .then(function (result) {
                    $scope.incompleteOrders = result.orders.filter(function (order) {
                        return !order.saleChannel || order.saleChannel === 'website'
                    });
                    $scope.totalIncompleteOrders = result.total;
                    console.log('Incomplete Order', $scope.incompleteOrders, $scope.totalIncompleteOrders);
                })
                .catch(function (err) {
                    console.log("err", err);
                })
        }

        function cancelOrder(ev, order, index) {
            order.cancelling = true;
            RestManager.deleteResource('/order/admin/cancelIncomplete/' + order.orderNumber, 'orders')
                .then(function (orders) {
                    var order = orders[0];
                    $scope.incompleteOrders[index].cancelling = false;
                    $scope.incompleteOrders[index].cancelled = true;
                    $mdToast.showSimple('Cancelled order :' + order.orderNumber)
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error Cancelling order :' + order.orderNumber + ' | ERR : ' + err.message);
                    $scope.incompleteOrders[index].cancelling = false;
                })
        }

        function close() {
            $mdDialog.cancel();
        }

        if (!orders || !orders.length) {
            $scope.fetchIncompleteOrders();
            $scope.isIncomplete = true;
        } else {
            console.log("order.incomplete.dialog.controller.js", "OrderIncompleteCtrl", orders);
            $scope.incompleteOrders = orders;
            $scope.totalIncompleteOrders = orders.length;
            $scope.isIncomplete = false;
        }
    }

})(angular);

/**
 * Created by kumardivyarajat on 04/12/16.
 */
angular.module("app.orders")
    .controller("orders.add.controller", ["$scope", function ($scope) {

    }]);
// (function () {
//     'use strict';
//     angular.module("app.offers.giftCards")
//         .service("allCardDataService", allCardDataService);
//
//     function allCardDataService(RestManager) {
//
//
//
//         // this.getAll = function() {
//         //
//         //     return $http({
//         //         method: 'GET',
//         //         url: 'ouvrage?action=getcategorie',
//         //         // pass in data as strings
//         //         headers: {'Content-Type': 'application/x-www-form-urlencoded'}  // set the headers so angular passing info as form data (not request payload)
//         //     })
//         //         .then(function(data) {
//         //
//         //             return data;
//         //
//         //
//         //         })
//         //
//         //
//         // }
//
//
//         //
//         // return {
//         //     getResponders: function() {
//         //         return $http.get('myUrl')
//         //             .then(function(response) {
//         //                 console.log("coming from servicejs", response.data);
//         //                 //return data when promise resolved
//         //                 //that would help you to continue promise chain.
//         //                 return response.data;
//         //             });
//         //     }
//         // };
//
//
//         this.fetchAllCards = function () {
//             return RestManager.getResource("/giftCards/admin", "cards", {query: this.query})
//                 .then(function (result) {
//                     console.log(result);
//                     return result;
//                 })
//                 .catch(function (err) {
//                     console.log(err);
//                 });
//         };
//
//         // return{
//         //     fetchAllCards: function () {
//         //        RestManager.getResource("/giftCards/admin", "cards", {query: this.query})
//         //             .then(function (result) {
//         //                 console.log(result);
//         //                 return result;
//         //             })
//         //             .catch(function (err) {
//         //                 console.log(err);
//         //             });
//         //     }
//         // };
//
//
//
//     }
//
// })(angular);

(function () {
    'use strict';
    giftCardsHome.$inject = ["$scope"];
    angular.module('app.offers.giftCards')
        .controller("offers.giftCardsHome.controller", giftCardsHome);


    function giftCardsHome($scope){
        $scope.$parent.pageTitle = "GIFT CARDS";
    }

})(angular);

(function () {
    'use strict';

    clearFraudlentCards.$inject = ["$scope", "$mdDialog", "payload", "mode", "fraudAttempt", "RestManager", "$mdToast"];
    angular.module("app.offers.giftCards")
        .controller("clearFraudlentCards.controller", clearFraudlentCards);

    function clearFraudlentCards($scope, $mdDialog, payload, mode, fraudAttempt, RestManager, $mdToast) {
        $scope.fraudAttempt = fraudAttempt;
        $scope.mode = mode;
        $scope.payload = {
            _id: payload._id,
            index: payload.index,
            description: ''
        };
        $scope.resolving = false;
        $scope.blocking = false;

        console.log("clearFraudlentsCards.controller.js", "resolveGiftCards", payload);


        $scope.closeDialog = closeDialog;
        $scope.handleFraudAttempts = handleFraudAttempts;


        function closeDialog() {
            $mdDialog.cancel();
        }

        function handleFraudAttempts() {
            $scope.handlingFraudTicket = true;
            var payloadForHandlingCards = {};
            angular.copy($scope.payload, payloadForHandlingCards);
            if (payloadForHandlingCards.isSuspicious === undefined) {
                payloadForHandlingCards.isSuspicious = false;
            }
            var promise = '';
            if ($scope.mode === 'resolve') {

                promise = RestManager.patchResource('/giftCards/resolveCardsById/' + payloadForHandlingCards._id, payloadForHandlingCards, "cards");

            } else if ($scope.mode === 'block') {
                promise = RestManager.patchResource('/giftCards/blockCardsById/' + payloadForHandlingCards._id, payloadForHandlingCards, "cards");
            }

            promise
                .then(function (response) {
                    $scope.handlingFraudTicket = false;
                    $mdToast.showSimple('Successfully ' + mode === 'resolve' ? ' resolving ' : 'blocking' + ' fraud attempt');
                    $mdDialog.hide({updatedData: response[0]});
                })
                .catch(function (err) {
                    $scope.handlingFraudTicket = false;
                    $mdToast.showSimple("Error in " + mode === 'resolve' ? ' resolving ' : 'blocking' + " gift card: " + err.message);
                });
        }
    }
})(angular);

(function () {
    'use strict';
    giftCardsDetails.$inject = ["$scope", "RestManager", "$stateParams", "$mdToast", "$mdDialog", "$timeout", "$interval", "AuthManager", "Utils", "Images", "Users"];
    angular.module('app.offers.giftCards')
        .controller("offers.giftCardsDetails.controller", giftCardsDetails);


    function giftCardsDetails($scope, RestManager, $stateParams, $mdToast, $mdDialog, $timeout,
                              $interval, AuthManager, Utils,Images, Users) {
        $scope.$parent.$parent.pageTitle = "Gift Card Details";
        $scope.$parent.$parent.nestedState = true;
        $scope.$parent.$parent.showActionButton = false;
        console.log("giftCardsDetails.controller.js", "fetchCards", $stateParams.cardId);
        $scope.$parent.$parent.backState = $stateParams.backState || "app.giftCards.all";
        $scope.$parent.$parent.backParams = {};
        $scope.cardStatusValue = 0;
        $scope.blocking = false;
        $scope.settingPayload = {};
        $scope.cardsBlocked = false;
        $scope.showCardChat = !!$stateParams.openNotes;
        $scope.imageSelected = null;
        $scope.message = null;
        $scope.currentUser = AuthManager.getCurrentUser();


        $scope.dateAgo = Utils.dateAgo;
        $scope.openImages = Images.openImageGallery;
        $scope.getCardStatusValue = getCardStatusValue;
        $scope.updateFraudAttempt = updateFraudAttempt;
        $scope.updateChanges = updateChanges;
        $scope.rearrangeCards = rearrangeCards;
        $scope.findReferences = findReferences;
        $scope.publishCardNote = publishCardNote;
        $scope.selectCaseWorker = selectCaseWorker;

        $scope.fetchCards = function () {
            var url = "/giftCards/";
            $scope.promise = RestManager.getResource(url + $stateParams.cardId, "cards");

            $scope.promise
                .then(function (data) {
                    $scope.card = data[0];
                    $scope.rearrangeCards();
                    $scope.getCardStatusValue();
                })

                .catch(function (err) {
                    console.log("giftCardsDetails.controller.js", "CARD DETAILS ERROR", err);
                });

        };

        $scope.openExpiryUpdate = function (ev) {
            $scope.expiryDate = $scope.card.expiryDate;
            $scope.dateTemplates = [
                {
                    label: '1 month from Redemption',
                    value: moment($scope.card.redemptionDate).endOf('day').add(1, 'month').toISOString()
                },
                {
                    label: '3 months from Redemption',
                    value: moment($scope.card.redemptionDate).endOf('day').add(3, 'month').toISOString()
                },
                {
                    label: '6 months from Redemption',
                    value: moment($scope.card.redemptionDate).endOf('day').add(6, 'month').toISOString()
                },
                {
                    label: '1 year from Redemption',
                    value: moment($scope.card.redemptionDate).endOf('day').add(1, 'year').toISOString()
                },
            ];
            $mdDialog.show({
                contentElement: '#expiryUpdateDialog',
                scope: $scope,
                fullscreen: true,
                targetEvent: ev,
                preserveScope: true
            });
        };

        $scope.updateExpiryDate = function () {
            $scope.savingExpiry = true;
            var expiryDate = moment($scope.expiryDate).endOf('day').toISOString();
            RestManager.patchResource('/giftCards/expiryDate/' + $stateParams.cardId, {date: expiryDate}, 'expiryDate')
                .then(function (data) {
                    $mdToast.showSimple('Updated Expiry Date');
                    $scope.card.expiryDate = $scope.expiryDate;
                    $scope.savingExpiry = false;
                    $scope.close();
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error updating the expiry date : ' + err.message);
                    $scope.savingExpiry = false;
                });
        };

        $scope.close = function () {
            $mdDialog.cancel();
        };


        function getCardStatusValue() {

            var a = $timeout(function () {
                switch ($scope.card.status) {
                    case "created" :
                        $scope.cardStatusValue = 0;
                        $scope.createdSuccess = true;
                        $scope.generatedSuccess = false;
                        $scope.activatedSuccess = false;
                        $scope.redeemedSuccess = false;
                        $scope.expiredSuccess = false;
                        $scope.blockedSuccess = false;
                        break;

                    case "generated" :
                        $scope.cardStatusValue = 20;
                        $scope.createdSuccess = true;
                        $scope.generatedSuccess = true;
                        $scope.activatedSuccess = false;
                        $scope.redeemedSuccess = false;
                        $scope.expiredSuccess = false;
                        $scope.blockedSuccess = false;
                        break;


                    case "activated" :
                        $scope.cardStatusValue = 40;
                        $scope.createdSuccess = true;
                        $scope.generatedSuccess = true;
                        $scope.activatedSuccess = true;
                        $scope.redeemedSuccess = false;
                        $scope.expiredSuccess = false;
                        $scope.blockedSuccess = false;
                        break;


                    case "redeemed":
                        $scope.cardStatusValue = 60;
                        $scope.createdSuccess = true;
                        $scope.generatedSuccess = true;
                        $scope.activatedSuccess = true;
                        $scope.redeemedSuccess = true;
                        $scope.expiredSuccess = false;
                        $scope.blockedSuccess = false;
                        break;


                    case "expired":
                        $scope.cardStatusValue = 80;
                        $scope.createdSuccess = true;
                        $scope.generatedSuccess = true;
                        $scope.activatedSuccess = true;
                        $scope.redeemedSuccess = true;
                        $scope.expiredSuccess = true;
                        $scope.blockedSuccess = false;
                        break;

                    case "blocked":
                        $scope.cardStatusValue = 100;
                        $scope.createdSuccess = true;
                        $scope.generatedSuccess = true;
                        $scope.activatedSuccess = true;
                        $scope.redeemedSuccess = true;
                        $scope.expiredSuccess = true;
                        $scope.blockedSuccess = true;
                        break;
                }

                var i = 0;
                var b = $interval(function () {
                    switch (i) {
                        case 0:
                            $scope.showCreatedSuccess = true;
                            break;

                        case 1 :
                            $scope.showGeneratedSuccess = true;
                            break;

                        case 2:
                            $scope.showActivatedSuccess = true;
                            break;

                        case 3:
                            $scope.showRedeemedSuccess = true;
                            break;

                        case 4:
                            $scope.showExpiredSuccess = true;
                            break;

                        case 5:
                            $scope.showBlockedSuccess = true;
                            break;

                        case 6:
                            $interval.cancel(b);
                            break;
                    }
                    i++;
                }, 50);
            }, 1000);
        }

        function updateFraudAttempt(id, index, fraudAttempt, mode) {
            $scope.blocking = true;
            var payload = {
                _id: id,
                index: fraudAttempt.initialIndex,
                status: $scope.card.status
            }
            $mdDialog.show({
                controller: "clearFraudlentCards.controller",
                templateUrl: 'app/modules/offers/giftCards/dialogs/partials/index.tmpl.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    mode: mode,
                    payload: payload,
                    fraudAttempt: fraudAttempt
                }
            })
                .then(function (response) {
                    $scope.card.status = response.updatedData.status;
                    $scope.card.fraudAttempts = response.updatedData.fraudAttempts;
                    $scope.rearrangeCards();
                    $mdToast.showSimple('Successfully ' + mode + 'ed card!');
                })
                .catch(function (err) {
                    console.log("giftCardsDetails.controller.js", "Error", err);
                    $mdToast.showSimple('Error in ' + mode + 'ing card : ' + err.message);
                });
        }

        function updateChanges() {
            $scope.savingFlag = true;
            RestManager.patchResource('/giftCards/changeSettingsById/' + $scope.card._id, $scope.card.flags, "cards")
                .then(function (response) {
                    $scope.savingFlag = false;
                    $mdToast.showSimple("Flags Settings Updated");
                })
                .catch(function (err) {
                    $mdToast.showSimple("Error saving card flags : " + err.message);
                    $scope.savingFlag = false;
                });
        }

        function rearrangeCards() {
            $scope.card.fraudAttempts = $scope.card.fraudAttempts.map(function (fraudAttempt, i) {
                if (fraudAttempt.fraudAttemptPriority === undefined) {
                    fraudAttempt.fraudAttemptPriority = null;
                }
                if (!fraudAttempt.processed) {
                    fraudAttempt.fraudAttemptPriority = -1;
                } else if (fraudAttempt.processed && !fraudAttempt.blocksCard) {
                    fraudAttempt.fraudAttemptPriority = 1;
                } else if (fraudAttempt.processed && fraudAttempt.blocksCard) {
                    fraudAttempt.fraudAttemptPriority = 0;
                }
                fraudAttempt.initialIndex = i;
                return fraudAttempt;
            });
            $scope.fraudAttempts = _.orderBy($scope.card.fraudAttempts, ['fraudAttemptPriority', 'date'], ['asc', 'desc']);
        }

        function publishCardNote() {
            if ($scope.message || $scope.imageSelected) {
                if (!$scope.card.notes) {
                    $scope.card.notes = [];
                }

                var data = {
                    comment: $scope.message,
                    images: $scope.imageSelected ? [$scope.imageSelected] : null,
                    date: new Date(),
                    by: $scope.currentUser._id,
                    byName: $scope.currentUser.name,
                    references: $scope.findReferences($scope.message),
                    saving: true
                };

                var index = $scope.card.notes.length;

                $scope.card.notes.push(data);

                RestManager.patchResource('/giftCards/comments/' + $scope.card._id, data, 'card')
                    .then(function (orders) {
                        $scope.card.notes[index].saving = false;
                        $scope.message = '';
                    })
                    .catch(function (err) {
                        $scope.card.notes[index].error = true;
                    });

                $scope.message = '';
                $scope.imageSelected = null;
            }
        }

        function findReferences(message) {
            var regex = /@\[([\s\w]+):([0-9a-z-]+)\]/gi;
            var m;
            var references = [];
            var i = 0;
            while ((m = regex.exec(message)) !== null) {
                // This is necessary to avoid infinite loops with zero-width matches
                if (m.index === regex.lastIndex) {
                    regex.lastIndex++;
                }

                m.forEach(function (match, groupIndex) {
                    if (groupIndex === 0) {
                        references.push({});
                    }
                    if (groupIndex === 1) {
                        references[i].name = _.trim(match);
                    }
                    if (groupIndex === 2) {
                        references[i].user = _.trim(match);
                    }
                });
                i++;
            }
            return references;
        }

        function selectCaseWorker(event) {
            Users.selectUserDialog(event, {fields: 'name,mobile,role', roles: 'admin,designer', multiple: false})
                .then(function (user) {
                    $scope.updatingHandler = true;
                    if(user) {
                        return RestManager.patchResource('/giftCards/handler', {giftCardIds : [$scope.card._id], user : user._id}, 'cards')
                    } else {
                        throw new Error('No User Selected')
                    }
                })
                .then(function (orders) {
                    $scope.updatingHandler = false;
                    $scope.card.notes = orders[0].notes;
                    $scope.card.caseWorker = orders[0].caseWorker;
                    $scope.card.cachedCaseWorker = orders[0].cachedCaseWorker;
                    $mdToast.showSimple('Updated handler successfully');
                })
                .catch(function (err) {
                    $scope.updatingHandler = false;
                    $mdToast.showSimple('Error updating handler : ' + err.message)
                })
        }


        $scope.fetchCards();
    }

})(angular);

(function () {
    'use strict';

    giftCardsAll.$inject = ["$scope", "RestManager", "$mdDialog", "$mdToast", "$stateParams", "$state", "CriticalUpdateConfirmation", "Users"];
    angular.module("app.offers.giftCards")
        .controller("offers.giftCardsAll.controller", giftCardsAll);

    function giftCardsAll($scope, RestManager, $mdDialog, $mdToast, $stateParams,
                          $state, CriticalUpdateConfirmation, Users) {
        $scope.$parent.$parent.showActionButton = false;
        $scope.$parent.$parent.pageTitle = "All Gift Cards";
        $scope.$parent.$parent.nestedState = false;
        $scope.query = {
            limit: 25,
            page: 1,
            sort: "-updatedAt",
            search: '',
            status: 'all',
            redemptionStartDate: null,
            redemptionEndDate: null,
        };

        $scope.selected = [];
        $scope.filterUsers = [];
        $scope.filterOrgs = [];
        $scope.filterAgents = [];
        $scope.filterCaseWorkers = [];
        $scope.fraudCards = null;
        $scope.loadingFraud = true;
        $scope.showFilters = false;
        $scope.hasFilters = false;
        $scope.columns = [
            {
                name: 'Code',
                model: true,
                orderBy: 'cardCode',
                value: 'code'
            },
            {
                name: 'Status',
                model: true,
                orderBy: 'status',
                value: 'status'
            },
            {
                name: 'Card Type',
                model: false,
                orderBy: 'cardType',
                value: 'cardType'
            },
            {
                name: 'Balance',
                model: true,
                orderBy: 'balance',
                value: 'balance'
            },
            {
                name: 'User',
                model: true,
                orderBy: 'user',
                value: 'user'
            },
            {
                name: 'Organisation',
                model: true,
                orderBy: 'organisation',
                value: 'organisation'
            },
            {
                name: 'Agent',
                model: true,
                orderBy: 'agent',
                value: 'agent'
            },
            {
                name: 'Handler',
                model: false,
                orderBy: 'handler',
                value: 'handler'
            },
            {
                name: 'Updated At',
                model: false,
                orderBy: 'updatedAt',
                value: 'updatedAt'
            },
            {
                name: 'Created At',
                model: false,
                orderBy: 'createdAt',
                value: 'createdAt'
            },
            {
                name: 'Redeem Date',
                model: false,
                orderBy: 'redemptionDate',
                value: 'redemptionDate'
            },
            {
                name: 'Activation Date',
                model: false,
                orderBy: 'activationDate',
                value: 'activationDate'
            },
            {
                name: 'Last Reminder',
                model: false,
                orderBy: 'lastReminderDate',
                value: 'lastReminderDate'
            },
            {
                name: 'Expiry Date',
                model: false,
                orderBy: 'expiryDate',
                value: 'expiryDate'
            },
            {
                name: 'Last Fraud Date',
                model: false,
                orderBy: 'lastFraudAttemptDate',
                value: 'lastFraudAttemptDate'
            },
            {
                name: 'Actions',
                model: true,
                orderBy: null,
                value: 'actions'
            }
        ];


        $scope.openCardModal = openCardModal;
        $scope.downloadPrintFiles = downloadPrintFiles;
        $scope.clearSelections = clearSelections;
        $scope.updateStatus = updateStatus;
        $scope.fetchFraudulentCards = fetchFraudulentCards;
        $scope.showFraudulentCards = showFraudulentCards;
        $scope.clearFiler = clearFiler;
        $scope.changeState = changeState;
        $scope.init = init;
        $scope.expireCards = expireCards;
        $scope.fetchAllCloseToExpiryCards = fetchAllCloseToExpiryCards;
        $scope.showCloseToExpiryCards = showCloseToExpiryCards;
        $scope.openNotifications = openNotifications;
        $scope.toggleFilters = toggleFilters;
        $scope.selectAll = selectAll;
        $scope.fetchAllOrg = fetchAllOrg;
        $scope.parseFilters = parseFilters;
        $scope.cancel = cancel;
        $scope.openFiltersDialog = openFiltersDialog;
        $scope.queryUsers = queryUsers;
        $scope.clearFilters = clearFilters;
        $scope.selectCaseWorker = selectCaseWorker;
        $scope.sendToLocalStorage = sendToLocalStorage;
        $scope.updateExpiryDates = updateExpiryDates;
        // $scope.openAgentModal = openAgentModal;
        // $scope.openCustomerModal = openCustomerModal;


        function init() {
            var storedColumns = localStorage.getItem('giftCardColumns');
            if (storedColumns) {
                storedColumns = JSON.parse(storedColumns);

                $scope.columns = $scope.columns.map(function (column) {
                    var stored = _.find(storedColumns, function (storedColumn) {
                        return storedColumn.value === column.value;
                    });
                    if (stored) {
                        column.model = stored.model;
                    }
                    return column;
                })
            }
            if (localStorage.getItem('giftCardQuery')) {
                $scope.query = JSON.parse(localStorage.getItem('giftCardQuery'));
                $scope.filterUsers = $scope.query.filterUsers || [];
                $scope.filterOrgs = $scope.query.filterOrgs || [];
                $scope.filterAgents = $scope.query.filterAgents || [];
                $scope.filterCaseWorkers = $scope.query.filterCaseWorkers || [];
                delete $scope.query.filterUsers;
                delete $scope.query.filterOrgs;
                delete $scope.query.filterAgents;
                delete $scope.query.filterCaseWorkers;
                console.log('Found in local', $scope.query);
            } else {
                $scope.query = {
                    page: $stateParams.page ? parseInt($stateParams.page) : 1,
                    limit: $stateParams.limit ? parseInt($stateParams.limit) : 10,
                    sort: $stateParams.orderBy || "-updatedAt",
                    search: $stateParams.q || '',
                    status: $stateParams.status || 'all',
                    onlyFraud: $stateParams.onlyFraud || false
                };
            }
            console.log("giftCardsAll.controller.js", "init", $scope.query);
            $scope.parseFilters();
        }

        function clearFiler(mode) {
            console.log("giftCardsAll.controller.js", "clearFiler", mode);
            switch (mode) {
                case 'fraudCards':
                    delete $scope.query.onlyFraud;
                    break;
                case 'closeToExpire':
                    delete $scope.query.closeToExpire;
                    break;
            }


            $scope.fetchAllCards();
        }

        function showFraudulentCards() {
            $scope.query.onlyFraud = true;
            $scope.query.page = 1;
            $scope.query.search = null;
            $scope.fetchAllCards();
        }

        function showCloseToExpiryCards() {
            $scope.query.closeToExpire = true;
            $scope.query.page = 1;
            $scope.query.search = null;
            $scope.fetchAllCards();
        }

        function fetchFraudulentCards() {
            $scope.loadingFraud = true;
            var query = {
                operation: 'count',
                'fraudAttempts.processed': false,
                'status': {$ne: 'blocked'}
            }
            console.log("giftCardsAll.controller.js", "fetchFraudulentCards", query);
            RestManager.postResource('/giftCards/analytics', query, 'cards')
                .then(function (cards) {
                    $scope.loadingFraud = false;
                    $scope.fraudCards = cards;
                })
                .catch(function (err) {
                    $scope.loadingFraud = false;
                    $mdToast.showSimple('Error fetching the list of fraudulentCards : ' + err.message);
                })
        }

        function clearSelections() {
            $scope.selected = [];
        }

        function expireCards(ev) {
            var payload = {};
            // _.forEach($scope.selected, function(card) {
            //     var cardId = card._id;
            //     payload._id = cardId;
            // })

            payload._id = $scope.selected.map(function (card) {
                return card._id;
            });

            console.log("giftCardsAll.controller.js", "expireCards", payload);
            CriticalUpdateConfirmation.showDialog({
                targetEvent: ev,
                title: 'Expire Gift Cards',
                description: 'You opt to expire the cards. Do you want to continue?',
                infoMessage: 'Expiring the cards will change its status to expire',
                inputValidatorString: 'Expire',
                confirmText: 'Expire'
            })

                .then(function (result) {
                    if (result) {
                        RestManager.putResource('/giftCards/expireCardsById', payload, "cards")
                            .then(function (data) {
                                $scope.selected = [];
                                $scope.fetchAllCards();
                            })
                            .catch(function (err) {
                                console.log("giftCardsAll.controller.js", "ERROR", err);
                            });
                    }
                })
        }

        function downloadPrintFiles(event) {

            if ($scope.selected.length) {
                var wb = {
                    SheetNames: [],
                    Sheets: []
                };
                var dataToExport = $scope.selected.map(function (data) {
                    return {
                        "Card Number": data.code,
                        "Card Type": data.cardType.toUpperCase()
                    };
                })
                var headers = Object.keys(dataToExport[0]);
                wb.SheetNames.push('Cards');
                var jsonToSheetOptions = {header: headers, skipHeader: false};
                var ws = XLSX.utils.json_to_sheet(dataToExport, jsonToSheetOptions);
                var wopts = {bookType: 'xlsx', bookSST: false, type: 'binary'};

                wb.Sheets['Cards'] = ws;

                var wbout = XLSX.write(wb, wopts);

                // noinspection JSAnnotator
                function s2ab(s) {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }

                // /* the saveAs call downloads a file on the local machine */
                saveAs(new Blob([s2ab(wbout)],
                    {type: "application/octet-stream"}),
                    'Aarida Gift Card.xlsx');
            }

        }

        function openNotifications(card, $event) {
            $event.stopPropagation();
            var cards = card;
            if (!Array.isArray(card)) {
                cards = [cards];
            }
            var orders = cards.map(function (card) {
                return {
                    orderData: {
                        products: []
                    },
                    user: card.user,
                    amount: card.balance,
                    shortLink: card.shortLink,
                    code: card.code,
                    expiryDate : card.expiryDate,
                    _id: card._id
                }
            });
            var status = cards[0].status;
            var hasSameStatus = _.every(cards, function (card) {
                return card.status === status;
            });
            if (!hasSameStatus) {
                status = null;
            }
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: $event,
                fullscreen: true,
                templateUrl: 'app/modules/components/notifications/user-notifications.html',
                locals: {
                    options: {
                        allowedTags: ['User Name', 'Customer Care Number'],
                        context: 'gift-card-' + status
                    },
                    order: orders
                },
                controller: 'notificationsController',
                clickOutsideToClose: true
            })
                .then(function (data) {
                    console.log('data', data)
                    return Promise.map(cards, function (card) {
                        card.savingNotification = true;
                        if (data && data.length) {
                            return new Promise(function (resolve, reject) {
                                RestManager.patchResource('/giftCards/reminderDate/' + card._id, {date: moment().toISOString()}, 'cards')
                                    .then(function (results) {
                                        card.savingNotification = false;
                                        if (results && results.length) {
                                            card.lastReminderDate = results[0].lastReminderDate;
                                            resolve(results[0]);
                                        } else {
                                            reject(new Error('Error saving reminder date'))
                                        }
                                    })
                                    .catch(reject)
                            })
                        } else {
                            return null;
                        }
                    })
                })
                .then(function (results) {
                    console.log("giftCardsAll.controller.js", "results", results);
                })
                .catch(function (err) {
                    console.log(err)
                    card.savingNotification = false;
                    $mdToast.showSimple('Error sending notification : ' + err.message);
                })
        }


        $scope.fetchAllCards = function () {
            console.log("giftCardsAll.controller.js", "fetchAllCards", "FETCH CARDS CALLED");

            var url = "/giftCards/admin";
            var query = {};
            angular.copy($scope.query, query);
            if (query.status === 'all') {
                delete query.status;
            }
            if (!query.search) {
                delete query.search;
            }
            if (query.onlyFraud === false || query.onlyFraud === undefined || query.onlyFraud === 'false') {
                delete query.onlyFraud;
            }

            $scope.promise = RestManager.getResource(url, "cards", {query: query, extras: ["total"]});

            $scope.promise
                .then(function (result) {
                    $scope.cards = result.cards;
                    $scope.total = result.total;
                    console.log(result);
                    $scope.changeState();
                })
                .catch(function (err) {
                    console.log(err);
                });
        };


        function fetchAllCloseToExpiryCards() {
            $scope.loadingCloseToExpiry = true;
            var curDate = new Date(Date.now());
            var dateLimit = new Date(Date.now() + 15 * 86400000);
            var closeToFraudCardQuery = {
                operation: 'count',
                expiryDate: {
                    $gte: curDate,
                    $lte: dateLimit
                },
                "status": {$ne: "expired"}

            }
            RestManager.postResource('/giftCards/analytics', closeToFraudCardQuery, 'cards')
                .then(function (cards) {
                    $scope.loadingCloseToExpiry = false;
                    $scope.closeToExpireCards = cards;
                })
                .catch(function (err) {
                    $scope.loadingCloseToExpiry = true;
                    $mdToast.showSimple('Error fetching the list of fraudulentCards : ' + err.message);
                })
        }


        function changeState() {
            $state.transitionTo("app.offers.giftCards.all", {
                    page: $scope.query.page,
                    limit: $scope.query.limit,
                    sort: $scope.query.sort,
                    q: $scope.query.search,
                    onlyFraud: $scope.query.onlyFraud,
                    status: $scope.query.status
                },
                { // prevent the events onStart and onSuccess from firing
                    notify: false,
                    // prevent reload of the current state
                    reload: false,
                    // replace the last record when changing the params so you don't hit the back button and get old params
                    location: 'replace'
                });
            $scope.backParams = JSON.stringify($stateParams);
            var query = {};
            angular.copy($scope.query, query);
            query.filterUsers = $scope.filterUsers;
            query.filterOrgs = $scope.filterOrgs;
            query.filterAgents = $scope.filterAgents;
            query.filterCaseWorkers = $scope.filterCaseWorkers;
            localStorage.setItem('giftCardQuery', JSON.stringify(query))
        }

        function openCardModal(e, id, i) {
            console.log("giftCardsAll.controller.js", "openCardModal", id);
            var parentEl = angular.element(document.body)
            $mdDialog.show({
                parentEl: parentEl,
                targetEvent: e,
                fullscreen: true,
                templateUrl: "app/modules/offers/giftCards/all/activateCard/partials/index.tmpl.html",
                controller: "activateCard.controller",
                multiple: true,
                locals: {
                    cardId: id
                }
            })
                .then(function (data) {
                    console.log("giftCardsAll.controller.js", "UPDATED CARDS", data, i);
                    $scope.cards[i] = data.updatedCard;
                    console.log("giftCardsAll.controller.js", "$cs", $scope.cards);
                })
                .catch(function (err) {
                    console.log("giftCardsAll.controller.js", "ERR", err);
                });
        }


        function updateStatus(giftCard, status, event) {
            event.stopPropagation();
            var payload = {};
            angular.copy(giftCard, payload);
            payload.status = status;
            giftCard.updating = true;
            RestManager.putResource('/giftCards', payload, 'cards')
                .then(function (result) {
                    giftCard.status = status;
                    giftCard.updating = false;
                    document.getElementById('giftCardSearch').select();
                    document.getElementById('giftCardSearch').focus();
                    $mdToast.showSimple('Updated Status to : ' + status);
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error while updating status : ' + err);
                })
        }

        function toggleFilters() {
            $scope.showFilters = !$scope.showFilters;
        }

        function selectAll(model, dataSet) {
            model = dataSet.map(function (data) {
                return data._id || data;
            })
        }


        function fetchAllOrg() {
            RestManager.getResource("/org", "organisations")
                .then(function (result) {
                    $scope.orgs = result;
                    console.log("users.all.controller.js", $scope.orgs);
                })
                .catch(function (err) {
                    console.log("users.all.controller.js", err);
                });
        }

        function parseFilters() {
            if ($scope.filterOrgs && $scope.filterOrgs.length) {
                $scope.query.organisation = $scope.filterOrgs.join(',');
            } else {
                delete $scope.query.organisation;
            }


            if ($scope.filterUsers && $scope.filterUsers.length) {
                $scope.query.user = $scope.filterUsers.map(function (user) {
                    return user._id;
                }).join(',');
            } else {
                $scope.filterUsers = [];
                delete $scope.query.user;
            }


            if ($scope.filterCaseWorkers && $scope.filterCaseWorkers.length) {
                $scope.query.caseWorker = $scope.filterCaseWorkers.map(function (user) {
                    return user._id;
                }).join(',');
            } else {
                $scope.filterCaseWorkers = [];
                delete $scope.query.caseWorker;
            }

            if ($scope.filterAgents && $scope.filterAgents.length) {
                $scope.query.agent = $scope.filterAgents.map(function (user) {
                    return user._id;
                }).join(',');
            } else {
                $scope.filterAgents = [];
                delete $scope.query.agent;
            }

            if (!$scope.query.redemptionStartDate) {
                delete $scope.query.redemptionStartDate;
            } else {
                $scope.query.redemptionStartDate = moment($scope.query.redemptionStartDate).startOf('day').toISOString()
            }

            if (!$scope.query.redemptionEndDate) {
                delete $scope.query.redemptionEndDate;
            } else {
                $scope.query.redemptionEndDate = moment($scope.query.redemptionEndDate).endOf('day').toISOString()
            }


            $scope.hasFilters = !!($scope.filterOrgs.length || $scope.filterUsers.length || $scope.filterAgents.length || $scope.filterCaseWorkers.length
                || $scope.query.redemptionStartDate || $scope.query.redemptionEndDate);

            console.log("giftCardsAll.controller.js", "parseFilters", $scope.query);
            $scope.fetchAllCards();
            $scope.cancel();
        }

        function queryUsers(searchText) {
            return RestManager.getResource("/users/filter", "users", {
                query: {
                    q: searchText,
                    fields: 'name,mobile',
                    page: 1,
                    limit: 5
                }
            })
                .then(function (users) {
                    return users;
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error loading user : ' + err.message);
                })
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function openFiltersDialog(event) {
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                scope: $scope,
                fullscreen: true,
                preserveScope: true,
                contentElement: "#giftCardFilterDialog"
            });

        }


        $scope.transformChip = function (chip) {
            console.log("giftCardsAll.controller.js", "transformChip", chip);
            return chip;
        }

        function clearFilters() {
            $scope.selected = [];
            $scope.filterUsers = [];
            $scope.filterOrgs = [];
            $scope.filterAgents = [];
            $scope.filterCaseWorkers = [];
            $scope.query.redemptionStartDate = null;
            $scope.query.redemptionEndDate = null;
            $scope.parseFilters();
        }

        function selectCaseWorker(event, card) {
            var cardList = [];
            if (_.isArray(card)) {
                cardList = card.map(function (card) {
                    return card._id;
                })
            } else {
                cardList = [card._id];
            }
            Users.selectUserDialog(event, {fields: 'name,mobile,role', roles: 'admin,designer', multiple: false})
                .then(function (user) {
                    if (_.isArray(card)) {
                        card = card.map(function (card) {
                            card.updatingHandler = true;
                            return card;
                        })
                    } else {
                        card.updatingHandler = true;
                    }
                    if (user) {
                        return RestManager.patchResource('/giftCards/handler', {
                            giftCardIds: cardList,
                            user: user._id
                        }, 'cards')
                    } else {
                        throw new Error('No User Selected')
                    }
                })
                .then(function (orders) {
                    if (_.isArray(card)) {
                        card = card.map(function (card) {
                            card.updatingHandler = false;
                            card.caseWorker = orders[0].caseWorker;
                            card.cachedCaseWorker = orders[0].cachedCaseWorker;
                            return card;
                        })
                    } else {
                        card.updatingHandler = false;
                        card.caseWorker = orders[0].caseWorker;
                        card.cachedCaseWorker = orders[0].cachedCaseWorker;
                    }

                    $mdToast.showSimple('Updated handler successfully');
                })
                .catch(function (err) {
                    card.updatingHandler = false;
                    $mdToast.showSimple('Error updating handler : ' + err.message)
                })
        }

        function sendToLocalStorage() {
            localStorage.setItem('giftCardColumns', JSON.stringify($scope.columns));
        }

        function updateExpiryDates($event) {
            var cards = [];
            angular.copy($scope.selected, cards);
            $mdDialog.show({
                targetEvent: $event,
                fullscreen: true,
                templateUrl: "app/modules/offers/giftCards/dialogs/updateExpiryDate/updateExpiryDate.html",
                controller: "updateExpiry.controller",
                multiple: true,
                locals: {
                    cards: cards
                }
            })
                .then(function (data) {
                    if (data && data.length) {
                        data.forEach(function (card) {
                            var cardIndex = _.findIndex($scope.cards, function (c) {
                                return c._id === card._id;
                            });
                            if (cardIndex !== -1) {
                                $scope.cards[cardIndex].expiryDate = card.expiryDate;
                            }
                        })
                    }
                    $scope.selected = [];
                })
                .catch(function (err) {
                    console.log("giftCardsAll.controller.js", "ERR", err);
                });
        }


        //
        // function openAgentModal(e) {
        //     var parentEl = angular.element(document.body)
        //     $mdDialog.show({
        //         parentEl: parentEl,
        //         targetEvent: e,
        //         templateUrl: "app/modules/offers/giftCards/all/assignAgent/partials/index.tmpl.html",
        //         controller: "assignAgent.controller",
        //         clickOutsideToClose: true
        //     });
        // }
        //
        // function openCustomerModal(e) {
        //     var parentEl = angular.element(document.body)
        //     $mdDialog.show({
        //         parentEl: parentEl,
        //         targetEvent: e,
        //         templateUrl: "app/modules/offers/giftCards/all/assignCustomer/partials/index.tmpl.html",
        //         controller: "assignCustomer.controller",
        //         clickOutsideToClose: true
        //     });
        // }

        $scope.init();
        $scope.fetchFraudulentCards();
        $scope.fetchAllCloseToExpiryCards();
        $scope.fetchAllOrg();


    }
})(angular);

(function () {
    'use strict';

    giftCardsAdd.$inject = ["$scope", "RestManager", "$mdToast", "$state"];
    angular.module("app.offers.giftCards")
        .controller("offers.giftCardsAdd.controller", giftCardsAdd);

    function giftCardsAdd($scope, RestManager, $mdToast, $state) {
        $scope.$parent.$parent.showActionButton = false;
        $scope.$parent.$parent.pageTitle = "Add Gift Cards";
        $scope.$parent.$parent.nestedState = false;

        $scope.cardParams = {
            cardType: '',
            isCorporateCard: false,
            count: 0,
            org: ''
        };

        $scope.cards = [
            {
                "type": "physical"
            },
            {
                "type": "virtual"
            }
        ];

        $scope.createCards = createCards;

        $scope.fetchAllOrg = function(){
            RestManager.getResource("/org", "organisations")
                .then(function(result){
                    $scope.orgs = result;
                    console.log( $scope.orgs);
                })
                .catch(function(err){
                    console.log( err);
                });
        };

        function resetBodyParam() {
            $scope.cardParams = {
                cardType: null,
                isCorporateCard: false,
                count: 0,
                org: null
            };

        }

        function createCards() {
            var url = "/giftCards/bulk";
            $scope.promise = RestManager.postResource(url, $scope.cardParams, "cards");

            $scope.promise
                .then(function (result) {
                    $scope.newCards = result;

                    $mdToast.show($mdToast.simple()
                        .textContent(result.length + " Cards Created")
                        .hideDelay(3000)
                        .position('bottom right'));

                    $state.go('app.offers.giftCards.all');
                })
                .catch(function (err) {
                    $mdToast.show("Some error occurred, Please see console")
                });
        }

        $scope.fetchAllOrg();


    }

})(angular);


/**
 * Created by kumardivyarajat on 25/12/16.
 */
angular.module("app.offers")
    .controller("offers.discount.modal.controller", ["$scope", function ($scope) {

    }]);
/**
 * Created by kumardivyarajat on 23/12/16.
 */
angular.module("app.offers")
    .controller("offers.discount.controller", ["$scope", "RestManager", "$log", function ($scope, RestManager, $log) {
        // Config
        $scope.$parent.pageTitle = "Offers";
        $scope.$parent.nestedState = false;
        $scope.$parent.showActionButton = true;
        $scope.$parent.actionButtonText = "Add New Offer";
        // Variables on the scope
        $scope.selected = [];
        $scope.query = {
            limit: 10,
            sort: "-expiryDate",
            page: 1
        };
        // Methods on the scope
        $scope.fetchAllDiscounts = fetchAllDiscounts;
        $scope.getApplicableTo = getApplicableTo;
        $scope.getDiscountType = getDiscountType;
        $scope.getDiscountAmount = getDiscountAmount;

        // Calls
        $scope.fetchAllDiscounts();

        // Method definitions
        function fetchAllDiscounts() {
            $scope.promise = RestManager.getResource("/coupons/offers", "coupons" , {query : $scope.query});

            $scope.promise
                .then(function (coupons) {
                    $scope.discounts = coupons;
                    console.log("dis", coupons);
                })
                .catch(function (err) {
                    $log.error(err);
                })
        }

        function getApplicableTo(applicableTo) {
            switch (applicableTo) {
                case 0:
                    return "Cart";

                case 1 :
                    return "Product";

                case 2 :
                    return "Points";
            }
        }

        function getDiscountType(discountType) {
            switch (discountType) {
                case 0:
                    return "Rs Off";

                case 1:
                    return "% Off";
            }
        }

        function getDiscountAmount(discountAmount, discountType) {
            switch (discountType) {
                case 0:
                    return "Rs. " + discountAmount;

                case 1:
                    return discountAmount + "%";
            }
        }

    }]);

/**
 * Created by kumardivyarajat on 23/12/16.
 */
angular.module("app.offers")
    .controller("offers.coupons.controller", ["$scope", "Base", "RestManager", "$log", "$mdToast", "$mdDialog", "Users", function ($scope, Base, RestManager, $log, $mdToast, $mdDialog, Users) {
        // Config
        $scope.$parent.pageTitle = "Coupons";
        $scope.$parent.nestedState = false;
        $scope.$parent.showActionButton = true;
        $scope.$parent.actionButtonText = "Add New Coupon"
        // Variables on the scope
        $scope.selected = [];
        $scope.total = 0;
        $scope.query = {
            limit: 10,
            sort: "-expiryDate",
            page: 1
        };
        $scope.mediaURL = Base.getMediaUrl();
        $scope.newCoupon = {
            eligibilityRules: []
        };
        $scope.myDate = new Date();
        $scope.selectedItem = '';
        $scope.searchText = '';
        $scope.productUrl = "/products/admin";
        $scope.minDate = new Date(
            $scope.myDate.getFullYear(),
            $scope.myDate.getMonth(),
            $scope.myDate.getDate());

        $scope.maxDate = new Date(
            $scope.myDate.getFullYear(),
            $scope.myDate.getMonth() + 2,
            $scope.myDate.getDate());

        // Methods on the scope
        $scope.fetchAllDiscounts = fetchAllDiscounts;
        $scope.getApplicableTo = getApplicableTo;
        $scope.getDiscountType = getDiscountType;
        $scope.getDiscountAmount = getDiscountAmount;
        $scope.$parent.onActionButtonClick = createNewCouponDialog;
        $scope.saveCoupon = saveCoupon;
        $scope.createNewCouponDialog = createNewCouponDialog;
        $scope.getNumericValue = getNumericValue;
        $scope.capitalize = capitalize;
        $scope.loadProducts = loadProducts;
        $scope.loadCollections = loadCollections;
        $scope.loadCategories = loadCategories;
        $scope.loadUsers = loadUsers;
        $scope.addNewRule = addNewRule;
        $scope.removeRule = removeRule;
        $scope.editCoupon = editCoupon;
        $scope.removeCoupon = removeCoupon;
        $scope.productQuery = productQuery;
        $scope.fetchProducts = fetchProducts;
        $scope.selectedItemChange = selectedItemChange;
        $scope.removeSelectedProduct = removeSelectedProduct;
        $scope.showUserSelector = showUserSelector;
        $scope.removeSelectedUser = removeSelectedUser;

        // Calls
        $scope.fetchAllDiscounts();


        if ($scope.newCoupon.eligibilityRules.length === 0) {
            $scope.newCoupon.eligibilityRules[0] = {
                lhs: "",
                operator: "",
                rhs: ""
            };
        }

        // Method definitions
        function fetchAllDiscounts() {

            $scope.promise = RestManager.getResource("/coupons/coupons", "coupons", {
                query: $scope.query,
                extras: ['total']
            });

            $scope.promise
                .then(function (result) {
                    $scope.discounts = result.coupons;
                    $scope.total = result.total;
                    console.log("dis", result);
                })
                .catch(function (err) {
                    $log.error(err);
                })
        }


        function getApplicableTo(applicableTo) {
            switch (applicableTo) {
                case 0:
                    return "Cart";

                case 1 :
                    return "Product";

                case 2 :
                    return "Points";
            }
        }

        function getDiscountType(discountType) {
            switch (discountType) {
                case 0:
                    return "Rs Off";

                case 1:
                    return "% Off";

                case 2:
                    return "BOGO";
            }
        }

        function getDiscountAmount(discountAmount, discountType) {
            switch (discountType) {
                case 0:
                    return "Rs. " + discountAmount;

                case 1:
                    return discountAmount + "%";

                case 2:
                    return discountAmount + "%";
            }
        }

        function editCoupon(coupon, index, event) {
            $scope.editingMode = true;
            $scope.newCoupon = {};
            if (coupon.startDate) {
                coupon.startDate = new Date(coupon.startDate);
            }
            if (coupon.expiryDate) {
                coupon.expiryDate = new Date(coupon.expiryDate);
            }

            coupon.eligibilityRules = coupon.eligibilityRules.map(function (o) {
                o.rhs = parseInt(o.rhs);
                return o;
            });
            angular.copy(coupon, $scope.newCoupon);
            $scope.loadUsers();
            $scope.editingIndex = index;
            console.log('coupon', $scope.newCoupon);
            showCouponDialog(event);
            event.stopPropagation();
        }

        function createNewCouponDialog(e) {
            $scope.newCoupon = {};
            $scope.editingMode = false;
            showCouponDialog(e, ".action-button");
        }

        function showCouponDialog(e, openFrom) {
            $mdDialog.show({
                contentElement: '#coupon_add',
                parent: angular.element(document.body),
                targetEvent: e,
                scope: $scope,
                fullscreen: true,
                preserveScope: true,
                openFrom: openFrom,
                clickOutsideToClose: true
            })
                .then(function (answer) {
                    $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    $scope.status = 'You cancelled the dialog.';
                });
        }

        function getNumericValue(val) {
            return parseInt(val);
        }

        function capitalize() {
            $scope.newCoupon.couponCode = _.toUpper($scope.newCoupon.couponCode);
        }

        function loadProducts() {
            $scope.fetchingProducts = true;

            var query = {
                orderBy: "-updatedAt",
                page: 1,
                limit: 100,
                searchTerm: null,
                query: {
                    _id: {$in: $scope.newCoupon.product}
                }
            }
            if ($scope.editingMode && $scope.newCoupon.product.length) {
                var promise = RestManager.postResource("/products/admin/", query, "products");
                promise
                    .then(function (products) {
                        $scope.fetchingProducts = false;
                        $scope.newCoupon.products = products;
                        console.log("ON LOAD PRODUCTS", $scope.newCoupon.products);
                    })
                    .catch(function (err) {
                        $log.error(err);
                    });
            }
        }


        function productQuery(searchText) {
            return $scope.fetchProducts(searchText);
        }

        function fetchProducts(searchText) {
            $scope.fetchingProducts = true;
            var filters = {
                orderBy: '-updatedAt',
                page: 1,
                showAll: {
                    type: true,
                    published: true,
                    featured: true
                },
                searchTerm: searchText

            };
            return RestManager.postResource($scope.productUrl, filters, "products");
        }

        function selectedItemChange(item) {
            if (item) {
                if (!$scope.newCoupon.products) {
                    $scope.newCoupon.products = [];
                }
                $scope.newCoupon.products.unshift(item);
            }
        }

        function removeSelectedProduct(i, id) {
            $scope.newCoupon.products.splice(i, 1);
        }

        function removeSelectedUser(i, id) {
            $scope.newCoupon.users.splice(i, 1);
        }

        function loadCollections() {
            var promise = RestManager.getResource("/collections", "collections");
            promise
                .then(function (collections) {
                    $scope.collections = collections;
                })
                .catch(function (err) {
                    $log.error(err);
                });
        }

        function loadCategories() {
            var promise = RestManager.getResource("/categories", "categories");
            promise
                .then(function (categories) {
                    $scope.categories = categories;
                })
                .catch(function (err) {
                    $log.error(err);
                });
        }

        function loadUsers() {
            console.log("offers.coupons.controller.js", "loadUsers", $scope.newCoupon.users);
            if($scope.newCoupon.users && $scope.newCoupon.users.length) {
                var ids = $scope.newCoupon.users.map(function (user) {
                    return user._id || user;
                })
                console.log("offers.coupons.controller.js", "loadUsers", ids);
                var promise = RestManager.getResource("/users/filter", "users", {
                    query : {
                        page: 1,
                        limit: 100,
                        ids : ids,
                        fields : 'name,mobile'
                    }
                });
                promise
                    .then(function (users) {
                        $scope.users = users;
                        $scope.newCoupon.users = $scope.newCoupon.users.map(function (user) {
                            var foundUser = _.find(users, function (u) {
                                return (user._id || user) === u._id;
                            });
                            if(foundUser) {
                                return foundUser;
                            } else {
                                return user;
                            }
                        })
                    })
                    .catch(function (err) {
                        console.log('Error', err);
                        $log.error(err);
                    });
            }
        }

        function addNewRule(index, event) {
            $scope.newCoupon.eligibilityRules.splice(index, 0, {lhs: "", operator: "", rhs: ""})
        }

        function removeRule(index) {
            $scope.newCoupon.eligibilityRules.splice(index, 1);
        }

        function saveCoupon() {
            // $scope.newCoupon.autoApplied = false;

            if ($scope.newCoupon.products) {
                $scope.newCoupon.product = $scope.newCoupon.products.map(function (product) {
                    return product._id;
                });
                delete $scope.newCoupon.products;
            }

            // if($scope.newCoupon.startDate) {
            //     $scope.newCoupon.startDate = moment($scope.newCoupon.startDate).startOf('day').toISOString();
            // }
            //
            // if($scope.newCoupon.expiryDate) {
            //     $scope.newCoupon.expiryDate = moment($scope.newCoupon.expiryDate).endOf('day').toISOString();
            // }

            if ($scope.editingMode) {
                $scope.promise = RestManager.putResource("/coupons", $scope.newCoupon, "coupons");
            } else {
                $scope.promise = RestManager.postResource("/coupons", $scope.newCoupon, "coupons");
            }
            $scope.promise
                .then(function (coupons) {
                    $mdDialog.hide()
                        .then(function () {
                            if ($scope.editingMode) {
                                $scope.discounts.splice($scope.editingIndex, 1, coupons[0]);
                            } else {
                                $scope.discounts.unshift(coupons[0]);
                            }
                        });
                })
                .catch(function (err) {
                    $log.error(err);
                });
        }

        function removeCoupon(discount, index, event) {

        }

        function showUserSelector(event) {
            var selected = [];
            if($scope.newCoupon.users) {
                selected = $scope.newCoupon.users.map(function (user) {
                    user.id = user._id;
                    return user;
                })
            }
            Users.selectUserDialog(event, {
                fields : 'name,email,mobile',
                multiple : true,
                selected : selected
            })
                .then(function (users) {
                    console.log("offers.coupons.controller.js", "users", users);
                    if(users && Array.isArray(users) && users.length) {
                        $scope.newCoupon.users = users;
                    }
                    console.log("offers.coupons.controller.js", "$scope.newCoupon.users", $scope.newCoupon.users);
                })
        }

    }]);

/**
 * Created by kumardivyarajat on 03/01/17.
 */
angular.module("app.customisation", [])
    .controller("customisation.home.controller", ["$scope", function ($scope) {

    }]);
/**
 * Created by kumardivyarajat on 03/01/17.
 */
angular.module("app.customisation")
    .controller("customisation.templates.controller", ["$scope", "$mdDialog", "RestManager", "$mdToast", "Utils", function ($scope, $mdDialog, RestManager, $mdToast, Utils) {
        $scope.$parent.pageTitle = "Templates";
        $scope.$parent.backState = "app.home";
        $scope.$parent.nestedState = true;
        $scope.$parent.showActionButton = true;

        $scope.$parent.actionButtonText = "Add New";

        $scope.selected = [];

        $scope.query = {
            page: 1,
            limit: 25,
            order: "name",
            search: ""
        };

        $scope.fetchTemplates = function () {
            $scope.promise = RestManager.getResource("/ucData/templates", "ucData");

            $scope.promise
                .then(function (data) {
                    $scope.templates = data;
                    _.forEach($scope.templates, function (template, i) {
                        $scope.templates[i] = $scope.populateDefaults(template);
                    })

                })
                .catch(function (err) {
                    console.log(err);
                })
        };

        $scope.fetchTemplates();

        $scope.showDialog = function (event, template, index) {
            $scope.selectedIndex = 0;

            // addNewTemplateDialog
            $scope.newTemplate = {
                product: {},
                customisation: {},
                isTemplate: true,
                data: []
            };
            if (template) {
                angular.copy(template, $scope.newTemplate);
                $scope.currIndex = index;
                $scope.editingMode = true;
            } else {
                $scope.editingMode = false;
            }

            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                scope: $scope,
                fullscreen : true,
                preserveScope: true,
                contentElement: "#addNewTemplateDialog"
            });

            event.stopPropagation();
        };

        $scope.populateDefaults = function (template) {
            template.data.forEach(function (datum) {
                var a = _.find(template.customisation.data, function (cData) {
                    return cData._id === datum.dataId;
                });

                var b;
                if (datum.selectedValues.length > 0) {
                    b = datum.selectedValues[0];
                } else {
                    b = a.default;
                }

                a.default = _.findIndex(a.options, function (option) {
                    return option._id === b;
                });
            });
            return template;
        };


        $scope.$parent.onActionButtonClick = function (event) {
            $scope.showDialog(event);
        };


        $scope.selectedItemChange = function (searchText) {

        };


        $scope.selectedItemChange = function (item) {
            if (item) {
                $scope.selectedItem = item;
            }
        };

        $scope.addProduct = function (item) {
            if (item) {
                console.log('selectedItemChange', item);
                $scope.selectedItem = item.name;
                $scope.newTemplate.product = item;
                $scope.newTemplate.customisation = item.customisation;
            }
            $scope.searchText = "";
        };


        $scope.changeData = function (index) {
            $scope.selectedIndex = index;
        };


        $scope.changeOption = function (option, index) {
            var id = $scope.newTemplate.customisation.data[$scope.selectedIndex]._id;
            $scope.newTemplate.customisation.data[$scope.selectedIndex].default = index;
            var findDataIndex = _.findIndex($scope.newTemplate.data, function (o) {
                return o.dataId === id;
            });

            if (findDataIndex != -1) {
                $scope.newTemplate.data[findDataIndex].selectedValues = [option._id];
            } else {
                $scope.newTemplate.data.push({
                    dataId: id,
                    selectedValues: [option._id]
                })
            }
            console.log('changeOption', findDataIndex, $scope.newTemplate.data, $scope.newTemplate.customisation);
        };


        $scope.querySearch = function (searchText) {
            return RestManager.getResource("/products/customisation/search/" + searchText, "products")
        };

        $scope.saveTemplate = function () {
            var response = {};
            angular.copy($scope.newTemplate, response);

            if (response.product) {
                response.product = response.product._id;
            }

            if (response.customisation) {
                response.customisation = response.customisation._id;
            }

            console.log('saveTemplate', response);

            if ($scope.editingMode) {
                $scope.savingPromise = RestManager.putResource("/ucData/" + response.slug, response, "ucData")
            } else {
                $scope.savingPromise = RestManager.postResource("/ucData/templates", response, "ucData")
            }

            $scope.savingPromise
                .then(function (data) {
                    var newData = {};
                    angular.copy($scope.newTemplate, newData);
                    newData.slug = data.slug;
                    if ($scope.editingMode) {
                        $scope.templates.splice($scope.curIndex, 1, newData);
                    } else {
                        $scope.templates.unshift(newData);
                    }
                    $scope.close();
                    $mdToast.showSimple("Successfully updated template");
                })
                .catch(function (err) {
                    console.log(err);
                    $mdToast.showSimple("Some error occurred. \n" + err.message);
                })
        };

        $scope.close = function () {
            $mdDialog.hide();
        }
    }]);

/**
 * Created by kumardivyarajat on 10/01/17.
 */
angular.module("app.customisation")
    .controller("customisation.options.controller", customisationOptionController);


function customisationOptionController($scope, $mdDialog, RestManager, $mdToast, Utils, $rootScope) {

    $scope.editPattern = editPattern;
    $scope.openUploader = openUploader;
    $scope.cancel = cancel;
    $scope.addAttribute = addAttribute;
    $scope.removeAttribute = removeAttribute;
    $scope.saveOption = saveOption;
    $scope.removeOption = removeOption;
    $scope.getPrice = getPrice;
    $scope.getAttributeValue = getAttributeValue;
    $rootScope.$on('uploaderClosed', openEditor);


    RestManager.getResource("/c/customisationOptions/fabric", "customisations")
        .then(function (data) {
            $scope.options = data;
            console.log($scope.options);
        })
        .catch(function (err) {
            console.log(err);
        });

    RestManager.getResource("/attributes", "attributes")
        .then(function (data) {
            $scope.attributes = data;
            console.log(data);
        })
        .catch(function (err) {
            console.log(err);
        });


    function getPrice(option) {
        var price = "Free";
        if (option.stockAndPrice.price) {
            if (option.stockAndPrice.price.salePrice) {
                price = "Rs. " + option.stockAndPrice.price.salePrice;
            } else if (option.stockAndPrice.price.mrp) {
                price = "Rs. " + option.stockAndPrice.price.mrp;
            }

        }
        return price;
    }


    function getAttributeValue(attributeData) {
        return _.find(attributeData.attribute.meta_values, function (o) {
            return o._id === attributeData.selectedValues[0];
        }).value;
    }


    function cancel(something) {
        $mdDialog.hide()
            .then(function () {
                console.log(something);
                if (!something) {
                    editPattern($scope.selectedOption, $scope.selectedIndex);
                }
            });
    }

    function addAttribute() {
        $scope.selectedOption.attributes.push({attribute: {}});
    }

    function removeAttribute(index) {
        $scope.selectedOption.attributes.splice(index, 1);
    }


    function openEditor() {
        editPattern($scope.selectedOption, $scope.selectedIndex);
    }

    function editPattern(pattern, index, e) {
        $scope.selectedOption = {};

        if (pattern) {
            angular.copy(pattern, $scope.selectedOption);
        }
        $scope.selectedIndex = index;
        $scope.editorOpen = true;
        $mdDialog.show({
            contentElement: "#options_editor",
            scope: $scope,
            fullscreen : true,
            eventTarget: e,
            preserveScope: true
        });

        if (!$scope.selectedOption.tags) {
            $scope.selectedOption.tags = [];
        }

        if (!$scope.selectedOption.attributes) {
            $scope.selectedOption.attributes = [];
        }
    }


    function openUploader(ev, type) {
        $mdDialog.show({
            locals: {
                multipleSelect: false,
                select: type ? "jpg" : "customisable",
                options : null
            },
            controller: "upload.controller",
            templateUrl: 'app/modules/base/partials/uploader.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            fullscreen : true,
            clickOutsideToClose: true
        })
            .then(function (images) {
                console.log(images);
                if (type) {
                    $scope.selectedOption.preview = images[0];
                } else {
                    $scope.selectedOption.image = images[0];
                }
                console.log($scope.selectedOption);
                editPattern($scope.selectedOption, $scope.selectedIndex, ev);
            }, function () {
                $scope.status = 'You cancelled the dialog.';
            });
    }

    function saveOption() {

        var promise;
        if ($scope.selectedIndex !== null)
            promise = RestManager.putResource("/c/customisationOption", filterOutput(), "customisations");
        else
            promise = RestManager.postResource("/c/customisationOption", filterOutput(), "customisations");

        promise.then(function (data) {
            console.log(data);
            $mdDialog.hide()
                .then(function () {
                    $scope.selectedOption._id = data[0]._id;
                    $scope.options.splice($scope.selectedIndex, 1, $scope.selectedOption);
                })
        })
            .catch(function (err) {
                console.log(err);
            })
    }

    function removeOption(option, index, ev) {
        var confirm = $mdDialog.confirm()
            .title('Would you like to delete this option?')
            .textContent('This action is irreversible and cannot be recycled.')
            .ariaLabel('Delete Option')
            .targetEvent(ev)
            .ok('Yes')
            .cancel('No. Cancel.');

        $mdDialog.show(confirm).then(function () {
            _removeOption(option)
                .then(function (result) {
                    $scope.options.splice(index, 1);
                    $mdDialog.show(
                        $mdDialog.alert()
                            .parent(angular.element(document.querySelector('body')))
                            .clickOutsideToClose(true)
                            .title('Option Deleted')
                            .textContent('The option has been deleted successfully.')
                            .ariaLabel('Delete Notification')
                            .ok('Got it!')
                            .targetEvent(ev)
                    );
                })
                .catch(function (err) {

                })
        }, function () {
            $scope.status = 'You decided to keep your debt.';
        });
    }

    function _removeOption(option) {
        return RestManager.deleteResource("/c/customisationOption/" + option._id, "customisations");
    }

    function filterOutput() {
        var data = {};
        console.log($scope.selectedOption);
        angular.copy($scope.selectedOption, data);
        _.forEach(data.attributes, function (attributeData, i) {
            data.attributes[i].attribute = attributeData.attribute._id;
        });

        if (data.image)
            data.image = data.image._id;

        if (data.preview)
            data.preview = data.preview._id;

        data.isFabric = true;

        console.log(data);
        return data;
    }
}


/**
 * Created by kumardivyarajat on 25/08/17.
 */
(function () {
    "use strict";

    angular
        .module('app.main', [
            "ngMaterialSidemenu",
            "md.data.table",
            "ngFileUpload",
            'textAngular',
            'ui.codemirror',
            'angular-js-xlsx',
            "app.home",
            "app.users",
            "app.media",
            "app.query",
            "app.pages",
            "app.products",
            "app.campaigns",
            "app.cart",
            "app.collections",
            "app.designs",
            "app.schedule",
            "app.orders",
            "app.offers",
            "app.offers.giftCards",
            "app.redux",
            "app.customisation",
            "app.photoshoot",
            "app.materials",
            "app.purchases",
            "app.pos",
            "app.diagnostics",
            'tandibar/ng-rollbar',
            'app.reports',
            'app.address',
            'app.warehouse',
            'app.homebuilder',
            'app.posts',
            'app.quotations',
            'app.workforce',
            'app.tasks'
        ]);

})();

(function () {
    'use strict';

    ProfileImage.$inject = ["Base"];
    angular.module("app.main")
        .directive("profileImage", ProfileImage);

    /** @ngInject **/
    function ProfileImage(Base) {
        return {
            restrict: "E",
            transclude: false,
            replace: false,
            scope: {
                imageUrl: "@",
                userName: '@',
                small: '=',
                medium: '='
            },
            link: function ($scope, element, attrs) {
                $scope.mediaUrl = Base.getMediaUrl();

                $scope.class = 'large';

                if ($scope.medium) {
                    $scope.class = 'medium';
                }
                if ($scope.small) {
                    $scope.class = 'small';
                }

            },
            templateUrl: "app/modules/base/directives/profile-image/profile-image.tmpl.html"
        }
    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 6/9/19 10:22 PM
 *
 */

(function () {
    'use strict';

    angular.module('app.main')
        .directive('mentionText', MentionText);

    function MentionText() {
        return {
            scope : {
                comment: "=",
            },
            link: function ($scope, $element, $attrs) {
                $scope.delimeter = "";


                $scope.decode = function (message) {
                    return message ? message.replace(/@\[([\s\w]+):([0-9a-z-]+)\]/gi, '<span class="mention-highlight-text" data-click="$1:$2">'+ $scope.delimeter +'$1</span>') : '';
                };

                var html = $scope.decode($scope.comment);
                $element.html(html);
            }
        };
    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 9/7/19 4:12 PM
 *
 */

(function () {
    'use strict';

    ImageSelector.$inject = ["$mdDialog", "Utils"];
    angular.module('app.main')
        .directive('imageSelector', ImageSelector);

    function ImageSelector($mdDialog, Utils) {
        return {
            restrict: "E",
            scope: {
                select: '@',
                multiple: "=",
                required: "=",
                placeholder: "@",
                viewModel: "@",
                sizes: '=',
                display: '@',
                defaultSelection: '=',
                onDefaultChange: '&'
            },
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl, Images) {
                scope.image = null;
                if (!scope.viewModel) {
                    scope.viewModel = 'thumbnail';
                }

                scope.$watch(function () {
                    return ctrl.$modelValue;
                }, function (newValue) {
                    if (newValue &&
                        newValue.urls &&
                        newValue.urls.full &&
                        newValue.urls.full.indexOf('gif') !== -1) {
                        scope.viewModel = 'full';
                    }
                    scope.image = newValue;
                });
                scope.openUploader = openUploader;
                scope.deleteImage = deleteImage;
                scope.updateDefault = updateDefault;
                scope.isMultiple = Utils.parseAttributeBoolean(attrs.multiple);
                scope.allowDefaultSelection = Utils.parseAttributeBoolean(attrs.defaultSelection);

                function openUploader(event, i) {
                    $mdDialog.show({
                        locals: {
                            multipleSelect: typeof i === "undefined" ? scope.isMultiple : false,
                            select: scope.select,
                            options: {sizes: scope.sizes}
                        },
                        controller: "upload.controller",
                        multiple: true,
                        fullscreen: true,
                        templateUrl: 'app/modules/base/partials/uploader.html',
                        parent: angular.element(document.body),
                        targetEvent: event,
                        clickOutsideToClose: true
                    })
                        .then(function (images) {


                            if (images && images.length) {
                                images = images.map(function (image) {
                                    delete image.selected;
                                    return image;
                                });
                                var value = getCopiedValue();
                                console.log(i, images);
                                if (typeof i === 'undefined') {
                                    if (scope.isMultiple) {
                                        value = value.concat(images);
                                    } else {
                                        value = images[0];
                                    }
                                } else {
                                    value[i] = images[0];
                                }
                                ctrl.$setViewValue(value);
                            }
                        });
                }

                function deleteImage(index) {
                    var value = getCopiedValue();
                    value.splice(index, 1);
                    ctrl.$setViewValue(value);
                }

                function getCopiedValue() {
                    var value = [];
                    angular.copy(scope.image, value);
                    return value;
                }

                function updateDefault(img, index) {
                    var value = getCopiedValue();
                    value = value.map(function (img) {
                        img.selected = false;
                        return img;
                    });
                    value[index].selected = true;
                    ctrl.$setViewValue(value);
                    scope.onDefaultChange({data: {images: value, updated: value[index], index: index}});
                }
            },
            templateUrl: "app/modules/base/directives/imageSelector/image-selector.html"
        };
    }

})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 02/02/20, 5:05 AM
 *
 */

(function () {
    'use strict';

    chatBox.$inject = ["ChatService", "AuthManager", "$mdToast", "Utils", "Base"];
    angular.module('app.main')
        .directive('chatBox', chatBox);

    function chatBox(ChatService, AuthManager, $mdToast, Utils, Base) {
        return {
            restrict: "E",
            replace: true,
            scope: {
                roomId: '=',
                hasAccess: '=',
                config: '=',
                onRoomUpdated: '&'
            },
            link: function (scope, element, attrs) {
                scope.connected = false;
                scope.messages = [];
                scope.connecting = false;
                scope.room = null;
                scope.typingUser = null;
                scope.isInternalMessage = true;
                scope.currentUser = AuthManager.getCurrentUser();
                scope.roomUsers = [];

                scope.init = init;
                scope.startConnection = startConnection;
                scope.transformMessage = transformMessage;
                scope.sendMessage = sendMessage;
                scope.setTypingIndicator = setTypingIndicator;
                scope.createRoom = createRoom;
                scope.dateAgo = Utils.dateAgo;
                scope.findReferences = Utils.findReferences;


                function init() {
                    scope.$watch('roomId', function (newVal, oldVal) {
                        if (newVal !== oldVal && scope.connected && newVal) {
                            scope.startConnection();
                        }
                    });
                    scope.startConnection();
                }

                function transformMessage(message) {
                    var comment = _.find(message.parts, function (part) {
                        return part.partType === 'inline' && part.payload.type === 'text/plain';
                    });
                    message.images = message.parts
                        .filter(function (part) {
                            return part.partType === 'url' && part.payload.type !== 'text/plain'
                        })
                        .map(function (part) {
                            return {
                                urls: {
                                    medium: part.payload.url,
                                    full: part.payload.url
                                }
                            }
                        });
                    message.comment = comment.payload.content;
                    return message;
                }

                function startConnection() {
                    console.log("chatBox.js", "startConnection", scope.hasAccess, typeof scope.hasAccess, scope.roomId);
                    if (scope.currentUser.role === 'admin' && scope.roomId) {
                        scope.connecting = true;
                        console.log("chatBox.js", "startConnection");
                        ChatService
                            .connectToRoom(scope.roomId, 10, scope.hooks)
                            .then(function (result) {
                                console.log("Connected to chat room : ", result);
                                scope.connecting = false;
                                scope.connected = true;
                                scope.room = result;
                                if(!scope.hasAccess) {
                                    scope.onRoomUpdated({data: {room: result}});
                                    scope.hasAccess = true;
                                }
                            })
                            .catch(function (err) {
                                console.log("chatBox.js", "er", err);
                                $mdToast.showSimple('There was an error connecting you to the chat service: ' + err.message);
                                scope.connecting = false;
                                scope.connectionError = err;
                            })
                    }

                }

                function sendMessage() {
                    if (scope.message || scope.imageSelected) {
                        if (!scope.messages) {
                            scope.messages = [];
                        }


                        var data = {
                            parts: [],
                            // references: scope.findReferences($scope.message),
                            saving: true,
                            isInternal: scope.isInternalMessage,
                            senderId: scope.currentUser._id,
                            sender: {
                                id: scope.currentUser._id,
                                name: scope.currentUser.name
                            }
                        };


                        if (scope.message) {
                            data.parts.push(
                                {
                                    type: "text/plain", content: scope.message
                                });
                        }


                        if (scope.imageSelected) {
                            scope.imageSelected.forEach(function (image) {
                                data.parts.push({
                                    type: Utils.getMimeType(image.extension),
                                    url: Base.getMediaUrl() + image.urls.medium,
                                })
                            })
                        }

                        var references = scope.findReferences(scope.message);
                        if (references && references.length) {
                            references.forEach(function (reference) {
                                data.parts.push({
                                    type: 'text/plain',
                                    content: 'reference:' + reference.user,
                                })
                            })
                        }

                        data.parts.push({
                            type: "text/plain",
                            content: 'private:' + scope.isInternalMessage
                        });


                        var index = scope.messages.length;
                        scope.sendingMessage = true;
                        ChatService
                            .sendMessageToRoom(scope.roomId, data.parts)
                            .then(function (result) {
                                scope.sendingMessage = false;
                                scope.message = '';
                                scope.imageSelected = null;
                            })
                            .catch(function (err) {
                                scope.sendingMessage = false;
                                scope.sendMessageError = err;
                                console.log("Error sending chat message:", err);
                                $mdToast.showSimple("Error sending chat message: " + err.message)
                            })
                    }
                }

                function setTypingIndicator(value) {
                    ChatService.sendTypingIndicatorsInRoom(scope.roomId)
                        .catch(function (error) {
                            console.log('Error setting typing indicators : ', error);
                        })
                }

                function createRoom() {
                    if (!scope.config.defaultId) {
                        throw new Error('A default room id is required to create a new chat room');
                    }
                    if (!scope.config.roomName) {
                        throw new Error('A default room name is required to create a new chat room');
                    }
                    if (!scope.config.members) {
                        scope.config.members = [];
                    }
                    scope.config.members.push({id: scope.currentUser._id, name: scope.currentUser.name});
                    scope.config.members = _.chain(scope.config.members)
                        .filter(function (member) {
                            return member.id;
                        })
                        .uniqBy(function (member) {
                            return member.id;
                        })
                        .value();
                    console.log("chatBox.js", "createRoom", scope.config);
                    scope.creatingRoom = true;
                    ChatService
                        .createRoom(
                            scope.config.defaultId,
                            scope.config.roomName,
                            {id: scope.currentUser._id, name: scope.currentUser.name},
                            scope.config.members,
                            scope.config.customData || {},
                            scope.config.public
                        )
                        .then(function (result) {
                            console.log("chatBox.js", "room", result[0]);
                            scope.creatingRoom = false;
                            scope.roomId = result[0].id;
                            scope.startConnection();
                            $mdToast.showSimple('Created new chat');
                        })
                        .catch(function (err) {
                            console.log("chatBox.js", "err", err);
                            scope.creatingRoom = false;
                            $mdToast.showSimple('Error creating a new chat: ' + err.message);
                        })
                }

                scope.hooks = {
                    onMessage: function (message) {
                        scope.messages.push(scope.transformMessage(message));
                    },
                    onUserStartedTyping: function (user) {
                        scope.typingUser = user;
                    },
                    onUserStoppedTyping: function (user) {
                        scope.typingUser = null;
                    },
                    onPresenceChanged: function (state, user) {
                        console.log("chatBox.js", "onPresenceChanged", state, user);
                    },
                    ooNewReadCursor: function (cursor) {
                        console.log("chatBox.js", "oonNewReadCursor", cursor);
                    }
                };

                scope.init();
            },
            templateUrl: "app/modules/base/directives/chatBox/chatBox.html"

        }
    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 21/6/19 2:33 AM
 *
 */

(function () {
    'use strict';

    AttachedTag.$inject = ["$window", "Menu", "$state", "hotkeys", "RestManager", "Utils", "$mdToast", "Materials"];
    angular.module('app.main')
        .directive('appSearch', AttachedTag);

    function AttachedTag($window, Menu, $state, hotkeys, RestManager, Utils, $mdToast, Materials) {
        return {
            restrict: "E",
            scope: {
                roleSpec: '=',
                openSearch: '='
            },
            link: function (scope, element, attrs) {
                scope.showSearchHelper = false;
                scope.blurBlocked = false;
                scope.searching = false;
                scope.searchTerm = '';
                scope.searchKeywords = [];
                scope.showPopup = showPopup;
                scope.hidePopup = hidePopup;
                scope.populateSuggestions = populateSuggestions;
                scope.navigateToPage = navigateToPage;
                scope.blockBlur = blockBlur;
                scope.unblockBlur = unblockBlur;
                scope.search = search;
                scope.clearSearch = clearSearch;
                scope.applyKeyword = applyKeyword;
                scope.saveSearch = saveSearch;
                scope.removeFromHistory = removeFromHistory;
                scope.initKeys = initKeys;
                scope.getSubheaderText = getSubheaderText;
                scope.searchProducts = searchProducts;
                scope.searchOrders = searchOrders;
                scope.searchUsers = searchUsers;
                scope.searchMaterials = searchMaterials;
                // scope.fuzzyLocalSearch = fuzzyLocalSearch;

                var keycodes = {
                    KEY_CODE: {
                        COMMA: 188,
                        SEMICOLON: 186,
                        ENTER: 13,
                        ESCAPE: 27,
                        SPACE: 32,
                        PAGE_UP: 33,
                        PAGE_DOWN: 34,
                        END: 35,
                        HOME: 36,
                        LEFT_ARROW: 37,
                        UP_ARROW: 38,
                        RIGHT_ARROW: 39,
                        DOWN_ARROW: 40,
                        TAB: 9,
                        BACKSPACE: 8,
                        DELETE: 46
                    }
                }

                function initKeys() {
                    element.bind("keyup", function (event) {
                        scope.$apply(function () {

                            switch (event.which) {
                                case keycodes.KEY_CODE.ESCAPE:
                                    scope.hasFocus = false;
                                    scope.hidePopup();
                                    event.stopPropagation();
                                    event.preventDefault();
                                    document.getElementById('app-search-input').blur();
                                    break;


                                case keycodes.KEY_CODE.DOWN_ARROW:
                                    if (scope.showSearchHelper) {

                                    }
                                    break;

                            }
                        });
                    });
                }

                function getSubheaderText() {
                    if (scope.searching) {
                        return 'Searching ...'
                    } else if (!scope.searching && !scope.searchTerm) {
                        return 'Suggested Actions'
                    } else {
                        return 'Matched Results'
                    }
                }

                function removeFromHistory(index, event) {
                    event.stopPropagation();
                    scope.unblockBlur()
                    var history = $window.localStorage.getItem('search-history');
                    if (history) {
                        history = JSON.parse(history);
                    } else {
                        history = [];
                    }

                    scope.searchKeywords.splice(index, 1);
                    history.splice(index, 1);
                    $window.localStorage.setItem('search-history', JSON.stringify(history));
                    scope.hasFocus = true;
                }

                function applyKeyword(keyword) {
                    scope.searchTerm = keyword;
                    scope.search();
                    scope.saveSearch(keyword);
                    scope.unblockBlur();
                    scope.hasFocus = true;
                }

                function saveSearch(keyword) {
                    if (keyword) {
                        var history = $window.localStorage.getItem('search-history');
                        if (history) {
                            history = JSON.parse(history);
                        } else {
                            history = [];
                        }

                        history.unshift(keyword);
                        history = _.uniq(history);
                        history = history.slice(0, 3);
                        $window.localStorage.setItem('search-history', JSON.stringify(history));
                    }
                }

                function clearSearch() {
                    scope.searchTerm = '';
                    scope.populateSuggestions();
                }

                function search() {
                    scope.searching = true;
                    scope.suggestions = [];
                    var promises = [scope.searchUsers(scope.searchTerm), scope.searchOrders(scope.searchTerm), scope.searchMaterials(scope.searchTerm), scope.searchProducts(scope.searchTerm)];

                    Promise.all(promises)
                        .then(function (suggestions) {
                            var menuSuggestions = Menu.searchMenuItems(scope.searchTerm, scope.roleSpec) || [];
                            if (suggestions) {
                                var results = _.flatten(suggestions).concat(menuSuggestions);
                                scope.suggestions = results;
                            } else {
                                scope.suggestions = menuSuggestions;
                            }
                            scope.searching = false;
                        })
                        .catch(function (err) {
                            console.log('Error with search', err);
                            $mdToast.showSimple('Error performing search : ' + err.message)

                        })
                }

                // function fuzzyLocalSearch(results, searchTerm) {
                //     var options = {
                //         keys: [
                //             {
                //                 name: 'name',
                //                 weight: 0.55
                //             },
                //             {
                //                 name: 'category',
                //                 weight: 0.45
                //             }
                //         ]
                //     };
                //     var fuse = new Fuse(results, options);
                //     return fuse.search(searchTerm)
                // }

                function searchProducts(searchTerm) {
                    if (searchTerm.length >= 3) {
                        return RestManager.getResource("/tags/search/" + searchTerm, 'tags')
                            .then(function (results) {
                                return results.map(function (product) {
                                    return {
                                        category: 'Product Search',
                                        name: Utils.getProperName(product.name, 40) + ' (' + product.sku + ')',
                                        image: product.featured_image.urls.thumbnail,
                                        sref: "app.products.add.home({slug: '" + product.objectID + "' , name: '" + product.name + "'})"
                                    }
                                })
                            })
                            .catch(function (err) {
                                $mdToast.showSimple('Error while searching products: ' + err.message);
                                return [];
                            })
                    } else {
                        return Promise.resolve([]);
                    }
                }

                function searchUsers(searchTerm) {
                    if (searchTerm.length >= 3) {
                        var query = {
                            order: 'name',
                            limit: 10,
                            page: 1,
                            searchTerm: searchTerm
                        };
                        return RestManager.postResource("/users/admin", query, 'users')
                            .then(function (results) {
                                return results.map(function (user) {
                                    return {
                                        category: 'User Search',
                                        name: Utils.getProperName(user.name, 40) + ' (' + user.mobile + ')',
                                        icon: 'person_outline',
                                        sref: "app.users.details.home({userId: '" + user._id + "'})"
                                    }
                                })
                            })
                            .catch(function (err) {
                                $mdToast.showSimple('Error while searching users: ' + err.message);
                                return [];
                            })
                    } else {
                        return Promise.resolve([]);
                    }
                }

                function searchMaterials(searchTerm) {
                    if (searchTerm.length >= 3) {
                        return Materials.autoCompleteMaterialByName(searchTerm)
                            .then(function (results) {
                                return results.map(function (material) {
                                    return {
                                        category: 'Material Search',
                                        name: Utils.getProperName(material.name, 40) + ' ( Stock : ' + material.stock + ')',
                                        image: material.image.urls.thumbnail,
                                        sref: "app.materials.details({materialId: '" + material._id + "'})"
                                    }
                                })
                            })
                            .catch(function (err) {
                                $mdToast.showSimple('Error while searching users: ' + err.message);
                                return [];
                            })
                    } else {
                        return Promise.resolve([]);
                    }
                }

                function searchOrders(searchTerm) {
                    if (searchTerm.length >= 3) {
                        var query = {
                            page: 1,
                            limit: 10,
                            filter: {
                                $or: [
                                    {
                                        orderNumber: {$regex: searchTerm, $options: 'ig'}
                                    },
                                    {
                                        'cachedAddress.name': {$regex: searchTerm, $options: 'ig'}
                                    },
                                    {
                                        'cachedAddress.mobile': {$regex: searchTerm, $options: 'ig'}
                                    },
                                    {
                                        'orderData.products.product.name': {$regex: searchTerm, $options: 'ig'}
                                    },
                                    {
                                        'orderData.products.product.sku': {$regex: searchTerm, $options: 'ig'}
                                    }
                                ]
                            }
                        };
                        return RestManager.postResource("/order/admin/getOrders", query, 'orders')
                            .then(function (orders) {
                                return orders.map(function (order) {
                                    return {
                                        category: 'Order Search',
                                        name: order.orderNumber + ' (' + Utils.getProperName(order.cachedAddres ? order.cachedAddress.name : order.user.name) + ')',
                                        icon: 'shopping_cart',
                                        sref: "app.orders.details({orderId :'" + order._id + "', backState: 'app.orders.all'})"
                                    }
                                })
                            })
                            .catch(function (err) {
                                $mdToast.showSimple('Error while searching orders: ' + err.message);
                                return [];
                            })
                    } else {
                        return Promise.resolve([]);
                    }
                }

                function unblockBlur() {
                    scope.blurBlocked = false;
                }

                function blockBlur() {
                    scope.blurBlocked = true;
                }


                function navigateToPage(sref, ev) {
                    ev.stopPropagation();
                    $state.go(sref)
                        .then(function () {
                            scope.hidePopup();
                        })
                }

                function populateSuggestions() {
                    var searchHistory = $window.localStorage.getItem('search-history');
                    if (searchHistory) {
                        scope.searchKeywords = JSON.parse(searchHistory)
                    }
                    scope.suggestions = Menu.getRecommendations(scope.roleSpec)
                }

                function showPopup() {
                    scope.showSearchHelper = true;
                    scope.hasFocus = true;
                }

                function hidePopup() {
                    if (!scope.blurBlocked) {
                        scope.showSearchHelper = false;
                    } else {
                        console.log('Blur is blocked');
                    }
                }

                scope.$watch('roleSpec', function (newVal, oldVal) {
                    scope.populateSuggestions();
                });

                scope.$watch('openSearch', function (newVal, oldVal) {
                    if (newVal) {
                        scope.hasFocus = true;
                    }
                });

                scope.initKeys()
                scope.populateSuggestions();
            },
            templateUrl: "app/modules/base/directives/appSearch/appSearch.tmpl.html"
        };
    }
})(angular);

(function () {
    'use strict';
    setAwbCode.$inject = ["$scope", "$mdDialog", "lineItem", "RestManager", "$mdToast", "orderId"];
    angular.module('app.main')
        .controller("setAwbCode.controller", setAwbCode);

    function setAwbCode($scope, $mdDialog, lineItem, RestManager, $mdToast, orderId) {
        $scope.lineItem = lineItem;

        console.log("set-awb-controller.js", "setAwbCode", lineItem);
        $scope.close = close;
        $scope.updateLineItemAwbCode = updateLineItemAwbCode;

        function close() {
            $mdDialog.cancel();
        }

        function updateLineItemAwbCode(code) {
            console.log("set-awb-controller.js", "updateLineItemAwbCode", code);
            RestManager.patchResource('/order/setLineItemAwbCode/' + orderId, {
                lineItemId: lineItem._id,
                awbCode: code
            }, 'orders')
                .then(function (res) {
                    console.log("set-awb-controller.js", "RES", res);
                    $mdDialog.hide({updatedData: res});
                })
                .catch(function (err) {
                    $mdToast.showSimple("Error in setting AWB Code, Please see network tab" + err.message);
                });

        }

    }

})(angular);

(function () {
    'use strict';

    PagePreview.$inject = ["$scope", "$mdDialog", "widgets", "setting", "RestManager", "$mdToast"];
    angular.module('app.main')
        .controller('PagePreview', PagePreview);

    function PagePreview($scope, $mdDialog, widgets, setting, RestManager, $mdToast) {
        $scope.widgets = widgets.map(function (config) {
            if(config.sizes && config.sizes.length) {
                var size = config.sizes[0];
                config.aspectRatio = size.width / size.height;
                config.width = size.width;
                config.height = size.height;
                config.objects = config.objects.map(function (object) {
                    if(object.image.urls.full.indexOf('gif') !== -1) {
                        object.key = 'full';
                    } else {
                        object.key = 'h_x_large';
                    }
                    return object;
                });
            }
            return config;
        });

        $scope.saveWidgets = saveWidgets;

        function saveWidgets() {
            var promise;
            var configs = [];
            angular.copy($scope.widgets, configs);
            configs = configs.map(function (config) {
                config.objects = config.objects.map(function (object) {
                    object.image = object.image._id;
                    return object;
                });
                return config;
            });
            $scope.saving = true;
            var payload = {};
            angular.copy($scope.setting, payload);
            payload.values = configs;
            if ($scope.setting && $scope.setting._id) {
                promise = RestManager.putResource('/settings/home/admin', payload, 'homeConfig')
            } else {
                promise = RestManager.postResource('/settings/home/admin', payload, 'homeConfig')
            }

            promise.then(function (settings) {
                $scope.setting = settings[0];
                $scope.configs = settings[0].values;
                $scope.saving = false;
                $mdToast.showSimple('Saved the config. Preview the page on the homepage to make sure it is perfect.')
                $mdDialog.hide({updatedSetting : settings[0]})
            })
                .catch(function (err) {
                    $scope.saving = false;
                    $mdToast.showSimple('Error saving home config : ' + err.message);
                })
        }


        $scope.cancel = function () {
            $mdDialog.cancel();
        }
    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 07/10/19, 1:22 AM
 *
 */

(function () {
    'use strict';

    LinkGenerator.$inject = ["$scope", "$mdDialog", "Base", "urlData", "Utils"];
    angular.module('app.main')
        .controller('link-generator.controller', LinkGenerator);


    function LinkGenerator($scope, $mdDialog, Base, urlData, Utils) {
        $scope.urlData = urlData || {
            baseUrl : '',
            url: '',
            page: '',
            query: {},
            utm_source: '',
            utm_medium: '',
            utm_campaign: '',
            utm_content: '',
            utm_term: '',
            ref: ''
        };
        $scope.readOnlyUrl = false;

        $scope.cancel = cancel;
        $scope.save = save;
        $scope.updateUrl = updateUrl;

        function cancel() {
            $mdDialog.cancel();
        }

        function save() {
            $mdDialog.hide($scope.urlData);
        }

        function updateUrl() {
            if ($scope.urlData.baseUrl) {
                $scope.urlData.url = $scope.urlData.baseUrl;
            }

            if ($scope.urlData.url && ($scope.urlData.utm_source || $scope.urlData.utm_medium || $scope.urlData.utm_campaign ||
                $scope.urlData.utm_content || $scope.urlData.utm_term || $scope.urlData.ref)) {
                $scope.urlData.url += '?';

                if ($scope.urlData.ref) {
                    $scope.urlData.url += 'ref=' + $scope.urlData.ref + '&';
                }

                if ($scope.urlData.utm_source) {
                    $scope.urlData.url += 'utm_source=' + $scope.urlData.utm_source + '&';
                }
                if ($scope.urlData.utm_medium) {
                    $scope.urlData.url += 'utm_medium=' + $scope.urlData.utm_medium + '&';
                }
                if ($scope.urlData.utm_campaign) {
                    $scope.urlData.url += 'utm_campaign=' + $scope.urlData.utm_campaign + '&';
                }
                if ($scope.urlData.utm_content) {
                    $scope.urlData.url += 'utm_content=' + $scope.urlData.utm_content + '&';
                }
                if ($scope.urlData.utm_term) {
                    $scope.urlData.url += 'utm_term=' + $scope.urlData.utm_term + '&';
                }

            }

            // if($scope.urlData.url) {
            //     $scope.urlData.url = $scope.urlData.url;
            // }
        }
    }

})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 21/02/20, 6:20 PM
 *
 */

(function () {
    'use strict';

    TaskCreateDialogController.$inject = ["$scope", "$mdDialog", "RestManager", "options", "TaskService", "Users", "$mdToast", "Workforce", "Utils", "AuthManager"];
    angular.module('app.workforce')
        .controller('task-create-dialog.controller', TaskCreateDialogController);

    function TaskCreateDialogController($scope, $mdDialog, RestManager, options, TaskService,
                                        Users, $mdToast, Workforce, Utils, AuthManager) {
        $scope.saving = false;
        $scope.tasks = [];
        $scope.product = options.product;
        $scope.order = options.order;
        $scope.lineItem = options.lineItem;
        $scope.design = options.design;
        $scope.description = null;
        $scope.taskName = null;
        $scope.priorites = TaskService.types.Constants.priority;
        $scope.taskTypes = TaskService.types.Constants.taskType;
        $scope.belongsTo = options.order ? 'order' : 'design';
        if (options.design) {
            options.product = {
                name: $scope.design.name
            };
            if (options.design.previewImageUrl) {
                options.product.image = {
                    urls: {
                        medium: options.design.previewImageUrl
                    }
                };
            }
        }
        $scope.taskName = '[' + $scope.belongsTo.toUpperCase() + '] ' + options.product.name;
        $scope.recommendedImages = [];
        $scope.currentUser = AuthManager.getCurrentUser();

        $scope.close = close;
        $scope.saveTask = saveTask;
        $scope.addTask = addTask;
        $scope.openUserSelect = openUserSelect;
        $scope.updateTaskImages = updateTaskImages;
        $scope.getSelectedImages = getSelectedImages;
        $scope.deleteTask = deleteTask;
        $scope.saveToOrder = saveToOrder;
        $scope.saveToDesign = saveToDesign;
        $scope.fetchPrevTasks = fetchPrevTasks;
        $scope.setupRecommendedImage = setupRecommendedImage;

        function deleteTask(index) {
            $scope.tasks.splice(index, 1);
        }

        function setupRecommendedImage() {
            if ($scope.order && $scope.order.designImages) {
                $scope.recommendedImages = $scope.order.designImages.map(function (designImage) {
                    return designImage.image;
                });
            } else if ($scope.design && $scope.design.images) {
                $scope.recommendedImages = $scope.design.images;
            }
            console.log($scope.recommendedImages);

            if ($scope.product && $scope.product.sku && $scope.product.sku.indexOf('ADRCUS') === -1) {
                RestManager.getResource("/products/" + $scope.product._id, "products")
                    .then(function (products) {
                        if (products && products.length) {
                            $scope.product.gallery = products[0].gallery;
                            $scope.recommendedImages = $scope.recommendedImages.concat($scope.product.gallery);
                        }
                        console.log($scope.recommendedImages);
                    })
                    .catch(function (error) {

                    })
            }

        }

        function getSelectedImages() {
            return $scope.recommendedImages
                .filter(function (image) {
                    return image.selected;
                });
        }

        function updateTaskImages(image) {
            $scope.tasks = $scope.tasks.map(function (task) {
                var imageIndex = _.findIndex(task.images, function (img) {
                    return img._id === image._id;
                });
                if (imageIndex !== -1) {
                    task.images.splice(imageIndex, 1);
                } else {
                    task.images.unshift(image);
                }
                return task;
            });
        }

        function addTask() {
            var images = $scope.getSelectedImages();
            $scope.tasks.push(
                new TaskService.types.Task({
                    product: options.product,
                    lineItem: options.lineItem,
                    order: options.order,
                    design: options.design,
                    name: options.taskName,
                    images: images,
                    designer: {
                        name: options.designer ? options.designer.name : $scope.currentUser.name,
                        mobile: options.designer ? options.designer.mobile : $scope.currentUser.mobile,
                        _id: options.designer ? options.designer._id : $scope.currentUser._id,
                    }
                })
            );
        }

        function openUserSelect(event, task, roles, property) {
            Users.selectUserDialog(event, {fields: 'name,mobile,role', roles: roles, multiple: false})
                .then(function (user) {
                    if (user)
                        task[property] = user;
                })
                .catch(function (error) {

                })
        }

        function fetchPrevTasks() {
            var query = {

                page: 1,
                limit: 25,
                sort: '-createdAt'
            };
            if ($scope.lineItem) {
                query.lineItems = $scope.lineItem._id;
            } else if ($scope.design) {
                query.designs = $scope.design._id;
            }
            Workforce
                .fetchTasksForLineItem(query)
                .then(function (tasks) {
                    $scope.prevTasks = tasks;
                    console.log(tasks)
                })
                .catch(function (error) {
                    $mdToast.showSimple('Error fetching previous tasks: ' + error.message);
                })
        }

        function close() {
            $mdDialog.cancel();
        }

        function saveTask() {
            $scope.saving = true;
            var payload = $scope.tasks.map(function (task) {
                return task.serialize($scope.taskName, $scope.description, $scope.belongsTo);
            });

            RestManager.postResource('/tasks', {tasks: payload}, 'tasks', {service: 'workforce'})
                .then(function (tasks) {
                    console.log("task-create.dialog.js", "TASKS", tasks);
                    return $scope.order ? $scope.saveToOrder(tasks) : $scope.saveToDesign(tasks);
                })
                .then(function (orders) {
                    console.log("task-create.dialog.js", "ORDERS", orders);
                    $scope.saving = false;
                    $mdDialog.hide(orders[0]);
                })
                .catch(function (err) {
                    $scope.saving = false;
                    $mdToast.showSimple('Error adding tasks to order : ' + err.message);
                });
        }

        function saveToDesign(tasks) {
            var taskIds = tasks.map(function (task) {
                return task._id;
            });
            return RestManager.patchResource('/designs/task/' + $scope.design._id, {tasks: taskIds}, 'designs', {service: 'scm'});

        }

        function saveToOrder(tasks) {
            // 'tasks', 'lineItemId', 'status', 'productName'
            var payload = {
                tasks: tasks,
                status: $scope.lineItem.status,
                lineItemId: $scope.lineItem._id,
                productName: $scope.product.name
            };
            return RestManager.patchResource('/order/updateLineItemTask/' + $scope.order._id, payload, 'orders')
        }

        $scope.addTask();
        $scope.fetchPrevTasks();

        $scope.setupRecommendedImage();
    }

})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 21/02/20, 7:03 PM
 *
 */

(function () {
    'use strict';

    TaskService.$inject = ["Utils"];
    angular.module('app.workforce')
        .service('TaskService', TaskService);

    function TaskService(Utils) {
        /**
         *
         * @type Task
         * @param options
         * @param options.order
         * @param options.lineItem
         * @param options.product
         * @param options.images
         * @param options.designer
         * @param options.design
         * @constructor
         */
        function Task(options) {
            this.product = options.product;
            this.lineItem = options.lineItem;
            this.order = options.order;

            this.priority = 'medium';
            this.days = 0;
            this.images = options.images || [];
            this.designer = options.designer;
            this.design = options.design;
            this.expanded = true;
            if (!this.images.length) {
                this.addImage();
            }
            if (this.order) {
                this.belongsTo = 'order';
            } else if(this.design) {
                this.belongsTo = 'design';
            }
            this.measurements = this.convertMeasurements(this.lineItem ? this.lineItem.measurements : this.design.measurements);
            console.log(this);
        }

        Task.prototype.serialize = function (name, description) {
            this.description = description;
            this.name = name;
            this.convertDurationToSeconds();
            var serializedObject = _.assign({}, this);
            serializedObject.images = _.filter(serializedObject.images, function (image) {
                return image._id;
            });
            var defaultImage = _.find(serializedObject.images, function (image) {
                return image.default;
            });
            if (!defaultImage && serializedObject.images.length) {
                defaultImage = serializedObject.images[0];
            }
            serializedObject.previewImageUrl = defaultImage ? defaultImage.urls.thumbnail : null;
            serializedObject.orderNumber = serializedObject.order ? serializedObject.order.orderNumber : null;
            serializedObject.order = serializedObject.order ? serializedObject.order._id : null;
            serializedObject.productName = serializedObject.product ? serializedObject.product.name : null;
            serializedObject.productSku = serializedObject.product ? serializedObject.product.sku : null;
            serializedObject.categories = serializedObject.lineItem ? serializedObject.lineItem.categories : null;
            serializedObject.categoryId = serializedObject.lineItem ? serializedObject.lineItem.categoryId : null;
            serializedObject.lineItem = serializedObject.lineItem ? serializedObject.lineItem._id : null;
            serializedObject.product = (serializedObject.product && serializedObject.product._id )? serializedObject.product._id : null;
            serializedObject.design = serializedObject.design ? serializedObject.design._id : null;
            return serializedObject;
        };

        Task.prototype.convertMeasurements = function (measurements) {
            if (measurements && !Array.isArray(measurements)) {
                return _.map(measurements, function (val, key) {
                    return {
                        value: val,
                        key: key
                    }
                })
            } else {
                return measurements;
            }
        };

        Task.prototype.convertDurationToSeconds = function () {
            this.allottedDuration = ((((((this.days || 0) * 24) + (this.hours || 0)) * 60) + (this.minutes || 0)) * 60);
        };

        Task.prototype.toggleExpansion = function () {
            this.expanded = !this.expanded;
        };

        Task.prototype.removeImage = function (index) {
            this.images.splice(index, 1);
        };

        Task.prototype.addImage = function () {
            this.images.unshift({});
        };

        Task.prototype.updateToImage = function (images, index) {
            console.log(images);
            var self = this;
            images.forEach(function (image, i) {
                if (i === 0) {
                    self.images.splice(index, 1, image);
                } else {
                    self.images.push(image);
                }
            });
        };

        var dbConstantStore = {
            priority: ['critical', 'high', 'medium', 'low'],
            taskType: ['marking', 'embroidery', 'cutting', 'stitching', 'alteration', 'tags-attachment',],
            belongsTo: ['order', 'design', 'outsourced-product']
        };

        this.types = {
            Task: Task,
            Constants: dbConstantStore
        };
    }


})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 16/09/19, 5:32 PM
 *
 */

(function () {
    'use strict';

    angular.module('app.warehouse', [])

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 16/09/19, 5:39 PM
 *
 */

(function () {
    'use strict';

    WarehouseCreateController.$inject = ["$scope", "$mdDialog", "warehouse", "RestManager", "$mdToast", "Address"];
    angular.module('app.warehouse')
        .controller('warehouse.create.dialog.controller', WarehouseCreateController);

    function WarehouseCreateController($scope, $mdDialog, warehouse, RestManager, $mdToast, Address) {
        $scope.editingMode = !!warehouse;
        $scope.warehouse = warehouse || {};

        $scope.cancel = cancel;
        $scope.addressSelector = addressSelector;
        $scope.save = save;


        function addressSelector(event) {
            var warehouse = {};
            angular.copy($scope.warehouse, warehouse);
            Address.showAddressSelector({
                event: event,
                user: warehouse,
                selected: warehouse.address ? warehouse._id : null
            })
                .then(function (result) {
                    console.log('Selected address', result);
                    if (result && result.address) {
                        $scope.warehouse.address = result.address;
                        $scope.warehouse.city = $scope.warehouse.address.city;
                        $scope.warehouse.state = $scope.warehouse.address.state;
                        $scope.warehouse.pinCode = $scope.warehouse.address.pinCode;
                    }
                })
                .catch(function (err) {

                })
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function save() {
            $scope.saving = true;
            var promise;
            if ($scope.editingMode) {
                promise = RestManager.putResource('/warehouse/' + $scope.warehouse._id, $scope.warehouse, 'warehouses');
            } else {
                promise = RestManager.postResource('/warehouse', $scope.warehouse, 'warehouses');
            }

            promise
                .then(function (data) {
                    $scope.saving = false;
                    $mdToast.showSimple(($scope.editingMode ? 'Updated ' : 'Added') + ' warehouse successfully.');
                    $mdDialog.hide({editing: $scope.editingMode, updated: data[0]})
                })
                .catch(function (err) {
                    $scope.saving = false;
                    $mdToast.showSimple('Error saving warehouse : ' + err.message);
                })
        }
    }

})(angular);

(function () {
    'use strict';

    organisationController.$inject = ["$scope", "$mdDialog", "RestManager", "$mdToast"];
    angular.module("app.users")
        .controller("users.org.controller", organisationController);


    function organisationController($scope, $mdDialog, RestManager, $mdToast) {
        $scope.$parent.pageTitle = "All Organisations";
        $scope.total = 0;
        $scope.query = {
            page: 1,
            limit: 25
        };

        $scope.addNewOrg = addNewOrg;
        $scope.rechargeWallet = rechargeWallet;
        $scope.showTxns = showTxns;


        $scope.fetchAllOrg = function () {
            RestManager.getResource("/org", "organisations", {query: $scope.query, extras: ['total']})
                .then(function (result) {
                    $scope.orgs = result.organisations;
                    $scope.total = result.total;
                })
                .catch(function (err) {
                    console.log(err);
                });
        };

        function rechargeWallet($event, org) {
            var data = {};
            angular.copy(org, data);
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: $event,
                fullscreen : true,
                controller: "recharge.wallet.controller",
                templateUrl: 'app/modules/users/organisations/rechargeWallet/recharge-wallet.html',
                clickOutsideToClose: true,
                locals: {
                    txn : null,
                    org: data
                }
            })
                .then(function (data) {
                    if(data) {
                        org.walletBalance = data;
                        $mdToast.showSimple('Successfully recharged wallet balance for : ' + org.name);
                    }
                })
                .catch(function (err) {

                })
        }

        function showTxns($event, org) {
            var data = {};
            angular.copy(org, data);
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: $event,
                fullscreen : true,
                controller: "transactions.dialog.controller",
                templateUrl: 'app/modules/users/organisations/transactions-dialog/transactions-dialog.html',
                clickOutsideToClose: true,
                locals: {
                    org: data
                }
            })
        }

        function addNewOrg(e, org, index) {
            var parentEl = angular.element(document.body);
            var data = {};
            angular.copy(org, data);
            $mdDialog.show({
                parent: parentEl,
                fullscreen : true,
                targetEvent: e,
                controller: "addOrg.dialog.controller",
                templateUrl: 'app/modules/users/organisations/addOrg/partials/addOrg.tmpl.html',
                clickOutsideToClose: true,
                locals: {
                    org: data
                }
            })
                .then(function (data) {
                    console.log("users.org.controller.js", "data", data);
                    if (data && data.updatedOrg) {
                        if (typeof index !== 'undefined') {
                            $scope.orgs.splice(index, 1, data.updatedOrg);
                        } else {
                            $scope.orgs.unshift(data.updatedOrg);
                        }
                    }
                });
        }


        $scope.fetchAllOrg();


    }

})(angular);

(function () {
    'use strict';
    InfluencersController.$inject = ["$scope", "RestManager", "$mdToast", "Influencers"];
    angular.module('app.users')
        .controller('influencers.controller', InfluencersController);

    function InfluencersController($scope, RestManager, $mdToast, Influencers) {

        $scope.managingRequest = false;
        $scope.$parent.pageTitle = "All Influencers";
        $scope.$parent.nestedState = false;
        $scope.$parent.backState = "app.home";

        $scope.fetchAllInfluencers = fetchAllInfluencers;
        $scope.manageInfluencerRequest = manageInfluencerRequest;
        $scope.openDetails = Influencers.openDetails;
        $scope.showFollowList = Influencers.openFollowList;

        function fetchAllInfluencers(type) {
            $scope.loading = true;
            var query = {};
            if (type === 'approved') {
                query = {
                    page: 1,
                    limit: 20,
                    roles: 'influencer'
                };
            } else if (type === 'pending') {
                query = {
                    page: 1,
                    limit: 20,
                    appliedForMarketer: true,
                    roles: 'customer'
                };
            }
            $scope.influencers = [];
            $scope.promise = RestManager.getResource('/users/filter', 'users', {
                query: query
            });
            $scope.promise
                .then(function (response) {
                    $scope.loading = false
                    $scope.influencers = response;
                })
                .catch(function (err) {
                    $scope.loading = false
                    $mdToast.showSimple("Error in fetching influencers: " + err.message);
                });
        }

        function manageInfluencerRequest(i, id, decision) {
            $scope.managingRequest = true;
            var payload = {
                id: id,
                decision: decision
            }
            RestManager.patchResource('/users/manageInfluencerRequest', payload, 'users')
                .then(function (response) {
                    $scope.managingRequest = false;
                    $scope.influencers.splice(i, 1);
                })
                .catch(function (err) {
                    $scope.managingRequest = false;
                    $mdToast.showSimple('Error in changing the status to ' + decision + ': ' + err.message);
                });
        }


        $scope.fetchAllInfluencers('approved');

    }

})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 09/01/20, 1:21 AM
 *
 */

(function () {
    'use strict';

    Influencers.$inject = ["$mdDialog"];
    angular.module('app.users')
        .service('Influencers', Influencers);

    function Influencers($mdDialog) {





        /**
         * @memberOf Influencers
         * @param event
         * @param options
         * @param options.userId
         */
        this.openDetails = function openDetails(event, options) {
            return $mdDialog.show({
                templateUrl : 'app/modules/users/dialogs/influencer-details-dialog/influencer-details.html',
                controller : 'influencer-details',
                clickOutSideToClose : false,
                fullscreen : true,
                multiple : true,
                targetEvent : event,
                locals : {
                    userId : options.userId,
                }
            })
        };

        /**
         * @memberOf Influencers
         * @param event
         * @param options
         * @param options.userId
         */
        this.openFollowList = function openFollowList(event, options) {
            return $mdDialog.show({
                templateUrl : 'app/modules/users/dialogs/follow-dialog/follow-dialog.html',
                controller : 'follow-details',
                clickOutSideToClose : false,
                fullscreen : true,
                multiple : true,
                targetEvent : event,
                locals : {
                    userId : options.userId,
                }
            })
        };
    }

})(angular);


/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 2/9/19 6:42 PM
 *
 */

(function () {
    'use strict';

    Address.$inject = ["$mdDialog", "$q", "$http", "RestManager"];
    angular.module('app.address')
        .service('Address', Address);

    function Address($mdDialog, $q, $http, RestManager) {
        this.showAddressSelector = showAddressSelector;
        this.showAddressEditDialog = showAddressEditDialog;

        /**
         * @method showAddressEditDialog
         * @memberOf Address
         * @param options
         * @returns {*}
         */
        function showAddressSelector(options) {
            return $mdDialog.show({
                templateUrl: 'app/modules/users/addresses/addressSelectorDialog/address-selector.dialog.tmpl.html',
                controller: 'address-selector.controller',
                multiple: true,
                fullscreen : true,
                targetEvent: options.event,
                locals: {
                    user: options.user,
                    selected : options.selected
                }
            })
        }

        /**
         * @method showAddressEditDialog
         * @memberOf Address
         * @param options
         * @returns {*}
         */
        function showAddressEditDialog(options) {
            return $mdDialog.show({
                templateUrl: 'app/modules/users/addresses/addressAddDialog/address-add-dialog.html',
                controller: 'address-add.controller',
                multiple: true,
                fullscreen : true,
                targetEvent: options.event,
                locals: {
                    address: options.address,
                    user: options.user
                }
            })
        }

        /**
         *
         * @memberOf Address
         * @param address
         * @returns {Promise}
         */
        this.addNewAddress = function (address) {
            return RestManager.postResource("/address", address, 'address')
                .then(this._sendSingle);
        };

        /**
         *
         * @memberOf Address
         * @returns {Promise}
         * @param address
         */
        this.updateAddress = function (address) {
            return RestManager.putResource("/address/" + address._id, address, 'addresses')
                .then(this._sendSingle);
        };


        /**
         *
         * @memberOf Address
         * @returns {Promise}
         * @param pinCode
         */
        this.checkCodAvailability = function (pinCode) {
            return $q(function (resolve, reject) {
                $http.get(Base.getBaseUrl() + "/pinCodes/" + pinCode)
                    .then(function (response) {
                        if (response.data.code == 200) {
                            //
                            resolve(response.data.message.pinCodes[0]);
                        } else {
                            reject(response.data.message.error);
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            });
        };

        /**
         *
         * @memberOf Address
         * @returns {Promise}
         * @param queryTerm
         */
        this.queryPinCode = function (queryTerm) {
            return RestManager.getResource("/pinCodes/" + queryTerm, 'pinCodes')
                .then(this._sendSingle);
        };


        /**
         *
         * @memberOf Address
         * @returns {Promise}
         */
        this.getAddresses = function (userId) {
            return RestManager.putResource("/address/admin?user=" + userId, 'address')
                .then(this._sendSingle);
        };


        /**
         *
         * @memberOf Address
         * @returns {Promise}
         * @param addressId
         */
        this.deleteAddress = function (addressId) {
            return RestManager.deleteResource('/address/' + addressId, 'address')
        };

        this._sendSingle = function (addresses) {
            console.log("address.service.js", "_sendSingle", addresses);
            return addresses[0];
        };


    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 2/9/19 6:35 PM
 *
 */

(function () {
    'use strict';

    AddressController.$inject = ["$scope"];
    angular.module('app.address')
        .controller('address.controller', AddressController);


    function AddressController($scope) {

    }

})(angular);

/**
 * Created by kumardivyarajat on 04/12/16.
 */
angular.module("app.redux", [])
    .controller("redux.controller", ["$scope", "$log", "RestManager", "Base", "$http", "Upload", function ($scope, $log, RestManager, Base, $http, Upload) {
        $log.info("Entered redux Module");


        $scope.file = "";

        $scope.getBackups = function (type) {
            $scope.backupsPromise = RestManager.getResource("/settings/backups/" + type, "settings");
            $scope.handleResponse($scope.backupsPromise, type);
        };

        $scope.generateBackup = function (type) {
            $scope.backupsPromise = RestManager.getResource("/settings/backups/generate/" + type, "settings");
            $scope.handleResponse($scope.backupsPromise);
        };

        $scope.handleResponse = function (promise, type) {
            promise
                .then(function (result) {
                    console.log(result);
                    if (type === "db") {
                        $scope.backups = result.map(function (o) {
                            o.size = parseFloat(parseFloat(o.size.split(" ")[0]) / 1024).toFixed(2) + " MB";
                            o.date = new Date($scope.getDate(o.name));
                            return o;
                        });
                    } else if (type === "app") {
                        $scope.appBackups = result.map(function (o) {
                            o.size = parseFloat(parseFloat(o.size.split(" ")[0]) / 1024).toFixed(2) + " MB";
                            o.date = new Date($scope.getDate(o.name));
                            return o;
                        });
                    } else if (type === "uploads") {
                        $scope.uploadsBackups = result.map(function (o) {
                            o.size = parseFloat(parseFloat(o.size.split(" ")[0]) / 1024).toFixed(2) + " MB";
                            o.date = new Date($scope.getDate(o.name));
                            return o;
                        });
                    }
                })
                .catch(function (err) {
                    console.log(err);
                })
        };

        $scope.getDate = function (name) {
            var data = name.split("-");
            var date = moment().date(data[3]).year(data[1]).month(data[2]);
            if (data[5]) {
                date.minutes(data[5].split(".")[0]).hours(data[4]).seconds(0);
            }
            return date.toString();
        };

        $scope.downloadFile = function (backup, type) {
            backup.downloading = true;
            var promise = $http.get(Base.getBaseUrl() + "/settings/backups/download/" + type + "/" + backup.name, {responseType: "arraybuffer"})
                .then(function (res) {
                    console.log("data fod");
                    saveAs(new Blob([res.data], {type: "application/zip"}), backup.name);
                    backup.downloading = false;
                    backup.downloaded = true;
                    console.log(backup);
                    // var blob = new Blob([ res ], { type : 'application/gzip' });
                    // $scope.url = (window.URL || window.webkitURL).createObjectURL( blob );
                    // console.log($scope.url);
                })
                .catch(function (err) {
                    console.log(err);
                });

            console.log(promise);
        };

        $scope.$watch('file', function () {
            if ($scope.file) {
                console.log("File available", $scope.file);
                $scope.uploadAndRestore();
            }
        });

        $scope.uploadAndRestore = function (type) {
            console.log("uploadAndRestore", $scope.file);
            Upload.upload({
                url: '/api/v1/settings/restore/file',
                data: {files: $scope.file}
            }).then(function (resp) {
                console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
            }, function (resp) {
                console.log('Error status: ' + resp.status);
            }, function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            });

        };
        $scope.getBackups("db");
        $scope.getBackups("app");
        $scope.getBackups("uploads");
    }]);
(function () {
    "use strict";


    ProductUtils.$inject = ["$mdToast", "$mdDialog", "Utils", "Base"];
    angular.module("app.products")
        .service("ProductUtils", ProductUtils);


    /**  @ngInject **/
    function ProductUtils($mdToast, $mdDialog, Utils, Base) {

        var vm = this;

        vm.varyingAttributes = [];
        vm.product = '';
        vm.getLowestPrice = Utils.getLowestPrice;
        vm.frontEndUrl = Base.getAppUrl();

        vm.openQuickView = function(event, productId) {
            return $mdDialog.show({
                templateUrl: "app/modules/products/quickViewDialog/quickView.tmpl.html",
                fullscreen: true,
                targetEvent: event,
                clickOutsideToClose: true,
                escapeToClose: true,
                multiple : true,
                locals: {
                    product: productId,
                    getLowestPrice: vm.getLowestPrice,
                    frontEndUrl: vm.frontEndUrl,
                    previewProduct: null
                },
                controller: 'product.quickView.controller'
            })

        }

        vm.openProductSelector = function(event, selectedProducts) {
            return $mdDialog.show({
                templateUrl: "app/modules/products/product-selector/products-selector.html",
                fullscreen: true,
                targetEvent: event,
                clickOutsideToClose: true,
                escapeToClose: true,
                multiple : true,
                locals: {
                    selectedProducts: selectedProducts
                },
                controller: 'products-selector.controller'
            })

        }

        vm.generateVariations = function (product, retainState) {
            vm.product = product;
            if(!vm.product.variations) {
                vm.product.variations = [];
            }
            switch (vm.evaluateNumberOfVaryingAttributes(product)) {
                case 0:
                    var data = {};
                    if (retainState) {
                        var previousVariation = [];
                        angular.copy(product.variations, previousVariation);
                        vm.product.variations = [];
                        data = previousVariation[0];
                    } else {
                        data = {
                            new: true,
                            stockAndPrice: {
                                price: {},
                                stock: {}
                            }
                        };
                    }
                    vm.product.variations.push(data);
                    break;

                case 1:
                    if (retainState) {
                        var previousVariations = [];
                        angular.copy(vm.product.variations, previousVariations);
                        vm.product.variations = [];
                        _.forEach(vm.varyingAttributes[0].selectedValues, function (selectedValue) {
                            var previousVariation = _.find(previousVariations, function (o) {
                                return _.toUpper(o.attributes[0].selectedValue[0]) === _.toUpper(selectedValue);
                            });
                            if (previousVariation) {
                                vm.product.variations.push(previousVariation);
                            } else {
                                vm._pushEmptyVariation(product, selectedValue, true);
                            }
                        })
                    } else {
                        _.forEach(vm.varyingAttributes[0].selectedValues, function (selectedValue) {
                            vm._pushEmptyVariation(selectedValue, true);
                        });
                    }
                    break;

                default:
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Multiple Varying attributes are not supported yet.\n Please go back to attributes and uncheck "Used for variations"\n from one of the attributes to continue.\n' +
                                'Please contact the admin for more details.')
                            .position("bottom right")
                            .capsule(false)
                            .highlightClass('md-primary')
                            .hideDelay(5000)
                    );
                    break;
            }
            return vm.product;
        };

        vm._pushEmptyVariation = function (selectedValue, markAsNew, modified) {
            vm.product.variations.push({
                attributes: [
                    {
                        attribute: vm.varyingAttributes[0].attribute,
                        selectedValue: [selectedValue]
                    }
                ],
                new: markAsNew,
                modified: modified,
                stockAndPrice: {
                    price: {},
                    stock: {}
                }
            });
        };

        vm.evaluateNumberOfVaryingAttributes = function () {
            var count = 0;
            _.forEach(vm.product.attributes, function (attributeData) {
                if (attributeData.isVariation) {
                    vm.varyingAttributes.push(attributeData);
                    count++;
                }
            });
            return count;
        };
    }
})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 6/6/19 4:15 PM
 *
 */

(function () {
    'use strict';


    ProductQuickViewController.$inject = ["$scope", "RestManager", "$window", "$mdDialog", "product", "StockUpdates", "$mdMedia", "previewProduct", "frontEndUrl", "Utils", "getLowestPrice", "ProductsBulk"];
    angular.module('app.main')
        .controller('product.quickView.controller', ProductQuickViewController);


    function ProductQuickViewController($scope, RestManager, $window, $mdDialog, product, StockUpdates, $mdMedia,
                                        previewProduct, frontEndUrl, Utils, getLowestPrice, ProductsBulk) {
        $scope.productId = product;
        $scope.frontEndUrl = frontEndUrl;
        $scope.getLowestPrice = getLowestPrice;
        $scope.loadingProduct = true;
        $scope.updatedData = false;
        $scope.priceHistoryLimit = 5;
        $scope.isSmall = !$mdMedia('gt-sm');

        $scope.fetchProduct = fetchProduct;
        $scope.showStockHistory = showStockHistory;
        $scope.init = init;
        $scope.dateAgo = Utils.dateAgo;

        if (previewProduct) {
            $scope.product = previewProduct;
            $scope.previewMode = true;
            $scope.init();
            $scope.fields = $scope.fields.map(function (field) {
                field.disabled = true;
                return field;
            });
            $scope.loadingProduct = false;
        }

        function fetchProduct() {
            RestManager.getResource("/products/admin/" + $scope.productId, "products")
                .then(function (result) {
                    $scope.product = result[0];
                    $scope.loadingProduct = false;
                    $scope.priceHistories = result[0].priceHistory.reverse();
                    $scope.init();
                })
                .catch(function (err) {
                    console.log('err loading product in quick view', err);
                })
        }

        function showStockHistory(event) {
            StockUpdates.openStockUpdateDialog( event , {productId : $scope.product._id})
        }

        function init() {
            console.log($scope.product);
            $scope.selectedImage = ($scope.product.featured_image && $scope.product.featured_image._id) ? $scope.product.featured_image : $scope.product.gallery[0];

            $scope.fields = [
                {model: 'published', title: 'Published', formType: 'switch'},
                {model: 'isFeatured', title: 'Featured', formType: 'switch'},
                {model: 'isOnSale', title: 'On Sale (Auto Generated)', formType: 'switch', disabled: true},
                {model: 'outOfStock', title: 'Out of Stock', formType: 'switch'},
                {model: 'comingSoon', title: 'Coming Soon', formType: 'switch'},
                {model: 'isAvailableForPreOrder', title: 'Available For Pre-Order', formType: 'switch'},
                {model: 'virtualVariations', title: 'Virtual Variations', formType: 'switch'}
            ];

            if ($scope.product.productType === 1) {
                $scope.fields.push({
                    model: 'editorType', title: 'Select Editor Type', formType: 'select',
                    options: [
                        {
                            value: 'simple',
                            title: 'Simple'
                        }, {
                            value: 'intermediate',
                            title: 'Intermediate'
                        }, {
                            value: 'advanced',
                            title: 'Advanced'
                        }
                    ]
                });
            }
        }

        $scope.closeDialog = function () {
            $mdDialog.hide({product: product, updatedData: $scope.updatedData});
        };

        $scope.update = function () {
            $scope.product.updating = true;
            ProductsBulk.updateBoolFields([$scope.product], {
                published: $scope.product.published,
                isCoupon: $scope.product.isCoupon,
                isOnSale: $scope.product.isOnSale,
                isFeatured: $scope.product.isFeatured,
                outOfStock: $scope.product.outOfStock,
                comingSoon: $scope.product.comingSoon,
                editorType: $scope.product.editorType,
                isAvailableForPreOrder: $scope.product.isAvailableForPreOrder,
                virtualVariations: $scope.product.virtualVariations
            })
                .then(function (products) {
                    $scope.product.updating = false;
                    $scope.product = products[0];
                    $scope.updatedData = true;
                    console.log('Updated', products);
                    console.log('Updated  aa', $scope.product);
                })
                .catch(function (err) {
                    $scope.product.updating = false;
                    console.log('Error', err)
                })

        };

        $scope.getAttributeData = function (attributeData) {
            var data = Utils.getAttributeObject(attributeData);
            console.log(data);
            return data;
        };

        $scope.getVariationValues = function (variation) {
            if (variation.attributes[0]) {
                var varId = variation.attributes[0].selectedValue[0];

                var a = _.find(variation.attributes[0].attribute.meta_values, function (meta_value) {
                    return meta_value._id === varId;
                });
                if (a) {
                    return a.value;
                }
            }
        };

        $scope.selectImage = function (image) {
            $scope.selectedImage = image;
        };

        $scope.viewOnWebsite = function () {
            var url = $scope.frontEndUrl + "/product/" + $scope.product.slug;
            console.log(url);
            $window.open(url, '_blank');
        };

        if (!$scope.previewMode) {
            $scope.fetchProduct();
        }
    }
})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 13/6/19 11:52 PM
 *
 */

(function () {
    'use strict';

    productTemplatesController.$inject = ["$scope", "$mdDialog", "product", "RestManager", "ucData", "Utils", "Base", "$window", "$timeout"];
    angular.module('app.products')
        .controller('product-templates.controller', productTemplatesController);

    function productTemplatesController($scope, $mdDialog, product, RestManager, ucData,
                                        Utils, Base, $window, $timeout) {
        $scope.product = product;
        $scope.mediaUrl = Base.getMediaUrl();
        $scope.frontEndUrl = Base.getAppUrl();
        $scope.viewMode = false;
        $scope.disableSelection = false;
        $scope.query = {
            page: 1,
            limit: 15,
            isTemplate: true,
            product: $scope.product._id,
            customisation: $scope.product.customisation._id || $scope.product.customisation
        };
        $scope.fetchingTemplates = true;


        $scope.ucData = {
            price: 0,
            product: product._id,
            customisation: product.customisation._id,
            isTemplate: true
        };

        $scope.adding = false;
        $scope.selectedIndex = -1;


        $scope.cancel = cancel;
        $scope.fetchProductTemplates = fetchProductTemplates;
        $scope.expandLayer = expandLayer;
        $scope.selectOption = selectOption;
        $scope.executeTriggers = executeTriggers;
        $scope.revertTriggers = revertTriggers;
        $scope.executeSingleTrigger = executeSingleTrigger;
        $scope.checkTotalPrice = checkTotalPrice;
        $scope.saveTemplate = saveTemplate;
        $scope.evaluateCustomisationState = evaluateCustomisationState;
        $scope.viewOnWebsite = viewOnWebsite;
        $scope.selectTemplate = selectTemplate;
        $scope.init = init;
        $scope.clearState = clearState;
        $scope.addTemplate = addTemplate;
        $scope.getBackGround = getBackGround;
        $scope.openNextLayer = openNextLayer;
        $scope.applyUCData = applyUCData;

        $scope.getBackgroundScale = Utils.getBackgroundScale;
        $scope.getSelectedPosition = Utils.getSelectedPosition;
        $scope.getPrice = Utils.getPrice;


        function addTemplate() {
            $scope.clearState();
            $scope.adding = true;
        }

        function selectTemplate(template, index) {
            $scope.ucData = {
                price: 0,
                product: product._id,
                customisation: product.customisation._id,
                isTemplate: true
            };
            if (template) {
                angular.copy(template, $scope.ucData);
                $scope.applyUCData();
            }
            $scope.editing = true;
            $scope.selectedIndex = index;
        }

        function applyUCData() {
            $scope.product.customisation.data = $scope.product.customisation.data.map(function (datum) {
                var a = _.find($scope.ucData.data, function (o) {
                    return o.dataId === datum._id;
                });
                // TODO- Will not work for multiple customisation options at all. RED FLAG!!!!
                var selectedValueId = null;
                if (a) {
                    selectedValueId = a.selectedValues[0];
                }

                datum.default = _.find(datum.options, function (o) {
                    return o._id === selectedValueId;
                });

                $scope.executeTriggers(datum.default);

                return datum;
            });
            $scope.checkTotalPrice();
        }

        function getBackGround(status) {
            switch (status) {
                case 'active' :
                    return '#28ffaa'

                case 'draft' :
                    return '#edff5c'

                case 'deleted' :
                    return '#ffd3d3'
            }
        }

        function init() {
            $timeout(function () {
                $scope.adding = false;
            }, 1000)
            if (ucData) {
                $scope.ucData = ucData;
                $scope.applyUCData();
                console.log('APplied', $scope.ucData);
                $scope.viewMode = true;
                $scope.adding = false;
                $scope.editing = false;
                $scope.disableSelection = true;
            }
            $scope.product.customisation.layerMap = {};
            _.forEach($scope.product.customisation.data, function (layer, i) {
                $scope.product.customisation.layerMap[layer._id] = i;
                _.forEach(layer.options, function (option) {
                    option.watchList = [];
                    if (option.triggers && option.triggers.length) {
                        option.watchList = _.map(option.triggers, 'linkedLayer');
                    }
                    if (layer.default && layer.default._id === option._id) {
                        $scope.executeTriggers(option);
                    }
                })
            });

        }

        function viewOnWebsite(ucSlug, event) {
            event.stopPropagation();
            var url = $scope.frontEndUrl + "/customisation/product/" + $scope.product.slug + '/' + ucSlug;
            console.log(url);
            $window.open(url, '_blank');
        }


        function saveTemplate() {
            $scope.savingTemplate = true;
            $scope.ucData.data = $scope.evaluateCustomisationState();
            var payload = {};
            angular.copy($scope.ucData, payload);
            var promise;
            if ($scope.editing) {
                promise = RestManager.putResource('/ucData/templates/' + payload._id, payload, 'ucData')
            } else {
                promise = RestManager.postResource('/ucData/templates', payload, 'ucData')
            }

            promise
                .then(function (result) {
                    $scope.savingTemplate = false;
                    if ($scope.editing) {
                        $scope.templates[$scope.selectedIndex] = result[0];
                    } else {
                        $scope.templates.push(result[0]);
                    }
                    console.log('Saved Result', result);
                    $scope.clearState();
                })
                .catch(function (err) {
                    $scope.savingTemplate = false;
                    console.log('Saved err', err);
                })
        }

        function clearState() {
            $scope.editing = false;
            $scope.adding = false;
            $scope.ucData = {
                isTemplate: true,
                product: $scope.product._id,
                customisation: $scope.product.customisation._id || $scope.product.customisation
            };
        }

        function evaluateCustomisationState() {
            var a = [];
            _.forEach($scope.product.customisation.data, function (datum, i) {
                if (datum.default !== undefined) {
                    a.push({
                        dataId: datum._id,
                        selectedValues: [datum.default._id]
                    });
                }
            });
            return a;
        }


        function executeTriggers(option) {
            console.log('Executing', option);
            if (option && option.triggers && option.triggers.length) {
                option.triggers.forEach(function (trigger) {
                    $scope.executeSingleTrigger(trigger.triggerType, trigger.linkedLayer, trigger.options)
                })
            }
        }

        function revertTriggers(option) {
            if (option && option.triggers && option.triggers.length) {
                option.triggers.forEach(function (trigger) {
                    var selectedLayer = _.find($scope.product.customisation.data, function (datum) {
                        return datum._id === trigger.linkedLayer;
                    });
                    selectedLayer.allOptionsDisabled = false;
                    if (selectedLayer) {
                        var shouldChangeDefault = false;
                        selectedLayer.options.forEach(function (option) {
                            if (trigger.options.includes(option._id) && trigger.triggerType === 'disable') {
                                option.disabled = false;
                            }
                        });
                    }
                });
            }

        }

        function executeSingleTrigger(triggerType, layer, options) {
            var selectedLayerIdx = _.findIndex($scope.product.customisation.data, function (datum) {
                return datum._id === layer;
            });

            if (selectedLayerIdx) {
                var selectedLayer = $scope.product.customisation.data[selectedLayerIdx];
                var shouldChangeDefault = false;
                selectedLayer.allOptionsDisabled = false;
                selectedLayer.options.forEach(function (option) {
                    if (triggerType === 'disable') {
                        option.disabled = options.includes(option._id);
                    } else if (triggerType === 'enable') {
                        option.disabled = !options.includes(option._id);
                    }
                    shouldChangeDefault = shouldChangeDefault || option.disabled && (option._id === selectedLayer.default._id);
                });
                selectedLayer.options = _.orderBy(selectedLayer.options, ['disabled'], ['asc']);
                if (shouldChangeDefault) {
                    selectedLayer.activeOptions = selectedLayer.options.filter(function (option) {
                        return !option.disabled;
                    });
                    if (selectedLayer.activeOptions.length) {
                        $scope.selectOption(selectedLayer, selectedLayer.activeOptions[0])
                        // selectedLayer.default = selectedLayer.activeOptions[0];
                    } else {
                        selectedLayer.allOptionsDisabled = true;
                    }
                }
                console.log('EXECUTE', selectedLayer, shouldChangeDefault);
            }
        }


        function selectOption(layer, option) {
            if(!$scope.disableSelection) {
                layer.default = option;
                // $scope.revertTriggers(layer.default);
                $scope.executeTriggers(option);
                $scope.checkTotalPrice();
            }

        }

        function checkTotalPrice() {
            $scope.totalPrice = product.customisation.basePrice;
            _.forEach($scope.product.customisation.data, function (datum, i) {
                if (datum.default !== undefined) {
                    console.log('Utils.getPrice(datum.default.stockAndPrice, true)', Utils.getPrice(datum.default.stockAndPrice, true));
                    $scope.totalPrice += Utils.getPrice(datum.default.stockAndPrice, true);
                    $scope.ucData.price = $scope.totalPrice;
                }
            });

            console.log('UC', $scope.ucData.totalPrice);
        }

        function expandLayer(layer) {
            $scope.product.customisation.data = $scope.product.customisation.data.map(function (datum) {
                if (layer !== datum) {
                    datum.expanded = false;
                }
                return datum;
            });
            layer.expanded = !layer.expanded;
        }

        function openNextLayer(currentLayerIndex) {
            if (currentLayerIndex !== $scope.product.customisation.data.length - 1 && !$scope.disableSelection) {
                $scope.expandLayer($scope.product.customisation.data[currentLayerIndex + 1])
            }
        }

        function fetchProductTemplates() {
            $scope.fetchingTemplates = true;
            RestManager.getResource('/ucData/templates', 'ucData', {query: $scope.query})
                .then(function (templates) {
                    $scope.templates = templates;
                    $scope.fetchingTemplates = false;
                })
                .catch(function (err) {
                    console.log(err);
                    $scope.fetchingTemplates = false;
                })
        }


        function cancel() {
            $mdDialog.cancel();
        }

        $scope.init();
        $scope.fetchProductTemplates();
        $scope.checkTotalPrice();
    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 15/5/19 5:37 PM
 *
 */

(function () {
    'use strict';

    ProductListCtrl.$inject = ["$scope", "products", "Utils", "$mdDialog", "Base"];
    angular.module('app.products')
        .controller('ProductListCtrl', ProductListCtrl);

    function ProductListCtrl($scope, products, Utils, $mdDialog, Base) {
        $scope.products = products;
        $scope.capitalize = Utils.capitalize;
        $scope.getLowestPrice = Utils.getLowestPrice;
        $scope.frontEndUrl = Base.getAppUrl();

        $scope.cancel = cancel;

        console.log("product-list.dialog.js", "ProductListCtrl", $scope.products);

        $scope.openQuickView = function (event, product) {
            event.stopPropagation();
            $mdDialog.show({
                templateUrl: "app/modules/products/quickViewDialog/quickView.tmpl.html",
                fullscreen: true,
                targetEvent: event,
                clickOutsideToClose: true,
                escapeToClose: true,
                multiple : true,
                locals: {
                    product: product._id,
                    getLowestPrice: $scope.getLowestPrice,
                    frontEndUrl: $scope.frontEndUrl,
                    previewProduct: null
                },
                controller: 'product.quickView.controller'
            })
                .then(function (data) {

                })
                .catch(function (data) {
                });
        };


        function cancel() {
            $mdDialog.cancel();
        }
    }

})(angular);

(function () {
    'use strict';

    ProductsSelectorController.$inject = ["$scope", "RestManager", "$mdDialog", "selectedProducts", "$mdToast", "Base", "Utils", "$q"];
    angular.module('app.products')
        .controller('products-selector.controller', ProductsSelectorController);


    function ProductsSelectorController($scope, RestManager, $mdDialog, selectedProducts, $mdToast, Base, Utils, $q) {
        $scope.editing = !!selectedProducts;
        $scope.selectedProducts = selectedProducts || [];
        $scope.mediaUrl = Base.getMediaUrl();
        $scope.query = {
            page: 1,
            limit: 10,
            search: '',
            order: '-updatedAt'
        };
        $scope.selectedMaterialsPanelCollapsed = false;

        $scope.cancel = cancel;
        $scope.save = save;
        $scope.addToCart = addToCart;
        $scope.fetchProducts = fetchProducts;
        $scope.updateStock = updateStock;
        $scope.removeProduct = removeProduct;
        $scope.checkIfHasToBeRemoved = checkIfHasToBeRemoved;
        $scope.capitalize = Utils.getProperName;

        function fetchProducts(searchText) {
            var size = '';
            // Checks if the lookup text is performing the search based on our new
            // SKU_SIZE combo barcode standard
            if (/^ADR\w{3}\d{4}/.test(searchText)) {
                size = searchText.slice(10);
                searchText = searchText.slice(0, 10);
            }
            // Sets the query parameters to be sent to the backend
            var filters = {
                orderBy: '-updatedAt',
                limit: 5,
                page: 1,
                showAll: {
                    type: true,
                    published: true,
                    featured: true
                },
                searchTerm: searchText,
                populate: 'variations sizeChart'

            };

            return $q(function (resolve, reject) {
                // Fetches the data from the backend
                RestManager.postResource("/products/admin", filters, "products", ["total"])
                    .then(function (result) {
                        var products = [];
                        // Transforms the data to show one entry in the autocomplete box
                        // for each variation of a product returned by the backend
                        result.products.forEach(function (product) {
                            product.variations.forEach(function (variation) {
                                var p = {};
                                angular.copy(product, p);
                                p.selectedVariation = Utils.getVariationValue(variation);
                                p.variation = variation;
                                p.sku = p.sku + p.selectedVariation;
                                p.discountValue = 0;
                                if (p.mrp && p.price && (p.mrp > p.price)) {
                                    p.discountAmount = p.mrp - p.price;
                                    p.discountValue = parseFloat((((p.discountAmount) / p.mrp) * 100).toFixed(2));
                                }
                                p.discountType = 'percent';
                                p.quantity = 1;

                                products.push(p);
                            });

                            if (size) {
                                products = products.filter(function (p) {
                                    return p.selectedVariation === size;
                                })
                            }
                        });
                        resolve(products);
                    })
                    .catch(function (err) {
                        console.log(err);
                        $scope.fetchingProducts = false;
                        reject(err);
                    });
            })
        }

        function addToCart(selectedItem) {
            if(selectedItem) {
                var isAlreadyPresent = _.findIndex($scope.selectedProducts, function (product) {
                    return product.productId === selectedItem._id;
                });
                console.log("products-selector.dialog.js", "addToCart", selectedItem);
                if(isAlreadyPresent === -1) {
                    $scope.selectedProducts.unshift({
                        productId : selectedItem._id,
                        productName : selectedItem.name,
                        quantity : 1,
                        image : selectedItem.featured_image,
                        price : selectedItem.price,
                        totalPrice : selectedItem.price,
                        variationId : selectedItem.variation._id,
                        selectedVariationText : selectedItem.variation.selectedVariation,
                        variationText : selectedItem.variation.selectedVariation,
                        sku : selectedItem.sku
                    })
                    console.log("products-selector.dialog.js", "addToCart", $scope.selectedProducts);
                    $scope.searchText = null;
                }
            }
        }

        function checkIfHasToBeRemoved(product, index) {
            product.totalPrice = _.round(product.quantity * product.price, 2);
            if (product.quantity <= 0) {
                $scope.removeProduct(product, index);
            }
        }

        function updateStock(product, updateQuantity, $event, index) {
            $event.stopPropagation();
            product.quantity = product.quantity + updateQuantity;
            $scope.checkIfHasToBeRemoved(product, index);
        }

        function removeProduct(product, index) {
            $scope.selectedProducts.splice(index, 1);
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function save() {
            $mdDialog.hide({products: $scope.selectedProducts})
        }

    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 19/6/19 5:01 PM
 *
 */

(function () {
    'use strict';

    angular.module('app.products')
        .controller('editProductPriceController', ["$scope", "RestManager", "$mdToast", "$mdDialog", "products", "$q", function ($scope, RestManager, $mdToast, $mdDialog, products, $q) {
            $scope.productsFetched = false;
            $scope.products = [];
            $scope.updatePrice = {};
            $scope.selected = [];
            $scope.editProductQuick = {};
            $scope.productPriceForm = {};
            $scope.productsLength = products.length;

            $scope.fetchProductDetails = fetchProductDetails;
            $scope.fetchProduct = fetchProduct;
            $scope.update = update;
            $scope.updateDataInSelected = updateDataInSelected;
            $scope.cancel = cancel;
            $scope.checkValue = checkValue;
            $scope.setForm = setForm;
            $scope.calculatePrice = calculatePrice;

            function calculatePrice(product) {
                product.price = _.round(product.mrp - (product.discountPercent / 100) * product.mrp);
                product.variations = product.variations.map(function (variation) {
                    variation.stockAndPrice.price.salePrice = product.price;
                    variation.stockAndPrice.price.mrp = product.mrp;
                    return variation;
                });
            }

            function setForm(form, formName) {
                $scope[formName] = form;
            }

            function checkValue(product) {
                if (product.salePrice < product.msp) {
                    $scope.productPriceForm.salePrice.$setValidity("minVal", false);
                } else {
                    $scope.productPriceForm.salePrice.$setValidity("minVal", true);
                }
            }

            function cancel() {
                $mdDialog.cancel();
            }

            function update() {
                $scope.updatingProducts = true;
                Promise
                    .map($scope.products, function (product) {
                        return new Promise(function (resolve, reject) {
                            _.forEach(product.variations, function (variation, i) {
                                if (variation.attributes) {
                                    if (variation.attributes.length > 0) {
                                        product.variations[i].attributes[0].attribute = variation.attributes[0].attribute._id;
                                    }
                                }
                            });

                            if (product.productType === 1) {
                                product.customisation.isModified = true;
                                product.customisation.basePrice = product.price;
                                product.customisation.mrp = product.mrp;
                            }

                            product.variations = product.variations.map(function (variation) {
                                variation.stockAndPrice.price.salePrice = product.price;
                                variation.stockAndPrice.price.mrp = product.mrp;
                                variation.modified = true;
                                return variation;
                            });

                            if ($scope.updatePrice.updateStatus) {
                                product.isFeatured = $scope.updatePrice.featured;
                                product.outOfStock = $scope.updatePrice.outOfStock;
                                product.published = $scope.updatePrice.published;
                                product.updateStatus = true;
                            }

                            product.isOnSale = product.price < product.mrp;

                            product.updating = true;
                            RestManager.putResource("/products/price/" + product._id, product, "products")
                                .then(function (data) {
                                    product.updating = false;
                                    product.updated = true;
                                    resolve(data);
                                })
                                .catch(function (err) {
                                    product.updating = false;
                                    product.updated = false;
                                    resolve(err);
                                });
                        })

                    })
                    .then(function (value) {
                        $scope.updatingProducts = false;
                        $scope.selected = [];
                        $mdDialog.hide({isUpdated: true});
                        $mdToast.showSimple("Successfully updated " + value.length + ' products');
                    })
                    .catch(function (err) {
                        $scope.updatingProducts = false;
                        $mdToast.showSimple("Error encountered while saving the products : " + err.message);
                    });
            }

            function updateDataInSelected(mode) {
                if (mode === 'salePrice' || mode === 'mrp') {
                    $scope.products = $scope.products.map(function (product) {
                        product.variations = product.variations.map(function (variation) {
                            if ($scope.updatePrice.salePrice) {
                                variation.stockAndPrice.price.salePrice = $scope.updatePrice.salePrice;
                            }
                            if ($scope.updatePrice.mrp) {
                                variation.stockAndPrice.price.mrp = $scope.updatePrice.mrp;
                            }
                            return variation;
                        });
                        if ($scope.updatePrice.salePrice)
                            product.price = $scope.updatePrice.salePrice;
                        if ($scope.updatePrice.mrp)
                            product.mrp = $scope.updatePrice.mrp;
                        return product;
                    });
                } else if (mode === 'discount') {
                    $scope.products = $scope.products.map(function (product) {
                        var salePrice = 0, mrp = 0;
                        product.variations = product.variations.map(function (variation) {
                            if (!variation.stockAndPrice.price.mrp) {
                                variation.hasError = true;
                                variation.error = 'MRP is not set';
                            } else {
                                mrp = variation.stockAndPrice.price.mrp;
                                variation.stockAndPrice.price.salePrice = mrp - parseInt((mrp * ($scope.updatePrice.discountPercent / 100)).toFixed(0));
                                salePrice = variation.stockAndPrice.price.salePrice;
                            }
                            return variation;
                        });
                        product.discountPercent = $scope.updatePrice.discountPercent;
                        product.price = salePrice;
                        product.mrp = mrp;
                        return product;
                    });
                }
            }

            $scope.regenerateSKU = function () {
                $scope.genSKU = true;
                ProductsBulk.updateSKU($scope.selected)
                    .then(function (results) {
                        $scope.genSKU = false;
                        $scope.selected = results;
                    })
                    .catch(function (err) {
                        $scope.genSKU = false;
                        console.log('[products.all.controller.js : 483]', 'errr', err);
                    })
            };

            function fetchProductDetails() {
                $scope.productsFetched = false;
                Promise.map(products, function (product) {
                    return $q(function (resolve, reject) {
                        $scope.fetchProduct(product._id)
                            .then(function (products) {
                                resolve(products[0])
                            })
                            .catch(function (err) {
                                reject(err);
                            })
                    })
                }).then(function (products) {
                    $scope.products = products;
                    $scope.productsFetched = true;
                })
                    .catch(function (err) {
                        console.log('Error fetching the products', err);
                    })
            }

            function fetchProduct(productId) {
                return RestManager.getResource("/products/admin/" + productId, "products")
            }

            $scope.fetchProductDetails();
        }])

})(angular);

/**
 * Created by kumardivyarajat on 21/03/17.
 */
angular.module("app.query", [])
    .controller("query.controller", ["$scope", "RestManager", function ($scope, RestManager) {

        $scope.selectedEntity = "";
        $scope.selected = [];

        $scope.fetchQuery = function () {
            RestManager.getResource("/query/models", "models")
                .then(function (models) {
                    $scope.entities = models;
                    console.log(models);
                })
                .catch(function (err) {
                    console.log(err);
                })
        };


        $scope.fetchOptions = function () {
            $scope.query = {
                sort: "",
                limit: 25,
                page: 1,
                filter: {},
                modelName: $scope.selectedEntity
            };
            $scope.fetchingOptions = true;
            console.log($scope.selectedEntity);
            RestManager.getResource("/query/model/" + $scope.selectedEntity, "model")
                .then(function (model) {
                    $scope.fetchingOptions = false;
                    $scope.keys = [];
                    _.forOwn(model[0], function (val, key) {
                        if (val.select !== false || key !== "id") {
                            $scope.keys.push(key);
                        }
                    });
                    // $scope.$$apply();
                    console.log(model);
                    $scope.fetchData();
                })
                .catch(function (err) {
                    $scope.fetchingOptions = false;
                    console.log(err);
                });
        };


        $scope.fetchData = function () {
            $scope.promise = RestManager.postResource("/query/data", $scope.query, "result", ["total"])
                .then(function (results) {
                    $scope.total = results.total;
                    $scope.documents = results.result;
                    console.log("Data", results);
                })
                .catch(function (err) {
                    console.log("Err in fetching data", err);
                })
        };

        $scope.capitalize = function (str) {
            return _.camelCase(str);
        };

        $scope.fetchQuery();
    }]);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 19/11/19, 12:03 AM
 *
 */

(function () {
    'use strict';

    angular.module('app.posts', []);

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 19/11/19, 12:13 AM
 *
 */

(function () {
    'use strict';

    AddPostController.$inject = ["$scope", "post", "RestManager", "$mdDialog", "Users", "Base"];
    angular.module('app.posts')
        .controller('add-posts.controller', AddPostController);

    function AddPostController($scope, post, RestManager, $mdDialog, Users, Base) {
        $scope.editingMode = !!post;
        $scope.post = post || {postType: 'image', products : []};
        $scope.mediaUrl = Base.getMediaUrl();

        $scope.savePost = savePost;
        $scope.cancel = cancel;
        $scope.updatePostType = updatePostType;
        $scope.userSelector = userSelector;
        $scope.productSelector = productSelector;

        function cancel() {
            $mdDialog.cancel();
        }

        function updatePostType() {

        }

        function userSelector(event) {
            Users.selectUserDialog(event, {roles: 'admin,influencer, designer', multiple: false, fields: 'name,role'})
                .then(function (user) {
                    console.log("add-posts.controller.js", "user", user);
                    $scope.post.user = user;
                })
                .catch(function (err) {

                })
        }

        function productSelector(event) {
            var products = $scope.post.products.map(function (product) {
                return {
                    productId: product._id,
                    productName: product.name,
                    image: product.featured_image,
                    quantity: 1
                }
            });
            $mdDialog.show({
                templateUrl: "app/modules/products/product-selector/products-selector.html",
                fullscreen: true,
                targetEvent: event,
                clickOutsideToClose: true,
                escapeToClose: true,
                multiple: true,
                locals: {
                    selectedProducts: products
                },
                controller: 'products-selector.controller'
            })
                .then(function (result) {
                    console.log("add-posts.controller.js", "pri", result);
                    if (result && result.products && result.products.length) {
                        $scope.post.products = result.products.map(function (product) {
                            return {
                                _id: product.productId,
                                name: product.productName,
                                featured_image: product.image
                            }
                        })
                    }
                    console.log("add-posts.controller.js", "pri", $scope.post.products);
                })
        }

        function savePost() {
            $scope.savingPost = true;
            var promise;
            if ($scope.editingMode) {
                promise = RestManager.putResource('/posts/' + $scope.post._id, $scope.post, 'posts')
            } else {
                promise = RestManager.postResource('/posts', $scope.post, 'posts')
            }
            promise
                .then(function (posts) {
                    $scope.savingPost = false;
                    $mdDialog.hide({post: posts[0]})
                })
                .catch(function (err) {
                    $scope.savingPost = false;
                })
        }
    }


})(angular);

(function () {
    'use strict';

    /**
     * @module app.pos
     */
    angular
        .module('app.pos', ['credit-cards', 'ngMaterialDatePicker']);

})(angular);

(function () {
    'use strict';


    angular.module('app.pos')
        .factory('salesHelper', salesHelper);

    salesHelper.$inject = ['$q'];

    function salesHelper($q) {

        var saleBySync = localforage.createInstance({
            driver: localforage.INDEXEDDB, // if you want to force a driver
            name: 'aaridaAdmin', // name of the database and prefix for your data
            version: 1.0, // version of the database, you shouldn't have to use this
            storeName: "saleBySync" // Should be alphanumeric, with underscores.
        });

        var service = {
            get: get,
            getAll: getAll,
            getAllByKeys: getAllByKeys,
            getAllKeys: getAllKeys,
            set: set,
            setItems: setItems,
            removeItem: removeItem,
            clear: clear
        };

        return service;

        /**
         * @memberOf salesHelper#
         * @param key
         * @returns {*}
         */
        function get(key) {
            var deferred = $q.defer();
            saleBySync.getItem(key).then(function (result) {
                deferred.resolve(result);
            });
            return deferred.promise;
        }

        /**
         * @memberOf salesHelper
         * @returns {*}
         */
        function getAll() {
            var deferred = $q.defer();
            saleBySync.getItems().then(function (result) {
                deferred.resolve(result);
            });
            return deferred.promise;
        }

        /**
         * @memberOf salesHelper
         * @returns {*}
         */
        function getAllByKeys() {
            var deferred = $q.defer();
            saleBySync.getItems().then(function (result) {
                deferred.resolve(result);
            });
            return deferred.promise;
        }

        /**
         * @memberOf salesHelper
         * @returns {*}
         */
        function getAllKeys() {
            var deferred = $q.defer();
            saleBySync.keys().then(function (result) {
                deferred.resolve(result);
            });
            return deferred.promise;
        }

        /**
         * @memberOf salesHelper
         * @param key
         * @param value
         * @returns {*}
         */
        function set(key, value) {
            var deferred = $q.defer();

            value = JSON.parse(JSON.stringify(value));

            saleBySync.setItem(key, value).then(function (result) {
                deferred.resolve(result);
            }).catch(function (err) {
                // This code runs if there were any errors
                console.log(err);
                deferred.reject(err);
            });


            return deferred.promise;
        }

        /**
         * @memberOf salesHelper
         * @param items
         * @returns {*}
         */
        function setItems(items) {
            var deferred = $q.defer();

            saleBySync.setItems(items).then(function (result) {
                deferred.resolve(result);
            }).catch(function (err) {
                // This code runs if there were any errors
                console.log(err);
                deferred.reject(err);
            });

            return deferred.promise;
        }

        /**
         * @memberOf salesHelper
         * @param key
         * @returns {*}
         */
        function removeItem(key) {
            var deferred = $q.defer();

            saleBySync.removeItem(key).then(function (result) {
                deferred.resolve(result);
            });

            return deferred.promise;
        }

        /**
         * @memberOf salesHelper
         * @returns {*}
         */
        function clear() {

            var deferred = $q.defer();

            saleBySync.clear().then(function (result) {
                deferred.resolve(result);
            });

            return deferred.promise;

        }
    }

})(angular);

(function () {
    'use strict';


    posHomeCtrl.$inject = ["$scope", "$stateParams", "RestManager", "$state"];
    angular.module('app.pos')
        .controller('pos.home.controller', posHomeCtrl);

    /** @ngInject **/
    function posHomeCtrl($scope, $stateParams, RestManager, $state) {

        $scope.orderUrl = "/order/admin/getOrders";
        $scope.query = {
            page: 1,
            limit: 25,
            orderBy: "-createdAt",
            search: '',
            filter: {
                saleChannel: 'pos',
                status: {$nin: ['cancelled']}
            }
        };

        $scope.showSearchBar = false;


        $scope.fetchPosOrders = fetchPosOrders;
        $scope.openOrderDetailsPage = openOrderDetailsPage;
        $scope.keyAction = keyAction;
        $scope.openSearchToolbar = openSearchToolbar;

        function openSearchToolbar() {
            $scope.showSearchBar = !$scope.showSearchBar;
            if(!$scope.showSearchBar) {
                $scope.query.search = '';
                $scope.fetchPosOrders();
            }
        }

        function keyAction(event) {
            if (event.which === 13)
                $scope.fetchPosOrders()
        }

        function fetchPosOrders() {
            // var posOrders = {};
            if ($scope.query.search && $scope.query.search.length <= 2) {
                return;
            } else if ($scope.query.search) {
                $scope.query.filter.$or = [
                    {
                        orderNumber: {$regex: $scope.query.search, $options: 'ig'}
                    },
                    {
                        'fullUser.name': {$regex: $scope.query.search, $options: 'ig'}
                    },
                    {
                        'fullUser.mobile': {$regex: $scope.query.search, $options: 'ig'}
                    }
                ]
            } else {
                delete $scope.query.filter.$or;
            }
            $scope.promise = RestManager.postResource($scope.orderUrl, $scope.query, "orders", ["total"]);

            $scope.promise
                .then(function (result) {
                    console.log("orders", result);
                    $scope.orders = result.orders.map(function (order) {
                        if (order.status === 'incomplete' && order.saleChannel === 'pos') {
                            order.status = 'parked';
                        }
                        return order;
                    });
                    $scope.total = result.total;
                    console.log($scope.orders);

                })
                .catch(function (err) {
                    console.log("err", err);
                });
        }

        function openOrderDetailsPage(order) {
            if (order.status === 'parked' || order.hasPendingAmount) {
                $state.go("app.pos.edit", {
                    orderNumber: order.orderNumber
                });
            } else {
                $state.go("app.orders.details", {
                    orderId: order._id,
                    backState: "app.pos.home"
                });
            }
        }

        $scope.fetchPosOrders();
    }
})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 27/8/19 3:44 PM
 *
 */

(function () {
    'use strict';

    PosCartController.$inject = ["$scope", "RestManager", "$stateParams", "$q", "Utils", "$mdToast", "CriticalUpdateConfirmation", "Base", "$http"];
    angular.module('app.pos')
        .controller('pos.cart.controller', PosCartController);

    /**
     * @ngInject
     * @param $scope
     * @param RestManager
     * @param $stateParams
     * @param $q
     * @param Utils
     * @constructor
     */
    function PosCartController($scope, RestManager, $stateParams, $q, Utils, $mdToast, CriticalUpdateConfirmation, Base, $http) {
        $scope.userId = $stateParams.userId;
        $scope.selectedItem = null;
        $scope.searchText = null;
        $scope.cart = null;
        $scope.products = [];
        $scope.giftCard = {};
        $scope.coupon = {};
        $scope.applyingGiftCard = false;
        $scope.applyingCouponCode = false;
        $scope.init = init;
        $scope.fetchCart = fetchCart;
        $scope.searchProducts = searchProducts;
        $scope.addToCart = addToCart;
        $scope.removeProductFromCart = removeProductFromCart;
        $scope.applyGiftCard = applyGiftCard;
        $scope.removeGiftCard = removeGiftCard;
        $scope.applyCouponCode = applyCouponCode;
        $scope.removeCouponCode = removeCouponCode;
        $scope.calculateQuantity = calculateQuantity;

        // $scope.addProductToCart = addProductToCart;


        function init() {
            if ($scope.userId) {
                $scope.fetchCart($scope.userId);
            }
        }

        function fetchCart(userId) {
            $scope.loadingCart = true;
            RestManager.getResource('/cart/admin/' + userId, 'cart')
                .then(function (carts) {
                    $scope.cart = carts[0];
                    $scope.cart.products = $scope.cart.products.map(function (productData) {
                        productData.selectedVariation = Utils.getVariationValue(productData.variation);
                        return productData;
                    });
                    $scope.cart.coupon.forEach(function (c) {
                        if (c) {
                            console.log("pos.cart.controller.js", "C", c);
                            $scope.couponExist = true;
                        } else {
                            $scope.couponExist = false;
                        }
                    })
                    console.log("pos.cart.controller.js", "carts", carts);
                    $scope.loadingCart = false;
                })
                .catch(function (err) {
                    $scope.loadingCart = false;
                })
        }

        function calculateQuantity(mode, index, product) {
            console.log("pos.cart.controller.js", "calculateQuantity", product.quantity);
            switch (mode) {
                case 'add':
                    product.quantity = product.quantity + 1;
                    break;
                case 'remove':
                    if (product.quantity > 1) {
                        product.quantity = product.quantity - 1;
                        break;
                    }
            }
            console.log("pos.cart.controller.js", "calculateQuantity", product.quantity);
            RestManager.putResource('/cart', {
                product: product.product._id,
                quantity: product.quantity,
                variation: product.variation._id
            }, 'cart')
                .then(function (res) {
                    console.log("pos.cart.controller.js", "res", res);
                })
                .catch(function (err) {
                    $mdToast.showSimple("Error in changing quantity of the product: " + err.message);
                })

        }

        // function addProductToCart(product){
        //     console.log("pos.cart.controller.js", "addProductToCart", product);
        //
        // }

        function addToCart(product) {
            console.log("pos.cart.controller.js", "addToCart", product);
            RestManager.postResource('/cart', {
                product: product._id,
                quantity: product.quantity,
                variation: product.variation._id,
                user: $scope.cart.user._id
            }, 'cart')
                .then(function (res) {
                    // if(res.length){
                    //     $scope.added = true;
                    // }
                    console.log("pos.cart.controller.js", "ADDED TO CART", res);
                    $scope.cart = res[0];
                })
                .catch(function (err) {
                    $mdToast.showSimple("Error in adding product to cart" + err.message)
                })
        }

        function removeProductFromCart(product, ev, i) {
            console.log("pos.cart.controller.js", "removeProductFromCart", product);

            CriticalUpdateConfirmation.showDialog({
                targetEvent: ev,
                title: 'Remove Product',
                description: 'You opt to remove the product. Do you want to continue?',
                infoMessage: 'Removing  the product will  remove it from user cart',
                inputValidatorString: 'Delete Product',
                confirmText: 'Delete'
            })
                .then(function (result) {
                    if (result) {
                        console.log(result, product, i);
                        $http.delete(Base.getBaseUrl() + "/cart", {
                            data: {product: product.product._id, variation: product.variation._id},
                            headers: {"content-type": "application/json"}
                        }).then(function (response) {
                            //
                            if (response.data.code === 200) {
                                $scope.cart = response.data.message.cart[0];
                            } else {
                                //
                                var err = new Error();
                                err.code = response.data.code;
                                err.message = response.data.message.error;
                            }
                        }).catch(function (err) {
                            console.log("pos.cart.controller.js", "Error", err);
                        });
                    }
                })
                .catch(function (err) {
                    $mdToast.showSimple("Error in removing product from cart" + err.message);
                });
        }

        function applyGiftCard() {
            $scope.applyingGiftCard = true
            console.log("pos.cart.controller.js", "applyGiftCard", $scope.giftCard.code);
            RestManager.putResource('/cart/applyGiftCard', {
                card: $scope.giftCard.code,
                user: $scope.cart.user._id
            }, 'cart')
                .then(function (res) {
                    console.log("pos.cart.controller.js", "RES", res);
                    $scope.applyingGiftCard = false;
                    if (res.length) {
                        $scope.cart = res[0];
                    } else {
                        //
                        var err = new Error();
                        err.code = res.data.code;
                        err.message = res.data.message.error;
                    }
                })
                .catch(function (err) {
                    $scope.applyingGiftCard = false;
                    console.log("pos.cart.controller.js", "Error", err);
                    $mdToast.showSimple("Error in applying giftCard: " + err.message);
                });
        }

        function removeGiftCard(giftCard) {
            console.log("pos.cart.controller.js", "removeGiftCard", giftCard);
            RestManager.putResource('/cart/removeGiftCard', {
                card: giftCard,
                user: $scope.cart.user._id
            }, 'cart')
                .then(function (res) {
                    if (res.length) {
                        $scope.cart = res[0];
                    } else {
                        //
                        var err = new Error();
                        err.code = res.data.code;
                        err.message = res.data.message.error;
                    }
                    $scope.cart.giftCard = null;
                })
                .catch(function (err) {
                    $mdToast.showSimple("Error in removing giftCard: " + err.message);
                })
        }

        function applyCouponCode() {
            $scope.applyingCouponCode = true;
            console.log("pos.cart.controller.js", "applyCouponCode", $scope.coupon.code);
            RestManager.putResource('/cart/applyCoupon', {
                coupon: $scope.coupon.code,
                user: $scope.cart.user._id
            }, 'cart')
                .then(function (res) {
                    console.log("pos.cart.controller.js", "RES", res);
                    $scope.applyingCouponCode = false;
                    if (res.length) {
                        $scope.cart = res[0];
                    } else {
                        //
                        var err = new Error();
                        err.code = res.data.code;
                        err.message = res.data.message.error;
                    }
                })
                .catch(function (err) {
                    $scope.applyingCouponCode = false;
                    $mdToast.showSimple("Error in applying coupon: " + err.message);
                });

        }

        function removeCouponCode(coupon) {
            console.log("pos.cart.controller.js", "removeCouponCode", coupon);
            RestManager.putResource('/cart/removeCoupon', {
                coupon: coupon,
                user: $scope.cart.user._id
            }, 'cart')
                .then(function (res) {
                    if (res.length) {
                        $scope.cart = res[0];
                    } else {
                        //
                        var err = new Error();
                        err.code = res.data.code;
                        err.message = res.data.message.error;
                    }
                })
                .catch(function (err) {
                    $mdToast.showSimple("Error in removing coupon: " + err.message)
                })

        }

        function searchProducts(searchText) {
            var size = '';
            // Checks if the lookup text is performing the search based on our new
            // SKU_SIZE combo barcode standard
            if (/^ADR\w{3}\d{4}/.test(searchText)) {
                size = searchText.slice(10);
                searchText = searchText.slice(0, 10);
            }
            // Sets the query parameters to be sent to the backend
            var filters = {
                orderBy: '-updatedAt',
                limit: 5,
                page: 1,
                showAll: {
                    type: true,
                    published: true,
                    featured: true
                },
                searchTerm: searchText,
                populate: 'variations sizeChart'

            };

            return $q(function (resolve, reject) {
                // Fetches the data from the backend
                RestManager.postResource("/products/admin", filters, "products", ["total"])
                    .then(function (result) {
                        var products = [];
                        // Transforms the data to show one entry in the autocomplete box
                        // for each variation of a product returned by the backend
                        result.products.forEach(function (product) {
                            product.variations.forEach(function (variation) {
                                var p = {};
                                angular.copy(product, p);
                                p.selectedVariation = Utils.getVariationValue(variation);
                                p.variation = variation;
                                // p.selectedVariationId =
                                p.sku = p.sku + p.selectedVariation;
                                p.discountValue = 0;
                                if (p.mrp && p.price && (p.mrp > p.price)) {
                                    p.discountAmount = p.mrp - p.price;
                                    p.discountValue = parseFloat((((p.discountAmount) / p.mrp) * 100).toFixed(2));
                                }
                                p.discountType = 'percent';
                                p.quantity = 1;

                                products.push(p);
                            });

                            if (size) {
                                products = products.filter(function (p) {
                                    return p.selectedVariation === size;
                                })
                            }
                        });
                        resolve(products);
                    })
                    .catch(function (err) {
                        console.log(err);
                        $scope.fetchingProducts = false;
                        reject(err);
                    });
            })
        }


        $scope.init();
    }

})(angular);

(function () {
        'use strict';


        posAddCtrl.$inject = ["$scope", "$stateParams", "RestManager", "$mdSidenav", "$q", "AuthManager", "Base", "$state", "$interval", "$mdMedia", "Utils", "salesHelper", "$mdDialog", "$mdToast", "Scanner", "$timeout"];
        angular.module('app.pos')
            .controller('pos.add.controller', posAddCtrl);

        // /**
        //  *
        //  * @typedef {object} posAddCtrlScope
        //  * @property promise
        //  * @property fetchingProducts
        //  * @property total
        //  * @property productUrl
        //  * @property customerUrl
        //  * @property newOrderUrl
        //  * @property selectedItem
        //  * @property searchText
        //  * @property selectedCustomerItem
        //  * @property customersearchText
        //  * @property selectedSpecsItem
        //  * @property selectedSpecsItemIndex
        //  * @property measurements
        //  * @property savingOrder
        //  * @property offline
        //  * @property newCustomer
        //  * @property orderData
        //  * @property openSidebar {function}
        //  * @property closeSidebar {function}
        //  * @property fetchProducts {function}
        //  * @property fetchCustomers {function}
        //  * @property showSpecs {function}
        //  * @property query {function}
        //  * @property customerQuery {function}
        //  * @property addToCart {function}
        //  * @property removeFromCart {function}
        //  * @property getVariationValue {function}
        //  * @property selectVariationForLineItem {function}
        //  * @property updateQuantity {function}
        //  * @property addCustomerToOrder {function}
        //  * @property removeCustomer {function}
        //  * @property changeDiscountType {function}
        //  * @property applyDiscount {function}
        //  * @property calculateOrderPrices {function}
        //  * @property applyOrderDiscount {function}
        //  * @property changeOrderDiscountType {function}
        //  * @property saveCustomer {function}
        //  * @property btnValue {function}
        //  * @property generateDefaultMeasurements {function}
        //  * @property flushToLocalStorage {function}
        //  * @property restoreFromLocalStorage {function}
        //  * @property sanitizeNumber {function}
        //  * @property registerOfflineListener {function}
        //  * @property deRegisterOfflineListener {function}
        //  * @property clearSession {function}
        //  * @property createNewOrder {function}
        //  * @property openInvoicePrintPage {function}
        //  * @property prepareOrderSummary {function}
        //  * @property recalculateTenderedAmounts {function}
        //  * @property $on {event}
        //  */


        /**
         * @ngInject
         * @memberOf app.pos
         * @ngDoc controller
         * @name posAddCtrl
         * @param $scope
         * @param $stateParams
         * @param RestManager
         * @param $mdSidenav
         * @param $q
         * @param AuthManager
         * @param Base
         * @param $state
         * @param $interval
         * @param $mdMedia
         * @param $state
         * @param $interval
         * @param $mdMedia
         * @param Utils
         * @param salesHelper
         * @param $mdDialog
         * @param $mdToast
         * @param Scanner
         * @param $timeout
         * @param Scanner
         * @param $timeout
         */
        function posAddCtrl($scope, $stateParams, RestManager, $mdSidenav, $q, AuthManager, Base, $state, $interval, $mdMedia,
                            Utils, salesHelper, $mdDialog, $mdToast, Scanner, $timeout) {


            $scope.promise = '';
            $scope.fetchingProducts = false;
            $scope.editMode = false;
            $scope.savingOrder = false;
            $scope.total = 0;
            $scope.backDateOrder = $stateParams.backDateOrder === true || $stateParams.backDateOrder === 'true';
            $scope.productUrl = "/products/admin";
            $scope.customerUrl = "/users/admin/create";
            $scope.newOrderUrl = $scope.backDateOrder ? "/order/pos/backDate" : "/order/pos";
            $scope.selectedItem = '';
            $scope.searchText = '';
            $scope.selectedCustomerItem = '';
            $scope.customersearchText = '';
            $scope.selectedSpecsItem = '';
            $scope.selectedSpecsItemIndex = '';
            $scope.measurements = [];
            $scope.offline = !navigator.onLine;
            $scope.heights = ["4.6", "4.7", "4.8", "4.9", "4.10", "4.11", "5.0", "5.1", "5.2", "5.3", "5.4", "5.5", "5.6", "5.7", "5.8", "5.9", "5.10", "5.11", "6.0", "6.1", "6.2", "6.3", "6.4", "6.5", "6.6", "6.7", "6.8", "6.9", "6.10", "6.11"];
            $scope.couponErrorMessage = '';
            $scope.couponCode = '';
            $scope.currentUser = AuthManager.getCurrentUser();
            $scope.creator = {};

            console.log('Backrdta', $scope.backDateOrder, $stateParams.backDateOrder);
            console.log('Curremt user', $scope.currentUser);

            $scope.newCustomer = {
                flags: {
                    "onboardUser": true
                },
                status: 1,
                points: 0,
                mobile: '',
                email: '',
                name: ''
            };

            $scope.timer = {
                startedAt: null,
                completedAt: null,
                totalTime: 0
            };

            $scope.orderData = {
                user: '',
                products: [],
                subtotal: 0,
                cashAmountTendered: 0,
                cardAmountTendered: 0,
                giftCardAmountTendered: 0,
                storeCreditAmountTendered: 0,
                taxAmount: 0,
                total: 0,
                discount: 0,
                discountValue: 0,
                coupon: '',
                mrp: 0,
                discountType: 'percent',
                createdDate: new Date(),
                paymentMode: 1,
                payment: {
                    cardAmount: undefined,
                    cardNumber: undefined
                },
                orderStatus: '',
                sessionTimes: [],

            };

            $scope.lineItems = [
                {
                    reviews: {
                        isReviewDone: false
                    }

                }
            ];

            $scope.isSmall = !$mdMedia('gt-sm');

            $interval(function () {
                $scope.isSmall = !$mdMedia('gt-sm');
            }, 5000);

            // Helper function to open sidebars
            $scope.openSidebar = openSidebar;
            // Helper function to close sidebars
            $scope.closeSidebar = closeSidebar;
            // Function to fetch the product based on search query
            $scope.fetchProducts = fetchProducts;
            // Function to fetch customer based on search query
            $scope.fetchCustomers = fetchCustomers;
            // Opens product sidebar
            $scope.showSpecs = showSpecs;
            // Forward the request to fetchProducts()
            $scope.query = query;
            // Forward the request to fetchCustomers()
            $scope.customerQuery = customerQuery;
            // Add products to cart
            $scope.addToCart = addToCart;
            // Remove Products from cart
            $scope.removeFromCart = removeFromCart;
            //Gets the current variation value
            $scope.getVariationValue = getVariationValue;
            //Select the clicked variation from the autocomplete dropdown
            $scope.selectVariationForLineItem = selectVariationForLineItem;
            //Updates the product quantity in cart
            $scope.updateQuantity = updateQuantity;
            //Adds customers to order
            $scope.addCustomerToOrder = addCustomerToOrder;
            //Removes customers from order
            $scope.removeCustomer = removeCustomer;
            //Switch discount type from amount to percentage discount and vice-versa on lineItem level
            $scope.changeDiscountType = changeDiscountType;
            //Applies the discount on lineItem level
            $scope.applyDiscount = applyDiscount;
            //Calculate the total Order value
            $scope.calculateOrderPrices = calculateOrderPrices;
            //Applies the discount on order level
            $scope.applyOrderDiscount = applyOrderDiscount;
            //Switch discount type from amount to percentage discount and vice-versa on order level
            $scope.changeOrderDiscountType = changeOrderDiscountType;
            //Save a new customer in the backend
            $scope.saveCustomer = saveCustomer;
            //*******Unused function
            $scope.btnValue = btnValue;
            //Sets the measurements for a lineItem
            $scope.generateDefaultMeasurements = generateDefaultMeasurements;
            //Saves the data to localStorage
            $scope.flushToLocalStorage = flushToLocalStorage;
            //Restores the localStorage data if a valid order session is found
            $scope.restoreFromLocalStorage = restoreFromLocalStorage;
            //Helper to sanitize number
            $scope.sanitizeNumber = sanitizeNumber;
            //Listens for offine events
            $scope.registerOfflineListener = registerOfflineListener;
            //Stops listening for offine events
            $scope.deRegisterOfflineListener = deRegisterOfflineListener;
            //Clears the in progress order session in index db
            $scope.clearSession = clearSession;
            //Creates a new order
            $scope.createNewOrder = createNewOrder;
            //Opens the  model to print Invoice Page
            $scope.openInvoicePrintPage = openInvoicePrintPage;
            //Creates the order summary when place order button is clicked
            $scope.prepareOrderSummary = prepareOrderSummary;
            //Calculate the total amount paid using card and cash
            $scope.recalculateTenderedAmounts = recalculateTenderedAmounts;
            //Emails the invoice to customer
            $scope.emailInvoice = emailInvoice;
            //Clear the index db to take new order, closes the sidebar
            $scope.prepareNewSale = prepareNewSale;
            //Parks existing order
            $scope.parkOrder = parkOrder;
            //Maps the data in order to save it in backend
            $scope.prepareOrderData = prepareOrderData;
            //Populate the data when parked order is loaded
            $scope.populateData = populateData;
            //Fetch the single product in case of park order
            $scope.populateDataItem = populateDataItem;
            //Opens the scanner dialog
            $scope.openScannerDialog = openScannerDialog;
            //Plays an audio file when scan is complete
            $scope.playAudio = playAudio;
            //Valdates the coupon
            $scope.checkCoupon = checkCoupon;
            //Fetch all the eligible coupons
            $scope.getEligibleCoupons = getEligibleCoupons;
            //Updates the session timer
            $scope.updateSessionTimer = updateSessionTimer;
            //Fetch users based on query
            $scope.fetchUsers = fetchUsers;
            //
            $scope.updateCreatedBy = updateCreatedBy;
            //Fetch all the Warehouses
            $scope.fetchWarehouses = fetchWarehouses;
            //Attatch the selected warehouse to order
            $scope.setWarehouse = setWarehouse;
            //Opens the dialog to customise the product
            $scope.openCustomisableProductBuilderDialog = openCustomisableProductBuilderDialog;
            //Saves the customisable options in products
            $scope.editProduct = editProduct;
            //Fetches the size chart
            $scope.fetchSizeCharts = fetchSizeCharts;
            //Select the customer on click from dropdown
            $scope.selectSuggestedCustomer = selectSuggestedCustomer;

            //$scope.populateOrderById = populateOrderById;


            /**
             * @function deRegisterOfflineListener
             * @description Deregisters the offline event listener when the component is destroyed
             * @memberOf posAddCtrl
             */
            function deRegisterOfflineListener() {
                window.removeEventListener('offline', function (ev) {
                })
            }

            /**
             * @function registerOfflineListener
             * @description Registers the offline event listener when the component is initialized.
             * Changes the offline status based on the `event.type`.
             * @example <caption>Example usage of method1.</caption>
             *
             function handleStatus(event) {
                console.log(event);
                $scope.offline = (event.type === 'offline');
                console.log($scope.offline);
             }

             window.addEventListener('offline', handleStatus);
             window.addEventListener('online', handleStatus);
             * @memberOf posAddCtrl
             */
            function registerOfflineListener() {

                function handleStatus(event) {
                    $scope.offline = (event.type === 'offline');
                }

                window.addEventListener('offline', handleStatus);
                window.addEventListener('online', handleStatus);
            }

            /**
             * @function openSidebar
             * @memberOf posAddCtrl
             * @description Opens the sidebar for the componentId passed to the function
             * @param componentId
             */
            function openSidebar(componentId) {
                if ($mdSidenav(componentId).isOpen()) {
                    $scope.closeSidebar(componentId)
                        .then(function () {
                            return $mdSidenav(componentId).open();
                        })
                        .then(function () {

                        });
                } else {
                    $mdSidenav(componentId).open()
                        .then(function () {

                        });
                }

                if (componentId === 'coupons') {
                    $scope.getEligibleCoupons()
                } else if (componentId === 'customers') {
                    console.log('Search' + $scope.customersearchText);
                    $scope.newCustomer.mobile = $scope.customersearchText;
                    var elem = document.querySelector('.md-not-found');
                    if (elem) {
                        elem.classList.add('ng-hide')
                    }
                    console.log(elem);

                }
            }

            /**
             * @function closeSidebar
             * @memberOf posAddCtrl
             * @description Closes the sidebar for the componentId passed to the function
             * @param componentId {string} The id of the registered sidenav component
             */
            function closeSidebar(componentId) {
                $mdSidenav(componentId).close()
                    .then(function () {
                        switch (componentId) {
                            case 'customers' :
                                console.log('Customers closed');
                                break;

                            case 'product-specs':
                                console.log('Product Specs closed');
                                break;
                        }
                    })
            }


            /**
             * @function query
             * @memberOf posAddCtrl
             * @description Forwards the call to the fetchProducts method in order to create a standard API
             * @param searchText {String} The string of product to search for
             */
            function query(searchText) {
                return $scope.fetchProducts(searchText)
            }


            /**
             * @function customerQuery
             * @memberOf posAddCtrl
             * @description Forwards the call to the fetchCustomers method in order to create a standard API
             * @param searchText {String} The string of customer to search for
             */
            function customerQuery(searchText) {
                $scope.customersearchText = searchText;
                return $scope.fetchCustomers(searchText)
            }


            /**
             * @function fetchCustomers
             * @memberOf posAddCtrl
             * @description Fetches the customer based on the query string provided in the auto complete box.
             * @param searchText {string} The text to query for
             * @returns {Promise} The list of customers matching the search criteria
             */
            function fetchCustomers(searchText) {
                var query = {
                    order: 'name',
                    limit: 25,
                    page: 1,
                    searchTerm: searchText
                };

                return $q(function (resolve, reject) {
                    RestManager.postResource("/users/admin", query, "users")
                        .then(resolve)
                        .catch(function (err) {
                            console.log("err", err);
                            reject(err);
                        });
                })

            }

            /**
             * @function fetchProducts
             * @description Function to fetch the products from the based on the search text typed in the box
             * Also, it is responsible for transforming the data to adapt the new barcode format
             * used in our retail stores.
             * @memberOf posAddCtrl
             * @returns {Promise} The list of products matching the search criteria
             * @param {string} searchText The text to query for
             */
            function fetchProducts(searchText) {
                var size = '';
                // Checks if the lookup text is performing the search based on our new
                // SKU_SIZE combo barcode standard
                if (/^ADR\w{3}\d{4}/.test(searchText)) {
                    size = searchText.slice(10);
                    searchText = searchText.slice(0, 10);
                }
                // Sets the query parameters to be sent to the backend
                var filters = {
                    orderBy: '-updatedAt',
                    limit: 5,
                    page: 1,
                    showAll: {
                        type: true,
                        published: true,
                        featured: true
                    },
                    searchTerm: searchText,
                    populate: 'variations sizeChart'

                };

                return $q(function (resolve, reject) {
                    // Fetches the data from the backend
                    RestManager.postResource($scope.productUrl, filters, "products", ["total"])
                        .then(function (result) {
                            var products = [];

                            // Transforms the data to show one entry in the autocomplete box
                            // for each variation of a product returned by the backend
                            result.products.forEach(function (product) {
                                product.variations.forEach(function (variation) {
                                    var p = {};
                                    angular.copy(product, p);
                                    p.selectedVariation = Utils.getVariationValue(variation);
                                    p.variation = variation;
                                    // p.selectedVariationId =
                                    p.sku = p.sku + p.selectedVariation;
                                    p.discountValue = 0;
                                    if (p.mrp && p.price && (p.mrp > p.price)) {
                                        p.discountAmount = p.mrp - p.price;
                                        p.discountValue = parseFloat((((p.discountAmount) / p.mrp) * 100).toFixed(2));
                                    }
                                    p.discountType = 'percent';
                                    p.quantity = 1;

                                    products.push(p);
                                });

                                if (size) {
                                    products = products.filter(function (p) {
                                        return p.selectedVariation === size;
                                    })
                                }
                            });
                            resolve(products);
                        })
                        .catch(function (err) {
                            console.log(err);
                            $scope.fetchingProducts = false;
                            reject(err);
                        });
                })
            }


            /**
             * @function saveCustomer
             * @description Saves the customer in the backend and then sets it to the orderData.
             * Also, calls the posAddCtrl#flushToLocalStorage method
             * @memberOf posAddCtrl
             */
            function saveCustomer() {
                $scope.savingCustomer = true;
                RestManager.postResource($scope.customerUrl, $scope.newCustomer, "user")
                    .then(function (result) {
                        $scope.orderData.user = result[0];
                        $scope.closeSidebar('customers');
                        $scope.flushToLocalStorage();
                        $scope.savingCustomer = false
                    })
                    .catch(function (err) {
                        $scope.savingCustomer = false

                    })
            }


            /**
             *
             * @function parkOrder
             * @description Park/Hold this order in backend. Every property value remains the same,
             * except the orderStatus. It is saved as 'incomplete'
             * @memberOf posAddCtrl
             * @Summary Parks the order in backend
             */

            function parkOrder() {

                var parkData = {};
                angular.copy($scope.orderData, parkData);
                $scope.parkingOrder = true;
                parkData = $scope.prepareOrderData(parkData, 'park');
                console.log('parkData', parkData);
                RestManager.postResource($scope.newOrderUrl, parkData, "orders")
                    .then(function (result) {
                        $scope.parkingOrder = false;
                        $scope.orderData = parkData;
                        $scope.openSidebar('order-success');
                    })
                    .catch(function (err) {
                        $scope.parkedOrder = false;
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(err.message || 'Error saving data')
                                .position("bottom right")
                                .capsule(false)
                                .hideDelay(3000)
                        )
                    });
            }


            /**
             *
             * @param variation
             * @return {string} The string value of the variation passed to the function
             * @function getVariationValue
             * @memberOf posAddCtrl
             * @description Gets the value of a variation using the helper method getVariationValue in Utils.js
             */
            function getVariationValue(variation) {
                return Utils.getVariationValue(variation);
            }


            /**
             * @description Responsible for updating the quantity of the line item.
             * @function updateQuantity
             * @param context {string} The context of the update
             * @memberOf posAddCtrl
             */
            function updateQuantity(context) {
                switch (context) {
                    case 'minus':
                        if ($scope.selectedSpecsItem.quantity !== 0.25) {
                            $scope.selectedSpecsItem.quantity = $scope.selectedSpecsItem.quantity - 0.25;
                        } else {
                            $scope.removeFromCart();
                        }
                        break;

                    case 'add':
                        $scope.selectedSpecsItem.quantity = $scope.selectedSpecsItem.quantity + 0.25;
                        break;

                    case 'remove' :
                        $scope.orderData.products.splice($scope.selectedSpecsItemIndex, 1);
                        $scope.closeSidebar('product-specs');
                        $scope.selectedSpecsItemIndex = '';
                        $scope.selectedSpecsItem = '';
                        break;
                }
                $scope.calculateOrderPrices();
                $scope.applyOrderDiscount();
            }

            /**
             * @function selectVariationForLineItem
             * @description Sets the variation as the selected variation for the line items.
             * Also, calls the function generateDefaultMeasurements to generate the measurements and
             * then calls the function flushToLocalStorage to sync the data in indexedb.
             * @param product {Product} The product
             * @param variation
             * @memberOf posAddCtrl
             */
            function selectVariationForLineItem(product, variation) {
                // Wrong way of doing this
                $scope.selectedSpecsItem.selectedVariation = Utils.getVariationValue(variation);
                $scope.selectedSpecsItem.variation = variation;
                $scope.generateDefaultMeasurements(product);
                $scope.flushToLocalStorage();
            }

            /**
             * @description Function to open Products Specifications Side-Bar
             * @param product {Product} The product
             * @param index {Number} The index of the item
             * @function showSpecs
             * @memberOf posAddCtrl
             */
            function showSpecs(product, index) {
                $scope.openSidebar('product-specs');
                $scope.selectedSpecsItem = product;
                $scope.selectedSpecsItemIndex = index;
                // angular.copy(product, $scope.selectedSpecsItem);
            }


            /**
             * @memberOf posAddCtrl
             * @function addToCart
             * @param product {Product} Product to add to cart
             * @description Adds the product as a line item to the orderData.
             * Triggers price re-computations and Measurement generation logic.
             * Later, calls `flushToLocalStorage` to sync the changes.
             */
            function addToCart(product) {
                console.log("pos.add.controller.js", "addToCart", product);
                if (product) {
                    $scope.searchText = '';
                    // product.sku = product.sku.slice(0,10);
                    if (!$scope.orderData.products.length) {
                        console.log('Started the timer');
                        $scope.timer.startedAt = moment().toString();
                    }
                    var p = {};
                    angular.copy(product, p);
                    $scope.orderData.products.push(p);
                    $scope.calculateOrderPrices();
                    $scope.generateDefaultMeasurements(p);
                    $scope.applyOrderDiscount();
                    $scope.flushToLocalStorage();

                }
            }

            /**
             * @memberOf posAddCtrl
             * @function removeFromCart
             * @description Removes a product from the orderData
             */
            function removeFromCart() {
                $scope.orderData.products.splice($scope.selectedSpecsItemIndex, 1);
                $scope.closeSidebar('product-specs');
                $scope.selectedSpecsItemIndex = '';
                $scope.selectedSpecsItem = '';
                $scope.applyOrderDiscount();
            }

            function fetchSizeCharts() {
                if (!$scope.sizeCharts) {
                    return new Promise(function (resolve, reject) {
                        RestManager.getResource("/settings/size_charts", 'size_charts')
                            .then(function (sizeCharts) {
                                $scope.sizeCharts = sizeCharts.map(function (chart) {
                                    var measurements = [];
                                    chart.values.values.charts.forEach(function (sizeValue) {
                                        sizeValue.values.forEach(function (val) {
                                            var data = _.findIndex(measurements, function (measurement) {
                                                return measurement.key === val.key;
                                            });
                                            if (data !== -1) {
                                                measurements[data].values.push({key: sizeValue.key, value: val.value})
                                            } else {
                                                measurements.push({
                                                    key: val.key,
                                                    values: [{key: sizeValue.key, value: val.value}]
                                                });
                                            }
                                        })
                                    });
                                    return {name: chart.values.values.name, measurements: measurements, id: chart._id};
                                });
                            })
                            .catch(reject)
                    })
                } else {
                    return $scope.sizeCharts;
                }
            }



            /**
             * @memberOf posAddCtrl
             * @function generateDefaultMeasurements
             * @description Generates the measurements to take the input for.
             * @param product {Product} The Product
             */
            function generateDefaultMeasurements(product) {
                if (product.sizeChart) {
                    product.measurements = _.chain(product.sizeChart.values.values.charts)
                        .uniqBy(function (sizeChart) {
                            return sizeChart.key;
                        })
                        .map(function (value) {
                            return {
                                key: value.key,
                                value: value.values[0].value
                            };
                        })
                        .tap(function (d) {
                            console.log(d)
                        })
                        .value();
                    product.measurements.push({key: "HEIGHT", value: ''})
                } else {
                    var sizeChart = _.find($scope.sizeCharts, function (chart) {
                        return chart.name === 'Customisation Size Chart';
                    });
                    if(sizeChart) {
                        var measurement = _.find(sizeChart.measurements, function (m) {
                            return m.key === product.selectedVariation;
                        })
                        product.measurements = (measurement && measurement.values) ||  [

                            {
                                key: "BUST",
                                value: 0
                            },
                            {
                                key: "HIP",
                                value: 0
                            },
                            {
                                key: "SHOULDER",
                                value: 0
                            },

                            {
                                key: "WAIST",
                                value: 0
                            },
                            {
                                key: "FULL LENGTH",
                                value: 0
                            },
                            {
                                key: "HEIGHT",
                                value: ''
                            }];
                    } else {
                        product.measurements = [

                            {
                                key: "BUST",
                                value: 0
                            },
                            {
                                key: "HIP",
                                value: 0
                            },
                            {
                                key: "SHOULDER",
                                value: 0
                            },

                            {
                                key: "WAIST",
                                value: 0
                            },
                            {
                                key: "FULL LENGTH",
                                value: 0
                            },
                            {
                                key: "HEIGHT",
                                value: ''
                            }]
                    }
                }
            }

            /**
             * @memberOf posAddCtrl
             * @param customer
             * @description Assigns a customer to the orderData.
             * @function addCustomerToOrder
             */
            function addCustomerToOrder(customer) {
                if (customer) {
                    $scope.customersearchText = '';
                    $scope.orderData.user = customer;
                    $scope.flushToLocalStorage();
                }
            }

            /**
             * @memberOf posAddCtrl
             * @function removeCustomer
             * @description Unsets the customer from the order data. Then calls the function `flushToLocalStorage`
             * to push the latest changes to indexedb.
             */
            function removeCustomer() {
                $scope.orderData.user = '';
                $scope.flushToLocalStorage();
            }

            /**
             * @memberOf posAddCtrl
             * @param type {string} Discount type
             * @function changeDiscountType
             * @description Changes the discount type of the selected product.
             */
            function changeDiscountType(type) {
                $scope.selectedSpecsItem.discountType = type;
            }

            /**
             * @memberOf posAddCtrl
             * @description Applies the discount at the product level and then calls the functions which recompute the
             * order total and discount. In the end, it calls the function `flushToLocalStorage` to sync the order data.
             * @function applyDiscount
             */
            function applyDiscount() {
                if ($scope.selectedSpecsItem.discountType === 'percent') {
                    $scope.selectedSpecsItem.discountAmount = $scope.selectedSpecsItem.mrp * ($scope.selectedSpecsItem.discountValue / 100);
                } else {
                    $scope.selectedSpecsItem.discountAmount = $scope.selectedSpecsItem.discountValue;
                }
                $scope.selectedSpecsItem.price = Math.round($scope.selectedSpecsItem.mrp - $scope.selectedSpecsItem.discountAmount);
                $scope.calculateOrderPrices();
                $scope.applyOrderDiscount();
                $scope.flushToLocalStorage();
            }

            //
            /**
             * @memberOf posAddCtrl
             * @description Calculates the order subtotal amount, tax, total, discounts.
             * @function calculateOrderPrices
             */
            function calculateOrderPrices() {
                var fSubtotal = 0, fTax = 0, fTotal = 0, fDiscount = 0, taxSlabs = [];
                $scope.orderData.products = $scope.orderData.products.map(function (product) {
                        if (product.price < 1000) {
                            product.taxPercent = 5;
                        } else {
                            product.taxPercent = 12;
                        }

                        product.subtotal = parseFloat(((product.price * product.quantity) / ((product.taxPercent / 100) + 1)).toFixed(2));
                        product.taxAmount = parseFloat(((product.price * product.quantity) - product.subtotal).toFixed(2));
                        product.total = product.price * product.quantity;
                        fSubtotal = parseFloat((fSubtotal + product.subtotal).toFixed(2));
                        fTax = parseFloat((fTax + product.taxAmount).toFixed(2));
                        fTotal += (product.total);
                        if (product.discountAmount) {
                            fDiscount += (product.discountAmount * product.quantity);
                        }
                        var taxSlab = _.findIndex(taxSlabs, function (slab) {
                            return slab.taxPercent === product.taxPercent;
                        });
                        if (taxSlab === -1) {
                            taxSlabs.push({taxPercent: product.taxPercent, taxAmount: product.taxAmount});
                        } else {
                            taxSlabs[taxSlab].taxAmount += product.taxAmount;
                        }

                        return product;
                    }
                );

                $scope.orderData.taxSlabs = taxSlabs;
                $scope.orderData.subtotal = fSubtotal;
                $scope.orderData.taxAmount = fTax;
                $scope.orderData.total = fTotal;
                $scope.orderData.savings = fDiscount;
                $scope.orderData.mrp = fDiscount + fTotal;
                console.log('Calculate Order Prices', $scope.editingOrder, $scope.orderData);
                if ($scope.editingOrder && $scope.orderData.hasPendingAmount) {
                    $scope.orderData.pendingAmount = $scope.orderData.total - $scope.orderData.paidAmount;
                } else {
                    $scope.orderData.pendingAmount = $scope.orderData.total;
                }
                $scope.flushToLocalStorage();
            }

            // function populateOrderById(){
            //
            //     if($stateParams.orderId){
            //         RestManager.getResource()
            //     }
            // }
            /**
             * @memberOf posAddCtrl
             * @param type {String} Discount type
             * @description Changes the discount type at the order level. Valid values are `percent` and  `amount`.
             * @function changeOrderDiscountType
             */
            function changeOrderDiscountType(type) {
                $scope.orderData.discountType = type;
            }

            /**
             * @memberOf posAddCtrl
             * @function applyOrderDiscount
             * @description Applies the discount to the order based on the discount type selected.
             */
            function applyOrderDiscount() {
                if ($scope.orderData.discountType === 'percent') {
                    $scope.orderData.discount = parseFloat(($scope.orderData.subtotal * ($scope.orderData.discountValue / 100)).toFixed(2));
                } else {
                    $scope.orderData.discount = $scope.orderData.discountValue;
                }
                // TODO : Check ceil vs round vs floor
                $scope.orderData.total = Math.round(($scope.orderData.subtotal - $scope.orderData.discount) + $scope.orderData.taxAmount);
                if ($scope.editingOrder && $scope.orderData.hasPendingAmount) {
                    $scope.orderData.pendingAmount = $scope.orderData.total - $scope.orderData.paidAmount;
                } else {
                    $scope.orderData.pendingAmount = $scope.orderData.total;
                }
                $scope.flushToLocalStorage();
            }

            /**
             * @memberOf posAddCtrl
             * @param value
             * @function btnValue
             */
            function btnValue(value) {
                $scope.amountTendered = value;
                console.log($scope.amountTendered);
            }


            /**
             * @memberOf posAddCtrl
             * @description Flushes the latest changes to indexed. Name is misleading.
             * @function flushToLocalStorage
             */
            function flushToLocalStorage() {
                salesHelper.set("1", $scope.orderData)
                    .then(function (result) {
                        console.log('Sync Done', result);
                    })
                    .catch(function (err) {
                        console.log('Sync Error', err);
                    })
            }

            /**
             * @memberOf posAddCtrl
             * @function restoreFromLocalStorage
             * @description In case a previous session is encountered in indexedb, asks the user for confirmation
             * and then restores it and puts it in the current scope.
             */
            function restoreFromLocalStorage() {
                salesHelper.get("1")
                    .then(function (data) {
                        if (data) {
                            console.log('Restored', data);
                            var alert = $mdDialog.confirm({
                                title: 'Restore Session',
                                textContent: 'A previous session with order value Rs. ' + data.total + ' created on ' + moment(data.createdDate).format('DD MMM, YYYY HH:MM:SS A') + ' can be restored. Do you want to restore this session?',
                                ok: 'Restore Session',
                                cancel: 'Cancel'
                            });

                            $mdDialog
                                .show(alert)
                                .then(function (result) {
                                    if (result) {
                                        $scope.orderData = data;
                                    } else {
                                        salesHelper.removeItem("1");
                                    }
                                    alert = undefined;
                                })
                                .catch(function (err) {
                                    alert = undefined;
                                });
                        }
                    })
                    .catch(function (err) {

                    })
            }

            /**
             * @memberOf posAddCtrl
             * @function clearSession
             * @description Clears the indexedb for the sale in progress
             */
            function clearSession() {
                salesHelper.clear()
                    .then(function (result) {

                    });
                $scope.orderData = {
                    user: '',
                    products: [],
                    subtotal: 0,
                    cashAmountTendered: 0,
                    cardAmountTendered: 0,
                    giftCardAmountTendered: 0,
                    storeCreditAmountTendered: 0,
                    taxAmount: 0,
                    total: 0,
                    discount: 0,
                    discountValue: 0,
                    coupon: '',
                    mrp: 0,
                    discountType: 'percent',
                    createdDate: new Date(),
                    paymentMode: 1,
                    payment: {
                        cardAmount: undefined,
                        cardNumber: undefined
                    }
                };
            }

            /**
             * @function sanitizeNumber
             * @memberOf posAddCtrl
             * @param num
             * @return {number}
             * @description Sanitizes the input number to fix it to 2 decimal points and then parse it to {Float}
             */
            function sanitizeNumber(num) {
                return parseFloat(Math.abs(num).toFixed(2));
            }

            /**
             * @memberOf posAddCtrl
             * @function openInvoicePrintPage
             * @description Opens a new window with the invoice html in order to trigger print
             */
            function openInvoicePrintPage() {
                var newWindow = window.open(Base.getBaseUrl() + '/order/invoice/' + $scope.orderData.orderNumber + "?access_token=" + AuthManager.getCurrentUser()['x-access-token']);
                newWindow.print();
            }

            /**
             * @memberOf posAddCtrl
             * @function emailInvoice
             * @description Email the invoice to the customer
             */
            function emailInvoice() {
                // var newWindow = window.open();
                // newWindow.document.write($scope.orderData.invoiceHtml);
                // newWindow.print();
            }

            /**
             * @memberOf posAddCtrl
             * @function prepareOrderSummary
             * @description Prepares the order sumarry data when the Place Order button is clicked and then opens the
             * sale-summary sidenav.
             */
            function prepareOrderSummary() {
                if (!$scope.orderData.cardAmountTendered || $scope.orderData.cardAmountTendered === 0) {
                    $scope.orderData.cashAmountTendered = $scope.orderData.pendingAmount;
                    $scope.orderData.cardAmountTendered = 0;
                }
                if(!$scope.orderData.warehouse){
                    $scope.setWarehouse($scope.orderData.user._id);
                }
                console.log('Prepare Order Summary', $scope.orderData);
                $scope.openSidebar('sale-summary');
            }

            /**
             * @memberOf posAddCtrl
             * @function recalculateTenderedAmounts
             * @description Recalculates the tendered amounts when the input for card amount changes
             */
            function recalculateTenderedAmounts() {
                if (!$scope.orderData.cardAmountTendered || $scope.orderData.cardAmountTendered === 0) {
                    $scope.orderData.cashAmountTendered = $scope.orderData.pendingAmount;
                    $scope.orderData.cardAmountTendered = 0;
                } else {
                    $scope.orderData.cashAmountTendered = $scope.orderData.pendingAmount - $scope.orderData.cardAmountTendered;
                }
                // $scope.flushToLocalStorage();
            }

            /**
             * @function prepareNewSale
             * @memberOf posAddCtrl
             * @description Reset the state of the page
             */
            function prepareNewSale() {
                $scope.clearSession();
                if ($scope.editingOrder || $scope.parkedOrder) {
                    $state.go('app.pos.add');
                } else {
                    console.log('Creator Now', $scope.creator);
                    // $state.reload();
                    $scope.orderData = {
                        user: '',
                        products: [],
                        subtotal: 0,
                        cashAmountTendered: 0,
                        cardAmountTendered: 0,
                        giftCardAmountTendered: 0,
                        storeCreditAmountTendered: 0,
                        taxAmount: 0,
                        total: 0,
                        discount: 0,
                        discountValue: 0,
                        coupon: '',
                        mrp: 0,
                        discountType: 'percent',
                        createdDate: new Date(),
                        paymentMode: 1,
                        payment: {
                            cardAmount: undefined,
                            cardNumber: undefined
                        },
                        creator: $scope.creator,
                        createdBy: $scope.creator ? $scope.creator._id : undefined
                    };
                    $scope.timer = {
                        startedAt: null,
                        completedAt: null,
                        totalTime: 0
                    }
                }
                $scope.closeSidebar('order-success');
            }

            /**
             * @function createNewOrder
             * @description Creates a new order in the backend. It first transforms the data in order to
             * conform with the order schema defined in the order model while also deleting properties
             * which will not be needed later on. Once the data is saved, it opens the sales summary sidenav
             * to show the actions needed once the order is processed.
             * @memberOf posAddCtrl
             * @summary Creates a new order in the backend
             * @param mode {string} The mode to use for creating the order. Can be `card`, `cash, `giftCard`
             */
            function createNewOrder(mode) {
                var data = {};
                // Set the order timing

                angular.copy($scope.orderData, data);
                data = $scope.prepareOrderData(data, 'placeOrder');
                //change according to user option
                delete data.products;
                data.paymentMode = (mode === 'cash') ? 1 : 7;
                $scope.savingOrder = true;
                console.log('Outgoing data', data);

                RestManager
                    .postResource($scope.newOrderUrl, data, 'orders')
                    .then(function (result) {
                        console.log("pos.add.controller.js", "----------------", result);
                        $scope.savingOrder = false;
                        // $scope.orderData = data;
                        $scope.orderData.orderNumber = result[0].orderNumber;
                        $scope.orderData._id = result[0]._id;
                        $scope.deliveryDate = result[0].createdAt;
                        $scope.closeSidebar('sale-summary');
                        $scope.openSidebar('order-success');

                    })
                    .catch(function (err) {
                        $scope.savingOrder = false;
                        console.log(err);
                    });
            }


            /**
             * @function prepareOrderData
             * @description Prepares order data prior to saving it to the backend
             * @memberOf posAddCtrl
             * @param data
             * @param mode
             * @return {object} data
             */
            function prepareOrderData(data, mode) {
                // Start Timer Data
                $scope.timer.completedAt = moment().toString();
                $scope.timer.totalTime = moment($scope.timer.completedAt).diff(moment($scope.timer.startedAt), 'seconds');
                if (!data.sessionTimes) {
                    data.sessionTimes = [];
                }
                data.sessionTimes.push($scope.timer);
                data.totalTimeForBilling = data.sessionTimes.reduce(function (a, timer) {
                    return a + timer.totalTime;
                }, 0);
                data.avgTimeForBilling = data.totalTimeForBilling / data.sessionTimes.length;
                // End Timer Data

                data.fullUser = {
                    name: data.user.name,
                    mobile: data.user.mobile
                };
                data.user = data.user._id;
                var paidAmount = (data.cardAmountTendered || 0) + (data.cashAmountTendered || 0) + (data.giftCardAmountTendered || 0) + (data.storeCreditAmountTendered || 0);
                if (!data.capturedPayments) {
                    data.capturedPayments = [];
                }
                data.capturedPayments.push({
                    cardAmount: data.cardAmountTendered,
                    cashAmount: data.cashAmountTendered,
                    giftCardAmount: data.giftCardAmountTendered,
                    storeCredit: data.storeCreditAmountTendered,
                    createdBy: data.creator ? data.creator.name : $scope.currentUser.name
                });
                // In editing mode
                if ($scope.editingOrder) {
                    console.log('Data', data);
                    data.paidAmount = data.paidAmount + paidAmount;
                    data.pendingAmount = data.total - data.paidAmount;
                } else {
                    data.paidAmount = paidAmount;
                }
                data.orderData = {
                    products: [],
                    amount: data.total,
                    mrp: data.mrp,
                    savings: data.savings,
                    subtotal: data.subtotal,
                    taxAmount:  data.taxAmount || data.tax,
                    total: data.total,
                    discountValue: data.discountValue,
                    discountType: data.discountType,
                    discount: data.discount,
                    cardAmountTendered: data.cardAmountTendered,
                    cashAmountTendered: data.cashAmountTendered,
                    storeCreditAmountTendered: data.storeCreditAmountTendered,
                    giftCardAmountTendered: data.giftCardAmountTendered,
                    taxSlabs: data.taxSlabs,
                    payment: data.payment,
                    sessionTimes: data.sessionTimes,
                    avgTimeForBilling: data.avgTimeForBilling,
                    totalTimeForBilling: data.totalTimeForBilling,
                    orderStatus: data.status,
                    warehouse: data.warehouse
                };
                var canBeApproved = (data.paidAmount >= data.orderData.total);

                if (mode === 'park') {
                    data.status = 'incomplete';
                } else if (canBeApproved && !data.cachedAddress) {
                    data.status = 'delivered';
                    data.approximatePrice = false;
                    data.hasPendingAmount = false;
                } else if (canBeApproved && data.cachedAddress) {
                    data.status = 'approved';
                    data.approximatePrice = false;
                    data.hasPendingAmount = false;
                } else if (!canBeApproved) {
                    data.hasPendingAmount = true;
                    data.pendingAmount = data.total - data.paidAmount;
                    if(!data.status || (data.status && data.status === 'incomplete')) {
                        data.status = 'placed';
                    }
                }

                if (!data.statusHistory) {
                    data.statusHistory = [];
                }

                data.statusHistory.push({
                    date: $scope.backDateOrder ? $scope.orderData.createdAt : new Date(),
                    status: data.status,
                    createdBy: data.creator ? data.creator.name : $scope.currentUser.name,
                    by: data.creator ? data.creator._id : $scope.currentUser._id
                })

                // data.status = (mode === 'park') ? 'incomplete' : 'approved';
                data.orderData.products = data.products.map(function (product) {
                    delete product.variations;
                    delete product.attributes;
                    delete product.comingSoon;
                    delete product.createdAt;
                    delete product.created_by;
                    delete product.deleted;
                    delete product.gallery;
                    delete product.groups;
                    delete product.isCoupon;
                    delete product.isFeatured;
                    delete product.isOnSale;
                    delete product.outOfStock;
                    delete product.priceHistory;
                    delete product.published;
                    delete product.seo;
                    delete product.virtualVariations;
                    delete product.visibility;
                    delete product.__v;

                    product.sku = product.sku.slice(0, 10);
                    console.log('Product', product);
                    return {
                        price: product.price,
                        variationText: product.selectedVariation,
                        totalPrice: product.total || product.totalPrice,
                        taxPercent: product.taxPercent,
                        taxAmount: product.taxAmount || product.tax,
                        quantity: product.quantity,
                        subtotal: product.subtotal,
                        product: product,
                        variation: product.variation,
                        //TODO:Changes made on 11 Dec, 2019 as it broke park order and payment button in prod
                        // There is no variation._id present in product. It'a a patch, will have to work on finding the real issue.
                        variationId: product.variation ? product.variation._id : null,
                        measurements: product.measurements,
                        categories: product.categories  ? product.categories.map(function (category) {
                            return category._id;
                        }) : []
                    }
                });
                data.amount = data.total.toString();
                //change according to user option
                delete data.products;

                return data;
            }

            /**
             *
             * @description Populates the entire POS with the backend data when a parked POS is loaded
             * @memberOf posAddCtrl
             * @param orderNumber
             */
            function populateData(orderNumber) {
                $scope.fetchingOrder = true;
                $scope.promise = RestManager.getResource("/order/admin/getOrders/" + orderNumber, "orders");
                var order = {};
                $scope.promise
                    .then(function (result) {
                        order = result[0];
                        if (order.status === 'incomplete') {
                            $scope.parkedOrder = true;
                        } else {
                            $scope.editingOrder = true;
                        }
                        return Promise.map(order.orderData.products, $scope.populateDataItem);
                    })
                    .then(function (products) {
                        order.products = products.filter(function (p) {
                            return !!p;
                        });
                        order.discountType = order.orderData.discountType;
                        order.discountValue = order.orderData.discountValue;
                        order.total = parseInt(order.amount);
                        order.mrp = order.orderData.mrp;
                        order.savings = order.orderData.savings;
                        order.subtotal = order.orderData.subtotal;
                        order.taxAmount = order.orderData.taxAmount || order.orderData.tax;
                        order.taxSlabs = order.orderData.taxSlabs;
                        order.total = order.orderData.total;
                        order.discount = order.orderData.discount;
                        order.sessionTimes = order.orderData.sessionTimes;
                        $scope.orderData = order;
                        $scope.timer.startedAt = moment().toString();
                        console.log($scope.orderData);
                        // $scope.calculateOrderPrices();
                        // $scope.generateDefaultMeasurements();
                        $scope.fetchingOrder = false;
                    })
                    .catch(function (err) {
                        console.log("err", err);
                        $scope.fetchingOrder = false;
                    });
            }

            /**
             * @description Populates a single product in the POS when a parked order is loaded
             * @memberOf posAddCtrl
             * @param productData
             * @return {*}
             */
            function populateDataItem(productData) {
                return $q(function (resolve, reject) {
                    if(!productData.product.isACustomMadeProduct) {
                        $scope.fetchProducts(productData.product.sku + productData.product.selectedVariation)
                            .then(function (products) {
                                var product = null;
                                if (products.length) {
                                    product = products[0];
                                    product.name = productData.product.name;
                                    product.editDisabled = $scope.editingOrder;
                                    product.quantity = productData.quantity;
                                    product.price = productData.price;
                                    product.subtotal = productData.subtotal;
                                    product.taxAmount = productData.taxAmount || productData.tax;
                                    product.taxPercent = productData.taxPercent;
                                    product.totalPrice = productData.totalPrice;
                                    product.measurements = productData.product.measurements;
                                    console.log('Product Populate', product);
                                }
                                resolve(product);
                            })
                    } else {
                        resolve(productData.product);
                    }
                })
            }


            /**
             * @description Opens the scanner dialog which tries to scan the bar code and then set it as the query term.
             * @memberOf posAddCtrl
             * @function openScannerDialog
             */
            function openScannerDialog() {
                $mdDialog.show({
                    templateUrl: "scannerDialog",
                    scope: $scope,
                    preserveScope: true,
                    fullscreen: true
                })
                    .finally(function () {
                        Scanner.stop();
                    });
                $timeout(function () {
                    Scanner.start()
                        .then(function (code) {
                            $scope.playAudio();
                            Scanner.stop();
                            $mdDialog.cancel();
                            $scope.searchText = code;
                            return $scope.query(code);
                        })
                        .then(function (products) {
                            if (products && products.length) {
                                $scope.addToCart(products[0]);
                            } else {
                                $mdToast.showSimple('No products with SKU ' + $scope.searchText + ' found. Please retry.');
                            }
                        })
                        .catch(function (err) {
                            $mdToast.showSimple("Error encountered while scanning : " + err.message);
                        });
                }, 500);
            }

            /**
             * @description Play the audio when the scan is complete
             */
            function playAudio() {
                var audio = new Audio('assets/sounds/solemn.mp3');
                audio.play();
            }


            /**
             * @description Check if the coupon is valid or not
             */
            function checkCoupon() {
                $scope.couponErrorMessage = '';
                var couponData = {};
                angular.copy($scope.orderData, couponData);
                couponData = $scope.prepareOrderData(couponData, 'park');
                console.log(couponData);
                RestManager.postResource('/coupons/checkCoupon', {
                    orderData: couponData.orderData,
                    couponCode: couponData.couponCode
                }, 'coupons')
                    .then(function (data) {
                        console.log(data)
                        $scope.orderData.coupon = data[0];
                        // Apply discount to orderData
                        $scope.closeSidebar('coupons');
                        $scope.flushToLocalStorage();
                    })
                    .catch(function (err) {
                        if (err.code === 441) {
                            $scope.couponErrorMessage = err.message;
                        }
                        console.log(err)
                    })
            }

            /**
             *
             */
            function getEligibleCoupons() {
                var couponData = {};
                angular.copy($scope.orderData, couponData);
                couponData = $scope.prepareOrderData(couponData, 'park');
                RestManager.postResource('/coupons/eligibleCoupons', {
                    orderData: couponData.orderData
                }, 'coupons')
                    .then(function (data) {
                        console.log(data)
                        // $scope.orderData.coupon = data[0];
                        // // Apply discount to orderData
                        // $scope.closeSidebar('coupons');
                        // $scope.flushToLocalStorage();
                    })
                    .catch(function (err) {
                        if (err.code === 441) {
                            $scope.couponErrorMessage = err.message;
                        }
                        console.log(err)
                    })
            }

            function updateSessionTimer() {
                $scope.$sessionTimerInterval = $interval(function () {
                    if ($scope.timer.startedAt) {
                        $scope.stopWatch = moment().diff(moment($scope.timer.startedAt), 'seconds');
                        $scope.stopWatchProgress = parseInt((($scope.stopWatch % 60) / 60) * 100);
                    } else {
                        $scope.stopWatch = 0;
                    }
                }, 1000);
            }

            function fetchUsers() {
                var queryRoles = ['admin', 'hr', 'marketing', 'sales-staff', 'designer', 'shop-manager', 'operator'];
                if ($scope.currentUser.role !== 'admin') {
                    queryRoles = ['sales-staff', 'shop-manager']
                }
                var query = {
                    query: {
                        role: {$in: queryRoles}
                    },
                    fields: ['name', 'warehouse'],
                    page: 1,
                    limit: 50,
                    order: {},
                    searchTerm: ""
                };
                RestManager.postResource("/users/admin", query, "users")
                    .then(function (users) {
                        console.log("users", users);
                        $scope.users = users;
                        if (!$scope.backDateOrder) {
                            $scope.orderData.createdBy = $scope.currentUser._id;
                            $scope.orderData.creator = $scope.currentUser;
                            $scope.creator = $scope.currentUser;
                            $scope.setWarehouse($scope.orderData.createdBy);
                        }
                    })
                    .catch(function (err) {
                        console.log(err);
                    })
            }

            function setWarehouse(userId) {
                var user = _.find($scope.users, ['_id', userId]);
                if (user && user.warehouse) {
                    $scope.orderData.warehouse = user.warehouse;
                } else if ($scope.warehouses) {
                    $scope.orderData.warehouse = $scope.warehouses[0]._id;
                }
            }

            function updateCreatedBy() {
                $scope.orderData.creator = _.find($scope.users, function (user) {
                    return user._id === $scope.orderData.createdBy
                });
                $scope.creator = $scope.orderData.creator;
                $scope.setWarehouse($scope.orderData.creator._id);
                console.log('Changed creator', $scope.orderData);
                // angular.copy($scope.orderData.creator, $scope.creator);
                // console.log('Creator ', $scope.creator);
            }

            function fetchWarehouses() {
                $scope.promise = RestManager.getResource('/warehouse', 'warehouses', {
                    query: {page: 1, limit: 10, sort : 'createdAt'},
                    extras: ['total']
                });

                $scope.promise
                    .then(function (result) {
                        $scope.warehouses = result.warehouses;
                        $scope.warehouse = $scope.warehouses[0];
                        console.log("pos.add.controller.js", "Warehouse", $scope.warehouse);
                        $scope.totalWarehouses = result.total;
                        if($scope.orderData.createdBy && !$scope.orderData.warehouse) {
                            $scope.setWarehouse($scope.orderData.createdBy )
                        }
                    })
            }

            function openCustomisableProductBuilderDialog(event, lineItem, index) {
                var ccLineItem = {};
                angular.copy(lineItem, ccLineItem);
                $mdDialog.show({
                    templateUrl : 'app/modules/pos/add/customisable-product-builder.dialog.html',
                    controller : 'customisable-product-builder.controller',
                    fullscreen : true,
                    multiple : true,
                    locals : {
                        lineItem : lineItem ? ccLineItem : null
                    },
                    targetEvent : event
                })
                    .then(function (data) {
                        if(data && lineItem) {
                            $scope.orderData.products[index] = data;
                            $scope.calculateOrderPrices();
                            $scope.generateDefaultMeasurements($scope.orderData.products[index]);
                            $scope.applyOrderDiscount();
                            $scope.flushToLocalStorage();
                        } else if(data) {
                            $scope.addToCart(data);
                        }
                        console.log("pos.add.controller.js", "lineItem", $scope.orderData.products[index]);
                    })
                    .catch(function (err) {

                    })
            }

            function editProduct(product, index, $event) {
                if(product.productType === 1 && product.isACustomMadeProduct) {
                    $scope.openCustomisableProductBuilderDialog($event, product, index);
                } else {
                    $scope.showSpecs(product, index);
                }
            }

            $scope.$on('$destroy', function (event) {
                $scope.deRegisterOfflineListener();
                $interval.cancel($scope.$sessionTimerInterval);
            });

            function selectSuggestedCustomer(customerName) {
                $scope.fetchCustomers(customerName)
                    .then(function (customers) {
                        console.log("pos.add.controller.js", "CUSTOMER", customers);
                        if (customers && customers.length) {
                            $scope.addCustomerToOrder(customers[0]);
                        } else {
                            $mdToast.show($mdToast.showSimple('No Customers Matching the name ' + customerName + ' found', 4000))
                        }
                    })
                    .catch(function (err) {
                        $mdToast.show($mdToast.showSimple('Error fetching suggestion for customers : ' + err.message))
                    })
            }


            if ($stateParams.orderNumber) {
                $scope.editMode = true;
                $scope.populateData($stateParams.orderNumber);
            }

            $scope.updateSessionTimer();
            $scope.restoreFromLocalStorage();
            $scope.registerOfflineListener();
            $scope.fetchUsers();
            $scope.fetchWarehouses();
            $scope.fetchSizeCharts();

        }
    }

)(angular);

(function () {
    'use strict';

    CustController.$inject = ["$scope", "RestManager", "$mdDialog", "$mdToast", "lineItem", "Materials", "Utils", "Base", "ProductUtils"];
    angular.module('app.pos')
        .controller('customisable-product-builder.controller', CustController);


    function CustController($scope, RestManager, $mdDialog, $mdToast, lineItem, Materials, Utils, Base, ProductUtils) {
        $scope.editing = !!lineItem;
        $scope.mediaUrl = Base.getMediaUrl();

        $scope.lineItem = lineItem || {price: 0, linkedProducts : [], materials : []};
        $scope.minDate = moment().startOf('day').format('DD-MMM-YYYY');
        $scope.availableSizes = ['FS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL'];
        $scope.quickAddProductOptions = [
            {
                name: 'Customisation Charges',
                added: false
            }, {
                name: 'Priority Charges',
                added: false
            }
        ];

        $scope.cancel = cancel;
        $scope.showMaterialSelector = showMaterialSelector;
        $scope.capitalize = Utils.getProperName;
        $scope.removeMaterial = removeMaterial;
        $scope.updateStock = updateStock;
        $scope.checkIfHasToBeRemoved = checkIfHasToBeRemoved;
        $scope.showProductSelectorDialog = showProductSelectorDialog;
        $scope.calculatePrices = calculatePrices;
        $scope.save = save;
        $scope.changeSize = changeSize;
        $scope.addProduct = addProduct;
        $scope.checkOptionsAreAdded = checkOptionsAreAdded;
        $scope.init = init;

        function init() {
            if ($scope.lineItem.deliveryDate) {
                $scope.lineItem.deliveryDate = moment($scope.lineItem.deliveryDate);
            }
            $scope.checkOptionsAreAdded();
        }

        function checkOptionsAreAdded() {
            if ($scope.lineItem.linkedProducts && $scope.lineItem.linkedProducts.length) {
                $scope.quickAddProductOptions = $scope.quickAddProductOptions.map(function (option) {
                    var isAdded = _.findIndex($scope.lineItem.linkedProducts, function (product) {
                        console.log("customisable-product-builder.dialog.js", "p", product, product.productName === option.name);
                        return product.productName === option.name;
                    });
                    option.added = isAdded !== -1;
                    return option;
                })
            }
        }

        function showMaterialSelector($event) {
            var selected = null;
            if ($scope.lineItem.materials) {
                selected = [];
                angular.copy($scope.lineItem.materials, selected)
            }
            Materials.openMaterialSelectorDialog($event, selected)
                .then(function (data) {
                    if (data && data.selectedMaterials) {
                        $scope.lineItem.materials = data.selectedMaterials;
                        $scope.calculatePrices();
                    }
                })
        }

        function showProductSelectorDialog($event) {
            var selected = null;
            if ($scope.lineItem.linkedProducts) {
                selected = [];
                angular.copy($scope.lineItem.linkedProducts, selected)
            }
            ProductUtils.openProductSelector($event, selected)
                .then(function (data) {
                    if (data && data.products) {
                        $scope.lineItem.linkedProducts = data.products;
                        $scope.calculatePrices();
                    }
                })
        }

        function checkIfHasToBeRemoved(material, index) {
            material.totalPrice = _.round(material.quantity * material.price, 2);
            if (material.quantity <= 0) {
                $scope.removeMaterial(material, index);
            }
            $scope.calculatePrices();
        }

        function updateStock(material, updateQuantity, $event, index) {
            $event.stopPropagation();
            material.quantity = material.quantity + updateQuantity;
            $scope.checkIfHasToBeRemoved(material, index);
        }

        function removeMaterial(material, index) {
            if (material.materialId) {
                $scope.lineItem.materials.splice(index, 1);
            } else if (material.productId) {
                $scope.lineItem.linkedProducts.splice(index, 1);
                $scope.checkOptionsAreAdded();
            }

            $scope.calculatePrices();
        }

        function calculatePrices() {
            $scope.lineItem.price = _.chain($scope.lineItem.linkedProducts)
                .concat($scope.lineItem.materials)
                .compact()
                .reduce(function (acc, entity) {
                    return acc + entity.totalPrice;
                }, 0)
                .value();
            $scope.lineItem.mrp = $scope.lineItem.price;
            $scope.lineItem.discountAmount = 0;
            $scope.lineItem.discountPercent = 0;
            $scope.lineItem.savings = 0;
            $scope.lineItem.totalPrice = $scope.lineItem.price;
        }

        function changeSize(size) {
            $scope.lineItem.variationText = size;
            $scope.lineItem.selectedVariation = size;
        }

        function save() {
            if (!$scope.lineItem.materials) {
                $scope.lineItem.materials = [];
            }
            if (!$scope.lineItem.linkedProducts) {
                $scope.lineItem.linkedProducts = [];
            }

            if (!$scope.lineItem.name) {
                $scope.error = 'Product Name is Required';
                return;
            }

            if (!$scope.lineItem.materials.length && !$scope.lineItem.linkedProducts.length) {
                $scope.error = 'Add some Materials or Linked Products to make it a customisable Product.'
                return;
            }

            if (!$scope.lineItem.variationText) {
                $scope.error = 'Please select a size to save the product';
                return;
            }

            if (!$scope.lineItem._id) {
                $scope.lineItem.quantity = 1;
            }
            $scope.lineItem.productType = 1;
            $scope.lineItem.isACustomMadeProduct = true;
            $scope.lineItem.featured_image = $scope.lineItem.image;
            $scope.lineItem.sku = 'ADRCUS0001' + $scope.lineItem.variationText;

            if (typeof $scope.lineItem.deliveryDate === 'object') {
                $scope.lineItem.deliveryDate = moment($scope.lineItem.deliveryDate).toISOString();
            }
            console.log("customisable-product-builder.dialog.js", "save", $scope.lineItem);
            $mdDialog.hide($scope.lineItem);
        }


        function addProduct(option) {
            RestManager.getResource("/products/admin/fastSearch/" + option.name, "products")
                .then(function (products) {
                    if (products && products.length) {
                        var product = products[0];
                        $scope.lineItem.linkedProducts.push({
                            productId: product._id,
                            productName: product.name,
                            image: product.featured_image,
                            featured_image: product.featured_image,
                            sku: product.sku,
                            price: product.price,
                            quantity: 1,
                            totalPrice: product.price,
                            variationText: 'Standard',
                            selectedVariationText: 'Standard'
                        });
                        option.added = true;
                        $scope.calculatePrices();
                    } else {
                        $mdToast.showSimple('No Product Matching the name ' + option.name + ' found');
                    }
                })

        }

        function cancel() {
            $mdDialog.cancel();
        }

        $scope.init();
    }

})(angular);

/**
 * Created by kumardivyarajat on 18/05/17.
 */
angular.module("app.photoshoot", [])
    .controller("shoot.controller", ["$scope", "RestManager", "$mdToast", "$mdDialog", function ($scope, RestManager, $mdToast, $mdDialog) {
        var vm = this;
        vm.shoots = [];
        vm.minDate = new Date();
        vm.newShoot = {};

        vm.fetchShoots = function () {
            RestManager.getResource("/shoots", "shoots",{local : true})
                .then(function (result) {
                    vm.shoots = result;
                    console.log(vm.shoots);
                    vm.count = 49;
                    vm.total = 50;
                })
                .catch(function (err) {
                    $mdToast.showSimple("Error | " + err.message);
                });
        };

        vm.addShoot = function (ev) {
            $mdDialog.show({
                templateUrl: "shootDialog.html",
                scope: $scope,
                preserveScope: true,
                targetEvent: ev,
                parent: angular.element(document.body),
                clickOutSideToClose: true,
                escapeToClose: true
            });
        };

        vm.queryPhotographer = function (text) {
            return RestManager.postResource("/users/admin", {
                page: 1,
                limit: 10,
                order: "",
                query: {role: "photographer"},
                searchTerm: text
            }, "users",{local : false})
        };

        vm.saveShoot = function () {
            console.log("saveShoot", vm.newShoot);
            var data = {};
            angular.copy(vm.newShoot, data);
            data.photographer = data.photographer._id;
            vm.savingShoot = true;
            RestManager.postResource("/shoots", vm.newShoot, "shoots", {local : true})
                .then(function (result) {
                    vm.savingShoot = false;
                    vm.shoots.unshift(result);
                    $mdDialog.hide();
                    // vm.shootForm.$setPristine();
                })
                .catch(function (err) {
                    vm.savingShoot = false;
                    $mdToast.showSimple("Error | " + err.message);
                })
        };

        vm.fetchShoots();

    }]);

/**
 * Created by kumardivyarajat on 19/05/17.
 */
angular.module("app.photoshoot")
    .controller("shoot.laid.controller", ["$scope", "$q", "$stateParams", "RestManager", "$mdToast", "$mdDialog", function ($scope, $q, $stateParams, RestManager, $mdToast, $mdDialog) {
        var vm = this;

        vm.fetchShootDetails = function () {

            RestManager.getResource("/shoots/full/" + $stateParams.id, "shoots")
                .then(function (result) {
                    vm.shoot = result[0];
                    //     return vm.aggregateLocalUrls()
                    // })
                    // .then(function () {
                    //     console.log("Done");
                })
                .catch(function (err) {
                    console.log(err);
                    $mdToast.showSimple("Error |" + err.message);
                })
        };

        vm.openImageDialog = function (image, ev) {
            $scope.dialogImage = image;
            $mdDialog.show({
                templateUrl: "image.html",
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose: true,
                escapeToClose: true,
                targetEvent: ev,
                fullscreen: true
            })
        };

        vm.fetchShootDetails();


        var logoDataUrl;
        var c = document.getElementById("mycanvas");
        var ctx = c.getContext("2d");
        var logo = new Image();
        logo.onload = function () {
            ctx.drawImage(logo, 0, 0);
            logoDataUrl = c.toDataURL();
        };
        logo.src = '/assets/images/rsz_aadira_dark.png';

        vm.export = function () {

            $mdToast.show({
                hideDelay: 0,
                position: 'bottom right',
                template: '<md-toast class="md-accent"><md-progress-circular md-mode="indeterminate" class="md-warn" md-diameter="20"></md-progress-circular> <span class="md-toast-text black-text" flex>Generating PDF</span> </md-toast>'
            });
            vm.aggregateLocalUrls()
                .then(function () {
                    return $mdToast.hide();
                })
                .then(function () {
                    console.log("resolved", vm.shoot.batch);
                    var docDefinition = getDocDefinition();
                    console.log(docDefinition);
                    // pdfMake.createPdf(docDefinition).open();
                    // pdfMake.createPdf(docDefinition).download('aadira-Photoshoot-' + vm.getFormattedDate(vm.shoot.date) + '.pdf');
                })
                .catch(function (err) {
                    console.log(err);
                });

            // pdfMake.createPdf(docDefinition).download('Delivery_list_' + vm.getFormattedDate() + '.pdf');
        };

        function getDocDefinition() {
            return {
                footer: function (currentPage, pageCount) {
                    return {
                        pageMargins: [40, 60, 40, 60],
                        columns: [
                            {
                                fontSize: 9,
                                text: [
                                    {
                                        text: '------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------' +
                                        '\n',
                                        margin: [20, 20]
                                    },
                                    {
                                        text: '© Redux X-press Pvt. Ltd.                                https://www.aadira.com                                            ' + currentPage.toString() + ' of ' + pageCount,
                                    }
                                ],
                                alignment: 'center'
                            }
                        ]
                    };

                },

                content: [
                    {
                        columns: [
                            {
                                image: logoDataUrl,
                                fit: [150, 100],
                                alignment: "left"
                            },
                            {
                                text: [
                                    {text: 'Redux X-press Pvt Ltd.\n', style: 'subheader'},
                                    {text: 'Bangalore, Karnataka\n', style: 'paragraph'},
                                    {text: 'https://www.aadira.com', style: 'medium'}
                                ],
                                alignment: "center"
                            },
                            {
                                text: [
                                    {
                                        text: "Photo shoot - " + vm.getFormattedDate(vm.shoot.date) + "\n",
                                        style: "header"
                                    },
                                    {
                                        text: 'Photographer - ' + vm.shoot.photographer.name + '\n',
                                        style: 'paragraph',

                                    },
                                    {
                                        text: vm.shoot.collectionName + "\n",
                                        style: "medium"
                                    }
                                ],
                                alignment: "right"
                            }
                        ]
                    },
                    {
                        text: {
                            fontSize: 9,
                            text: '------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------' +
                            '\n',
                            margin: [0, 20],
                            alignment: 'center'
                        },
                    },
                    {
                        // star-sized columns fill the remaining space
                        // if there's more than one star-column, available width is divided equally
                        width: '*',
                        text: 'Product Sequence',
                        style: "header",
                        alignment: "center",
                        margin: [0, 30, 0, 10]
                    },
                    {
                        text: {
                            fontSize: 9,
                            text: '------------------------------------------------------------------' +
                            '\n',
                            margin: [0, 0, 0, 20],
                            alignment: 'center'
                        },
                    },
                    {
                        stack: vm.generateExportData()
                    }
                ],
                styles: {
                    title: {
                        fontSize: 18,
                        underline: true
                    },
                    header: {
                        fontSize: 14,
                        bold: false
                    },
                    subheader: {
                        fontSize: 13,
                        bold: false
                    },
                    paragraph: {
                        fontSize: 11,
                        bold: false
                    },
                    quote: {
                        italics: true
                    },
                    medium: {
                        fontSize: 10
                    },
                    small: {
                        fontSize: 8
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 13,
                        color: 'black'
                    },
                    table: {}
                }
            }
        }

        vm.aggregateLocalUrls = function () {
            var promises = [];
            vm.shoot.batch.forEach(function (o, i) {
                promises.push(putData(o));
                o.referenceImages.map(function (img) {
                    promises.push(putRefernceData(img));
                })
            });
            return $q.all(promises);
        };

        function putRefernceData(img) {
            return $q(function (resolve, reject) {
                getBase64Image(img.urls.thumbnail)
                    .then(function (dataUrl) {
                        img.dataUrl = dataUrl;
                        resolve(img);
                    })
                    .catch(function (err) {
                        console.log(err);
                        reject(err);

                    })
            });
        }

        function putData(o) {
            return $q(function (resolve, reject) {
                getBase64Image(o.product.featured_image.urls.thumbnail)
                    .then(function (dataUrl) {
                        o.product.dataUrl = dataUrl;
                        resolve(o);
                    })
                    .catch(function (err) {
                        console.log(err);
                        reject(err);

                    })
            });
        }

        function getBase64Image(src) {
            return $q(function (resolve, reject) {
                var canvas = document.createElement("canvas");
                // Copy the image contents to the canvas
                var ctx = canvas.getContext("2d");
                var img = new Image();
                img.onload = function () {
                    ctx.drawImage(img, 0, 0);
                    var dataURL = canvas.toDataURL();
                    resolve(dataURL);
                };
                img.src = src;
            });
        }

        vm.generateExportData = function () {
            var data = vm.shoot.batch.map(function (sData, i) {
                var content = {};
                content.stack = [];

                content.stack.push({
                    text: (i + 1 ) + ".  " + _.startCase(_.toLower(sData.product.name)),
                    style: "tableHeader"
                });

                content.stack.push({
                    columns: [
                        {
                            text: [
                                {
                                    text: "Model : ",
                                    fontSize: 9
                                },
                                {
                                    text: sData.model.name,
                                    fontSize: 11
                                }
                            ]
                        },
                        {
                            text: [
                                {
                                    text: "Total Shots : ",
                                    fontSize: 9
                                },
                                {
                                    text: sData.totalShots,
                                    fontSize: 11
                                }
                            ]
                        }
                    ],
                    margin: [0, 20]
                });

                if (sData.conceptShoot) {
                    content.stack[1].columns.push({
                        text: [
                            {
                                text: "Concept Shoot : ",
                                fontSize: 9
                            },
                            {
                                text: sData.conceptShoot.required ? "Yes" : "No",
                                fontSize: 11
                            }
                        ]
                    });
                } else {
                    content.stack[1].columns.push({
                        text: [
                            {
                                text: "Concept Shoot : ",
                                fontSize: 9
                            },
                            {
                                text: "No",
                                fontSize: 11
                            }
                        ]
                    });
                }

                content.stack.push({
                    columns: [
                        {
                            stack: [
                                {
                                    text: "Product Image",
                                    fontSize: 6
                                },
                                {
                                    image: sData.product.dataUrl,
                                    alignment: "center",
                                    width: 200 * 0.7487922705314,
                                }
                            ],
                            width: "auto"
                        },
                        {
                            stack: [
                                {
                                    text: "Reference Images",
                                    fontSize: 6
                                },
                                {
                                    columns: getRefernceImages(sData),
                                }
                            ],
                            width: '*'
                        }
                    ]
                });

                content.stack.push({
                    fontSize: 9,
                    margin: [0, 30],
                    width: 100,
                    columns: getMetaStack1(sData)
                });

                content.stack.push({
                    fontSize: 9,
                    width: 100,
                    text: [
                        "Notes - ",
                        {text: sData.notes}
                    ]
                });

                content.stack.push({
                    fontSize: 9,
                    text: '------------------------------------------------------------------------------------------------------------------------------------' +
                    '\n',
                    margin: [0, 20, 0, 30],
                    alignment: 'center'
                });

                return content;
            });
            console.log("generateExportData", data);
            return data;
        };

        function getRefernceImages(o) {
            var a = [];

            o.referenceImages.forEach(function (img) {
                a.push({
                    image: img.dataUrl,
                    width: 200 * 0.7487922705314,
                    margin : [10]
                })
            });
            return a;
        }

        function getMetaStack1(o) {
            var a = [];
            if (o.accessories) {
                a.push({
                    width: "*",
                    margin: [0, 20, 0, 10],
                    stack: [
                        {text: 'Accessories', style: 'header'},
                        {ul: getLi(o.accessories)}
                    ]
                });
            }

            if (o.stylingTips) {
                a.push({
                    width: "*",
                    margin: [0, 20, 0, 10],
                    stack: [
                        {text: 'Styling Tips', style: 'header'},
                        {ul: getLi(o.stylingTips)}
                    ]
                })
            }
            if (o.helpingPeople) {
                a.push({
                    width: "*",
                    margin: [0, 20, 0, 10],
                    stack: [
                        {text: 'People Involved', style: 'header'},
                        {ul: getLi(o.helpingPeople)}
                    ]
                })
            }

            if (o.pairedWith) {
                a.push({
                    width: "*",
                    margin: [0, 20, 0, 10],
                    stack: [
                        {text: 'Paired With', style: 'header'},
                        {ul: getLi(o.pairedWith)}
                    ]
                })
            }
            return a;
        }

        function getLi(data) {
            if (data.length > 0) {
                if (data[0].name) {
                    return data.map(function (o) {
                        return o.name;
                    })
                } else {
                    return data.map(function (o) {
                        return o;
                    })
                }
            } else {
                return [];
            }

        }

        vm.getFormattedDate = function (date) {
            var today = new Date(date);
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!

            var yyyy = today.getFullYear();
            if (dd < 10) {
                dd = '0' + dd
            }
            if (mm < 10) {
                mm = '0' + mm
            }
            today = dd + '/' + mm + '/' + yyyy;
            return today;
        };
    }]);



/**
 * Created by kumardivyarajat on 18/05/17.
 */
angular.module("app.photoshoot")
    .controller("shoot.details.controller", ["$scope", "Utils", "$state", "$mdDialog", "$stateParams", "$filter", "$mdToast", "RestManager", function ($scope, Utils, $state, $mdDialog, $stateParams, $filter, $mdToast, RestManager) {
        var vm = this;

        vm.name = "asda";
        vm.init = false;

        vm.fetchSingleShoot = function () {
            RestManager.getResource("/shoots/" + $stateParams.id, "shoots",{local : true})
                .then(function (shoot) {
                    vm.shoot = shoot[0];
                    vm.shoot.batch = $filter('orderBy')(vm.shoot.batch, 'sequence');
                    vm.filter();
                    console.log(vm.shoot);
                    if (vm.shoot.batch) {
                        if (vm.shoot.batch.length === 0) {
                            vm.addNewRow(0);
                        } else {
                            // vm.shoot.batch.forEach(function (o, i) {
                            //     if (o.helpingPeople.length !== 0) {
                            //         vm.queryHelpers(i);
                            //     }
                            //
                            //     if (!o.pairedWith) {
                            //         o.pairedWith = [];
                            //     }
                            // })
                        }
                    } else {
                        vm.shoot.batch = [];
                        vm.addNewRow(0);
                    }
                    vm.init = true;
                })
                .catch(function (err) {
                    console.log(err);
                    $mdToast.showSimple("Error | " + err.message);
                })
        };

        vm.filter = function () {
            vm.modelData = _.groupBy(_.filter(vm.shoot.batch, function (o) {
                return o.status === "done"
            }), function (o) {
                return o.model.name;
            });
            console.log("filter", vm.modelData);
        };

        vm.addNewRow = function ($index) {
            vm.shoot.batch.splice($index + 1, 0, {
                product: {
                    name: "",
                    featured_image: ""
                },
                model: "",
                referenceImages: [],
                accessories: [],
                helpingPeople: [],
                stylingTips: [],
                pairedWith: [],
                conceptShoot: {},
                notes: "",
                sequence: $index + 1,
                others: {}
            })
        };

        vm.duplicateRow = function (index) {
            var data = {};
            angular.copy(vm.shoot.batch[index], data);
            data.product = {
                name: data.product.name,
                featured_image: data.product.featured_image
            };
            vm.shoot.batch.splice(index + 1, 0, data)
        };

        vm.removeRow = function ($index) {
            vm.dumpData = {
                row: vm.shoot.batch[$index],
                index: $index
            };
            vm.shoot.batch.splice($index, 1);
            vm.showActionToast();
        };

        vm.editRow = function (data, ev) {
            vm.selectedData = data;
            console.log("editRow", vm.selectedData);
            $mdDialog.show({
                templateUrl: 'batchDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose: true
            })
        };

        vm.openSingleUploader = function (ev, mode, data, index) {
            $mdDialog.show({
                locals: {
                    multipleSelect: false,
                    select: "jpeg",
                    options : null
                },
                controller: "upload.controller",
                templateUrl: 'app/modules/base/partials/uploader.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            })
                .then(function (images) {
                    if (mode === "featured image") {
                        data.product.featured_image = images[0];
                        data.product.modified = true;
                    } else if (mode === "reference") {
                        data.referenceImages[index] = images[0];
                    }
                }, function () {
                    $scope.status = 'You cancelled the dialog.';
                });
        };

        vm.openMultipleUploader = function (ev, data, append) {
            $mdDialog.show({
                locals: {
                    multipleSelect: true,
                    select: "jpeg",
                    options : null
                },
                controller: "upload.controller",
                templateUrl: 'app/modules/base/partials/uploader.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            })
                .then(function (images) {
                    if (append) {
                        _.forEach(images, function (image) {
                            data.referenceImages.push(image);
                        })
                    } else {
                        data.referenceImages = images;
                    }
                }, function () {
                    $scope.status = 'You cancelled the dialog.';
                });

        };


        vm.queryPhotographer = function (text) {
            return RestManager.postResource("/users/admin", {
                page: 1,
                limit: 10,
                order: "",
                query: {role: "photographer"},
                searchTerm: text
            }, "users")
        };

        vm.queryModel = function (text) {
            return RestManager.postResource("/users/admin", {
                page: 1,
                limit: 10,
                order: "",
                query: {role: "model"},
                searchTerm: text
            }, "users")
        };

        vm.queryHelpers = function (index) {
            vm.users = [];

            vm.shoot.batch[index].helpingPeople = vm.shoot.batch[index].helpingPeople.filter(function (o) {
                return o !== null;
            });
            RestManager.postResource("/users/admin", {
                page: 1,
                limit: 25,
                order: "",
                searchTerm: "",
                query: {
                    role: {
                        $in: ["model", "admin", "designer", "marketing", "photographer", "makeup"],
                    },
                    id: {"$nin": vm.shoot.batch[index].helpingPeople}
                }
            }, "users")
                .then(function (users) {
                    vm.users = users;
                })
                .catch(function (err) {
                    console.log(err);
                    $mdToast.showSimple("Error | " + err.message);
                })
        };

        vm.queryAccessories = function (text) {
            console.log(text);
            return RestManager.postResource("/shoots/query", {
                limit: 10,
                query: {
                    search: "batch.accessories",
                    text: text
                },
                distinct: "batch.accessories"
            }, "shoots", {local : true})
        };

        vm.queryStylingTips = function (text) {
            console.log(text);
            return RestManager.postResource("/shoots/query", {
                limit: 10,
                query: {
                    search: "batch.stylingTips",
                    text: text
                },
                distinct: "batch.stylingTips"
            }, "shoots",{local : true})
        };
        vm.queryPairedWith = function (text) {
            console.log(text);
            return RestManager.postResource("/shoots/query", {
                limit: 10,
                query: {
                    search: "batch.pairedWith",
                    text: text
                },
                distinct: "batch.pairedWith"
            }, "shoots",{local : true})
        };

        vm.showActionToast = function () {
            var pinTo = "bottom right";
            var toast = $mdToast.simple()
                .textContent('Deleted Batch')
                .action('UNDO')
                .hideDelay(0)
                .highlightAction(true)
                .highlightClass('md-warn')// Accent is used by default, this just demonstrates the usage.
                .position(pinTo);

            $mdToast.show(toast).then(function (response) {
                if (response === 'ok') {
                    vm.shoot.batch.splice(vm.dumpData.index, 0, vm.dumpData.row);
                    var toast = $mdToast.simple()
                        .textContent('Restored Batch')
                        .position(pinTo);
                    $mdToast.show(toast)
                }
            });
        };

        vm.transformChip = function (chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }

            // Otherwise, create a new one
            return chip;
        };

        vm.checkSlug = function (name, index) {
            if (vm.init) {
                vm.shoot.batch[index].product.modified = true;
                var slug = _.replace(_.toLower(name), /\s/g, '-');
                RestManager.getResource("/products/checkSlug/" + slug, "available")
                    .then(function (isAvailable) {
                        vm.shoot.batch[index].product.available = isAvailable;
                    })
                    .catch(function (err) {

                    })
            }
        };


        vm.updateShoot = function () {
            vm.savingShoot = true;
            var data = {};
            angular.copy(vm.shoot, data);
            data.batch = data.batch.filter(function (o) {
                return o.product.name.length > 0;
            });
            console.log("updateShoot", data);
            RestManager.putResource("/shoots", data, "shoots", {local : true})
                .then(function (result) {
                    $mdToast.showSimple("Updated Data");
                    vm.shoot = result[0];
                    vm.savingShoot = false;
                    vm.query = "";
                    // $state.reload();
                    vm.shoot.batch = $filter('orderBy')(vm.shoot.batch, 'sequence');
                    vm.filter();

                    if (vm.shoot.batch) {
                        if (vm.shoot.batch.length === 0) {
                            vm.addNewRow(0);
                        } else {
                            // vm.shoot.batch.forEach(function (o, i) {
                            //     if (o.helpingPeople.length !== 0) {
                            //         vm.queryHelpers(i);
                            //     }
                            //
                            //     if (!o.pairedWith) {
                            //         o.pairedWith = [];
                            //     }
                            // })
                        }
                    } else {
                        vm.shoot.batch = [];
                        vm.addNewRow(0);
                    }
                })
                .catch(function (err) {
                    vm.savingShoot = false;
                    $mdToast.showSimple("Error | " + err.message);
                })
        };

        vm.proper = function (str) {
            return Utils.capitalize(str);
        };

        vm.fetchSingleShoot();
    }]);

(function () {
    'use strict';

    StockUpdatesController.$inject = ["$scope", "RestManager", "$mdDialog", "options"];
    angular.module('app.orders')
        .controller('stock-updates.controller', StockUpdatesController);


    function StockUpdatesController($scope, RestManager, $mdDialog, options) {
        if (!options) {
            options = {};
        }
        $scope.total = 0;
        $scope.stockUpdates = [];
        $scope.fetching = true;
        $scope.query = {
            page: 1,
            limit: 10,
            sort: '-createdAt',
            lineItemId: options.lineItemId || null,
            productId: options.productId || null,
            variationId: options.variationId || null,
            orderId: options.orderId || null
        };
        $scope.fetchStockUpdates = fetchStockUpdates;
        $scope.paginate = paginate;
        $scope.close = close;

        function close() {
            $mdDialog.cancel();
        }

        function paginate() {
            $scope.query.page += 1;
            $scope.fetchStockUpdates(true);
        }


        function fetchStockUpdates(concat) {
            $scope.fetching = true;
            RestManager.getResource('/stockUpdates', 'stockUpdates', {query: $scope.query, extras: ['total']})
                .then(function (result) {
                    $scope.total = result.total;
                    if (concat) {
                        $scope.stockUpdates = $scope.stockUpdates.concat(result.stockUpdates);
                    } else {
                        $scope.stockUpdates = result.stockUpdates;
                    }
                    $scope.fetching = false;
                })
                .catch(function (err) {
                    $scope.fetching = false;
                    console.log("stock-updates.controller.js", "err", err);
                });
        }

        $scope.fetchStockUpdates();
    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 01/12/19, 3:38 PM
 *
 */

(function () {
    'use strict';

    PlanningController.$inject = ["$scope", "$stateParams", "RestManager", "Utils", "$mdToast", "$mdDialog", "$timeout"];
    angular.module('app.orders')
        .controller('orders.planning.controller', PlanningController);


    /** @ngInject **/
    function PlanningController($scope, $stateParams, RestManager, Utils, $mdToast, $mdDialog, $timeout) {
        $scope.$parent.nestedState = false;
        $scope.$parent.showActionButton = false;
        $scope.$parent.pageTitle = "Order Planning";
        $scope.$parent.nestedState = true;
        $scope.$parent.backState = $stateParams.backState || "app.orders.all";
        $scope.$parent.backParams = $stateParams.backParams ? JSON.parse($stateParams.backParams) : {};
        $scope.productGroups = {};
        $scope.showingProductOverlay = false;
        $scope.minDate = moment().format('DD-MMM-YYYY');
        $scope.loadingOrders = true;

        $scope.orderQuery = {
            queryType: "find",
            queryParams: {
                status: {$in: ["placed", "approved", "processing"]},
            },
            queryOptions: {
                select: "orderNumber saleChannel createdAt status _id fullUser fullUser.name " +
                    "fullUser.mobile orderData orderData.products orderData.products.product " +
                    "orderData.products.quantity orderData.products.selectedVariationText orderData.products.customisation " +
                    "orderData.products.ucData orderData.products.deliveryDate orderData.products.status orderData.products.measurements orderData.products.status orderData.products.deliveryDate" +
                    "lineItems lineItems._id lineItems.productId lineItems.deliveryDate lineItems.name lineItems.linkedProducts lineItems.sku " +
                    "lineItems.quantity lineItems.image lineItems.ucData lineItems.selectedVariationText lineItems.status " +
                    "lineItems.customisation lineItems.isACustomMadeProduct lineItems.measurements ",
                sort: "createdAt",
                limit: 100
            }
        };

        $scope.properName = Utils.getProperName;
        $scope.getWhiteFrameClass = getWhiteFrameClass;
        $scope.fetchOrders = fetchOrders;
        $scope.showProductList = showProductList;
        $scope.getLineItemStatus = getLineItemStatus;
        $scope.updateLineItemStatus = updateLineItemStatus;
        $scope.showCustomisation = showCustomisation;
        $scope.updateLineItemDeliveryDate = updateLineItemDeliveryDate;
        $scope.openMeasurementDialog = openMeasurementDialog;
        $scope.viewMeasurementsDialogs = viewMeasurementsDialogs;
        $scope.getMeasurementForSizeChart = getMeasurementForSizeChart;
        $scope.fetchSizeCharts = fetchSizeCharts;
        $scope.updateMeasurements = updateMeasurements;
        $scope.appendMeasurement = appendMeasurement;
        $scope.deleteMeasurement = deleteMeasurement;
        $scope.changeSelected = changeSelected;
        $scope.isDone = isDone;

        function isDone(lineItem) {
            return lineItem.status === 'packed' ||
            lineItem.status === 'shipped' || lineItem.status === 'delivered' || lineItem.status === 'cancelled'|| lineItem.status === 'returned'
        }

        function showProductList() {
            $scope.showingProductOverlay = true;
        }

        function getLineItemStatus() {
            RestManager.getResource("/settings/constants/lineItemStatus", "settings")
                .then(function (data) {
                    $scope.lineItemStatuses = data[0];
                })
                .catch(function (err) {
                    console.log(err);
                });
        }

        function getWhiteFrameClass(groupContents, index) {
            if (index === 0) {
                return 'md-whiteframe-0dp'
            } else {
                return 'md-whiteframe-1dp';
            }
        }

        function updateLineItemStatus(lineItem, status) {
            console.log("updating Line item status", lineItem);
            lineItem.updating = true;
            RestManager.patchResource('/order/updateLineItemStatus/' + lineItem.orderId, {
                lineItemId: lineItem._id,
                status: lineItem.status,
                productIndex: lineItem.lineItemIndex,
                variationText: lineItem.selectedVariationText
            }, 'orders')
                .then(function (response) {
                    lineItem.updating = false;
                    $mdToast.showSimple("Status Updated to : " + lineItem.status.toUpperCase());
                })
                .catch(function (err) {
                    lineItem.updating = false;
                    console.log(err);
                    $mdToast.showSimple("Error updating status : " + err.message);
                })
        }

        function updateLineItemDeliveryDate(lineItem) {
            lineItem.updating = true;
            RestManager.patchResource('/order/updateLineItemDeliveryDate/' + lineItem.orderId, {
                lineItemId: lineItem._id,
                deliveryDate: moment(lineItem.deliveryDate, 'DD-MMM-YYYY').endOf('day').toISOString(),
                productIndex: lineItem.lineItemIndex,
                variationText: lineItem.selectedVariationText,
                status: lineItem.status
            }, 'orders')
                .then(function (response) {
                    lineItem.updating = false;
                    $mdToast.showSimple("Delivery Date Updated");
                })
                .catch(function (err) {
                    lineItem.updating = false;
                    console.log(err);
                    $mdToast.showSimple("Error updating status : " + err.message);
                })
        }

        function showCustomisation(lineItem, event) {
            var productDataObj = {};
            angular.copy(lineItem, productDataObj);
            productDataObj.product = {
                customisation: lineItem.ucData.customisation,
                _id: lineItem.productId,
                name: lineItem.name,
            };
            productDataObj.ucData.customisation = productDataObj.ucData.customisation._id;
            $mdDialog.show({
                locals: {
                    product: productDataObj.product,
                    ucData: lineItem.ucData
                },
                controller: "product-templates.controller",
                templateUrl: 'app/modules/products/productTemplates/product-templates.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: event,
                fullscreen: true,
                clickOutsideToClose: true
            })

        }

        function fetchOrders() {

            RestManager.postResource("/analytics/Order", $scope.orderQuery, "analytics")
                .then(function (result) {
                    console.log("planning.controller.js", "dre", result);
                    $scope.loadingOrders = false;
                    $scope.orders = result;
                    $scope.products = _.chain(result)
                        .map(function (order) {
                            if (order.lineItems && order.lineItems.length) {
                                return order.lineItems.map(function (lineItem) {
                                    lineItem.deliveryDate = lineItem.deliveryDate ? moment(lineItem.deliveryDate).format('DD-MMM-YYYY').toString() : null;
                                    lineItem.orderId = order._id;
                                    lineItem.user = order.fullUser;
                                    lineItem.createdAt = order.createdAt;
                                    lineItem.skuSize = lineItem.sku + lineItem.selectedVariationText;
                                    return lineItem;
                                })
                            } else {
                                return _.flatMap(order.orderData.products, function (lineItem, index) {
                                    var selectedVariationText = lineItem.selectedVariationText || lineItem.product.selectedVariation;
                                    return {
                                        orderId: order._id,
                                        lineItemIndex: index,
                                        name: lineItem.product.name,
                                        image: lineItem.product.featured_image,
                                        selectedVariationText: selectedVariationText,
                                        quantity: lineItem.quantity,
                                        user: order.fullUser,
                                        createdAt: order.createdAt,
                                        status: lineItem.status || order.status,
                                        deliveryDate: lineItem.deliveryDate ? moment(lineItem.deliveryDate).format('DD-MMM-YYYY').toString() : null,
                                        productId: lineItem.product._id,
                                        sku: lineItem.product.sku,
                                        skuSize: lineItem.product.sku + selectedVariationText,
                                        measurements: lineItem.measurements || lineItem.product.measurements,
                                        ucData: lineItem.ucData
                                    }
                                })
                            }
                        })
                        .flatten()
                        .value();
                    var grp = _.groupBy($scope.products, function (product) {
                        return product.skuSize;
                    });
                    $scope.productGroups = _.map(grp, function (val, key) {
                        val = _.orderBy(val, ['createdAt'], ['desc']);
                        return {key : key, values : val}
                    });
                    console.log("planning.controller.js", "sdfa", $scope.products);
                })
                .catch(function (err) {
                    $scope.loadingOrders = false;
                    console.log("err", err);
                });
        }

        function viewMeasurementsDialogs(ev, l) {
            var lineItem = {};
            angular.copy(l, lineItem);

            $scope.editMeasurements = false;
            $scope.loadingSizeCharts = true;
            $scope.measurements = [];
            $scope.disableEdit = true;
            if (Array.isArray(lineItem.measurements)) {
                $scope.measurements = lineItem.measurements;

            } else {
                _.forOwn(lineItem.measurements, function (value, key) {
                    $scope.measurements.push({
                        key: key,
                        value: _.round(value, 2)
                    });
                });
            }
            $scope.productQuery = {
                queryType: "find",
                queryParams: {
                    _id: lineItem.productId
                },
                queryOptions: {
                    select: 'sizeChart'
                }
            };

            $scope.openMeasurementDialog();
            $scope.fetchSizeCharts()
                .then(function (sizeCharts) {
                    $scope.sizeCharts = sizeCharts;
                    if (!l.sizeChart) {
                        return RestManager.postResource("/analytics/Products", $scope.productQuery, "analytics")
                    } else {
                        return [l]
                    }
                })
                .then(function (products) {
                    if (products && products.length && products[0].sizeChart) {
                        $scope.sizeChartGroupSelected = _.find($scope.sizeCharts, function (chart) {
                            return chart.id === products[0].sizeChart;
                        });
                    } else {
                        $scope.sizeChartGroupSelected = _.find($scope.sizeCharts, function (chart) {
                            return chart.name === "Customisation Size Chart";
                        });
                    }
                    lineItem.product = {
                        name : lineItem.name
                    };
                    $scope.measurementProduct = lineItem;
                    $scope.loadingSizeCharts = false;
                    console.log("planning.controller.js", "measurements", $scope.measurements);
                })
                .catch(function (err) {
                    console.log("order.details.controller.js", "err", err);
                    $mdToast.showSimple('Error loading measurement data : ' + err.message);
                })
        }

        function getMeasurementForSizeChart(sizeChartGroupSelected, sizeText) {
            var data = _.find(sizeChartGroupSelected.measurements, function (m) {
                return m.key === sizeText;
            });
            if (data) {
                return data.values;
            } else {
                return [];
            }
        }

        function fetchSizeCharts() {
            if (!$scope.sizeCharts) {
                return Utils.fetchSizeCharts();
            } else {
                return Promise.resolve($scope.sizeCharts);
            }
        }

        function updateMeasurements() {
            $scope.updatingMeasurements = true;
            var payload = {indexes: [$scope.measurementProduct.productIndex], measurements: $scope.measurements};
            RestManager.patchResource('/order/measurements/' + $scope.measurementProduct.orderId, payload, 'orders')
                .then(function (orders) {
                    $scope.measurementProduct.measurements = orders[0].products[$scope.measurementProduct.productIndex].measurements;
                    console.log('ups', $scope.measurementProduct);
                    $scope.updatingMeasurements = false;
                    $mdDialog.cancel();
                    $mdToast.showSimple('Updated measurement');
                })
                .catch(function (err) {
                    $scope.updatingMeasurements = false;
                    console.log("order.details.controller.js", "err", err);
                    $mdToast.showSimple('Error updating measurements :' + err.message);
                })
        }

        function appendMeasurement(index) {
            $scope.measurements.splice(index + 1, 0, {key: '', value: ''})
        }

        function deleteMeasurement(index) {
            $scope.measurements.splice(index, 1);
        }

        function openMeasurementDialog(ev) {
            $mdDialog.show({
                preserveScope: true,
                scope: $scope,
                fullscreen: true,
                contentElement: '#viewMeasurementsDialogs',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,

            });
        }

        function changeSelected(key, moveSize) {
            var grpIndex = _.findIndex($scope.productGroups, function (grp) {
                return grp.key === key;
            });
            var lastIndex = $scope.productGroups[grpIndex].values.length - 1;
            $scope.productGroups[grpIndex].values[lastIndex].movingOut = true;
            $scope.productGroups[grpIndex].values[lastIndex].direction = moveSize === 1 ? 'right' : 'left';
            console.log("planning.controller.js", "changeSelected", $scope.productGroups[grpIndex].values[lastIndex].direction);
            $timeout(function () {
                $scope.productGroups[grpIndex].values = move($scope.productGroups[grpIndex].values, lastIndex, 0)
                $scope.productGroups[grpIndex].values[lastIndex].movingOut = false;
                $scope.productGroups[grpIndex].values[lastIndex].direction = null;
            }, 250);
        }

        function move(arr, old_index, new_index) {
            while (old_index < 0) {
                old_index += arr.length;
            }
            while (new_index < 0) {
                new_index += arr.length;
            }
            if (new_index >= arr.length) {
                var k = new_index - arr.length;
                while ((k--) + 1) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr;
        }

        $scope.fetchOrders();
        $scope.getLineItemStatus();
    }

})(angular);

(function () {
    'use strict';
    giftCardsController.$inject = ["$scope"];
    angular.module("app.offers.giftCards")
        .controller("offers.giftCardsController", giftCardsController);

    function giftCardsController($scope){

    }

})(angular);

/**
 * Created by kumardivyarajat on 23/12/16.
 */
angular.module("app.offers")
    .controller("offers.home.controller", ["$scope", "RestManager", function ($scope, RestManager) {

    }]);



/**
 * Created by kumardivyarajat on 04/12/16.
 */
angular.module("app.media", [])
    .controller("media.controller", ["$scope", "$log", "RestManager", "AuthManager", "$mdPanel", "Upload", "Base", "$mdToast", "$timeout", "$mdDialog", "ImageEdgeDetector", function ($scope, $log, RestManager, AuthManager, $mdPanel, Upload, Base, $mdToast, $timeout, $mdDialog,
                                              ImageEdgeDetector) {
        $log.info("Entered media Module");
        $scope.pngRegex = /((.png))/;
        $scope.svgRegex = /((.svg))/;
        $scope.jpegRegex = /((.jpg))|((.jpeg))/;
        $scope.images = [];
        $scope.context = "";
        $scope.selectedImages = [];
        $scope.showInfo = false;
        $scope.loading = true;
        $scope.mediaUrl = Base.getMediaUrl();
        $scope.filterActive = false;
        $scope.originalQuery = null;
        $scope.multiSelectionMode = false;

        $scope.query = {
            limit: 48,
            page: 1,
            sort: "-createdAt",
            filter: $scope.selectionPattern ? $scope.selectionPattern : {}
        };

        $scope.sizes = [
            {
                width: 0,
                height: 0,
                attributeName: ""
            }
        ];

        $scope._mdPanel = $mdPanel;
        $scope.suggestedFilters = [
            {
                name: 'Customisation',
                condition: {"urls.c_large": {$exists: true}},
                active: false
            },
            {
                name: 'SVG Images',
                condition: {'extension': '.svg'},
                active: false
            },
            {
                name: 'My Images',
                condition: {createdBy: AuthManager.getCurrentUser()._id},
                active: false
            }
        ];

        $scope.applyFilter = applyFilter;
        $scope.loadNextPage = loadNextPage;
        $scope.clearFilter = clearFilter;
        $scope.hide = hide;
        $scope.cancel = cancel;
        $scope.answer = answer;

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
            $rootScope.$emit('uploaderClosed', {});
        }

        function answer() {
            $mdDialog.hide($scope.selectedImages);
        }

        function loadNextPage() {
            $scope.query.page += 1;
            $scope.fetchImages(false);
        }

        function applyFilter(filter) {
            $scope.suggestedFilters = $scope.suggestedFilters.map(function (f) {
                f.active = false;
                return f;
            });
            if (!$scope.originalQuery) {
                $scope.originalQuery = $scope.query.filter;
            }
            filter.active = true;
            $scope.filterActive = true;
            $scope.query.page = 1;
            $scope.query.filter = {
                query: filter.condition
            }
            $scope.fetchImages(true);
        }

        function clearFilter() {
            $scope.query.filter = $scope.originalQuery;
            $scope.filterActive = false;
            $scope.suggestedFilters = $scope.suggestedFilters.map(function (f) {
                f.active = false;
                return f;
            });
            $scope.query.page = 1;
            $scope.fetchImages(true);
        }

        $scope.hide = function () {
            return $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.answer = function () {
            $mdDialog.hide($scope.selectedImages);
        };

        $scope.showPopup = function (image, ev) {
            var position = $scope._mdPanel.newPanelPosition()
                .relativeTo('#' + image.filename.split(".")[0])
                .addPanelPosition($scope._mdPanel.xPosition.ALIGN_START, $scope._mdPanel.yPosition.BELOW);

            var config = {
                attachTo: angular.element(document.body),
                template:
                    '<div class="demo-menu-example" ' +
                    '     aria-label="Select your favorite dessert." ' +
                    '     role="listbox">' +
                    '  <div class="demo-menu-item" ' +
                    '       ng-class="{selected : dessert == favoriteDessert}" ' +
                    '       aria-selected="{{dessert == favoriteDessert}}" ' +
                    '       tabindex="-1" ' +
                    '       role="option" ' +
                    '       ng-click="ctrl.selectDessert(dessert)"' +
                    '       ng-keydown="ctrl.onKeydown($event, dessert)">' +
                    '    {{ image.filename }} ' +
                    '  </div>' +
                    '</div>',
                panelClass: 'demo-menu-example',
                position: position,
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2
            };

            $scope._mdPanel.open(config);
        };

        $scope.selectImage = function (image) {
            if ($scope.multiSelectionMode) {
                image.selected = !image.selected;
                console.log("selectImage", image);
                var a = _.findIndex($scope.selectedImages, function (o) {
                    return o._id === image._id;
                });
                if (a !== -1) {
                    $scope.selectedImages.splice(a, 1);
                } else {
                    $scope.selectedImages.push(image);
                }
            } else {
                image.selected = !image.selected;
                var a = _.findIndex($scope.selectedImages, function (o) {
                    return o._id === image._id;
                });
                if (a !== -1) {
                    $scope.selectedImages = [];
                } else {
                    $scope.selectedImages[0] = (image);
                }
            }
            // $scope.selectedImages = _.uniq($scope.selectedImages);
        };

        $scope.checkSelecttions = function () {
            if (!$scope.multiSelectionMode) {
                $scope.selectedImages[0].splice(1);
            }
        };

        $scope.openMenu = function ($mdMenu, ev) {
            $mdMenu.open(ev);
        };

        $scope.sortBy = function (attr) {
            $scope.query.sort = attr;
            $scope.query.page = 0;
            $scope.fetchImages(true);
        };

        $scope.querySearch = function (query) {
            return RestManager.getResource("/images/search/" + query, "images");
        };

        $scope.showList = function ($event) {
            $scope.showPanel = true;
            var panelPosition = $mdPanel.newPanelPosition()
                .absolute()
                .bottom('0%')
                .right('1%');
            //
            // var panelAnimation = $mdPanel.newPanelAnimation()
            //     .targetEvent($event)
            //     .withAnimation($mdPanel.animation.SCALE);

            var config = {
                attachTo: ".uploader",
                scope: $scope,
                preserveScope: true,
                // controller: DialogController,
                position: panelPosition,
                targetEvent: $event,
                // animation: panelAnimation,
                panelClass: "white md-whiteframe-5dp",
                templateUrl: 'upload-list.html',
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                hasBackdrop: false,
                trapFocus: false
            };

            $mdPanel.open(config);
        };

        function DialogController(MdPanelRef) {
            function closeDialog() {
                if (MdPanelRef) MdPanelRef.close();
            }
        }

        // $scope.showList();


        $scope.fetchImages = function (replace) {
            $scope.loading = true;
            $scope.promise = RestManager.postResource("/images", $scope.query, "images");
            $scope.promise
                .then(function (images) {
                    $scope.loading = false;
                    images = images.map(function (image) {
                        image.formattedSize = $scope.getSize(image.size);
                        image.formattedFileType = $scope.getFileType(image.extension);
                        image.isCustomisable = !!image.urls.c_large;
                        return image;
                    });
                    if (replace) {
                        $scope.images = images;
                    } else {
                        $scope.images = $scope.images.concat(images);
                    }
                })
                .catch(function (err) {
                    $scope.loading = false;
                    $log.error("Error while fetching images", err)
                });
        };

        $timeout(function () {
            $scope.fetchImages();
        }, 1000);

        $scope.closeSideBar = function () {
            $scope.showInfo = !$scope.showInfo;
        };

        $scope.imageIsPng = function (image) {
            if (image)
                // console.log(image, /((.svg)|(.png))/.test(image.extension));
                return $scope.pngRegex.test(image.extension);
        };

        $scope.imageIsSvg = function (image) {
            if (image)
                return $scope.svgRegex.test(image.extension);
        };

        var initializing = true;

        $scope.$watch('files', function () {
            console.log($scope.files);

            if (initializing) {
                $timeout(function () {
                    initializing = false;
                });
            } else {
                console.log($scope.files);
                $mdDialog.show({
                    scope: $scope,
                    preserveScope: true,
                    fullscreen: true,
                    contentElement: '#myDialog',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false
                });
            }
        });

        $scope.getSize = function (size) {
            return Math.ceil(parseInt(size) / 1024) + " kb";
        };

        $scope.getFileType = function (extension) {
            return _.upperCase(extension);
        };

        $scope.trimFileName = function (name) {
            // var s = name.split("-").sl;
            return _.truncate(name.split("-").slice(0, -1).join("-").split("_").join(" ")
                , {length: 24, omission: "..."});
        };

        $scope.addSize = function () {
            $scope.sizes.push({width: 0, height: 0, attributeName: ""})
        };

        $scope.removeSize = function (index) {
            $scope.sizes.splice(index, 1)
        };

        $scope.log = '';

        // upload on file select or drop
        $scope.upload = function () {
            // console.log(file);
            $scope.hide();
            $scope.showList();
            $scope.uploaded = 0;

            Promise
                .mapSeries($scope.files, function (o) {
                    return $scope.performUpload(o);
                }, {concurrency: 4})
                .then(function (res) {
                    console.log("In the end", res);
                    $scope.context = "";
                    $scope.sizes = [
                        {
                            width: 0,
                            height: 0,
                            attributeName: ""
                        }
                    ];
                    $scope.uploaded = 0;
                    // mdPanelRef.close();
                })
                .catch(function (err) {
                    console.log("Error", err);
                    var toast = $mdToast.simple()
                        .textContent('Failed to upload image')
                        .highlightClass('md-warn')// Accent is used by default, this just demonstrates the usage.
                        .position("bottom right")
                        .capsule(false);

                    $mdToast.show(toast);
                });
            // console.log("data", data);
        };


        $scope.performUpload = function (file) {
            return new Promise(function (resolve, reject) {
                var data = {
                    files: file,
                    context: $scope.context
                };

                if (data.context == "custom") {
                    data.sizes = $scope.sizes;
                }
                console.log(data);
                // con
                Upload.upload({
                    url: Base.getBaseUrl() + "/images/upload",
                    method: 'POST',
                    arrayKey: '',
                    data: data
                }).then(function (resp) {
                    // console.log('Success ', resp.status, 'uploaded. Response: ', resp.data.message);
                    if (resp.data.code == 200) {
                        file.uploaded = true;
                        for (var i in resp.data.message.images) {
                            $scope.images.unshift(resp.data.message.images[i]);
                        }
                        console.log("Complete", file);
                        $scope.uploaded++;
                        resolve(file);
                    } else {
                        console.log("Reject", resp);
                        reject(resp.data.message.error);
                    }
                }, function (resp) {
                    // reject(resp);
                    // console.log('Error status: ' + resp.status);
                }, function (evt) {
                    // console.log(evt);
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    file.progress = progressPercentage;
                    console.log('progress: ' + progressPercentage + '% ', evt.config.data.files);
                });
            })
        }

        $scope.detectEdge = function (image) {
            var canvas = document.createElement('canvas');
            var canvasResult = document.getElementById('image-edge-detector');
            var width , height;
            loadImage(Base.getMediaUrl() + image.urls.full)
                .then(setCanvasSizeFromImage(canvas))
                .then(drawImageOnCanvas(canvas))
                .then(setCanvasSizeFromImage(canvasResult))
                .then(function (image) {
                    const imgd = canvas
                        .getContext('2d')
                        .getImageData(0, 0, image.naturalWidth, image.naturalHeight)
                    // console.log("media.controller.js", "imgd", imgd.data);
                    width = image.naturalWidth;
                    height = image.naturalHeight;
                    console.log("media.controller.js", "ass", width, height);
                    return ImageEdgeDetector.detectEdges(imgd.data, {
                        width: image.naturalWidth,
                        height: image.naturalHeight,
                        ut : 1,
                        lt : 1
                    })
                })
                .then(function (data) {
                    console.log('Data', data);

                    $mdDialog.show({
                        contentElement: '#edge-detector',
                        scope: $scope,
                        preserveScope: true
                    });
                    // canvasResult.style.width = width + 'px';
                    // canvasResult.style.height = height + 'px';
                    console.log("media.controller.js", "image.naturalWidth", width, height);
                    const drawBytesOnCanvasForImg = drawBytesOnCanvas(width, height);
                    drawBytesOnCanvasForImg(canvasResult, data);
                })
                .catch(function (error) {
                    console.log('err', error);
                })
        }
    }]);

(function () {
    'use strict';
    imageGalleryController.$inject = ["$scope", "images", "$mdDialog"];
    angular.module('app.media')
        .controller('imageGallery.controller', imageGalleryController);

    function imageGalleryController($scope, images, $mdDialog) {
        $scope.images = _.compact(images);
        $scope.loading = false;

        $scope.close = close;
        $scope.selectImage = selectImage;

        function close() {
            $mdDialog.cancel();
        }

        function selectImage(image) {
            $scope.selectedImage = image;
        }

        $scope.selectedImage = $scope.images[0];


    }

})(angular);

/**
 * Created by kumardivyarajat on 22/11/16.
 */
angular.module("app.login", [])
    .controller("login.controller", ["$scope", "$stateParams", "$rootScope", "$timeout", "$log", "ErrorHero", "$state", "$analytics", function ($scope, $stateParams, $rootScope, $timeout, $log, ErrorHero, $state, $analytics) {
        console.log("returnTo", $stateParams.returnTo);
        $scope.showRegistrationForm = false;
        $scope.hideCloseBtn = true;

        if (AuthManager.isUserLoggedIn) {
            $state.go("app.account.home");
        }

        if (confData.env === 'prod' && typeof FS !== 'undefined') {
            FS.identify(false);
        }

        $scope.generateLoginClass = function () {
            console.log("sdsdf");

            var min = 1;
            var max = 12;
            $scope.loginClass = "header-" + Math.floor(Math.random() * (max - min + 1)) + min;
            console.log($scope.loginClass);
        };

        $scope.loginUser = function () {
            $scope.loggingIn = true;
            AuthManager.loginUser($scope.user.mobile, $scope.user.password)
                .then(function (user) {
                    $scope.loggingIn = false;
                    console.log("user", user);
                    $analytics.setAlias(user._id);
                    $analytics.setUsername(user.email);
                    $analytics.setUserProperties({
                        name: user.name,
                        email: user.email,
                        role: user.role,
                        mobile: user.mobile,
                        id: user._id,
                        _id: user._id
                    });
                    if (confData.env === 'prod' && typeof FS !== 'undefined') {
                        FS.identify(user._id, {
                            displayName: user.name,
                            email: user.email,
                            role_str : user.role
                        });
                    }
                    $analytics.eventTrack('LoggedIn', {name: user.name, id: user._id});
                    $timeout(function () {
                        $rootScope.$broadcast("loggedIn", {user: user});
                    }, 0);
                    $state.go($stateParams.returnTo);
                    $scope.user = {};
                })
                .catch(function (err) {
                    $scope.loggingIn = false;
                    console.log(err);
                    if (err.code === 423) {
                        $scope.error = "Invalid Mobile/Password";
                    }
                    $log.error(err);
                    ErrorHero(err);
                })
        };

        $scope.toggleForms = function () {
            $timeout(function () {
                $scope.showRegistrationForm = !$scope.showRegistrationForm;
            }, 300);
        };

        $scope.generateLoginClass();
    }]);

/**
 * Created by kumardivyarajat on 04/12/16.
 */
angular.module("app.home", [])
    .controller("home.controller", ["$scope", "AuthManager", "HomePageActions", "$rootScope", "Utils", "$timeout", "$state", "RestManager", "$mdMenu", "$cookies", "$filter", "$q", "$window", function ($scope, AuthManager,
                                             HomePageActions, $rootScope,
                                             Utils, $timeout, $state, RestManager, $mdMenu, $cookies, $filter, $q, $window) {

        $scope.currentUser = AuthManager.getCurrentUser();
        $scope.asana = {};

        // 0: "admin"
        // 1: "hr"
        // 2: "marketing"
        // 3: "designer"
        // 4: "shop-manager"
        // 5: "model"
        // 6: "operator"
        // 7: "sales-staff"
        // 8: "photographer"
        // 9: "customer"

        $scope.generateLayout = generateLayout;

        function generateLayout() {
            $scope.quickActions = HomePageActions.getActions($scope.currentUser.roleSpec, 'quickActions')
            console.log('$socpe.q', $scope.currentUser, $scope.quickActions);
        }



        $scope.asana.authorized = !!$cookies.get("token");

        $scope.authorizeAsana = function () {
            RestManager.getResource("/asana/auth", "url", {local: true})
                .then(function (res) {
                    console.log("home.controller.js", "res", res);
                    var url = res[0].url;
                    $window.location.href = (url);
                })
                .catch(function (err) {
                    console.log("home.controller.js", "err", err);
                })
        };


        $scope.fetchPendingTasks = function () {
            $scope.asana.tasksLoaded = false;
            $scope.asana.err = "";
            RestManager.getResource("/asana/tasks/" + $scope.asana.token, "tasks", {local: true})
                .then(function (data) {
                    $scope.asana.tasks = data;
                    console.log("home.controller.js", "reask", $scope.asana);
                    $scope.asana.tasksLoaded = true;
                })
                .catch(function (err) {
                    console.log("home.controller.js", "err", err);
                    $scope.asana.error = err;
                    $scope.asana.tasksLoaded = true;
                })
        };

        if ($scope.asana.authorized) {
            $scope.asana.token = $cookies.get("token");
            $scope.fetchPendingTasks()
        }

        $rootScope.$on('ROLE_CHANGED', function (evt, data) {
            console.log(data);
            $scope.currentUser.roleSpec = data;
            $scope.generateLayout();
        });

        $scope.generateLayout();
    }]);

(function () {
    'use strict';


    angular.module('app.home')
        .service('HomePageActions', HomePageActions);

    function HomePageActions() {
        this._actions = [
            {
                icon: "add",
                name: "Add New Product",
                state: "app.products.add.home({newProduct: true})",
                class: "gradient-45deg-green-teal",
                allowedRoleSpecs: [0, 2, 3, 4],
                scope : 'quickActions'
            }, {
                icon: "shopping_cart",
                name: "Browse Orders",
                state: "app.orders.all",
                class: "gradient-45deg-red-pink",
                allowedRoleSpecs: [0, 1, 2, 3, 4, 7],
                scope : 'quickActions'
            }, {
                icon: "photo_library",
                name: "Browse Media",
                state: "app.media",
                class: "gradient-45deg-amber-amber",
                allowedRoleSpecs: [0, 2, 3, 4],
                scope : 'quickActions'
            },
            {
                icon: "local_play",
                name: "View Attributes",
                state: "app.products.attributes",
                class: "gradient-45deg-light-blue-cyan",
                allowedRoleSpecs: [0, 2, 3, 4],
                scope : 'quickActions'
            },
            {
                icon: "store",
                name: "View POS Orders",
                state: "app.pos.home",
                class: "gradient-45deg-light-blue-cyan",
                allowedRoleSpecs: [7],
                scope : 'quickActions'
            },
            {
                icon: "add",
                name: "New POS Order",
                state: "app.pos.add",
                class: "gradient-45deg-light-blue-cyan",
                allowedRoleSpecs: [7],
                scope : 'quickActions'
            }
        ]


        this.getActions = function (roleSpec, scope) {
            return this._actions.filter(function (action) {
                return action.allowedRoleSpecs.includes(roleSpec) && action.scope === scope;
            })
        };
    }

})(angular);

(function () {
    "use strict";

    angular.module("app.home")
        .directive("aadiraDataWidget", AadiraDataWidget);

    /**  @ngInject **/
    function AadiraDataWidget() {
        return {
            restrict: "E",
            transclude: true,
            replace: true,
            scope: {
                widgetData: "@",
                widgetName: "@"
            },
            link: function (scope, attrs, element) {
                console.log("product", scope.product);

            },
            templateUrl: "app/modules/home/directives/dataWidget.tpl.html"
        }
    }

})(angular);

(function () {
    'use strict';


    ctrl.$inject = ["$scope", "AuthManager", "RestManager"];
    angular.module('app.home')
        .controller('salesStaff.home.controller', ctrl);

    function ctrl($scope, AuthManager, RestManager) {

        $scope.fetchOrders = fetchOrders;
        $scope.currentUser = AuthManager.getCurrentUser();
        $scope.orders = [];
        $scope.total = 0;
        $scope.fetchingCnt = false;

        $scope.cardData = [
            // Delivery rate inline data
            {
                title: 'Delivery Rate',
                value: 0,
                type: 'percent'
            },
            // parked orders
            {
                title: 'Parked Orders',
                value: 0,
                type: 'number'
            },
            {
                title: 'Delivered Orders',
                value: 0,
                type: 'number'
            },
            {
                title: 'Total Order Value',
                value: 0,
                type: 'number'
            },
            {
                title: 'Delivery Rate',
                value: 0,
                type: 'percent'
            },
            // parked orders
            {
                title: 'Parked Orders',
                value: 0,
                type: 'number'
            },
            {
                title: 'Delivered Orders',
                value: 0,
                type: 'number'
            },
            {
                title: 'Total Order Value',
                value: 0,
                type: 'number'
            }
        ];


        function fetchOrders() {
            $scope.fetchingCnt = true;
            RestManager.postResource("/analytics/Order", {
                queryType: "find",
                queryParams: {
                    createdBy: $scope.currentUser._id
                }
            }, "analytics")
                .then(function (data) {
                    $scope.orders = data;

                    // Delivery rate inline data
                    const deliveryRate = ((data.filter(function (order) {
                        return order.status === 'delivered';
                    }).length) / data.length) * 100;

                    $scope.cardData[0].value = (deliveryRate).toFixed(2);
                    $scope.cardData[0].theme = deliveryRate <= 75 ? 'error' : 'success';

                    const parkedOrders = ((data.filter(function (order) {
                        return order.status === 'incomplete' && order.saleChannel === 'pos';
                    }).length));
                    $scope.cardData[1].value = parkedOrders;
                    $scope.cardData[1].contextMessage = ' out of ' + data.length;
                    $scope.cardData[1].theme = ((parkedOrders / data.length) * 100) >= 75 ? 'error' : 'success';

                    const deliveredOrders = ((data.filter(function (order) {
                        return order.status === 'delivered' && order.saleChannel === 'pos';
                    }).length));
                    $scope.cardData[2].value = deliveredOrders;
                    $scope.cardData[2].contextMessage = ' out of ' + data.length;
                    $scope.cardData[2].theme = ((deliveredOrders / data.length) * 100) <= 75 ? 'error' : 'success';

                    const orderValue = data.reduce(function (a, order) {
                        return (order.status === 'incomplete' && order.saleChannel === 'pos') ? a : a + parseInt(order.amount);
                    }, 0);
                    $scope.cardData[3].value = '₹' + orderValue;
                    $scope.cardData[3].theme = 'success';

                    const thisMonthOrders = data.filter(function (order) {
                       return moment(order.createdAt).isSameOrAfter(moment().startOf('month'));
                    });

                    const deliveryRateMonth = ((thisMonthOrders.filter(function (order) {
                        return order.status === 'delivered';
                    }).length) / thisMonthOrders.length) * 100;


                    $scope.cardData[4].value = (deliveryRateMonth || 0).toFixed(2);
                    $scope.cardData[4].theme = deliveryRateMonth <= 75 ? 'error' : 'success';

                    const parkedOrdersMonth = ((thisMonthOrders.filter(function (order) {
                        return order.status === 'incomplete' && order.saleChannel === 'pos';
                    }).length));
                    $scope.cardData[5].value = parkedOrdersMonth;
                    $scope.cardData[5].contextMessage = ' out of ' + thisMonthOrders.length;
                    $scope.cardData[5].theme = ((parkedOrdersMonth / thisMonthOrders.length) * 100) >= 75 ? 'error' : 'success';

                    const deliveredOrdersMonth = ((thisMonthOrders.filter(function (order) {
                        return order.status === 'delivered' && order.saleChannel === 'pos';
                    }).length));
                    $scope.cardData[6].value = deliveredOrdersMonth;
                    $scope.cardData[6].contextMessage = ' out of ' + thisMonthOrders.length;
                    $scope.cardData[6].theme = ((deliveredOrdersMonth / thisMonthOrders.length) * 100) <= 75 ? 'error' : 'success';

                    const orderValueMonth = thisMonthOrders.reduce(function (a, order) {
                        return (order.status === 'incomplete' && order.saleChannel === 'pos') ? a : a + parseInt(order.amount);
                    }, 0);
                    $scope.cardData[7].value = '₹' + orderValueMonth;
                    $scope.cardData[7].theme = 'success';


                    $scope.generateChartData(data, 'statsData',
                        'statsLabels', 'statsOptions', 'Orders Created By Me Over Time');
                    $scope.generateChartData(thisMonthOrders, 'statsDataMonth',
                        'statsLabelsMonth', 'statsOptionsMonth',
                        'Orders Created By Me This Month');


                    $scope.fetchingCnt = false;


                })
                .catch(function (err) {
                    console.log('Error Sales Satff', err);
                    $scope.fetchingCnt = false;
                })
        }

        $scope.generateChartData = generateChartData;

        function generateChartData(data, dataVar, labelVar, optionsVar, title) {

            var a = _.groupBy(data, function (o) {
                return moment(o.createdAt).format('DD-MM-YY');
            });
            var b = [], c = [];
            _.forOwn(a, function (val, key) {
                b.push(val.length);
                c.push(key);
            });
            $scope[dataVar] = [
                b
            ];
            $scope[labelVar] = c;

            $scope.statsDatasetOverride = [{
                label: "Orders Created",
                fill: true,
                lineTension: 0.2,
                borderColor: "#0094E8",
                backgroundColor: "#D7EEF2",
            }];

            $scope[optionsVar] = {
                title: {
                    display: true,
                    text: title,
                    fontColor: '#0094E8',
                    fontSize: 16
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },
            };
        }

        $scope.fetchOrders();

    }

})(angular);

/**
 * Created by kumardivyarajat on 14/07/17.
 */
angular.module("app.home")
    .controller("designer.home.controller", ["$scope", "RestManager", "AuthManager", function ($scope, RestManager, AuthManager) {
        $scope.currentUser = AuthManager.getCurrentUser();
        $scope.getDesignCount = function () {
            $scope.fetchingCnt = true;
            RestManager.postResource("/products/admin?ctx=home_designs", {created_by : $scope.currentUser._id}, "products", ["total"])
                .then(function (data) {
                    $scope.fetchingCnt = false;
                    $scope.totalProducts = data.total;
                    $scope.designCount = data.products.length;
                    $scope.cntLabels = ["My Designs", "Total Designs"];
                    $scope.cntOptions = {
                        rotation: 0.5 * Math.PI,
                        title: {
                            display: true,
                            text: 'Ratio of products created by me in the organisation',
                            fontColor: '#485fb5',
                            fontSize: 10
                        },
                        legend: {
                            display: false
                        }
                    };
                    $scope.cntColors = ["#D6BF61", "#3F99B5"];
                    $scope.cntDatasetOverride = [{
                        label: "Red Stuff",
                        fill: true,
                        lineTension: 0.2,
                        borderColor: "rgba(255,0,0,1)",
                        backgroundColor: "rgba(255,0,0,0.6)"
                    }];
                    $scope.cntData = [data.products.length, data.total];
                    var b = [], c = [];
                    var a = _.groupBy(data.products, function (o) {
                        return moment(o.createdAt).format('DD-MM-YY');
                    });
                    _.forOwn(a,function (val, key) {
                        b.push(val.length);
                        c.push(key);
                    });

                    console.log("Created", a, b, c);
                    $scope.statsData = [
                        b
                    ];
                    $scope.statsLabels = c;

                    $scope.statsDatasetOverride = [{
                        label: "Designs Created",
                        fill: true,
                        lineTension: 0.2,
                        borderColor: "rgba(255,105,180,0.4)",
                        backgroundColor: "rgba(255,105,180,0.3)",
                    }];

                    $scope.statsOptions = {
                        title: {
                            display: true,
                            text: 'Products added by me day wise for the last month',
                            fontColor: 'rgba(255,105,180,1)',
                            fontSize: 16
                        },
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        },
                    };


                })
                .catch(function (err) {
                    $scope.fetchingCnt = false;
                    console.log(err);
                })
        };
        $scope.getDesignCount();

    }]);

/**
 * Created by kumardivyarajat on 15/07/17.
 */
angular.module("app.home")
    .controller("admin.home.controller", ["$scope", "AuthManager", "Utils", "$timeout", "$state", "RestManager", "$mdMenu", "$filter", "$q", function ($scope, AuthManager, Utils, $timeout, $state, RestManager, $mdMenu, $filter, $q) {
        console.log("err");

        $scope.loading = {};

        var dateFilter = $filter('date');
        $scope.orderCountDays = 1;
        $scope.fetchPopularSources = fetchPopularSources;

        $scope.getOrderDays = function () {
            return moment().subtract($scope.orderCountDays, 'days').toISOString();
        };

        $scope.ordersQuery = {
            queryType: "find",
            queryParams: {
                $or: [
                    {status: {$nin: ["cancelled", "incomplete", "delivered"]}},
                    {status: 'incomplete', saleChannel: 'pos'}
                ]
            },
            queryOptions: {
                select: "user saleChannel orderNumber createdAt amount orderData status paymentMode",
                populate : {path : 'user', select : 'name'},
                sort: "-createdAt",
                limit: 10,
                skip: 0,
                page: 1
            }
        };

        $scope.salesChartOptions = {
            scales: {
                xAxes: [{
                    ticks: {
                        callback: function (label, index, labels) {
                            return moment(label).format('DD MMM YY').toString();
                        }
                    },
                }],
                yAxes: [{
                    ticks: {
                        stepSize: 1,
                        beginAtZero: true
                    }
                }]
            }
        };
        $scope.events = ["Added to Cart", "Checkout Page", "Purchase", "Page Viewed", "Error"];
        $scope.cardData = $scope.events;
        $scope.interval = 1;
        $scope.unit = "day";

        $scope.getAnalyticsData = function (unit, interval) {
            $scope.unit = unit;
            $scope.loading = true;
            RestManager.postResource("/analytics/homepage", {
                events: $scope.events,
                interval: interval,
                unit: $scope.unit
            }, "data")
                .then(function (data) {

                    $scope.cardData = $scope.events.map(function (event) {
                        return {
                            name: event,
                            value: $scope.addUpData(data, event)
                        }
                    });

                    console.log($scope.cardData);
                    $scope.loading = false;
                })
                .catch(function (err) {
                    console.log(err);
                })
        };


        $scope.addUpData = function (data, k) {
            var a = 0;
            _.forOwn(data[0].data.values[k], function (val, key) {
                // console.log(key, val);
                a += val;
            });
            return a;
        };


        $scope.mvplabels = ["Download Sales", "In-Store Sales", "Mail-Order Sales"];
        $scope.mvpdata = [300, 500, 100];


        function fetchPopularSources() {
            $scope.fetchingSources = true;
            RestManager.postResource("/analytics/eventProperties", {
                event: 'Page Viewed',
                name : '$referring_domain',
                unit : 'day',
                from_date: moment().subtract(30, "day").format('YYYY-MM-DD').toString(),
                to_date : moment().format('YYYY-MM-DD').toString()
            }, "data")
                .then(function (data) {
                    $scope.fetchingSources = false;
                    console.log("admin.home.controller.js", "data", data);
                })
                .catch(function (err) {

                })
        }

        $scope.fetchMostPopularProduct = function () {
            $scope.fetchingMP = true;
            RestManager.postResource("/analytics/eventProperties", {
                interval: 2,
                unit: "month",
                name: "product",
                event: "Added to Cart"
            }, "data").then(function (data) {

                var products = [];
                _.forOwn(data[0].data.values, function (val, key) {
                    var product = {name: key, count: 0};
                    _.forOwn(val, function (v, k) {
                        product.count += v;
                    });
                    products.push(product);
                });
                var promises = [];
                products = _.sortBy(products, function (o) {
                    return o.count;
                }).slice(-6).reverse().map(function (o) {
                    promises.push(RestManager.getResource("/products/admin/search/" + o.name, "products"));
                    return o;
                });
                console.log(products);
                return $q.all(promises);
            }).then(function (products) {
                $scope.top_sellingProducts = products;
                $scope.fetchingMP = false;
                console.log("Products", products);
            }).catch(function (err) {
                console.log(err);
            });
        };

        $scope.fetchMostPopularProduct();

        $scope.getSalesDays = function () {
            return moment().subtract($scope.salesCountDays, 'days').toISOString();
        };

        $scope.salesQuery = {
            queryType: "find",
            queryParams: {
                createdAt: {
                    $gte: '',
                    $lte: ''
                }
            }
        };

        $scope.salesTabs = [
            {
                title: "This Week",
                startDate: moment().startOf('week').startOf('day').toISOString(),
                endDate: moment().toISOString(),
                filter: 7
            },
            {
                title: "Last 7 Days",
                startDate: moment().subtract(7, 'days').startOf('day').toISOString(),
                endDate: moment().toISOString(),
                filter: 7
            },
            {
                title: "Last 14 days",
                startDate: moment().subtract(14, 'days').startOf('day').toISOString(),
                endDate: moment().toISOString(),
                filter: 14
            },
            {
                title: "This Month",
                startDate: moment().startOf('month').startOf('day').toISOString(),
                endDate: moment().toISOString(),
                filter: 30
            },
            {
                title: "Last 30 Days",
                startDate: moment().subtract(30, 'days').startOf('day').toISOString(),
                endDate: moment().toISOString(),
                filter: 30
            },
            {
                title: "Last 90 Days",
                startDate: moment().subtract(90, 'days').startOf('day').toISOString(),
                endDate: moment().toISOString(),
                filter: 90
            }
        ];

        $scope.salesCountDays = $scope.salesTabs[0];


        $scope.fetchSalesCount = function () {
            $scope.salesDataLoading = true;
            console.log('Sales', $scope.salesDataLoading);
            $scope.salesQuery.queryParams.createdAt.$gte = $scope.salesCountDays.startDate;
            $scope.salesQuery.queryParams.createdAt.$lte = $scope.salesCountDays.endDate;
            console.log("salesOrdersCount", $scope.salesQuery, $scope.salesCountDays);
            RestManager.postResource("/analytics/Order", $scope.salesQuery, "analytics")
                .then(function (data) {
                    console.log(data);
                    $scope.salesDataLoading = false;
                    $scope.salesCount = data.length;
                    $scope._loadSalesChart(data);
                })
                .catch(function (err) {
                    $scope.salesDataLoading = false;
                    $scope.salesCount = "Error";
                    console.log(err);
                })
        };

        $scope.fetchPendingOrders = function () {
            $scope.loadingPendingOrdes = true;
            $scope.pendingOrdersError = "";

            $scope.ordersQuery.queryOptions.skip = ($scope.ordersQuery.queryOptions.page - 1) * $scope.ordersQuery.queryOptions.limit;
            $scope.fetchingPendingOrdersPromise = RestManager.postResource("/analytics/Order", $scope.ordersQuery, "analytics");


            $scope.fetchingPendingOrdersPromise.then(function (orders) {
                console.log("Pending Orders", orders);
                $scope.loadingPendingOrdes = false;
                $scope.totalOrders = orders.length;
                $scope.pendingOrders = orders.map(function (order) {
                    if (order.saleChannel === 'pos' && order.status === 'incomplete') {
                        order.status = 'parked';
                    }
                    order.daysOpen = moment().diff(order.createdAt, 'days');
                    return order;
                });
            }).catch(function (err) {
                $scope.loadingPendingOrdes = false;
                $scope.pendingOrdersError = "Error";
                console.log(err);
            })
        };

        $scope.fetchPendingOrders();

        $scope._loadSalesChart = function (data) {
            console.log(data);
            if (data.length > 0) {
                $scope.hasNoData = false;
                var dateGroupedOrders = _.groupBy(data, function (o) {
                    return moment(o.createdAt).startOf('day').toISOString();
                });
                console.log("_loadSalesChart", dateGroupedOrders);
                $scope.salesCountlabels = [];
                $scope.salesCountdata = [
                    []
                ];
                var salesCountDays = moment($scope.salesCountDays.endDate).diff(moment($scope.salesCountDays.startDate), 'days')
                console.log('salesCountDays', salesCountDays);
                var startDate = moment().subtract(salesCountDays, 'days');
                var a = {};
                for (var i = 0; i < salesCountDays; i++) {
                    var date = moment(startDate).startOf('day').add(i, 'days').toISOString();
                    console.log('date', date, dateGroupedOrders[date]);
                    if (!a[date]) {
                        a[date] = [];
                    }
                    if (dateGroupedOrders[date]) {
                        a[date] = a[date].concat(dateGroupedOrders[date]);
                    }
                }
                console.log("_loadSalesCountChart", a);
                _.forOwn(a, function (val, key) {
                    $scope.salesCountlabels.push(key);
                    $scope.salesCountdata[0].push(val.length);
                });
                console.log("salesCountlabels", $scope.salesCountlabels);
                console.log("salesCountdata", $scope.salesCountdata);
            } else {
                $scope.hasNoData = true;
            }
        };

        $scope.onTabSelected = function (tab) {
            console.log(tab);
            $scope.salesCountDays = tab;
            $scope.fetchSalesCount();
        };


        $scope.properName = function (name) {
            return Utils.capitalize(name);
        };


        // $scope.fetchOrdersCount();
        // $scope.fetchCartCount();
        // $scope.fetchUserCount();
        // $scope.fetchSalesCount();
        $scope.getAnalyticsData('day', 1);
        // $scope.fetchPopularSources();

    }]);

/**
 * Created by kumardivyarajat on 04/02/17.
 */
angular.module("app.collections", [])
    .controller("group.controller", ["$scope", "$log", "$mdDialog", "RestManager", "$window", "Base", function ($scope, $log, $mdDialog, RestManager, $window, Base) {

        $scope.collections = [];

        $scope.openInWebsite = openInWebsite;
        $scope.deleteCollection = deleteCollection;
        $scope.getProductCountInCollection = getProductCountInCollection;


        function deleteCollection(collection, index, event) {
            var confirm = $mdDialog.confirm()
                .title('Delete the collection ?')
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                // Delete the collection
                RestManager.deleteResource("/collections/" + collection._id)
                    .then(function(){
                        $scope.collections.splice(index, 1);
                    })
                    .catch(function(err){
                        console.log("group.controller.js", "ERROR", err);
                    })
            }, function () {
            });
        }

        $scope.showDialog = function (i, id, ev) {
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                controller: "editCollectionController",
                templateUrl: "app/modules/collections/modals/edit-collection.tmpl.html",
                multiple: true,
                locals: {
                    collectionId: id,
                    rules: null
                }
            })
                .then(function (updateData) {
                    if (updateData.collection) {
                        console.log("group.controller.js", "HERERERERRERE", updateData.collection);
                        updateData.collection.loadingTotal = true;
                        var index;
                        if (i !== null) {
                            index = i;
                            $scope.collections[i] = updateData.collection;
                        } else {
                            index = 0;
                            $scope.collections.unshift(updateData.collection);
                        }
                        $scope.getProductCountInCollection(updateData.collection)
                            .then(function (data) {
                                $scope.collections[index].loadingTotal = false;
                                $scope.collections[index].total = data.total;
                            })
                    }
                })
                .catch(function (err) {
                    console.log("group.controller.js", "ERROR", err);
                });
        };


        function getProductCountInCollection(collection) {
            return RestManager.postResource('/products/admin/preview', _.assign(collection.rules, {actionType: 'count'}), 'preview', {extras: ['total']})
        }

        $scope.showProductsDialog = function (ev, index, collection) {
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                controller: "manageProductsInCollection",
                templateUrl: "app/modules/collections/modals/manage-products.tmpl.html",
                multiple: true,
                locals: {
                    collection: collection,
                    title: "Manage Products in",
                    saveButtonText: "Save",
                    returnQuery: false
                }
            })
                .then(function (updateData) {
                    if (updateData) {
                        updateData.loadingTotal = true;
                        $scope.collections[index] = updateData;
                        $scope.getProductCountInCollection(updateData)
                            .then(function (data) {
                                $scope.collections[index].loadingTotal = false;
                                $scope.collections[index].total = data.total;
                            })
                    }
                })
                .catch(function (err) {
                    console.log("group.controller.js", "ERROR", err);
                });
        };

        $scope.fetchCollections = function () {
            $scope.loadingCollections = true;
            RestManager.getResource("/collections", "collections")
                .then(function (result) {
                    $scope.collections = result;
                    console.log("group.controller.js", "COLELC", $scope.collections);
                    $scope.collections.forEach(function (collection) {
                        collection.loadingTotal = true;
                        $scope.getProductCountInCollection(collection)
                            .then(function (result) {
                                collection.total = result.total;
                                collection.loadingTotal = false;
                            })
                            .catch(function (err) {
                                console.log('err', err);
                                collection.loadingTotal = false;
                            });
                    });
                    $scope.loadingCollections = false;
                })
                .catch(function (err) {
                    console.log(err);
                    $scope.loadingCollections = false;
                });
        };



        function openInWebsite(collection) {
            $window.open(Base.getAppUrl() + '/collection/' + collection.slug, '_blank');
        }


        $scope.fetchCollections();
    }]);

(function () {
    'use strict';
    manageProductCollection.$inject = ["$scope", "$q", "Materials", "RestManager", "returnQuery", "title", "saveButtonText", "Base", "$log", "collection", "$mdDialog", "$mdToast"];
    angular.module("app.collections")
        .controller("manageProductsInCollection", manageProductCollection)
        .filter('percentage', ['$filter', function ($filter) {
            return function (price, mrp) {
                return $filter('number')(((mrp - price) / mrp) * 100, 2) + '%';
            };
        }]);

    function manageProductCollection($scope, $q, Materials, RestManager, returnQuery, title, saveButtonText, Base, $log, collection, $mdDialog, $mdToast) {
        $scope.editingMode = !!collection;
        $scope.collection = collection;
        $scope.productSearch = '';
        $scope.attributeSearch = '';
        $scope.attributeValueSearch = '';
        $scope.materialSerach = '';
        $scope.queryEntities = [
            {
                name: 'Category',
                value: 'categories',
                operands: [
                    {
                        name: 'Equals',
                        value: '$eq',
                        valType: 'String'
                    },
                    {
                        name: 'Not Equals',
                        value: '$ne',
                        valType: 'String'
                    },
                    {
                        name: 'Contained In',
                        value: '$in',
                        valType: 'Array_String'
                    },
                    {
                        name: 'Not Contained In',
                        value: '$nin',
                        valType: 'Array_String'
                    }
                ],
                valType: 'Array_String',
                inputType: 'select',
                triggers: ['fetchCategories']
            },
            {
                name: 'Materials',
                value: 'materials',
                operands: [
                    {
                        name: 'Contained In',
                        value: '$in',
                        valType: 'Array_String'
                    },
                    {
                        name: 'Not Contained In',
                        value: '$nin',
                        valType: 'Array_String'
                    }
                ],
                valType: 'Array_String',
                inputType: 'select'
            },
            {
                name: 'Products',
                value: '_id',
                operands: [
                    {
                        name: 'Contained In',
                        value: '$in',
                        valType: 'Array_String'
                    },
                    {
                        name: 'Not Contained In',
                        value: '$nin',
                        valType: 'Array_String'
                    }
                ],
                valType: 'Array_String',
                inputType: 'select',
                // triggers: ['fetchProducts']
            },
            {
                name: 'Product Type',
                value: 'productType',
                operands: [
                    {
                        name: 'Equals',
                        value: '$eq'
                    },
                    {
                        name: 'Not Equals',
                        value: '$ne'
                    }
                ],
                selectValues: [
                    {
                        name: 'Simple',
                        value: 0
                    },
                    {
                        name: 'Customisable',
                        value: 1
                    }
                ],
                inputType: 'select',
                valType: 'Number'
            },
            {
                name: 'Product Price',
                value: 'price',
                operands: [
                    {
                        name: 'Equals',
                        value: '$eq'
                    },
                    {
                        name: 'Not Equals',
                        value: '$ne'
                    },
                    {
                        name: 'Less Than',
                        value: '$lt'
                    },
                    {
                        name: 'Greater Than',
                        value: '$gt'
                    },
                    {
                        name: 'Less Than Equal To',
                        value: '$lte'
                    },
                    {
                        name: 'Greater Than Equal To',
                        value: '$gte'
                    }
                ],
                inputType: 'number',
                valType: 'Number'
            },
            {
                name: 'Discount Amount',
                value: 'discountAmount',
                operands: [
                    {
                        name: 'Equals',
                        value: '$eq'
                    },
                    {
                        name: 'Not Equals',
                        value: '$ne'
                    },
                    {
                        name: 'Less Than',
                        value: '$lt'
                    },
                    {
                        name: 'Greater Than',
                        value: '$gt'
                    },
                    {
                        name: 'Less Than Equal To',
                        value: '$lte'
                    },
                    {
                        name: 'Greater Than Equal To',
                        value: '$gte'
                    }
                ],
                inputType: 'number',
                valType: 'Number'
            },
            {
                name: 'Discount Percent',
                value: 'discountPercent',
                operands: [
                    {
                        name: 'Equals',
                        value: '$eq'
                    },
                    {
                        name: 'Not Equals',
                        value: '$ne'
                    },
                    {
                        name: 'Less Than',
                        value: '$lt'
                    },
                    {
                        name: 'Greater Than',
                        value: '$gt'
                    },
                    {
                        name: 'Less Than Equal To',
                        value: '$lte'
                    },
                    {
                        name: 'Greater Than Equal To',
                        value: '$gte'
                    }
                ],
                inputType: 'number',
                valType: 'Number'
            },
            {
                name: 'MRP',
                value: 'mrp',
                operands: [
                    {
                        name: 'Equals',
                        value: '$eq'
                    },
                    {
                        name: 'Not Equals',
                        value: '$ne'
                    },
                    {
                        name: 'Less Than',
                        value: '$lt'
                    },
                    {
                        name: 'Greater Than',
                        value: '$gt'
                    },
                    {
                        name: 'Less Than Equal To',
                        value: '$lte'
                    },
                    {
                        name: 'Greater Than Equal To',
                        value: '$gte'
                    }
                ],
                inputType: 'number',
                valType: 'Number'
            },
            {
                name: 'Editor Type',
                value: 'editorType',
                operands: [
                    {
                        name: 'Is',
                        value: '$eq'
                    }
                ],
                selectValues: [
                    {
                        name: 'Simple',
                        value: 'simple'
                    },
                    {
                        name: 'Intermediate',
                        value: 'intermediate'
                    },
                    {
                        name: 'Advanced',
                        value: 'advanced'
                    },
                    {
                        name: 'Not Set',
                        value: {
                            $exists: false
                        },
                        valType: 'Object',
                        flatten: true
                    }
                ],
                inputType: 'select',
                valType: 'String'
            },
            {
                name: 'Created Date',
                value: 'createdAt',
                operands: [
                    {
                        name: 'On',
                        value: '$eq'
                    },
                    {
                        name: 'Not On',
                        value: '$ne'
                    },
                    {
                        name: 'Before',
                        value: '$lt'
                    },
                    {
                        name: 'After',
                        value: '$gt'
                    },
                    {
                        name: 'Before and Including',
                        value: '$lte'
                    },
                    {
                        name: 'After and Including',
                        value: '$gte'
                    }
                ],
                inputType: 'date',
                valType: 'String'
            },
            {
                name: 'Updated Date',
                value: 'updatedAt',
                operands: [
                    {
                        name: 'On',
                        value: '$eq'
                    },
                    {
                        name: 'Not On',
                        value: '$ne'
                    },
                    {
                        name: 'Before',
                        value: '$lt'
                    },
                    {
                        name: 'After',
                        value: '$gt'
                    },
                    {
                        name: 'Before and Including',
                        value: '$lte'
                    },
                    {
                        name: 'After and Including',
                        value: '$gte'
                    }
                ],
                inputType: 'date',
                valType: 'String'
            },
            {
                name: 'Notes Date',
                value: 'notes.date',
                operands: [
                    {
                        name: 'On',
                        value: '$eq'
                    },
                    {
                        name: 'Not On',
                        value: '$ne'
                    },
                    {
                        name: 'Before',
                        value: '$lt'
                    },
                    {
                        name: 'After',
                        value: '$gt'
                    },
                    {
                        name: 'Before and Including',
                        value: '$lte'
                    },
                    {
                        name: 'After and Including',
                        value: '$gte'
                    }
                ],
                inputType: 'date',
                valType: 'String'
            },
            {
                name: 'Attributes',
                value: 'attributes.selectedValues',
                operands: [
                    {
                        name: 'Contained In',
                        value: '$in'
                    },
                    {
                        name: 'Not Contained In',
                        value: '$nin'
                    }
                ],
                valType: 'Array_String',
                inputType: 'select',
                triggers: ['fetchAttributes']
            },
            {
                name: 'Creator',
                value: 'created_by',
                operands: [
                    {
                        name: 'IS',
                        value: '$eq'
                    },
                    {
                        name: 'IS NOT',
                        value: '$ne'
                    },
                    {
                        name: 'IS CONTAINED IN',
                        value: '$in',
                        valType: 'Array_String'
                    },
                    {
                        name: 'IS NOT CONTAINED IN',
                        value: '$nin',
                        valType: 'Array_String'

                    }

                ],
                valType: 'String',
                inputType: 'select',
                triggers: ['getUsers']
            },
            {
                name: 'Published',
                value: 'published',
                operands: [
                    {
                        name: 'IS',
                        value: '$eq'
                    },
                    {
                        name: 'IS NOT',
                        value: '$ne'
                    }
                ],
                selectValues: [
                    {
                        name: 'True',
                        value: true
                    },
                    {
                        name: 'False',
                        value: false
                    }
                ],
                valType: 'Boolean',
                inputType: 'select'
            },
            {
                name: 'Visibility',
                value: 'visibility',
                operands: [
                    {
                        name: 'IS',
                        value: '$eq'
                    },
                    {
                        name: 'IS NOT',
                        value: '$ne'
                    }
                ],
                selectValues: [
                    {
                        name: 'EVERYWHERE',
                        value: 3
                    },
                    {
                        name: 'CATALOG',
                        value: 2
                    },
                    {
                        name: 'SEARCH',
                        value: 1
                    },
                    {
                        name: 'HIDDEN',
                        value: 0
                    },
                ],
                valType: 'Number',
                inputType: 'select'
            },
            {
                name: 'On Sale',
                value: 'isOnSale',
                operands: [
                    {
                        name: 'IS',
                        value: '$eq'
                    },
                    {
                        name: 'IS NOT',
                        value: '$ne'
                    }
                ],
                selectValues: [
                    {
                        name: 'True',
                        value: true
                    },
                    {
                        name: 'False',
                        value: false
                    }
                ],
                valType: 'Boolean',
                inputType: 'select'
            },
            {
                name: 'Out of Stock',
                value: 'outOfStock',
                operands: [
                    {
                        name: 'IS',
                        value: '$eq'
                    },
                    {
                        name: 'IS NOT',
                        value: '$ne'
                    }
                ],
                selectValues: [
                    {
                        name: 'True',
                        value: true
                    },
                    {
                        name: 'False',
                        value: false
                    }
                ],
                valType: 'Boolean',
                inputType: 'select'
            },
            {
                name: 'Coming Soon',
                value: 'comingSoon',
                operands: [
                    {
                        name: 'IS',
                        value: '$eq'
                    },
                    {
                        name: 'IS NOT',
                        value: '$ne'
                    }
                ],
                selectValues: [
                    {
                        name: 'True',
                        value: true
                    },
                    {
                        name: 'False',
                        value: false
                    }
                ],
                valType: 'Boolean',
                inputType: 'select'
            },
            {
                name: 'Is Featured',
                value: 'isFeatured',
                operands: [
                    {
                        name: 'IS',
                        value: '$eq'
                    },
                    {
                        name: 'IS NOT',
                        value: '$ne'
                    }
                ],
                selectValues: [
                    {
                        name: 'True',
                        value: true
                    },
                    {
                        name: 'False',
                        value: false
                    }
                ],
                valType: 'Boolean',
                inputType: 'select'
            },
            {
                name: 'Size Chart',
                value: 'sizeChart',
                operands: [
                    {
                        name: 'IS',
                        value: '$exists'
                    }
                ],
                selectValues: [
                    {
                        name: 'SET',
                        value: true
                    },
                    {
                        name: 'NOT SET',
                        value: false
                    }
                ],
                valType: 'Boolean',
            }

        ];
        $scope.previewProductsList = [];
        $scope.mediaUrl = Base.getMediaUrl();
        $scope.isModified = false;

        $scope.previewQuery = {
            page: 1,
            limit: 10,
            sortBy: collection.sortBy,
            queries: [],
        };
        $scope.productsQuery = {
            page: 1,
            limit: 100,
            orderBy: 'name',
            searchTerm: '',
            query: {published: true},
        };
        $scope.products = [];
        if (title) {
            $scope.pageTitle = title;
        }

        if (saveButtonText) {
            $scope.buttonText = saveButtonText;
        }

        $scope.addQuery = addQuery;
        $scope.removeQuery = removeQuery;
        $scope.selectEntity = selectEntity;
        $scope.fetchCategories = fetchCategories;
        $scope.fetchNextPreview = fetchNextPreview;
        $scope.fetchPreviewProducts = fetchPreviewProducts;
        $scope.showQuery = showQuery;
        $scope.closeDialog = closeDialog;
        $scope.saveUpdateInCollection = saveUpdateInCollection;
        $scope.refetchPreview = refetchPreview;
        $scope.getStartPrice = getStartPrice;
        $scope.changeValTypeOnSelection = changeValTypeOnSelection;
        $scope.fetchAttributes = fetchAttributes;
        $scope.fetchAttributeValue = fetchAttributeValue;
        $scope.getUsers = getUsers;
        $scope.init = init;
        $scope.resetState = resetState;

        function resetState() {
            $scope.collection.rules.queries = [];
            $scope.refetchPreview();
        }

        function removeQuery(index, e) {
            var confirm = $mdDialog.confirm()
                .title('Delete query?')
                .ariaLabel('Lucky day')
                .targetEvent(e)
                .ok('Yes')
                .cancel('No')
                .multiple(true);


            $mdDialog.show(confirm).then(function () {
                $scope.collection.rules.queries.splice(index, 1);
                $scope.refetchPreview();
            }, function () {
            });
        }


        function refetchPreview(onInit) {
            $scope.isModified = !onInit;

            $scope.previewQuery.page = 1;
            $scope.previewProductsList = [];
            $scope.fetchPreviewProducts([]);
        }

        function fetchNextPreview() {
            $scope.previewQuery.page += 1;
            $scope.fetchPreviewProducts($scope.previewProductsList);
        }

        function showQuery(event) {
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                multiple: true,
                fullscreen: true,
                contentElement: '#rawQuery',
                clickOutSideToClose: false
            });
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function getStartPrice(product) {
            if (!product.variations.length) {
                return "Rs 0";
            } else {
                var sp = _.sortBy(product.variations, function (o) {
                    return parseInt(o.mrp);
                });

                return "Rs " + sp[0].mrp;
            }
        }

        function addQuery(index) {
            if (typeof index === 'undefined') {
                $scope.collection.rules.queries.unshift({
                    values: [],
                    enabled: true
                });
            } else {

                $scope.collection.rules.queries.splice(index + 1, 0, {values: [], enabled: true});
            }
        }

        function selectEntity(query) {
            if (query.entity) {
                query.selectedEntity = _.find($scope.queryEntities, function (e) {
                    return e.value === query.entity;
                });

            }

            if (query.selectedEntity && query.selectedEntity.operands) {
                query.selectedOperand = _.find(query.selectedEntity.operands, function (o) {
                    return o.value === query.operand;
                });
            }

            if (query.selectedOperand && query.selectedOperand.valType) {
                query.valType = query.selectedOperand.valType;

            } else {
                query.valType = query.selectedEntity.valType;
                $scope.savingDisabled = true;


            }
            if (query.selectedEntity.triggers) {
                query.selectedEntity.triggers.forEach(function (trigger) {
                    $scope[trigger]();
                });
            }
        }


        function fetchPreviewProducts(appender) {
            $scope.fetchingPreview = true;
            if (!$scope.collection.rules.queries.reduce(function (acc, val) {
                return acc && val.entity && val.operand && (typeof val.value !== 'undefined' || val.values.length)
            }, true)) {
                return;
            }
            angular.copy($scope.collection.rules.queries, $scope.previewQuery.queries);

            $scope.previewQuery.queries = $scope.previewQuery.queries.map(function (value) {
                delete value.selectedEntity;
                delete value.selectedOperand;
                delete value.selectValues2;
                delete value.tempVal;
                return value;
            });
            RestManager.postResource('/products/admin/preview', $scope.previewQuery, 'preview', {extras: ['total']})
                .then(function (result) {
                    if ($scope.previewProductsList.length === $scope.previewTotal) {
                        $scope.allPreviewLoaded = true;
                    }
                    $scope.rawQuery = result.preview[0].rawQuery;
                    $scope.previewProductsList = appender.concat(result.preview[0].products.map(function (value) {
                        value.startPrice = value.startPrice ? "Rs " + value.startPrice : $scope.getStartPrice(value);
                        return value;
                    }));
                    $scope.previewTotal = result.total;
                    $scope.fetchingPreview = false;
                })
                .catch(function (err) {

                    $scope.fetchingPreview = false;
                })
        }

        function getUsers() {
            var q = {
                page: 1,
                limit: 100,
                order: 'name',
                query: {
                    role: {$in: ['admin', 'designer']}
                }
            };
            RestManager.postResource("/users/admin", q, "users")
                .then(function (users) {
                    $scope.users = users;
                })
                .catch(function (err) {

                });
        };


        function changeValTypeOnSelection(tempVal, query) {
            if (tempVal.valType) {
                query.valType = tempVal.valType;
            } else {
                query.valType = query.selectedEntity.valType;
            }
            query.value = tempVal;
            query.flatten = tempVal.flatten;
        }

        function fetchCategories() {
            $scope.loading = true;
            $scope.promise = RestManager.getResource("/categories", "categories")
            $scope.promise
                .then(function (categories) {
                    $scope.categories = categories;
                    $log.info(categories, $scope.parentCategories);
                    $scope.loading = false;
                })
                .catch(function (err) {
                    $log.error(err);
                    $scope.loading = false;
                })
        }

        function fetchAttributes() {
            if ($scope.attributes && $scope.attributes.length) {
                return $q.resolve();
            }
            return RestManager.getResource("/attributes", "attributes")
                .then(function (attributes) {
                    $scope.attributes = attributes
                })
                .catch(function (err) {

                });
        }

        function fetchAttributeValue(attributeId, query, init) {
            query.selectValues2 = _.find($scope.attributes, function (attribute) {
                return attribute._id === attributeId;
            }).meta_values;
            if (!init) {
                query.values = [];
            }
        }

        $scope.checkProduct = function (product) {
            return $scope.asd(product) !== -1;
        };

        $scope.asd = function (product) {
            if ($scope.selectedCollection1) {
                return _.findIndex($scope.selectedCollection1.products, function (o) {
                    return o._id === product._id;
                });
            }
        };

        $scope.fetchProducts = function (search) {

            // if ($scope.productsQuery.showOnlyCollectionProducts) {
            //     $scope.productsQuery.query.$in = [];
            // } else {
            //     delete $scope.productsQuery.query.$in;
            // }
            return $q(function (resolve, reject) {
                if (search.length > 1) {
                    $scope.fectchingProducts = true;
                    $scope.refresh = true;
                    RestManager.getResource("/products/admin/fastSearch/" + search, "products")
                        .then(function (products) {
                            products = products.map(function (product) {
                                product.image = $scope.mediaUrl + product.featured_image.urls.thumbnail;
                                product.price = '₹' + product.price;
                                product.sku = 'SKU : ' + product.sku;
                                return product;
                            })
                            resolve(products);
                        })
                        .catch(reject)
                } else {
                    resolve([]);
                }
            })

        };


        $scope.fetchMaterials = function () {
            Materials.autoCompleteMaterialByName($scope.materialSerach)
                .then(function (result) {
                    $scope.materials = result;
                })
                .catch(function (err) {

                })
        }

        $scope.fetchSelectedMaterials = function (materialIds) {
            Materials.getAllMaterials({
                page: 1,
                limit: 100,
                ids: materialIds.join(','),
                fields: 'name,image'
            })
                .then(function (result) {
                    $scope.materials = result.materials;
                })
                .catch(function (err) {
                    $mdToast.show($mdToast.showSimple('Error fetching materials from server : ' + err.message));
                })
        }

        $scope.fetchSelectedProducts = function (productsList) {
            $scope.fectchingProducts = true;
            $scope.refresh = true;
            RestManager.postResource('/products/admin', {
                query: [{
                    "values": productsList,
                    "enabled": true,
                    "entity": "_id",
                    "valType": "Array_String",
                    "operand": "$in"
                }]
            }, 'products')
                .then(function (products) {
                    $scope.fectchingProducts = false;
                    $scope.refresh = false;
                    $scope.products = products;
                })
                .catch(function (err) {
                    $scope.fectchingProducts = false;
                    $scope.refresh = false;
                    $mdToast.show($mdToast.showSimple('Error fetching products from server : ' + err.message));
                })
        };

        function saveUpdateInCollection() {
            if (returnQuery) {
                // delete $scope.collection.rules.queries.selectedEntity;
                // delete $scope.collection.rules.queries.selectedOperand;
                $mdDialog.hide({
                    queries: $scope.collection.rules.queries,
                    sortBy: $scope.previewQuery.sortBy,
                    modified: $scope.isModified
                });
            } else {
                var payload = {};
                angular.copy($scope.collection, payload);
                if (payload.headerImage) {
                    payload.headerImage = payload.headerImage._id;
                }
                if (payload.image) {
                    payload.image = payload.image._id;
                }
                if (payload.products) {
                    payload.products = payload.products.map(function (o) {
                        return o._id;
                    })
                }

                payload.sortBy = $scope.previewQuery.sortBy;
                var promise = RestManager.putResource("/collections", payload, "collections");
                promise.then(function (result) {
                    $mdToast.showSimple('Saved Collection', 3000);
                    $mdDialog.hide(result[0]);

                })
                    .catch(function (err) {
                        console.log(err);
                    });
            }
        }

        function init() {
            console.log("Check collection", $scope.collection);
            if (!$scope.collection) {
                $scope.collection = {};
            }
            if (!$scope.collection.rules) {
                $scope.collection.rules = {};
            }
            if (!$scope.collection.rules.queries) {
                $scope.collection.rules.queries = [];
            } else {
                $scope.refetchPreview(true);
            }

            if ($scope.collection.rules.queries.length) {
                $scope.disableGroup = true;
                $scope.fetchAttributes()
                    .then(function () {
                        $scope.collection.rules.queries.forEach(function (query) {
                            $scope.selectEntity(query);
                            if (query.entity === 'attributes.selectedValues') {
                                $scope.fetchAttributeValue(query.value, query, true);
                            }
                            if (query.entity === 'editorType') {
                                $scope.changeValTypeOnSelection(query.value, query);
                            }
                        });
                    });
            }


            var productsRule = _.find($scope.collection.rules.queries, function (query) {
                return query && query.selectedEntity && query.selectedEntity.name === 'Products';
            });

            if (productsRule) {
                $scope.fetchSelectedProducts(productsRule.values);
            }

            var materialsRule = _.find($scope.collection.rules.queries, function (query) {
                return query && query.selectedEntity && query.selectedEntity.name === 'Materials';
            });

            if (materialsRule) {
                $scope.fetchSelectedMaterials(materialsRule.values);
            }
        }

        $scope.init();


    }

})(angular);

(function () {
    'use strict';
    editCollection.$inject = ["$scope", "RestManager", "collectionId", "rules", "$mdDialog", "CriticalUpdateConfirmation"];
    angular.module("app.collections")
        .controller("editCollectionController", editCollection);

    function editCollection($scope, RestManager, collectionId, rules, $mdDialog, CriticalUpdateConfirmation) {

        $scope.collectionId = collectionId;
        $scope.editingMode = !!collectionId;
        $scope.collection = {
            public: false,
            rules: {queries: rules}
        };

        $scope.fetchCollection = fetchCollection;
        $scope.saveCollection = saveCollection;
        $scope.cancel = $mdDialog.cancel;
        $scope.openSingleUploader = openSingleUploader;
        $scope.changePrivateField = changePrivateField;
        $scope.closePrivateConfirmationDialog = closePrivateConfirmationDialog;
        $scope.updateName = updateName;

        function updateName() {
            $scope.collectionName = $scope.collection.name;
        }

        function fetchCollection() {
            RestManager.getResource('/collections/id/' + $scope.collectionId, 'collections')
                .then(function (data) {
                    $scope.collection = data[0];
                    $scope.collectionName = $scope.collection.name;
                    $scope.collectionName1 = '';
                })
                .catch(function (err) {
                    console.log("edit-collections-controller.js", "ERROR", err);
                });
        }

        function saveCollection() {
            var a = {};
            angular.copy($scope.collection, a);
            if (a.headerImage) {
                a.headerImage = a.headerImage._id;
            }
            if (a.image) {
                a.image = a.image._id;
            }
            if (a.products) {
                a.products = a.products.map(function (o) {
                    return o._id;
                })
            }
            console.log("Save ", a);
            var promise;
            if ($scope.editingMode) {
                promise = RestManager.putResource("/collections", a, "collections")
            } else {
                promise = RestManager.postResource("/collections", a, "collections")
            }
            promise
                .then(function (result) {
                    $mdDialog.hide({collection: result[0]});
                })
                .catch(function (err) {
                    console.log(err);
                });
        }

        function closePrivateConfirmationDialog(success) {
            if (!success) {
                $scope.collection.public = false;
            }
            $mdDialog.cancel();

        }

        function openSingleUploader(ev, where, index) {
            $mdDialog.show({
                locals: {
                    multipleSelect: false,
                    select: "header",
                    options : null
                },
                controller: "upload.controller",
                multiple: true,
                fullscreen : true,
                templateUrl: 'app/modules/base/partials/uploader.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            })
                .then(function (images) {
                    if (where === 0) {
                        $scope.collection.headerImage = images[0];
                    } else if (where === 1) {
                        $scope.collection.image = images[0];
                    }
                }, function () {

                });

        }

        function changePrivateField(ev) {
            if ($scope.collection.public) {
                CriticalUpdateConfirmation.showDialog({
                    targetEvent : ev,
                    title : 'Change Collection Type',
                    description : 'Before changing, please confirm the name of the collection.',
                    infoMessage : 'This will make the collection public',
                    inputValidatorString : $scope.collectionName
                })
                    .then(function (result) {
                        if(!result) {
                            $scope.collection.public = false;
                        }
                    })
                    .catch(function (err) {
                        $scope.collection.public = false;
                    })
            }

        }


        if ($scope.editingMode) {
            $scope.fetchCollection();
        }


    }

})(angular);

/**
 * Created by abhinav on 31/01/19.
 */

(function () {
    'use strict';

    userNotificationsController.$inject = ["$scope", "order", "Utils", "options", "$mdDialog", "$rootScope", "RestManager", "Base", "$mdToast", "NotificationTags"];
    angular.module("app.main")
        .controller("notificationsController", userNotificationsController);

    function userNotificationsController($scope, order, Utils, options, $mdDialog, $rootScope, RestManager, Base, $mdToast,
                                         NotificationTags) {
        if (Array.isArray(order)) {
            $scope.orders = order;
        } else {
            $scope.orders = [order];
        }
        console.log("user-notifications-controller.js", "userNotificationsController", order.user);
        $scope.sendSmsNotification = sendSmsNotification;
        $scope.cancel = cancel;
        $scope.currentTab = 0;
        $scope.smsActiveTag = '';
        $scope.appliedOffer = null;
        $scope.smsText = ''
        $scope.emailText = null;
        $scope.emailSubject = null;
        $scope.sendingEmail = false;

        $scope.emailCC = (options.email && options.email.cc) || [];
        $scope.emailBCC = (options.email && options.email.bcc) || [];
        $scope.emailTo = (options.email && options.email.to) || [];
        $scope.replyTo = (options.email && options.email.replyTo) || {
            name: 'Aarida Support',
            email: 'support@aarida.com'
        };
        $scope.emailFrom = (options.email && options.email.from && options.email.from) || {
            name: 'Aarida Team',
            email: 'support@aarida.com'
        };
        $scope.orders = $scope.orders.map(function (order, index) {
            order.id = index;
            var addressString = '';
            if (order.cachedAddress) {
                addressString = _.toUpper(order.cachedAddress.name) + '\n';
                addressString += _.toUpper(order.cachedAddress.streetAddress) + '\n';
                if (order.cachedAddress.landmark) {
                    addressString += _.toUpper(order.cachedAddress.landmark) + "\n";
                }
                addressString += _.toUpper(order.cachedAddress.city) + ',' + _.toUpper(order.cachedAddress.state) + "\n";
                addressString += _.toUpper(order.cachedAddress.pinCode) + "\n";
                addressString += _.toUpper(order.cachedAddress.mobile);
            }
            var expiryDays = null;
            if (order.expiryDate) {
                var diff = moment(order.expiryDate).diff(moment(), 'days');
                if (diff === 0) {
                    expiryDays = 'today';
                } else if (diff === 1) {
                    expiryDays = 'in 1 day';
                } else {
                    expiryDays = 'in ' + diff + ' days';
                }
            }
            order.smsAllowed = options.disableSms || !!(order.user.mobile && order.user.mobile !== '9999999998' && /^[56789]\d{9}$/.test(order.user.mobile));
            order.tagCtxVars = {
                userName: Utils.getProperName(order.user.name, 40),
                userMobile: order.user ? order.user.mobile : null,
                userEmail: order.user ? order.user.email : null,
                orderNumber: order.orderNumber,
                createdAt: moment(order.createdAt).format('Do MMM, YYYY').toString(),
                customerCareNumber: '08041521574',
                orderAmount: "Rs. " + order.amount,
                newDeliveryDate: null,
                orderLink: (order.links && order.links.shortUrl) ? order.links.shortUrl : Base.getAppUrl() + '/account/orders/' + order.orderNumber,
                orderReviewLink: (order.links && order.links.shortUrl) ? order.links.shortUrl : Base.getAppUrl() + '/account/orders/' + order.orderNumber + '?askForReview=true&h=' + window.btoa(order.user.mobile),
                cartLink: 'https://sl.aarida.com/2WYAFNc',
                offerText: '{{offerText}}',
                cardAmount: order.amount,
                redeemLink: order.shortLink,
                cardCode: order.code,
                productsCount: (order.orderData && order.orderData.products) ? (order.orderData.products.length + (order.orderData.products.length > 1 ? ' products' : ' product')) : 'null',
                agentName: order.agent ? order.agent.name : '',
                agentMobile: order.agent ? order.agent.mobile : '',
                organisation: order.organisation ? order.organisation.name : '',
                awbCode: order.awbCode,
                customerName: order.customer ? Utils.getProperName(order.customer.name, 40) : 'NA',
                addressString: addressString,
                emailText: $scope.emailText ? $scope.emailText : '',
                emailSubject: 'Shipment of Orders - ' + order.orderNumber,
                emailCC: $scope.emailCC ? $scope.emailCC : [],
                emailBCC: $scope.emailBCC ? $scope.emailBCC : [],
                replyTo: $scope.replyTo ? $scope.replyTo : [],
                emailFrom: $scope.emailFrom ? $scope.emailFrom : null,
                emailTo: $scope.emailTo ? $scope.emailTo : [],
                status: order.status ? order.status : '',
                giftCardAmount: order.giftCardAmount,
                templateId: order.templateId ? order.templateId : null,
                orderId: order._id,
                index: index,
                expiryDate: order.expiryDate ? moment(order.expiryDate).format('Do MMM').toString() : null,
                expiringDays: expiryDays
            };
            return order;
        });

        $scope.validSMSUsers = _.filter($scope.orders, function (order) {
            return order.smsAllowed;
        }).length || 0;

        console.log("user-notifications-controller.js", "userNotificationsController", $scope.validSMSUsers);

        $scope.smsType = 'transactional';
        $scope.newDeliveryDate = null;
        $scope.templates = [];
        $scope.templateTags = [];
        $scope.allowedTags = (options && options.allowedTags) || ['all'];
        $scope.allowedContext = (options && options.context) || null;
        $scope.allowedScopes = (options && options.scopes) || null;
        $scope.selectedIndex = (options && options.selectedIndex) || 0;
        $scope.isTemplateEditorOpen = false;
        $scope.showEditButton = false;

        $scope.init = init;
        $scope.onTabChange = onTabChange;
        $scope.applyTag = applyTag;
        $scope.applyInterpolation = applyInterpolation;
        $scope.applyDateInterpolation = applyDateInterpolation;
        $scope.fetchOffers = fetchOffers;
        $scope.applyOfferInterpolation = applyOfferInterpolation;
        $scope.fetchUserNotifications = fetchUserNotifications;
        $scope.openWhatsAppWindow = openWhatsAppWindow;
        $scope.sendEmailNotification = sendEmailNotification;
        $scope.truncate = _.truncate;
        $scope.selectOrder = selectOrder;
        $scope.queryUsers = queryUsers;
        $scope.reComputeTags = reComputeTags;
        $scope.openTemplateEditor = openTemplateEditor;

        $scope.selectedOrder = $scope.orders[0];
        $scope.reComputeTags();

        function reComputeTags() {
            $scope.tags = NotificationTags.getAvailableTags($scope.allowedTags, $scope.allowedContext, $scope.allowedScopes);
            $scope.selectedOrder = $scope.orders[0];

            $scope.templates = $scope.tags.filter(function (tag) {
                return tag.isTemplate;
            });

            $scope.templateTags = $scope.tags.filter(function (tag) {
                return !tag.isTemplate;
            });

            console.log("user-notifications-controller.js", "reComputeTags", $scope.selectedOrder);
        }

        function fetchOffers() {
            $scope.query = {
                page: 1,
                limit: 50,
                query: {
                    expiryDate: {$gte: moment().startOf('day').toISOString()},
                    startDate: {$lte: moment().startOf('day').toISOString()},
                    applicableTo: 0, // Applicable to Cart,
                    currentStatus: 1
                },
                sort: '-createdAt'
            };
            $scope.promise = RestManager.getResource("/coupons/coupons", "coupons", {
                extras: ['total'],
                query: $scope.query
            });

            $scope.promise
                .then(function (result) {
                    $scope.offers = result.coupons;
                    $scope.totalOffers = result.total;
                })
                .catch(function (err) {
                    $log.error(err);
                })
        }

        function fetchUserNotifications() {
            $scope.loadingOldNotifications = true;
            var notificationsQuery = {
                queryType: "find",
                queryParams: {
                    user: $scope.selectedOrder.user._id
                },
                queryOptions: {
                    limit: 4,
                    page: 1,
                    sort: '-createdAt',
                    populate: {path: 'sentBy', select: 'name'}
                }
            };
            RestManager.postResource("/analytics/Sms", notificationsQuery, "analytics")
                .then(function (data) {
                    if (data) {
                        $scope.oldNotifications = data;
                    }
                    $scope.loadingOldNotifications = false;
                })
                .catch(function (er) {
                    $scope.loadingOldNotifications = false;
                })
        }

        function applyOfferInterpolation(ctx) {
            $scope.orders = $scope.orders.forEach(function (order) {
                order.tagCtxVars.offerText = 'Get ' + $scope.appliedOffer.discountText + ' by using code ' + $scope.appliedOffer.couponCode + ' during checkout.';
                order.smsText = $scope.applyInterpolation(order.smsText, order);
                order.tagCtxVars.offerText = '{{offerText}}';
            });
            $scope.appliedOffer = '';
        }

        function applyDateInterpolation(ctx) {
            $scope.orders = $scope.orders.forEach(function (order) {
                order.tagCtxVars.newDeliveryDate = moment($scope.newDeliveryDate).format('Do MMM, YYYY').toString();
                $scope.applyTag(_.find($scope.tags, function (tag) {
                    return tag.title === $scope.smsActiveTag;
                }), ctx);
            })
        }

        function applyInterpolation(content, order) {
            var interpolatedContent = content;
            Object.keys(order.tagCtxVars).forEach(function (v) {
                interpolatedContent = _.replace(interpolatedContent, new RegExp('{{' + v + '}}', 'g'), order.tagCtxVars[v]);
            });

            // Needed to show/hide the offer selection box
            $scope.showOfferSelection = interpolatedContent.indexOf('{{offerText}}') !== -1;
            return interpolatedContent;
        }

        function applyTag(tag, ctx) {
            switch (ctx) {
                case 'sms':
                    if (tag.replace) {
                        $scope.smsActiveTag = tag.title;
                        $scope.smsActiveTagObject = tag;
                        $scope.orders.forEach(function (order) {
                            order.smsText = $scope.applyInterpolation(tag.content, order);
                        })
                    } else {
                        // $scope.smsText += $scope.applyInterpolation(tag.content);
                        $rootScope.$broadcast('add', $scope.applyInterpolation(tag.content, $scope.selectedOrder));
                    }
                    if (tag.isTemplate) {
                        if (tag.smsType) {
                            $scope.smsType = tag.smsType;
                        } else {
                            $scope.smsType = 'transactional';
                        }
                    }
            }
        }

        function onTabChange(tabNumber) {
            $scope.currentTab = tabNumber;
            var scopes = [];
            switch (tabNumber) {
                case 0:
                    scopes = ['sms'];
                    break;
                case 1:
                    scopes = ['whatsapp'];
                    break;
                case 2:
                    scopes = ['email'];
                    break;
            }
            $scope.allowedScopes = scopes;
            $scope.reComputeTags();
        }

        function sendSmsNotification() {
            $scope.sendingSms = true;
            var chunks = _.chain($scope.orders)
                .filter(function (order) {
                    return order.smsAllowed;
                })
                .chunk(5)
                .value();
            Promise.map(chunks, function (orders) {
                var data = {
                    messages: orders.map(function (order) {
                        return {
                            message: order.smsText,
                            mobile: order.user.mobile,
                            userId: order.user._id,
                            orderId: order._id,
                            smsType: $scope.smsType
                        }
                    })
                };
                return RestManager.postResource("/notifications/send/sms", data, "data")
            })
                .then(function (result) {
                    var results = _.flatten(result);
                    $scope.sendingSms = false;
                    $mdToast.show($mdToast.simple()
                        .textContent('SMS has been sent to ' + $scope.validSMSUsers + ' users')
                        .hideDelay(2000)
                        .position('bottom right'));

                    $mdDialog.hide(results);

                })
                .catch(function (err) {
                    console.log(err);
                    $scope.sendingSms = false;
                    $mdToast.show($mdToast.simple()
                        .textContent('Error Sending Message : ' + (err.message || 'Unknown Error'))
                        .hideDelay(2000)
                        .position('bottom right'));

                });
        }

        function init() {
            $scope.fetchUserNotifications();
            if (options && options.selectedTemplate) {
                var findTag = _.find($scope.tags, function (tag) {
                    return tag.title === options.selectedTemplate
                });
                if (findTag) {
                    $scope.applyTag(findTag, 'sms');
                } else {
                    console.error('Passed option ' + options.selectedTemplate + ' is not a valid tag.');
                }
            }

            $rootScope.$on('interpolationDone', function (e, val) {
                if (!$scope.isTemplateEditorOpen) {
                    $scope.selectedOrder.smsText = val;
                }
            });

            $scope.smsAllowed = options.disableSms || !!($scope.selectedOrder.user.mobile && $scope.selectedOrder.user.mobile !== '9999999998' && /^[56789]\d{9}$/.test($scope.selectedOrder.user.mobile));

            $scope.whatsAppAllowed = options.disableWhatsapp || !!($scope.selectedOrder.user.mobile && $scope.selectedOrder.user.mobile !== '9999999998' && /^[56789]\d{9}$/.test($scope.selectedOrder.user.mobile));
            $scope.emailAllowed = options.disableEmail || !!($scope.selectedOrder.user.email && /.+\@.+\..+/.test($scope.selectedOrder.user.email));

        }

        function selectOrder(order) {
            $scope.selectedOrder = order;
            $scope.fetchUserNotifications();
        }

        function openWhatsAppWindow() {
            var url = 'https://api.whatsapp.com/send?phone=91' + $scope.selectedOrder.user.mobile + '&text=' + encodeURIComponent($scope.selectedOrder.smsText);
            var win = window.open(url, '_blank');
            win.focus();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function sendEmailNotification() {
            $scope.sendingEmail = true;
            var payload = {
                subject: $scope.selectedOrder.tagCtxVars.emailSubject || $scope.smsActiveTagObject.messageSubject ||
                    'Message from Aarida',
                message: $scope.selectedOrder.tagCtxVars.emailText,
                to: $scope.selectedOrder.tagCtxVars.emailTo,
                cc: $scope.selectedOrder.tagCtxVars.emailCC,
                bcc: $scope.selectedOrder.tagCtxVars.emailBCC,
                replyTo: $scope.selectedOrder.tagCtxVars.replyTo,
                emailTo: $scope.selectedOrder.tagCtxVars.emailTo,
                emailFrom: $scope.selectedOrder.tagCtxVars.emailFrom,
                status: $scope.selectedOrder.tagCtxVars.status,
                templateId: $scope.smsActiveTagObject.templateData.id,
                orderId: $scope.selectedOrder.tagCtxVars.orderId,
                templateData: {
                    orderNumber: $scope.selectedOrder.orderNumber,
                    orders: [
                        {
                            sl: $scope.selectedOrder.tagCtxVars.index + 1,
                            orderNumber: $scope.selectedOrder.tagCtxVars.orderNumber,
                            name: $scope.selectedOrder.tagCtxVars.userName,
                            count: $scope.orders[0].tagCtxVars.productsCount.replace(/product|products/, ''),
                            giftCardAmount: '₹ ' + $scope.selectedOrder.tagCtxVars.giftCardAmount,
                            address: $scope.selectedOrder.tagCtxVars.addressString,
                            orderId: $scope.selectedOrder.tagCtxVars.orderId
                        }
                    ]
                }
            };
            RestManager.postResource("/mailer/multipleNotifications", payload, "result")
                .then(function (result) {
                    $scope.sendingEmail = false;
                    $mdDialog.hide(result);
                })
                .catch(function (err) {
                    $mdToast.showSimple("Some error occurred -" + err);
                    console.log(err);
                    $scope.sendingEmail = false;
                });
        }

        function queryUsers(searchText) {
            return RestManager.getResource("/users/filter", "users", {
                query: {
                    q: searchText,
                    fields: 'name,email, profileImageURL',
                    page: 1,
                    limit: 5
                }
            })
                .then(function (users) {
                    return users;
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error loading user : ' + err.message);
                })
        }

        function openTemplateEditor(event, template, index) {
            var tags = [];
            angular.copy($scope.templateTags, tags);
            var payloadTemplate;
            if (template) {
                payloadTemplate = {};
                angular.copy(template, payloadTemplate);
            }
            $scope.isTemplateEditorOpen = true;
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                fullscreen: true,
                multiple: true,
                templateUrl: 'app/modules/components/notifications/notification-template-builder.dialog.html',
                locals: {
                    templateTags: tags,
                    template: payloadTemplate,
                    contexts: ['order']
                },
                controller: 'template-builder.controller',
                clickOutsideToClose: true
            }).then(function (data) {
                if (data && data.template) {
                    if (data.editing) {
                        $scope.templates.splice(index, 1, data.template);
                        $scope.applyTag($scope.templates[index], 'sms');
                    } else {
                        $scope.templates.push(data.template);
                        $scope.applyTag($scope.templates[$scope.templates.length - 1], 'sms');
                    }
                    // $scope.reComputeTags();
                }
                $scope.showEditButton = false;
                $scope.isTemplateEditorOpen = false;
            }).catch(function (error) {
                $scope.isTemplateEditorOpen = false;
            })
        }

        $scope.init();
    }

})(angular);


/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 22/6/19 5:38 AM
 *
 */


(function () {
    'use strict';


    angular.module('app.main')
        .service('NotificationTags', NotificationTags);

    function NotificationTags() {
        var availableTags = [
            {
                title: 'Business Card',
                replace: true,
                isTemplate: true,
                context : [],
                content: 'Dear {{userName}}. Welcome to Aarida, India\'s Premier Customised Clothing Store. You can get directions to our Flagship store by clicking : https://goo.gl/maps/oJnFYWnLTmpqnc1RA . We offer Customisation on Lehengas, Blouses, Tops, Dresses, Skirts and much more. Visit https://www.aarida.com to purchase online. Call us on {{customerCareNumber}} if you have any queries.'
            },
            {
                title: 'Order Delayed',
                replace: true,
                isTemplate: true,
                context : ['order status', 'order'],
                content: 'Dear {{userName}}. Due to an unusually high volume of orders with us, your order with order number {{orderNumber}} has been delayed and will now be delivered by {{newDeliveryDate}}. Sorry for any inconvenience caused. Track order progress {{orderReviewLink}}. Call us on {{customerCareNumber}} if you have any queries.'
            },
            {
                title: 'Order Review',
                replace: true,
                isTemplate: true,
                context : ['order status', 'order'],
                content: 'Dear {{userName}}. Do you like the items you purchased from us on {{createdAt}}? Kindly provide us your valuable feedback by visiting {{orderReviewLink}}. Call us on {{customerCareNumber}} if you have any queries.'
            },
            {
                title: 'Ready for Pickup',
                replace: true,
                isTemplate: true,
                context : [ 'order'],
                content: 'Your order with order number {{orderNumber}} is ready for pickup from our store. Track order progress {{orderReviewLink}}. Customer Care {{customerCareNumber}}.'
            },
            {
                title: 'Order Placed',
                replace: true,
                isTemplate: true,
                context : ['order status', 'order'],
                content: 'Dear {{userName}}. Your order with order number {{orderNumber}} worth Rs {{orderAmount}} is placed. Track order progress {{orderReviewLink}}. Customer Care {{customerCareNumber}}.'
            },
            {
                title: 'Order Processing',
                replace: true,
                isTemplate: true,
                context : ['order status', 'order'],
                content: 'Dear {{userName}}. Your order with order number {{orderNumber}} is under processing. We will notify you once its ready. Track order progress {{orderReviewLink}}. Customer Care {{customerCareNumber}}.'
            },
            {
                title: 'Order Packed',
                replace: true,
                isTemplate: true,
                context : ['order status', 'order'],
                content: 'Dear {{userName}}. Your order with order number {{orderNumber}} is packed and ready to be shipped. Track order progress {{orderReviewLink}}. Customer Care {{customerCareNumber}}.'
            },
            {
                title: 'Order Shipped',
                replace: true,
                isTemplate: true,
                context : ['order status', 'order'],
                content: 'Dear {{userName}}. Your order with order number {{orderNumber}} is shipped and should reach you soon. Track order progress {{orderReviewLink}}. Customer Care {{customerCareNumber}}.'
            },
            {
                title: 'Agent :: Order Shipped',
                replace: true,
                isTemplate: true,
                context : ['agent order status', 'order'],
                content: 'Dear {{userName}}. The order for {{customerName}} with order number {{orderNumber}} containing {{productsCount}} has been shipped and should reach you soon. Track shipment: https://tracklite.in/track/{{awbCode}} . Customer Care {{customerCareNumber}}.'
            },
            {
                title: 'Order Shipped - To Agent',
                replace: true,
                isTemplate: true,
                context : ['order status', 'order'],
                content: 'Dear {{userName}}. Your order with order number {{orderNumber}} is shipped and will be delivered to the {{organisation}} representative {{agentName}} ({{agentMobile}}) soon. They will deliver the order to you. Track order progress {{orderReviewLink}}. Customer Care {{customerCareNumber}}.'
            },
            {
                title: 'Agent :: Order Delivered',
                replace: true,
                isTemplate: true,
                context : ['agent order status', 'order'],
                content: 'Dear {{userName}}. The order for {{customerName}} with order number {{orderNumber}} containing {{productsCount}} has been delivered successfully. Request you to kindly deliver it to the customer soon. Customer Care {{customerCareNumber}}.'
            },
            {
                title: 'Order Delivered - To Agent',
                replace: true,
                isTemplate: true,
                context : ['order status', 'order'],
                content: 'Dear {{userName}}. Your order with order number {{orderNumber}} has been delivered to the {{organisation}} representative {{agentName}} ({{agentMobile}}). They will deliver it to you soon. Aarida Customer Care : {{customerCareNumber}}.'
            },
            {
                title: 'Order Delivered',
                replace: true,
                isTemplate: true,
                context : ['order status', 'order'],
                content: 'Dear {{userName}}. Your order with order number {{orderNumber}} has been successfully delivered. Aarida Customer Care : {{customerCareNumber}}.'
            },
            {
                title: 'Order Cancelled',
                replace: true,
                isTemplate: true,
                context : ['order status', 'order'],
                content: 'Dear {{userName}}. Your order with order number {{orderNumber}} has been cancelled. Customer Care {{customerCareNumber}}.'
            },
            {
                title: 'Gift Card Reminder 1 (Activated)',
                replace: true,
                isTemplate: true,
                context : ['gift-card-activated'],
                content: 'Do not lose out on Rs {{cardAmount}}.\n--\nHey {{userName}}. You are about to lose Rs {{cardAmount}} as your unused gift card with code {{cardCode}} is going to expire {{expiringDays}} ({{expiryDate}}). Please only use your linked mobile number {{userMobile}} to login into Aarida.\n--\nRedeem it instantly by clicking here: {{redeemLink}}\nCustomer Care {{customerCareNumber}}'
            },
            {
                title: 'Gift Card Reminder 2 (Activated)',
                replace: true,
                isTemplate: true,
                context : ['gift-card-activated'],
                content: 'Do not lose out on Rs {{cardAmount}}.\n--\nHey {{userName}}. Rs {{cardAmount}} is going to be lost forever after expiry of your Aarida Gift Card {{expiringDays}} ({{expiryDate}}). Please only use your linked mobile number {{userMobile}} to login into Aarida.\n--\nRedeem it instantly by clicking here : {{redeemLink}}\nCustomer Care {{customerCareNumber}}'
            },
            {
                title: 'Gift Card Reminder 3 (Activated)',
                replace: true,
                isTemplate: true,
                context : ['gift-card-activated'],
                content: 'Dear {{userName}}. Pre Expiry Offer Alert :  Get 25% extra off on orders above Rs 4000 only till 20th Dec, 2019 11:30 pm. Also, Rs {{cardAmount}} in your gift card is expiring {{expiringDays}} ({{expiryDate}}). Redeem it before it is gone : {{redeemLink}}. Customer Care {{customerCareNumber}}.'
            },{
                title: 'Gift Card Reminder 4 (Activated)',
                replace: true,
                isTemplate: true,
                context : ['gift-card-activated'],
                content: 'Dear {{userName}}. Hurry up!! Last offer for this campaign, Get FLAT 15% off on all orders till 15th Dec, 2019 11:30 pm. Use your gift-card balance, Rs {{cardAmount}} to make a purchase before the offer runs out. Visit {{cartLink}}.  Customer Care {{customerCareNumber}}.'
            },
            {
                title: 'Gift Card Reminder 5 (Activated)',
                replace: true,
                isTemplate: true,
                context : ['gift-card-activated'],
                content: 'Dear {{userName}}. Hurry up!! Last chance before you loose Rs 3000, Get FLAT 20% off on all orders and FLAT 25% off on all orders above 4000 till 27th Dec, 2019 11:30 pm. Also, Rs {{cardAmount}} in your gift card is expiring {{expiringDays}} ({{expiryDate}}). Visit : {{cartLink}}.  Customer Care {{customerCareNumber}}.'
            },
            {
                title: 'Gift Card Reminder 1 (Redeemed)',
                replace: true,
                isTemplate: true,
                context : ['gift-card-redeemed'],
                content: 'Last 30 minutes to go. Hurry up.\n--\nHey {{userName}}. Complete your purchase by 11:59 pm today using your Gift Card (Balance : Rs {{cardAmount}}). Please only use your linked mobile number {{userMobile}} to login into Aarida.\n--\nPurchase Now : {{cartLink}}\nCustomer Care {{customerCareNumber}}.'
            },
            {
                title: 'Gift Card Reminder 2 (Redeemed)',
                replace: true,
                isTemplate: true,
                context : ['gift-card-redeemed'],
                content: 'You are about to lose Rs {{cardAmount}}.\n--\nHey {{userName}}. Rs {{cardAmount}} is going to be lost forever after expiry of your Aarida Gift Card {{expiringDays}} ({{expiryDate}}). Please only use your linked mobile number {{userMobile}} to login into Aarida.\n--\nMake a purchase before its gone : {{cartLink}}\nCustomer Care {{customerCareNumber}}.'
            },
            {
                title: 'Gift Card Reminder 3 (Redeemed)',
                replace: true,
                isTemplate: true,
                context : ['gift-card-redeemed'],
                content: 'Dear {{userName}}. Pre Expiry Offer Alert: Get 25% extra off on orders above Rs 4000 only till 20th Dec, 2019 11:30 pm. Also, Rs {{cardAmount}} in your gift card is expiring {{expiringDays}} ({{expiryDate}}). Make a purchase before the offer runs out : {{cartLink}}.  Customer Care {{customerCareNumber}}.'
            },
            {
                title: 'Gift Card Reminder 4 (Redeemed)',
                replace: true,
                isTemplate: true,
                context : ['gift-card-redeemed'],

                content: 'Dear {{userName}}. Hurry up!! Last offer for this campaign, Get FLAT 15% off on all orders till 15th Dec, 2019 11:30 pm. Use your gift-card balance, Rs {{cardAmount}} to make a purchase before the offer runs out. Visit : {{cartLink}}.  Customer Care {{customerCareNumber}}.'
            },
            {
                title: 'Gift Card Reminder 5 (Redeemed)',
                replace: true,
                isTemplate: true,
                context : ['gift-card-redeemed'],

                content: 'Dear {{userName}}. Hurry up!! Last chance before you loose Rs 3000, Get FLAT 20% off on all orders and FLAT 25% off on all orders above 4000 till 27th Dec, 2019 11:30 pm. Also, Rs {{cardAmount}} in your gift card is expiring {{expiringDays}} ({{expiryDate}}). Visit : {{cartLink}}.  Customer Care {{customerCareNumber}}.'
            },
            {
                title: 'Christmas Greetings',
                replace: true,
                isTemplate: true,
                context : [],
                content: 'Dear Customer. Wishing you and your family a Merry Christmas. Holiday sale is now live. Get a minimum FLAT 20% off on all orders both online and in-store. Offer valid only till stocks last. Hurry Up. Show Now : {{cartLink}}'
            },
            {
                title: 'Order Amount',
                replace: false,
                context : ['order', 'order status'],
                isTemplate: false,
                content: '{{orderAmount}}'
            },
            {
                title: 'Card Amount',
                replace: false,
                context : ['gift-card-activated', 'gift-card-redeemed'],
                isTemplate: false,
                content: '{{cardAmount}}'
            },
            {
                title: 'Card Code',
                replace: false,
                context : ['gift-card-activated', 'gift-card-redeemed'],
                isTemplate: false,
                content: '{{cardCode}}'
            },
            {
                title: 'Expiry Date',
                replace: false,
                context : ['gift-card-activated', 'gift-card-redeemed'],
                isTemplate: false,
                content: '{{expiryDate}}'
            },
            {
                title: 'Expiry Days Count',
                replace: false,
                context : ['gift-card-activated', 'gift-card-redeemed'],
                isTemplate: false,
                content: '{{expiringDays}}'
            },
            {
                title: 'Order Date',
                replace: false,
                context : ['order', 'order status'],
                isTemplate: false,
                content: '{{createdAt}}'
            },
            {
                title: 'Review Link',
                replace: false,
                context : ['order', 'order status'],
                isTemplate: false,
                content: ' {{orderReviewLink}} '
            },
            {
                title: 'Redeem Link',
                replace: false,
                context : ['gift-card-activated'],
                isTemplate: false,
                content: ' {{redeemLink}} '
            },
            {
                title: 'User Name',
                replace: false,
                context : ['order', 'order status', 'gift-card-activated', 'gift-card-redeemed', 'cart'],
                isTemplate: false,
                content: '{{userName}}'
            },
            {
                title: 'Order Number',
                replace: false,
                context : ['order', 'order status'],
                isTemplate: false,
                content: '{{orderNumber}}'
            },
            {
                title: 'Awb Code',
                replace: false,
                context : ['order', 'order status'],
                isTemplate: false,
                content: '{{awbCode}}'
            },
            {
                title: 'Products Count',
                replace: false,
                context : ['order', 'order status'],
                isTemplate: false,
                content: '{{productsCount}}'
            },
            {
                title: 'Organisation',
                replace: false,
                context : ['order', 'order status'],
                isTemplate: false,
                content: '{{organisation}}'
            },
            {
                title: 'Agent Name',
                replace: false,
                context : ['order', 'order status'],
                isTemplate: false,
                content: '{{agentName}}'
            },
            {
                title: 'Agent Mobile',
                replace: false,
                context : ['order', 'order status'],
                isTemplate: false,
                content: '{{agentMobile}}'
            },
            {
                title: 'Customer Care Number',
                replace: false,
                context : ['order', 'order status', 'cart', 'gift-card-activated', 'gift-card-redeemed'],
                isTemplate: false,
                content: '{{customerCareNumber}}'
            },
            {
                title: 'Cart Reminder - 1',
                context: ['cart'],
                replace: true,
                isTemplate: true,
                smsType : 'promotional',
                content: 'Hey {{userName}}.\nLooks like you forgot something in your cart.\nShop now : {{cartLink}}\nCheers\nTeam Aarida!'
            },
            {
                title: 'Cart Reminder - 2',
                context: ['cart'],
                replace: true,
                isTemplate: true,
                smsType : 'promotional',
                content: '\nYour cart calls for you.\nShop now : {{cartLink}}\nCheers\nTeam Aarida!'
            },
            {
                title: 'Cart Reminder - 3',
                context: ['cart'],
                replace: true,
                isTemplate: true,
                smsType : 'promotional',
                content: 'Get Flat 10% discount + a surprise using coupon FXMD43FRS to kickstart ur customisation journey like many others who tried us and gave us 5 stars.\nOffer extended due to overwhelming demand and now expires on Sunday, 11:00pm. Limited Slots left!\nShop Now: {{cartLink}}\nTeam Aarida!'
            },
            {
                title: 'Cart Reminder - 4',
                context: ['cart'],
                replace: true,
                isTemplate: true,
                smsType : 'transactional',
                content: 'Hey.\nThe latest giveaway result has been announced.\nView Results: http://bit.ly/38vX7ic\n\Team Aarida!'
            },
            {
                title: 'Cart Reminder - 5',
                context: ['cart'],
                replace: true,
                isTemplate: true,
                smsType : 'transactional',
                content: 'Hey {{userName}},\nSorry that you did not win the contest. You can still complete your purchase and get a chance to win a surprise gift from us. Use code: WINIT to get a surprise discount in your cart and also a chance to win the surprise product. Three lucky winners will be announced on 14th Feb, 2020.\n--\nPurchase Now : {{cartLink}}\nView Results: http://bit.ly/38vX7ic\nTeam Aarida!'
            },
            {
                title: 'Cart Reminder - 6',
                context: ['cart'],
                replace: true,
                isTemplate: true,
                smsType : 'transactional',
                content: 'Hey {{userName}},\nCongratulations! You have won our giveaway contest. Use the code NEHAAGL4341 during checkout to get Rs 1699 off on your purchase. Valid only till 24 Jan 2020, 9 pm. \nRequesting you to enter your precise measurements and customisation options during purchase.\nPurchase Now : {{cartLink}}\nView Results: http://bit.ly/38vX7ic\nTeam Aarida!'
            },
            {
                title: 'Cart Reminder - 7',
                context: ['cart'],
                replace: true,
                isTemplate: true,
                smsType : 'transactional',
                content: 'Hey {{userName}},\nCongratulations! You have won a consolation prize of Rs 500 Aarida Discount Coupon in our giveaway contest.\nUse the code MNUBHG323 during checkout to get the discount on your purchase.\nValid only till 24 Jan 2020, 9 pm.\nPlease use your registered mobile number to avail offer. Purchase Now : {{cartLink}}\nView Results: http://bit.ly/38vX7ic\nTeam Aarida!'
            },
            {
                title: 'Cart Link',
                replace: false,
                context: ['cart', 'gift-card-activated', 'gift-card-redeemed'],
                isTemplate: false,
                content: '{{cartLink}}'
            },
            {
                title: 'Offer',
                context: ['cart', 'gift-card-activated', 'gift-card-redeemed'],
                replace: false,
                isTemplate: false,
                selectData: {
                    type: 'Offers',
                    text: 'Select Offer to Embed'
                },
                content: '{{offerText}}'
            },
            {
                title: 'Shipment Of Orders',
                context: ['order'],
                replace: true,
                isTemplate: true,
                disableSubject : true,
                disableEmail : true,
                messageSubject : 'Shipment of Orders',
                templateData : {
                    id : 'd-cdb7c23490c9495c9599dbbb21131cbd',
                    text : 'Shipment of Orders Template'
                },
                scope : ['email']
            }
        ];


        /**
         * @methodOf NotificationTags
         * @type {getAvailableTags}
         */
        this.getAvailableTags = getAvailableTags;

        function getAvailableTags(tagsList, context, scopes) {
            var tags = [];
            console.log('context => ', tags, tagsList);
            if (tagsList && tagsList.length && !context) {
                // Remove temp checks for sms and whatsapp. Check History before 02/12/2019 for reverting back to earlier version.
                if (tagsList[0] === 'all') {
                    tags = availableTags;
                } else {
                    tags = availableTags.filter(function (tag) {
                        if(!tag.scope) {
                            tag.scope = ['sms', 'whatsapp'];
                        }
                        return  _.includes(tagsList, tag.title);
                    })
                }
            } else {
                tags = [];
            }

            console.log('context => Middle', tags, tagsList);

            if (context) {
                tags = tags.concat(availableTags.filter(function (tag) {
                    if(!tag.scope) {
                        tag.scope = ['sms', 'whatsapp'];
                    }
                    return tag.scope && tag.scope.length && scopes && scopes.length ?
                        _.intersection(scopes, tag.scope).length && _.includes(tag.context, context):
                        _.includes(tag.context, context);
                }));
            }
            console.log('context after => ', tags, scopes);

            return tags;
        }
    }

})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 22/01/20, 8:09 PM
 *
 */

(function () {
    'use strict';

    TemplateBuilder.$inject = ["$scope", "$mdDialog", "RestManager", "$rootScope", "template", "templateTags"];
    angular.module('app.main')
        .controller('template-builder.controller', TemplateBuilder);

    function TemplateBuilder($scope, $mdDialog, RestManager, $rootScope, template, templateTags) {
        $scope.cancel = cancel;
        $scope.applyTag = applyTag;
        $scope.editing = !!template;
        $scope.template = template || {
            title: '',
            replace: true,
            isTemplate: true,
            context : [],
            content: ''
        };
        $scope.templateTags = templateTags;
        $scope.save = save;

        function applyTag(tag) {
            $rootScope.$broadcast('add', tag.content);
        }

        $rootScope.$on('interpolationDone', function (e, val) {
            $scope.template.content = val;
        });

        function save() {
            $mdDialog.hide({template : $scope.template, editing : $scope.editing})
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }

})(angular);

(function () {
    'use strict';

    VersionManager.$inject = ["$cookies", "Notifications", "$http", "$mdDialog"];
    angular.module("app.main")
        .service("VersionManager", VersionManager);


    /** @ngInject **/
    function VersionManager($cookies, Notifications, $http, $mdDialog) {
        this.fetchReleaseNotes = fetchReleaseNotes;
        this._showUpdateDialog = _showUpdateDialog;

        function fetchReleaseNotes() {
            return $http.get('/releases.json')
                .then(function (response) {
                    return response.data;
                })
                .catch(function (err) {
                    console.log('er');
                })
        }

        this.setServerVersion = function (version) {
            this._serverVersion = version;
        };

        // Get Version from cookies
        this._getVersionFromCookies = function () {
            this.appData = $cookies.getObject("appData") || {};
            if (!this.appData.version) {
                // New Setup
                this.version = this._serverVersion;
                this.isNew = true;
            } else {
                // Get Version
                this.isNew = versionCompare(this.appData.version, this._serverVersion);
                if (this.isNew) {
                    this.version = this._serverVersion;
                } else {
                    this.version = this.appData.version;
                }
            }
        };


        // Put new version to cookies
        this._putNewVersion = function () {
            this.appData.version = this.version;
            $cookies.putObject("appData", this.appData, {
                expires: moment().add(20, "years").format()
            })
        };


        this.manageVersion = function () {
            this._getVersionFromCookies();
            if (this.isNew) {
                this._sendNotification();
                this._putNewVersion();
            }
        };


        function _showUpdateDialog() {
            $mdDialog.show({
                templateUrl: 'app/main/appUpdateDialog.tmpl.html',
                controller: ["release", "releaseNotes", "$scope", "$mdDialog", function (release,releaseNotes, $scope, $mdDialog) {
                    $scope.release = release;
                    $scope.releaseNotes = releaseNotes;

                    $scope.close = function () {
                        $mdDialog.cancel();
                    }
                }],
                locals: {
                    release: this.release,
                    releaseNotes : this.releaseNotes
                },
                clickOutsideToClose: true,
                fullscreen: true,
                escapeToClose: true
            })
        }

        function versionCompare(v1, v2, options) {
            var lexicographical = options && (options.lexicographical || false),
                zeroExtend = options && (options.zeroExtend || true),
                v1parts = v1.split('.'),
                v2parts = v2.split('.');

            function isValidPart(x) {
                return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
            }

            if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
                return NaN;
            }

            if (zeroExtend) {
                while (v1parts.length < v2parts.length) v1parts.push("0");
                while (v2parts.length < v1parts.length) v2parts.push("0");
            }

            if (!lexicographical) {
                v1parts = v1parts.map(Number);
                v2parts = v2parts.map(Number);
            }

            for (var i = 0; i < v1parts.length; ++i) {
                if (v2parts.length == i) {
                    return 1;
                }

                if (v1parts[i] == v2parts[i]) {
                    continue;
                }
                else if (v1parts[i] > v2parts[i]) {
                    return 1;
                }
                else {
                    return -1;
                }
            }

            if (v1parts.length != v2parts.length) {
                return -1;
            }

            return 0;
        }

        this._sendNotification = function () {
            var vm = this;
            this.fetchReleaseNotes()
                .then(function (releases) {
                    releases= releases.map(function (release) {
                        release.releaseNote = release.releaseNote.replace(/\\n/g, '<br/>') + '<br/><hr><br/>'
                        return release;
                    });
                    vm.release  = releases[0];
                    vm.releaseNotes = releases.reduce(function (a, release) {
                        a += release.releaseNote
                        return a;
                    }, "");
                    // vm._showUpdateDialog();
                    Notifications.addMessage({
                        title: "New Version Updated - " + vm.release.version,
                        description: 'Version has been updated to ' + vm.release.version + '. Please check release notes.',
                        highlight: vm.release.version,
                        icon: "system_update",
                        sref : 'app.home()',
                        buttonText : 'View Home',
                        action: "open_version_bar"
                    });
                })

        };

    }
})(angular);

/**
 * Created by kumardivyarajat on 04/11/16.
 */
angular.module("app.main")
    .service("Utils", ["$mdDialog", "$q", "$injector", function ($mdDialog, $q, $injector) {

        this.performSearchBySlug = function (slug, entityArray) {
            return _.find(entityArray, function (o) {
                return o.slug === slug;
            })
        };

        this.startCase = function (text) {
            return _.startCase(text)
        };

        this.getProperName = function (str, length) {
            if (!length) length = 24;
            return _.truncate(_.startCase(_.toLower(str)), {'length': length, 'separator': ' '});
        };

        this.dateAgo = function (date) {
            if (!date || !moment(date).isValid()) {
                return 'Never';
            } else {
                return moment(date).fromNow();
            }
        }

        this.secondsToDHM = function (d) {
            d = Number(d);
            var days = Math.floor(d / (3600 * 24));
            var h = Math.floor(d / 3600) % 24;
            var m = Math.floor(d % 3600 / 60);
            var s = Math.floor(d % 3600 % 60);
            var dDisplay = days > 0 ? _.padStart(days.toString(), 2, '0') + 'd ' : '';
            var hDisplay = h > 0 ? _.padStart(h.toString(), 2, '0') + 'h ' : '';
            var mDisplay = m > 0 ? _.padStart(m.toString(), 2, '0') + 'm ' : '';
            var sDisplay = _.padStart(s.toString(), 2, '0') + 's ';
            var display =  dDisplay + hDisplay + mDisplay + (days > 0 ? '' : sDisplay);
            return {
                hours: h,
                minutes: m,
                seconds: s,
                days: days,
                display : display
            };
        };

        /**
         * @memberOf Utils
         * @methodOf Utils
         * @function categoryListToTree
         * @param list
         * @returns {Array}
         */
        this.categoryListToTree = function (list) {
            var map = {}, node, roots = [], i;
            for (i = 0; i < list.length; i += 1) {
                map[list[i]._id] = i; // initialize the map
                list[i].children = []; // initialize the children
            }
            for (i = 0; i < list.length; i += 1) {
                node = list[i];
                if (node.parent) {
                    node.level = 1;
                    // if you have dangling branches check that map[node.parentId] exists
                    list[map[node.parent]].children.push(node);
                } else {
                    node.level = 0;
                    roots.push(node);
                }
            }
            return roots;
        };

        /**
         * @memberOf Utils
         * @methodOf Utils
         * @function categoriesToTreeString
         * @param list
         * @returns {Array}
         */
        this.categoriesToTreeString = function (list) {
            var parentCategories = list
                .filter(function (category) {
                    return !category.parent;
                });
            var parentMap = {};
            parentCategories.forEach(function (category) {
                parentMap[category._id] = category.name;
            });
            var categories = _.chain(list)
                .map(function (category) {
                    if (category.parent) {
                        category.name = parentMap[category.parent] + ' > ' + category.name;
                    }
                    return category;
                })
                .sortBy(function (category) {
                    return category.name;
                })
                .value();
            console.log('Categories', categories);
            return categories;
        };

        /**
         *
         * @memberOf Utils
         * @methodOf Utils
         * @function replaceEnd
         * @param string
         * @param toReplace
         * @returns {*}
         */
        this.replaceEnd = function (string, toReplace) {
            var re = new RegExp(toReplace + "([^" + toReplace + "]*)$", "g");
            return string.replace(re, '$1')
        };

        this.getBackgroundScale = function (datum) {
            if (datum && datum.extras && datum.extras.backgroundScale) {
                return datum.extras.backgroundScale + '%';
            }
            var name = datum.name;
            switch (name) {
                case "Pattern" :
                    return "100%";

                case "Sleeves" :
                    return "175%";

                case "Length" :
                    return "100%";

                case "Neck" :
                    return "175%";

                case "Necks":
                    return "175%";

                case "Product Type":
                    return "100%";

                default :
                    return "center";
            }
        }

        this.getSelectedPosition = function (datum) {
            if (datum && datum.extras && datum.extras.backgroundPosition) {
                return datum.extras.backgroundPosition;
            }
            var name = datum.name;
            switch (name) {
                case "Pattern" :
                    return "center";

                case "Sleeves" :
                    return "top";

                case "Length" :
                    return "bottom";

                case "Neck" :
                    return "top";

                case "Necks":
                    return "top";

                default :
                    return "center";
            }
        };


        this.addToSet = function (array, value) {
            var isPresent = false;
            if (Array.isArray(value)) {
                _.forEach(value, function (val) {
                    var a = _.find(array, function (v) {
                        return v == val;
                    });
                    if (!a) {
                        array.push(val);
                    }
                })
            } else {
                _.forEach(array, function (val) {
                    if (val == value) {
                        isPresent = true;
                    }
                });

                if (!isPresent) {
                    array.push(value);
                }
            }

        };

        this.getAttributeObject = function (attributeData) {
            var data = {
                key: '',
                values: []
            };

            data.key = attributeData.attribute.meta_key;
            data.values = attributeData.attribute.meta_values
                .filter(function (value) {
                    return _.includes(attributeData.selectedValues, value._id);
                })
                .reduce(function (concatter, value) {
                    return concatter + value.value + ', '
                }, '')
            data.values = this.replaceEnd(data.values, ',');
            return data;
        };

        this.getPaymentModeString = function (value) {
            switch (value) {
                case 1:
                    return "COD";

                case 2 :
                    return "Instamojo";

                case 3:
                    return "Payumoney";

                case 4 :
                    return "Paytm";

                case 5 :
                    return "Freecharge";

                case 6 :
                    return "MobiKwik";

                case 7 :
                    return "Credit/Debit Card";
            }
        };

        this.formatAddress = function (address, returnRichText) {
            if (address && !returnRichText) {
                var addressString = "<span class='md-caption bold-text' style='font-weight: 500;'>" + _.toUpper(address.name) + "</span>,<br>";
                addressString += "<span class='md-tiny'>" + _.toUpper(address.streetAddress) + ",</span><br>";
                if (address.landmark)
                    addressString += "<span class='md-tiny'>" + _.toUpper(address.landmark) + ",</span><br>";
                addressString += "<span class='md-tiny'>" + _.toUpper(address.city) + "</span>, <span class='md-tiny'>" + _.toUpper(address.state) + "</span><br>";
                addressString += "<span class='md-tiny'>" + _.toUpper(address.pinCode) + "</span><br>";
                addressString += "<span class='md-caption bold-text'>" + _.toUpper(address.mobile) + "</span>";
                return addressString;
            } else if (address && returnRichText) {
                var addressString = _.toUpper(address.name) + '\n';
                addressString += _.toUpper(address.streetAddress) + '\n';
                if (address.landmark) {
                    addressString += _.toUpper(address.landmark) + "\n";
                }
                addressString += _.toUpper(address.city) + ',' + _.toUpper(address.state) + "\n";
                addressString += _.toUpper(address.pinCode) + "\n";
                addressString += _.toUpper(address.mobile);
                return addressString;
            } else {
                return '';
            }
        };

        this.getChecklistDescription = function (key) {
            var description = '';
            switch (key) {
                case 'isInvoiced':
                    description = 'Print Invoice';
                    break;

                case 'isManifested':
                    description = 'Print Manifest';
                    break;

                case 'isThanksLetterPrinted':
                    description = 'Print Thanks Letter';
                    break;

                case 'isQCDone':
                    description = 'Perform Quality Checks';
                    break;

                case 'isQueued':
                    description = 'Queue order for processing';
                    break;

                case 'isOrgBillingDone':
                    description = 'Bill Organisation';
                    break;

                case 'isOrgPaymentDone':
                    description = 'Payment done by org';
                    break;

                case 'isStockDeducted':
                    description = 'Deduct Stock';
                    break;

                case 'isVolumetricWeightCalculated':
                    description = 'Calculate Volumetric Weight';
                    break;

                case 'isWeightCalculated':
                    description = 'Calculate Weight';
                    break;

                default:
                    description = key;
                    break;

            }

            return description;
        }

        this.getSizePriority = {
            "XXS": 0,
            "XS": 1,
            "S": 2,
            "M": 3,
            "L": 4,
            "XL": 5,
            "XXL": 6,
            "XXXL": 7

        };

        this.capitalize = function (str) {
            return _.startCase(_.toLower(str));
        };

        this.getSelectedVariationFromCartProduct = function (product) {
            // console.log(product);
            return _.find(product.variation.attributes[0].attribute.meta_values, function (val) {
                return val._id === product.variation.attributes[0].selectedValue[0];
            }).value;
        };

        this.getVariationByValue = function (product, value) {
            // console.log(product);
            return _.find(product.variation.attributes[0].attribute.meta_values, function (val) {
                return val._id === product.variation.attributes[0].selectedValue[0];
            }).value;
        };

        this.getVariationValue = function (variation) {
            if (variation.attributes[0]) {

                var varId = variation.attributes[0].selectedValue[0];

                var a = _.find(variation.attributes[0].attribute.meta_values, function (meta_value) {
                    return meta_value._id === varId;
                });
                if (a) {
                    return a.value;
                }
            }
        };


        this.getPrice = function (stockAndPrice, justNumber) {
            var price = "Free";
            if (stockAndPrice.price) {
                var salePrice = stockAndPrice.price.salePrice;

                if (salePrice) {
                    price = parseInt(salePrice);
                }
            }
            if (justNumber) {
                return price !== "Free" ? price : 0;
            } else {
                return price !== "Free" ? "+Rs. " + price : price;
            }
        };

        this.getLowestPrice = function (product) {
            switch (product.productType) {
                case 0:
                    var lowestPrice = 0;
                    _.forEach(product.variations, function (variation, i) {
                        var comparePrice = variation.stockAndPrice.price.salePrice ? variation.stockAndPrice.price.salePrice : variation.stockAndPrice.price.mrp;
                        if (lowestPrice > comparePrice) {
                            lowestPrice = i;
                        }
                    });
                    return product.variations[lowestPrice].stockAndPrice.price;

                case 1:
                    return product.customisation.basePrice;
                    break;
            }
        };


        this.openLinkGenerator = function (event, url, urlData) {
            var data = {};
            angular.copy(urlData, data);
            data.url = url;
            return $mdDialog.show({
                templateUrl: 'app/modules/base/dialogs/link-generator/link-generator.html',
                controller: 'link-generator.controller',
                locals: {
                    urlData: data
                },
                fullscreen: true,
                targetEvent: event,
                multiple: true
            })
        }

        this.openLayoutPreviewer = function (event, options) {
            var data = [], setting = {};
            angular.copy(options.widgets || [], data);
            angular.copy(options.setting || {}, setting);

            return $mdDialog.show({
                templateUrl: 'app/modules/base/dialogs/page-preview/page-preview.html',
                controller: 'PagePreview',
                locals: {
                    widgets: data,
                    setting: setting
                },
                fullscreen: true,
                targetEvent: event,
                multiple: true
            })
        }

        this.isImage = function (src) {
            var deferred = $q.defer();

            var image = new Image();
            image.onerror = function () {
                deferred.resolve(false);
            };
            image.onload = function () {
                deferred.resolve(true);
            };
            image.src = src;

            return deferred.promise;
        }

        this.fetchSizeCharts = function (){
            return new Promise(function (resolve, reject) {
                var RestManager = $injector.get('RestManager');
                RestManager.getResource("/settings/size_charts", 'size_charts')
                    .then(function (sizeCharts) {
                        var data = sizeCharts.map(function (chart) {
                            var measurements = [];
                            chart.values.values.charts.forEach(function (sizeValue) {
                                sizeValue.values.forEach(function (val) {
                                    var data = _.findIndex(measurements, function (measurement) {
                                        return measurement.key === val.key;
                                    });
                                    if (data !== -1) {
                                        measurements[data].values.push({key: sizeValue.key, value: val.value})
                                    } else {
                                        measurements.push({
                                            key: val.key,
                                            values: [{key: sizeValue.key, value: val.value}]
                                        });
                                    }
                                })
                            });
                            return {name: chart.values.values.name, measurements: measurements, id: chart._id};
                        });
                        resolve(data);
                    })
                    .catch(reject)
            })
        }

        this.findReferences = function (message) {
            var regex = /@\[([\s\w]+):([0-9a-z-]+)\]/gi;
            var m;
            var references = [];
            var i = 0;
            while ((m = regex.exec(message)) !== null) {
                // This is necessary to avoid infinite loops with zero-width matches
                if (m.index === regex.lastIndex) {
                    regex.lastIndex++;
                }

                m.forEach(function (match, groupIndex) {
                    if (groupIndex === 0) {
                        references.push({});
                    }
                    if (groupIndex === 1) {
                        references[i].name = _.trim(match);
                    }
                    if (groupIndex === 2) {
                        references[i].user = _.trim(match);
                    }
                });
                i++;
            }
            return references;
        }

        /**
         * @memberOf Utils
         * @param selector
         * @param [options] {object}
         * @param options.elementY {number}
         * @param options.duration {number}
         * @param options.direction {string}
         */
        this.scrollTo = function (selector, options) {
            var duration = options.duration;
            var elementY = options.elementY;
            var element = document.querySelector(selector);
            if (!elementY) {
                elementY = 0;
            }
            if (!duration) {
                duration = 500;
            }
            if (options.direction) {
                if (options.direction === 'bottom') {
                    elementY = element.clientHeight;
                } else if (options.direction === 'top') {
                    elementY = 0;
                } else {
                    console.warn('Direction value can only be top or bottom');
                }
            }
            if (!element) {
                console.warn('Element ' + selector + ' not found in DOM');
                return
            }
            var startingY = element.scrollTop;
            var diff = elementY - startingY;
            var start;

            // Bootstrap our animation - it will get called right before next frame shall be rendered.
            window.requestAnimationFrame(function step(timestamp) {
                if (!start) start = timestamp;
                // Elapsed milliseconds since start of scrolling.
                var time = timestamp - start;
                // Get percent of completion in range [0, 1].
                var percent = Math.min(time / duration, 1);

                element.scrollTo(0, startingY + diff * percent);

                // Proceed with animation as long as we wanted it to.
                if (time < duration) {
                    window.requestAnimationFrame(step);
                }
            })
        }

        this.getMimeType = function (extension) {
            var standardType = _.lowerCase(extension.replace('.', ''));
            switch (standardType) {
                case 'jpeg':
                    return 'image/jpeg';

                case 'jpg':
                    return 'image/jpeg';

                case 'jfif':
                    return 'image/jpeg';

                case 'png':
                    return 'image/png';

                case 'svg':
                    return 'image/svg+xml';

                case 'gif':
                    return 'image/gif';

                case 'webp':
                    return 'image/webp';
            }
        };

        this.parseAttributeBoolean = function (value, negatedCheck) {
            return value === '' || !!value && (negatedCheck === false || value !== 'false' && value !== '0');
        }

    }]);

(function () {
    'use strict';

    angular.module('app.main')
        .service('SheetClip', SheetClip);

    function SheetClip() {
        function countQuotes(str) {
            return str.split('"').length - 1;
        }


        function parse(str) {
            var r, rLen, rows, arr = [], a = 0, c, cLen, multiline, last;

            rows = str.replace(/\r\n|\r/g, '\n').split('\n');

            if (rows.length > 1 && rows[rows.length - 1] === '') {
                rows.pop();
            }
            for (r = 0, rLen = rows.length; r < rLen; r += 1) {
                rows[r] = rows[r].split('\t');

                for (c = 0, cLen = rows[r].length; c < cLen; c += 1) {
                    if (!arr[a]) {
                        arr[a] = [];
                    }
                    if (multiline && c === 0) {
                        last = arr[a].length - 1;
                        arr[a][last] = arr[a][last] + '\n' + rows[r][0];

                        if (multiline && (countQuotes(rows[r][0]) & 1)) { //& 1 is a bitwise way of performing mod 2
                            multiline = false;
                            arr[a][last] = arr[a][last].substring(0, arr[a][last].length - 1).replace(/""/g, '"');
                        }
                    } else {
                        if (c === cLen - 1 && rows[r][c].indexOf('"') === 0 && (countQuotes(rows[r][c]) & 1)) {
                            arr[a].push(rows[r][c].substring(1).replace(/""/g, '"'));
                            multiline = true;
                        } else {
                            arr[a].push(rows[r][c].replace(/""/g, '"'));
                            multiline = false;
                        }
                    }
                }
                if (!multiline) {
                    a += 1;
                }
            }

            return arr;
        }


        function stringify(arr) {
            var r, rLen, c, cLen, str = '', val;

            for (r = 0, rLen = arr.length; r < rLen; r += 1) {
                cLen = arr[r].length;

                for (c = 0; c < cLen; c += 1) {
                    if (c > 0) {
                        str += '\t';
                    }
                    val = arr[r][c];

                    if (typeof val === 'string') {
                        if (val.indexOf('\n') > -1) {
                            str += '"' + val.replace(/"/g, '""') + '"';
                        } else {
                            str += val;
                        }
                    } else if (val === null || val === void 0) { // void 0 resolves to undefined
                        str += '';
                    } else {
                        str += val;
                    }
                }

                if (r !== rLen - 1) {
                    str += '\n';
                }
            }

            return str;
        }


        this.parse = parse;
        this.stringify = stringify;
        this.parse = parse;


    }

})(angular);

(function () {
    'use strict';


    Scanner.$inject = ["$q"];
    angular.module('app.main')
        .service('Scanner', Scanner);

    /** @ngInject **/
    function Scanner($q) {

        this.start = startScanner;
        this.stop = Quagga.stop;

        function stubbedScanner() {
            var deferred = $q.defer();
            deferred.resolve('ADRSEP0075XS');

            return deferred.promise;
        }

        function startScanner() {

            return new $q(function (resolve, reject) {
                try {
                    Quagga.init({
                        inputStream: {
                            name: "Live",
                            type: "LiveStream",
                            target: document.querySelector('#scanner-container'),
                            constraints: {
                                width: 640,
                                height: 480,
                                facingMode: "environment"
                            },
                        },
                        decoder: {
                            readers: [
                                "code_128_reader"
                            ],
                            debug: {
                                showCanvas: true,
                                showPatches: true,
                                showFoundPatches: true,
                                showSkeleton: true,
                                showLabels: true,
                                showPatchLabels: true,
                                showRemainingPatchLabels: true,
                                boxFromPatches: {
                                    showTransformed: true,
                                    showTransformedBox: true,
                                    showBB: true
                                }
                            }
                        }

                    }, function (err) {
                        if (err) {
                            console.log(err);
                            reject(err);
                            return
                        }

                        console.log("Initialization finished. Ready to start");
                        Quagga.start();
                    });

                    Quagga.onProcessed(function (result) {
                        var drawingCtx = Quagga.canvas.ctx.overlay,
                            drawingCanvas = Quagga.canvas.dom.overlay;

                        if (result) {
                            if (result.boxes) {
                                drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                                result.boxes.filter(function (box) {
                                    return box !== result.box;
                                }).forEach(function (box) {
                                    Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {
                                        color: "green",
                                        lineWidth: 2
                                    });
                                });
                            }

                            if (result.box) {
                                Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {
                                    color: "#00F",
                                    lineWidth: 2
                                });
                            }

                            if (result.codeResult && result.codeResult.code) {
                                Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {
                                    color: 'red',
                                    lineWidth: 3
                                });
                            }
                        }
                    });


                    Quagga.onDetected(function (result) {
                        if (result && result.codeResult && result.codeResult.code) {
                            resolve(result.codeResult.code);
                        }
                    });
                } catch (e) {
                    reject(e);
                }

            });

        }
    }
})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 18/7/19 2:45 AM
 *
 */

(function () {
    'use strict';


    Scanner.$inject = ["$mdDialog"];
    angular.module('app.main')
        .service('ScannerDialog', Scanner);

    function Scanner($mdDialog) {
        this.openDialog  = openDialog;

        function openDialog(event,locals) {
            return $mdDialog.show({
                templateUrl: "app/modules/base/dialogs/scanner-dialog.html",
                controller : 'scanner.dialog.controller',
                fullscreen: true,
                multiple : true,
                clickOutSideToClose : true,
                targetEvent : event,
                locals : locals || {}
            })
        }
    }
})(angular);

(function () {
    'use strict';

    angular
        .module('app', ['ui.router', 'ngCookies', 'dndLists', 'ngAnimate', 'ngMessages', "app.main", "chart.js", "cfp.hotkeys", 'angulartics',
            'angulartics.mixpanel', 'ui.knob', 'ngclipboard']);

})();

/**
 * Created by kumardivyarajat on 02/12/16.
 */
"use strict";

angular.module("app")
    .service("RestManager", ["$http", "$q", "Base", "$log", "ErrorHero", "$mdToast", "Utils", function ($http, $q, Base, $log, ErrorHero, $mdToast, Utils) {
        var _handleResponse = function (response, extras, resourceName, resolve, reject) {
            if (response.data.code === 200) {
                if (extras) {
                    if (extras.length > 0) {
                        var returnData = {};
                        returnData[resourceName] = response.data.message[resourceName];
                        _.forEach(extras, function (extra) {
                            returnData[extra] = response.data[extra];
                        });
                        resolve(returnData);
                    } else {
                        resolve(response.data.message[resourceName]);
                    }
                } else {
                    resolve(response.data.message[resourceName]);
                }
            } else if (response.data.code === 413) {
                $mdToast.showSimple("Session Expired. Login Again");
            } else {
                console.log("rest.js", "_handleResponse", response);
                reject(ErrorHero(response));
            }
        };
        //
        // this.getResourcePromise = function (route) {
        //     return $q(function (resolve, reject) {
        //         return $http.get(Base.getBaseUrl() + route);
        //     })
        // };

        this._buildUrl = function (route, options) {
            if (!Array.isArray(options)) {
                if (!options) {
                    return Base.getBaseUrl() + route;
                } else if (options) {
                    var url = '';

                    switch (options.service) {
                        case 'scm' :
                            url = Base.getSCMUrl() + route;
                            break;

                        case 'review' :
                            url = Base.getReviewUrl() + route;
                            break;

                        case 'shortUrl' :
                            url = Base.getShortUrlService() + route;
                            break;

                        case 'pdf' :
                            url = Base.getPdfService() + route;
                            break;

                        case 'chat' :
                            url = Base.getChatService() + route;
                            break;

                        case 'workforce' :
                            url = Base.getWorkforceUrl() + route;
                            break;

                        default:
                            url = Base.getBaseUrl() + route;
                            break;
                    }

                    if (options.query || options.cursor || options.select)
                        url += '?';

                    if (options.query) {
                        _.forOwn(options.query, function (val, key) {
                            if (val) {
                                if (Array.isArray(val)) {
                                    if (val.length) {
                                        val = val.join(',');
                                        url += key + '=' + val + '&'
                                    }
                                } else {
                                    url += key + '=' + val + '&'
                                }
                            }
                        })
                    }

                    if (options.cursor) {
                        _.forOwn(options.query, function (val, key) {
                            url += key + '=' + val + '&'
                        })
                    }

                    if (options.select) {
                        url += 'select=' + _.reduce(options.select, function (reducer, val) {
                            return reducer + val + ','
                        }, '')
                    }

                    if (_.endsWith(url, '&')) {
                        url = Utils.replaceEnd(url, '&');
                    }
                    return encodeURI(url);
                }


            } else {
                return Base.getBaseUrl() + route;
            }
        };

        this._buildHttpConfig = function (options) {
            var config = {};
            if (options && options.download) {
                config.responseType = 'arraybuffer';
            }
            return config;
        }

        this.getResource = function (route, resourceName, options) {
            var vm = this;
            return $q(function (resolve, reject) {
                $http.get(vm._buildUrl(route, options), vm._buildHttpConfig(options))
                    .then(function (response) {
                        if (Array.isArray(options) || !options) {
                            _handleResponse(response, options, resourceName, resolve, reject);
                        } else {
                            _handleResponse(response, options ? options.extras : null, resourceName, resolve, reject);
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    });
            });
        };

        this.getResourceWithHtmlResponse = function (route, data, options) {
            var vm = this;
            return $q(function (resolve, reject) {
                $http.get(vm._buildUrl(route, options), vm._buildHttpConfig(options))
                    .then(function (response) {
                        console.log(response);
                        if (response.data.code) {
                            reject(new Error(response.data.message.error))
                        } else {
                            resolve(response.data);
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    });
            });
        };

        this.postResource = function (route, data, resourceName, options) {
            var vm = this;
            return $q(function (resolve, reject) {
                var reqOptions = {};
                $http.post(vm._buildUrl(route, options), data, vm._buildHttpConfig(options))
                    .then(function (response) {
                        if (options && options.download) {
                            resolve(response.data)
                        } else if (Array.isArray(options)) {
                            _handleResponse(response, options, resourceName, resolve, reject);
                        } else {
                            _handleResponse(response, options ? options.extras : null, resourceName, resolve, reject);
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    });
            });
        };


        this.postResourceWithHtmlResponse = function (route, data, options) {
            var vm = this;
            return $q(function (resolve, reject) {
                $http.post(vm._buildUrl(route, options), data, vm._buildHttpConfig(options))
                    .then(function (response) {
                        console.log(response);
                        resolve(response);
                    })
                    .catch(function (err) {
                        reject(err);
                    });
            });
        };

        this.putResource = function (route, data, resourceName, options) {
            var vm = this;
            return $q(function (resolve, reject) {
                $http.put(vm._buildUrl(route, options), data, vm._buildHttpConfig(options))
                    .then(function (response) {
                        if (Array.isArray(options)) {
                            _handleResponse(response, options, resourceName, resolve, reject);
                        } else {
                            _handleResponse(response, options ? options.extras : null, resourceName, resolve, reject);
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    });
            });
        };

        this.patchResource = function (route, data, resourceName, options) {
            var vm = this;
            return $q(function (resolve, reject) {
                $http.patch(vm._buildUrl(route, options), data, vm._buildHttpConfig(options))
                    .then(function (response) {
                        if (Array.isArray(options)) {
                            _handleResponse(response, options, resourceName, resolve, reject);
                        } else {
                            _handleResponse(response, options ? options.extras : null, resourceName, resolve, reject);
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    });
            });
        };

        this.deleteResource = function (route, resourceName, options) {
            var vm = this;
            return $q(function (resolve, reject) {
                $http.delete(vm._buildUrl(route, options), vm._buildHttpConfig(options))
                    .then(function (response) {
                        if (Array.isArray(options)) {
                            _handleResponse(response, options, resourceName, resolve, reject);
                        } else {
                            _handleResponse(response, options ? options.extras : null, resourceName, resolve, reject);
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    });
            });
        };
    }]);

/**
 * Created by kumardivyarajat on 21/08/17.
 */
angular.module("app.main").factory('sessionRecoverer', ['$q', '$injector', function ($q, $injector) {
    return {
        response: function (response) {
            if (response.data.code === 413 || response.status === 401) {
                // var AuthManager = $injector.get('AuthManager');
                // var $http = $injector.get('$http');
                // var deferred = $q.defer();
                //
                // console.log('File : response.js | Line : 13', 'response', AuthManager);
                // // Create a new session (recover the session)
                // // We use login method that logs the user in using the current credentials and
                // // returns a promise
                // AuthManager.loginUser("8147851623", "rajat225").then(deferred.resolve, deferred.reject);
                //
                // // When the session recovered, make the same backend call again and chain the request
                // return deferred.promise.then(function () {
                //     return $http(response.config);
                // });
                var state = $injector.get("$state");
                var rootScope = $injector.get("$rootScope");
                var notifications = $injector.get("Notifications")
                var params = {};
                console.log('File : response.js | Line : 29', 'response', "Expired");
                if (state.current.name !== "login") {
                    params.returnTo = window.location.href;
                }
                rootScope.$broadcast("TOKEN_EXPIRED", {});
                state.go("login", params);
                notifications.stopService();
            }
            return response;
        }
    };
}]);

(function(window, angular, undefined) {
    'use strict';

    angular.module('app.main').factory('$queue',
        ['$timeout', '$log',
        function($timeout, $log) {

            var defaults = {
                delay: 100,
                complete: null,
                paused: false
            };

            /**
             * Implementation of the Queue class
             *
             */
            function Queue(callback, options) {
                options = angular.extend({}, defaults, options);

                if (!angular.isFunction(callback)) {
                    throw new Error('callback must be a function');
                }

                //-- Private variables
                var cleared = false,
                    timeoutProm = null;

                //-- Public variables
                this.queue = [];
                this.delay = options.delay;
                this.callback = callback;
                this.complete = options.complete;
                this.paused = options.paused;

                //-- Private methods
                /**
                 * stop() stops processing of the queue
                 *
                 */
                var stop = function() {
                    if (timeoutProm) {
                        $timeout.cancel(timeoutProm);
                    }

                    timeoutProm = null;
                };

                //-- Privileged/Public methods

                /**
                 * size() returns the size of the queue
                 *
                 * @return<Number> queue size
                 */
                this.size = function() {
                    return this.queue.length;
                };

                /**
                 * add() adds an item to the back of the queue
                 *
                 * @param<Object> item
                 * @return<Number> queue size
                 */
                this.add = function(item) {
                    return this.addEach([item]);
                };

                /**
                 * addEach() adds an array of items to the back of the queue
                 *
                 * @param<Array> items
                 * @return<Number> queue size
                 */
                this.addEach = function(items) {
                    if (items) {
                        cleared = false;
                        this.queue = this.queue.concat(items);
                    }

                    if (!this.paused) { this.start(); }

                    return this.size();
                };

                /**
                 * clear() clears all items from the queue
                 * and stops processing
                 *
                 * @return<Array> the original queue
                 */
                this.clear = function() {
                    var orig = this.queue;
                    stop();
                    this.queue = [];
                    cleared = true;
                    return orig;
                };

                /**
                 * pause() pauses processing of the queue
                 *
                 */
                this.pause = function() {
                    stop();
                    this.paused = true;
                };


                /**
                 * start() starts processing of the queue.
                 * start() may be called after pause()
                 *
                 */
                this.start = function() {
                    var _this = this;
                    this.paused = false;
                    if (this.size() && !timeoutProm) {
                        (function loopy() {
                            var item;

                            stop();

                            if(_this.paused)
                                return;

                            if (!_this.size()) {
                                cleared = true;
                                if (angular.isFunction(_this.complete)) {
                                    _this.complete.call(_this);
                                }
                                return;
                            }

                            item = _this.queue.shift();
                            _this.callback.call(_this, item);
                            // console.log("queue.js", "loopy", loopy);
                            timeoutProm = $timeout(loopy,
                                _this.delay);

                            return;
                        })();
                    }
                };

                /**
                 * indexOf() returns the first index of the item in the queue
                 *
                 * @param<Object> item
                 * @return<Number> index of the item if found, or -1 if not
                 */
                this.indexOf = function(item) {
                    if (this.queue.indexOf) return this.queue.indexOf(item);

                    for (var i = 0; i < this.queue.length; i++) {
                        if (item === this.queue[i]) return i;
                    }
                    return -1;
                };
            }

            /**
             * queue() is a convenience function to return a new Queue
             *
             * Usage: var queue = $queue.queue(someOptions);
             *
             * @param<Function> callback - *Required* - Function called for
             *          each item in the queue after each delay. Passed
             *          item and called with the context of Queue.
             * @param<Object> options
             *      delay<Number> - *Optional* - Number of milliseconds between each
             *          processing step of the queue. Defaults to 100.
             *      complete<Function> - *Optional* - Function called upon
             *          completion of processing all items in the queue.
             *      paused<Boolean> - *Optional* - Flag to indicate if the queue
             *          starts paused. If false, queue will start processing
             *          items immediately after the first add or addEach.
             * @return<Queue> a new Queue
             */
            Queue.queue = function(callback, options) {
                return new Queue(callback, options);
            };

            return Queue;
        }]);

})(window, window.angular);

(function () {
    'use strict';

    NotificationBus.$inject = ["$mdToast", "RestManager", "$state", "$interval", "AuthManager", "Base", "$queue", "$log"];
    angular.module("app.main")
        .controller('NotificationToastController', ["$scope", "data", "$state", function ($scope, data, $state) {
            $scope.data = data;
        }])
        .service("Notifications", ['$mdToast', 'RestManager', '$state', '$interval', 'AuthManager', 'Base', '$queue', '$log', NotificationBus]);

    /** @ngInject **/
    function NotificationBus($mdToast, RestManager, $state, $interval, AuthManager, Base, $queue, $log) {

        // Defaults for notification times are set on login if not exists.
        this.messages = window.localStorage.getItem('messages') ? JSON.parse(window.localStorage.getItem('messages')) : [];
        this._interval = null;
        this.timeInterval = 10000;
        this.newMessages = 0;
        this.toastDelay = 3000;
        this.queue = $queue.queue(function (data) {
            data.toast.show(data.item)
        }, {
            delay: this.toastDelay,
            paused: true
        });

        this.startService = function () {
            var vm = this;
            vm._query();
            this._interval = $interval(function () {
               vm._query();
            }, this.timeInterval);
            this.queue.start();
            return this._interval;
        };

        this._query = function () {
            this.currentUser = AuthManager.getCurrentUser();
            this._productNotifications();
            this._orderNotifications();
            this._orderCommentNotifications();
            this._giftCardCommentNotifications();
        };

        this.updateTimeInterval = function (interval) {
            this.timeInterval = interval;
            this.stopService();
            return this.startService();
        };

        this.stopService = function (intervalId) {
            $interval.cancel(intervalId || this._interval);
            this.queue.pause();
            // this.clear();
        };


        this.markAsRead = function (notification) {
            this.messages = this.messages.map(function (message) {
                if (message.id === notification.id) {
                    message.read = true;
                }
                return message;
            });
            window.localStorage.setItem('messages', JSON.stringify(this.messages));
            return this.messages;
        };

        this.markAllAsViewed = function () {
            this.messages = this.messages.map(function (message) {
                message.viewed = true;
                return message;
            });
            window.localStorage.setItem('messages', JSON.stringify(this.messages));
            return this.messages;
        };


        this._orderNotifications = function () {
            var currentComment = moment().toISOString();
            var queryDate = window.localStorage.getItem('lastOrder') || currentComment;
            var salesQuery = {
                queryType: "count",
                queryParams: {
                    createdAt: {
                        $gte: queryDate
                    }
                }
            };
            var vm = this;

            RestManager.postResource("/analytics/Order", salesQuery, "analytics")
                .then(function (data) {
                    if (data) {
                        vm.addMessage({
                            title: "New Order Placed",
                            description: data + (data === 1 ? ' order' : ' orders') + "  have been placed since " + moment(queryDate).format('llll').toString(),
                            highlight: data,
                            icon: "system_update",
                            action: "open_version_bar",
                            buttonText: 'View Orders',
                            sref: 'app.orders.all({page: 1, limit: 25, order: \'-createdAt\', filter: \'{"createdAt":{"$gte":"' + queryDate + '"}}\'})'
                        });
                    }
                    window.localStorage.setItem('lastOrder', moment(currentComment).toISOString());
                })
        };

        this._orderCommentNotifications = function () {
            var currentComment = moment().toISOString();
            var queryDate = window.localStorage.getItem('lastOrderComment') || currentComment;
            var salesQuery = {
                queryType: "find",
                queryParams: {
                    'notes.date': {
                        $gt: queryDate
                    },
                    'notes.references.user': this.currentUser._id
                },
                queryOptions: {
                    select: 'orderNumber'
                }
            };
            var vm = this;

            RestManager.postResource("/analytics/Order", salesQuery, "analytics")
                .then(function (data) {
                    if (data && data.length) {
                        data.forEach(function (order) {
                            vm.addMessage({
                                title: "You have a new mention on an Order",
                                description: "New Mention on " + order.orderNumber,
                                icon: "system_update",
                                action: "open_version_bar",
                                buttonText: 'View Order',
                                sref: 'app.orders.details({orderId : \'' + order._id + '\', openNotes : true})'
                            }, data.length > 4);
                        })

                    }
                    window.localStorage.setItem('lastOrderComment', moment(currentComment).toISOString());
                })
        };

        this._giftCardCommentNotifications = function () {
            var currentComment = moment().toISOString();
            var queryDate = window.localStorage.getItem('lastGCComment') || currentComment;
            var salesQuery = {
                queryType: "find",
                queryParams: {
                    'notes.date': {
                        $gt: queryDate
                    },
                    'notes.references.user': this.currentUser._id
                },
                queryOptions: {
                    select: 'code'
                }
            };
            var vm = this;

            RestManager.postResource("/analytics/GiftCards", salesQuery, "analytics")
                .then(function (data) {
                    if (data && data.length) {
                        data.forEach(function (order) {
                            vm.addMessage({
                                title: "You have a new mention on a Gift Card",
                                description: "New Mention on " + order.code,
                                icon: "system_update",
                                action: "open_version_bar",
                                buttonText: 'View Order',
                                sref: 'app.offers.giftCards.details({cardId : \'' + order._id + '\', openNotes : true})'
                            }, data.length > 4);
                        })

                    }
                    window.localStorage.setItem('lastGCComment', moment(currentComment).toISOString());
                })
        };

        this._productNotifications = function () {
            var currentComment = moment().toISOString();
            var queryDate = window.localStorage.getItem('lastComment') || currentComment;
            var vm = this;
            RestManager.postResource('/products/admin/preview', {
                actionType: "find",
                collections: [],
                products: [],
                queries: [
                    {
                        "value": queryDate,
                        "enabled": true,
                        "entity": "notes.date",
                        "valType": "String",
                        "operand": "$gt"
                    },
                    {
                        "value": vm.currentUser._id,
                        "enabled": true,
                        "entity": "notes.references.user",
                        "valType": "String",
                        "operand": "$eq"
                    }]
            }, 'preview', {extras: ['total']})
                .then(function (data) {
                    if (data && data.total && data.preview && data.preview[0] && data.preview[0].products && data.preview[0].products.length) {
                        data.preview[0].products.forEach(function (product) {
                            vm.addMessage({
                                title: "You have a new mention on a Product",
                                description: "New Mention on " + product.name,
                                highlight: data.total,
                                image: product.featured_image ? product.featured_image.urls.thumbnail : '',
                                icon: "system_update",
                                action: "open_version_bar",
                                buttonText: 'View Product',
                                sref: 'app.products.add.home({newProduct : false, openNotes : true, slug : \'' + product._id + '\', name : \'' + product.name + '\'})'
                            }, data.total > 4);
                        })

                    }
                    window.localStorage.setItem('lastComment', moment(currentComment).toISOString());
                })
                .catch(function (err) {
                    console.log("products.all.controller.js", "err", err);
                })
        };

        this.addMessage = function (data, disableNotify) {
            data.read = false;
            data.viewed = false;
            data.id = new Date() + ':' + Math.floor(Math.random() * (999 - 100 + 1) + 100);
            if (!data.sref) {
                data.sref = "app.home()"
            }
            this.messages.unshift(data);

            window.localStorage.setItem('messages', JSON.stringify(this.messages));

            if (!disableNotify) {
                var template = '<md-toast>' +
                    '<div layout="column" layout-align="center start">' +
                    '<h4> {{data.title}}  </h4>' +
                    '<p>{{data.description}}</p>' +
                    '<md-button class="md-accent outline small" ng-if="data.buttonText" ui-sref="{{data.sref}}">' +
                    '{{data.buttonText}}' +
                    '</md-button>' +
                    '</div>' +
                    '</md-toast>';

                this.queue.add({
                    item: {
                        template: template,
                        locals: {
                            data: data
                        },
                        controller: 'NotificationToastController',
                        position: 'bottom right',
                        hideDelay: this.toastDelay,
                        bindToController: true
                    }, toast: $mdToast
                });
                console.log("notifications.js", "addMessage", this.queue);
            }
        };


        this.clear = function () {
            window.localStorage.removeItem('messages');
            window.localStorage.removeItem('lastComment');
            window.localStorage.removeItem('lastOrder');
        };

        this.clearNotifications = function () {
            window.localStorage.removeItem('messages');
            this.messages = [];
        }


    }
})(angular);

/**
 * Created by kumardivyarajat on 13/12/16.
 */
(function () {

    angular.module('app').factory('ImagePreloader', imagePreloader);

    imagePreloader.$inject = ['$q', '$timeout', 'Utils', 'Base'];

    function imagePreloader($q, $timeout, Utils, Base) {

        var _body = document.getElementsByTagName('body')[0];

        return {
            preloadImages: preloadImages
        };

        function renderImage(imgPath) {

            return $q(function (resolve) {


                Utils.isImage(imgPath)
                    .then(function (exists) {
                        //
                        if (exists) {
                            // Create an image element
                            var element = document.createElement('img');
                            var timeoutId;


                            // Assign properties to the element making it tiny and invisible to the viewer
                            element.src = imgPath;
                            element.height = "1";
                            element.width = "1";
                            element.style.opacity = 0;

                            // Begin a timeout.  If image has failed to load, resolve anyway and remove element
                            timeoutId = $timeout(function () {
                                _body.removeChild(element);
                                element.removeEventListener('load', processLoadEvent);
                                resolve();
                            }, 1750);

                            element.addEventListener('load', processLoadEvent);

                            // Wait for the image to load and then remove it
                            // Cancel the timeout event
                            function processLoadEvent() {
                                // //
                                _body.removeChild(element);
                                $timeout.cancel(timeoutId);
                                resolve(true);
                            }

                            // Add the image element to the DOM
                            _body.appendChild(element);
                        } else {
                            resolve(false);
                        }
                    })
                    .catch(function (err) {

                    });
            });

        }

        /**
         * Take array of images and force them to be loaded/cached by the browser
         * @param {array} images
         */
        function preloadImages(images) {

            if (!images || images.length === 0) {
                return $q.when();
            }

            return $q.all(images.map(function (image) {
                return renderImage(image);
            }));

        }
    }

})();

/**
 * Created by kumardivyarajat on 02/11/16.
 */
angular.module("app.main")
    .factory('Header', ["Constants", "Role", function (Constants, Role) {
        var showHeaderImage = false;
        return {
            isHeaderImageEnabled: function () {
                return showHeaderImage;
            },
            setShowHeaderImage: function (boolVal) {
                showHeaderImage = boolVal
            }
        };
    }]);
/**
 * Created by kumardivyarajat on 11/11/16.
 */
angular.module('app.main')
    .factory('$exceptionHandler', ["$log", function ($log) {
        return function myExceptionHandler(exception, cause) {
            // logErrorsToBackend(exception, cause);
            $log.warn(exception, cause);
        };
    }])
    .factory("ErrorHero", function () {
        return function myHero(response) {
            var err = new Error(response.data.message.error);
            err.message = response.data.message.error;
            err.code = response.data.code;
            return err;
        }
    });

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 19/6/19 8:05 PM
 *
 */

(function () {
    'use strict';

    CriticalUpdateConfirmation.$inject = ["$mdDialog", "$q"];
    angular.module('app.main')
        .service('CriticalUpdateConfirmation', CriticalUpdateConfirmation);

    function CriticalUpdateConfirmation($mdDialog, $q) {

        controller.$inject = ["$scope", "$mdDialog", "options"];
        function controller($scope, $mdDialog, options) {
            if (!options) {
                options = {};
            }
            if(!options.headerClass) {
                options.headerClass = 'md-primary';
            }
            $scope.options = options;
            if (!$scope.options.confirmText) {
                $scope.options.confirmText = 'Change'
            }
            if (!$scope.options.cancelText) {
                $scope.options.cancelText = 'Cancel'
            }

            $scope.entity1 = '';
            if (!$scope.options.inputValidatorString) {
                throw new Error('Cannot Work Without Input Validator String');
            }
            $scope.entity = $scope.options.inputValidatorString;

            $scope.close = function (value) {
                $mdDialog.hide(value);
            }
        }

        /**
         * @memberOf CriticalUpdateConfirmation
         * @methodOf CriticalUpdateConfirmation
         * @param options
         * @param options.targetEvent
         * @param options.title
         * @param [options.headerClass]
         * @returns {*}
         */
        this.showDialog = function (options) {

            console.log('Options', options);
            return $q(function (resolve, reject) {
                $mdDialog.show({
                    parent: angular.element(document.body),
                    targetEvent: options.targetEvent,
                    multiple: true,
                    fullscreen: true,
                    clickOutsideToClose: false,
                    controller: controller,
                    locals: {
                        options: options
                    },
                    escapeToClose: false,
                    templateUrl: 'app/modules/base/services/critical-setting-change-confirm-dialog.tmpl.html'
                })
                    .then(function (result) {
                        resolve(result)
                    })
                    .catch(reject)
            })
        }
    }

})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 02/02/20, 1:39 AM
 *
 */

(function () {
        'use strict';

        ChatService.$inject = ["RestManager", "Base", "AuthManager"];
        angular.module('app.main')
            .service('ChatService', ChatService);


        function ChatService(RestManager, Base, AuthManager) {

            this.chatUser = null;
            this.manager = null;
            this._connectionPromise = null;

            /**
             *
             * @typedef {Object} User
             * @property {string} id - Id of the user in the chat interface.
             * @property {string} name - Name of the user in the chat interface.
             */
            this.init = init;
            this.createRoom = createRoom;
            this.connect = connect;
            this.connectToRoom = connectToRoom;
            this.disconnectFromRoom = disconnectFromRoom;
            this.checkConnectionStatus = checkConnectionStatus;
            this.sendMessageToRoom = sendMessageToRoom;
            this.joinRoom = joinRoom;
            this.sendTypingIndicatorsInRoom = sendTypingIndicatorsInRoom;


            /**
             *
             * @memberOf ChatService
             * @param currentUser
             */
            function init(currentUser) {
                var self = this;
                if (!currentUser._id) {
                    console.error('Cannot initialize Pusher without a userId');
                    throw new Error('Cannot initialize Pusher without a userId');
                }
                self.manager = new Chatkit.ChatManager({
                    instanceLocator: Base.getChatInstance(),
                    userId: currentUser._id,
                    tokenProvider: new Chatkit.TokenProvider({
                        url: Base.getChatService() + '/chat/authenticate',
                        queryParams: {
                            name: currentUser.name
                        },
                        headers : {
                            'x-access-token' : currentUser['x-access-token']
                        }
                    })
                });
                self._connectionPromise = self.connect();
                return self._connectionPromise;
            }

            /**
             * @memberOf ChatService
             */
            function connect() {
                var self = this;
                return self.manager.connect()
                    .then(function (currentUser) {
                        self.chatUser = currentUser;
                        self._connectionPromise = null;
                        return self.chatUser
                            .enablePushNotifications({
                                onClick: function (data) {
                                    console.log("chat.js", "onClick", data);
                                },
                                serviceWorkerRegistration: window._serviceWorkerRegistration,
                            })
                    })
            }

            /**
             * @memberOf ChatService
             * @returns {*}
             */
            function checkConnectionStatus() {
                var self = this;
                return new Promise(function (resolve, reject) {
                    var internalPromise;
                    if (self.chatUser) {
                        internalPromise = Promise.resolve(self.chatUser);
                    } else if (self._connectionPromise) {
                        internalPromise = self._connectionPromise;
                    } else {
                        internalPromise = self.init(AuthManager.getCurrentUser()._id)
                    }
                    internalPromise
                        .then(function (result) {
                            resolve(result)
                        })
                        .catch(function (error) {
                            console.log('Init of Pusher has caused an error :', error);
                            reject(error);
                        })
                })
            }


            /**
             *
             *
             * @memberOf ChatService
             * @param roomId {String}
             * @param roomName {String}
             * @param creator {User}
             * @param members {User[]}
             * @param customData
             * @param isPublic
             * @returns {*}
             */
            function createRoom(roomId, roomName, creator, members, customData, isPublic) {
                var self = this;
                return new Promise(function (resolve, reject) {
                    self.checkConnectionStatus()
                        .then(function () {
                            return RestManager.postResource('/chat/createRoom', {
                                roomId: roomId,
                                name: roomName,
                                creator: creator,
                                members: members,
                                customData: customData,
                                isPublic: isPublic
                            }, 'chat', {service: 'chat'})
                        })
                        .then(resolve)
                        .then(reject)
                })
            }

            /**
             * @memberOf ChatService
             * @param roomId
             */
            function joinRoom(roomId) {
                var currentUser = AuthManager.getCurrentUser();
                return RestManager.postResource('/chat/joinRoom', {
                    roomId: roomId,
                    users: [
                        {
                            name: currentUser.name,
                            id: currentUser._id
                        }
                    ]
                }, 'chat', {service: 'chat'})
            }


            /**
             * @memberOf ChatService#
             * @member ChatService
             * @param roomId {String}
             * @param limit {Number}
             * @param hooks {Object}
             * @param hooks.onUserStartedTyping {Function}
             * @param hooks.onUserStoppedTyping {Function}
             * @param hooks.onUserJoined {Function}
             * @param hooks.onUserLeft {Function}
             * @param hooks.onPresenceChanged {Function}
             * @param hooks.onMessage {Function}
             * @param hooks.onNewReadCursor {Function}
             */
            function connectToRoom(roomId, limit, hooks) {
                var self = this;
                return self.checkConnectionStatus()
                    .then(function (result) {
                        return self.chatUser.subscribeToRoomMultipart({
                            roomId: roomId,
                            hooks: hooks,
                            messageLimit: limit
                        })
                    })
            }

            /**
             * @memberOf ChatService
             * @param roomId
             * @param messageParts
             */
            function sendMessageToRoom(roomId, messageParts) {
                var self = this;
                return self.chatUser.sendMultipartMessage({
                    roomId: roomId,
                    parts: messageParts,
                })
            }

            /**
             * @memberOf ChatService
             * @param roomId
             * @returns {*}
             */
            function sendTypingIndicatorsInRoom(roomId) {
                var self = this;
                return self.chatUser.isTypingIn({
                    roomId: roomId
                })
            }

            /**
             * @memberOf ChatService
             * @param roomId
             * @returns {*}
             */
            function disconnectFromRoom(roomId) {
                var self = this;
                return self.chatUser.roomSubscriptions[roomId].cancel();
            }
        }


    }

)(angular);

/**
 * Created by kumardivyarajat on 01/11/16.
 */
(function () {
    'use strict';
    BaseFactory.$inject = ["Constants", "Role"];
    angular
        .module("app.main")
        .factory('Base', BaseFactory)
        .constant('Constants', {
            ENVIRONMENT: {
                "DEVELOPMENT": "dev",
                "STAGE": "stage",
                "PRODUCTION": "prod"
            }
        })
        .constant('Role', {
            admin: "ADMIN",
            shopManager: "SHOP MANAGER",
            csExecutive: "CS EXECUTIVE",
            customer: "CUSTOMER"
        });

    /* @ngInject */
    function BaseFactory(Constants, Role) {
        var title = 'Aarida';
        var baseUrl = "/api/v1";
        var mediaUrl;
        var scmUrl;
        var baseUri = "/api/v1";
        var lBaseUrl = "/api/v1";
        var appUrl = "";
        var shortUrl = "";
        var reviewUrl = "";
        var pdfService = "";
        var chatService = "";
        var chatInstance = "";
        var workforceUrl = "";
        var role = Role.admin;
        var replaceDirectives = true;
        var ENV;
        return {
            getTitle: function () {
                return title;
            },
            setTitle: function (newTitle) {
                title = newTitle;
            },
            setBaseUrl: function (base) {
                baseUri = base;
            },
            getBase: function () {
                return baseUri;
            },
            setSCMUrl: function (url) {
                scmUrl = url;
            },
            getSCMUrl: function () {
                return scmUrl;
            },

            setAppUrl: function (url) {
                appUrl = url;
            },
            getAppUrl: function () {
                return appUrl;
            },
            setShortUrlService: function (url) {
                shortUrl = url;
            },
            getShortUrlService: function () {
                return shortUrl;
            },
            setPdfService: function (url) {
                pdfService = url;
            },
            getPdfService: function () {
                return pdfService;
            },
            setChatService: function (url) {
                chatService = url;
            },
            getChatService: function () {
                return chatService;
            },
            setChatInstance: function (instanceId) {
                chatInstance = instanceId;
            },
            getChatInstance: function () {
                return chatInstance;
            },
            setReviewUrl: function (url) {
                reviewUrl = url;
            },
            getReviewUrl: function () {
                return reviewUrl;
            },
            getBaseUrl: function () {
                return baseUri;
            },
            setLocalBaseUrl: function (localBaseUrl) {
                lBaseUrl = localBaseUrl;
            },
            getLocalBaseUrl: function () {
                return lBaseUrl;
            },
            setMediaUrl: function (url) {
                mediaUrl = url;
            },
            getMediaUrl: function () {
                return mediaUrl;
            },
            setEnv: function (env) {
                ENV = env;
            },
            getEnv: function () {
                return ENV;
            },
            setRole: function (text) {
                role = Role[text];
            },
            getRole: function () {
                return role;
            },
            setWorkforceUrl: function (w) {
                workforceUrl = w;
            },
            getWorkforceUrl: function () {
                return workforceUrl;
            },
            setReplaceDirectives: function (change) {
                replaceDirectives = change;
            },
            getReplaceDirectives: function () {
                return replaceDirectives;
            }
        };
    }

})();


/**
 * Created by Nidhu on 11/11/16.
 */
angular.module("app.main")
    .service('AuthManager', ["$q", "$log", "$http", "ErrorHero", "Base", "$cookies", "$mdDialog", "$analytics", function ($q, $log, $http, ErrorHero, Base, $cookies, $mdDialog, $analytics) {
        this._currentUser = "";
        this.isUserLoggedIn = false;


        this.getCurrentUser = function () {
            if (!this.isUserLoggedIn) {
                this._currentUser = $cookies.getObject('adminUser');
                if (this._currentUser) {
                    this.isUserLoggedIn = true;
                    this._setUpHeaders(this._currentUser['x-access-token'], this._currentUser['x-refresh-token']);
                }
            }
            return this._currentUser;
        };


        this.getCurrentUserAysnc = function () {
            var that = this;
            return $q(function (resolve, reject) {
                if (!that.isUserLoggedIn) {
                    that._currentUser = $cookies.getObject('adminUser');
                    if (that._currentUser) {
                        console.log("getCurrentUser", that._currentUser);
                        that.isUserLoggedIn = true;
                        that._setUpHeaders(that._currentUser['x-access-token'], that._currentUser['x-refresh-token']);
                    }
                    resolve(that._currentUser);
                } else {
                    resolve(that._currentUser);
                }
            });
        };
        this.setCurrentUser = function (user, persistent) {
            console.log("setCurrentUser", user);
            this._currentUser = user;
            //TODO Validate data for integrity
            this.isUserLoggedIn = true;
            if (!persistent) {
                var now = new Date();
                now.setDate(now.getDate() + 7);
                delete user.google;
                delete user.otp;
                delete user.virtualMobile;
                delete user.createdAt;
                delete user.points;
                delete user.tempUser;
                delete user.updatedAt;
                delete user["x-refresh-token"];
                $cookies.putObject("adminUser", user, {
                    expires: now
                });
            } else {
                $cookies.putObject("adminUser", user);
            }

            this._setUpHeaders(user['x-access-token'], user['x-refresh-token']);
        };

        // this.showLoginModal = function ($scope, clickOnCloseOutside) {
        //     $mdDialog.show({
        //         contentElement: '#loginDialog',
        //         parent: angular.element(document.body),
        //         fullscreen: false,
        //         // scope: $scope,        // use parent scope in template
        //         // preserveScope: true,  // do not forget this if use parent scope
        //         clickOutsideToClose: clickOnCloseOutside,
        //         escapeToClose: true
        //
        //     });
        // };


        this.loginUser = function (username, password) {
            var that = this;
            return $q(function (resolve, reject) {
                $http.post(Base.getBaseUrl() + "/users/admin/login", {mobile: username, password: password})
                    .then(function (response) {
                        // console.log("user", response);
                        if (response.data.code === 200) {
                            that.setCurrentUser(response.data.message.users[0]);
                            resolve(that._currentUser);
                        } else {
                            reject(new Error(response.data.message.error, response.data.code));
                        }
                    })
                    .catch(function (err) {
                        // $log.error(err);
                        reject(err);
                    })
            });
        };

        this._setUpHeaders = function (accessToken, refreshToken) {
            $http.defaults.headers.common['x-access-token'] = accessToken; // jshint ignore:line
            $http.defaults.headers.common['x-refresh-token'] = refreshToken; // js
        };

        this.logout = function () {
            var self = this;
            return $q(function (resolve, reject) {
                $analytics.eventTrack('LOGOUT', {
                    action: 'MANUAL',
                    user: self._currentUser.name,
                    id: self._currentUser._id
                })
                $cookies.remove('adminUser');
                self._currentUser = {};
                self.isUserLoggedIn = false;
                $analytics.setAlias("");
                $analytics.setUsername("");
                $analytics.setUserProperties("");
                mixpanel.cookie.clear();

                resolve();
            });
        };
        // this.requestOTP = function (mobile) {
        //     console.log("mobile", mobile);
        // };
        //
        // this.signup = function () {
        //
        // };

    }]);

/**
 * Created by kumardivyarajat on 03/06/17.
 */
angular.module("app.campaigns", [])
    .controller("campaign.controller", ["$scope", "RestManager", "$mdToast", "$mdDialog", function ($scope, RestManager, $mdToast, $mdDialog) {
        $scope.campaign = {};


        $scope.sendMails = function () {
            $scope.sendingMails = true;
            var data = {};
            angular.copy($scope.campaign, data);
            data.emailList = data.emailList.split(",").map(function (o) {
                return o.trim();
            });
            console.log("sendMails", data);
            RestManager.postResource("/mailer/spam", data, "mails")
                .then(function (result) {
                    $scope.sendingMails = false;
                    var alert = $mdDialog.alert({
                        title: 'Success',
                        textContent: 'Sent all the ' + result.length + " emails !",
                        ok: 'Close'
                    });

                    $mdDialog
                        .show(alert)
                        .finally(function () {
                            alert = undefined;
                        });

                })
                .catch(function (err) {
                    $mdToast.showSimple("Error | Message => " + err.message)
                })
        };
    }]);
(function () {
    var service = angular.module('app.main');

    service.factory('UuidService', UuidService);

    function UuidService() {

        /**
         * Generates a rfc4122 UUID based on:
         * http://stackoverflow.com/a/21963136/1579559.
         */
        var lut = Array(256).fill().map(function (_, i) {
            return (i < 16 ? '0' : '') + (i).toString(16);
        });

        var formatUuid = function (data) {
            var d0 = data.d0;
            var d1 = data.d1;
            var d2 = data.d2;
            var d3 = data.d3;
            return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' +
                lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' +
                lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' +
                lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' +
                lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] +
                lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] +
                lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
        }


        var getRandomValuesFunc = window.crypto && window.crypto.getRandomValues ?
            function () {
                var dvals = new Uint32Array(4);
                window.crypto.getRandomValues(dvals);
                return {
                    d0: dvals[0],
                    d1: dvals[1],
                    d2: dvals[2],
                    d3: dvals[3],
                };
            } :
            function () {
                return {
                    d0: Math.random() * 0x100000000 >>> 0,
                    d1: Math.random() * 0x100000000 >>> 0,
                    d2: Math.random() * 0x100000000 >>> 0,
                    d3: Math.random() * 0x100000000 >>> 0,
                };
            }

        var uuid = function () {
            return formatUuid(getRandomValuesFunc())
        };

        var service = {
            generate: generateUuid,
        };

        return service;

        // Private functions.
        function generateUuid() {
            return uuid();
        }
    }
})();

/**
 * Created by kumardivyarajat on 06/12/16.
 */
angular.module("app.main")
    .directive('mdUploader', ["RestManager", "$rootScope", "$timeout", "Upload", function (RestManager, $rootScope, $timeout, Upload) {
        return {
            // Restrict it to be an attribute and element in this case
            restrict: 'AE',
            // responsible for registering DOM listeners as well as updating the DOM
            link: function (scope, element, attrs) {
                scope.images = [];
                scope.uploads = [];

                $rootScope.$on("dataReady", function () {
                    scope.multiple = $rootScope.imageUploader.multiple;
                    scope.context = $rootScope.imageUploader.context;
                    scope.selectionType = $rootScope.imageUploader.selectionType;
                });

                RestManager.getResource("/images", "images")
                    .then(function (images) {
                        console.log(images);
                        scope.images = images;
                    })
                    .catch(function (err) {
                        console.log(err);
                    });


                scope.indexList = [];
                scope.updateImg = function (image, index) {
                    if (scope.multiple) {
                        scope.indexList[index] = true;
                        scope.uploads.push(image);
                    } else {
                        scope.selectedImage = image;
                    }
                };

                scope.passImage = function () {
                    console.log(scope.uploads, scope.selectedImage);
                    var data = {};
                    if (scope.multiple) {
                        data = scope.uploads;
                    } else {
                        data = scope.selectedImage;
                    }

                    $rootScope.$emit("imagesReady", {
                        data: data
                    })
                };

                /*
                 *
                 *
                 * */
                var initializing = true;

                scope.$watch('files', function () {
                    if (initializing) {
                        $timeout(function () {
                            initializing = false;
                        });
                    } else {
                        scope.upload(scope.files);
                    }
                });

                scope.log = '';

                // upload on file select or drop
                scope.upload = function (file) {
                    // console.log(file);
                    var data = {
                        files: file,
                        context: scope.context ? scope.context : "simple"
                    };

                    for (var i in file) {
                        if (scope.images && scope.images.length > 0) {
                            scope.images.unshift({});
                        }
                    }

                    Upload.upload({
                        url: Base.getBaseUrl() + "/images/upload",
                        method: 'POST',
                        arrayKey: '',
                        data: data
                    }).then(function (resp) {
                        // console.log('Success ', resp.status, 'uploaded. Response: ', resp.data.message);
                        if (resp.data.code == 200) {
                            for (var i in file) {
                                if (scope.images && scope.images.length > 0) {
                                    scope.images.shift();
                                }
                            }
                            for (var i in resp.data.message.images) {
                                scope.images.unshift(resp.data.message.images[i]);
                            }
                        }
                    }, function (resp) {
                        // console.log('Error status: ' + resp.status);
                    }, function (evt) {
                        // console.log(evt);
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        // console.log('progress: ' + progressPercentage + '% ', evt.config.data.files);
                    });
                };
            },
            templateUrl: 'directives/templates/uploader.html'
        };
    }]);


/**
 * Created by kumardivyarajat on 05/12/16.
 */
angular.module("app.main")
    .directive('staticInclude', ["$http", "$templateCache", "$compile", function ($http, $templateCache, $compile) {
        return function (scope, element, attrs) {
            var templatePath = attrs.staticInclude;
            $http.get(templatePath, {cache: $templateCache}).then(function (response) {
                var contents = element.html(response.data).contents();
                $compile(contents)(scope);
            });
        };
    }]);
(function () {
    'use strict';

    angular.module('app.main')
        .directive('selectOnClick', ['$window', function ($window) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    element.on('click', function () {
                        if (!$window.getSelection().toString()) {
                            // Required for mobile Safari
                            this.setSelectionRange(0, this.value.length)
                        }
                    });
                }
            };
        }]);

})(angular);

/**
 * Created by kumardivyarajat on 08/05/17.
 */
angular.module("app.main")
    .directive("preview", function () {
        function link(scope, element) {


            scope.$watch('content', function (data) {
                if(data) {
                    var iframe = document.createElement('iframe');
                    iframe.style.width = "100%";
                    iframe.style.height = "400px";
                    var element0 = element[0];
                    element0.appendChild(iframe);
                    var body = iframe.contentDocument.body;
                    var el = document.createElement( 'html' );
                    el.innerHTML = data;
                    console.log("el.getElementsByTagName('body')", el.getElementsByTagName('body')[0]);
                    var bodyData = el.getElementsByTagName('body')[0].innerHTML;
                    body.innerHTML = bodyData;
                    // scope.$apply();
                }
            });
        }

        return {
            link: link,
            restrict: 'E',
            scope: {
                content: '='
            }
        };
    });
(function () {
    'use strict';

    angular.module('app.main')
        .directive('onEnterPress', function () {
            return function (scope, element, attrs) {
                element.bind("keydown keypress", function (event) {
                    if(event.which === 13) {
                        scope.$apply(function (){
                            scope.$eval(attrs.myEnter);
                        });

                        event.preventDefault();
                    }
                });
            };
        });

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 06/10/19, 12:57 PM
 *
 */

(function () {
    'use strict';

    angular.module('app.main')
        .directive('mousepointMenu', [function () {
            return {
                restrict: 'A',
                require: 'mdMenu',
                link: function ($scope, $element, $attrs, mdMenuCtrl) {
                    var MousePointMenuCtrl = mdMenuCtrl;

                    var prev = {x: 0, y: 0}

                    $scope.$mdOpenMousepointMenu = function($event) {
                        MousePointMenuCtrl.offsets = function() {
                            return {
                                left: $event.offsetX,
                                top: $event.offsetY
                            };
                        };
                        MousePointMenuCtrl.open($event);
                    };
                }

            };
        }])

})(angular);

/**
 * Created by kumardivyarajat on 14/12/16.
 */
angular.module("app.main")
    .directive("mdImageSlider", ["$interval", "$log", "$state", "$window", "$document", "$mdMedia", "$timeout", "$rootScope", "Base", function ($interval, $log, $state, $window, $document, $mdMedia, $timeout, $rootScope, Base) {
        return {
            restrict: "AEC",
            transclude: true,
            scope: {
                srcList: "=",
                autoPlay: "=",
                interval: "=",
                overlay: "=",
                controls: "=",
                fullLink: "=",
                isMobile : "=",
                aspectRatio : '=?'
            },
            link: function (scope, element, attrs) {
                scope.currentItem = 0;

                scope.isSmall = !$mdMedia("gt-sm");

                if(!scope.srcList.length || scope.srcList.length === 1) {
                    scope.hideIndicator = true;
                }
                var a, b;

                if(_.isString(scope.interval)) {
                    scope.interval = parseInt(scope.interval);
                    if(!scope.interval) {
                        scope.autoPlay = false;
                    }
                }

                if (scope.autoPlay) {
                    a = $interval(function () {
                        scope.currentItem = (scope.currentItem + 1) % scope.srcList.length;
                        // $log.info("Changed the slider image. Image at" + scope.currentItem + " is " + scope.srcList[scope.currentItem]);
                    }, scope.interval)
                }


                _.forEach(scope.srcList, function (o, i) {
                    if (scope.isSmall && o.position) {
                        o.alignClass = "layout-align-center-start";
                    } else if(o.position) {
                        o.alignClass = "layout-align-" + o.position.split(" ").join("-");
                    } else {
                        o.alignClass = "layout-align-center-center"
                    }
                });

                scope.getClass = function ($index) {
                    return scope.srcList[$index].alignClass;
                };

                scope.getButtonClass = function (index) {
                    return scope.srcList[index].buttonColor + " " + scope.srcList[index].buttonTextColor + "-text";
                };

                scope.performAction = function (event, index) {
                    if (scope.srcList[scope.currentItem].buttonSref) {
                        $state.go(scope.srcList[scope.currentItem].buttonSref);
                    }
                };

                scope.getUrl = function(url) {
                    if(url.indexOf('assets') !== -1) {
                        return url;
                    } else {
                        return Base.getMediaUrl() + url;
                    }
                }

                scope.next = function () {
                    scope.currentItem = (scope.currentItem + 1) % scope.srcList.length;
                    if (scope.autoPlay) {
                        $interval.cancel(a);
                        a = $interval(function () {
                            scope.currentItem = (scope.currentItem + 1) % scope.srcList.length;
                            // $log.info("Changed the slider image. Image at" + scope.currentItem);
                        }, scope.interval)
                    }
                };

                scope.previous = function () {
                    if (scope.currentItem === 0) {
                        scope.currentItem = scope.srcList.length - 1;
                    } else {
                        scope.currentItem = (scope.currentItem - 1) % scope.srcList.length;
                    }
                    if (scope.autoPlay) {
                        $interval.cancel(a);
                        a = $interval(function () {
                            scope.currentItem = (scope.currentItem + 1) % scope.srcList.length;
                            // $log.info("Changed the slider image. Image at" + scope.currentItem);
                        }, scope.interval)
                    }
                };

                var pendingSwipe = false;

                scope.onSwipeLeft = function () {
                    if (scope.isSmall && !pendingSwipe) {
                        scope.next();
                        pendingSwipe = true;
                        b = $timeout(function () {
                            pendingSwipe = false;
                        }, 100);
                    }
                };

                scope.onSwipeRight = function () {
                    if (scope.isSmall && !pendingSwipe) {
                        scope.previous();
                        pendingSwipe = true;
                        b = $timeout(function () {
                            pendingSwipe = false;
                        }, 100);
                    }
                };

                scope.change = function (newIndex) {
                    scope.currentItem = newIndex % scope.srcList.length;
                    if (scope.autoPlay) {
                        $interval.cancel(a);
                        a = $interval(function () {
                            scope.currentItem = (scope.currentItem + 1) % scope.srcList.length;
                            // $log.info("Changed the slider image. Image at" + scope.currentItem);
                        }, scope.interval)
                    }
                };

                scope.$on('$destroy', function () {
                    $interval.cancel(a);
                    $timeout.cancel(b);
                });

                scope.buildUrl = function () {
                    if (scope.srcList[scope.currentItem]) {
                        var src = scope.srcList[scope.currentItem];
                        return $state.href(src.state, src.params);
                    } else {
                        return undefined;
                    }
                };


                if(!scope.aspectRatio) {
                    scope.aspectRatio = (1920 / 1080);
                }
                // Maintain aspect ratio
                scope.width = ($window.innerWidth <= 1440) ? $window.innerWidth : 1440;
                scope.height = Math.min(( scope.width - scope.width / 3), scope.width / scope.aspectRatio);

                scope.heightPx = scope.height + 'px';

                $rootScope.varHeight = scope.height;


                // FIxed height
                // scope.height = 400;
                // //

                // element.on("load", function () {
                //     //
                // });

                // image: "assets/images/summer-singlet-1200x750.jpg",
                //     position: "center start",
                //     button: true,
                //     heading: "New Arrivals",
                //     text: "Buy the latest fashion.",
                //     buttonText: "Shop Now",
                //     buttonColor: "white",
                //     buttonTextColor: "black",
                //     buttonIcon: "",
                //     buttonSref: "app.customisation"

            },
            templateUrl: "app/modules/base/directives/templates/mdSlider.tpl.html"
        }
    }]);

/**
 * Created by kumardivyarajat on 05/12/16.
 */
angular.module("app.main")
    .directive("mdSectionHeader", ["$state", "$mdToast", "$window", function ($state, $mdToast, $window) {
        return {
            restrict: "E",
            transclude: true,
            replace: true,
            scope: {
                mdSectionTitle: "@",
                mdBackState: "@",
                mdBackParams: "=",
                mdNestedState: "=",
                copyTitleButton : "=",
                copyTitleTooltip : "="
            },
            link: function (scope, attrs, element) {
                scope.goToState = function () {
                    $state.go(scope.mdBackState, scope.mdBackParams);
                };

                scope.showToast = function (message) {
                    $mdToast.showSimple(message);
                };
            },
            templateUrl: "app/modules/base/directives/templates/mdSectionHeader.tpl.html"
        }
    }]);

/**
 * Created by kumardivyarajat on 17/12/16.
 */
angular.module("app.main")
    .directive("mdPreload", ["ImagePreloader", "Base", "$interval", "$log", "$state", "$window", "$document", "$mdMedia", "$timeout", function (ImagePreloader, Base, $interval, $log, $state, $window, $document, $mdMedia, $timeout) {
        return {
            restrict: "AEC",
            scope: {
                mdSrc: "=",
                itemIndex: '=',
                key: "@",
                stagedKey: '@',
                aspectRatio: '=?',
                width: '=?',
                height: '=?',
            },
            link: function (scope, element, attrs) {
                if (!scope.stagedKey) {
                    scope.stagedKey = 'thumbnail';
                }
                var a = scope.$watch('element', function () {
                    // a();
                    // //
                    var b = scope.$watch('mdSrc', function (mdSrc) {
                        // b();
                        if (mdSrc) {
                            // //
                            // //
                            // //
                            if (mdSrc &&
                                mdSrc.urls &&
                                mdSrc.urls.full &&
                                mdSrc.urls.full.indexOf('gif') !== -1) {
                                scope.key = 'full';
                            }

                            var observer = '', img = '';
                            var aspectRatio = scope.aspectRatio;

                            if (!aspectRatio && scope.width && scope.height) {
                                aspectRatio = parseFloat(scope.height / scope.width);
                            } else if (!aspectRatio) {
                                aspectRatio = parseFloat(205 / 150)
                            }

                            var css = {
                                width: "100%",
                                height: element.parent()[0].clientWidth * aspectRatio + "px"
                            };
                            try {
                                css.background = mdSrc.swatch.css;
                            } catch (e) {
                                css.background = "rgb(53,62,84)";
                            }
                            loadBlurredImage();


                            $timeout(function () {

                                if (typeof IntersectionObserver !== "undefined") {
                                    if (scope.itemIndex > 2) {
                                        scope.itemIndex = 2;
                                    }

                                    observer = new IntersectionObserver(loadImg, {
                                        rootMargin: '100px 0px 100px 0px',
                                        root: document.querySelector('#body')
                                    });
                                    img = angular.element(element)[0];
                                    observer.observe(img);
                                } else {
                                    changeSources()
                                }
                                element.css(css);
                            });


                            // changeSources()

                            function loadImg(changes) {
                                changes.forEach(function (change) {
                                    if (change.intersectionRatio > 0) {
                                        // change.target.src = 'boy.jpg'
                                        changeSources();
                                        observer.unobserve(img);
                                    }
                                })
                            }

                            function changeSources() {

                                ImagePreloader.preloadImages([prefixBaseUrl(mdSrc.urls[scope.key])])
                                    .then(function (done) {
                                        //
                                        if (done[0]) {
                                            element.css({
                                                width: "100%",
                                                height: "auto",
                                                background: ""
                                            });
                                            element.attr({src: prefixBaseUrl(mdSrc.urls[scope.key])});
                                        }
                                    })
                                    .catch(function (err) {
                                        //
                                    });
                            }

                            function loadBlurredImage() {
                                var url = prefixBaseUrl(getBlurredImage(mdSrc.urls[scope.key]));
                                element.attr({src: url});
                                element.css({
                                    width: "100%",
                                    height: "auto",
                                    background: "",
                                    opacity: 1,
                                    animation: 'fadein 0.75s',
                                    '-moz-animation': 'fadein 0.75s', /* Firefox */
                                    '-webkit-animation': 'fadein 0.75s', /* Safari and Chrome */
                                    '-o-animation': 'fadein 0.75s'
                                });

                                // ImagePreloader.preloadImages([url])
                                //     .then(function (done) {
                                //         if (done[0]) {
                                //             element.css({
                                //                 width: "100%",
                                //                 height: "auto",
                                //                 background: "",
                                //                 opacity: 1,
                                //                 animation: 'fadein 0.75s',
                                //                 '-moz-animation': 'fadein 0.75s', /* Firefox */
                                //                 '-webkit-animation': 'fadein 0.75s', /* Safari and Chrome */
                                //                 '-o-animation': 'fadein 0.75s'
                                //             });
                                //             element.attr({src: url});
                                //         }
                                //     })
                            }

                        }
                    })

                });

                function getBlurredImage(url) {
                    var a = url.split(".");
                    return a[0] + "-staged." + a[1];
                }

                function prefixBaseUrl(imageUrl) {
                    if (imageUrl && imageUrl.indexOf("http") === -1) {
                        scope.base = Base.getMediaUrl();
                        return scope.base + imageUrl;
                    } else if (imageUrl.indexOf("http") !== -1) {
                        return imageUrl;
                    } else {
                        return "/assets/images/placeholder.png";
                    }
                }

            }
        }
    }]);

/**
 * Created by kumardivyarajat on 29/05/17.
 */
angular.module("app.main")
    .directive("mdLightbox", ["$state", "$mdDialog", function ($state, $mdDialog) {
        return {
            restrict: "EA",
            transclude: false,
            replace: false,
            scope: {
                ngSrc: "@",
                mdBackState: "@",
                mdNestedState: "=",
            },
            link: function (scope, attrs, element) {

            },
            templateUrl: "app/modules/base/directives/templates/mdLightbox.tpl.html"
        }
    }]);

/**
 * Created by kumardivyarajat on 13/01/17.
 */
angular.module("app.main")
    .directive("mdInlineInputContainer", ["$state", function ($state) {
        return {
            restrict: "E",
            transclude: true,
            replace: false,
            scope: {
                inputType: "@",
                class: "@",
                bindedModel: "=ngModel",
                placeholder: "@",
                label: "@",
                width: "@",
                onBlur: '&',
                onDeleteClicked : '&',
                onAddRowAfterClicked : '&'
            },
            link: function (scope, element, attrs) {
                scope.editing = false;
                scope.showingMenu = false;

                scope.toggleMenu = function (ev, showIp) {
                    scope.showingMenu = !scope.showingMenu;
                    if(showIp) {
                        scope.showIp()
                    }
                };

                scope.showIp = function () {
                    scope.editing = true;
                    console.log('as',angular.element(element)[0].getElementsByClassName('inline-input-box')[0]);
                    angular.element(element)[0].getElementsByClassName('inline-input-box')[0].focus();
                };

                // scope.closeMenu = function (ev) {
                //     scope.showingMenu = false
                // }
            },
            templateUrl: "app/modules/base/directives/templates/mdInlineInputContainer.tpl.html"
        }
    }]);

/**
 * Created by kumardivyarajat on 24/08/17.
 */
(function () {
    "use strict";
    MdImageDirective.$inject = ["Base", "$sce"];
    angular.module("app.main")
        .directive("mdImg", MdImageDirective);


    function MdImageDirective(Base, $sce) {
        return {
            restrict: "E",
            scope: {
                src: "@mdSrc",
                hideLazyLoad : '=',
                noCover : "="
            },
            replace: true,
            template: "<img ng-src='{{ srcUrl }}' />",
            compile: function (element, attr) {
                for (var i in attr) {
                    if (i.indexOf('$') === -1)
                        angular.element(element).attr(i, attr[i]);
                }
                return {
                    pre: function (scope, element, attr) {
                        var observer, img;
                        if (typeof IntersectionObserver !== "undefined" && !scope.hideLazyLoad) {
                            observer = new IntersectionObserver(loadImg);
                            img = angular.element(element)[0];
                            observer.observe(img);
                            scope.srcUrl = "/assets/images/placeholder.png";
                        } else {
                            changeSource()
                        }

                        function loadImg(changes) {
                            changes.forEach(function (change) {
                                if (change.intersectionRatio > 0) {
                                    // return link function
                                    changeSource()
                                    observer.unobserve(img);
                                }
                            })
                        }

                        scope.$watch('src', function (newVal, oldVal) {
                           changeSource();
                        });

                        function changeSource() {
                            if (scope.src && scope.src === 'default.png') {
                                scope.srcUrl = "/assets/images/default.png"
                            } else if (scope.src && (scope.src.indexOf("http") === -1)) {
                                scope.base = Base.getMediaUrl();
                                scope.srcUrl = scope.base + scope.src;
                            } else if (scope.src && (scope.src.indexOf("http") !== -1)) {
                                scope.srcUrl = scope.src;
                            } else if(!scope.hideLazyLoad || !scope.noCover) {
                                scope.srcUrl = "/assets/images/placeholder.png";
                            }
                        }

                    }
                };
            }
        }

    }

})();

/**
 * Created by kumardivyarajat on 16/12/16.
 */
angular.module("app.main")
    .directive("mdAbsolute", function () {
        return {
            restrict: "EA",
            scope: {
                mdPosition: "@",
                mdPadding: "@",
                mdMargin: "@",
                mdTag: "=",
                backgroundColor: "@",
                textColor: "@"
            },
            link: function (scope, element, attrs) {
                var css = {
                    position: "absolute",
                };
                var topRegex = /((top))/;
                var bottomRegex = /((bottom))/;
                var rightRegex = /((right))/;
                var leftRegex = /((left))/;

                if (testRegex(topRegex, scope.mdPosition)) {
                    css.top = 0;
                } else if (testRegex(bottomRegex, scope.mdPosition)) {
                    css.bottom = 0;
                }

                if (testRegex(leftRegex, scope.mdPosition)) {
                    css.left = 0;
                } else if (testRegex(rightRegex, scope.mdPosition)) {
                    css.right = 0;
                }

                if (typeof scope.mdMargin != "undefined") {
                    css.margin = scope.mdMargin;
                }

                if (typeof scope.mdPadding != "undefined") {
                    css.padding = scope.mdPadding;
                }

                if (scope.mdTag) {
                    css["border-radius"] = "2px";
                    css["text-transform"] = "uppercase";
                    css["font-weight"] = 700;
                    css.color = scope.textColor;
                    css.background = scope.backgroundColor;
                }

                element.css(css);

                function testRegex(lhs, rhs) {
                    return lhs.test(rhs);
                }
            }
        }
    });
/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 21/6/19 6:07 AM
 *
 */

(function () {
    'use strict';

    angular.module('app.main')
        .directive('inputFocus', ["$timeout", function ($timeout) {
            return {
                scope: {trigger: '=inputFocus'},
                link: function (scope, element) {
                    scope.$watch('trigger', function (value) {
                        if (value === true) {
                            //console.log('trigger',value);
                            //$timeout(function() {
                            element[0].focus();
                            scope.trigger = false;
                            //});
                        }
                    });
                }
            };
        }]);
})(angular);

/**
 * Created by kumardivyarajat on 18/11/16.
 */
angular.module('app.main')
    .directive('elementWidth', function () {
        return {
            restrict: "A",
            link: function ($scope, element) {
                // do something with the element width here
                element.html('Your element is ' + element[0].clientWidth + 'pixels');
            }
        }
    });
(function () {
    WebWorkerService.$inject = ["$rootScope", "$q"];
    var service = angular.module('app.main');

    service.factory('WebWorkerService', WebWorkerService);

    function WebWorkerService($rootScope, $q) {

        return {
            evalCustomisationState: evalCustomisationState
        };


        function evalCustomisationState(values, layerIndex, optionIndex) {
            var webWorker = new Worker('assets/scripts/customisation-state-worker.js');
            var defer = $q.defer();
            webWorker.postMessage(
                JSON.stringify([
                    'evalCustomisationState',
                    values,
                    layerIndex,
                    optionIndex
                ])
            );

            webWorker.onmessage = function (message) {
                var data = JSON.parse(message.data);
                defer.resolve(data[0]);
                webWorker.terminate();
            };

            return defer.promise;
        }

    }
})();

/**
 * Created by kumardivyarajat on 12/11/16.
 */
angular.module("app.main")
    .directive("customisableProduct", ["Base", function (Base) {
        return {
            restrict: "AE",
            replace: true,
            scope: {
                customisation: "=",
                size: "@",
                name: "@",
                whiteFrame: "="
            },
            link: function (scope, attrs, element) {

                scope.mediaUrl = Base.getMediaUrl();

                switch (scope.size) {
                    case 'x-large' :
                        scope.style = {'width': getWidth(900), 'height': '900px'};
                        scope.key = "c_x_large";
                        break;

                    case 'large' :
                        scope.style = {'width': getWidth(600), 'height': '600px'};
                        scope.key = "c_large";
                        break;

                    case 'medium' :
                        scope.style = {'width': getWidth(450), 'height': '450px'};
                        scope.key = "c_large";
                        break;

                    case 'small' :
                        scope.style = {'width': getWidth(300), 'height': '300px'};
                        scope.key = "c_medium";
                        break;

                    case 'x-small' :
                        scope.style = {'width': getWidth(225), 'height': '225px'};
                        scope.key = "c_medium";
                        break;

                    case 'thumbnail' :
                        scope.style = {'width': getWidth(112.5), 'height': '112.5px'};
                        scope.key = "c_thumbnail";
                        break;

                    default:
                        scope.key = "c_medium";
                        break;
                }

                if (scope.whiteFrame) {
                    scope.whiteFrameValue = 1;
                } else {
                    scope.whiteFrameValue = -1;
                }


                function getWidth(height) {
                    return ((400 / 600) * height) + "px";
                }

            },
            templateUrl: "app/modules/base/directives/templates/cp.tpl.html"
        }
    }]);

/**
 * Created by kumardivyarajat on 13/11/16.
 */

angular.module("app.main")
    .directive("customisableProductView", ["Base", "WebWorkerService", "$timeout", function (Base, WebWorkerService, $timeout) {
        return {
            restrict: "AE",
            replace: true,
            scope: {
                customisation: "=",
                size: "@",
                selectedIndex: "=",
                currentIndex: "=",
                position: "=",
                backgroundScale: '='
            },

            // SelectedIndex - The index of the selected data option i.e the pattern, neck or some other data
            // currentIndex - The current populated index
            link: function (scope, attrs, element) {
                scope.url = Base.getMediaUrl();

                scope.backgroundScale = scope.backgroundScale || "175%";

                scope.baseLayerIndex = _.findIndex(scope.customisation.data, function (datum) {
                    return datum.isBaseLayer;
                });

                scope.previewsData = [];
                scope.composeWatchGroup = [];
                scope.hasBaseLayer = scope.baseLayerIndex !== -1;
                scope.currentOption = scope.customisation.data[scope.selectedIndex].options[scope.currentIndex];

                scope.getLimit = getLimit;
                scope.init = init;
                scope.evalState = evalState;

                if(scope.currentOption.watchList) {
                    scope.composeWatchGroup = scope.currentOption.watchList.map(function (value) {
                        return 'customisation.data[' + scope.customisation.layerMap[value] + '].default'
                    });
                }

                if (scope.composeWatchGroup.length) {
                    scope.$watchGroup(scope.composeWatchGroup, function (newVal) {
                        scope.evalState();
                    }, true);
                }

                // scope.$watch('customisation', function (newVal) {
                //     scope.init();
                // }, true);


                function init() {
                    scope.previewsData = scope.customisation.data.map(function (layer, i) {
                        return layer.preview;
                    });
                }

                function evalState() {
                    WebWorkerService
                        .evalCustomisationState(
                            scope.customisation,
                            scope.selectedIndex,
                            scope.currentIndex
                        )
                        .then(function (result) {
                            scope.previewsData = result;
                            console.log('Updated', scope.currentOption.name, scope.previewsData)
                        })
                }

                function getLimit() {
                    if (scope.customisation.data[0].name === 'Fabric') {
                        return (1 - scope.customisation.data.length)
                    } else if (scope.hasBaseLayer && scope.selectedIndex === scope.baseLayerIndex) {
                        return scope.baseLayerIndex + 1;
                    } else {
                        return scope.customisation.data.length
                    }
                }

                switch (scope.size) {
                    case 'x-large' :
                        scope.style = {'width': '1200px', 'height': '1640px'};
                        scope.key = "full";
                        break;

                    case 'large' :
                        scope.style = {'width': '600px', 'height': '840px'};
                        scope.key = "large";
                        break;


                    case 'medium-2x' :
                        scope.style = {'width': '300px', 'height': '410px'};
                        scope.key = "large";
                        break;

                    case 'medium' :
                        scope.style = {'width': '300px', 'height': '410px'};
                        scope.key = "medium";
                        break;

                    case 'small-2x' :
                        scope.style = {'width': '150px', 'height': '205px'};
                        scope.key = "medium";
                        break;

                    case 'small' :
                        scope.style = {'width': '150px', 'height': '205px'};
                        scope.key = "thumbnail";
                        break;

                    case 'x-small' :
                        scope.style = {'width': '100px', 'height': '139px'};
                        scope.key = "thumbnail";
                        break;

                    case 'x-small-2x' :
                        scope.style = {'width': '100px', 'height': '150px'};
                        scope.key = "medium";
                        break;

                    case 'thumbnail' :
                        scope.style = {'width': '75px', 'height': '102.5px'};
                        scope.key = "thumbnail";
                        break;

                    case 'thumbnail-2x' :
                        scope.style = {'width': '75px', 'height': '102.5px'};
                        scope.key = "thumbnail";
                        break;

                    case 'responsive' :
                        var a = scope.$watch('element', function () {
                            if (screen.width > 0) {
                                console.log(element);
                                var h = element[0].parentElement.clientHeight;
                                var w = h * (150 / 205);
                                console.log(w, h);
                                scope.style = {'width': w + 'px', 'height': h + 'px'};
                                scope.key = "medium";
                                a();
                            }
                        });

                        break;

                    default:
                        scope.key = "medium";
                        break;

                }

                scope.init();
            },
            templateUrl: "app/modules/base/directives/templates/cp-view.tpl.html"
        }
    }]);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 6/6/19 6:45 PM
 *
 */

(function () {
    'use strict';

    angular.module('app.main')
        .directive('bubbleLoader', bubbleLoader);

    function bubbleLoader() {
        return {
            restrict: "E",
            replace : true,
            scope: {

            },
            link: function (scope, attrs, element) {
            },
            templateUrl: "app/modules/base/directives/templates/bubble-loader.html"
        }
    }
})(angular);

(function () {
    'use strict';

    angular.module('app.main')
        .directive('attachedTag', AttachedTag);

    function AttachedTag() {
        return {
            restrict: "E",
            transclude: {
                'content': '?tagContent'
            },
            scope: {
                tagType: "@",
                showTill: "=",
                top: '@',
                right: '@',
                bottom: '@',
                left: '@',
                background: '@',
                ngClass: '@'
            },
            link: function (scope, attrs, element) {
                if (!scope.top) {
                    scope.top = '2px';
                }
                if (!scope.right) {
                    scope.right = '2px';
                }
                scope.style = {top: scope.top, right: scope.right, left : scope.left, bottom : scope.bottom};
                if (scope.background) {
                    scope.style.background = scope.background;
                }
            },
            templateUrl: "app/modules/base/directives/templates/attached-tag.tmpl.html"
        };
    }
})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 24/6/19 2:21 PM
 *
 */

(function () {
    'use strict';

    angular.module('app.main')
        .directive('appendText', ['$rootScope', function ($rootScope) {
            return {
                link: function (scope, element, attrs) {
                    scope.$on('add', function (e, val) {
                        var domElement = element[0];
                        if (document.selection) {
                            domElement.focus();
                            var sel = document.selection.createRange();
                            sel.text = val;
                            domElement.focus();
                        } else if (domElement.selectionStart || domElement.selectionStart === 0) {
                            var startPos = domElement.selectionStart;
                            var endPos = domElement.selectionEnd;
                            var scrollTop = domElement.scrollTop;
                            domElement.value = domElement.value.substring(0, startPos) + val + domElement.value.substring(endPos, domElement.value.length);
                            domElement.focus();
                            domElement.selectionStart = startPos + val.length;
                            domElement.selectionEnd = startPos + val.length;
                            domElement.scrollTop = scrollTop;
                        } else {
                            domElement.value += val;
                            domElement.focus();
                        }
                        $rootScope.$broadcast('interpolationDone', domElement.value);
                    });
                }
            }
        }])

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 27/8/19 2:18 AM
 *
 */

(function () {
    'use strict';

    angular.module('app.main')
        .directive('aaridaMentions', ["RestManager", function (RestManager) {
            return {
                require: 'uiMention',
                link: function ($scope, $element, $attrs, uiMention) {
                    /**
                     * Converts a choice object to a human-readable string
                     *
                     * @param  {mixed|object} choice The choice to be rendered
                     * @return {string}              Human-readable string version of choice
                     */
                    uiMention.label = function (choice) {
                        return  choice.name;
                    };


                    uiMention.renderElement = function () {
                        return angular.element(getNextSibling($element[0].parentElement, '.mention-highlight'))
                    };

                    var getNextSibling = function (elem, selector) {

                        // Get the next sibling element
                        var sibling = elem.nextElementSibling;

                        // If there's no selector, return the first sibling
                        if (!selector) return sibling;

                        // If the sibling matches our selector, use it
                        // If not, jump to the next sibling and continue the loop
                        while (sibling) {
                            if (sibling.matches(selector)) return sibling;
                            sibling = sibling.nextElementSibling
                        }

                    };

                    uiMention.autogrow = function () {
                        $element[0].style.minHeight = '2.5em'; // autoshrink - need accurate scrollHeight
                        var style = getComputedStyle($element[0]);
                        if (style.boxSizing == 'border-box') {
                            $element[0].style.height = $element[0].scrollHeight + 'px';
                        }
                    };

                    /**
                     * Retrieves choices
                     *
                     * @param  {regex.exec()} match    The trigger-text regex match object
                     * @param mentions
                     * @return {array[choice]|Promise} The list of possible choices
                     */
                    uiMention.findChoices = function (match, mentions) {
                        if (match[1].length < 3) {
                            return;
                        }
                        uiMention.loading = true;
                        var query = {
                            page: 1,
                            limit: 5,
                            order: 'name',
                            fields: 'name,email',
                            q: match[1],
                            roles: 'admin,sales-staff'
                        };
                        return RestManager.getResource("/users/filter", "users", {query: query})
                            .then(function (users) {
                                users = users.map(function (user) {
                                    user.id = user._id;
                                    return user;
                                });
                                //
                                // var fuse = new Fuse(users, options);
                                uiMention.loading = false;
                                // return fuse.search(match[1])
                                return users;
                            })
                            .catch(function (err) {
                                uiMention.loading = false;
                                console.log(err);
                            })
                    };
                }
            };
        }]);

})(angular);

/**
 * Created by kumardivyarajat on 04/11/16.
 */
angular.module("app.main")
    .directive("aadiraCard", function () {
        return {
            restrict: "E",
            transclude: true,
            replace : true,
            link: function (scope, attrs, element) {
                console.log("product",scope.product);
            },
            templateUrl: "app/modules/base/directives/templates/aadiraCard.tpl.html"
        }
    });
/**
 * Created by kumardivyarajat on 28/01/17.
 */
angular.module('app.cart',[]);
/**
 * Created by kumardivyarajat on 28/01/17.
 */
angular.module('app.cart')
    .controller("carts.all.controller", ["$scope", "$mdDialog", "$stateParams", "RestManager", "$state", function ($scope, $mdDialog, $stateParams, RestManager, $state) {

        $scope.selected = [];
        $scope.query = {
            sort: '-updatedAt',
            limit: 25,
            page: 1,
            searchTerm: "",
            status: 'active'
        };

        if ($stateParams.page) {
            $scope.query.page = $stateParams.page;
        }

        if ($stateParams.limit) {
            $scope.query.limit = $stateParams.limit;
        }

        if ($stateParams.order) {
            $scope.query.order = $stateParams.order;
        }

        if ($stateParams.searchTerm) {
            $scope.query.searchTerm = $stateParams.searchTerm;
        }


        // function success(carts) {
        //     $scope.carts = carts;
        //     console.log(carts);
        // }

        $scope.openNotifications = openNotifications;
        $scope.searchUser = searchUser;
        $scope.sendBulkNotifications = sendBulkNotifications;
        $scope.clearSelections = clearSelections;

        function clearSelections() {
            $scope.selected = [];
        }

        function searchUser(userSearch) {
            if( userSearch && userSearch.length > 3) {
                RestManager.getResource('/users/filter', 'users', {
                    query: {
                        page: 1,
                        limit: $scope.query.limit,
                        q: userSearch,
                        fields: '_id,name'
                    }
                })
                    .then(function (users) {
                        if (users && users.length) {
                            $scope.query.user = users.map(function (user) {
                                return user._id;
                            });
                            $scope.getAllCarts();
                        } else  {
                            $scope.query.user = null;
                            $scope.carts = [];
                            $scope.total = 0;
                        }
                    })
            } else {
                $scope.query.user = null;
                $scope.getAllCarts();
            }
        }

        function sendBulkNotifications($event) {
            $scope.openNotifications($scope.selected, $event)
        }


        function openNotifications(carts, $event) {
            $event.stopPropagation();
            var orders  = carts.map(function (cart) {
                return {
                    orderData: cart,
                    user: cart.user
                }
            });
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: $event,
                fullscreen: true,
                templateUrl: 'app/modules/components/notifications/user-notifications.html',
                locals: {
                    options: {
                        allowedTags: ['User Name', 'Customer Care Number'],
                        context: 'cart'
                    },
                    order: orders
                },
                controller: 'notificationsController',
                clickOutsideToClose: true
            })
                .then(function (data) {
                    console.log('data', data)
                    $scope.notifications = $scope.notifications.concat(data);
                })
                .catch(function (err) {
                    console.log(err)
                })
        }


        $scope.getAllCarts = function () {
            var url = "/cart/admin";
            $scope.promise = RestManager.getResource(url, "cart", {extras: ["total"], query: $scope.query});

            $scope.promise
                .then(function (result) {
                    $scope.carts = result.cart;
                    $scope.total = result.total;
                    $scope.changeState();
                    console.log(result);
                })
                .catch(function (err) {
                    console.log(err);
                })
        };

        $scope.getAllCarts();


        // RestManager.getResource("/carts/admin", "carts")
        //     .then(function (carts) {
        //         $scope.carts = carts;
        //         console.log(carts);
        //     })
        //     .catch(function (err) {
        //         console.log(err);
        //     });


        $scope.changeState = function () {
            $state.go("app.cartAll", {
                    page: $scope.query.page,
                    limit: $scope.query.limit,
                    order: $scope.query.order,
                    searchTerms: $scope.query.searchTerm
                },
                {notify: false, reload: false})
        };

        $scope.openDetailsPage = function (product, where, event) {
            if (where == 1) {
                console.log(product);
                var url = $state.href('app.carts.add', {slug: product.slug, name: product.name});
                $window.open(url, '_blank');
            } else {
                $state.go('app.products.add', {slug: product.slug, name: product.name});
            }
            console.log("openDetailsPage", "ASdfasd");
            event.stopPropagation();
            // $window.open("/home");
        };


        $scope.moveToTrash = function (product, index, event) {
            var confirm = $mdDialog.confirm()
                .title('Do you want to move ' + product.name + ' to trash ? ')
                .textContent('This action is reversible and the product can be restored from the trash.')
                .ariaLabel('move to trash')
                .targetEvent(event)
                .ok('Yes. I will move it to trash!')
                .cancel('No. Sounds like a scam');

            $mdDialog.show(confirm)
                .then(function () {
                    $scope._moveToTrash(product, index);
                }, function () {
                    $mdToast.showSimple("Cancelled the action");
                });
        };

        $scope._moveToTrash = function (product, index) {
            product.deleted = true;
            console.log(product);
            $scope.promise = RestManager.deleteResource("/products/trash/" + product._id, product, "products")
                .then(function (data) {
                    console.log(data);
                    $scope.products.splice(index, 1);
                    $mdToast.showSimple("Successfully moved product to trash ");
                })
                .catch(function (err) {
                    console.log(err);
                })
        };

        $scope.showProductListDialog = showProductListDialog;

        function showProductListDialog(cart, event) {
            event.stopPropagation();
            $mdDialog.show({
                locals: {
                    products: cart.products
                },
                controller: "ProductListCtrl",
                templateUrl: 'app/modules/products/productListDialog/product-list.dialog.html',
                parent: angular.element(document.body),
                targetEvent: event,
                fullscreen: true,
                clickOutsideToClose: true
            })
        }


        $scope.getProductType = function (product) {
            switch (product.productType) {
                case 0:
                    return "Simple";

                case 1:
                    return "Customizable";
            }
        }
    }]);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 04/12/19, 1:48 AM
 *
 */

(function () {
    WebWorkerService.$inject = ["$rootScope", "$q"];
    var service = angular.module('app.main');

    service.factory('ImageEdgeDetector', WebWorkerService);

    function WebWorkerService($rootScope, $q) {

        return {
            detectEdges: detectEdges
        };


        /**
         *
         * @param pixels [ImageData]
         * @param options
         * @param options.width [Number]
         * @param options.height [Number]
         * @param options.ut [Number]
         * @param options.lt [Number]
         * @returns {*}
         */
        function detectEdges(pixels, options) {
            var webWorker = new Worker('assets/scripts/image-detection-worker.js');
            var defer = $q.defer();
            webWorker.postMessage({
                cmd: 'appData',
                data: {
                    width: options.width,
                    height: options.height,
                    ut: options.ut,
                    lt: options.lt
                }
            });

            webWorker.postMessage({ cmd: 'imgData', data: pixels });


            // const imgd = canvasFrom
            //     .getContext('2d')
            //     .getImageData(0, 0, window.appData.width, window.appData.height);
            // const pixels = imgd.data;

            webWorker.onmessage = function (message) {
                console.log('mes', message)
                // var data = JSON.parse(message.data);
                defer.resolve(message.data.data);
                webWorker.terminate();
            };

            return defer.promise;
        }

    }
})();

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 27/8/19 6:04 PM
 *
 */

(function () {
    'use strict';


    SettingsController.$inject = ["$scope", "$mdDialog", "$rootScope", "RestManager"];
    angular.module('app.main')
        .controller('settings.dialog.controller', SettingsController);


    function SettingsController($scope, $mdDialog, $rootScope, RestManager) {

        var settings = window.localStorage.getItem('settings') || '{}';
        settings = JSON.parse(settings);

        $scope.settings = Object.assign({
            notificationSyncDuration: 60000,
            autoNotifications: true
        }, settings);
        $scope.state = {
            purgingCache: false,
            purgeCacheSuccess: false,
            purgeCacheError: null
        };


        $scope.close = close;
        $scope.save = save;
        $scope.purgeProductBuilderCache = purgeProductBuilderCache;

        function purgeProductBuilderCache(event) {
            $scope.state.purgeCacheSuccess = false;
            $scope.state.purgingCache = true;
            $scope.state.purgeCacheError = null;
            RestManager.getResource('/settings/builder/hydrate', 'product_builder')
                .then(function (builder) {
                    $scope.state.purgingCache = false;
                    $scope.state.purgeCacheSuccess = true;
                })
                .catch(function (error) {
                    $scope.state.purgingCache = false;
                    $scope.state.purgeCacheError = error.message;
                })
        }

        function save() {
            window.localStorage.setItem('settings', JSON.stringify($scope.settings))
            $rootScope.$broadcast('SETTINGS_CHANGED', $scope.settings);
            $scope.close();
        }

        function close() {
            $mdDialog.cancel();
        }

    }
})(angular);


/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 18/7/19 2:43 AM
 *
 */

(function () {
    'use strict';

    ScannerController.$inject = ["$scope", "$mdDialog", "$timeout", "Scanner"];
    angular.module('app.main')
        .controller('scanner.dialog.controller', ScannerController);

    function ScannerController($scope, $mdDialog, $timeout, Scanner) {


        $scope.init = init;
        $scope.cancel = cancel;
        $scope.playAudio = playAudio;
        $scope.hide = hide;

        function init() {
            $timeout(function () {
                Scanner.start()
                    .then(function (code) {
                        $scope.playAudio();
                        Scanner.stop();
                        $scope.hide(code);
                    })
            }, 500);
        }

        function hide(value) {
            $mdDialog.hide(value);
            Scanner.stop();
        }

        function playAudio() {
            var audio = new Audio('assets/sounds/solemn.mp3');
            audio.play();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        $scope.init();
    }

})(angular);

(function () {
    'use strict';

    importSheet.$inject = ["$scope", "$mdDialog", "$mdToast", "RestManager"];
    angular.module('app.main')
        .controller('importSheet.dialog.controller', importSheet);

    function importSheet($scope, $mdDialog, $mdToast, RestManager) {
        $scope.$parent.pageTitle = "Import Sheets";
        $scope.hasFile = false;
        $scope.myLimit = 100;
        $scope.myPage = 1;
        $scope.mapping = false;
        var promises;
        $scope.processed = 0;
        var rABS = true;
        $scope.aaridaHeaders = [
            {entity: 'Name', value: 'name'},
            {entity: 'Mobile', value: 'mobile'},
            {entity: 'Password', value: 'password'},
            {entity: 'Organisation', value: 'organisation'},
            {entity: 'Role', value: 'role'}
        ];
        $scope.transformedHeaders = [];
        $scope.existingUserMobile = [];
        $scope.query = {
            page: 1,
            limit: 25
        };
        $scope.imported = false;
        $scope.finalState = false;
        $scope.allheadersSelected = false;
        $scope.updatingUsersEmail = false;
        $scope.selectedHeaderArray = [];


        $scope.cancel = cancel;
        $scope.removeFiles = removeFiles;
        $scope.$watch('file', watchFiles);
        $scope.transform = transform;
        $scope.selectHeaders = selectHeaders;
        $scope.importData = importData;
        $scope.fetchAllOrg = fetchAllOrg;
        $scope.saveUsers = saveUsers;
        $scope.showUsers = showUsers;
        $scope.showSelectedHeaders = showSelectedHeaders;


        $scope.fetchAllOrg();

        function fetchAllOrg() {
            RestManager.getResource("/org", "organisations")
                .then(function (result) {
                    $scope.orgs = result;
                    $scope.total = result.total;
                })
                .catch(function (err) {
                    console.log(err);
                });
        }

        function watchFiles(files) {
            if (files) {
                $scope.hasFile = true;
                handleDrop();
                console.log(files);
            }
        }

        function removeFiles($index) {
            $scope.file = "";
            $scope.hasFile = false;
            $scope.jsonData = "";
            $scope.status = "";
        }

        function fixdata(data) {
            var o = "", l = 0, w = 10240;
            for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
            o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
            return o;
        }

        function handleDrop() {
            $mdToast.show({
                template: '<md-toast>' +
                    '<div class="md-toast-content" layout layout-align="center center">' +
                    '<md-progress-circular md-diameter="20" class="md-warn"></md-progress-circular>' +
                    '<span class="md-caption" style="margin-left: 20px;">Reading File</span>' +
                    '</div>' +
                    '</md-toast>',
                hideDelay: 3000,
                position: 'bottom right'
            });
            $scope.status = "Reading File..";
            var files = [$scope.file];
            var i, f;
            for (i = 0; i !== files.length; ++i) {
                f = files[i];
                var reader = new FileReader();
                var name = f.name;
                reader.onload = function (e) {
                    var data = e.target.result;

                    var workbook;
                    if (rABS) {
                        /* if binary string, read with type 'binary' */
                        workbook = XLSX.read(data, {type: 'binary'});

                    } else {
                        /* if array buffer, convert to base64 */
                        var arr = fixdata(data);
                        workbook = XLSX.read(btoa(arr), {type: 'base64'});
                    }
                    /* Loop through Sheets to get sheetName*/
                    for (var sheetName in workbook.Sheets) {
                        $scope.jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
                    }
                    console.log("importSheet.dialog.controller.js", "onload", $scope.jsonData);
                    $scope.newHeaders = Object.keys($scope.jsonData[0]);
                    console.log("importSheet.dialog.controller.js", "onload", $scope.newHeaders);
                    // $scope.userEmail = $scope.jsonData.splice(0, 2).map(function (user) {
                    //     return user.email;
                    // })
                    $scope.status = "Ready";
                    $mdToast.hide();
                };
                if (rABS) reader.readAsBinaryString(f);
                else reader.readAsArrayBuffer(f);
            }
        }


        function selectHeaders() {
            $scope.status = 'Selecting Headers';
        }

        function showSelectedHeaders(header) {
            $scope.selectedHeaderArray.push(header);
            if ($scope.selectedHeaderArray.length === $scope.aaridaHeaders.length) {
                $scope.allheadersSelected = true;
            }
        }


        function transform(excelData) {
            $scope.mapping = true;
            $mdToast.show({
                template: '<md-toast>' +
                    '<div class="md-toast-content" layout layout-align="center center">' +
                    '<md-progress-circular md-diameter="20" class="md-warn"></md-progress-circular>' +
                    '<span class="md-caption" style="margin-left: 20px;">Mapping Data</span>' +
                    '</div>' +
                    '</md-toast>',
                hideDelay: 3000,
                position: 'bottom right'
            });
            $scope.transformedArray = excelData.map(function (data) {
                var mappedData = {};
                _.forEach($scope.aaridaHeaders, function (field) {
                    _.forOwn(data, function (val, key) {
                        if (key.toString() === field.selectedHeaders) {
                            mappedData[field.value] = data[key];
                        }
                        if (key.toString() === 'email') {
                            mappedData.email = data[key];
                        }
                    });
                });
                return mappedData;
            })

            $scope.status = 'Mapped';
            $scope.mapping = false;
            $mdToast.hide();

        }


        function importData(mappedData) {
            $scope.localErrors = [];
            $scope.serverErrors = [];
            $scope.processed = 0;
            $scope.duplicates = [];

            $scope.status = "Importing..";
            var startTime = new Date();
            console.time("Saving");
            promises = Promise.mapSeries(mappedData, function (data) {
                data.completed = false;
                if (!data.mobile || !data.name) {
                    $scope.localErrors.push(data);
                    $scope.processed++;
                    data.completed = false;
                    data.error = "Error";
                    updatePercent();
                    return "";
                } else {
                    return new Promise(function (resolve, reject) {
                        var trimmedMobile = '';
                        var email = '';
                        if (data.email !== '') {
                            email = data.email;
                        }
                        var mobile = data.mobile.split('/');
                        var mobileData = mobile[0].split('');
                        if (mobileData[0] === '0' && mobileData.length > 10) {
                            mobileData.splice(0, 1);
                            trimmedMobile = mobileData.join('');
                        } else {
                            trimmedMobile = mobile[0];
                        }
                        return RestManager.postResource("/users/getAccountDetail/", {mobile: trimmedMobile}, "data")
                            .then(function (result) {
                                if (!result[0].hasAccount) {
                                    if (!data.role) {
                                        data.role = 'org-agent';
                                    }
                                    data.mobile = trimmedMobile;
                                    if (!result[0].email) {
                                        data.email = email;
                                    }
                                    //TODO: Find a better way to send org_id in body in line below,
                                    // this will fail if any other field(headers in $scope.aaridaHeaders) is added or removed
                                    data.organisation = $scope.aaridaHeaders[2].selectedHeadersOrg;
                                    return RestManager.postResource('/users/admin/create', data, 'user');
                                    // console.log("importSheet.dialog.controller.js", "datat", data, $scope.aaridaHeaders[3].selectedHeadersOrg);
                                    // return [data];
                                } else if (result[0].hasAccount && !result[0].email) {
                                    $scope.updatingUsersEmail = true;
                                    // return [data];
                                    return RestManager.patchResource('/users/updateUserEmail/' + result[0].id, {email: email}, 'user');
                                } else {
                                    return null;
                                }
                            })
                            .then(function (res) {
                                if (res) {
                                    $scope.status = "Importing";
                                    data.completed = true;
                                    $scope.processed++;
                                    resolve(res[0]);
                                } else {
                                    $scope.status = "Importing";
                                    data.completed = false;
                                    data.existingUser = true;
                                    $scope.duplicates.push(data);
                                    resolve(data);
                                }
                            })
                            .catch(function (err) {
                                data.completed = false;
                                console.log(err);
                                // updatePercent();
                                $scope.serverErrors.push({data: data, err: err});
                                return resolve({});
                            });
                    });
                }
            }, {concurrency: 10})
                .then(function (result) {
                    console.time("Saving");
                    $scope.imported = true;
                    if (!$scope.updatingUsersEmail) {
                        $scope.userArray = result;
                    }
                    var endTime = new Date()
                    $scope.time = (endTime - startTime) / 1000;
                    $scope.$apply();
                });
        }

        function updatePercent() {
            $scope.percent = parseInt(($scope.processed / $scope.transformedArray.length) * 100);
        }

        /***
         * function showUsers is used for changing the the state to 'finaleState'
         * on button click.
         */

        function showUsers() {
            $scope.importing = false;
            $scope.status = "Import Complete";
            $scope.finalState = true;
            $scope.userArr = [];
            $scope.userArr = $scope.userArray.filter(function (user) {
                return user.existingUser === undefined;
            });


        }


        $scope.$on('$destroy', DestroyCtrl);

        function DestroyCtrl(event) {
            if ($scope.mapping) {
                var answer = confirm("Import is running. The process will be cancelled if you leave the page. Are you sure you want to leave this page?");
                if (!answer) {
                    event.preventDefault();
                } else {
                    promises.cancel();
                }
            }
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function saveUsers() {
            $mdDialog.hide({newUsers: $scope.userArr})
            console.log("importSheet.dialog.controller.js", "SaveData", "DATA IS BEING UPLOADED.......!");
        }


    }

})(angular);

/**
 * Created by kumardivyarajat on 06/12/16.
 */
angular.module("app.main")
    .controller("upload.controller", ["$scope", "$mdPanel", "AuthManager", "$mdDialog", "RestManager", "$log", "options", "$rootScope", "multipleSelect", "select", "Upload", "$timeout", "Base", "$mdToast", function ($scope, $mdPanel, AuthManager,
                                               $mdDialog, RestManager, $log, options,
                                               $rootScope, multipleSelect, select, Upload, $timeout,
                                               Base, $mdToast) {
        $scope.selectedImages = [];
        $scope.multiple = multipleSelect;
        console.log("uploader.controller.js", "MULTIPLE", multipleSelect);
        $scope.selectionPattern = select;
        $scope.images = [];
        $scope.files = [];
        $scope.pngRegex = /((.png))/;
        $scope.svgRegex = /((.svg))/;
        $scope.jpegRegex = /((.jpg))|((.jpeg))|((.png))/;
        $scope.hideHeader = true;
        $scope.mediaUrl = Base.getMediaUrl();
        $scope.sizes = options ? options.sizes : [];
        console.log("uploader.controller.js", "sd", $scope.sizes, $scope.multiple);

        $scope.selectedTab = 1;

        $scope.suggestedFilters = [
            {
                name: 'Customisation',
                condition: {"urls.c_large": {$exists: true}},
                active: false
            },
            {
                name: 'SVG Images',
                condition: {'extension': '.svg'},
                active: false
            },
            {
                name: 'My Images',
                condition: {createdBy: AuthManager.getCurrentUser()._id},
                active: false
            }
        ];

        $scope.query = {
            limit: 48,
            page: 1,
            sort: "-createdAt",
            filter: $scope.selectionPattern ? $scope.selectionPattern : {}
        };

        $scope.applyFilter = applyFilter;
        $scope.loadNextPage = loadNextPage;
        $scope.clearFilter = clearFilter;
        $scope.hide = hide;
        $scope.cancel = cancel;
        $scope.answer = answer;
        $scope.getSize = getSize;
        $scope.getFileType = getFileType;


        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
            $rootScope.$emit('uploaderClosed', {});
        }

        function answer() {
            $mdDialog.hide($scope.selectedImages);
        }

        function loadNextPage() {
            $scope.query.page += 1;
            $scope.fetchImages(false);
        }

        function applyFilter(filter) {
            $scope.suggestedFilters = $scope.suggestedFilters.map(function (f) {
                f.active = false;
                return f;
            });
            if (!$scope.originalQuery) {
                $scope.originalQuery = $scope.query.filter;
            }
            filter.active = true;
            $scope.filterActive = true;
            $scope.query.page = 1;
            $scope.query.filter = {
                query : filter.condition
            }
            $scope.fetchImages(true);
        }

        function clearFilter() {
            $scope.query.filter = $scope.originalQuery;
            $scope.filterActive = false;
            $scope.suggestedFilters = $scope.suggestedFilters.map(function (f) {
                f.active = false;
                return f;
            });
            $scope.query.page = 1;
            $scope.fetchImages(true);
        }



        function getSize(size) {
            return Math.ceil(parseInt(size) / 1024) + " kb";
        }

        function getFileType(extension) {
            return _.upperCase(extension);
        }

        switch (select) {
            case "jpeg" :
                $scope.selectRegex = $scope.jpegRegex;
                break;

            case "svg" :
                $scope.selectRegex = $scope.svgRegex;
                break;

            case "png" :
                $scope.selectRegex = $scope.pngRegex;
                break;

            case "*" :
                $scope.selectRegex = $scope.jpegRegex;
                break;
        }

        $scope.fetchImages = function (replace) {
            $scope.loading = true;
            $scope.promise = RestManager.postResource("/images", $scope.query, "images");
            $scope.promise
                .then(function (images) {
                    $scope.loading = false;
                    images = images.map(function (image) {
                        image.formattedSize = $scope.getSize(image.size);
                        image.formattedFileType = $scope.getFileType(image.extension);
                        image.isCustomisable = !!image.urls.c_large;
                        return image;
                    });
                    if (replace) {
                        $scope.images = images;
                    } else {
                        $scope.images = $scope.images.concat(images);
                    }
                    if ($scope.selectionPattern) {
                        if ($scope.selectionPattern === "customisable") {
                            $scope.images = _.filter($scope.images, function (o) {
                                return o.urls.c_large;
                            });
                        } else if ($scope.selectionPattern === "header") {
                            $scope.images = _.filter($scope.images, function (o) {
                                return o.urls.h_large;
                            });
                        } else if ($scope.selectionPattern === "profile") {
                            $scope.images = _.filter($scope.images, function (o) {
                                return o.urls.profile_m;
                            });
                        } else {
                            $scope.images = _.filter($scope.images, function (o) {
                                return $scope.selectRegex.test(o.extension);
                            });
                        }
                    }
                })
                .catch(function (err) {
                    $scope.loading = false;
                    $log.error("Error while fetching images", err)
                });
        };

        $timeout(function () {
            $scope.fetchImages();
        }, 1000);

        $scope.trimFileName = function (name) {
            // var s = name.split("-").sl;
            return _.truncate(name.split("-").slice(0, -1).join("-").split("_").join(" ")
                , {length: 24, omission: "..."});
        };


        $scope.selectImage = function (image) {
            if ($scope.multiple) {
                var index = $scope.containsImage(image);
                console.log(index, $scope.selectedImages, image._id);
                if (index === -1) {
                    $scope.selectedImages.push(image);
                } else {
                    $scope.selectedImages[index].selected = false;
                    $scope.selectedImages.splice(index, 1);
                }
            } else {
                if ($scope.selectedImages.length > 0) {
                    $scope.selectedImages[0].selected = false;
                    $scope.selectedImages.splice(0, 1);
                }
                $scope.selectedImages.push(image);
            }
            image.selected = true;
        };

        $scope.containsImage = function (image) {
            return _.findIndex($scope.selectedImages, function (o) {
                return o._id === image._id;
            })
        };


        // $scope.showInfo = function (image, event) {
        //     $scope.sideNavImage = image;
        //     $scope.showSideNav = true;
        //     console.log("showSideNav", $scope.showSideNav, image);
        //     event.stopPropagation();
        // };

        // $scope.closeSideNav = function () {
        //     $scope.sideNavImage = "";
        //     $scope.showSideNav = false;
        // };

        $scope.imageIsPng = function (image) {
            if (image)
            // console.log(image, /((.svg)|(.png))/.test(image.extension));
                return $scope.pngRegex.test(image.extension);
        };

        $scope.imageIsSvg = function (image) {
            if (image)
                return $scope.svgRegex.test(image.extension);
        };

        var initializing = true;

        $scope.$watch('files', function () {
            console.log($scope.files);

            if (initializing) {
                $timeout(function () {
                    initializing = false;
                });
            } else {
                console.log($scope.files);
                $scope.upload($scope.files);
            }
        });

        $scope.showList = function ($event) {
            $scope.showPanel = true;
            var panelPosition = $mdPanel.newPanelPosition()
                .absolute()
                .bottom('0%')
                .right('1%');
            //
            // var panelAnimation = $mdPanel.newPanelAnimation()
            //     .targetEvent($event)
            //     .withAnimation($mdPanel.animation.SCALE);

            var config = {
                attachTo: ".uploader",
                scope: $scope,
                preserveScope: true,
                // controller: DialogController,
                position: panelPosition,
                targetEvent: $event,
                // animation: panelAnimation,
                panelClass: "white md-whiteframe-5dp",
                templateUrl: 'upload-list.html',
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                hasBackdrop: false,
                trapFocus: false
            };

            $mdPanel.open(config);
        };


        $scope.log = '';

        $scope.upload = function () {
            // console.log(file);
            // $scope.hide();
            $scope.showList();
            $scope.uploaded = 0;
            $scope.selectedTab = 1;

            Promise
                .mapSeries($scope.files, function (o) {
                    return $scope.performUpload(o);
                }, {concurrency: 4})
                .then(function (res) {
                    console.log("In the end", res);
                    $scope.context = "";
                    $scope.sizes = [
                        {
                            width: 0,
                            height: 0,
                            attributeName: ""
                        }
                    ];
                    $scope.uploaded = 0;
                    // mdPanelRef.close();
                })
                .catch(function (err) {
                    console.log("Error", err);
                    var toast = $mdToast.simple()
                        .textContent('Failed to upload image')
                        .highlightClass('md-warn')// Accent is used by default, this just demonstrates the usage.
                        .position("bottom right")
                        .capsule(false);

                    $mdToast.show(toast);
                });
            // console.log("data", data);
        };


        $scope.performUpload = function (file) {
            return new Promise(function (resolve, reject) {
                var context;
                if(options && options.sizes && options.sizes.length) {
                    context = "custom";
                } else if ($scope.selectionPattern === "customisable") {
                    context = "customisable";
                } else if ($scope.selectionPattern === "header") {
                    context = "header";
                } else {
                    context = "simple";
                }

                var data = {
                    files: file,
                    context: context
                };

                if (data.context === "custom") {
                    data.sizes = $scope.sizes;
                }
                console.log(data);
                // con
                Upload.upload({
                    url: Base.getBaseUrl() + "/images/upload",
                    method: 'POST',
                    arrayKey: '',
                    data: data
                }).then(function (resp) {
                    // console.log('Success ', resp.status, 'uploaded. Response: ', resp.data.message);
                    if (resp.data.code == 200) {
                        file.uploaded = true;
                        for (var i in resp.data.message.images) {
                            $scope.images.unshift(resp.data.message.images[i]);
                        }
                        console.log("Complete", file);
                        $scope.uploaded++;
                        resolve(file);
                    } else {
                        console.log("Reject", resp);
                        reject(resp.data.message.error);
                    }
                }, function (resp) {
                    // reject(resp);
                    // console.log('Error status: ' + resp.status);
                }, function (evt) {
                    // console.log(evt);
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    file.progress = progressPercentage;
                    console.log('progress: ' + progressPercentage + '% ', evt.config.data.files);
                });
            })
        };

    }]);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 21/02/20, 6:22 PM
 *
 */

(function () {
    'use strict';

    Workforce.$inject = ["$mdDialog", "RestManager"];
    angular.module('app.workforce')
        .service('Workforce', Workforce);

    /**
     * @module Workforce
     * @param $mdDialog
     * @param RestManager
     * @constructor
     */
    function Workforce($mdDialog, RestManager) {

        /**
         * @memberOf Workforce
         * @methodOf Workforce
         * @param event
         * @param {Object} options
         * @param {String} options.order
         * @param {Object} options.product
         * @param {Object} options.lineItem
         * @param {Object} options.design
         * @param {Object} options.designer
         */
        function openTaskCreateDialog(event, options) {
            if (options && options.design && options.design.designer) {
                options.designer = {
                    name: options.design.designerName,
                    _id: options.design.designer
                };
            }
            console.log(options.design);
            return $mdDialog.show({
                templateUrl: 'app/modules/workforce/task-create-dialog/task-create-dialog.tmpl.html',
                locals: {
                    options: options
                },
                controller: "task-create-dialog.controller",
                multiple: true,
                fullscreen: true,
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true
            })
        }


       /**
        * @memberOf Workforce
        * @methodOf Workforce
        * @param event
        * @param task
        */
        function openUpdateTimeDialog(event, task) {
            var payload = {};
            angular.copy(task, payload);
            return $mdDialog.show({
                templateUrl: 'app/modules/workforce/tasks/dialogs/task-update-time/task-update-time.dialog.html',
                locals: {
                    task: payload
                },
                controller: "task-update-time.dialog.controller",
                multiple: true,
                fullscreen: true,
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true
            })
        }

        /**
         *
         * @memberOf Workforce
         * @methodOf Workforce
         * @param query
         * @param query.lineItems
         * @param query.orders
         * @param query.products
         * @param query.page
         * @param query.limit
         * @param query.sort
         * @param query.search
         * @param query.fields
         * @return {*}
         */
        function fetchTasksForLineItem(query) {
            return RestManager.getResource('/tasks', 'tasks', {query: query, service: 'workforce'});
        }

        /**
         *
         * @memberOf Workforce
         * @methodOf Workforce
         * @param query
         * @param query.designs
         * @param query.orders
         * @param query.products
         * @param query.page
         * @param query.limit
         * @param query.sort
         * @param query.search
         * @param query.fields
         * @return {*}
         */
        function fetchTasksForDesign(query) {
            return RestManager.getResource('/tasks', 'tasks', {query: query, service: 'workforce'});
        }

        /**
         *
         * @param measurements
         * @param designId
         * @param lineItemId
         * @return {*}
         */
        function updateMeasurementForTasks(measurements, designId, lineItemId) {
            return RestManager.patchResource('/tasks/measurements', {
                design: designId,
                lineItem: lineItemId,
                measurements: measurements
            }, 'tasks', {service: 'workforce'})
        }

        this.openTaskCreateDialog = openTaskCreateDialog;
        this.openUpdateTimeDialog = openUpdateTimeDialog;
        this.fetchTasksForLineItem = fetchTasksForLineItem;
        this.fetchTasksForDesign = fetchTasksForDesign;
        this.updateMeasurementForTasks = updateMeasurementForTasks;


    }


})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 21/02/20, 6:16 PM
 *
 */

(function () {
    'use strict';

    WorkforceController.$inject = ["$scope"];
    angular.module('app.workforce')
        .controller('workforce.controller', WorkforceController);

    function WorkforceController($scope) {

    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 16/09/19, 5:32 PM
 *
 */

(function () {
    'use strict';

    WarehouseController.$inject = ["$scope", "RestManager", "$mdDialog"];
    angular.module('app.warehouse')
        .controller('warehouse.controller', WarehouseController);

    function WarehouseController($scope, RestManager, $mdDialog) {
        $scope.selected = [];
        $scope.warehouses = [];
        $scope.showFilters = false;
        $scope.promise = '';
        $scope.query = {
            page: 1,
            limit: 10,
            sort: '-createdAt',
            q: ''
        };

        $scope.columns = [
            {
                name: 'Name',
                model: true,
                orderBy: 'name',
                value: 'name'
            },
            {
                name: 'Status',
                model: true,
                orderBy: 'status',
                value: 'status'
            },
            {
                name: 'City',
                model: true,
                orderBy: 'city',
                value: 'city'
            },
            {
                name: 'Address',
                model: true,
                orderBy: 'address',
                value: 'address'
            },
            {
                name: 'Prefix',
                model: true,
                orderBy: 'prefix',
                value: 'prefix'
            },
            {
                name: 'Created At',
                model: true,
                orderBy: 'createdAt',
                value: 'createdAt'
            },
            {
                name: 'Actions',
                model: true,
                orderBy: 'actions',
                value: 'actions'
            },
        ];

        $scope.fetchWarehouses = fetchWarehouses;
        $scope.openAddWarehouse = openAddWarehouse;
        $scope.clearSelections = clearSelections;


        function clearSelections() {
            $scope.selected = [];
        }
        function fetchWarehouses() {
            $scope.promise = RestManager.getResource('/warehouse', 'warehouses', {
                query: $scope.query,
                extras: ['total']
            });

            $scope.promise
                .then(function (result) {
                    $scope.warehouses = result.warehouses;
                    $scope.total = result.total;
                })
        }

        function openAddWarehouse(event, warehouse, index) {
            var editWarehouse = null;
            if(warehouse) {
                editWarehouse = {};
                angular.copy(warehouse, editWarehouse);
            }
            $mdDialog.show({
                templateUrl: 'app/modules/warehouses/create/warehouse.create.dialog.html',
                controller: 'warehouse.create.dialog.controller',
                multiple: true,
                fullscreen : true,
                targetEvent: event,
                locals: {
                    warehouse: editWarehouse
                }
            })
                .then(function (result) {
                    if (result && result.updated) {
                        console.log("warehouse.controller.js", "re", result, index);
                        if (result.editing) {
                            $scope.warehouses[index] = result.updated;
                        } else {
                            $scope.warehouses.unshift(result.updated);
                        }
                    }
                })
        }

        $scope.fetchWarehouses();

    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 11/9/19 5:05 PM
 *
 */

(function () {
    'use strict';

    Users.$inject = ["$mdDialog"];
    angular.module('app.users')
        .service('Users', Users);

    function Users($mdDialog) {


        /**
         *
         * @memberOf Users
         * @param event
         * @param options
         * @param options.user
         * @returns {*}
         */
        this.editUserDialog = function (event, options) {
            return $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                fullscreen: true,
                multiple: true,
                locals: {
                    newUser: options.user
                },
                controller: 'add-users.controller',
                templateUrl: 'app/modules/users/dialogs/add-user/add-user.tmpl.html'
            })
        };


        /**
         * @memberOf Users
         * @param event
         * @param options
         * @param options.roles
         * @param options.fields
         * @param options.search
         * @param options.multiple
         * @param options.selected
         */
        this.selectUserDialog = function selectUserDialog(event, options) {
            return $mdDialog.show({
                templateUrl: 'app/modules/users/dialogs/select-users/select-users.dialog.html',
                controller: 'select-users.dialog.controller',
                clickOutSideToClose: false,
                fullscreen: true,
                multiple: true,
                targetEvent: event,
                locals: {
                    roles: options.roles,
                    fields: options.fields,
                    search: options.search,
                    multipleSelect: options.multiple,
                    selected: options.selected,
                }
            })
        };
    }

})(angular);

(function () {
    'use strict';


    angular.module('app.reports', [])
})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 20/5/19 12:25 AM
 *
 */

(function () {
    'use strict';


    ReportsService.$inject = ["RestManager", "$q"];
    angular.module('app.reports')
        .service('ReportsService', ReportsService);

    function ReportsService(RestManager, $q) {
        var service = {};

        service.getReportsList = getReportsList;
        service.getWarehouse = getWarehouse;
        return service;

        /**
         * @memberOf ReportsService
         * @returns list of warehouse
         */

        function getWarehouse() {
            return new $q(function (resolve, reject) {
                RestManager.getResource('/warehouse', 'warehouses')
                    .then(function (warehouses) {
                        warehouses = warehouses.map(function (warehouse) {
                            return {
                                key: warehouse.name,
                                value: warehouse._id
                            };
                        })
                        resolve(warehouses);
                    })
                    .catch(function (err) {
                        reject(err);
                    });
            });
        }


        /**
         * @memberOf ReportsService
         * @returns {{image: string, columns: *[], meta: {month: string}, query: {queryParams: {$and: *[], $or: {status: {$nin: string[]}}[]}, queryOptions: {sort: string}, queryType: string}, name: string, dataMapper: (function(*): *), description: string, entity: string}[]}
         */
        function getReportsList() {
            return [
                {
                    name: 'GST Sales Invoice Monthly',
                    query: {
                        queryType: 'find',
                        queryParams: {
                            $or: [
                                {
                                    status: {
                                        $nin: [
                                            "cancelled",
                                            "incomplete",
                                            "returned",
                                            "return requested",
                                            "return approved",
                                            "return shipped",
                                            "return rejected"
                                        ]
                                    }
                                }
                            ],
                            $and: [
                                {
                                    createdAt: {$gte: moment().subtract(1, 'month').startOf('month').startOf('day').toISOString()},
                                },
                                {
                                    createdAt: {$lte: moment().startOf('month').subtract(1, 'day').endOf('day').toISOString()},
                                }
                            ]
                        },
                        queryOptions: {
                            sort: 'createdAt',
                            lean: true,
                            populate: [
                                {
                                    path: 'cart',
                                    lean: true,
                                    select: 'products',
                                    populate: {
                                        path: 'products.variation',
                                        select: 'stockAndPrice',
                                        populate: {
                                            path: 'stockAndPrice',
                                            select: 'price'
                                        }
                                    },
                                },
                                {
                                    path: 'warehouse',
                                    lean: true,
                                    select: 'name'
                                }
                            ]
                        }
                    },
                    filters: [
                        {
                            label: 'Select Date Range',
                            model: 'Previous::prev_month',
                            rangeModels: [
                                {
                                    name: 'Current',
                                    models: [
                                        {
                                            title: 'Today',
                                            startDate: moment().startOf('day'),
                                            endDate: moment().endOf('day'),
                                            value: 'this_day'
                                        },
                                        {
                                            title: 'This Week',
                                            startDate: moment().startOf('day').startOf('week'),
                                            endDate: moment().endOf('week'),
                                            value: 'this_week'
                                        },
                                        {
                                            title: 'This Month',
                                            startDate: moment().startOf('day').startOf('month'),
                                            endDate: moment().endOf('month'),
                                            value: 'this_month'
                                        },
                                        {
                                            title: 'This Quarter',
                                            startDate: moment().startOf('day').startOf('quarter'),
                                            endDate: moment().endOf('day').endOf('quarter'),
                                            value: 'this_quarter'
                                        },
                                        {
                                            title: 'This Year',
                                            startDate: moment().startOf('day').startOf('year'),
                                            endDate: moment().endOf('year'),
                                            value: 'this_year'
                                        },
                                        {
                                            title: 'This Fiscal Year',
                                            startDate: moment().month() < 4 ? moment().subtract(1, 'year').month(3).startOf('month') : moment().month(3).startOf('month'),
                                            endDate: moment().month() < 4 ? moment().month(2).endOf('month') : moment().month(2).add(1, 'year').endOf('month'),
                                            value: 'this_fiscal_year'
                                        }
                                    ]
                                },
                                {
                                    name: 'Previous',
                                    models: [
                                        {
                                            title: 'Yesterday',
                                            startDate: moment().startOf('day').subtract(1, 'day'),
                                            endDate: moment().endOf('day').subtract(1, 'day'),
                                            value: 'prev_day'
                                        },
                                        {
                                            title: 'Last Week',
                                            startDate: moment().subtract(1, 'week').startOf('week'),
                                            endDate: moment().subtract(1, 'week').endOf('week'),
                                            value: 'prev_week'
                                        },
                                        {
                                            title: 'Last Month',
                                            startDate: moment().subtract(1, 'month').startOf('month'),
                                            endDate: moment().subtract(1, 'month').endOf('month'),
                                            value: 'prev_month'
                                        },
                                        {
                                            title: 'Last Quarter',
                                            startDate: moment().subtract(1, 'quarter').startOf('quarter'),
                                            endDate: moment().subtract(1, 'quarter').endOf('quarter'),
                                            value: 'prev_quarter'
                                        },
                                        {
                                            title: 'Last Year',
                                            startDate: moment().subtract(1, 'year').startOf('year'),
                                            endDate: moment().subtract(1, 'year').endOf('year'),
                                            value: 'prev_year'
                                        },
                                        {
                                            title: 'Last Fiscal Year',
                                            startDate: moment().subtract(1, 'year').month(3).startOf('month'),
                                            endDate: moment().month(2).endOf('month'),
                                            value: 'prev_fiscal_year'
                                        }
                                    ]
                                },
                                {
                                    name: 'Custom',
                                    models: [
                                        {
                                            title: 'Custom Date',
                                            value: 'custom'
                                        }
                                    ]
                                }
                            ],
                            type: 'date-range',
                            predicate: function (query, m) {
                                return query;
                            },

                            onChange: function (filters) {
                                var p = this.model.split('::');
                                var name = p[0];
                                var value = p[1];
                                var range = _.find(this.rangeModels, function (r) {
                                    return r.name === name;
                                });

                                var model = _.find(range.models, function (m) {
                                    return m.value === value;
                                });

                                var startDate = _.find(filters, function (filter) {
                                    return filter.name === 'startDate';
                                });
                                var endDate = _.find(filters, function (filter) {
                                    return filter.name === 'endDate';
                                });
                                startDate.model = model.startDate;
                                endDate.model = model.endDate;
                            },
                        },
                        {
                            label: 'Select Start Date',
                            model: moment().subtract(1, 'month').startOf('month').toISOString(),
                            type: 'date',
                            name: 'startDate',
                            predicate: function (query, model) {
                                query.queryParams.$and[0].createdAt = {$gte: this.model};
                                return query;
                            }
                        },
                        {
                            label: 'Select End Date',
                            name: 'endDate',
                            model: moment().startOf('month').subtract(1, 'day').toISOString(),
                            type: 'date',
                            predicate: function (query, model) {
                                query.queryParams.$and[1].createdAt = {$lt: this.model};
                                return query;
                            }
                        },
                        {
                            label: 'Select Warehouse',
                            model: null,
                            collection: [],
                            type: 'select',
                            loading : false,
                            predicate: function (query, model) {
                                if (model) {
                                    if (!query.queryParams.$and[2]) {
                                        query.queryParams.$and.push({'warehouse': {$in: [this.model]}});
                                    } else {
                                        query.queryParams.$and[2]['warehouse'] = {$in: [this.model]};
                                    }
                                }
                                return query;
                            },
                            onOpen: function () {
                                var self = this;
                                self.loading = true;
                                self.collection = [];
                                service.getWarehouse()
                                    .then(function (warehouses) {
                                        self.loading = false;
                                        self.collection = warehouses;
                                    })
                                    .catch(function (err) {
                                        self.loading = false;
                                        console.log("reports.service.js", "err", err);
                                    });
                            },
                            onInit: function () {
                                var self = this;
                                self.loading = true;
                                self.collection = [];
                                service.getWarehouse()
                                    .then(function (warehouses) {
                                        self.loading = false;
                                        self.collection = warehouses;
                                        self.model = warehouses[0].value;
                                    })
                                    .catch(function (err) {
                                        self.loading = false;
                                        console.log("reports.service.js", "err", err);
                                    });
                            }
                        },
                    ],
                    cards: [
                        {
                            title: 'Total Orders',
                            interpolation: 'length',
                            flex: 20
                        },
                        {
                            title: 'Total Order Value',
                            interpolation: '*',
                            value: '',
                            subtitleClass: 'grey-text md-caption',
                            predicate: function (orders) {
                                var amount = orders.reduce(function (acc, order) {
                                    return acc + order.orderData.amount
                                }, 0);

                                return '₹' + amount;
                            },
                            subTitlePredicate: function (orders) {
                                var amount = orders.reduce(function (acc, order) {
                                    return acc + order.orderData.amount
                                }, 0);

                                var avgVal = amount / orders.length;
                                return 'Avg Value : ₹' + avgVal.toFixed(2);
                            },
                            flex: 20
                        },
                        // {
                        //     title: 'Avg Order Value',
                        //     interpolation: '*',
                        //     predicate: function (orders) {
                        //         var amount = orders.reduce(function (acc, order) {
                        //             return acc + order.orderData.amount
                        //         }, 0);
                        //
                        //         var avgVal = amount / orders.length;
                        //
                        //         return '₹' + avgVal.toFixed(2);
                        //     },
                        //     flex: 20
                        // },
                        {
                            title: 'Total GST',
                            interpolation: '*',
                            predicate: function (orders) {
                                var amount = orders.reduce(function (acc, order) {
                                    return acc + (order.orderData.taxSlabs ? order.orderData.taxSlabs.reduce(function (inAcc, tax) {
                                        return inAcc + tax.taxAmount
                                    }, 0) : 0)
                                }, 0);
                                return '₹' + amount.toFixed(2);
                            },
                            flex: 20
                        },
                        {
                            title: 'Online Orders',
                            interpolation: '*',
                            value: '',
                            subtitleClass: 'grey-text md-caption',
                            predicate: function (orders) {
                                return orders.filter(function (order) {
                                    return order.saleChannel !== 'pos'
                                }).length;
                            },
                            subTitlePredicate: function (orders) {
                                return ((this.value / orders.length) * 100).toFixed(2) + '%'
                            },
                            flex: 20
                        },
                        {
                            title: 'POS Orders',
                            interpolation: '*',
                            value: '',
                            subtitleClass: 'grey-text md-caption',
                            predicate: function (orders) {
                                return orders.filter(function (order) {
                                    return order.saleChannel === 'pos'
                                }).length;
                            },
                            subTitlePredicate: function (orders) {
                                return ((this.value / orders.length) * 100).toFixed(2) + '%'
                            },
                            flex: 20
                        },
                        {
                            title: 'Lowest Order Value',
                            interpolation: '*',
                            value: '',
                            subtitleClass: 'grey-text md-caption',
                            predicate: function (orders) {
                                orders = _.orderBy(orders, 'orderData.amount', ['asc']);
                                return orders.length ? '₹' + orders[0].orderData.amount : '-';
                            },
                            flex: 20
                        },
                        {
                            title: 'Highest Order Value',
                            interpolation: '*',
                            value: '',
                            subtitleClass: 'grey-text md-caption',
                            predicate: function (orders) {
                                orders = _.orderBy(orders, 'orderData.amount', ['desc']);
                                return orders.length ? '₹' + orders[0].orderData.amount : '-';
                            },
                            flex: 20
                        },
                        {
                            title: 'Profit Amount',
                            interpolation: '*',
                            value: '',
                            subtitleClass: 'grey-text md-caption',
                            predicate: function (orders) {
                                var amount = orders.reduce(function (acc, order) {
                                    return acc + order.orderData.profitAmount
                                }, 0);
                                return '₹' + amount.toFixed(2);
                            },
                            subTitlePredicate: function (orders) {
                                var profitAmt = orders.reduce(function (acc, order) {
                                    if (!order.orderData.profitAmount) {
                                        console.log(order);
                                    }
                                    return acc + order.orderData.profitAmount
                                }, 0);

                                var orderAmount = orders.reduce(function (acc, order) {
                                    return acc + order.orderData.amount
                                }, 0);

                                return ((profitAmt / orderAmount) * 100).toFixed(2) + '%'
                            },
                            flex: 20
                        },
                        {
                            title: 'Production Cost',
                            interpolation: '*',
                            value: '',
                            subtitleClass: 'grey-text md-caption',
                            predicate: function (orders) {
                                var amount = orders.reduce(function (acc, order) {
                                    return acc + order.orderData.beforeProfit
                                }, 0);
                                return '₹' + amount.toFixed(2);
                            },
                            subTitlePredicate: function (orders) {
                                var profitAmt = orders.reduce(function (acc, order) {
                                    return acc + order.orderData.beforeProfit
                                }, 0);

                                return 'Avg Prod. Cost: ₹' + ((profitAmt / orders.length)).toFixed(2)
                            },
                            flex: 20
                        },
                        {
                            title: 'Days Without Order',
                            interpolation: '*',
                            value: '',
                            titleClass: 'red-text',
                            subtitleClass: 'grey-text md-caption',
                            subheadClass: 'red-text',
                            predicate: function (orders, meta) {
                                var grp = _.groupBy(orders, function (order) {
                                    return moment(order.createdAt).startOf('day').format('DD-MM-YYYY').toString();
                                });
                                return meta.totalOrderDays - _.keys(grp).length;
                            },
                            subTitlePredicate: function (orders, meta) {
                                return ((this.value / meta.totalOrderDays) * 100).toFixed(2) + '% of ' + meta.totalOrderDays + ' days'
                            },
                            flex: 20
                        }
                    ],
                    exportSheetName: 'Sales Invoice -' + moment().subtract(1, 'month').format('MMM-YYYY').toString(),
                    exportFileName: 'Aarida GST Sales Invoice|' + moment().subtract(1, 'month').format('MMM-YYYY').toString(),
                    columns: [
                        {
                            columnHeader: 'Customer Name',
                            interpolation: 'fullUser',
                            predicate: function (fullUser) {
                                return fullUser ? _.startCase(_.toLower(fullUser.name)) : 'Walk In';
                            }
                        },
                        {
                            columnHeader: 'Order Number',
                            interpolation: 'orderNumber'
                        },
                        {
                            columnHeader: 'Invoice Date',
                            interpolation: 'createdAt',
                            predicate: function (createdAt) {
                                return moment(createdAt).format('DD-MMM-YYYY').toString();
                            }
                        },
                        {
                            columnHeader: 'Taxable Amount',
                            interpolation: 'orderData',
                            predicate: function (orderData) {
                                return 'Rs. ' + orderData.subtotal;
                            }
                        },
                        {
                            columnHeader: 'CGST',
                            interpolation: '*',
                            predicate: function (order) {
                                if (order.cachedAddress.state.toUpperCase().match(/^KA/)) {
                                    return (order.orderData && order.orderData.taxSlabs) ? order.orderData.taxSlabs.reduce(function (a, tax) {
                                        return a + ' | ' + (tax.taxAmount / 2).toFixed(2) + '@' + (tax.taxPercent / 2).toFixed(2) + '%'
                                    }, '').replace(' | ', '') : 'NA';
                                } else {
                                    return '-';
                                }
                            }
                        },
                        {
                            columnHeader: 'SGST',
                            interpolation: '*',
                            predicate: function (order) {
                                if (order.cachedAddress.state.toUpperCase().match(/^KA/)) {
                                    return (order.orderData && order.orderData.taxSlabs) ? order.orderData.taxSlabs.reduce(function (a, tax) {
                                        return a + ' | ' + (tax.taxAmount / 2).toFixed(2) + '@' + (tax.taxPercent / 2).toFixed(2) + '%'
                                    }, '').replace(' | ', '') : 'NA';
                                } else {
                                    return '-';
                                }
                            }
                        },
                        {
                            columnHeader: 'IGST',
                            interpolation: '*',
                            predicate: function (order) {
                                if (!order.cachedAddress.state.toUpperCase().match(/^KA/)) {
                                    return (order.orderData && order.orderData.taxSlabs) ? order.orderData.taxSlabs.reduce(function (a, tax) {
                                        return a + ' | ' + (tax.taxAmount).toFixed(2) + '@' + (tax.taxPercent).toFixed(2) + '%'
                                    }, '').replace(' | ', '') : 'NA';
                                } else {
                                    return '-';
                                }
                            }
                        },
                        {
                            columnHeader: 'Total Amount',
                            interpolation: 'orderData',
                            predicate: function (orderData) {
                                return 'Rs. ' + orderData.amount;
                            }
                        },
                        {
                            columnHeader: 'State',
                            interpolation: 'cachedAddress',
                            predicate: function (cachedAddress) {
                                return cachedAddress ? (cachedAddress.state.toUpperCase().match('KA') ? 'Karnataka' : cachedAddress.state) : '-';
                            }
                        },
                        {
                            columnHeader: 'Warehouse',
                            interpolation: '*',
                            predicate: function (order) {
                                return order.warehouse ? order.warehouse.name : 'N/A';
                            }
                        },
                    ],
                    image: '',
                    description: '',
                    entity: 'Order',
                    meta: {
                        totalOrderDays: 0
                    },
                    metaPredicate: function (query, filters) {
                        this.meta.totalOrderDays = moment(query.queryParams.$and[1].createdAt.$lt, 'YYYY-MM-DDTHH:mm:ss.sssZ ').diff(moment(query.queryParams.$and[0].createdAt.$gte, 'YYYY-MM-DDTHH:mm:ss.sssZ '), 'days') + 1;
                    },
                    dataMapper: function (order) {
                        var fSubtotal = 0, fTax = 0, fTotal = 0, fDiscount = 0, taxSlabs = [], fProfitAmount = 0,
                            fBeforeProfit = 0;
                        var profitCalcField = 'productionCost';
                        order.orderData.products = order.orderData.products.map(function (product, index) {
                                if (product.price < 1000) {
                                    product.taxPercent = 5;
                                } else {
                                    product.taxPercent = 12;
                                }
                                var productPrices = 0;
                                if (order.cart && order.cart.products && order.cart.products[index]) {
                                    productPrices = order.cart.products[index].variation.stockAndPrice.price;
                                } else {
                                    if(product.variation) {
                                        productPrices = product.variation.stockAndPrice.price;
                                    } else {
                                        productPrices = {mrp : 0, salePrice : 0, productionCost : 0}
                                    }
                                }

                                product.subtotal = parseFloat(((product.price * product.quantity) / ((product.taxPercent / 100) + 1)).toFixed(2));
                                product.taxAmount = parseFloat(((product.price * product.quantity) - product.subtotal).toFixed(2));
                                product.total = product.price * product.quantity;
                                product.beforeProfitAdjustment = productPrices[profitCalcField] * product.quantity;
                                product.profitAmount = product.total - product.beforeProfitAdjustment;
                                if (product.profitAmount) {
                                    fProfitAmount += product.profitAmount;
                                    fBeforeProfit += product.beforeProfitAdjustment;
                                } else {
                                    console.log('No Profit', order);
                                }
                                fSubtotal = parseFloat((fSubtotal + product.subtotal).toFixed(2));
                                fTax = parseFloat((fTax + product.taxAmount).toFixed(2));
                                fTotal += (product.total);
                                if (product.discountAmount) {
                                    fDiscount += (product.discountAmount * product.quantity);
                                }
                                var taxSlab = _.findIndex(taxSlabs, function (slab) {
                                    return slab.taxPercent === product.taxPercent;
                                });
                                if (taxSlab === -1) {
                                    taxSlabs.push({taxPercent: product.taxPercent, taxAmount: product.taxAmount});
                                } else {
                                    taxSlabs[taxSlab].taxAmount += product.taxAmount;
                                }

                                return product;
                            }
                        );

                        if (!order.fullUser) {
                            if (order.cachedAddress) {
                                order.fullUser = {
                                    _id: order.cachedAddress.user,
                                    name: order.cachedAddress.name
                                };
                            } else {
                                order.fullUser = {
                                    _id: 'NA',
                                    name: 'NA'
                                }

                            }
                        }

                        order.orderData.beforeProfit = fBeforeProfit;
                        order.orderData.profitAmount = fProfitAmount;
                        order.orderData.taxSlabs = taxSlabs;
                        order.orderData.subtotal = fSubtotal;
                        order.orderData.tax = fTax;
                        order.orderData.total = fTotal;
                        order.orderData.savings = fDiscount;
                        order.orderData.mrp = fDiscount + fTotal;
                        return order;
                    }
                },
                {
                    name: 'Most Popular Products',
                    query: {
                        queryType: 'find',
                        queryParams: {
                            $or: [
                                {
                                    status: {
                                        $nin: [
                                            "cancelled",
                                            "incomplete",
                                            "returned",
                                            "return requested",
                                            "return approved",
                                            "return shipped",
                                            "return rejected"
                                        ]
                                    }
                                }
                            ],
                            $and: [
                                {
                                    createdAt: {$gte: moment().subtract(1, 'month').startOf('month').startOf('day').toISOString()},
                                },
                                {
                                    createdAt: {$lte: moment().startOf('month').subtract(1, 'day').endOf('day').toISOString()},
                                }
                            ]
                        },
                        queryOptions: {
                            sort: 'createdAt',
                            lean: true,
                            select: 'orderNumber orderData.products orderData.products.product orderData.products.totalPrice orderData.products.price orderData.products.quantity orderData.products.product.name ' +
                                'orderData.products.product._id orderData.products.product.sku orderData.products.product.featured_image'
                        }
                    },
                    filters: [
                        {
                            label: 'Select Date Range',
                            model: 'Previous::prev_month',
                            rangeModels: [
                                {
                                    name: 'Current',
                                    models: [
                                        {
                                            title: 'Today',
                                            startDate: moment().startOf('day'),
                                            endDate: moment().endOf('day'),
                                            value: 'this_day'
                                        },
                                        {
                                            title: 'This Week',
                                            startDate: moment().startOf('day').startOf('week'),
                                            endDate: moment().endOf('week'),
                                            value: 'this_week'
                                        },
                                        {
                                            title: 'This Month',
                                            startDate: moment().startOf('day').startOf('month'),
                                            endDate: moment().endOf('month'),
                                            value: 'this_month'
                                        },
                                        {
                                            title: 'This Quarter',
                                            startDate: moment().startOf('day').startOf('quarter'),
                                            endDate: moment().endOf('day').endOf('quarter'),
                                            value: 'this_quarter'
                                        },
                                        {
                                            title: 'This Year',
                                            startDate: moment().startOf('day').startOf('year'),
                                            endDate: moment().endOf('year'),
                                            value: 'this_year'
                                        },
                                        {
                                            title: 'This Fiscal Year',
                                            startDate: moment().month() < 4 ? moment().subtract(1, 'year').month(3).startOf('month') : moment().month(3).startOf('month'),
                                            endDate: moment().month() < 4 ? moment().month(2).endOf('month') : moment().month(2).add(1, 'year').endOf('month'),
                                            value: 'this_fiscal_year'
                                        }
                                    ]
                                },
                                {
                                    name: 'Previous',
                                    models: [
                                        {
                                            title: 'Yesterday',
                                            startDate: moment().startOf('day').subtract(1, 'day'),
                                            endDate: moment().endOf('day').subtract(1, 'day'),
                                            value: 'prev_day'
                                        },
                                        {
                                            title: 'Last Week',
                                            startDate: moment().subtract(1, 'week').startOf('week'),
                                            endDate: moment().subtract(1, 'week').endOf('week'),
                                            value: 'prev_week'
                                        },
                                        {
                                            title: 'Last Month',
                                            startDate: moment().subtract(1, 'month').startOf('month'),
                                            endDate: moment().subtract(1, 'month').endOf('month'),
                                            value: 'prev_month'
                                        },
                                        {
                                            title: 'Last Quarter',
                                            startDate: moment().subtract(1, 'quarter').startOf('quarter'),
                                            endDate: moment().subtract(1, 'quarter').endOf('quarter'),
                                            value: 'prev_quarter'
                                        },
                                        {
                                            title: 'Last Year',
                                            startDate: moment().subtract(1, 'year').startOf('year'),
                                            endDate: moment().subtract(1, 'year').endOf('year'),
                                            value: 'prev_year'
                                        },
                                        {
                                            title: 'Last Fiscal Year',
                                            startDate: moment().subtract(1, 'year').month(3).startOf('month'),
                                            endDate: moment().month(2).endOf('month'),
                                            value: 'prev_fiscal_year'
                                        }
                                    ]
                                },
                                {
                                    name: 'Custom',
                                    models: [
                                        {
                                            title: 'Custom Date',
                                            value: 'custom'
                                        }
                                    ]
                                }
                            ],
                            type: 'date-range',
                            predicate: function (query, m) {
                                return query;
                            },

                            onChange: function (filters) {
                                var p = this.model.split('::');
                                var name = p[0];
                                var value = p[1];
                                var range = _.find(this.rangeModels, function (r) {
                                    return r.name === name;
                                });

                                var model = _.find(range.models, function (m) {
                                    return m.value === value;
                                });

                                var startDate = _.find(filters, function (filter) {
                                    return filter.name === 'startDate';
                                });
                                var endDate = _.find(filters, function (filter) {
                                    return filter.name === 'endDate';
                                });
                                startDate.model = model.startDate;
                                endDate.model = model.endDate;
                            },
                        },
                        {
                            label: 'Select Start Date',
                            model: moment().subtract(1, 'month').startOf('month').toISOString(),
                            type: 'date',
                            name: 'startDate',
                            predicate: function (query, model) {
                                query.queryParams.$and[0].createdAt = {$gte: this.model};
                                return query;
                            }
                        },
                        {
                            label: 'Select End Date',
                            name: 'endDate',
                            model: moment().startOf('month').subtract(1, 'day').toISOString(),
                            type: 'date',
                            predicate: function (query, model) {
                                query.queryParams.$and[1].createdAt = {$lt: this.model};
                                return query;
                            }
                        },
                        {
                            label: 'Select Warehouse',
                            model: null,
                            collection: [],
                            type: 'select',
                            predicate: function (query, model) {
                                console.log("reports.service.js", "predicate", model, query.queryParams);
                                if (model) {
                                    if (!query.queryParams.$and[2]) {
                                        query.queryParams.$and.push({'warehouse': {$in: [this.model]}});
                                    } else {
                                        query.queryParams.$and[2].warehouse = {$in: this.model};
                                    }
                                }
                                console.log("reports.service.js", "predicate", query);
                                return query;
                            },
                            onOpen: function () {
                                var self = this;
                                service.getWarehouse()
                                    .then(function (warehouses) {
                                        self.collection = warehouses;
                                    })
                                    .catch(function (err) {
                                        console.log("reports.service.js", "err", err);
                                    });
                            },
                            onInit: function () {
                                var self = this;
                                service.getWarehouse()
                                    .then(function (warehouses) {
                                        self.collection = warehouses;
                                        self.model = warehouses[0].value;
                                    })
                                    .catch(function (err) {
                                        console.log("reports.service.js", "err", err);
                                    });
                            }
                        },
                    ],
                    cards: [],
                    exportSheetName: 'Products -' + moment().subtract(1, 'month').format('MMM-YYYY').toString(),
                    exportFileName: 'Sales Report|' + moment().subtract(1, 'month').format('MMM-YYYY').toString(),
                    columns: [
                        {
                            columnHeader: 'Sl',
                            displayType: 'index',
                        },
                        {
                            columnHeader: 'Image',
                            interpolation: 'image',
                            displayType: 'image',
                            style: {
                                'width': '75px',
                                'height': 'auto',
                                padding : '4px',
                                borderRadius : '8px'
                            },
                            predicate: function (image) {
                                if (image) {
                                    return image.urls.thumbnail
                                } else {
                                    return null
                                }
                            }
                        },
                        {
                            columnHeader: 'Name',
                            interpolation: 'name',
                            orderBy : 'name'
                        },
                        {
                            columnHeader: 'SKU',
                            interpolation: 'sku',
                            orderBy : 'sku'
                        },
                        {
                            columnHeader: 'Price',
                            interpolation: 'amount',
                            // predicate: function (price) {
                            //     return '₹' + price
                            // },
                            orderBy : 'amount'
                        },
                        {
                            columnHeader: 'SaleCount',
                            interpolation: 'count',
                            orderBy : 'count'
                        },
                        {
                            columnHeader: 'TotalSales',
                            interpolation: 'totalAmount',
                            orderBy : 'totalAmount'
                            // predicate: function (price) {
                            //     return '₹' + price
                            // }
                        }
                    ],
                    image: '',
                    description: '',
                    entity: 'Order',
                    meta: {
                        totalOrderDays: 0
                    },
                    metaPredicate: function (query, filters) {
                        this.meta.totalOrderDays = moment(query.queryParams.$and[1].createdAt.$lt, 'YYYY-MM-DDTHH:mm:ss.sssZ ').diff(moment(query.queryParams.$and[0].createdAt.$gte, 'YYYY-MM-DDTHH:mm:ss.sssZ '), 'days') + 1;
                    },
                    dataTransformer: function (data) {
                        var products = _.flatMap(data, function (order) {
                            return _.map(order.orderData.products, function (lineItem) {
                                return {
                                    name: lineItem.product.name,
                                    amount: _.round(lineItem.totalPrice || lineItem.price, 2),
                                    quantity : lineItem.quantity,
                                    image: lineItem.product.featured_image,
                                    sku: lineItem.product.sku || 'ADRCUS0001',
                                    id: lineItem.product._id
                                }
                            })
                        });

                        return _.chain(products)
                            .groupBy(function (product) {
                                return product.id;
                            })
                            .map(function (val, key) {
                                var lineItem = val[0];
                                var totalAmount = val.reduce(function (acc, p) {
                                    var subtotal = _.round(p.amount * p.quantity, 2);
                                    return _.round(acc + subtotal, 2);
                                }, 0);
                                return {
                                    name: lineItem.name,
                                    amount: lineItem.amount,
                                    image: lineItem.image,
                                    sku: lineItem.sku,
                                    id: lineItem.id,
                                    count: val.length,
                                    totalAmount: _.round(totalAmount, 2)
                                }
                            })
                            .flatten()
                            .orderBy(['count'], ['desc'])
                            .map(function (l, idx) {
                                l.index  = (idx + 1) + '.';
                                return l;
                            })
                            .value();
                    }
                }
            ]
        }
    }
})(angular);

(function () {
    'use strict';

    ReportsController.$inject = ["$scope", "RestManager", "ReportsService"];
    angular.module('app.reports')
        .controller('reports.controller', ReportsController);

    function ReportsController($scope, RestManager, ReportsService) {
        $scope.selectedReport = '';
        $scope.resportsCount = false;
        $scope.loading = false;
        $scope.selected = [];
        $scope.orderBy = '';


        $scope.reports = ReportsService.getReportsList();

        $scope.selectReport = selectReport;
        $scope.fetchData = fetchData;
        $scope.getDynamicValue = getDynamicValue;
        $scope.backToHome = backToHome;
        $scope.exportData = exportData;
        $scope.getInterpolation = getInterpolation;
        $scope.getCardClass = getCardClass;


        function fetchData() {
            $scope.loading = true;
            $scope.compiledJSON = [];
            if ($scope.selectedReport.filters) {
                $scope.selectedReport.filters.forEach(function (filter) {
                    $scope.selectedReport.query = filter.predicate($scope.selectedReport.query, filter.model);
                })
            }
            $scope.selectedReport.metaPredicate($scope.selectedReport.query, $scope.selectedReport.filters);

            var start = performance.now();
            $scope.promise = RestManager.postResource("/analytics/" + $scope.selectedReport.entity, $scope.selectedReport.query, "analytics");
            $scope.promise
                .then(function (data) {
                    $scope.loading = false;
                    $scope.resportsCount = data.length;

                    if($scope.selectedReport.dataMapper) {
                        data = data.map($scope.selectedReport.dataMapper);
                    }

                    if($scope.selectedReport.dataTransformer) {
                        data = $scope.selectedReport.dataTransformer(data);
                    }

                    $scope.selectedReport.cards = $scope.selectedReport.cards.map(function (card) {
                        card.value = $scope.getDynamicValue(card, data);
                        if(card.subTitlePredicate) {
                            card.subValue = $scope.getDynamicValue(card, data, 'subTitlePredicate');
                        }
                        return card;
                    });

                    $scope.compiledJSON = data.map(function (d) {
                        var obj = {};
                        $scope.selectedReport.columns.forEach(function (column) {
                            obj[column.columnHeader] = $scope.getDynamicValue(column, d)
                        });

                        return obj;
                    });

                    $scope.duration = performance.now() - start;
                })
                .catch(function (err) {
                    $scope.loading = false;
                    $scope.salesCount = "Error";
                    console.log(err);
                });
        }

        function getCardClass(card) {
            var classess = '';
            if (card.flex) {
                classess += 'flex-' + card.flex;
            }

            if (card.classes) {
                classess += card.classes;
            }

            return classess;
        }


        function selectReport(report) {
            $scope.selectedReport = report;
            $scope.selectedEntity = report.entity;
            $scope.fetchData();
        }

        function getDynamicValue(column, data, predicateToCall) {
            try {
                if(column[predicateToCall]) {
                    return column[predicateToCall]($scope.getInterpolation(data, column.interpolation), $scope.selectedReport.meta)
                } else if (column.predicate) {
                    return column.predicate($scope.getInterpolation(data, column.interpolation), $scope.selectedReport.meta)
                } else if (column.interpolation) {
                    return $scope.getInterpolation(data, column.interpolation)
                } else {
                    return 'Unsupported option';
                }
            } catch (e) {
                console.log(e);
                return 'Undefined'
            }

        }


        function getInterpolation(data, interpolation) {
            if (interpolation === '*') {
                return data;
            } else {
                return data[interpolation];
            }
        }

        function backToHome() {
            $scope.selectedReport = '';
        }

        function exportData() {
            if ($scope.compiledJSON.length) {
                var wb = {
                    SheetNames: [],
                    Sheets: []
                };
                var dataToExport = $scope.compiledJSON.map(function (data) {
                    delete data['$$hashKey'];
                    return data;
                })
                var headers = Object.keys(dataToExport[0]);
                wb.SheetNames.push($scope.selectedReport.exportSheetName);
                var jsonToSheetOptions = {header: headers, skipHeader: false};
                var ws = XLSX.utils.json_to_sheet(dataToExport, jsonToSheetOptions);
                var wopts = {bookType: 'xlsx', bookSST: false, type: 'binary'};

                wb.Sheets[$scope.selectedReport.exportSheetName] = ws;

                var wbout = XLSX.write(wb, wopts);

                // noinspection JSAnnotator
                function s2ab(s) {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }

                // /* the saveAs call downloads a file on the local machine */
                saveAs(new Blob([s2ab(wbout)],
                    {type: "application/octet-stream"}),
                    $scope.selectedReport.exportFileName + '.xlsx');
            }

        }

    }

})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 25/01/20, 1:52 PM
 *
 */

(function () {
    'use strict';

    angular.module('app.quotations', [])

})(angular);

/*
 * Copyright (c) 2020. Kumar Divya Rajat
 * Created on 25/01/20, 1:53 PM
 *
 */

(function () {
    'use strict';

    QuotationsController.$inject = ["$scope", "RestManager", "$mdToast", "$state", "$stateParams", "$mdDialog", "Utils", "Images", "ChatService"];
    angular.module('app.quotations')
        .controller('quotations.controller', QuotationsController);


    function QuotationsController($scope, RestManager, $mdToast, $state, $stateParams,
                                  $mdDialog, Utils, Images, ChatService) {
        $scope.query = {
            page: 1,
            limit: 10,
            sort: '-createdAt',
            search: null,
            status: 'created'
        };
        $scope.selectedQuotationId = null;
        $scope.selectedQuotation = null;
        $scope.currentStatus = null;
        $scope.total = null;
        $scope.cancelReason = null;
        $scope.otherReason = null;
        $scope.isInternalMessage = true;
        $scope.imageSelected = false;
        $scope.statusUpdating = false;
        $scope.message = '';
        $scope.tableRows = ['height', 'size', 'city', 'state', 'pinCode'];
        $scope.tableData = null;
        $scope.statusList = ['created', 'processing', 'completed', 'cancelled'];
        $scope.reasons = [
            'Already purchased a product',
            'Made a request by mistake',
            "I don't have time",
            "I don't like the designs",
            "Others"
        ];

        $scope.init = init;
        $scope.applyFilter = applyFilter;
        $scope.updateStatus = updateStatus;
        $scope.changeState = changeState;
        $scope.selectQuotation = selectQuotation;
        $scope.fetchQuotations = fetchQuotations;
        $scope.fetchSingleQuotation = fetchSingleQuotation;
        $scope.convertForTable = convertForTable;
        $scope.deselectQuotation = deselectQuotation;
        $scope.openNotifications = openNotifications;
        $scope.publishQuotationComment = publishQuotationComment;
        $scope.cancelQuotationDialog = cancelQuotationDialog;
        $scope.createChatInstance = createChatInstance;
        $scope.initChat = initChat;
        $scope.askJoinConfirmation = askJoinConfirmation;
        $scope.updateRoom = updateRoom;
        $scope.openImages = Images.openImageGallery;
        $scope.findReferences = Utils.findReferences;
        $scope.dateAgo = Utils.dateAgo;

        function init() {
            if ($stateParams.page) {
                $scope.query.page = $stateParams.page;
            }

            if ($stateParams.limit) {
                $scope.query.limit = $stateParams.limit;
            }

            if ($stateParams.order) {
                $scope.query.order = $stateParams.order;
            }

            if ($stateParams.search) {
                $scope.query.search = $stateParams.search;
            }

            if ($stateParams.id) {
                $scope.selectedQuotationId = $stateParams.id;
                $scope.fetchSingleQuotation($scope.selectedQuotationId);
            }
        }

        function applyFilter(status) {
            $scope.query.status = status;
            $scope.query.page = 1;
            $scope.fetchQuotations();
        }

        function selectQuotation(quotation) {
            $scope.selectedQuotationId = quotation._id;
            $scope.changeState();
            $scope.fetchSingleQuotation($scope.selectedQuotationId);
        }

        function deselectQuotation() {
            $scope.selectedQuotation = null;
            $scope.selectedQuotationId = null;
            $scope.changeState();
        }

        function fetchSingleQuotation(quotationId) {
            $scope.fetchingDetails = true;
            RestManager.getResource('/quotations/admin/' + quotationId, 'quotations')
                .then(function (quotations) {
                    $scope.selectedQuotation = quotations[0];
                    $scope.fetchingDetails = false;
                    $scope.tableData = $scope.convertForTable();
                    $scope.currentStatus = $scope.selectedQuotation.status;
                    $scope.initChat();
                    setTimeout(function () {
                        Utils.scrollTo('#message-content-wrapper', {direction: 'bottom'});
                    }, 2000);
                })
                .catch(function (err) {
                    $scope.fetchingDetails = false;
                    $mdToast.showSimple('Error loading quotation details: ' + err.message);
                })
        }

        function fetchQuotations() {
            $scope.loading = true;
            RestManager.getResource('/quotations', 'quotations', {query: $scope.query, extras: ['total']})
                .then(function (result) {
                    $scope.loading = false;
                    $scope.quotations = result.quotations;
                    $scope.total = result.total;
                    $scope.changeState();
                })
                .catch(function (error) {
                    $mdToast.showSimple('Error loading quotation : ' + error.message);
                    $scope.loading = false;
                })
        }

        function convertForTable() {
            return $scope.tableRows.map(function (property) {
                return {
                    key: property,
                    displayKey: _.capitalize(property),
                    value: $scope.selectedQuotation[property]
                }
            });
        }

        function changeState() {
            var location = 'replace';
            if (!$stateParams.id && $scope.selectedQuotationId && $scope.isSmall) {
                location = 'null';
            }
            $state.go("app.quotations", {
                    id: $scope.selectedQuotationId,
                    page: $scope.query.page,
                    limit: $scope.query.limit,
                    sort: $scope.query.order,
                    search: $scope.query.search
                },
                {notify: false, reload: false, location: location})
        }

        function openNotifications(quotation, $event) {
            $event.stopPropagation();
            var payload = {};
            angular.copy(quotation, payload);
            payload.user = payload.cachedUser;
            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: $event,
                fullscreen: true,
                templateUrl: 'app/modules/components/notifications/user-notifications.html',
                locals: {
                    options: {
                        allowedTags: ['User Name', 'Customer Care Number'],
                        context: 'quotation'
                    },
                    order: payload
                },
                controller: 'notificationsController',
                clickOutsideToClose: true
            })
                .then(function (data) {
                    console.log('data', data);
                    $mdToast.showSimple('Sent Notification');
                })
                .catch(function (err) {
                    console.log(err)
                })
        }

        function publishQuotationComment() {
            if ($scope.message || $scope.imageSelected) {
                if (!$scope.selectedQuotation.notes) {
                    $scope.selectedQuotation.notes = [];
                }

                var data = {
                    comment: $scope.message,
                    images: $scope.imageSelected,
                    date: new Date(),
                    by: $scope.currentUser._id,
                    byName: $scope.currentUser.name,
                    references: $scope.findReferences($scope.message),
                    saving: true,
                    isInternal: $scope.isInternalMessage
                };

                var index = $scope.selectedQuotation.notes.length;

                $scope.selectedQuotation.notes.push(data);
                Utils.scrollTo('#message-content-wrapper', {elementY: 500, direction: 'bottom'});

                RestManager.patchResource('/quotations/comment/' + $scope.selectedQuotation._id, data, 'selectedQuotation')
                    .then(function (orders) {
                        $scope.selectedQuotation.notes[index].saving = false;
                        $scope.message = '';
                        $scope.imageSelected = null;
                    })
                    .catch(function (err) {
                        $scope.selectedQuotation.notes[index].saving = false;
                        $scope.selectedQuotation.notes[index].error = true;
                        Utils.scrollTo('#message-content-wrapper', {elementY: 500});
                    });

                $scope.message = '';
                $scope.imageSelected = null;
            }
        }

        function cancelQuotationDialog(ev) {
            var confirm = {
                clickOutsideToClose: true,
                targetEvent: ev,
                scope: $scope,
                preserveScope: true,
                contentElement: '#cancel-quotation-dialog',
                fullscreen: true,
                parent: angular.element(document.body)
            };

            $mdDialog.show(confirm)
        }

        function updateStatus() {
            $scope.statusUpdating = true;
            var reason;
            var payload = {
                status: $scope.currentStatus
            };
            if ($scope.currentStatus === 'cancelled') {
                reason = $scope.cancelReason;
                if ($scope.cancelReason === 'Others') {
                    reason += " - " + $scope.otherReason;
                }
                payload.reason = reason;
            }

            RestManager.patchResource('/quotations/status/' + $scope.selectedQuotation._id,
                payload,
                'quotations'
            )
                .then(function (quotations) {
                    $scope.selectedQuotation.status = quotations[0].status;
                    $scope.selectedQuotation.cancellationReason = reason;
                    $scope.selectedQuotation.notes = quotations[0].notes;
                    $scope.selectedQuotation.cancelledDate = new Date();
                    $scope.statusUpdating = false;
                    $mdDialog.cancel();
                    $mdToast.showSimple('Updated status successfully!');
                })
                .catch(function (err) {
                    $mdToast.showSimple('Error udpating status of quotation: ' + err.message);
                    $scope.statusUpdating = false;
                })
        }

        function initChat() {
            $scope.selectedQuotation.hasAccessToChat = _.includes($scope.selectedQuotation.chatMembers, $scope.currentUser._id);
            var members = [
                {id: $scope.selectedQuotation.user, name: $scope.selectedQuotation.cachedUser.name}
            ];
            $scope.selectedQuotation.chatConfig = {
                members: members,
                defaultId: $scope.selectedQuotation._id,
                roomName: $scope.selectedQuotation.quotationNumber,
                customData: {quotationNumber: $scope.selectedQuotation.quotationNumber},
                public: true
            };
            // $scope.showChat = false;
            // $scope.loadingChat = true;
            // var promise;
            // if ($scope.selectedQuotation && $scope.selectedQuotation.chatRoomId) {
            //     var hasAccess = _.includes($scope.selectedQuotation.chatMembers, $scope.currentUser._id);
            //     if (hasAccess) {
            //         promise = Promise.resolve()
            //     } else {
            //         // promise = $scope.askJoinConfirmation($scope.selectedQuotation.chatRoomId);
            //         promise = Promise.reject();
            //     }
            // } else {
            //     promise = $scope.createChatInstance()
            // }
            // promise
            //     .then(function (result) {
            //         $scope.showChat = true;
            //         $scope.loadingChat = false;
            //     })
            //     .catch(function (err) {
            //         $scope.showChat = false;
            //         $scope.loadingChat = false;
            //         console.log("quotations.controller.js", "err", err);
            //     })
        }

        function askJoinConfirmation(roomId) {
            return new Promise((function (resolve, reject) {
                var confirm = $mdDialog.confirm()
                    .title('You are not a part of this conversation yet!')
                    .textContent('Do you want to join this chat instance and be able to communicate directly with the users')
                    .ok('Join Chat')
                    .cancel('Cancel');

                $mdDialog.show(confirm)
                    .then(function (result) {
                        if (result) {
                            return ChatService.joinRoom(roomId)
                        } else {
                            $scope.loadingChat = false;
                            reject(new Error('You will no longer be able to get the messages of this chat!'))
                        }
                    })
                    .then(function (result) {
                        console.log("quotations.controller.js", "Joined user to room", result);
                        var members = ($scope.selectedQuotation.chatMembers || []);
                        members.push($scope.currentUser._id);
                        return RestManager.patchResource('/quotations/chatRoom', {
                            memberIds: members,
                            chatId: roomId,
                            quotationId: $scope.selectedQuotation._id
                        }, 'quotations')
                    })
                    .then(resolve)
                    .catch(reject)
            }))
        }

        function updateRoom(data, selectedQuotation) {
            console.log("quotations.controller.js", "updateRoom", data, selectedQuotation);
            // var members = ($scope.selectedQuotation.chatMembers || []);
            // members.push($scope.currentUser._id);
            if (data && data.room) {
                RestManager.patchResource('/quotations/chatRoom', {
                    memberIds: data.room.userIds,
                    chatId: data.room.id,
                    quotationId: $scope.selectedQuotation._id
                }, 'quotations')
                    .then(function (quotations) {
                        $scope.selectedQuotation.chatMembers = quotations[0].chatMembers;
                        $scope.selectedQuotation.chatRoomId = quotations[0].chatRoomId;
                        $mdToast.showSimple('Added members to chat');
                    })
                    .catch(function (error) {
                        $mdToast.showSimple('Error adding members to chat' + error.message);
                        console.log('Error adding members to chat: ', error)
                    })
            }
        }


        function onMessage(message) {
            console.log("quotations.controller.js", "onMessage", message);
        }

        function createChatInstance() {
            return new Promise(function (resolve, reject) {
                var members = [
                    {id: $scope.currentUser._id, name: $scope.currentUser.name},
                    {id: $scope.selectedQuotation.user, name: $scope.selectedQuotation.cachedUser.name}
                ];
                members = _.chain(members)
                    .uniqBy(members, function (member) {
                        return member.id
                    })
                    .value();
                ChatService
                    .createRoom($scope.selectedQuotation._id,
                        $scope.selectedQuotation.quotationNumber,
                        {id: $scope.currentUser._id, name: $scope.currentUser.name},
                        members,
                        {
                            quotationNumber: $scope.selectedQuotation.quotationNumber
                        },
                        false
                    )
                    .then(function (chats) {
                        return RestManager.patchResource('/quotations/chatRoom', {
                            memberIds: chats[0].member_user_ids,
                            chatId: chats[0].id,
                            quotationId: $scope.selectedQuotation._id
                        }, 'quotations')
                    })
                    .then(function (quotations) {
                        $scope.selectedQuotation.chatRoomId = quotations[0].chatRoomId;
                        $scope.selectedQuotation.chatMembers = quotations[0].chatMembers;
                        resolve(quotations[0]);
                    })
                    .catch(function (error) {
                        reject(error);
                    })
            })
        }


        $scope.fetchQuotations();
        $scope.init();
    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 19/11/19, 12:04 AM
 *
 */

(function () {
    'use strict';

    PostController.$inject = ["RestManager", "$scope", "$mdDialog", "$mdToast"];
    angular.module('app.posts')
        .controller('posts.controller', PostController);

    function PostController(RestManager, $scope, $mdDialog, $mdToast) {

        $scope.posts = [];
        $scope.fetchingPosts = true;
        $scope.query = {
            page : 1,
            limit : 24,
            sort : '-createdAt',
            user : [],
            products : []
        };

        $scope.fetchPosts = fetchPosts;
        $scope.addNewPost = addNewPost;

        function fetchPosts() {
            $scope.fetchingPosts = true;
            RestManager.getResource('/posts/admin', 'posts', {query : $scope.query})
                .then(function (posts) {
                    $scope.posts = posts;
                    $scope.fetchingPosts = false;
                })
                .catch(function (err) {
                    $scope.fetchingPosts = false;
                })
        }

        function addNewPost(e, post, index) {
            var newPost = null;
            if(post) {
                newPost = {};
                angular.copy(post, newPost);
            }
            $mdDialog.show({
                templateUrl : 'app/modules/posts/add-posts/add-posts.tmpl.html',
                controller : 'add-posts.controller',
                multiple : true,
                fullscreen : true,
                targetEvent : e,
                locals : {
                    post : post ? newPost : null
                }
            })
                .then(function (data) {
                    if(data && data.post) {
                        if(typeof index === 'undefined') {
                            $scope.posts.unshift(data.post)
                        } else {
                            $scope.posts[index] = data.post;
                        }
                    }
                })
        }

        $scope.fetchPosts();
    }

})(angular);

(function () {
    'use strict';


    angular.module('app.pos')
        .controller('pos.controller', posCtrl);

    /** @ngInject **/
    function posCtrl() {

    }
})(angular);

(function () {
    'use strict';

    StockUpdates.$inject = ["$mdDialog"];
    angular.module('app.orders')
        .service('StockUpdates', StockUpdates);

    function StockUpdates($mdDialog) {
        this.openStockUpdateDialog = openStockUpdateDialog;


        /**
         * @memberOf StockUpdates
         * @param event
         * @param [options]
         * @param [options.lineItemId] {String} Line item ID
         * @param [options.productId] {String} Product ID
         * @param [options.variationId] {String} Variation ID
         * @param [options.orderId] {String} Order ID
         */
        function openStockUpdateDialog(event, options) {
            return $mdDialog.show({
                templateUrl: 'app/modules/orders/stock-updates/stock-upates.tmpl.html',
                controller: 'stock-updates.controller',
                locals: {
                    options: options || {}
                },
                multiple: true,
                fullscreen: true,
                targetEvent: event
            });
        }
    }

})(angular);

(function () {
    'use strict';
    imageService.$inject = ["$mdDialog"];
    angular.module('app.media')
    .service('Images', imageService);

    function imageService($mdDialog){

        /**
         * @methodOf Images
         * @param event
         * @param images
         * @returns {*}
         */
        this.openImageGallery = function(event, images){
            return $mdDialog.show({
                locals: {
                    images: images
                },
                controller: "imageGallery.controller",
                templateUrl: 'app/modules/media/dialog/image-gallery.html',
                parent: angular.element(document.body),
                targetEvent: event,
                fullscreen: true,
                multiple: true,
                clickOutsideToClose: true
            });
        };
    }



})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 06/10/19, 4:20 AM
 *
 */

(function () {
    'use strict';

    angular.module('app.homebuilder', [])

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 06/10/19, 4:20 AM
 *
 */

(function () {
    'use strict';

    angular.module('app.homebuilder')
        .service('$widget', HomeService);

    /**
     * @module $widget
     * @constructor
     */
    function HomeService() {
        /**
         * @type Widget
         * @param [options]
         * @param {String} [options.name]
         * @param {String}  [options.type]
         * @param {[String]}  [options.classes]
         * @param {[String]}  [options.objects]
         * @param {[String]}  [options.sizes]
         * @param {[Object]}  [options.grids]
         * @param {String}  [options.url]
         * @param {String}  [options.icon]
         * @param {String}  [options.description]
         * @param {Object}  [options.urlData]
         * @constructor
         */
        function Widget(options) {
            if (!options) {
                options = {};
            }

            this.name = options.name;
            this.type = options.type;
            this.classes = options.classes || '';
            this.objects = options.objects || [];
            this.sizes = options.sizes;
            this.grids = options.grids;
            this.url = options.url || null;
            this.urlData = options.urlData || {};
            this.icon = options.icon || {};
            this.expanded = true;
            this.id = options.id || Math.random();
            this.description = options.description || '';

            if(this.type === 'slider' && !options.options) {
                this.options = {
                    autoPlay: true,
                    controls: false,
                    fullLink: true,
                    interval: 5000,
                    overlay: false,
                }
            } else {
                this.options = options.options || {};
            }
        }

        Widget.prototype.getClassString = function () {
            return this.classes.join(' ');
        }

        /**
         *
         * @param [options]
         * @param {[Layer]} options.layers
         * @constructor
         */
        function Slide(options) {
            if (!options) {
                options = {};
            }

            this.layers = options.layers || [new Layer()];
        }

        /**
         * @type Layer
         * @param [options]
         * @param {String} [options.backgroundColor]
         * @param {String} [options.backgroundUrl]
         * @param {String} [options.text]
         * @param {String} [options.textPosition]
         * @param {[String]} [options.textClasses]
         * @param {[String]} [options.containerClasses]
         * @constructor
         */
        function Layer(options) {
            if (!options) {
                options = {};
            }
            this.backgroundColor = options.backgroundColor;
            this.backgroundUrl = options.backgroundUrl;
            this.text = options.text;
            this.textPosition = options.textPosition;
            this.textClasses = options.textClasses || [];
            this.containerClasses = options.containerClasses || [];
        }

        /**
         * @memberOf $widget#
         * @type {Widget[]}
         */
        this.defaultWidgets = [
            new Widget({
                classes: ['center-text'],
                icon : 'assets/images/icons/1.png',
                name: 'Banner Slider',
                type: 'slider',
                allowedTools: ['layers'],
                objects: [],
                description : 'A full screen slider with multiple slides. Autoplay supported',
                sizes : [
                    {
                        width: 1280,
                        height: 520,
                        attributeName: 'h_x_large'
                    },
                    {
                        width: 640,
                        height: 260,
                        attributeName: 'h_large'
                    },
                    {
                        width: 320,
                        height: 130,
                        attributeName: 'h_medium'
                    }
                ]
            }),
            new Widget({
                classes: 'flex-100 col-12',
                grids : {
                    xs : 100,
                    sm : 100,
                    md : 100,
                    lg : 100,
                    xl : 100,
                },
                name: 'One Column Layout',
                icon : 'assets/images/icons/2.png',
                type: 'column-banner',
                description : 'A full width banner which spans the entire width',
                allowedTools: ['layers'],
                objects: [{}],
                sizes : [
                    {
                        width: 1280,
                        height: 520,
                        attributeName: 'h_x_large'
                    },
                    {
                        width: 640,
                        height: 260,
                        attributeName: 'h_large'
                    },
                    {
                        width: 320,
                        height: 130,
                        attributeName: 'h_medium'
                    }
                ]
            }),
            new Widget({
                classes: 'flex-xs-100 col-12 flex-sm-50 col-sm-6 flex-md-50 col-md-6 flex-lg-50 col-lg-6 flex-xl-50 col-xl-6',
                name: 'Two Column Layout',
                grids : {
                    xs : 100,
                    sm : 50,
                    md : 50,
                    lg : 50,
                    xl : 50,
                },
                icon : 'assets/images/icons/3.png',
                description : 'A two column layout to stack images side by side',
                type: 'column-banner',
                allowedTools: ['layers'],
                objects: [{}, {}],
                sizes : [
                    {
                        width: 1120,
                        height: 800,
                        attributeName: 'h_x_large'
                    },
                    {
                        width: 560,
                        height: 400,
                        attributeName: 'h_large'
                    },
                    {
                        width: 280,
                        height: 200,
                        attributeName: 'h_medium'
                    }
                ]
            }),
            new Widget({
                classes: 'flex-xs-100 col-12 flex-sm-33 col-sm-4 flex-md-33 col-sm-4 flex-lg-33 col-lg-4 flex-xl-33 col-xl-4',
                name: 'Three Column Layout',
                grids : {
                    xs : 100,
                    sm : 33,
                    md : 33,
                    lg : 33,
                    xl : 33,
                },
                icon : 'assets/images/icons/4.png',
                description : 'A three column layout to stack images side by side',
                type: 'column-banner',
                allowedTools: ['layers'],
                objects: [{}, {}, {}],
                sizes : [
                    {
                        width: 1120,
                        height: 570,
                        attributeName: 'h_x_large'
                    },
                    {
                        width: 560,
                        height: 285,
                        attributeName: 'h_large'
                    },
                    {
                        width: 280,
                        height: 142.5,
                        attributeName: 'h_medium'
                    }
                ]
            }),
            new Widget({
                classes: 'flex-xs-100 col-12 flex-sm-50 col-sm-6 flex-md-25 col-md-3 flex-lg-25 col-lg-3 flex-xl-25 col-xl-3',
                name: 'Four Column Layout',
                icon : 'assets/images/icons/5.png',
                grids : {
                    xs : 100,
                    sm : 50,
                    md : 25,
                    lg : 25,
                    xl : 25,
                },
                description : 'A four column layout to stack images side by side',
                type: 'column-banner',
                allowedTools: ['layers'],
                objects: [{}, {}, {}, {}],
                sizes : [
                    {
                        width: 1200,
                        height: 1200,
                        attributeName: 'h_x_large'
                    },
                    {
                        width: 600,
                        height: 600,
                        attributeName: 'h_large'
                    },
                    {
                        width: 300,
                        height: 300,
                        attributeName: 'h_medium'
                    }
                ]
            }),
        ];

        /**
         * @memberOf $widget#
         * @type {Widget}
         */
        this.Widget = Widget;
        this.Slide = Slide;
        this.Layer = Layer;
    }

})(angular);

/*
 * Copyright (c) 2019. Kumar Divya Rajat
 * Created on 06/10/19, 4:17 AM
 *
 */

(function () {
    'use strict';

    HomeBuilderController.$inject = ["$scope", "$widget", "Utils", "$mdDialog", "$mdToast", "RestManager"];
    angular.module('app.homebuilder')
        .controller('home-builder.controller', HomeBuilderController);

    function HomeBuilderController($scope, $widget, Utils, $mdDialog, $mdToast, RestManager) {
        $scope.templates = $widget.defaultWidgets;
        $scope.configs = [];
        $scope.setting = '';
        $scope.menuFlex = 30;
        $scope.menuOpen = true;
        $scope.selectedWidget = null;

        $scope.addWidget = addWidget;
        $scope.editWidget = editWidget;
        $scope.clearSection = clearSection;
        $scope.addSlide = addSlide;
        $scope.deleteSlide = deleteSlide;
        $scope.getStyles = getStyles;
        $scope.generateLink = generateLink;
        $scope.getPlaceholder = getPlaceholder;
        $scope.deleteWidget = deleteWidget;
        $scope.saveWidgets = saveWidgets;
        $scope.fetchHomeConfig = fetchHomeConfig;
        $scope.minimiseMenu = minimiseMenu;
        $scope.openPreview = openPreview;
        $scope.updateClasses = updateClasses;
        $scope.properName = Utils.properName;
        $scope.columns = [
            {
                title: 'XS (Mobile)',
                value: 'xs'
            },
            {
                title: 'SM (iPad/ Small Tablets)',
                value: 'sm'
            },
            {
                title: 'MD (iPad Pro / Large Tablets)',
                value: 'md'
            },
            {
                title: 'LG (Laptops)',
                value: 'lg'
            },
            {
                title: 'XL (Desktops)',
                value: 'xl'
            }
        ];
        $scope.gridValues = [
            {
                title: 25,
                value: 25,
                classes: ['flex-{col}-25', 'col-{col}-3']
            },
            {
                title: 33,
                value: 33,
                classes: ['flex-{col}-33', 'col-{col}-4']
            },
            {
                title: 50,
                value: 50,
                classes: ['flex-{col}-50', 'col-{col}-6']
            },
            {
                title: 66,
                value: 66,
                classes: ['flex-{col}-66', 'col-{col}-8']
            },
            {
                title: 75,
                value: 75,
                classes: ['flex-{col}-75', 'col-{col}-9']
            },
            {
                title: 100,
                value: 100,
                classes: ['flex-{col}-100', 'col-{col}-12']
            }
        ];

        function updateClasses(selectedWidget, column) {
            // Extract the value from selectedWidget. eg : 25
            var value = selectedWidget.grids[column.value];
            // Find the value from the gridValues
            var selectedGridValue = _.find($scope.gridValues, function (gridValue) {
                return gridValue.value === value;
            });
            console.log("home-builder.controller.js", "updateClasses", selectedWidget);
            if (Array.isArray(selectedWidget.classes)) {
                selectedWidget.classes = selectedWidget.classes[0];
            }
            // examples for xs. Supported values are xs,sm,md,lg,xl.
            // Split the classes string to an array
            var widgetClasses = selectedWidget.classes.split(' ');
            widgetClasses = widgetClasses.map(function (classValue) {
                // If flex-xs- value is present, replace it with new value
                if (classValue.indexOf('flex-' + column.value + '-') !== -1) {
                    // Compile the new class value
                    classValue = selectedGridValue.classes[0].replace('{col}', column.value);
                } else if (classValue.indexOf('col-' + column.value + '-') !== -1) {
                    classValue = selectedGridValue.classes[1].replace('{col}', column.value);
                } else if (column.value === 'xs' && /col-\d{1,2}/.test(classValue)) {
                    // special case for vuetify xs grid. It is col-12 and not col-xs-12.
                    classValue = selectedGridValue.classes[1].replace('{col}-', '');
                }
                return classValue;
            });
            // Check if the flex-xs- class is present. If not, we will add it.
            var hasFlexClass = _.find(widgetClasses, function (classValue) {
                return new RegExp('flex-' + column.value + '-\\d{1,2}').test(classValue);
            });
            // Check if col-xs class is present. If not, we will add it.
            var hasColClass = _.find(widgetClasses, function (classValue) {
                var regex;
                // the regex for xs in vuetify is col-12 and not col-xs-12
                if (column.value === 'xs') {
                    regex = /col-\d{1,2}/
                } else {
                    regex = new RegExp('col-' + column.value + '-\\d{1,2}')
                }
                return regex.test(classValue);
            });
            // if flex class is not present, add it.
            if (!hasFlexClass) widgetClasses.push(selectedGridValue.classes[0].replace('{col}', column.value));
            if (!hasColClass) {
                if (column.value === 'xs') widgetClasses.push(selectedGridValue.classes[1].replace('{col}-', ''))
                else widgetClasses.push(selectedGridValue.classes[1].replace('{col}', column.value))
            }
            // combine the classes array to create a new class string. This step is needed now to provide a live preview.
            // Otherwise it could have been done just before saving too.
            selectedWidget.classes = widgetClasses.join(' ');
        }

        function addWidget($event, index, config) {
            var conf = config || new $scope.Widget({
                name: 'Custom Template',
                type: 'custom',
                objects: []
            })
            // Contract all widgets so that it is easier to edit the new widget
            $scope.configs = $scope.configs.map(function (config) {
                config.expanded = false;
                return config;
            });
            console.log("home-builder.controller.js", "addWidget", config, typeof index !== 'undefined');
            var newWidget = {};
            angular.copy(config, newWidget);
            // newWidget.id = moment().utc().toString();
            if (index === 0 || index) {
                $scope.configs.splice(index, 0, newWidget);
            } else {
                $scope.configs.push(newWidget);
            }
            console.log("home-builder.controller.js", "addWidget", $scope.configs);
        }

        function editWidget(config, event) {
            event.stopPropagation();
            $scope.selectedWidget = config;
        }

        function clearSection() {
            $scope.selectedWidget = null;
        }

        function deleteWidget($event, index) {
            $mdDialog.show(
                $mdDialog.confirm()
                    .title('Delete this widget?')
                    .textContent('This action is irreversible. Please make sure that this is an intended action.')
                    .ok('Delete')
                    .cancel('Cancel')
            )
                .then(function (res) {
                    if (res) {
                        $scope.configs.splice(index, 1);
                    }
                })
                .catch(function (err) {
                    console.log('Error : ' + err);
                })
        }

        function addSlide(event, config, index) {
            if (typeof index !== 'undefined') {
                config.objects.splice(index, 0, new $widget.Slide());
            } else {
                config.objects.push(new $widget.Slide());
            }
        }

        function deleteSlide(config, index, ev) {
            config.objects.splice(index, 1);
            ev.stopPropagation();
        }

        function generateLink(ev, object) {
            Utils.openLinkGenerator(ev, object.url, object.urlData)
                .then(function (data) {
                    if (data) {
                        object.url = data.url;
                        object.urlData = data;
                        delete object.urlData.url;
                    }
                })
                .catch(function (err) {

                })
        }

        function openPreview(ev) {
            Utils.openLayoutPreviewer(ev, {widgets: $scope.configs, setting: $scope.setting})
                .then(function (data) {
                    if (data && data.updatedSetting) {
                        $scope.clearSection();
                        $scope.setting = data.updatedSetting;
                        $scope.configs = data.updatedSetting.values;
                    }
                })
                .catch(function (err) {

                })
        }


        function getPlaceholder(config) {
            if (config.sizes && config.sizes.length) {
                return 'Image Size - (' + config.sizes[0].width + 'px x ' + config.sizes[0].height + 'px )';
            } else {
                return 'NA'
            }
        }

        function saveWidgets() {
            console.log("home-builder.controller.js", "saveWidgets", $scope.configs);
            var promise;
            var configs = [];
            angular.copy($scope.configs, configs);
            configs = configs.map(function (config) {
                config.objects = config.objects.map(function (object) {
                    object.image = object.image._id;
                    return object;
                });
                return config;
            });
            $scope.saving = true;
            if ($scope.setting && $scope.setting._id) {
                var payload = {};
                angular.copy($scope.setting, payload);
                payload.values = configs;
                promise = RestManager.putResource('/settings/home/admin', payload, 'homeConfig')
            } else {
                promise = RestManager.postResource('/settings/home/admin', {values: configs}, 'homeConfig')
            }

            promise.then(function (settings) {
                $scope.setting = settings[0];
                $scope.configs = settings[0].values;
                $scope.saving = false;
                $scope.clearSection();
                $mdToast.showSimple('Saved the config. Preview the page on the homepage to make sure it is perfect.')
            })
                .catch(function (err) {
                    $scope.saving = false;
                    $mdToast.showSimple('Error saving home config : ' + err.message);
                })
        }

        function fetchHomeConfig() {
            $scope.fetching = true;
            RestManager.getResource('/settings/home/admin', 'homeConfig')
                .then(function (settings) {
                    if (settings && settings.length) {
                        $scope.setting = settings[0];
                        $scope.configs = settings[0].values.map(function (config) {
                            return new $widget.Widget(config);
                        });
                        console.log("home-builder.controller.js", "assa", $scope.configs);
                    }
                    $scope.fetching = false;
                })
                .catch(function (err) {
                    $scope.fetching = false;
                    $mdToast.showSimple('Error saving home config : ' + err.message);
                })
        }

        function getStyles(layerLikeObject, index) {
            var style = {};
            if (typeof index !== 'undefined') {
                style['z-index'] = 10 + index;
            }

            style.backgroundColor = layerLikeObject.background;
            style.backgroundUrl = 'url(' + layerLikeObject.background + ')';
            return style;
        }

        function minimiseMenu() {
            if ($scope.menuFlex === 30) {
                $scope.menuFlex = 5;
            } else {
                $scope.menuFlex = 30;
            }
            $scope.menuOpen = !$scope.menuOpen;
        }

        $scope.fetchHomeConfig();
    }

})(angular);

(function () {
    'use strict';


    angular.module('app.diagnostics', [])
})(angular);

(function () {
    'use strict';

    DiagnosticsController.$inject = ["$scope", "RestManager"];
    angular.module('app.diagnostics')
        .controller('diagnostics.controller', DiagnosticsController);

    /** @ngInject **/
    function DiagnosticsController($scope, RestManager) {
        var vm = this;

        vm.runProductDiagnostics = runProductDiagnostics;

        function runProductDiagnostics() {
            RestManager
                .postResource('/products/admin/diagnostics',
                    {
                        recoverSizeChartIssue: true
                    },
                    'products')
                .then(function (products) {
                    console.log("diagnostics.controller.js", "products", products);
                })
                .catch(function (err) {
                    console.log("diagnostics.controller.js", "err", err);
                })
        }

    }

})(angular);

(function () {
    'use strict';

    angular.module('app.main')
        .factory('Menu', function () {
            var menuItems = [
                {
                    name: 'Home',
                    icon: 'home',
                    sref: 'app.home',
                    allowedRoleSpecs: 8,
                    recommended: 0
                },
                {
                    allowedRoleSpecs: 2,
                    name: 'Users',
                    icon: 'person',
                    sref: '',
                    recommended: 0,
                    children: [
                        {

                            name: ' All Users',
                            icon: 'person_pin',
                            sref: 'app.users.all',
                            allowedRoleSpecs: 2,
                            recommended: 3
                        },
                        {

                            name: ' Addresses',
                            icon: 'map',
                            sref: 'app.users.addresses',
                            allowedRoleSpecs: 2,
                            recommended: 3
                        },
                        {
                            name: ' Influencers',
                            icon: 'group',
                            sref: 'app.users.influencers',
                            allowedRoleSpecs: 2,
                            recommended: 3
                        }
                    ]
                },

                {
                    name: 'Media',
                    icon: 'photo_library',
                    sref: 'app.media',
                    allowedRoleSpecs: 3,
                    recommended: 1
                },

                {
                    name: 'Pages',
                    icon: 'pages',
                    sref: '',
                    allowedRoleSpecs: 2,
                    children: [
                        {
                            name: 'Add New',
                            icon: 'library_add',
                            sref: 'app.pages.add',
                            allowedRoleSpecs: 2,
                            recommended: 1
                        },
                        {
                            name: 'All Pages',
                            icon: 'playlist_add_check',
                            sref: 'app.pages.all({page : 1, limit : 25, sort : "-createdAt"})',
                            allowedRoleSpecs: 2,
                            recommended: 2
                        },
                        {
                            name: 'Trash',
                            icon: 'delete_sweep',
                            sref: 'app.products.trash',
                            allowedRoleSpecs: 2,
                            recommended: 1
                        }
                    ]
                },
                {
                    name: 'Posts',
                    icon: 'photo_library',
                    sref: 'app.posts',
                    allowedRoleSpecs: 3,
                    recommended: 1
                },
                {
                    allowedRoleSpecs: 2,
                    group: 'Products',
                    name: 'Products',
                    children: [
                        {
                            name: 'Categories',
                            icon: 'layers',
                            sref: 'app.products.categories',
                            allowedRoleSpecs: 2,
                            recommended: 2
                        }, {
                            name: 'Attributes',
                            icon: 'texture',
                            sref: 'app.products.attributes',
                            allowedRoleSpecs: 2,
                            recommended: 2
                        }, {
                            name: 'Collections',
                            icon: 'donut_large',
                            sref: 'app.collections',
                            allowedRoleSpecs: 2,
                            recommended: 2
                        },
                        // {
                        //     name: 'Models',
                        //     icon: 'person_pin_circle',
                        //     sref: 'app.products.models',
                        //     allowedRoleSpecs: 2,
                        // },
                        {
                            name: 'Size Charts',
                            icon: 'insert_chart',
                            sref: 'app.products.sizeCharts',
                            allowedRoleSpecs: 2,
                            recommended: 2
                        },
                        {
                            name: 'Designs',
                            icon: 'work',
                            sref: 'app.design.all',
                            allowedRoleSpecs: 2,
                            recommended: 0
                        },
                        // {
                        //     name: 'Tags',
                        //     icon: 'local_library',
                        //     sref: 'app.products.tags',
                        //     allowedRoleSpecs: 2,
                        // },
                        {
                            name: 'Products',
                            icon: 'event_seat',
                            sref: '',
                            allowedRoleSpecs: 2,
                            recommended: 0,
                            children: [
                                {
                                    name: 'Add New',
                                    icon: 'library_add',
                                    sref: 'app.products.add.home',
                                    allowedRoleSpecs: 2,
                                    recommended: 2
                                }, {
                                    name: 'All Products',
                                    icon: 'playlist_add_check',
                                    sref: 'app.products.all({page : 1, limit : 25, order : \'-createdAt\'})',
                                    allowedRoleSpecs: 7,
                                    recommended: 5
                                },
                                // {
                                //     name: 'Import',
                                //     icon: 'import_export',
                                //     sref: 'app.products.import',
                                //     allowedRoleSpecs: 2,
                                // },
                                {
                                    name: 'Trash',
                                    icon: 'delete_sweep',
                                    sref: 'app.products.trash',
                                    allowedRoleSpecs: 2,
                                    recommended: 1
                                }
                            ]
                        },
                        {
                            name: 'Materials',
                            icon: 'toys',
                            sref: '',
                            allowedRoleSpecs: 2,
                            recommended: 0,
                            children: [
                                {
                                    name: 'All Materials',
                                    icon: 'home',
                                    sref: 'app.materials.all',
                                    allowedRoleSpecs: 2,
                                    recommended: 3
                                },
                                {
                                    name: "Categories",
                                    icon: 'star',
                                    sref: 'app.materials.categories',
                                    allowedRoleSpecs: 2,
                                    recommended: 1
                                },
                                {
                                    name: "Vendors",
                                    icon: 'person_pin',
                                    sref: 'app.materials.vendors',
                                    allowedRoleSpecs: 2,
                                    recommended: 1
                                }
                            ]
                        },
                    ]
                },
                // {
                //     allowedRoleSpecs: 2,
                //     group: 'Customisation',
                //     name: 'Customisation',
                //     children: [
                //         {
                //             name: 'Templates',
                //             icon: 'star_half',
                //             sref: 'app.customisation.templates',
                //             allowedRoleSpecs: 2,
                //         }, {
                //             name: 'Fabrics',
                //             icon: 'tab',
                //             sref: 'app.customisation.options',
                //             allowedRoleSpecs: 2,
                //         }
                //     ]
                // },
                {
                    allowedRoleSpecs: 2,
                    group: 'Discount',
                    name: 'Discount',
                    recommended: 0,
                    children: [
                        {
                            name: 'Coupons',
                            icon: 'local_play',
                            sref: 'app.offers.coupons',
                            allowedRoleSpecs: 2,
                            recommended: 3
                        },
                        {
                            name: 'Gift Cards',
                            icon: 'card_giftcard',
                            sref: '',
                            allowedRoleSpecs: 2,
                            recommended: 0,
                            children: [
                                {
                                    name: 'Home',
                                    icon: 'home',
                                    sref: 'app.offers.giftCards.home',
                                    allowedRoleSpecs: 2,
                                    recommended: 2
                                }, {
                                    name: 'Add Gift Cards',
                                    icon: 'library_add',
                                    sref: 'app.offers.giftCards.add',
                                    allowedRoleSpecs: 2,
                                    recommended: 1
                                }, {
                                    name: 'All Gift Cards',
                                    icon: 'select_all',
                                    sref: 'app.offers.giftCards.all',
                                    allowedRoleSpecs: 2,
                                    recommended: 3
                                }
                            ]
                        }
                    ]
                },
                {
                    allowedRoleSpecs: 7,
                    group: 'Orders',
                    name: 'Orders',
                    recommended: 0,
                    children: [
                        {
                            name: 'Cart',
                            icon: 'shopping_basket',
                            sref: 'app.cartAll',
                            allowedRoleSpecs: 1,
                            recommended: 3
                        },
                        {
                            name: 'POS',
                            icon: 'store',
                            sref: '',
                            recommended: 0,
                            allowedRoleSpecs: 7,
                            children: [
                                {
                                    name: 'Home',
                                    icon: 'home',
                                    sref: 'app.pos.home',
                                    allowedRoleSpecs: 7,
                                    recommended: 2
                                },
                                {
                                    name: 'Add Backdate Order',
                                    icon: 'history',
                                    sref: 'app.pos.backDate({backDateOrder : true})',
                                    allowedRoleSpecs: 3,
                                    recommended: 1
                                },
                                {
                                    name: 'Add New',
                                    icon: 'add',
                                    sref: 'app.pos.add',
                                    allowedRoleSpecs: 7,
                                    recommended: 4
                                }
                            ]
                        },
                        {
                            name: 'Quotations',
                            icon: 'business',
                            sref: 'app.quotations',
                            allowedRoleSpecs: 1,
                            recommended: 3
                        },
                        {
                            name: 'Orders',
                            icon: 'shopping_cart',
                            sref: '',
                            allowedRoleSpecs: 3,
                            recommended: 0,
                            children: [
                                // {
                                //     name: 'Add New',
                                //     icon: 'add',
                                //     sref: 'app.orders.add',
                                //     allowedRoleSpecs: 3,
                                //     recommended: 0
                                // },
                                {
                                    name: 'Order Planning',
                                    icon: 'local_mall',
                                    sref: 'app.orders.planning',
                                    allowedRoleSpecs: 3,
                                    recommended: 4
                                },
                                {
                                    name: 'All Orders',
                                    icon: 'star',
                                    sref: 'app.orders.all',
                                    allowedRoleSpecs: 3,
                                    recommended: 4
                                }
                            ]
                        }
                    ]
                },

                {
                    allowedRoleSpecs: 2,
                    group: 'Company',
                    name: 'Company',
                    recommended: 0,
                    children: [
                        {
                            name: 'Reports',
                            icon: 'data_usage',
                            sref: 'app.reports',
                            allowedRoleSpecs: 2,
                            recommended: 3
                        },
                        {
                            name: 'Organisations',
                            icon: 'group',
                            sref: 'app.users.organisations',
                            allowedRoleSpecs: 2,
                            recommended: 1
                        },
                        {
                            name: 'Warehouses',
                            icon: 'store',
                            sref: 'app.warehouse',
                            allowedRoleSpecs: 0,
                            recommended: 3
                        },
                        {
                            name: 'Purchases',
                            icon: 'home',
                            sref: 'app.purchase',
                            allowedRoleSpecs: 2,
                            recommended: 1
                        },

                        {
                            name: "Tasks",
                            icon: 'assignment',
                            sref: 'app.tasks.all',
                            allowedRoleSpecs: 1,
                            recommended: 2
                        },
                        // {
                        //     name: 'Schedule',
                        //     icon: 'timer',
                        //     sref: 'app.schedule',
                        //     allowedRoleSpecs: 2,
                        //     recommended: 0
                        // },

                        // {
                        //     name: 'Photo Shoot',
                        //     icon: 'camera',
                        //     sref: 'app.photoShoot',
                        //     allowedRoleSpecs: 2,
                        //     recommended: 0
                        // }, {
                        //     name: 'Campaigns',
                        //     icon: 'email',
                        //     sref: 'app.campaigns',
                        //     allowedRoleSpecs: 2,
                        //     recommended: 0
                        // }
                    ]
                },
                {
                    allowedRoleSpecs: 2,
                    group: 'Developers',
                    name: 'Developers',
                    recommended: 0,
                    children: [
                        {
                            name: 'Homepage Builder',
                            icon: 'dynamic_feed',
                            sref: 'app.homepageBuilder',
                            allowedRoleSpecs: 2,
                            recommended: 0
                        },
                        {
                            name: 'Redux',
                            icon: 'compare',
                            sref: 'app.redux',
                            allowedRoleSpecs: 2,
                            recommended: 0
                        },
                        {
                            name: 'Query',
                            icon: 'query_builder',
                            sref: 'app.query',
                            allowedRoleSpecs: 1,
                            recommended: 0
                        }
                        // {
                        //     name: 'Diagnostics',
                        //     icon: 'bug',
                        //     sref: 'app.diagnostics',
                        //     allowedRoleSpecs: 2,
                        // }
                    ]
                }
            ];



            var flattenedMenuItems = _.flatMapDeep(menuItems, function (item) {
                if (item.children) {
                    return _.map(item.children, function (childItem) {
                        if (childItem.children) {
                            return _.map(childItem.children, function (grandChildren) {
                                return {
                                    name: grandChildren.name,
                                    icon: grandChildren.icon,
                                    sref: grandChildren.sref,
                                    category: childItem.name,
                                    recommended: grandChildren.recommended,
                                    allowedRoleSpecs: grandChildren.allowedRoleSpecs,
                                    description: grandChildren.description
                                }
                            })
                        } else {
                            return {
                                name: childItem.name,
                                icon: childItem.icon,
                                sref: childItem.sref,
                                category: item.name,
                                recommended: childItem.recommended,
                                allowedRoleSpecs: childItem.allowedRoleSpecs,
                                description: childItem.description
                            }
                        }
                    })
                } else {
                    return {
                        name: item.name,
                        icon: item.icon,
                        sref: item.sref,
                        category: item.name,
                        recommended: item.recommended,
                        allowedRoleSpecs: item.allowedRoleSpecs,
                        description: item.description
                    }
                }
            });

            /**
             * @module Menu
             * @param roleSpec
             * @returns {*[]}
             */
            function getMenuItems(roleSpec) {
                var returnItems = [];

                menuItems
                    .forEach(function (menuItem) {
                        if (menuItem.children && menuItem.children.length) {
                            var data = [];
                            menuItem.children.forEach(function (childMenuItem) {
                                if (childMenuItem.children && childMenuItem.children.length) {
                                    var childData = [];
                                    childMenuItem.children.forEach(function (grandChildMenuItem) {
                                        if (roleSpec <= grandChildMenuItem.allowedRoleSpecs) {
                                            childData.push(grandChildMenuItem);
                                        }
                                    });
                                    if (childData.length) {
                                        childMenuItem.children = childData;
                                        data.push(childMenuItem);
                                    }
                                } else if (roleSpec <= childMenuItem.allowedRoleSpecs) {
                                    data.push(childMenuItem);
                                }
                            });

                            if (data.length) {
                                menuItem.children = data;
                                returnItems.push(menuItem);
                            }
                        } else if (roleSpec <= menuItem.allowedRoleSpecs) {
                            returnItems.push(menuItem);
                        }
                    });

                return returnItems;
            }

            /**
             * @module Menu
             * @param queryText {String}
             * @param roleSpec {Number}
             * @returns {*[]}
             */
            function searchMenuItems(queryText, roleSpec) {
                var options = {
                    keys: [{
                        name: 'name',
                        weight: 0.55
                    }, {
                        name: 'category',
                        weight: 0.45
                    }]
                };
                var items  =  _.chain(flattenedMenuItems)
                    .filter(function (item) {
                        return roleSpec <= item.allowedRoleSpecs && item.sref;
                    })
                    .value();
                var fuse = new Fuse(items, options);
                return fuse.search(queryText)
            }

            /**
             * @module Menu
             * @returns {*[]}
             * @param roleSpec {Number}
             */
            function getRecommendations(roleSpec) {
                return _.chain(flattenedMenuItems)
                    .filter(function (item) {
                        return roleSpec <= item.allowedRoleSpecs && item.sref;
                    })
                    .orderBy(['recommended'], ['desc'])
                    .slice(0, 10)
                    .value();
            }

            return {
                getMenuItems: getMenuItems,
                searchMenuItems: searchMenuItems,
                getRecommendations: getRecommendations
            }
        });

})(angular);

// 0: "admin"
// 1: "hr"
// 2: "marketing"
// 3: "designer"
// 4: "shop-manager"
// 5: "model"
// 6: "operator"
// 7: "sales-staff"
// 8: "photographer"
// 9: "customer"

(function () {
    'use strict';

    MainController.$inject = ["$scope", "$rootScope", "$location", "RestManager", "Base", "$mdMedia", "$timeout", "$state", "hotkeys", "$mdToast", "$stateParams", "$cookies", "Menu", "$mdPanel", "$interval", "$analytics", "$http", "$window", "$mdDialog", "Header", "$mdSidenav", "$log", "AuthManager", "VersionManager", "Notifications", "ChatService"];
    angular.module("app.main")
        .controller('mainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, $location, RestManager, Base, $mdMedia, $timeout, $state, hotkeys,
                            $mdToast, $stateParams, $cookies, Menu, $mdPanel, $interval, $analytics, $http, $window,
                            $mdDialog, Header, $mdSidenav, $log, AuthManager, VersionManager, Notifications, ChatService) {
        // Base.setEnv(process.env.NODE_ENV);
        Base.setBaseUrl(confData.baseUrl ? confData.baseUrl : "/api/v1");
        Base.setMediaUrl(confData.mediaUrl || "/api/v1");
        Base.setSCMUrl(confData.scmUrl || "/api/v1");
        Base.setAppUrl(confData.appUrl || "/");
        Base.setReviewUrl(confData.reviewUrl || "/");
        Base.setShortUrlService(confData.shortUrlService || "/");
        Base.setEnv(confData.env ? confData.env : "dev");
        Base.setPdfService(confData.pdfService || '/');
        Base.setChatService(confData.chatService || '/');
        Base.setChatInstance(confData.chatInstanceId || '');
        Base.setWorkforceUrl(confData.workforceUrl || '');
        $scope.dynamicTheme = 'boring';
        $scope.currentUser = AuthManager.getCurrentUser();
        $scope.notifications = Notifications.messages;
        $scope.loadingMenu = true;
        $scope._mdPanel = $mdPanel;
        $scope.appVersion = confData.version;
        $scope.productUpdateInterval = -1;
        $scope.settings = JSON.parse(window.localStorage.getItem('settings') || JSON.stringify({
            notificationSyncDuration: 60000,
            autoNotifications: true
        }));

        $scope.updateView = updateView;
        $scope.openNotificationsPanel = openNotificationsPanel;
        $scope.openAction = openAction;
        $scope.checkForUpdates = checkForUpdates;
        $scope.clearNotifications = clearNotifications;
        $scope.markAsRead = markAsRead;
        $scope.showSettings = showSettings;
        $scope.showToast = showToast;
        $scope.media = $mdMedia;

        $scope.isSmall = !$mdMedia('gt-sm');
        $scope.isIpad = $mdMedia('sm');

        $interval(function () {
            $scope.isSmall = !$mdMedia('gt-sm');
        }, 5000);

        function showToast(message) {
            $mdToast.showSimple(message);
        }

        function clearNotifications() {
            Notifications.clearNotifications();
            $scope.notifications = [];
        }

        function markAsRead(notification) {
            $scope.notifications = Notifications.markAsRead(notification);
            $mdSidenav('notifications-panel').close()
        }


        function openNotificationsPanel($event, menu) {
            $mdSidenav('notifications-panel').open()
                .then(function () {
                    $scope.notifications = Notifications.markAllAsViewed();
                    $scope.unreadCount = $scope.notifications.filter(function (m) {
                        return !m.viewed
                    }).length;
                })
            // var panelAnimation = $mdPanel.newPanelAnimation()
            //     .openFrom('.notification-button')
            //     .closeTo('.notification-button')
            //     .withAnimation($mdPanel.animation.SCALE);
            //
            // var panelPosition = $mdPanel.newPanelPosition()
            //     .relativeTo($event.target)
            //     .addPanelPosition(
            //         $mdPanel.xPosition.OFFSET_END,
            //         $mdPanel.yPosition.BELOW
            //     );
            //
            // $mdPanel.open({
            //     id: 'menu_notifications',
            //     position: panelPosition,
            //     openFrom: $event,
            //     scope: $scope,
            //     attachTo: angular.element(document.body),
            //     disableParentScroll: this.disableParentScroll,
            //     templateUrl: 'notifications.panel.tmpl.html',
            //     hasBackdrop: false,
            //     panelClass: 'notifications-panel',
            //     trapFocus: true,
            //     zIndex: 150,
            //     clickOutsideToClose: true,
            //     escapeToClose: true,
            //     focusOnOpen: true,
            //     animation: panelAnimation
            // })
            //     .then(function (ref) {
            //         $scope._mdPanel = ref;

            // })
        }

        function openAction(notification) {
            console.log(notification);
        }


        function updateView() {
            $scope.menuItems = Menu.getMenuItems($scope.currentUser.roleSpec);
            $scope.currentView = $scope.currentUser.role;
            $scope.loadingMenu = false;
            $rootScope.$broadcast('ROLE_CHANGED', $scope.currentUser.roleSpec);
        }


        var setUser = function () {
            $scope.user = $scope.currentUser || {};

            if ($scope.user && !$scope.user.profileImageURL) {
                $scope.user.profileImageURL = "/assets/images/icons/man.svg";
            }

        };


        var clearUser = function () {
            $scope.user = {};
        };

        var navToLogin = function () {
            if (!$scope.isUserLoggedIn && $state.current.name !== "login") {
                $mdDialog.cancel();
                if (confData.env === 'prod' && typeof FS !== 'undefined') {
                    FS.identify(false);
                }
                $state.go("login");
            } else if ($scope.isUserLoggedIn && $state.current.name === "login") {
                $state.go("app.home", {location: "replace"});
            } else {
                // console.log('File : main.js | Line : 37', 'navToLogin', $scope.isUserLoggedIn, $state.current.name);
            }
        };


        var getInt = function (key) {
            return Number(key);
        };


        var generateLoginClass = function () {
            var min = 1;
            var max = 12;
            $scope.loginClass = "header-" + (Math.floor(Math.random() * (max - min + 1)) + min);
        };


        $scope.getRoles = function () {
            return RestManager.getResource("/settings/constants/USER_ROLES", "settings");
        };

        var handleRoleData = function (data) {
            $scope.userRoles = data;
            $scope.currentUser.roleSpec = Number(_.findIndex(data, function (o) {
                return o === $scope.currentUser.role;
            }));
            $scope.roleKeys = data.reduce(function (acc, cur, i) {
                acc[i] = cur;
                return acc;
            }, {});
            $scope.updateView();
        };


        $scope.frontEndUrl = Base.getAppUrl();

        $scope.isSmall = !$mdMedia('gt-sm');

        $scope.loading = false;
        $scope.isUserLoggedIn = AuthManager.isUserLoggedIn;
        if ($scope.isUserLoggedIn) {
            $scope.getRoles()
                .then(function (data) {
                    handleRoleData(data);
                    VersionManager.manageVersion();
                    if ($scope.settings.notificationSyncDuration && $scope.settings.autoNotifications) {
                        $scope.productUpdateInterval = Notifications.updateTimeInterval($scope.settings.notificationSyncDuration);
                    }
                    if ($scope.currentUser.role === 'admin') {
                        return ChatService.init($scope.currentUser)
                    } else {
                        return Promise.resolve()
                    }
                })
                .then(function () {

                })
                .catch(function (err) {
                    console.log('File : main.js | Line : 84', 'err', err);
                });

            hotkeys.bindTo($scope)
                .add({
                    combo: 'mod+e',
                    description: 'Open the app search bar',
                    callback: function (e) {
                        e.preventDefault();
                        $scope.openSearch = true;

                        setTimeout(function () {
                            $scope.openSearch = false;
                        }, 1000);
                    }
                })
        }

        $scope.open = function () {
            // Component lookup should always be available since we are not using `ng-if`

            if ($mdSidenav('left').isOpen()) {
                $scope.closeSidebar()
                    .then(function () {
                        $log.debug("close LEFT is done");
                        return $mdSidenav('left').open();
                    })
                    .then(function () {
                        $log.debug("open LEFT is done");
                    });
            } else {
                $mdSidenav('left').open()
                    .then(function () {
                        $log.debug("open LEFT is done");
                    });
            }
        };


        $scope.openLoginModal = function (ev) {
            AuthManager.showLoginModal($scope, true);
            $scope.closeSidebar()
                .then(function () {
                    $log.info("closed");
                })

        };


        $scope.openNewProductPage = function () {
            RestManager.getResource("/products/new", "products")
                .then(function (products) {
                    $scope.closeSidebar()
                        .then(function () {
                            $state.go("app.products.add", {slug: products[0]._id});
                        });
                })
                .catch(function (err) {
                    console.log(err);
                })
        };

        $scope.closeSidebar = function () {
            return $mdSidenav('left').close()
        };

        $scope.loginUser = function () {
            $scope.loggingIn = true;
            $scope.error = "";
            // $log.info("loggged in", $scope.user);
            AuthManager.loginUser($scope.user.mobile, $scope.user.password)
                .then(function (user) {
                    $scope.loggingIn = false;
                    $scope.isUserLoggedIn = true;
                    $scope.currentUser = user;
                    $scope.user = {};
                    $scope.settingUp = true;
                    $analytics.setAlias(user._id);
                    $analytics.setUsername(user.email);
                    $analytics.setUserProperties({
                        name: user.name,
                        email: user.email,
                        role: user.role,
                        mobile: user.mobile,
                        id: user._id,
                        _id: user._id
                    });
                    if (confData.env === 'prod' && typeof FS !== 'undefined') {
                        FS.identify(user._id, {
                            displayName: user.name,
                            email: user.email,
                            role_str: user.role
                        });
                    }
                    $analytics.eventTrack('LoggedIn', {name: user.name, id: user._id});
                    return $scope.getRoles();
                })
                .then(function (data) {
                    handleRoleData(data);
                    // VersionManager.manageVersion();
                    if ($scope.settings.notificationSyncDuration && $scope.settings.autoNotifications) {
                        $scope.productUpdateInterval = Notifications.updateTimeInterval($scope.settings.notificationSyncDuration);
                    }
                    $scope.setUser();
                    $timeout(function () {
                        if ($stateParams.returnTo) {
                            window.location.href = $stateParams.returnTo;
                        } else {
                            $state.transitionTo("app.home");
                        }
                        var date = moment().subtract(1, 'month').startOf('day').toISOString();
                        $scope.setDefaults('lastOrder', date);
                        $scope.setDefaults('lastComment', date);
                        $scope.setDefaults('lastOrderComment', date);
                        $scope.setDefaults('lastGCComment', date);
                        $scope.settingUp = false;
                    }, 500);
                    if ($scope.currentUser.role === 'admin') {
                        return ChatService.init($scope.currentUser);
                    } else {
                        return Promise.resolve();
                    }
                })
                .then(function () {

                })
                .catch(function (err) {
                    console.log(err);
                    if (err.code === 403) {

                    }
                    $scope.loggingIn = false;
                    // console.log(err);
                    $scope.error = err;

                    // $log.error(err);
                })
        };

        $scope.setDefaults = function (key, value) {
            if (!$window.localStorage.getItem(key)) {
                $window.localStorage.setItem(key, value)
            }
        };

        $scope.logout = function () {
            AuthManager.logout()
                .then(function () {
                    $state.transitionTo("login");
                    $scope.currentUser = "";
                    $scope.user = {};
                    $scope.isUserLoggedIn = AuthManager.isUserLoggedIn;
                    Notifications.stopService($scope.productUpdateInterval);
                });
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
            return $mdSidenav('left').close()
        };


        $scope.registerSideMenuListeners = function () {
            $timeout(function () {
                var sideMenuButtons = document.querySelectorAll("a.md-sidemenu-button");
                sideMenuButtons.forEach(function (button) {
                    button.addEventListener("click", function (e) {
                        $scope.cancel();
                    }, false);
                });
            }, 500);
        };

        $scope.registerSideMenuListeners();


        $rootScope.$on("loggedIn", function ($event, data) {
            $timeout(function () {
                // the code you want to run in the next digest
                $scope.$apply(function () {
                    //wrapped this within $apply
                    $scope.currentUser = data.user;
                });
            });
        });

        $scope.reloadState = function () {
            $state.reload();
        };


        $rootScope.$on("TOKEN_EXPIRED", function () {
            $analytics.eventTrack('LOGOUT', {
                actions: 'TOKEN_EXPIRED',
                user: $scope.currentUser.name,
                id: $scope.currentUser._id
            })
            $scope.currentUser = "";
            $scope.isUserLoggedIn = false;
            AuthManager.isUserLoggedIn = false;
            $analytics.setAlias("");
            $analytics.setUsername("");
            $analytics.setUserProperties("");
            navToLogin();
        });


        $rootScope.$on('$stateChangeStart', function (event, next, current) {
            $scope.loading = true;
        });

        $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
            $scope.loading = false;
            navToLogin();
            $rootScope.previousState = from.name;
            $rootScope.previousParams = fromParams;
            $scope.currentNavItem = to.url.split("/")[1];
        });

        $rootScope.$on('SETTINGS_CHANGED', function (ev, data) {
            $scope.settings = data;
            if (!$scope.settings.autoNotifications) {
                Notifications.stopService();
            } else {
                $scope.productUpdateInterval = Notifications.startService();
            }

            if ($scope.settings.notificationSyncDuration !== Notifications.timeInterval) {
                $scope.productUpdateInterval = Notifications.updateTimeInterval($scope.settings.notificationSyncDuration)
            }
        });

        // $rootScope.$on('$stateChangeError', function (event, next, current) {
        //     //catch error
        //
        //     // Toast.errorToast("Some Error Occurred. Error report sent to admin.", 4000);
        // });


        /**             SOCKET IO          **/
        $scope.startSocket = function () {
            var socket = io.connect('http://api.knowlarity.com:8088/');
            socket.emit('feedapp', 'efe0081c-0b55-11e5-bead-22000aaca33c');
            socket.on('message', function (msg) {
                var msg = JSON.parse(msg.replace(/\'/g, '\"'));
                var message = "";
                if (msg.action === "phone") {
                    message = "New phone call from " + msg.caller_id + " " + msg.event + " to " + msg.destination + ".";
                }
                document.getElementById('xyz').play();
                $mdToast.show({
                    locals: {
                        message: message,
                        showProgress: true
                    },
                    controller: 'ToastCtrl',
                    templateUrl: 'toast-template.html',
                    hideDelay: 10000,
                    position: "bottom right"
                });
            });
        };

        function checkForUpdates() {
            var promise = window['isUpdateAvailable'];
            if (promise) {
                promise
                    .then(function (isAvailable) {
                        if (isAvailable) {
                            $mdToast.show($mdToast.simple()
                                .textContent('New Update available! Refresh the page to get the latest version. Current Version : ' + confData.version)
                                .action('Refresh')
                                .actionKey('Refresh Page')
                                .highlightAction(true)
                                .highlightClass('white-text')
                                .hideDelay(0)
                                .position('bottom right'))
                                .then(function (res) {
                                    if (res === 'ok') {
                                        window.location.reload();
                                    }
                                });
                        }
                    });
            }

        }

        function showSettings(ev) {
            $mdDialog.show({
                templateUrl: 'app/modules/base/dialogs/settings.dialog.controller.html',
                controller: 'settings.dialog.controller',
                targetEvent: ev,
                fullscreen: true
            })
        }

        function toggleSearchBar() {
            $scope.showSearch = !$scope.showSearch;
        }

        $scope.$watchCollection('notifications', function (newVal, oldVal) {
            $scope.unreadCount = $scope.notifications.filter(function (m) {
                return !m.viewed
            }).length;
        });


        $scope.navToLogin = navToLogin;
        $scope.generateLoginClass = generateLoginClass;
        $scope.getInt = getInt;
        $scope.setUser = setUser;
        $scope.clearUser = clearUser;
        $scope.toggleSearchBar = toggleSearchBar;

        VersionManager.setServerVersion(confData.version);
        // $scope.startSocket();

        $scope.checkForUpdates();
        $scope.generateLoginClass();
        $scope.setUser();
    }

})();

/**
 * Created by kumardivyarajat on 25/08/17.
 */
(function () {
    "use strict";

    MainConfig.$inject = ["$mdThemingProvider", "$mdToastProvider", "$mdGestureProvider", "$provide"];
    RollbarConfig.$inject = ["RollbarProvider"];
    textAngularConfig.$inject = ["$provide"];
    angular.module("app.main")
        .config(MainConfig)
        .config(RollbarConfig)
        .config(textAngularConfig);


    function RollbarConfig(RollbarProvider) {
        if (confData.env === 'prod') {
            RollbarProvider.init({
                accessToken: "5b4038fa1d1a4f4e9139184c9333014f",
                captureUncaught: true,
                payload: {
                    environment: confData.env
                }
            });
        }
    }


    function textAngularConfig($provide) {
        $provide.decorator('taToolFunctions', ["$delegate", function ($delegate) {
                // save original function to call it later
                var imgOnSelectActionFn = $delegate.imgOnSelectAction;

                // decorate imgOnSelectAction
                $delegate.imgOnSelectAction = function (event, $element, editorScope) {
                    // call original function in which img toolbar is constructed
                    imgOnSelectActionFn(event, $element, editorScope);

                    // set popover size to fit content
                    // btw, dunno why it is set to concrete size
                    editorScope.displayElements.popover.css('width', 'auto');

                    // https://github.com/fraywing/textAngular/blob/1372bc1d2187f959b6eb01bbf6dab1410a598e2a/src/textAngularSetup.js#L219-L221
                    var finishEdit = function () {
                        editorScope.updateTaBindtaTextElement();
                        editorScope.hidePopover();
                    };

                    var centerImage = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-center"></i></button>');
                    centerImage.on('click', function (event) {
                        event.preventDefault();
                        // use bootstrap helper class because no margin or display allowed
                        // https://github.com/fraywing/textAngular/blob/1372bc1d2187f959b6eb01bbf6dab1410a598e2a/src/textAngular-sanitize.js#L499-L501
                        $element.addClass('center-block');
                        finishEdit();
                    });

                    angular.element(editorScope.displayElements.popover[0].querySelector('.btn-group')).append(centerImage);
                };

                return $delegate;
            }]
        );
    }


    function MainConfig($mdThemingProvider, $mdToastProvider, $mdGestureProvider, $provide) {
        $provide.decorator('taOptions', ['taRegisterTool', '$delegate', '$mdDialog', 'Base', function (taRegisterTool, taOptions, $mdDialog, Base) {
            // $delegate is the taOptions we are decorating
            // register the tool with textAngular

            taRegisterTool('image', {
                display: '<md-button class="md-icon-button" aria-label="Insert photo"><md-icon >insert_photo</md-icon><md-tooltip>Insert Image</md-tooltip></md-button>',
                iconclass: "fa fa-picture-o",
                activeState: function(commonElement){
                    /* istanbul ignore next: */
                    if (commonElement && commonElement.nodeName === '#document') return false;
                    var result = false;
                    if (commonElement) {
                        // commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
                        // so we do try catch here...
                        try {
                            result =
                                commonElement.css('text-align') === 'left' ||
                                commonElement.attr('align') === 'left' ||
                                (
                                    commonElement.css('text-align') !== 'right' &&
                                    commonElement.css('text-align') !== 'center' &&
                                    commonElement.css('text-align') !== 'justify' && !this.$editor().queryCommandState('justifyRight') && !this.$editor().queryCommandState('justifyCenter')
                                ) && !this.$editor().queryCommandState('justifyFull');
                        } catch(e) {
                            /* istanbul ignore next: error handler */
                            //console.log(e);
                            result = false;
                        }
                    }
                    result = result || this.$editor().queryCommandState('justifyLeft');
                    return result;
                },
                action: function (deferred, restoreSelection) {

                    var textAngular = this;
                    var item = {
                        url: ''
                    };

                    $mdDialog.show({
                        locals: {
                            multipleSelect: true,
                            select: '',
                            options : null
                        },
                        multiple : true,
                        fullscreen : true,
                        controller: "upload.controller",
                        templateUrl: 'app/modules/base/partials/uploader.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true
                    })
                        .then(function (images) {
                            console.log('images', images, textAngular.$editor());
                            if (!Array.isArray(images)) {
                                images = [images];
                            }
                            if (images) {
                                var imagesHtml = '';
                                images.forEach(function (image) {
                                    var embedObject = {
                                        urls : image.urls,
                                        swatch : image.swatch,
                                        filename : image.filename,
                                        formattedFileType : image.formattedFileType,
                                        extention : image.extension,
                                        size : image.size
                                    };
                                    // TODO : Make this work
                                    // console.log("main.config.js", "embedObject", image,embedObject);
                                    // imagesHtml += '<md-img alt="'+ image.filename +'"' +
                                    //     'class="editor-image"' +
                                    //     'md-src="'+ JSON.stringify(embedObject)+'"' +
                                    //     '></md-img>'
                                    imagesHtml += '<img src="' + Base.getMediaUrl() + image.urls.large + '" alt="' + image.filename + '" width="50%" class="fade-image md-lazy-load"/>';
                                })
                                textAngular.$editor().wrapSelection('insertHTML', imagesHtml);
                            }
                            restoreSelection();
                            deferred.resolve();
                        }, function () {

                        });
                    return false;
                }
            });
            taOptions.forceTextAngularSanitize = true;
            taOptions.keyMappings = [];
            taOptions.toolbar = [
                ['h1', 'h2', 'h3','h4', 'h5', 'h6', 'p', 'pre', 'quote'],
                ['bold', 'italics', 'underline', 'ul', 'ol', 'redo', 'undo', 'clear'],
                ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                ['html', 'insertLink', 'insertImage', 'insertVideo']
            ];
            taOptions.classes = {
                focussed: '',
                toolbar: 'ta-toolbar layout-row layout-align-start-center md-subheader',
                toolbarGroup: 'ta-button-group',
                toolbarButton: '',
                toolbarButtonActive: 'active',
                disabled: 'disabled',
                textEditor: 'ta-text-editor',
                htmlEditor: 'md-input'
            };
            // add the button to the default toolbar definition
            taOptions.toolbar[3].push('image');
            return taOptions;
        }]);

        $provide.decorator('taTools', ['$delegate', function (taTools) {
            console.log('taTplls', taTools);
            taTools.h1.display = '<md-button aria-label="Heading 1">H1<md-tooltip>Heading 1</md-tooltip></md-button>';
            taTools.h2.display = '<md-button aria-label="Heading 2">H2<md-tooltip>Heading 2</md-tooltip></md-button>';
            taTools.h3.display = '<md-button aria-label="Heading 3">H3<md-tooltip>Heading 3</md-tooltip></md-button>';
            taTools.h4.display = '<md-button aria-label="Heading 4">H4<md-tooltip>Heading 4</md-tooltip></md-button>';
            taTools.h5.display = '<md-button aria-label="Heading 5">H5<md-tooltip>Heading 5</md-tooltip></md-button>';
            taTools.h6.display = '<md-button aria-label="Heading 6">H6<md-tooltip>Heading 6</md-tooltip></md-button>';
            taTools.p.display = '<md-button aria-label="Paragraph">P<md-tooltip>Paragraph</md-tooltip></md-button>';
            taTools.pre.display = '<md-button aria-label="Pre">pre<md-tooltip>Pre-formatted</md-tooltip></md-button>';
            taTools.quote.display = '<md-button class="md-icon-button" aria-label="Quote"><md-icon >format_quote</md-icon><md-tooltip>Quote</md-tooltip></md-button>';
            taTools.bold.display = '<md-button class="md-icon-button" aria-label="Bold"><md-icon >format_bold</md-icon><md-tooltip>Bold</md-tooltip></md-button>';
            taTools.italics.display = '<md-button class="md-icon-button" aria-label="Italic"><md-icon >format_italic</md-icon><md-tooltip>Italic</md-tooltip></md-button>';
            taTools.underline.display = '<md-button class="md-icon-button" aria-label="Underline"><md-icon >format_underlined</md-icon><md-tooltip>Underline</md-tooltip></md-button>';
            taTools.ul.display = '<md-button class="md-icon-button" aria-label="Buletted list"><md-icon >format_list_bulleted</md-icon><md-tooltip>Bullet List</md-tooltip></md-button>';
            taTools.ol.display = '<md-button class="md-icon-button" aria-label="Numbered list"><md-icon >format_list_numbered</md-icon><md-tooltip>Numbered List</md-tooltip></md-button>';
            taTools.undo.display = '<md-button class="md-icon-button" aria-label="Undo"><md-icon >undo</md-icon><md-tooltip>Undo</md-tooltip></md-button>';
            taTools.redo.display = '<md-button class="md-icon-button" aria-label="Redo"><md-icon >redo</md-icon><md-tooltip>Redo</md-tooltip></md-button>';
            taTools.justifyLeft.display = '<md-button class="md-icon-button" aria-label="Align left"><md-icon >format_align_left</md-icon><md-tooltip>Align Left</md-tooltip></md-button>';
            taTools.justifyRight.display = '<md-button class="md-icon-button" aria-label="Align right"><md-icon >format_align_right</md-icon><md-tooltip>Align Right</md-tooltip></md-button>';
            taTools.justifyCenter.display = '<md-button class="md-icon-button" aria-label="Align center"><md-icon >format_align_center</md-icon><md-tooltip>Align Center</md-tooltip></md-button>';
            taTools.justifyFull.display = '<md-button class="md-icon-button" aria-label="Justify"><md-icon >format_align_justify</md-icon><md-tooltip>Justify</md-tooltip></md-button>';
            taTools.clear.display = '<md-button class="md-icon-button" aria-label="Clear formatting"><md-icon >format_clear</md-icon><md-tooltip>Clear</md-tooltip></md-button>';
            taTools.html.display = '<md-button class="md-icon-button" aria-label="Show HTML"><md-icon >code</md-icon><md-tooltip>Show HTML</md-tooltip></md-button>';
            taTools.insertLink.display = '<md-button class="md-icon-button" aria-label="Insert link"><md-icon >insert_link</md-icon><md-tooltip>Insert Link</md-tooltip></md-button>';
            taTools.insertImage.display = '<md-button class="md-icon-button" aria-label="Insert photo"><md-icon >add_photo_alternate</md-icon><md-tooltip>Embed Image</md-tooltip></md-button>';
            taTools.insertVideo.display = '<md-button class="md-icon-button" aria-label="Insert photo"><md-icon >video_library</md-icon><md-tooltip>Insert Video</md-tooltip></md-button>';
            return taTools;
        }]);
        $mdGestureProvider.skipClickHijack();
        $mdThemingProvider.definePalette('aadira-accent', {
            '50': 'ffffff',
            '100': 'b6b6b6',
            '200': '858585',
            '300': '545454',
            '400': '303030',
            '500': '0b0b0b',
            '600': '0a0a0a',
            '700': '080808',
            '800': '060606',
            '900': '030303',
            'A100': 'a6a6a6',
            'A200': '8c8c8c',
            'A400': '737373',
            'A700': '666666',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                'A100',
                'A200'
            ],
            'contrastLightColors': [
                '300',
                '400',
                '500',
                '600',
                '700',
                '800',
                '900',
                'A400',
                'A700'
            ]
        });
        $mdThemingProvider.definePalette('aadira-blue', {
            '50': 'ebefff',
            '100': 'ced6ff',
            '200': 'aebbff',
            '300': '8da0ff',
            '400': '748bff',
            '500': '5c77ff',
            '600': '546fff',
            '700': '4a64ff',
            '800': '415aff',
            '900': '3047ff',
            'A100': 'ffffff',
            'A200': 'ffffff',
            'A400': 'dbdfff',
            'A700': 'c2c8ff',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                '300',
                '400',
                'A100',
                'A200',
                'A400',
                'A700'
            ],
            'contrastLightColors': [
                '500',
                '600',
                '700',
                '800',
                '900'
            ]
        });


        $mdThemingProvider.theme('boring')
            .primaryPalette('aadira-blue', {
                'default': '600', // by default use shade 400 from the pink palette for primary intentions
                'hue-1': '100', // use shade 100 for the <code>md-hue-1</code> class
                'hue-2': '400', // use shade 600 for the <code>md-hue-2</code> class
                'hue-3': 'A100', // use shade A100 for the <code>md-hue-3</code> class,
            })
            .accentPalette('aadira-accent', {
                'default': '500',
                'hue-1': '50', // use shade 200 for default, and keep all other shades the same
                'hue-2': '900'
            });

        $mdThemingProvider.theme('dark-blue').backgroundPalette('blue').dark();
        $mdThemingProvider.theme('dark-grey').backgroundPalette('grey').dark();
        $mdThemingProvider.theme('dark-orange').backgroundPalette('orange').dark();
        $mdThemingProvider.theme('dark-purple').backgroundPalette('deep-purple').dark();
        $mdThemingProvider.theme('dark-red').backgroundPalette('red').dark();

        $mdThemingProvider.setDefaultTheme('boring');
        $mdThemingProvider.enableBrowserColor({
            theme: 'boring', // Default is 'default'
            palette: 'blue', // Default is 'primary', any basic material palette and extended palettes are available
        });

        $mdToastProvider.addPreset('aadiraToast', {
            options: function () {
                return {
                    template: '<md-toast>' +
                        '<div class="md-toast-content">' +
                        'This is a custom preset' +
                        '</div>' +
                        '</md-toast>',
                    controllerAs: 'toast',
                    bindToController: true
                };
            }
        });

        $mdThemingProvider.alwaysWatchTheme(false);

    }
})
();

(function() {
    'use strict';

    runBlock.$inject = ["AuthManager", "$location", "$analytics"];
    angular
        .module('app')
        .run(runBlock);

    /** @ngInject */
    function runBlock(AuthManager, $location, $analytics) {

        var user = AuthManager.getCurrentUser();
        if (!user || typeof user._id === "undefined") {
            $location.path("/login");
        } else {
            $analytics.setAlias(user._id);
            $analytics.setUsername(user.email);
            $analytics.setUserProperties({
                name: user.name,
                email: user.email,
                role: user.role,
                mobile: user.mobile,
                id: user._id,
                _id: user._id
            });
        }
    }

})();

(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];
    angular
        .module('app')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        $stateProvider
            .state("app", {
                url: '',
                abstract: true,
                templateUrl: 'app/main/main.html'
            })
            .state("login", {
                url: '/login?returnTo',
                templateUrl: 'app/modules/login/partials/login-base.html'
            })
            .state("app.home", {
                url: '/home',
                templateUrl: "app/modules/home/partials/home.html",
                resolve: {
                    roles: ["RestManager", function (RestManager) {
                        return RestManager.getResource("/settings/constants/USER_ROLES", "settings");
                    }]
                },
                data: {
                    label: 'Home', //label to show in breadcrumbs
                },
            })
            .state("app.users", {
                url: '/users',
                abstract: true,
                controller: "users.controller",
                templateUrl: 'app/modules/users/partials/home.html',
                data: {
                    label: 'Users Base', //label to show in breadcrumbs
                }
            })
            .state("app.users.addresses", {
                url: '/address',
                controller: "address.controller",
                templateUrl: 'app/modules/users/addresses/address.tmpl.html',
                data: {
                    label: 'All Users', //label to show in breadcrumbs
                }
            })
            .state("app.users.influencers", {
                url: '/influencers',
                controller: "influencers.controller",
                templateUrl: 'app/modules/users/influencers/partials/influencer.html',
                data: {
                    label: 'All Users',
                }
            })
            .state("app.users.all", {
                url: '/all?organisation&roles&page&order&limit&q&validMobile&tags',
                controller: "users.all.controller",
                templateUrl: 'app/modules/users/allUsers/partials/all.html',
                data: {
                    label: 'All Users', //label to show in breadcrumbs
                }
            })
            .state("app.users.organisations", {
                url: '/organisations',
                controller: "users.org.controller",
                templateUrl: 'app/modules/users/organisations/partials/index.html',
                data: {
                    label: 'All Organisations', //label to show in breadcrumbs
                }
            })
            .state("app.users.details", {
                url: '/details',
                abstract: true,
                controller: "users.details.controller",
                templateUrl: 'app/modules/users/details/partials/index.html',
                data: {
                    label: 'Users Details', //label to show in breadcrumbs
                },
                params: {
                    userId: null
                },
                resolve: {
                    user: ["RestManager", "$stateParams", "$q", function (RestManager, $stateParams, $q) {
                        if ($stateParams.userId) {
                            return $q(function (resolve, reject) {
                                RestManager.getResource("/users/admin/single/" + $stateParams.userId, "users")
                                    .then(function (users) {
                                        resolve(users[0])
                                    })
                                    .catch(function (err) {
                                        reject(err);
                                    })
                            })
                        } else {
                            $q.reject(err);
                        }
                    }]
                }
            })
            .state('app.users.details.home', {
                url: '/:userId/home',
                controller: 'user.details.home.controller as userHomeCtrl',
                templateUrl: 'app/modules/users/details/partials/nested/home.html'
            })
            .state('app.users.details.job', {
                url: '/:userId/job',
                controller: 'user.details.job.controller as userJobCtrl',
                templateUrl: 'app/modules/users/details/partials/nested/job.html'
            })
            .state('app.users.details.cart', {
                url: '/:userId/cart',
                controller: 'user.details.cart.controller as userCartCtrl',
                templateUrl: 'app/modules/users/details/partials/nested/cart.html'
            })
            .state('app.users.details.offers', {
                url: '/:userId/offers',
                controller: 'user.details.offers.controller',
                templateUrl: 'app/modules/users/details/partials/nested/offers.html'
            })
            .state('app.users.details.transactions', {
                url: '/:userId/transactions',
                controller: 'user.details.transactions.controller as userTxnCtrl',
                templateUrl: 'app/modules/users/details/partials/nested/transactions.html'
            })
            .state('app.users.details.orders', {
                url: '/:userId/orders',
                controller: 'user.details.orders.controller as userOrderCtrl',
                templateUrl: 'app/modules/users/details/partials/nested/orders.html'
            })

            .state("app.users.add", {
                url: '/add',
                controller: "users.add.controller",
                templateUrl: 'app/modules/users/addUser/partials/add.html',
                data: {
                    label: 'Add User', //label to show in breadcrumbs
                }
            })
            .state("app.media", {
                url: '/media',
                controller: "media.controller",
                templateUrl: 'app/modules/media/partials/media.html',
                data: {
                    label: 'Gallery', //label to show in breadcrumbs
                }
            })
            .state("app.query", {
                url: '/query',
                controller: "query.controller",
                templateUrl: 'app/modules/query/partials/index.html',
                data: {
                    label: 'Query', //label to show in breadcrumbs
                }
            })
            .state("app.pages", {
                url: '/pages',
                abstract: true,
                controller: "pages.controller",
                templateUrl: 'app/modules/pages/index.html',
                data: {
                    label: 'Static Pages Base', //label to show in breadcrumbs
                }
            })
            .state("app.pages.all", {
                url: '/all?page?limit?sort?search',
                controller: "pages.all.controller",
                templateUrl: 'app/modules/pages/all/partials/index.html',
                data: {
                    label: 'All Static Pages', //label to show in breadcrumbs
                }
            })
            .state("app.pages.add", {
                url: '/new',
                controller: "pages.add.controller",
                templateUrl: 'app/modules/pages/add/partials/index.html',
                data: {
                    label: 'Add Static Page', //label to show in breadcrumbs
                }
            })
            .state("app.pages.edit", {
                url: '/edit?slug&id',
                controller: "pages.add.controller",
                templateUrl: 'app/modules/pages/add/partials/index.html',
                data: {
                    label: 'Edit Static Page', //label to show in breadcrumbs
                }
            })
            .state("app.products", {
                url: '/products',
                abstract: true,
                controller: "products.controller",
                templateUrl: 'app/modules/products/partials/home.html'
            })
            .state("app.products.all", {
                url: '/all?page&limit&order&searchTerm',
                controller: "products.all.controller as allCtrl",
                templateUrl: 'app/modules/products/allProducts/partials/all.html',
                params: {
                    productIds: null,
                    query: null
                }
            })
            .state("app.products.add", {
                url: '/add/',
                abstract: true,
                controller: "products.add.controller",
                params: {
                    slug: undefined,
                    name: undefined,
                    newProduct: undefined,
                    openNotes: false
                },
                templateUrl: 'app/modules/products/addProducts/partials/add.html',
                resolve: {
                    product: ["RestManager", "$stateParams", "$q", "$timeout", function (RestManager, $stateParams, $q, $timeout) {
                        if ($stateParams.slug && !$stateParams.newProduct) {
                            return RestManager.getResource("/products/admin/" + $stateParams.slug, "products");
                        } else {
                            return $q(function (resolve, reject) {
                                $timeout(function () {
                                    resolve(undefined);
                                }, 100);
                            })
                        }
                    }]
                }
            })
            .state("app.products.add.home", {
                url: ':slug/general_information',
                templateUrl: 'app/modules/products/addProducts/partials/tabs/general-information.html',
                params: {
                    name: undefined,
                    newProduct: undefined,
                    openNotes: false
                }
            })
            .state("app.products.add.categories", {
                url: ':slug/categories',
                templateUrl: 'app/modules/products/addProducts/partials/tabs/categories.html',
                params: {
                    name: undefined,
                    newProduct: undefined,
                    slug: undefined
                }
            })
            .state("app.products.add.images", {
                url: ':slug/images',
                templateUrl: 'app/modules/products/addProducts/partials/tabs/images.html',
                params: {
                    name: undefined,
                    newProduct: undefined,
                    slug: undefined
                }
            })
            .state("app.products.add.attributes", {
                url: ':slug/attributes',
                templateUrl: 'app/modules/products/addProducts/partials/tabs/attributes.html',
                params: {
                    name: undefined,
                    newProduct: undefined,
                    slug: undefined
                }
            })
            .state("app.products.add.variations", {
                url: ':slug/variations',
                templateUrl: 'app/modules/products/addProducts/partials/tabs/variations.html',
                params: {
                    name: undefined,
                    newProduct: undefined,
                    slug: undefined
                }
            })
            .state("app.products.add.customisation", {
                url: ':slug/customisation',
                templateUrl: 'app/modules/products/addProducts/partials/tabs/customisation.html',
                params: {
                    name: undefined,
                    newProduct: undefined,
                    slug: undefined
                }
            })
            .state("app.products.add.packaging", {
                url: ':slug/packaging',
                templateUrl: 'app/modules/products/addProducts/partials/tabs/packaging.html',
                params: {
                    name: undefined,
                    newProduct: undefined,
                    slug: undefined
                }
            })
            .state("app.products.add.finish", {
                url: ':slug/finish',
                templateUrl: 'app/modules/products/addProducts/partials/tabs/finish.html',
                params: {
                    name: undefined,
                    newProduct: undefined,
                    slug: undefined
                }
            })
            .state("app.products.categories", {
                url: '/categories',
                controller: "products.categories.controller",
                templateUrl: 'app/modules/products/categories/partials/categories.html'
            })
            .state("app.products.import", {
                url: '/import',
                controller: "products.import.controller",
                templateUrl: 'app/modules/products/import/partials/index.html'
            })
            .state("app.products.tags", {
                url: '/tags',
                controller: "products.tags.controller",
                templateUrl: 'app/modules/products/tags/partials/tags.html'
            })
            .state("app.products.attributes", {
                url: '/attributes',
                controller: "products.attributes.controller",
                templateUrl: 'app/modules/products/attributes/partials/attributes.html'
            })
            .state("app.products.sizeCharts", {
                url: '/size_charts',
                controller: "products.sizeCharts.controller",
                templateUrl: 'app/modules/products/size_charts/partials/size_charts.html'
            })
            .state("app.products.models", {
                url: '/modals',
                controller: "products.modals.controller",
                templateUrl: 'app/modules/products/models/partials/index.html'
            })
            .state("app.products.trash", {
                url: '/trash?page&limit&order&searchTerm',
                controller: "products.trash.controller",
                templateUrl: 'app/modules/products/trash/partials/trash.html'
            })
            .state("app.customisation", {
                url: '/customisation',
                abstract: true,
                controller: "customisation.home.controller",
                templateUrl: 'app/modules/customisation/partials/index.html'
            })
            .state("app.customisation.templates", {
                url: '/templates',
                controller: "customisation.templates.controller",
                templateUrl: 'app/modules/customisation/templates/partials/index.html'
            })
            .state("app.customisation.options", {
                url: '/options',
                controller: "customisation.options.controller",
                templateUrl: 'app/modules/customisation/options/partials/options.html'
            })
            .state("app.offers", {
                url: '/offers',
                abstract: true,
                controller: "offers.home.controller",
                templateUrl: 'app/modules/offers/partials/offers.html'
            })
            .state("app.offers.coupons", {
                url: '/coupons',
                controller: "offers.coupons.controller",
                templateUrl: 'app/modules/offers/coupons/partials/coupons.html'
            })
            .state("app.offers.discount", {
                url: '/discount',
                controller: "offers.discount.controller",
                templateUrl: 'app/modules/offers/discount/partials/discount.html'
            })
            .state("app.offers.giftCards", {
                url: '/giftCards',
                abstract: true,
                controller: "offers.giftCardsController",
                templateUrl: 'app/modules/offers/giftCards/index.html'
            })
            .state("app.offers.giftCards.home", {
                url: '/home',
                controller: "offers.giftCardsHome.controller",
                templateUrl: 'app/modules/offers/giftCards/home/giftCards.home.html'
            })
            .state("app.offers.giftCards.add", {
                url: '/add',
                controller: "offers.giftCardsAdd.controller",
                templateUrl: 'app/modules/offers/giftCards/add/giftCards.add.html'
            })
            .state("app.offers.giftCards.all", {
                url: '/all?page&limit&sort&q&status&onlyFraud',
                controller: "offers.giftCardsAll.controller",
                templateUrl: 'app/modules/offers/giftCards/all/giftCards.all.html'
            })
            .state("app.offers.giftCards.details", {
                url: '/details/:cardId?backState&backParams&openNotes',
                controller: "offers.giftCardsDetails.controller",
                templateUrl: 'app/modules/offers/giftCards/details/giftCards.details.html',
            })
            .state("app.pos", {
                url: '/pos',
                abstract: true,
                controller: "pos.controller",
                templateUrl: 'app/modules/pos/index.html'
            })
            .state("app.pos.home", {
                url: '/home',
                controller: "pos.home.controller",
                templateUrl: 'app/modules/pos/home/index.html'
            })
            .state("app.pos.add", {
                url: '/add',
                controller: "pos.add.controller",
                templateUrl: 'app/modules/pos/add/index.html'
            })
            .state("app.pos.cart", {
                url: '/cart?userId',
                controller: "pos.cart.controller",
                templateUrl: 'app/modules/pos/cart/pos.cart.tmpl.html'
            })
            .state("app.pos.backDate", {
                url: '/add/backDateOrder?backDateOrder',
                controller: "pos.add.controller",
                templateUrl: 'app/modules/pos/add/index.html'
            })
            .state("app.pos.edit", {
                url: '/edit/:orderNumber',
                controller: 'pos.add.controller',
                templateUrl: 'app/modules/pos/add/index.html'
            })
            .state("app.orders", {
                url: '/orders',
                abstract: true,
                controller: "orders.controller",
                templateUrl: 'app/modules/orders/partials/home.html',
                data: {
                    label: 'Orders Base', //label to show in breadcrumbs
                }
            })
            .state("app.orders.details", {
                url: '/details/:orderId?backState&backParams',
                controller: "orders.details.controller",
                templateUrl: 'app/modules/orders/orderDetails/partials/index.html',
                data: {
                    label: 'Order Details', //label to show in breadcrumbs
                },
                params: {
                    openNotes: false
                }
            })
            .state("app.orders.all", {
                url: '/all?page&limit&orderBy&q&filter&currentStatus&orgs&warehouses&&designers&users&startDate&endDate&channels&creator&rangeModel',
                controller: "orders.all.controller",
                templateUrl: 'app/modules/orders/allOrders/partials/all.html',
                data: {
                    label: 'All Orders', //label to show in breadcrumbs
                }
            })
            .state("app.orders.planning", {
                url: '/planning?page&limit&orderBy&q&filter&currentStatus&orgs&warehouses&&designers&users&startDate&endDate&channels&creator&rangeModel',
                controller: "orders.planning.controller",
                templateUrl: 'app/modules/orders/planning/planning.tmpl.html',
                data: {
                    label: 'All Orders', //label to show in breadcrumbs
                }
            })
            .state("app.orders.add", {
                url: '/add',
                controller: "orders.add.controller",
                templateUrl: 'app/modules/orders/addOrders/partials/add.html'
            })
            .state("app.quotations", {
                url: '/quotations?page&limit&sort&search&id',
                controller: "quotations.controller",
                templateUrl: 'app/modules/quotations/quotations.all.html',
                data: {
                    label: 'Orders Base', //label to show in breadcrumbs
                }
            })
            .state("app.redux", {
                url: '/redux',
                controller: "redux.controller",
                templateUrl: 'app/modules/redux/partials/redux.html'
            })
            .state("app.cartAll", {
                url: '/cart',
                controller: "carts.all.controller",
                templateUrl: 'app/modules/cart/partials/all.html'
            })

            .state("app.collections", {
                url: '/collections',
                controller: "group.controller",
                templateUrl: 'app/modules/collections/partials/index.html'
            })
            .state("app.campaigns", {
                url: '/campaign',
                controller: "campaign.controller",
                templateUrl: 'app/modules/campaign/partials/index.html'
            })
            .state("app.warehouse", {
                url: '/warehouse',
                controller: "warehouse.controller",
                templateUrl: 'app/modules/warehouses/warehouse.tmpl.html'
            })
            .state("app.photoShoot", {
                url: '/shoot',
                controller: "shoot.controller as stCtrl",
                templateUrl: 'app/modules/photoShoot/partials/index.html'
            })
            .state("app.photoShootView", {
                url: '/shoot/laidView/:id',
                controller: "shoot.laid.controller as ltCtrl",
                templateUrl: 'app/modules/photoShoot/partials/laidBackView.html'
            })
            .state("app.photoShootDetails", {
                url: '/shoot/details/:id',
                controller: "shoot.details.controller as dtCtrl",
                templateUrl: 'app/modules/photoShoot/partials/details.html'
            })
            .state("app.design", {
                url: '/designs',
                abstract: true,
                templateUrl: 'app/modules/scm/designs/partials/design-home.tmpl.html',
                data: {
                    label: 'Users Base', //label to show in breadcrumbs
                }
                // controller: "designs.controller",
                // templateUrl: 'app/modules/scm/designs/partials/designs.tmpl.html'
            })
            .state("app.design.all", {
                url: '/all',
                controller: 'designs.controller',
                templateUrl: 'app/modules/scm/designs/partials/designs.all.tmpl.html'
            })
            .state("app.design.add", {
                url: '/add',
                controller: 'addDesignController.controller',
                templateUrl: 'app/modules/scm/designs/partials/addDesign.tmpl.html'
            })
            .state("app.design.edit", {
                url: '/edit/:id',
                controller: 'addDesignController.controller',
                templateUrl: 'app/modules/scm/designs/partials/addDesign.tmpl.html'
            })
            .state("app.design.details", {
                url: '/details/:id',
                controller: 'designDetails.controller',
                templateUrl: 'app/modules/scm/designs/designDetails/designDetails.tmpl.html'
            })
            .state("app.schedule", {
                url: '/schedule',
                controller: 'scheduleController.controller',
                templateUrl: 'app/modules/scm/schedule/partials/scheduleTask.tmpl.html'
            })
            .state("app.reports", {
                url: '/reports',
                controller: "reports.controller",
                templateUrl: 'app/modules/reports/reports.tmpl.html'
            })
            .state("app.materials", {
                url: '/materials',
                abstract: true,
                templateUrl: 'app/modules/scm/materials/partials/materialsHome.tmpl.html',
                data: {
                    label: 'Users Base', //label to show in breadcrumbs
                }
            })
            .state("app.materials.all", {
                url: '/all',
                controller: "materials.controller",
                templateUrl: 'app/modules/scm/materials/partials/materials.tmpl.html'
            })
            .state("app.materials.details", {
                url: '/details/:materialId?backState&backParams',
                controller: 'materialDetails.controller',
                templateUrl: 'app/modules/scm/materials/details/partials/materialDetails.tmpl.html'
            })
            .state("app.materials.categories", {
                url: '/categories',
                controller: "materialsCategories.controller",
                templateUrl: 'app/modules/scm/materials/categories/partials/materialsCategories.tmpl.html'
            })
            .state("app.materials.vendors", {
                url: '/vendors',
                controller: "materialsVendors.controller",
                templateUrl: 'app/modules/scm/materials/vendors/partials/vendors.tmpl.html'
            })
            .state("app.purchase", {
                url: '/purchase',
                controller: "purchase.controller",
                templateUrl: "app/modules/scm/purchase/partials/purchase.tmpl.html"
            })
            .state("app.diagnostics", {
                url: '/diagnostics',
                controller: "diagnostics.controller as diagCtrl",
                templateUrl: 'app/modules/diagnostics/diagnostics.tmpl.html'
            })
            .state("app.homepageBuilder", {
                url: '/home-builder',
                controller: "home-builder.controller",
                templateUrl: 'app/modules/homepage-builder/homepage-builder.html'
            })
            .state("app.posts", {
                url: '/posts?page&limit&sort&user&products',
                controller: "posts.controller",
                templateUrl: 'app/modules/posts/posts.tmpl.html'
            })
            .state('app.tasks', {
                url: '/tasks',
                abstract: true,
                templateUrl: 'app/modules/workforce/tasks/partials/tasks-home.html'
            })
            .state('app.tasks.all', {
                url: '/all',
                controller: 'all-tasks.controller',
                templateUrl: 'app/modules/workforce/tasks/partials/all-tasks.html'
            })
            .state('app.tasks.details', {
                url: '/details/:id',
                controller: 'taskDetails.controller',
                templateUrl: 'app/modules/workforce/tasks/task-details/task-details.html'
            });
        $urlRouterProvider.otherwise("/home");
        $locationProvider.html5Mode(true);
    }
})();

/* global malarkey:false, toastr:false, moment:false */
(function() {
    'use strict';

    angular
        .module('app');
})();

(function () {
    'use strict';

    config.$inject = ["$logProvider", "$httpProvider"];
    optionsConfig.$inject = ["$compileProvider", "$analyticsProvider", "$sceProvider", "$mdAriaProvider"];
    DateProvider.$inject = ["$mdDateLocaleProvider"];
    angular
        .module('app')
        .config(config)
        .config(optionsConfig)
        .config(DateProvider);

    /** @ngInject */
    function config($logProvider, $httpProvider) {
        // Enable log
        $logProvider.debugEnabled(true);
        $httpProvider.interceptors.push("sessionRecoverer");
    }

    function DateProvider($mdDateLocaleProvider) {
        $mdDateLocaleProvider.formatDate = function (date) {
            if(date) {
                return moment(date).format('DD-MMM-YYYY');
            } else {
                return "Enter Date";
            }
        };
    }

    /** @ngInject */
    function optionsConfig($compileProvider, $analyticsProvider, $sceProvider, $mdAriaProvider) {
        var debugInfo = true;
        var developerMode = true;

        if (confData.env === "prod") {
            debugInfo = false;
            developerMode = false;
        }
        $analyticsProvider.firstPageview(false);
        /* Records pages that don't use $state or $route */
        $analyticsProvider.withBase(false);
        // $analyticsProvider.virtualPageviews(false);
        /* Records full path */
        $analyticsProvider.trackExceptions(true);
        $sceProvider.enabled(false);
        $compileProvider.debugInfoEnabled(debugInfo);
        $analyticsProvider.developerMode(developerMode);
        $mdAriaProvider.disableWarnings();
    }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/appUpdateDialog.tmpl.html","<md-dialog flex=\"70\"><md-dialog-content layout=\"column\" layout-align=\"center center\" class=\"md-padding md-margin\"><img src=\"assets/images/update.svg\" style=\"max-width: 200px\"><h3 class=\"center-text md-margin\" style=\"padding: 32px 0\">App Updated to Version {{release.version}}</h3><pre class=\"md-body-1 md-padding\" style=\"white-space: pre-wrap; background: #efefef\" ng-bind-html=\"releaseNotes\"></pre></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"center center\"><md-button class=\"md-raised md-primary\" ng-click=\"close()\">Got It!</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/main.html","<div layout=\"row\" flex=\"\" ng-cloak=\"\" class=\"body\"><md-sidenav md-component-id=\"left\" id=\"vertical-navigation\" class=\"md-sidenav-left\"><md-toolbar class=\"logo-container md-primary\" ng-cloak=\"\"><div layout=\"\" layout-align=\"center center\" class=\"md-padding\"><img src=\"assets/images/aarida-optimized.png\"></div></md-toolbar><md-content flex=\"\" class=\"sidemenu-container\" ng-cloak=\"\"><md-sidemenu ng-if=\"!loadingMenu\"><div ng-repeat=\"menuItem in menuItems\" data-category-name=\"{{menuItem.name}}\" class=\"product-group-container\"><md-sidemenu-button ng-if=\"!menuItem.group && !menuItem.children\" ng-click=\"closeSidebar()\" ui-sref=\"{{menuItem.sref}}\" ui-sref-active=\"active\"><md-icon class=\"material-icons--two-tone\">{{menuItem.icon}}</md-icon>{{ menuItem.name}}</md-sidemenu-button><md-sidemenu-content md-icon=\"{{menuItem.icon}}\" md-heading=\"{{menuItem.name}}\" ng-if=\"menuItem.children && !menuItem.group\" md-arrow=\"true\"><md-sidemenu-button ng-repeat=\"childMenu in menuItem.children\" ng-click=\"closeSidebar()\" ui-sref=\"{{childMenu.sref}}\" ui-sref-active=\"active\"><md-icon class=\"material-icons--two-tone\">{{childMenu.icon}}</md-icon>{{ childMenu.name}}</md-sidemenu-button></md-sidemenu-content><md-sidemenu-group ng-if=\"menuItem.group\"><md-divider></md-divider><md-subheader class=\"md-no-sticky\">{{menuItem.group}}</md-subheader><div ng-repeat=\"childMenu in menuItem.children\" class=\"child product-group-container\"><md-sidemenu-button ng-if=\"!childMenu.group && !childMenu.children\" ng-click=\"closeSidebar()\" ui-sref=\"{{childMenu.sref}}\" ui-sref-active=\"active\"><md-icon class=\"material-icons--two-tone\">{{childMenu.icon}}</md-icon>{{ childMenu.name}}</md-sidemenu-button><md-sidemenu-content md-icon=\"{{childMenu.icon}}\" md-heading=\"{{childMenu.name}}\" ng-if=\"childMenu.children\" md-arrow=\"true\"><md-sidemenu-button ng-repeat=\"grandChildMenu in childMenu.children\" ng-click=\"closeSidebar()\" ui-sref=\"{{grandChildMenu.sref}}\" ui-sref-active=\"active\"><md-icon class=\"material-icons--two-tone\">{{grandChildMenu.icon}}</md-icon>{{ grandChildMenu.name}}</md-sidemenu-button></md-sidemenu-content></div></md-sidemenu-group></div></md-sidemenu><div class=\"skeleton-loader\" ng-if=\"loadingMenu\"><div class=\"loader-container\"><div class=\"post\"><div class=\"avatar\"></div><div class=\"line\"></div><div class=\"line\"></div></div><div class=\"post\"><div class=\"avatar\"></div><div class=\"line\"></div><div class=\"line\"></div></div><div class=\"post\"><div class=\"avatar\"></div><div class=\"line\"></div><div class=\"line\"></div></div></div></div></md-content></md-sidenav><div layout=\"column\" flex=\"\"><md-toolbar md-colors=\"{\'background\' : \'accent-500-0\'}\" md-whiteframe=\"1\" class=\"main-toolbar\"><div class=\"md-toolbar-tools\" ng-if=\"!showSearch\"><md-button ng-click=\"open();\" class=\"md-icon-button\" aria-label=\"open sidebar\"><md-icon class=\"black-text\">menu</md-icon></md-button><a class=\"md-title bold-text black-text\" ui-sref=\"app.home\">DASHBOARD</a> <span flex=\"\"><app-search role-spec=\"currentUser.roleSpec\" open-search=\"openSearch\" ng-if=\"media(\'gt-xs\')\"></app-search></span><md-select ng-change=\"updateView()\" ng-model=\"currentUser.roleSpec\" class=\"md-accent md-hue-1\" ng-if=\"(currentUser.role === \'admin\' || currentUser.roleSpec <= 1) && !isSmall\"><md-option ng-value=\"getInt(key)\" ng-repeat=\"(key,val) in roleKeys\"><span class=\"md-tiny bold-text\" md-colors=\"{\'color\' : \'accent-500-1\'}\" style=\"text-transform: uppercase\">{{val}}</span></md-option></md-select><span class=\"version\" ng-if=\"!isSmall\">v{{appVersion}}</span><md-button class=\"md-icon-button\" ng-if=\"isSmall\" ng-click=\"toggleSearchBar()\"><md-icon class=\"black-text material-icons--two-tone\">search</md-icon><md-tooltip>Search</md-tooltip></md-button><md-button ng-click=\"openNotificationsPanel($event)\" class=\"md-icon-button notification-button\" style=\"position: relative\"><div class=\"badge\" ng-if=\"unreadCount\" ng-class=\"{\'has-notification\' : unreadCount}\" layout=\"\" layout-align=\"center center\"><span class=\"md-tiny bold-text\" style=\"min-width: 20px\">{{unreadCount }}</span></div><md-icon class=\"black-text material-icons--two-tone\">notifications</md-icon><md-tooltip>Notifications</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-if=\"!isSmall\" ng-click=\"showSettings($event)\"><md-icon class=\"black-text material-icons--two-tone\">settings</md-icon><md-tooltip>Settings</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"reloadState();\" ng-if=\"!isSmall\"><md-icon class=\"black-text material-icons--two-tone\">refresh</md-icon><md-tooltip>Refresh State</md-tooltip></md-button><md-menu md-position-mode=\"left bottom\"><md-button ng-click=\"$mdOpenMenu($event)\" aria-label=\"User\" class=\"md-accent\" ng-class=\"{\'md-icon-button\' : isSmall, \'outline\' : !isSmall}\"><span class=\"md-caption bold-text\" ng-if=\"!isSmall\">{{ currentUser.name }}</span><md-icon class=\"black-text\">{{isSmall ? \'more_vert\' : \'expand_more\'}}</md-icon></md-button><md-menu-content width=\"3\" style=\"margin: 0; padding: 0;\"><md-menu-item><md-button ng-click=\"reloadState();\">Refresh State</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item ng-if=\"isUserLoggedIn\"><md-button ng-click=\"closeSidebar();\" ui-sref=\"app.account.home\">My Account</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=\"showSettings($event)\">Settings</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item ng-if=\"isUserLoggedIn\"><md-button ng-click=\"logout();\">Logout</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"md-toolbar-tools\" ng-if=\"showSearch\"><md-button class=\"md-icon-button md-accent\" ng-click=\"toggleSearchBar()\"><md-icon>arrow_back</md-icon></md-button><app-search role-spec=\"currentUser.roleSpec\" open-search=\"openSearch\" class=\"full-width\"></app-search></div></md-toolbar><div class=\"app-loader\" ng-if=\"loading\" layout=\"\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\"></md-progress-circular></div><md-content layout=\"column\" flex=\"\" md-scroll-y=\"\" ui-view=\"\" class=\"aarida-content-holder\"></md-content></div></div><script type=\"text/ng-template\" id=\"toast-template.html\"><md-toast> <md-progress-circular md-diameter=\"24\" class=\"md-warn\" ng-if=\"showProgress\"></md-progress-circular> <span flex style=\"margin: 0 8px;\">{{message}}</span> <md-button class=\"md-icon-button\" ng-click=\"closeToast()\"> <md-icon class=\"md-warn\">close</md-icon> </md-button> </md-toast></script><div class=\"notification-panel-container\" ng-include=\"\'app/main/notifications.panel.tmpl.html\'\"></div><script type=\"text/ng-template\" id=\"upload-list.html\"><md-card ng-style=\"{\'max-width\' : isSmall ? \'100%\' :\'350px\'}\" style=\" max-height: 260px; margin: 0;\" ng-if=\"files.length > 0 \"> <section md-whiteframe=\"3\" md-colors=\"{\'background\' : \'boring-primary-500-1\'}\" layout layout-align=\"space-between center\" class=\"md-padding\"> <span class=\"md-body-1 bold-text\">Uploading images ({{uploaded}}/{{files.length}}) </span> <md-button class=\"md-icon-button\" ng-click=\"showPanel = !showPanel\"> <md-icon class=\"white-text\">{{showPanel ? \"keyboard_arrow_down\" : \"keyboard_arrow_up\"}}</md-icon> </md-button> </section> <md-content style=\"max-height: 200px; width: 100%;\" ng-hide=\"!showPanel\"> <md-list class=\"md-1-line\"> <md-list-item ng-repeat-start=\"file in files\"> <img ngf-thumbnail=\"file || \'/thumb.jpg\'\" class=\"md-avatar\" alt=\"{{file.name}}\"> <!--<md-img md-src=\"{{image.urls.thumbnail}}\" class=\"md-avatar\" alt=\"{{image.filename}}\">--> <md-truncate class=\"md-caption\" style=\"width: 200px;\">{{file.name}}</md-truncate> <section layout layout-align=\"center center\" class=\"md-secondary relative\"> <md-progress-circular ng-if=\"!file.uploaded\" md-diameter=\"30\" value=\"{{file.progress}}\" md-mode=\"determinate\"></md-progress-circular> <md-icon md-svg-src=\"/assets/images/checked.svg\" ng-if=\"file.uploaded\"></md-icon> <div style=\"position: absolute; top: 0; bottom : 0; left: 0; right: 0;\" layout layout-align=\"center center\"> <span class=\"md-tiny\" ng-if=\"!file.uploaded\">{{file.progress}}</span> </div> </section> </md-list-item> <!--<md-progress-linear md-mode=\"determinate\" value=\"{{progressPercentage}}\"></md-progress-linear>--> <md-divider ng-repeat-end></md-divider> </md-list> </md-content> </md-card></script>");
$templateCache.put("app/main/notifications.panel.tmpl.html","<md-sidenav md-component-id=\"notifications-panel\" class=\"md-sidenav-right notification-panel\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"center start\"><h4 class=\"md-subhead\">Notifications ({{notifications.length}})</h4><span class=\"md-caption\">{{unreadCount}} Unread</span></div><md-button class=\"md-icon-button\" ng-if=\"notifications.length\" ng-click=\"clearNotifications()\"><md-icon>clear_all</md-icon><md-tooltip>Clear All Notifications</md-tooltip></md-button></div></md-toolbar><md-divider></md-divider><md-content md-scroll-y=\"\"><md-list class=\"md-3-line notifications-list md-dense\"><md-list-item ng-repeat-start=\"notification in notifications track by notification.id\" ng-click=\"markAsRead(notification)\" class=\"notification-item\" ng-class=\"{\'unread\' : !notification.read, \'read\' : notification.read }\" ui-sref=\"{{notification.sref}}\"><div class=\"md-list-item-text\"><p class=\"bold-text notification-title md-body-1\">{{notification.title}}</p><p class=\"md-caption notification-description md-truncate\" ng-bind-html=\"notification.description\"></p><p class=\"md-tiny notification-date\">{{notification.id | date : \'medium\'}}</p></div></md-list-item><md-divider ng-repeat-end=\"\"></md-divider></md-list></md-content></md-sidenav>");
$templateCache.put("app/modules/diagnostics/diagnostics.tmpl.html","<section><div layout=\"\" layout-align=\"center center\"><h3>Diagnostics</h3></div><div layout=\"\"><md-button class=\"md-primary md-raised\" ng-click=\"diagCtrl.runProductDiagnostics()\">Run Product Diagnostics</md-button></div></section>");
$templateCache.put("app/modules/homepage-builder/homepage-builder.html","<div class=\"ui-builder\"><md-subheader class=\"md-primary ui-builder-subheader\"><div flex=\"\" layout=\"\" layout-align=\"stretch center\"><h4 class=\"md-subhead bold-text\">UI Builder</h4><span flex=\"\"></span><md-button class=\"md-raised md-primary medium\" ng-click=\"openPreview($event)\" ng-disabled=\"saving\"><span>Preview and Save</span></md-button></div></md-subheader><div layout=\"\"><section flex=\"\" class=\"builder\" dnd-list=\"configs\"><md-card class=\"expandable-section\" ng-repeat=\"config in configs\" ng-class=\"{\'expanded\': config.expanded}\"><md-toolbar class=\"md-primary md-hue-3 expansion-header\" dnd-draggable=\"config\" dnd-moved=\"configs.splice($index, 1)\" dnd-effect-allowed=\"move\"><div class=\"md-toolbar-tools pointer\" layout=\"\" layout-align=\"stretch center\" ng-click=\"config.expanded = !config.expanded\"><md-button class=\"md-icon-button\"><md-icon class=\"material-icons--two-tone\">drag_handle</md-icon></md-button><span class=\"md-subhead\" ng-if=\"!config.edit\" ng-click=\"config.edit = true; $event.stopPropagation()\">{{config.name}}</span> <input type=\"text\" class=\"config-name-input\" ng-click=\"$event.stopPropagation()\" ng-if=\"config.edit\" ng-model=\"config.name\" ng-blur=\"config.edit = false\"> <span flex=\"\"></span><section layout=\"\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"editWidget(config, $event)\"><md-icon class=\"material-icons--two-tone\">edit</md-icon></md-button><md-button class=\"md-icon-button md-warn\" ng-click=\"$event.stopPropagation();deleteWidget($event, $index)\"><md-icon>delete</md-icon></md-button><md-button class=\"md-icon-button\"><md-icon class=\"material-icons--two-tone\">{{config.expanded ? \'keyboard_arrow_up\' : \'keyboard_arrow_down\'}}</md-icon><md-tooltip>{{config.expanded ? \'Collapse Section\' : \'Expand Section\'}}</md-tooltip></md-button></section></div></md-toolbar><md-divider></md-divider><div class=\"expansion-content\" ng-class=\"{\'expanded\' : config.expanded}\"><section class=\"md-padding\"><section ng-if=\"config.type === \'slider\'\" class=\"slider-creator\"><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-raised md-primary\" ng-click=\"$event.stopPropagation();addSlide($event, config)\"><md-icon>add</md-icon><span>Add New Slide</span></md-button></div><div layout=\"column\" layout-align=\"center center\" layout-fill=\"\" ng-if=\"!config.objects.length\"><p>No Slides Here</p><md-button ng-click=\"addSlide($event, config, 0)\"><md-icon>add</md-icon><span>Add Slider</span></md-button></div><md-tabs ng-if=\"config.objects.length\" md-dynamic-height=\"\"><md-tab ng-repeat=\"object in config.objects\" label=\"Slide {{$index + 1}}\"><md-content><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-raised md-warn small\" ng-click=\"deleteSlide(config, $index, $event)\"><span>Delete Slide</span></md-button></div><image-selector ng-model=\"object.image\" view-model=\"h_x_large\" select=\"header\" sizes=\"config.sizes\" placeholder=\"{{getPlaceholder(config)}}\" class=\"slide-image-selector\"></image-selector><div layout=\"\" layout-align=\"center center\" class=\"md-padding\" layout-wrap=\"\"><md-input-container flex=\"\" class=\"no-error-spacer md-block\" ng-if=\"object.url\" style=\"padding: 0;margin: 12px 0;\"><label>Link URL</label> <textarea ng-model=\"object.url\" readonly=\"\"></textarea></md-input-container><md-input-container flex=\"\" class=\"no-error-spacer md-block\" ng-if=\"!object.url\" style=\"padding: 0;margin: 12px 0;\"><label>Link URL</label> <textarea readonly=\"\">Please Generate Link</textarea></md-input-container></div><div layout=\"\" layout-align=\"center center\"><md-button class=\"outline small\" ngclipboard=\"\" ng-if=\"object.url\" ng-click=\"$event.stopPropagation(); showToast(\'Copied Url to Clipboard\')\" data-clipboard-text=\"{{properName(object.url)}}\"><span>Copy Url</span></md-button><md-button ng-click=\"generateLink($event, object, \'url\')\" class=\"small md-primary md-raised\">{{object.url ? \'Edit URL\' : \'Generate Link\'}}</md-button></div></md-content></md-tab></md-tabs></section><section ng-if=\"config.type === \'column-banner\'\" layout=\"\" dnd-list=\"config.objects\"><div ng-class=\"config.classes\" ng-repeat=\"object in config.objects\" layout=\"column\" dnd-draggable=\"object\" dnd-moved=\"config.objects.splice($index, 1)\" dnd-effect-allowed=\"move\"><image-selector ng-model=\"object.image\" view-model=\"h_x_large\" select=\"header\" sizes=\"config.sizes\" placeholder=\"{{getPlaceholder(config)}}\" class=\"slide-image-selector\"></image-selector><div layout=\"\" layout-align=\"center center\" class=\"md-padding\" layout-wrap=\"\"><md-input-container flex=\"\" class=\"no-error-spacer md-block\" ng-if=\"object.url\" style=\"padding: 0;margin: 12px 0;\"><label>Link URL</label> <textarea ng-model=\"object.url\" readonly=\"\"></textarea></md-input-container><md-input-container flex=\"\" class=\"no-error-spacer md-block\" ng-if=\"!object.url\" style=\"padding: 0;margin: 12px 0;\"><label>Link URL</label> <textarea readonly=\"\">Please Generate Link</textarea></md-input-container></div><div layout=\"\" layout-align=\"center center\"><md-button class=\"outline small\" ngclipboard=\"\" ng-if=\"object.url\" ng-click=\"$event.stopPropagation(); showToast(\'Copied Url to Clipboard\')\" data-clipboard-text=\"{{properName(object.url)}}\"><span>Copy Url</span></md-button><md-button ng-click=\"generateLink($event, object, \'url\')\" class=\"small md-primary md-raised\">{{object.url ? \'Edit URL\' : \'Generate Link\'}}</md-button></div></div></section></section></div></md-card></section><section flex=\"{{menuFlex}}\" class=\"relative\"><md-card><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"stretch center\"><md-button class=\"md-icon-button\" ng-click=\"minimiseMenu()\"><md-icon>menu_open</md-icon></md-button><span ng-if=\"menuOpen\">Templates</span> <span flex=\"\"></span></div></md-toolbar><md-card-content ng-if=\"menuOpen\"><md-list class=\"ui-builder-templates-list md-2-line\"><md-list-item class=\"list-item\" ng-repeat=\"template in templates\" ng-click=\"addWidget($event, null, template)\"><img ng-src=\"{{template.icon}}\" class=\"md-avatar\"><div class=\"md-list-item-text\" layout=\"column\"><h5>{{template.name}}</h5><p class=\"md-caption\" style=\"line-height: 1.4em\">{{template.description}}</p></div></md-list-item></md-list></md-card-content></md-card><md-card class=\"edit-section-card\" ng-class=\"{\'active\' : selectedWidget}\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"stretch center\"><md-button class=\"md-icon-button\" ng-click=\"clearSection()\"><md-icon>arrow_backward</md-icon></md-button><span>Edit {{selectedWidget.name}}</span> <span flex=\"\"></span></div></md-toolbar><md-divider></md-divider><md-card-content><div layout=\"column\" ng-if=\"selectedWidget.type === \'slider\'\"><md-list><md-list-item><md-input-container class=\"no-error-spacer full-width\"><md-checkbox ng-model=\"selectedWidget.options.autoPlay\" ng-required=\"\">Autoplay Allowed</md-checkbox></md-input-container></md-list-item><md-list-item><md-input-container class=\"no-error-spacer full-width\"><label>Autoplay Speed (In ms)</label> <input type=\"number\" ng-model=\"selectedWidget.options.interval\" ng-required=\"\"> <span class=\"md-tiny grey-text\" md-hint=\"\" ng-if=\"selectedWidget.options.interval\">Equivalent to {{selectedWidget.options.interval / 1000}} seconds</span></md-input-container></md-list-item><md-list-item><md-input-container class=\"no-error-spacer full-width\"><md-checkbox ng-model=\"selectedWidget.options.overlay\" ng-required=\"\">Display Overlay</md-checkbox></md-input-container></md-list-item><md-list-item><md-input-container class=\"no-error-spacer full-width\"><md-checkbox ng-model=\"selectedWidget.options.controls\" ng-required=\"\">Show Controls</md-checkbox></md-input-container></md-list-item><md-list-item><md-input-container class=\"no-error-spacer full-width\"><md-checkbox ng-model=\"selectedWidget.options.fullLink\" ng-required=\"\">Full Page Link</md-checkbox></md-input-container></md-list-item><md-list-item><md-input-container class=\"no-error-spacer full-width\"><label>Slide Class</label> <input type=\"text\" ng-model=\"selectedWidget.options.slideClass\" ng-required=\"\"></md-input-container></md-list-item><md-list-item><md-input-container class=\"no-error-spacer full-width\"><label>Card Class</label> <input type=\"text\" ng-model=\"selectedWidget.options.cardClass\" ng-required=\"\"></md-input-container></md-list-item><md-list-item><md-input-container class=\"no-error-spacer full-width\"><label>Image Class</label> <input type=\"text\" ng-model=\"selectedWidget.options.imageClass\" ng-required=\"\"></md-input-container></md-list-item></md-list></div><div layout=\"column\"><md-list><md-list-item><md-input-container class=\"no-error-spacer full-width\"><label>Widget Class</label> <textarea type=\"text\" ng-model=\"selectedWidget.classes\" ng-required=\"\">\n                                    </textarea></md-input-container></md-list-item><md-list-item ng-repeat=\"column in columns\"><p>{{column.title}}</p><div class=\"md-secondary\"><md-select ng-model=\"selectedWidget.grids[column.value]\" ng-change=\"updateClasses(selectedWidget, column)\"><md-option ng-repeat=\"grid in gridValues\" ng-value=\"grid.value\">{{grid.title}}</md-option></md-select></div></md-list-item></md-list></div></md-card-content></md-card></section></div></div>");
$templateCache.put("app/modules/pages/index.html","<div ui-view=\"\"></div>");
$templateCache.put("app/modules/pos/index.html","<div ui-view=\"\"></div>");
$templateCache.put("app/modules/posts/posts.tmpl.html","<div class=\"md-padding\"><section layout=\"\" layout-align=\"space-between center\"><h2>User Posts</h2><md-button class=\"outline\" ng-click=\"addNewPost($event)\"><md-icon>add</md-icon>Add New Post</md-button></section><div layout=\"\" layout-wrap=\"\"><section ng-repeat=\"post in posts\" flex=\"20\" flex-xs=\"100\" flex-sm=\"50\" flex-md=\"33\" flex-lg=\"20\"><md-card class=\"influencer-image\"><md-card-header><md-card-avatar><md-img class=\"avatar\" md-src=\"{{post.user.profileImageURL}}\"></md-img></md-card-avatar><md-card-header-text><span class=\"md-title\">{{post.user.name}}</span> <i class=\"md-subhead\">{{post.user.userName}}</i></md-card-header-text></md-card-header><md-img md-src=\"{{post.image.urls.medium}}\" class=\"md-card-image\"></md-img><md-card-actions layout=\"\" layout-align=\"space-between center\"><section layout=\"column\"><span class=\"md-caption\">Views : {{post.viewCount}}</span> <span class=\"md-tiny grey-text\">Uploaded On : {{post.createdAt | date : \'mediumDate\'}}</span></section><md-button class=\"outline small\" ng-click=\"addNewPost($event, post, $index)\">Edit</md-button></md-card-actions></md-card></section></div></div>");
$templateCache.put("app/modules/printTemplates/material-batch-barcode.html","<!DOCTYPE html><html lang=\"en\"><head><link href=\"labels.css\" rel=\"stylesheet\" type=\"text/css\"><style type=\"text/css\">\n        /*@media print {*/\n            body {\n                -webkit-print-color-adjust: exact;\n                width: 8.5in;\n                margin: 0in .1875in;\n            }\n\n            #print {\n            }\n\n            .page-break {\n                page-break-after: always;\n                overflow: hidden;\n                display: block;\n                position: relative;\n                clear: left;\n            }\n\n            .label {\n                /* Avery 5160 labels -- CSS and HTML by MM at Boulder Information Services */\n                width: 2.4in; /* plus .6 inches from padding */\n                height: 1.2in; /* plus .125 inches from padding */\n                padding: .125in .3in 0;\n                margin: 0.12in; /* the gutter */\n                float: left;\n                text-align: center;\n                overflow: hidden;\n                outline: 1px dotted; /* outline doesn\'t occupy space like border does */\n            }\n\n            img.logo {\n                max-width: 50pt;\n                /*transform: rotate(-90deg);*/\n            }\n        /*}*/\n\n    </style></head><body><div class=\"label\"><img src=\"https://lh3.googleusercontent.com/-EOb9rO1vsdo/AAAAAAAAAAI/AAAAAAAAAAA/wWOvjacky18/photo.jpg\" height=\"74\" width=\"74\"><br>Fred Smith<br>Date of Birth: 04/03/2000<br>Year: 2015<br>League: Recreation<br>Id: 343535<br></div><div class=\"page-break\"></div></body></html>");
$templateCache.put("app/modules/quotations/quotations.all.html","<div class=\"all-quotations\" layout-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"row\"><section flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"{{selectedQuotationId ? \'30\' : \'100\'}}\"><md-card class=\"no-margin quotation-list-card\"><md-subheader layout=\"\" layout-align=\"space-between center\"><span class=\"md-title bold-text\">All Quotations</span> <span class=\"md-caption\">Total : {{total}}</span></md-subheader><md-content md-scroll-x=\"\" class=\"scrolling-tabs\"><md-button class=\"custom-tab\" ng-class=\"{\'active\' : query.status === \'created\'}\" ng-click=\"applyFilter(\'created\')\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator\"></span> <span>Created</span></div></md-button><md-button class=\"custom-tab\" ng-class=\"{\'active\' : (query.status === \'processing\')}\" ng-click=\"applyFilter(\'processing\')\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator pending\"></span> <span>Processing</span></div></md-button><md-button class=\"custom-tab\" ng-class=\"{\'active\' : query.status === \'completed\'}\" ng-click=\"applyFilter(\'processing\')\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator success\"></span> <span>Completed</span></div></md-button><md-button class=\"custom-tab\" ng-class=\"{\'active\' : query.status === \'cancelled\'}\" ng-click=\"applyFilter(\'cancelled\')\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator error\"></span> <span>Cancelled</span></div></md-button></md-content><md-progress-linear ng-if=\"loading\"></md-progress-linear><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[10, 25, 50]\" md-page=\"query.page\" md-total=\"{{total}}\" md-on-paginate=\"fetchQuotations\" md-page-select=\"\"></md-table-pagination><md-list class=\"quotation-list\"><md-list-item ng-repeat-start=\"quotation in quotations\" ng-click=\"selectQuotation(quotation)\" ng-class=\"{\'active\' : selectedQuotationId === quotation._id}\" class=\"md-3-line quotation-item\"><div class=\"md-list-item-text\"><h5>{{quotation.quotationNumber}} <span class=\"md-caption\">●</span> {{quotation.cachedUser.name}}</h5><p class=\"md-caption\">{{quotation.category.name}} | {{quotation.productType.name}}</p><i class=\"md-tiny expected-on-date\" ng-if=\"quotation.expectedDate && quotation.status !== \'cancelled\'\">Expected On: {{quotation.expectedDate | date : \'mediumDate\'}}</i><div><md-button disabled=\"\" class=\"md-secondary\"><span class=\"badge\">{{quotation.status| uppercase}}</span></md-button></div></div><div class=\"md-secondary\"><md-icon class=\"white-text\" ng-if=\"selectedQuotationId === quotation._id\">arrow_forward</md-icon></div></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list></md-card></section><section flex=\"\" ng-if=\"selectedQuotationId && selectedQuotation\" class=\"quotation-details slide-up-fade-in\" ng-class=\"{\'overlay\' : isSmall}\"><md-toolbar class=\"md-accent md-hue-1\"><div layout=\"\" layout-align=\"space-between center\" class=\"md-toolbar-tools\"><h3>{{selectedQuotation.quotationNumber}}</h3><md-button class=\"md-icon-button\" ng-click=\"deselectQuotation()\"><md-icon>close</md-icon><md-tooltip>Close the Details Pane</md-tooltip></md-button></div></md-toolbar><md-content md-scroll-y=\"\" class=\"md-padding quotation-details-scroll-container\"><div class=\"user-info\"><h4 style=\"margin-bottom: 20px\">Basic Information</h4><section layout=\"\" layout-align=\"space-between center\" style=\"margin: 30px 0\"><div layout=\"column\" layout-align=\"center start\"><a class=\"md-subhead md-link pointer\" style=\"margin-bottom: 8px\" ui-sref=\"app.users.details.home({userId : selectedQuotation.user})\">{{selectedQuotation.cachedUser.name}}</a><p>{{selectedQuotation.cachedUser.mobile}}</p><p>{{selectedQuotation.cachedUser.email}}</p></div><div><md-button class=\"md-raised flat tile medium md-primary\" ng-click=\"openNotifications(selectedQuotation, $event)\"><md-icon>message</md-icon>Notify User</md-button></div></section><section layout=\"\" layout-align=\"center center\"><md-select ng-model=\"$parent.currentStatus\" style=\"min-width: 200px\" placeholder=\"Quotation Status\" ng-change=\"currentStatus === \'cancelled\' ? cancelQuotationDialog($event) : updateStatus()\" ng-disabled=\"statusUpdating\"><md-option ng-value=\"status\" ng-repeat=\"status in statusList\">{{status | uppercase}}</md-option></md-select><bubble-loader ng-if=\"statusUpdating\"></bubble-loader></section></div><div><md-divider></md-divider><h4>Details</h4><section layout=\"\" layout-wrap=\"\"><div flex=\"100\" ng-if=\"selectedQuotation.expectedDate\"><md-card class=\"flat tile delivery-card\"><span>The customer needs the product by {{selectedQuotation.expectedDate | date : \'mediumDate\'}}.</span></md-card></div><div flex=\"100\" ng-if=\"selectedQuotation.comment\"><md-card><md-card-content>\"{{selectedQuotation.comment}}\"</md-card-content></md-card></div><div flex-xl=\"60\" flex-lg=\"50\" flex-xs=\"100\" flex-sm=\"100\" flex-md=\"50\"><md-card></md-card><md-card><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Key</th><th md-column=\"\">Value</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"data in tableData\"><td md-cell=\"\">{{data.displayKey}}</td><td md-cell=\"\">{{data.value}}</td></tr></tbody></table></md-card><md-card class=\"no-shadow quotation-details-card\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" style=\"height: 75px\"><td md-cell=\"\">Category</td><td md-cell=\"\">{{selectedQuotation.category.name}}</td><td md-cell=\"\"><img ng-src=\"{{selectedQuotation.category.imageUrl}}\" style=\"max-width: 50px\"></td></tr><tr md-row=\"\" style=\"height: 75px\"><td md-cell=\"\">Product Type</td><td md-cell=\"\">{{selectedQuotation.productType.name}}</td><td md-cell=\"\"><img ng-src=\"{{selectedQuotation.productType.imageUrl}}\" style=\"max-width: 50px\"></td></tr><tr md-row=\"\" ng-if=\"selectedQuotation.option\" style=\"height: 75px\"><td md-cell=\"\">Option</td><td md-cell=\"\">{{selectedQuotation.option.name}}</td><td md-cell=\"\"><img ng-src=\"{{selectedQuotation.option.imageUrl}}\" style=\"max-width: 50px\"></td></tr></tbody></table><md-divider></md-divider><md-card-header layout=\"\" layout-align=\"center center\" ng-if=\"selectedQuotation.approxPrice\"><span class=\"md-subhead bold-text\">Estimated Price : ₹ {{selectedQuotation.approxPrice}}</span></md-card-header></md-card></div><div flex-xl=\"40\" flex-lg=\"50\" flex-xs=\"100\" flex-sm=\"100\" flex-md=\"50\"><chat-box config=\"selectedQuotation.chatConfig\" on-room-updated=\"updateRoom(data, selectedQuotation)\" has-access=\"selectedQuotation.hasAccessToChat\" room-id=\"selectedQuotation.chatRoomId\"></chat-box></div></section></div></md-content></section></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"cancel-quotation-dialog\"><md-dialog aria-label=\"cancel order dialog\" flex=\"30\" flex-lg=\"30\" flex-md=\"40\" flex-sm=\"60\" flex-xl=\"20\" flex-xs=\"90\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h5>Cancel Quotation</h5><md-button class=\"md-icon-button\" ng-click=\"close();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content\"><p class=\"md-caption grey-text center-text\">Select a reason for Cancellation</p><form name=\"cancelForm\"><md-radio-group ng-model=\"cancelReason\" required=\"\"><md-list><md-list-item ng-repeat-start=\"reason in reasons\"><md-radio-button aria-label=\"{{reason}}\" ng-value=\"reason\" style=\"margin-bottom: 0\"><span class=\"md-body-1\">{{reason}}</span></md-radio-button></md-list-item><md-divider ng-if=\"!$last\" ng-repeat-end=\"\"></md-divider></md-list></md-radio-group><md-input-container class=\"md-block\" md-theme=\"black\" ng-if=\"cancelReason === \'Others\'\"><label>Reason for Cancellation</label> <textarea ng-model=\"otherReason\" placeholder=\"Tell us why you feel like cancelling this order\" required=\"\" rows=\"5\"></textarea></md-input-container></form></md-dialog-content><md-divider></md-divider><md-dialog-actions layout=\"\" layout-align=\"space-between\"><md-button ng-click=\"close()\">Close</md-button><md-button class=\"md-warn\" ng-click=\"updateStatus();\" ng-disabled=\"cancelForm.$invalid || updatingStatus\"><span ng-if=\"!cancelling\">Cancel Quotation</span><bubble-loader ng-if=\"cancelling\"></bubble-loader></md-button></md-dialog-actions></md-dialog></div></div>");
$templateCache.put("app/modules/reports/reports.tmpl.html","<div class=\"reports\"><section layout=\"\" layout-align=\"center center\"><h2 class=\"center-text\">Reports Generator</h2></section><section ng-if=\"!selectedReport\" layout=\"\" layout-wrap=\"\"><div ng-repeat=\"report in reports\" flex=\"25\" flex-xs=\"100\" flex-sm=\"50\" flex-md=\"33\" flex-lg=\"25\" flex-xl=\"20\"><md-card><md-card-header><h3 class=\"md-card-title\">{{report.name}}</h3></md-card-header><md-card-content><p>{{report.description}}</p></md-card-content><md-divider></md-divider><md-card-actions><md-button class=\"md-primary\" ng-click=\"selectReport(report)\">Select this report<md-icon>arrow_forward</md-icon></md-button></md-card-actions></md-card></div></section><section ng-if=\"selectedReport\" class=\"md-padding\"><md-toolbar class=\"md-primary md-hue-3 reports-toolbar\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><md-button ng-click=\"backToHome()\"><md-icon>arrow_back</md-icon><span>Back</span></md-button><h4>{{selectedReport.name}}</h4><div layout=\"\"><md-button class=\"md-icon-button\" ng-click=\"exportData()\"><md-icon>file_download</md-icon><md-tooltip>Download File as Excel</md-tooltip></md-button></div></div></md-toolbar><div layout=\"\" layout-xs=\"column\" layout-sm=\"column\" layout-align=\"space-between center\" ng-if=\"selectedReport.filters.length\" class=\"md-padding\"><h3 class=\"\">Filters:</h3><div layout=\"\" layout-align=\"center center\" layout-sm=\"column\" layout-xs=\"column\"><section ng-repeat=\"filter in selectedReport.filters\" layout=\"\" layout-wrap=\"\"><md-input-container flex=\"\" ng-if=\"filter.type === \'date\'\" class=\"no-error-spacer\"><label>{{filter.label}}</label><md-datepicker ng-model=\"filter.model\"></md-datepicker></md-input-container><md-input-container flex=\"\" ng-if=\"filter.type === \'select\'\" layout=\"\"><label>{{filter.label}}</label><md-select ng-model=\"filter.model\" md-on-open=\"filter.onOpen()\"><md-option layout-fill=\"\" ng-if=\"filter.loading\" value=\"\"><bubble-loader></bubble-loader></md-option><md-option value=\"\" ng-if=\"!filter.loading\" class=\"grey-text caption\">Select Warehouse</md-option><md-option ng-repeat=\"object in filter.collection\" ng-value=\"object.value\">{{object.key}}</md-option></md-select></md-input-container><md-input-container ng-if=\"filter.type === \'date-range\'\" layout=\"\"><label>{{filter.label}}</label><md-select ng-model=\"filter.model\" ng-change=\"filter.onChange(selectedReport.filters)\"><md-optgroup label=\"{{modelGroup.name}}\" ng-repeat=\"modelGroup in filter.rangeModels\"><md-option ng-repeat=\"model in modelGroup.models\" ng-value=\"modelGroup.name + \'::\' +model.value\">{{model.title}}</md-option></md-optgroup></md-select></md-input-container></section></div><md-button class=\"md-raised md-primary\" ng-click=\"fetchData()\"><md-icon>filter_list</md-icon>Filter</md-button></div><div layout=\"\" layout-wrap=\"\" ng-if=\"selectedReport.cards.length\"><section ng-repeat=\"card in selectedReport.cards\" flex=\"25\" flex-xs=\"100\" flex-sm=\"50\" flex-md=\"33\" flex-lg=\"25\" flex-xl=\"20\"><md-card><md-card-content layout=\"\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\" ng-if=\"!promise.$$state.pending\"><span class=\"md-display-1\" ng-class=\"card.titleClass\">{{card.value}}</span> <span class=\"md-subhead\" ng-class=\"card.subtitleClass\">{{card.subValue ? card.subValue : \'&nbsp;\'}}</span></div><md-progress-circular md-diameter=\"28\" ng-if=\"promise.$$state.pending\"></md-progress-circular></md-card-content><md-divider></md-divider><md-card-actions layout=\"\" layout-align=\"center center\"><p class=\"md-subhead\" ng-class=\"card.subheadClass\">{{card.title}}</p></md-card-actions></md-card></section></div><div layout=\"\" layout-align=\"end center\"><p class=\"grey-text\">Query took : <i ng-if=\"!duration\">0</i> <i ng-if=\"duration\">{{(duration/1000).toFixed(2)}}</i> seconds</p></div><md-card><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"orderBy\"><tr md-row=\"\" md-colors=\"{\'background\' : \'boring-accent-50-0.1\'}\"><th md-column=\"\" ng-repeat=\"column in selectedReport.columns\" md-order-by=\"{{column.columnHeader}}\">{{column.columnHeader}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"data\" md-select-id=\"_id\" md-auto-select=\"\" ng-repeat=\"data in compiledJSON | orderBy : orderBy\" ng-init=\"rowIndex = $index\" style=\"height: 75px;\"><td md-cell=\"\" ng-repeat=\"column in selectedReport.columns\"><span ng-if=\"!column.displayType\">{{data[column.columnHeader]}}</span> <span ng-if=\"column.displayType === \'index\'\">{{rowIndex + 1}}.</span><md-img md-src=\"{{data[column.columnHeader]}}\" ng-if=\"column.displayType === \'image\'\" ng-style=\"column.style\"></md-img></td></tr></tbody></table></md-table-container></md-card></section></div>");
$templateCache.put("app/modules/warehouses/warehouse.tmpl.html","<div><md-card flex=\"\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\" style=\"background: #ebebee\"><div layout=\"\" layout-align=\"start center\" flex=\"\"><span ng-if=\"!selected.length\" style=\"margin-right: 20px\">Warehouses</span><section layout=\"\" layout-align=\"start center\" ng-if=\"selected.length\"><md-button class=\"md-icon-button material-icons--two-tone\" ng-click=\"clearSelections()\"><md-icon>close</md-icon></md-button><span>{{selected.length}} Warehouses Selected</span></section><span ng-if=\"selected.length\" flex-offset=\"5\"></span><div layout=\"\" layout-align=\"center center\" ng-if=\"selected.length\"></div><span ng-if=\"selected.length\" flex-offset=\"5\"></span><form role=\"form\" novalidate=\"\" name=\"filterForm\" flex-offset=\"5\" ng-submit=\"fetchWarehouses()\" layout=\"\" flex=\"\" layout-align=\"center center\"><md-input-container flex=\"\" class=\"no-error-spacer\" layout=\"\"><label>&nbsp;</label> <input type=\"search\" id=\"giftCardSearch\" ng-model=\"query.q\" select-on-click=\"\" ng-model-options=\"{\'debounce\' : 500}\" ng-change=\"fetchWarehouses()\" placeholder=\"Search Warehouses\" class=\"search-bar-input\"></md-input-container><md-button ng-click=\"fetchWarehouses()\" class=\"md-icon-button\"><md-icon>search</md-icon></md-button></form></div><div layout=\"\" layout-align=\"end center\"><md-menu><md-button ng-click=\"$mdOpenMenu($event)\" aria-label=\"User\" class=\"md-accent md-icon-button\"><md-icon class=\"black-text\">more_vert</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"column in columns\"><md-button md-prevent-menu-close=\"\"><md-checkbox class=\"md-primary\" ng-change=\"sendToLocalStorage()\" ng-model=\"column.model\">{{column.name}}</md-checkbox></md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-primary md-fab md-mini\" ng-click=\"openAddWarehouse($event)\"><md-icon>add</md-icon><md-tooltip class=\"white-text\">Create Warehouse</md-tooltip></md-button></div></div></md-toolbar><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.sort\" md-on-reorder=\"fetchAllCards\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\">Sl No.</th><th md-column=\"\" md-order-by=\"{{column.orderBy}}\" ng-repeat=\"column in columns\" ng-show=\"column.model\">{{column.name}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"warehouse\" md-auto-select=\"\" ng-repeat=\"warehouse in warehouses\" ng-init=\"parentIndex = $index\"><td md-cell=\"\">{{ (((query.page - 1) * query.limit) + $index) + 1}}.</td><td md-cell=\"\" ng-repeat=\"column in columns\" ng-show=\"column.model\"><span ng-if=\"column.value === \'name\'\" class=\"md-tiny\">{{warehouse.name }}</span> <span ng-if=\"column.value === \'city\'\" class=\"md-tiny\">{{warehouse.city }}</span> <span ng-if=\"column.value === \'status\'\" class=\"md-tiny\">{{warehouse.status | uppercase }}</span><div ng-if=\"column.value === \'address\'\" class=\"md-tiny md-padding\"><span class=\"bold-text\">{{ warehouse.address.name }} : {{warehouse.address.mobile}}</span><br><span>{{ warehouse.address.streetAddress }}</span><br><span><span ng-if=\"warehouse.address.landmark\">{{ warehouse.address.landmark }},</span> {{warehouse.address.city}}, {{warehouse.address.state}}-{{warehouse.address.pinCode}}</span></div><span ng-if=\"column.value === \'prefix\'\" class=\"md-tiny\">{{warehouse.prefix }}</span> <span ng-if=\"column.value === \'createdAt\'\" class=\"md-tiny\">{{warehouse.createdAt | date : \'medium\' }}</span><div ng-if=\"column.value === \'actions\'\"><md-menu><md-button ng-click=\"$mdOpenMenu($event)\" aria-label=\"User\" class=\"md-primary md-icon-button\"><md-icon class=\"material-icons--two-tone\">more_horiz</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"$event.stopPropagation(); openAddWarehouse($event, warehouse, parentIndex)\"><md-icon>edit</md-icon><span>Edit</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[10, 25, 50, 100]\" md-page=\"query.page\" md-total=\"{{total}}\" md-on-paginate=\"fetchWarehouses\" md-page-select=\"\"></md-table-pagination></md-card></div>");
$templateCache.put("app/modules/workforce/workforce.html","");
$templateCache.put("app/modules/base/dialogs/import-sheet-dialog.html","<md-dialog flex=\"90\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h3>Import User</h3><md-button ng-click=\"cancel();\" class=\"md-icon-button\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><section ng-if=\"!hasFile\" layout=\"\" layout-align=\"center center\" class=\"md-margin md-padding\"><div ngf-drop=\"\" ngf-select=\"\" ng-model=\"$parent.file\" class=\"drag-drop white\" flex=\"\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"false\" ngf-allow-dir=\"false\" layout=\"column\" layout-align=\"center center\"><md-icon>cloud_upload</md-icon><span class=\"md-caption\" style=\"margin-top: 30px;\">Drop images here or click to upload</span></div><div ngf-no-file-drop=\"\">File Drag/Drop is not supported for this browser</div></section><section ng-if=\"hasFile\" layout=\"column\"><md-card><md-card-content><div layout=\"\" layout-align=\"stretch center\"><section layout=\"\" layout-align=\"space-around center\"><span class=\"md-body-2\" style=\"color: #0a6ebd; margin-left: 20px;\">{{file.name}}</span></section><span flex=\"\"></span><section layout=\"\" layout-align=\"center center\"><md-progress-circular style=\"padding: 0 16px;\" class=\"md-warn\" md-diameter=\"20\" ng-if=\"status === \'Reading File..\'\"></md-progress-circular><span class=\"md-body-2\" style=\"padding: 0 16px;\">{{status}}</span><md-button class=\"md-icon-button\" style=\"padding: 0 16px;\" ng-click=\"removeFiles($index);\"><md-icon>close</md-icon></md-button></section></div></md-card-content></md-card></section><div md-whiteframe=\"1\" class=\"md-padding md-padding\" layout=\"\" layout-align=\"end center\"><md-button ng-if=\"status ==\'Ready\'\" class=\"md-raised md-accent\" ng-click=\"selectHeaders();\" ng-disabled=\"mapping\" style=\"width: 200px; margin: 0;\">Select Headers</md-button><md-button ng-if=\"status == \'Selecting Headers\'\" class=\"md-raised md-accent\" ng-click=\"transform(jsonData);\" ng-disabled=\"!allheadersSelected\" style=\"width: 200px; margin: 0;\">Next</md-button><md-button ng-if=\"status ==\'Mapped\'\" class=\"md-raised md-accent\" ng-click=\"importData(transformedArray);\" ng-disabled=\"mapping\" style=\"width: 200px; margin: 0;\">Submit</md-button><md-button ng-if=\"status ==\'Importing\'\" class=\"md-raised md-accent\" ng-click=\"showUsers();\" style=\"width: 200px; margin: 0;\">Next</md-button></div><md-table-container ng-if=\"status == \'Ready\'\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\">#</th><th md-column=\"\" md-numeric=\"\">Status</th><th md-column=\"\" ng-repeat=\"header in newHeaders track by $index\">{{header | uppercase}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"data in jsonData | limitTo: myLimit: (myPage - 1) * myLimit\" ng-init=\"parentIndex = $index\"><td md-cell=\"\"><span class=\"md-caption grey-text\">{{$index + 1}}.</span></td><td md-cell=\"\"><section layout=\"\" layout-align=\"center center\" ng-if=\"importing || imported\"><md-progress-circular md-diameter=\"24\" ng-if=\"importing\"></md-progress-circular><md-icon md-svg-src=\"/assets/images/checked.svg\" ng-if=\"imported\"><md-tooltip>Import Complete</md-tooltip></md-icon><md-icon class=\"red-text\" ng-if=\"data.error\">error<md-tooltip>Error - {{data.error}}</md-tooltip></md-icon></section><section layout=\"\" layout-align=\"center center\" ng-if=\"!importing && !imported\"><md-icon>check</md-icon><md-tooltip>Ready For Mapping</md-tooltip></section></td><td md-cell=\"\" ng-repeat=\"(key, val) in jsonData[parentIndex]\">{{val}}</td></tr></tbody></table></md-table-container><section ng-if=\"status ==\'Selecting Headers\'\" layout=\"column\" layout-align=\"stretch center\" class=\"md-margin md-padding\"><md-card ng-repeat=\"entity in aaridaHeaders track by $index\" flex=\"100\" style=\"width: 100%\" layout=\"\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"space-around center md-margin md-padding\" style=\"width: 100%\"><md-input-container><input type=\"text\" ng-model=\"entity.entity\" disabled=\"\"></md-input-container><md-input-container><label>Headers</label><md-select ng-model=\"entity.selectedHeaders\" ng-change=\"showSelectedHeaders(header)\"><md-option ng-repeat=\"header in newHeaders track by $index\" ng-value=\"header\">{{header}}</md-option></md-select></md-input-container><md-input-container ng-if=\"entity.entity === \'Organisation\'\"><md-select ng-model=\"entity.selectedHeadersOrg\"><label>Select Org</label><md-option ng-repeat=\"org in orgs\" ng-value=\"org._id\">{{org.name}}</md-option></md-select></md-input-container></div></md-card><div ng-if=\"mapping\" layout=\"column\" layout-align=\"center center\"><md-progress-circular></md-progress-circular><h4 class=\"md-title\">Mapping ...</h4></div><div layout=\"\" layout-align=\"end center\">{{selectedHeaderArray.length}} out of {{aaridaHeaders.length}} selected.</div></section><md-table-container ng-if=\"status == \'Mapped\'\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\" ng-init=\"parentIndex = $index\"><th md-column=\"\" md-numeric=\"\">#</th><th md-column=\"\" ng-repeat=\"key in transformedHeaders track by $index\">{{key | uppercase}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"data in transformedArray | limitTo: myLimit: (myPage - 1) * myLimit\" ng-init=\"parentIndex = $index\"><td md-cell=\"\"><span class=\"md-caption grey-text\">{{$index + 1}}.</span></td><td md-cell=\"\" ng-repeat=\"(key, val) in transformedArray[parentIndex]\"><span ng-if=\"key !== \'completed\'\">{{val}}</span><div ng-if=\"key === \'completed\'\">{{val}}</div></td></tr></tbody></table></md-table-container><md-table-container ng-if=\"status === \'Importing\'\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\" ng-init=\"parentIndex = $index\"><th md-column=\"\" md-numeric=\"\">#</th><th md-column=\"\">Name</th><th md-column=\"\">Mobile</th><th md-column=\"\">Existing User</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"data in userArray\"><td md-cell=\"\"><span class=\"md-caption grey-text\">{{$index + 1}}.</span></td><td md-cell=\"\" class=\"md-caption\">{{data.name}}</td><td md-cell=\"\" class=\"md-caption\">{{data.mobile}}</td><td md-cell=\"\" class=\"md-caption\">{{data.existingUser ? \"Yes\" : \"No\"}}</td></tr></tbody></table></md-table-container><section ng-if=\"status === \'Import Complete\' && finalState\"><md-table-container ng-if=\"userArr.length\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\" ng-init=\"parentIndex = $index\"><th md-column=\"\" md-numeric=\"\">#</th><th md-column=\"\">Name</th><th md-column=\"\">Mobile</th><th md-column=\"\">Active</th><th md-column=\"\">Join Date</th><th md-column=\"\">Role</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"data in userArr\"><td md-cell=\"\"><span class=\"md-caption grey-text\">{{$index + 1}}.</span></td><td md-cell=\"\" class=\"md-caption\">{{data.name}}</td><td md-cell=\"\" class=\"md-caption\">{{data.mobile}}</td><td md-cell=\"\" class=\"md-caption\">{{data.status === 1 ? \'Active\' : \'N/A\'}}</td><td md-cell=\"\" class=\"md-caption\">{{data.createdAt | date : \'medium\'}}</td><td md-cell=\"\" class=\"md-caption\">{{data.role}}</td></tr></tbody></table></md-table-container><div ng-if=\"userArr.length === 0\" layout=\"column\" layout-align=\"center center\" class=\"md-margin md-padding\"><span class=\"text-center\">No New User found</span> <img class=\"no-user-found\" src=\"assets/images/blank.svg\"></div></section><md-table-pagination ng-if=\"status === \'Ready\' || status === \'Mapped\' || status === \'importing\' || imported || userArr.length > 0\" md-page-select=\"\" md-limit-options=\"[100,150,200,250,300]\" md-limit=\"myLimit\" md-page=\"myPage\" md-total=\"{{jsonData.length}}\"></md-table-pagination><md-card style=\"position: fixed; bottom: 0; width: 100%; z-index: 10; left: 0; padding-left: 240px; margin: 0;\" md-theme=\"dark-purple\" ng-if=\"jsonData.length > 0 && status === \'Importing\'\"><md-card-content><div layout=\"\" layout-align=\"stretch center\"><section layout=\"\" layout-align=\"start center\" flex=\"\"><span class=\"md-subhead\">Processed : {{processed + \" / \" + jsonData.length}}</span><div class=\"md-caption\" layout=\"\" layout-align=\"center center\" ng-if=\"importing || imported\"><span style=\"margin-left: 40px;\" ng-if=\"!imported\">{{percent}}%</span><md-progress-circular class=\"md-warn\" style=\"margin-left: 40px;\" ng-if=\"!imported\" md-diameter=\"24\" ng-value=\"percent\" md-mode=\"determinate\"></md-progress-circular><span style=\"margin-left: 40px;\">Errors (Local/Server) : {{localErrors.length + \" / \" + serverErrors.length}}</span> <span style=\"margin-left: 40px;\">Duplicates : {{duplicates.length}}</span> <span style=\"margin-left: 40px;\" ng-if=\"imported\">Total Time : {{time}} seconds</span></div></section></div></md-card-content></md-card></md-dialog-content><md-divider></md-divider><md-dialog-actions><div layout=\"\" layout-align=\"space-between center\" flex=\"100\"><md-button class=\"md-warn md-raised\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-primary md-raised\" ng-click=\"saveUsers()\" ng-disabled=\"!imported\">{{userArr.length > 0 ? \'Save\' : \'Return\'}}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/base/dialogs/scanner-dialog.html","<md-dialog flex=\"90\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h3>Scanner</h3><md-button ng-click=\"cancel();\" class=\"md-icon-button\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><div id=\"scanner-container\"></div></md-dialog-content><md-dialog-actions md-colors=\"{\'background\' : \'boring-primary-500-0\'}\"><div layout=\"\" layout-align=\"space-between center\" flex=\"\"><md-button class=\"md-warn md-raised\" ng-click=\"cancel();\">Close</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/base/dialogs/settings.dialog.controller.html","<md-dialog flex=\"50\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout-align=\"space-between center\"><span class=\"md-title\">Settings</span><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-center-tabs=\"\" md-stretch-tabs=\"\"><md-tab label=\"General\"><md-content class=\"md-padding\"><md-list class=\"md-3-line\"><md-list-item><div class=\"md-list-item-text\"><h4>Purge Product Builder Cache</h4><p class=\"md-caption grey-text\">Purging the cache will refetch the data from the external source and add it to local cache. This operation is safe and failure in purging will not delete any data.</p><p class=\"md-caption slide-up-fade-in\" ng-if=\"state.purgeCacheSuccess || state.purgeCacheError\" ng-class=\"{\'green-text\' : state.purgeCacheSuccess, \'red-text\' : state.purgeCacheError}\">{{state.purgeCacheSuccess ? \'Cache Purged Successfully !\' : \'Error : \'+ state.purgeCacheError}}</p></div><md-button class=\"md-secondary md-warn md-raised small\" ng-disabled=\"state.purgingCache\" ng-click=\"purgeProductBuilderCache($event)\"><span ng-if=\"!state.purgingCache\">Purge Now</span><bubble-loader ng-if=\"state.purgingCache\"></bubble-loader></md-button></md-list-item><md-divider></md-divider><md-list-item><div class=\"md-list-item-text\"><h4>Edit Product Builder Data</h4><p class=\"md-caption grey-text\">Product Builder data is linked to another system and can only be edited there. After editing, make sure that your purge the cache above to make sure the latest changes are visible.</p></div><md-button class=\"md-secondary md-primary md-raised small\" target=\"_blank\" href=\"https://airtable.com/tbl9REmF1zWAIzNBp/viwfpC1113rT3Zrer?blocks=hide\">Edit Cache<md-icon>open_in_new</md-icon></md-button></md-list-item><md-divider></md-divider></md-list></md-content></md-tab><md-tab label=\"Notifications\"><md-content class=\"md-padding\"><md-list><md-list-item><p>Enable Auto Notifications</p><md-checkbox class=\"md-secondary\" ng-model=\"settings.autoNotifications\"></md-checkbox></md-list-item><md-divider></md-divider><md-list-item><p>Sync Duration</p><md-input-container class=\"md-secondary no-error-spacer\"><input type=\"number\" ng-model=\"settings.notificationSyncDuration\"></md-input-container></md-list-item></md-list></md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"close()\">Cancel</md-button><md-button class=\"md-primary outline\" ng-click=\"save()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/base/partials/customisationOption.html","<md-dialog aria-label=\"Customisation Data Creator\" layout=\"\" layout-fill=\"\" flex=\"100\" style=\"min-height: 100%\"><form layout=\"column\" layout-fill=\"\" flex=\"\"><md-toolbar md-colors=\"{\'backgroundColor\' : \'boring-primary-500-1\'}\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"center center\"><h2>Customisation Data Creator</h2><span flex=\"\"></span><div><md-input-container ng-if=\"editName\" class=\"md-block\"><label>Layer Name</label> <input type=\"text\" ng-model=\"newCData.name\"></md-input-container><span ng-if=\"!editName\" class=\"md-title\">{{newCData.name}}</span></div><md-button class=\"md-icon-button\" ng-click=\"editName != editName;\"><md-icon>edit</md-icon></md-button><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content flex=\"\" md-colors=\"{background : \'boring-primary-100-0.2\'}\"></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-warn\" ng-click=\"cancel();\">Cancel</md-button><md-button class=\"md-primary\" ng-click=\"answer()\" style=\"margin-right:20px;\">Done</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/base/partials/mobile-menu.html","<div layout=\"column\"><header flex=\"\" layout-fill=\"\" layout=\"column\" layout-align=\"end end\" style=\"background: url(\'assets/images/mob-nav-bg1.png\') center; background-size: cover; height: 180px; max-height: 180px;\"><span flex=\"\"></span><section layout-align=\"center center\" layout=\"row\" layout-padding=\"\" style=\"width: 100%; background: rgba(1,1,1,0.5)\"><div ng-show=\"isUserLoggedIn\" layout=\"row\" layout-align=\"center center\" style=\"width: 100%;\"><img src=\"assets/images/user.svg\" class=\"md-avatar\" style=\"width: 64px; height: 64px;\" flex=\"30\"><div layout=\"column\" flex=\"\"><span class=\"md-subhead white-text\">{{ currentUser.name }}</span> <span class=\"md-caption white-text\">{{ currentUser.email }}</span></div></div><md-button class=\"md-raised md-accent\" ng-click=\"openLoginModal();\" ng-show=\"!isUserLoggedIn\">Login/SignUp</md-button></section></header><md-content layout=\"column\" layout-fill=\"\" layout-align=\"start start\"><span class=\"md-caption\" layout-margin=\"\">Categories</span><md-divider></md-divider><md-list layout=\"column\" layout-fill=\"\" layout-align=\"start start\"><md-list-item ng-repeat-start=\"category in parentCategories\" layout-fill=\"\" layout-align=\"start start\" ui-sref=\"app.category({categoryName : category.slug})\" ng-click=\"closeSidebar();\"><div flex=\"\" layout=\"row\"><md-icon flex=\"20\" md-svg-src=\"{{ category.svg.normal.urls.thumbnail}}\" style=\"margin-right: 10px;\"></md-icon><span flex=\"\">{{ category.name }}</span></div></md-list-item><md-divider style=\"width: 100%;\" flex=\"\" ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list></md-content></div>");
$templateCache.put("app/modules/base/partials/quickView.html","<div layout=\"column\"><section layout=\"column\" layout-gt-sm=\"row\"><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"40\" layout=\"column\" layout-align=\"start center\"><md-img style=\"width: 100%\" md-src=\"{{selectedImage.urls.large}}\"></md-img><section layout=\"\" layout-align=\"center center\"><md-img class=\"md-margin\" style=\"width: 75px; height: auto;\" ng-repeat=\"image in product.gallery\" ng-click=\"selectImage(image)\" md-src=\"{{image.urls.thumbnail}}\"></md-img></section></div><div flex=\"\" layout-padding=\"\" layout=\"column\"><h4>{{product.name}}</h4><p><i>SKU :</i>{{product.sku}}</p><p ng-class=\"{\'red-text\' : !product.sizeChart}\"><i>Size Chart : {{product.sizeChart ? \'Set\' : \'Not Set\'}}</i></p><div layout=\"\" layout-align=\"start center\" ng-init=\"price = getLowestPrice(product);\"><div ng-if=\"product.productType == 0\"><strike class=\"md-body-1\">{{ \"Rs. \" + price.mrp}}</strike><span style=\"padding-left: 20px;\" class=\"md-title green-text bold-text\">{{ \"Rs. \" + price.salePrice}}</span></div><div ng-if=\"product.productType == 1\"><span class=\"md-body-2\">{{ \"Rs. \" + price}}</span></div><span style=\"margin-left: 24px\">(<span class=\"md-caption\" ng-repeat=\"category in product.categories\">{{category.name}}<span class=\"md-caption\" ng-if=\"!$last\">,</span></span>)</span></div><section class=\"relative\"><div layout=\"\" layout-wrap=\"\" layout-align=\"center center\"><section ng-repeat=\"field in fields\" flex=\"45\" layout=\"\" layout-align=\"space-between center\" style=\"padding: 4px 8px; margin: 4px; border: 1px dashed #efefef\"><p>{{field.title}}</p><md-switch ng-change=\"update()\" class=\"md-primary\" ng-model=\"product[field.model]\"></md-switch></section></div><div class=\"loading-mask\" layout=\"column\" layout-align=\"center center\" ng-if=\"product.updating\"><md-progress-circular></md-progress-circular><h3 class=\"md-title\">Updating Product ...</h3></div></section><div><table class=\"table table-bordered table-striped table-hover\"><caption>Variations</caption><thead><tr><th>Sl.</th><th>Size</th><th>Cost Price</th><th>MSP</th><th>Sale Price</th><th>MRP</th><th>Discount (%)</th><th>Stock</th></tr></thead><tbody><tr ng-repeat=\"variation in product.variations\"><td>{{$index + 1}}.</td><td>{{getVariationValues(variation)}}</td><td>Rs. {{variation.stockAndPrice.price.productionCost}}</td><td>Rs. {{variation.stockAndPrice.price.msp}}</td><td>Rs. {{variation.stockAndPrice.price.salePrice}}</td><td>Rs. {{variation.stockAndPrice.price.mrp}}</td><td>{{(((variation.stockAndPrice.price.mrp - variation.stockAndPrice.price.salePrice) / variation.stockAndPrice.price.mrp) * 100).toFixed(0)}}</td><td>{{variation.stockAndPrice.stock.quantity}}</td></tr></tbody></table></div><div><table class=\"table table-bordered table-striped table-hover\"><caption>Attributes</caption><thead><tr><th>Sl.</th><th>Key</th><th>Values</th><th>Variation</th><th>Visible</th><th>Filters</th><th>Featured</th></tr></thead><tbody><tr ng-init=\"data = getAttributeData(attribute)\" ng-repeat=\"attribute in product.attributes\"><td>{{$index + 1}}.</td><td>{{data.key}}</td><td>{{data.values}}</td><td><md-icon ng-class=\"{\'md-warn\' : !attribute.isVariation, \'green-text\' : attribute.isVariation }\">{{attribute.isVariation ? \'check\' : \'close_circle\'}}</md-icon></td><td><md-icon ng-class=\"{\'md-warn\' : !attribute.visible, \'green-text\' : attribute.visible }\">{{attribute.visible ? \'check\' : \'close_circle\'}}</md-icon></td><td><md-icon ng-class=\"{\'md-warn\' : !attribute.applyFilters, \'green-text\' : attribute.applyFilters }\">{{attribute.applyFilters ? \'check\' : \'close_circle\'}}</md-icon></td><td><md-icon ng-class=\"{\'md-warn\' : !attribute.featured, \'green-text\' : attribute.featured }\">{{attribute.featured ? \'check\' : \'close_circle\'}}</md-icon></td></tr></tbody></table></div></div></section></div>");
$templateCache.put("app/modules/base/partials/toast-template.html","<md-toast class=\"white-background\"><span class=\"md-toast-text\" flex=\"\">Logged In</span></md-toast>");
$templateCache.put("app/modules/base/partials/uploader.html","<md-dialog aria-label=\"Uploader\" flex=\"100\" style=\"height: 100vh;\"><form class=\"uploader\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Uploader</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-tabs md-border-bottom=\"\" md-selected=\"selectedTab\" md-dynamic-height=\"\" md-stretch-tabs=\"always\" md-center-tabs=\"\" md-enable-disconnect=\"\"><md-tab label=\"upload\"><md-content class=\"md-padding\" layout=\"\" style=\"height: 85vh;\"><div ngf-drop=\"\" ngf-select=\"\" ng-model=\"$parent.files\" class=\"drop-box drag-drop\" flex=\"\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-allow-dir=\"false\" accept=\"image/*\" ngf-pattern=\"\'image/*\'\" layout=\"column\" layout-align=\"center center\"><section layout=\"\" layout-align=\"center center\"><img src=\"assets/images/icons/upload.svg\" style=\"width: 150px; height: auto;\"></section><span>Drop images here or click to upload</span></div><div ngf-no-file-drop=\"\">File Drag/Drop is not supported for this browser</div></md-content></md-tab><md-tab label=\"select\"><md-content class=\"md-padding\" style=\"padding-top: 30px;\"><section static-include=\"app/modules/media/partials/media.html\"></section></md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-warn\" ng-click=\"cancel();\">Cancel</md-button><md-button class=\"md-primary\" ng-click=\"answer()\" style=\"margin-right:20px;\">Done</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/base/services/critical-setting-change-confirm-dialog.tmpl.html","<md-dialog flex=\"50\"><md-toolbar ng-class=\"options.headerClass\"><div class=\"md-toolbar-tools\"><h2>{{options.title}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"close(false)\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><form name=\"privateForm\"><md-dialog-content><div layout=\"column\" layout-align=\"center center\" layout-margin=\"\" layout-padding=\"\"><section layout=\"column\" layout-align=\"center center\"><span class=\"md-body-1\">{{options.description}}</span><div ng-if=\"options.infoMessage\" class=\"md-margin\"><p class=\"md-tiny\">(<span class=\"red-text\">{{options.infoMessage}}</span>)</p></div></section><div layout=\"\" layout-align=\"center center\" layout-padding=\"\"><span>Please type</span><pre style=\"margin: 0\">{{options.inputValidatorString}}</pre><span>in the box below to change the value</span></div><md-input-container class=\"md-block\"><input md-maxlength=\"{{entity.length}}\" ng-model=\"entity1\" name=\"collectionName\" type=\"text\" ng-required=\"\" placeholder=\"Type {{options.inputValidatorString}}\"></md-input-container></div></md-dialog-content><md-dialog-actions md-colors=\"{\'background\':\'primary-50-0.2\'}\"><div layout=\"\" layout-align=\"space-around center\" flex=\"\"><md-button class=\"md-primary\" ng-click=\"close(false)\">{{options.cancelText}}</md-button><md-button class=\"md-warn\" ng-disabled=\"entity1 !== entity\" ng-click=\"close(true)\">{{options.confirmText}}</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/campaign/partials/index.html","<div><section layout=\"column\"><h3 class=\"center-text\">Email Campaign</h3><md-card><md-card-content><form name=\"campaignForm\"><md-input-container class=\"md-block\"><label>Email Ids (Comma Seperated for mutilpes)</label> <textarea required=\"\" rows=\"2\" type=\"text\" name=\"emails\" ng-model=\"campaign.emailList\"></textarea></md-input-container><md-input-container class=\"md-block\"><label>Subject</label> <input required=\"\" type=\"text\" name=\"subject\" ng-model=\"campaign.subject\"></md-input-container><md-input-container class=\"md-block\"><label>Message</label> <textarea md-detect-hidden=\"\" required=\"\" rows=\"8\" name=\"message\" ng-model=\"campaign.message\"></textarea></md-input-container><section layout=\"\" layout-align=\"center center\"><md-button type=\"submit\" role=\"submit\" ng-click=\"sendMails();\" class=\"md-raised md-accent\" ng-disabled=\"campaignForm.$invalid || sendingMails\" style=\"width: 200px;\"><div layout=\"\" layout-align=\"center center\"><span class=\"md-caption\">{{sendingMails ? \"Sending Mails..\" : \"Send Mail \"}}</span><section layout=\"\" layout-align=\"center center\" style=\"margin-left: 10px;\"><md-icon ng-if=\"!sendingMails\">send</md-icon><md-progress-circular md-diameter=\"24\" ng-if=\"sendingMails\"></md-progress-circular></section></div></md-button></section></form></md-card-content></md-card></section></div>");
$templateCache.put("app/modules/cart/partials/all.html","<div><div layout=\"\" layout-align=\"center center\"><h1>Active Carts</h1></div><md-card style=\"margin: 0 32px;\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools scrolling-tabs\" layout=\"\" layout-align=\"space-between center\" style=\"background: #ebebee\"><div layout=\"\" layout-align=\"start center\" flex=\"\"><span ng-if=\"!selected.length\" style=\"margin-right: 20px\">User Carts</span><section layout=\"\" layout-align=\"start center\" ng-if=\"selected.length\"><md-button class=\"md-icon-button material-icons--two-tone\" ng-click=\"clearSelections()\"><md-icon>close</md-icon></md-button><span class=\"md-tiny\">{{selected.length}} Carts Selected</span></section><span ng-if=\"selected.length\" flex-offset=\"5\"></span><form role=\"form\" novalidate=\"\" name=\"filterForm\" flex-offset=\"5\" ng-submit=\"searchUser(userSearch)\" layout=\"\" layout-align=\"center center\"><md-input-container flex=\"\" class=\"no-error-spacer\" layout=\"\"><label>&nbsp;</label> <input type=\"search\" id=\"cartSearch\" ng-model=\"userSearch\" select-on-click=\"\" ng-model-options=\"{\'debounce\' : 500}\" ng-change=\"searchUser(userSearch)\" placeholder=\"Search Carts\" class=\"search-bar-input\"></md-input-container><md-button ng-click=\"searchUser(userSearch)\" class=\"md-icon-button\"><md-icon>search</md-icon></md-button></form></div><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-primary md-fab md-mini\" ui-sref=\"app.pos.cart\"><md-icon>add</md-icon><md-tooltip class=\"white-text\">Create New Cart</md-tooltip></md-button></div></div><div class=\"md-toolbar-tools scrolling-tabs toolbar-show\" ng-show=\"selected.length\" style=\"background: #ebebee\" layout=\"\" layout-align=\"start center\"><md-button class=\"small md-primary\" ng-click=\"sendBulkNotifications($event)\"><md-icon>message</md-icon><span>Notify Customers</span></md-button></div></md-toolbar><md-table-pagination mdboundarylinks=\"\" md-limit=\"query.limit\" md-limit-options=\"[5, 10, 25, 50,100]\" md-page=\"query.page\" md-total=\"{{total}}\" md-on-paginate=\"getAllCarts\" md-page-select=\"\"></md-table-pagination><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.sort\" md-on-reorder=\"getAllCarts\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\"></th><th md-column=\"\">User</th><th md-column=\"\" md-numeric=\"\"><span>Mobile</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"length\"><span>Prod. #</span></th><th md-column=\"\" md-order-by=\"status\"><span>Amount</span></th><th md-column=\"\" md-order-by=\"status\"><span>Status</span></th><th md-column=\"\" md-order-by=\"createdAt\"><span>Created</span></th><th md-column=\"\" md-order-by=\"updatedAt\"><span>Last Modified</span></th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"cart\" md-auto-select=\"\" ng-repeat=\"cart in carts\"><td md-cell=\"\">{{ (((query.page - 1) * query.limit) + $index) + 1}}.</td><td md-cell=\"\"><a class=\"md-link pointer\" ui-sref=\"app.users.details.cart({userId : cart.user._id})\">{{cart.user.name}}</a></td><td md-cell=\"\">{{cart.user.mobile}}</td><td md-cell=\"\"><a class=\"md-link pointer\" ng-click=\"showProductListDialog(cart, $event)\">{{cart.length}}</a></td><td md-cell=\"\">₹ {{cart.amount}}</td><td md-cell=\"\">{{cart.status}}</td><td md-cell=\"\"><span class=\"md-tiny\">{{cart.createdAt | date : \"medium\"}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{cart.updatedAt | date : \"medium\"}}</span></td><td md-cell=\"\"><span layout=\"row\"><md-button class=\"outline small\" ui-sref=\"app.pos.cart({userId : cart.user._id || cart.user})\">Process</md-button><md-button class=\"md-icon-button\" ng-disabled=\"!cart.length\" ng-click=\"openNotifications([cart],$event);\"><md-icon class=\"md-primary\">message</md-icon><md-tooltip md-direction=\"bottom\">Notify Customer</md-tooltip></md-button></span></td></tr></tbody></table></md-table-container><md-table-pagination mdboundarylinks=\"\" md-limit=\"query.limit\" md-limit-options=\"[5, 10, 25, 50,100]\" md-page=\"query.page\" md-total=\"{{total}}\" md-on-paginate=\"getAllCarts\" md-page-select=\"\"></md-table-pagination></md-card></div>");
$templateCache.put("app/modules/components/notifications/notification-template-builder.dialog.html","<md-dialog flex=\"60\" class=\"notification-template-builder\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\"><h2>{{editing? \'Edit \' : \'Add \'}} Template</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><md-input-container class=\"md-block\"><label>Template Title</label> <input type=\"text\" ng-model=\"template.title\" required=\"\" md-maxlength=\"20\"></md-input-container><div layout=\"\" layout-align=\"start center\" class=\"md-padding tags-container\"><strong flex=\"10\" class=\"md-caption\">Tags</strong><div layout=\"\" layout-align=\"start center\" layout-wrap=\"\"><md-button class=\"md-primary small\" ng-repeat=\"tag in templateTags\" ng-click=\"applyTag(tag)\">{{tag.title}}</md-button></div></div><md-input-container class=\"md-block flex\"><label>Template Content</label> <textarea append-text=\"\" ng-model=\"template.content\" ng-trim=\"true\" rows=\"3\" md-maxlength=\"480\" placeholder=\"Use tags to build out your message.. eg: Hey \'{{userName}}\'.\">\n            </textarea></md-input-container></md-dialog-content><md-dialog-actions md-colors=\"{\'background\' : \'primary-50-1\'}\" layout-align=\"space-between center\"><md-button ng-click=\"cancel()\" ng-disabled=\"!template.content\" class=\"md-warn md-raised\">Cancel</md-button><md-button ng-click=\"save()\" ng-disabled=\"!template.content || !template.title\" class=\"md-primary md-raised\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/components/notifications/user-notifications.html","<md-dialog flex=\"90\" class=\"user-notifications-dialog\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\"><h2>Send Notification</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><md-tabs class=\"md-accent md-hue-1\" md-selected=\"selectedIndex\" md-border-bottom=\"\" md-center-tab=\"\" md-dynamic-height=\"\" md-stretch-tabs=\"always\"><md-tab label=\"Sms\" md-on-select=\"onTabChange(0)\"><md-tab-label><md-icon class=\"md-primary\">message</md-icon>SMS</md-tab-label><md-tab-body><div layout=\"column\" class=\"md-padding\"><md-content md-scroll-x=\"\" class=\"scrolling-tabs\" ng-if=\"orders.length\"><md-button class=\"custom-tab\" ng-repeat=\"order in orders\" ng-class=\"{\'active\' : selectedOrder.id === order.id}\" ng-click=\"selectOrder(order)\"><div layout=\"column\" layout-align=\"center center\"><span class=\"md-caption\">{{order.user.name}}</span> <span class=\"md-tiny\">{{order.user.mobile}}</span></div></md-button></md-content><md-toolbar class=\"md-warn\" ng-if=\"!selectedOrder.smsAllowed\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"center center\"><span class=\"md-caption\">SMS Notification Disabled because {{selectedOrder.user.mobile}} is not a valid Mobile Number</span></div></md-toolbar><div layout=\"\" layout-align=\"space-between center\"><span>{{ selectedOrder.user.name }} : {{ selectedOrder.user.mobile }}</span><md-input-container class=\"no-error-spacer\"><md-switch ng-model=\"showEditButton\">Edit Templates</md-switch></md-input-container></div><div layout=\"\" layout-align=\"start center\" class=\"md-padding tags-container\"><strong flex=\"10\" class=\"md-caption\">Templates</strong><div layout=\"\" layout-align=\"start center\" layout-wrap=\"\"><md-button ng-repeat-start=\"tag in templates\" ng-click=\"applyTag(tag,\'sms\')\" ng-disabled=\"showEditButton\" class=\"md-primary outline small round\" ng-class=\"{\'md-raised\' : smsActiveTag === tag.title}\">{{tag.title}}</md-button><span ng-repeat-end=\"\"><md-button class=\"md-icon-button small md-primary\" ng-if=\"showEditButton\" ng-click=\"$event.stopPropagation();openTemplateEditor($event, tag, $index)\"><md-icon>edit</md-icon></md-button></span><md-button class=\"md-primary outline small round\" ng-click=\"openTemplateEditor($event)\"><md-icon>add</md-icon><span>Add Template</span></md-button></div></div><div layout=\"\" layout-align=\"start center\" class=\"md-padding tags-container\"><strong flex=\"10\" class=\"md-caption\">Tags</strong><div layout=\"\" layout-align=\"start center\" layout-wrap=\"\"><md-button class=\"md-primary\" ng-repeat=\"tag in templateTags\" ng-click=\"applyTag(tag,\'sms\')\">{{tag.title}}</md-button></div></div><div layout=\"\"><md-datepicker ng-model=\"newDeliveryDate\" md-placeholder=\"Enter New Delivery Date\" ng-change=\"applyDateInterpolation(\'sms\')\" ng-show=\"smsActiveTag === \'Order Delayed\'\"></md-datepicker><div layout=\"\" layout-align=\"center center\" ng-show=\"showOfferSelection\"><span class=\"md-tiny md-padding\">Applied Offer:</span><md-select style=\"min-width: 300px\" ng-model=\"appliedOffer\" ng-change=\"applyOfferInterpolation(\'sms\')\" md-on-open=\"fetchOffers()\" placeholder=\"Select Offer\"><md-option ng-repeat=\"offer in offers\" ng-value=\"offer\"><div layout=\"column\" layout-align=\"center start\"><span class=\"md-tiny grey-text\">{{ offer.couponCode }}</span> <span class=\"md-caption\">{{ offer.discountText }}</span></div></md-option></md-select></div></div><div layout=\"row\" class=\"md-padding\" ng-if=\"currentTab === 0\"><md-input-container class=\"md-block flex\" ng-if=\"!isTemplateEditorOpen\"><textarea append-text=\"\" ng-model=\"selectedOrder.smsText\" ng-trim=\"true\" rows=\"3\" md-maxlength=\"480\" placeholder=\"Message\"></textarea></md-input-container><md-input-container class=\"md-block flex\" ng-if=\"isTemplateEditorOpen\"><textarea ng-model=\"selectedOrder.smsText\" ng-trim=\"true\" rows=\"3\" md-maxlength=\"480\" placeholder=\"Message\"></textarea></md-input-container><div layout=\"\" layout-align=\"center center\" class=\"feedback\"></div></div><h3 class=\"center-text\">Latest 4 Notifications</h3><div layout=\"\" class=\"scrolling-tabs\"><bubble-loader ng-if=\"loadingOldNotifications\"></bubble-loader><div ng-repeat=\"notification in oldNotifications\" ng-if=\"!loadingOldNotifications\" style=\"min-width: 300px\"><md-card flex=\"\" class=\"pointer relative\"><md-card-content><p class=\"md-tiny\" style=\"text-align: justify\">{{truncate(notification.message, { \'length\': 160})}}</p></md-card-content><md-card-actions layout=\"\" layout-align=\"space-between center\"><span class=\"md-tiny\">{{notification.sentAt | date : \'medium\'}}</span> <span class=\"md-caption\">By {{notification.sentBy.name}}</span></md-card-actions><md-tooltip class=\"mega-tooltip\" md-direction=\"right\"><p>{{notification.message}}</p></md-tooltip></md-card></div></div></div></md-tab-body></md-tab><md-tab label=\"Whatsapp\" md-on-select=\"onTabChange(1)\" ng-if=\"orders.length === 1\"><md-tab-label><md-icon md-svg-src=\"assets/images/whatsapp.svg\"></md-icon>WhatsApp</md-tab-label><md-tab-body><div layout=\"column\" class=\"md-padding\"><div layout=\"row\" layout-align=\"center stretch\"><p>{{ selectedOrder.user.name }} : {{ selectedOrder.user.mobile }}</p></div><md-toolbar class=\"md-warn\" ng-if=\"!smsAllowed\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"center center\"><span class=\"md-caption\">SMS Notification Disabled because {{selectedOrder.user.mobile}} is not a valid Mobile Number</span></div></md-toolbar><div layout=\"\" layout-align=\"start center\" class=\"md-padding tags-container\"><strong flex=\"10\" class=\"md-caption\">Templates</strong><div layout=\"\" layout-align=\"start center\" layout-wrap=\"\"><md-button ng-repeat=\"tag in templates\" ng-click=\"applyTag(tag,\'sms\')\" class=\"md-primary outline small round\" ng-class=\"{\'md-raised\' : smsActiveTag === tag.title}\">{{tag.title}}</md-button></div></div><div layout=\"\" layout-align=\"start center\" class=\"md-padding tags-container\"><strong flex=\"10\" class=\"md-caption\">Tags</strong><div layout=\"\" layout-align=\"start center\" layout-wrap=\"\"><md-button class=\"md-primary\" ng-repeat=\"tag in templateTags\" ng-click=\"applyTag(tag,\'sms\')\">{{tag.title}}</md-button></div></div><div layout=\"\"><md-datepicker ng-model=\"newDeliveryDate\" md-placeholder=\"Enter New Delivery Date\" ng-change=\"applyDateInterpolation(\'sms\')\" ng-show=\"smsActiveTag === \'Order Delayed\'\"></md-datepicker><div layout=\"\" layout-align=\"center center\" ng-show=\"(smsActiveTag === \'Cart Reminder - 1\' || smsActiveTag === \'Cart Reminder - 2\') && showOfferSelection\"><span class=\"md-tiny md-padding\">Applied Offer:</span><md-select style=\"min-width: 300px\" ng-model=\"appliedOffer\" ng-change=\"applyOfferInterpolation(\'sms\')\" md-on-open=\"fetchOffers()\" placeholder=\"Select Offer\"><md-option ng-repeat=\"offer in offers\" ng-value=\"offer\"><div layout=\"column\" layout-align=\"center start\"><span class=\"md-tiny grey-text\">{{ offer.couponCode }}</span> <span class=\"md-caption\">{{ offer.discountText }}</span></div></md-option></md-select></div></div><div layout=\"row\" class=\"md-padding\" ng-if=\"currentTab === 1\"><md-input-container class=\"md-block flex\"><textarea append-text=\"\" ng-model=\"selectedOrder.smsText\" ng-trim=\"true\" rows=\"3\" md-maxlength=\"999\" placeholder=\"Message\"></textarea></md-input-container><div layout=\"\" layout-align=\"center center\" class=\"feedback\"></div></div></div></md-tab-body></md-tab><md-tab label=\"Email\" md-on-select=\"onTabChange(2)\" ng-if=\"orders.length === 1\"><md-tab-label><md-icon class=\"md-primary\">email</md-icon>Email</md-tab-label><md-tab-body><div layout=\"column\" class=\"md-padding\"><div layout=\"row\" layout-align=\"center stretch\"><p><md-icon class=\"md-boring-theme material-icons\" role=\"img\" aria-label=\"person\">person</md-icon>{{ selectedOrder.user.name }}</p><p><md-icon class=\"md-boring-theme material-icons\" role=\"img\" aria-label=\"person\">email</md-icon>{{ selectedOrder.user.email }}</p></div><md-toolbar class=\"md-warn\" ng-if=\"!emailAllowed\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"center center\"><span class=\"md-caption\">Email Notification Disabled because {{selectedOrder.user.email}} is not a valid Email</span></div></md-toolbar><md-input-container><label>Recepients</label><md-contact-chips ng-model=\"selectedOrder.tagCtxVars.emailTo\" md-contacts=\"queryUsers($query)\" md-contact-name=\"name\" md-contact-image=\"profileImageURL\" md-contact-email=\"email\" md-require-match=\"true\" md-highlight-flags=\"i\" placeholder=\"Enter Recepients\" secondary-placeholder=\"Add another contact\" input-aria-label=\"Intended Recipients\"></md-contact-chips></md-input-container><md-input-container><label>CC</label><md-contact-chips ng-model=\"selectedOrder.tagCtxVars.emailCC\" md-contacts=\"queryUsers($query)\" md-contact-name=\"name\" md-contact-image=\"profileImageURL\" md-contact-email=\"email\" md-require-match=\"true\" md-highlight-flags=\"i\" placeholder=\"Search users\" secondary-placeholder=\"Add another contact\" input-aria-label=\"Intended Recipients\"></md-contact-chips></md-input-container><md-input-container><label>BCC</label><md-contact-chips ng-model=\"selectedOrder.tagCtxVars.emailBCC\" md-contacts=\"queryUsers($query)\" md-contact-name=\"name\" md-contact-image=\"profileImageURL\" md-contact-email=\"email\" md-require-match=\"true\" md-highlight-flags=\"i\" placeholder=\"Search User\" secondary-placeholder=\"Add another contact\" input-aria-label=\"Intended Recipients\"></md-contact-chips></md-input-container><md-input-container flex=\"100\" class=\"no-error-spacer\" ng-show=\"!smsActiveTagObject.disableSubject\"><label>Subject</label> <input ng-model=\"selectedOrder.tagCtxVars.emailSubject\" type=\"text\" placeholder=\"Subject...\" class=\"search-bar-input\"></md-input-container><div layout=\"column\" layout-align=\"center center\" ng-show=\"!smsActiveTagObject.disableEmail\"><md-input-container class=\"md-block\" flex=\"\"><text-angular ng-model=\"selectedOrder.tagCtxVars.emailText\" required=\"\"></text-angular></md-input-container><div layout=\"\" layout-align=\"center center\" class=\"feedback\"></div></div><div layout=\"column\" layout-align=\"center center\" ng-show=\"smsActiveTagObject.templateData\"><p>{{smsActiveTagObject.templateData && smsActiveTagObject.templateData.text}}</p></div></div></md-tab-body></md-tab></md-tabs></md-dialog-content><md-dialog-actions md-colors=\"{\'background\' : \'primary-50-1\'}\"><md-select ng-model=\"smsType\" ng-show=\"currentTab === 0\"><md-option ng-value=\"\'promotional\'\">Promotional</md-option><md-option ng-value=\"\'transactional\'\">Transactional</md-option></md-select><md-button ng-if=\"currentTab === 0\" ng-click=\"sendSmsNotification()\" ng-disabled=\"sendingSms || !selectedOrder.smsText\" class=\"md-primary md-raised\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!sendingSms\">Send Message</span><md-progress-circular md-diameter=\"20\" ng-if=\"sendingSms\"></md-progress-circular></div></md-button><md-button ng-if=\"currentTab === 1\" ng-disabled=\"!selectedOrder.smsText\" class=\"md-primary md-raised\" ng-click=\"openWhatsAppWindow()\">Send WhatsApp Message<md-icon>open_in_new</md-icon></md-button><md-button ng-if=\"currentTab === 2\" ng-click=\"sendEmailNotification()\" class=\"md-primary md-raised\" ng-disabled=\"!emailAllowed && emailText && sendingEmail\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!sendingEmail\">Send Email</span><md-progress-circular md-diameter=\"20\" ng-if=\"sendingEmail\"></md-progress-circular></div></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/customisation/partials/index.html","<md-section-header md-section-title=\"{{pageTitle}}\" md-back-state=\"{{backState}}\" md-nested-state=\"nestedState\"><md-button class=\"md-raised\" ng-click=\"onActionButtonClick($event);\" ng-if=\"showActionButton && !actionButtonDisabled.$$state.pending\">{{actionButtonText}}</md-button><md-progress-circular ng-if=\"actionButtonDisabled.$$state.pending\" md-mode=\"indeterminate\" md-diameter=\"40\" class=\"md-accent\"></md-progress-circular></md-section-header><form ng-disabled=\"actionButtonDisabled.$$state.pending\" style=\"padding: 2%; margin-top: -60px; z-index: 1\"><div ui-view=\"\"></div></form>");
$templateCache.put("app/modules/collections/modals/edit-collection.tmpl.html","<md-dialog aria-label=\"editCollectionDialog block\" flex-gt-sm=\"60\"><form ng-cloak=\"\" name=\"editCollectionDialog\"><md-toolbar md-colors=\"{\'backgroundColor\' : \'boring-accent-500-1\'}\"><div class=\"md-toolbar-tools\"><h2>{{ editingMode ? \'Edit Collection\' : \'Add New Collection\'}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" layout-padding=\"\" layout-margin=\"\" style=\"padding-top: 20px;\"><div layout=\"\"><md-input-container flex=\"\" class=\"md-block\"><label>Name</label> <input type=\"text\" name=\"name\" ng-model=\"collection.name\" ng-change=\"updateName()\"></md-input-container><md-input-container flex=\"\" class=\"md-block\"><label>Slug</label> <input type=\"text\" name=\"slug\" ng-model=\"collection.slug\"></md-input-container><md-input-container flex=\"\" class=\"md-block\"><label>Current Status</label><md-select ng-model=\"collection.currentStatus\"><md-option ng-value=\"option.value\" ng-repeat=\"option in [ {name : \'Active\', value : 1}, {name : \'Scheduled\', value : 0}, {name : \'Expired\', value : -1}]\">{{option.name}}</md-option></md-select></md-input-container></div><div layout=\"\" layout-align=\"center center\"><md-switch ng-model=\"collection.public\" ng-change=\"changePrivateField($event)\">Make Collection Public</md-switch></div><div layout=\"\"><md-input-container flex=\"\" class=\"md-block\"><md-checkbox ng-model=\"collection.showOnHomePage\">Show On Home Page</md-checkbox></md-input-container><md-datepicker flex=\"\" ng-model=\"collection.startDate\" md-placeholder=\"Start date\"></md-datepicker><md-datepicker flex=\"\" ng-model=\"collection.expires\" md-placeholder=\"Expiry date\"></md-datepicker></div><div layout=\"\"><div flex=\"\" layout=\"column\" layout-align=\"center center\"><span class=\"md-subhead\" style=\"text-align: center; padding: 8px;\">Header Image</span><div ng-click=\"openSingleUploader($event,0)\" class=\"pointer\" flex=\"\" style=\"border: 1px dashed grey; width: 256px; height: 120px; background: rgba(169,169,169,0.15);\" layout=\"\"><div ng-if=\"!collection.headerImage\" layout=\"column\" layout-margin=\"\" flex=\"\"><span flex=\"\"></span><div layout=\"column\"><md-icon>add</md-icon><span style=\"text-align: center\">Add Header Image</span> <span style=\"text-align: center\">(Click here)</span></div><span flex=\"\"></span></div><div ng-if=\"collection.headerImage\" layout=\"\" layout-align=\"center center\" flex=\"\"><md-img md-src=\"{{ collection.headerImage.urls.h_thumbnail}}\"></md-img></div></div></div><div flex=\"\" layout=\"column\" layout-align=\"center center\"><span class=\"md-subhead\" style=\"text-align: center; padding: 8px;\">Featured Image</span><div ng-click=\"openSingleUploader($event,1)\" class=\"pointer\" flex=\"\" style=\"border: 1px dashed grey; background: rgba(169,169,169,0.15); width: 256px; height: 120px\" layout=\"\"><div ng-if=\"!collection.image\" layout=\"column\" layout-margin=\"\" flex=\"\"><span flex=\"\"></span><div layout=\"column\"><md-icon>add</md-icon><span style=\"text-align: center\">Add Image</span> <span style=\"text-align: center\">(Click here)</span></div><span flex=\"\"></span></div><div ng-if=\"collection.image\" layout=\"\" layout-align=\"center center\" flex=\"\"><md-img md-src=\"{{ collection.image.urls.h_thumbnail}}\"></md-img></div></div></div></div></md-dialog-content><md-dialog-actions style=\"background: rgba(1,1,1,0.03)\"><md-button class=\"md-warn md-raised\" ng-click=\"cancel();\">CANCEL</md-button><span flex=\"\"></span><md-button ng-disabled=\"editCollectionDialog.$invalid\" type=\"submit\" class=\"md-raised md-accent\" ng-click=\"saveCollection();\">{{editingMode ? \"Edit\" : \"Save\"}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/collections/modals/manage-products.tmpl.html","<div class=\"md-dialog-container\" id=\"addProductsDialog\"><md-dialog aria-label=\"addProductsDialog block\" class=\"addProductsDialog\" flex=\"90\"><form ng-cloak=\"\" name=\"addProductsDialog\" class=\"addProductsDialogForm\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\"><h2>{{pageTitle}}{{collection.name}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"resetState()\"><md-icon aria-label=\"Close dialog\">refresh</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\"><md-icon aria-label=\"Refresh\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"add-products-dialog-content\"><div layout=\"column\" class=\"manage-collection-container\"><div layout=\"\" layout-align=\"center start\" class=\"rules-container\"><section flex=\"70\" class=\"left-section\"><md-toolbar class=\"md-action md-hue-3\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h4 class=\"center-text\">Rules</h4><md-button ng-click=\"addQuery()\" class=\"md-accent outline\"><md-icon>add</md-icon>Add Rule</md-button></div></md-toolbar><md-divider></md-divider><div layout=\"\" ng-repeat=\"query in collection.rules.queries\" class=\"single-rule-item md-whiteframe-1dp\" ng-class=\"{\'inactive\' : !query.enabled}\"><section layout=\"\" flex=\"\"><md-input-container flex=\"25\" class=\"no-error-spacer\"><label>Select Entity</label><md-select ng-model=\"query.entity\" ng-change=\"selectEntity(query);\"><md-option ng-value=\"entity.value\" ng-repeat=\"entity in queryEntities | orderBy : \'name\'\">{{entity.name}}</md-option></md-select></md-input-container><md-input-container flex=\"33\" class=\"no-error-spacer\" ng-if=\"query.entity !== \'attributes.selectedValues\'\"><label>Select Operand</label><md-select ng-model=\"query.operand\" ng-change=\"selectEntity(query); refetchPreview()\"><md-option ng-value=\"op.value\" ng-repeat=\"op in query.selectedEntity.operands\">{{op.name}}</md-option></md-select></md-input-container><md-input-container class=\"no-error-spacer\" flex=\"25\" ng-if=\"query.selectedEntity.inputType === \'text\' || query.selectedEntity.inputType === \'number\'\"><label>Value</label> <input ng-change=\"refetchPreview()\" ng-model-options=\"{\'debounce\' : 500}\" type=\"{{query.selectedEntity.inputType}}\" ng-model=\"query.value\"></md-input-container><md-input-container flex=\"\" class=\"no-error-spacer\" ng-if=\"query.entity === \'categories\' && (query.selectedOperand.value === \'$in\' || query.selectedOperand.value === \'$nin\')\"><label>Select Categories</label><md-select flex=\"\" ng-required=\"\" data-md-container-class=\"selectdemoSelectHeader\" ng-model=\"query.values\" ng-change=\"refetchPreview()\" multiple=\"\"><md-select-header class=\"demo-select-header\"><input ng-model=\"categorySearch\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search for a category..\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-value=\"category._id\" ng-repeat=\"category in categories | filter:categorySearch\">{{category.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" class=\"no-error-spacer\" ng-show=\"query.entity === \'categories\' && (query.selectedOperand.value === \'$eq\' || query.selectedOperand.value === \'$ne\')\"><label>Select Category</label><md-select flex=\"\" ng-required=\"\" data-md-container-class=\"selectdemoSelectHeader\" ng-model=\"query.value\" ng-change=\"refetchPreview()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"categorySearch\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search for a category..\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-value=\"category._id\" ng-repeat=\"category in categories | filter:categorySearch | orderBy : \'name\'\">{{category.name}}</md-option></md-select></md-input-container><md-contact-chips ng-model=\"query.values\" md-autocomplete-snap=\"\" flex=\"\" ng-show=\"query.entity === \'_id\' && (query.selectedOperand.value === \'$in\' || query.selectedOperand.value === \'$nin\')\" ng-change=\"refetchPreview()\" md-contact-name=\"name\" md-contact-email=\"sku\" md-min-length=\"2\" placeholder=\"Search for products by Name, SKU\" secondary-placeholder=\"Search for products\" md-contact-image=\"image\" md-require-match=\"true\" md-contacts=\"fetchProducts($query)\" input-aria-label=\"Favorite Products\" class=\"md-block full-width\"></md-contact-chips><md-input-container flex=\"\" class=\"no-error-spacer\" ng-show=\"query.entity === \'materials\' && (query.selectedOperand.value === \'$in\' || query.selectedOperand.value === \'$nin\')\"><label>Select Materials</label><md-select flex=\"\" ng-required=\"\" data-md-container-class=\"selectdemoSelectHeader\" ng-model=\"query.values\" ng-change=\"refetchPreview()\" multiple=\"\"><md-select-header class=\"demo-select-header\"><input ng-model=\"$parent.materialSerach\" ng-change=\"fetchMaterials()\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search for a Material..\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-value=\"material._id\" ng-repeat=\"material in materials\"><img style=\"width: 22px; height: 31px;\" ng-if=\"material.image && material.image.urls\" ng-src=\"{{mediaUrl + material.image.urls.thumbnail}}\" alt=\"{{material.name}}\"> {{material.name}} <span flex=\"\"></span></md-option></md-select></md-input-container><md-input-container flex=\"\" class=\"no-error-spacer\" ng-show=\"query.entity=== \'productType\' && (query.selectedOperand.value === \'$eq\' || query.selectedOperand.value === \'$ne\')\"><label>Select Product Type</label><md-select flex=\"\" ng-required=\"\" ng-model=\"query.value\" ng-change=\"refetchPreview()\"><md-option ng-repeat=\"productType in query.selectedEntity.selectValues\" ng-value=\"productType.value\">{{ productType.name }}</md-option></md-select></md-input-container><md-input-container flex=\"\" class=\"no-error-spacer\" ng-if=\"(query.entity=== \'createdAt\' || query.entity=== \'updatedAt\'|| query.entity=== \'notes.date\') && query.selectedEntity.inputType === \'date\'\"><label>Select Date</label><md-datepicker ng-change=\"refetchPreview()\" ng-model=\"query.value\"></md-datepicker></md-input-container><md-input-container flex=\"\" ng-show=\"query.entity=== \'editorType\'\"><label>Select Editor</label><md-select flex=\"\" ng-required=\"\" ng-model=\"query.value\" ng-change=\"changeValTypeOnSelection(query.value,query);refetchPreview()\"><md-option ng-repeat=\"editor in query.selectedEntity.selectValues\" ng-value=\"editor.value\">{{ editor.name }}</md-option></md-select></md-input-container><md-input-container flex=\"\" class=\"no-error-spacer\" ng-if=\"query.entity=== \'attributes.selectedValues\'\"><label>Select Attribute</label><md-select flex=\"\" ng-required=\"\" data-md-container-class=\"selectdemoSelectHeader\" ng-model=\"query.value\" ng-change=\"fetchAttributeValue(query.value, query)\"><md-select-header class=\"demo-select-header\"><input ng-model=\"attributeSearch\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search for an Attribute Name..\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"attribute in attributes | orderBy : \'meta_key\' | filter :attributeSearch\" ng-value=\"attribute._id\">{{ attribute.meta_key }}</md-option></md-select></md-input-container><md-input-container flex=\"\" class=\"no-error-spacer\" ng-if=\"query.entity=== \'attributes.selectedValues\'\"><label>Select Operand</label><md-select ng-model=\"query.operand\" ng-change=\"selectEntity(query); refetchPreview()\"><md-option ng-value=\"op.value\" ng-repeat=\"op in query.selectedEntity.operands\">{{op.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" class=\"no-error-spacer\" ng-if=\"query.entity=== \'attributes.selectedValues\'\"><label>Select Attribute Value</label><md-select flex=\"\" ng-required=\"\" data-md-container-class=\"selectdemoSelectHeader\" ng-model=\"query.values\" ng-change=\"refetchPreview()\" multiple=\"\"><md-select-header class=\"demo-select-header\"><input ng-model=\"attributeValueSearch\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search for an attribute value..\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"attributeValue in query.selectValues2 | orderBy : \'value\' | filter : attributeValueSearch\" ng-value=\"attributeValue._id\">{{ attributeValue.value }}</md-option></md-select></md-input-container><md-input-container flex=\"\" class=\"no-error-spacer\" ng-if=\"query.entity === \'created_by\' && (query.selectedOperand.value === \'$eq\' || query.selectedOperand.value === \'$ne\')\"><label>Select User</label><md-select flex=\"\" ng-required=\"\" ng-model=\"query.value\" ng-change=\"refetchPreview();\"><md-option ng-value=\"user._id\" ng-repeat=\"user in users\">{{user.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" class=\"no-error-spacer\" ng-if=\"query.entity === \'created_by\' && (query.selectedOperand.value === \'$in\' || query.selectedOperand.value === \'$nin\')\"><label>Select User</label><md-select flex=\"\" ng-required=\"\" ng-model=\"query.values\" ng-change=\"refetchPreview();\"><md-option ng-value=\"user._id\" ng-repeat=\"user in users\">{{user.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\" class=\"no-error-spacer\" ng-if=\"query.entity === \'visibility\'\"><label>Select Visibility</label><md-select flex=\"\" ng-required=\"\" ng-model=\"query.value\" ng-change=\"refetchPreview();\"><md-option ng-value=\"value.value\" ng-repeat=\"value in query.selectedEntity.selectValues\">{{value.name}}</md-option></md-select></md-input-container><div flex=\"\" ng-if=\"[\'published\', \'isOnSale\', \'outOfStock\', \'comingSoon\', \'isFeatured\', \'sizeChart\'].includes(query.entity)\"><md-input-container class=\"no-error-spacer\" style=\"width: 100%\"><label>Select Value</label><md-select flex=\"\" ng-required=\"\" ng-model=\"query.value\" ng-change=\"refetchPreview();\"><md-option ng-value=\"value.value\" ng-repeat=\"value in query.selectedEntity.selectValues\">{{value.name}}</md-option></md-select></md-input-container></div></section><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button no-margin\" ng-click=\"addQuery($index)\"><md-icon>add</md-icon><md-tooltip>Add Query In Next Row</md-tooltip></md-button><md-button class=\"md-icon-button md-warn no-margin\" ng-click=\"removeQuery($index, $event)\"><md-icon>delete</md-icon><md-tooltip>Delete Query</md-tooltip></md-button><md-switch ng-model=\"query.enabled\" ng-change=\"refetchPreview()\"><md-tooltip>{{query.enabled ? \'Query Enabled\' : \'Query Disabled\'}}</md-tooltip></md-switch></div></div><section class=\"md-padding md-margin\" ng-if=\"!collection.rules.queries.length\" layout=\"column\" layout-align=\"center center\"><h4>No rules configured</h4><p class=\"grey-text\">Add rules to start seeing preview on the right panel</p><md-button ng-click=\"addQuery()\" class=\"md-accent outline\"><md-icon>add</md-icon>Add Rule</md-button></section></section><section flex=\"\" class=\"productsPreviewContainer\"><md-input-container class=\"no-error-spacer sort-selector\"><label>Select Sort Field</label><md-select ng-model=\"previewQuery.sortBy\" ng-change=\"refetchPreview()\"><md-option ng-value=\"option.value\" ng-repeat=\"option in [ {name : \'Name Ascending\', value : \'name\'}, {name : \'Name Descending\', value : \'-name\'}, {name : \'Latest Created\', value : \'-createdAt\'}, {name : \'Oldest Created\', value : \'createdAt\'}, {name : \'Latest Updated\', value : \'-updatedAt\'}, {name : \'Oldest Updated\', value : \'updatedAt\'}, {name : \'Cheapest\', value : \'price\'}, {name : \'Costliest\', value : \'-price\'}]\">{{option.name}}</md-option></md-select></md-input-container><md-subheader><div flex=\"\" layout=\"\" layout-align=\"space-between center\"><span class=\"black-text md-caption\">Preview Products {{previewTotal ? \'(\' + previewTotal + \' products)\' : \'\'}}</span><md-button class=\"md-icon-button\" ng-click=\"showQuery($event)\"><md-icon>bug_report</md-icon></md-button></div></md-subheader><md-virtual-repeat-container id=\"vertical-container\" ng-show=\"previewProductsList.length\"><div md-virtual-repeat=\"product in previewProductsList\" class=\"repeated-item\" flex=\"\" layout=\"\" layout-align=\"stretch center\"><div layout=\"\" layout-align=\"center center\"><p class=\"md-caption\">{{$index + 1}}.</p></div><img ng-src=\"{{mediaUrl + product.featured_image.urls.thumbnail}}\" alt=\"{{product.name}}\"><div layout=\"column\" flex=\"\" layout-align=\"center start\" flex-offset=\"5\"><p class=\"md-truncate\" style=\"max-width: 100%\">{{product.name}}</p><p class=\"md-caption grey-text\">SKU : {{product.sku}} | Variations:{{product.variations.length}}</p><div layout=\"\" style=\"width: 100%\" layout-align=\"start center\"><span class=\"md-body-1 bold-text\">₹ {{product.price}}</span> <s class=\"md-caption red-text\" flex-offset=\"5\" ng-if=\"product.mrp > product.price\">₹ {{product.mrp}}</s> <span class=\"discount-percent\" ng-if=\"product.mrp > product.price\" flex-offset=\"5\">{{product.price | percentage: product.mrp }}</span></div></div></div></md-virtual-repeat-container><div ng-show=\"!previewProductsList.length && !fetchingPreview\" layout=\"column\" layout-align=\"center center\" layout-margin=\"\" layout-padding=\"\" class=\"no-product-found\"><span class=\"text-center\">No Products found matching the filter criteria</span> <img src=\"assets/images/blank.svg\"></div><md-progress-linear ng-show=\"fetchingPreview\"></md-progress-linear><div layout=\"\" layout-align=\"space-between center\" class=\"load-info\"><i class=\"md-tiny md-padding\">Loaded {{previewProductsList.length}} of {{previewTotal}} products</i><md-button ng-click=\"fetchNextPreview()\"><md-icon>refresh</md-icon>Load More</md-button></div></section></div></div></md-dialog-content><md-dialog-actions md-colors=\"{\'background\' : \'primary-50-1\'}\"><md-button ng-disabled=\"savingProducts\" class=\"md-warn outline\" ng-click=\"closeDialog();\">CANCEL</md-button><span flex=\"\"></span><md-button class=\"md-primary outline\" ng-click=\"saveUpdateInCollection();\">{{buttonText}}<md-icon>keyboard_arrow_right</md-icon></md-button></md-dialog-actions></form></md-dialog></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"rawQuery\"><md-dialog flex=\"50\"><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools layout-row layout-align-space-between-center\"><section layout=\"\"><h3>Raw Query</h3></section><md-button class=\"md-icon-button\" ng-click=\"closeDialog();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><section flex=\"\" class=\"raw-query-container\"><md-subheader><div flex=\"\" layout=\"\">Preview Raw Query</div></md-subheader><pre class=\"query\">{{rawQuery | json }}</pre></section></md-dialog-content></md-dialog></div></div>");
$templateCache.put("app/modules/collections/partials/index.html","<md-section-header md-section-title=\"{{\'Product Collections\'}}\" md-nested-state=\"false\"><md-button class=\"md-raised md-primary\" ng-click=\"showDialog(null, null, $event)\"><md-icon>add</md-icon><span>Add New Collection</span></md-button></md-section-header><div layout=\"row\" layout-wrap=\"\" layout-align=\"start stretch\"><section flex=\"\" layout-padding=\"\" layout-margin=\"\" layout=\"column\" layout-align=\"center center\" ng-if=\"loadingCollections\"><md-progress-circular></md-progress-circular></section><section ng-if=\"!loadingCollections\" flex=\"33\" ng-repeat=\"collection in collections track by collection._id\"><md-card class=\"pointer relative\"><md-card-header class=\"md-padding\" layout=\"\" layout-align=\"start center\"><div layout=\"column\"><span class=\"bold-text\">{{collection.name}}</span><bubble-loader ng-if=\"collection.loadingTotal\"></bubble-loader><span class=\"md-caption\" ng-if=\"!collection.loadingTotal\">{{collection.total}} products</span></div><span flex=\"\"></span> <span>{{collection.rules.queries.length ? collection.rules.queries.length + \' rules\' : \'No Rules\'}}</span><attached-tag class=\"md-tiny\" right=\"8px\" ng-class=\"public-tag\" ng-if=\"collection.public\"><tag-content>Public</tag-content></attached-tag></md-card-header><md-img ng-if=\"collection.headerImage.urls.h_large\" md-src=\"{{collection.headerImage.urls.h_large}}\" alt=\"{{collection.name}}\"></md-img><img ng-if=\"!collection.headerImage.urls.h_large\" src=\"assets/images/text.png\"><md-card-actions layout=\"\" layout-align=\"space-between center\"><div><md-button class=\"md-primary md-icon-button\" ng-click=\"showDialog($index, collection._id,$event);\"><md-icon>edit</md-icon><md-tooltip><span>Edit Collection</span></md-tooltip></md-button><md-button class=\"md-primary md-icon-button\" ng-click=\"showProductsDialog($event, $index, collection);\"><md-icon>add</md-icon><md-tooltip><span>Manage Products</span></md-tooltip></md-button><md-button class=\"md-primary md-icon-button\" ng-click=\"openInWebsite(collection);\"><md-icon>open_in_new</md-icon><md-tooltip><span>View Collection</span></md-tooltip></md-button></div><div><md-button class=\"md-icon-button md-warn\" ng-click=\"deleteCollection(collection, $index)\"><md-icon>delete</md-icon><md-tooltip><span>Delete Collection</span></md-tooltip></md-button></div></md-card-actions></md-card></section></div>");
$templateCache.put("app/modules/login/partials/login-base.html","<div layout-align=\"center center\" layout=\"\" class=\"login-bg\" ng-class=\"[loginClass]\"></div><div class=\"login\" layout=\"\" layout-align=\"center center\"><md-card flex-gt-sm=\"30\" flex=\"80\" class=\"login-card\"><form ng-if=\"!isUserLoggedIn\" name=\"loginForm\"><div layout=\"\" layout-align=\"center center\" class=\"md-padding\" style=\"height: 120px;\"><img src=\"assets/images/aarida-optimized.png\" style=\"max-height: 75px;\"></div><div layout=\"column\" layout-align=\"start center\" flex=\"\"><div layout=\"column\" layout-align=\"start center\"><md-input-container style=\"margin: 20px 0; width: 100%;\" ng-if=\"!user.name\"><label>Mobile Number</label><md-icon>phone_iphone</md-icon><input ng-disabled=\"loggingIn\" type=\"tel\" name=\"mobile\" ng-model=\"user.mobile\" required=\"\" maxlength=\"10\" autocomplete=\"tel\" minlength=\"10\" ng-pattern=\"/^[56789][0-9]{9}$/\"><div ng-messages=\"loginForm.mobile.$error\" ng-show=\"loginForm.mobile.$dirty\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\"><div ng-message=\"pattern\">Please enter a valid 10 digit mobile number</div></div></div></md-input-container><div layout=\"\" layout-align=\"start center\" ng-if=\"user.name\" style=\"margin-bottom: 35px;\"><section layout=\"\" layout-align=\"center center\"><md-img md-src=\"{{user.profileImageURL ? user.profileImageURL : \'\'}}\" style=\"width: 50px; height: auto; border-radius: 50%;\"></md-img></section><section layout=\"column\" style=\"margin-left: 10px;\"><span class=\"md-body-1\">{{user.name}}</span> <span class=\"md-caption grey-text bold-text\">{{user.mobile}}</span></section><section><md-button class=\"md-icon-button md-accent\" ng-click=\"clearUser()\"><md-icon>close</md-icon></md-button></section></div><md-input-container style=\"margin: 3px 0; width: 100%;\"><label>Password</label><md-icon>vpn_key</md-icon><input autocomplete=\"password\" ng-disabled=\"loggingIn\" name=\"password\" ng-model=\"user.password\" minlength=\"6\" required=\"\" type=\"password\"><div ng-messages=\"loginForm.password.$error\" ng-show=\"loginForm.password.$dirty\"><div ng-message-exp=\"[\'required\', \'minlength\']\"><div ng-message=\"pattern\">Please enter a valid password</div></div></div></md-input-container><md-input-container><md-checkbox style=\"margin: auto;\" ng-model=\"user.rememberMe\" aria-label=\"Remember Me\">Remember Me</md-checkbox></md-input-container><div layout=\"\" layout-align=\"center center\" style=\"min-height: 44px;\"><span class=\"red-text md-caption\" ng-show=\"error\">{{error}}</span></div></div></div><span flex=\"\"></span><md-divider></md-divider><div layout=\"column\" layout-margin=\"\" layout-align=\"center center\" style=\"margin-bottom: 20px\"><md-button class=\"md-accent md-raised login-btn\" ng-disabled=\"loggingIn\" type=\"submit\" ng-click=\"loginUser($event);\" style=\"min-width: 250px; max-width: 100%;\"><div layout=\"\" layout-align=\"center center\"><span>LOGIN</span></div></md-button></div></form><md-card-content ng-if=\"isUserLoggedIn\"><div layout=\"column\" layout-align=\"center center\"><span class=\"md-title center-text\">Welcome</span><section class=\"md-padding\" layout=\"column\" layout-align=\"center center\"><div layout=\"\" layout-align=\"center center\" class=\"relative\" style=\"width: 120px; height: 120px;\"><md-img md-src=\"{{currentUser.profileImageURL}}\" style=\"border-radius: 50%; width: 100px; height: 100px;\"></md-img><section style=\"position: absolute; top: 0; right: 0; left: 0; bottom: 0;\" layout=\"\" layout-align=\"center center\"><md-progress-circular md-diameter=\"120\" md-width=\"2\" class=\"md-accent profile-loading\"></md-progress-circular></section></div><span class=\"md-body-1\">{{currentUser.name}}</span> <span class=\"md-caption grey-text bold-text\">{{currentUser.email}}</span> <span class=\"md-caption grey-text bold-text\">{{currentUser.mobile}}</span></section><span class=\"md-subhead grey-text\">Setting Up ...</span></div></md-card-content></md-card></div>");
$templateCache.put("app/modules/login/partials/login-page.html","<md-card style=\"height: 500px; margin: 1% 3% 1% 3%;\"><div layout=\"row\" layout-fill=\"\" ng-include=\"\'app/modules/login/partials/login-base.html\'\"></div></md-card>");
$templateCache.put("app/modules/media/dialog/image-gallery.html","<md-dialog flex=\"75\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout-align=\"space-between center\"><span>Image Gallery</span><md-button ng-click=\"close()\" class=\"md-icon-button\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><div layout=\"\" ng-if=\"images.length\"><section layout=\"column\" layout-align=\"start center\"><div ng-repeat=\"image in images\" class=\"md-margin\"><md-img class=\"pointer\" ng-click=\"selectImage(image)\" md-src=\"{{image.urls.thumbnail}}\"></md-img></div></section><section flex=\"\" layout=\"\" layout-align=\"center start\"><md-img style=\"height: calc(100vh - 64px)\" class=\"pointer\" md-src=\"{{selectedImage.urls.large}}\"></md-img></section></div><div ng-if=\"!images.length\" layout=\"\" layout-padding=\"\" layout-margin=\"\" layout-align=\"center center\"><span>No Images Set</span></div></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/media/partials/media.html","<div><section layout=\"column\" class=\"drag-drop uploader relative\"><md-subheader md-whiteframe=\"2\" ng-if=\"!hideHeader\"><section layout=\"\"><div layout=\"\" layout-align=\"start center\" flex-gt-sm=\"20\" flex=\"40\"><md-button class=\"md-raised md-accent\" ngf-select=\"\" ng-model=\"$parent.files\" ngf-multiple=\"true\" ngf-allow-dir=\"false\" accept=\"image/*\" ngf-pattern=\"\'image/*\'\" style=\"padding: 0 16px;\"><md-icon>cloud_upload</md-icon><span>Upload</span></md-button></div><div flex=\"\" layout=\"\" layout-align=\"center center\" ng-if=\"!isSmall\"><form ng-submit=\"$event.preventDefault()\" flex=\"\" layout=\"\" layout-align=\"center center\"><md-autocomplete flex=\"\" md-selected-item=\"selectedItem\" md-search-text-change=\"searchTextChange(searchText)\" md-search-text=\"searchText\" md-selected-item-change=\"selectedItemChange(item)\" md-items=\"item in querySearch(searchText)\" md-item-text=\"item.filename\" md-min-length=\"3\" placeholder=\"Search For Images\" md-menu-class=\"autocomplete-custom-template\"><md-item-template><span class=\"item-title\"><img ng-src=\"{{mediaUrl + item.urls.thumbnail}}\" class=\"md-avatar\" style=\"width: 20px; height: auto; border-radius: 50%;\"> <span class=\"md-caption\" md-highlight-text=\"searchText\">{{trimFileName(item.filename)}}</span></span> <span class=\"item-metadata md-tiny\"><span><span class=\"grey-text\">{{item.createdAt | date : \"medium\"}}</span></span> <span><span class=\"grey-text\" ng-if=\"item.size\">{{getSize(item.size)}}</span></span></span></md-item-template></md-autocomplete></form></div><div layout=\"\" layout-align=\"end center\" flex-gt-sm=\"45\" flex=\"\" ng-if=\"!isSmall\"><span style=\"margin-right: 10px;\" class=\"md-caption center-text\" ng-if=\"selectedImages.length > 0\">Selected {{selectedImages.length}} images</span><md-switch ng-model=\"multiSelectionMode\" ng-change=\"checkSelecttions();\">Multiple Selection Mode</md-switch><md-button class=\"md-icon-button\" ng-click=\"showInfo = !showInfo\"><md-icon>info</md-icon></md-button><md-menu md-offset=\"0 48\"><md-button aria-label=\"Open menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdMenu, $event)\"><md-icon>sort_by_alpha</md-icon></md-button><md-menu-content width=\"2\" style=\"padding: 0;\"><md-menu-item ng-class=\"{\'active\' : (query.sort === \'filename\' || query.sort === \'-filename\')}\"><md-button ng-click=\"asc1 = !asc1; sortBy(asc1 ? \'filename\' : \'-filename\')\"><md-icon ng-if=\"(query.sort === \'filename\' || query.sort === \'-filename\')\">{{asc1 ? \"arrow_upward\" : \"arrow_downward\"}}</md-icon><span>File Name</span></md-button></md-menu-item><md-menu-divider style=\"margin: 0;\"></md-menu-divider><md-menu-item ng-class=\"{\'active\' : (query.sort === \'createdAt\' || query.sort === \'-createdAt\')}\"><md-button ng-click=\"asc2 = !asc2; sortBy(asc2 ? \'createdAt\' : \'-createdAt\')\"><md-icon ng-if=\"(query.sort === \'createdAt\' || query.sort === \'-createdAt\')\">{{asc2 ? \"arrow_upward\" : \"arrow_downward\"}}</md-icon><span>Date Added</span></md-button></md-menu-item><md-menu-divider style=\"margin: 0;\"></md-menu-divider><md-menu-item ng-class=\"{\'active\' : (query.sort === \'updatedAt\' || query.sort === \'-updatedAt\')}\"><md-button ng-click=\"asc3 = !asc3; sortBy(asc3 ? \'updatedAt\' : \'-updatedAt\')\"><md-icon ng-if=\"(query.sort === \'updatedAt\' || query.sort === \'-updatedAt\')\">{{asc3 ? \"arrow_upward\" : \"arrow_downward\"}}</md-icon><span>Date Modified</span></md-button></md-menu-item><md-menu-divider style=\"margin: 0;\"></md-menu-divider></md-menu-content></md-menu><md-menu md-offset=\"0 48\" md-position-mode=\"target-right target\"><md-button aria-label=\"Open menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdMenu, $event)\"><md-icon>more_vert</md-icon></md-button><md-menu-content width=\"4\" style=\"padding: 0;\"><md-menu-item><md-button ng-click=\"ctrl.redial($event)\"><md-icon md-menu-align-target=\"\">remove_red_eye</md-icon><span>Preview</span></md-button></md-menu-item><md-menu-divider style=\"margin: 0;\"></md-menu-divider><md-menu-item><md-button ng-click=\"ctrl.checkVoicemail()\"><md-icon md-menu-align-target=\"\">share</md-icon><span>Share</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.checkVoicemail()\"><md-icon md-menu-align-target=\"\">file_download</md-icon><span>Download {{selectedImages.length > 0 ? selectedImages.length + \' images\' : \'image\'}}</span></md-button></md-menu-item><md-menu-divider style=\"margin: 0;\"></md-menu-divider><md-menu-item><md-button ng-click=\"deleteImages();\" class=\"md-warn\"><md-icon md-menu-align-target=\"\">delete</md-icon><span>Remove {{selectedImages.length > 0 ? selectedImages.length + \' images\' : \'image\'}}</span></md-button></md-menu-item></md-menu-content></md-menu></div></section></md-subheader><div layout=\"\" layout-align=\"center center\" class=\"suggested-filters\"><i class=\"md-tiny grey-text\">Suggested Filters :</i><md-button class=\"md-primary filter-button\" ng-class=\"{\'md-raised active\' : filter.active}\" ng-repeat=\"filter in suggestedFilters\" ng-click=\"applyFilter(filter)\">{{filter.name}}</md-button><md-button class=\"md-icon-button md-warn\" ng-show=\"filterActive\" ng-click=\"clearFilter()\"><md-icon>close</md-icon></md-button></div><div layout=\"row\"><div class=\"md-margin\" flex=\"\" style=\"height: 100vh; background: transparent;\"><div layout=\"column\" layout-align=\"center center\" style=\"height: 200px;\" ng-show=\"loading\"><md-progress-circular></md-progress-circular><div layout=\"\" layout-align=\"center center\" layout-padding=\"\"><span>Loading images...</span></div></div><div flex=\"\" layout=\"row\" layout-wrap=\"\" layout-align=\"center start\" ng-show=\"images.length > 0\"><md-card ng-repeat=\"image in images\" class=\"image pointer relative\" md-whiteframe=\"1\" id=\"{{image.filename.split(\'.\')[0]}}\" md-ink-ripple=\"\" ng-click=\"selectImage(image);\" ng-class=\"{\'flex-30\' : image.urls.h_large, \'selected\' : image.selected}\"><img md-preload=\"\" md-src=\"image\" key=\"{{image.urls.h_large ? \'h_medium\' : \'thumbnail\'}}\" class=\"md-card-image\" alt=\"{{image.filename}}\" ng-class=\"{\'selected\' : image.selected}\" ng-style=\"{\'max-width\' : image.extension === \'.svg\' ? \'150px\' : \'\', \'height\' : image.extension === \'.svg\' ? \'205px\' : \'inherit\'}\"><span class=\"md-tiny image-size\">{{image.formattedSize}}</span> <span class=\"md-tiny image-type\">{{image.formattedFileType}}</span> <span class=\"detected-color\" ng-style=\"{\'background-color\' : image.swatch.css}\">{{image.swatch.css}}</span><md-divider></md-divider><md-card-content style=\"padding: 4px 8px\" md-colors=\"{\'background\' : \'primary-50-0.4\'}\"><div layout=\"\" layout-align=\"space-between center\"><section layout=\"column\"><md-truncate class=\"md-tiny\">{{image.createdAt | date : \"mediumDate\"}}</md-truncate></section><md-truncate class=\"md-tiny bold-text\">{{image.formattedFileType}}</md-truncate></div></md-card-content><div class=\"image-overlay\" ng-show=\"image.selected\" layout=\"\" layout-align=\"center center\"><md-icon>check_circle</md-icon></div></md-card><div layout=\"\" layout-align=\"center center\" style=\"height: 200px\"><md-button ng-click=\"loadNextPage();\" ng-disabled=\"loading\" class=\"md-accent\" style=\"padding: 4px 30px; border: 1px solid currentColor; border-radius: 32px;\"><section layout=\"\" layout-align=\"center center\"><span ng-if=\"!loading\">Load {{query.limit}} more images ...</span><md-progress-circular md-diameter=\"20\" ng-if=\"loading\"></md-progress-circular></section></md-button></div></div></div><section md-whiteframe=\"2\" flex=\"30\" ng-if=\"showInfo\" style=\"height: 90vh;\" class=\"white\"><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"closeSideBar();\"><md-icon>close</md-icon></md-button></div><md-content><section layout=\"column\" layout-align=\"start center\"><md-img md-src=\"{{selectedImages[0].urls.medium ? selectedImages[0].urls.medium : \'\'}}\" alt=\"{{selectedImages[0].filename}}\"></md-img></section></md-content></section></div></section></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"myDialog\"><md-dialog aria-label=\"uploader block\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Upload Images</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\"><span>Hey there. You are about to upload {{ files.length }} {{files.length == 1 ? \"images\" : \"images\"}} to the server. Can you provide the details</span> <span>below so that the server can accordingly process your images in the correct manner?</span><div layout=\"row\"><div flex=\"{{ context == \'custom\' ? 25 : 50}}\"><md-select ng-model=\"context\" placeholder=\"What type of image is it?\"><md-option ng-value=\"\'simple\'\">Simple</md-option><md-option ng-value=\"\'customisable\'\">Customisable</md-option><md-option ng-value=\"\'custom\'\">Custom</md-option></md-select></div><div flex=\"70\" flex-offset=\"5\" ng-if=\"context == \'custom\'\" layout=\"column\"><div layout=\"row\"><md-button class=\"md-icon-button\"><md-icon>info</md-icon><md-tooltip>Suggestion : Please add at least three size. Thumbnail, medium and large. For instance, if you uploading header images to be used in emails, knowing the exact dimensions of the images will be the first step.</md-tooltip></md-button><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"addSize($index)\"><md-icon>add</md-icon></md-button></div><div ng-repeat=\"size in sizes track by $index\" layout=\"column\" style=\"border: 1px dashed lightgrey\" layout-margin=\"\"><section layout=\"row\"><md-input-container flex=\"30\" style=\"margin: 0;\"><label>Width (px)</label> <input type=\"number\" min=\"0\" ng-model=\"size.width\"></md-input-container><md-input-container flex=\"30\" style=\"margin: 0;\"><label>Height (px)</label> <input type=\"number\" min=\"0\" ng-model=\"size.height\"></md-input-container><md-input-container flex=\"30\" style=\"margin: 0;\"><label>Attribute Name</label> <input type=\"text\" ng-model=\"size.attributeName\"></md-input-container><md-button class=\"md-icon-button\" ng-click=\"removeSize($index);\" flex=\"10\"><md-icon style=\"color: red;\">delete</md-icon></md-button></section></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button md-autofocus=\"\" ng-click=\"cancel()\"><md-icon>keyboard_arrow_left</md-icon>Cancel</md-button><span flex=\"\"></span><md-button ng-click=\"upload()\"><md-icon>file_upload</md-icon>Upload Now</md-button></md-dialog-actions></form></md-dialog></div></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"edge-detector\"><md-dialog aria-label=\"uploader block\" flex=\"100\"><md-toolbar><div class=\"md-toolbar-tools\" layout-align=\"space-between center\"><span>Edge Detector</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content\"><div layout=\"\" layout-align=\"center center\"><canvas id=\"image-edge-detector\"></canvas></div></md-dialog-content></md-dialog></div></div>");
$templateCache.put("app/modules/offers/giftCards/index.html","<div ui-view=\"\"></div>");
$templateCache.put("app/modules/offers/partials/offers.html","<md-section-header md-section-title=\"{{pageTitle}}\" md-back-state=\"{{backState}}\" md-nested-state=\"nestedState\"><md-button class=\"md-raised action-button md-accent\" ng-click=\"onActionButtonClick($event);\" ng-if=\"showActionButton && !actionButtonDisabled.$$state.pending\">{{actionButtonText}}</md-button><md-progress-circular ng-if=\"actionButtonDisabled.$$state.pending\" md-mode=\"indeterminate\" md-diameter=\"40\" class=\"md-accent\"></md-progress-circular></md-section-header><form ng-disabled=\"actionButtonDisabled.$$state.pending\" style=\"z-index: 1\"><div ui-view=\"\"></div></form>");
$templateCache.put("app/modules/orders/partials/home.html","<md-section-header md-section-title=\"{{pageTitle}}\" md-back-state=\"{{backState}}\" md-back-params=\"backParams\" md-nested-state=\"nestedState\"><md-button class=\"md-raised\" ng-if=\"showActionButton\">Save</md-button></md-section-header><div ui-view=\"\" style=\"z-index: 2; background: #f5f6fa;\"></div>");
$templateCache.put("app/modules/orders/planning/planning.tmpl.html","<div class=\"order-planning\" ng-class=\"{\'disable-scroll\' : showingProductOverlay}\"><div class=\"products-list\" layout=\"\" layout-wrap=\"\" ng-show=\"!loadingOrders\"><section ng-repeat=\"productGroup in productGroups track by productGroup.key | filter : productSearch\" class=\"product-group\" ng-class=\"{\'pointer\' : productGroup.values.length > 1}\" md-swipe-left=\"productGroup.values.length > 1 ? changeSelected(productGroup.key, -1) : null\" md-swipe-right=\"productGroup.values.length > 1 ? changeSelected(productGroup.key, -1) : null\" flex-xl=\"20\" flex-lg=\"25\" flex-md=\"33\" flex-sm=\"33\" flex-xs=\"100\"><md-card ng-class=\"[{\'overlay\' : $index > 0}, {\'exiting\' : lineItem.movingOut}, {\'success\' : isDone(lineItem)}, getWhiteFrameClass(productGroup.values, $index), lineItem.direction ]\" class=\"product-card\" ng-repeat-start=\"lineItem in productGroup.values | filter : productSearch\"><md-card-header style=\"padding: 6px 0 6px 10px\" layout=\"\" layout-align=\"space-between center\"><md-card-header-text><span class=\"md-caption\">{{lineItem.user.name}}</span> <i class=\"md-tiny\">{{lineItem.user.mobile}}</i></md-card-header-text><md-menu md-position-mode=\"left bottom\"><md-button ng-click=\"$mdMenu.open($event)\" class=\"md-icon-button\" aria-label=\"Open menu\"><md-icon>more_vert</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"viewMeasurementsDialogs($event, lineItem)\">View Measurements</md-button></md-menu-item><md-menu-item ng-if=\"lineItem.ucData\" ng-click=\"showCustomisation(lineItem, $event)\"><md-button>View Customisation Options</md-button></md-menu-item></md-menu-content></md-menu></md-card-header><section class=\"relative\"><md-img md-src=\"{{lineItem.image.urls[isSmall ? \'medium\' : \'large\']}}\" class=\"md-card-image\"></md-img><div class=\"tags customisable md-caption\" ng-if=\"lineItem.ucData\">Customisable</div><div class=\"tags custom-made md-caption\" ng-if=\"lineItem.isACustomMadeProduct\">Custom Product</div><div class=\"success-overlay\" ng-repeat-end=\"\" ng-if=\"isDone(lineItem)\" layout=\"column\" layout-align=\"center center\"><md-icon class=\"green-text\">check_circle</md-icon></div></section><md-card-content layout=\"column\" layout-align=\"center start\"><span class=\"md-truncate product-name\">{{properName(lineItem.name, 40)}}</span> <span class=\"md-caption grey-text md-truncate\">SKU : {{lineItem.sku}}</span> <span class=\"md-caption grey-text\">Size : <span class=\"black-text\">{{lineItem.selectedVariationText}}</span></span> <span class=\"md-caption grey-text\">Quantity : <span class=\"black-text\">{{lineItem.quantity}}</span></span></md-card-content><md-divider></md-divider><md-card-actions layout=\"column\" layout-lg=\"row\" layout-xl=\"row\" layout-align=\"center center\"><md-input-container class=\"no-error-spacer status\" flex-xl=\"50\" flex-lg=\"50\"><md-select ng-model=\"lineItem.status\" ng-change=\"updateLineItemStatus(lineItem)\" placeholder=\"Select Status\"><md-option ng-value=\"status\" ng-repeat=\"status in lineItemStatuses\"><span class=\"md-tiny\">{{status | uppercase}}</span></md-option></md-select></md-input-container><md-input-container class=\"no-error-spacer date\" flex-xl=\"50\" flex-lg=\"50\"><input mdc-datetime-picker=\"\" date=\"true\" ng-change=\"updateLineItemDeliveryDate(lineItem)\" time=\"false\" type=\"text\" id=\"time\" short-time=\"true\" show-todays-date=\"\" click-outside-to-close=\"true\" placeholder=\"Processing Date\" auto-ok=\"true\" min-date=\"minDate\" minute-steps=\"1\" format=\"DD-MMM-YYYY\" ng-model=\"lineItem.deliveryDate\"></md-input-container></md-card-actions><md-card-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"small md-primary\" ng-click=\"viewMeasurementsDialogs($event, lineItem)\">Measurements</md-button><md-button class=\"small outline md-accent\" ui-sref=\"app.orders.details({orderId : lineItem.orderId})\">View Order</md-button></md-card-actions></md-card><div class=\"count-overlay\" ng-repeat-end=\"\" ng-if=\"$last && productGroup.values.length > 1\" layout=\"column\" layout-align=\"center center\"><span class=\"md-display-3 count-text\">{{productGroup.values.length}}</span></div><div class=\"switcher-overlay\" ng-if=\"productGroup.values.length > 1\" layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-fab md-mini left-btn\" ng-click=\"changeSelected(productGroup.key, -1)\"><md-icon>keyboard_arrow_left</md-icon></md-button><md-button class=\"md-fab md-mini right-btn\" ng-click=\"changeSelected(productGroup.key, 1)\"><md-icon>keyboard_arrow_right</md-icon></md-button></div></section></div><div layout=\"column\" layout-align=\"center center\" md-margin=\"\" md-padding=\"\" style=\"margin-top: 100px\" ng-show=\"loadingOrders\"><md-progress-circular></md-progress-circular></div></div><div static-include=\"app/modules/orders/orderDetails/partials/viewMeasurementsDialog.html\"></div>");
$templateCache.put("app/modules/orders/stock-updates/stock-upates.tmpl.html","<md-dialog flex=\"60\" class=\"stockUpdatesModal\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"center center\"><h4>View Stock Updates</h4></div><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-progress-linear ng-if=\"fetching\"></md-progress-linear><md-divider></md-divider><section ng-if=\"stockUpdates.length\"><md-dialog-content class=\"md-dialog-content md-margin\"><h4 class=\"md-padding\">Updates: ({{stockUpdates.length}})</h4><md-list class=\"md-3-line md-padding\"><md-list-item class=\"txn-item\" ng-repeat=\"update in stockUpdates | orderBy: \'-createdAt\'\" ng-class=\"{\'credit\' : update.updateType === \'inc\', \'debit\' : update.updateType === \'dec\' || update.updateType === \'lease\'}\"><div class=\"md-list-item-text\"><p>{{update.description}}</p><p><span class=\"md-caption grey-text\">On <span class=\"black-text\">{{update.createdAt | date : \'medium\'}}</span></span> <span class=\"md-caption grey-text\">By <span class=\"black-text\">{{update.updaterName}}</span></span></p><p><span class=\"md-tiny grey-text\">Product <span class=\"black-text\">{{update.productName || \'N/A\'}}</span> | Variation : <span class=\"black-text\">{{update.variationText || \'N/A\'}}</span></span></p></div><div class=\"md-secondary\" layout=\"column\" layout-align=\"end center\"><h3 class=\"md-headline\" ng-class=\"{\'red-text\': update.updateType === \'dec\', \'green-text\' : update.updateType === \'inc\'}\">{{ update.updateType === \'dec\' ? \'-\' : \'+\'}}{{update.updateQty}}</h3></div></md-list-item></md-list><div layout=\"\" layout-align=\"center center\"><md-button ng-if=\"stockUpdates.length < total\" ng-click=\"paginate()\" class=\"small md-raised md-accent\">Load More</md-button></div></md-dialog-content></section><section ng-if=\"!stockUpdates.length && !fetching\" layout=\"column\" layout-align=\"center center\" layout-fill=\"\"><img src=\"assets/images/blank.svg\" style=\"width: 100px\"><p>No Stock Updates Found</p></section></md-dialog>");
$templateCache.put("app/modules/home/directives/dataWidget.tpl.html","<md-card><md-toolbar><div class=\"md-toolbar-tools md-secondary\" layout=\"\" layout-align=\"center center\"><span class=\"md-title\">{{widgetName}}</span></div></md-toolbar><md-divider></md-divider><section layout=\"\" layout-align=\"center center\" layout-padding=\"\" layout-margin=\"\"><span class=\"md-display-1 md-primary\">{{widgetData}}</span></section></md-card>");
$templateCache.put("app/modules/home/partials/admin-home.html","<div ng-controller=\"admin.home.controller\"><section layout=\"column\" layout-align=\"start center\" layout-margin=\"\"><span class=\"md-title bold-text\">Website Overview</span> <span class=\"md-caption\">Some important stats from the website</span><div layout=\"row\" layout-wrap=\"\" layout-align=\"center center\" style=\"width: 100%;\"><section flex=\"100\" flex-sm=\"50\" flex-gt-sm=\"25\" ng-repeat=\"data in cardData\"><md-card><div layout=\"column\" layout-align=\"center center\"><span class=\"md-title center-text md-padding\" flex=\"\">{{data.name}}</span> <span class=\"md-caption bold-text grey-text\">This {{unit}}</span></div><md-card-content layout=\"column\" layout-align=\"center center\"><div layout=\"\" layout-align=\"center center\" ng-if=\"!loading\"><span class=\"md-display-2\" style=\"color: deepskyblue\">{{data.value}}</span></div><md-progress-circular md-diameter=\"40\" ng-if=\"loading\"></md-progress-circular></md-card-content><md-divider></md-divider><div layout=\"\" layout-align=\"center center\" md-colors=\"{\'background\' : \'accent-500-1\'}\"><md-button class=\"md-icon-button\" ng-click=\"getAnalyticsData(unit);\"><md-icon class=\"white-text\">refresh</md-icon></md-button><md-button class=\"md-icon-button\"><md-icon class=\"white-text\">open_in_new</md-icon></md-button><md-menu><md-button ng-click=\"$mdMenu.open($event)\" class=\"md-icon-button\" aria-label=\"Open menu\"><md-icon class=\"white-text\">more_vert</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"getAnalyticsData(\'day\', 1)\">Today</md-button></md-menu-item><md-menu-item><md-button ng-click=\"getAnalyticsData(\'day\', 2)\">Last 2 Days</md-button></md-menu-item><md-menu-item><md-button ng-click=\"getAnalyticsData(\'week\', 1)\">This Week</md-button></md-menu-item><md-menu-item><md-button ng-click=\"getAnalyticsData(\'week\', 2)\">Last 2 Weeks</md-button></md-menu-item><md-menu-item><md-button ng-click=\"getAnalyticsData(\'month\', 2)\">Last and this Month</md-button></md-menu-item></md-menu-content></md-menu></div></md-card></section></div></section><md-divider></md-divider><div layout=\"column\" layout-margin=\"\"><section layout=\"column\" layout-align=\"center center\"><span class=\"md-title bold-text\">Most Popular Products</span> <span class=\"md-caption grey-text\" style=\"margin-top: 5px;\">Based on customers add to cart history</span></section><section layout=\"column\" layout-align=\"center center\" layout-padding=\"\" ng-if=\"fetchingMP\"><md-progress-circular md-diameter=\"36\"></md-progress-circular><span class=\"md-caption\">Digging deep for the most popular products..</span></section><section layout=\"row\" layout-wrap=\"\" layout-align=\"center\" ng-if=\"!fetchingMP\"><a ng-repeat=\"p in top_sellingProducts\" flex=\"50\" flex-gt-sm=\"15\" ng-init=\"product = p[0]\" target=\"_blank\" class=\"layout-column\" ng-href=\"{{frontEndUrl + \'product/\' + product.slug}}\"><md-card style=\"display: block; position: relative;\" md-ink-ripple=\"\" class=\"pointer relative\" flex=\"\"><md-img md-src=\"{{product.featured_image.urls.medium}}\" class=\"text\"></md-img><span flex=\"\"></span><md-divider></md-divider><md-card-content layout=\"column\" layout-padding=\"\"><span class=\"montserrat md-caption\">{{properName(product.name)}}</span> <span class=\"green-text bold-text md-tiny\" style=\"font-weight: 600;\">Rs. {{product.price}}</span></md-card-content></md-card></a></section></div><md-divider></md-divider><div layout=\"column\" layout-margin=\"\"><section layout=\"column\" layout-align=\"center center\"><span class=\"md-title bold-text\">Orders</span> <span class=\"md-caption grey-text\" style=\"margin-top: 5px;\">A summary of recent orders from the website</span></section><section layout=\"\" layout-wrap=\"\"><md-card flex=\"\"><div layout=\"column\"><section layout=\"\" layout-align=\"space-between center\" class=\"md-padding\"><span class=\"md-title\">Last 10 Pending Orders</span><md-button class=\"md-accent md-raised\" ui-sref=\"app.orders.all\">View All</md-button></section><md-divider></md-divider><md-table-container><table md-table=\"\" md-progress=\"fetchingPendingOrdersPromise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\">Sl.</th><th md-column=\"\" md-numeric=\"\">Order No.</th><th md-column=\"\" md-numeric=\"\">User</th><th md-column=\"\" md-numeric=\"\">Products</th><th md-column=\"\" md-numeric=\"\">Amount</th><th md-column=\"\" md-order-by=\"status\">Order Status</th><th md-column=\"\" md-numeric=\"\">Order Date</th><th md-column=\"\" md-numeric=\"\">Days Open</th><th md-column=\"\" md-numeric=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"order in pendingOrders\"><td md-cell=\"\">{{$index + 1 }}.</td><td md-cell=\"\">{{order.orderNumber}}</td><td md-cell=\"\">{{order.user.name}}</td><td md-cell=\"\">{{order.orderData.products.length}}</td><td md-cell=\"\">Rs. {{order.amount}}</td><td md-cell=\"\"><div layout=\"\" layout-align=\"start center\"><span class=\"dot-indicator\" ng-class=\"{ \'error\' : order.status ===\'incomplete\' || order.status ===\'parked\', \'pending\' : order.status === \'placed\', \'staging\' : [\'approved\', \'processing\', \'returned\', \'shipped\', \'packed\'].includes(order.status), \'success\' : order.status === \'delivered\'}\"></span> <span class=\"red-text\" ng-if=\"order.status ===\'parked\'\">PARKED</span> <span ng-if=\"order.status !== \'parked\'\">{{ order.status | uppercase }}</span></div></td><td md-cell=\"\">{{order.createdAt | date : \"medium\"}}</td><td md-cell=\"\">{{order.daysOpen}}</td><td md-cell=\"\"><md-button class=\"md-icon-button\" ui-sref=\"app.orders.details({orderId : order._id})\"><md-icon>open_in_new</md-icon></md-button></td></tr></tbody></table><md-table-pagination md-limit=\"ordersQuery.limit\" md-limit-options=\"[10, 25, 50]\" md-page=\"ordersQuery.page\" md-total=\"{{totalOrders}}\" md-on-paginate=\"fetchPendingOrders\" md-page-select=\"\"></md-table-pagination></md-table-container></div></md-card></section></div></div>");
$templateCache.put("app/modules/home/partials/designer-home.html","<div layout=\"column\" ng-controller=\"designer.home.controller\"><section layout=\"column\" layout-align=\"center center\"><span class=\"md-title bold-text\">My Stats</span> <span class=\"md-caption grey-text\" style=\"margin-top: 5px;\">All the vital stats from your profile</span></section><section layout-gt-sm=\"row\" layout-sm=\"column\" layout-xs=\"column\"><div layout=\"column\" flex-gt-sm=\"25\" flex=\"\"><md-card ng-style=\"{\'width\': isSmall ? \'100%\' : \'inherit\'}\"><md-card-content><div layout=\"\" layout-align=\"center center\"><md-progress-circular ng-if=\"fetchingCnt\" md-diameter=\"24\"></md-progress-circular><span class=\"md-display-2 bold-text\" ng-if=\"!fetchingCnt\" style=\"color: #485fb5\">{{designCount}}</span></div></md-card-content><md-divider></md-divider><div layout=\"\" layout-align=\"center center\" md-whiteframe=\"1\" style=\"background: #485fb5;\"><span class=\"bold-text white-text md-caption\" style=\"padding: 4px 8px;\">My Designs</span></div></md-card><md-card ng-style=\"{\'width\': isSmall ? \'100%\' : \'inherit\'}\"><md-card-content><div layout=\"\" layout-align=\"center center\"><md-progress-circular ng-if=\"fetchingCnt\" md-diameter=\"24\"></md-progress-circular><canvas id=\"pie\" class=\"chart chart-pie\" ng-if=\"!fetchingCnt\" chart-colors=\"cntColors\" chart-dataset-override=\"cntDatasetOverride\" chart-data=\"cntData\" chart-labels=\"cntLabels\" chart-options=\"cntOptions\"></canvas></div></md-card-content><md-divider></md-divider><div layout=\"\" layout-align=\"center center\" md-whiteframe=\"1\" style=\"background: #485fb5;\"><span class=\"bold-text white-text md-caption\" style=\"padding: 4px 8px;\">Design Ratio</span></div></md-card></div><div flex=\"\"><md-card><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-center-tabs=\"\" md-stretch-tabs=\"\"><md-tab label=\"Designs Per Day\"><md-content class=\"md-padding\"><canvas id=\"chartjs\" class=\"chart-line chart\" chart-data=\"statsData\" chart-labels=\"statsLabels\" chart-series=\"statsSeries\" chart-options=\"statsOptions\" chart-dataset-override=\"statsDatasetOverride\"></canvas></md-content></md-tab></md-tabs></md-card></div></section></div>");
$templateCache.put("app/modules/home/partials/home.html","<div ng-class=\"{\'md-margin\' : !isSmall}\" style=\"min-height: 100vh;\" ng-controller=\"home.controller\"><section layout=\"\" layout-wrap=\"\" layout-align=\"center\" style=\"margin: 10px 0 30px 0;\"><div layout=\"column\" layout-align=\"center center\" flex=\"100\" style=\"margin-bottom: 30px;\"><span class=\"md-title bold-text\">Quick Actions</span> <span class=\"md-caption grey-text\" style=\"margin-top: 5px;\">Most Used Actions for easy access</span></div><md-button flex=\"40\" flex-gt-sm=\"20\" ng-repeat=\"action in quickActions\" class=\"md-accent md-hue-1 md-raised\" ui-sref=\"{{action.state}}\" style=\"height: 44px; line-height: 44px;\"><section layout=\"\" layout-align=\"center center\"><div layout=\"\" layout-align=\"center center\"><md-icon>{{action.icon}}</md-icon></div><span class=\"bold-text md-caption\">{{action.name}}</span></section></md-button></section><md-divider></md-divider><md-divider></md-divider><div static-include=\"app/modules/home/partials/admin-home.html\" ng-if=\"currentUser.roleSpec <= 1\"></div><div static-include=\"app/modules/home/partials/designer-home.html\" ng-if=\"currentUser.roleSpec === 3\"></div><div static-include=\"app/modules/home/partials/sales-staff.html\" ng-if=\"currentUser.roleSpec === 7\"></div></div>");
$templateCache.put("app/modules/home/partials/sales-staff.html","<div ng-controller=\"salesStaff.home.controller\"><div layout=\"\" layout-align=\"center center\"><md-card class=\"sales-staff getting-started-card\" flex-gt-sm=\"66\" flex-sm=\"100\"><md-card-content class=\"content--data\" layout=\"\"><div flex-gt-sm=\"66\" flex-sm=\"100\" flex-xs=\"100\" flex-offset-sm=\"0\" flex-offset-gt-sm=\"33\" layout=\"column\" layout-align=\"center start\"><h1 class=\"md-display-1 title\">Welcome to Aarida</h1><h3 class=\"md-subhead subtitle\">Here are a few tips to help you get started</h3><md-list><md-list-item style=\"height: 32px;min-height: 32px;\"><md-icon class=\"icon\">check_circle</md-icon><p class=\"md-body-2\">Make sure to login with your account before billing</p></md-list-item><md-list-item style=\"height: 32px;min-height: 32px;\"><md-icon class=\"icon\">check_circle</md-icon><p class=\"md-body-2\">Check your stats daily in order be right on track</p></md-list-item><md-list-item style=\"height: 32px;min-height: 32px;\"><md-icon class=\"icon\">check_circle</md-icon><p class=\"md-body-2\">Always try to keep the billing time under 5 minutes</p></md-list-item><md-list-item style=\"height: 32px;min-height: 32px;\"><md-icon class=\"icon\">check_circle</md-icon><p class=\"md-body-2\">Make sure that you provide customers the information they are looking for</p></md-list-item></md-list></div></md-card-content></md-card></div><md-divider></md-divider><section layout=\"column\" layout-align=\"center center\" class=\"md-padding\"><span class=\"md-title bold-text\">My Stats</span> <span class=\"md-body-1 grey-text\" style=\"margin-top: 5px;\">All the vital stats from your profile</span></section><div flex=\"\" layout=\"column\"><section layout=\"column\" layout-align=\"center start\" class=\"md-padding\"><span class=\"md-headline bold-text\">All Time</span></section><div layout=\"row\" layout-wrap=\"\"><section class=\"md-padding\" flex=\"25\" flex-sm=\"50\" flex-xs=\"100\" ng-repeat=\"data in cardData | limitTo : 4\"><md-card class=\"analytics-card\" ng-class=\"data.theme\"><md-card-content><div layout=\"\" layout-align=\"center center\"><md-progress-circular ng-if=\"fetchingCnt\" md-diameter=\"24\"></md-progress-circular><span class=\"md-display-2 bold-text analytics--value\" ng-show=\"!fetchingCnt\">{{data.value}} {{data.type === \'percent\' ? \'%\' : \'\'}}</span> <span class=\"md-caption grey-text analytics--context--message\" ng-show=\"!fetchingCnt && data.contextMessage\">{{data.contextMessage}}</span></div></md-card-content><md-divider></md-divider><div ng-show=\"!fetchingCnt\" layout=\"\" layout-align=\"center center\" md-whiteframe=\"1\" class=\"analytics--footer\"><span class=\"bold-text white-text md-caption analytics--title\">{{data.title}}</span></div></md-card></section></div><section layout=\"column\" layout-align=\"center start\" class=\"md-padding\"><span class=\"md-headline bold-text\">This Month</span></section><div layout=\"row\" layout-wrap=\"\"><section class=\"md-padding\" flex=\"25\" flex-sm=\"50\" flex-xs=\"100\" ng-repeat=\"data in cardData | limitTo : -4\"><md-card class=\"analytics-card\" ng-class=\"data.theme\"><md-card-content><div layout=\"\" layout-align=\"center center\"><md-progress-circular ng-if=\"fetchingCnt\" md-diameter=\"24\"></md-progress-circular><span class=\"md-display-2 bold-text analytics--value\" ng-show=\"!fetchingCnt\">{{data.value }} {{data.type === \'percent\' ? \'%\' : \'\'}}</span> <span class=\"md-caption grey-text analytics--context--message\" ng-show=\"!fetchingCnt && data.contextMessage\">{{data.contextMessage}}</span></div></md-card-content><md-divider></md-divider><div ng-show=\"!fetchingCnt\" layout=\"\" layout-align=\"center center\" md-whiteframe=\"1\" class=\"analytics--footer\"><span class=\"bold-text white-text md-caption analytics--title\">{{data.title}}</span></div></md-card></section></div></div><section layout=\"\" layout-align=\"center center\" layout-wrap=\"\"><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-card><md-content class=\"md-padding\"><canvas id=\"chartjs\" class=\"chart-horizontal-bar chart\" chart-data=\"statsData\" chart-labels=\"statsLabels\" chart-series=\"statsSeries\" chart-options=\"statsOptions\" chart-dataset-override=\"statsDatasetOverride\"></canvas></md-content></md-card></div><div flex-sm=\"100\" flex-xs=\"100\" flex-gt-sm=\"50\"><md-card><md-content class=\"md-padding\"><canvas id=\"chartjs-2\" class=\"chart-horizontal-bar chart\" chart-data=\"statsDataMonth\" chart-labels=\"statsLabelsMonth\" chart-series=\"statsSeries\" chart-options=\"statsOptionsMonth\" chart-dataset-override=\"statsDatasetOverride\"></canvas></md-content></md-card></div></section></div>");
$templateCache.put("app/modules/photoShoot/partials/details.html","<div><section class=\"header\" layout=\"row\" layout-align=\"center center\"><img src=\"assets/images/head.png\" style=\"opacity: 0.2;position: absolute; top: 0; left: 0; bottom: 0; right: 0; width: 100%; height: 100%;\"><section layout=\"\" flex=\"\" style=\"z-index: 1;\"><div flex=\"70\" layout=\"\" layout-align=\"start center\" style=\"margin-left: 40px;\"><h1 class=\"md-display-1 white-text\">{{dtCtrl.shoot.collectionName}} Details</h1></div><div flex=\"30\" layout=\"\" layout-align=\"center center\"><md-button ng-disabled=\"shootForm.$invalid || dtCtrl.savingShoot\" class=\"md-raised\" ng-click=\"dtCtrl.updateShoot();\">Update</md-button></div></section></section><form name=\"shootForm\" layout=\"column\" style=\"z-index: 2;\"><md-card><section class=\"md-padding\" layout=\"\" layout-align=\"center center\"><span class=\"md-title\">Edit Details</span></section><md-divider></md-divider><md-card-content><div layout-gt-sm=\"row\" layout-xs=\"column\" layout-sm=\"column\" layout-wrap=\"\" layout-align-gt-sm=\"start center\"><md-input-container class=\"md-block\" flex-gt-sm=\"30\" flex=\"100\"><label>Name</label> <input required=\"\" type=\"text\" name=\"name\" ng-model=\"dtCtrl.shoot.collectionName\"><div ng-messages=\"shootForm.name.$error\" ng-show=\"shootForm.name.$touched\"><div ng-message=\"required\">This is required!</div><div ng-message=\"\">Product Name Already Taken</div></div></md-input-container><md-autocomplete flex-gt-sm=\"30\" flex=\"100\" required=\"\" md-input-name=\"photographer\" md-input-minlength=\"2\" md-input-maxlength=\"18\" md-selected-item=\"dtCtrl.shoot.photographer\" md-search-text=\"dtCtrl.searchText\" md-items=\"item in dtCtrl.queryPhotographer(dtCtrl.searchText)\" md-item-text=\"item.name\" md-require-match=\"\" md-floating-label=\"Photographer\"><md-item-template><span md-highlight-text=\"dtCtrl.searchText\">{{item.name}}</span></md-item-template></md-autocomplete><md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex=\"100\"><md-datepicker name=\"date\" md-min-date=\"dtCtrl.minDate\" required=\"\" ng-model=\"dtCtrl.shoot.date\" md-placeholder=\"Enter date\"></md-datepicker></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex=\"100\"><label>Cost</label> <input required=\"\" type=\"number\" min=\"0\" name=\"cost\" ng-model=\"dtCtrl.shoot.cost\"></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>Location</label> <textarea rows=\"1\" required=\"\" name=\"location\" ng-model=\"dtCtrl.shoot.location\"></textarea></md-input-container></div></md-card-content></md-card><section layout=\"column\" dnd-list=\"dtCtrl.shoot.batch\"><md-card><section class=\"md-padding\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">Batch Details</span><md-switch ng-model=\"dtCtrl.showCompleted\" ng-change=\"dtCtrl.showView()\">Show Completed</md-switch></section></md-card><div layout=\"\"><md-card md-theme=\"dark-blue\" flex=\"\" ng-repeat=\"(key, val) in dtCtrl.modelData\"><section layout=\"\" layout-align=\"center center\"><h4>{{key}}</h4></section><md-divider></md-divider><md-card-content><section layout=\"\" layout-align=\"center center\"><span class=\"md-display-1\">{{val.length}}</span></section></md-card-content></md-card></div><section layout=\"\" layout-wrap=\"\" layout-align=\"center stretch\"><div layout=\"\" layout-align=\"center center\" flex=\"100\" flex-gt-sm=\"33\" ng-repeat=\"data in dtCtrl.shoot.batch | filter: dtCtrl.query track by $index\" class=\"mover\" dnd-draggable=\"data\" dnd-effect-allowed=\"move\" dnd-moved=\"dtCtrl.shoot.batch.splice($index, 1);\"><md-card flex=\"\" md-theme=\"{{data.status === \'done\' ? \'dark-grey\' : \'boring\'}}\"><md-img md-src=\"{{data.product.featured_image.urls.large}}\" class=\"md-card-image\" alt=\"Washed Out\"><md-card-title><md-card-title-text><section layout=\"\"><span class=\"md-title\">{{$index + 1}}.</span><div layout=\"column\" style=\"margin-left: 10px;\"><span class=\"md-body-1 bold-text\">{{dtCtrl.proper(data.product.name)}}</span> <span class=\"md-caption\">Status : <span class=\"bold-text\">{{data.status | uppercase}}</span></span> <span class=\"md-caption\">Model : <span class=\"bold-text\">{{data.model.name}}</span></span></div></section></md-card-title-text></md-card-title><md-divider></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\"><md-input-container class=\"no-error-spacer\" style=\"margin: 0;\"><input type=\"number\" min=\"1\" ng-model=\"data.sequence\" ng-disabled=\"data.status === \'done\'\"><md-tooltip>Image Sequence</md-tooltip></md-input-container><md-button class=\"md-icon-button\" ng-click=\"dtCtrl.addNewRow($index);\"><md-icon>add</md-icon><md-tooltip>Add New After This</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"dtCtrl.editRow(data, $event);\"><md-icon>edit</md-icon><md-tooltip>Edit This</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"dtCtrl.duplicateRow($index);\"><md-icon>content_copy</md-icon><md-tooltip>Create a copy of this</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"dtCtrl.removeRow($index);\"><md-icon>delete</md-icon><md-tooltip>Delete this</md-tooltip></md-button></md-card-actions></md-img></md-card></div></section></section><md-button ng-disabled=\"shootForm.$invalid || dtCtrl.savingShoot\" class=\"md-raised\" ng-click=\"dtCtrl.updateShoot();\">Update</md-button></form></div><script type=\"text/ng-template\" id=\"batchDialog.html\"><md-dialog flex md-theme=\"boring\"> <md-toolbar> <div class=\"md-toolbar-tools\" flex> <section flex layout=\"space-between center\"> <h4>Edit Sequence</h4> <md-button class=\"md-icon-button\" ng-click=\"cancel();\"> <md-icon>close</md-icon> </md-button> </section> </div> </md-toolbar> <md-content ng-init=\"data = dtCtrl.selectedData;\"> <section layout-gt-sm=\"row\" layout-xs=\"column\" layout-sm=\"column\" layout-align=\"start start\"> <div layout=\"column\" layout-align=\"center center\" flex-gt-sm=\"15\" flex=\"100\" class=\"md-padding\"> <span class=\"md-tiny\" style=\"text-align: center; padding: 8px;\">Product Image</span> <div ng-click=\"dtCtrl.openSingleUploader($event,\'featured image\',data)\" class=\"pointer\" flex style=\"border: 1px dashed grey; background: rgba(169,169,169,0.15);\" layout> <div ng-if=\"!data.product.featured_image\" layout=\"column\" layout-margin flex> <span flex></span> <div layout=\"column\"> <md-icon>add</md-icon> <span class=\"center-text md-caption\">Add Product Image</span> <span class=\"center-text md-caption\">(Click here)</span> </div> <span flex></span> </div> <div ng-if=\"data.product.featured_image\" layout layout-align=\"center center\" flex style=\"width: 100%; height: 100%;\"> <md-img md-src=\"{{ data.product.featured_image.urls.medium}}\" style=\"width: 100%; height: auto;\"> </div> </div> </div> <div layout flex-gt-sm=\"60\" flex=\"100\" layout-wrap> <md-input-container class=\"md-block\" flex-gt-sm=\"35\" flex=\"100\" ng-class=\"{\'md-input-invalid\' : !data.product.available && data.product.modified}\"> <label>Product Name</label> <input ng-model-options=\"{\'debounce\' : 50}\" required type=\"text\" ng-model=\"data.product.name\" ng-change=\"dtCtrl.checkSlug(data.product.name, $index)\"/> </md-input-container> <md-autocomplete flex-gt-sm=\"25\" flex=\"100\" md-input-name=\"model\" md-input-minlength=\"2\" md-input-maxlength=\"18\" md-selected-item=\"data.model\" md-search-text=\"data.searchText\" md-items=\"item in dtCtrl.queryModel(data.searchText)\" md-item-text=\"item.name\" md-require-match md-floating-label=\"Model\"> <md-item-template> <span md-highlight-text=\"dtCtrl.searchText\">{{item.name}}</span> </md-item-template> </md-autocomplete> <md-input-container class=\"md-block\" flex-gt-sm=\"30\" flex=\"100\"> <label>Helping People</label> <md-select placeholder=\"Assign Helpers\" ng-model=\"data.helpingPeople\" md-on-open=\"dtCtrl.queryHelpers($index)\" multiple> <md-option ng-value=\"user._id\" ng-repeat=\"user in dtCtrl.users\"> {{user.name}} </md-option> </md-select> </md-input-container> <md-chips ng-model=\"data.accessories\" md-autocomplete-snap readonly=\"false\" md-removable=\"true\" md-enable-chip-edit md-transform-chip=\"dtCtrl.transformChip($chip)\" flex=\"100\"> <md-autocomplete md-selected-item=\"data.selectedAItem\" md-search-text=\"data.searchAText\" md-items=\"item in dtCtrl.queryAccessories(data.searchAText)\" md-item-text=\"item\" placeholder=\"Search Accessory\"> <span md-highlight-text=\"data.searchAText\">{{item}}</span> </md-autocomplete> <md-chip-template> <span> <strong>{{$chip}}</strong> </span> </md-chip-template> </md-chips> <md-chips ng-model=\"data.stylingTips\" md-autocomplete-snap readonly=\"false\" md-removable=\"true\" md-enable-chip-edit md-transform-chip=\"dtCtrl.transformChip($chip)\" flex=\"100\"> <md-autocomplete md-selected-item=\"data.selectedSItem\" md-search-text=\"data.searchSText\" md-items=\"item in dtCtrl.queryStylingTips(data.searchSText)\" md-item-text=\"item\" placeholder=\"Styling Tips\"> <span md-highlight-text=\"data.searchSText\">{{item}}</span> </md-autocomplete> <md-chip-template> <span> <strong>{{$chip}}</strong> </span> </md-chip-template> </md-chips> <md-chips ng-model=\"data.pairedWith\" md-autocomplete-snap readonly=\"false\" md-removable=\"true\" md-enable-chip-edit md-transform-chip=\"dtCtrl.transformChip($chip)\" flex=\"100\"> <md-autocomplete md-selected-item=\"data.selectedPItem\" md-search-text=\"data.searchPText\" md-items=\"item in dtCtrl.queryPairedWith(data.searchPText)\" md-item-text=\"item\" placeholder=\"Paired With\"> <span md-highlight-text=\"data.searchPText\">{{item}}</span> </md-autocomplete> <md-chip-template> <span> <strong>{{$chip}}</strong> </span> </md-chip-template> </md-chips> <md-input-container class=\"md-block\" flex=\"100\" style=\"margin-top: 40px;\"> <label>Notes</label> <textarea ng-model=\"data.notes\" rows=\"1\"></textarea> </md-input-container> <div layout-gt-sm=\"row\" flex=\"100\" layout-sm=\"column\" layout-xs=\"column\"> <md-input-container class=\"md-block\" flex-gt-sm=\"30\" flex=\"100\"> <label>Total Shots</label> <input type=\"number\" ng-model=\"data.totalShots\"/> </md-input-container> <md-input-container class=\"md-block\" flex-gt-sm=\"30\" flex=\"100\"> <md-checkbox ng-model=\"data.conceptShoot.required\"> Concept Shoot </md-checkbox> </md-input-container> <md-input-container class=\"md-block\" flex-gt-sm=\"40\" flex=\"100\"> <label>Status</label> <md-select ng-model=\"data.status\"> <md-option value=\"pending\">Pending</md-option> <md-option value=\"makeup\">Make Up</md-option> <md-option value=\"ready\">Ready</md-option> <md-option value=\"next\">Next</md-option> <md-option value=\"ongoing\">Ongoing</md-option> <md-option value=\"done\">Done</md-option> </md-select> </md-input-container> </div> </div> <section layout=\"column\" layout-align=\"start center\" flex class=\"md-padding\"> <span class=\"md-tiny center-text\">Reference Images</span> <div ng-click=\"dtCtrl.openMultipleUploader($event, data);\" class=\"pointer\" layout style=\"border: 1px dashed grey;margin: 8px;background: rgba(169,169,169,0.15);\" ng-if=\"data.referenceImages.length == 0\"> <div flex layout layout-align=\"center center\"> <div layout=\"column\"> <md-icon>add</md-icon> <span class=\"center-text md-caption\">Add Reference Images</span> <span class=\"center-text md-caption\">(Multiple Image Selection Mode)</span> </div> </div> </div> <div layout=\"row\" layout-wrap layout-align=\"center space-between\" layout-margin> <div ng-click=\"dtCtrl.openSingleUploader($event,\'reference\',data, $index);\" ng-repeat-start=\"image in data.referenceImages\" class=\"pointer\" style=\"border: 1px dashed grey; position: relative\" ng-if=\"data.referenceImages.length > 0\" flex=\"40\"> <md-img md-src=\"{{ image.urls.thumbnail}}\" style=\"width: 100%; height: auto;\"> <md-button class=\"md-icon-button delete-img\" ng-click=\"dtCtrl.removeImage(index, $event);\"> <md-icon>close</md-icon> </md-button> </div> <div layout layout-align=\"center center\" ng-repeat-end ng-if=\"$last\" ng-click=\"dtCtrl.openMultipleUploader($event, data, true);\" class=\"pointer\" md-ink-ripple flex=\"50\" style=\"border: 1px dashed grey; position: relative;\"> <div flex layout-align=\"center center\" layout> <md-icon>add</md-icon> </div> </div> </div> </section> </section> </md-content> </md-dialog></script><md-card md-theme=\"dark-purple\" class=\"white\" layout=\"\" layout-align=\"start center\" style=\"position: fixed; padding: 8px; margin: 0; bottom : 0; height: 44px; width: 100%;\"><md-input-container flex-gt-sm=\"60\" flex=\"100\" class=\"md-block\"><input type=\"search\" ng-model=\"dtCtrl.query\" placeholder=\"Search for products\"></md-input-container><md-button style=\"width: 200px;\" ng-disabled=\"dtCtrl.savingShoot\" class=\"md-accent md-raised\" ng-click=\"dtCtrl.updateShoot();\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!dtCtrl.savingShoot\">Update</span><md-progress-circular md-diameter=\"20\" ng-if=\"dtCtrl.savingShoot\"></md-progress-circular></div></md-button></md-card>");
$templateCache.put("app/modules/photoShoot/partials/index.html","<div><section class=\"header\" layout=\"row\" layout-align=\"center center\" style=\"z-index: -1;\"><img src=\"assets/images/head.png\" style=\"opacity: 0.2;position: absolute; top: 0; left: 0; bottom: 0; right: 0; width: 100%; height: 100%;\"><h1 class=\"md-display-1 white-text\" style=\"z-index: 1;\">Photo Shoot</h1></section><section layout=\"column\" class=\"md-padding\" style=\"margin-top: -48px; z-index: 1;\"><md-card><md-card-content><div layout=\"\" layout-align=\"space-between center\"><span class=\"md-caption\">Showing {{stCtrl.count}} of {{stCtrl.total}} photoshoots.</span></div></md-card-content></md-card><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-raised md-accent\" ng-click=\"stCtrl.addShoot($event);\"><md-icon>add</md-icon><span>Add Photoshoot</span></md-button></div><div layout=\"\" layout-wrap=\"\" layout-align=\"start center\"><md-card class=\"relative\" flex-gt-sm=\"30\" flex=\"100\" ng-repeat=\"shoot in stCtrl.shoots\"><md-card-content><section flex=\"\" layout=\"column\" layout-align=\"start center\"><span class=\"bold-text md-title\">{{shoot.collectionName}}</span> <span class=\"md-caption\" ng-if=\"shoot.location\">{{ shoot.location}}</span></section><section layout=\"\" layout-align=\"space-between center\"><span class=\"md-caption\"><span ng-if=\"shoot.date\">{{shoot.date | date : \"mediumDate\"}}</span><br><span ng-if=\"shoot.photographer.name\">{{shoot.photographer.name}}</span></span> <span class=\"md-subhead\">Rs. {{shoot.cost}}</span></section></md-card-content><md-divider></md-divider><md-dialog-actions><section flex=\"\" layout=\"\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ui-sref=\"app.photoShootView({id : shoot._id})\"><md-icon>airline_seat_recline_extra</md-icon><md-tooltip>Open Laid Back View</md-tooltip></md-button><md-button class=\"md-icon-button\" ui-sref=\"app.photoShootDetails({id : shoot._id})\"><md-icon>edit</md-icon><md-tooltip>Edit Shoot</md-tooltip></md-button></section></md-dialog-actions></md-card></div></section></div><script type=\"text/ng-template\" id=\"shootDialog.html\"><md-dialog> <form name=\"shootForm\"> <md-toolbar> <section class=\"md-toolbar-tools\" layout layout-align=\"space-between center\"> <h3>Add PhotoShoot</h3> <md-button class=\"md-icon-button\" ng-click=\"cancel();\" ng-disabled=\"stCtrl.savingShoot\"> <md-icon>close</md-icon> </md-button> </section> </md-toolbar> <div class=\"md-dialog-content\"> <div layout layout-wrap layout-align=\"start center\"> <md-input-container class=\"md-block\" flex=\"100\"> <label>Name</label> <input required type=\"text\" name=\"name\" ng-model=\"stCtrl.newShoot.collectionName\"/> </md-input-container> <md-input-container class=\"md-block\" flex=\"33\"> <label>Date</label> <md-datepicker name=\"date\" md-min-date=\"stCtrl.minDate\" required ng-model=\"stCtrl.newShoot.date\" md-placeholder=\"Enter date\"></md-datepicker> </md-input-container> <md-autocomplete flex=\"33\" required md-input-name=\"photographer\" md-input-minlength=\"2\" md-input-maxlength=\"18\" md-selected-item=\"stCtrl.newShoot.photographer\" md-search-text=\"stCtrl.searchText\" md-items=\"item in stCtrl.queryPhotographer(stCtrl.searchText)\" md-item-text=\"item.name\" md-require-match md-floating-label=\"Photographer\"> <md-item-template> <span md-highlight-text=\"stCtrl.searchText\">{{item.name}}</span> </md-item-template> </md-autocomplete> <md-input-container class=\"md-block\" flex=\"33\"> <label>Cost</label> <input required type=\"number\" min=\"0\" name=\"cost\" ng-model=\"stCtrl.newShoot.cost\"/> </md-input-container> <md-input-container class=\"md-block\" flex=\"100\"> <label>Location</label> <input required type=\"text\" name=\"location\" ng-model=\"stCtrl.newShoot.location\"/> </md-input-container> </div> </div> <md-dialog-actions> <md-button class=\"md-warn\" ng-click=\"cancel();\" ng-disabled=\"stCtrl.savingShoot || shootForm.$invalid\"> Cancel </md-button> <md-button type=\"submit\" class=\"md-accent\" ng-click=\"stCtrl.saveShoot()\" ng-disabled=\"stCtrl.savingShoot\"> <section layout layout-align=\"center center\"> <span ng-if=\"!stCtrl.savingShoot\">Save</span> <md-progress-circular md-diameter=\"24\" ng-if=\"stCtrl.savingShoot\"></md-progress-circular> </section> </md-button> </md-dialog-actions> </form> </md-dialog></script>");
$templateCache.put("app/modules/photoShoot/partials/laidBackView.html","<md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"upload photo\" ng-click=\"ltCtrl.export();\"><md-icon>file_download</md-icon></md-button><div style=\"min-height: 100vh;\"><md-tabs md-enable-disconnect=\"\" class=\"md-primary md-hue-2\" md-center-tabs=\"\" md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab ng-repeat=\"data in ltCtrl.shoot.batch\"><md-tab-label md-theme=\"dark-blue\"><h5>{{::$index+1 + \'. \'+ data.product.name}}</h5></md-tab-label><md-tab-body><div style=\"min-height: 75vh;\"><section layout-gt-sm=\"row\" layout-xs=\"column\" layout-sm=\"column\"><div flex-xs=\"100\" flex-sm=\"100\" layout=\"column\" layout-align=\"start center\"><md-card><img class=\"md-card-image\" ng-click=\"ltCtrl.openImageDialog(data.product.featured_image, $event);\" ng-src=\"{{ isSmall ? data.product.featured_image.urls.thumbnail : data.product.featured_image.urls.medium }}\"><md-card-title><md-card-title-text><span class=\"md-title center-text\">{{::data.product.name}}</span></md-card-title-text></md-card-title></md-card><p class=\"center-text md-caption\">Reference Images</p><section layout=\"\" layout-wrap=\"\"><div flex=\"33\" ng-repeat=\"image in data.referenceImages\" layout=\"\" layout-align=\"center center\"><md-card><img class=\"md-card-image\" ng-click=\"ltCtrl.openImageDialog(image, $event);\" ng-src=\"{{::image.urls.thumbnail }}\"></md-card></div></section></div><md-content class=\"md-padding\" flex=\"\"><section layout=\"\" layout-padding=\"\"><ul><li><span class=\"md-title\">Status : <span class=\"md-body-1\">{{::data.status | uppercase}}</span></span></li><li><span class=\"md-title\">Model : <span class=\"md-body-1\">{{::data.model.name}}</span></span></li><li><span class=\"md-title\">Accessories</span><ul><li ng-repeat=\"accessory in data.accessories\">{{::accessory}}</li></ul></li><li><span class=\"md-title\">People Involved</span><ul><li ng-repeat=\"people in data.helpingPeople\">{{::people.name}}</li></ul></li><li><span class=\"md-title\">Styling Tips</span><ul><li ng-repeat=\"tips in data.stylingTips\">{{::tips}}</li></ul></li><li><span class=\"md-title\">Concept Shoot : <span class=\"md-body-1\">{{!!data.conceptShoot.required}}</span></span></li><li ng-if=\"data.totalShots\"><span class=\"md-title\">Total Shots : <span class=\"md-body-1\">{{::data.totalShots}}</span></span></li><li><span class=\"md-title\">Paired With</span><ul><li ng-repeat=\"pair in data.pairedWith\">{{pair}}</li></ul></li><li ng-if=\"data.notes\"><span class=\"md-title\">Notes : <span class=\"md-body-1\">{{::data.notes}}</span></span></li></ul></section></md-content></section></div></md-tab-body></md-tab></md-tabs></div><canvas id=\"mycanvas\" style=\"display: none;\"></canvas><script type=\"text/ng-template\" id=\"image.html\"><md-dialog> <md-toolbar> <div class=\"md-toolbar-tools\" layout layout-align=\"space-between center\"> <h3>Image</h3> <md-button ng-click=\"cancel();\" class=\"md-icon-button\"> <md-icon>close</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content> <md-img md-src=\"{{dialogImage.urls.large}}\" style=\"height: 85vh; width: auto;\"/> </md-dialog-content> </md-dialog></script>");
$templateCache.put("app/modules/pos/add/add-customers.html","<div layout=\"column\" layout-fill=\"\" flex=\"\"><md-divider></md-divider><md-toolbar md-colors=\"{\'background\' : \'accent-50-1\'}\"><div class=\"md-toolbar-tools\" layout=\"\"><h2>Add Customer</h2><span flex=\"\" class=\"flex\"></span><md-button class=\"md-raised md-primary\" ng-disabled=\"newCustomerLeftForm.$invalid || newCustomerLeftForm.$pending || savingCustomer\" ng-click=\"saveCustomer()\">Save</md-button></div></md-toolbar><md-divider></md-divider><div layout=\"column\" layout-align=\"center center\" class=\"form-section\"><div layout=\"\" layout-align=\"center center\" flex=\"\" class=\"form-left-section md-padding md-margin\"><form name=\"newCustomerLeftForm\" layout=\"\" layout-wrap=\"\" class=\"customer-left-form\"><md-input-container flex=\"45\" class=\"md-block\"><label class=\"md-required\">Name</label> <input required=\"\" ng-minlength=\"3\" type=\"text\" name=\"name\" ng-model=\"newCustomer.name\"><div ng-messages=\"newCustomerLeftForm.name.$error\" class=\"md-input-messages-animation md-auto-hide\" aria-live=\"assertive\"><div ng-message=\"required\" class=\"md-input-message-animation\">Name is required.</div><div ng-message=\"md-maxlength\" class=\"md-input-message-animation\">The name has to be less than 30 characters long.</div></div></md-input-container><md-input-container flex=\"45\" flex-offset=\"10\" class=\"md-block\"><label class=\"md-required\">Mobile Number</label> <input type=\"tel\" ng-pattern=\"/^[56789][0-9]{9}$/\" name=\"mobile\" md-maxlength=\"10\" ng-minlength=\"10\" ng-maxlength=\"10\" required=\"\" ng-model=\"newCustomer.mobile\"></md-input-container><md-input-container flex=\"45\" class=\"md-block md-boring-theme\"><label>Email</label> <input md-maxlength=\"40\" type=\"email\" ng-model=\"newCustomer.email\"></md-input-container><md-input-container class=\"md-block md-boring-theme\" flex=\"45\" flex-offset=\"10\"><label class=\"md-placeholder\">Gender</label><md-select ng-model=\"newCustomer.gender\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" aria-expanded=\"false\" aria-multiselectable=\"false\" aria-invalid=\"false\" aria-label=\"Gender\"><md-option value=\"male\">Male</md-option><md-option value=\"female\">Female</md-option></md-select></md-input-container><md-input-container flex=\"100\" class=\"md-block\"><label>Address</label> <textarea ng-required=\"\" md-maxlength=\"100\" type=\"text\" ng-model=\"newCustomer.Address\"></textarea></md-input-container><md-input-container flex=\"100\" class=\"md-block\"><label>Landmark</label> <textarea ng-required=\"\" md-maxlength=\"100\" type=\"text\" ng-model=\"newCustomer.Address\"></textarea></md-input-container><md-input-container flex=\"30\" class=\"md-block md-boring-theme\"><label class=\"md-required\">Pin Code</label> <input type=\"number\" md-maxlength=\"6\" ng-model=\"newCustomer.Pincode\"></md-input-container><md-input-container flex=\"30\" flex-offset=\"5\" class=\"md-block md-boring-theme\"><label class=\"md-required\">City/Suburb</label> <input ng-required=\"\" md-maxlength=\"30\" type=\"text\" ng-model=\"newCustomer.City\"></md-input-container><md-input-container flex=\"30\" flex-offset=\"5\" class=\"md-block md-boring-theme\"><label class=\"md-required\">State</label> <input ng-required=\"\" md-maxlength=\"30\" type=\"text\" ng-model=\"newCustomer.State\" aria-invalid=\"true\"></md-input-container></form></div><div layout-align=\"center center\" layout-wrap=\"\" class=\"customer-preference-section md-margin md-padding\"><div class=\"customer-preference-question\"><h4>How did you hear about us?</h4><md-select ng-model=\"newCustomer.discoverability\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" aria-expanded=\"false\" aria-multiselectable=\"false\" aria-invalid=\"false\" aria-label=\"Gender\"><md-option value=\"Travel Magazines\" ng-selected=\"true\">Travel Magazines</md-option><md-option value=\"Email\">Email</md-option><md-option value=\"Sms\">Sms</md-option><md-option value=\"Online\">Online</md-option><md-option value=\"Through a friend\">Through a friend</md-option></md-select></div><div layout=\"column\" layout-align=\"start\"><md-checkbox md-required=\"\" ng-model=\"newCustomer.optedForLoyaltyReward\">Sign up for loyalty reward program</md-checkbox><md-checkbox md-required=\"\" ng-model=\"newCustomer.optedForCommunication\">Customer has opted in for calls/emails/sms</md-checkbox></div></div></div></div>");
$templateCache.put("app/modules/pos/add/coupon.html","<div layout=\"column\" layout-fill=\"\" flex=\"\" class=\"apply-coupon\"><md-divider></md-divider><md-toolbar md-colors=\"{\'background\' : \'accent-50-1\'}\"><div class=\"md-toolbar-tools\" layout=\"\"><h2>Apply Coupon</h2><span flex=\"\" class=\"flex\"></span></div></md-toolbar><md-divider></md-divider><div layout=\"column\" layout-align=\"center center\" class=\"form-section\"><div layout=\"\" layout-align=\"center center\" flex=\"\" class=\"form-left-section md-padding md-margin\"><form name=\"couponForm\" layout=\"column\" class=\"customer-left-form\"><md-input-container flex=\"45\" class=\"md-block\"><label class=\"md-required\">Enter Coupon Code</label> <input required=\"\" ng-minlength=\"3\" md-maxlength=\"15\" type=\"text\" name=\"couponCode\" ng-model=\"orderData.couponCode\"><div ng-messages=\"couponForm.couponCode.$error\"><div ng-message=\"required\">Coupon Code is required.</div><div ng-message=\"md-maxlength\">The couponCode has to be less than 15 characters long.</div></div></md-input-container><span class=\"text-center red-text\">{{couponErrorMessage}}</span><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"couponForm.$invalid || couponForm.$pending\" ng-click=\"checkCoupon()\">Apply Coupon</md-button></form></div></div></div>");
$templateCache.put("app/modules/pos/add/customer-info.html","<div layout=\"column\" layout-fill=\"\" flex=\"\" class=\"customer-info\"><md-divider></md-divider><md-toolbar md-colors=\"{\'background\' : \'accent-50-1\'}\"><div class=\"md-toolbar-tools\" layout=\"\"><h2>Customer Information</h2><span flex=\"\" class=\"flex\"></span></div></md-toolbar><md-divider></md-divider></div>");
$templateCache.put("app/modules/pos/add/customisable-product-builder.dialog.html","<md-dialog flex=\"90\" flex-xl=\"50\"><md-toolbar layout=\"\" layout-align=\"center center\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-subhead\">{{editing ? \"Edit Line Item\" : \"Add Customisable Product\"}}</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><form name=\"addCustomForm\" class=\"md-padding md-margin\"><div class=\"md-padding section-group\"><h3>1. Product Name</h3><md-input-container class=\"md-block\"><label>Product Name</label> <textarea required=\"\" name=\"productName\" ng-model=\"lineItem.name\"></textarea></md-input-container></div><div class=\"md-padding section-group\"><h3>2. Product Image</h3><div layout=\"\" layout-align=\"start center\"><image-selector flex=\"30\" ng-model=\"lineItem.image\"></image-selector></div></div><div class=\"md-padding section-group\"><h3>3. Materials</h3><div layout=\"column\" layout-align=\"start start\"><div md-whiteframe=\"-1\" ng-if=\"!lineItem.materials || !lineItem.materials.length\"><section class=\"md-padding\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/fashion-tshirts-colour.svg\" style=\"width: 150px; height: auto\"><md-button class=\"outline md-primary\" ng-click=\"showMaterialSelector($event)\">Select Materials</md-button></section></div><div layout=\"\" layout-align=\"end center\" ng-if=\"lineItem.materials.length\" class=\"full-width\"><md-button class=\"outline md-primary\" ng-click=\"showMaterialSelector($event)\">Update Materials</md-button></div><div layout=\"\" layout-wrap=\"\" layout-align=\"space-between stretch\"><section class=\"selected-materials-list\" layout=\"\"><div ng-repeat=\"material in lineItem.materials\" class=\"selected-material\" layout=\"column\" layout-align=\"center center\"><section class=\"selected-material-image large md-whiteframe-3dp\" ng-style=\"{\'backgroundImage\' : \'url(\' + mediaUrl + material.image.urls.medium +\')\'}\"></section><p class=\"md-caption\">{{capitalize(material.materialName)}}</p><p class=\"md-caption\">₹ {{material.totalPrice}}</p><div layout=\"\" layout-align=\"center center\" class=\"quantity-box\"><md-button class=\"md-icon-button medium md-primary subtract\" ng-click=\"updateStock(material, -0.25, $event, $index)\"><md-icon>remove_circle</md-icon></md-button><input ng-change=\"checkIfHasToBeRemoved(material, $index)\" class=\"quantity\" min=\"0\" step=\"0.25\" ng-model=\"material.quantity\" type=\"number\"><md-button class=\"md-icon-button medium md-primary add\" ng-click=\"updateStock(material, 0.25, $event, $index)\"><md-icon>add_circle</md-icon></md-button></div><md-button class=\"small md-warn\" ng-click=\"removeMaterial(material, $index)\">Remove</md-button></div></section></div></div></div><div class=\"md-padding section-group\"><h3>4. Linked Products</h3><div layout=\"column\" layout-align=\"start start\"><div layout=\"\" layout-align=\"space-between center\" class=\"full-width\"><div layout=\"\"><md-button class=\"md-raised small md-primary\" ng-repeat=\"option in quickAddProductOptions\" ng-disabled=\"option.added\" ng-click=\"addProduct(option)\">{{option.name}}</md-button></div><md-button class=\"outline md-primary\" ng-if=\"lineItem.linkedProducts.length\" ng-click=\"showProductSelectorDialog($event)\">Update Products</md-button></div><div md-whiteframe=\"-1\" ng-if=\"!lineItem.linkedProducts || !lineItem.linkedProducts.length\"><section class=\"md-padding\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/icons/getting-started.svg\" style=\"width: 150px; height: auto\"><md-button class=\"outline md-primary\" ng-click=\"showProductSelectorDialog($event)\">Select Products</md-button></section></div><div ng-if=\"lineItem.linkedProducts.length\" layout=\"\" layout-wrap=\"\" class=\"selected-materials-list products-list\"><div ng-repeat=\"product in lineItem.linkedProducts\" class=\"selected-material\" layout=\"column\" layout-align=\"center center\"><section class=\"selected-material-image large md-whiteframe-3dp\" ng-style=\"{\'backgroundImage\' : \'url(\' + mediaUrl + product.image.urls.medium +\')\'}\"></section><p class=\"md-caption\">{{capitalize(product.productName)}}</p><p class=\"md-caption\">₹{{product.totalPrice}}</p><div layout=\"\" layout-align=\"center center\" class=\"quantity-box\"><md-button class=\"md-icon-button medium md-primary subtract\" ng-click=\"updateStock(product, -1, $event, $index)\"><md-icon>remove_circle</md-icon></md-button><input ng-blur=\"checkIfHasToBeRemoved(product, $index)\" class=\"quantity\" min=\"0\" step=\"0.25\" ng-model=\"product.quantity\" type=\"number\"><md-button class=\"md-icon-button medium md-primary add\" ng-click=\"updateStock(product, 1, $event, $index)\"><md-icon>add_circle</md-icon></md-button></div></div></div></div></div><div class=\"md-padding section-group\"><h3>5. Size</h3><div layout=\"\" layout-wrap=\"\"><md-button class=\"md-primary\" ng-repeat=\"size in availableSizes\" ng-click=\"changeSize(size)\" ng-class=\"{\'md-raised\' : lineItem.variationText === size, \'outline\' : lineItem.variationText !== size}\">{{size}}</md-button></div></div><div class=\"md-padding section-group\"><h3>6. Estimated Delivery Date</h3><section layout=\"\"><md-input-container class=\"no-error-spacer md-block\" flex=\"40\"><input mdc-datetime-picker=\"\" date=\"true\" time=\"false\" type=\"text\" id=\"time\" short-time=\"true\" show-todays-date=\"\" click-outside-to-close=\"true\" placeholder=\"Order Date\" auto-ok=\"true\" min-date=\"minDate\" minute-steps=\"1\" format=\"DD-MMM-YYYY\" ng-model=\"lineItem.deliveryDate\"></md-input-container></section></div><div layout=\"\" layout-align=\"center center\" layout-margin=\"\" layout-padding=\"\" ng-if=\"error\" class=\"slide-up-fade-in\"><p class=\"red-text\">{{error}}</p></div></form></md-dialog-content><md-dialog-actions><div layout=\"\" layout-align=\"center center\" flex=\"\"><md-button class=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><span flex=\"\"></span> <span class=\"bold-text\">Total : ₹ {{lineItem.price}}</span><md-button class=\"md-primary\" ng-click=\"save()\">Save</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/pos/add/index.html","<section class=\"pos-add-page\"><div layout=\"\" layout-align=\"space-between center\" ng-show=\"offline\" class=\"md-padding\" md-colors=\"{\'background\' : \'warn-500-1\'}\"><span>Working offline now. Please connect to internet as soon as possible.</span><md-progress-circular md-diameter=\"24\"></md-progress-circular></div><div layout=\"\" layout-align=\"start center\"><md-button class=\"md-icon-button\" md-ink-ripple=\"\" ui-sref=\"app.pos.home\"><md-icon>arrow_back</md-icon></md-button><span class=\"md-caption\">Back To All Orders</span></div><div layout=\"\" layout-xs=\"column\" class=\"pos-add\" layout-align=\"stretch start\"><section flex-xs-none=\"\" flex-sm=\"60\" flex-gt-sm=\"70\"><div layout=\"\" layout-align=\"center center\"><div class=\"md-margin\" flex=\"\" layout=\"\" layout-align=\"stretch center\"><md-autocomplete flex=\"\" md-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-min-length=\"3\" md-selected-item-change=\"addToCart(selectedItem)\" md-menu-class=\"product-autocomplete-results\" placeholder=\"Search for products by sku, sku_size combo, product name, wid etc.\" md-items=\"item in query(searchText)\"><md-item-template><div layout=\"\" layout-align=\"stretch center\"><md-img md-src=\"{{item.featured_image.urls.thumbnail}}\" class=\"search-image\"></md-img><div layout=\"column\"><p md-highlight-text=\"searchText\">{{item.name}} ({{item.sku}}) - &#8377; {{item.price}}</p></div><span flex=\"20\"></span></div></md-item-template><md-not-found>No products matching \"{{searchText}}\" were found. <a ng-click=\"newProduct(searchText)\">Create a new one!</a></md-not-found></md-autocomplete></div></div><div layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-primary\" ng-click=\"openScannerDialog()\"><md-icon>control_camera</md-icon>Open Scanner</md-button><md-button class=\"md-primary md-raised\" ng-click=\"openCustomisableProductBuilderDialog($event)\"><md-icon>add</md-icon>Add Customisable Product</md-button></div><div ng-if=\"orderData.products.length\" layout=\"\" layout-wrap=\"\" layout-align=\"stretch stretch\" class=\"products-section\"><md-list flex=\"\"><md-list-item class=\"md-3-line md-margin line-item\" md-whiteframe=\"1\" ng-class=\"{\'small\' : isSmall}\" ng-repeat=\"product in orderData.products track by $index\"><md-img md-src=\"{{product.featured_image.urls.medium}}\" alt=\"{{product.name}}\" class=\"line-item-image md-avatar\"></md-img><div class=\"md-list-item-text\" layout=\"column\"><p class=\"md-body-1 product-name-container\" layout-sm=\"column\" layout-gt-sm=\"row\" layout-align-sm=\"center start\" layout-align-gt-sm=\"space-between center\"><a ng-click=\"showSpecs(product, $index)\" class=\"product-name md-link pointer\">{{product.name}}</a> <span>Quantity: {{product.quantity}}</span></p><p layout-sm=\"column\" layout-gt-sm=\"row\" layout-align-sm=\"center start\" layout-align-gt-sm=\"space-between center\" class=\"md-caption product-meta-container\"><span class=\"grey-text\">{{product.sku}}</span></p><p layout-sm=\"column\" layout-gt-sm=\"row\" layout-align-sm=\"center start\" layout-align-gt-sm=\"space-between center\" class=\"md-body-1 line-item-meta-container\"><span>Variation: {{product.selectedVariation}}</span> <span class=\"product-price\">&#8377; {{product.total || product.totalPrice}}</span></p></div><md-button ng-click=\"editProduct(product, $index, $event)\" class=\"md-primary md-raised md-secondary\">Edit</md-button></md-list-item></md-list></div><div ng-if=\"!orderData.products.length\" layout=\"column\" layout-align=\"center center\" class=\"products-section\"><img src=\"assets/images/blank.svg\" class=\"error-image\"><h5 class=\"error-title\">Scan and add products to view it here</h5></div></section><div class=\"add-customer\" flex=\"\"><section class=\"main-container\" flex=\"\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"start center\" flex=\"\"><md-button class=\"md-icon-button\" disabled=\"\"><md-icon>person_outline</md-icon></md-button><span class=\"md-title\">Customer</span> <span flex=\"\"></span><div class=\"timer\" ng-show=\"stopWatch\"><md-progress-circular md-diameter=\"32\" value=\"{{stopWatchProgress}}\" md-mode=\"determinate\" class=\"md-mode-determinate stopwatch-progress\"></md-progress-circular><span class=\"md-caption timer-text\">{{stopWatch}}</span></div></div></div><md-divider></md-divider><div class=\"md-padding\" ng-if=\"!orderData.user\"><md-autocomplete md-selected-item=\"selectedCustomerItem\" md-search-text=\"customersearchText\" md-min-length=\"3\" md-escape-options=\"none\" md-selected-item-change=\"addCustomerToOrder(selectedCustomerItem)\" md-menu-class=\"customer-autocomplete-results\" placeholder=\"Search for customer by mobile number, email ID, name\" md-items=\"item in customerQuery(customersearchText)\"><md-item-template><div layout=\"\" layout-align=\"stretch center\"><span md-highlight-text=\"customersearchText\">{{item.name}} ({{item.mobile}})</span></div></md-item-template><md-not-found><a ng-click=\"openSidebar(\'customers\')\">Create a new one!</a> No customers matching \"{{customersearchText}}\" were found.</md-not-found></md-autocomplete><div layout=\"\" layout-align=\"start center\"><span class=\"md-caption\"><i>Suggested :</i></span><md-button class=\"md-primary round outline small\" ng-click=\"selectSuggestedCustomer(\'Walk In\')\">Walk In</md-button></div></div><div ng-if=\"orderData.user\" class=\"md-padding\" layout=\"\" layout-align=\"space-between center\"><a class=\"md-link pointer\" ng-click=\"openSidebar(\'customer-info\')\">{{orderData.user.name}} ({{orderData.user.mobile}})</a><md-button class=\"md-icon-button\" ng-click=\"removeCustomer()\" ng-disabled=\"editingOrder\"><md-icon>close</md-icon></md-button></div><md-divider></md-divider><div class=\"coupon-section\" layout=\"\" layout-align=\"center center\"><md-button class=\"md-primary\" ng-disabled=\"!orderData.user || editingOrder\" ng-if=\"!orderData.coupon\" ng-click=\"openSidebar(\'coupons\')\">Apply Coupon</md-button><md-tooltip ng-if=\"!orderData.user\">Select a customer before checking for coupons</md-tooltip></div><md-divider ng-if=\"backDateOrder\"></md-divider><div layout=\"\" ng-if=\"backDateOrder\" class=\"md-padding\"><md-input-container class=\"no-error-spacer md-block\" flex=\"\"><label>Select Order Date</label> <input mdc-datetime-picker=\"\" date=\"true\" time=\"true\" type=\"text\" id=\"time\" short-time=\"true\" show-todays-date=\"\" click-outside-to-close=\"true\" placeholder=\"Order Date\" auto-ok=\"true\" min-date=\"minDate\" minute-steps=\"1\" format=\"DD-MMM-YYYY hh:mm a\" ng-model=\"orderData.createdAt\"></md-input-container></div><md-divider></md-divider><div layout=\"column\" class=\"md-padding\"><md-input-container flex=\"\" class=\"md-block\"><label>Select Billing Person</label><md-select ng-model=\"orderData.createdBy\" ng-change=\"updateCreatedBy()\"><md-option>Select User</md-option><md-option ng-repeat=\"user in users\" ng-value=\"user._id\"><div layout=\"column\"><span>{{user.name}}</span> <span class=\"md-caption\">{{user.mobile}}</span></div></md-option></md-select></md-input-container><md-input-container flex=\"\" class=\"md-block\"><label>Select Store</label><md-select ng-model=\"orderData.warehouse\" ng-disabled=\"currentUser.role !== \'admin\'\"><md-option>Select Warehouse</md-option><md-option ng-repeat=\"warehouse in warehouses\" ng-value=\"warehouse._id\"><div layout=\"column\"><span>{{warehouse.name}}</span></div></md-option></md-select></md-input-container></div><div class=\"md-chips applied-coupon\" layout=\"\" layout-align=\"space-between center\" ng-if=\"orderData.coupon\"><h5>Coupon</h5><md-chip class=\"md-chip pointer coupon\" layout=\"\" layout-align=\"center center\" md-colors=\"{\'background\' : \'primary-100-1\'}\"><span class=\"md-body-1 bold-text black-text\">{{ orderData.coupon.couponCode }}</span> <span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"orderData.coupon = \'\'\" ng-disabled=\"editingOrder\"><md-icon>close</md-icon></md-button></md-chip></div><md-divider></md-divider><div class=\"order-summary-section\" layout=\"column\"><md-list><md-list-item><p>Subtotal</p><p class=\"md-secondary value\">&#8377; {{orderData.subtotal}}</p></md-list-item><md-divider></md-divider><md-list-item><p>Discount</p><a class=\"md-secondary value md-link\" ng-disabled=\"editingOrder\" ng-click=\"openSidebar(\'order-discounts\')\">- &#8377; {{orderData.discount}}</a></md-list-item><md-divider></md-divider><md-list-item><p>Taxes</p><p class=\"md-secondary value\">&#8377; {{orderData.taxAmount || orderData.tax}}</p></md-list-item><md-divider></md-divider><md-list-item><p>Total</p><p class=\"md-secondary bold-text value total\">&#8377; {{orderData.total }}</p></md-list-item><md-divider></md-divider></md-list></div><div class=\"order-meta-actions-section\" layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-primary\" ng-disabled=\"!orderData.products.length || !orderData.user || editingOrder || parkingOrder\" ng-click=\"parkOrder()\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!parkingOrder\">Park Order</span><md-progress-circular ng-if=\"parkingOrder\" md-diameter=\"24\"></md-progress-circular></div></md-button><md-button class=\"md-warn\" ng-disabled=\"!orderData.products.length || !orderData.user\" ng-click=\"clearSession()\">Discard Order</md-button></div><div class=\"order-action-section\" layout=\"\" layout-align=\"stretch center\"><md-button class=\"md-raised md-primary md-block\" ng-click=\"prepareOrderSummary()\" ng-disabled=\"!orderData.products.length || !orderData.user\">{{editingOrder ? \'Update Order\' : \'Place Order\'}}</md-button></div></section></div></div><div class=\"loading-mask\" ng-if=\"fetchingOrder\" layout=\"column\" layout-align=\"center center\"><md-progress-circular></md-progress-circular><h4 class=\"md-title\">Loading ...</h4></div></section><md-sidenav class=\"md-sidenav-right\" md-disable-scroll-target=\"body\" md-component-id=\"customers\" md-whiteframe=\"4\"><div ng-include=\"\'app/modules/pos/add/add-customers.html\'\"></div></md-sidenav><md-sidenav class=\"md-sidenav-right\" md-disable-scroll-target=\"body\" md-component-id=\"product-specs\" md-whiteframe=\"4\"><div ng-include=\"\'app/modules/pos/add/product-specs.html\'\"></div></md-sidenav><md-sidenav class=\"md-sidenav-right\" md-disable-scroll-target=\"body\" md-component-id=\"customer-info\" md-whiteframe=\"4\"><div ng-include=\"\'app/modules/pos/add/customer-info.html\'\"></div></md-sidenav><md-sidenav class=\"md-sidenav-right\" md-disable-scroll-target=\"body\" md-component-id=\"measurements\" md-whiteframe=\"4\"><div ng-include=\"\'app/modules/pos/add/measurements.html\'\"></div></md-sidenav><md-sidenav class=\"md-sidenav-right\" md-disable-scroll-target=\"body\" md-component-id=\"coupons\" md-whiteframe=\"4\"><div ng-include=\"\'app/modules/pos/add/coupon.html\'\"></div></md-sidenav><md-sidenav class=\"md-sidenav-right\" md-disable-scroll-target=\"body\" md-component-id=\"order-discounts\" md-whiteframe=\"4\"><div ng-include=\"\'app/modules/pos/add/order-discount.html\'\"></div></md-sidenav><md-sidenav class=\"md-sidenav-right\" md-disable-scroll-target=\"body\" md-component-id=\"sale-summary\" md-whiteframe=\"4\"><div ng-include=\"\'app/modules/pos/add/sale-summary.html\'\"></div></md-sidenav><md-sidenav class=\"md-sidenav-right\" md-disable-scroll-target=\"body\" md-component-id=\"order-success\" md-whiteframe=\"4\" md-disable-backdrop=\"true\"><div ng-include=\"\'app/modules/pos/add/order-success.html\'\"></div></md-sidenav><script id=\"scannerDialog\" type=\"text/ng-template\"><md-dialog flex=\"90\"> <md-toolbar class=\"md-accent\"> <div class=\"md-toolbar-tools\" layout layout-align=\"space-between center\"> <h3>Scanner</h3> <md-button ng-click=\"cancel();\" class=\"md-icon-button\"> <md-icon>close</md-icon> </md-button> </div> </md-toolbar> <md-divider></md-divider> <md-dialog-content> <div id=\"scanner-container\"></div> </md-dialog-content> <md-dialog-actions md-colors=\"{\'background\' : \'boring-primary-500-0\'}\"> <div layout layout-align=\"space-between center\" flex> <md-button class=\"md-warn md-raised\" ng-click=\"cancel();\"> Close </md-button> </div> </md-dialog-actions> </md-dialog></script>");
$templateCache.put("app/modules/pos/add/measurements.html","<div layout=\"column\" layout-fill=\"\" flex=\"\" class=\"order-measurements\"><md-divider></md-divider><md-toolbar md-colors=\"{\'background\' : \'accent-50-1\'}\"><div class=\"md-toolbar-tools\" layout=\"\"><h2>Capture Custom Measurements</h2><span flex=\"\" class=\"flex\"></span></div></md-toolbar><md-divider></md-divider><div layout=\"column\" class=\"order-measurements-content\"><div flex=\"\"><h4 class=\"order-measurements-header\">Upper Chest</h4><md-slider-container class=\"md-margin md-padding\"><md-slider ng-model=\"products.measurement.upperChest\" aria-label=\"upperChest\" min=\"0\" max=\"60\"></md-slider><md-input-container><input type=\"number\" ng-model=\"products.measurement.upperChest\" aria-label=\"upperChest\" class=\"md-accent\"></md-input-container></md-slider-container></div></div></div>");
$templateCache.put("app/modules/pos/add/order-discount.html","<div layout=\"column\" layout-fill=\"\" flex=\"\" class=\"order-discounts\"><md-divider></md-divider><md-toolbar md-colors=\"{\'background\' : \'accent-50-1\'}\"><div class=\"md-toolbar-tools\" layout=\"\"><h2>Modify Order Discount</h2><span flex=\"\" class=\"flex\"></span></div></md-toolbar><md-divider></md-divider><div layout=\"column\" layout-align=\"center center\" class=\"product-specs-discount-sidenav-content\"><div layout=\"column\" layout-align=\"center center\" class=\"product-discount\"><div layout=\"column\" layout-align=\"center start\" class=\"product-discount-header\"><h2>Discount</h2></div><div layout=\"column\" layout-align=\"center center\" class=\"discount-info\"><div layout=\"\" layout-align=\"center center\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td class=\"md-cell\">Before Tax</td><td class=\"md-cell\">Rs. {{orderData.subtotal}}</td></tr><tr md-row=\"\"><td class=\"md-cell\">Discount</td><td class=\"md-cell\">- Rs. {{orderData.discount}}</td></tr><tr md-row=\"\"><td class=\"md-cell\">Subtotal</td><td class=\"md-cell\">Rs. {{sanitizeNumber(orderData.subtotal - orderData.discount)}}</td></tr><tr md-row=\"\"><td class=\"md-cell\">Taxes</td><td class=\"md-cell\">Rs. {{orderData.tax}}</td></tr><tr md-row=\"\"><td class=\"md-cell\"><h4>Total</h4></td><td class=\"md-cell\"><h4>Rs. {{orderData.total}}</h4></td></tr></tbody></table></div><div layout=\"column\" flex=\"\" layout-align=\"start center\"><div class=\"md-padding\"><md-button ng-click=\"changeOrderDiscountType(\'percent\')\" ng-class=\"{\'selected\' : orderData.discountType === \'percent\', \'not-selected\' : orderData.discountType !== \'percent\'}\">Percent</md-button><md-button ng-click=\"changeOrderDiscountType(\'amount\')\" ng-class=\"{\'selected\' : orderData.discountType === \'amount\', \'not-selected\' : orderData.discountType !== \'amount\'}\">Amount</md-button></div><div layout=\"\" class=\"md-padding md-margin\"><md-input-container class=\"no-error-spacer\"><input type=\"number\" min=\"0\" ng-model=\"orderData.discountValue\" placeholder=\"Value\"></md-input-container><md-button class=\"md-raised md-primary\" ng-click=\"applyOrderDiscount()\">Apply Discount</md-button></div></div></div></div></div></div>");
$templateCache.put("app/modules/pos/add/order-success.html","<div layout=\"column\" layout-fill=\"\" flex=\"\" class=\"order-success\"><md-divider></md-divider><md-toolbar md-colors=\"{\'background\' : \'accent-50-1\'}\"><div class=\"md-toolbar-tools\" layout=\"\"><h2>Sale Success</h2><span flex=\"\" class=\"flex\"></span></div></md-toolbar><md-divider></md-divider><div layout=\"column\" ng-if=\"orderData.status !== \'incomplete\'\" class=\"sale-summary-sidenav-content\"><div layout=\"column\" layout-align=\"center center\" class=\"sale-summary\"><div layout=\"column\" layout-align=\"center start\" class=\"sale-summary-header\"><h2>Sale Summary</h2></div><div class=\"sale-summary-info\" layout=\"column\"><md-list><md-list-item><p>Subtotal:</p><p class=\"md-secondary value\">Rs {{ orderData.subtotal}}</p></md-list-item><md-divider></md-divider><md-list-item><p>Discounts:</p><p class=\"md-secondary value\">- Rs {{ orderData.discount }}</p></md-list-item><md-divider></md-divider><md-list-item><p>Tax:</p><p class=\"md-secondary value\">Rs {{ orderData.tax }}</p></md-list-item><md-divider></md-divider><md-list-item><p>Total:</p><p class=\"md-secondary value\">Rs. {{orderData.total}}</p></md-list-item><md-divider></md-divider><md-list-item><p class=\"md-caption\">Payment</p></md-list-item><md-list-item><p>Cash:</p><p class=\"md-secondary value\">Rs. {{orderData.cashAmountTendered}}</p></md-list-item><md-list-item ng-if=\"orderData.cardAmountTendered && orderData.cardAmountTendered !== 0\"><p>Debit/Credit Card:</p><p class=\"md-secondary value\">Rs. {{orderData.cardAmountTendered}}</p></md-list-item><md-list-item ng-if=\"orderData.giftCardAmountTendered && orderData.giftCardAmountTendered !== 0\"><p>Gift Card:</p><p class=\"md-secondary value\">Rs. {{orderData.giftCardAmountTendered}}</p></md-list-item><md-list-item ng-if=\"orderData.storeCreditAmountTendered && orderData.storeCreditAmountTendered !== 0\"><p>Store Credit:</p><p class=\"md-secondary value\">Rs. {{orderData.storeCreditAmountTendered}}</p></md-list-item><md-divider></md-divider></md-list></div><div layout=\"\" layout-align=\"center center\" class=\"order-success-actions\"><md-button class=\"md-raised md-primary\" ng-click=\"openInvoicePrintPage()\">Print Invoice</md-button><md-button class=\"md-raised md-primary\" ng-click=\"emailInvoice()\">Email Invoice</md-button></div><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-raised md-margin md-padding new-sale-button\" ng-click=\"prepareNewSale()\">New Sale</md-button></div></div></div><div layout=\"column\" ng-if=\"orderData.status === \'incomplete\'\" class=\"sale-summary-sidenav-parkOrder-content\"><div layout=\"column\" layout-align=\"center center\"><div layout=\"column\" flex=\"\" layout-align=\"center center\"><h2>Order Parked Successfully</h2></div><div layout=\"column\" layout-align=\"center center\"><md-button class=\"md-raised md-margin md-padding new-sale-button\" ng-click=\"prepareNewSale()\">New Sale</md-button></div></div></div></div>");
$templateCache.put("app/modules/pos/add/product-specs.html","<div layout=\"column\" layout-fill=\"\" flex=\"\" class=\"product-specs\"><md-divider></md-divider><md-toolbar md-colors=\"{\'background\' : \'accent-50-1\'}\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><input type=\"text\" ng-model=\"selectedSpecsItem.name\" flex=\"\" style=\"margin-right: 50px\"><md-button class=\"md-raised md-warn\" ng-disabled=\"editingOrder && selectedSpecsItem.editDisabled\" ng-click=\"updateQuantity(\'remove\')\">Remove Product</md-button></div></md-toolbar><md-divider></md-divider><div layout=\"column\" layout-align=\"center center\" class=\"product-specs-quantity-sidenav-content\"><div layout=\"column\" layout-align=\"center center\" class=\"product-quantity\"><div layout=\"column\" layout-align=\"center start\" class=\"products-specs-header\"><h2>Quantity</h2></div><div class=\"products-specs-counter\" flex=\"100\"><md-button class=\"md-icon-button md-primary product-specs-counter-btn\" ng-click=\"updateQuantity(\'minus\')\"><md-icon>remove</md-icon></md-button><input md-colors=\"{\'borderColor\' : \'awesome-accent-500-1\'}\" ng-change=\"calculateOrderPrices();applyOrderDiscount();\" class=\"md-title montserrat ng-binding product-specs-counter-value\" ng-model=\"selectedSpecsItem.quantity\"><md-button class=\"md-icon-button md-primary product-specs-counter-btn\" ng-click=\"updateQuantity(\'add\')\"><md-icon>add</md-icon></md-button></div></div></div><div layout=\"column\" layout-align=\"center center\" class=\"product-specs-size-sidenav-content\"><div layout=\"column\" layout-align=\"center center\" class=\"product-size\"><div layout=\"column\" layout-align=\"center start\" class=\"products-specs-size-header\"><h2>Size</h2></div><div layout=\"column\" layout-align=\"center stretch\"><md-button ng-repeat=\"variation in selectedSpecsItem.variations\" ng-click=\"selectVariationForLineItem(selectedSpecsItem,variation)\" ng-init=\"varValue = getVariationValue(variation)\" ng-class=\"{\'selected\' : varValue === selectedSpecsItem.selectedVariation}\" class=\"size-btn\"><span>{{varValue}}</span></md-button></div></div></div><div layout=\"column\" layout-align=\"center center\" class=\"product-specs-price-sidenav-content\"><div layout=\"column\" layout-align=\"center center\" class=\"product-price\"><div layout=\"column\" layout-align=\"center start\" class=\"products-price-header\"><h2>Pricing</h2></div><div layout=\"column\" layout-align=\"center center\" class=\"pricing-info\"><h6 class=\"md-subhead\">MRP : Rs {{selectedSpecsItem.mrp}}</h6><h6 class=\"md-subhead\">Price : Rs {{selectedSpecsItem.price}}</h6><h6 class=\"md-subhead\">Total : Rs {{ selectedSpecsItem.price * selectedSpecsItem.quantity}}</h6><div layout=\"\" class=\"md-padding\"><md-button ng-click=\"changeDiscountType(\'percent\')\" ng-class=\"{\'selected\' : selectedSpecsItem.discountType === \'percent\', \'not-selected\' : selectedSpecsItem.discountType !== \'percent\'}\">Percent (%)</md-button><md-button ng-click=\"changeDiscountType(\'amount\')\" ng-class=\"{\'selected\' : selectedSpecsItem.discountType === \'amount\', \'not-selected\' : selectedSpecsItem.discountType !== \'amount\'}\">Amount (Rs.)</md-button></div><div layout=\"\" class=\"md-margin md-padding\"><md-input-container class=\"no-error-spacer\"><input type=\"number\" min=\"0\" ng-model=\"selectedSpecsItem.discountValue\" placeholder=\"Value\"></md-input-container><md-button class=\"md-raised md-primary\" ng-click=\"applyDiscount()\">Apply Discount</md-button></div></div></div></div><div layout=\"column\" class=\"product-specs-price-sidenav-content\"><div layout=\"\" layout-align=\"start center\" class=\"products-price-header\"><h2>Measurements</h2></div><div layout=\"\" layout-align=\"center center\"><md-card flex-gt-md=\"50\" flex-xs=\"100\" flex-sm=\"100\" flex-md=\"100\"><md-list><md-list-item ng-repeat=\"measurement in selectedSpecsItem.measurements\"><p class=\"order-measurements-header\" ng-if=\"!measurement.custom\">{{measurement.key}}</p><input ng-model=\"measurement.key\" type=\"text\" ng-if=\"measurement.custom\"> <input type=\"number\" ng-if=\"measurement.key !== \'HEIGHT\'\" ng-model=\"measurement.value\" aria-label=\"{{measurement.key}}\" class=\"md-accent md-secondary\" style=\"text-align: right\"><md-select ng-model=\"measurement.value\" class=\"md-secondary\" ng-if=\"measurement.key === \'HEIGHT\'\" placeholder=\"Select Height\"><md-option ng-value=\"height\" ng-repeat=\"height in heights\">{{height}}</md-option></md-select><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list><div class=\"md-padding md-margin\" layout=\"\" layout-align=\"end center\"><md-button class=\"md-raised md-accent\" ng-click=\"selectedSpecsItem.measurements.push({key : \'\' , value : 0, custom : true})\"><md-icon>add</md-icon><span>Add New Measurement</span></md-button></div></md-card></div></div></div>");
$templateCache.put("app/modules/pos/add/sale-summary.html","<form novalidate=\"\" layout=\"column\" layout-fill=\"\" flex=\"\" class=\"order-sale-summary\"><md-divider></md-divider><md-toolbar md-colors=\"{\'background\' : \'accent-50-1\'}\"><div class=\"md-toolbar-tools\"><h2>Sale Summary</h2><span flex=\"\" class=\"flex\"></span></div></md-toolbar><md-divider></md-divider><div layout=\"column\" class=\"sale-summary-sidenav-content\"><div layout=\"column\" layout-align=\"center center\" class=\"sale-summary\"><div layout=\"column\" layout-align=\"center start\" class=\"sale-summary-header\"><h2>Sale Summary</h2></div><div class=\"sale-summary-info\" layout=\"column\"><md-list><md-list-item><p>Before Tax:</p><p class=\"md-secondary value\">Rs {{ orderData.subtotal}}</p></md-list-item><md-divider></md-divider><md-list-item><p>Discount:</p><p class=\"md-secondary value\">- Rs {{ orderData.discount }}</p></md-list-item><md-divider></md-divider><md-list-item><p>Tax:</p><p class=\"md-secondary value\">Rs {{ orderData.taxAmount || orderData.tax}}</p></md-list-item><md-divider></md-divider><md-list-item><p class=\"md-title\">Total:</p><p class=\"md-secondary value md-headline bold-text\">&#8377; {{orderData.total}}</p></md-list-item><md-divider></md-divider><md-list-item ng-if=\"orderData.hasPendingAmount\"><p>Amount Paid:</p><p class=\"md-secondary value\">Rs {{ orderData.paidAmount }}</p></md-list-item><md-divider ng-if=\"orderData.hasPendingAmount\"></md-divider><md-list-item ng-if=\"orderData.hasPendingAmount\"><p class=\"md-title\">Amount Pending:</p><p class=\"md-secondary value md-headline bold-text\">&#8377; {{orderData.pendingAmount}}</p></md-list-item><md-divider ng-if=\"orderData.hasPendingAmount\"></md-divider></md-list><div layout=\"\" layout-align=\"start center\" class=\"md-padding\"><md-checkbox ng-model=\"orderData.approximatePrice\">Is this an approx price?</md-checkbox></div></div></div><div layout=\"column\" layout-align=\"center center\" class=\"sale-summary-customer-level-content\"><div layout=\"column\" layout-align=\"center start\" class=\"sale-summary-customer-level-header\"><h2>Payment</h2></div><div layout=\"row\" flex=\"\" layout-align=\"center center\" layout-margin=\"\" class=\"paymentData\"><md-input-container flex=\"\" class=\"md-block no-error-spacer\" md-no-float=\"\"><span layout=\"\">Cash Amount</span> <input placeholder=\"Cash Amount\" type=\"number\" ng-model=\"orderData.cashAmountTendered\"></md-input-container><md-input-container class=\"md-block no-error-spacer\" flex=\"\" md-no-float=\"\"><span>Debit/Credit Card Amount</span> <input ng-change=\"recalculateTenderedAmounts()\" ng-model-options=\"{\'debounce\' : 500}\" type=\"number\" placeholder=\"Card Amount\" ng-model=\"orderData.cardAmountTendered\"></md-input-container></div></div><div layout=\"\" layout-align=\"center center\"><h3>Amount Tendered : &#8377; {{orderData.cardAmountTendered + orderData.cashAmountTendered}}</h3></div><div layout=\"column\" layout-align=\"center center\" class=\"sale-summary-payment-mode-content\"><div layout=\"row\" layout-align=\"center center\" class=\"payment-mode-Btn\"><md-button class=\"md-raised md-primary\" ng-click=\"createNewOrder(\'cash\')\" ng-disabled=\"orderData.cardAmountTendered !== 0 || savingOrder\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!savingOrder\">Cash</span><md-progress-circular md-diameter=\"20\" class=\"md-accent\" ng-if=\"savingOrder\"></md-progress-circular></div></md-button><md-button class=\"md-raised md-primary\" ng-click=\"createNewOrder(\'card\')\" ng-disabled=\"savingOrder\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!savingOrder\">Debit/Credit Card</span><md-progress-circular md-diameter=\"20\" class=\"md-accent\" ng-if=\"savingOrder\"></md-progress-circular></div></md-button></div></div></div></form>");
$templateCache.put("app/modules/pos/cart/pos.cart.tmpl.html","<div layout=\"\" class=\"pos-cart\"><section layout=\"column\" flex=\"70\"><div class=\"md-margin\" flex=\"\" layout=\"\" layout-align=\"stretch center\"><md-autocomplete flex=\"\" md-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-min-length=\"3\" md-selected-item-change=\"addToCart(selectedItem)\" md-menu-class=\"product-autocomplete-results\" placeholder=\"Search for products by sku, sku_size combo, product name, wid etc.\" md-items=\"item in searchProducts(searchText)\" md-item-text=\"item.name\"><md-item-template><div layout=\"\" layout-align=\"stretch center\"><md-img md-src=\"{{item.featured_image.urls.thumbnail}}\" class=\"search-image\"></md-img><div layout=\"column\"><p md-highlight-text=\"searchText\">{{item.name}} ({{item.sku}}) - &#8377; {{item.price}}</p></div><span flex=\"20\"></span></div></md-item-template><md-not-found>No products matching \"{{searchText}}\" were found. <a ng-click=\"newProduct(searchText)\">Create a new one!</a></md-not-found></md-autocomplete></div><div layout=\"\" layout-wrap=\"\"><md-card flex=\"30\" ng-repeat=\"productData in cart.products track by $index\" style=\"position: relative\"><div style=\"position: absolute; right: 0px; top: 0px; width: 100%; z-index: 1;\" layout=\"\" layout-align=\"center center\"><span flex=\"\"></span><div layout=\"\" layout-align=\"center center\" style=\"width: 44px; height: 44px;\"><md-button class=\"md-icon-button\" md-ink-ripple=\"\" style=\"margin: 0; padding: 0;\" ng-click=\"removeProductFromCart(productData, $event, $index);\"><md-icon>close</md-icon><md-tooltip md-direction=\"bottom\">Remove product from cart</md-tooltip></md-button><md-progress-circular class=\"md-accent\" md-diameter=\"20\" ng-if=\"removingProduct\"></md-progress-circular></div></div><md-img md-src=\"{{productData.product.featured_image.urls.medium}}\" alt=\"{{productData.product.name}}\" class=\"md-card-image\"></md-img><md-card-content><h5>{{productData.product.name}}</h5><p class=\"md-body-1\">₹{{productData.price}}</p><p class=\"md-body-1\">Variation : {{productData.selectedVariationText}}</p></md-card-content><md-divider></md-divider><md-card-actions><div layout=\"\" layout-align=\"center center\"><md-button ng-click=\"calculateQuantity(\'add\', $index, productData)\"><md-icon>add</md-icon></md-button><span ng-model=\"productQuantity\">{{productData.quantity}}</span><md-button ng-click=\"calculateQuantity(\'remove\', $index, productData)\"><md-icon>remove</md-icon></md-button></div></md-card-actions></md-card></div></section><section layout=\"column\" flex=\"\"><md-card><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"start center\" flex=\"\"><md-button class=\"md-icon-button\" disabled=\"\"><md-icon>person_outline</md-icon></md-button><span class=\"md-title\">Customer</span></div></div><md-divider></md-divider><div class=\"md-padding\" ng-if=\"!cart.user\"><md-autocomplete md-selected-item=\"selectedCustomerItem\" md-search-text=\"customersearchText\" md-min-length=\"3\" md-escape-options=\"none\" md-selected-item-change=\"addCustomerToOrder(selectedCustomerItem)\" md-menu-class=\"customer-autocomplete-results\" placeholder=\"Search for customer by mobile number, email ID, name\" md-items=\"item in customerQuery(customersearchText)\"><md-item-template><div layout=\"\" layout-align=\"stretch center\"><span md-highlight-text=\"customersearchText\">{{item.name}} ({{item.mobile}})</span></div></md-item-template><md-not-found><a ng-click=\"openSidebar(\'customers\')\">Create a new one!</a> No customers matching \"{{customersearchText}}\" were found.</md-not-found></md-autocomplete></div><div ng-if=\"cart.user\" class=\"md-padding\" layout=\"\" layout-align=\"space-between center\"><a class=\"md-link pointer\" ng-click=\"openSidebar(\'customer-info\')\">{{cart.user.name}} ({{cart.user.mobile}})</a><md-button class=\"md-icon-button\" ng-click=\"removeCustomer()\" ng-disabled=\"editingOrder\"><md-icon>close</md-icon></md-button></div><md-divider></md-divider><div class=\"coupon-section\" layout=\"\" layout-align=\"center center\"><div ng-if=\"!couponExist\" layout=\"\" layout-align=\"stretch center\" class=\"md-padding\"><form name=\"couponForm\" layout=\"\" layout-align=\"stretch center\" class=\"coupon-card-form\"><md-input-container flex=\"100\"><label>Coupon Code</label> <input type=\"text\" ng-model=\"coupon.code\" name=\"couponCode\" aria-label=\"coupon\" class=\"md-accent\"></md-input-container></form></div><md-tooltip ng-if=\"!cart.user\">Select a customer before checking for coupons</md-tooltip><div ng-if=\"couponExist\" class=\"md-chips applied-coupon\" layout=\"\" layout-align=\"space-between center\"><h5>Coupon</h5><md-chip class=\"md-chip pointer coupon\" layout=\"\" layout-align=\"space-between center\" md-colors=\"{\'background\' : \'primary-100-1\'}\"><span class=\"md-body-1 bold-text black-text\">{{ cart.coupon.couponCode }}</span> <span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"removeCouponCode(cart.coupon._id)\"><md-icon>close</md-icon></md-button></md-chip></div></div><md-divider></md-divider><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-primary md-raised\" ng-disabled=\"couponExist\" ng-click=\"applyCouponCode()\"><span ng-if=\"!applyingCouponCode\">Apply</span><bubble-loader ng-if=\"applyingCouponCode\"></bubble-loader></md-button></div></md-card><md-card><div class=\"md-padding\" layout=\"\" layout-align=\"start center\"><md-icon id=\"gift-card-icon\">card_giftcard</md-icon><span class=\"md-title\">Apply GiftCard</span></div><md-divider></md-divider><div ng-if=\"!cart.giftCard\" layout=\"\" layout-align=\"stretch center\" class=\"md-padding\"><form name=\"giftCardForm\" layout=\"\" layout-align=\"stretch center\" class=\"gift-card-form\"><md-input-container flex=\"100\"><label>GiftCard Code</label> <input type=\"text\" md-maxlength=\"19\" ng-model=\"giftCard.code\" name=\"giftCard\" aria-label=\"giftCard\" class=\"md-accent\"><div ng-messages=\"giftCardForm.giftCard.$error\"><div ng-message=\"md-maxlength\">The giftCard must be less than 19 characters.</div></div></md-input-container></form></div><div class=\"md-chips applied-giftcard md-padding md-margin\" layout=\"\" layout-align=\"space-between center\" ng-if=\"cart.giftCard\"><h5>GiftCard:</h5><md-chip class=\"md-chip pointer giftCard\" layout=\"\" layout-align=\"center center\" md-colors=\"{\'background\' : \'primary-100-1\'}\"><span class=\"md-body-1 bold-text black-text\">{{ cart.giftCard }}</span> <span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"removeGiftCard(cart.giftCard)\"><md-icon>close</md-icon></md-button></md-chip></div><md-divider></md-divider><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-primary md-raised\" ng-disabled=\"cart.giftCard\" ng-click=\"applyGiftCard()\"><span ng-if=\"!applyingGiftCard\">Apply</span><bubble-loader ng-if=\"applyingGiftCard\"></bubble-loader></md-button></div></md-card></section></div>");
$templateCache.put("app/modules/pos/home/index.html","<div layout=\"column\" layout-align=\"center stretch\" class=\"pos-home-content\"><md-card class=\"pos-home-card-content\"><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"!showSearchBar\"><div class=\"md-toolbar-tools\"><h4 class=\"md-title\">Pos Invoice</h4><div flex=\"\"></div><md-button class=\"md-icon-button md-primary\" ng-click=\"fetchPosOrders()\"><md-icon>refresh</md-icon></md-button><md-button class=\"md-icon-button md-primary\" ng-click=\"openSearchToolbar()\"><md-icon>search</md-icon></md-button><md-button ui-sref=\"app.pos.add\" class=\"md-raised md-primary\"><md-icon>add</md-icon><span class=\"white-text\">New Sale</span></md-button></div></md-toolbar><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"showSearchBar\"><div class=\"md-toolbar-tools\"><form role=\"form\" novalidate=\"\" name=\"filterForm\" ng-submit=\"fetchPosOrders()\" flex-gt-sm=\"30\" flex=\"100\" layout=\"\" layout-align=\"center center\"><md-input-container flex=\"\" class=\"no-error-spacer\"><md-icon>search</md-icon><label>&nbsp;</label> <input type=\"search\" style=\"border-bottom-color: rgba(29,29,29,0.87); font-size: 0.8em\" id=\"search-bar1\" ng-model=\"query.search\" select-on-click=\"\" ng-model-options=\"{\'debounce\' : 500}\" ng-keypress=\"keyAction($event)\" placeholder=\"Search For Orders\"></md-input-container><md-button ng-click=\"fetchPosOrders()\" class=\"md-primary md-raised white-text\">Search</md-button><md-button class=\"md-icon-button md-warn\" ng-click=\"openSearchToolbar()\"><md-icon>close</md-icon></md-button></form></div></md-toolbar><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.orderBy\" md-on-reorder=\"fetchPosOrders\"><tr md-row=\"\" md-colors=\"{\'background\' : \'boring-accent-50-0.1\'}\"><th md-column=\"\" md-numeric=\"\">#</th><th md-column=\"\" md-numeric=\"\">Count</th><th md-column=\"\" md-order-by=\"orderNumber\">Order Number</th><th md-column=\"\" md-order-by=\"orders.orderData.user.name\"><span>User Name</span></th><th md-column=\"\" md-order-by=\"warehouse\">Store</th><th md-column=\"\" md-order-by=\"amount\">Amount (Rs.)</th><th md-column=\"\" md-order-by=\"status\">Order Status</th><th md-column=\"\" md-order-by=\"createdAt\"><span>Order Date</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"product\" md-select-id=\"name\" md-auto-select=\"\" ng-repeat=\"order in orders\" style=\"height: 75px;\" ng-style=\"{\'background\' : (order.status === \'incomplete\') || (order.status === \'cancelled\')? \'#fdf8ff\' : \'#ffffff\' }\"><td md-cell=\"\">{{$index + 1}}.</td><td md-cell=\"\"><span>{{order.orderData.products.length}}<md-tooltip><span ng-repeat-start=\"productData in order.orderData.products\">{{productData.product.name}}</span> <span ng-repeat-end=\"\" ng-if=\"!$last\">,</span></md-tooltip></span></td><td md-cell=\"\"><div layout=\"column\" layout-align=\"center center\" class=\"relative\"><a class=\"md-body-1 md-link pointer\" ng-click=\"openOrderDetailsPage(order)\">{{ order.orderNumber }}</a> <span class=\"pending-badge\" ng-if=\"order.hasPendingAmount\">Amount Pending</span></div></td><td md-cell=\"\"><span class=\"md-body-2\">{{order.user.name}}</span></td><td md-cell=\"\"><span class=\"md-caption\">{{order.warehouse ? order.warehouse.name : \'N/A\'}}</span></td><td md-cell=\"\"><span class=\"md-body-2\">Rs. {{order.amount ? order.amount : 0 | number : 0}}</span></td><td md-cell=\"\"><div layout=\"\" layout-align=\"start center\"><span class=\"dot-indicator\" ng-class=\"{ \'error\' : order.status ===\'incomplete\' || order.status ===\'parked\', \'pending\' : order.status === \'placed\', \'staging\' : [\'approved\', \'processing\', \'returned\', \'shipped\', \'packed\'].includes(order.status), \'success\' : order.status === \'delivered\'}\"></span> <span class=\"red-text\" ng-if=\"order.status ===\'parked\'\">PARKED</span> <span ng-if=\"order.status !== \'parked\'\">{{ order.status | uppercase }}</span></div></td><td md-cell=\"\" md-numeric=\"\">{{order.createdAt | date : \"medium\"}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[10, 25, 50, 100]\" md-page=\"query.page\" md-total=\"{{total}}\" md-on-paginate=\"fetchPosOrders\" md-page-select=\"\"></md-table-pagination></md-card></div>");
$templateCache.put("app/modules/posts/add-posts/add-posts.tmpl.html","<md-dialog aria-label=\"addNewUserDialog block\" flex-gt-sm=\"50\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\"><span>{{ editingMode ? \'Edit Post\' : \'Add New Post\'}}</span> <span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><form flex=\"\" ng-cloak=\"\" name=\"newPostForm\" layout=\"row\" layout-wrap=\"\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"start center\" flex=\"100\"><section flex=\"\"><image-selector ng-model=\"post.image\" style=\"width: 200px\" ng-change=\"updatePostType()\" required=\"\" multiple=\"\" placeholder=\"Select Image\"></image-selector></section><div flex=\"45\" layout=\"column\"><p class=\"center-text\">{{post.user.name}}</p><md-button class=\"small outline\" ng-click=\"userSelector($event)\">Select User</md-button></div></div><md-divider></md-divider><div layout=\"column\" flex=\"100\" style=\"margin-top: 20px; background: #f4f4f4;padding: 8px 12px;}\"><section layout=\"\" layout-align=\"space-between center\" style=\"margin-bottom: 20px\"><span class=\"bold-text md-title\">Tagged Products</span><md-button class=\"outline small\" ng-click=\"productSelector($event)\">Select Products</md-button></section><section layout=\"\" layout-align=\"start stretch\" layout-wrap=\"\" class=\"selected-materials-list\"><div ng-repeat=\"product in post.products\" flex=\"25\" class=\"selected-material\" layout=\"column\" layout-align=\"start center\"><section class=\"selected-material-image large\" ng-style=\"{\'backgroundImage\' : \'url(\' + mediaUrl + product.featured_image.urls.medium +\')\'}\"></section><p class=\"md-truncate md-tiny center-text\">{{product.name}}</p></div></section></div><md-input-container flex=\"100\" style=\"margin-top: 50px\"><label>Caption</label> <textarea ng-model=\"post.caption\" rows=\"5\" name=\"caption\" placeholder=\"Please enter the caption for this post\"></textarea></md-input-container></form></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\" md-whiteframe=\"1\"><md-button class=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><div layout=\"\" layout-align=\"end center\"><md-input-container class=\"no-error-spacer\"><md-checkbox ng-model=\"post.isPublished\">Published</md-checkbox></md-input-container><md-button ng-disabled=\"newPostForm.$invalid || savingPost\" type=\"submit\" class=\"outline md-accent\" ng-click=\"savePost();\">{{editingMode ? \"Edit\" : \"Save\"}}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/query/partials/index.html","<div><h2 class=\"center-text\">Query Builder</h2><md-card><md-card-content><div layout=\"\"><md-input-container class=\"md-block\" flex=\"20\"><label>Select Entity</label><md-select ng-model=\"selectedEntity\" ng-change=\"fetchOptions()\"><md-option ng-repeat-start=\"model in entities\" ng-value=\"model\">{{model}}</md-option><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-select></md-input-container><div flex=\"10\"><md-progress-circular md-diameter=\"20\" ng-if=\"fetchingOptions\"></md-progress-circular></div></div></md-card-content></md-card><md-card><md-table-conatiner><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\" ng-if=\"selectedEntity\"><thead md-head=\"\" md-order=\"query.sort\" md-on-reorder=\"fetchData\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\">#</th><th md-column=\"\" ng-repeat=\"key in keys\" md-order-by=\"{{key}}\">{{capitalize(key)}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"document\" md-select-id=\"document._id\" md-auto-select=\"\" ng-repeat=\"document in documents\"><td md-cell=\"\">{{ $index + 1}}.</td><td md-cell=\"\" ng-repeat=\"key in keys\" style=\"max-height: 75px;\">{{::document[key]}}</td></tr></tbody></table></md-table-conatiner><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[10, 25, 50, 100]\" md-page=\"query.page\" md-total=\"{{total}}\" md-on-paginate=\"fetchData\" md-page-select=\"\" md-boundary-links=\"\"></md-table-pagination></md-card></div>");
$templateCache.put("app/modules/products/editProductPriceDialog/edit-product-price.html","<md-dialog flex=\"90\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h4>Edit {{productsLength}} products</h4><md-button ng-click=\"cancel();\" class=\"md-icon-button\" ng-disabled=\"updatingProducts\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-progress-linear ng-if=\"!productsFetched\"></md-progress-linear><md-dialog-content style=\"overflow-y: hidden\"><section ng-if=\"productsFetched\" layout=\"\"><md-card flex=\"30\"><md-card-content><form name=\"editProductQuick\"><div layout=\"column\"><h4>Select Update Type :</h4><md-select ng-model=\"updatePrice.updateType\"><md-option value=\"\'\'\" ng-selected=\"true\">Select Update Type</md-option><md-option value=\"discount\">Discount</md-option><md-option value=\"salePrice\">Sale Price</md-option></md-select></div><div layout=\"\" ng-if=\"updatePrice.updateType === \'discount\'\"><md-input-container class=\"md-block\" flex=\"\"><label>Discount Percent (%)</label> <input type=\"number\" ng-disabled=\"updatingProducts\" ng-model=\"updatePrice.discountPercent\" ng-change=\"updateDataInSelected(\'discount\')\" ng-model-options=\"{\'debouce\' : 1000}\"> <i class=\"hint md-caption\">Sets the same discount value for all the products in the list</i></md-input-container></div><div layout=\"\" layout-align=\"center center\" ng-if=\"updatePrice.updateType === \'salePrice\' || updatePrice.updateType === \'mrp\'\"><md-input-container class=\"md-block\" flex=\"\"><label>Sale Price</label> <input type=\"number\" ng-disabled=\"updatingProducts\" ng-model=\"updatePrice.salePrice\" ng-change=\"updateDataInSelected(\'salePrice\')\"> <i class=\"hint md-caption\">Set the same sale price for all products with this input</i></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>MRP</label> <input type=\"number\" ng-disabled=\"updatingProducts\" ng-model=\"updatePrice.mrp\" ng-change=\"updateDataInSelected(\'mrp\')\"> <i class=\"hint md-caption\">Set the same MRP for all products with this input</i></md-input-container></div><div layout=\"\" layout-align=\"space-between center\"><md-switch ng-disabled=\"updatingProducts\" ng-model=\"updatePrice.updateStatus\">Update Status</md-switch></div><div layout=\"\" layout-align=\"center center\" ng-if=\"updatePrice.updateStatus\"><md-input-container class=\"md-block\" flex=\"\"><md-checkbox ng-model=\"updatePrice.featured\">Featured</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex=\"\"><md-checkbox ng-model=\"updatePrice.outOfStock\">Out Of Stock</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex=\"\"><md-checkbox ng-model=\"updatePrice.published\">Published</md-checkbox></md-input-container></div></form></md-card-content></md-card><div flex=\"\" layout=\"column\" style=\"max-height: calc(100vh - 128px); overflow-y: scroll\"><div layout=\"\" layout-align=\"center center\" class=\"md-padding\" md-colors=\"{\'background\' : \'boring-primary-50-0.25\'}\"><span>Products</span></div><form name=\"productPriceForm\"><md-table-container ng-init=\"setForm(productPriceForm, \'productPriceForm\')\"><table md-table=\"\" ng-model=\"selected\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\"></th><th md-column=\"\"><span>Product</span></th><th md-column=\"\" md-numeric=\"\"><span>Discount Percent</span></th><th md-column=\"\" md-numeric=\"\"><span>Sale Price (₹)</span></th><th md-column=\"\" md-numeric=\"\"><span>MRP (₹)</span></th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"product in products\"><td md-cell=\"\">{{$index + 1 }}.</td><td md-cell=\"\"><section layout=\"column\" layout-align=\"center start\"><span class=\"md-caption\">{{product.name}}</span> <span class=\"md-caption grey-text\">{{product.sku}}</span></section></td><td md-cell=\"\"><md-input-container md-no-float=\"\"><input type=\"number\" ng-disabled=\"updatingProducts\" ng-model=\"product.discountPercent\" placeholder=\"Discount %\" ng-blur=\"calculatePrice(product)\"></md-input-container></td><td md-cell=\"\"><md-input-container md-no-float=\"\"><input type=\"number\" ng-disabled=\"updatingProducts\" ng-model=\"product.price\" placeholder=\"Sale Price (Rs.)\" name=\"salePrice\" required=\"\"></md-input-container></td><td md-cell=\"\"><md-input-container md-no-float=\"\"><input type=\"number\" ng-disabled=\"updatingProducts\" ng-model=\"product.mrp\" placeholder=\"Mrp (Rs.)\"></md-input-container></td><td md-cell=\"\"><section layout=\"\" layout-align=\"center center\"><md-progress-circular ng-if=\"product.updating\" md-diameter=\"20\" class=\"md-accent\"></md-progress-circular><md-icon class=\"green-text\" ng-if=\"!product.updating && product.updated\">check</md-icon><md-icon class=\"red-text\" ng-if=\"!product.updating && !product.updated\">close</md-icon></section></td></tr></tbody></table></md-table-container></form></div></section><section layout=\"\" layout-align=\"center center\" ng-if=\"!productsFetched\" layout-fill=\"\" flex=\"\" style=\"min-height: calc(100vh - 128px)\"><md-progress-circular md-diameter=\"36\"></md-progress-circular></section></md-dialog-content><md-dialog-actions><div layout=\"\" layout-align=\"space-between center\" flex=\"\"><md-button class=\"md-warn md-raised\" ng-click=\"cancel();\" ng-disabled=\"!productsFetched || updatingProducts\">Close</md-button><md-button ng-click=\"update();\" class=\"md-raised md-primary\" ng-disabled=\"editProductQuick.$invalid || productPriceForm.$invalid || !productsFetched || updatingProducts || !products.length\">Update</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/products/partials/home.html","<md-section-header md-section-title=\"{{pageTitle}}\" md-back-state=\"{{backState}}\" class=\"product-section-title\" md-nested-state=\"nestedState\" copy-title-button=\"copyTitleButton\" copy-title-tooltip=\"copyTitleTooltip\"><md-button class=\"md-raised md-primary\" ng-click=\"onActionButtonClick();\" ng-if=\"showActionButton && !actionButtonDisabled.$$state.pending\">{{actionButtonText}}<md-icon>save</md-icon></md-button><md-progress-circular ng-if=\"actionButtonDisabled.$$state.pending\" md-mode=\"indeterminate\" md-diameter=\"40\" class=\"md-accent\"></md-progress-circular></md-section-header><div ui-view=\"\"></div>");
$templateCache.put("app/modules/products/product-selector/products-selector.html","<md-dialog flex=\"80\" class=\"products-selector-dialog\"><md-toolbar layout=\"\" layout-align=\"center center\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h3 class=\"md-subhead\">Select Products</h3><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"relative\"><form name=\"productSelectorForm\" class=\"md-padding md-margin\"><div layout=\"\" flex=\"100\"><md-autocomplete flex=\"\" md-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-min-length=\"3\" md-selected-item-change=\"addToCart(selectedItem)\" md-menu-class=\"product-autocomplete-results\" placeholder=\"Search for products by sku, sku_size combo, product name, wid etc.\" md-items=\"item in fetchProducts(searchText)\"><md-item-template><div layout=\"\" layout-align=\"stretch center\"><md-img md-src=\"{{item.featured_image.urls.thumbnail}}\" class=\"search-image\"></md-img><div layout=\"column\"><p md-highlight-text=\"searchText\">{{item.name}} ({{item.sku}}) - &#8377; {{item.price}}</p></div><span flex=\"20\"></span></div></md-item-template><md-not-found>No products matching \"{{searchText}}\" were found.</md-not-found></md-autocomplete></div><md-divider></md-divider><h4 style=\"margin-top: 50px\">Selected Products :</h4><div layout=\"\" layout-wrap=\"\" layout-align=\"stretch stretch\" ng-if=\"selectedProducts.length\"><section flex=\"25\" ng-repeat=\"product in selectedProducts\"><md-card><md-img md-src=\"{{product.image.urls.medium}}\" class=\"md-card-image\"></md-img><md-card-content layout=\"column\" layout-align=\"center center\"><p class=\"md-caption\">{{capitalize(product.productName)}}</p><p class=\"md-caption\">₹{{product.totalPrice}}</p><div layout=\"\" layout-align=\"center center\" class=\"quantity-box\"><md-button class=\"md-icon-button medium md-primary subtract\" ng-click=\"updateStock(product, -1, $event, $index)\"><md-icon>remove_circle</md-icon></md-button><input ng-blur=\"checkIfHasToBeRemoved(product, $index)\" class=\"quantity\" min=\"0\" step=\"0.25\" ng-model=\"product.quantity\" type=\"number\"><md-button class=\"md-icon-button medium md-primary add\" ng-click=\"updateStock(product, 1, $event, $index)\"><md-icon>add_circle</md-icon></md-button></div></md-card-content></md-card></section></div><div ng-if=\"!selectedProducts.length\" layout=\"\" layout-align=\"center center\"><img src=\"assets/images/blank.svg\" style=\"width: 150px\"> <span></span></div></form></md-dialog-content><md-dialog-actions class=\"md-whiteframe-2dp\"><div layout=\"\" layout-align=\"center center\" flex=\"\"><md-button class=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><span flex=\"\"></span><md-button class=\"md-primary outline\" ng-click=\"save()\">Save</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/products/productListDialog/product-list.dialog.html","<md-dialog aria-label=\"productListDialog\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Product List</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content-body md-padding\"><md-card><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\">Product</th><th md-column=\"\" md-numeric=\"\">Rating</th><th md-column=\"\" md-numeric=\"\">Size</th><th md-column=\"\" md-numeric=\"\">Price</th><th md-column=\"\" md-numeric=\"\">Qty.</th><th md-column=\"\" md-numeric=\"\">Total</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"productData in products\" style=\"height: 75px;\"><td md-cell=\"\"><md-img md-src=\"{{ productData.product.featured_image.urls.thumbnail }}\" alt=\"{{productData.product.name}}\" class=\"pointer\" style=\"width: 50px; height: auto; margin: 5px;\" ng-click=\"openQuickView($event, productData.product)\"></md-img></td><td md-cell=\"\"><div layout=\"column\"><a ng-href=\"{{frontEndUrl + \'/product/\' + productData.product.slug}}\" target=\"_blank\" class=\"green-text pointer\">{{ capitalize(productData.product.name)}}</a> <a class=\"md-primary pointer\" ng-if=\"productData.measurements || productData.variation.measurements\" ng-click=\"viewMeasurementsDialogs($event, productData)\">View Measurements</a></div></td><td md-cell=\"\"><a class=\"green-text pointer\" ng-if=\"productData.ratingValue\" ng-click=\"openReviewListDialog($event, [productData])\">{{productData.rating}}</a> <span ng-if=\"!productData.ratingValue\">-</span></td><td md-cell=\"\">{{productData.selectedVariationText}}</td><td md-cell=\"\"><div layout=\"column\" layout-align=\"center end\"><strike class=\"red-text md-tiny\" ng-if=\"productData.product.mrp\">Rs.{{ productData.product.mrp }}</strike><span class=\"bold-text md-caption\">Rs.{{ productData.price }}</span> <span class=\"green-text md-tiny\" ng-if=\"productData.product.discountValue\">{{ productData.product.discountValue }} %</span></div></td><td md-cell=\"\">{{ productData.quantity }}</td><td md-cell=\"\">{{ productData.totalPrice }}</td><td md-cell=\"\"><div layout=\"\"><md-button class=\"md-icon-button\" target=\"_blank\" ui-sref=\"app.products.add.home({slug : productData.product._id, name : productData.product.name, newProduct : false})\"><md-icon>edit</md-icon><md-tooltip>Edit Product in New Tab</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"showCustomisation(productData, $event);\" ng-if=\"productData.product.productType === 1\"><md-icon>rate_review</md-icon><md-tooltip>View Customisation</md-tooltip></md-button></div></td></tr></tbody></table></md-table-container></md-card></md-dialog-content></form></md-dialog>");
$templateCache.put("app/modules/products/productTemplates/product-templates.tmpl.html","<md-dialog aria-label=\"productTemplatesDialog\" flex=\"100\" class=\"product-templates-dialog\"><form ng-cloak=\"\"><md-toolbar class=\"md-primary md-hue-3\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">keyboard_backspace</md-icon></md-button><h2>Product Templates : {{product.name}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content-body\"><div layout=\"\"><section layout=\"column\" flex=\"25\" class=\"templates-list\" ng-if=\"!viewMode\"><md-subheader><section layout=\"\" layout-align=\"space-between center\"><span>Templates ({{templates.length}})</span><md-button class=\"md-raised md-primary\" ng-click=\"addTemplate()\">Add Template</md-button></section></md-subheader><div layout=\"\" layout-align=\"center center\" layout-margin=\"\" layout-padding=\"\" ng-if=\"fetchingTemplates\"><md-progress-circular></md-progress-circular></div><md-list ng-if=\"templates.length && !fetchingTemplates\"><md-list-item ng-repeat-start=\"template in templates\" ng-click=\"selectTemplate(template, $index)\" class=\"white templates-list-item\" style=\"margin: 8px\" ng-class=\"{\'selected\' : ucData._id === template._id}\"><section flex=\"\" layout=\"\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"center center\" flex=\"\"><img ng-src=\"{{mediaUrl+ template.image.urls.large }}\" alt=\"{{template.name}}\" style=\"width: 60px; height: 84px; margin: 5px;\"><section layout=\"column\" flex-offset=\"5\" flex=\"\"><span>{{template.name}}</span> <span>₹ {{template.price}}</span> <span class=\"md-tiny\">Created At : {{template.createdAt | date : \'medium\'}}</span></section></div><div layout=\"column\" layout-align=\"space-around end\"><md-button class=\"md-icon-button\" ng-click=\"viewOnWebsite(template.slug, $event)\"><md-icon>open_in_new</md-icon></md-button></div></section><attached-tag class=\"md-tiny active-tag\" top=\"70%\" bottom=\"2px\" right=\"2%\" background=\"{{getBackGround(template.status)}}\"><tag-content>{{template.status}}</tag-content></attached-tag></md-list-item><md-divider ng-repeat-end=\"\"></md-divider><div ng-if=\"!fetchingTemplates && !templates.length\" class=\"md-padding md-margin\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/error.svg\" style=\"max-width: 100px; height: auto\"><p class=\"text-center\">No Templates Found</p></div><div ng-if=\"fetchingTemplates\" class=\"md-padding md-margin\" layout=\"column\" layout-align=\"center center\"><md-progress-circular></md-progress-circular><span>Fetching Templates</span></div></md-list></section><section flex=\"\" flex-offset=\"5\" layout=\"\" class=\"customisation-editor-dialog\"><div flex=\"33\" class=\"options-section\" ng-class=\"{\'view-mode\' : !adding && !editing}\"><h5 class=\"text-center md-title\">Layers</h5><md-divider></md-divider><section class=\"single-layer\" ng-repeat=\"data in product.customisation.data\" ng-init=\"parentIndex = $index\"><div class=\"pointer expansion-header\" md-whiteframe=\"2\" layout=\"\" ng-click=\"expandLayer(data)\" layout-align=\"space-between center\"><section class=\"layer-title\"><span class=\"bold-text md-body-1\">{{data.name}}</span> <span class=\"md-caption\">: {{data.default.name}}</span></section><section layout=\"\"><md-button class=\"md-icon-button\"><md-icon>{{data.expanded ? \'keyboard_arrow_up\' : \'keyboard_arrow_down\'}}</md-icon></md-button></section></div><div class=\"expansion-content\" md-whiteframe=\"1\" ng-class=\"{\'expanded\' : data.expanded}\" layout=\"\" layout-wrap=\"\"><section class=\"single-option\" ng-repeat=\"option in data.options\" layout=\"column\" flex=\"50\" layout-align=\"stretch center\" ng-class=\"{\'disabled\' : option.disabled}\"><md-card class=\"option-card relative\" ng-class=\"{\'pointer\' : !disableSelection, \'disabled\' : disableSelection}\" md-ink-ripple=\"{{!disableSelection}}\" ng-click=\"selectOption(data, option); openNextLayer(parentIndex)\"><section layout=\"\" layout-align=\"center center\"><customisable-product-view selected-index=\"parentIndex\" current-index=\"$index\" class=\"md-media-sm card-media\" size=\"small-2x\" position=\"getSelectedPosition(data);\" background-scale=\"getBackgroundScale( data);\" customisation=\"product.customisation\"></customisable-product-view></section><div layout=\"column\" layout-align=\"center center\"><span class=\"text-center md-caption name\">{{option.name}}</span> <span class=\"text-center md-tiny price grey-text\">{{getPrice(option.stockAndPrice)}}</span></div><md-button ng-disabled=\"disableSelection\" ng-class=\"{\'md-raised selected\' : data.default === option}\">{{data.default === option ? \'Selected\' : \'Select\'}}</md-button></md-card></section></div></section></div><div flex=\"33\" class=\"preview-section\" layout=\"column\" layout-align=\"start center\" ng-class=\"{\'view-mode\' : !adding && !editing}\"><p class=\"text-center\">Preview</p><customisable-product size=\"medium\" white-frame=\"false\" fallback=\"{{product.featured_image.urls.large}}\" name=\"customisable-main\" customisation=\"product.customisation\"></customisable-product></div><div flex=\"33\" class=\"config-section\" ng-if=\"adding || editing\" md-whiteframe=\"2\"><md-toolbar class=\"md-primary md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"stretch center\"><md-button class=\"md-icon-button\" ng-click=\"clearState()\" ng-disabled=\"savingTemplate\"><md-icon>close</md-icon></md-button><h5 class=\"center-text\">{{editing ?\'Edit Template\' : \'Create New Template\'}}</h5><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-disabled=\"savingTemplate\" ng-click=\"saveTemplate()\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!savingTemplate\">{{editing ? \'Update\' : \'Save\'}}</span><md-progress-circular md-diameter=\"20\" ng-if=\"savingTemplate\"></md-progress-circular></div></md-button></div></md-toolbar><div class=\"md-padding\"><form name=\"templateForm\" ng-submit=\"saveTemplate()\"><section layout=\"\" layout-wrap=\"\"><md-input-container class=\"minimal\" flex=\"100\"><label>Name</label> <input type=\"text\" name=\"name\" ng-model=\"ucData.name\" required=\"\"></md-input-container><md-input-container class=\"minimal\" flex=\"100\"><label>Slug</label> <input disabled=\"\" type=\"text\" name=\"slug\" ng-model=\"ucData.slug\" placeholder=\"Automatically Generated\"></md-input-container><md-input-container class=\"minimal\" flex=\"50\"><label>Price</label> <input type=\"number\" required=\"\" min=\"0\" name=\"totalPrice\" ng-model=\"ucData.price\"></md-input-container><md-input-container class=\"minimal\" flex=\"50\"><label>Status</label><md-select ng-model=\"ucData.status\" required=\"\"><md-option value=\"active\">Active</md-option><md-option value=\"draft\">Draft</md-option><md-option value=\"deleted\">Deleted</md-option></md-select></md-input-container></section></form></div></div></section></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/modules/products/quickViewDialog/quickView.tmpl.html","<md-dialog flex=\"90\" id=\"quick-view-dialog\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h3>Quick View</h3><md-button ng-click=\"closeDialog();\" class=\"md-icon-button\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content ng-class=\"{\'md-dialog-content\' : !isSmall}\"><div layout=\"column\"><section ng-if=\"!loadingProduct\" layout-xs=\"column\" layout-gt-sm=\"row\" layout-align=\"center start\" layout-align-xs=\"start center\"><div layout=\"column\" layout-align=\"center center\" flex-gt-sm=\"33\" flex-xs=\"100\" flex-sm=\"100\"><div layout=\"column\" layout-align=\"start center\"><md-img style=\"width: 100%; border-radius: 4px; border-bottom: 4px\" md-src=\"{{selectedImage.urls.large}}\"></md-img><md-content md-scroll-x=\"\" layout=\"\" layout-align=\"center center\"><md-img class=\"md-margin\" style=\"width: 75px; height: auto; border-radius: 4px;\" ng-repeat=\"image in product.gallery\" ng-click=\"selectImage(image)\" md-src=\"{{image.urls.thumbnail}}\"></md-img></md-content></div><div layout=\"column\" layout-align=\"center center\" class=\"hide-xs hide-sm\"><table class=\"table table-bordered table-striped table-hover md-caption\"><caption>Price History</caption><thead><tr><th>Sl.</th><th>By</th><th>Mrp</th><th>Price</th><th>Time</th><th>Type</th></tr></thead><tbody><tr ng-init=\"priceHistoryLimit = 5\" ng-repeat=\"priceHistory in priceHistories | limitTo : priceHistoryLimit\"><td>{{::$index + 1}}.</td><td>{{::priceHistory.created_by.name ? priceHistory.created_by.name : \"N/A\"}}</td><td>{{::priceHistory.mrp ? \'₹\' + priceHistory.mrp : \'N/A\'}}</td><td>₹{{::priceHistory.price}}</td><td>{{::dateAgo(priceHistory.date)}}<md-tooltip>{{priceHistory.date | date : \'medium\'}}</md-tooltip></td><td><md-icon ng-class=\"{\'md-warn\' : priceHistory.updateType === \'dec\', \'green-text\' : priceHistory.updateType === \'inc\' }\">{{priceHistory.updateType === \'inc\' ? \'arrow_upward\' : \'arrow_downward\'}}</md-icon></td></tr></tbody></table><div layout=\"\" layout-align=\"center center\" ng-show=\"priceHistories.length > 5\"><md-button class=\"small md-raised md-accent\" ng-show=\"priceHistoryLimit !== priceHistories.length\" ng-click=\"priceHistoryLimit = priceHistories.length\">View All<md-icon>arrow_drop_down</md-icon></md-button><md-button class=\"small md-raised md-accent\" ng-show=\"priceHistoryLimit === priceHistories.length\" ng-click=\"priceHistoryLimit = 5\">Hide<md-icon>arrow_drop_up</md-icon></md-button></div></div></div><div flex=\"\" layout-padding=\"\" layout=\"column\"><h4>{{product.name}}</h4><p><i>SKU :</i>{{product.sku}} <span class=\"customisable-badge\" ng-if=\"product.productType === 1\" style=\"background: rgb(255, 224, 83); margin-left: 8px; color: #2d2d2d; padding: 4px 8px;\">CUSTOMISABLE PRODUCT</span></p><p ng-class=\"{\'red-text\' : !product.sizeChart}\"><i>Size Chart : {{product.sizeChart ? \'Set\' : \'Not Set\'}}</i></p><div layout=\"\" layout-align=\"start center\"><strike class=\"md-body-1\" ng-if=\"product.isOnSale\">{{ \"Rs. \" + product.mrp}}</strike><span style=\"padding-left: 20px;\" class=\"md-title green-text bold-text\">{{ \"Rs. \" + product.price}}</span> <span class=\"discount-percent\" ng-if=\"product.isOnSale\">{{product.discountPercent}}%</span> <span style=\"margin-left: 24px\">(<span class=\"md-caption\" ng-repeat=\"category in product.categories\">{{category.name}}<span class=\"md-caption\" ng-if=\"!$last\">,</span></span>)</span></div><section class=\"relative\"><div layout=\"\" layout-wrap=\"\" layout-align=\"center center\"><section ng-repeat=\"field in fields\" flex=\"{{field.formType === \'switch\' ? 45 : 45}}\" layout=\"\" layout-align=\"space-between center\" style=\"padding: 4px 8px; margin: 4px; border: 1px dashed #efefef\"><p>{{field.title}}</p><md-switch ng-if=\"field.formType === \'switch\'\" ng-change=\"update()\" class=\"md-primary\" ng-model=\"product[field.model]\" ng-disabled=\"field.disabled\"></md-switch><md-select ng-if=\"field.formType === \'select\'\" ng-disabled=\"field.disabled\" ng-change=\"update()\" class=\"md-primary\" ng-model=\"product[field.model]\"><md-option ng-repeat=\"option in field.options\" ng-value=\"option.value\">{{option.title}}</md-option></md-select></section></div><div class=\"loading-mask\" layout=\"column\" layout-align=\"center center\" ng-if=\"product.updating\"><md-progress-circular></md-progress-circular><h3 class=\"md-title\">Updating Product ...</h3></div></section><md-card><div layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">Variations</span><md-button class=\"md-primary outline\" ng-click=\"showStockHistory($event)\"><md-icon>history</md-icon>View Stock Updates</md-button></div><md-table-container><table md-table=\"\" class=\"table-striped\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Sl.</th><th md-column=\"\">Size</th><th md-column=\"\">CP</th><th md-column=\"\">MSP</th><th md-column=\"\">Sale Price</th><th md-column=\"\">MRP</th><th md-column=\"\">Dis. (%)</th><th md-column=\"\">Stock</th><th md-column=\"\">Status</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"variation in product.variations\"><td md-cell=\"\" md-numeric=\"\" class=\"md-caption\">{{$index + 1}}.</td><td md-cell=\"\" md-numeric=\"\" class=\"md-caption\">{{getVariationValues(variation)}}</td><td md-cell=\"\" md-numeric=\"\" class=\"md-tiny\">₹{{variation.stockAndPrice.price.productionCost}}</td><td md-cell=\"\" md-numeric=\"\" class=\"md-tiny\">₹{{variation.stockAndPrice.price.msp}}</td><td md-cell=\"\" md-numeric=\"\" class=\"md-tiny\">₹{{variation.stockAndPrice.price.salePrice}}</td><td md-cell=\"\" md-numeric=\"\" class=\"md-tiny\">₹{{variation.stockAndPrice.price.mrp}}</td><td md-cell=\"\" md-numeric=\"\" class=\"md-tiny\">{{(((variation.stockAndPrice.price.mrp - variation.stockAndPrice.price.salePrice) / variation.stockAndPrice.price.mrp) * 100).toFixed(0)}}</td><td md-cell=\"\" md-numeric=\"\" class=\"md-caption\">{{variation.stockAndPrice.stock.quantity}}</td><td md-cell=\"\" md-numeric=\"\" style=\"text-align: center\"><md-icon ng-class=\"{\'green-text\' : !variation.outOfStock , \'red-text\' : variation.outOfStock }\">{{variation.outOfStock ? \'remove_circle\' : \'check_circle\'}}<md-tooltip>Stock {{variation.outOfStock ? \'Unavailable\' : \'Available\'}}</md-tooltip></md-icon></td></tr></tbody></table></md-table-container></md-card><md-card><md-table-container><table md-table=\"\" class=\"table-striped\"><caption class=\"md-title center-text\">Attributes</caption><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Sl.</th><th md-column=\"\">Key</th><th md-column=\"\">Values</th><th md-column=\"\">Variation</th><th md-column=\"\">Visible</th><th md-column=\"\">Filters</th><th md-column=\"\">Featured</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-init=\"data = getAttributeData(attribute)\" ng-repeat=\"attribute in product.attributes\"><td md-cell=\"\" md-numeric=\"\">{{$index + 1}}.</td><td md-cell=\"\">{{data.key}}</td><td md-cell=\"\">{{data.values}}</td><td md-cell=\"\" md-numeric=\"\"><md-icon ng-class=\"{\'md-warn\' : !attribute.isVariation, \'green-text\' : attribute.isVariation }\">{{attribute.isVariation ? \'check\' : \'close_circle\'}}</md-icon></td><td md-cell=\"\" md-numeric=\"\"><md-icon ng-class=\"{\'md-warn\' : !attribute.visible, \'green-text\' : attribute.visible }\">{{attribute.visible ? \'check\' : \'close_circle\'}}</md-icon></td><td md-cell=\"\" md-numeric=\"\"><md-icon ng-class=\"{\'md-warn\' : !attribute.applyFilters, \'green-text\' : attribute.applyFilters }\">{{attribute.applyFilters ? \'check\' : \'close_circle\'}}</md-icon></td><td md-cell=\"\" md-numeric=\"\"><md-icon ng-class=\"{\'md-warn\' : !attribute.featured, \'green-text\' : attribute.featured }\">{{attribute.featured ? \'check\' : \'close_circle\'}}</md-icon></td></tr></tbody></table></md-table-container></md-card></div></section><section layout=\"\" layout-align=\"center center\" ng-if=\"loadingProduct\" layout-fill=\"\" flex=\"\" style=\"min-height: calc(100vh - 128px)\"><md-progress-circular md-diameter=\"36\"></md-progress-circular></section></div></md-dialog-content><md-dialog-actions md-colors=\"{\'background\' : \'boring-primary-50-0.4\'}\" ng-disabled=\"loadingProduct\"><div layout=\"\" layout-align=\"space-between center\" flex=\"\"><md-button class=\"md-warn\" ng-click=\"closeDialog();\">Close</md-button><div ng-if=\"!previewMode\"><md-button ng-click=\"closeDialog();\" ui-sref=\"app.products.add.home({slug: product._id, name: product.name})\" class=\"md-icon-button\"><md-icon class=\"md-primary\">edit</md-icon><md-tooltip>Edit Product</md-tooltip></md-button><md-button ng-if=\"!product.duplicating\" ng-disabled=\"loadingProduct\" class=\"md-icon-button md-primary\" ng-click=\"closeDialog(); showDuplicationConfirmation(product, $event);\"><div layout=\"\" layout-align=\"center center\"><section ng-if=\"!product.duplicating\"><md-icon>content_copy</md-icon></section><md-progress-circular md-diameter=\"20\" ng-if=\"product.duplicating\"></md-progress-circular></div><md-tooltip md-direction=\"bottom\">Duplicate the product and Start editing</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-disabled=\"loadingProduct\" ng-click=\"closeDialog(); moveToTrash(product, $index, $event);\"><md-icon class=\"red-text\">delete</md-icon><md-tooltip md-direction=\"bottom\">Move to Trash</md-tooltip></md-button><md-button class=\"md-raised md-primary\" ng-click=\"viewOnWebsite()\"><md-icon>open_in_new</md-icon><span>View On Website</span></md-button></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/redux/partials/redux.html","<div><section layout=\"\" layout-align=\"start center\"><md-card flex=\"\"><div layout=\"column\"><md-subheader md-whiteframe=\"1\"><div layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">Mongo Backups</span><section layout=\"\" layout-align=\"center center\"><md-card class=\"md-raised md-button\" ng-model=\"file\" ngf-select=\"upload()\" md-theme=\"dark-purple\"><md-icon>attachment</md-icon>Restore Via File</md-card><md-button class=\"md-raised\" md-theme=\"dark-purple\" ng-click=\"generateBackup(\'db\');\">Generate Backup Now</md-button></section></div></md-subheader><md-table-container><table md-table=\"\" md-progress=\"backupsPromise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\">Sl.</th><th md-column=\"\">Date</th><th md-column=\"\" md-numeric=\"\">Size</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"backup in backups\"><td md-cell=\"\">{{$index + 1 }}.</td><td md-cell=\"\">{{backup.date | date : \"medium\"}}</td><td md-cell=\"\">{{backup.size}}</td><td md-cell=\"\"><section layout=\"\" layout-align=\"center center\"><div layout=\"\" layout-align=\"center center\" flex=\"\"><md-progress-circular md-diameter=\"20\" md-theme=\"dark-orange\" ng-if=\"backup.downloading\"></md-progress-circular><md-button class=\"md-primary md-icon-button\" ng-if=\"!backup.downloading && !backup.downloaded\" md-theme=\"dark-orange\" ng-click=\"downloadFile(backup, \'db\')\"><md-icon>file_download</md-icon><md-tooltip>{{\"Download Backup\"}}</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-if=\"backup.downloaded\"><md-icon class=\"grey-text\">file_download</md-icon><md-tooltip>Already Downloaded</md-tooltip></md-button></div><md-button class=\"md-primary md-icon-button\" md-theme=\"dark-orange\"><md-icon>restore</md-icon></md-button></section></td></tr></tbody></table></md-table-container></div></md-card></section><section layout=\"\" layout-align=\"start center\"><md-card flex=\"\"><div layout=\"column\"><md-subheader md-whiteframe=\"1\"><div layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">App Backups</span><section layout=\"\" layout-align=\"center center\"><md-card class=\"md-raised md-button\" ng-model=\"file\" ngf-select=\"upload()\" md-theme=\"dark-purple\"><md-icon>attachment</md-icon>Restore Via File</md-card><md-button class=\"md-raised\" md-theme=\"dark-purple\" ng-click=\"generateBackup(\'app\');\">Generate Backup Now</md-button></section></div></md-subheader><md-table-container><table md-table=\"\" md-progress=\"appBackupsPromise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\">Sl.</th><th md-column=\"\">Date</th><th md-column=\"\" md-numeric=\"\">Size</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"backup in appBackups\"><td md-cell=\"\">{{$index + 1 }}.</td><td md-cell=\"\">{{backup.date | date : \"medium\"}}</td><td md-cell=\"\">{{backup.size}}</td><td md-cell=\"\"><section layout=\"\" layout-align=\"center center\"><div layout=\"\" layout-align=\"center center\" flex=\"\"><md-progress-circular md-diameter=\"20\" md-theme=\"dark-orange\" ng-if=\"backup.downloading\"></md-progress-circular><md-button class=\"md-primary md-icon-button\" ng-if=\"!backup.downloading && !backup.downloaded\" md-theme=\"dark-orange\" ng-click=\"downloadFile(backup, \'app\')\"><md-icon>file_download</md-icon><md-tooltip>{{\"Download Backup\"}}</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-if=\"backup.downloaded\"><md-icon class=\"grey-text\">file_download</md-icon><md-tooltip>Already Downloaded</md-tooltip></md-button></div><md-button class=\"md-primary md-icon-button\" md-theme=\"dark-orange\"><md-icon>restore</md-icon></md-button></section></td></tr></tbody></table></md-table-container></div></md-card></section><section layout=\"\" layout-align=\"start center\"><md-card flex=\"\"><div layout=\"column\"><md-subheader md-whiteframe=\"1\"><div layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">Uploads Backups</span><section layout=\"\" layout-align=\"center center\"><md-card class=\"md-raised md-button\" ng-model=\"file\" ngf-select=\"upload()\" md-theme=\"dark-purple\"><md-icon>attachment</md-icon>Restore Via File</md-card><md-button class=\"md-raised\" md-theme=\"dark-purple\" ng-click=\"generateBackup(\'uploads\');\">Generate Backup Now</md-button></section></div></md-subheader><md-table-container><table md-table=\"\" md-progress=\"appBackupsPromise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\">Sl.</th><th md-column=\"\">Date</th><th md-column=\"\" md-numeric=\"\">Size</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"backup in uploadsBackups\"><td md-cell=\"\">{{$index + 1 }}.</td><td md-cell=\"\">{{backup.date | date : \"medium\"}}</td><td md-cell=\"\">{{backup.size}}</td><td md-cell=\"\"><section layout=\"\" layout-align=\"center center\"><div layout=\"\" layout-align=\"center center\" flex=\"\"><md-progress-circular md-diameter=\"20\" md-theme=\"dark-orange\" ng-if=\"backup.downloading\"></md-progress-circular><md-button class=\"md-primary md-icon-button\" ng-if=\"!backup.downloading && !backup.downloaded\" md-theme=\"dark-orange\" ng-click=\"downloadFile(backup, \'uploads\')\"><md-icon>file_download</md-icon><md-tooltip>{{\"Download Backup\"}}</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-if=\"backup.downloaded\"><md-icon class=\"grey-text\">file_download</md-icon><md-tooltip>Already Downloaded</md-tooltip></md-button></div><md-button class=\"md-primary md-icon-button\" md-theme=\"dark-orange\"><md-icon>restore</md-icon></md-button></section></td></tr></tbody></table></md-table-container></div></md-card></section></div>");
$templateCache.put("app/modules/warehouses/create/warehouse.create.dialog.html","<md-dialog aria-label=\"editCollectionDialog block\" flex=\"60\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\"><h2>{{ editingMode ? \'Edit Warehouse\' : \'Add New Warehouse\'}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><form ng-cloak=\"\" name=\"editWarehouseDialog\" layout=\"\" layout-wrap=\"\"><md-input-container flex=\"100\"><label>Name</label> <input type=\"text\" ng-model=\"warehouse.name\" required=\"\"></md-input-container><md-card class=\"full-width\" ng-if=\"editingMode\"><md-card-header flex=\"\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">Address <i class=\"md-tiny\">*Required</i></span><md-button class=\"md-primary outline small\" ng-click=\"addressSelector($event)\">Change Address</md-button></md-card-header><md-card-content><div layout=\"column\" ng-if=\"warehouse.address\"><p class=\"md-body-1 bold-text\">{{ warehouse.address.name }} : {{warehouse.address.mobile}}</p><p class=\"md-caption\">{{ warehouse.address.streetAddress }}</p><p class=\"md-caption\"><span ng-if=\"warehouse.address.landmark\">{{ warehouse.address.landmark }},</span> {{warehouse.address.city}}, {{warehouse.address.state}}-{{warehouse.address.pinCode}}</p></div><div layout=\"column\" layout-align=\"center center\" ng-if=\"!warehouse.address\"><img src=\"assets/images/blank.svg\" style=\"width: 100px; height: auto\"><p>No Address Set</p><md-button class=\"md-primary outline\" ng-click=\"addressSelector($event)\">Select Address</md-button></div></md-card-content></md-card><input type=\"hidden\" ng-model=\"warehouse.address\" ng-if=\"editingMode\" required=\"\"><md-input-container flex=\"33\" ng-if=\"editingMode\"><label>City</label> <input type=\"text\" ng-model=\"warehouse.city\" required=\"\"></md-input-container><md-input-container flex=\"33\" ng-if=\"editingMode\"><label>State</label> <input type=\"text\" ng-model=\"warehouse.state\" required=\"\"></md-input-container><md-input-container flex=\"33\" ng-if=\"editingMode\"><label>PinCode</label> <input type=\"text\" ng-model=\"warehouse.pinCode\" required=\"\"></md-input-container><md-input-container flex=\"50\"><label>Prefix</label> <input required=\"\" ng-model=\"warehouse.prefix\" type=\"text\"></md-input-container><md-input-container flex=\"50\"><label>GST Number</label> <input ng-model=\"warehouse.gstNumber\" type=\"text\" ng-pattern=\"/^\\d{2}[A-Z]{5}\\d{4}[A-Z]{1}[A-Z\\d]{1}[Z]{1}[A-Z\\d]{1}/\"></md-input-container><md-input-container flex=\"50\"><label>Select Status</label><md-select ng-model=\"warehouse.status\" required=\"\"><md-option value=\"active\">Active</md-option><md-option value=\"blocked\">Blocked</md-option></md-select></md-input-container><md-input-container flex=\"50\"><label>Shyplite Id</label> <input ng-model=\"warehouse.shypliteId\" type=\"text\" required=\"\"></md-input-container><md-input-container flex=\"50\" layout=\"\" layout-align=\"center center\"><md-checkbox class=\"md-primary\" ng-model=\"warehouse.isStore\">Is this a Store?</md-checkbox></md-input-container><md-input-container flex=\"50\" layout=\"\" layout-align=\"center center\"><md-checkbox class=\"md-primary\" ng-model=\"warehouse.sellsOnline\">Does it sell online?</md-checkbox></md-input-container></form></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-accent\" ng-disabled=\"saving || editWarehouseDialog.$invalid\" ng-click=\"save()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/users/addresses/address.tmpl.html","Address");
$templateCache.put("app/modules/users/partials/home.html","<md-section-header md-section-title=\"{{pageTitle}}\" md-back-state=\"{{backState}}\" md-back-params=\"backParams\" md-nested-state=\"nestedState\"></md-section-header><div ui-view=\"\"></div>");
$templateCache.put("app/modules/workforce/task-create-dialog/task-create-dialog.tmpl.html","<md-dialog flex=\"70\"><md-toolbar class=\"md-accent md-hue-1\" layout=\"\" layout-align=\"center center\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-subhead\">Create New Tasks</span><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><form name=\"addTasksForm\"><div ng-if=\"prevTasks && prevTasks.length\" class=\"md-padding\"><h3 class=\"md-title\">Existing Tasks For {{order ? \'Line Item\' : \'Design\'}}:</h3><task-list tasks=\"prevTasks\"></task-list></div><md-card><div layout=\"\"><section flex=\"30\" layout=\"\" layout-align=\"center center\"><md-img md-src=\"{{product.image.urls.medium}}\" style=\"width: 100px\"></md-img></section><section flex=\"\" flex-offset=\"5\" layout=\"column\" layout-align=\"center\"><p>Create tasks for:</p><md-input-container><label>Task Name</label> <input type=\"text\" ng-model=\"taskName\" required=\"\" name=\"taskName\"></md-input-container></section></div><md-input-container class=\"md-margin task-description\"><label>Task Description</label> <textarea ng-model=\"description\" rows=\"3\" name=\"description\"></textarea></md-input-container><div ng-if=\"recommendedImages.length\" layout=\"column\" layout-align=\"center center\"><h4>Pick Images</h4><div layout=\"\" layout-wrap=\"\"><section ng-repeat=\"image in recommendedImages\" layout=\"column\" layout-align=\"center center\" class=\"md-padding\"><md-img md-src=\"{{image.urls.thumbnail}}\" class=\"pointer task-image\" ng-click=\"openImages($event, [image] )\"></md-img><md-checkbox ng-model=\"image.selected\" ng-click=\"updateTaskImages(image)\">Select Image</md-checkbox></section></div></div></md-card><div layout=\"\" layout-align=\"space-between center\" class=\"md-padding\"><h3 class=\"md-title\">Tasks</h3><md-button class=\"md-primary outline\" ng-click=\"addTask()\"><md-icon>add</md-icon><span>Add Task</span></md-button></div><div layout=\"\" ng-repeat=\"task in tasks\" class=\"task-list\"><section flex=\"5\" layout=\"\" layout-align=\"center\">{{$index + 1}}.</section><section flex=\"\" class=\"task-item expandable-section\"><md-toolbar class=\"expansion-header\" md-whiteframe=\"1\" ng-click=\"task.toggleExpansion()\"><div class=\"md-toolbar-tools\" layout=\"\"><span>Task {{$index + 1}}</span> <span flex=\"\"></span><md-button class=\"md-icon-button md-warn\" ng-click=\"$event.stopPropagation();deleteTask($index)\"><md-icon>delete</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"$event.stopPropagation();task.toggleExpansion()\"><md-icon class=\"material-icons--two-tone\">{{task.expanded ? \'keyboard_arrow_up\' : \'keyboard_arrow_down\'}}</md-icon><md-tooltip>{{task.expanded ? \'Collapse Section\' : \'Expand Section\'}}</md-tooltip></md-button></div></md-toolbar><section layout=\"\" layout-wrap=\"\" class=\"expansion-content\" layout-align=\"space-between\" ng-class=\"{\'expanded md-padding\' : task.expanded}\"><md-input-container flex=\"40\"><label>Task Type</label><md-select ng-model=\"task.taskType\" required=\"\" name=\"taskType\"><md-option ng-repeat=\"taskType in taskTypes\" ng-value=\"taskType\">{{taskType | uppercase}}</md-option></md-select></md-input-container><md-input-container flex=\"40\"><label>Priority</label><md-select ng-model=\"task.priority\" required=\"\" name=\"priority\"><md-option ng-repeat=\"priority in priorites\" ng-value=\"priority\">{{priority | uppercase}}</md-option></md-select></md-input-container><div flex=\"50\" layout=\"\" layout-align=\"center center\" class=\"my-20\"><section layout=\"column\" layout-align=\"start center\"><span class=\"md-caption grey-text\">Assigned To:</span><p class=\"bold-text\">{{task.assignee ? task.assignee.name : \'Auto-Assign\'}}</p></section><md-button class=\"small tile md-primary\" ng-click=\"openUserSelect($event, task, \'operator\', \'assignee\')\">{{task.assignee ? \"Change\" : \'Select User\'}}</md-button></div><div flex=\"50\" layout=\"\" layout-align=\"center center\" class=\"my-20\"><section layout=\"column\" layout-align=\"start center\"><span class=\"md-caption grey-text\">Designer:</span><p class=\"bold-text\">{{task.designer ? task.designer.name : \'Not Assigned\'}}</p></section><md-button class=\"small tile md-primary\" ng-click=\"openUserSelect($event, task, \'admin,designer\', \'designer\')\">{{task.designer ? \"Change\" : \'Select User\'}}</md-button></div><div layout=\"\" flex=\"100\" layout-align=\"space-between center\" class=\"allotted-time-row\"><section layout=\"column\" flex=\"30\"><span class=\"bold-text\">Allotted Time:</span> <span class=\"grey-text\">Time allotted to finish the task</span></section><section><span class=\"time-input-label\">Days</span> <input class=\"time-input hours\" ng-model=\"task.days\" type=\"number\" min=\"0\" required=\"\"> <span class=\"time-input-label\">Hours</span> <input class=\"time-input hours\" ng-model=\"task.hours\" type=\"number\" min=\"0\" max=\"23\" required=\"\"> <span class=\"time-input-label\">Minutes</span> <input class=\"time-input minutes\" ng-model=\"task.minutes\" type=\"number\" max=\"59\" required=\"\"></section></div><div flex=\"100\" layout=\"column\" layout-align=\"center center\" style=\"margin-top: 12px\"><section layout=\"\" layout-align=\"space-between center\" class=\"full-width\"><h4>Task Images:</h4><md-button class=\"outline md-primary small\" ng-click=\"task.addImage()\"><md-icon>add</md-icon>Add Image</md-button></section><md-radio-group ng-model=\"task.previewImageUrl\" layout=\"\" layout-wrap=\"\" dnd-list=\"task.images\" class=\"task-image-list\"><section ng-repeat=\"image in task.images\" layout=\"column\" layout-align=\"stretch start\" dnd-draggable=\"image\" dnd-effect-allowed=\"move\" dnd-moved=\"task.images.splice($index, 1);\" class=\"md-padding\"><image-selector ng-if=\"!image._id\" multiple=\"\" ng-change=\"task.updateToImage(imgs, $index)\" ng-model=\"imgs\" placeholder=\"\"></image-selector><md-img md-src=\"{{image.urls.thumbnail}}\" class=\"pointer task-image\" ng-if=\"image._id\" ng-click=\"openImages($event, [image] )\"></md-img><div layout=\"\" layout-align=\"space-between center\"><md-radio-button ng-value=\"image.urls.medium\" ng-if=\"image._id\">Default</md-radio-button><span flex=\"\" ng-if=\"!image._id\"></span><md-button class=\"md-icon-button md-warn\" ng-click=\"task.removeImage($index)\"><md-icon>delete</md-icon><md-tooltip>Remove Image</md-tooltip></md-button></div></section></md-radio-group></div></section></section></div></form></md-dialog-content><md-dialog-actions><div layout=\"\" layout-align=\"center center\" flex=\"\"><md-button class=\"md-warn\" ng-click=\"close()\">Cancel</md-button><span flex=\"\"></span><md-button class=\"md-primary\" ng-click=\"saveTask()\" ng-disabled=\"addTasksForm.$invalid || saving\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!saving\">Create</span><md-progress-circular md-diameter=\"20\" ng-if=\"saving\"></md-progress-circular></div></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/base/dialogs/link-generator/link-generator.html","<md-dialog flex=\"50\"><md-toolbar><div class=\"md-toolbar-tools\" layout-align=\"space-between center\"><span class=\"md-title\">Link Generator</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-padding\"><md-card><md-card-content layout=\"column\"><md-input-container><label>Enter URL</label> <input type=\"url\" ng-model=\"urlData.baseUrl\" ng-change=\"updateUrl()\"> <span md-hint=\"\" class=\"grey-text md-tiny\">The full website URL (e.g. https://www.example.com)</span></md-input-container><p class=\"center-text\">OR</p></md-card-content></md-card><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"text\" ng-model=\"urlData.ref\" placeholder=\"Enter Referrer\" ng-change=\"updateUrl()\"> <span md-hint=\"\" class=\"grey-text md-tiny\">The local referrer: (e.g. homepage, main-banner)</span></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"text\" ng-model=\"urlData.utm_source\" placeholder=\"Enter Campaign Source\" ng-change=\"updateUrl()\"> <span md-hint=\"\" class=\"grey-text md-tiny\">The referrer: (e.g. google, newsletter)</span></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"text\" ng-model=\"urlData.utm_medium\" placeholder=\"Enter Campaign Medium\" ng-change=\"updateUrl()\"> <span md-hint=\"\" class=\"grey-text md-tiny\">Marketing medium: (e.g. cpc, banner, email)</span></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"text\" ng-model=\"urlData.utm_campaign\" placeholder=\"Enter Campaign Name\" ng-change=\"updateUrl()\"> <span md-hint=\"\" class=\"grey-text md-tiny\">Product, promo code, or slogan (e.g. spring_sale)</span></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"text\" ng-model=\"urlData.utm_term\" placeholder=\"Enter Campaign Term\" ng-change=\"updateUrl()\"> <span md-hint=\"\" class=\"grey-text md-tiny\">Identify the paid keywords</span></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"text\" ng-model=\"urlData.utm_content\" placeholder=\"Enter Campaign Content\" ng-change=\"updateUrl()\"> <span md-hint=\"\" class=\"grey-text md-tiny\">Used to differentiate ads</span></md-input-container><div layout=\"\" layout-align=\"end center\" ng-if=\"urlData.url\"><md-switch ng-model=\"$parent.readOnlyUrl\">Edit Final URL</md-switch></div><div layout=\"\" layout-wrap=\"\" ng-if=\"urlData.url\"><md-input-container flex=\"\" class=\"no-error-spacer\"><label>Campaign URL</label> <textarea ng-model=\"urlData.url\" ng-disabled=\"{{readOnlyUrl}}\"></textarea></md-input-container><md-button ng-href=\"{{urlData.url}}\" target=\"_blank\" class=\"md-primary md-raised\"><md-icon>open_in_new</md-icon><span>Test Link</span></md-button></div><md-card><md-table-container><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\" style=\"width: 30%\"><p><strong>Referrer</strong></p><p><code>ref</code></p></td><td md-cell=\"\"><p>Use <code>ref</code> to identify the page/website/element which referred to the next page.</p><p><em>Example:</em> <code>homepage</code> , <code>main_banner</code></p></td></tr><tr md-row=\"\"><td md-cell=\"\"><p><strong>Campaign Source</strong></p><p><code>utm_source</code></p></td><td md-cell=\"\"><p>Use <code>utm_source</code> to identify a search engine, newsletter name, or other source.</p><p><em>Example:</em> <code>google</code></p></td></tr><tr md-row=\"\"><td md-cell=\"\"><p><strong>Campaign Medium</strong></p><p><code>utm_medium</code></p></td><td md-cell=\"\"><p>Use <code>utm_medium</code> to identify a medium such as email or cost-per- click.</p><p><em>Example:</em> <code>cpc</code></p></td></tr><tr md-row=\"\"><td md-cell=\"\"><p><strong>Campaign Name</strong></p><p><code>utm_campaign</code></p></td><td md-cell=\"\"><p>Used for keyword analysis. Use <code>utm_campaign</code> to identify a specific product promotion or strategic campaign.</p><p><em>Example:</em> <code>utm_campaign=spring_sale</code></p></td></tr><tr md-row=\"\"><td md-cell=\"\"><p><strong>Campaign Term</strong></p><p><code>utm_term</code></p></td><td md-cell=\"\"><p>Used for paid search. Use <code>utm_term</code> to note the keywords for this ad.</p><p><em>Example:</em> <code>running+shoes</code></p></td></tr><tr md-row=\"\"><td md-cell=\"\"><p><strong>Campaign Content</strong></p><p><code>utm_content</code></p></td><td md-cell=\"\"><p>Used for A/B testing and content-targeted ads. Use <code>utm_content</code> to differentiate ads or links that point to the same URL.</p><p><em>Examples:</em> <code>logolink</code> <em>or</em> <code>textlink</code></p></td></tr></tbody></table></md-table-container></md-card></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-primary outline\" ng-click=\"save()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/base/dialogs/page-preview/page-preview.html","<md-dialog flex=\"100\"><md-toolbar><div class=\"md-toolbar-tools\" layout-align=\"space-between center\"><span class=\"md-title\">Preview Layout</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-padding\"><div ng-repeat=\"widget in widgets\"><md-image-slider ng-if=\"widget.type === \'slider\'\" ng-class=\"widget.classes\" aspect-ratio=\"widget.aspectRatio\" auto-play=\"widget.options.autoPlay\" controls=\"widget.options.controls\" flex=\"100\" full-link=\"widget.options.fullLink\" interval=\"widget.options.interval\" overlay=\"widget.options.overlay\" src-list=\"widget.objects\"></md-image-slider><section ng-if=\"widget.type === \'column-banner\'\" layout=\"\" layout-wrap=\"\"><a ng-class=\"widget.classes\" ng-repeat=\"object in widget.objects\" ng-href=\"{{object.url}}\"><img md-preload=\"\" width=\"widget.width\" height=\"widget.height\" md-src=\"object.image\" item-index=\"$index\" key=\"{{object.key}}\" staged-key=\"h_mediumStaged\"></a></section></div></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-primary\" ng-click=\"saveWidgets()\"><span ng-if=\"!saving\">Save</span><bubble-loader ng-if=\"saving\"></bubble-loader></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/base/directives/appSearch/appSearch.tmpl.html","<form id=\"app-search\" name=\"form1\" layout=\"\" layout-align=\"stretch center\"><md-button class=\"md-icon-button form-action-button search\"><md-icon class=\"grey-text\">search</md-icon><md-tooltip>Search</md-tooltip></md-button><input ng-model=\"searchTerm\" ng-focus=\"showPopup()\" ng-blur=\"hidePopup()\" flex=\"\" input-focus=\"hasFocus\" id=\"app-search-input\" autocomplete=\"off\" ng-model-options=\"{\'debounce\' : 500}\" ng-change=\"search()\" ng-class=\"{\'md-whiteframe-1dp search-helper-active\' : showSearchHelper}\" placeholder=\"Search for actions, products, orders, users, materials\" class=\"search-input\"><md-button class=\"md-icon-button form-action-button remove\" ng-click=\"clearSearch()\"><md-icon class=\"grey-text\">close</md-icon><md-tooltip>Clear</md-tooltip></md-button><div class=\"search-helper\" md-whiteframe=\"1\" ng-if=\"showSearchHelper\" ng-mouseover=\"blockBlur()\" ng-mouseleave=\"unblockBlur()\"><md-progress-linear ng-if=\"searching\"></md-progress-linear><div class=\"search-scrim\" ng-if=\"!searching\"></div><md-list class=\"suggestions-container\"><div ng-if=\"searchKeywords.length && !searchTerm\" class=\"history\"><md-subheader class=\"md-no-sticky\">History</md-subheader><md-list-item ng-repeat-start=\"keyword in searchKeywords\" ng-click=\"applyKeyword(keyword); unblockBlur();\"><md-icon class=\"md-avatar\">history</md-icon><p class=\"suggestion-name\">{{keyword}}</p><span class=\"md-tiny\"><span>Apply Search</span></span><md-button class=\"md-secondary\" ng-click=\"removeFromHistory($index, $event); unblockBlur()\"><md-icon>close</md-icon></md-button></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></div><md-subheader class=\"md-no-sticky\"><div layout=\"\" layout-align=\"space-between center\"><span>{{getSubheaderText()}}</span><bubble-loader ng-if=\"searching\"></bubble-loader></div></md-subheader><div ng-if=\"suggestions.length && !searching\"><md-list-item class=\"md-2-line\" ng-repeat-start=\"suggestion in suggestions\" ui-sref=\"{{suggestion.sref}}\" ng-click=\"saveSearch(searchTerm); unblockBlur(); hidePopup(); clearSearch()\"><md-icon class=\"md-avatar\" ng-if=\"suggestion.icon\">{{suggestion.icon}}</md-icon><md-img class=\"product-image\" ng-if=\"suggestion.image\" md-src=\"{{suggestion.image}}\"></md-img><div class=\"md-list-item-text\" layout=\"column\"><p class=\"suggestion-name\">{{suggestion.name}}</p><p class=\"suggestion-category\">{{suggestion.category}}</p></div><md-icon class=\"md-avatar\">arrow_forward</md-icon></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></div><div ng-if=\"!suggestions.length && !searching\" layout=\"column\" layout-align=\"center center\" class=\"md-padding no-results\"><img src=\"assets/images/blank.svg\"><p>No Results Found</p></div></md-list></div></form>");
$templateCache.put("app/modules/base/directives/chatBox/chatBox.html","<div><md-card class=\"relative\" ng-show=\"roomId && hasAccess\"><div class=\"md-padding\" layout=\"\" layout-align=\"space-between center\"><h3 class=\"no-margin\">Chat</h3><div layout=\"\" layout-align=\"end center\" ng-if=\"room\"><section class=\"md-caption members-notifier pointer\">{{room.users.length}} Members<md-tooltip class=\"mega-tooltip\" md-direction=\"left\" style=\"width: 200px\"><h5 class=\"md-body-1\">{{room.users.length}} Members</h5><md-divider></md-divider><md-list class=\"members-list\"><md-list-item ng-repeat=\"user in room.users\" class=\"member-item\"><img ng-src=\"{{user.avatarURL || \'/assets/images/default.png\'}}\" ng-class=\"{\'online\' : user}\" class=\"md-avatar chat-profile-image\"> <span class=\"md-caption\">{{user.name}}</span></md-list-item></md-list></md-tooltip></section></div></div><md-divider></md-divider><md-card-content class=\"message-content-wrapper extended\" id=\"message-content-wrapper\"><md-list class=\"md-2-line\"><md-list-item ng-repeat-start=\"note in messages\" class=\"message-full-wrapper\" ng-class=\"{\'align-left\' : note.senderId !== currentUser._id, \'align-right\' : note.senderId === currentUser._id}\"><div class=\"message\" ng-class=\"{\'others\' : note.senderId !== currentUser._id, \'me\' : note.senderId === currentUser._id}\" layout=\"column\"><div class=\"message-images-container\" ng-if=\"note.images && note.images.length\" ng-class=\"{\'layout-align-start-center\' : note.by !== currentUser._id, \'layout-align-end-center\' : note.by === currentUser._id}\" layout=\"\" layout-wrap=\"\"><md-img class=\"message-image\" ng-repeat=\"image in note.images\" md-src=\"{{image.urls.medium}}\" ng-click=\"openImages($event, note.images)\"></md-img></div><p class=\"comment\" mention-text=\"\" comment=\"note.comment\"></p><section layout=\"\" layout-align=\"space-between center\"><span class=\"md-tiny\">By {{note.sender.name}}</span> <span class=\"md-tiny date grey-text\" ng-if=\"!note.saving && !note.error\">{{dateAgo(note.createdAt) }}<md-tooltip>{{note.createdAt | date : \'medium\'}}</md-tooltip></span><md-icon class=\"bug-icon red-text\" ng-if=\"!note.saving && note.error\">error</md-icon><bubble-loader class=\"save-loader\" ng-if=\"note.saving\"></bubble-loader></section></div></md-list-item><div ng-repeat-end=\"\" class=\"align-clear\"></div><md-list-item><span class=\"md-caption\" ng-if=\"typingUser\">{{typingUser.name}} is typing ...</span> <span class=\"md-secondary\"><bubble-loader ng-if=\"sendingMessage\"></bubble-loader></span></md-list-item></md-list><div layout=\"column\" layout-align=\"center center\" ng-if=\"!messages || !messages.length\"><img src=\"assets/images/blank.svg\" style=\"width: 100px; height: auto;\"><p>No Comments Yet</p></div></md-card-content><md-divider></md-divider><md-card-actions layout=\"\" layout-wrap=\"\" layout-align=\"stretch center\" class=\"relative\"><md-input-container class=\"no-error-spacer message-internal-confirm\" ng-class=\"{\'highlight\' : imageSelected}\" flex=\"100\"><md-checkbox ng-model=\"isInternalMessage\" ng-disabled=\"sendingMessage\">Hide Message from Customer</md-checkbox></md-input-container><md-input-container class=\"no-error-spacer ui-mention-container\" flex=\"65\" md-no-float=\"\"><textarea ui-mention=\"\" aarida-mentions=\"\" rows=\"2\" ng-model=\"message\" placeholder=\"Comment\" ng-keydown=\"setTypingIndicator(true)\" ng-blur=\"setTypingIndicator(false)\"></textarea><div class=\"mention-highlight\"></div><md-list class=\"dropdown md-2-line md-whiteframe-1dp\" ng-if=\"$mention.choices.length\"><md-list-item ng-if=\"$mention.loading\"><bubble-loader></bubble-loader></md-list-item><md-list-item ng-repeat-start=\"choice in $mention.choices\" ng-class=\"{active:$mention.activeChoice==choice}\" ng-click=\"$mention.select(choice)\"><div class=\"md-list-item-text\" layout=\"column\"><span class=\"name\">{{::choice.name}}</span> <span class=\"md-caption email\">{{::choice.email}}</span></div></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list></md-input-container><div layout=\"\" layout-align=\"center center\" flex=\"30\"><md-button class=\"md-icon-button relative\" ng-disabled=\"sendingMessage\"><md-icon>{{!imageSelected ? \'attach_file\' : \'attachment\'}}</md-icon><image-selector class=\"message-media-selector\" multiple=\"\" ng-model=\"$parent.imageSelected\"></image-selector></md-button><md-button class=\"md-icon-button md-fab md-mini md-primary\" ng-disabled=\"(!message && !imageSelected) || sendingMessage\" ng-click=\"sendMessage()\"><md-icon ng-if=\"!sendingMessage\">send</md-icon><bubble-loader ng-if=\"sendingMessage\"></bubble-loader></md-button></div></md-card-actions><div ng-show=\"imageSelected && imageSelected.length\" class=\"image-material-box full-width\"><div layout=\"\" class=\"images-container\"><md-img ng-repeat=\"image in imageSelected\" md-src=\"{{ image.urls.medium }}\" alt=\"{{image.message}}\"></md-img></div><md-button class=\"md-icon-button close-material-box-button\" ng-click=\"imageSelected = null\"><md-icon>close</md-icon></md-button></div></md-card><div ng-if=\"!roomId\" class=\"create-room md-margin md-padding\" layout=\"column\" layout-align=\"center center\"><p class=\"title md-title\">Chat is not created</p><p class=\"md-caption\">Would you like to create a new chat interface?</p><div layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-raised tile md-primary medium\" ng-disabled=\"creatingRoom\" ng-click=\"createRoom()\"><span ng-if=\"!creatingRoom\">Create Room</span><bubble-loader ng-if=\"creatingRoom\"></bubble-loader></md-button></div></div><div ng-if=\"!hasAccess && roomId\" class=\"join-room md-margin md-padding\" layout=\"column\" layout-align=\"center center\"><p class=\"title md-title\">You are not a part of this conversation!</p><p class=\"md-caption\">Would you like to join the chat or just want to view the messages in the room?</p><div layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-raised tile md-primary medium\" ng-click=\"askJoinConfirmation()\">Join Chat</md-button><md-button class=\"outline medium tile\">View Messages</md-button></div></div></div>");
$templateCache.put("app/modules/base/directives/imageSelector/image-selector.html","<div class=\"image-selector-container\"><section layout=\"column\" layout-align=\"center center\"><span ng-if=\"placeholder\" style=\"margin-bottom: 4px\">{{placeholder}}</span><div ng-click=\"openUploader($event);\" md-ink-ripple=\"\" layout=\"\" layout-align=\"center center\" class=\"pointer uploader-box\"><md-img class=\"image\" ng-if=\"image && display!==\'extended\'\" md-src=\"{{image.urls[viewModel]}}\"></md-img><input type=\"hidden\" class=\"hidden\" ng-model=\"image\"></div></section><section ng-if=\"isMultiple && display === \'extended\'\" layout=\"\" layout-align=\"center center\" class=\"selected-image-container\"><div ng-repeat=\"img in image\" class=\"selected-images\"><md-img md-src=\"{{img.urls.thumbnail}}\" class=\"pointer\" ng-click=\"openUploader($event, $index)\" style=\"max-width: 150px\"></md-img><div layout=\"\" layout-align=\"space-between center\"><span ng-if=\"!allowDefaultSelection\"></span><md-checkbox ng-if=\"allowDefaultSelection\" ng-click=\"updateDefault(img, $index)\" ng-model=\"img.selected\">Default</md-checkbox><md-button class=\"md-icon-button md-warn small\" ng-click=\"deleteImage($index)\"><md-icon>delete</md-icon></md-button></div></div></section></div>");
$templateCache.put("app/modules/base/directives/profile-image/profile-image.tmpl.html","<div ng-if=\"!userName\" class=\"profile-image\" ng-class=\"class\" ng-style=\"{\'backgroundImage\' : \'url(\' + mediaUrl+ imageUrl + \')\'}\"></div><div ng-if=\"userName\" class=\"profile-image pointer\" ng-class=\"class\" ui-sref=\"app.profile({userName : userName})\" ng-style=\"{\'backgroundImage\' : \'url(\' + mediaUrl+ imageUrl + \')\'}\"></div>");
$templateCache.put("app/modules/base/directives/templates/aadiraCard.tpl.html","<div class=\"card\"><div class=\"card-content\"><ng-transclude></ng-transclude></div></div>");
$templateCache.put("app/modules/base/directives/templates/attached-tag.tmpl.html","<div class=\"attached-tag\" ng-class=\"[tagType, ngClass]\" ng-style=\"style\"><span ng-if=\"tagType === \'new\' && !content\">NEW</span><div ng-class=\"[ngClass]\" ng-if=\"tagType === \'dot\' && !content\" class=\"dot-indicator\"></div><div ng-class=\"[ngClass]\"><span ng-transclude=\"content\"></span></div></div>");
$templateCache.put("app/modules/base/directives/templates/bubble-loader.html","<div class=\"bubble-loader\"><div class=\"bubble\"></div><div class=\"bubble\"></div><div class=\"bubble\"></div><div class=\"bubble\"></div></div>");
$templateCache.put("app/modules/base/directives/templates/cp-view.tpl.html","<div class=\"preview-container\" ng-style=\"style\"><div class=\"center black-text\" ng-show=\"!customisation.baseImage.urls\"></div><div class=\"preview\" alt=\"customisation.pattern\" ng-show=\"customisation.data[0].preview && customisation.data[0].name === \'Fabric\'\" style=\"background-size: {{backgroundScale}}; background: url(\'{{ selectedIndex != 0 ? url +customisation.data[0].default.image.urls[key] : url +customisation.data[0].options[currentIndex].image.urls[key]}}\') {{position}};\"></div><div class=\"preview\" ng-show=\"customisation.baseImage.urls\" style=\"background: url(\'{{ url + customisation.baseImage.urls[key] }}\') {{position}}; background-size: {{backgroundScale}};\"></div><div class=\"preview\" ng-repeat=\"layer in customisation.data | limitTo: getLimit()\" alt=\"{{ layer.name + \'-\'+ $index}}\" ng-show=\"layer.default.image.urls && layer.preview && previewsData[$index]\" style=\"background-image: url(\'{{ (selectedIndex) != $index ? (url + layer.default.image.urls[key]) : (url +customisation.data[selectedIndex].options[currentIndex].image.urls[key])}}\'); background-position: {{position}}; background-size: {{backgroundScale}};\"></div><div class=\"preview\" alt=\"{{customisation.data[selectedIndex].name + \'-last\' }}\" ng-init=\"layer = customisation.data[selectedIndex]\" ng-show=\"!layer.preview\" style=\"background: url(\'{{ url + customisation.data[selectedIndex].options[currentIndex].image.urls[key] }}\') {{position}}; background-size: {{backgroundScale}};\"></div></div>");
$templateCache.put("app/modules/base/directives/templates/cp.tpl.html","<div class=\"cp-container\" ng-style=\"style\" md-whiteframe=\"{{ whiteFrameValue }}\" id=\"{{ name }}\"><div class=\"center black-text\" ng-show=\"!customisation.baseImage.urls\"><img ng-src=\"{{ mediaUrl + fallback }}\" alt=\"Fallback Image\" ng-if=\"fallback\"></div><div class=\"viewer\"><img ng-src=\"{{ mediaUrl +customisation.data[0].default.image.urls[key] }}\" alt=\"Non Base Image\" ng-if=\"customisation.data[0].default.image.urls && customisation.data[0].preview && customisation.data[0].name === \'Fabric\'\"></div><div class=\"viewer\"><img ng-src=\"{{ mediaUrl +customisation.baseImage.urls[key] }}\" alt=\"Base Image\" ng-if=\"customisation.baseImage.urls\"></div><div class=\"viewer\" ng-if=\"customisation.data[0].name === \'Fabric\'\" ng-repeat=\"layer in customisation.data | limitTo: (1 - customisation.data.length)\"><img class=\"fade-image\" ng-src=\"{{ mediaUrl +layer.default.image.urls[key] }}\" alt=\"Fabric Layer\" ng-if=\"layer.default.image.urls && layer.preview\"></div><div class=\"viewer\" ng-if=\"customisation.data[0].name !== \'Fabric\'\" ng-repeat=\"layer in customisation.data\"><img class=\"fade-image\" ng-src=\"{{ mediaUrl +layer.default.image.urls[key] }}\" alt=\"Non Fabric Layer\" ng-if=\"layer.default.image.urls && layer.preview\"></div></div>");
$templateCache.put("app/modules/base/directives/templates/mdCarousel.tpl.html","<div flex=\"\" layout=\"column\" style=\"margin: {{padding ? padding : \'16\'}}px; position:relative; transition:transform 1s ease-in-out; overflow: hidden;\"><div layout=\"row\" ng-style=\"style\"><md-card ng-repeat=\"item in data\" ng-style=\"{\'max-width\': singleItemWidth + \'px\', \'transition\': \'transform 0.5s ease-in-out\', \'min-width\': singleItemWidth + \'px\', \'padding\': 0, \'max-height\': itemHeight + \'px\', \'min-height\': itemHeight + \'px\', \'transform\': \'translateX(-\' + margin_left + \'px)\'}\"><div layout=\"\" ng-transclude=\"\" style=\"height: {{ itemHeight }}px;\"></div></md-card></div><div style=\"position: absolute; left: 0; line-height: {{ itemHeight }}px; height: 25px; vertical-align: middle;\"><a md-whiteframe=\"8\" style=\"max-height: 25px; position: relative; max-width: 50px; background: white; cursor: pointer; padding: 25px 5px 25px 5px;\" ng-click=\"controlSlider(\'previous\');\" md-ink-ripple=\"\" ng-if=\"margin_left != 0\" class=\"md-raised\"><md-icon md-svg-src=\"/assets/images/previous.svg\"></md-icon></a></div><div style=\"position: absolute; right: 0; line-height: {{ itemHeight }}px; height: {{ itemHeight }}px; vertical-align: middle;\"><a md-whiteframe=\"8\" style=\"max-height: 25px;position: relative; max-width: 50px; background: white; cursor: pointer; padding: 25px 5px 25px 5px;\" md-ink-ripple=\"\" ng-click=\"controlSlider(\'next\');\" ng-if=\"margin_left <= totalMarginLeft\" class=\"md-raised\"><md-icon md-svg-src=\"/assets/images/next.svg\"></md-icon></a></div></div>");
$templateCache.put("app/modules/base/directives/templates/mdInlineInputContainer.tpl.html","<div class=\"relative\"><md-input-container ng-class=\"class\" ng-show=\"editing || !bindedModel\" md-no-float=\"\" style=\"margin: 0; min-width: 150px;\"><label ng-if=\"label\">{{ label }}</label> <input aria-label=\"{{placeholder}}\" type=\"{{inputType}}\" class=\"inline-input-box\" ng-blur=\"editing = !editing; onBlur($event)\" ng-model=\"bindedModel\" placeholder=\"{{placeholder}}\" ng-style=\"{\'width\' : width}\"></md-input-container><span ng-click=\"toggleMenu($event)\" style=\"line-height: 30px; vertical-align: middle;\" class=\"md-padding pointer\" ng-show=\"!editing && bindedModel\">{{bindedModel}}</span><div class=\"inline-menu\" ng-if=\"showingMenu\"><span class=\"item edit\" ng-click=\"toggleMenu($event, true);\">Edit</span> <span class=\"item delete\" ng-click=\"onDeleteClicked($event); toggleMenu($event);\">Delete</span> <span class=\"item delete\" ng-click=\"onAddRowAfterClicked($event); toggleMenu($event);\">Insert After</span> <span class=\"item close-btn\" ng-click=\"toggleMenu($event)\">&#x2715;</span></div></div>");
$templateCache.put("app/modules/base/directives/templates/mdLightbox.html","<md-dialog><md-img md-src=\"{{currentSrc.urls.large}}\" alt=\"{{currentSrc.filename}}\"></md-img></md-dialog>");
$templateCache.put("app/modules/base/directives/templates/mdSectionHeader.tpl.html","<div md-colors=\"{\'background\' : \'primary-50-1\'}\" class=\"md-padding\" role=\"heading\" aria-level=\"2\" style=\"position: sticky; top: 0; z-index: 2; background: white\"><div class=\"md-subheader-inner\"><div class=\"md-subheader-content\"><div layout=\"\" layout-align=\"center center\"><section ng-if=\"mdNestedState\"><md-button class=\"md-icon-button\" md-ink-ripple=\"\" ng-click=\"goToState()\"><md-icon>arrow_back</md-icon></md-button><span class=\"md-caption\">Back</span></section><span flex=\"\"></span><div layout=\"column\" layout-align=\"center start\"><section layout=\"\" layout-align=\"start center\"><span class=\"md-title\">{{mdSectionTitle}}</span><md-button ng-if=\"copyTitleButton\" class=\"md-icon-button small\" ngclipboard=\"\" ng-click=\"$event.stopPropagation(); showToast(\'Copied to Clipboard\')\" data-clipboard-text=\"{{mdSectionTitle}}\"><md-icon>content_copy</md-icon><md-tooltip>{{copyTitleTooltip || \'Copy\'}}</md-tooltip></md-button></section></div><span flex=\"\"></span><div ng-transclude=\"\" style=\"height: 100%;\" layout=\"\" layout-align=\"center center\"></div></div></div></div></div>");
$templateCache.put("app/modules/base/directives/templates/mdSlider.tpl.html","<div layout=\"\" layout-fill=\"\" class=\"slider\" ng-style=\"{\'height\': heightPx}\" md-swipe-left=\"onSwipeLeft();\" md-swipe-right=\"onSwipeRight();\"><div class=\"swap-animation image hide pointer\" ng-animate-swap=\"currentItem\" ng-class=\"{\'show\' : $index === currentItem}\" ng-repeat=\"src in srcList track by $index\" ng-style=\"{\'background\': \'url(\' + getUrl(src.image.urls.full) + \')\'}\"></div><section ng-if=\"controls\"><div layout=\"\" layout-align=\"center center\" class=\"control-button left-arrow\"><md-button class=\"md-fab md-primary md-mini\" ng-click=\"previous();\"><md-icon>keyboard_arrow_left</md-icon></md-button></div><div layout=\"\" layout-align=\"center center\" class=\"control-button right-arrow\"><md-button class=\"md-fab md-primary md-mini\" ng-click=\"next();\"><md-icon>keyboard_arrow_right</md-icon></md-button></div></section><div flex=\"\" ng-repeat=\"src in srcList track by $index\" ng-class=\"getClass($index);\" ng-if=\"$index === currentItem\" layout=\"\" layout-padding=\"\" style=\"z-index: 3;margin: 64px;\"><div layout=\"column\" layout-align=\"center center\" class=\"swap-animation text\" ng-animate-swap=\"currentItem\"><span class=\"white-text center-text md-title\" style=\"font-weight: 700;\">{{ src.heading | uppercase }}</span> <span class=\"white-text\" ng-class=\"{\'md-title\' : !isSmall, \'md-body-1 center-text\' : isSmall}\">{{ src.text }}</span><md-button ng-if=\"src.button\" ui-sref=\"{{src.buttonSref}}\" style=\"margin-top: 24px;\" ng-style=\"src.buttonStyle\" class=\"md-raised\" ng-class=\"getButtonClass($index);\">{{ src.buttonText }}</md-button></div></div><div layout=\"row\" class=\"bottom-indicator\" layout-align=\"center center\" ng-if=\"!hideIndicator\"><div layout=\"\"><md-icon ng-class=\"{\'active\' : $index === currentItem}\" ng-click=\"change($index);\" ng-repeat=\"i in srcList track by $index\" class=\"pointer indicator-icon\">lens</md-icon></div></div><a ng-style=\"{\'background\' : overlay ? rgba(1,1,1,0.2) : \'\'}\" ng-href=\"{{buildUrl();}}\" class=\"overlay-link\" ng-if=\"fullLink || overlay\"></a></div>");
$templateCache.put("app/modules/customisation/options/partials/options.html","<md-subheader class=\"md-no-sticky\" layout=\"\" md-whiteframe=\"2\"><span class=\"md-caption\">Showing {{options.length}} fabrics</span> <span flex=\"\"></span><md-button class=\"md-icon-button md-primary\" ng-click=\"editPattern(null, null, $event);\"><md-icon>add</md-icon><md-tooltip md-direction=\"bottom\">Add New Fabric</md-tooltip></md-button></md-subheader><div layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><md-card flex=\"20\" ng-repeat=\"option in options track by $index\" layout=\"\"><md-img md-src=\"{{option.image.urls.c_thumbnail}}\" style=\"width: auto; height: 100%;\"><div flex=\"\" layout=\"column\" style=\"padding: 4px 8px;\"><div layout=\"\" layout-align=\"start center\"><span style=\"color: brown;\" class=\"md-caption\">{{option.name ? option.name : \"N/A\"}}</span></div><div layout=\"\" layout-align=\"start center\"><span class=\"md-caption\">{{getPrice(option)}}</span></div><div flex=\"\"></div><div layout=\"\" layout-align=\"end center\"><md-button ng-click=\"editPattern(option, $index,$event);\" class=\"md-accent md-icon-button\" style=\"margin: 0;\"><md-icon>edit</md-icon><md-tooltip>Edit</md-tooltip></md-button><md-button ng-click=\"removeOption(option, $index, $event)\" class=\"md-warn md-icon-button\" style=\"margin: 0;\"><md-icon>close</md-icon><md-tooltip>Delete</md-tooltip></md-button></div></div></md-img></md-card></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"options_editor\"><md-dialog aria-label=\"Edit Pattern\" class=\"options_editor_dialog\" flex=\"66\" layout=\"column\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"cancel(\'as\')\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button><h2>Edit Pattern</h2><span flex=\"\"></span><md-button class=\"md-primary\" ng-click=\"saveOption()\">Save</md-button></div></md-toolbar><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" style=\"width: 800px;\"><md-tab label=\"General Information\"><md-content class=\"md-padding\" layout=\"column\"><div layout=\"\"><md-input-container flex=\"\" class=\"md-block\" md-no-float=\"\"><input type=\"text\" ng-model=\"selectedOption.name\" placeholder=\"Enter Name\"></md-input-container><md-chips flex=\"\" ng-model=\"selectedOption.tags\" name=\"tags\" md-removable=\"true\" md-enable-chip-edit=\"\" placeholder=\"Enter a tag\" delete-button-label=\"Remove Tag\" delete-hint=\"Press delete to remove tag\" secondary-placeholder=\"+Tag\"></md-chips></div><div layout=\"\"><md-input-container flex=\"\" class=\"md-block\" md-no-float=\"\"><md-icon md-svg-src=\"/assets/images/rupee-indian.svg\"></md-icon><input type=\"text\" ng-model=\"selectedOption.stockAndPrice.price.productionCost\" placeholder=\"Production Cost (Rs.)\"></md-input-container><md-input-container flex=\"\" class=\"md-block\" md-no-float=\"\"><md-icon md-svg-src=\"/assets/images/rupee-indian.svg\"></md-icon><input type=\"text\" ng-model=\"selectedOption.stockAndPrice.price.mrp\" placeholder=\"MRP (Rs.)\"></md-input-container><md-input-container flex=\"\" class=\"md-block\" md-no-float=\"\"><md-icon md-svg-src=\"/assets/images/rupee-indian.svg\"></md-icon><input type=\"text\" ng-model=\"selectedOption.stockAndPrice.price.salePrice\" placeholder=\"Sale Price(Rs.)\"></md-input-container></div><div layout=\"row\"><md-checkbox aria-label=\"Manage Stock\" class=\"md-align-center-center\" ng-model=\"selectedOption.stockAndPrice.stock.manageStock\">Manage Stock</md-checkbox><md-input-container flex=\"\" class=\"md-block\" md-no-float=\"\"><input type=\"number\" min=\"0\" ng-model=\"selectedOption.stockAndPrice.stock.quantity\" placeholder=\"Stock Quantity\" ng-disabled=\"!selectedOption.stockAndPrice.stock.manageStock\"></md-input-container><md-input-container flex=\"\" class=\"md-block\" md-no-float=\"\"><input type=\"number\" min=\"0\" ng-model=\"selectedOption.stockAndPrice.stock.threshold\" placeholder=\"Max/order\" ng-disabled=\"!selectedOption.stockAndPrice.stock.manageStock\"></md-input-container><md-checkbox ng-model=\"selectedOption.stockAndPrice.stock.backOrder.status\" ng-disabled=\"!selectedOption.stockAndPrice.stock.manageStock\"><span>Allow Backorders</span></md-checkbox><md-input-container flex=\"\" class=\"md-block\" md-no-float=\"\"><input type=\"number\" min=\"0\" ng-model=\"selectedOption.stockAndPrice.stock.backOrder.limit\" placeholder=\"Limit\" ng-disabled=\"!selectedOption.stockAndPrice.stock.backOrder.status\"></md-input-container></div></md-content></md-tab><md-tab label=\"Images\"><md-content class=\"md-padding\" layout=\"\"><div flex=\"\" layout=\"column\" layout-align=\"center center\"><span class=\"md-caption\">Attaches to the layer. Should be solid image</span><div ng-click=\"openUploader($event, 0);\" style=\"width: 200px; height: 300px; background: lightgrey; border: 1px dashed black\" layout=\"\" layout-align=\"center center\" class=\"pointer\"><span style=\"text-align: center\" flex=\"\" ng-if=\"!selectedOption.image.urls\">Layer Image</span><md-img ng-if=\"selectedOption.image.urls\" md-src=\"{{selectedOption.image.urls.medium}}\" style=\"width: 200px; height: 100%;\"></md-img></div></div><div flex=\"\" layout=\"column\" layout-align=\"center center\"><span class=\"md-caption\">Preview image. Can be used from Fabriclore</span><div ng-click=\"openUploader($event, 1);\" style=\"width: 200px; height: 300px; background: lightgrey; border: 1px dashed black\" layout=\"\" layout-align=\"center center\" class=\"pointer\"><span style=\"text-align: center\" flex=\"\" ng-if=\"!selectedOption.preview.urls\">Preview Image</span><md-img ng-if=\"selectedOption.preview.urls\" md-src=\"{{selectedOption.preview.urls.medium}}\" style=\"width: 200px; height: 100%;\"></md-img></div></div></md-content></md-tab><md-tab label=\"Attributes\"><md-content class=\"md-padding\"><div layout=\"row\"><span flex=\"\"></span><md-button flex=\"30\" class=\"md-raised md-accent\" ng-click=\"addAttribute();\">Add New</md-button></div><div flex=\"\" layout=\"row\" ng-repeat=\"attributeData in selectedOption.attributes\" ng-show=\"selectedOption.attributes.length > 0\"><md-card flex=\"30\"><md-card-content><md-select aria-label=\"Select Attribute\" ng-model=\"selectedOption.attributes[$index].attribute\" ng-model-options=\"{trackBy: \'$value._id\'}\" placeholder=\"Select Attribute\"><md-option ng-value=\"attribute\" ng-repeat=\"attribute in attributes\">{{ attribute.meta_key }}</md-option></md-select></md-card-content></md-card><md-card flex=\"\"><md-card-content layout=\"\"><md-select flex=\"\" aria-label=\"Select Attributes\" multiple=\"true\" ng-model=\"selectedOption.attributes[$index].selectedValues\" ng-model-options=\"{trackBy: \'$value\'}\" placeholder=\"Select Options\"><md-option ng-value=\"meta_value._id\" ng-repeat=\"meta_value in selectedOption.attributes[$index].attribute.meta_values\">{{ meta_value.value }}</md-option></md-select><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-icon-button md-warn\" ng-click=\"removeAttribute($index);\"><md-icon>delete</md-icon></md-button></div></md-card-content></md-card></div><div ng-show=\"selectedOption.attributes.length === 0\" layout=\"column\" flex=\"\" style=\"min-height: 400px;\" layout-align=\"center center\" layout-margin=\"\"><img src=\"assets/images/icons/coffee.svg\" style=\"max-width: 100px;\"> <span class=\"cookie md-title\">Please stop sipping in so much coffee<br>and start adding some attributes here.</span></div></md-content></md-tab></md-tabs></md-dialog></div></div>");
$templateCache.put("app/modules/customisation/templates/partials/index.html","<div layout=\"column\"><md-card><md-card-content><md-table-container><div layout=\"row\"><md-input-container md-no-float=\"\" flex=\"20\" class=\"md-block\"><input type=\"search\" placeholder=\"Search\" ng-model=\"query.search\" ng-model-options=\"{\'debounce\' : 200}\" ng-change=\"templates()\"></md-input-container><span flex=\"\"></span></div><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getAllTemplates\"><tr md-row=\"\"><th md-column=\"\"><span>Sl.</span></th><th></th><th md-column=\"\" md-order-by=\"name\"><span>Name</span></th><th md-column=\"\" md-numeric=\"\"><span>Price</span></th><th md-column=\"\" md-order-by=\"product\"><span>Product</span></th><th>Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"template\" md-select-id=\"template._id\" md-auto-select=\"\" ng-repeat=\"template in templates\"><td md-cell=\"\">{{ $index + 1}}.</td><td md-cell=\"\"><customisable-product customisation=\"template.customisation\" size=\"thumbnail\"></customisable-product></td><td md-cell=\"\">{{template.name}}</td><td md-cell=\"\">Rs. {{template.customisation.basePrice}}</td><td md-cell=\"\">{{template.product.name}}</td><td><md-button class=\"md-icon-button\" ng-click=\"showDialog($event, template, $index);\"><md-icon>edit</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5, 25, 50]\" md-page=\"query.page\" md-total=\"{{totalCount}}\" md-on-paginate=\"getAllTemplates\" md-page-select=\"\"></md-table-pagination></md-card-content></md-card></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"addNewTemplateDialog\"><md-dialog aria-label=\"addNewTemplateDialog block\" flex=\"100\" style=\"min-height: 100%\"><md-toolbar md-colors=\"{\'backgroundColor\' : \'boring-primary-500-1\'}\"><div class=\"md-toolbar-tools\"><h2>{{ editingMode ? \'Edit Template\' : \'Add New Template\'}}</h2><span flex=\"\"></span><md-autocomplete flex=\"40\" md-no-cache=\"true\" md-selected-item=\"selectedItem\" md-search-text-change=\"searchTextChange(searchText)\" md-search-text=\"searchText\" md-selected-item-change=\"selectedItemChange(item)\" md-items=\"item in querySearch(searchText)\" md-min-length=\"3\" md-item-text=\"selectedItem.name\" placeholder=\"Search for customisable products to add below\"><md-item-template><div layout=\"row\" ng-click=\"addProduct(item);\"><md-img md-src=\"{{ item.featured_image.urls.thumbnail }}\" class=\"md-avatar\" style=\"width: 34px; height: 48px;\"><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\" style=\"margin-left: 10px;\">{{item.name}}</span></md-img></div></md-item-template><md-not-found>No products found.</md-not-found></md-autocomplete><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" md-colors=\"{background : \'boring-primary-100-0.2\'}\" style=\"max-height: calc(100% - 100px);\" flex=\"\"><div ng-if=\"newTemplate.product._id\" layout=\"\"><section flex=\"20\"><div style=\"height: 64px; cursor: pointer; outline: none;\" ng-click=\"changeData($index);\" md-colors=\"{background : selectedIndex === $index ? \'boring-accent-400-1\' : \'boring-accent-200-1\'}\" ng-repeat-start=\"datum in newTemplate.customisation.data\" layout=\"\" layout-align=\"center center\"><div style=\"font-weight: bold;\"><span style=\"padding: 4px;\" ng-style=\"{\'border-bottom\' : selectedIndex === $index ? \'2px solid orangered\' : \'none\',\'text-decoration-color\' : \'orangeRed\' }\">{{ datum.name }}</span></div></div><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider><span flex=\"\"></span></section><section flex=\"50\" layout=\"\" layout-wrap=\"\" layout-align=\"center\" style=\"max-height: calc(100vh); overflow: scroll;\"><md-card style=\"width: 150px; height: 270px; position: relative; outline: none; cursor: pointer;\" md-ink-ripple=\"\" ng-click=\"changeOption(option, $index);\" ng-repeat=\"option in newTemplate.customisation.data[selectedIndex].options\"><md-img md-src=\"{{ option.image.urls.medium}}\" style=\"width: 100%; height: auto; background: grey;\"><div layout=\"\" layout-padding=\"\" md-colors=\"{background : newTemplate.customisation.data[selectedIndex].default === $index ? \'boring-accent-400-1\' : \'boring-accent-50-0.05\'}\"><span>{{ option.name }}</span> <span class=\"md-option\">{{option.stockAndPrice.price.mrp ? \"Rs. \"+ option.stockAndPrice.price.mrp : \"Free\"}}</span></div></md-img></md-card></section><section flex=\"30\"><customisable-product customisation=\"newTemplate.customisation\" size=\"large\"></customisable-product></section></div><div ng-if=\"!newTemplate.product._id\" flex=\"\" layout=\"column\" layout-align=\"center center\" layout-margin=\"\"><img src=\"assets/images/safebox.svg\" style=\"width: 100px;\"> <span class=\"md-caption\" style=\"color: grey;\">No product loaded. Add a customisable product first from the search bar.</span></div></md-dialog-content><md-dialog-actions><span class=\"md-title\">{{ newTemplate.product.name}}</span> <span flex=\"\"></span> <label>Template Name</label> <input type=\"text\" ng-model=\"newTemplate.name\"><md-button class=\"md-raised md-accent\" ng-click=\"saveTemplate();\">{{editingMode ? \"Edit\" : \"Save\"}}</md-button></md-dialog-actions></md-dialog></div></div>");
$templateCache.put("app/modules/offers/coupons/partials/coupons.html","<div layout=\"row\" layout-align=\"center start\"><md-card flex=\"\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools scrolling-tabs\" layout=\"\" layout-align=\"space-between center\" style=\"background: #ebebee\"><div layout=\"\" layout-align=\"start center\" flex=\"\"><span ng-if=\"!selected.length\" style=\"margin-right: 20px\">Coupons</span><section layout=\"\" layout-align=\"start center\" ng-if=\"selected.length\"><md-button class=\"md-icon-button material-icons--two-tone\" ng-click=\"clearSelections()\"><md-icon>close</md-icon></md-button><span class=\"md-tiny\">{{selected.length}} Coupons Selected</span></section><span ng-if=\"selected.length\" flex-offset=\"5\"></span><form role=\"form\" novalidate=\"\" name=\"filterForm\" flex-offset=\"5\" ng-submit=\"fetchAllDiscounts()\" layout=\"\" layout-align=\"center center\"><md-input-container flex=\"\" class=\"no-error-spacer\" layout=\"\"><label>&nbsp;</label> <input type=\"search\" id=\"giftCardSearch\" ng-model=\"query.search\" select-on-click=\"\" ng-model-options=\"{\'debounce\' : 500}\" ng-change=\"fetchAllDiscounts()\" placeholder=\"Search Coupons\" class=\"search-bar-input\"></md-input-container><md-button ng-click=\"fetchAllDiscounts()\" class=\"md-icon-button\"><md-icon>search</md-icon></md-button></form></div><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-primary md-fab md-mini\" ng-click=\"createNewCouponDialog($event)\"><md-icon>add</md-icon><md-tooltip class=\"white-text\">Create New Coupon</md-tooltip></md-button></div></div><div class=\"md-toolbar-tools scrolling-tabs toolbar-show\" ng-show=\"selected.length\" style=\"background: #ebebee\" layout=\"\" layout-align=\"start center\"></div></md-toolbar><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[10, 25, 50, 100]\" md-page=\"query.page\" md-total=\"{{total}}\" md-on-paginate=\"fetchAllDiscounts\" md-page-select=\"\"></md-table-pagination><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.sort\" md-on-reorder=\"fetchAllDiscounts\"><tr md-row=\"\"><th md-column=\"\">Sl.</th><th md-column=\"\" md-order-by=\"couponCode\">Coupon Code</th><th md-column=\"\" md-order-by=\"autoApplied\">Auto-Applied</th><th md-column=\"\" md-order-by=\"startDate\">Start Date</th><th md-column=\"\" md-order-by=\"expiryDate\">Expiry Date</th><th md-column=\"\" md-order-by=\"applicableTo\"><span>Apply On</span></th><th md-column=\"\" md-order-by=\"discountType\"><span>Type</span></th><th md-column=\"\" md-order-by=\"discountAmount\" md-numeric=\"\">Amount</th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"discount\" md-select-id=\"discount._id\" md-auto-select=\"\" ng-repeat=\"discount in discounts\" style=\"height: 75px;\"><td md-cell=\"\">{{ (((query.page - 1) * query.limit) + $index) + 1}}.</td><td md-cell=\"\">{{ discount.couponCode }}</td><td md-cell=\"\"><md-icon md-svg-src=\"{{discount.autoApplied ? \'/assets/images/checked.svg\' : \'/assets/images/cancel.svg\' }}\"></md-icon></td><td md-cell=\"\"><span class=\"md-tiny\">{{discount.startDate | date : \"medium\" }}</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{discount.expiryDate | date : \"medium\" }}</span></td><td md-cell=\"\">{{ getApplicableTo(discount.applicableTo); }}</td><td md-cell=\"\">{{ getDiscountType(discount.discountType); }}</td><td md-cell=\"\">{{ getDiscountAmount(discount.discountAmount, discount.discountType); }}</td><td md-cell=\"\"><span layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"editCoupon(discount, $index, $event); loadProducts()\"><md-icon>edit</md-icon><md-tooltip md-direction=\"bottom\">Edit Coupon</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"removeCoupon(discount, $index, $event);\"><md-icon style=\"color: red;\">delete</md-icon><md-tooltip md-direction=\"bottom\">Delete Coupon</md-tooltip></md-button></span></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[10, 25, 50]\" md-page=\"query.page\" md-total=\"{{total}}\" md-on-paginate=\"fetchAllDiscounts\" md-page-select=\"\"></md-table-pagination></md-card></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"coupon_add\"><md-dialog aria-label=\"Add Coupon\" class=\"coupon-dialog\" flex=\"75\"><form ng-cloak=\"\" name=\"newCouponForm\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{editingMode ? \"Edit Coupon\" : \"Add New Coupon\"}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"details\"><md-content class=\"md-padding\" layout=\"row\" layout-wrap=\"\"><md-input-container ng-required=\"\" class=\"md-block\" flex=\"25\"><label>Coupon Code</label> <input type=\"text\" ng-change=\"capitalize();\" name=\"couponCode\" ng-minlength=\"5\" ng-model=\"newCoupon.couponCode\"><div ng-messages=\"newCouponForm.couponCode.$error\"><div ng-message=\"valid\">The entered value is not valid!</div><div ng-message=\"required\">CouponCode is required!</div></div></md-input-container><md-input-container class=\"md-block\" ng-required=\"\" flex=\"25\"><label>Current Status</label><md-select name=\"currentStatus\" ng-model=\"newCoupon.currentStatus\"><md-option ng-value=\"getNumericValue(1);\">Active</md-option><md-option ng-value=\"getNumericValue(0);\">Scheduled</md-option><md-option ng-value=\"getNumericValue(-1);\">Expired</md-option></md-select><div ng-messages=\"newCouponForm.currentStatus.$error\"><div ng-message=\"valid\">The entered value is not valid!</div><div ng-message=\"required\">Current Status is required!</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"25\"><label>Select Start Date</label> <input mdc-datetime-picker=\"\" date=\"true\" time=\"true\" type=\"text\" short-time=\"true\" show-todays-date=\"\" click-outside-to-close=\"true\" placeholder=\"Start Date\" auto-ok=\"true\" min-date=\"minDate\" minute-steps=\"1\" format=\"DD-MMM-YYYY hh:mm a\" ng-model=\"newCoupon.startDate\"><div ng-messages=\"newCouponForm.startDate.$error\"><div ng-message=\"valid\">The entered value is not a date!</div><div ng-message=\"required\">This date is required!</div><div ng-message=\"mindate\">Date is too early!</div><div ng-message=\"maxdate\">Date is too late!</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"25\"><label>Select Expiry Date</label> <input mdc-datetime-picker=\"\" date=\"true\" time=\"true\" type=\"text\" short-time=\"true\" name=\"expiryDate\" show-todays-date=\"\" click-outside-to-close=\"true\" placeholder=\"Expiry Date\" auto-ok=\"true\" max-date=\"maxDate\" min-date=\"newCoupon.startDate ? newCoupon.startDate : minDate\" minute-steps=\"1\" format=\"DD-MMM-YYYY hh:mm a\" ng-model=\"newCoupon.expiryDate\"><div ng-messages=\"newCouponForm.expiryDate.$error\"><div ng-message=\"valid\">The entered value is not a date!</div><div ng-message=\"required\">This date is required!</div><div ng-message=\"mindate\">Date is too early!</div><div ng-message=\"maxdate\">Date is too late!</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"33\" flex=\"90\"><label>Cashback Type</label><md-select name=\"discountType1\" ng-required=\"\" ng-model=\"newCoupon.cashBack.discountType\"><md-option ng-value=\"getNumericValue(0);\">Fixed Amount</md-option><md-option ng-value=\"getNumericValue(1);\">Percentage</md-option></md-select><div ng-messages=\"newCouponForm.discountType1.$error\"><div ng-message=\"valid\">The entered value is not valid!</div><div ng-message=\"required\">Type is required!</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"33\"><label>Cashback Amount</label> <input type=\"number\" min=\"0\" name=\"cashBackAmount\" ng-model=\"newCoupon.cashBack.amount\"><div ng-messages=\"newCoupon.cashBackAmount.$error\"><div ng-message=\"valid\">The entered value is not valid!</div><div ng-message=\"required\">CouponCode is required!</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"33\"><label>Cashback Limit</label> <input type=\"number\" min=\"0\" name=\"limit\" ng-model=\"newCoupon.cashBack.limit\"><div ng-messages=\"newCoupon.limit.$error\"><div ng-message=\"valid\">The entered value is not valid!</div><div ng-message=\"required\">CouponCode is required!</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"33\" flex=\"90\"><label>Apply To</label><md-select name=\"applicableTo\" ng-required=\"\" ng-model=\"newCoupon.applicableTo\"><md-option ng-value=\"getNumericValue(0);\">Cart</md-option><md-option ng-value=\"getNumericValue(1);\">Product</md-option><md-option ng-value=\"getNumericValue(2);\">Points</md-option></md-select><div ng-messages=\"newCouponForm.applicableTo.$error\"><div ng-message=\"valid\">The entered value is not valid!</div><div ng-message=\"required\">Applicable to is required!</div></div></md-input-container><md-input-container class=\"md-block\" ng-required=\"\" flex-gt-sm=\"33\" flex=\"90\"><label>Discount Type</label><md-select name=\"discountType\" ng-required=\"\" ng-model=\"newCoupon.discountType\"><md-option ng-value=\"getNumericValue(0);\">Fixed Amount</md-option><md-option ng-if=\"newCoupon.applicableTo != 2\" ng-value=\"getNumericValue(1);\">Percentage</md-option><md-option ng-if=\"newCoupon.applicableTo === 1\" ng-value=\"getNumericValue(2);\">Buy One Get One Free</md-option></md-select><div ng-messages=\"newCouponForm.discountType.$error\"><div ng-message=\"valid\">The entered value is not valid!</div><div ng-message=\"required\">Type is required!</div></div></md-input-container><md-input-container ng-required=\"\" class=\"md-block\" flex-gt-sm=\"33\" flex=\"90\"><label>Discount Amount</label> <input type=\"number\" min=\"0\" name=\"discountAmount\" ng-model=\"newCoupon.discountAmount\"><div ng-messages=\"newCouponForm.discountAmount.$error\"><div ng-message=\"valid\">The entered value is not valid!</div><div ng-message=\"required\">Discount Amount is required!</div></div></md-input-container></md-content></md-tab><md-tab label=\"target\"><md-content class=\"md-padding coupon-products\" layout=\"\" layout-sm=\"column\" layout-xs=\"column\" layout-align=\"center center\"><div flex=\"40\" layout=\"column\" layout-align=\"space-around center\"><md-autocomplete id=\"autoCompleteSearch\" md-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-min-length=\"3\" md-selected-item-change=\"selectedItemChange(item)\" placeholder=\"Search for products by sku, sku_size combo, product name, wid etc.\" md-menu-class=\"product-autocomplete-results\" md-items=\"item in productQuery(searchText)\" md-item-text=\"item.name\"><md-item-template><div layout=\"\" layout-align=\"stretch center\"><img ng-src=\"{{mediaURL + item.featured_image.urls.thumbnail}}\" class=\"search-image\"><div layout=\"column\"><p md-highlight-text=\"searchText\">{{item.name}} ({{item.sku}}) - &#8377; {{item.price}}</p></div><span flex=\"20\"></span></div></md-item-template><md-not-found>No products matching \"{{searchText}}\" were found.</md-not-found></md-autocomplete><md-content layout=\"column\"><md-virtual-repeat-container class=\"vertical-container\"><div layout=\"\" layout-align=\"stretch center\" md-virtual-repeat=\"item in newCoupon.products\" class=\"repeated-item\" flex=\"\"><md-img hide-lazy-load=\"true\" md-src=\"{{item.featured_image.urls.thumbnail}}\" class=\"md-avatar\"></md-img><p style=\"padding: 5px;\">{{item.name}}</p><span flex=\"\"></span><md-button class=\"md-icon-button md-warn\" ng-click=\"removeSelectedProduct($index, item._id)\"><md-icon>close</md-icon><md-tooltip md-direction=\"bottom\">Remove this Product</md-tooltip></md-button></div></md-virtual-repeat-container></md-content></div><div flex=\"20\" layout=\"\" layout-align=\"center center\"><md-select placeholder=\"Assign to Product Collections\" multiple=\"\" ng-model=\"newCoupon.groups\" md-on-open=\"loadCollections()\" style=\"min-width: 200px;\"><md-option ng-value=\"collection._id\" ng-repeat=\"collection in collections\">{{collection.name}}</md-option></md-select></div><div flex=\"20\" layout=\"\" layout-align=\"center center\"><md-select placeholder=\"Assign to Category\" multiple=\"\" ng-model=\"newCoupon.categories\" md-on-open=\"loadCategories()\" style=\"min-width: 200px;\"><md-option ng-value=\"category._id\" ng-repeat=\"category in categories\">{{category.name}}</md-option></md-select></div><div layout=\"column\"><div layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">Target Users ({{newCoupon.users ? newCoupon.users.length : 0}})</span><md-button ng-click=\"showUserSelector($event)\" class=\"small outline\">Select Users</md-button></div><md-virtual-repeat-container class=\"vertical-container\"><div layout=\"\" layout-align=\"stretch center\" md-virtual-repeat=\"item in newCoupon.users\" class=\"repeated-item\" flex=\"\"><div layout=\"column\"><span class=\"md-body-1\">{{item.name}}</span> <span class=\"md-caption\">{{item.mobile}}</span></div><span flex=\"\"></span><md-button class=\"md-icon-button md-warn\" ng-click=\"removeSelectedUser($index, item._id)\"><md-icon>close</md-icon><md-tooltip md-direction=\"bottom\">Remove this User</md-tooltip></md-button></div></md-virtual-repeat-container></div></md-content></md-tab><md-tab label=\"rules\"><md-content class=\"md-padding\" layout=\"\" layout-wrap=\"\"><md-input-container ng-required=\"\" class=\"md-block\" flex=\"50\"><label>User Usage Limit</label> <input type=\"number\" min=\"0\" name=\"userUsageLimit\" ng-model=\"newCoupon.userUsageLimit\"><div ng-messages=\"newCouponForm.userUsageLimit.$error\"><div ng-message=\"valid\">The entered value is not valid!</div><div ng-message=\"required\">User Usage Limit is required!</div></div></md-input-container><md-input-container ng-required=\"\" class=\"md-block\" flex=\"50\"><label>Total Usage Limit</label> <input type=\"number\" min=\"0\" name=\"totalUsageLimit\" ng-model=\"newCoupon.totalUsageLimit\"><div ng-messages=\"newCouponForm.totalUsageLimit.$error\"><div ng-message=\"valid\">The entered value is not valid!</div><div ng-message=\"required\">Total Usage Limit is required!</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><md-checkbox ng-model=\"newCoupon.autoApplied\">Auto Applied</md-checkbox></md-input-container><section layout=\"column\" flex=\"100\"><div layout=\"\" layout-align=\"end center\" class=\"full-width\"><md-button ng-click=\"addNewRule(0, $event)\" class=\"md-primary\"><md-icon>add</md-icon>Add New Rule</md-button></div><div flex=\"\" layout=\"\" layout-wrap=\"\" layout-padding=\"\" class=\"full-width\"><div flex=\"100\" layout=\"\" ng-repeat=\"rule in newCoupon.eligibilityRules\" md-colors=\"{\'borderColor\' : \'boring-accent-200-1\'}\" style=\"border: 1px dashed;\" class=\"md-margin\"><md-input-container flex=\"30\"><label>Compare Variable</label><md-select ng-model=\"rule.lhs\"><md-option ng-value=\"\'amount\'\">Total Cart Value</md-option><md-option ng-value=\"\'ordersCount\'\">Number of Orders for User</md-option></md-select></md-input-container><md-input-container flex=\"20\"><label>Rule Type</label><md-select ng-required=\"\" ng-model=\"rule.operator\"><md-option ng-value=\"\'==\'\">Equals</md-option><md-option ng-value=\"\'>\'\">Greater Than</md-option><md-option ng-value=\"\'>=\'\">Greater or equal to</md-option><md-option ng-value=\"\'<\'\">Less than</md-option><md-option ng-value=\"\'<=\'\">Lesser or Equal to</md-option></md-select></md-input-container><md-input-container flex=\"30\"><label>Enter Comparator</label> <input type=\"number\" ng-model=\"rule.rhs\" ng-required=\"\" ng-minlength=\"0\" min=\"0\"></md-input-container><div flex=\"10\" layout=\"\" layout-align=\"center center\"><md-button class=\"md-fab md-mini\" ng-click=\"addNewRule($index, $event);\"><md-icon>add</md-icon></md-button></div><div flex=\"10\" layout=\"\" layout-align=\"center center\"><md-button class=\"md-fab md-mini\" ng-click=\"removeRule($index);\"><md-icon>close</md-icon></md-button></div></div></div></section></md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"cancel()\">Cancel</md-button><span flex=\"\"></span><md-button ng-disabled=\"promise.$$state.pending\" ng-click=\"saveCoupon();\">Save</md-button></md-dialog-actions></form></md-dialog></div></div><style>\n    .selectdemoSelectHeader {\n        /* Please note: All these selectors are only applied to children of elements with the \'selectdemoSelectHeader\' class */\n    }\n\n    .selectdemoSelectHeader .demo-header-searchbox {\n        border: none;\n        outline: none;\n        height: 100%;\n        width: 100%;\n        padding: 0;\n    }\n\n    .selectdemoSelectHeader .demo-select-header {\n        box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.1), 0 0 0 0 rgba(0, 0, 0, 0.14), 0 0 0 0 rgba(0, 0, 0, 0.12);\n        padding-left: 10.667px;\n        height: 48px;\n        cursor: pointer;\n        position: relative;\n        display: flex;\n        align-items: center;\n        width: auto;\n    }\n\n    .selectdemoSelectHeader md-content._md {\n        max-height: 240px;\n    }\n</style>");
$templateCache.put("app/modules/offers/discount/partials/discount.html","<div layout=\"row\" layout-align=\"center start\"><md-card flex=\"\"><md-card-content><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"fetchAllDiscounts\"><tr md-row=\"\"><th md-column=\"\">Sl.</th><th md-column=\"\" md-order-by=\"couponCode\">Coupon Code</th><th md-column=\"\" md-order-by=\"startDate\">Start Date</th><th md-column=\"\" md-order-by=\"expiryDate\">Expiry Date</th><th md-column=\"\" md-order-by=\"applicableTo\"><span>Apply On</span></th><th md-column=\"\" md-order-by=\"discountType\"><span>Type</span></th><th md-column=\"\" md-order-by=\"discountAmount\" md-numeric=\"\">Amount</th><th md-column=\"\" md-order-by=\"userUsageLimit\">User Usages<md-button class=\"md-icon-button\"><md-icon>info</md-icon><md-tooltip md-direction=\"bottom\">Number of coupon usages allowed per user</md-tooltip></md-button></th><th md-column=\"\" md-order-by=\"totalUsageLimit\">Total Usage<md-button class=\"md-icon-button\"><md-icon>info</md-icon><md-tooltip md-direction=\"bottom\">Total number of coupon usages allowed</md-tooltip></md-button></th><th md-column=\"\"><span>Created By</span></th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"discount\" md-select-id=\"discount._id\" md-auto-select=\"\" ng-repeat=\"discount in discounts\" style=\"height: 75px;\"><td md-cell=\"\">{{$index + 1 }}.</td><td md-cell=\"\">{{ discount.couponCode }}</td><td md-cell=\"\">{{discount.startDate | date : \"mediumDate\" }}</td><td md-cell=\"\">{{discount.expiryDate | date : \"mediumDate\" }}</td><td md-cell=\"\">{{ getApplicableTo(discount.applicableTo); }}</td><td md-cell=\"\">{{ getDiscountType(discount.discountType); }}</td><td md-cell=\"\">{{ getDiscountAmount(discount.discountAmount, discount.discountType); }}</td><td md-cell=\"\">{{ discount.userUsageLimit }}</td><td md-cell=\"\">{{ discount.totalUsageLimit }}</td><td md-cell=\"\">{{discount.created_by.name }}</td><td md-cell=\"\"><span layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"editCategory(category, $index, $event);\"><md-icon>edit</md-icon><md-tooltip md-direction=\"bottom\">Edit Category</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"removeCategory(category, $index, $event);\"><md-icon style=\"color: red;\">delete</md-icon><md-tooltip md-direction=\"bottom\">Delete Category</md-tooltip></md-button></span></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[10, 25, 50]\" md-page=\"query.page\" md-total=\"{{products.count}}\" md-on-paginate=\"fetchAllDiscounts\" md-page-select=\"\"></md-table-pagination></md-card-content></md-card></div>");
$templateCache.put("app/modules/offers/giftCards/add/giftCards.add.html","<div layout=\"column\" layout-align=\"center stretch\"><div layout=\"column\" layout-align=\"center stretch\"><form name=\"newGiftCardForm\"><md-card><md-card-content><div layout=\"\" layout-align=\"space-around center\"><md-input-container><label>Count</label> <input type=\"number\" ng-model=\"cardParams.count\" min=\"0\"></md-input-container><md-input-container style=\"margin-bottom: 37px;\"><label>Card Type</label><md-select ng-model=\"cardParams.cardType\"><md-option ng-value=\"card.type\" ng-repeat=\"card in cards\">{{card.type | uppercase}}</md-option></md-select></md-input-container><md-input-container style=\"margin-bottom: 37px;\"><label>Organisation</label><md-select ng-model=\"cardParams.org\"><md-option ng-value=\"org._id\" ng-repeat=\"org in orgs\">{{org.name}}</md-option></md-select></md-input-container></div><div layout=\"\" layout-align=\"center center\"><md-input-container><md-checkbox ng-model=\"cardParams.isCorporateCard\">Disable checkout form the gift cards?</md-checkbox></md-input-container></div></md-card-content><md-card-actions><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-primary md-raised\" ng-disabled=\"!cardParams.cardType || !cardParams.count\" ng-click=\"createCards()\">Create</md-button></div></md-card-actions></md-card></form></div></div>");
$templateCache.put("app/modules/offers/giftCards/all/giftCards.all.html","<div layout=\"column\"><div layout=\"\" layout-align=\"space-between center\"><div flex-offset=\"5\" layout=\"\" layout-align=\"start center\" ng-if=\"query.onlyFraud && query.onlyFraud !== \'false\'\"><span class=\"md-caption green-text\">Showing {{fraudCards}} cards with Fraud Attempts</span><md-button class=\"md-icon-button\" ng-click=\"clearFiler(\'fraudCards\')\"><md-icon>close</md-icon><md-tooltip>Clear Filter</md-tooltip></md-button></div><div flex-offset=\"5\" layout=\"\" layout-align=\"start center\" ng-if=\"query.closeToExpire\"><span class=\"md-caption green-text\">Showing {{closeToExpireCards}} cards which will be expired soon</span><md-button class=\"md-icon-button\" ng-click=\"clearFiler(\'closeToExpire\')\"><md-icon>close</md-icon><md-tooltip>Clear Filter</md-tooltip></md-button></div><span flex=\"\"></span><md-button class=\"md-warn outline\" ng-click=\"showFraudulentCards()\"><div layout=\"\" layout-align=\"space-around center\"><bubble-loader ng-if=\"loadingFraud\"></bubble-loader><span ng-if=\"!loadingFraud\">{{fraudCards}}</span> <span style=\"margin-left: 4px\">Fraud Cards</span></div></md-button><md-button class=\"md-warn outline\"><div layout=\"\" layout-align=\"space-around center\" ng-click=\"showCloseToExpiryCards()\"><bubble-loader ng-if=\"loadingCloseToExpiry\"></bubble-loader><span ng-if=\"!loadingCloseToExpiry\">{{closeToExpireCards}}</span> <span style=\"margin-left: 4px\">Close To Expire Cards</span></div></md-button></div><md-content md-scroll-x=\"\" class=\"scrolling-tabs\"><md-button class=\"custom-tab\" ng-class=\"{\'active\' : query.status === \'all\'}\" ng-click=\"query.status = \'all\'; fetchAllCards()\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator\"></span> <span>All</span></div></md-button><md-button class=\"custom-tab\" ng-class=\"{\'active\' : (query.status === \'created\')}\" ng-click=\"query.status = \'created\'; fetchAllCards()\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator pending\"></span> <span>Created</span></div></md-button><md-button class=\"custom-tab\" ng-class=\"{\'active\' : (query.status === \'generated\')}\" ng-click=\"query.status = \'generated\'; fetchAllCards()\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator pending\"></span> <span>Generated</span></div></md-button><md-button class=\"custom-tab\" ng-class=\"{\'active\' : query.status === \'activated\'}\" ng-click=\"query.status = \'activated\'; fetchAllCards()\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator staging\"></span> <span>Activated</span></div></md-button><md-button class=\"custom-tab\" ng-class=\"{\'active\' : query.status === \'redeemed\'}\" ng-click=\"query.status = \'redeemed\'; fetchAllCards()\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator success\"></span> <span>Redeemed</span></div></md-button><md-button class=\"custom-tab\" ng-class=\"{\'active\' : query.status === \'expired\'}\" ng-click=\"query.status = \'expired\'; fetchAllCards()\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator error\"></span> <span>Expired</span></div></md-button><md-button class=\"custom-tab\" ng-class=\"{\'active\' : query.status === \'blocked\'}\" ng-click=\"query.status = \'blocked\'; fetchAllCards()\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator error\"></span> <span>Blocked</span></div></md-button></md-content><md-card flex=\"\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools scrolling-tabs\" layout=\"\" layout-align=\"space-between center\" style=\"background: #ebebee\"><div layout=\"\" layout-align=\"start center\" flex=\"\"><span ng-if=\"!selected.length\" style=\"margin-right: 20px\">Gift Cards</span><section layout=\"\" layout-align=\"start center\" ng-if=\"selected.length\"><md-button class=\"md-icon-button material-icons--two-tone\" ng-click=\"clearSelections()\"><md-icon>close</md-icon></md-button><span class=\"md-tiny\">{{selected.length}} Gift Cards Selected</span></section><span ng-if=\"selected.length\" flex-offset=\"5\"></span><form role=\"form\" novalidate=\"\" name=\"filterForm\" flex-offset=\"5\" ng-submit=\"fetchAllCards()\" layout=\"\" layout-align=\"center center\"><md-input-container flex=\"\" class=\"no-error-spacer\" layout=\"\"><label>&nbsp;</label> <input type=\"search\" id=\"giftCardSearch\" ng-model=\"query.search\" select-on-click=\"\" ng-model-options=\"{\'debounce\' : 500}\" ng-change=\"fetchAllCards()\" placeholder=\"Search Gift Cards\" class=\"search-bar-input\"></md-input-container><md-button ng-click=\"fetchAllCards()\" class=\"md-icon-button\"><md-icon>search</md-icon></md-button></form></div><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-class=\"{\'md-accent\': !showFilters, \'md-primary\' : showFilters}\" ng-click=\"openFiltersDialog($event)\"><md-icon class=\"material-icons--two-tone\">filter_list</md-icon><md-tooltip>Filters</md-tooltip><attached-tag tag-type=\"dot\" right=\"8px\" top=\"8px\" ng-if=\"hasFilters\"></attached-tag></md-button><md-button ng-click=\"clearFilters()\" ng-if=\"hasFilters\" class=\"md-warn small\">Clear Filters</md-button><md-menu><md-button ng-click=\"$mdOpenMenu($event)\" aria-label=\"User\" class=\"md-accent md-icon-button\"><md-icon class=\"black-text\">more_vert</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"column in columns\"><md-button md-prevent-menu-close=\"\"><md-checkbox class=\"md-primary\" ng-change=\"sendToLocalStorage()\" ng-model=\"column.model\">{{column.name}}</md-checkbox></md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-primary md-fab md-mini\" ui-sref=\"app.offers.giftCards.add\"><md-icon>add</md-icon><md-tooltip class=\"white-text\">Generate Gift Cards</md-tooltip></md-button></div></div><div class=\"md-toolbar-tools scrolling-tabs toolbar-show\" ng-show=\"selected.length\" style=\"background: #ebebee\" layout=\"\" layout-align=\"start center\"><md-button class=\"small md-primary\" ng-click=\"openNotifications(selected, $event)\"><md-icon>message</md-icon><span>Notify Customers</span></md-button><md-button class=\"small md-primary\" ng-click=\"selectCaseWorker($event, selected)\"><md-icon>person_add</md-icon><span>Assign Handler</span></md-button><md-button class=\"small md-primary\" ng-click=\"updateExpiryDates($event, selected)\"><md-icon>history</md-icon><span>Update Expiry Date</span></md-button><md-button class=\"small md-primary\" ng-click=\"downloadPrintFiles($event)\"><md-icon>file_download</md-icon><span>Download Print Excel File</span></md-button><md-button class=\"small md-warn\" ng-click=\"expireCards($event)\"><md-icon>system_update_alt</md-icon><span>Expire Card</span></md-button></div></md-toolbar><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[10, 25, 50, 100]\" md-page=\"query.page\" md-total=\"{{total}}\" md-on-paginate=\"fetchAllCards\" md-page-select=\"\"></md-table-pagination><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.sort\" md-on-reorder=\"fetchAllCards\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\">Sl No.</th><th md-column=\"\" md-order-by=\"{{column.orderBy}}\" ng-repeat=\"column in columns\" ng-show=\"column.model\">{{column.name}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"card\" md-auto-select=\"\" ng-repeat=\"card in cards\" ng-init=\"index = $index\"><td md-cell=\"\">{{ (((query.page - 1) * query.limit) + $index) + 1}}.</td><td md-cell=\"\" ng-repeat=\"column in columns\" ng-show=\"column.model\"><div layout=\"column\" layout-align=\"center center\" style=\"white-space: nowrap\" ng-if=\"column.value === \'code\'\"><a class=\"md-caption md-link\" ng-click=\"$event.stopPropagation();\" ui-sref=\"app.offers.giftCards.details({cardId : card._id, backState: \'app.offers.giftCards.all\', backParams : backParams})\">{{card.code }}</a> <i class=\"red-text md-tiny\" ng-if=\"card.fraudCount\">{{card.fraudCount}} Fraud Attempts Detected</i></div><div layout=\"\" layout-align=\"center center\" ng-if=\"column.value === \'status\'\"><span class=\"dot-indicator\" ng-class=\"{ \'error\' : card.status ===\'expired\' || card.status ===\'blocked\' , \'pending\' : [\'created\', \'generated\'].includes(card.status), \'staging\' : [\'activated\'].includes(card.status), \'success\' : card.status === \'redeemed\'}\"></span> <span class=\"md-tiny\">{{card.status| uppercase}}</span></div><div layout=\"column\" layout-align=\"center start\" ng-if=\"column.value === \'cardType\'\"><span class=\"md-tiny grey-text\">{{card.cardType | uppercase}}</span> <span class=\"md-tiny green-text\" ng-if=\"card.isCorporateCard\">Corporate Card</span></div><span ng-class=\"{\'bold-text\' : card.balance}\" ng-if=\"column.value === \'balance\'\">₹{{card.balance}}</span><div ng-if=\"column.value === \'organisation\'\"><div layout=\"column\" ng-if=\"card.organisation\"><a ui-sref=\"app.users.organisations({orgId : card.organisation._id})\" class=\"md-caption md-link\">{{card.organisation.name}}</a></div><span ng-if=\"!card.organisation\" class=\"md-tiny grey-text\">N/A</span></div><div ng-if=\"column.value === \'agent\'\"><div layout=\"column\" ng-if=\"card.agent\"><a ui-sref=\"app.users.details.home({userId : card.agent._id})\" ng-click=\"$event.stopPropagation()\" class=\"md-caption md-link\">{{card.agent.name}}</a> <span class=\"md-tiny grey-text\">{{card.agent.mobile}}</span></div><span ng-if=\"!card.agent\" class=\"md-tiny grey-text\">Not Assigned</span></div><div ng-if=\"column.value === \'user\'\"><div layout=\"column\" ng-if=\"card.user\"><a ui-sref=\"app.users.details.home({userId : card.user._id})\" ng-click=\"$event.stopPropagation()\" class=\"md-caption md-link\">{{card.user.name}}</a> <span class=\"md-tiny grey-text\">{{card.user.mobile}}</span></div><span ng-if=\"!card.user\" class=\"md-tiny grey-text\">Not Assigned</span></div><div ng-if=\"column.value === \'handler\'\"><div layout=\"column\" ng-if=\"card.caseWorker\"><a ui-sref=\"app.users.details.home({userId : card.caseWorker})\" ng-click=\"$event.stopPropagation()\" class=\"md-caption md-link\">{{card.cachedCaseWorker}}</a></div><md-button ng-if=\"!card.caseWorker && (card.status === \'activated\' || card.status === \'redeemed\' || card.status === \'expired\')\" class=\"md-primary small\" ng-click=\"$event.stopPropagation(); selectCaseWorker($event, card)\"><span ng-if=\"!card.updatingHandler\">Assign</span><bubble-loader ng-if=\"card.updatingHandler\"></bubble-loader></md-button><span class=\"grey-text md-tiny\" ng-if=\"!card.caseWorker && (card.status !== \'activated\' && card.status !== \'redeemed\' && card.status !== \'expired\')\">Not Applicable</span></div><span ng-if=\"column.value === \'updatedAt\'\" class=\"md-tiny grey-text\">{{card.updatedAt | date : \'medium\'}}</span> <span ng-if=\"column.value === \'createdAt\'\" class=\"md-tiny grey-text\">{{card.createdAt | date : \'medium\'}}</span> <span ng-if=\"column.value === \'redemptionDate\'\" class=\"md-tiny\">{{card.redemptionDate | date : \'medium\'}}</span> <span ng-if=\"column.value === \'activationDate\'\" class=\"md-tiny\">{{card.activationDate | date : \'medium\'}}</span> <span ng-if=\"column.value === \'expiryDate\'\" class=\"md-tiny\">{{card.expiryDate | date : \'medium\'}}</span> <span ng-if=\"column.value === \'lastReminderDate\'\" class=\"md-tiny\">{{card.lastReminderDate | date : \'medium\'}}</span> <span ng-if=\"column.value === \'lastFraudAttemptDate\'\" class=\"md-tiny\">{{card.lastFraudAttemptDate | date : \'medium\'}}</span><div ng-if=\"column.value === \'actions\'\"><md-button class=\"md-primary md-icon-button\" ng-click=\"$event.stopPropagation(); openCardModal($event, card._id, index)\"><md-icon class=\"material-icons--two-tone\">edit</md-icon><md-tooltip>Edit Card</md-tooltip></md-button><md-menu><md-button ng-click=\"$mdOpenMenu($event)\" aria-label=\"User\" class=\"md-primary md-icon-button\"><md-icon class=\"material-icons--two-tone\">more_horiz</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item ng-if=\"card.status === \'created\'\"><md-button ng-disabled=\"card.updating\" ng-click=\"$event.stopPropagation(); updateStatus(card, \'generated\', $event)\"><bubble-loader ng-if=\"card.updating\"></bubble-loader><md-icon ng-if=\"!card.updating\">star</md-icon><span ng-if=\"!card.updating\">Mark As Generated</span></md-button></md-menu-item><md-menu-item ng-if=\"card.status !== \'created\' && card.status !== \'generated\'\"><md-button ng-disabled=\"savingNotification\" ng-click=\"$event.stopPropagation();openNotifications(card,$event);\"><div ng-if=\"!card.savingNotification\"><md-icon>message</md-icon><span>Notify Customer</span></div><bubble-loader ng-if=\"card.savingNotification\"></bubble-loader></md-button></md-menu-item><md-menu-item><md-button ng-click=\"$event.stopPropagation(); openCardModal($event, card._id, index)\"><md-icon>edit</md-icon>Edit Card</md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-icon-button\" ng-disabled=\"card.savingNotification\" ng-if=\"card.status !== \'created\' && card.status !== \'generated\'\" ng-click=\"openNotifications(card,$event);\"><bubble-loader ng-if=\"card.savingNotification\"></bubble-loader><md-icon class=\"md-primary material-icons--two-tone\" ng-if=\"!card.savingNotification\">message</md-icon><md-tooltip md-direction=\"bottom\">Notify Customer</md-tooltip></md-button></div></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[10, 25, 50, 100]\" md-page=\"query.page\" md-total=\"{{total}}\" md-on-paginate=\"fetchAllCards\" md-page-select=\"\"></md-table-pagination></md-card></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"giftCardFilterDialog\"><md-dialog aria-label=\"giftCardFilterDialog\" flex=\"66\"><form ng-cloak=\"\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout-align=\"space-between center\"><span class=\"md-title\">Filters</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><div class=\"md-dialog-content\" layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"\"><div layout=\"\"><md-select ng-model=\"filterOrgs\" multiple=\"\" placeholder=\"Organisation\" flex=\"\"><md-button layout-fill=\"\" value=\"all\" ng-click=\"selectAll(filterOrgs, orgs)\"><md-icon class=\"material-icons--two-tone\">select_all</md-icon>Select all</md-button><md-option ng-value=\"organisation._id\" ng-repeat=\"organisation in orgs\">{{organisation.name}}</md-option></md-select><md-input-container flex=\"\"><label>Select Redemption Start Date</label><md-datepicker ng-model=\"query.redemptionStartDate\"></md-datepicker></md-input-container><md-input-container flex=\"\"><label>Select Redemption End Date</label><md-datepicker ng-model=\"query.redemptionEndDate\"></md-datepicker></md-input-container></div><md-divider></md-divider><h4>Filter By Users</h4><p>Select the users the gift cards have been assigned to</p><md-chips ng-model=\"filterUsers\" md-autocomplete-snap=\"\" md-transform-chip=\"transformChip($chip)\" md-require-match=\"true\" input-aria-label=\"Favorite Users\" class=\"md-block full-width\"><md-autocomplete md-selected-item=\"selectedItem\" md-search-text=\"userSearch\" md-items=\"item in queryUsers(userSearch)\" md-item-text=\"item.name\" input-aria-describedby=\"autocompleteTitle\" placeholder=\"Search for a user\"><md-item-template><span class=\"md-caption\" md-highlight-text=\"userSearch\">{{item.name}}</span> <span class=\"grey-text md-caption\" md-highlight-text=\"userSearch\">:{{item.mobile}}</span></md-item-template></md-autocomplete><md-chip-template><p><span class=\"md-caption\">{{$chip.name}}</span> <span class=\"md-tiny\">({{$chip.mobile}})</span></p></md-chip-template></md-chips><md-divider></md-divider><h4>Filter By Agents</h4><p>Select the users who are incharge of delivery/activation of the gift card</p><md-chips ng-model=\"filterAgents\" md-autocomplete-snap=\"\" md-transform-chip=\"transformChip($chip)\" md-require-match=\"true\" input-aria-label=\"Favorite Users\" class=\"md-block full-width\"><md-autocomplete md-selected-item=\"selectedItem\" md-search-text=\"agentSearch\" md-items=\"item in queryUsers(agentSearch)\" md-item-text=\"item.name\" input-aria-describedby=\"autocompleteTitle\" placeholder=\"Search for an agent\"><md-item-template><span class=\"md-caption\" md-highlight-text=\"userSearch\">{{item.name}}</span> <span class=\"grey-text md-caption\" md-highlight-text=\"userSearch\">:{{item.mobile}}</span></md-item-template></md-autocomplete><md-chip-template><p><span class=\"md-caption\">{{$chip.name}}</span> <span class=\"md-tiny\">({{$chip.mobile}})</span></p></md-chip-template></md-chips><md-divider></md-divider><h4>Filter By Handlers</h4><p>Select the users the are being worked on by</p><md-chips ng-model=\"filterCaseWorkers\" md-autocomplete-snap=\"\" md-transform-chip=\"transformChip($chip)\" md-require-match=\"true\" input-aria-label=\"Favorite Users\" class=\"md-block full-width\"><md-autocomplete md-selected-item=\"selectedItem\" md-search-text=\"handlerSearch\" md-items=\"item in queryUsers(handlerSearch)\" md-item-text=\"item.name\" input-aria-describedby=\"autocompleteTitle\" placeholder=\"Search for a handler\"><md-item-template><span class=\"md-caption\" md-highlight-text=\"userSearch\">{{item.name}}</span> <span class=\"grey-text md-caption\" md-highlight-text=\"userSearch\">:{{item.mobile}}</span></md-item-template></md-autocomplete><md-chip-template><p><span class=\"md-caption\">{{$chip.name}}</span> <span class=\"md-tiny\">({{$chip.mobile}})</span></p></md-chip-template></md-chips></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><span flex=\"\"></span><md-button ng-click=\"parseFilters()\">Apply Filters</md-button></md-dialog-actions></form></md-dialog></div></div>");
$templateCache.put("app/modules/offers/giftCards/details/giftCards.details.html","<md-tabs md-dynamic-height=\"\" class=\"gift-card-details\"><md-tab label=\"Details\"><md-content class=\"md-padding\"><div layout=\"\" layout-align=\"space-between center\"><span flex=\"\"></span><div layout=\"\" layout-align=\"end center\" ng-if=\"card.status === \'redeemed\'\"><md-button class=\"md-accent outline\" ng-click=\"openExpiryUpdate($event)\">Update Expiry Date</md-button></div></div><div layout=\"column\" layout-align=\"stretch center\"><md-card><md-card-content><div layout=\"\" layout-align=\"space-between center\" style=\"padding: 10px;\"><div layout=\"column\" layout-align=\"center center\"><span class=\"grey-text md-caption bold-text\" style=\"text-transform: uppercase;\">Card Code</span> <span class=\"md-subhead\" ng-click=\"$event.stopPropagation()\">{{card.code}}<md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-click=\"$event.stopPropagation(); showToast(\'Copied Card Code to Clipboard\')\" data-clipboard-text=\"{{card.code}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy Card Code</md-tooltip></md-button></span></div><div layout=\"column\" layout-align=\"center center\"><span class=\"grey-text md-caption\" style=\"text-transform: uppercase;\">Balance</span> <span class=\"md-subhead\">{{card.balance}}</span></div><div layout=\"column\" layout-align=\"center center\"><span class=\"grey-text md-caption\" style=\"text-transform: uppercase;\">Used Amount</span> <span class=\"md-subhead\">{{card.usedAmount}}</span></div><div layout=\"column\" layout-align=\"center center\"><span class=\"grey-text md-caption\" style=\"text-transform: uppercase;\">Card Type</span> <span class=\"md-subhead\">{{card.cardType | uppercase}}</span></div><div layout=\"column\" layout-align=\"center center\"><span class=\"grey-text md-caption\" style=\"text-transform: uppercase;\">Organisation</span> <span class=\"md-subhead\">{{card.organisation.name}}</span></div></div></md-card-content></md-card><md-card class=\"md-padding\"><md-card-content layout=\"column\"><md-progress-linear class=\"md-accent\" md-mode=\"determinate\" ng-value=\"cardStatusValue\"></md-progress-linear><div layout=\"\" class=\"relative\"><div ng-show=\"createdSuccess && showCreatedSuccess\" style=\"position: absolute; top: -15px; width: 24px;\" ng-style=\"{\'left\' : (0 + 8) + \'%\'}\"><img src=\"/assets/images/success.svg\" style=\"width: 24px;\"></div><div ng-show=\"generatedSuccess && showGeneratedSuccess\" style=\"position: absolute; top: -15px; width: 24px;\" ng-style=\"{\'left\' : (20 + 4) +\'%\'}\"><img src=\"assets/images/success.svg\" style=\"width: 24px;\"></div><div ng-show=\"activatedSuccess && showActivatedSuccess\" style=\"position: absolute; top: -15px; width: 24px;\" ng-style=\"{\'left\' : (40 + 1) + \'%\'}\"><img src=\"assets/images/success.svg\" style=\"width: 24px;\"></div><div ng-show=\"redeemedSuccess && showRedeemedSuccess\" style=\"position: absolute; top: -15px; width: 24px;\" ng-style=\"{\'left\' : (60 - 2) +\'%\'}\"><img src=\"assets/images/success.svg\" style=\"width: 24px;\"></div><div ng-show=\"expiredSuccess && showExpiredSuccess\" style=\"position: absolute; top: -15px; width: 24px;\" ng-style=\"{\'left\' : (80 - 6) +\'%\'}\"><img src=\"assets/images/success.svg\" style=\"width: 24px;\"></div><div ng-show=\"blockedSuccess && showBlockedSuccess\" style=\"position: absolute; top: -15px; width: 24px;\" ng-style=\"{\'left\' : (100 - 9) +\'%\'}\"><img src=\"assets/images/success.svg\" style=\"width: 24px;\"></div></div><div layout=\"\" style=\"margin-top: 30px; position: relative;\"><div layout=\"column\" flex=\"\" layout-align=\"center center\"><md-icon class=\"material-icons--two-tone\" ng-class=\"{\'md-primary\' : showCreatedSuccess}\" style=\"margin-bottom: 8px;\">create</md-icon><span ng-class=\"{\'md-caption\' : isSmall,\'grey-text\' : card.status === \'created\'}\">Created</span></div><div flex=\"\" layout=\"column\" layout-align=\"center center\"><md-icon class=\"md-primary material-icons--two-tone\" style=\"margin-bottom: 8px;\">card_membership</md-icon><span ng-class=\"{\'md-caption\' : isSmall,\'grey-text\' : card.status === \'generated\'}\">Generated</span></div><div flex=\"\" layout=\"column\" layout-align=\"center center\"><md-icon class=\"md-primary material-icons--two-tone\" style=\"margin-bottom: 8px;\">room</md-icon><span ng-class=\"{\'md-caption\' : isSmall,\'grey-text\' : card.status === \'activated\'}\">Activated</span></div><div flex=\"\" layout=\"column\" layout-align=\"center center\"><md-icon class=\"md-primary material-icons--two-tone\" style=\"margin-bottom: 8px;\">redeem</md-icon><span ng-class=\"{\'md-caption\' : isSmall,\'grey-text\' : card.status === \'redeemed\'}\">Redeemed</span></div><div flex=\"\" layout=\"column\" layout-align=\"center center\"><md-icon class=\"md-primary material-icons--two-tone\" style=\"margin-bottom: 8px;\">highlight_off</md-icon><span ng-class=\"{\'md-caption\' : isSmall,\'grey-text\' : card.status === \'expired\'}\">Expired</span></div><div flex=\"\" layout=\"column\" layout-align=\"center center\"><md-icon class=\"md-primary material-icons--two-tone\" style=\"margin-bottom: 8px;\">block</md-icon><span ng-class=\"{\'md-caption\' : isSmall,\'grey-text\' : card.status === \'blocked\'}\">Blocked</span></div></div></md-card-content></md-card></div><div layout=\"\" layout-align=\"stretch center\"><div layout=\"\" layout-align=\"center center\" flex=\"50\"><md-card flex=\"50\"><md-card-content><section><h4>User</h4></section><md-divider></md-divider><div layout=\"column\" layout-align=\"stretch center\" class=\"md-padding md-margin\"><div layout=\"\" layout-align=\"start center\"><span class=\"grey-text md-caption\">Name:</span> <span class=\"md-subhead\" style=\"margin-left: 30px;\">{{card.user.name ? card.user.name : \"-\"}}</span></div><div layout=\"\" layout-align=\"start center\"><span class=\"grey-text md-caption\">Mobile:</span> <span class=\"md-subhead\" style=\"margin-left: 30px;\">{{card.user.mobile ? card.user.mobile : \"-\"}}</span></div></div></md-card-content></md-card><md-card flex=\"50\"><md-card-content><section><h4>Agent</h4></section><md-divider></md-divider><div layout=\"column\" layout-align=\"stretch center\" class=\"md-padding md-margin\"><div layout=\"\" layout-align=\"start center\"><span class=\"grey-text md-caption\">Name:</span> <span class=\"md-subhead\" style=\"margin-left: 30px;\">{{card.agent.name ? card.agent.name : \"-\"}}</span></div><div layout=\"\" layout-align=\"start center\"><span class=\"grey-text md-caption\">Mobile:</span> <span class=\"md-subhead\" style=\"margin-left: 30px;\">{{card.agent.mobile ? card.agent.mobile : \"-\"}}</span></div></div></md-card-content></md-card></div><div layout=\"\" layout-align=\"center center\" flex=\"50\"><md-card flex=\"50\"><md-card-content><section><h4>Details</h4></section><md-divider></md-divider><div layout=\"column\" layout-align=\"stretch center\" class=\"md-padding md-margin\"><div layout=\"\" layout-align=\"start center\"><span class=\"grey-text md-caption\">No of Fraud Attempts:</span> <span class=\"md-subhead\" style=\"margin-left: 30px;\">{{card.fraudAttempts.length}}</span></div><div layout=\"\" layout-align=\"start center\"><span class=\"grey-text md-caption\">Expiry Date:</span> <span class=\"md-subhead\" style=\"margin-left: 30px;\">{{card.expiryDate | date }}</span></div></div></md-card-content></md-card><md-card flex=\"50\"><md-card-content><section><h4>Handler</h4></section><md-divider></md-divider><div layout=\"column\" layout-align=\"stretch center\" class=\"md-padding md-margin\"><div layout=\"\" layout-align=\"center center\"><span class=\"md-subhead\">{{card.cachedCaseWorker ? card.cachedCaseWorker : \'Not Set\'}}</span></div><md-button class=\"md-primary small outline\" ng-click=\"selectCaseWorker($event)\" ng-disabled=\"updatingHandler\"><span ng-if=\"!updatingHandler\">{{card.caseWorker ? \'Change\' : \'Select\'}} Handler</span><bubble-loader ng-if=\"updatingHandler\"></bubble-loader></md-button></div></md-card-content></md-card></div></div></md-content></md-tab><md-tab label=\"Fraud Attempts\"><md-content class=\"md-padding\"><div layout=\"\" layout-align=\"start stretch\" layout-wrap=\"\"><section ng-if=\"card.fraudAttempts.length\" layout=\"column\" ng-repeat=\"fraudAttempt in fraudAttempts track by $index\" flex-gt-md=\"25\" flex-xs=\"100\" flex-sm=\"50\" flex-md=\"33\"><md-card flex=\"\"><div layout=\"row\" layout-align=\"space-between center\" ng-if=\"fraudAttempt.processed === false\" style=\"border-bottom: 2px solid red; margin: 0 16px\"><div layout=\"\" layout-align=\"space-between center\" flex=\"\"><div layout=\"\" layout-align=\"center center\"><md-icon>warning</md-icon><h5 style=\"margin-left: 8px;\">Fraud Attempt Detected</h5></div></div></div><div ng-if=\"fraudAttempt.processed === true && !fraudAttempt.blocksCard\" layout=\"\" layout-align=\"center center\"><h5 class=\"green-text\">Resolved</h5></div><div ng-if=\"fraudAttempt.blocksCard\" layout=\"\" layout-align=\"center center\"><h5 class=\"red-text\">Blocked</h5><span class=\"blocked-indicator\"></span></div><md-divider></md-divider><md-card-content><div layout=\"column\" ng-if=\"fraudAttempt.processed === false\" layout-align=\"center stretch\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start start\"><p class=\"md-caption\">User: <span class=\"md-tiny\" flex=\"\">{{fraudAttempt.user.name}}</span></p><p class=\"md-caption\">Description: <span class=\"md-tiny\" flex=\"\">{{fraudAttempt.description}}</span></p><p class=\"md-caption\">Date: <span class=\"md-tiny\" flex=\"\">{{fraudAttempt.date | date : \"medium\"}}</span></p></div></div><md-divider></md-divider></div><div ng-if=\"fraudAttempt.processed === true && !fraudAttempt.blocksCard\" layout=\"\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><p class=\"md-caption\">Resolved By: <span class=\"md-body-1 bold-text\">{{fraudAttempt.resolvedByName}}</span></p><p class=\"md-caption\">Reason: <span class=\"md-body-1 bold-text\">{{fraudAttempt.reasonToResolve}}</span></p><p class=\"md-caption\">Resolved On: <span class=\"md-body-1 bold-text\">{{fraudAttempt.resolvedDate | date}}</span></p><p class=\"md-caption\">Suspicious: <span class=\"md-body-1 bold-text\">{{fraudAttempt.isSuspicious ? \'Yes\' : \'No\'}}</span></p></div></div><div ng-if=\"fraudAttempt.blocksCard\" layout=\"\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><p class=\"md-caption\">Blocked By: <span class=\"md-body-1 bold-text\">{{card.blockedByName}}</span></p><p class=\"md-caption\">Reason: <span class=\"md-body-1 bold-text\">{{card.reasonToBlock}}</span></p><p class=\"md-caption\">Blocked On: <span class=\"md-body-1 bold-text\">{{card.blockDate | date}}</span></p></div></div></md-card-content><md-card-actions ng-if=\"!fraudAttempt.processed && card.status !== \'blocked\'\"><section layout=\"\"><div layout=\"\" layout-align=\"center center\"><md-button ng-disabled=\"card.status === \'blocked\'\" class=\"md-accent green-text small outline\" ng-click=\"updateFraudAttempt(card._id, $index, fraudAttempt ,\'resolve\')\" aria-label=\"Favorite\"><md-tooltip md-direction=\"bottom\"><span>Approve</span></md-tooltip><md-icon class=\"green-text\">check</md-icon><span>Resolve</span></md-button></div><div flex=\"\" layout=\"\" layout-align=\"end center\"><md-button ng-disabled=\"card.status === \'blocked\'\" class=\"md-warn md-raised small\" ng-click=\"updateFraudAttempt(card._id, $index, fraudAttempt, \'block\');\"><span>Block</span></md-button></div></section></md-card-actions></md-card></section><section ng-if=\"!card.fraudAttempts.length\" style=\"width: 100%; height: 50vh\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/blank.svg\" style=\"width: 150px\"><p>No Fraud Attempts Detected Yet!</p></section></div></md-content></md-tab><md-tab label=\"Flags\"><section flex=\"40\"><md-content><md-card><div layout=\"\" layout-align=\"center center\"><h3 class=\"md-title\">Settings</h3></div><md-divider></md-divider><md-card-content><md-list><md-list-item><md-input-container><md-checkbox ng-model=\"card.flags.dispatchToCorporateWarehouse\">Dispatch to Corporate Warehouse</md-checkbox></md-input-container></md-list-item><md-list-item><md-input-container><md-checkbox ng-model=\"card.flags.hideAddressForm\">Hide Address Form</md-checkbox></md-input-container></md-list-item></md-list></md-card-content><md-divider></md-divider><md-card-actions layout=\"\" layout-align=\"end center\"><md-button class=\"md-primary md-raised\" ng-disabled=\"savingFlag\" ng-click=\"updateChanges(card._id)\"><bubble-loader ng-if=\"savingFlag\"></bubble-loader><span ng-if=\"!savingFlag\">Update Flags</span></md-button></md-card-actions></md-card></md-content></section></md-tab><md-tab label=\"Status History\"><md-content class=\"md-padding\"><md-card><md-card-content><section><h4>Status History</h4></section><md-divider></md-divider><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">#</th><th md-column=\"\">Creator</th><th md-column=\"\">Created At</th><th md-column=\"\">Status</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"history in card.statusHistory | orderBy: \'-updatedAt\'\"><td md-cell=\"\">{{$index +1}}.</td><td md-cell=\"\"><span class=\"md-tiny\">{{history.creator.name}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{history.createdAt | date : \"medium\"}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{history.status}}</span></td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content></md-tab><md-tab label=\"Transactions\"><md-content class=\"md-padding\"><md-card><md-card-content><section><h4>Transactions</h4></section><md-divider></md-divider><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">#</th><th md-column=\"\">User</th><th md-column=\"\">Txn Type</th><th md-column=\"\">Txn Id</th><th md-column=\"\">From</th><th md-column=\"\">To</th><th md-column=\"\">Amount</th><th md-column=\"\">Created At</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"transaction in card.transactions | orderBy: \'-createdAt\'\"><td md-cell=\"\">{{$index +1}}.</td><td md-cell=\"\"><span class=\"md-tiny\">{{transaction.user.name}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{transaction.txnType | uppercase}}</span></td><td md-cell=\"\"><span class=\"md-tiny\" ng-click=\"$event.stopPropagation()\">{{transaction.txnId}}<md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-click=\"$event.stopPropagation(); showToast(\'Copied Txn Id to Clipboard\')\" data-clipboard-text=\"{{transaction.txnId}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy Txn Id</md-tooltip></md-button></span></td><td md-cell=\"\"><span class=\"md-tiny\">₹ {{transaction.from}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">₹ {{transaction.to}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">₹ {{transaction.amount}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{transaction.createdAt | date : \"medium\"}}</span></td></tr></tbody></table></md-table-container></md-card-content></md-card></md-content></md-tab></md-tabs><md-card class=\"md-primary card-notes\" md-whiteframe=\"16\"><section ng-click=\"showCardChat = !showCardChat\" class=\"pointer\" layout=\"\" layout-align=\"space-between center\" style=\"padding: 6px\"><div layout=\"\" layout-align=\"center center\"><span><md-icon class=\"md-accent\" style=\"margin-left: 8px\">speaker_notes</md-icon></span> <span class=\"md-body-1 bold-text\" style=\"margin-left: 8px\">Gift Card Notes ({{card.notes ? card.notes.length : 0}})</span></div><md-button class=\"md-icon-button md-primary\"><md-icon>{{showCardChat ? \'keyboard_arrow_down\' : \'keyboard_arrow_up\'}}</md-icon></md-button></section><div ng-show=\"showCardChat\" class=\"relative\"><md-divider></md-divider><md-card-content class=\"message-content-wrapper\"><md-list class=\"md-2-line\" ng-if=\"card.notes && card.notes.length\"><md-list-item ng-repeat-start=\"note in card.notes\" class=\"message-full-wrapper\" ng-class=\"{\'align-left\' : note.by !== currentUser._id, \'align-right\' : note.by === currentUser._id}\"><div class=\"message\" ng-class=\"{\'others\' : note.by !== currentUser._id, \'me\' : note.by === currentUser._id}\" layout=\"column\"><div class=\"message-images-container\" ng-if=\"note.images && note.images.length\" ng-class=\"{\'layout-align-start-center\' : note.by !== currentUser._id, \'layout-align-end-center\' : note.by === currentUser._id}\" layout=\"\"><md-img class=\"message-image\" md-src=\"{{note.images[0].urls.medium}}\" ng-click=\"openImages($event, note.images)\"></md-img></div><p class=\"comment\" mention-text=\"\" comment=\"note.comment\"></p><section layout=\"\" layout-align=\"space-between center\"><span class=\"md-tiny\">By {{note.byName}}</span> <span class=\"md-tiny date grey-text\" ng-if=\"!note.saving && !note.error\">{{dateAgo(note.date) }}</span><md-icon class=\"bug-icon\" ng-if=\"!note.saving && note.error\">bug</md-icon><bubble-loader class=\"save-loader\" ng-if=\"note.saving\"></bubble-loader></section></div></md-list-item><div ng-repeat-end=\"\" class=\"align-clear\"></div></md-list><div layout=\"column\" layout-align=\"center center\" ng-if=\"!card.notes || !card.notes.length\"><img src=\"assets/images/blank.svg\" style=\"width: 100px; height: auto;\"><p>No Comments Yet</p></div></md-card-content><md-divider></md-divider><md-card-actions layout=\"\" layout-align=\"stretch center\" class=\"relative\"><md-input-container class=\"no-error-spacer ui-mention-container\" flex=\"\" md-no-float=\"\"><textarea ui-mention=\"\" aarida-mentions=\"\" rows=\"2\" ng-model=\"message\" placeholder=\"Comment\"></textarea><div class=\"mention-highlight\"></div><md-list class=\"dropdown md-2-line md-whiteframe-1dp\" ng-if=\"$mention.choices.length\"><md-list-item ng-if=\"$mention.loading\"><bubble-loader></bubble-loader></md-list-item><md-list-item ng-repeat-start=\"choice in $mention.choices\" ng-class=\"{active:$mention.activeChoice==choice}\" ng-click=\"$mention.select(choice)\"><div class=\"md-list-item-text\" layout=\"column\"><span class=\"name\">{{::choice.name}}</span> <span class=\"md-caption email\">{{::choice.email}}</span></div></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list></md-input-container><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-icon-button relative\"><md-icon>{{!imageSelected ? \'attach_file\' : \'attachment\'}}</md-icon><image-selector class=\"message-media-selector\" ng-model=\"$parent.imageSelected\"></image-selector></md-button><md-button class=\"md-icon-button md-fab md-mini md-primary\" ng-disabled=\"!message && !imageSelected\" ng-click=\"publishCardNote()\"><md-icon>send</md-icon></md-button></div></md-card-actions><div ng-show=\"imageSelected\" class=\"image-material-box\"><md-img md-src=\"{{ imageSelected.urls.medium }}\" alt=\"{{message}}\"></md-img><md-button class=\"md-icon-button close-material-box-button\" ng-click=\"imageSelected = null\"><md-icon>close</md-icon></md-button></div></div></md-card><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"expiryUpdateDialog\"><md-dialog><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">Update Expiry Date</span><md-button class=\"md-warn md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-progress-linear ng-if=\"savingExpiry\"></md-progress-linear><md-dialog-content class=\"md-dialog-content\"><p class=\"text-center\">Update the expiry date of the Gift Card. Make sure that you understand what you are doing.</p><p class=\"md-padding md-caption text-center\">Select one of the template dates from below or enter a custom date manually :</p><md-radio-group ng-model=\"expiryDate\"><md-list class=\"md-2-line\"><md-list-item ng-repeat=\"template in dateTemplates\"><div class=\"md-list-item-text md-padding\" layout=\"column\"><span>{{template.label}}</span> <span class=\"grey-text\">{{template.value | date : \'fullDate\'}}</span></div><md-radio-button class=\"md-secondary\" ng-value=\"template.value\"></md-radio-button></md-list-item></md-list></md-radio-group><div layout=\"\" layout-align=\"center center\"><md-input-container><label>Select Expiry Date</label><md-datepicker ng-model=\"expiryDate\"></md-datepicker></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"close()\">Close</md-button><md-button class=\"md-primary outline\" ng-disabled=\"savingExpiry\" ng-click=\"updateExpiryDate()\">Save</md-button></md-dialog-actions></md-dialog></div></div>");
$templateCache.put("app/modules/offers/giftCards/home/giftCards.home.html","<div layout=\"\" layout-align=\"center center\"><md-card><md-card_content><md-button class=\"md-icon-button md-primary\"><md-icon>refresh</md-icon></md-button></md-card_content></md-card></div>");
$templateCache.put("app/modules/orders/addOrders/partials/add.html","add products");
$templateCache.put("app/modules/orders/allOrders/partials/all.html","<div layout=\"column\"><div layout=\"\" layout-xs=\"column\" layout-sm=\"column\" layout-align=\"space-between center\"><md-content md-scroll-x=\"\" class=\"scrolling-tabs\"><md-button class=\"custom-tab\" ng-class=\"{\'active\' : query.currentStatus === \'all\'}\" ng-click=\"applyFilter(\'all\')\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator\"></span> <span>All</span></div></md-button><md-button class=\"custom-tab\" ng-class=\"{\'active\' : (query.currentStatus === \'placed\')}\" ng-click=\"applyFilter(\'placed\')\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator pending\"></span> <span>Placed/Approved</span></div></md-button><md-button class=\"custom-tab\" ng-class=\"{\'active\' : query.currentStatus === \'processing\'}\" ng-click=\"applyFilter(\'processing\')\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator staging\"></span> <span>Processing</span></div></md-button><md-button class=\"custom-tab\" ng-class=\"{\'active\' : query.currentStatus === \'packed\'}\" ng-click=\"applyFilter(\'packed\')\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator staging\"></span> <span>Packed</span></div></md-button><md-button class=\"custom-tab\" ng-class=\"{\'active\' : query.currentStatus === \'partially shipped\'}\" ng-click=\"applyFilter(\'partially shipped\')\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator staging\"></span> <span>Partially Shipped</span></div></md-button><md-button class=\"custom-tab\" ng-class=\"{\'active\' : query.currentStatus === \'shipped\'}\" ng-click=\"applyFilter(\'shipped\')\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator staging\"></span> <span>Shipped</span></div></md-button><md-button class=\"custom-tab\" ng-class=\"{\'active\' : query.currentStatus === \'delivered\'}\" ng-click=\"applyFilter(\'delivered\')\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator success\"></span> <span>Delivered</span></div></md-button><md-button class=\"custom-tab\" ng-class=\"{\'active\' : query.currentStatus === \'cancelled\'}\" ng-click=\"applyFilter(\'cancelled\')\"><div layout=\"\" layout-align=\"center center\"><span class=\"dot-indicator error\"></span> <span>Cancelled</span></div></md-button></md-content><span flex=\"\"></span><md-button class=\"md-warn\" ng-click=\"openIncompleteOrderList()\">{{totalIncompleteOrders}} Errored Orders</md-button></div><md-card flex=\"\"><md-toolbar class=\"md-table-toolbar\" ng-class=\"{\'md-tall\' : isSmall}\" ng-if=\"!showSearchBar\" style=\"background: #ebebee\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-wrap=\"\"><section layout=\"\" layout-align=\"start center\" flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"70\"><span class=\"black-text\" ng-if=\"!selected.length\">Orders</span><div layout=\"\" ng-if=\"selected.length\" layout-align=\"center center\"><md-button class=\"md-icon-button\" ng-click=\"clearSelection()\"><md-icon>close</md-icon><md-tooltip>Clear Selection</md-tooltip></md-button><md-button class=\"md-icon-button medium md-primary\" ng-click=\"notify(selected, $event)\"><md-icon>message</md-icon><md-tooltip>Notify Customers</md-tooltip></md-button><md-select ng-model=\"actionModel\" class=\"md-primary\" placeholder=\"Select Action :\" style=\"font-size: 14px;\"><md-option ng-value=\"action.id\" ng-repeat=\"action in actions\">{{ action.title }}</md-option></md-select><md-button class=\"md-raised md-primary small\" ng-click=\"performSmartAction($event, actionModel)\">GO</md-button><md-button class=\"md-warn small outline\" ng-click=\"openIncompleteOrderList($event, selected)\">Cancel {{selected.length}} Orders</md-button></div><form role=\"form\" novalidate=\"\" name=\"filterForm\" flex-offset=\"5\" ng-submit=\"fetchOrders()\" layout=\"\" flex=\"\" layout-align=\"center center\"><md-input-container flex=\"\" class=\"no-error-spacer\" layout=\"\"><label>&nbsp;</label> <input type=\"search\" id=\"giftCardSearch\" ng-model=\"query.search\" select-on-click=\"\" ng-model-options=\"{\'debounce\' : 500}\" ng-change=\"fetchOrders()\" placeholder=\"Search For Orders by Customer Name, Mobile Number, Order Number, Product Name, Product SKU\" class=\"search-bar-input\"></md-input-container><md-button type=\"submit\" ng-click=\"fetchOrders()\" class=\"md-icon-button hide-xs hide-sm\"><md-icon>search</md-icon></md-button></form></section><section layout=\"\" layout-align=\"end center\" flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"30\"><md-button class=\"md-warn small outline\" ng-if=\"hasFilters\" ng-click=\"clearFilters()\">Clear Filters</md-button><md-button class=\"md-icon-button\" ui-sref=\"app.orders.planning\"><md-icon class=\"md-primary\">dynamic_feed</md-icon><md-tooltip>God Mode</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"openOrderFilterDialog($event)\"><md-icon class=\"md-primary\">filter_list</md-icon><attached-tag tag-type=\"dot\" right=\"8px\" top=\"8px\" ng-if=\"hasFilters\"></attached-tag><md-tooltip>Filters</md-tooltip></md-button><md-menu class=\"no-margin\"><md-button ng-click=\"$mdOpenMenu($event)\" aria-label=\"User\" class=\"md-accent md-icon-button\"><md-icon class=\"black-text\">more_vert</md-icon><md-tooltip>Filter Columns</md-tooltip></md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"column in columns\"><md-button md-prevent-menu-close=\"\"><md-checkbox class=\"md-primary\" ng-change=\"changeState()\" ng-model=\"column.model\">{{column.name}}</md-checkbox></md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-icon-button\" ng-click=\"fetchOrders()\"><md-icon class=\"md-primary\">refresh</md-icon><md-tooltip>Refresh Table Data</md-tooltip></md-button><md-button class=\"md-fab md-mini md-primary\" ui-sref=\"app.pos.add\"><md-icon class=\"md-primary\">add</md-icon><md-tooltip>Add New Order</md-tooltip></md-button></section></div></md-toolbar><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[10, 25, 50, 100]\" md-page=\"query.page\" md-total=\"{{total}}\" md-on-paginate=\"fetchOrders\" md-page-select=\"\"></md-table-pagination><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.orderBy\" md-on-reorder=\"reorder\"><tr md-row=\"\" md-colors=\"{\'background\' : \'boring-accent-50-0.1\'}\"><th md-column=\"\">Sl</th><th md-column=\"\"></th><th md-column=\"\" md-order-by=\"{{column.orderBy}}\" ng-repeat=\"column in columns\" ng-show=\"column.model\">{{column.name}}</th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"order\" md-select-id=\"order._id\" md-auto-select=\"\" ng-repeat=\"order in orders\" style=\"height: 75px;\"><td md-cell=\"\">{{ (((query.page - 1) * query.limit) + $index) + 1}}.</td><td md-cell=\"\"><div class=\"percent-display\" ng-if=\"order.saleChannel !== \'pos\'\" ng-mouseover=\"order.hovered = true\" ng-mouseleave=\"order.hovered = false\" ng-class=\"{\'pending\' : order.completedPercent <= 30, \'success\' : order.completedPercent > 75}\"><md-progress-circular ng-if=\"order.completedPercent < 100\" md-diameter=\"40\" md-mode=\"determinate\" value=\"{{order.completedPercent}}\"></md-progress-circular><span class=\"percent\" ng-if=\"order.completedPercent < 100\">{{order.completedPercent}}%</span><md-icon ng-if=\"order.completedPercent >= 100\" class=\"green-text\" ng-class=\"{\'hovered\' : order.hovered}\">check_circle</md-icon><md-tooltip class=\"mega-tooltip\" md-direction=\"right\" style=\"width: 400px\"><h4 class=\"center-text\">Checklist</h4><table md-table=\"\"><tbody md-body=\"\"><tr ng-repeat=\"item in order.checklistItems\"><td md-cell=\"\" class=\"md-tiny\">{{$index + 1}}.</td><td md-cell=\"\" class=\"md-tiny\">{{item.description}}</td><td md-cell=\"\" class=\"md-tiny\">{{item.value ? \'Done\' : \'Pending\'}}</td></tr></tbody></table></md-tooltip></div></td><td md-cell=\"\" ng-repeat=\"column in columns\" ng-show=\"column.model\"><div layout=\"column\" layout-align=\"center start\" ng-if=\"column.value === \'orderNumber\'\"><div layout=\"\"><a class=\"md-caption md-link\" ng-click=\"$event.stopPropagation()\" ui-sref=\"app.orders.details({orderId : order._id, backState: \'app.orders.all\', backParams : backParams})\">{{ order.orderNumber }}</a><md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-click=\"$event.stopPropagation(); showToast(\'Copied Order Number to Clipboard\')\" data-clipboard-text=\"{{order.orderNumber}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy Order Number</md-tooltip></md-button></div><div layout=\"\" class=\"pointer\"><p class=\"relative bold-text\">{{ formatName(order.user.name)}}<md-tooltip md-direction=\"right\" md-auto-hide=\"false\" class=\"mega-tooltip\" style=\"max-width: 200px\"><span ng-bind-html=\"formatAddress(order.cachedAddress)\"></span></md-tooltip></p><md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-click=\"$event.stopPropagation(); showToast(\'Copied User Name to Clipboard\')\" data-clipboard-text=\"{{formatName(order.user.name)}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy User Name</md-tooltip></md-button></div><i class=\"md-tiny red-text\" ng-if=\"order.daysOpen >= 10 && order.status !== \'cancelled\' && order.status !== \'delivered\' && order.status !== \'shipped\' && order.status !== \'parked\'\">Order Open for {{order.daysOpen}} days. Update status now.</i></div><div ng-if=\"column.value === \'address\'\" style=\"padding: 6px 0; max-width: 200px\"><span ng-bind-html=\"formatAddress(order.cachedAddress)\"></span><md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-click=\"$event.stopPropagation(); showToast(\'Copied Address to Clipboard\')\" data-clipboard-text=\"{{formatAddress(order.cachedAddress, true)}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy Address</md-tooltip></md-button></div><div ng-if=\"column.value === \'store\'\"><span>{{order.warehouse ? order.warehouse.name : \'N/A\'}}</span></div><div ng-if=\"column.value === \'productCount\'\" class=\"relative pointer\">{{order.orderData.products.length}}<md-tooltip class=\"mega-tooltip\" md-direction=\"right\" style=\"max-width: 450px\"><h3 class=\"center-text md-subhead\">Products</h3><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"productData in order.orderData.products\"><td md-cell=\"\" class=\"md-tiny\">{{$index + 1}}.</td><td md-cell=\"\" style=\"max-width: 32px\"><md-img style=\"max-width: 32px\" md-src=\"{{productData.product.featured_image.urls.thumbnail}}\"></md-img></td><td md-cell=\"\"><span class=\"md-caption bold-text\" style=\"line-height: 0.85em\">{{productData.product.name}}</span><br><span class=\"md-tiny\">{{productData.product.sku}}</span> <span class=\"md-caption\" ng-if=\"productData.selectedVariationText || productData.product.selectedVariation\">| Size : {{productData.selectedVariationText || productData.product.selectedVariation}}</span></td><td md-cell=\"\" class=\"md-tiny\">{{productData.quantity}}</td><td md-cell=\"\" class=\"md-tiny\">₹{{productData.totalPrice}}</td></tr></tbody></table></md-tooltip></div><p class=\"md-body-2 text-center\" ng-if=\"column.value === \'amount\'\"><span class=\"bold-text\">₹ {{order.amount | number : 0}}</span><br><span ng-if=\"order.giftCardAmount\" class=\"md-tiny grey-text\">₹ {{order.orderData.amount | number : 0}}</span></p><div layout=\"column\" layout-align=\"center center\" ng-if=\"column.value === \'saleChannel\'\"><span class=\"md-body-1 text-uppercase\">{{order.saleChannel ? order.saleChannel : \'WEB\'}}</span> <span class=\"md-tiny grey-text center-text\" ng-if=\"order.organisation\">{{order.organisation.name}}</span></div><div layout=\"\" layout-align=\"start center\" ng-if=\"column.value === \'status\'\"><span class=\"dot-indicator\" ng-class=\"{ \'error\' : order.status ===\'incomplete\' || order.status ===\'parked\' || order.status === \'cancelled\' , \'pending\' : order.status === \'placed\', \'staging\' : [\'approved\', \'processing\', \'returned\', \'partially shipped\', \'shipped\', \'packed\'].includes(order.status), \'success\' : order.status === \'delivered\'}\"></span> <span>{{order.status | uppercase}}</span></div><div layout=\"\" layout-align=\"start center\" ng-if=\"column.value === \'confirmationStatus\'\"><span class=\"dot-indicator\" ng-if=\"order.agent\" ng-class=\"{ \'error\' : order.confirmationStatus.status ===\'on-hold\', \'pending\' : order.confirmationStatus.status === \'pending\', \'staging\' : [\'requested\'].includes(order.confirmationStatus.status), \'success\' : order.confirmationStatus.status === \'approved\'}\"></span> <span ng-if=\"order.agent\">{{order.confirmationStatus.status | uppercase}}</span> <span ng-if=\"!order.agent\">N/A</span></div><span class=\"md-caption\" ng-class=\"{\'grey-text\' : !order.organisation}\" ng-if=\"column.value === \'organisation\'\">{{order.organisation ? order.organisation.name : \'NA\'}}</span> <span class=\"md-caption\" ng-class=\"{\'grey-text\' : !order.designer}\" ng-if=\"column.value === \'designer\'\">{{order.designer ? order.designer.name : \'NA\'}}</span><div ng-class=\"{\'grey-text\' : !order.agent}\" ng-if=\"column.value === \'agent\'\"><div layout=\"\"><span class=\"md-caption\">{{order.agent ? order.agent.name : \'NA\'}}</span><md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-if=\"order.agent\" ng-click=\"$event.stopPropagation(); showToast(\'Copied Agent Name to Clipboard\')\" data-clipboard-text=\"{{order.agent.name}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy Agent Name</md-tooltip></md-button></div><div layout=\"\"><span class=\"md-caption\">{{order.agent ? order.agent.mobile : \'\'}}</span><md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-if=\"order.agent\" ng-click=\"$event.stopPropagation(); showToast(\'Copied Agent Mobile Number to Clipboard\')\" data-clipboard-text=\"{{order.agent.mobile}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy Agent Number</md-tooltip></md-button></div></div><span class=\"md-caption\" ng-if=\"column.value === \'createdAt\'\">{{order.createdAt | date : \"medium\"}}</span> <span class=\"md-caption\" ng-if=\"column.value === \'updatedAt\'\">{{order.updatedAt | date : \"medium\"}}</span><div ng-if=\"column.value === \'isReviewDone\'\"><span class=\"grey-text\" ng-if=\"order.status !== \'delivered\'\">NA</span><md-icon class=\"green-text\" ng-if=\"order.status === \'delivered\' && isReviewDone\">check</md-icon><a class=\"green-text md-tiny\" ng-if=\"order.status === \'delivered\' &&!isReviewDone\">Request Review</a></div><div ng-if=\"column.value === \'daysOpen\'\"><p class=\"md-subhead\">{{order.daysOpen}}</p></div></td><td md-cell=\"\"><md-menu><md-button ng-click=\"$mdOpenMenu($event)\" aria-label=\"User\" class=\"md-primary md-icon-button\"><md-icon class=\"material-icons--two-tone\">more_horiz</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ui-sref=\"app.orders.details({orderId : order._id, backState: \'app.orders.all\', backParams : backParams})\" ng-click=\"$event.stopPropagation();\">View Details</md-button></md-menu-item></md-menu-content></md-menu><md-button ng-if=\"(order.status === \'shipped\' || order.status === \'partially shipped\') && order.awbCode\" target=\"_blank\" class=\"md-primary small outline\" ng-click=\"$event.stopPropagation();\" ng-href=\"{{\'https://tracklite.in/track/\' + order.awbCode}}\">Track Shipment</md-button><md-button ng-if=\"(order.status === \'shipped\' || order.status === \'partially shipped\') && !order.awbCode\" ng-click=\"$event.stopPropagation(); promptAwbDialog($event, order)\" class=\"md-warn small outline\">Add AWB Code</md-button><div layout=\"\" layout-align=\"center center\" ng-if=\"order.confirmationStatus.status === \'pending\'\"><md-button ng-if=\"order.status === \'packed\' && order.agent\" class=\"outline small md-primary\" ng-click=\"openConfirmOrderShipmentDialog($event, order)\">Request Shipment Confirmation</md-button></div></td></tr></tbody><tfoot md-foot=\"\"><tr md-row=\"\"><td md-cell=\"\" colspan=\"4\"><div layout=\"\" layout-align=\"start center\" ng-if=\"totalParkedAmount\"><span class=\"md-caption red-text\">Total value of parked orders in page: <strong>₹{{ totalParkedAmount }}</strong></span></div></td><td md-cell=\"\" colspan=\"{{getActiveColumnsCount() - 1}}\"><div layout=\"\" layout-align=\"end center\"><span class=\"md-subhead\">Total value of orders in page: <strong>₹{{ totalAmount }}</strong></span></div></td><td md-cell=\"\"></td></tr></tfoot></table></md-table-container><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[10, 25, 50, 100]\" md-page=\"query.page\" md-total=\"{{total}}\" md-on-paginate=\"fetchOrders\" md-page-select=\"\"></md-table-pagination></md-card></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"ordersFilterDialog\"><md-dialog aria-label=\"ordersFilterDialog\" flex=\"66\"><form ng-cloak=\"\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout-align=\"space-between center\"><span class=\"md-title\">Filters</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><div class=\"md-dialog-content\" layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"\"><div layout=\"\" class=\"filter-group\"><md-input-container class=\"no-error-spacer md-block\" flex=\"30\"><label>Select Date Range</label><md-select ng-model=\"queryParams.rangeModel\" ng-change=\"updateDateFilter()\"><md-optgroup label=\"{{modelGroup.name}}\" ng-repeat=\"modelGroup in rangeModels\"><md-option ng-repeat=\"model in modelGroup.models\" ng-value=\"model.value\">{{model.title}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"no-error-spacer md-block\" flex=\"\"><label>Select Order Start Date</label> <input mdc-datetime-picker=\"\" date=\"true\" time=\"false\" type=\"text\" id=\"startDate\" short-time=\"true\" show-todays-date=\"\" click-outside-to-close=\"true\" ng-click=\"queryParams.rangeModel = \'custom\'\" placeholder=\"Select Order Start Date\" auto-ok=\"true\" format=\"DD-MM-YYYY\" show-icon=\"true\" show-clear=\"true\" ng-model=\"queryParams.startDate\"></md-input-container><md-input-container class=\"no-error-spacer md-block\" flex=\"\"><label>Select Order End Date</label> <input mdc-datetime-picker=\"\" date=\"true\" time=\"false\" type=\"text\" id=\"endDate\" short-time=\"true\" ng-click=\"queryParams.rangeModel = \'custom\'\" show-todays-date=\"\" click-outside-to-close=\"true\" placeholder=\"Select Order End Date\" auto-ok=\"true\" format=\"DD-MM-YYYY\" show-icon=\"true\" show-clear=\"true\" ng-model=\"queryParams.endDate\"></md-input-container></div><div layout=\"\" class=\"filter-group\"><md-input-container class=\"no-error-spacer md-block\" flex=\"\"><md-select ng-model=\"queryParams.filterOrgs\" multiple=\"\" placeholder=\"Organisation\"><md-button layout-fill=\"\" value=\"all\" ng-click=\"selectAll(queryParams.filterOrgs, orgs)\"><md-icon class=\"material-icons--two-tone\">select_all</md-icon>Select all</md-button><md-option ng-value=\"organisation._id\" ng-repeat=\"organisation in orgs\">{{organisation.name}}</md-option></md-select></md-input-container><md-input-container class=\"no-error-spacer md-block\" flex=\"\" flex-offset=\"5\"><md-select ng-model=\"queryParams.filterChannels\" multiple=\"\" placeholder=\"Sale Channels\"><md-button layout-fill=\"\" value=\"all\" ng-click=\"selectAll(queryParams.filterChannels, orgs)\"><md-icon class=\"material-icons--two-tone\">select_all</md-icon>Select all</md-button><md-option value=\"pos\">POS</md-option><md-option value=\"website\">WEBSITE</md-option></md-select></md-input-container><md-input-container class=\"no-error-spacer md-block\" flex=\"\" flex-offset=\"5\"><md-select ng-model=\"queryParams.filterWarehouses\" multiple=\"\" placeholder=\"Store\"><md-button layout-fill=\"\" value=\"all\" ng-click=\"selectAll(queryParams.filterWarehouses, warehouses)\"><md-icon class=\"material-icons--two-tone\">select_all</md-icon>Select all</md-button><md-option ng-value=\"warehouse._id\" ng-repeat=\"warehouse in warehouses\">{{warehouse.name}}</md-option></md-select></md-input-container></div><div class=\"filter-group\"><h4>Filter By Designer</h4><md-chips ng-model=\"queryParams.filterDesigners\" md-autocomplete-snap=\"\" md-transform-chip=\"transformChip($chip)\" md-require-match=\"true\" input-aria-label=\"Favorite Users\" class=\"md-block full-width\"><md-autocomplete md-selected-item=\"selectedItem\" md-search-text=\"designerSearch\" md-items=\"item in queryUsers(designerSearch, \'admin,designer\')\" md-item-text=\"item.name\" input-aria-describedby=\"autocompleteTitle\" placeholder=\"Search for a designer\"><md-item-template><span class=\"md-caption\" md-highlight-text=\"designerSearch\">{{item.name}}</span> <span class=\"grey-text md-caption\" md-highlight-text=\"designerSearch\">:{{item.mobile}}</span> <span class=\"grey-text md-caption\" md-highlight-text=\"designerSearch\">({{item.role}})</span></md-item-template></md-autocomplete><md-chip-template><p><span class=\"md-caption\">{{$chip.name}}</span> <span class=\"md-tiny\">({{$chip.mobile}})</span></p></md-chip-template></md-chips></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><span flex=\"\"></span><md-button ng-click=\"parseFilters()\">Apply Filters</md-button></md-dialog-actions></form></md-dialog></div></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"copyOrderDataDialog\"><md-dialog aria-label=\"copyOrderDataDialog\" flex=\"66\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout-align=\"space-between center\"><span class=\"md-title\">Copy Order Data</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><p class=\"center-text\">Preview Your Data here</p><pre>{{copyText}}</pre></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-primary\" data-clipboard-text=\"{{copyText}}\" ngclipboard=\"\" ng-click=\"cancel(); showToast(\'Copied Order Data to Clipboard\')\">Copy to Clipboard</md-button></md-dialog-actions></md-dialog></div></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"orgBillingDialog\"><md-dialog aria-label=\"orgBillingDialog\" flex=\"66\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout-align=\"space-between center\"><span class=\"md-title\">Generate Bill</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><form name=\"billForm\"><p class=\"center-text\">Generate Bill for Organisation</p><div layout=\"\" layout-align=\"center center\"><md-input-container class=\"no-error-spacer\"><label>Select Organisation</label><md-select ng-model=\"newBill.organisation\" required=\"\" ng-change=\"detectIssues()\"><md-option ng-repeat=\"org in orgs\" ng-value=\"org._id\">{{org.name}}</md-option></md-select></md-input-container><md-input-container class=\"no-error-spacer\"><label>Overall Discount Percent</label> <input type=\"number\" min=\"0\" max=\"100\" ng-model=\"globalDiscountPercent\" ng-change=\"updateDiscounts()\"></md-input-container></div><section class=\"order-bill-list\"><div layout=\"\" ng-repeat=\"lineItem in newBill.lineItems\" class=\"order-bill-list-item\"><div layout=\"column\"><md-input-container class=\"no-error-spacer\"><label>Description</label> <input type=\"text\" required=\"\" ng-model=\"lineItem.description\"></md-input-container><span ng-if=\"lineItem.issue\" class=\"red-text md-tiny\">{{lineItem.issue}}</span></div><span flex=\"\"></span><div layout=\"\" layout-align=\"start center\"><p class=\"md-title\" style=\"margin-right: 16px\">₹{{lineItem.price}}</p><md-input-container class=\"no-error-spacer\"><label>Discount Percent</label> <input type=\"number\" ng-change=\"updateLineItem(lineItem)\" required=\"\" ng-model=\"lineItem.discountPercent\"></md-input-container></div><span flex=\"\"></span><h3>₹{{lineItem.totalPrice}}</h3><div layout=\"\" flex=\"5\" layout-align=\"end center\"><md-button ng-if=\"lineItem.issue\" class=\"md-warn md-icon-button\" ng-click=\"removeLineItem($index)\"><md-icon>delete</md-icon><md-tooltip>Remove Line Item</md-tooltip></md-button></div></div><div layout=\"\" layout-align=\"end center\"><span class=\"md-subhead\">Total Price :</span> <span class=\"md-title\">₹ {{newBill.amount}}</span></div></section><h4 class=\"md-title center-text\">Description</h4><md-input-container flex=\"\" class=\"md-block\"><label>Description for the Bill</label> <textarea ng-model=\"newBill.description\" rows=\"2\" required=\"\"></textarea></md-input-container></form></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-primary\" ng-disabled=\"generatingBill || billForm.$invalid\" ng-click=\"generateOrgBill()\"><bubble-loader ng-if=\"generatingBill\"></bubble-loader><span ng-if=\"!generatingBill\">Generate</span></md-button></md-dialog-actions></md-dialog></div></div>");
$templateCache.put("app/modules/orders/allOrders/partials/incomplete-orders-dialog.html","<md-dialog aria-label=\"cancel order dialog\" flex=\"60\" flex-xs=\"90\" flex-sm=\"80\" flex-md=\"60\" flex-lg=\"40\" flex-xl=\"35\" class=\"order-incomplete-dialog\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">{{isIncomplete ? \'Incomplete\' : \'\'}} Orders ({{totalIncompleteOrders}})</span><md-button class=\"md-icon-button\" ng-click=\"close();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content\"><md-table-container><table md-table=\"\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.orderBy\" md-on-reorder=\"reorder\"><tr md-row=\"\" md-colors=\"{\'background\' : \'boring-accent-50-0.1\'}\"><th md-column=\"\">Sl</th><th md-column=\"\" md-order-by=\"orderNumber\">Order Number</th><th md-column=\"\" md-order-by=\"orderData.amount\"><span>Total (Rs.)</span></th><th md-column=\"\" md-order-by=\"createdAt\" md-numeric=\"\"><span>Order Date</span></th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"order in incompleteOrders\" style=\"height: 75px;\"><td md-cell=\"\">{{ (((query.page - 1) * query.limit) + $index) + 1}}.</td><td md-cell=\"\"><div layout=\"column\" layout-align=\"center center\"><p class=\"md-caption\">{{ order.orderNumber }}</p><p class=\"md-caption grey-text\">{{ formatName(order.user.name)}}</p></div></td><td md-cell=\"\"><div layout=\"column\" layout-align=\"start start\"><span class=\"md-body-2 bold-text\">Rs. {{order.amount | number : 0}}</span> <span class=\"grey-text md-tiny\" ng-if=\"order.giftCardAmount\">Gift Card : Rs. {{order.giftCardAmount}}</span> <span class=\"grey-text md-tiny\" ng-if=\"order.orderData.creditDiscount\">Credit : Rs. {{order.orderData.creditDiscount}}</span></div></td><td md-cell=\"\" md-numeric=\"\"><span class=\"md-caption\">{{order.createdAt | date : \"medium\"}}</span></td><td md-cell=\"\"><md-button ng-if=\"!order.cancelled\" class=\"md-warn outline\" ng-click=\"cancelOrder(ev, order, $index)\" ng-disabled=\"order.cancelling\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!order.cancelling\">Cancel Order</span><md-progress-circular ng-if=\"order.cancelling\" md-diameter=\"20\"></md-progress-circular></div></md-button><span class=\"green-text\" ng-if=\"order.cancelled\">Cancelled</span></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[10, 25, 50, 100]\" md-page=\"query.page\" md-total=\"{{totalIncompleteOrders}}\" md-on-paginate=\"fetchIncompleteOrders\" md-page-select=\"\"></md-table-pagination></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/orders/orderDetails/lineItem-history-dialog/lineItem-history.tmpl.html","<md-dialog flex=\"50\" class=\"lineitem-history\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">Updates</span><md-button class=\"md-icon-button\" ng-click=\"close();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-content class=\"md-dialog-content\"><md-list class=\"md-3-line\"><md-list-item class=\"txn-item\" ng-repeat=\"update in lineItem.updates | orderBy: \'-date\'\"><div class=\"md-list-item-text\" layout=\"column\"><p>{{update.description}}</p><p class=\"md-caption grey-text\">At: <span class=\"black-text\">{{update.date | date: \'medium\'}}</span></p><p class=\"md-caption grey-text\">By <span class=\"black-text\">{{update.updaterName}}</span></p></div><p class=\"md-caption md-secondary\" ng-if=\"update.status\"><span class=\"black-text\">{{update.status | uppercase}}</span></p></md-list-item></md-list></md-content></md-dialog>");
$templateCache.put("app/modules/orders/orderDetails/order-payments-dialog/order-payments-dialog.html","<md-dialog flex=\"70\" class=\"update-order-payment-dialog\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h5>Update Order Payments</h5><md-button class=\"md-icon-button\" ng-click=\"cancel();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><md-list class=\"md-1-line\" layout=\"column\" layout-align=\"stretch center\"><md-list-item ng-repeat=\"payment in capturedPayments\" md-whiteframe=\"1\" class=\"update-payment-dialog-list-container\"><md-input-container flex=\"40\"><label>Card Amount</label> <input type=\"number\" ng-change=\"reCalculateTotalAmount(payment.cardAmount, \'card\', $index)\" ng-model=\"payment.cardAmount\" aria-label=\"Card Amount\" min=\"0\" class=\"md-accent\"></md-input-container><md-input-container flex=\"40\"><label>Cash Amount</label> <input type=\"number\" ng-change=\"reCalculateTotalAmount(payment.cashAmount, \'cash\', $index)\" ng-model=\"payment.cashAmount\" min=\"0\" aria-label=\"Cash Amount\" class=\"md-accent\"></md-input-container><md-input-container flex=\"40\"><label>Payment Date</label> <input type=\"text\" ng-model=\"payment.createdAt\" aria-label=\"Payment Date\" class=\"md-accent\" disabled=\"\"></md-input-container><div layout=\"column\" layout-align=\"center center\" flex=\"40\"><div layout=\"\" layout-align=\"center center\"><span class=\"md-caption\">{{payment.createdBy ? payment.createdBy : \'Not Set\'}}</span></div><md-button class=\"md-primary small outline\" ng-click=\"changePaymentPerson($event, $index)\" ng-disabled=\"updatingPaymentPerson\"><span ng-if=\"!updatingPaymentPerson\" class=\"md-tiny\">{{payment.createdBy ? \'Change\' : \'Select\'}} Payment Person</span><bubble-loader ng-if=\"updatingPaymentPerson\"></bubble-loader></md-button></div><md-button ng-if=\"!updatedCapturedPayment\" class=\"md-primary small outline\" ng-click=\"updateCapturedPayment($event, $index)\" ng-disabled=\"updatingCapturedPayment\"><span ng-if=\"!updatingCapturedPayment\" class=\"md-tiny\">Update</span><bubble-loader ng-if=\"updatingCapturedPayment\"></bubble-loader></md-button><md-button ng-if=\"updatedCapturedPayment\" class=\"md-primary small outline\" ng-disabled=\"updatedCapturedPayment\"><span class=\"md-tiny green-text\">UPDATED</span></md-button></md-list-item></md-list><md-card><md-card-content><div layout=\"\" layout-align=\"center center\" class=\"order-payment-form-container\"><form name=\"orderPaymentsForm\" layout=\"\" layout-wrap=\"\"><md-input-container flex=\"40\"><label>Total Paid Amount</label> <input type=\"number\" ng-model=\"paymentDetails.totalPaidAmount\"></md-input-container><md-input-container flex=\"40\" flex-offset=\"10\"><label>Pending Amount</label> <input type=\"number\" ng-model=\"paymentDetails.totalPendingAmount\"></md-input-container><md-input-container flex=\"40\"><label>Payment Mode</label><md-select ng-model=\"paymentMode\"><md-option value=\"\">Select Mode</md-option><md-option value=\"1\">COD</md-option><md-option value=\"2\">InstaMojo</md-option><md-option value=\"3\">PayUMoney</md-option><md-option value=\"4\">PayTm</md-option><md-option value=\"5\">Freecharge</md-option><md-option value=\"6\">MobiKwik</md-option><md-option value=\"7\">Debit/Credit Card</md-option><md-option value=\"8\">Gift Card</md-option><md-option value=\"9\">Buy Now Pay Later</md-option><md-option value=\"10\">Cash</md-option><md-option value=\"11\">CashAndCard</md-option></md-select></md-input-container><md-input-container flex=\"40\" flex-offset=\"10\"><md-checkbox ng-model=\"paymentDetails.hasPendingAmount\">Pending Amount</md-checkbox></md-input-container></form></div></md-card-content><md-divider></md-divider><md-card-actions layout=\"\" layout-align=\"end center\"><md-button ng-click=\"updateOrderLevelPaymentDetails()\" class=\"medium md-raised md-primary\" ng-disabled=\"updatingOrderPaymentDetails\"><span ng-if=\"!updatingOrderPaymentDetails\">Save</span><bubble-loader ng-if=\"updatingOrderPaymentDetails\"></bubble-loader></md-button></md-card-actions></md-card></md-dialog-content><md-divider></md-divider><md-dialog-actions layout=\"\" layout-align=\"end center\"><md-button class=\"outline medium\" ng-click=\"updateParentPage()\">Okay</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/orders/orderDetails/partials/index.html","<div layout=\"column\"><md-card style=\"border-bottom: 5px solid;\" ng-style=\"{\'border-color\' : getColor(order.status)}\"><md-card-content layout-gt-sm=\"row\" layout-sm=\"column\" layout-xs=\"column\" layout-align=\"center center\"><div flex=\"100\" flex-gt-sm=\"25\" layout=\"column\" layout-align-gt-sm=\"start center\" layout-align=\"center center\" layout-padding=\"\"><span class=\"grey-text md-caption\" style=\"text-transform: uppercase;\">Order Number</span> <span class=\"md-subhead\" style=\"font-weight: 600;\">{{order.orderNumber}}</span></div><div flex=\"100\" flex-gt-sm=\"25\" layout=\"column\" layout-align-gt-sm=\"start center\" layout-align=\"center center\" layout-padding=\"\"><span class=\"grey-text md-caption\" style=\"text-transform: uppercase;\">Total Value</span> <span class=\"md-subhead\" style=\"font-weight: 600;\">Rs. {{order.amount}}</span></div><div flex=\"100\" flex-gt-sm=\"25\" layout=\"column\" layout-align-gt-sm=\"start center\" layout-align=\"center center\" layout-padding=\"\"><span class=\"grey-text md-caption\" style=\"text-transform: uppercase;\">Payment Method</span> <span class=\"md-subhead\" style=\"font-weight: 600;\">{{getPMString(order.paymentMode);}}</span></div><div flex=\"100\" flex-gt-sm=\"25\" layout=\"column\" layout-align-gt-sm=\"start center\" layout-align=\"center center\" layout-padding=\"\"><span class=\"grey-text md-caption\" style=\"text-transform: uppercase;\">Order Date</span> <span class=\"md-subhead\" style=\"font-weight: 600;\">{{order.createdAt | date :\'medium\'}}</span></div></md-card-content></md-card><md-card class=\"md-padding\" ng-if=\"order.status !== \'cancelled\' || order.status !== \'returned\'\"><md-card-content layout=\"column\"><md-progress-linear class=\"md-accent\" md-mode=\"determinate\" ng-value=\"orderStatusValue\"></md-progress-linear><div layout=\"\" class=\"relative\"><div ng-show=\"placedSuccess && showPlacedSuccess\" style=\"position: absolute; top: -15px; width: 24px;\" ng-style=\"{\'left\' : 0 +\'%\'}\"><img src=\"/assets/images/success.svg\" style=\"width: 24px;\"></div><div ng-show=\"approvedSuccess && showApprovedSuccess\" style=\"position: absolute; top: -15px; width: 24px;\" ng-style=\"{\'left\' : (30 - 1) +\'%\'}\"><img src=\"assets/images/success.svg\" style=\"width: 24px;\"></div><div ng-show=\"packedSuccess && showPackedSuccess\" style=\"position: absolute; top: -15px; width: 24px;\" ng-style=\"{\'left\' : (50 - 1) +\'%\'}\"><img src=\"assets/images/success.svg\" style=\"width: 24px;\"></div><div ng-show=\"shippedSuccess && showShippedSuccess\" style=\"position: absolute; top: -15px; width: 24px;\" ng-style=\"{\'left\' : (70 - 1) +\'%\'}\"><img src=\"assets/images/success.svg\" style=\"width: 24px;\"></div><div ng-show=\"deliveredSuccess && showDeliveredSuccess\" style=\"position: absolute; top: -15px; width: 24px;\" ng-style=\"{\'left\' : (100 - 1) +\'%\'}\"><img src=\"assets/images/success.svg\" style=\"width: 24px;\"></div></div><div layout=\"\" style=\"margin-top: 30px; position: relative;\"><div layout=\"column\" flex=\"\" layout-align=\"center start\"><img src=\"assets/images/places.svg\" style=\"width: 24px; margin-left: 10px; margin-bottom: 8px;\"> <span ng-class=\"{\'md-caption\' : isSmall,\'grey-text\' : order.status === \'cancelled\'|| order.status ===\'returned\'}\">Placed</span></div><div flex=\"\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/approve.svg\" style=\"width: 24px; margin-left: 10px; margin-bottom: 8px;\"> <span ng-class=\"{\'md-caption\' : isSmall,\'grey-text\' : order.status === \'cancelled\'|| order.status ===\'returned\'}\">Approved</span></div><div flex=\"\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/export.svg\" style=\"width: 24px; margin-left: 10px; margin-bottom: 8px;\"> <span ng-class=\"{\'md-caption\' : isSmall,\'grey-text\' : order.status === \'cancelled\'|| order.status ===\'returned\'}\">Packed</span></div><div flex=\"\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/route.svg\" style=\"width: 24px; margin-left: 10px; margin-bottom: 8px;\"> <span ng-class=\"{\'md-caption\' : isSmall,\'grey-text\' : order.status === \'cancelled\'|| order.status ===\'returned\'}\">{{order.status === \'partially shipped\' ? \'Partially Shipped\' : \'Shipped\'}}</span></div><div flex=\"\" layout=\"column\" layout-align=\"center end\"><img src=\"assets/images/truck-delivering.svg\" style=\"width: 24px; margin-right: 12px; margin-bottom: 8px;\"> <span ng-class=\"{\'md-caption\' : isSmall,\'grey-text\' : order.status === \'cancelled\'|| order.status ===\'returned\'}\">Delivered</span></div></div></md-card-content></md-card><div layout-gt-sm=\"row\" layout-sm=\"column\" layout-xs=\"column\"><div flex=\"100\" flex-gt-sm=\"70\" layout=\"column\"><section layout-gt-sm=\"row\" layout-xs=\"column\" layout-sm=\"column\" layout-align=\"center\"><md-card flex=\"\"><section layout=\"\" layout-align=\"space-between center\"><h4 class=\"grey-text\" style=\"margin-left: 16px\">Shipping Address</h4><md-button class=\"md-primary outline small\" ng-click=\"openAddressSelectorDialog($event)\"><span class=\"md-caption\">Change Address</span></md-button></section><md-divider></md-divider><md-card-content><div style=\"margin-left: 10%;\" ng-bind-html=\"formatAddress(order.cachedAddress)\"></div></md-card-content><div ng-if=\"isNewAddress\" layout=\"\" layout-align=\"end center\"><md-button class=\"md-primary md-raised small\" ng-disabled=\"savingAddress || updatingOrgDetails\" ng-click=\"saveNewAddress(order._id, order.cachedAddress)\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!savingAddress\">Save</span><bubble-loader ng-if=\"savingAddress\"></bubble-loader></div></md-button></div></md-card><md-card flex=\"\"><div layout=\"row\" layout-align=\"space-between center\"><h4 class=\"grey-text\" style=\"margin-left: 16px\">User</h4></div><md-divider></md-divider><md-list><md-list-item><span class=\"center-text md-caption grey-text\">NAME</span> <span class=\"center-text md-caption md-secondary\">{{order.user.name}}</span></md-list-item><md-list-item><span class=\"center-text md-caption grey-text\">EMAIL</span> <span class=\"center-text md-caption md-secondary\">{{order.user.email}}</span></md-list-item><md-list-item><span class=\"center-text md-caption grey-text\">MOBILE</span> <span class=\"center-text md-caption md-secondary\">{{order.user.mobile}}</span></md-list-item></md-list></md-card></section><md-card><div layout=\"\" layout-align=\"space-between center\" flex=\"\"><h4 class=\"grey-text\" style=\"margin-left: 16px\">Products</h4><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-primary small\" ng-click=\"viewStockUpdates($event)\"><span>View Stock Updates</span></md-button><md-button class=\"md-primary small\" ui-sref=\"app.products.all({productIds: productIds})\"><span>View In Products</span></md-button><md-button class=\"md-primary small\" ng-if=\"order.lineItems && order.lineItems.length\" ng-click=\"openPackageGroupManager($event)\"><span>{{order.shipments && order.shipments.length ? \'Manage Shipments\' : \'Create Shipment\'}}</span></md-button></div></div><md-divider></md-divider><md-table-container ng-if=\"!order.lineItems.length\"><table md-table=\"\" md-progress=\"promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\">Product</th><th md-column=\"\" md-numeric=\"\">Rating</th><th md-column=\"\" md-numeric=\"\">Size</th><th md-column=\"\" md-numeric=\"\">Qty.</th><th md-column=\"\" md-numeric=\"\">Total</th><th md-column=\"\" md-numeric=\"\">Status</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"productData in order.orderData.products track by $index\" style=\"min-height: 75px; padding: 8px 0\"><td md-cell=\"\"><md-img md-src=\"{{ productData.product.featured_image.urls.thumbnail }}\" alt=\"{{productData.product.name}}\" class=\"pointer\" ng-click=\"quickView($event, productData.product._id)\" style=\"width: 50px; height: auto; margin: 5px;\"></md-img></td><td md-cell=\"\"><div layout=\"column\"><div layout=\"\"><a ng-href=\"{{frontEndUrl + \'/product/\' + productData.product.slug}}\" target=\"_blank\" class=\"green-text pointer\">{{ capitalize(productData.product.name)}}</a><md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-click=\"$event.stopPropagation(); showToast(\'Copied Product Name to Clipboard\')\" data-clipboard-text=\"{{capitalize(productData.product.name)}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy Product Name</md-tooltip></md-button></div><div layout=\"\" layout-align=\"start center\"><span class=\"md-caption grey-text\">{{productData.product.sku}}</span><md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-click=\"$event.stopPropagation(); showToast(\'Copied Product SKU to Clipboard\')\" data-clipboard-text=\"{{productData.product.sku}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy Product SKU</md-tooltip></md-button></div><a class=\"md-primary pointer\" ng-if=\"productData.measurements || productData.variation.measurements\" ng-click=\"viewMeasurementsDialogs($event, productData)\">View Measurements</a></div></td><td md-cell=\"\"><a class=\"green-text pointer\" ng-if=\"productData.ratingValue\" ng-click=\"openReviewListDialog($event, [productData])\">{{productData.rating}}</a> <span ng-if=\"!productData.ratingValue\">-</span></td><td md-cell=\"\">{{productData.variation && productData.variation.attributes.length > 0 ? getVariationValue(productData) : \"-\"}}</td><td md-cell=\"\">{{ productData.quantity }}</td><td md-cell=\"\"><div layout=\"column\" layout-align=\"center end\">{{ productData.totalPrice }}<strike class=\"red-text md-tiny\" ng-if=\"productData.product.mrp\">Rs.{{ productData.product.mrp }}</strike><span class=\"bold-text md-caption\">Rs.{{ productData.price }}</span> <span class=\"green-text md-tiny\" ng-if=\"productData.product.discountValue\">{{ productData.product.discountValue }} %</span></div></td><td md-cell=\"\"><md-select ng-change=\"updateLineItemStatus(lineItem, lineItem.status)\" ng-model=\"lineItem.status\" class=\"md-accent md-hue-1\"><md-option ng-repeat=\"status in lineItemStatus\" ng-value=\"status\">{{status | uppercase}}</md-option></md-select></td><td md-cell=\"\"><md-button class=\"md-icon-button\" target=\"_blank\" ui-sref=\"app.products.add.home({slug : productData.product._id, name : productData.product.name, newProduct : false})\"><md-icon>edit</md-icon><md-tooltip>Edit Product in New Tab</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"showCustomisation(productData, $event);\" ng-if=\"productData.product.productType === 1 && productData.ucData\"><md-icon>rate_review</md-icon><md-tooltip>View Customisation</md-tooltip></md-button></td></tr></tbody></table></md-table-container><md-table-container ng-if=\"order.lineItems && order.lineItems.length\"><table md-table=\"\" md-progress=\"promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\">Product</th><th md-column=\"\" md-numeric=\"\">Size : Qty : Total</th><th md-column=\"\">Tasks</th><th md-column=\"\" md-numeric=\"\">Status</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"lineItem in order.lineItems track by $index\" style=\"min-height: 75px; padding: 8px 0\"><td md-cell=\"\"><md-img md-src=\"{{ lineItem.image.urls.thumbnail }}\" alt=\"{{lineItem.name}}\" class=\"pointer\" ng-click=\"lineItem.isACustomMadeProduct ? showLineItemDetails(lineItem, $event) : quickView($event, lineItem.productId)\" style=\"width: 50px; height: auto; margin: 5px;\"></md-img></td><td md-cell=\"\"><div layout=\"column\"><div layout=\"\"><a ng-href=\"{{lineItem.isACustomMadeProduct ? frontEndUrl : frontEndUrl + \'/product/\' + lineItem.slug}}\" target=\"_blank\" class=\"green-text pointer\">{{ capitalize(lineItem.name)}}</a><md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-click=\"$event.stopPropagation(); showToast(\'Copied Product Name to Clipboard\')\" data-clipboard-text=\"{{capitalize(lineItem.name)}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy Product Name</md-tooltip></md-button></div><div layout=\"\" layout-align=\"start center\"><span class=\"md-caption grey-text\">{{lineItem.sku}}</span><md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-click=\"$event.stopPropagation(); showToast(\'Copied Product SKU to Clipboard\')\" data-clipboard-text=\"{{lineItem.sku}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy Product SKU</md-tooltip></md-button></div><a class=\"md-primary pointer\" ng-if=\"lineItem.measurements\" ng-click=\"viewMeasurementsDialogs($event, lineItem)\">View Measurements</a></div></td><td md-cell=\"\"><span>{{lineItem.selectedVariationText}}</span> : <span>{{ lineItem.quantity }}</span> : <span style=\"white-space: nowrap;\">₹ {{ lineItem.totalPrice }}</span></td><td md-cell=\"\"><section layout=\"\" layout-align=\"center center\"><a class=\"md-link pointer\" ng-click=\"manageTasksDialog($event, lineItem, $index)\">{{lineItem.tasks ? lineItem.tasks.length : 0}}</a> <a style=\"margin-left: 8px\" class=\"md-link pointer md-caption\" ng-click=\"manageTasksDialog($event, lineItem, $index)\">Add</a></section></td><td md-cell=\"\"><md-select ng-change=\"updateLineItemStatus(lineItem, lineItem.status)\" ng-model=\"lineItem.status\" class=\"md-accent md-hue-1\"><md-option ng-repeat=\"status in lineItemStatus\" ng-value=\"status\">{{status | uppercase}}</md-option></md-select></td><td md-cell=\"\"><div layout=\"\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"center center\" ng-if=\"lineItem.manageStock && !lineItem.isStockDeducted && lineItem.status === \'placed\' && !lineItem.isACustomMadeProduct\"><md-button class=\"md-primary small outline\" ng-click=\"updateStock($event, lineItem)\">Update Stock</md-button></div><div layout=\"\" layout-align=\"center center\" ng-if=\"lineItem.isStockDeducted && lineItem.status === \'placed\' && !lineItem.isACustomMadeProduct\"><span class=\"md-tiny green-text\">Stock Updated</span></div><div layout=\"\" layout-align=\"center center\" ng-if=\"!lineItem.manageStock && !lineItem.isACustomMadeProduct\"><span class=\"md-tiny green-text\">Stock Management Not Required</span></div><div layout=\"\" layout-align=\"center center\" ng-if=\"order.saleChannel !== \'pos\'&& (lineItem.status === \'placed\'|| lineItem.status === \'enqueued\' || lineItem.status === \'cutting\' ||lineItem.status === \'stitching\' || lineItem.status === \'qualityChecked\' ||lineItem.status === \'packed\' || lineItem.status === \'cutting\' ||lineItem.status === \'cutting\')\"><md-input-container><label>Select Warehouse</label><md-select ng-change=\"updateLineItemWarehouse(lineItem, $index)\" ng-model=\"lineItem.warehouse\" class=\"md-accent md-hue-1\"><md-option ng-repeat=\"warehouse in warehouses\" ng-value=\"warehouse._id\">{{warehouse.name | uppercase}}</md-option></md-select></md-input-container></div><div layout=\"\" layout-align=\"center center\" ng-if=\"lineItem.status === \'shipped\' && !lineItem.awbCode && !lineItem.shipment\"><md-button class=\"md-primary small outline\" ng-click=\"showAwbDialog($event, lineItem, $index);\"><span class=\"md-caption\">Set AWB</span></md-button></div><div layout=\"\" layout-align=\"center center\" ng-if=\"lineItem.status === \'shipped\' && !lineItem.awbCode && lineItem.shipment\"><md-button class=\"md-primary small outline\" ng-disabled=\"lineItem.syncingAwb\" ng-click=\"syncAwb($event, lineItem, $index);\"><span class=\"md-caption\" ng-if=\"!lineItem.syncingAwb\">Sync AWB</span><bubble-loader ng-if=\"lineItem.syncingAwb\"></bubble-loader></md-button></div><div layout=\"\" layout-align=\"center center\" ng-if=\"lineItem.status ===\'shipped\' && lineItem.awbCode\"><md-button class=\"md-primary small\" ng-disabled=\"!lineItem.awbCode\" target=\"_blank\" ng-href=\"{{getTrackingUrl(lineItem.shipment, lineItem.awbCode)}}\"><md-icon>location_on</md-icon><span class=\"bold-text\">Track</span></md-button></div><md-menu><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon>more_vert</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item ng-if=\"!lineItem.isACustomMadeProduct\"><md-button target=\"_blank\" ui-sref=\"app.products.add.home({slug : lineItem.productId, name : lineItem.name, newProduct : false})\">Edit<md-tooltip>Edit Product in New Tab</md-tooltip></md-button></md-menu-item><md-menu-item ng-if=\"lineItem.productType === 1 && !lineItem.isACustomMadeProduct\"><md-button ng-click=\"showCustomisation(lineItem, $event);\">View Customisation</md-button></md-menu-item><md-menu-item><md-button ng-click=\"showHistory($event, lineItem)\">View Updates</md-button></md-menu-item><md-menu-item ng-if=\"lineItem.status !== \'delivered\' || lineItem.status === \'cancelled\'\"><md-button ng-click=\"manageTasksDialog($event, lineItem, $index)\">Create Tasks</md-button></md-menu-item><md-menu-item ng-if=\"lineItem.isACustomMadeProduct\"><md-button ng-click=\"showLineItemDetails(lineItem, $event);\">View Embedded Materials</md-button></md-menu-item><md-menu-item ng-if=\"!lineItem.isStockDeducted && !lineItem.isACustomMadeProduct\"><md-button ng-click=\"updateStock($event, lineItem)\">Update Stock</md-button></md-menu-item><md-menu-item ng-if=\"lineItem.isStockDeducted && !lineItem.isACustomMadeProduct\"><md-button ng-click=\"viewStockUpdates($event, lineItem._id);\">View Stock Updates</md-button></md-menu-item><md-menu-item ng-if=\"lineItem.status === \'shipped\' && lineItem.awbCode\"><md-button ng-click=\"showAwbDialog($event, lineItem, $index);\">Set Awb Code</md-button></md-menu-item><md-menu-item ng-if=\"lineItem.status ===\'shipped\' && lineItem.awbCode\"><md-button class=\"md-primary\" ng-disabled=\"!lineItem.awbCode\" target=\"_blank\" ng-href=\"{{\'https://tracklite.in/track/\' + lineItem.awbCode}}\"><span class=\"bold-text\">Track</span></md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></md-card><md-card><section layout=\"\" layout-align=\"space-between center\"><h4 class=\"grey-text\" style=\"margin-left: 16px\">Notifications</h4><div><md-button class=\"md-primary outline\" ng-click=\"sendAgentNotificationDialog($event)\" ng-if=\"order.agent\">Notify Agent</md-button><md-button class=\"md-primary md-raised\" ng-click=\"sendNotificationDialog($event)\">Notify Customer</md-button></div></section><md-divider></md-divider><section ng-if=\"fetchingNotifications\" layout=\"column\" layout-align=\"center center\" class=\"md-padding\"><md-progress-circular md-diameter=\"36\"></md-progress-circular><span class=\"md-caption grey-text\">Fetching Order Notifications ..</span></section><section ng-if=\"!fetchingNotifications && !fetchingNotificationsError\"><md-table-container><table md-table=\"\" md-progress=\"notificationsPromise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">#</th><th md-column=\"\">Type</th><th md-column=\"\">Date</th><th md-column=\"\">Sent To</th><th md-column=\"\">Sender</th><th md-column=\"\">Reason</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"notification in notifications\"><td md-cell=\"\">{{$index +1}}.</td><td md-cell=\"\"><div layout=\"\" layout-align=\"center center\"><md-icon>{{notification.from ? \'mail_outline\' : \'sms\'}}</md-icon></div></td><td md-cell=\"\"><span class=\"md-tiny\">{{notification.createdAt | date : \"medium\"}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{notification.to ? notification.to : notification.mobile}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{notification.from ? notification.from : notification.senderId}}</span></td><td md-cell=\"\"></td><td md-cell=\"\"><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-icon-button\" ng-click=\"showEmailDialog(notification, $event)\"><md-icon>folder_open</md-icon><md-tooltip>{{notification.from ? \"View Sent Mail\" : notification.message}}</md-tooltip></md-button></div></td></tr></tbody></table></md-table-container></section><section ng-if=\"!fetchingNotifications && fetchingNotificationsError\" layout=\"column\" layout-align=\"center center\" class=\"md-padding\"><div layout=\"\" layout-align=\"center center\"><md-icon>notifications_off</md-icon></div><span class=\"md-captions\">{{fetchingNotificationsError}}</span></section></md-card><md-card ng-if=\"order.capturedPayments\"><section layout=\"\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"center center\"><md-icon style=\"margin: 0px 4px;\">schedule</md-icon><h4 class=\"grey-text\">Payment History</h4></div><md-button class=\"md-primary outline\" ng-click=\"openOrderPaymentsDialog($event)\">Update Order Payments</md-button></section><md-divider></md-divider><section ng-if=\"fetchingPayments\" layout=\"column\" layout-align=\"center center\" class=\"md-padding\"><md-progress-circular md-diameter=\"36\"></md-progress-circular><span class=\"md-caption grey-text\">Fetching Order Payments ..</span></section><section ng-if=\"!fetchingPayments && order.capturedPayments.length\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Sl</th><th md-column=\"\">Card</th><th md-column=\"\">Cash</th><th md-column=\"\">Payment By</th><th md-column=\"\">Date</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"payment in order.capturedPayments | orderBy : \'-createdAt\'\"><td md-cell=\"\">{{$index + 1}}.</td><td md-cell=\"\">Rs. {{payment.cardAmount}}</td><td md-cell=\"\">Rs. {{payment.cashAmount}}</td><td md-cell=\"\">{{payment.createdBy}}</td><td md-cell=\"\">{{payment.createdAt | date :\'medium\'}}</td></tr></tbody></table></md-table-container></section><section ng-if=\"!fetchingPayments && !order.capturedPayments.length\" layout=\"column\" layout-align=\"center center\" class=\"md-padding\"><div layout=\"\" layout-align=\"center center\"><md-icon>bug_report</md-icon></div><span class=\"md-captions\">{{fetchingPaymentsError}}</span></section></md-card><div layout=\"\" layout-align=\"start stretch\" layout-wrap=\"\"><div flex-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"33\" ng-if=\"order.giftCard\"><md-card style=\"background: rgb(255,218,174);\"><md-card-content><div layout=\"column\" layout-align=\"start center\"><span class=\"center-text md-caption\">GIFTCARD USED</span> <a class=\"md-title md-link\" ui-sref=\"app.offers.giftCards.details({cardId : order.giftCard._id})\" style=\"font-weight: 600;margin-top: 20px;\">{{order.giftCard.code}}</a><table style=\"border: 1px solid; width: 85%; border-collapse: collapse; margin-top: 20px;\"><tr style=\"border: 1px solid;\"><th style=\"border: 1px solid; padding: 8px;\">Subtotal</th><td style=\"border: 1px solid; padding: 8px;\">&nbsp;&nbsp;Rs. {{order.orderData.creditDiscount ? (order.orderData.amount - order.orderData.creditDiscount) : order.orderData.amount}}</td></tr><tr style=\"border: 1px solid;\"><th style=\"border: 1px solid; padding: 8px;\">Gift Card Amount</th><td style=\"border: 1px solid; padding: 8px;\">- Rs. {{order.giftCardAmount}}</td></tr><tr style=\"border: 1px solid;\"><th style=\"border: 1px solid; padding: 8px;\">Total</th><td style=\"border: 1px solid; padding: 8px;\">&nbsp;&nbsp;Rs. {{order.amount}}</td></tr></table></div></md-card-content></md-card></div><div ng-if=\"order.orderData.coupon.couponCode\" flex-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"33\"><md-card style=\"background: #ffd8f2;\"><md-card-content><div layout=\"column\" layout-align=\"start center\"><span class=\"center-text md-caption\">COUPON USED</span> <span class=\"md-title\" style=\"font-weight: 600;margin-top: 20px;\">{{order.orderData.coupon.couponCode}}</span> <span class=\"md-body-1\">({{order.orderData.discountText}})</span><table style=\"border: 1px solid; border-collapse: collapse; margin-top: 20px; width: 85%\"><tr style=\"border: 1px solid;\"><th style=\"border: 1px solid; padding: 8px;\">Subtotal</th><td style=\"border: 1px solid; padding: 8px;\">&nbsp;&nbsp;Rs. {{order.orderData.subtotal}}</td></tr><tr style=\"border: 1px solid;\"><th style=\"border: 1px solid; padding: 8px;\">Discount</th><td style=\"border: 1px solid; padding: 8px;\">- Rs. {{order.orderData.discountAmount}}</td></tr><tr><th style=\"border: 1px solid; padding: 8px;\">Total</th><td style=\"border: 1px solid; padding: 8px;\">&nbsp;&nbsp;Rs. {{order.orderData.amount}}</td></tr></table></div></md-card-content></md-card></div><div flex-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"33\" ng-if=\"order.orderData.creditDiscount\"><md-card style=\"background: rgb(231,255,245);\"><md-card-content><div layout=\"column\" layout-align=\"start center\"><span class=\"center-text md-caption\">AARIDA CASH USED</span><table style=\"border: 1px solid; width: 85%; border-collapse: collapse; margin-top: 20px;\"><tr style=\"border: 1px solid;\"><th style=\"border: 1px solid; padding: 8px;\">Subtotal</th><td style=\"border: 1px solid; padding: 8px;\">&nbsp;&nbsp;Rs. {{order.orderData.amount}}</td></tr><tr style=\"border: 1px solid;\"><th style=\"border: 1px solid; padding: 8px;\">Aarida Cash Amount</th><td style=\"border: 1px solid; padding: 8px;\">- Rs. {{order.orderData.creditDiscount}}</td></tr><tr style=\"border: 1px solid;\"><th style=\"border: 1px solid; padding: 8px;\">Total</th><td style=\"border: 1px solid; padding: 8px;\">&nbsp;&nbsp;Rs. {{order.orderData.amount - order.orderData.creditDiscount}}</td></tr></table></div></md-card-content></md-card></div><div flex-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"33\"><md-card><section layout=\"\" layout-align=\"space-between center\"><h4 class=\"grey-text\" style=\"margin-left: 8px\">Cost Breakdown</h4><md-button class=\"small md-icon\" ng-click=\"showCostBreakDown = !showCostBreakDown\"><md-icon style=\"margin: 0px 4px;\">{{showCostBreakDown ? \'keyboard_arrow_up\' : \'keyboard_arrow_down\'}}</md-icon></md-button></section><md-divider></md-divider><section ng-if=\"!showCostBreakDown\"><md-list><md-list-item><span>Subtotal :</span> <span class=\"md-secondary\">₹ {{order.orderData.subtotal}}</span></md-list-item><md-divider></md-divider><md-list-item><span>Discounts :</span> <span class=\"md-secondary\">₹ {{order.orderData.discount}}</span></md-list-item><md-divider></md-divider><md-list-item><span>Taxes :</span> <span class=\"md-secondary\">₹ {{order.orderData.tax}}</span></md-list-item><md-divider></md-divider><md-list-item><span class=\"bold-text black-text\">Total :</span> <span class=\"md-secondary\">₹ {{order.orderData.amount}}</span></md-list-item></md-list><md-divider></md-divider><md-card-actions layout=\"\"><section flex=\"\" layout=\"\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/icons/txn-success.svg\" style=\"width: 24px;height: auto\"> <span class=\"grey-text md-tiny\">Amount Paid</span></div><span class=\"md-headline bold-text green-text\">₹{{order.paidAmount}}</span></section><section flex=\"\" layout=\"\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/icons/txn-fail.svg\" style=\"width: 24px;height: auto\"> <span class=\"grey-text md-tiny\">Amount Pending</span></div><span class=\"md-headline bold-text red-text\">₹{{order.orderData.total - order.paidAmount}}</span></section></md-card-actions></section><section layout=\"column\" layout-align=\"space-around center\" flex=\"\" style=\"min-height: 50px;\" ng-if=\"showCostBreakDown\"><div layout=\"\" layout-align=\"space-around center\" style=\"width: 100%;\"><div layout=\"column\" layout-align=\"space-around center\" style=\"width: 80%;\"><div layout=\"\" layout-align=\"space-between center\" class=\"costDetails\"><p class=\"md-caption\"><span>Total Mrp:</span></p><p class=\"md-caption\"><span>Rs.{{order.orderData.mrp}}</span></p></div><md-divider></md-divider><div layout=\"\" layout-align=\"space-between center\" class=\"costDetails\"><p class=\"md-caption\"><span>Total Discount on Products:</span></p><p class=\"md-caption\"><span>- Rs.{{totalProductLevelDiscount}}</span></p></div><md-divider></md-divider><div layout=\"\" layout-align=\"space-between center\" class=\"costDetails\"><p class=\"md-caption\"><span>Total Price after discount:</span></p><p class=\"md-caption\"><span>Rs.{{totalProductPrice}}</span></p></div><md-divider></md-divider><div layout=\"\" layout-align=\"space-between center\" class=\"costDetails\"><p class=\"md-caption\"><span>Subtotal:</span></p><p class=\"md-caption\"><span>Rs.{{order.orderData.subtotal}}</span></p></div><md-divider class=\"md-accent\"></md-divider><md-divider></md-divider><div layout=\"\" layout-align=\"space-between center\" class=\"costDetails\"><p class=\"md-caption\"><span>Total Discount on Order:</span></p><p class=\"md-caption\"><span>- Rs.{{order.orderData.discount}}</span></p></div><div layout=\"\" layout-align=\"space-between center\" class=\"costDetails\"><p class=\"md-caption\"><span>Tax:</span></p><p class=\"md-caption\"><span>Rs. {{order.orderData.tax}}</span></p></div><md-divider class=\"md-accent\"></md-divider><div layout=\"\" layout-align=\"space-between center\" class=\"costDetails\"><p class=\"md-caption\"><span>Total amount to be paid:</span></p><p class=\"md-caption\"><span>Rs. {{order.amount}}</span></p></div><md-divider class=\"md-accent\"></md-divider><div layout=\"\" layout-align=\"space-between center\" class=\"costDetails\"><p class=\"md-caption\"><span>Amount Paid In Cash:</span></p><p class=\"md-caption\"><span>Rs. {{order.orderData.cashAmountTendered}}</span></p></div><md-divider class=\"md-accent\"></md-divider><div layout=\"\" layout-align=\"space-between center\" class=\"costDetails\"><p class=\"md-caption\"><span>Amount Paid via Card:</span></p><p class=\"md-caption\"><span>Rs. {{order.orderData.cardAmountTendered}}</span></p></div><md-divider class=\"md-accent\"></md-divider><div layout=\"\" layout-align=\"space-between center\" class=\"costDetails\"><p class=\"md-caption\"><span>Total Amount Paid:</span></p><p class=\"md-caption\"><span>Rs. {{order.paidAmount}}</span></p></div><md-divider></md-divider><div layout=\"\" layout-align=\"space-between center\" class=\"costDetails\"><p class=\"md-caption\"><span>Amount Pending:</span></p><p class=\"md-caption\"><span>Rs.{{order.pendingAmount}}</span></p></div></div></div></section></md-card></div><div flex-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"33\"><md-card><section style=\"margin: 0 8px\" layout=\"\" layout-align=\"space-between center\"><div layout=\"column\"><h4 class=\"grey-text\">Checklist</h4><i class=\"md-caption\">Completed {{completedChecklists}} of {{order.checklistItems.length}}</i></div><md-switch ng-model=\"editChecklist\">Edit</md-switch></section><md-divider></md-divider><md-list style=\"max-height: 300px; overflow-y: scroll\"><md-list-item ng-repeat-start=\"checklistItem in order.checklistItems\" ng-disabled=\"!editChecklist\"><md-checkbox ng-change=\"updateChecklistItem(checklistItem)\" ng-disabled=\"!editChecklist\" ng-model=\"checklistItem.value\">{{checklistItem.description}}</md-checkbox><p ng-class=\"{\'strikethrough grey-text\': checklistItem.value}\">{{checklistItem.description}}</p><div class=\"md-secondary\"><bubble-loader ng-if=\"checklistItem.updating\"></bubble-loader></div></md-list-item><md-divider ng-if=\"!$last\" ng-repeat-end=\"\"></md-divider></md-list></md-card></div><div flex-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"33\" ng-if=\"order.isDelivered\"><md-card class=\"info-widget\" ng-class=\"{\'success\' : order.isReviewDone, \'error\' : !order.isReviewDone}\"><md-card-content flex=\"\" layout=\"\" layout-align=\"center center\"><div ng-if=\"!order.isReviewDone\" layout=\"\" layout-align=\"center center\"><p class=\"md-title\">Not Reviewed Yet</p></div><div ng-if=\"order.isReviewDone\" layout=\"column\" layout-align=\"center center\"><h3 class=\"md-title\">{{order.rating}} / 5.00</h3><div class=\"comment\" ng-repeat=\"review in reviews\"><p ng-if=\"review.comment\" class=\"md-caption\">\" {{review.comment}} \"</p><p ng-if=\"review.comment\" class=\"md-tiny\"><i>{{review.createdAt | date : \'medium\'}}</i></p></div></div></md-card-content><md-divider></md-divider><md-card-actions layout=\"\" layout-align=\"space-between center\"><md-button ng-if=\"!order.isReviewDone\" ng-click=\"requestReview($event)\">Request Review</md-button><md-button ng-if=\"!order.isReviewDone\" ng-click=\"openReviewDialog($event)\">Record Review</md-button><md-button ng-if=\"order.isReviewDone\" ng-click=\"openReviewListDialog($event, order.orderData.products)\">View Review</md-button></md-card-actions></md-card></div><div flex-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"33\" ng-if=\"order.shipRocketId && !fetchingSync\"><md-card class=\"info-widget success\"><md-card-content flex=\"\" layout=\"\" layout-align=\"center center\"><section class=\"white-text\" layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><div layout=\"\" layout-align=\"center center\"><md-icon class=\"white-text\">cloud_done</md-icon></div><span class=\"md-caption bold-text\">ShipRocket Synced</span> <span class=\"md-caption bold-text\">ID : {{order.shipRocketId}}</span></section></md-card-content></md-card></div></div></div><div flex=\"\" layout=\"column\"><md-card><md-card-content layout=\"\" layout-align=\"center center\"><p class=\"md-title\">Sale Channel : <span class=\"text-uppercase\">{{order.saleChannel ? order.saleChannel : \'WEB\'}}</span></p></md-card-content><md-divider></md-divider><md-card-content><div layout=\"column\" layout-align=\"center center\"><p>Designer : <span ng-if=\"order.cachedDesignerName\">{{order.cachedDesignerName}}</span> <span ng-if=\"!order.cachedDesignerName\">Not Set</span></p><md-button class=\"small outline md-primary\" ng-click=\"selectDesigner($event)\" ng-disabled=\"updatingDesigner || order.status === \'cancelled\'\"><span ng-if=\"!updatingDesigner\">{{order.designer ? \'Change\' : \'Select\'}} Designer</span><bubble-loader ng-if=\"updatingDesigner\"></bubble-loader></md-button></div></md-card-content><md-divider></md-divider><div ng-if=\"!savingShortLink && order.links && order.links.shortUrl\"><md-card-content layout=\"column\" layout-align=\"center center\"><h5>Order Short Link</h5><pre>{{order.links.shortUrl}}</pre></md-card-content><md-divider></md-divider></div><div ng-if=\"savingShortLink\"><md-card-content layout=\"column\" layout-align=\"center center\"><md-progress-circular md-diameter=\"24\"></md-progress-circular><p class=\"md-caption grey-text\">Generating order short link...</p></md-card-content></div><md-card-actions ng-if=\"order.saleChannel === \'pos\'\" layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-primary\" ui-sref=\"app.pos.edit({orderNumber : order.orderNumber})\"><md-icon>edit</md-icon><span>Edit Order</span></md-button><md-button class=\"md-primary\" ng-click=\"printInvoice()\"><md-icon>print</md-icon><span>Print Invoice</span></md-button></md-card-actions><md-card-actions layout=\"\"><md-menu flex=\"\" layout=\"\" layout-align=\"center center\"><md-button ng-click=\"$mdOpenMenu($event)\" aria-label=\"User\" class=\"md-primary outline full-width\">Downloads<md-icon>arrow_drop_down_circle</md-icon></md-button><md-menu-content><md-menu-item><md-button class=\"md-primary\" ng-click=\"downloadInvoice()\"><span>Download Order Invoice</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-primary\" ng-click=\"downloadThanksLetter()\"><span>Download Thanks Letter</span></md-button></md-menu-item><md-menu-item><md-button class=\"md-primary\" ng-click=\"openManifestDialog($event)\"><span>Download Order Manifest</span></md-button></md-menu-item></md-menu-content></md-menu></md-card-actions><md-divider></md-divider><h4 class=\"md-subhead center-text\">Share/Notify :</h4><div layout=\"\" layout-align=\"center center\"><md-button ng-click=\"sendNotificationDialog($event, null, 2)\" class=\"md-icon-button\"><md-icon>email</md-icon><md-tooltip>Send Email</md-tooltip></md-button><md-button ng-click=\"sendNotificationDialog($event, null, 0)\" class=\"md-icon-button\"><md-icon>message</md-icon><md-tooltip>Send Message</md-tooltip></md-button><md-button ng-click=\"sendNotificationDialog($event, null, 1)\" class=\"md-icon-button\"><md-icon class=\"green-text\" md-svg-src=\"assets/images/whatsapp.svg\"></md-icon><md-tooltip>Send WhatsApp</md-tooltip></md-button></div><div layout=\"column\" layout-align=\"center stretch\" ng-if=\"order.flags && order.flags.dispatchToAgent\" class=\"org-confirmation-box md-padding\" ng-class=\"[order.confirmationStatus.status]\"><h4 class=\"md-subhead center-text\">Confirmation Status</h4><p class=\"center-text\">{{order.confirmationStatus.status | uppercase}}</p><div layout=\"\" ng-if=\"order.confirmationStatus.status === \'requested\'\" layout-align=\"space-between center\"><span class=\"md-tiny\">{{order.confirmationStatus.requestedBy.name}}</span> <span class=\"md-tiny\">{{order.confirmationStatus.requestDate | date : \'medium\'}}</span></div><div layout=\"\" class=\"full-width\" ng-if=\"order.confirmationStatus.status === \'on-hold\' || order.confirmationStatus.status === \'approved\'\" layout-align=\"space-between center\"><span class=\"md-tiny\">{{order.confirmationStatus.confirmedBy.name}}</span> <span class=\"md-tiny\">{{order.confirmationStatus.confirmationDate | date : \'medium\'}}</span></div><div layout=\"\" layout-align=\"center center\" ng-if=\"order.confirmationStatus.status === \'pending\'\"><md-button ng-click=\"openConfirmOrderShipmentDialog()\" ng-disabled=\"updatingConfirmation\" class=\"small outline md-accent\">Request Confirmation</md-button></div><section ng-if=\"order.confirmationStatus.status === \'pending\' || order.confirmationStatus.status === \'requested\'\"><md-divider></md-divider><div layout=\"\" layout-align=\"space-between center\"><md-button ng-click=\"updateOrderConfirmation(\'approved\')\" ng-disabled=\"updatingConfirmation\" class=\"md-primary md-raised small\">Approved</md-button><md-button ng-click=\"updateOrderConfirmation(\'on-hold\')\" ng-disabled=\"updatingConfirmation\" class=\"md-warn md-raised small\">On Hold</md-button></div></section></div><md-divider></md-divider><md-list><md-list-item><md-input-container class=\"no-error-spacer md-secondary\"><md-switch ng-model=\"editAgentBox\">Edit Details</md-switch></md-input-container></md-list-item><md-divider></md-divider><md-list-item><p>Organisation</p><md-input-container class=\"no-error-spacer md-secondary\"><md-select ng-model=\"order.organisation\" ng-disabled=\"!editAgentBox\" ng-change=\"loadAgents()\"><md-option value=\"\">Select Organisation</md-option><md-option ng-repeat=\"organisation in orgs\" ng-value=\"organisation._id\">{{organisation.name}}</md-option></md-select></md-input-container></md-list-item><md-divider></md-divider><md-list-item><p>Warehouse</p><md-input-container class=\"no-error-spacer md-secondary\"><md-select ng-model=\"order.warehouse._id\" ng-disabled=\"!editAgentBox\" ng-change=\"changeWarehouse(order.warehouse)\"><md-option value=\"\">Select Warehouse</md-option><md-option ng-repeat=\"warehouse in warehouses\" ng-value=\"warehouse._id\">{{warehouse.name}}</md-option></md-select></md-input-container></md-list-item><md-divider></md-divider><md-list-item><p>Agent</p><md-input-container class=\"no-error-spacer md-secondary\"><md-select ng-disabled=\"!editAgentBox\" data-md-container-class=\"selectdemoSelectHeader\" ng-model=\"order.agent\"><md-select-header class=\"demo-select-header\" md-no-float=\"\"><input ng-model=\"agentSearch\" ng-change=\"loadAgents()\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option layout-fill=\"\" ng-if=\"loadingAgents\" value=\"\"><bubble-loader></bubble-loader></md-option><md-option ng-value=\"agent._id\" ng-repeat=\"agent in agents | orderBy : \'name\' track by $index\"><div layout=\"column\"><span>{{agent.name}}</span> <span>{{agent.mobile}}</span></div></md-option></md-select></md-input-container></md-list-item><md-divider></md-divider><md-list-item><p>Dispatch To Agent</p><md-input-container class=\"no-error-spacer md-secondary\"><md-switch ng-disabled=\"!editAgentBox\" ng-model=\"order.flags.dispatchToAgent\"></md-switch></md-input-container></md-list-item><md-divider></md-divider><md-list-item><p>Hide Address</p><md-input-container class=\"no-error-spacer md-secondary\"><md-switch ng-disabled=\"!editAgentBox\" ng-model=\"order.flags.hideAddress\"></md-switch></md-input-container></md-list-item></md-list><md-divider></md-divider><md-card-actions ng-if=\"editAgentBox\" layout=\"\" layout-align=\"end center\"><md-button class=\"md-primary small md-raised\" ng-disabled=\"savingAddress || updatingOrgDetails\" ng-click=\"saveOrganisationDetails()\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!updatingOrgDetails\">Save Details</span><bubble-loader ng-if=\"updatingOrgDetails\"></bubble-loader></div></md-button></md-card-actions></md-card><md-card class=\"image-widget\"><div layout=\"\" layout-align=\"space-between center\" style=\"padding: 0 8px\"><section><md-icon style=\"margin: 0px 4px;\">photo_library</md-icon><span class=\"md-subhead\">Order Images</span></section><md-button class=\"md-primary outline small\" ng-click=\"addDesignImage()\">Add Image</md-button></div><md-divider></md-divider><div ng-if=\"!order.designImages || !order.designImages.length\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/blank.svg\" style=\"max-width: 100px\"><p>No Images Yet</p><md-button class=\"md-primary outline small\" ng-click=\"addDesignImage()\">Add Image</md-button></div><div class=\"order-designs\" ng-if=\"order.designImages && order.designImages.length\" layout=\"\" layout-wrap=\"\" layout-align=\"space-between stretch\"><div ng-repeat=\"designImage in order.designImages track by $index\" flex=\"40\" class=\"single-design\"><div layout=\"\" layout-align=\"center center\" class=\"md-card-image\"><image-selector style=\"max-width: 200px\" ng-if=\"!designImage.image\" multiple=\"true\" ng-change=\"attachImages(designImage.newImage)\" ng-model=\"designImage.newImage\" placeholder=\"Select Design Image\"></image-selector><md-img md-src=\"{{designImage.image.urls.thumbnail}}\" class=\"pointer\" ng-click=\"openImages($event, [designImage.image] )\" style=\"max-width: 150px\" ng-if=\"designImage.image\"></md-img></div><md-card-content layout=\"column\" layout-align=\"center center\" ng-if=\"designImage.image && designImage._id\"><span class=\"md-caption\">{{designImage.uploadedByName}}</span> <span class=\"md-tiny grey-text\">{{dateAgo(designImage.date)}}</span></md-card-content><md-divider ng-if=\"!designImage._id\"></md-divider><md-card-actions layout=\"\" layout-align=\"space-between center\" ng-if=\"!designImage._id\"><md-button class=\"md-warn md-icon-button\" ng-click=\"removeImage($index)\"><md-icon>delete</md-icon></md-button><md-button class=\"md-primary outline small\" ng-disabled=\"!designImage.newImage\" ng-click=\"saveDesignImage(designImage)\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!designImage.saving\">Save</span><bubble-loader ng-if=\"designImage.saving\"></bubble-loader></div></md-button></md-card-actions></div></div></md-card><md-card class=\"info-widget error\" ng-if=\"order.status === \'return requested\'\"><div layout=\"row\" layout-align=\"center center\"><section layout=\"\" layout-align=\"center center\"><md-icon class=\"white-text\">info</md-icon></section><h4 class=\"white-text\" style=\"margin-left: 8px;\">Return Requested</h4></div><md-divider></md-divider><md-card-content class=\"white-text\"><div layout=\"row\" layout-align=\"start start\"><span class=\"md-tiny bold-text\" flex=\"20\">Date :</span> <span class=\"md-caption\" flex=\"\">{{order.updatedAt | date : \"medium\"}}</span></div><div layout=\"row\" layout-align=\"start start\" style=\"margin-top: 8px;\"><span class=\"md-tiny bold-text\" flex=\"20\">Reason :</span> <span class=\"md-caption\" flex=\"\">{{order.cancellationReason}}</span></div></md-card-content><md-divider></md-divider><section layout=\"\"><div flex=\"\" layout=\"\" layout-align=\"center center\"><md-button style=\"width: 100%;\" ng-click=\"updateStatus(\'return approved\', $event);\"><md-icon class=\"white-text\">done</md-icon><span class=\"white-text\">Accept</span></md-button></div><div flex=\"\" layout=\"\" layout-align=\"center center\"><md-button style=\"width: 100%;\" ng-click=\"updateStatus(\'return rejected\', $event);\"><md-icon class=\"white-text\">close</md-icon><span class=\"white-text\">Reject</span></md-button></div></section></md-card><md-card ng-if=\"(order.status === \'shipped\' || order.status === \'partially shipped\' || order.status === \'delivered\')\"><div layout=\"\" layout-align=\"center center\" class=\"md-padding\"><span class=\"grey-text md-caption\">Shipment Details</span></div><md-divider></md-divider><md-card-content><div layout=\"\" layout-align=\"space-between center\"><span class=\"md-caption\">AWB : {{order.awbCode ? order.awbCode : \"Enter AWB\"}}</span><md-button class=\"md-icon-button\" ng-click=\"showAwbDialog($event, null, null);\"><md-icon>edit</md-icon></md-button></div></md-card-content><md-divider></md-divider><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-primary\" ng-disabled=\"!order.awbCode\" target=\"_blank\" ng-href=\"{{\'https://tracklite.in/track/\' + order.awbCode}}\"><md-icon>location_on</md-icon><span class=\"bold-text\">Track Order</span></md-button></div></md-card><md-card><section><div layout=\"row\" layout-align=\"center center\"><md-icon style=\"margin: 0px 4px;\">schedule</md-icon><h4 class=\"grey-text\">Order Status</h4></div></section><md-divider></md-divider><md-card-content><div layout=\"column\"><md-select ng-model=\"order.status\" aria-label=\"status select\"><md-option ng-repeat=\"status in orderStatus\" ng-value=\"status\">{{capitalize(status);}}</md-option></md-select><span class=\"md-caption center-text\">Last Saved - {{order.updatedAt | date : \"medium\"}}</span><div layout=\"\" layout-align=\"center center\" class=\"md-padding\"><md-button ng-if=\"!saving\" class=\"md-accent md-raised\" ng-click=\"saveOrder($event);\" style=\"width: 100%;\"><md-icon>save</md-icon><span>Save</span></md-button><md-progress-circular md-diameter=\"36\" ng-if=\"saving\"></md-progress-circular></div><span class=\"md-caption center-text\">STATUS HISTORY</span><div layout=\"column\" ng-if=\"order.statusHistory.length > 0\" class=\"timeline md-margin\" layout-padding=\"\" style=\"background: rgba(1,1,1,0.1);\"><div class=\"timeline-item\" ng-repeat=\"history in order.statusHistory | orderBy:\'-\'\" layout=\"column\" style=\"position: relative; margin-left: 20px\"><md-icon ng-style=\"{\'color\' : getColor(history.status)}\" style=\"position: absolute; left: -7px; top: 15px; width: 12px; min-width: 12px; height: 12px; min-height: 12px; font-size: 12px; color: black;\">lens</md-icon><span class=\"md-body-1\" ng-style=\"{\'color\' : getColor(history.status)}\" style=\"font-weight: 500; margin-left: 10px;\">{{capitalize(history.status)}}</span> <span class=\"grey-text\" style=\"font-size: 10px; margin-left: 15px; font-style: italic;\">{{ history.date | date : \"medium\"}}</span></div></div></div></md-card-content></md-card></div></div><md-card class=\"md-primary order-notes\" md-whiteframe=\"16\"><section ng-click=\"showOrderChat = !showOrderChat\" class=\"pointer\" layout=\"\" layout-align=\"space-between center\" style=\"padding: 6px\"><div layout=\"\" layout-align=\"center center\"><span><md-icon class=\"md-accent\" style=\"margin-left: 8px\">speaker_notes</md-icon></span> <span class=\"md-body-1 bold-text\" style=\"margin-left: 8px\">Order Notes ({{order.notes ? order.notes.length : 0}})</span></div><md-button class=\"md-icon-button md-primary\"><md-icon>{{showOrderChat ? \'keyboard_arrow_down\' : \'keyboard_arrow_up\'}}</md-icon></md-button></section><div ng-show=\"showOrderChat\" class=\"relative\"><md-divider></md-divider><md-card-content class=\"message-content-wrapper\"><md-list class=\"md-2-line\" ng-if=\"order.notes && order.notes.length\"><md-list-item ng-repeat-start=\"note in order.notes\" class=\"message-full-wrapper\" ng-class=\"{\'align-left\' : note.by !== currentUser._id, \'align-right\' : note.by === currentUser._id}\"><div class=\"message\" ng-class=\"{\'others\' : note.by !== currentUser._id, \'me\' : note.by === currentUser._id}\" layout=\"column\"><div class=\"message-images-container\" ng-if=\"note.images && note.images.length\" ng-class=\"{\'layout-align-start-center\' : note.by !== currentUser._id, \'layout-align-end-center\' : note.by === currentUser._id}\" layout=\"\"><md-img class=\"message-image\" md-src=\"{{note.images[0].urls.medium}}\" ng-click=\"openImages($event, note.images)\"></md-img></div><p class=\"comment\" mention-text=\"\" comment=\"note.comment\"></p><section layout=\"\" layout-align=\"space-between center\"><span class=\"md-tiny\">By {{note.byName}}</span> <span class=\"md-tiny date grey-text\" ng-if=\"!note.saving && !note.error\">{{dateAgo(note.date) }}</span><md-icon class=\"bug-icon\" ng-if=\"!note.saving && note.error\">bug</md-icon><bubble-loader class=\"save-loader\" ng-if=\"note.saving\"></bubble-loader></section></div></md-list-item><div ng-repeat-end=\"\" class=\"align-clear\"></div></md-list><div layout=\"column\" layout-align=\"center center\" ng-if=\"!order.notes || !order.notes.length\"><img src=\"assets/images/blank.svg\" style=\"width: 100px; height: auto;\"><p>No Comments Yet</p></div></md-card-content><md-divider></md-divider><md-card-actions layout=\"\" layout-align=\"stretch center\" class=\"relative\"><md-input-container class=\"no-error-spacer ui-mention-container\" flex=\"\" md-no-float=\"\"><textarea ui-mention=\"\" aarida-mentions=\"\" rows=\"2\" ng-model=\"message\" placeholder=\"Comment\"></textarea><div class=\"mention-highlight\"></div><md-list class=\"dropdown md-2-line md-whiteframe-1dp\" ng-if=\"$mention.choices.length\"><md-list-item ng-if=\"$mention.loading\"><bubble-loader></bubble-loader></md-list-item><md-list-item ng-repeat-start=\"choice in $mention.choices\" ng-class=\"{active:$mention.activeChoice==choice}\" ng-click=\"$mention.select(choice)\"><div class=\"md-list-item-text\" layout=\"column\"><span class=\"name\">{{::choice.name}}</span> <span class=\"md-caption email\">{{::choice.email}}</span></div></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list></md-input-container><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-icon-button relative\"><md-icon>{{!imageSelected ? \'attach_file\' : \'attachment\'}}</md-icon><image-selector class=\"message-media-selector\" ng-model=\"$parent.imageSelected\"></image-selector></md-button><md-button class=\"md-icon-button md-fab md-mini\" ng-disabled=\"!message && !imageSelected\" ng-click=\"publishOrderNote()\"><md-icon>send</md-icon></md-button></div></md-card-actions><div ng-show=\"imageSelected\" class=\"image-material-box\"><md-img md-src=\"{{ imageSelected.urls.medium }}\" alt=\"{{message}}\"></md-img><md-button class=\"md-icon-button close-material-box-button\" ng-click=\"imageSelected = null\"><md-icon>close</md-icon></md-button></div></div></md-card></div><div style=\"visibility: hidden\" flex=\"66\"><div class=\"md-dialog-container\" id=\"customisationDialog\"><md-dialog aria-label=\"customisationDialog\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Customisation</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"background: rgba(1,1,1,0.03); min-width: 800px;\"><div class=\"md-dialog-content\" layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"40\"><div ng-if=\"showProduct.customisation.baseImage.urls\"></div><div ng-if=\"!showProduct.customisation.baseImage.urls\" ng-repeat=\"layer in showProduct.ucData.customisation.data\" layout=\"row\"><div layout=\"\" layout-align=\"center center\"><span>{{layer.name }}</span></div><md-card ng-init=\"default = getDefault(layer);\"><md-img md-src=\"{{default.image.urls.c_medium}}\" style=\"width: 200px\"><span class=\"md-padding center-text\">{{default.name}}</span></md-img></md-card></div></div><div flex=\"60\" layout=\"\" layout-align=\"center start\"><customisable-product ng-if=\"showProduct.customisation.baseImage.urls\" customisation=\"showProduct.customisation\"></customisable-product><div ng-if=\"!showProduct.customisation.baseImage.urls\"><md-img md-src=\"{{showProduct.product.featured_image.urls.medium}}\" style=\"width: 100%\"></md-img></div></div></div></md-dialog-content></form></md-dialog></div></div><div style=\"visibility: hidden\" flex=\"66\"><div class=\"md-dialog-container\" id=\"customDialog\"><md-dialog aria-label=\"customDialog\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Email</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"background: rgba(1,1,1,0.03); min-width: 800px; margin: 0; padding: 0;\"><preview content=\"contentHtml\"></preview></md-dialog-content></form></md-dialog></div></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"reviewsListDialog\"><md-dialog aria-label=\"customDialog\" flex=\"40\"><form ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Reviews</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content-body md-padding\"><md-list ng-repeat=\"productData in selectedReviewProducts\"><md-subheader>{{productData.product.name}}</md-subheader><md-list-item class=\"md-3-line md-long-text\" ng-repeat-start=\"review in productData.reviews\"><div class=\"md-list-item-text\"><p><span class=\"md-caption grey-text\">By {{review.userName}}</span> <span class=\"md-caption grey-text\">On {{review.createdAt | date : \'medium\'}}</span></p><p class=\"black-text\">{{review.comment || \'No Comment\'}}</p></div><md-button disabled=\"\" class=\"md-secondary\"><span class=\"badge\">Rating : {{review.reviewPoints}}</span></md-button></md-list-item><md-divider ng-repeat-end=\"\"></md-divider></md-list></md-dialog-content></form></md-dialog></div></div><div static-include=\"app/modules/orders/orderDetails/partials/trackingDialog.html\"></div><div static-include=\"app/modules/orders/orderDetails/partials/viewMeasurementsDialog.html\"></div><div static-include=\"app/modules/orders/orderDetails/partials/manifest-builder.html\"></div><div static-include=\"app/modules/orders/orderDetails/partials/lineItemDetails.html\"></div><div static-include=\"app/modules/orders/orderDetails/partials/package-manager.html\"></div><div static-include=\"app/modules/orders/orderDetails/order-payments-dialog/order-payments-dialog.html\"></div>");
$templateCache.put("app/modules/orders/orderDetails/partials/lineItemDetails.html","<div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"lineItemDetails\"><md-dialog flex=\"50\"><md-toolbar><div layout=\"\" layout-align=\"space-between center\" class=\"md-toolbar-tools md-accent\"><h3>Details For {{selectedLineItem.name}}</h3><md-button class=\"md-icon-button\" ng-click=\"cancel();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content\"><md-list><md-subheader>Materials ({{selectedLineItem.materials.length}})</md-subheader><md-list-item ng-repeat-start=\"material in selectedLineItem.materials\" class=\"md-3-line\"><md-img md-src=\"{{material.image.urls.thumbnail}}\" class=\"md-avatar\" style=\"height: auto; border-radius: 0;\"></md-img><div class=\"md-list-item-text\" layout=\"column\"><span class=\"md-subhead\">{{material.materialName}}</span><p class=\"md-caption\">Price : ₹ {{material.price}}</p><p class=\"md-caption\">Quantity : {{material.quantity}}</p></div><h3 class=\"md-secondary\">₹ {{material.totalPrice}}</h3></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider><md-subheader>Linked Products ({{selectedLineItem.linkedProducts.length}})</md-subheader><md-list-item ng-repeat-start=\"product in selectedLineItem.linkedProducts\" class=\"md-3-line\"><md-img md-src=\"{{product.image.urls.thumbnail}}\" class=\"md-avatar\" style=\"height: auto; border-radius: 0;\"></md-img><div class=\"md-list-item-text\" layout=\"column\"><span class=\"md-subhead\">{{product.productName}}</span><p class=\"md-caption\">SKU : ₹ {{product.sku}} | Variation : {{product.selectedVariationText}}</p><p class=\"md-caption\">Price : ₹ {{product.price}} | Quantity : {{product.quantity}}</p></div><h3 class=\"md-secondary\">₹ {{product.totalPrice}}</h3></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list></md-dialog-content></md-dialog></div></div>");
$templateCache.put("app/modules/orders/orderDetails/partials/manifest-builder.html","<div style=\"visibility: hidden\"><div class=\"md-dialog-container manifest-builder-dialog\" id=\"manifestSelector\"><md-dialog flex=\"50\"><md-toolbar><div layout=\"\" layout-align=\"space-between center\" class=\"md-toolbar-tools md-accent\"><h3>Select Manifest Details</h3><md-button class=\"md-icon-button\" ng-click=\"cancel();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content md-content\"><p>Please select the options below to build your manifest.</p><h3 class=\"center-text\">Select Products</h3><div layout=\"\" layout-align=\"end center\"><md-switch ng-model=\"editLineItemsInManifest\">Edit Products before Manifesting</md-switch><div><md-icon>info<md-tooltip class=\"mega-tooltip\">Will not change the line items in the order</md-tooltip></md-icon></div></div><md-list><md-list-item ng-repeat=\"lineItem in manifestOrder.orderData.products\"><md-img ng-if=\"!editLineItemsInManifest\" md-src=\"{{lineItem.product.featured_image.urls.thumbnail}}\" class=\"md-avatar\"></md-img><p ng-if=\"!editLineItemsInManifest\">{{lineItem.product.name}}</p><image-selector ng-click=\"$event.stopPropagation()\" ng-model=\"lineItem.product.featured_image\" ng-if=\"editLineItemsInManifest\" class=\"md-avatar\"></image-selector><input style=\"width: 60%\" ng-if=\"editLineItemsInManifest\" type=\"text\" ng-model=\"lineItem.product.name\" ng-click=\"$event.stopPropagation()\" required=\"\"><md-checkbox ng-if=\"!editLineItemsInManifest\" class=\"md-secondary\" ng-model=\"lineItem.selectedForManifest\"></md-checkbox></md-list-item></md-list><h3 class=\"center-text\">Select Images</h3><div layout=\"\" layout-wrap=\"\" layout-align=\"stretch stretch\" style=\"margin-top: 20px\"><section ng-repeat=\"designImage in manifestOrder.designImages\" flex=\"33\" layout=\"column\" layout-align=\"start center\" ng-if=\"designImage._id\"><md-img md-src=\"{{designImage.image.urls.thumbnail}}\" class=\"pointer\" ng-click=\"openImages($event, [designImage.image] )\" style=\"max-width: 150px\"></md-img><div layout=\"column\" layout-align=\"center center\"><span class=\"md-caption\">{{designImage.uploadedByName}}</span> <span class=\"md-tiny grey-text\">{{dateAgo(designImage.date)}}</span></div><md-checkbox ng-model=\"designImage.selectedForManifest\">Select Image</md-checkbox></section><section layout=\"column\" layout-align=\"center center\" class=\"md-padding\" flex=\"\" ng-if=\"!manifestOrder.designImages || !manifestOrder.designImages.length\"><img src=\"assets/images/blank.svg\" style=\"width: 100px\"> <span>No Design Images Added to Order</span><p>Please add design images to put them in the manifest</p></section></div></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-primary md-raised\" ng-click=\"downloadOrderManifest()\" ng-disabled=\"downloadingManifest\"><span ng-if=\"!downloadingManifest\">Generate Manifest</span><bubble-loader ng-if=\"downloadingManifest\"></bubble-loader></md-button></md-dialog-actions></md-dialog></div></div>");
$templateCache.put("app/modules/orders/orderDetails/partials/package-manager.html","<div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"packageManager\"><md-dialog aria-label=\"cancel order dialog\" class=\"package-manager-dialog\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h5>{{orderShipments.length && orderShipments[0]._id ? \'Manage Shipments\' : \'Create Shipments\' }}</h5><md-button class=\"md-icon-button\" ng-click=\"cancel();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><div layout=\"column\" layout-align=\"center center\"><h4 class=\"\">Please select and group packages according to the source of the shipment.</h4><p class=\"md-caption\">For eg : Two products which have to be shipped together from an order in Deoghar will be packaged together. This has to be done before the order can be shipped.</p></div><div layout=\"\" layout-align=\"space-between center\"><h5>Packages</h5><md-button class=\"md-primary small\" ng-click=\"appendPackage()\"><md-icon>add</md-icon><span>Add Package</span></md-button></div><md-divider></md-divider><div class=\"package-selector\" ng-repeat=\"shipment in orderShipments\" ng-init=\"packageIndex = $index\"><section class=\"layout\" layout-wrap=\"\" layout-align=\"stretch center\"><div layout=\"\" layout-align=\"space-between center\" flex=\"100\"><h5>{{$index + 1}}.</h5><md-button class=\"md-warn small round md-raised flat\" ng-if=\"!shipment._id\" ng-click=\"removePackageGroup($index)\">Remove</md-button></div><md-input-container flex=\"100\"><label>Select Line Items</label><md-select ng-model=\"shipment.lineItems\" multiple=\"\" ng-disabled=\"shipment.isEditDisabled\" ng-change=\"updateShipmentDescription(shipment)\"><md-option ng-value=\"lineItem._id\" ng-repeat=\"lineItem in order.lineItems\"><md-img style=\"width: 32px; height: auto;\" ng-if=\"lineItem.image\" md-src=\"{{lineItem.image.urls.thumbnail}}\"></md-img><span>{{ lineItem.name }}</span></md-option></md-select></md-input-container><md-input-container flex=\"50\"><label>Select Source Warehouse</label><md-select ng-model=\"shipment.sourceWarehouse\" ng-disabled=\"shipment.isEditDisabled\"><md-option ng-repeat=\"warehouse in warehouses\" ng-value=\"warehouse._id\">{{warehouse.name}}</md-option></md-select></md-input-container><md-input-container flex=\"50\"><label>Order Type</label><md-select ng-model=\"shipment.orderType\" ng-disabled=\"shipment.isEditDisabled\"><md-option value=\"cod\">COD</md-option><md-option value=\"prepaid\">Prepaid</md-option><md-option value=\"reverse\">Reverse</md-option></md-select></md-input-container><md-input-container flex=\"33\"><label>Package ID</label> <input type=\"text\" disabled=\"\" ng-model=\"shipment.packageId\"></md-input-container><md-input-container flex=\"33\"><label>Shipping Partner</label><md-select ng-model=\"shipment.logisticsChannel\" ng-disabled=\"shipment.isEditDisabled\"><md-option value=\"\"></md-option><md-option value=\"shiprocket\">Shiprocket</md-option><md-option value=\"shyplite\">Shyplite</md-option></md-select></md-input-container><md-input-container flex=\"33\"><label>External Order ID</label> <input type=\"text\" disabled=\"\" ng-model=\"shipment.extOrderId\"></md-input-container><md-input-container flex=\"20\"><label>Length(cm)</label> <input type=\"number\" ng-disabled=\"shipment.isEditDisabled\" ng-model=\"shipment.dimensions.length\" ng-change=\"calculateVolumetricWeight(shipment)\"></md-input-container><md-input-container flex=\"20\"><label>Breadth(cm)</label> <input type=\"number\" ng-disabled=\"shipment.isEditDisabled\" ng-model=\"shipment.dimensions.breadth\" ng-change=\"calculateVolumetricWeight(shipment)\"></md-input-container><md-input-container flex=\"20\"><label>Height(cm)</label> <input type=\"number\" ng-disabled=\"shipment.isEditDisabled\" ng-model=\"shipment.dimensions.height\" ng-change=\"calculateVolumetricWeight(shipment)\"></md-input-container><md-input-container flex=\"20\"><label>Volumetric Weight(kg)</label> <input type=\"number\" ng-disabled=\"shipment.isEditDisabled\" ng-model=\"shipment.volumetricWeight\" disabled=\"\"></md-input-container><md-input-container flex=\"20\"><label>Weight(kg)</label> <input type=\"number\" ng-disabled=\"shipment.isEditDisabled\" ng-model=\"shipment.weight\"></md-input-container><md-input-container flex=\"30\"><label>Total Invoice Value (₹)</label> <input type=\"number\" disabled=\"\" ng-model=\"shipment.invoiceValue\"></md-input-container><md-input-container flex=\"70\"><label>Description</label> <input type=\"text\" disabled=\"\" ng-model=\"shipment.description\"></md-input-container><div layout=\"\" layout-align=\"end center\" flex=\"100\"><md-button class=\"md-primary outline small\" ng-if=\"shipment._id && shipment.status === \'created\'\" ng-click=\"shippingConfirmationDialog($event, shipment)\">Ship Now</md-button><md-button class=\"md-primary md-raised round flat small\" ng-if=\"shipment._id && shipment.status !== \'created\'\">Shipment Shipped</md-button></div></section></div></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"cancel();\">Cancel</md-button><md-button class=\"md-accent\" ng-click=\"createShipment($event)\"><div layout=\"\" layout-align=\"center center\"><div ng-if=\"!savingPackages\">Save</div><md-progress-circular md-diameter=\"20\" class=\"md-accent\" ng-if=\"savingPackages\"></md-progress-circular></div></md-button></md-dialog-actions></md-dialog></div></div>");
$templateCache.put("app/modules/orders/orderDetails/partials/review-dialog.html","<md-dialog aria-label=\"cancel order dialog\" flex=\"60\" flex-xs=\"90\" flex-sm=\"80\" flex-md=\"60\" flex-lg=\"40\" flex-xl=\"35\" class=\"review-dialog\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h5>Reviews</h5><md-button class=\"md-icon-button\" ng-click=\"close();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-padding\"><md-card ng-repeat=\"review in reviews\" layout=\"column\" layout-align=\"stretch center\" class=\"md-padding\"><div layout-sm=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\"><div layout=\"\" layout-align=\"center center\"><md-img md-src=\"{{ review.product.image }}\" alt=\"{{review.product.name}}\" class=\"product-image\"></md-img></div><div layout=\"column\" layout-align=\"center center\"><span flex=\"\" class=\"montserrat center-text\" ng-class=\"{\'md-subhead\' : !isSmall, \'md-body-1\' : isSmall}\">{{ review.product.name }}</span><star-rating class=\"md-padding\" rating-value=\"1\" on-rating-selected=\"updateRating(data, review)\"></star-rating></div></div><md-input-container class=\"suggestion-box\" md-theme=\"indigo\"><label>Your Review (Optional)</label> <textarea ng-model=\"review.comment\" placeholder=\"Hey, Let us know what you think about this product\" col=\"30\" rows=\"3\" md-maxlength=\"150\"></textarea></md-input-container></md-card></md-dialog-content><md-dialog-actions><md-button class=\"md-accent\" ng-click=\"saveReview($event)\"><div layout=\"\" layout-align=\"center center\"><div ng-if=\"!savingReview\">Save Review</div><md-progress-circular md-diameter=\"20\" class=\"md-accent\" ng-if=\"savingReview\"></md-progress-circular></div></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/orders/orderDetails/partials/trackingDialog.html","<div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"trackingDialog\"><md-dialog flex=\"75\"><md-toolbar><div layout=\"\" layout-align=\"space-between center\" class=\"md-toolbar-tools md-accent\"><h6>Track Shipment - {{order.orderNumber}}</h6><md-button class=\"md-icon-button\" ng-click=\"cancel();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-height: 400px; background: #efefef;\"><div layout=\"\" layout-align=\"center center\" ng-if=\"fetchingTracking\"><md-progress-circular></md-progress-circular></div><div ng-if=\"!fetchingTracking && trackingData.status\" layout=\"column\" class=\"md-padding\"><section layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" layout-align=\"stretch center\"><md-card flex=\"\"><div layout=\"\" md-whiteframe=\"2\" layout-align=\"center center\" class=\"md-padding\" style=\"background: #5c3fff;\"><div layout=\"\" layout-align=\"center center\"><md-icon class=\"white-text\">place</md-icon></div><span class=\"md-caption white-text bold-text\" style=\"margin-left: 4px;\">Current Status</span></div><md-divider></md-divider><md-card-content layout=\"\" layout-align=\"center center\"><span class=\"md-body-1\">{{trackingData.current_status}}</span> <span class=\"md-tiny\">{{trackingData.history.slice(-1).date | date : \"mediumDate\"}}</span></md-card-content></md-card><md-card flex=\"\"><div layout=\"\" md-whiteframe=\"2\" layout-align=\"center center\" class=\"md-padding\" style=\"background: #5c3fff;\"><div layout=\"\" layout-align=\"center center\"><md-icon class=\"white-text\">layers</md-icon></div><span class=\"md-caption white-text bold-text\" style=\"margin-left: 4px;\">AWB Code</span></div><md-divider></md-divider><md-card-content layout=\"\" layout-align=\"center center\"><span class=\"md-body-1 center-text\">{{trackingData.awb_code}}</span></md-card-content></md-card><md-card flex=\"\"><div layout=\"\" md-whiteframe=\"2\" layout-align=\"center center\" class=\"md-padding\" style=\"background: #5c3fff;\"><div layout=\"\" layout-align=\"center center\"><md-icon class=\"white-text\">date_range</md-icon></div><span class=\"md-caption white-text bold-text\" style=\"margin-left: 4px;\">Pickup Date</span></div><md-divider></md-divider><md-card-content layout=\"\" layout-align=\"center center\"><span class=\"md-body-1 center-text\">{{trackingData.pickup_date | date : \"medium\"}}</span></md-card-content></md-card><md-card flex=\"\"><div layout=\"\" md-whiteframe=\"2\" layout-align=\"center center\" class=\"md-padding\" style=\"background: #5c3fff;\"><div layout=\"\" layout-align=\"center center\"><md-icon class=\"white-text\">pin_drop</md-icon></div><span class=\"md-caption white-text bold-text\" style=\"margin-left: 4px;\">Destination</span></div><md-divider></md-divider><md-card-content layout=\"\" layout-align=\"center center\"><span class=\"md-body-1 center-text\">{{trackingData.destination}}</span></md-card-content></md-card></section><section layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><div flex-gt-sm=\"66\" flex=\"100\" layout=\"\" layout-align=\"stretch stretch\"><md-card flex=\"\"><div layout=\"\" layout-align=\"center center\" class=\"md-padding\"><div layout=\"\" layout-align=\"center center\"><md-icon>history</md-icon></div><span class=\"md-caption bold-text\" style=\"margin-left: 4px;\">History</span></div><md-divider></md-divider><div layout=\"column\" ng-if=\"trackingData.history.length > 0\" class=\"timeline md-margin\" layout-padding=\"\"><div class=\"timeline-item\" ng-repeat=\"history in trackingData.history | orderBy:\'-date\'\" layout=\"column\" style=\"position: relative; margin-left: 20px\"><md-icon style=\"color : green; position: absolute; left: -7px; top: 15px; width: 12px; min-width: 12px; height: 12px; min-height: 12px; font-size: 12px;\">lens</md-icon><span class=\"md-body-1 bold-text\" style=\"margin-left: 10px;\">{{capitalize(history.activity)}}</span> <span class=\"grey-text\" style=\"font-size: 12px; margin-left: 15px; margin-top: 5px;\">{{ history.location}}</span> <span class=\"grey-text bold-text\" style=\"font-size: 10px; margin-left: 15px; margin-top: 5px; font-style: italic;\">{{ history.date | date : \"medium\"}}</span></div></div></md-card></div><div flex=\"\" layout=\"\"><md-card flex=\"\"><div layout=\"\" layout-align=\"center center\" class=\"md-padding\"><div layout=\"\" layout-align=\"center center\"><md-icon>info_outline</md-icon></div><span class=\"md-caption bold-text\" style=\"margin-left: 4px;\">Shipment Information</span></div><md-divider></md-divider><md-card-content><table><tr><th class=\"md-caption grey-text\">Consignee Name</th><td class=\"md-caption\">{{trackingData.consignee_name}}</td></tr><tr><th class=\"md-caption grey-text\">Consignee Address</th><td class=\"md-caption\">{{trackingData.consignee_address}}</td></tr><tr><th class=\"md-caption grey-text\">Origin</th><td class=\"md-caption\">{{trackingData.origin}}</td></tr><tr><th class=\"md-caption grey-text\">Service</th><td class=\"md-caption\">{{trackingData.service}}</td></tr><tr><th class=\"md-caption grey-text\">Shipment Type</th><td class=\"md-caption\">{{trackingData.shipment_type}}</td></tr><tr><th class=\"md-caption grey-text\">Weight</th><td class=\"md-caption\">{{trackingData.weight}}</td></tr><tr><th class=\"md-caption grey-text\">Package Count</th><td class=\"md-caption\">{{trackingData.packages}}</td></tr></table></md-card-content></md-card></div></section></div><div ng-if=\"!fetchingTracking && !trackingData.status\" layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><md-icon class=\"md-warn\">error</md-icon><span class=\"md-caption\">{{trackingData.message}}</span></div></md-dialog-content></md-dialog></div></div>");
$templateCache.put("app/modules/orders/orderDetails/partials/viewMeasurementsDialog.html","<div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"viewMeasurementsDialogs\"><md-dialog flex=\"50\"><md-toolbar><div layout=\"\" layout-align=\"space-between center\" class=\"md-toolbar-tools md-accent\"><h3>Measurements For {{measurementProduct.product ? measurementProduct.product.name : measurementProduct.name}}</h3><md-button class=\"md-icon-button\" ng-click=\"cancel();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-progress-linear ng-if=\"loadingSizeCharts\"></md-progress-linear><md-dialog-content class=\"md-dialog-content\" ng-if=\"!loadingSizeCharts\"><form name=\"measurementEditForm\"><md-card><div layout=\"\" layout-align=\"space-between center\" style=\"margin: 0 8px\"><h4 class=\"center-text\">User Measurements (Selected Size : {{measurementProduct.selectedVariationText}})</h4><md-switch ng-model=\"$parent.editMeasurements\" ng-if=\"!disableEdit\">Edit</md-switch></div><md-table-container dnd-list=\"measurements\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"measurement in measurements\" dnd-draggable=\"measurement\" dnd-disable-if=\"!editMeasurements\" dnd-moved=\"measurements.splice($index, 1)\" dnd-effect-allowed=\"move\"><td md-cell=\"\" style=\"width: 50px\"><md-icon style=\"margin: 0 4px\" class=\"drag-pointer\" ng-if=\"editMeasurements\">drag_handle</md-icon></td><td md-cell=\"\"><p ng-if=\"!editMeasurements\">{{ measurement.key }}</p><input type=\"text\" ng-model=\"measurement.key\" ng-if=\"editMeasurements\"></td><td md-cell=\"\" style=\"text-align: right\"><div layout=\"\" class=\"md-secondary\"><p class=\"value\" ng-if=\"!editMeasurements\">{{ measurement.value}}</p><input required=\"\" min=\"0\" type=\"number\" ng-model=\"measurement.value\" ng-if=\"editMeasurements\" style=\"width: 75px; text-align: end\"><md-button class=\"md-icon-button small md-primary\" ng-click=\"appendMeasurement($index)\" ng-if=\"editMeasurements\"><md-icon>add</md-icon><md-tooltip>Add Measurement in Next Row</md-tooltip></md-button><md-button class=\"md-icon-button small md-warn\" ng-click=\"deleteMeasurement($index)\" ng-if=\"editMeasurements\"><md-icon>delete</md-icon><md-tooltip>Delete Measurement</md-tooltip></md-button></div></td></tr></tbody></table></md-table-container><md-divider></md-divider><div ng-show=\"editMeasurements && !disableEdit\" layout=\"\" layout-align=\"space-between center\" class=\"md-padding\"><md-checkbox ng-model=\"updateMeasurementData\" ng-change=\"updateMeasurementForAllValue(updateMeasurementData)\">Update same size values for all the Products in this order</md-checkbox><md-button ng-click=\"updateMeasurements()\" class=\"outline\" ng-disabled=\"measurementEditForm.$invalid|| updatingMeasurements\"><span ng-if=\"!updatingMeasurements\">Save</span><bubble-loader ng-if=\"updatingMeasurements\"></bubble-loader></md-button></div><div layout=\"\" layout-align=\"space-between center\" style=\"margin: 0 8px\"><h4>System Size Chart For Size : {{measurementProduct.selectedVariationText}}</h4><md-select ng-model=\"sizeChartGroupSelected\" placeholder=\"Select Size Chart\"><md-option ng-repeat=\"sizeChart in sizeCharts\" ng-value=\"sizeChart\">{{sizeChart.name}}</md-option></md-select></div><md-list ng-if=\"sizeChartGroupSelected\"><md-list-item dnd-draggable=\"measurement\" dnd-effect-allowed=\"copy\" dnd-disable-if=\"!editMeasurements\" ng-repeat=\"measurement in getMeasurementForSizeChart(sizeChartGroupSelected, measurementProduct.selectedVariationText)\"><p>{{ measurement.key }}</p><p class=\"md-secondary\">{{ measurement.value }}</p><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></md-card></form></md-dialog-content></md-dialog></div></div>");
$templateCache.put("app/modules/orders/orderDetails/rate-calculator/rate-calculator.html","<md-dialog aria-label=\"cancel order dialog\" flex=\"50\" class=\"package-manager-dialog\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h5>{{fetchingRates ? \'Loading Shipping Modes...\' : \'Select Shipment Mode\'}}</h5><md-button class=\"md-icon-button\" ng-click=\"cancel();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-progress-linear ng-if=\"fetchingRates\"></md-progress-linear><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\" ng-show=\"!fetchingRates\"><md-radio-group ng-model=\"selectedMode\"><md-list class=\"md-2-line\"><md-list-item><p class=\"md-caption grey-text\">Shipping Mode</p><p class=\"md-secondary md-caption grey-text\">Estimated Price</p></md-list-item><md-list-item ng-repeat=\"rate in rates\" ng-disabled=\"!rate.serviceable\"><p ng-class=\"{\'grey-text\' : !rate.serviceable}\">{{rate.modeKey}} <span class=\"md-caption\">{{!rate.serviceable ? \'(Not Serviceable)\' : \'\'}}</span></p><div layout=\"\" class=\"md-secondary\"><span class=\"md-title bold-text\" ng-class=\"{\'grey-text\' : !rate.serviceable}\" style=\"margin-right: 20px\">₹ {{rate.price}}</span><md-radio-button style=\"margin-bottom: 0\" ng-disabled=\"!rate.serviceable\" ng-value=\"rate.modeKey\"></md-radio-button></div></md-list-item></md-list></md-radio-group></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\" ng-if=\"!fetchingRates\"><md-button class=\"md-warn\" ng-click=\"cancel();\">Cancel</md-button><md-button class=\"md-accent outline\" ng-click=\"save($event)\"><div layout=\"\" layout-align=\"center center\"><div ng-if=\"!creatingShipment\">Save</div><md-progress-circular md-diameter=\"20\" class=\"md-accent\" ng-if=\"creatingShipment\"></md-progress-circular></div></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/orders/orderDetails/updateStock-dialog/updateStock.tmpl.html","<md-dialog flex=\"50\" class=\"update-stock\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">Update Stock</span><md-button class=\"md-icon-button\" ng-click=\"close();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><section layout=\"column\" layout-align=\"center center\"><div layout=\"\" layout-align=\"space-between center\"><md-switch ng-model=\"newStock.editingExistingPiece\" aria-label=\"Editing Existing Piece\" class=\"md-primary\">Editing Existing Piece</md-switch></div><div layout=\"\" layout-align=\"center center\" class=\"update-stock-dialog-container md-whiteframe-1dp\"><img ng-src=\"{{ mediaUrl + lineItem.image.urls.thumbnail }}\" class=\"update-stock-dialog-lineItem-image\"><div layout=\"\" layout-align=\"center center\" class=\"md-padding md-margin\"><p class=\"md-body-2\">{{lineItem.name}}</p><br><p class=\"md-body-1\">Current Stock: {{currentStock}}</p></div></div><div layout=\"\" layout-align=\"center center\" class=\"update-stock-dialog-description md-margin md-padding\"><md-input-container flex=\"100\"><label>Description</label> <textarea ng-model=\"newStock.description\" rows=\"3\" required=\"\">\n                    </textarea></md-input-container></div></section></md-dialog-content><md-divider></md-divider><md-dialog-actions><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-warn md-raised\" ng-click=\"close()\">Cancel</md-button><span flex=\"\"></span><md-button class=\"md-primary md-raised\" ng-disabled=\"isUpdating\" ng-click=\"updateStock()\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!isUpdating\">Update</span><bubble-loader ng-if=\"isUpdating\"></bubble-loader></div></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/orders/orderDetails/updateStock-dialog/updated-response.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><span class=\"md-title\">Out of Stock Notice</span></div></md-toolbar><md-dialog-content class=\"md-dialog-content\"><p>After the stock update, the <span ng-if=\"productOos && variationOos\">product and the variation have</span> <span ng-if=\"productOos\">product has</span> <span ng-if=\"variationOos\">variation has</span> been made out of stock. Please review the changes in the quick view dialog.</p><div layout=\"\" layout-align=\"center center\"><table md-table=\"\"><tbody md-body=\"\"><tr ng-if=\"productOos\" md-row=\"\"><td md-cell=\"\">Product</td><td md-cell=\"\">Out Of Stock</td><td md-cell=\"\"><md-icon class=\"green-text\">check_circle</md-icon></td></tr><tr ng-if=\"variationOos\" md-row=\"\"><td md-cell=\"\">Variation</td><td md-cell=\"\">Out Of Stock</td><td md-cell=\"\"><md-icon class=\"green-text\">check_circle</md-icon></td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button ng-click=\"cancel()\">Cancel</md-button><md-button ng-click=\"hide(true)\">Show the product</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/pages/add/partials/index.html","<div><div layout=\"\" layout-align=\"center center\"><h1>{{editingMode ? \"Edit Page\" : \"Add New Page\"}}</h1></div><form name=\"pageForm\"><section layout=\"column\" layout-gt-sm=\"row\"><md-card flex=\"70\" flex-order=\"2\" flex-order-gt-sm=\"1\"><div layout=\"\" layout-align=\"center center\"><h4>Page Information</h4></div><md-divider></md-divider><md-card-content><section layout=\"column\"><md-input-container md-no-float=\"\" class=\"md-block\"><label>Page Title</label> <input type=\"text\" ng-model=\"page.title\" required=\"\"></md-input-container><md-input-container md-no-float=\"\" class=\"md-block\"><label>Page Slug</label> <input type=\"text\" ng-model=\"page.slug\" required=\"\"></md-input-container><div layout=\"\"><md-input-container class=\"md-block\" flex=\"50\"><label>Seo Title</label> <input type=\"text\" ng-model=\"page.seo.title\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Seo Keywords</label> <input type=\"text\" ng-model=\"page.seo.keywords\"></md-input-container></div><md-input-container class=\"md-block\"><label>Seo Description</label> <textarea rows=\"3\" ng-model=\"page.seo.description\"></textarea></md-input-container></section></md-card-content></md-card><md-card flex=\"30\" flex-order=\"1\" flex-order-gt-sm=\"2\"><div layout=\"\" layout-align=\"center center\"><h4>Page Actions</h4></div><md-divider></md-divider><md-card-content><div layout=\"column\" layout-align=\"center center\" layout-margin=\"\"><table md-table=\"\" ng-if=\"editingMode\"><tr><th><span class=\"md-tiny\">Created At</span></th><td><span class=\"md-caption\">{{page.createdAt | date : \"medium\"}}</span></td></tr><tr><th><span class=\"md-tiny\">Created By</span></th><td><span class=\"md-caption\">{{page.createdBy.name}}</span></td></tr><tr><th><span class=\"md-tiny\">Last Edit</span></th><td><span class=\"md-caption\">{{page.updatedAt | date : \"medium\"}}</span></td></tr><tr><th><span class=\"md-tiny\">Last Edit By</span></th><td><span class=\"md-caption\">{{page.editBy.name}}</span></td></tr><tr><th><span class=\"md-tiny\">Revisions</span></th><td><a class=\"md-caption pointer\">{{page.edits.length}}</a></td></tr></table><md-button class=\"md-raised md-warn\" style=\"width: 150px\" ng-if=\"editingMode\" ng-disabled=\"promise.$$state.pending\"><div layout=\"\" layout-align=\"center center\"><md-progress-circular md-diameter=\"12\" ng-if=\"deletePromise.$$state.pending\"></md-progress-circular><span>Move to Trash</span></div></md-button><md-button class=\"md-raised md-accent\" ng-click=\"savePage();\" style=\"width: 150px\" ng-disabled=\"pageForm.$invalid || promise.$$state.pending\"><div layout=\"\" layout-align=\"center center\"><md-progress-circular md-diameter=\"12\" ng-if=\"promise.$$state.pending\"></md-progress-circular><span>{{editingMode ? \"Update Page\" : \"Save Page\"}}</span></div></md-button></div></md-card-content></md-card></section><md-card><div layout=\"\" layout-align=\"center center\"><h4>Page Content</h4></div><md-divider></md-divider><md-card-content><div layout=\"\" layout-align=\"end center\"><md-switch ng-model=\"showHtml\">Show Advanced Html Editor</md-switch></div><div layout=\"\" layout-align=\"stretch center\"><md-input-container class=\"md-block\" flex=\"\"><text-angular ng-model=\"page.content\" takeepstyles=\"true\" required=\"\"></text-angular></md-input-container><md-card ng-if=\"showHtml\" flex=\"\" class=\"CodeMirror-container\"><md-card-content><ui-codemirror ui-codemirror-opts=\"$parent.codeMirrorOptions\" flex=\"\" ng-model=\"page.content\" style=\"height: inherit\"></ui-codemirror></md-card-content></md-card></div></md-card-content></md-card></form></div>");
$templateCache.put("app/modules/pages/all/partials/index.html","<div layout=\"column\"><section layout=\"\" layout-align=\"center center\"><h1>All Static Pages</h1></section><md-card><md-card-content><md-table-container><div layout=\"row\" layout-margin=\"\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-block\"><md-icon>search</md-icon><input type=\"search\" placeholder=\"Search for pages here\" ng-model=\"query.search\" ng-model-options=\"{\'debounce\' : 200}\" ng-change=\"getPages()\"></md-input-container></div><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.sort\" md-on-reorder=\"getPages\"><tr md-row=\"\"><th md-column=\"\">#</th><th md-column=\"\" md-order-by=\"title\">Title</th><th md-column=\"\" md-order-by=\"slug\">Slug</th><th md-column=\"\" md-order-by=\"createdBy\">Created By</th><th md-column=\"\" md-order-by=\"updatedAt\" md-numeric=\"\">Last Edit</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"product\" md-auto-select=\"\" ng-repeat=\"page in pages\"><td md-cell=\"\">{{$index + 1 }}.</td><td md-cell=\"\">{{page.title}}</td><td md-cell=\"\">{{page.slug}}</td><td md-cell=\"\">{{page.createdBy.name}}</td><td md-cell=\"\"><span class=\"md-caption\">{{page.updatedAt | date : \"medium\"}}</span></td><td md-cell=\"\"><span layout=\"row\"><md-button class=\"md-icon-button\" ui-sref=\"app.pages.edit({id: page._id})\" ng-click=\"$event.stopPropagation();\"><md-icon>edit</md-icon><md-tooltip md-direction=\"bottom\">Edit Page</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"$event.stopPropagation();\" ui-sref=\"app.pages.edit({id: page._id})\" target=\"_blank\"><md-icon>open_in_new</md-icon><md-tooltip md-direction=\"bottom\">Open in new tab</md-tooltip></md-button></span></td></tr></tbody></table></md-table-container><md-table-pagination mdboundarylinks=\"\" md-limit=\"query.limit\" md-limit-options=\"[5, 10, 25, 50,100]\" md-page=\"query.page\" md-total=\"{{total}}\" md-on-paginate=\"getPages\" md-page-select=\"\"></md-table-pagination></md-card-content></md-card></div>");
$templateCache.put("app/modules/products/addProducts/partials/add.html","<style>\n    .tab-content {\n        min-height: 50vh;\n    }\n\n    .red-text {\n        color: red !important;\n    }\n\n    .orange-text {\n        color: orange !important;\n    }\n</style><md-subheader md-whiteframe=\"1\" class=\"md-table-toolbar no-padding product-navbar\"><div layout=\"\" layout-align=\"center center\"><md-nav-bar md-selected-nav-item=\"currentNavItem\" style=\"overflow-y: scroll\"><md-nav-item md-nav-click=\"goto(\'app.products.add.home\', 0)\" name=\"general_information\" aria-label=\"general_information\" class=\"md-primary\">General Information</md-nav-item><md-nav-item ng-if=\"editingMode\" md-nav-click=\"goto(\'app.products.add.categories\', 1)\" name=\"categories\" aria-label=\"categories\">Categories</md-nav-item><md-nav-item ng-if=\"editingMode\" md-nav-click=\"goto(\'app.products.add.images\', 2)\" name=\"images\" aria-label=\"images\">Images</md-nav-item><md-nav-item ng-if=\"editingMode\" md-nav-click=\"goto(\'app.products.add.attributes\', 3)\" name=\"attributes\" aria-label=\"attributes\">Attributes</md-nav-item><md-nav-item ng-if=\"editingMode\" md-nav-click=\"goto(\'app.products.add.variations\', 4)\" name=\"variations\" aria-label=\"variations\">Variations</md-nav-item><md-nav-item md-nav-click=\"goto(\'app.products.add.customisation\', 5)\" ng-if=\"editingMode && (product.productType == 1)\" name=\"customisation\" aria-label=\"customisation\">Customisation</md-nav-item><md-nav-item ng-if=\"editingMode\" md-nav-click=\"goto(\'app.products.add.packaging\', 6)\" name=\"delivery\" aria-label=\"delivery\">Delivery</md-nav-item><md-nav-item ng-if=\"editingMode\" md-nav-click=\"goto(\'app.products.add.finish\', 7)\" name=\"finish\" aria-label=\"finish\">Finish</md-nav-item></md-nav-bar></div></md-subheader><md-button class=\"md-raised md-primary\" ng-click=\"openPreviewDialog($event)\" style=\"position: fixed; bottom: 20px; right: 20px\" aria-label=\"upload photo\"><md-icon>blur_circular</md-icon><span>Preview Product</span></md-button><div ui-view=\"\" style=\"min-height: 60vh; padding-bottom: 100px\"></div><md-card class=\"md-primary product-note\" md-whiteframe=\"16\"><section ng-click=\"showChat = !showChat\" class=\"pointer\" layout=\"\" layout-align=\"space-between center\" style=\"padding: 6px\"><div layout=\"\" layout-align=\"center center\"><span><md-icon class=\"md-accent\" style=\"margin-left: 8px\">speaker_notes</md-icon></span> <span class=\"md-body-1 bold-text\" style=\"margin-left: 8px\">Product Notes ({{product.notes ? product.notes.length : 0}})</span></div><md-button class=\"md-icon-button md-primary\"><md-icon>{{showChat ? \'keyboard_arrow_down\' : \'keyboard_arrow_up\'}}</md-icon></md-button></section><div ng-show=\"showChat\"><md-divider></md-divider><md-card-content class=\"message-content-wrapper\"><md-list class=\"md-2-line\" ng-if=\"product.notes && product.notes.length\"><md-list-item ng-repeat=\"note in product.notes\" class=\"message-full-wrapper\" ng-class=\"{\'align-left\' : note.by !== currentUser._id, \'align-right\' : note.by === currentUser._id}\"><div class=\"message\" ng-class=\"{\'others\' : note.by !== currentUser._id, \'me\' : note.by === currentUser._id}\" layout=\"column\"><p class=\"comment\" mention-text=\"\" comment=\"note.comment\"></p><section layout=\"\" layout-align=\"space-between center\"><span class=\"md-tiny\">By {{note.byName}}</span> <span class=\"md-tiny date\" ng-if=\"!note.saving && !note.error\">{{dateAgo(note.date) }}</span><md-icon class=\"bug-icon\" ng-if=\"!note.saving && note.error\">bug</md-icon><bubble-loader class=\"save-loader\" ng-if=\"note.saving\"></bubble-loader></section></div></md-list-item></md-list><div layout=\"column\" layout-align=\"center center\" ng-if=\"!product.notes || !product.notes.length\"><img src=\"assets/images/blank.svg\" style=\"width: 100px; height: auto;\"><p>No Comments Yet</p></div></md-card-content><md-divider></md-divider><md-card-actions layout=\"\" layout-align=\"stretch center\" class=\"relative\"><md-input-container class=\"no-error-spacer ui-mention-container\" flex=\"\" md-no-float=\"\"><textarea ui-mention=\"\" aarida-mentions=\"\" rows=\"2\" ng-model=\"message\" placeholder=\"Comment\"></textarea><div class=\"mention-highlight\"></div><md-list class=\"dropdown md-2-line md-whiteframe-1dp\" ng-if=\"$mention.choices.length\"><md-list-item ng-if=\"$mention.loading\"><bubble-loader></bubble-loader></md-list-item><md-list-item ng-repeat-start=\"choice in $mention.choices\" ng-class=\"{active:$mention.activeChoice==choice}\" ng-click=\"$mention.select(choice)\"><div class=\"md-list-item-text\" layout=\"column\"><span class=\"name\">{{::choice.name}}</span> <span class=\"md-caption email\">{{::choice.email}}</span></div></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list></md-input-container><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-icon-button md-primary md-fab md-mini\" ng-click=\"publishNote()\"><md-icon>send</md-icon></md-button></div></md-card-actions></div></md-card><script type=\"text/ng-template\" id=\"errorDialog.html\"><md-dialog class=\"relative\" flex=\"70\"> <md-button class=\"md-icon-button\" style=\"position: absolute; top: 8px; right: 8px;\" ng-click=\"cancel();\"> <md-icon class=\"white-text\">close</md-icon> </md-button> <img src=\"assets/images/error.svg\"> <md-dialog-content class=\"md-padding\"> <h3 class=\"center-text\">Errors</h3> <ol> <li ng-repeat=\"err in error\"> <p>{{err}}</p> </li> </ol> </md-dialog-content> <md-dialog-actions> <md-button ng-click=\"cancel();\" class=\"md-warn\"> Okay ! </md-button> </md-dialog-actions> </md-dialog></script>");
$templateCache.put("app/modules/products/allProducts/partials/all.html","<div layout=\"row\" layout-align=\"center start\"><div flex=\"\"><div layout=\"\" class=\"collections-row\"><md-card ng-repeat=\"collection in collections track by collection._id\" ng-class=\"{\'active\' : collection.selected}\" ng-click=\"applyCollection(collection)\" class=\"collectionCards pointer\"><md-card-content layout=\"\" layout-align=\"center center\" class=\"relative\"><span class=\"md-caption bold-text\">{{collection.name}}</span><attached-tag class=\"md-tiny\" ng-class=\"public-tag\" ng-if=\"collection.public\"><tag-content>Public</tag-content></attached-tag></md-card-content><md-divider></md-divider><div layout=\"\" layout-align=\"space-between center\" class=\"md-padding\"><bubble-loader ng-if=\"collection.loadingTotal\"></bubble-loader><span class=\"md-tiny\" ng-if=\"!collection.loadingTotal\">{{collection.total}} products</span> <span class=\"md-tiny\">{{collection.rules.queries.length ? collection.rules.queries.length + \' rules\' : \'No Rules\'}}</span></div></md-card></div><section class=\"white\"><md-subheader><div layout=\"\"><form role=\"form\" novalidate=\"\" name=\"filterForm\" ng-submit=\"getProducts()\" flex-gt-sm=\"30\" flex=\"100\" layout=\"\" layout-align=\"center center\"><md-input-container flex=\"\" class=\"no-error-spacer\" ng-if=\"!filters.showNewSearch\"><md-icon>search</md-icon><label>&nbsp;</label> <input ng-blur=\"getProducts()\" type=\"text\" style=\"border-bottom-color: rgba(29,29,29,0.87);\" id=\"search-bar\" ng-model=\"filters.searchTerm\" select-on-click=\"\" ng-model-options=\"{\'debounce\' : 500}\" ng-keypress=\"keyAction($event)\" placeholder=\"Search For Products\"></md-input-container><md-button type=\"submit\" class=\"md-raised md-primary\" ng-if=\"!filters.showNewSearch\">Search</md-button><md-autocomplete md-selected-item=\"selectedItem\" md-search-text=\"filters.searchTerm\" md-menu-class=\"product-autocomplete-results\" md-delay=\"100\" md-min-length=\"3\" flex=\"\" md-input-id=\"search-bar\" class=\"product-autocomplete\" ng-if=\"filters.showNewSearch\" placeholder=\"Search for Products\" md-item-text=\"item.name\" md-selected-item-change=\"filters.searchTerm = selectedItem.sku; getProducts()\" md-items=\"item in searchProducts(filters.searchTerm)\"><md-item-template><div layout=\"\" layout-align=\"stretch center\"><md-img md-src=\"{{item.featured_image.urls.thumbnail}}\" class=\"search-image\"></md-img><div layout=\"column\"><p md-highlight-flags=\"ig\" md-highlight-text=\"searchText\">{{item.name}} ({{item.sku}}) - &#8377; {{item.price}}</p></div><span flex=\"20\"></span></div></md-item-template></md-autocomplete></form><div flex=\"\" layout=\"\" layout-align=\"center center\" class=\"md-tiny\"><section><i class=\"md-caption\" ng-if=\"filters.query && filters.query.length && !collectionSelected\">Showing filtered results. Save Filter As Collection?</i><md-button class=\"md-primary md-raised\" ng-click=\"saveFiltersAsCollections($event)\" ng-if=\"filters.query && filters.query.length && !collectionSelected\"><span class=\"md-caption\">Save</span></md-button></section></div><div ng-if=\"selected.length\" layout=\"\" layout-align=\"space-between center\" flex=\"\" flex-sm=\"100\" flex-xs=\"100\" ng-show=\"selected.length > 0\"><md-button class=\"md-icon-button\" ng-click=\"clearSelected()\"><md-icon>close</md-icon></md-button><p>{{selected.length}} items selected</p><md-select ng-model=\"bulk.actionModel\" flex=\"50\" placeholder=\"Select Action :\" style=\"margin-left: 10px; margin-right: 10px;\"><md-option ng-value=\"action.id\" ng-repeat=\"action in singleActions\" ng-if=\"selected.length === 1\">{{ action.title }}</md-option><md-option ng-value=\"action.id\" ng-repeat=\"action in actions\">{{ action.title }}</md-option></md-select><md-button class=\"md-raised md-primary\" ng-click=\"performSmartAction($event)\">GO</md-button></div><div ng-if=\"!selected.length\" layout=\"\" layout-align=\"end center\"><md-button class=\"md-warn\" ng-click=\"resetFilters()\" ng-if=\"filters.query && filters.query.length\"><span class=\"md-caption\">Clear Filters</span></md-button><md-switch ng-model=\"filters.showNewSearch\">New Search Interface</md-switch><md-button class=\"md-primary\" ng-click=\"getProducts()\" aria-label=\"filter_list\"><md-icon>refresh</md-icon><span>Refresh</span></md-button><md-button class=\"md-primary\" ng-click=\"showFilterDialog($event)\" aria-label=\"filter_list\"><attached-tag tag-type=\"dot\" ng-if=\"filters.query && filters.query.length\"></attached-tag><md-icon>filter_list</md-icon><span>Filters</span></md-button></div></div></md-subheader><md-table-pagination md-limit=\"filters.limit\" md-limit-options=\"limitOptions\" md-page=\"filters.page\" md-page-select=\"\" md-total=\"{{total}}\" md-on-paginate=\"getProducts\"></md-table-pagination><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"filters.orderBy\" md-on-reorder=\"getProducts\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\"></th><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\" md-order-by=\"name\"><span>Name</span></th><th md-column=\"\"><span>Categories</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"price\"><span>Price (Rs.)</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"outOfStock\"><span>Stock/Published</span></th><th md-column=\"\" md-order-by=\"productType\"><span>Product Type</span></th><th md-column=\"\"><span>Variants</span></th><th md-column=\"\" md-order-by=\"updatedAt\"><span>Last Update</span></th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"product\" md-auto-select=\"\" ng-repeat=\"product in products\" style=\"height: 75px;\"><td md-cell=\"\">{{(((filters.page - 1) * filters.limit) + $index) + 1}}.</td><td md-cell=\"\" ng-class=\"{\'error-container\' : product.hasError}\"><md-icon class=\"info-icon\" ng-class=\"{\'error md-warn\' : product.hasError}\">{{product.hasError ? \'error\' : \'done_all\'}}<md-tooltip>{{product.hasError ? product.errors : \'Everything looks great!\'}}</md-tooltip></md-icon></td><td md-cell=\"\"><md-img class=\"product-image pointer\" ng-click=\"quickViewProduct($event, product)\" md-src=\"{{product.featured_image.urls.thumbnail}}\"></md-img></td><td md-cell=\"\"><div layout=\"\" layout-align=\"start center\"><a ng-click=\"$event.stopPropagation()\" ui-sref=\"app.products.add.home({slug: product._id, name: product.name})\" class=\"md-body-2 md-truncate pointer\">{{properName(product.name)}}</a><md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-click=\"$event.stopPropagation(); showToast(\'Copied Product Name to Clipboard\')\" data-clipboard-text=\"{{properName(product.name)}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy Product Name</md-tooltip></md-button></div><div layout=\"\" layout-align=\"start center\"><span class=\"md-caption grey-text\">{{product.sku}}</span><md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-click=\"$event.stopPropagation(); showToast(\'Copied SKU to Clipboard\')\" data-clipboard-text=\"{{product.sku}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy SKU</md-tooltip></md-button></div></td><td md-cell=\"\"><span class=\"md-caption\" ng-repeat=\"category in product.categories\">{{category.name}}<span class=\"md-caption\" ng-if=\"!$last\">,</span></span></td><td md-cell=\"\"><s class=\"md-caption\" ng-if=\"product.isOnSale\">{{ \"Rs. \" + product.mrp}}</s><br><span class=\"md-body-2\">{{ \"Rs. \" + product.price}}</span></td><td md-cell=\"\"><md-icon ng-if=\"product.outOfStock\" style=\"color: #a82930\">close</md-icon><md-icon ng-if=\"!product.outOfStock\" style=\"color: #6ebc61\">check</md-icon><md-icon ng-if=\"!product.published\" style=\"color: #a82930\">close</md-icon><md-icon ng-if=\"product.published\" style=\"color: #6ebc61\">check</md-icon></td><td md-cell=\"\">{{getProductType(product);}}</td><td md-cell=\"\"><a ng-click=\"$event.stopPropagation()\" ng-if=\"product.variations\" ui-sref=\"app.products.add.variations({slug: product._id, name: product.name})\" class=\"md-body-2 md-truncate pointer\">{{product.variations.length}}</a> <a ng-click=\"$event.stopPropagation()\" ng-if=\"!product.variations\" ui-sref=\"app.products.add.variations({slug: product._id, name: product.name})\" class=\"md-body-2 md-truncate pointer md-warn\">0</a></td><td md-cell=\"\"><span class=\"md-tiny grey-text\">{{product.updatedAt | date : \'medium\'}}</span></td><td md-cell=\"\"><div layout=\"\" layout-align=\"center center\"><md-button ng-click=\"quickViewProduct($event, product)\" class=\"md-icon-button\"><md-icon class=\"md-primary\">poll</md-icon><md-tooltip>Quick View</md-tooltip></md-button><md-button ng-click=\"$event.stopPropagation()\" ui-sref=\"app.products.add.home({slug: product._id, name: product.name})\" class=\"md-icon-button\"><md-icon class=\"md-primary\">edit</md-icon><md-tooltip>Edit Product</md-tooltip></md-button><md-button ng-click=\"openDetailsPage(product, 1, $event);\" class=\"md-icon-button\"><md-icon class=\"md-primary\">open_in_new</md-icon><md-tooltip>Edit Product in New Tab</md-tooltip></md-button><md-button ng-if=\"!product.duplicating\" class=\"md-icon-button md-primary\" ng-click=\"showDuplicationConfirmation(product, $event);\"><div layout=\"\" layout-align=\"center center\"><section ng-if=\"!product.duplicating\"><md-icon>content_copy</md-icon></section><md-progress-circular md-diameter=\"20\" ng-if=\"product.duplicating\"></md-progress-circular></div><md-tooltip md-direction=\"bottom\">Duplicate the product and Start editing</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"moveToTrash(product, $index, $event);\"><md-icon class=\"red-text\">delete</md-icon><md-tooltip md-direction=\"bottom\">Move to Trash</md-tooltip></md-button></div></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"filters.limit\" md-limit-options=\"limitOptions\" md-page=\"filters.page\" md-page-select=\"\" md-total=\"{{total}}\" md-on-paginate=\"getProducts\"></md-table-pagination></section></div><md-card flex=\"30\" ng-if=\"showFilters\"><md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" md-ink-ripple=\"\" ng-click=\"$parent.showFilters = !$parent.showFilters;\"><md-icon>close</md-icon></md-button><h3>Filters</h3><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"getProducts()\"><span>Apply</span></md-button></div></md-toolbar><section ng-include=\"\'productFilters\'\"></section></md-card></div><script id=\"scannerDialog\" type=\"text/ng-template\"><md-dialog flex=\"70\"> <md-toolbar> <div class=\"md-toolbar-tools\" layout layout-align=\"space-between center\"> <h3>Scanner</h3> <md-button ng-click=\"cancel();\" class=\"md-icon-button\"> <md-icon>close</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content> <div id=\"scanner-container\"></div> </md-dialog-content> <md-dialog-actions md-colors=\"{\'background\' : \'boring-primary-500-1\'}\"> <div layout layout-align=\"space-between center\" flex> <md-button class=\"md-warn md-raised\" ng-click=\"cancel();\"> Close </md-button> </div> </md-dialog-actions> </md-dialog></script><script id=\"json.html\" type=\"text/ng-template\"><md-dialog flex=\"50\"> <md-toolbar> <div class=\"md-toolbar-tools\" layout layout-align=\"space-between center\"> <h4>Query JSON</h4> <md-button ng-click=\"cancel();\" class=\"md-icon-button\"> <md-icon>close</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content class=\"md-padding md-margin\"> <pre> {{ filters | json }} </pre> </md-dialog-content> </md-dialog></script><script id=\"exportDialog\" type=\"text/ng-template\"><md-dialog flex=\"50\"> <md-toolbar> <div class=\"md-toolbar-tools\" layout layout-align=\"space-between center\"> <h4>Export Data</h4> <md-button ng-click=\"cancel();\" class=\"md-icon-button\"> <md-icon>close</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content class=\"md-padding md-margin\"> <form name=\"exportForm\"> <p>Select the type of export. Explanation of each type mentioned below.</p> <ol> <li> <strong>SIMPLE : </strong> <span>Will export the data with local compliant headers. Can be used for import later.</span> </li> <li> <strong>FOR BARCODE : </strong> <span>Will export the data in csv format.</span> </li> <li> <strong>FOR FLIPKART : </strong> <span>Will export the data with Flipkart Compliant Attributes and Prices.</span> </li> <li> <strong>FOR AMAZON : </strong> <span>Will export the data with Amazon Compliant Attributes and Prices.</span> </li> </ol> <div layout layout-align=\"center center\"> <md-input-container> <label>Select export type : </label> <md-select ng-model=\"exportType\"> <md-option value=\"simple\">Simple</md-option> <md-option value=\"barcode\">For Barcode</md-option> <md-option value=\"flipkart\">Flipkart</md-option> <md-option value=\"amazon\">Amazon</md-option> <md-option value=\"graftale\">Graftale</md-option> <md-option value=\"ecommdesk\">Ecommdesk</md-option> </md-select> </md-input-container> </div> </form> </md-dialog-content> <md-dialog-actions> <div layout layout-align=\"space-between center\" flex> <md-button class=\"md-warn\" ng-click=\"cancel();\"> Close </md-button> <md-button ng-click=\"download($event);\" ng-disabled=\"exportForm.$invalid\"> Export </md-button> </div> </md-dialog-actions> </md-dialog></script>");
$templateCache.put("app/modules/products/attributes/partials/attributes.html","<div layout=\"column\"><md-card><md-subheader class=\"md-table-toolbar md-default white\"><div layout=\"row\"><md-input-container md-no-float=\"\" flex=\"40\" class=\"md-block no-error-spacer md-primary\"><md-icon>search</md-icon><input type=\"search\" placeholder=\"Search For Attributes\" ng-model=\"query.search\" ng-model-options=\"{\'debounce\' : 200}\" ng-change=\"getAllAttributes()\"></md-input-container><span flex=\"\"></span><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-primary outline\" ng-click=\"showDialog($event);\"><md-icon>add</md-icon><span class=\"md-caption bold-text\">Add New Attribute</span></md-button></div></div></md-subheader><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getAllAttributes\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\">Sl</th><th md-column=\"\" md-order-by=\"meta_key\"><span>Attribute Name</span></th><th md-column=\"\" md-order-by=\"meta_values\"><span>Total Values</span></th><th md-column=\"\" md-order-by=\"supportFilters\" md-numeric=\"\">Filterable</th><th md-column=\"\" md-order-by=\"isMandatory\" md-numeric=\"\">Mandatory</th><th md-column=\"\" md-order-by=\"showInProductsPage\" md-numeric=\"\">Products Page</th><th md-column=\"\" md-order-by=\"showAbovePriceBox\" md-numeric=\"\">Above Price Box</th><th md-column=\"\" md-order-by=\"deleted\" md-numeric=\"\">Active</th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"attribute\" md-select-id=\"attribute._id\" md-auto-select=\"\" ng-repeat=\"attribute in attributes\"><td md-cell=\"\">{{(((query.page - 1) * query.limit) + $index) + 1}}.</td><td md-cell=\"\"><a class=\"md-link pointer\" ng-click=\"showDialog($event, attribute, $index)\">{{attribute.meta_key}}</a></td><td md-cell=\"\">{{attribute.meta_values.length}}</td><td md-cell=\"\"><md-icon class=\"red-text\" ng-class=\"{\'green-text\' : attribute.supportFilters}\">{{ attribute.supportFilters ? \'done_all\' : \'close\'}}</md-icon></td><td md-cell=\"\"><md-icon class=\"red-text\" ng-class=\"{\'green-text\' : attribute.isMandatory}\">{{ attribute.isMandatory ? \'done_all\' : \'close\'}}</md-icon></td><td md-cell=\"\"><md-icon class=\"red-text\" ng-class=\"{\'green-text\' : attribute.showInProductsPage}\">{{ attribute.showInProductsPage ? \'done_all\' : \'close\'}}</md-icon></td><td md-cell=\"\"><md-icon class=\"red-text\" ng-class=\"{\'green-text\' : attribute.showAbovePriceBox}\">{{ attribute.showAbovePriceBox ? \'done_all\' : \'close\'}}</md-icon></td><td md-cell=\"\"><md-icon class=\"red-text\" ng-class=\"{\'green-text\' : !attribute.deleted}\">{{ !attribute.deleted ? \'done_all\' : \'close\'}}</md-icon></td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"showDialog($event, attribute, $index);\"><md-icon>edit</md-icon><md-tooltip>Edit Attribute</md-tooltip></md-button><md-button class=\"md-warn md-icon-button\" ng-disabled=\"attribute.deleteLoading\" ng-click=\"openDeleteConfirmDialog($event, attribute, $index)\"><div layout=\"\" layout-align=\"center center\"><md-progress-circular md-diameter=\"20\" ng-if=\"attribute.deleteLoading\"></md-progress-circular><md-icon ng-if=\"!attribute.deleteLoading\">delete</md-icon></div><md-tooltip>Delete Attribute</md-tooltip></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5, 25, 50]\" md-page=\"query.page\" md-total=\"{{totalCount}}\" md-on-paginate=\"getAllAttributes\" md-page-select=\"\"></md-table-pagination></md-card></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"addNewAttributeDialog\"><md-dialog aria-label=\"addNewAttributeDialog block\" flex-gt-sm=\"60\"><form ng-cloak=\"\" name=\"addNewAttributeForm\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\"><h2>{{ editingMode ? \'Edit Attribute\' : \'Add New Attribute\'}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-progress-linear ng-if=\"loadingPlainAttrs || saving\"></md-progress-linear><div style=\"height: 5px; width: 100%\" ng-if=\"!loadingPlainAttrs\"></div><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><div layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><md-input-container class=\"md-block\" flex=\"45\"><label>Name</label> <input required=\"\" ng-minlength=\"3\" type=\"text\" name=\"meta_key\" ng-model=\"newattribute.meta_key\"><div ng-messages=\"addNewAttributeForm.meta_key.$error\"><div ng-message=\"required\">Name is required.</div><div ng-message=\"ng-minlength\">The name has to at least 3 characters long.</div></div></md-input-container><md-input-container class=\"md-block\" flex-offset=\"5\" flex=\"45\"><label>Slug</label> <input required=\"\" ng-minlength=\"3\" type=\"text\" name=\"slug\" ng-model=\"newattribute.slug\"><div ng-messages=\"addNewAttributeForm.slug.$error\"><div ng-message=\"required\">Slug is required.</div><div ng-message=\"ng-minlength\">The slug has to at least 3 characters long.</div></div></md-input-container><md-input-container flex=\"40\"><md-checkbox ng-disabled=\"newattribute.isScopedForVendor\" ng-model=\"newattribute.supportFilters\">Support Filters</md-checkbox></md-input-container><md-input-container flex=\"40\"><md-checkbox ng-model=\"newattribute.allowMultipleSelections\">Allow Multiple Values</md-checkbox></md-input-container><md-input-container flex=\"40\"><md-checkbox ng-disabled=\"newattribute.isScopedForVendor\" ng-model=\"newattribute.showInProductsPage\">Show In Products Page</md-checkbox></md-input-container><md-input-container flex=\"40\"><md-checkbox ng-disabled=\"newattribute.isScopedForVendor\" ng-model=\"newattribute.showAbovePriceBox\">Show Above Price Box</md-checkbox></md-input-container><md-input-container flex=\"40\"><md-checkbox ng-model=\"newattribute.isMandatory\">Mandatory Attribute</md-checkbox></md-input-container><p flex=\"40\" class=\"md-caption grey-text\">If an attribute is marked as mandatory, this attribute will be automatically added to a product.</p><md-input-container flex=\"40\"><md-checkbox ng-change=\"changeOtherSettings()\" ng-model=\"newattribute.isScopedForVendor\">Vendor Attribute</md-checkbox></md-input-container><p flex=\"40\" class=\"md-caption grey-text\">Is this attribute specifically for a Vendor like Flipkart or Amazon? If yes, it will not be displayed on the products page and will only be used to generate vendor specific excel sheets</p><md-input-container flex=\"40\" ng-show=\"newattribute.isScopedForVendor\"><label>Select Vendor Name</label><md-select ng-model=\"newattribute.vendorName\" ng-change=\"changeAttributeName()\"><md-option ng-repeat=\"vendor in vendors | orderBy\" ng-value=\"vendor\">{{vendor}}</md-option></md-select></md-input-container><span flex=\"5\" ng-show=\"newattribute.isScopedForVendor\"></span><md-input-container class=\"no-error-space hints\" flex=\"35\" ng-show=\"newattribute.isScopedForVendor\"><label>Multiple Values Delimeter</label> <input type=\"text\" ng-model=\"newattribute.delimeter\"><div class=\"hint\">Value to set as the seperator when exporting the selected values as a String. For eg, Color -> Red and Blue will be exported as Red::Blue if the delimeter is set to ::. Default is , (comma)</div></md-input-container></div><div class=\"md-padding md-margin\"></div><div layout=\"\" layout-align=\"space-between center\"><h3 class=\"text-center\">Attribute Values ({{newattribute.meta_values.length}} values)</h3><md-switch ng-model=\"newattribute.allowImages\" ng-change=\"askDeleteImagesQuestion()\">Allow Images</md-switch></div><div layout=\"\" layout-wrap=\"\" layout-align=\"space-between center\"><div flex=\"100\" ng-if=\"!newattribute.meta_values.length\" layout=\"\" layout-align=\"center center\"><md-button class=\"md-primary outline round small\" ng-click=\"addValue(-1, $event)\"><md-icon>add</md-icon>Add Attribute Value</md-button></div><div layout=\"\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"100\" md-no-float=\"\"><md-icon>search</md-icon><textarea ng-model=\"searchAttributeText\" placeholder=\"Search for attribute value\"></textarea></md-input-container></div><div flex=\"45\" layout=\"\" layout-align=\"center center\" layout-wrap=\"\" class=\"md-padding attribute-value-container\" ng-if=\"newattribute.meta_values.length > 0\" ng-repeat=\"meta_value in newattribute.meta_values | filter : searchAttributeText track by $index\"><md-input-container class=\"no-error-spacer\" flex=\"\"><textarea rows=\"1\" ng-paste=\"pasteMultipleItems(meta_value, $index)\" type=\"text\" required=\"\" ng-model=\"meta_value.value\" placeholder=\"Value\"></textarea></md-input-container><md-button class=\"md-icon-button\" ng-click=\"addValue($index, $event);\"><md-icon>add</md-icon></md-button><md-button class=\"md-icon-button md-warn\" ng-click=\"removeValue($index);\"><md-icon>close</md-icon></md-button><section flex=\"100\" layout=\"\" layout-align=\"center center\"><md-input-container flex=\"45\"><label>Select Linked Layer</label><md-select ng-model=\"meta_value.linkedAttribute\"><md-option value=\"\">Select Attribute</md-option><md-option ng-value=\"attribute\" ng-repeat=\"attribute in plainAttributes | filter:{isScopedForVendor:false}\">{{attribute.meta_key}}</md-option></md-select></md-input-container><md-input-container flex=\"45\" flex-offset=\"5\"><label>Select Attribute Value</label><md-select aria-label=\"Select Attributes\" md-on-close=\"searchTerm = \'\'\" data-md-container-class=\"selectHeader\" ng-model=\"meta_value.linkedValue\" ng-model-options=\"{trackBy: \'$value\'}\"><md-select-header class=\"select-header\"><input ng-model=\"searchTerm\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search for an option..\" class=\"header-searchbox md-text\"></md-select-header><md-option ng-value=\"meta_value._id\" ng-repeat=\"meta_value in meta_value.linkedAttribute.meta_values | filter: searchTerm | orderBy:\'value\'\">{{ meta_value.value }}</md-option></md-select></md-input-container></section><section flex=\"100\" layout=\"\" layout-align=\"center center\" class=\"md-padding\" ng-if=\"newattribute.allowImages\"><image-selector flex=\"50\" placeholder=\"Select Value Image\" ng-model=\"meta_value.image\"></image-selector></section></div></div></md-dialog-content><md-dialog-actions><md-switch class=\"md-warn\" ng-model=\"newattribute.deleted\">Make Inactive</md-switch><span flex=\"\"></span><md-button ng-disabled=\"addNewAttributeForm.$invalid || saving\" type=\"submit\" class=\"md-raised md-primary\" ng-click=\"saveattribute();\">{{editingMode ? \"Update Attribute\" : \"Create New Attribute\"}}</md-button></md-dialog-actions></form></md-dialog></div></div>");
$templateCache.put("app/modules/products/categories/partials/categories.html","<div layout=\"column\"><section layout=\"column\" ng-if=\"!loading\"><div layout=\"\" class=\"md-padding\"><div class=\"breadcrumb-list\" flex-offset=\"5\"><span class=\"md-title pointer\" ng-class=\"{\'grey-text\' : selectedParent}\" ng-click=\"restore()\">Categories ({{categories.length}})</span> <span class=\"md-title\" ng-show=\"selectedParent\">> {{selectedParent.name}}</span></div><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"addNewCategory()\"><md-icon>add</md-icon><span>Add New Category</span></md-button></div><div layout=\"\"><section flex-offset=\"5\"><span class=\"md-caption\">Parent ({{parentCategories.length}} categories)</span><md-list><md-list-item class=\"pointer category-list-item\" ng-class=\"{\'active\' : category.selected}\" ng-click=\"selectParent(category, $index)\" ng-mouseenter=\"category.showEdit = true\" ng-mouseleave=\"category.showEdit = false\" ng-repeat=\"category in parentCategories\"><md-icon style=\"margin: 0 32px 0 0;\">reorder</md-icon><p>{{category.name}} ({{category.children.length}})</p><md-button class=\"edit-btn\" ng-click=\"editCategory(category, $index, $event);\"><span ng-show=\"category.showEdit\">Edit</span></md-button><md-icon ng-show=\"category.featured\" style=\"margin: 0 32px 0 0;\">star</md-icon><md-icon ng-show=\"!category.featured\" style=\"margin: 0 32px 0 0;\">star_border</md-icon><md-icon style=\"margin: 0 32px 0 0;\">keyboard_arrow_right</md-icon></md-list-item></md-list></section><md-divider style=\"margin: 0 3em\"></md-divider><section flex-offset=\"5\" ng-show=\"selectedParent\"><span class=\"md-caption\">{{selectedParent.name}} ({{selectedParent.children.length}} categories)</span><md-list style=\"min-width: 350px;\"><md-list-item class=\"pointer category-list-item\" ng-class=\"{\'active\' : category.selected}\" ng-mouseenter=\"category.showEdit = true\" ng-mouseleave=\"category.showEdit = false\" ng-repeat=\"category in selectedParent.children\"><md-icon style=\"margin: 0 32px 0 0;\">reorder</md-icon><p>{{category.name}}</p><md-button style=\"margin: 0; padding: 0\" ng-click=\"editCategory(category, $index, $event);\"><span ng-show=\"category.showEdit\">Edit</span></md-button><md-icon ng-show=\"category.featured\" style=\"margin: 0 32px 0 0;\">star</md-icon><md-icon ng-show=\"!category.featured\" style=\"margin: 0 32px 0 0;\">star_border</md-icon></md-list-item></md-list><div layout=\"\" layout-align=\"center center\"><md-button ng-click=\"addSubcategory(selectedParent)\"><md-icon>add</md-icon><span>Add New Subcategory</span></md-button></div></section><section ng-show=\"!selectedParent\" layout=\"column\" layout-align=\"start center\" style=\"margin-left: 50px;\"><img src=\"assets/images/icons/no-category-selected.svg\" style=\"width: 200px; margin-top: 100px; height: auto\"> <span class=\"md-body-1 md-padding\">Select a category from the left menu first</span></section></div></section><section ng-if=\"loading\" layout=\"\" layout-align=\"center center\" style=\"margin-top: 100px\"><md-progress-circular></md-progress-circular></section></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"editCategoryDialog\"><md-dialog flex=\"85\"><form name=\"categoryForm\" flex=\"\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\"><h2>{{ editingMode ? \"Edit \" + newCategory.name : \"Add New Category\"}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\" style=\"color: #181818\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><div layout=\"row\" layout-wrap=\"\" class=\"md-padding\"><md-input-container class=\"md-block\" flex=\"50\"><label>Name</label> <input type=\"text\" ng-model=\"newCategory.name\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Slug</label> <input type=\"text\" ng-model=\"newCategory.slug\"></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>Description</label> <textarea type=\"text\" ng-model=\"newCategory.description\"></textarea></md-input-container><md-input-container class=\"md-block\" flex=\"60\"><label>Parent Category</label><md-select ng-model=\"newCategory.parent\"><md-option ng-repeat=\"category in parentCategories\" ng-value=\"category._id\"><span>{{category.name}}</span></md-option></md-select></md-input-container><md-button class=\"md-icon-button\" flex=\"20\" ng-click=\"newCategory.parent = null\"><md-icon>close</md-icon></md-button><md-input-container class=\"md-block\" flex=\"100\"><label>PAGE Title</label> <input type=\"text\" ng-model=\"newCategory.seo.title\"></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>SEO Description</label> <input type=\"text\" ng-model=\"newCategory.seo.description\"></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>SEO Keywords</label> <input type=\"text\" ng-model=\"newCategory.seo.keywords\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><md-checkbox ng-model=\"newCategory.featured\">Show in Home Page</md-checkbox></md-input-container><div layout=\"row\" layout-align=\"center center\" flex=\"100\"><div flex=\"30\" layout=\"column\" layout-align=\"center center\" layout-margin=\"\"><image-selector flex=\"\" ng-model=\"newCategory.image\" placeholder=\"Select Image\"></image-selector></div><div layout=\"\" flex=\"70\"><image-selector flex=\"\" select=\"header\" view-model=\"h_large\" ng-model=\"newCategory.headerImage\" placeholder=\"Select Header Image\"></image-selector></div></div></div></md-dialog-content><md-dialog-actions><div layout=\"row\" flex=\"\" layout-align=\"space-between center\"><md-button class=\"md-raised md-warn\" ng-click=\"cancel();\"><md-icon>close</md-icon>Cancel</md-button><md-button class=\"md-raised md-primary\" ng-click=\"saveCategory();\"><md-icon>{{editingMode ? \'edit\' : \'add\'}}</md-icon>{{ editingMode ? \"Update\" : \"Add New Category\" }}</md-button></div></md-dialog-actions></form></md-dialog></div></div>");
$templateCache.put("app/modules/products/import/partials/index.html","<div style=\"min-height: 60vh; margin-bottom: 64px;\" class=\"import\"><section ng-if=\"!hasFile\" layout=\"\" layout-fill=\"\" layout-align=\"center center\"><div ngf-drop=\"\" ngf-select=\"\" ng-model=\"$parent.file\" class=\"drag-drop white\" flex=\"\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"false\" ngf-allow-dir=\"false\" layout=\"column\" layout-align=\"center center\"><md-icon>cloud_upload</md-icon><span class=\"md-caption\" style=\"margin-top: 30px;\">Drop images here or click to upload</span></div><div ngf-no-file-drop=\"\">File Drag/Drop is not supported for this browser</div></section><section ng-if=\"hasFile\" layout=\"column\"><md-card><md-card-content><div layout=\"\" layout-align=\"stretch center\"><section layout=\"\" layout-align=\"space-around center\"><span class=\"md-body-2\" style=\"color: #0a6ebd; margin-left: 20px;\">{{file.name}}</span></section><span flex=\"\"></span><section layout=\"\" layout-align=\"center center\"><md-progress-circular style=\"padding: 0 16px;\" class=\"md-warn\" md-diameter=\"20\" ng-if=\"status === \'Reading File..\'\"></md-progress-circular><span class=\"md-body-2\" style=\"padding: 0 16px;\">{{status}}</span><md-button class=\"md-icon-button\" style=\"padding: 0 16px;\" ng-click=\"removeFiles($index);\"><md-icon>close</md-icon></md-button></section></div></md-card-content></md-card></section><md-card ng-if=\"status === \'Ready\'\"><md-subheader md-whiteframe=\"1\"><div layout=\"row\" layout-align=\"space-between center\"><span class=\"md-title\">Import Data</span><md-button class=\"md-raised md-accent\" ng-click=\"import();\" ng-disabled=\"importing\" style=\"width: 200px; margin: 0;\"><section layout=\"\" layout-align=\"center center\"><div layout=\"\" layout-align=\"center center\" ng-if=\"!importing\"><md-icon>import_export</md-icon><span class=\"md-caption\">Import</span></div><md-progress-circular class=\"md-warn\" ng-if=\"importing\" md-diameter=\"24\"></md-progress-circular></section></md-button></div></md-subheader></md-card><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\">#</th><th md-column=\"\" md-numeric=\"\">Status</th><th md-column=\"\" ng-repeat=\"(key, val) in jsonData[0]\">{{key | uppercase}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"data in jsonData | limitTo: myLimit: (myPage - 1) * myLimit\" ng-init=\"parentIndex = $index\"><td md-cell=\"\"><span class=\"md-caption grey-text\">{{$index + 1}}.</span></td><td md-cell=\"\"><section layout=\"\" layout-align=\"center center\" ng-if=\"importing || imported\"><md-progress-circular md-diameter=\"24\" ng-if=\"importing\"></md-progress-circular><md-icon md-svg-src=\"/assets/images/checked.svg\" ng-if=\"imported\"><md-tooltip>Import Complete</md-tooltip></md-icon><md-icon class=\"red-text\" ng-if=\"data.error\">error<md-tooltip>Error - {{data.error}}</md-tooltip></md-icon></section><section layout=\"\" layout-align=\"center center\" ng-if=\"!importing && !imported\"><md-icon style=\"color: darkorange\">info_outline</md-icon><md-tooltip>Ready For Import</md-tooltip></section></td><td md-cell=\"\" ng-repeat=\"(key, val) in jsonData[parentIndex]\">{{val}}</td></tr></tbody></table></md-table-container><md-table-pagination md-page-select=\"\" md-limit-options=\"[25,50,100]\" md-limit=\"myLimit\" md-page=\"myPage\" md-total=\"{{jsonData.length}}\"></md-table-pagination></div><md-card style=\"position: fixed; bottom: 0; width: 100%; z-index: 10; left: 0; padding-left: 240px; margin: 0;\" md-theme=\"dark-purple\" ng-if=\"jsonData.length > 0 && status === \'Ready\'\"><md-card-content><div layout=\"\" layout-align=\"stretch center\"><section layout=\"\" layout-align=\"start center\" flex=\"\"><span class=\"md-subhead\">Processed : {{processed + \" / \" + jsonData.length}}</span><div class=\"md-caption\" layout=\"\" layout-align=\"center center\" ng-if=\"importing || imported\"><span style=\"margin-left: 40px;\" ng-if=\"!imported\">{{percent}}%</span><md-progress-circular class=\"md-warn\" style=\"margin-left: 40px;\" ng-if=\"!imported\" md-diameter=\"24\" ng-value=\"percent\" md-mode=\"determinate\"></md-progress-circular><span style=\"margin-left: 40px;\">Errors (Local/Server) : {{localErrors.length + \" / \" + serverErrors.length}}</span> <span style=\"margin-left: 40px;\">Duplicates : {{duplicates.length}}</span> <span style=\"margin-left: 40px;\" ng-if=\"imported\">Total Time : {{time}} seconds</span></div></section></div></md-card-content></md-card>");
$templateCache.put("app/modules/products/models/partials/index.html","<div layout-gt-sm=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-card flex=\"40\"><md-toolbar class=\"md-table-toolbar md-default\" ng-show=\"filter.show && !selected.length\"><div class=\"md-toolbar-tools\"><h3>Models</h3></div></md-toolbar><md-table-container><table md-table=\"\" md-progress=\"promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\"></th><th md-column=\"\"></th><th md-column=\"\">Name</th><th md-column=\"\">Email</th><th md-column=\"\">Mobile</th><th md-column=\"\">Size</th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"model in models\"><td md-cell=\"\">{{$index + 1 }}.</td><td md-cell=\"\"><md-img md-src=\"{{model.profileImage}}\" style=\"width: 75px; height: auto; border-radius: 50%;\"></md-img></td><td md-cell=\"\">{{model.name}}</td><td md-cell=\"\">{{model.email}}</td><td md-cell=\"\">{{model.mobile}}</td><td md-cell=\"\">{{model.size}}</td></tr></tbody></table></md-table-container></md-card><md-card flex=\"60\"><md-card-content></md-card-content></md-card></div>");
$templateCache.put("app/modules/products/size_charts/partials/size_charts.html","<div layout=\"\" layout-align=\"center\"><md-card flex=\"25\"><md-card-content><md-button ng-click=\"addSizeChart();\" class=\"md-primary md-raised\" style=\"height: 44px; line-height: 44px;\"><md-icon>add</md-icon>Add New Size Chart</md-button><md-subheader>Size Chart List</md-subheader><md-list><md-list-item ng-repeat=\"chart in sizeCharts\"><div layout=\"\" layout-align=\"center center\" ng-click=\"selectChart($index);\" class=\"pointer\" ng-style=\"{\'border-color\' : selectedChart === chart ? \'#ff4081\' : \'#fff\'}\" md-whiteframe=\"1\" style=\"position: relative; width: 100%; outline: none; border: 1px solid;\" md-ink-ripple=\"\"><span style=\"padding-left: 5px;\">{{chart.values.name}}</span> <span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"editName($index, $event);\"><md-icon>edit</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"deleteSizeChart($index, $event);\"><md-icon style=\"color: darkred;\">delete</md-icon></md-button></div></md-list-item></md-list></md-card-content></md-card><md-card style=\"width: 100%;\" flex=\"\"><div layout=\"column\"><div layout=\"\" layout-align=\"space-between\"><md-button class=\"md-raised md-accent\" ng-click=\"addRow();\">Add Size</md-button><md-button class=\"md-raised md-accent\" ng-click=\"addColumn();\">Add Measurement</md-button></div><md-table-container><table md-table=\"\" md-progress=\"promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" style=\"padding-top: 32px;\">Size/Measurement</th><th md-column=\"\" style=\"padding-top: 32px;\" md-numeric=\"\" ng-repeat=\"size in selectedChart.values.charts\"><md-inline-input-container ng-model=\"size.key\" on-delete-clicked=\"deleteColumn(size)\" on-add-row-after-clicked=\"addColumn($index)\" placeholder=\"Key (Bust, Waist, etc.)\"></md-inline-input-container></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"value in selectedChart.values.charts[0].values\" ng-init=\"key = value.key; parent = $index\"><td md-cell=\"\" ng-init=\"editing1 = false;\"><md-inline-input-container ng-model=\"value.key\" on-delete-clicked=\"deleteRow(value, $index)\" on-blur=\"update($index)\" placeholder=\"Size\"></md-inline-input-container></td><td md-cell=\"\" ng-repeat=\"size in selectedChart.values.charts\" ng-init=\"editing = false;\"><span ng-show=\"!editing\" ng-click=\"editing = !editing\">{{findValue(size, $index, parent, key);}}</span> <input style=\"width: 50px;\" type=\"number\" min=\"0\" ng-show=\"editing\" ng-blur=\"editing = !editing; show(size);\" ng-model=\"size.values[parent].value\"></td></tr></tbody></table></md-table-container></div></md-card></div>");
$templateCache.put("app/modules/products/tags/partials/tags.html","tags");
$templateCache.put("app/modules/products/trash/partials/trash.html","<div layout=\"column\" layout-align=\"center center\"><md-card><md-card-content><md-table-container><div layout=\"row\" layout-margin=\"\"><span flex=\"\"></span><md-input-container md-no-float=\"\" flex=\"20\" class=\"md-block\"><md-icon>search</md-icon><input type=\"search\" placeholder=\"Search\" ng-model=\"query.searchTerm\" ng-model-options=\"{\'debounce\' : 200}\" ng-change=\"getProducts()\"></md-input-container></div><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getProducts\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\"></th><th md-column=\"\"></th><th md-column=\"\" md-order-by=\"sku\">SKU</th><th md-column=\"\" md-order-by=\"name\"><span>Name</span></th><th md-column=\"\" md-numeric=\"\"><span>Price (Rs.)</span></th><th md-column=\"\" md-numeric=\"\"><span>Stock</span></th><th md-column=\"\" md-order-by=\"productType\"><span>Product Type</span></th><th md-column=\"\" md-order-by=\"createdAt\"><span>Deleted</span></th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"product\" md-auto-select=\"\" ng-repeat=\"product in products\" style=\"height: 75px;\"><td md-cell=\"\">{{$index + 1 }}.</td><td md-cell=\"\"><md-img class=\"product-image\" md-src=\"{{product.featured_image.urls.thumbnail}}\"></md-img></td><td md-cell=\"\">{{product.sku }}</td><td md-cell=\"\">{{product.name}}</td><td md-cell=\"\" ng-init=\"price = getLowestPrice(product);\"><div ng-if=\"product.productType == 0\"><strike class=\"md-caption\">{{ \"Rs. \" + price.mrp}}</strike><br><span class=\"md-body-2\">{{ \"Rs. \" + price.salePrice}}</span></div><div ng-if=\"product.productType == 1\"><span class=\"md-body-2\">{{ \"Rs. \" + price}}</span></div></td><td md-cell=\"\">{{user.mobile}}</td><td md-cell=\"\">{{getProductType(product);}}</td><td md-cell=\"\">{{product.updatedAt | date : \"mediumDate\"}}</td><td md-cell=\"\"><span layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"restoreProduct(product, index, $event);\"><md-icon>restore</md-icon><md-tooltip md-direction=\"bottom\">Restore Product</md-tooltip></md-button></span></td></tr></tbody></table></md-table-container><md-table-pagination mdboundarylinks=\"\" md-limit=\"query.limit\" md-limit-options=\"[5, 10, 25, 50,100]\" md-page=\"query.page\" md-total=\"{{total}}\" md-on-paginate=\"getProducts\" md-page-select=\"\"></md-table-pagination></md-card-content></md-card></div>");
$templateCache.put("app/modules/scm/designs/designDetails/designDetails.tmpl.html","<div class=\"design-details-page\"><div layout=\"\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start center\" class=\"md-padding\" flex=\"40\"><md-img style=\"width: 80%; border-radius: 4px; border-bottom: 4px\" md-src=\"{{previewImage.urls.large}}\"></md-img><md-content md-scroll-x=\"\" layout=\"\" layout-align=\"start center\"><md-img class=\"md-margin image-preview relative pointer\" md-ink-ripple=\"#c3c3c3\" ng-class=\"{\'selected\' : image.active}\" style=\"width: 75px; height: auto; border-radius: 4px;\" ng-repeat=\"image in design.images\" ng-click=\"selectImage(image)\" md-src=\"{{image.urls.thumbnail}}\"></md-img></md-content></div><div layout=\"column\" layout-align=\"start start\" flex=\"60\"><h2>{{design.name}}</h2><p>Designed by {{design.designerName}}</p><p>On {{design.createdAt | date: \'medium\'}}</p><p>Size Selected: {{design.sizeText || \'n/a\'}}</p><p>Season: {{design.season}}</p><p>Quantity: {{design.quantity}}</p><div layout=\"\" layout-align=\"start center\" class=\"full-width\" style=\"padding: 8px 0\"><md-button class=\"md-primary medium md-raised flat\" ui-sref=\"app.design.edit({id: design._id})\"><md-icon>edit</md-icon><span class=\"md-caption\">Edit Design</span></md-button></div><md-card style=\"width: 95%\" class=\"flat\"><div layout=\"\" layout-align=\"space-between center\"><h3 style=\"margin-left: 8px\">Measurements</h3><md-button class=\"md-primary outline\" ng-click=\"openEditMeasurementsDialog($event)\"><md-icon>edit</md-icon><span>Edit Measurements</span></md-button></div><md-divider></md-divider><md-list><md-list-item ng-repeat-start=\"measurement in design.measurements\"><p>{{measurement.key}}</p><p class=\"md-secondary md-title\">{{measurement.value}}</p></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list><div layout=\"column\" layout-align=\"center center\" class=\"md-padding md-margin\" ng-if=\"design && (!design.measurements ||!design.measurements.length)\"><img src=\"assets/images/blank.svg\" style=\"width: 100px;\"><p>No Measurements Added</p><md-button class=\"md-primary outline\" ng-click=\"openEditMeasurementsDialog($event)\"><md-icon>add</md-icon><span>Add Measurements</span></md-button></div></md-card></div></div><div layout=\"\" layout-wrap=\"\" layout-align=\"center start\" style=\"padding-bottom: 100px\"><md-card flex=\"85\" class=\"flat\"><div layout=\"\" layout-align=\"space-between center\"><h3 style=\"margin-left: 8px\">Tasks</h3><md-button class=\"md-primary outline\" ng-click=\"createTaskDialog($event)\"><md-icon>add</md-icon><span>Add Task</span></md-button></div><md-divider></md-divider><md-table-container><task-list tasks=\"tasks\" ng-if=\"!loadingTasks && tasks && tasks.length\"></task-list><div layout=\"column\" layout-align=\"center center\" class=\"md-padding md-margin\" ng-if=\"!loadingTasks && !tasks.length\"><img src=\"assets/images/blank.svg\" style=\"width: 100px;\"><p>No Tasks Added</p><md-button class=\"md-primary outline\" ng-click=\"createTaskDialog($event)\"><md-icon>add</md-icon><span>Add Task</span></md-button></div><div layout=\"\" class=\"md-padding md-margin\" ng-if=\"loadingTasks\"><md-progress-circular></md-progress-circular></div></md-table-container></md-card></div></div>");
$templateCache.put("app/modules/scm/designs/dialog/edit-measurements-dialog.tmpl.html","<md-dialog class=\"edit-measurements-container\" flex=\"70\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">Edit Measurements</span><md-button class=\"md-icon-button\" ng-click=\"close();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><div layout=\"\" layout-align=\"space-between center\" layout-wrap=\"\"><md-input-container flex=\"45\"><label>Select Size Chart</label><md-select ng-model=\"sizeChartId\" ng-change=\"updateSizeChart(sizeChartId, true)\"><md-option ng-value=\"sizeChart.id\" ng-repeat=\"sizeChart in sizeCharts\">{{sizeChart.name}}</md-option></md-select></md-input-container><md-input-container flex=\"45\" flex-offset=\"10\"><label>Select Size</label><md-select ng-model=\"sizeText\" ng-change=\"updateMeasurements(sizeText, true)\"><md-option ng-value=\"measurement.key\" ng-repeat=\"measurement in selectedSizeChart.measurements\">{{measurement.key}}</md-option></md-select></md-input-container><md-table-container flex=\"100\" dnd-list=\"selectedMeasurements\"><table md-table=\"\"><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"measurement in design.measurements\" dnd-draggable=\"measurement\" dnd-moved=\"measurements.splice($index, 1)\" dnd-effect-allowed=\"move\"><td md-cell=\"\" style=\"width: 50px\"><md-icon style=\"margin: 0 4px\" class=\"drag-pointer\">drag_handle</md-icon></td><td md-cell=\"\"><input type=\"text\" ng-model=\"measurement.key\"></td><td md-cell=\"\" style=\"text-align: right\"><div layout=\"\" class=\"md-secondary\"><input required=\"\" min=\"0\" type=\"number\" ng-model=\"measurement.value\" style=\"width: 75px; text-align: end\"><md-button class=\"md-icon-button small md-primary\" ng-click=\"appendMeasurement($index)\"><md-icon>add</md-icon><md-tooltip>Add Measurement in Next Row</md-tooltip></md-button><md-button class=\"md-icon-button small md-warn\" ng-click=\"deleteMeasurement($index)\"><md-icon>delete</md-icon><md-tooltip>Delete Measurement</md-tooltip></md-button></div></td></tr></tbody></table></md-table-container></div></md-dialog-content><md-dialog-actions><md-button class=\"md-warn\" ng-click=\"close()\">Cancel</md-button><md-button class=\"md-primary\" ng-disabled=\"savingMeasurements\" ng-click=\"saveMeasurements()\"><bubble-loader ng-if=\"savingMeasurements\"></bubble-loader><span ng-if=\"!savingMeasurements\">Save</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/scm/designs/partials/addDesign.tmpl.html","<div class=\"addDesigns md-padding md-margin\" layout=\"column\" style=\"padding-top: 50px\"><form name=\"designForm\" style=\"margin-top: 50px\"><md-input-container class=\"md-block name-input\"><label>Design Name</label> <input required=\"\" type=\"text\" name=\"name\" ng-model=\"design.name\"></md-input-container><md-card class=\"card-one\"><md-card-content><div layout=\"\" layout-align=\"center center\" layout-wrap=\"\"><md-chips ng-model=\"design.seasons\" md-autocomplete-snap=\"\" md-transform-chip=\"transformChip($chip)\" md-require-match=\"false\" md-removable=\"true\" md-on-add=\"onAdd($chip, $index)\" md-enable-chip-edit=\"true\" readonly=\"false\" md-max-chips=\"1\" input-aria-label=\"Assign Season\" class=\"md-block full-width\" flex=\"45\"><md-autocomplete md-selected-item=\"selectedItem\" md-search-text=\"seasonSearch\" md-items=\"item in querySeasons(seasonSearch)\" md-item-text=\"item\" input-aria-describedby=\"autocompleteTitle\" placeholder=\"Assign Season\"><md-item-template><span class=\"md-caption\">{{item}}</span></md-item-template></md-autocomplete><md-chip-template><p><span class=\"md-caption\">{{$chip}}</span></p></md-chip-template></md-chips><md-input-container flex=\"45\" flex-offset=\"10\"><label>Categories</label><md-select ng-model=\"design.categories\" multiple=\"\"><md-option ng-value=\"category._id\" ng-repeat=\"category in categories\">{{category.name}}</md-option></md-select></md-input-container></div></md-card-content><md-card-content><div layout=\"\" layout-align=\"center center\" layout-wrap=\"\"><md-input-container flex=\"30\"><label>Quantity</label> <input type=\"number\" name=\"quantity\" ng-model=\"design.quantity\"></md-input-container><div layout=\"column\" layout-align=\"center center\" flex=\"30\" flex-offset=\"5\"><p>Designer : <span ng-if=\"!design.designerName\">Not Set</span> <span ng-if=\"design.designerName\">{{design.designerName}}</span></p><md-button class=\"small outline md-primary\" ng-click=\"selectDesigner($event)\"><span ng-if=\"!updatingDesigner\">{{design.designer ? \'Change\' : \'Select\'}} Designer</span><bubble-loader ng-if=\"updatingDesigner\"></bubble-loader></md-button></div></div></md-card-content></md-card><md-card class=\"card-one\"><md-card-content><div layout=\"\" layout-align=\"center center\"><image-selector style=\"max-width: 200px\" multiple=\"true\" display=\"extended\" default-selection=\"\" on-default-change=\"updatePreviewImage(data)\" ng-model=\"design.images\" placeholder=\"Add Sample Image\"></image-selector></div></md-card-content></md-card><md-card class=\"card-one\"><div layout=\"column\" layout-align=\"center center\"><div layout=\"\" layout-align=\"space-between center\" class=\"attribute-card-heading\"><div class=\"md-margin md-padding\"><p class=\"md-title\">Sample Attributes</p></div><md-button flex=\"10\" class=\"outline md-primary\" ng-click=\"addAttribute();\">Add New</md-button></div><div flex=\"\" layout=\"row\" layout-align=\"space-around center\" ng-repeat=\"attributeData in design.attributes\" class=\"attribute-data\"><md-card flex=\"45\"><md-card-content><md-select aria-label=\"Select Attribute\" ng-change=\"setAttribute(attributeData)\" ng-model=\"attributeData.attributeId\" placeholder=\"Select Attribute\"><md-option ng-value=\"attribute._id\" ng-repeat=\"attribute in attributes\">{{ attribute.meta_key }}</md-option></md-select></md-card-content></md-card><md-card flex=\"45\"><md-card-content layout=\"row\"><md-select flex=\"80\" required=\"\" ng-if=\"!design.attributes[$index].attribute.allowMultipleSelections\" aria-label=\"Select Attributes\" md-on-close=\"searchTerm = \'\'\" data-md-container-class=\"selectHeader\" ng-model=\"attributeData.selectedValue\" ng-model-options=\"{trackBy: \'$value\'}\" placeholder=\"Select Options\"><md-select-header class=\"select-header\"><input ng-model=\"searchTerm\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search for an option..\" class=\"header-searchbox md-text\"></md-select-header><md-option ng-value=\"meta_value._id\" ng-repeat=\"meta_value in attributeData.attribute.meta_values | filter: searchTerm | orderBy:\'value\'\"><md-img ng-if=\"meta_value.image\" md-src=\"{{meta_value.image.urls.thumbnail}}\"></md-img><span>{{ meta_value.value }}</span></md-option></md-select><md-select flex=\"80\" aria-label=\"Select Attributes\" multiple=\"true\" required=\"\" md-on-close=\"searchTerm = \'\'\" ng-if=\"design.attributes[$index].attribute.allowMultipleSelections\" data-md-container-class=\"selectHeader\" ng-model=\"attributeData.selectedValues\" ng-model-options=\"{trackBy: \'$value\'}\" placeholder=\"Select Options\"><md-select-header class=\"select-header\"><input ng-model=\"searchTerm\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search for an option..\" class=\"header-searchbox md-text\"></md-select-header><md-option ng-value=\"meta_value._id\" ng-repeat=\"meta_value in attributeData.attribute.meta_values | filter: searchTerm | orderBy:\'value\'\"><md-img style=\"width: 32px; height: auto;\" ng-if=\"meta_value.image\" md-src=\"{{meta_value.image.urls.thumbnail}}\"></md-img><span>{{ meta_value.value }}</span></md-option></md-select><div layout=\"\" layout-align=\"end center\" flex=\"10\" flex-offset=\"10\"><md-button class=\"md-icon-button\" ng-click=\"removeAttribute($index);\"><md-icon style=\"color: red\">delete</md-icon></md-button></div></md-card-content></md-card></div></div></md-card><div layout=\"\" layout-align=\"end center\" class=\"md-padding\" ng-if=\"editMode\"><md-input-container><label>Status</label><md-select ng-model=\"design.status\"><md-option ng-value=\"status.value\" ng-repeat=\"status in designStatus\">{{status.name}}</md-option></md-select></md-input-container></div></form><div layout=\"\" layout-align=\"end center\" class=\"md-padding\"><md-button class=\"md-raised flat tile md-primary\" ng-disable=\"!savingDesign || $designForm.invalid\" ng-click=\"editMode ? editDesign() : saveDesign()\"><bubble-loader ng-if=\"savingDesign\"></bubble-loader><span ng-if=\"!savingDesign\">{{editMode ? \'Edit\' : \'Save\'}}</span></md-button></div></div>");
$templateCache.put("app/modules/scm/designs/partials/design-home.tmpl.html","<md-section-header md-section-title=\"{{pageTitle}}\" md-back-state=\"{{backState}}\" md-nested-state=\"nestedState\"><md-button class=\"md-raised action-button md-primary\" ng-click=\"onActionButtonClick($event);\" ng-if=\"showActionButton && !actionButtonDisabled.$$state.pending\">{{actionButtonText}}</md-button><md-progress-circular ng-if=\"actionButtonDisabled.$$state.pending\" md-mode=\"indeterminate\" md-diameter=\"40\" class=\"md-accent\"></md-progress-circular></md-section-header><form ng-disabled=\"actionButtonDisabled.$$state.pending\" style=\"z-index: 1\"><div ui-view=\"\"></div></form>");
$templateCache.put("app/modules/scm/designs/partials/designs.all.tmpl.html","<div><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\" style=\"background: #ebebee\"><div layout=\"\" layout-align=\"start center\" flex=\"\"><span ng-if=\"!selected.length\" style=\"margin-right: 20px\">Designs</span><section layout=\"\" layout-align=\"start center\" ng-if=\"selected.length\"><md-button class=\"md-icon-button material-icons--two-tone\" ng-click=\"clearSelections()\"><md-icon>close</md-icon></md-button><span class=\"md-caption\">{{selected.length}} Materials Selected</span></section><span ng-if=\"selected.length\" flex-offset=\"5\"></span><div layout=\"\" layout-align=\"center center\" ng-if=\"selected.length\"><md-button class=\"md-accent small\" ng-click=\"exportData(selected)\" ng-if=\"selected.length\"><md-icon>print</md-icon><span>Print Barcodes</span><md-tooltip>Print Barcode Label</md-tooltip></md-button></div><span ng-if=\"selected.length\" flex-offset=\"5\"></span><form role=\"form\" novalidate=\"\" name=\"filterForm\" flex-offset=\"5\" ng-submit=\"fetchDesigns()\" layout=\"\" flex=\"\" layout-align=\"center center\"><md-input-container flex=\"\" class=\"no-error-spacer\" layout=\"\"><label>&nbsp;</label> <input type=\"search\" id=\"searchDesigns\" ng-model=\"query.search\" select-on-click=\"\" ng-model-options=\"{\'debounce\' : 500}\" ng-change=\"fetchDesigns()\" placeholder=\"Search for Designs\" class=\"search-bar-input\"></md-input-container><md-button ng-click=\"fetchDesigns()\" class=\"md-icon-button\"><md-icon>search</md-icon></md-button></form></div><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-primary md-fab md-mini\" ui-sref=\"app.design.add\"><md-icon>add</md-icon><md-tooltip class=\"white-text\">Create New Design</md-tooltip></md-button></div></div></md-toolbar><md-table-container class=\"white\"><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5, 25, 50]\" md-page=\"query.page\" md-total=\"{{totalCount}}\" md-on-paginate=\"fetchDesigns\" md-page-select=\"\"></md-table-pagination><table md-table=\"\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"fetchDesigns\"><tr md-row=\"\"><th md-column=\"\">Sl</th><th md-column=\"\"></th><th md-column=\"\" md-order-by=\"name\"><span>Name</span></th><th md-column=\"\"><span>Designer Name</span></th><th md-column=\"\">Season</th><th md-column=\"\" md-order-by=\"status\">Status</th><th md-column=\"\">Progress</th><th md-column=\"\" md-order-by=\"createdAt\">Created At</th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"design\" md-select-id=\"design._id\" md-auto-select=\"\" ng-repeat=\"design in designs\"><td md-cell=\"\">{{ (((query.page - 1) * query.limit) + $index) + 1}}.</td><td md-cell=\"\"><a class=\"pointer\" ng-click=\"openImage($event, design.previewImage)\"><md-img md-src=\"{{design.previewImageUrl}}\" class=\"design-image\"></md-img></a></td><td md-cell=\"\"><a class=\"md-link pointer\" ui-sref=\"app.design.details({id : design._id})\">{{design.name}}</a></td><td md-cell=\"\">{{design.designerName}}</td><td md-cell=\"\"><span class=\"grey-text md-caption\">{{design.season || \'NA\'}}</span></td><td md-cell=\"\"><span class=\"md-caption\">{{startCase(design.status)}}</span></td><td md-cell=\"\"><div layout=\"column\" layout-align=\"center center\" ng-if=\"design.tasks.length\"><span class=\"md-caption grey-text\" style=\"margin-bottom: 4px\">{{design.completedTasks}} / {{design.totalTasks}} done</span><md-progress-linear value=\"{{design.progress}}\" style=\"border-radius: 4px\"></md-progress-linear></div><span ng-if=\"!design.tasks.length\" class=\"md-caption red-text\">No Tasks Yet</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{design.createdAt | date : \'medium\'}}</span></td><td md-cell=\"\"><md-button class=\"md-icon-button\" ui-sref=\"app.design.edit({id : design._id})\"><md-icon>edit</md-icon></md-button><md-button class=\"md-icon-button md-warn\" ng-click=\"removeDesign(design, $index, $event)\"><md-icon>delete</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5, 25, 50]\" md-page=\"query.page\" md-total=\"{{totalCount}}\" md-on-paginate=\"fetchDesigns\" md-page-select=\"\"></md-table-pagination></div><script id=\"addDesignDialog\" type=\"text/ng-template\"><md-dialog flex=\"40\"> <md-toolbar> <div class=\"md-toolbar-tools\" layout layout-align=\"space-between center\"> <h3>{{editingMode ? \'Edit Design\' : \'Add Design\'}}</h3> <md-button ng-click=\"cancel();\" class=\"md-icon-button\"> <md-icon>close</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content> <section ng-include=\"\'addDesign\'\"></section> </md-dialog-content> <md-dialog-actions md-colors=\"{\'background\' : \'boring-primary-50-0.2\'}\"> <div layout layout-align=\"space-between center\" flex> <md-button class=\"md-warn md-raised\" ng-click=\"cancel();\"> Close </md-button> <md-button class=\"md-primary md-raised\" ng-disabled=\"addCollectionForm.$invalid || savingCollection\" ng-click=\"saveDesign()\"> {{editingMode ? \'Update\' : \'Save\'}} </md-button> </div> </md-dialog-actions> </md-dialog></script><script id=\"addDesign\" type=\"text/ng-template\"><div ng-include=\"\'app/modules/scm/designs/partials/addDesign.tmpl.html\'\"></div></script>");
$templateCache.put("app/modules/scm/materials/partials/materials.tmpl.html","<div><md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\" style=\"background: #ebebee\"><div layout=\"\" layout-align=\"start center\" flex=\"\"><span ng-if=\"!selected.length\" style=\"margin-right: 20px\">Materials</span><section layout=\"\" layout-align=\"start center\" ng-if=\"selected.length\"><md-button class=\"md-icon-button material-icons--two-tone\" ng-click=\"clearSelections()\"><md-icon>close</md-icon></md-button><span class=\"md-caption\">{{selected.length}} Materials Selected</span></section><span ng-if=\"selected.length\" flex-offset=\"5\"></span><div layout=\"\" layout-align=\"center center\" ng-if=\"selected.length\"><md-button class=\"md-accent small\" ng-click=\"exportData(selected)\" ng-if=\"selected.length\"><md-icon>print</md-icon><span>Print Barcodes</span><md-tooltip>Print Barcode Label</md-tooltip></md-button></div><span ng-if=\"selected.length\" flex-offset=\"5\"></span><form role=\"form\" novalidate=\"\" name=\"filterForm\" flex-offset=\"5\" ng-submit=\"fetchMaterials()\" layout=\"\" flex=\"\" layout-align=\"center center\"><md-input-container flex=\"\" class=\"no-error-spacer\" layout=\"\"><label>&nbsp;</label> <input type=\"search\" id=\"giftCardSearch\" ng-model=\"query.search\" select-on-click=\"\" ng-model-options=\"{\'debounce\' : 500}\" ng-change=\"fetchMaterials()\" placeholder=\"Search Materials\" class=\"search-bar-input\"></md-input-container><md-button ng-click=\"fetchMaterials()\" class=\"md-icon-button\"><md-icon>search</md-icon></md-button></form></div><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-primary md-icon-button\" ng-click=\"openScanner($event);\"><md-icon>scanner</md-icon><md-tooltip class=\"white-text\">Scan Barcode</md-tooltip></md-button><md-button class=\"md-primary md-fab md-mini\" ng-click=\"showDialog($event, null, null);\"><md-icon>add</md-icon><md-tooltip class=\"white-text\">Create Warehouse</md-tooltip></md-button></div></div></md-toolbar><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5, 25, 50]\" md-page=\"query.page\" md-total=\"{{totalCount}}\" md-on-paginate=\"fetchMaterials\" md-page-select=\"\"></md-table-pagination><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.sort\" md-on-reorder=\"fetchMaterials\"><tr md-row=\"\"><th md-column=\"\"><span>Sl</span></th><th md-column=\"\"><span></span></th><th md-column=\"\"><span></span></th><th md-column=\"\" md-order-by=\"name\"><span>Name</span></th><th md-column=\"\" md-order-by=\"stock\" md-numeric=\"\"><span>Stock #</span></th><th md-column=\"\" md-order-by=\"leasedQuantity\"><span>Leased/Quantity</span></th><th md-column=\"\" md-order-by=\"category\"><span>Category</span></th><th md-column=\"\" md-order-by=\"salePrice\">Sale Price</th><th md-column=\"\" md-order-by=\"updatedAt\">Last Update</th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"material\" md-select-id=\"material._id\" md-auto-select=\"\" ng-repeat=\"material in materials\" style=\"height: 75px\"><td md-cell=\"\">{{ (((query.page - 1) * query.limit) + $index) + 1}}.</td><td md-cell=\"\"><attached-tag tag-type=\"dot relative\" ng-class=\"{{getClass(material)}}\"></attached-tag></td><td md-cell=\"\"><a class=\"pointer\" ng-click=\"$event.stopPropagation(); quickView(material._id, $event )\"><md-img class=\"product-image\" md-src=\"{{material.image.urls.thumbnail}}\"></md-img></a></td><td md-cell=\"\"><a class=\"md-caption md-link\" ng-click=\"$event.stopPropagation()\" ui-sref=\"app.materials.details({materialId : material._id, backState: \'app.materials.all\', backParams : backParams})\">{{material.name}}</a><br><span class=\"md-tiny grey-text\">{{material.sku}}</span></td><td md-cell=\"\"><span class=\"md-caption\">{{material.stock}}</span></td><td md-cell=\"\"><div ng-if=\"material.leasedQuantity\"><span class=\"md-caption red-text\">{{material.leasedQuantity}}<md-tooltip class=\"md-tiny\">Quantity {{material.leasedQuantity}} is on lease.</md-tooltip></span></div><div ng-if=\"!material.leasedQuantity\"><span class=\"md-tiny grey-text\">N/L</span></div></td><td md-cell=\"\"><span class=\"md-tiny\">{{material.categoryString}}</span></td><td md-cell=\"\"><span class=\"md-caption\">₹ {{material.salePrice}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{dateAgo(material.updatedAt)}}</span></td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"showDialog($event, material, $index);\"><md-icon class=\"md-primary\">edit</md-icon><md-tooltip>Edit</md-tooltip></md-button><md-button class=\"md-icon-button md-primary\" ng-click=\"exportData([material])\"><md-icon>print</md-icon><md-tooltip>Print Barcode Label</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-if=\"currentUser.roleSpec === 0\" ng-click=\"deleteMaterial($event, material, $index);\"><md-icon class=\"md-warn\">delete</md-icon><md-tooltip>Delete</md-tooltip></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5, 25, 50]\" md-page=\"query.page\" md-total=\"{{totalCount}}\" md-on-paginate=\"fetchMaterials\" md-page-select=\"\"></md-table-pagination></md-card></div>");
$templateCache.put("app/modules/scm/materials/partials/materialsHome.tmpl.html","<md-section-header md-section-title=\"{{pageTitle}}\" md-back-state=\"{{backState}}\" md-nested-state=\"nestedState\"><md-button class=\"md-raised action-button md-accent\" ng-click=\"onActionButtonClick($event);\" ng-if=\"showActionButton && !actionButtonDisabled.$$state.pending\">{{actionButtonText}}</md-button><md-progress-circular ng-if=\"actionButtonDisabled.$$state.pending\" md-mode=\"indeterminate\" md-diameter=\"40\" class=\"md-accent\"></md-progress-circular></md-section-header><form ng-disabled=\"actionButtonDisabled.$$state.pending\" style=\"z-index: 1\"><div ui-view=\"\"></div></form>");
$templateCache.put("app/modules/scm/purchase/partials/purchase.tmpl.html","<md-card><md-subheader class=\"md-table-toolbar md-default white\"><div layout=\"row\"><md-input-container md-no-float=\"\" flex=\"40\" class=\"md-block no-error-spacer md-primary\"><md-icon>search</md-icon><input type=\"search\" placeholder=\"Search For Purchases\" ng-model=\"query.search\" ng-model-options=\"{\'debounce\' : 200}\" ng-change=\"fetchAllPurchase()\"></md-input-container><span flex=\"\"></span><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-primary outline\" ng-click=\"showDialog($event, null, null);\"><md-icon>add</md-icon><span class=\"md-caption bold-text\">Create Purchase</span></md-button></div></div></md-subheader><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.sort\" md-on-reorder=\"fetchAllPurchase\"><tr md-row=\"\"><th md-column=\"\">Sl.No.</th><th md-column=\"\" md-order-by=\"invoiceNumber\"><span>Invoice Number</span></th><th md-column=\"\" md-order-by=\"totalPurchaseAmount\"><span>Total Purchase Amt</span></th><th md-column=\"\" md-order-by=\"vendor\">Vendor</th><th md-column=\"\" md-order-by=\"billGstNumber\"><span>Created By</span></th><th md-column=\"\" md-order-by=\"createdAt\">Created Date</th><th md-column=\"\" md-order-by=\"createdAt\">Updated Date</th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"material\" md-select-id=\"material._id\" md-auto-select=\"\" ng-repeat=\"purchase in purchases\"><td md-cell=\"\"><span>{{$index + 1}}.</span></td><td md-cell=\"\"><span>{{purchase.invoiceNumber}}</span></td><td md-cell=\"\"><span>Rs. {{purchase.totalPurchaseAmount}}</span></td><td md-cell=\"\"><p class=\"md-caption\">{{purchase.vendor.name}}</p></td><td md-cell=\"\"><span class=\"md-caption\">{{purchase.cachedCreatedBy.name}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{purchase.purchaseDate | date : \'medium\'}}</span></td><td md-cell=\"\"><md-button class=\"md-icon-button md-primary\" ng-click=\"showDialog($event, purchase, $index);\"><md-icon>edit</md-icon><md-tooltip>Edit</md-tooltip></md-button><md-button class=\"md-icon-button md-warn\" ng-click=\"deletePurchase($event, purchase, $index);\"><md-icon>delete</md-icon><md-tooltip>Delete</md-tooltip></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[10, 25, 50]\" md-page=\"query.page\" md-total=\"{{totalPurchaseCount}}\" md-on-paginate=\"fetchAllPurchase\" md-page-select=\"\"></md-table-pagination></md-card>");
$templateCache.put("app/modules/scm/schedule/partials/edit-event.html","<md-dialog flex=\"60\"><md-toolbar layout=\"\" layout-align=\"center center\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><p class=\"md-primary md-title\">Edit Task</p><md-button ng-click=\"closeDialog()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" layout-align=\"center stretch\"><div layout=\"column\" layout-align=\"center stretch\" ng-if=\"!editMode\"><div layout=\"\" layout-align=\"space-around center\"><md-input-container flex=\"25\"><label>Start Date</label><md-datepicker flex=\"\" class=\"md-block\" name=\"startDate\" ng-required=\"\" ng-model=\"event.start\" md-min-date=\"minDate\" md-max-date=\"maxDate\"></md-datepicker></md-input-container><md-input-container flex=\"25\"><label>End Date</label><md-datepicker flex=\"\" class=\"md-block\" name=\"endDate\" ng-required=\"\" ng-model=\"event.end\" md-min-date=\"event.startDate\" md-max-date=\"maxDate\"></md-datepicker></md-input-container></div><div layout=\"\" layout-align=\"space-around center\"><md-input-container><label>Start Time</label> <input type=\"time\" ng-model=\"event.startTime\"><div>{{startTime}}</div></md-input-container><md-input-container><label>End Time</label> <input type=\"time\" ng-model=\"event.endTime\"><div>{{endTime}}</div></md-input-container></div><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.orderBy\" md-on-reorder=\"reorder\"><tr md-row=\"\" md-colors=\"{\'background\' : \'boring-accent-50-0.1\'}\"><th md-column=\"\">Sl</th><th md-column=\"\" md-numeric=\"\">Sync</th><th md-column=\"\" md-order-by=\"orderNumber\">Order Number</th><th md-column=\"\" md-order-by=\"status\">Status</th><th md-column=\"\" md-order-by=\"createdAt\" md-numeric=\"\"><span>Order Date</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"order\" md-select-id=\"order._id\" md-auto-select=\"\" ng-repeat=\"order in orders\" style=\"height: 75px;\"><td md-cell=\"\">{{ (((query.page - 1) * query.limit) + $index) + 1}}.</td><td md-cell=\"\"><div layout=\"\" layout-align=\"center center\" ng-init=\"spDone = order.shipRocketId ? true : false;\"><md-icon ng-class=\"{\'green-text\' : spDone, \'red-text\' : !spDone}\">{{spDone ? \"cloud_done\" :\"cloud_off\"}}<md-tooltip>{{spDone ? \"Shiprocket Synced\" : \"Shiprocket not synced\"}}</md-tooltip></md-icon></div></td><td md-cell=\"\"><div layout=\"\" layout-align=\"start center\"><span class=\"dot-indicator\" ng-class=\"{ \'error\' : order.status ===\'incomplete\' || order.status ===\'parked\' , \'pending\' : order.status === \'placed\', \'staging\' : [\'approved\', \'processing\', \'returned\', \'shipped\', \'packed\'].includes(order.status), \'success\' : order.status === \'delivered\'}\"></span> <span>{{order.status | uppercase}}</span></div></td><td md-cell=\"\" md-numeric=\"\"><span class=\"md-caption\">{{order.createdAt | date : \"medium\"}}</span></td></tr></tbody></table></md-table-container></div></md-dialog-content><md-dialog-actions><md-button class=\"md-accent\" ng-click=\"closeDialog()\">Submit</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/scm/schedule/partials/scheduleTask.tmpl.html","<md-card-container><md-toolbar class=\"md-accent\" layout=\"\" layout-align=\"start center\"><p class=\"md-title\">Time Scheduler</p></md-toolbar><md-card-content><div><md-event-calendar ng-model=\"selected\" md-events=\"events\" md-event-click=\"eventClicked($selectedEvent)\" md-label=\"title\" md-show-create-link=\"true\" md-create-event-click=\"eventCreated($date)\" md-create-disabled=\"false\" auto-height=\"4000\" class=\"md-primary\"><md-event-calendar-header class=\"md-left\"><md-event-calendar-prev></md-event-calendar-prev><md-event-calendar-title></md-event-calendar-title><md-event-calendar-next></md-event-calendar-next><md-event-calendar-today></md-event-calendar-today></md-event-calendar-header></md-event-calendar></div></md-card-content></md-card-container>");
$templateCache.put("app/modules/users/addresses/addressAddDialog/address-add-dialog.html","<div class=\"md-dialog-container\" id=\"addressDialog\"><md-dialog><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">{{editingMode ? \'Edit\' : \'Add New\'}} Address</span><md-button class=\"md-icon-button md-accent\" ng-click=\"cancelDialog()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><form name=\"$parent.addressForm\" ng-cloak=\"\"><md-dialog-content><div class=\"md-dialog-content\"><div layout=\"column\"><div layout=\"row\" flex=\"100\"><md-input-container class=\"md-block md-primary\" flex=\"70\"><label>Name</label> <input required=\"\" ng-model=\"newAddress.name\" autocomplete=\"name\"></md-input-container><md-button class=\"md-primary small round\" ng-if=\"user.name\" ng-click=\"newAddress.name = user.name\">Set User\'s Name</md-button></div><div layout=\"row\" flex=\"100\"><md-input-container class=\"md-block md-primary\" flex=\"70\"><label>Mobile Number</label> <input type=\"tel\" ng-pattern=\"/^[56789][0-9]{9}$/\" name=\"mobile\" md-maxlength=\"10\" md-minlength=\"10\" autocomplete=\"mobile\" required=\"\" ng-model=\"newAddress.mobile\"><div ng-messages=\"$parent.mobile.city.$error\" ng-if=\"$parent.mobile.city.$touched && $parent.mobile.city.$error\"><div ng-message-exp=\"[\'required\', \'pattern\', \'minlength\', \'maxlength\']\"><div ng-message=\"pattern\">Please provide a 10 digit Indian mobile number without 0 or +91</div></div></div></md-input-container><md-button class=\"md-primary small round\" ng-if=\"user.mobile\" ng-click=\"newAddress.mobile = user.mobile\">Set User\'s Mobile Number</md-button></div></div><md-input-container class=\"md-block md-primary\"><label>Address</label> <textarea required=\"\" md-maxlength=\"100\" autocomplete=\"address\" ng-model=\"newAddress.streetAddress\"></textarea></md-input-container><md-input-container class=\"md-block md-primary\"><input md-maxlength=\"32\" ng-model=\"newAddress.landmark\" autocomplete=\"landmark\" placeholder=\"Landmark\"></md-input-container><div layout-gt-sm=\"row\" class=\"md-block md-primary\"><md-input-container class=\"md-block md-primary\" flex-gt-sm=\"\"><label>Pin Code</label> <input name=\"postalCode\" ng-model=\"newAddress.pinCode\" placeholder=\"123456\" required=\"\" ng-pattern=\"/^[0-9]{6}$/\" md-maxlength=\"6\" ng-blur=\"populateCity()\"><div ng-if=\"$parent.postalCode.$touched && $parent.addressFrom.postalCode.$error\" ng-messages=\"$parent.addressFrom.postalCode.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\" class=\"my-message\">You must supply a postal code.</div></div></md-input-container><md-input-container><label>City</label> <input name=\"city\" ng-model=\"newAddress.city\" placeholder=\"Delhi\" required=\"\" minlength=\"2\" ng-disabled=\"populatingCity\"><div ng-messages=\"$parent.addressFrom.city.$error\" ng-if=\"$parent.city.$touched && $parent.city.$invalid && $parent.addressFrom.city.$error\"><div ng-message=\"required\">Please enter your city.</div></div></md-input-container><md-input-container class=\"md-block md-primary\" flex-gt-sm=\"\"><label>State</label> <input name=\"state\" md-maxlength=\"20\" ng-model=\"newAddress.state\" required=\"\"><div ng-if=\"$parent.state.$touched && $parent.state.$error\" ng-messages=\"$parent.state.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\" class=\"my-message\">You must add a state.</div></div></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"center center\"><div flex-gt-sm=\"50\"><md-checkbox class=\"md-accent\" ng-model=\"newAddress.isDefault\" aria-label=\"Default Address\"><span>Default Address</span></md-checkbox></div><md-input-container class=\"md-block md-primary\" flex-gt-sm=\"\"><label>Address Label</label> <input name=\"tag\" ng-model=\"newAddress.addressType\" placeholder=\"Home, Office, etc.\" md-maxlength=\"10\"></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"end center\" md-colors=\"{\'background\' : \'accent-50-0.2\'}\"><md-button class=\"md-raised md-accent\" ng-click=\"saveAddress();\" ng-disabled=\"addressSaving || $parent.addressForm.$invalid\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!addressSaving\">{{editingMode ? \'Update\' : \'Add New\'}} Address</span><md-progress-circular class=\"md-accent\" md-diameter=\"20\" ng-if=\"addressSaving\"></md-progress-circular></div></md-button></md-dialog-actions></form></md-dialog></div>");
$templateCache.put("app/modules/users/addresses/addressSelectorDialog/address-selector.dialog.tmpl.html","<md-dialog flex=\"60\" class=\"activateCardModal\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"center center\"><h4>Select Address</h4></div><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-progress-linear ng-if=\"loadingAddressses || deleting\"></md-progress-linear><md-dialog-content class=\"md-dialog-content\"><form name=\"addressSelectorForm\"><div flex=\"\" class=\"full-width\" layout=\"\" layout-align=\"end center\"><md-button class=\"md-primary outline small\" ng-click=\"openNewAddressDialog($event)\">Add New Address</md-button></div><md-radio-group required=\"\" ng-model=\"$parent.selectedAddress\" ng-if=\"addresses.length && !loadingAddressses\"><md-list class=\"md-3-line\"><md-list-item ng-repeat-start=\"address in addresses | filter : isNotDeleted\" style=\"margin-top: 4px; padding-top: 8px; background: #f4f4f4\"><div class=\"md-list-item-text\" layout=\"column\"><p class=\"md-body-1 bold-text\">{{ address.name }} : {{address.mobile}}</p><p class=\"md-caption\">{{ address.streetAddress }}</p><p class=\"md-caption\"><span ng-if=\"address.landmark\">{{ address.landmark }},</span> {{address.city}}, {{address.state}}-{{address.pinCode}}</p><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-primary small round\" ng-click=\"openNewAddressDialog($event, $index, address)\"><md-icon>edit</md-icon>Edit</md-button><md-button class=\"md-warn small round\" ng-click=\"deleteAddress($event, $index, address)\"><md-icon>delete</md-icon>Delete</md-button></div></div><md-radio-button class=\"md-secondary md-primary\" ng-value=\"address._id\"></md-radio-button></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list></md-radio-group><div ng-if=\"!addresses.length && !loadingAddressses\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/blank.svg\" style=\"width: 100px; height: auto\"><p>No Addresses For User Yet</p><md-button class=\"md-primary outline small\" ng-click=\"openNewAddressDialog($event)\">Add New Address</md-button></div><div ng-if=\"loadingAddressses\" layout=\"\" layout-align=\"center center\" style=\"min-height: calc(50vh - 128px)\"><md-progress-circular></md-progress-circular></div></form></md-dialog-content><md-dialog-actions><md-button class=\"md-primary md-raised\" ng-disabled=\"addressSelectorForm.$invalid || deleting\" ng-click=\"selectOrg()\"><md-icon>add</md-icon>Select</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/users/allUsers/partials/all.html","<div><md-card><md-subheader class=\"md-table-toolbar md-default white\"><div layout=\"row\" layout-wrap=\"\" layout-align=\"start center\"><md-input-container md-no-float=\"\" flex-gt-sm=\"40\" flex-xs=\"100\" flex-sm=\"100\" class=\"md-block no-error-spacer md-primary\"><md-icon>search</md-icon><input type=\"search\" placeholder=\"Search for Users\" ng-model=\"query.searchTerm\" ng-model-options=\"{\'debounce\' : 500}\" ng-change=\"getAllUsers()\"></md-input-container><span ng-if=\"!selected.length\" flex-sm=\"30\" flex-xs=\"30\" flex-gt-sm=\"20\"></span><div layout=\"\" layout-align=\"center center\" ng-if=\"selected.length\" flex-sm=\"30\" flex-xs=\"30\" flex-gt-sm=\"20\"><md-button class=\"md-primary material-icons--two-tone\" ng-click=\"$event.stopPropagation();openNotifications(selected,$event);\"><md-icon>message</md-icon><span>Notify Customer</span></md-button><md-button class=\"md-primary material-icons--two-tone\" ng-click=\"$event.stopPropagation();openTagUserDialog(selected,$event);\"><md-icon>tag</md-icon><span>Tag Customer</span></md-button><md-button class=\"md-primary md-icon-button material-icons--two-tone\" ng-click=\"showMailDialog($event)\"><md-icon>email</md-icon><md-tooltip>Send Email</md-tooltip></md-button><md-button class=\"md-primary md-icon-button material-icons--two-tone\" ng-click=\"exportUsers($event);\"><md-icon>file_download</md-icon><md-tooltip class=\"md-caption bold-text\">Export Users</md-tooltip></md-button></div><div layout=\"\" layout-align=\"center center\" flex-sm=\"70\" flex-xs=\"70\" flex-gt-sm=\"30\"><md-button class=\"md-primary outline hide-xs hide-sm\" ng-click=\"showImportDialog($event);\"><md-icon>cloud_upload</md-icon><span class=\"md-caption bold-text\">Import User</span></md-button><md-button class=\"md-primary outline\" ng-click=\"showDialog($event);\"><md-icon>add</md-icon><span class=\"md-caption bold-text\">Add New User</span></md-button><md-button class=\"md-icon-button\" ng-class=\"{\'md-accent\': !showFilters, \'md-primary\' : showFilters}\" ng-click=\"showFilters = !showFilters\"><md-icon>filter_list</md-icon><md-tooltip>Filters</md-tooltip><attached-tag tag-type=\"dot\" right=\"8px\" top=\"8px\" ng-if=\"hasFilters\"></attached-tag></md-button></div></div><div ng-if=\"showFilters\" layout=\"\" layout-align=\"space-between center\" style=\"background: #f4f4f4; padding: 0 12px;\"><section layout=\"\" layout-align=\"start center\" flex=\"\"><md-select ng-model=\"filters.type\" placeholder=\"Select Operand\"><md-option value=\"in\">Belong to</md-option><md-option value=\"nin\">Does not belong to</md-option></md-select><md-select ng-model=\"filters.organisation\" multiple=\"\" placeholder=\"Organisation\"><md-button layout-fill=\"\" value=\"all\" ng-click=\"selectAll(\'organisation\', orgs)\"><md-icon class=\"material-icons--two-tone\">select_all</md-icon>Select all</md-button><md-option ng-value=\"organisation._id\" ng-repeat=\"organisation in orgs\">{{organisation.name}}</md-option></md-select><md-select flex-offset=\"5\" ng-model=\"filters.role\" multiple=\"\" placeholder=\"Users\"><md-button layout-fill=\"\" value=\"all\" ng-click=\"selectAll(\'role\', userRoles)\"><md-icon class=\"material-icons--two-tone\">select_all</md-icon>Select all</md-button><md-option ng-value=\"role\" ng-repeat=\"role in userRoles\">{{role | uppercase}}</md-option></md-select><md-checkbox flex-offset=\"5\" ng-model=\"filters.hasValidMobile\">Has Valid Mobile Number?</md-checkbox></section><md-button class=\"md-warn small\" ng-click=\"clearFilters()\">Clear Filters</md-button><md-button class=\"md-primary md-raised small\" ng-click=\"parseFilters(null)\">Apply</md-button></div><div ng-if=\"containsTags || tags.length\" layout=\"\" layout-align=\"center center\" class=\"tags-row\"><md-card ng-repeat=\"tag in tags track by $index\" class=\"tagCards pointer\" ng-click=\"parseFilters(tag)\"><md-card-content layout=\"\" layout-align=\"center center\" class=\"relative\"><span class=\"md-caption bold-text\">{{tag}}</span></md-card-content></md-card></div></md-subheader><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5, 25, 50, 100, 500]\" md-page=\"query.page\" md-total=\"{{totalCount}}\" md-on-paginate=\"getAllUsers\" md-page-select=\"\"></md-table-pagination><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getAllUsers\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\" md-order-by=\"name\"><span>Name</span></th><th md-column=\"\" md-order-by=\"mobile\" md-numeric=\"\">Mobile</th><th md-column=\"\" md-order-by=\"status\">Active</th><th md-column=\"\" md-order-by=\"createdAt\">Join Date</th><th md-column=\"\" md-order-by=\"role\">Role</th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"user\" md-select-id=\"user._id\" md-auto-select=\"\" ng-repeat=\"user in users\"><td md-cell=\"\">{{(((query.page - 1) * query.limit) + $index) + 1}}.</td><td md-cell=\"\"><md-img class=\"avatar\" md-src=\"{{user.profileImageURL}}\"></md-img></td><td md-cell=\"\"><div layout=\"column\" layout-align=\"center start\"><div layout=\"\" layout-align=\"start center\"><a class=\"md-link pointer\" ng-click=\"$event.stopPropagation()\" ui-sref=\"app.users.details.home({userId : user._id, backParams : jsonParams})\">{{user.name }}</a><md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-click=\"$event.stopPropagation(); showToast(\'Copied User Name to Clipboard\')\" data-clipboard-text=\"{{user.name}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy Name</md-tooltip></md-button></div><div layout=\"\" layout-align=\"start center\" ng-if=\"user.email\"><span class=\"md-tiny grey-text\" style=\"padding-top: 4px\">{{user.email}}</span><md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-click=\"$event.stopPropagation(); showToast(\'Copied Email Address to Clipboard\')\" data-clipboard-text=\"{{user.email}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy Email Address</md-tooltip></md-button></div></div></td><td md-cell=\"\"><span>{{user.mobile}}</span><md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-click=\"$event.stopPropagation(); showToast(\'Copied Mobile to Clipboard\')\" data-clipboard-text=\"{{user.mobile}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy Mobile Number</md-tooltip></md-button></td><td md-cell=\"\"><md-icon ng-class=\"{\'red-text\' : user.status !== 1, \'green-text\' : user.status === 1}\">{{ user.status === 1 ? \'verified_user\' : \'close\'}}</md-icon></td><td md-cell=\"\"><span class=\"md-tiny\">{{user.createdAt | date : \'medium\'}}</span></td><td md-cell=\"\"><span class=\"md-tiny bold-text\">{{user.role | uppercase}}</span></td><td md-cell=\"\"><div layout=\"\" layout-align=\"start center\"><md-button class=\"md-primary md-icon-button material-icons--two-tone\" ng-disabled=\"user.virtualMobile\" ng-click=\"openNotifications(user, $event)\"><md-icon>message</md-icon><md-tooltip>Send SMS to customer</md-tooltip></md-button><md-button class=\"md-icon-button md-accent\" ng-click=\"showDialog($event, user, $index);\"><md-icon class=\"material-icons--two-tone\">edit</md-icon><md-tooltip>Edit User</md-tooltip></md-button></div></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5, 25, 50, 100, 500]\" md-page=\"query.page\" md-total=\"{{totalCount}}\" md-on-paginate=\"getAllUsers\" md-page-select=\"\"></md-table-pagination></md-card></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"emailDialog\"><md-dialog aria-label=\"emailDialog block\" flex=\"75\"><form ng-cloak=\"\" name=\"$parent.emailForm\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\"><h2>Send Mail</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content ng-class=\"{\'layout-column\' : !screenTwo, \'layout-row\' : screenTwo}\" layout-padding=\"\"><div layout=\"column\" ng-if=\"!screenTwo\" flex=\"\"><md-contact-chips ng-model=\"selected\" md-contacts=\"querySearch($query)\" md-contact-name=\"name\" md-contact-image=\"user.profileImageURL === \'default.png\' ?\'/assets/images/\' + user.profileImageURL : user.profileImageURL\" md-contact-email=\"email\" md-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"email.users\" placeholder=\"To\" required=\"\" ng-disabled=\"sendingMail\"></md-contact-chips><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Subject</label> <input type=\"text\" id=\"message\" ng-model=\"email.subject\" required=\"\" ng-disabled=\"sendingMail\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Button Text</label> <input type=\"text\" ng-model=\"email.buttonText\" required=\"\" ng-disabled=\"sendingMail\"></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Button Url</label> <input type=\"text\" ng-model=\"email.buttonUrl\" required=\"\" ng-disabled=\"sendingMail\"></md-input-container></div></div><div layout=\"row\" flex=\"\" ng-if=\"screenTwo\"><div flex=\"33\" layout=\"column\" class=\"md-padding\"><md-subheader>Users</md-subheader><md-list><md-list-item class=\"md-2-line\" ng-repeat-start=\"user in selected\" style=\"background: rgba(186,218,254,0.44)\"><div class=\"md-list-item-text\" layout=\"column\"><p>{{user.name}}</p><p>{{user.email}}</p></div></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list></div><section flex=\"\" layout=\"column\"><div layout=\"\" flex=\"10\"><md-input-container class=\"md-block\" flex=\"\"><label>Subject</label> <input type=\"text\" ng-model=\"email.subject\" required=\"\" ng-disabled=\"true\"></md-input-container></div><div layout=\"\" flex=\"10\"><p class=\"center-text md-caption grey-text\">Template Variables</p><md-button class=\"md-accent\" ng-click=\"addData(field.exp);\" ng-repeat=\"field in formFields\">{{field.title}}</md-button></div><md-input-container class=\"md-block\" style=\"background: rgba(1,1,1,0.05);\" flex=\"\"><text-angular name=\"message\" ng-model=\"email.message\" md-select-on-focus=\"\" required=\"\" ng-disabled=\"sendingMail\" placeholder=\"Message\"></text-angular></md-input-container></section></div></md-dialog-content><md-dialog-actions style=\"background: rgba(1,1,1,0.1)\" layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-raised md-warn\" ng-click=\"cancel();\" ng-if=\"!screenTwo\">Cancel</md-button><md-button class=\"md-raised md-warn\" ng-click=\"prev();\" ng-if=\"screenTwo\">Go Back</md-button><md-button ng-disabled=\"$parent.emailForm.$invalid || sendingMail\" type=\"submit\" class=\"md-raised md-accent\" ng-if=\"!screenTwo\" ng-click=\"next()\"><span>Next</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"12\" ng-if=\"sendingMail\"></md-progress-circular></md-button><md-button ng-if=\"screenTwo\" ng-disabled=\"$parent.emailForm.$invalid || sendingMail\" type=\"submit\" class=\"md-raised md-accent\" ng-click=\"sendMail()\"><span ng-if=\"!sendingMail\">Send Mail</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"12\" ng-if=\"sendingMail\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog></div></div>");
$templateCache.put("app/modules/users/details/partials/index.html","<div layout=\"column\"><md-subheader md-whiteframe=\"1\" class=\"md-table-toolbar no-padding\"><div layout=\"\" layout-align=\"center center\"><md-nav-bar md-selected-nav-item=\"currentNavItem\" style=\"overflow-y: scroll\"><md-nav-item md-nav-click=\"goto(\'app.users.details.home\', \'home\', 0)\" name=\"home\" aria-label=\"home\" class=\"md-primary\">Home</md-nav-item><md-nav-item md-nav-click=\"goto(\'app.users.details.job\', \'job\', 1)\" name=\"job\" ng-if=\"user.role !== \'customer\'\" aria-label=\"job\">Job</md-nav-item><md-nav-item md-nav-click=\"goto(\'app.users.details.offers\', \'offers\', 2)\" name=\"offers\" aria-label=\"offers\">Offers</md-nav-item><md-nav-item md-nav-click=\"goto(\'app.users.details.cart\', \'cart\', 3)\" name=\"cart\" aria-label=\"categories\">Carts</md-nav-item><md-nav-item md-nav-click=\"goto(\'app.users.details.orders\', \'orders\', 4)\" name=\"orders\" aria-label=\"categories\">Orders</md-nav-item><md-nav-item md-nav-click=\"goto(\'app.users.details.transactions\',\'transactions\', 5)\" name=\"transactions\" aria-label=\"transactions\">Transactions</md-nav-item></md-nav-bar></div></md-subheader><div ui-view=\"\" style=\"padding: 24px\"></div></div>");
$templateCache.put("app/modules/users/dialogs/add-user/add-user.tmpl.html","<md-dialog aria-label=\"addNewUserDialog block\" flex-gt-sm=\"50\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\"><span>{{ editingMode ? \'Edit User\' : \'Add New User\'}}</span> <span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><form flex=\"\" ng-cloak=\"\" name=\"newUserForm\" layout=\"row\" layout-wrap=\"\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"center center\" flex=\"33\" class=\"profile-image-selector\"><image-selector ng-model=\"newUser.profileImage\" select=\"profile\" sizes=\"profileImageSizes\"></image-selector></div><div layout=\"column\" flex=\"66\"><md-input-container class=\"md-block\"><label>Name</label> <input required=\"\" ng-minlength=\"3\" type=\"text\" name=\"name\" ng-model=\"newUser.name\"><div ng-messages=\"newUserForm.name.$error\"><div ng-message=\"required\">Name is required.</div><div ng-message=\"md-maxlength\">The name has to be less than 30 characters long.</div></div></md-input-container><md-input-container class=\"md-block\"><label>Mobile Number</label> <input required=\"\" md-maxlength=\"10\" type=\"text\" name=\"mobile\" ng-model=\"newUser.mobile\"></md-input-container></div><md-input-container class=\"md-block hints\" flex=\"45\"><label>UserName</label> <input md-maxlength=\"25\" ng-blur=\"checkAvailable(newUser.userName)\" ng-disabled=\"userNameDisabled\" type=\"text\" name=\"userName\" ng-model=\"newUser.userName\"> <span class=\"hint md-tiny green-text\" ng-if=\"userNameAvailable\">Username available</span><div ng-messages=\"newUserForm.userName.$error\" ng-if=\"newUserForm.userName.$touched\"><div ng-message=\"unavailable\">The provided user name is not available</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"45\"><label>Email</label> <input md-maxlength=\"40\" autocomplete=\"off\" type=\"email\" name=\"email\" ng-model=\"newUser.email\"></md-input-container><md-input-container class=\"md-block\" flex=\"45\"><label>Password</label> <input md-minlength=\"6\" autocomplete=\"off\" type=\"{{defaultPasswordType ? \'password\' : \'text\'}}\" name=\"password\" ng-model=\"newUser.password\"><md-icon md-ink-ripple=\"\" ng-click=\"defaultPasswordType = !defaultPasswordType\">remove_red_eye</md-icon></md-input-container><md-input-container class=\"md-block\" flex=\"45\"><label>Warehouse</label><md-select ng-model=\"newUser.warehouse\"><md-option ng-value=\"warehouse._id\" ng-repeat=\"warehouse in warehouses | orderBy : \'name\'\">{{warehouse.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"45\"><label>Points</label> <input ng-required=\"\" type=\"number\" name=\"points\" ng-model=\"newUser.points\"></md-input-container><md-input-container class=\"md-block\" flex=\"45\"><label>Account Status</label><md-select ng-model=\"newUser.status\" required=\"\"><md-option ng-value=\"getOption(\'1\');\">Active</md-option><md-option ng-value=\"getOption(\'0\');\">Pending Auth</md-option><md-option ng-value=\"getOption(\'-1\');\">Blocked</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"45\"><label>Organisation</label><md-select ng-model=\"newUser.organisation\"><md-option ng-value=\"org._id\" ng-repeat=\"org in orgs | orderBy : \'name\'\">{{org.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"45\"><label>User Role</label><md-select ng-model=\"newUser.role\"><md-option ng-value=\"role\" ng-repeat=\"role in userRoles\">{{role | uppercase}}</md-option></md-select></md-input-container><p class=\"center-text md-title md-padding bold-text\" flex=\"100\">Settings</p><div layout=\"\" layout-align=\"space-around center\" flex=\"100\"><md-checkbox ng-model=\"newUser.public\" flex=\"45\">Is Public Profile?</md-checkbox><md-checkbox ng-model=\"newUser.virtualMobile\" flex=\"45\">Require Mobile Number At Checkout</md-checkbox></div><div layout=\"\" layout-align=\"space-around center\" flex=\"100\"><md-checkbox ng-model=\"newUser.flags.onboardUser\" flex=\"45\">Onboard User?</md-checkbox><md-checkbox ng-model=\"newUser.flags.hasOrgPassword\" flex=\"45\">Has Org Password?</md-checkbox></div><div ng-if=\"(newUser.role === \'admin\' || newUser.role === \'influencer\') && newUser._id\" class=\"full-width\"><md-divider></md-divider><md-card><div class=\"md-padding\" layout=\"column\"><p class=\"center-text md-title md-padding bold-text\" flex=\"100\">Social Profile</p><div layout=\"row\" layout-align=\"space-between center\" layout-wrap=\"\"><md-input-container flex=\"100\"><label>Instagram</label> <input type=\"url\" ng-model=\"newUser.instagramProfile\"></md-input-container><md-input-container flex=\"100\"><label>Facebook</label> <input type=\"url\" ng-model=\"newUser.facebookProfile\"></md-input-container><md-input-container flex=\"100\"><label>Youtube</label> <input type=\"url\" ng-model=\"newUser.youtubeProfile\"></md-input-container><md-input-container flex=\"100\"><label>Website</label> <input type=\"url\" ng-model=\"newUser.website\"></md-input-container><md-input-container flex=\"100\"><label>Bio</label> <textarea ng-model=\"newUser.bio\" rows=\"3\" placeholder=\"Your short sweet bio\" md-maxlength=\"180\"></textarea></md-input-container><md-input-container flex=\"100\"><label>Date of Birth</label><md-datepicker ng-model=\"newUser.dob\"></md-datepicker></md-input-container></div></div></md-card></div><md-card class=\"full-width\" ng-if=\"(newUser.role === \'org-agent\' || newUser.role === \'org-admin\') && newUser._id\"><md-card-header flex=\"\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">Dispatch Address</span><md-button class=\"md-primary outline small\" ng-click=\"openAddressSelector($event)\">Change Address</md-button></md-card-header><md-card-content><div layout=\"column\" ng-if=\"newUser.dispatchAddress\"><p class=\"md-body-1 bold-text\">{{ newUser.dispatchAddress.name }} : {{newUser.dispatchAddress.mobile}}</p><p class=\"md-caption\">{{ newUser.dispatchAddress.streetAddress }}</p><p class=\"md-caption\"><span ng-if=\"newUser.dispatchAddress.landmark\">{{ newUser.dispatchAddress.landmark }},</span> {{newUser.dispatchAddress.city}}, {{newUser.dispatchAddress.state}}-{{newUser.dispatchAddress.pinCode}}</p></div><div layout=\"column\" layout-align=\"center center\" ng-if=\"!newUser.dispatchAddress\"><img src=\"assets/images/blank.svg\" style=\"width: 100px; height: auto\"><p>No Address Set</p><md-button class=\"md-primary outline\" ng-click=\"openAddressSelector($event)\">Select Address</md-button></div></md-card-content></md-card><input type=\"hidden\" ng-model=\"newUser.dispatchAddress\"></form></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><md-button ng-disabled=\"newUserForm.$invalid || saving\" type=\"submit\" class=\"md-raised md-accent\" ng-click=\"saveUser($event);\"><span ng-if=\"!saving\">{{editingMode ? \"Edit\" : \"Save\"}}</span><bubble-loader ng-if=\"saving\"></bubble-loader></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/users/dialogs/follow-dialog/follow-dialog.html","<md-dialog aria-label=\"followDialog block\" flex-gt-sm=\"50\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\"><span>{{ loading ? \'Loading Details...\' : \'View Followers/Following List\'}}</span> <span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-progress-linear ng-if=\"loading\"></md-progress-linear><md-dialog-content ng-if=\"!loading\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-center-tabs=\"\"><md-tab label=\"Followers\" md-on-select=\"fetchList(\'followers\')\"></md-tab><md-tab label=\"Following\" md-on-select=\"fetchList(\'following\')\"></md-tab></md-tabs><md-subheader><md-input-container class=\"no-error-spacer md-block full-width\"><textarea placeholder=\"Search for user\" ng-model=\"searchText\"></textarea></md-input-container></md-subheader><div class=\"info-box slide-up-fade-in\" layout=\"\" layout-align=\"space-between center\" ng-if=\"searchText\"><section layout=\"\" layout-align=\"start center\"><md-icon>star_filled</md-icon><span class=\"bold-text\">Showing Filtered Results</span></section><md-button class=\"md-warn small round\" ng-click=\"clearFilters()\"><md-icon>close</md-icon>Clear Filters</md-button></div><md-list class=\"md-3-line\"><md-list-item ng-repeat-start=\"item in list | filter : searchText\"><profile-image image-url=\"{{item.user.profileImageURL}}\" small=\"true\" class=\"avatar md-avatar\"></profile-image><div class=\"md-list-item-text\" layout=\"column\"><h5 style=\"margin-bottom: 4px\">{{::item.user.name}}</h5><h6 style=\"margin-bottom: 4px\">{{::item.user.email}} | {{::item.user.mobile}}</h6><p class=\"md-caption\">Date : {{::item.followDate | date : \'medium\'}}</p></div><div class=\"md-secondary\"><md-button class=\"flat md-primary small outline\" target=\"_blank\" ui-sref=\"app.users.details.home({userId : item.user._id})\">View Profile</md-button></div></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/users/dialogs/influencer-details-dialog/influencer-details.html","<md-dialog aria-label=\"addNewUserDialog block\" flex-gt-sm=\"50\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\"><span>{{ loading ? \'Loading Details...\' : \'View Influencer Details\'}}</span> <span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-progress-linear ng-if=\"loading\"></md-progress-linear><md-dialog-content class=\"md-dialog-content\" ng-if=\"!loading\"><div layout=\"\"><section flex=\"33\" layout=\"\" layout-align=\"center center\"><md-img class=\"avatar full-width\" style=\"width: 150px; height: 150px\" md-src=\"{{influencer.profileImageURL}}\"></md-img></section><section layout=\"column\" layout-align=\"center start\"><p class=\"md-title\">{{influencer.name}}</p><p class=\"md-body-1\"><a class=\"md-link pointer\" target=\"_blank\" ng-if=\"influencer.userName\" href=\"{{Base.getAppUrl() + \'/profile/\' + influencer.userName}}\">@{{influencer.userName}}</a> <a class=\"md-link pointer\" ng-click=\"editUser($event);\" ng-if=\"!influencer.userName\">Set Username</a></p><p class=\"md-body-1\">Mobile : <a class=\"md-link pointer\" ng-href=\"{{\'tel:\'+ influencer.mobile}}\">{{influencer.mobile}}</a></p><p class=\"md-body-1\">Email : <a class=\"md-link pointer\" ng-href=\"{{\'email:\'+ influencer.email}}\">{{influencer.email}}</a></p></section></div><md-divider style=\"margin-top: 30px\"></md-divider><div layout=\"\" layout-align=\"center center\" ng-if=\"influencer.bio\" class=\"md-margin md-padding languid\" style=\"padding: 20px 0\"><p flex=\"85\">{{influencer.bio}}</p></div><div layout=\"\" layout-align=\"center center\" ng-if=\"!influencer.bio\" class=\"md-margin md-padding languid\" style=\"padding: 20px 0\"><a flex=\"85\" ng-click=\"editUser($event);\" class=\"md-link pointer\">Set Bio</a></div><md-list class=\"md-2-line\"><md-list-item><div class=\"md-list-item-text\" layout=\"column\"><p class=\"md-caption\">Current Role</p></div><p class=\"md-secondary\">{{influencer.role | uppercase}}</p></md-list-item><md-divider></md-divider><md-list-item><div class=\"md-list-item-text\" layout=\"column\"><p class=\"md-caption\">Followers</p></div><a class=\"md-secondary md-link pointer\" ng-click=\"showFollowList($event, {userId : influencer._id})\">{{influencer.followers.length}}</a></md-list-item><md-divider></md-divider><md-list-item><div class=\"md-list-item-text\" layout=\"column\"><p class=\"md-caption\">Age</p></div><p class=\"md-secondary\">{{influencer.age}}</p></md-list-item><md-divider></md-divider><md-list-item><div class=\"md-list-item-text\" layout=\"column\"><p class=\"md-caption\">DOB</p></div><p class=\"md-secondary\">{{influencer.dob | date : \'dd-MMM-yyyy\'}}</p></md-list-item><md-divider></md-divider><md-list-item><div class=\"md-list-item-text\" layout=\"column\"><p class=\"md-caption\">Based In</p></div><p class=\"md-secondary\" ng-if=\"influencer.basedIn\">{{influencer.basedIn.city}},{{influencer.basedIn.state}},{{influencer.basedIn.pinCode}}</p></md-list-item><md-divider></md-divider><md-list-item><div class=\"md-list-item-text\" layout=\"column\"><p class=\"md-caption\">Instagram Profile</p></div><a class=\"md-secondary md-link pointer\" target=\"_blank\" ng-if=\"influencer.instagramProfile\" ng-href=\"{{influencer.instagramProfile}}\">{{influencer.instagramProfile}}</a></md-list-item><md-divider></md-divider><md-list-item><div class=\"md-list-item-text\" layout=\"column\"><p class=\"md-caption\">Facebook Profile</p></div><a class=\"md-secondary md-link pointer\" target=\"_blank\" ng-if=\"influencer.facebookProfile\" ng-href=\"{{influencer.facebookProfile}}\">{{influencer.facebookProfile}}</a></md-list-item><md-divider></md-divider><md-list-item><div class=\"md-list-item-text\" layout=\"column\"><p class=\"md-caption\">Youtube Link</p></div><a class=\"md-secondary md-link pointer\" target=\"_blank\" ng-if=\"influencer.youtubeProfile\" ng-href=\"{{influencer.youtubeProfile}}\">{{influencer.youtubeProfile}}</a></md-list-item><md-divider></md-divider><md-list-item><div class=\"md-list-item-text\" layout=\"column\"><p class=\"md-caption\">Website</p></div><a class=\"md-secondary md-link pointer\" target=\"_blank\" ng-if=\"influencer.website\" ng-href=\"{{influencer.website}}\">{{influencer.website}}</a></md-list-item></md-list></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" class=\"outline md-accent\" ng-click=\"editUser($event);\">Edit</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/users/dialogs/select-users/select-users.dialog.html","<md-dialog flex=\"50\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout-align=\"space-between center\"><span class=\"md-title\">{{title}}</span><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content md-padding\"><p class=\"center-text\">Start Typing in the box below to filter users</p><div layout=\"\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"100\" md-no-float=\"\"><md-icon>search</md-icon><textarea autocomplete=\"off\" rows=\"2\" ng-model=\"query.q\" ng-change=\"fetchUsers()\" placeholder=\"Search for users\"></textarea></md-input-container></div><md-radio-group ng-model=\"$parent.selectedUsers\" ng-if=\"!multiple\"><md-list><md-list-item ng-repeat=\"user in users\" class=\"md-2-line\"><div class=\"md-list-item-text\"><h3>{{user.name}} <span class=\"grey-text md-caption\" ng-if=\"user.role\">({{user.role | uppercase}})</span></h3><p class=\"md-caption\">{{user.mobile}}</p></div><md-radio-button ng-value=\"user\" class=\"md-secondary md-primary\"></md-radio-button></md-list-item></md-list></md-radio-group><md-list ng-if=\"multiple\"><md-list-item ng-repeat=\"user in users\" class=\"md-2-line\"><div class=\"md-list-item-text\"><h3>{{user.name}} <span class=\"grey-text md-caption\" ng-if=\"user.role\">({{user.role | uppercase}})</span></h3><p class=\"md-caption\">{{user.mobile}}</p></div><md-checkbox class=\"md-primary md-secondary\" ng-model=\"user.selected\" ng-change=\"updateSelected(user)\"></md-checkbox></md-list-item></md-list></md-dialog-content><md-dialog-actions layout-align=\"space-between center\"><md-button ng-click=\"close()\">Cancel</md-button><md-button class=\"md-primary\" ng-click=\"done()\" ng-disabled=\"!selectedUsers || loadingUsers\">Select</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/users/dialogs/tag-users-dialog/tag-users-dialog.html","<md-dialog flex=\"50\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout-align=\"space-between center\"><span class=\"md-title\">Tags Users</span><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content md-padding\"><form name=\"tagForm\"><md-chips name=\"tags\" ng-model=\"tags.names\" ng-required=\"true\" placeholder=\"Ex. Contest 1\" secondary-placeholder=\"Add another tag\"></md-chips></form></md-dialog-content><md-dialog-actions layout-align=\"space-between center\"><md-button ng-click=\"close()\">Cancel</md-button><md-button class=\"md-primary\" ng-click=\"tagUsers(form)\">Create Tags</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/users/influencers/partials/influencer.html","<div><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"Approved\" md-on-select=\"fetchAllInfluencers(\'approved\')\"><md-content><div ng-if=\"!influencers.length && !loading\" layout=\"column\" layout-align=\"center center\" class=\"md-padding md-margin\"><h5 class=\"error-title\">Influencers not found</h5><img src=\"assets/images/blank.svg\" alt=\"No Influencers Found\" style=\"max-width: 200px; height: auto\"></div><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getAllInfluencers\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\" md-order-by=\"name\">Name</th><th md-column=\"\" md-order-by=\"mobile\">Mobile</th><th md-column=\"\" md-order-by=\"createdAt\">Approved On</th><th md-column=\"\" md-order-by=\"metrics.viewCount\">Views</th><th md-column=\"\" md-order-by=\"followers.length\">Followers</th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"influencer\" md-select-id=\"influencer._id\" md-auto-select=\"\" ng-repeat=\"influencer in influencers\"><td md-cell=\"\">{{$index + 1}}.</td><td md-cell=\"\"><profile-image image-url=\"{{influencer.profileImageURL}}\" medium=\"true\"></profile-image></td><td md-cell=\"\">{{influencer.name}}</td><td md-cell=\"\">{{influencer.mobile}}</td><td md-cell=\"\">{{influencer.influencerRequest.statusHistory.requestHandledOn | date: \'medium\'}}</td><td md-cell=\"\">{{influencer.metrics.viewCount}}</td><td md-cell=\"\"><a class=\"md-secondary md-link\" ng-click=\"showFollowList($event, {userId : influencer._id})\">{{influencer.followers.length}}</a></td><td md-cell=\"\"><md-button class=\"md-primary md-raised flat small\" ng-click=\"openDetails($event, {userId : influencer._id})\">View Details</md-button></td></tr></tbody></table></md-table-container></md-content></md-tab><md-tab label=\"Pending Approvals\" md-on-select=\"fetchAllInfluencers(\'pending\')\"><md-content><div ng-if=\"!influencers.length && !loading\" layout=\"column\" layout-align=\"center center\" class=\"md-padding md-margin\"><h5 class=\"error-title\">Influencers not found</h5><img src=\"assets/images/blank.svg\" alt=\"No Influencers Found\" style=\"max-width: 200px; height: auto\"></div><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"getAllInfluencers\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\" md-order-by=\"name\"><span>Name</span></th><th md-column=\"\" md-order-by=\"mobile\" md-numeric=\"\">Mobile</th><th md-column=\"\" md-order-by=\"createdAt\">Applied Date</th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"influencer\" md-select-id=\"influencer._id\" md-auto-select=\"\" ng-repeat=\"influencer in influencers\"><td md-cell=\"\">{{$index + 1}}.</td><td md-cell=\"\"><profile-image image-url=\"{{influencer.profileImageURL}}\" medium=\"true\"></profile-image></td><td md-cell=\"\">{{influencer.name}}</td><td md-cell=\"\">{{influencer.mobile}}</td><td md-cell=\"\">{{influencer.influencerRequest.appliedForMarketerOn | date: \'medium\'}}</td><td md-cell=\"\"><div layout=\"\" layout-align=\"start center\"><md-button class=\"md-primary md-raised flat small\" ng-click=\"openDetails($event, {userId : influencer._id})\">View Details</md-button><md-button class=\"rounded md-warn small outline\" ng-click=\"manageInfluencerRequest($index, influencer._id, \'deny\');\"><md-progress-circular md-diameter=\"24\" class=\"md-warn\" ng-if=\"managingRequest\"></md-progress-circular><span ng-if=\"!managingRequest\">Deny</span></md-button><md-button class=\"rounded md-primary small outline\" ng-click=\"manageInfluencerRequest($index, influencer._id, \'approved\');\"><md-progress-circular md-diameter=\"24\" class=\"md-primary\" ng-if=\"managingRequest\"></md-progress-circular><span ng-if=\"!managingRequest\">Approve</span></md-button><md-button class=\"rounded md-primary small outline\" ng-click=\"manageInfluencerRequest($index, influencer._id, \'on-hold\');\"><md-progress-circular md-diameter=\"24\" class=\"md-warn\" ng-if=\"managingRequest\"></md-progress-circular><span ng-if=\"!managingRequest\">Hold</span></md-button></div></td></tr></tbody></table></md-table-container></md-content></md-tab></md-tabs></div>");
$templateCache.put("app/modules/users/organisations/bill-details/bill-details.html","<md-dialog flex=\"45\" flex-xl=\"30\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span>View Bill Details</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-progress-linear ng-if=\"loading\"></md-progress-linear><md-dialog-content class=\"md-dialog-content\" ng-if=\"!loading\"><div layout=\"\" layout-align=\"space-between center\"><section><img src=\"assets/images/aarida-optimized.png\" class=\"logo medium\"></section><section><md-button ng-click=\"downloadInvoice($event)\" class=\"md-raised md-primary\">Download Invoice</md-button></section></div><div layout=\"\" layout-align=\"space-between center\"><section layout=\"column\" layout-align=\"start start\"><div ng-bind-html=\"formatAddress(transaction.organisation.address)\"></div><span class=\"md-tiny\">GSTIN : {{transaction.organisation.gstNumber}}</span></section><section style=\"text-align: end\"><span class=\"bold-text md-caption uppercase\">Redux X-press Private Limited</span><br><span class=\"md-tiny uppercase\">759, 1st Floor,</span><br><span class=\"md-tiny uppercase\">100 feet Road, Indiranagar</span><br><span class=\"md-tiny uppercase\">Bangalore, Karnataka - 560038</span><br><span class=\"md-tiny\">GSTIN : AAHCR0931ZR1R</span></section></div><md-divider class=\"md-margin\"></md-divider><div layout=\"column\" layout-align=\"center center\"><h5>Invoice Number : {{transaction.txnId}}</h5><h6>Invoice Date : {{transaction.createdAt | date : \'medium\'}}</h6></div><md-list class=\"md-2-line\"><md-list-item ng-repeat=\"lineItem in transaction.lineItems\" class=\"txn-item\"><div layout=\"\" class=\"md-list-item-text\"><div layout=\"\" layout-align=\"center center\"><p>{{$index + 1}}.</p></div><div class=\"md-padding\" layout=\"column\"><p>{{lineItem.description}}</p><div layout=\"\"><span class=\"md-caption\">Price : ₹{{lineItem.price}}</span> <span class=\"md-caption\" ng-if=\"lineItem.discountPercent\">| Discount : ₹{{lineItem.discountAmount}} ({{lineItem.discountPercent}}%)</span></div></div></div><h5 class=\"md-secondary md-title\">₹{{lineItem.totalPrice}}</h5></md-list-item><md-list-item><div layout=\"\" layout-align=\"end center\" class=\"md-secondary\"><span>Total :</span> <span class=\"md-headline\">₹ {{transaction.amount}}</span></div></md-list-item></md-list></md-dialog-content><md-dialog-actions layout-align=\"space-between center\" ng-if=\"!loading\"><md-button class=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/users/organisations/partials/index.html","<div layout=\"column\"><md-card><md-card-content><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-primary md-raised\" ng-click=\"addNewOrg($event)\"><md-icon>add</md-icon>Add Org</md-button></div></md-card-content><md-divider></md-divider><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.orgs\" md-on-reorder=\"fetchAllOrg\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\"><span>Sl No</span></th><th md-column=\"\">Name</th><th md-column=\"\"><span>Status</span></th><th md-column=\"\"><span>Balance (₹)</span></th><th md-column=\"\" md-order-by=\"adminUser\"><span>Admin</span></th><th md-column=\"\" md-order-by=\"updatedAt\"><span>Last Update</span></th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"orgs\" md-auto-select=\"\" ng-repeat=\"org in orgs\"><td md-cell=\"\">{{$index + 1 }}.</td><td md-cell=\"\">{{org.name}}</td><td md-cell=\"\">{{org.status}}</td><td md-cell=\"\">{{org.walletBalance}}</td><td md-cell=\"\">{{org.adminUser ? org.adminUser.name : \'N/A\'}}</td><td md-cell=\"\">{{org.updatedAt | date : \"mediumDate\"}}</td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"addNewOrg($event, org, $index)\"><md-icon>edit</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"showTxns($event, org, $index)\"><md-icon>history</md-icon></md-button><md-button class=\"md-icon-button\" ui-sref=\"app.users.all({organisation : org._id, roles : \'org-agent\'})\"><md-icon>people</md-icon><md-tooltip>View Agents</md-tooltip></md-button><md-button class=\"small outline\" ng-click=\"rechargeWallet($event, org)\">Recharge</md-button></td></tr></tbody></table></md-table-container><md-table-pagination mdboundarylinks=\"\" md-limit=\"query.limit\" md-limit-options=\"[5, 10, 25, 50,100]\" md-page=\"query.page\" md-total=\"{{total}}\" md-on-paginate=\"fetchAllOrg\" md-page-select=\"\"></md-table-pagination></md-card></div>");
$templateCache.put("app/modules/users/organisations/rechargeWallet/recharge-wallet.html","<md-dialog flex=\"45\" flex-xl=\"30\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span>Recharge Organisation Wallet</span><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><form name=\"orgWalletRechargeForm\" layout=\"column\"><md-card><md-card-content layout=\"column\" layout-align=\"center center\"><p><span class=\"md-title grey-text\">Current Balance :</span> <span class=\"md-display-1 bold-text\">₹ {{org.walletBalance}}</span></p><p>{{org.name}}</p><p class=\"grey-text\">{{org.adminUser.name}} : {{org.adminUser.mobile}}</p><md-divider></md-divider></md-card-content></md-card><div layout=\"\" layout-align=\"center center\" class=\"md-padding\"><md-switch ng-model=\"isDebit\" ng-if=\"!payingTxn\">{{isDebit ? \'Debit\' : \'Credit\'}}</md-switch></div><div layout=\"\" layout-align=\"center center\"><md-input-container flex=\"75\"><label>{{isDebit ? \'Deduction\' : \'Recharge\'}} Amount</label> <input required=\"\" name=\"amount\" type=\"number\" min=\"0\" ng-model=\"rechargeData.amount\"></md-input-container></div><div layout=\"\" layout-align=\"center center\"><md-input-container flex=\"75\"><label>Description</label> <textarea required=\"\" name=\"description\" rows=\"3\" ng-model=\"rechargeData.description\" placeholder=\"Enter Description\"></textarea></md-input-container></div><div layout=\"\" layout-align=\"center center\" ng-if=\"loadingLastRecharge && !payingTxn\"><md-progress-circular md-diameter=\"20\"></md-progress-circular></div><div layout=\"column\" ng-if=\"!loadingLastRecharge && lastTxn && !payingTxn\"><h4>Last Transaction:</h4><md-list class=\"md-3-line\"><md-list-item class=\"txn-item\" ng-class=\"{\'credit\' : lastTxn.txnType === \'credit\', \'debit\' : lastTxn.txnType === \'debit\'}\"><div class=\"md-list-item-text\"><p>{{lastTxn.description}}</p><p class=\"md-tiny grey-text\">{{lastTxn.txnId}}</p><span class=\"md-caption grey-text\">{{lastTxn.createdAt | date : \'medium\'}}</span></div><h3 class=\"md-secondary md-headline\" ng-class=\"{\'red-text\': lastTxn.txnType === \'debit\', \'green-text\' : lastTxn.txnType === \'credit\'}\">{{lastTxn.txnType === \'debit\' ? \'-\' : \'+\'}}₹{{lastTxn.amount}}</h3></md-list-item></md-list></div></form></md-dialog-content><md-dialog-actions layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"close()\">Cancel</md-button><md-button class=\"md-accent\" ng-click=\"recharge()\" ng-disabled=\"orgWalletRechargeForm.$invalid || saving\">Recharge Now</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/users/organisations/transactions-dialog/transactions-dialog.html","<md-dialog flex=\"60\" class=\"activateCardModal\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"center center\"><h4>View Txns for {{org.name}}</h4></div><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><h4>Transactions ({{total}}):</h4><md-list class=\"md-3-line\"><md-list-item class=\"txn-item\" ng-repeat=\"txn in txns\" ng-class=\"{\'credit\' : txn.txnType === \'credit\', \'debit\' : txn.txnType === \'debit\'}\"><div class=\"md-list-item-text\"><p>{{txn.description}}</p><p class=\"md-tiny grey-text\">{{txn.txnId}}</p><span class=\"md-caption grey-text\">{{txn.createdAt | date : \'medium\'}} |</span> <span class=\"md-caption grey-text\">From : ₹{{txn.from}}</span> <span class=\"md-caption grey-text\">To : ₹{{txn.to}}</span></div><div class=\"md-secondary\" layout=\"column\" layout-align=\"end end\"><h3 class=\"md-headline\" ng-class=\"{\'red-text\': txn.txnType === \'debit\', \'green-text\' : txn.txnType === \'credit\'}\">{{txn.txnType === \'debit\' ? \'-\' : \'+\'}}₹{{txn.amount}}</h3><div layout=\"\" layout-align=\"end center\"><md-button ng-if=\"txn.isReceipt\" class=\"small md-accent outline\" ng-click=\"viewBillDetails($event, txn)\">View Details</md-button><md-button ng-if=\"txn.isReceipt && !txn.isPaid\" class=\"small md-primary md-raised\" ng-click=\"markAsPaid($event, txn)\">Mark As Paid</md-button></div></div></md-list-item></md-list><div layout=\"\" layout-align=\"center center\"><md-progress-circular ng-if=\"loading\"></md-progress-circular><md-button class=\"md-accent small md-raised\" ng-click=\"nextPage()\" ng-if=\"!loading && (total > txns.length)\">Next Page</md-button></div></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/workforce/components/task-item/task-item.component.tmpl.html","<div class=\"task-item-component\" layout=\"\" layout-wrap=\"\" layout-align=\"start center\"><div flex=\"20\"><md-img md-src=\"{{$ctrl.task.previewImageUrl}}\" class=\"task-preview-image\" ng-if=\"$ctrl.task.previewImageUrl\"></md-img><div ng-if=\"!$ctrl.task.previewImageUrl\" class=\"task-preview-image placeholder\"></div></div><span class=\"task-name\">{{$ctrl.task.name}}</span> <span class=\"assignee\">{{$ctrl.task.assignee ? $ctrl.task.assignee.name : \'Unassigned\'}}</span> <span class=\"status\">{{$ctrl.task.taskType}}</span> <span class=\"status\">{{$ctrl.task.status}}</span></div>");
$templateCache.put("app/modules/workforce/components/task-list/task-list.component.tmpl.html","<div class=\"task-list-component\"><div layout=\"\" layout-align=\"center center\" ng-if=\"$ctrl.dynamic\"><md-content md-scroll-x=\"\" class=\"scrolling-tabs\"><md-button class=\"custom-tab\" style=\"min-width: 88px\" ng-repeat=\"taskType in $ctrl.taskTypes\" ng-class=\"{\'active md-primary\' : $ctrl.query.taskTypes === taskType.value}\" ng-click=\"$ctrl.applyFilter(taskType.value)\"><div layout=\"\" layout-align=\"center center\"><span>{{taskType.title}}</span></div></md-button></md-content></div><md-toolbar class=\"md-table-toolbar md-default\" ng-if=\"$ctrl.dynamic\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\" style=\"background: #ebebee\"><div layout=\"\" layout-align=\"start center\" flex=\"\"><section layout=\"\" layout-align=\"start center\" ng-if=\"$ctrl.selected.length\"><md-button class=\"md-icon-button material-icons--two-tone\" ng-click=\"$ctrl.clearSelections()\"><md-icon>close</md-icon></md-button><span class=\"md-caption\">{{$ctrl.selected.length}} Materials Selected</span></section><span ng-if=\"$ctrl.selected.length\" flex-offset=\"5\"></span> <span ng-if=\"$ctrl.selected.length\" flex-offset=\"5\"></span><form role=\"form\" novalidate=\"\" name=\"filterForm\" ng-submit=\"$ctrl.fetchTasks()\" layout=\"\" flex=\"\" layout-align=\"center center\"><md-input-container flex=\"\" class=\"no-error-spacer\" layout=\"\"><label>&nbsp;</label> <input type=\"search\" id=\"searchDesigns\" ng-model=\"$ctrl.query.search\" select-on-click=\"\" ng-model-options=\"{\'debounce\' : 500}\" ng-change=\"$ctrl.fetchTasks()\" placeholder=\"Search for Tasks\" class=\"search-bar-input\"></md-input-container><md-button ng-click=\"$ctrl.fetchTasks()\" class=\"md-icon-button\"><md-icon>search</md-icon></md-button></form></div><div layout=\"\" layout-align=\"end center\"></div></div></md-toolbar><md-table-pagination md-limit=\"$ctrl.query.limit\" md-limit-options=\"[10, 25, 50]\" md-page=\"$ctrl.query.page\" md-total=\"{{$ctrl.total}}\" md-on-paginate=\"$ctrl.fetchTasks\" ng-if=\"$ctrl.dynamic\" md-page-select=\"\"></md-table-pagination><md-table-container><table md-table=\"\" md-progress=\"$ctrl.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Sl</th><th md-column=\"\"></th><th md-column=\"\">Name</th><th md-column=\"\">Task Type</th><th md-column=\"\" md-numeric=\"\">Status</th><th md-column=\"\">Assigned</th><th md-column=\"\">Allotted Time</th><th md-column=\"\">Cost</th><th md-column=\"\">Created</th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"task in $ctrl.tasks\" class=\"task-row\"><td md-cell=\"\">{{ ((($ctrl.query.page - 1) * $ctrl.query.limit) + $index) + 1}}.</td><td md-cell=\"\" class=\"image-cell\"><md-img md-src=\"{{task.previewImageUrl}}\" class=\"task-preview-image\"></md-img></td><td md-cell=\"\"><a class=\"md-caption md-link pointer\" ui-sref=\"app.tasks.details({id : task._id})\">{{task.name}}</a></td><td md-cell=\"\" class=\"capitalize\"><div layout=\"column\" layout-align=\"center start\"><span class=\"capitalize\">{{task.taskType}}</span><section layout=\"\" layout-align=\"center center\"><div class=\"dot\" ng-style=\"{backgroundColor : $ctrl.getColor(\'priority\', task.priority)}\"></div><span class=\"capitalize md-tiny\" ng-style=\"{color : $ctrl.getColor(\'priority\', task.priority)}\">{{task.priority}}</span></section></div></td><td md-cell=\"\"><section layout=\"\" layout-align=\"center center\"><div class=\"dot\" ng-style=\"{backgroundColor : $ctrl.getColor(\'status\', task.status)}\"></div><span class=\"capitalize\" ng-style=\"{color : $ctrl.getColor(\'status\', task.status)}\">{{task.status}}</span></section></td><td md-cell=\"\"><section layout=\"column\"><span>{{task.assigneeList || \'Unassigned\'}}</span> <a class=\"md-tiny md-link pointer\" ng-disabled=\"updatingAssignee\" ng-if=\"task.status === \'created\' || task.status === \'paused\'\" ng-click=\"$ctrl.selectAssignee(task, $index, $event)\"><span ng-if=\"!task.updatingAssignee\">Update</span><bubble-loader ng-if=\"updatingAssignee\"></bubble-loader></a></section></td><td md-cell=\"\"><section class=\"md-tiny\"><div layout=\"column\" layout-align=\"center start\"><a class=\"md-caption md-link pointer\" style=\"margin-bottom: 8px\" ng-click=\"task.status !==\'completed\' && task.status !== \'cancelled\' ? $ctrl.openUpdateTimeDialog($event, task, $index) : \'\'\" ng-class=\"{\'disabled\' : task.status ===\'completed\' || task.status === \'cancelled\'}\"><span ng-if=\"task.isStarted || task.status === \'completed\'\">{{task.currentDurationObject.display}} /</span> {{task.allottedDurationObject.display}}</a><md-progress-linear value=\"{{task.durationPercent}}\" style=\"border-radius: 4px\" ng-if=\"task.isStarted\" class=\"task-progress\" ng-class=\"task.progressColor\" md-mode=\"{{task.status === \'paused\' ? \'determinate\' : \'indeterminate\'}}\"></md-progress-linear></div></section></td><td md-cell=\"\"><span class=\"md-body-1\">{{task.productionCost ? \'₹\' + task.productionCost : \'-\'}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{task.createdAt | date : \'mediumDate\'}}</span></td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"\"><md-icon>edit</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"$ctrl.query.limit\" md-limit-options=\"[10, 25, 50]\" md-page=\"$ctrl.query.page\" md-total=\"{{$ctrl.total}}\" md-on-paginate=\"$ctrl.fetchTasks\" ng-if=\"$ctrl.dynamic\" md-page-select=\"\"></md-table-pagination></div>");
$templateCache.put("app/modules/workforce/tasks/partials/all-tasks.html","<div><md-tabs md-border-bottom=\"\" md-selected=\"selectedTab\" md-dynamic-height=\"\" md-center-tabs=\"\" md-enable-disconnect=\"\"><md-tab label=\"All Tasks\"><md-content class=\"md-padding\"><task-list dynamic=\"true\"></task-list></md-content></md-tab><md-tab label=\"Orders\" ng-click=\"fetchOrders()\"><md-content class=\"md-padding\"><div layout=\"column\"><section ng-repeat=\"order in orders\" class=\"full-width expandable-section single-order\" ng-class=\"{\'expanded\' : order.showLineItems}\"><md-card ng-click=\"toggleLineItem(order)\" class=\"relative pointer order-card\" md-ink-ripple=\"#c3c3c3\"><div layout=\"\" layout-align=\"start center\" class=\"single-item\"><span flex-offset=\"5\">{{$index + 1}}.</span><div layout=\"\" class=\"images-list\" flex-offset=\"5\"><section class=\"image\" ng-repeat=\"lineItem in order.lineItems\"><md-img md-src=\"{{lineItem.image.urls.thumbnail}}\" class=\"task-preview-image\"></md-img><md-tooltip md-direction=\"top\">{{lineItem.name}}</md-tooltip></section></div><span flex=\"\"></span><p class=\"md-body-2 bold-text\" flex-offset=\"5\">{{order.orderNumber}}</p><span flex=\"\"></span><section class=\"md-caption\" layout=\"column\" layout-align=\"center center\"><span>{{order.user.name}}</span> <span>{{order.user.mobile}}</span><br></section><span flex-offset=\"5\" class=\"grey-text md-tiny\">{{order.createdAt | date : \'medium\'}}</span><div flex-offset=\"5\"><md-icon>{{order.showLineItems ? \'keyboard_arrow_up\' : \'keyboard_arrow_down\'}}</md-icon></div></div></md-card><div class=\"line-items-view expansion-content\" ng-class=\"{\'expanded\' : order.showLineItems}\"><h4>Line Items :</h4><section ng-repeat=\"lineItem in order.lineItems\" class=\"expandable-section\"><md-card ng-click=\"toggleLineItemTasks(lineItem)\" class=\"relative pointer\" md-ink-ripple=\"#c3c3c3\"><section layout=\"\" layout-align=\"start center\" class=\"single-line-item\"><span flex-offset=\"5\">{{$index + 1}}.</span><md-img md-src=\"{{lineItem.image.urls.medium}}\" class=\"md-avatar\" flex-offset=\"5\"></md-img><section layout=\"column\" layout-align=\"center start\" flex-offset=\"5\"><span>{{lineItem.name}}</span> <span class=\"md-caption grey-text\">{{lineItem.sku}}</span></section><span flex=\"\"></span> <span>Tasks : {{lineItem.tasks ? lineItem.tasks.length : 0}}</span><div flex-offset=\"5\"><md-icon>{{lineItem.showTasks ? \'keyboard_arrow_up\' : \'keyboard_arrow_down\'}}</md-icon></div></section></md-card><div class=\"tasks-table expansion-content\" ng-class=\"{\'expanded\' : lineItem.showTasks}\"><div layout=\"\" layout-align=\"center center\" ng-if=\"lineItem.loading\"><md-progress-circular md-diameter=\"32\"></md-progress-circular></div><md-table-container><task-list tasks=\"lineItem.hydratedTasks\" ng-if=\"lineItem.hydratedTasks\"></task-list></md-table-container></div></section></div></section></div></md-content></md-tab><md-tab label=\"Designs\" ng-click=\"fetchDesigns()\"><md-content class=\"md-padding\"><div layout=\"column\"><section ng-repeat=\"design in designs\" class=\"full-width expandable-section single-order\" ng-class=\"{\'expanded\' : design.showTasks}\"><md-card ng-click=\"toggleDesignTasks(design)\" class=\"relative pointer order-card\" md-ink-ripple=\"#c3c3c3\"><div layout=\"\" layout-align=\"start center\" class=\"single-item\"><span flex-offset=\"5\">{{$index + 1}}.</span><div layout=\"\" class=\"images-list\" flex-offset=\"5\"><section class=\"image\"><md-img md-src=\"{{design.previewImageUrl}}\" class=\"task-preview-image\"></md-img></section></div><span flex=\"\"></span><p class=\"md-body-2 bold-text\" flex-offset=\"5\">{{design.name}}</p><span flex=\"\"></span><section class=\"md-caption\" layout=\"column\" layout-align=\"center center\"><span>{{design.designerName}}</span><br></section><span flex-offset=\"5\" class=\"grey-text md-tiny\">{{design.createdAt | date : \'medium\'}}</span><div flex-offset=\"5\"><md-icon>{{design.showTasks ? \'keyboard_arrow_up\' : \'keyboard_arrow_down\'}}</md-icon></div></div></md-card><div class=\"tasks-table expansion-content\" ng-class=\"{\'expanded\' : design.showTasks}\"><div layout=\"\" layout-align=\"center center\" ng-if=\"design.loading\"><md-progress-circular md-diameter=\"32\"></md-progress-circular></div><md-table-container><task-list tasks=\"design.hydratedTasks\" ng-if=\"design.hydratedTasks\"></task-list></md-table-container></div></section></div></md-content></md-tab></md-tabs></div>");
$templateCache.put("app/modules/workforce/tasks/partials/tasks-home.html","<md-section-header md-section-title=\"{{pageTitle}}\" md-back-state=\"{{backState}}\" md-nested-state=\"nestedState\"><md-button class=\"md-raised action-button md-primary\" ng-click=\"onActionButtonClick($event);\" ng-if=\"showActionButton && !actionButtonDisabled.$$state.pending\">{{actionButtonText}}</md-button><md-progress-circular ng-if=\"actionButtonDisabled.$$state.pending\" md-mode=\"indeterminate\" md-diameter=\"40\" class=\"md-accent\"></md-progress-circular></md-section-header><form ng-disabled=\"actionButtonDisabled.$$state.pending\" style=\"z-index: 1\"><div ui-view=\"\"></div></form>");
$templateCache.put("app/modules/workforce/tasks/task-details/task-details.html","<div class=\"task-details-page\"><div layout=\"\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start center\" class=\"md-padding\" flex=\"40\"><md-img style=\"width: 80%; border-radius: 4px; border-bottom: 4px\" md-src=\"{{selectedImage.urls.large}}\"></md-img><md-content md-scroll-x=\"\" layout=\"\" layout-align=\"center center\"><md-img class=\"md-margin image-preview relative pointer\" style=\"width: 75px; height: auto; border-radius: 4px;\" md-ink-ripple=\"#c3c3c3\" ng-class=\"{\'selected\' : image.active}\" ng-repeat=\"image in task.images\" ng-click=\"selectImage(image, $index)\" md-src=\"{{image.urls.thumbnail}}\"></md-img></md-content></div><div layout=\"column\" layout-align=\"start start\" class=\"md-padding\" flex=\"60\"><h2>{{task.name}}</h2><p>{{task.designer.name}}</p><p>{{task.createdAt | date: \'medium\'}}</p><p>Priority: {{task.priority}}</p><md-card style=\"width: 95%\" class=\"flat\"><div layout=\"\" layout-align=\"space-between\"><h4 style=\"margin-left: 8px\">Measurements</h4></div><md-divider></md-divider><md-list ng-if=\"task.measurements.length\"><md-list-item ng-repeat-start=\"measurement in task.measurements\"><p>{{measurement.key}}</p><p class=\"md-secondary md-title\">{{measurement.value}}</p></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list><div ng-if=\"!task.measurements.length\" layout=\"column\" layout-align=\"center center\" class=\"md-padding\"><img src=\"assets/images/blank.svg\" style=\"width: 250px\"><p class=\"md-caption\">No measurements found</p></div></md-card><md-card style=\"width: 95%\"><div layout=\"\" layout-align=\"space-between\"><h4 style=\"margin-left: 8px\">History</h4></div><md-divider></md-divider><md-list class=\"md-2-line\"><md-list-item ng-repeat-start=\"note in task.notes | orderBy : \'-date\'\"><div layout=\"column\"><h3 class=\"md-caption\">{{note.description}}</h3><p class=\"md-tiny\">By {{note.creator.name}}</p></div><p class=\"md-secondary md-caption\">{{note.date | date : \'medium\'}}</p></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list></md-card></div></div><md-card><div layout=\"\" layout-align=\"space-between\" class=\"md-padding\"><h3>Details</h3></div><md-divider></md-divider><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\">#</th><th md-column=\"\">Assignor</th><th md-column=\"\">Assignee</th><th md-column=\"\">Task Type</th><th md-column=\"\">Product</th><th md-column=\"\">Allotted Time</th><th md-column=\"\">Created On</th><th md-column=\"\">History</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\"><td md-cell=\"\"></td><td md-cell=\"\">{{task.assignor.name}}.</td><td md-cell=\"\">{{task.lastAssignee.name}}.</td><td md-cell=\"\">{{task.taskType}}.</td><td md-cell=\"\">{{task.productName}}.</td><td md-cell=\"\">{{allottedTime}}</td><td md-cell=\"\">{{task.createdAt | date :\'medium\'}}.</td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"showHistory($event)\"><md-icon>history</md-icon><md-tooltip>Check Task History</md-tooltip></md-button></td></tr></tbody></table></md-table-container></md-card></div>");
$templateCache.put("app/modules/base/dialogs/set-awb-code/partials/set-awb-code.tmpl.html","<md-dialog flex=\"50\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout-align=\"space-between center\"><span>Set AWB Code for {{lineItem.name}}</span><md-button ng-click=\"close()\" class=\"md-icon-button\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><div layout=\"\" layout-align=\"center center\" class=\"md-padding md-margin\"><md-input-container><label>Set Awb Code</label> <input type=\"text\" ng-model=\"lineItem.awbCode\"></md-input-container></div></md-dialog-content><md-divider></md-divider><md-dialog-actions><div layout=\"\" layout-align=\"center center\" flex=\"\"><md-button class=\"md-warn small md-raised\" ng-click=\"close()\">Cancel</md-button><span flex=\"\"></span><md-button class=\"md-primary small md-raised\" ng-click=\"updateLineItemAwbCode(lineItem.awbCode)\">Set AWB Code</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/offers/giftCards/dialogs/partials/index.tmpl.html","<md-dialog flex=\"40\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-body-1\">{{ mode === \'resolve\' ? \"Resolve Fraud Attempt\" : \"Block Card\"}}</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><form name=\"resolveForm\" layout=\"column\" layout-align=\"start center\" flex=\"\"><div layout=\"column\" layout-align=\"center center\"><p class=\"md-caption\">Description: <span class=\"md-body-1 bold-text\">{{fraudAttempt.description}}</span></p><p class=\"md-caption\">Date: <span class=\"md-body-1 bold-text\">{{fraudAttempt.date | date}}</span></p></div><md-input-container class=\"full-width\"><label>Reason to {{mode === \'resolve\' ? \'Resolve\' : \'Block\'}}</label> <textarea rows=\"3\" ng-minlength=\"6\" md-maxlength=\"200\" required=\"\" ng-model=\"payload.description\" placeholder=\"Please be as descriptive as possible.\"></textarea></md-input-container><md-input-container ng-if=\"mode === \'resolve\'\"><md-checkbox ng-model=\"payload.isSuspicious\">Looks suspicious?</md-checkbox></md-input-container></form></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"closeDialog()\">Cancel</md-button><md-button class=\"md-primary md-raised\" ng-disabled=\"resolveForm.$invalid || blocking\" ng-click=\"handleFraudAttempts()\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!handlingFraudTickets\">{{mode === \'resolve\' ? \'Resolve\' : \'Block\'}}</span><bubble-loader ng-if=\"handlingFraudTickets\"></bubble-loader></div></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/offers/giftCards/dialogs/updateExpiryDate/updateExpiryDate.html","<md-dialog><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">Update Expiry Date</span><md-button class=\"md-warn md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-progress-linear ng-if=\"savingExpiry\"></md-progress-linear><md-dialog-content class=\"md-dialog-content\"><p class=\"text-center\">Update the expiry date of the Gift Card. Make sure that you understand what you are doing.</p><h3 class=\"center-text\">Step 1</h3><h5 class=\"center-text\">Select one of the template dates from below or enter a custom date manually :</h5><md-radio-group ng-model=\"selectedTemplate\" ng-change=\"updateExpiryDate()\"><md-list class=\"md-2-line\"><md-list-item ng-repeat=\"template in dateTemplates\"><div class=\"md-list-item-text md-padding\" layout=\"column\"><span>{{template.label}}</span></div><md-radio-button class=\"md-secondary\" ng-value=\"template\"></md-radio-button></md-list-item></md-list></md-radio-group><div layout=\"\" layout-align=\"center center\" ng-if=\"selectedTemplate.value === \'custom\'\"><md-input-container><label>Select Date</label><md-datepicker ng-model=\"$parent.expiryDate\" ng-change=\"updateExpiryDate()\"></md-datepicker></md-input-container></div><div ng-if=\"selectedTemplate.value && selectedTemplate.value !== \'custom\'\" class=\"center-text\" layout=\"column\" layout-align=\"center center\"><h3>Step 2</h3><h5>Select the date range to update the expiry date in the cards :</h5><md-input-container><label>Select Activation Date/ Redemption Date</label><md-select ng-model=\"$parent.dateRange\" ng-change=\"updateExpiryDate()\"><md-option value=\"activationDate\">Activate Date</md-option><md-option value=\"redemptionDate\">Redemption Date</md-option></md-select></md-input-container></div><md-divider></md-divider><md-list><md-list-item ng-repeat-start=\"card in cards\" class=\"md-3-line\" style=\"background: #e7f3f3; margin: 2px 0; border-radius: 4px\"><div layout=\"column\" class=\"md-list-item-text\"><h4 class=\"md-subhead\">{{card.user.name}}</h4><p class=\"md-body-1\">{{card.code}}</p><p class=\"red-text\" ng-if=\"card.error\">{{card.error}}</p></div><div layout=\"column\" layout-align=\"center end\" class=\"md-secondary\"><span class=\"md-caption\">{{card.expiryDate | date : \'mediumDate\'}}</span><md-icon ng-class=\"{\'green-text\' : card.success && card.updated, \'red-text\' : card.success && card.updated}\">{{!card.updated ? \'refresh\' : (card.success ? \'check_circle\' : \'close\')}}</md-icon></div></md-list-item><md-divider ng-if=\"!$last\" ng-repeat-end=\"\"></md-divider></md-list></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"close()\">Close</md-button><md-button class=\"md-primary outline\" ng-disabled=\"savingExpiry || !selectedTemplate\" ng-click=\"saveExpiryDate()\"><bubble-loader ng-if=\"savingExpiry\"></bubble-loader><span ng-if=\"!savingExpiry\">Save</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/orders/orderDetails/directives/template/star-rating.html","<div layout=\"column\"><div class=\"col-md-12\" layout=\"\" layout-align=\"center center\"><div><md-button ng-repeat=\"star in stars\" class=\"md-icon-button rating-button\" ng-click=\"toggle($index)\"><md-icon class=\"md-accent rating-icon\">{{star.filled ? \'star\' : \'star_border\'}}</md-icon></md-button></div></div></div>");
$templateCache.put("app/modules/products/addProducts/partials/tabs/attributes.html","<div layout=\"column\" ng-controller=\"products.add.attributes.controller as attributesCtrl\"><div layout=\"row\" class=\"md-padding\"><section flex=\"50\" layout=\"\" layout-align=\"center center\"><md-autocomplete flex=\"\" md-no-cache=\"true\" md-selected-item=\"attributesCtrl.selectedProduct\" md-items=\"item in attributesCtrl.searchProducts()\" md-search-text=\"attributesCtrl.searchQuery\" md-clear-button=\"true\" md-item-text=\"item.name\" placeholder=\"Copy Attributes from Product\"><md-item-template><div layout=\"\" layout-align=\"stretch center\"><md-img md-src=\"{{::item.featured_image.urls.thumbnail}}\" class=\"md-avatar\" style=\"width: 30px; height: 41px; border-radius: 50%;\"></md-img><div layout=\"column\"><p class=\"md-caption\" md-highlight-text=\"searchText\">{{item.name}} ({{item.sku}}) - &#8377; {{item.price}}</p></div><span flex=\"20\"></span></div></md-item-template></md-autocomplete><md-button class=\"md-raised md-accent\" ng-disabled=\"!attributesCtrl.selectedProduct\" ng-click=\"attributesCtrl.copyAttributes()\">Copy Attributes</md-button></section><span flex=\"\"></span><md-button flex=\"30\" class=\"md-raised md-accent\" ng-click=\"attributesCtrl.addAttribute();\">Add New</md-button></div><div flex=\"\" layout=\"row\" ng-repeat=\"attributeData in attributesCtrl.product.attributes\" ng-show=\"attributesCtrl.product.attributes.length > 0\"><md-card flex=\"25\"><md-card-content><md-select aria-label=\"Select Attribute\" ng-change=\"attributesCtrl.log(attributesCtrl.product.attributes[$index])\" ng-model=\"attributesCtrl.product.attributes[$index].attribute\" ng-model-options=\"{trackBy: \'$value._id\'}\" placeholder=\"Select Attribute\"><md-option ng-value=\"attribute\" ng-repeat=\"attribute in attributesCtrl.attributes | orderBy:\'meta_key\'\">{{ attribute.meta_key }}</md-option></md-select></md-card-content></md-card><md-card flex=\"\"><md-card-content layout=\"row\"><md-select flex=\"25\" required=\"\" ng-if=\"!attributesCtrl.product.attributes[$index].attribute.allowMultipleSelections\" aria-label=\"Select Attributes\" md-on-close=\"searchTerm = \'\'\" data-md-container-class=\"selectHeader\" ng-model=\"attributesCtrl.product.attributes[$index].selectedValues\" ng-model-options=\"{trackBy: \'$value\'}\" placeholder=\"Select Options\"><md-select-header class=\"select-header\"><input ng-model=\"searchTerm\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search for an option..\" class=\"header-searchbox md-text\"></md-select-header><md-option ng-value=\"meta_value._id\" ng-repeat=\"meta_value in attributesCtrl.product.attributes[$index].attribute.meta_values | filter: searchTerm | orderBy:\'value\'\"><md-img style=\"width: 32px; height: auto;\" ng-if=\"meta_value.image\" md-src=\"{{meta_value.image.urls.thumbnail}}\"></md-img><span>{{ meta_value.value }}</span></md-option></md-select><md-select flex=\"25\" aria-label=\"Select Attributes\" multiple=\"true\" required=\"\" md-on-close=\"searchTerm = \'\'\" ng-if=\"attributesCtrl.product.attributes[$index].attribute.allowMultipleSelections\" data-md-container-class=\"selectHeader\" ng-model=\"attributesCtrl.product.attributes[$index].selectedValues\" ng-model-options=\"{trackBy: \'$value\'}\" placeholder=\"Select Options\"><md-select-header class=\"select-header\"><input ng-model=\"searchTerm\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search for an option..\" class=\"header-searchbox md-text\"></md-select-header><md-option ng-value=\"meta_value._id\" ng-repeat=\"meta_value in attributesCtrl.product.attributes[$index].attribute.meta_values | filter: searchTerm | orderBy:\'value\'\"><md-img style=\"width: 32px; height: auto;\" ng-if=\"meta_value.image\" md-src=\"{{meta_value.image.urls.thumbnail}}\"></md-img><span>{{ meta_value.value }}</span></md-option></md-select><div flex=\"\" flex-offset=\"5\" layout=\"column\" layout-align=\"center start\"><md-checkbox ng-model=\"attributesCtrl.product.attributes[$index].visible\" ng-disabled=\"attributesCtrl.product.attributes[$index].attribute.isScopedForVendor\" aria-label=\"isVisible\">Visible (Products page)</md-checkbox><md-checkbox ng-model=\"attributesCtrl.product.attributes[$index].isVariation\" ng-disabled=\"attributesCtrl.product.attributes[$index].attribute.isScopedForVendor || (!attributesCtrl.product.attributes[$index].isVariation && attributesCtrl.product.attributes[$index].attribute.meta_key !== \'Size\')\" aria-label=\"isVariation\">Used as Variation</md-checkbox></div><div flex=\"\" flex-offset=\"5\" layout=\"column\" layout-align=\"center start\"><md-checkbox ng-model=\"attributesCtrl.product.attributes[$index].applyFilters\" ng-disabled=\"attributesCtrl.product.attributes[$index].attribute.isScopedForVendor\" aria-label=\"applyFilters\">Support filters</md-checkbox><md-checkbox ng-model=\"attributesCtrl.product.attributes[$index].featured\" ng-disabled=\"attributesCtrl.product.attributes[$index].attribute.isScopedForVendor\" aria-label=\"featured\">Shown above price box</md-checkbox></div><div layout=\"\" layout-align=\"center center\" flex=\"10\"><md-button class=\"md-icon-button\" ng-click=\"attributesCtrl.removeAttribute($index);\"><md-icon style=\"color: red\">delete</md-icon></md-button></div></md-card-content></md-card></div><div ng-show=\"attributesCtrl.product.attributes.length == 0\" layout=\"column\" flex=\"\" style=\"min-height: 400px;\" layout-align=\"center center\" layout-margin=\"\"><img src=\"assets/images/icons/coffee.svg\" style=\"max-width: 100px;\"> <span class=\"cookie md-title\">Please stop sipping in so much coffee<br>and start adding some attributes here.</span></div></div>");
$templateCache.put("app/modules/products/addProducts/partials/tabs/categories.html","<div layout=\"row\" layout-align=\"center start\" ng-controller=\"products.add.categories.controller as categoriesCtrl\"><md-card flex=\"30\"><md-card-content><md-subheader class=\"md-no-sticky\"><div layout=\"column\"><h4>Product Categories</h4><md-input-container class=\"no-error-spacer\"><label>Search Category by Name</label> <input type=\"search\" ng-model=\"searchModel\"></md-input-container></div></md-subheader><md-list style=\"max-height: 400px; overflow-y: scroll;\"><md-list-item ng-repeat-start=\"category in categoriesCtrl.categories | filter : searchModel\"><p ng-class=\"{\'md-caption\' : category.parent}\" ng-style=\"{\'margin-left\' : category.parent ? \'20px\' : 0, \'font-weight\' : !category.parent ? \'bold\' : \'400\'}\">{{ category.name }}</p><md-checkbox class=\"md-secondary\" ng-checked=\"categoriesCtrl.checkPresent(category);\" ng-model=\"categoriesCtrl.selectedCategories[$index]\" ng-click=\"categoriesCtrl.checkInfo(category,$index);\"></md-checkbox></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list></md-card-content></md-card><md-card flex=\"\"><md-card-content layout=\"column\"><md-subheader class=\"md-no-sticky\">Selected Categories</md-subheader><div ng-show=\"categoriesCtrl.product.categories.length > 0\" style=\"max-height: 400px; overflow-y: scroll;\"><div flex=\"\" ng-repeat=\"category in categoriesCtrl.product.categories\" layout=\"row\" layout-align=\"center center\" style=\"min-height: 75px; margin: 2%; background: rgba(1,1,1,0.05);\"><span flex=\"10\"></span><div flex=\"30\"><md-img md-src=\"{{ category.image.urls.thumbnail }}\" alt=\"{{ category.name }}\" class=\"avatar\"></md-img></div><div flex=\"\"><span class=\"md-title\">{{ category.name }}</span></div></div></div><div flex=\"\" ng-show=\"categoriesCtrl.product.categories == 0\">No Categories selected</div></md-card-content></md-card></div>");
$templateCache.put("app/modules/products/addProducts/partials/tabs/customisation.html","<div ng-controller=\"products.add.customisation.controller as customisationCtrl\" class=\"customisation-editor\"><section ng-if=\"customisationCtrl.product.editorType && customisationCtrl.product.isOnboardingDone\"><div class=\"full-width\" md-colors=\"{\'background\' : \'primary-50-1\'}\" layout=\"\" layout-align=\"space-between center\" style=\"padding: 4px; position: sticky; top : 0; z-index: 3;\"><div layout=\"\" layout-align=\"start center\" ng-if=\"!customisationCtrl.noCustomisation\"><div style=\"margin-left: 8px\" layout=\"\"><span ng-if=\"!customisationCtrl.fetchingTemplatesCount\">{{customisationCtrl.templatesCount }} templates found</span><bubble-loader ng-if=\"customisationCtrl.fetchingTemplatesCount\"></bubble-loader></div><a ng-click=\"customisationCtrl.openProductTemplatesDialog($event)\" class=\"md-link pointer\" style=\"margin-left: 8px\">View Templates</a><md-button class=\"md-accent\" ng-click=\"customisationCtrl.openProductTemplatesDialog($event)\"><md-icon>add</md-icon>Create Template</md-button></div><div layout=\"\" layout-align=\"end center\"><span ng-if=\"customisationCtrl.file\">{{customisationCtrl.file}}</span><md-switch class=\"md-caption\" ng-model=\"customisationCtrl.expandAll\" ng-change=\"customisationCtrl.toggleOptions()\">Expand All</md-switch><md-switch class=\"md-caption\" ng-model=\"customisationCtrl.showOptionPreview\">Show Option Preview</md-switch><md-switch ng-model=\"customisationCtrl.showFullScreen\" class=\"md-caption\" ng-change=\"customisationCtrl.toggleFullScreen()\">Toggle Fullscreen</md-switch></div></div><div layout=\"row\"><div flex=\"30\" ng-if=\"customisationCtrl.product.editorType !== \'simple\'\" style=\"min-height: 500px;\" layout=\"column\"><div layout=\"column\" layout-align=\"center center\" layout-margin=\"\"><div ng-show=\"customisationCtrl.product.customisation.baseImage\" md-ink-ripple=\"\" class=\"pointer\" style=\"position: relative;\" ng-click=\"customisationCtrl.openSingleUploader($event,\'base\');\"><customisable-product customisation=\"customisationCtrl.product.customisation\" size=\"medium\"></customisable-product></div><div ng-show=\"!customisationCtrl.product.customisation.baseImage\" layout=\"row\" style=\"width: 300px; height: 450px; background: rgba(1,1,1,0.1); border: 2px dashed grey; position: relative;\"><div flex=\"\" layout=\"column\" layout-align=\"center center\" class=\"pointer\" md-ink-ripple=\"\" ng-click=\"customisationCtrl.openSingleUploader($event,\'base\');\"><md-icon>add</md-icon><span>Add a base image first</span></div></div></div><p class=\"md-title center-text\">Base Image</p></div><section flex=\"\" layout=\"column\"><div layout=\"row\" layout-margin=\"\"><div style=\"min-height: 300px;\" flex=\"\" layout=\"\"><div layout=\"column\" flex=\"\" ng-init=\"customisationCtrl.edit[$index] = false;\"><div layout=\"\" layout-align=\"space-between center\"><span class=\"md-subhead\">Options : {{customisationCtrl.selectedLayer.name}}</span><md-button class=\"md-raised md-accent\" style=\"margin: 0\" ng-disabled=\"!customisationCtrl.selectedLayer || (customisationCtrl.selectedLayer.name === \'Fabric\' || customisationCtrl.selectedLayer.name === \'Size\')\" ng-click=\"customisationCtrl.addOption();\"><md-icon>add</md-icon><span>Add Option</span></md-button></div><md-divider class=\"md-margin\"></md-divider><div layout=\"\" layout-align=\"space-between center\"><md-input-container class=\"no-error-spacer\"><md-checkbox ng-model=\"customisationCtrl.selectedLayer.isBaseLayer\">Base Layer</md-checkbox></md-input-container><md-input-container class=\"no-error-spacer\"><md-checkbox ng-model=\"customisationCtrl.selectedLayer.preview\">Show Preview</md-checkbox></md-input-container></div><md-radio-group ng-model=\"customisationCtrl.selectedLayer.default\"><div dnd-list=\"customisationCtrl.selectedLayer.options\" class=\"md-padding\" style=\"background: rgba(1,1,1,0.1); min-height: 60vh; max-height: 80vh; overflow-y: scroll;\">{{ isFabricLayer = customisationCtrl.selectedLayer.name === \'Fabric\'; \"\"}}<md-card ng-style=\"{\'border\' : option.isDefault ? \'2px solid\' : \'2px solid rgba(1,1,1,0)\' }\" class=\"expandable-section md-margin\" ng-repeat=\"option in customisationCtrl.selectedLayer.options\"><section md-whiteframe=\"4\" layout=\"\" layout-align=\"space-between center\" class=\"expansion-header pointer\" dnd-draggable=\"option\" dnd-moved=\"customisationCtrl.selectedLayer.options.splice($index, 1)\" dnd-effect-allowed=\"move\" ng-click=\"option.expanded = !option.expanded\"><span class=\"md-caption title\"><span class=\"bold-text\">{{option.name? option.name : \'No Name Assigned\'}}</span> <span class=\"grey-text md-tiny\">{{option.extras.alias ? \' : \' + option.extras.alias : \'\'}}</span></span><div layout=\"row\" layout-align=\"end center\"><md-checkbox ng-model=\"option.isDefault\" style=\"margin: 0\" ng-click=\"$event.stopPropagation();\" ng-change=\"customisationCtrl.clearDefaults(option, $event)\"><span class=\"md-caption\">Default</span></md-checkbox><md-button class=\"md-icon-button\" ng-click=\"customisationCtrl.duplicateOption(customisationCtrl.selectedIndex, $index, $event);\"><md-icon>content_copy</md-icon><md-tooltip>Duplicate Option</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"customisationCtrl.removeOption(customisationCtrl.selectedIndex, $index, $event);\"><md-icon class=\"md-warn\">close</md-icon><md-tooltip>Delete Option</md-tooltip></md-button><md-button class=\"md-icon-button\"><md-icon>{{option.expanded ? \'keyboard_arrow_up\' : \'keyboard_arrow_down\'}}</md-icon><md-tooltip>{{option.expanded ? \'Collapse Section\' : \'Expand Section\'}}</md-tooltip></md-button></div></section><md-divider></md-divider><dnd-nodrag><div layout=\"row\" style=\"background: white;\" ng-if=\"!isFabricLayer\" class=\"expansion-content\" ng-class=\"{\'expanded\' : option.expanded}\"><div layout=\"column\" style=\"position: relative; max-width: 150px; margin: 5px;\"><div class=\"pointer\" md-ink-ripple=\"\" ng-click=\"customisationCtrl.openMultipleUploader($event,\'option\',$index, customisationCtrl.selectedIndex);\" style=\"width: 100px; height: 150px;border: 1px dashed grey; background: url(\'/assets/images/transparent_1.jpg\') center; background-size: cover; position: relative;\"><img ng-if=\"!customisationCtrl.showOptionPreview\" ng-src=\"{{ customisationCtrl.url + option.image.urls.c_thumbnail }}\"><customisable-product-view ng-if=\"customisationCtrl.showOptionPreview\" selected-index=\"customisationCtrl.selectedIndex\" current-index=\"$index\" class=\"md-media-sm card-media\" size=\"x-small-2x\" position=\"customisationCtrl.getSelectedPosition(customisationCtrl.selectedLayer);\" background-scale=\"customisationCtrl.getBackgroundScale(customisationCtrl.selectedLayer);\" customisation=\"customisationCtrl.product.customisation\"></customisable-product-view></div><span class=\"md-subhead center-text\" style=\"padding: 4px; background: navy; color: white;\" ng-if=\"option._id && (option.isDefault)\">DEFAULT</span></div><div layout=\"column\" flex=\"\" style=\"padding: 2% 4%; position: relative;\"><div layout=\"row\"><md-input-container flex=\"\" style=\"margin: 12px 20px 0 0;\"><input type=\"text\" ng-model=\"option.name\" ng-blur=\"customisationCtrl.correctName(option)\" placeholder=\"Name\"></md-input-container><md-input-container flex=\"\" style=\"margin: 12px 20px 0 0;\"><input type=\"text\" ng-model=\"option.extras.alias\" placeholder=\"Alias\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\" style=\"margin: 0 20px 0 0;\"><input type=\"number\" min=\"0\" ng-model=\"option.stockAndPrice.price.mrp\" placeholder=\"Purchase Cost\"></md-input-container><md-input-container flex=\"\" class=\"md-block\" style=\"margin: 0 20px 0 0;\"><input type=\"number\" min=\"0\" ng-model=\"option.stockAndPrice.price.mrp\" placeholder=\"Mrp\"></md-input-container><md-input-container flex=\"\" class=\"md-block\" style=\"margin: 0 20px 0 0;\"><input type=\"number\" min=\"0\" ng-model=\"option.stockAndPrice.price.salePrice\" placeholder=\"Sale Price\"></md-input-container></div><div layout=\"row\"><md-checkbox ng-model=\"option.isDefault\" ng-change=\"customisationCtrl.clearDefaults(option)\"><span class=\"md-caption\">Default</span></md-checkbox><md-checkbox style=\"margin-left: 20px;\" ng-model=\"option.stockAndPrice.stock.manageStock\" aria-label=\"option\"><span class=\"md-caption\">Manage Stock</span></md-checkbox><md-checkbox style=\"margin-left: 20px;\" ng-model=\"option.outOfStock\" aria-label=\"option\"><span class=\"md-caption\">Out Of Stock</span></md-checkbox></div><div layout=\"\" layout-wrap=\"\"><md-input-container class=\"md-block\" flex=\"40\" style=\"margin: 0;\"><input type=\"number\" min=\"0\" ng-disabled=\"!option.stockAndPrice.stock.manageStock\" ng-model=\"option.stockAndPrice.stock.quantity\" placeholder=\"Quantity\"></md-input-container><md-checkbox flex=\"60\" ng-disabled=\"!option.stockAndPrice.stock.manageStock\" ng-model=\"option.stockAndPrice.stock.backOrder.status\" aria-label=\"option\"><span class=\"md-caption\">Allow Backorders</span></md-checkbox><md-input-container class=\"md-block\" flex=\"\" style=\"margin: 0 20px 0 0;\"><input type=\"number\" min=\"0\" ng-disabled=\"!option.stockAndPrice.stock.manageStock && !option.stockAndPrice.stock.backOrder.status\" ng-model=\"option.stockAndPrice.stock.backOrder.limit\" placeholder=\"Max Backorders\"></md-input-container></div><div layout=\"\" layout-align=\"space-between center\"><span class=\"bold-text center-text md-subhead\">Triggers ({{option.triggers ? option.triggers.length : 0}})</span><md-button ng-click=\"customisationCtrl.addTriggers(option)\">Add Trigger</md-button></div><div layout=\"\" layout-wrap=\"\" layout-align=\"stretch center\" ng-repeat=\"trigger in option.triggers\"><md-input-container flex=\"\"><label>On Select</label><md-select ng-model=\"trigger.triggerType\"><md-option value=\"\">Select Trigger Type</md-option><md-option value=\"enable\">Enable</md-option><md-option value=\"disable\">Disable</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Layer</label><md-select ng-model=\"trigger.linkedLayer\" ng-disabled=\"!trigger.triggerType\"><md-option value=\"\">Select Layer</md-option><md-option ng-repeat=\"layer in customisationCtrl.product.customisation.data\" ng-value=\"layer._id\">{{layer.name}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Options</label><md-select ng-model=\"trigger.options\" multiple=\"\" ng-disabled=\"!trigger.triggerType\"><md-option value=\"\">Select Options</md-option><md-option ng-value=\"option._id\" ng-repeat=\"option in customisationCtrl.getOptions(trigger.linkedLayer)\"><span class=\"md-caption\">{{option.extras.alias ? option.extras.alias : option.name}}</span></md-option></md-select></md-input-container><md-button class=\"md-warn md-icon-button\" ng-click=\"customisationCtrl.removeTrigger(option, $index)\"><md-icon>delete</md-icon></md-button></div></div></div><div ng-if=\"isFabricLayer\" layout=\"column\" ng-style=\"{\'border\' : option.isDefault ? \'2px solid\' : \'2px solid rgba(1,1,1,0)\' }\" style=\"height: 200px; width: 100%;\"><img ng-src=\"{{customisationCtrl.url + option.image.urls.thumbnail}}\" style=\"width: auto; height: 125px;\"><div flex=\"\" layout=\"column\" style=\"padding: 4px;\"><div layout=\"row\" flex=\"\" layout-align=\"space-between\"><span>{{ option.name}}</span> <span class=\"md-caption\">{{customisationCtrl.getPrice(option.stockAndPrice); }}</span></div><span flex=\"\"></span><div layout=\"\" layout-align=\"center center\"><md-checkbox ng-model=\"option.isDefault\" ng-change=\"customisationCtrl.clearDefaults(option)\"><span class=\"md-caption\">Default</span></md-checkbox></div><md-button class=\"md-icon-button\" md-absolute=\"\" style=\"top : 4px; right: 4px; background: white;\" ng-click=\"customisationCtrl.removeOption(customisationCtrl.selectedIndex, $index);\"><md-icon>close</md-icon></md-button></div></div></dnd-nodrag></md-card></div></md-radio-group></div></div></div></section><div flex=\"30\"><div layout=\"column\"><md-card><md-card-content layout=\"column\"><md-input-container class=\"md-block\"><label>Select Editor Type</label><md-select ng-model=\"customisationCtrl.product.editorType\"><md-option value=\"simple\">Simple</md-option><md-option value=\"intermediate\">Intermediate</md-option><md-option value=\"advanced\">Advanced</md-option></md-select></md-input-container><div layout=\"\"><md-input-container class=\"md-block\" flex=\"\"><label>MRP</label> <input type=\"number\" ng-model=\"customisationCtrl.product.customisation.mrp\" placeholder=\"MRP\"></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Base Price</label> <input type=\"number\" ng-model=\"customisationCtrl.product.customisation.basePrice\" placeholder=\"Base Price\"></md-input-container></div></md-card-content></md-card><div layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">Layers</span><md-button class=\"md-raised md-accent\" ng-click=\"customisationCtrl.addLayer();\"><md-icon>add</md-icon>Add Layer</md-button></div><div dnd-list=\"customisationCtrl.product.customisation.data\" style=\"min-height: 200px; border: 2px dashed grey;\"><div ng-repeat=\"layer in customisationCtrl.product.customisation.data\" dnd-draggable=\"layer\" dnd-moved=\"customisationCtrl.product.customisation.data.splice($index, 1)\" dnd-effect-allowed=\"move\" dnd-selected=\"customisationCtrl.selectLayer(layer,$index)\" style=\"cursor: move\" ng-class=\"{\'selected\': customisationCtrl.selectedLayer === layer}\"><div layout=\"column\" style=\"position: relative; margin: 8px\"><section layout=\"\" md-whiteframe=\"3\" layout-align=\"space-between center\" class=\"full-width\" style=\"padding: 4px\" md-colors=\"{\'background\' : \'{{layer._id && (customisationCtrl.selectedLayer._id === layer._id) ? \'boring-primary-500-1\' : \'boring-background-50-1\' }}\'}\"><span>{{layer.name}}</span> <span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"customisationCtrl.editOption(layer, $event);\"><md-icon ng-style=\"{\'color\' : layer._id && (customisationCtrl.selectedLayer._id === layer._id )? \'white\' : \'grey\'}\">edit</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"customisationCtrl.removeLayer($index);\"><md-icon ng-style=\"{\'color\' : layer._id && (customisationCtrl.selectedLayer._id === layer._id )? \'white\' : \'red\'}\">delete</md-icon></md-button></section><section ng-if=\"customisationCtrl.selectedLayer === layer\" class=\"full-width white\"><div layout=\"\"><md-input-container class=\"md-block\" flex=\"\" style=\"margin: 24px 0 0 0\"><label>Background Scale</label> <input type=\"number\" min=\"0\" max=\"350\" ng-model=\"layer.extras.backgroundScale\" placeholder=\"Background Scale\"></md-input-container><md-input-container class=\"md-block\" flex=\"\" style=\"margin: 24px 0 0 0\"><label>Background Position Price</label> <input type=\"text\" ng-model=\"layer.extras.backgroundPosition\" placeholder=\"Background Position\"></md-input-container></div></section></div></div></div></div></div></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"layerDialog\"><md-dialog aria-label=\"layerDialog\" layout=\"column\" style=\"z-index: 20;\" flex=\"20\"><form layout=\"column\" flex=\"\"><md-toolbar md-colors=\"{\'backgroundColor\' : \'boring-primary-500-1\'}\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"center center\"><h2>Edit {{customisationCtrl.editingLayer.name}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content flex=\"\" layout=\"column\" layout-align=\"center center\" class=\"md-padding\" md-colors=\"{background : \'boring-primary-100-0.2\'}\"><md-input-container class=\"md-block\" flex=\"\"><label>Layer Name</label> <input type=\"text\" ng-model=\"customisationCtrl.editingLayer.name\"></md-input-container><md-input-container class=\"md-block\" flex=\"\"><md-checkbox ng-model=\"customisationCtrl.editingLayer.preview\"><span>Preview Image</span></md-checkbox></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-warn\" ng-click=\"cancel();\">Cancel</md-button><md-button class=\"md-primary\" ng-click=\"cancel()\" style=\"margin-right:20px;\">Done</md-button></md-dialog-actions></form></md-dialog></div></div><md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-is-open=\"false\" md-component-id=\"right\" md-disable-backdrop=\"\" style=\"margin-top: 80px;\"><md-toolbar class=\"md-accent md-hue-3\" layout=\"\" layout-align=\"center center\"><h1 class=\"md-toolbar-tools\">Fabric Importer</h1><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"customisationCtrl.import();\"><md-icon>close</md-icon></md-button></md-toolbar><md-content class=\"md-padding\" layout=\"column\" style=\"max-height: 100%; min-height: 100%; overflow-y: scroll; background: rgba(1,1,1,0.03)\"><div ng-if=\"!customisationCtrl.optionsFetched\" flex=\"\" layout=\"\" layout-align=\"center center\"><md-progress-circular></md-progress-circular></div><div ng-if=\"customisationCtrl.optionsFetched\" dnd-list=\"customisationCtrl.selectedLayer.options\"><md-card ng-repeat=\"option in customisationCtrl.options\" ng-if=\"customisationCtrl.selectedLayer.name === \'Fabric\'\" dnd-draggable=\"option\" dnd-moved=\"customisationCtrl.options.splice($index, 1)\" dnd-effect-allowed=\"move\"><div layout=\"\"><md-img md-src=\"{{option.image.urls.thumbnail}}\" style=\"width: 100px; height: 100px;\"><div layout=\"\" flex=\"\" style=\"margin-left: 10px;\"><span class=\"md-subhead\">{{option.name}}</span></div></md-img></div></md-card><md-card ng-repeat=\"value in customisationCtrl.options\" ng-if=\"customisationCtrl.selectedLayer.name === \'Size\'\" dnd-draggable=\"value\" dnd-moved=\"customisationCtrl.moveSize(value)\" dnd-effect-allowed=\"move\"><md-card-content layout=\"column\"><span class=\"md-title center-text\">{{value.key}}</span><div layout=\"row\" layout-align=\"space-around\"><span>Min : {{customisationCtrl.getMin(value.values)}}</span> <span>Max : {{customisationCtrl.getMax(value.values)}}</span></div></md-card-content></md-card></div></md-content></md-sidenav></section><section ng-if=\"!customisationCtrl.product.editorType || !customisationCtrl.product.isOnboardingDone\" class=\"no-editor-set\"><md-card class=\"editor-type-card\"><md-card-content><div flex=\"\" layout=\"column\" layout-align=\"center center\"><h1 class=\"md-display-1 title\">{{customisationCtrl.onboard.title}}</h1><h3 class=\"md-subhead subtitle\">{{customisationCtrl.onboard.subtitle}}</h3><div class=\"close-btn\"><md-button class=\"md-icon-button\" ng-click=\"customisationCtrl.hideOnboardingTool()\"><md-icon>close</md-icon></md-button></div><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-accent\" ng-click=\"customisationCtrl.showImages($event)\">View Product Images</md-button></div><section layout=\"column\" style=\"width: 100%\" ng-if=\"customisationCtrl.onboard.currentForm === \'editor_type\'\"><div layout=\"\" layout-align=\"center center\"><md-card flex-xs=\"100\" flex-sm=\"100\" ng-click=\"customisationCtrl.selectEditor(editor)\" ng-class=\"{\'selected\' : customisationCtrl.product.editorType === editor.value}\" flex-gt-sm=\"20\" class=\"editor-select-item pointer\" ng-repeat=\"editor in customisationCtrl.editorTypes\"><img class=\"md-card-image\" ng-src=\"{{editor.image}}\"><md-card-title><md-card-title-text><span class=\"md-title\">{{editor.name}}</span></md-card-title-text></md-card-title><md-card-content><p>{{editor.description}}</p></md-card-content></md-card></div><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-raised md-primary\" ng-click=\"customisationCtrl.startEditing()\"><span>Next</span><md-icon>arrow_forward</md-icon></md-button></div></section><section layout=\"column\" ng-if=\"customisationCtrl.onboard.currentForm === \'simple_layers\'\"><md-list><md-list-item ng-repeat=\"option in customisationCtrl.supportedLayers.simple\" class=\"layer-selection-item\"><p>{{option.name}}</p><md-checkbox class=\"md-secondary\" ng-model=\"option.checked\"></md-checkbox></md-list-item></md-list><div flex=\"\" layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-raised md-primary\" ng-click=\"customisationCtrl.changeForm(\'editor_type\')\"><md-icon>arrow_backward</md-icon><span>Previous : Change Editor Type</span></md-button><md-button class=\"md-raised md-primary\" ng-click=\"customisationCtrl.changeForm(\'simple_options\')\"><span>Next : Select Options</span><md-icon>arrow_forward</md-icon></md-button></div></section><section layout=\"column\" style=\"width: 80%\" ng-if=\"customisationCtrl.onboard.currentForm === \'simple_options\'\"><md-card><md-tabs md-border-bottom=\"\" md-dynamic-height=\"\" md-center-tabs=\"\"><md-tab label=\"{{layer.name}}\" ng-repeat=\"layer in customisationCtrl.selectedLayers\"><md-content class=\"md-padding\"><div layout=\"\" layout-wrap=\"\"><section flex-sm=\"33\" flex-xs=\"50\" flex=\"25\" flex-gt-md=\"20\" ng-repeat=\"option in customisationCtrl.optionsObject[layer.name]\"><md-card><md-img md-src=\"{{ option.image.urls.thumbnail }}\" class=\"md-avatar\"></md-img><md-card-content><h4 class=\"md-title\">{{option.name}}</h4></md-card-content><md-divider></md-divider><md-card-actions layout=\"\" layout-align=\"center center\"><md-checkbox ng-model=\"option.selected\">Select this option</md-checkbox></md-card-actions></md-card></section></div></md-content></md-tab></md-tabs></md-card><div flex=\"\" layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-raised md-primary\" ng-click=\"customisationCtrl.changeForm(\'simple_layers\')\"><md-icon>arrow_backward</md-icon><span>Previous : Modify Layers</span></md-button><md-button class=\"md-raised md-primary\" ng-click=\"customisationCtrl.changeForm(\'select_defaults\')\"><span>Next : Select Defaults And Prices for Options</span><md-icon>arrow_forward</md-icon></md-button></div></section><section layout=\"column\" style=\"width: 80%\" ng-if=\"customisationCtrl.onboard.currentForm === \'select_defaults\'\"><md-card><md-tabs md-border-bottom=\"\" md-dynamic-height=\"\" md-center-tabs=\"\"><md-tab label=\"{{layer.name}}\" md-on-select=\"customisationCtrl.selectLayer(layer, $index)\" ng-repeat=\"layer in customisationCtrl.product.customisation.data\"><md-content class=\"md-padding\"><div layout=\"\" layout-wrap=\"\"><section flex-sm=\"33\" flex-xs=\"50\" flex=\"25\" flex-gt-md=\"20\" ng-repeat=\"option in layer.options track by $index\"><md-card><md-img md-src=\"{{ option.image.urls.thumbnail }}\" class=\"md-avatar\"></md-img><md-card-content><h4 class=\"md-title\">{{option.name}}</h4><section layout=\"\" layout-align=\"space-between center\"><md-input-container md-no-float=\"\" class=\"no-error-spacer\"><label>MRP (Rs.)</label> <input type=\"number\" min=\"0\" ng-change=\"customisationCtrl.evalDefaultsFormDisabled()\" ng-model=\"option.stockAndPrice.price.mrp\"></md-input-container><md-input-container md-no-float=\"\" class=\"no-error-spacer\"><label>Sale Price (Rs.)</label> <input type=\"number\" min=\"0\" ng-change=\"customisationCtrl.evalDefaultsFormDisabled()\" ng-model=\"option.stockAndPrice.price.salePrice\"></md-input-container></section></md-card-content><md-divider></md-divider><md-card-actions layout=\"\" layout-align=\"center center\"><md-checkbox ng-change=\"customisationCtrl.clearDefaults(option); customisationCtrl.evalDefaultsFormDisabled();\" ng-model=\"option.isDefault\">Default</md-checkbox></md-card-actions></md-card></section></div></md-content></md-tab></md-tabs></md-card><p class=\"red-text center-text\">{{customisationCtrl.defaultFormError}}</p><div flex=\"\" layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-raised md-primary\" ng-click=\"customisationCtrl.changeForm(\'simple_options\')\"><md-icon>arrow_backward</md-icon><span>Previous : Modify Options</span></md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"customisationCtrl.defaultsFormDisabled\" ng-click=\"customisationCtrl.changeForm(\'editor_pricing\')\"><span>Next : Set Pricing</span><md-icon>arrow_forward</md-icon></md-button></div></section><section layout=\"column\" style=\"width: 80%\" ng-if=\"customisationCtrl.onboard.currentForm === \'editor_pricing\'\"><md-card><md-card-content><h4 class=\"md-headline\">Customisation Prices</h4><div layout=\"\"><md-input-container class=\"md-block\" flex=\"\"><label>MRP</label> <input type=\"number\" ng-model=\"customisationCtrl.product.customisation.mrp\" ng-change=\"customisationCtrl.evalPricingFormDisabled()\" placeholder=\"MRP\"></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Base Price</label> <input type=\"number\" ng-model=\"customisationCtrl.product.customisation.basePrice\" ng-change=\"customisationCtrl.evalPricingFormDisabled()\" placeholder=\"Base Price\"></md-input-container></div><div layout=\"\" layout-align=\"space-around start\"><section flex=\"\" ng-repeat=\"data in customisationCtrl.product.customisation.data\" class=\"md-padding\"><md-subheader>{{data.name}}</md-subheader><md-list><md-list-item ng-repeat-start=\"option in data.options\"><md-img md-src=\"{{option.image.urls.thumbnail}}\" class=\"md-avatar\"></md-img><div class=\"md-list-item-text\" layout=\"column\"><p>{{option.name}}</p><p>Sale Price : Rs. {{option.stockAndPrice.price.salePrice}} | MRP : Rs. {{option.stockAndPrice.price.mrp}}</p></div><md-button class=\"md-icon-button md-secondary\" disabled=\"\" ng-if=\"data.default === option\"><md-icon>check_circle</md-icon></md-button></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list></section></div></md-card-content></md-card><p class=\"md-padding red-text center-text\" ng-show=\"customisationCtrl.pricingFormError\">{{customisationCtrl.pricingFormError}}</p><div flex=\"\" layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-raised md-primary\" ng-click=\"customisationCtrl.changeForm(\'select_defaults\')\"><md-icon>arrow_backward</md-icon><span>Previous : Edit Defaults</span></md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"customisationCtrl.pricingFormDisabled\" ng-click=\"customisationCtrl.product.isOnboardingDone = true\"><span>Next : Preview and Finalize</span><md-icon>arrow_forward</md-icon></md-button></div></section></div></md-card-content></md-card></section><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"product-image-preview\"><md-dialog flex=\"90\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h3>View Product Images</h3><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"\"><section flex=\"25\" layout=\"column\"><div><md-img md-src=\"{{image.urls.thumbnail}}\" ng-class=\"{\'selected\' : customisationCtrl.selectedImage._id === image._id}\" ng-click=\"customisationCtrl.selectedImage = image\" ng-repeat=\"image in customisationCtrl.product.gallery\"></md-img></div></section><md-content flex=\"\" md-scroll-y=\"\"><md-img style=\"width: 100%\" md-src=\"{{customisationCtrl.selectedImage.urls.full}}\"></md-img></md-content></div></md-dialog-content></md-dialog></div></div></div>");
$templateCache.put("app/modules/products/addProducts/partials/tabs/finish.html","<div layout=\"row\"><div layout=\"column\" flex=\"33\" ng-controller=\"products.add.tags.controller as tagsCtrl\"><md-card><md-card-content><div layout=\"column\"><span class=\"md-title\">Tags</span> <span flex=\"\"></span><md-chips ng-model=\"tagsCtrl.product.tags\" md-autocomplete-snap=\"\" md-removable=\"true\" md-on-add=\"tagsCtrl.onAdd($chip, $index)\" md-on-remove=\"tagsCtrl.onRemove($chip, $index)\" md-transform-chip=\"tagsCtrl.transformChip($chip)\" md-require-match=\"false\"><md-autocomplete md-selected-item=\"tagsCtrl.selectedItem\" md-search-text=\"tagsCtrl.searchText\" md-items=\"item in tagsCtrl.querySearch()\" md-item-text=\"item.value\" placeholder=\"Search for a tag\"><span md-highlight-text=\"tagsCtrl.searchText\">{{item.value}}</span></md-autocomplete><md-chip-template ng-if=\"!$chip.deleted\"><span><strong>{{$chip.value}}</strong></span></md-chip-template></md-chips></div></md-card-content></md-card><md-card><md-card-content><div layout=\"column\"><p class=\"md-title\" style=\"text-align: center;\">SEO</p><md-chips ng-model=\"tagsCtrl.product.seo.keywords\" readonly=\"false\" md-removable=\"true\" placeholder=\"Enter a keyword\" delete-button-label=\"Remove Keyword\" delete-hint=\"Press delete to remove keyword\" secondary-placeholder=\"+Keyword\"></md-chips><md-input-container class=\"md-block\"><label>Meta Description</label> <textarea ng-model=\"tagsCtrl.product.seo.description\" md-select-on-focus=\"\"></textarea></md-input-container></div></md-card-content></md-card></div><div ng-controller=\"products.add.finish.controller as finishCtrl\" flex=\"\" layout=\"row\"><section flex=\"50\" layout=\"\"><md-card flex=\"\"><md-card-content><h4 class=\"grey-text center-text\">Size Chart</h4><div layout=\"\" layout-align=\"center center\"><md-select flex=\"\" ng-model=\"finishCtrl.product.sizeChart\" placeholder=\"Select Size Chart\"><md-option ng-value=\"chart._id\" ng-repeat=\"chart in finishCtrl.sizeCharts\">{{chart.values.name }}</md-option></md-select><md-button class=\"md-icon-button\" ng-if=\"finishCtrl.product.sizeChart\" ng-click=\"finishCtrl.removeSizeChart()\"><md-icon class=\"red-text\">close</md-icon><md-tooltip>Remove Size Chart</md-tooltip></md-button></div><div layout=\"column\"><span class=\"md-subhead\" style=\"text-align: center; padding: 12px;\">Product Visibility</span><md-radio-group ng-model=\"finishCtrl.product.visibility\"><md-radio-button value=\"3\">Catalog/Search</md-radio-button><md-radio-button value=\"2\">Catalog</md-radio-button><md-radio-button value=\"1\">Search</md-radio-button><md-radio-button value=\"0\">Hidden</md-radio-button></md-radio-group></div></md-card-content></md-card></section><section flex=\"50\" layout=\"\"><md-card flex=\"\"><md-card-content><div layout=\"\" layout-align=\"center center\"><md-input-container class=\"md-block\" flex=\"\"><label>Product SKU</label> <input type=\"text\" ng-model=\"finishCtrl.product.sku\" ng-disabled=\"true\" ng-blur=\"finishCtrl.transformCapital()\"></md-input-container><md-button class=\"md-primary md-icon-button\" ng-click=\"finishCtrl.openSkuChangeConfirm($event);\"><md-icon>sync</md-icon></md-button></div><md-input-container class=\"md-block\" flex=\"100\" ng-if=\"currentUser.roleSpec === 0\"><label>Created By</label><md-select ng-model=\"finishCtrl.product.created_by\" md-on-open=\"finishCtrl.getUsers();\"><md-option ng-repeat=\"user in finishCtrl.users\" ng-value=\"user._id\">{{user.name}}</md-option></md-select></md-input-container><md-switch ng-model=\"finishCtrl.product.published\" aria-label=\"publish product\" class=\"md-accent\">Publish Product</md-switch><md-switch ng-model=\"finishCtrl.product.outOfStock\" aria-label=\"publish product\" class=\"md-accent\">Out of Stock</md-switch><md-switch ng-model=\"finishCtrl.product.comingSoon\" aria-label=\"coming soon product\" class=\"md-accent\">Coming Soon</md-switch><md-switch ng-model=\"finishCtrl.product.isFeatured\" aria-label=\"featured product\" class=\"md-accent\">Featured Product</md-switch></md-card-content></md-card></section></div></div><div layout=\"row\"><div ng-controller=\"products.add.quality.controller as qualityCtrl\" flex=\"33\"><md-card><md-card-header layout=\"\" layout-align=\"center center\"><span class=\"md-title\">Initial Quality Rating</span></md-card-header><md-divider></md-divider><md-card-content class=\"center-text\"><div layout=\"\" layout-align=\"center center\"><ui-knob value=\"qualityCtrl.product.qualityRating\" options=\"qualityCtrl.finishOptions\"></ui-knob></div></md-card-content></md-card></div></div>");
$templateCache.put("app/modules/products/addProducts/partials/tabs/general-information.html","<div layout=\"row\" ng-controller=\"products.add.general.controller as gnrlCtrl\" class=\"general-page\"><md-card flex=\"\"><md-card-content><form name=\"generalForm\" layout=\"column\" ng-disabled=\"gnrlCtrl.checkingSlug\"><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Product Name</label> <input type=\"text\" ng-model=\"gnrlCtrl.product.name\" ng-change=\"gnrlCtrl.checkSpelling(gnrlCtrl.product.name);\" ng-model-options=\"{\'debounce\' : 100}\" ng-blur=\"gnrlCtrl.openProductSlugDialog($event);\" required=\"\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label>Product Type</label><md-select required=\"\" ng-model=\"gnrlCtrl.product.productType\"><md-option ng-value=\"gnrlCtrl.parseInt(0);\">Simple</md-option><md-option ng-value=\"gnrlCtrl.parseInt(1);\">Customisable</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"\" ng-class=\"{\'md-input-invalid\' : gnrlCtrl.product.name && !gnrlCtrl.slug_avaliable}\"><label>Slug/Url</label> <input type=\"text\" ng-model=\"gnrlCtrl.product.slug\" required=\"\"><md-progress-circular ng-if=\"gnrlCtrl.checkingSlug\" md-mode=\"indeterminate\"></md-progress-circular><md-icon class=\"red-text\" ng-if=\"!gnrlCtrl.checkingSlug && !gnrlCtrl.slug_avaliable\">close</md-icon><md-icon class=\"green-text\" ng-if=\"!gnrlCtrl.checkingSlug && gnrlCtrl.slug_avaliable\">check</md-icon><md-tooltip>{{gnrlCtrl.slug_avaliable ? \"Slug Available\" : \"Slug Unavailable\"}}</md-tooltip></md-input-container></div><div layout=\"\" layout-align=\"center center\"><md-switch ng-model=\"gnrlCtrl.product.showDescription\">Show Description In Product Page</md-switch></div><div layout=\"\" layout-align=\"space-between center\"><h1 class=\"center-text\">Description</h1><md-switch ng-model=\"gnrlCtrl.showPreview\">Show Preview</md-switch></div><div layout=\"row\" layout-align=\"center center\"><text-angular class=\"text-angular\" flex=\"90\" ng-if=\"!gnrlCtrl.showPreview\" ng-model=\"gnrlCtrl.product.description\" required=\"\"></text-angular><md-card ng-if=\"gnrlCtrl.showPreview\" flex=\"90\"><md-card-content><div ta-bind=\"\" ng-model=\"gnrlCtrl.product.description\"></div></md-card-content></md-card><div layout=\"\" layout-align=\"center center\" class=\"feedback\"></div></div></form></md-card-content></md-card></div>");
$templateCache.put("app/modules/products/addProducts/partials/tabs/images.html","<div ng-controller=\"products.add.images.controller as imagesCtrl\"><section layout=\"row\"><md-card flex=\"\"><div layout=\"\" layout-align=\"center center\"><h4 class=\"md-subhead\">Gallery</h4></div><md-divider></md-divider><md-card-content><md-radio-group ng-model=\"imagesCtrl.product.featured_image\"><div ng-click=\"imagesCtrl.openMultipleUploader($event);\" class=\"pointer\" flex=\"\" layout=\"\" style=\"border: 1px dashed grey; width: 100%;min-height: 300px;margin: 8px;background: rgba(169,169,169,0.15);\" ng-if=\"imagesCtrl.product.gallery.length == 0\"><div flex=\"\" layout=\"\" layout-align=\"center center\"><div layout=\"column\"><md-icon>add</md-icon><span style=\"text-align: center\">Add Gallery Images</span> <span style=\"text-align: center\">(Multiple Image Selection Mode)</span></div></div></div><div layout=\"row\" layout-wrap=\"\" layout-align=\"center space-between\" layout-margin=\"\" ng-if=\"imagesCtrl.product.gallery.length > 0\" dnd-list=\"imagesCtrl.product.gallery\"><section layout=\"column\" dnd-draggable=\"image\" dnd-effect-allowed=\"move\" dnd-moved=\"imagesCtrl.product.gallery.splice($index, 1);\" ng-repeat-start=\"image in imagesCtrl.product.gallery\"><div ng-click=\"imagesCtrl.openSingleUploader($event, \'gallery\', $index);\" class=\"pointer\" style=\"border: 1px dashed grey; position: relative\"><md-img md-src=\"{{ :: image.urls.thumbnail}}\"></md-img></div><div layout=\"\" layout-align=\"space-between center\"><md-input-container class=\"md-block\" style=\"margin: 0;\"><md-radio-button ng-value=\"image._id\" style=\"margin-bottom: 0;\">Featured</md-radio-button></md-input-container><md-button class=\"md-icon-button md-warn\" ng-click=\"imagesCtrl.removeImage(image._id, $event);\"><md-icon>delete</md-icon><md-tooltip>Remove Image</md-tooltip></md-button></div></section><div layout=\"\" layout-align=\"center center\" ng-repeat-end=\"\" ng-if=\"$last\" ng-click=\"imagesCtrl.openMultipleUploader($event, true);\" class=\"pointer\" md-ink-ripple=\"\" style=\"width: 150px; height: 205px; background: rgba(1,1,1,0.1);border: 1px dashed grey; position: relative;\"><div flex=\"\" layout-align=\"center center\" layout=\"\"><md-icon>add</md-icon></div></div><div layout=\"\" layout-align=\"center center\" class=\"dndPlaceholder\" style=\"width: 150px; height: 205px; background: rgba(1,1,1,0.1);border: 1px dashed grey; position: relative;\"></div></div></md-radio-group></md-card-content></md-card><div layout=\"column\" flex=\"30\" class=\"hide\"><section flex=\"\" ng-if=\"imagesCtrl.shoots.length > 0\"><h4 class=\"md-subhead center-text\">Photo Shoot Details</h4><section layout=\"\" layout-wrap=\"\" layout-align=\"start center\"><div ng-repeat=\"shoot in imagesCtrl.shoots\" flex=\"\"><md-card><md-card-header><md-card-avatar><img class=\"avatar\" ng-src=\"{{shoot.batch[0].model.profileImageURL === \'default.png\' ? \'/assets/images/profile.jpg\' : shoot.model.profileImageURL}}\"></md-card-avatar><md-card-header-text><span class=\"md-title\">{{shoot.batch[0].model.name}}</span> <span class=\"md-subhead\">Model</span></md-card-header-text></md-card-header><md-img md-src=\"{{shoot.batch[0].product.featured_image.urls.medium}}\" alt=\"{{shoot.batch[0].product.name}}\"><md-card-content><span class=\"md-subhead\">{{shoot.collectionName}} - {{shoot.date | date : \"mediumDate\"}}</span></md-card-content></md-img></md-card></div></section></section><section flex=\"\"><md-card><h4 class=\"md-subhead center-text\">Downloads</h4><md-divider></md-divider><md-list><md-list-item><p>All Gallery Images</p><md-checkbox class=\"md-secondary\" ng-model=\"imagesCtrl.downloads.gallery\"></md-checkbox></md-list-item><md-list-item><p>Flipkart Sizes</p><md-checkbox class=\"md-secondary\" ng-model=\"imagesCtrl.downloads.flipkart\"></md-checkbox></md-list-item><md-list-item><p>Paytm Sizes</p><md-checkbox class=\"md-secondary\" ng-model=\"imagesCtrl.downloads.paytm\"></md-checkbox></md-list-item></md-list><md-divider></md-divider><md-card-actions><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-primary\" ng-disabled=\"!imagesCtrl.downloads || imagesCtrl.downloadingImages\" ng-click=\"imagesCtrl.downloadImages();\"><section layout=\"\" layout-align=\"center center\"><div layout=\"\" layout-align=\"center center\" ng-if=\"!imagesCtrl.downloadingImages\"><md-icon>file_download</md-icon>Download Files</div><md-progress-circular md-diameter=\"24\" ng-if=\"imagesCtrl.downloadingImages\"></md-progress-circular></section></md-button></div></md-card-actions></md-card></section></div></section><div layout=\"row\"><md-card flex=\"\"><div layout=\"\" layout-align=\"center center\"><h4 class=\"md-subhead\">Customer Images</h4></div><md-divider></md-divider><md-card-content><div layout=\"\" layout-align=\"end center\" ng-if=\"imagesCtrl.product.customerImages && imagesCtrl.product.customerImages.length\"><md-button class=\"md-primary outline\" ng-click=\"imagesCtrl.addNewImage(0)\"><md-icon>add</md-icon><span>Add Customer Image</span></md-button></div><section layout=\"row\" layout-wrap=\"\" ng-if=\"imagesCtrl.product.customerImages && imagesCtrl.product.customerImages.length\"><section flex=\"33\" ng-repeat=\"imageData in imagesCtrl.product.customerImages\"><div layout=\"\" class=\"customer-image-item\"><section layout=\"\" layout-align=\"center center\"><div ng-click=\"imagesCtrl.openSingleUploader($event, \'customerImages\', $index);\" class=\"pointer\" style=\"border: 1px dashed grey; position: relative\"><md-img class=\"image\" md-src=\"{{ :: imageData.image.urls.thumbnail}}\"></md-img></div></section><section layout=\"\" layout-wrap=\"\" flex-offset=\"5\" flex=\"\" layout-align=\"start center\"><div layout=\"\" layout-align=\"end center\"><md-button class=\"small outline\" ng-click=\"imagesCtrl.selectUser($event, imageData)\">Select User</md-button></div><md-input-container class=\"no-error-spacer\" flex=\"100\"><label>Customer Name</label> <input type=\"text\" ng-model=\"imageData.name\" required=\"\"></md-input-container><md-input-container class=\"no-error-spacer\" flex=\"100\"><md-switch ng-model=\"imageData.isInfluencer\">Influencer</md-switch></md-input-container><md-input-container flex=\"100\" class=\"no-error-spacer\"><label>Link Url</label> <input type=\"url\" ng-model=\"imageData.link\" required=\"\"></md-input-container><md-input-container flex=\"100\"><label>Link Type</label><md-select required=\"\" ng-model=\"imageData.linkType\"><md-option value=\"Instagram\">Instagram</md-option><md-option value=\"Self\">Aarida</md-option><md-option value=\"Facebook\">Facebook</md-option><md-option value=\"Website\">Website</md-option><md-option value=\"Youtube\">Youtube</md-option></md-select></md-input-container></section><section layout=\"column\" flex=\"10\" layout-align=\"center center\"><md-button class=\"md-icon-button md-primary\" ng-click=\"imagesCtrl.addNewImage($index)\"><md-icon>add</md-icon></md-button><md-button class=\"md-icon-button md-warn\" ng-click=\"imagesCtrl.removeCustomerImage($index)\"><md-icon>delete</md-icon></md-button></section></div></section></section><section layout=\"column\" layout-margin=\"\" layout-align=\"center center\" ng-if=\"!imagesCtrl.product.customerImages || !imagesCtrl.product.customerImages.length\"><p>No Customer Images Found</p><md-button class=\"md-primary outline\" ng-click=\"imagesCtrl.addNewImage(0)\"><md-icon>add</md-icon><span>Add Customer Image</span></md-button></section></md-card-content></md-card></div></div>");
$templateCache.put("app/modules/products/addProducts/partials/tabs/packaging.html","<div layout=\"row\" ng-controller=\"packagingCtrl\"><section flex=\"60\"><md-card><md-card-header layout=\"\" layout-align=\"center center\"><span class=\"md-title bold-text\">Packaging</span></md-card-header><md-divider></md-divider><md-card-content><section layout=\"\" layout-wrap=\"\" layout-align=\"center center\"><md-input-container flex=\"40\"><label>Length(cm)</label> <input type=\"number\" min=\"0\" ng-change=\"calculateVolumetricWeight()\" ng-model=\"product.packaging.length\" ng-model-options=\"{\'debounce\':500}\"></md-input-container><md-input-container flex=\"40\" flex-offset=\"10\"><label>Breadth(cm)</label> <input type=\"number\" min=\"0\" ng-change=\"calculateVolumetricWeight()\" ng-model=\"product.packaging.breadth\" ng-model-options=\"{\'debounce\':500}\"></md-input-container><md-input-container flex=\"40\"><label>Height(cm)</label> <input type=\"number\" min=\"0\" ng-change=\"calculateVolumetricWeight()\" ng-model=\"product.packaging.height\" ng-model-options=\"{\'debounce\':500}\"></md-input-container><md-input-container flex=\"40\" flex-offset=\"10\"><label>Weight(kg)</label> <input type=\"number\" min=\"0\" ng-change=\"calculateVolumetricWeight()\" ng-model=\"product.packaging.weight\" ng-model-options=\"{\'debounce\':500}\"></md-input-container><md-input-container flex=\"40\"><label>Volumetric Weight(kg)</label> <input type=\"number\" min=\"0\" ng-change=\"calculateVolumetricWeight()\" ng-model=\"product.packaging.volumetricWeight\" ng-model-options=\"{\'debounce\':500}\"></md-input-container><span flex=\"40\" flex-offset=\"10\"></span></section></md-card-content></md-card></section><section flex=\"40\"><md-card><md-card-header layout=\"\" layout-align=\"center center\"><span class=\"md-title bold-text\">Shipping SLA</span></md-card-header><md-divider></md-divider><md-card-content><md-radio-group ng-model=\"product.sla\" ng-change=\"updateSla()\"><md-list class=\"md-2-line\"><md-list-item><div class=\"md-list-item-text\" layout=\"column\"><h5>2 - 5 days</h5><p class=\"md-caption\">Generally for simple products which are ready made and are in stock with us</p></div><md-radio-button class=\"md-secondary\" ng-value=\"\'2 to 5 days\'\"></md-radio-button></md-list-item><md-divider></md-divider><md-list-item><div class=\"md-list-item-text\" layout=\"column\"><h5>6 - 10 days</h5><p class=\"md-caption\">Generally for customisable products for which materials are handy and no further sourcing is required</p></div><md-radio-button class=\"md-secondary\" ng-value=\"\'6 to 10 days\'\"></md-radio-button></md-list-item><md-divider></md-divider><md-list-item><div class=\"md-list-item-text\" layout=\"column\"><h5>12 - 24 days</h5><p class=\"md-caption\">Generally for customisable products for which materials are to be sourced from scratch. May require sourcing samples from other cities too.</p></div><md-radio-button class=\"md-secondary\" ng-value=\"\'12 to 24 days\'\"></md-radio-button></md-list-item><md-divider></md-divider><md-list-item><div class=\"md-list-item-text\" layout=\"column\"><h5>Custom</h5><p class=\"md-caption\">For Custom Inputs</p><md-radio-button class=\"md-secondary\" ng-value=\"\'custom\'\"></md-radio-button><section layout=\"\" ng-show=\"product.sla === \'custom\'\"><md-input-container><label>Start Day Range</label> <input type=\"number\" min=\"0\" ng-model=\"product.slaStart\"></md-input-container><md-input-container flex-offset=\"10\"><label>End Day Range</label> <input type=\"number\" min=\"0\" ng-model=\"product.slaEnd\"></md-input-container></section></div></md-list-item></md-list></md-radio-group></md-card-content></md-card></section></div>");
$templateCache.put("app/modules/products/addProducts/partials/tabs/variations.html","<div layout=\"column\" ng-controller=\"products.add.variations.controller as variationsCtrl\" layout-padding=\"\"><div layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><md-input-container class=\"md-block md-primary\" flex-gt-sm=\"20\" flex=\"50\"><md-switch ng-model=\"variationsCtrl.product.virtualVariations\"><span>Virtual Variations</span><md-tooltip>The variations stock won\'t be considered as the de-facto for</md-tooltip></md-switch></md-input-container><md-input-container class=\"md-block md-primary\" flex-gt-sm=\"20\" flex=\"50\"><md-switch ng-model=\"variationsCtrl.sameValueForAll\"><span>Same Price For All</span><md-tooltip>The price values for all the variations will change simultaneously</md-tooltip></md-switch></md-input-container><span flex-gt-sm=\"\" flex-none=\"\"></span><md-button class=\"md-accent md-raised\" ng-click=\"variationsCtrl.generateVariations($event);\" flex-gt-sm=\"30\" flex=\"100\"><section layout=\"\" layout-align=\"center center\"><div layout=\"\" layout-align=\"center center\"><md-icon>show_chart</md-icon></div><span>{{ variationsCtrl.product.variations.length > 0 ? \"Regenerate Variations\" : \"Generate Variations\" }}</span></section><md-tooltip md-direction=\"bottom\">Generates all the variations automatically if varying attributes are present</md-tooltip></md-button></div><form name=\"variationForm\"><md-card><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-primary medium\" ng-click=\"variationsCtrl.viewStockHistory($event)\"><md-icon>history</md-icon>View All Stock Updates</md-button></div><md-card-content><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\">Sl.</th><th md-column=\"\">Size</th><th md-column=\"\">MSP</th><th md-column=\"\">Sale</th><th md-column=\"\">MRP</th><th md-column=\"\">Stock</th><th md-column=\"\">Materials</th></tr></thead><tbody md-body=\"\" dnd-list=\"variationsCtrl.product.variations\"><tr md-row=\"\" class=\"dndPlaceholder\"><td md-cell=\"\" colspan=\"9\"></td></tr><tr md-row=\"\" ng-repeat=\"variation in variationsCtrl.product.variations\" dnd-draggable=\"variation\" dnd-effect-allowed=\"move\" dnd-moved=\"variationsCtrl.product.variations.splice($index, 1);\"><td md-cell=\"\"><md-icon class=\"drag-pointer\">drag_handle</md-icon></td><td md-cell=\"\">{{$index +1 }}.</td><td md-cell=\"\"><a class=\"md-link pointer\" ng-click=\"variationsCtrl.openSidebar(variation)\">{{variationsCtrl.getVariationValues(variation) | uppercase}}</a></td><td class=\"pointer relative\" md-cell=\"\"><div class=\"relative\" style=\"max-width: 50px\"><span>{{variation.stockAndPrice.price.msp}}<md-tooltip class=\"pricing-tooltip\" md-direction=\"right\"><p class=\"text-center md-title\">Pricing</p><table md-table=\"\"><tr md-row=\"\"><td md-cell=\"\">Fabric Cost</td><td md-cell=\"\">₹{{variation.stockAndPrice.price.fabricCost}}</td></tr><tr><td md-cell=\"\">Trims Cost</td><td md-cell=\"\">₹{{variation.stockAndPrice.price.trims}}</td></tr><tr><td md-cell=\"\">Stitching Cost</td><td md-cell=\"\">₹{{variation.stockAndPrice.price.stitching}}</td></tr><tr><td md-cell=\"\">Embroidery Cost</td><td md-cell=\"\">₹{{variation.stockAndPrice.price.embroidery}}</td></tr><tr><td md-cell=\"\">Designing Cost</td><td md-cell=\"\">₹{{variation.stockAndPrice.price.designing}}</td></tr><tr><td md-cell=\"\">Photoshoot Cost</td><td md-cell=\"\">₹{{variation.stockAndPrice.price.photoShoot}}</td></tr><tr><td md-cell=\"\">Tax</td><td md-cell=\"\">{{variation.stockAndPrice.price.tax || 0}}%</td></tr><tr><td md-cell=\"\">Production Cost</td><td md-cell=\"\">₹{{variation.stockAndPrice.price.productionCost}}</td></tr><tr><td md-cell=\"\">MSP</td><td md-cell=\"\">₹{{variation.stockAndPrice.price.msp}}</td></tr></table></md-tooltip></span></div></td><td md-cell=\"\">{{variation.stockAndPrice.price.salePrice}}</td><td md-cell=\"\">{{variation.stockAndPrice.price.mrp}}</td><td md-cell=\"\">{{variation.stockAndPrice.stock.quantity}}</td><td md-cell=\"\" class=\"md-tiny\"><span class=\"pointer\" ng-if=\"variation.materials && variation.materials.length && variation.materialString\">{{variation.materialString}}<md-tooltip class=\"pricing-tooltip\" md-direction=\"left\"><p class=\"text-center md-title\">Materials</p><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Material</th><th md-column=\"\">Consumption</th></tr></thead><tbody><tr md-row=\"\" ng-repeat=\"material in variation.materials\"><td md-cell=\"\">{{material.material.name}}</td><td md-cell=\"\">{{material.consumption}}</td></tr></tbody></table></md-tooltip></span><bubble-loader ng-if=\"variation.materials && variation.materials.length && !variation.materialString\"></bubble-loader><a class=\"md-link pointer\" ng-if=\"!variation.materials || !variation.materials.length\" ng-click=\"variationsCtrl.openSidebar(variation)\">Add Material</a></td><td md-cell=\"\"><div layout=\"\" layout-align=\"center center\"><md-switch ng-model=\"variation.outOfStock\" ng-change=\"variation.modified = true\" class=\"md-tiny\">Out Of Stock</md-switch><md-switch ng-model=\"variation.disabled\" ng-change=\"variation.modified = true\" class=\"md-tiny\">Disabled</md-switch><md-button class=\"md-icon-button material-icons--two-tone\" ng-click=\"variationsCtrl.viewStockHistory($event, variation)\"><md-icon>history</md-icon><md-tooltip>View Stock Update History</md-tooltip></md-button><md-button class=\"md-icon-button material-icons--two-tone\" ng-click=\"variationsCtrl.openSidebar(variation)\"><md-icon>edit</md-icon><md-tooltip>Edit Variation</md-tooltip></md-button></div></td></tr></tbody></table></md-table-container></md-card-content></md-card><div class=\"scrim\" ng-class=\"{\'open\' : variationsCtrl.sideBarOpen}\" ng-click=\"variationsCtrl.closeSidebar()\"></div><div class=\"variation-edit-sidebar\" ng-class=\"{\'open\' : variationsCtrl.sideBarOpen}\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"variationsCtrl.closeSidebar()\"><md-icon>close</md-icon></md-button><span>Edit Variation ({{variationsCtrl.selectedVariation.selectedValueText}})</span></div></md-toolbar><md-divider></md-divider><md-content class=\"md-dialog-content md-padding sidebar-content\" md-scroll-y=\"\"><div layout=\"row\" layout-wrap=\"\" layout-align=\"space-between center\"><div layout=\"\" flex=\"100\" layout-align=\"space-between center\"><h3>Pricing</h3><md-input-container class=\"md-block md-primary\"><md-switch ng-model=\"variationsCtrl.sameValueForAll\"><span>Same Price For All</span><md-tooltip>The price values for all the variations will change simultaneously</md-tooltip></md-switch></md-input-container></div><md-input-container class=\"md-block\" flex=\"45\"><label>Fabric Cost (Rs.)</label> <input type=\"number\" min=\"0\" ng-model=\"variationsCtrl.selectedVariation.stockAndPrice.price.fabricCost\" ng-model-options=\"{\'debounce\':500}\" ng-change=\"variationsCtrl.markAsModified(variationsCtrl.selectedVariation, \'{{variationsCtrl.selectedVariation}}\');\"></md-input-container><md-input-container class=\"md-block\" flex=\"45\"><label>Stitching Cost (Rs.)</label> <input type=\"number\" min=\"0\" ng-model=\"variationsCtrl.selectedVariation.stockAndPrice.price.stitching\" ng-model-options=\"{\'debounce\':500}\" ng-change=\"variationsCtrl.markAsModified(variationsCtrl.selectedVariation, \'{{variationsCtrl.selectedVariation}}\');\"></md-input-container><md-input-container class=\"md-block\" flex=\"45\"><label>Designing Cost (Rs.)</label> <input type=\"number\" min=\"0\" ng-model=\"variationsCtrl.selectedVariation.stockAndPrice.price.designing\" ng-model-options=\"{\'debounce\':500}\" ng-change=\"variationsCtrl.markAsModified(variationsCtrl.selectedVariation, \'{{variationsCtrl.selectedVariation}}\');\"></md-input-container><md-input-container class=\"md-block\" flex=\"45\"><label>Photo Shoot Cost (Rs.)</label> <input type=\"number\" min=\"0\" ng-model=\"variationsCtrl.selectedVariation.stockAndPrice.price.photoShoot\" ng-model-options=\"{\'debounce\':500}\" ng-change=\"variationsCtrl.markAsModified(variationsCtrl.selectedVariation, \'{{variationsCtrl.selectedVariation}}\');\"></md-input-container><md-input-container class=\"md-block\" flex=\"45\"><label>Hand Embroidery Cost (Rs.)</label> <input type=\"number\" min=\"0\" ng-model=\"variationsCtrl.selectedVariation.stockAndPrice.price.embroidery\" ng-model-options=\"{\'debounce\':500}\" ng-change=\"variationsCtrl.markAsModified(variationsCtrl.selectedVariation, \'{{variationsCtrl.selectedVariation}}\');\"></md-input-container><md-input-container class=\"md-block\" flex=\"45\"><label>Trims (Rs.)</label> <input type=\"number\" min=\"0\" ng-model=\"variationsCtrl.selectedVariation.stockAndPrice.price.trims\" ng-model-options=\"{\'debounce\':500}\" ng-change=\"variationsCtrl.markAsModified(variationsCtrl.selectedVariation, \'{{variationsCtrl.selectedVariation}}\');\"></md-input-container><md-input-container class=\"md-block\" flex=\"45\"><label>Total Production Cost (Rs.)</label> <input type=\"number\" min=\"0\" ng-model=\"variationsCtrl.selectedVariation.stockAndPrice.price.productionCost\" ng-model-options=\"{\'debounce\':500}\" ng-blur=\"variationsCtrl.openPriceModificationDialog($event)\" ng-change=\"variationsCtrl.markAsModified(variationsCtrl.selectedVariation, \'{{variationsCtrl.selectedVariation}}\');\"></md-input-container><md-input-container class=\"md-block\" flex=\"45\"><label>M.S.P (Rs.)</label> <input type=\"number\" min=\"0\" ng-model=\"variationsCtrl.selectedVariation.stockAndPrice.price.msp\" ng-model-options=\"{\'debounce\':500}\" ng-change=\"variationsCtrl.markAsModified(variationsCtrl.selectedVariation, \'{{variationsCtrl.selectedVariation}}\');\"></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>Sale Price (Rs.)</label> <input type=\"number\" min=\"0\" ng-model=\"variationsCtrl.selectedVariation.stockAndPrice.price.salePrice\" ng-model-options=\"{\'debounce\':500}\" ng-change=\"variationsCtrl.markAsModified(variationsCtrl.selectedVariation, \'{{variationsCtrl.selectedVariation}}\');\"></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>MRP (Rs.)</label> <input type=\"number\" min=\"0\" ng-model=\"variationsCtrl.selectedVariation.stockAndPrice.price.mrp\" ng-model-options=\"{\'debounce\':500}\" ng-change=\"variationsCtrl.markAsModified(variationsCtrl.selectedVariation, \'{{variationsCtrl.selectedVariation}}\');\"></md-input-container><div layout=\"\" flex=\"100\" layout-align=\"space-between center\"><h3>Stocks</h3><md-input-container class=\"md-block md-primary\"><md-switch ng-model=\"variationsCtrl.sameStockForAll\"><span>Same Stock For All</span><md-tooltip>The stock values for all the variations will change simultaneously</md-tooltip></md-switch></md-input-container></div><md-switch flex=\"45\" ng-model=\"variationsCtrl.selectedVariation.stockAndPrice.stock.manageStock\" ng-model-options=\"{\'debounce\':500}\" aria-label=\"featured product\" class=\"md-accent\" ng-change=\"variationsCtrl.markAsModified(variationsCtrl.selectedVariation, \'{{variationsCtrl.selectedVariation}}\');\">Manage Stock</md-switch><md-input-container class=\"md-block\" flex=\"45\"><label>Stock Quantity</label> <input type=\"number\" min=\"0\" ng-disabled=\"!variationsCtrl.selectedVariation.stockAndPrice.stock.manageStock\" ng-model=\"variationsCtrl.selectedVariation.stockAndPrice.stock.quantity\" ng-model-options=\"{\'debounce\':500}\" ng-change=\"variationsCtrl.markAsModified(variationsCtrl.selectedVariation, \'{{variationsCtrl.selectedVariation}}\');\"></md-input-container><md-input-container class=\"md-block\" flex=\"45\"><label>Max pcs/order</label> <input type=\"number\" min=\"0\" ng-disabled=\"!variationsCtrl.selectedVariation.stockAndPrice.stock.manageStock\" ng-model=\"variationsCtrl.selectedVariation.stockAndPrice.stock.threshold\" ng-model-options=\"{\'debounce\':500}\" ng-change=\"variationsCtrl.markAsModified(variationsCtrl.selectedVariation, \'{{variationsCtrl.selectedVariation}}\');\"></md-input-container><md-switch ng-model=\"variationsCtrl.selectedVariation.stockAndPrice.stock.backOrder.status\" aria-label=\"featured product\" class=\"md-accent\" ng-disabled=\"!variationsCtrl.selectedVariation.stockAndPrice.stock.manageStock\" ng-model-options=\"{\'debounce\':500}\" ng-change=\"variationsCtrl.markAsModified(variationsCtrl.selectedVariation, \'{{variationsCtrl.selectedVariation}}\');\">Backorders</md-switch><md-input-container class=\"md-block\" flex=\"45\"><label>Max Back Orders</label> <input type=\"number\" min=\"0\" ng-disabled=\"!variationsCtrl.selectedVariation.stockAndPrice.stock.backOrder.status\" ng-change=\"variationsCtrl.selectedVariation.markAsModified(variationsCtrl.selectedVariation, \'{{variationsCtrl.selectedVariation}}\');\" ng-model=\"variationsCtrl.selectedVariation.stockAndPrice.stock.backOrder.limit\" ng-model-options=\"{\'debounce\':500}\"></md-input-container><div layout=\"\" flex=\"100\" layout-align=\"space-between center\"><h3>Materials</h3><md-input-container class=\"md-block md-primary\"><md-switch ng-model=\"variationsCtrl.sameMaterialsForAll\"><span>Same Materials For All</span><md-tooltip>The materials values for all the variations will change simultaneously</md-tooltip></md-switch></md-input-container></div><div flex=\"100\" layout=\"\" layout-align=\"end center\"><md-button class=\"md-accent outline\" ng-click=\"variationsCtrl.addMaterial(variationsCtrl.selectedVariation)\"><md-icon>add</md-icon><span>Add Material</span></md-button></div><div layout=\"column\" flex=\"100\" layout-align=\"center center\" style=\"margin: 20px\" ng-if=\"!variationsCtrl.selectedVariation.materials || !variationsCtrl.selectedVariation.materials.length\"><img src=\"assets/images/blank.svg\" style=\"width: 100px;\" alt=\"blank material\"><p>No Materials Linked</p><md-button class=\"md-accent outline small round\" ng-click=\"variationsCtrl.addMaterial(variationsCtrl.selectedVariation)\"><md-icon>add</md-icon><span>Add Material</span></md-button></div><div flex=\"100\" class=\"single-material-item\" layout=\"\" layout-align=\"space-between center\" ng-repeat=\"material in variationsCtrl.selectedVariation.materials\"><md-autocomplete md-selected-item=\"selectedMaterial\" md-search-text=\"materialSearchText\" md-min-length=\"3\" md-input-name=\"materialAutoComplete\" required=\"\" flex=\"45\" ng-if=\"!material.materialId\" md-floating-label=\"Select Material\" md-escape-options=\"none\" md-selected-item-change=\"variationsCtrl.addMaterialToLineItem(selectedMaterial, material, $index)\" md-menu-class=\"material-autocomplete-results\" placeholder=\"Search for Materials\" md-items=\"item in variationsCtrl.fetchMaterials(materialSearchText)\"><md-item-template><div layout=\"\" layout-align=\"stretch center\"><md-img md-src=\"{{item.image.urls.thumbnail}}\" class=\"material-image md-avatar\"></md-img><div layout=\"column\" layout-align=\"space-between start\"><span class=\"no-margin\" style=\"line-height: 10px; text-transform: capitalize\" md-highlight-text=\"searchText\">{{item.name}}</span> <span class=\"no-margin\" style=\"line-height: 10px; margin-top: 4px\">(Stock : {{item.stock}}) ₹{{item.salePrice}}</span></div></div></md-item-template><md-not-found><a ng-click=\"variationsCtrl.openAddNewMaterial($event,materialSearchText, material)\">Create a new Material!</a> No materials matching \"{{materialSearchText}}\" were found.</md-not-found></md-autocomplete><div layout=\"row\" flex=\"50\" layout-align=\"space-between center\" class=\"autocomplete-chip\" ng-if=\"material.materialId\"><section layout=\"row\"><span class=\"bold-text\">{{material.material.name}}</span></section><md-button class=\"md-icon-button\" ng-click=\"variationsCtrl.removeMaterialFromItem(material, $index)\"><md-icon>close</md-icon><md-tooltip>Remove Vendor</md-tooltip></md-button></div><input type=\"hidden\" ng-model=\"material.materialId\" ng-change=\"variationsCtrl.markAsModified(variationsCtrl.selectedVariation, \'{{variationsCtrl.selectedVariation}}\');\"><md-input-container class=\"md-block\" flex=\"45\"><label>Consumption Per Piece</label> <input type=\"number\" min=\"0\" ng-disabled=\"!material.materialId\" ng-change=\"variationsCtrl.markAsModified(variationsCtrl.selectedVariation, \'{{variationsCtrl.selectedVariation}}\');\" ng-model=\"material.consumption\" ng-model-options=\"{\'debounce\':500}\"></md-input-container><md-button class=\"md-warn md-icon-button\" ng-click=\"variationsCtrl.deleteLineItem(variationsCtrl.selectedVariation,$index)\"><md-icon>delete</md-icon></md-button></div></div><md-dialog-actions><md-button class=\"outline full-width\" ng-click=\"variationsCtrl.closeSidebar()\">Save</md-button></md-dialog-actions></md-content></div></form><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"priceUpdateDialog\"><md-dialog aria-label=\"priceUpdateDialog\" layout=\"column\" style=\"z-index: 20;\" flex=\"50\"><form layout=\"column\" flex=\"\"><md-toolbar md-colors=\"{\'backgroundColor\' : \'boring-primary-500-1\'}\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"center center\"><h2>Variation Price Updated</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"variationsCtrl.cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content\"><p>The variation\'s Production cost has been changed to ₹{{variationsCtrl.selectedVariation.stockAndPrice.price.productionCost}}. Do you want to apply the below mentioned prices to the MSP, Sale Price and MRP? You can adjust the prices below using the input box corresponding to the pricing factor.</p><h3 class=\"center-text\">Suggested Pricing Updates</h3><p class=\"center-text bold-text md-caption\">Note : Rounding off to the nearest 49 or 99 occurs for Sale Price and MRP.</p><md-list><md-list-item><h5>Production Cost</h5><div class=\"md-secondary\" layout=\"\" layout-align=\"center center\"><h5 class=\"md-body-1 grey-text\" style=\"margin: 0 4px; width: 55px\">₹{{variationsCtrl.selectedVariation.prevProductionCost}}<md-tooltip>Previous Price</md-tooltip></h5><span style=\"margin: 0 4px\">→</span><h4 style=\"width: 70px\">₹ {{variationsCtrl.selectedVariation.stockAndPrice.price.productionCost}}<md-tooltip>Updated Price</md-tooltip></h4></div></md-list-item><md-divider></md-divider><md-list-item><div layout=\"\" layout-align=\"space-between center\" flex=\"\"><h5>MSP</h5><div layout=\"\" layout-align=\"end end\"><p style=\"margin-right: 20px\">₹ {{variationsCtrl.selectedVariation.stockAndPrice.price.productionCost}} x</p><md-input-container style=\"width: 75px\" md-no-float=\"\" class=\"no-error-spacer\"><input required=\"\" placeholder=\"1.5\" ng-model=\"variationsCtrl.mspFactor\" type=\"number\" min=\"0\"></md-input-container></div></div><div class=\"md-secondary\" layout=\"\" layout-align=\"center center\"><h5 class=\"md-body-1 grey-text\" style=\"margin: 0 4px; width: 55px\">₹{{variationsCtrl.selectedVariation.stockAndPrice.price.msp}}<md-tooltip>Previous Price</md-tooltip></h5><span style=\"margin: 0 4px\">→</span><h4 style=\"width: 70px\">₹ {{variationsCtrl.getSuggestedPricing(variationsCtrl.mspFactor , false)}}<md-tooltip>Updated Price</md-tooltip></h4></div></md-list-item><md-divider></md-divider><md-list-item><div layout=\"\" layout-align=\"space-between center\" flex=\"\"><h5>Sale Price</h5><div layout=\"\" layout-align=\"end end\"><p style=\"margin-right: 20px\">₹ {{variationsCtrl.selectedVariation.stockAndPrice.price.productionCost}} x</p><md-input-container flex-offset=\"20\" style=\"width: 75px\" md-no-float=\"\" class=\"no-error-spacer\"><input required=\"\" placeholder=\"1.5\" ng-model=\"variationsCtrl.salePriceFactor\" type=\"number\" min=\"0\"></md-input-container></div></div><div class=\"md-secondary\" layout=\"\" layout-align=\"center center\"><h5 class=\"md-body-1 grey-text\" style=\"margin: 0 4px; width: 55px\">₹{{variationsCtrl.selectedVariation.stockAndPrice.price.salePrice}}<md-tooltip>Previous Price</md-tooltip></h5><span style=\"margin: 0 4px\">→</span><h4 style=\"width: 70px\">₹ {{variationsCtrl.getSuggestedPricing(variationsCtrl.salePriceFactor , true)}}<md-tooltip>Updated Price</md-tooltip></h4></div></md-list-item><md-divider></md-divider><md-list-item><div layout=\"\" layout-align=\"space-between center\" flex=\"\"><h5>MRP</h5><div layout=\"\" layout-align=\"end end\"><p style=\"margin-right: 20px\">₹ {{variationsCtrl.selectedVariation.stockAndPrice.price.productionCost}} x</p><md-input-container style=\"width: 75px\" md-no-float=\"\" class=\"no-error-spacer\"><input required=\"\" placeholder=\"1.5\" ng-model=\"variationsCtrl.mrpFactor\" type=\"number\" min=\"0\"></md-input-container></div></div><div class=\"md-secondary\" layout=\"\" layout-align=\"center center\"><h5 class=\"md-body-1 grey-text\" style=\"margin: 0 4px; width: 55px\">₹{{variationsCtrl.selectedVariation.stockAndPrice.price.mrp}}<md-tooltip>Previous Price</md-tooltip></h5><span style=\"margin: 0 4px\">→</span><h4 style=\"width: 70px\">₹ {{variationsCtrl.getSuggestedPricing(variationsCtrl.mrpFactor , true)}}<md-tooltip>Updated Price</md-tooltip></h4></div></md-list-item><md-divider></md-divider></md-list><div class=\"md-padding\" layout=\"\" layout-align=\"center center\"><md-checkbox ng-model=\"variationsCtrl.sameValueForAll\">Apply same prices to all Variations</md-checkbox></div></md-dialog-content><md-dialog-actions layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"variationsCtrl.cancel()\">Cancel</md-button><md-button class=\"md-primary outline\" ng-click=\"variationsCtrl.applyPrices()\">Accept Price Changes</md-button></md-dialog-actions></form></md-dialog></div></div></div>");
$templateCache.put("app/modules/scm/materials/categories/partials/materialsCategories.tmpl.html","<div layout=\"column\"><section layout=\"column\" ng-if=\"!loading\"><div layout=\"\" layout-align=\"space-between center\" class=\"md-padding\"><section flex=\"\"><div class=\"breadcrumb-list\" flex-offset=\"5\"><span class=\"md-title pointer\" ng-class=\"{\'grey-text\' : selectedParent}\" ng-click=\"restore()\">Material Categories ({{categories.length}})</span> <span class=\"md-title\" ng-show=\"selectedParent\">> {{selectedParent.name}}</span></div></section><md-button class=\"md-accent md-raised\" ng-click=\"addNewCategory($event)\"><md-icon>add</md-icon>Add New Material Category</md-button></div><div layout=\"\"><section flex-offset=\"5\"><span class=\"md-caption\">Parent ({{parentCategories.length}} categories)</span><md-list><md-list-item class=\"pointer category-list-item\" ng-class=\"{\'active\' : category.selected}\" ng-click=\"selectParent(category, $index)\" ng-mouseenter=\"category.showEdit = true\" ng-mouseleave=\"category.showEdit = false\" ng-repeat=\"category in parentCategories\"><md-icon style=\"margin: 0 32px 0 0;\">reorder</md-icon><p>{{category.name}} ({{category.children.length}})</p><md-button class=\"edit-btn\" ng-click=\"editCategory(category, $index, $event);\"><span ng-show=\"category.showEdit\">Edit</span></md-button><md-icon ng-show=\"category.featured\" style=\"margin: 0 32px 0 0;\">star</md-icon><md-icon ng-show=\"!category.featured\" style=\"margin: 0 32px 0 0;\">star_border</md-icon><md-icon style=\"margin: 0 32px 0 0;\">keyboard_arrow_right</md-icon></md-list-item></md-list></section><md-divider style=\"margin: 0 3em\"></md-divider><section flex-offset=\"5\" ng-show=\"selectedParent\"><span class=\"md-caption\">{{selectedParent.name}} ({{selectedParent.children.length}} categories)</span><md-list style=\"min-width: 350px;\"><md-list-item class=\"pointer category-list-item\" ng-class=\"{\'active\' : category.selected}\" ng-mouseenter=\"category.showEdit = true\" ng-mouseleave=\"category.showEdit = false\" ng-repeat=\"category in selectedParent.children\"><md-icon style=\"margin: 0 32px 0 0;\">reorder</md-icon><p>{{category.name}}</p><md-button style=\"margin: 0; padding: 0\" ng-click=\"editCategory(category, $index, $event);\"><span ng-show=\"category.showEdit\">Edit</span></md-button><md-icon ng-show=\"category.featured\" style=\"margin: 0 32px 0 0;\">star</md-icon><md-icon ng-show=\"!category.featured\" style=\"margin: 0 32px 0 0;\">star_border</md-icon><md-icon style=\"margin: 0 32px 0 0;\">keyboard_arrow_right</md-icon></md-list-item></md-list><div layout=\"\" layout-align=\"center center\"><md-button ng-click=\"addSubcategory(selectedParent, $event)\"><md-icon>add</md-icon><span>Add New Material Subcategory</span></md-button></div></section><section ng-show=\"!selectedParent\" layout=\"column\" layout-align=\"start center\" style=\"margin-left: 50px;\"><img src=\"assets/images/icons/no-category-selected.svg\" style=\"width: 200px; margin-top: 100px; height: auto\"> <span class=\"md-body-1 md-padding\">Select a category from the left menu first</span></section></div></section><section ng-if=\"loading\" layout=\"\" layout-align=\"center center\" style=\"margin-top: 100px\"><md-progress-circular></md-progress-circular></section></div>");
$templateCache.put("app/modules/scm/materials/details/partials/materialDetails.tmpl.html","<div layout=\"column\" layout-align=\"stretch center\" class=\"materialDetails\"><md-card class=\"materialDetailsCard\"><md-card-content><section layout=\"row\" layout-align=\"space-around center\"><div layout=\"column\" layout-align=\"center center\"><span class=\"md-subhead\">Name</span> <span class=\"gray-text md-caption\">{{material.name}}</span></div><div layout=\"column\" layout-align=\"center center\"><span class=\"md-subhead\">SKU</span> <span class=\"gray-text md-caption\">{{material.sku}}</span></div><div layout=\"column\" layout-align=\"center center\"><span class=\"md-subhead\">Sale Price</span> <span class=\"gray-text md-caption\">{{material.salePrice}}</span></div><div layout=\"column\" layout-align=\"center center\"><span class=\"md-subhead\">Stock</span> <span class=\"gray-text md-caption\">{{material.stock}}</span></div></section></md-card-content></md-card><md-card style=\"margin-top: 40px\" class=\"flat\"><md-card-content><section layout=\"row\" layout-align=\"space-around center\"><div layout=\"column\" layout-align=\"center center\"><div layout=\"\"><p class=\"md-subhead color-header\">Detected Colors<md-icon class=\"md-primary md-hue-2\">info</md-icon><md-tooltip>Colors automatically detected by Aarida\'s color detection algorithm. If it is not correct, please contact the admin to adjust the values.</md-tooltip></p></div><p class=\"md-caption\"><span ng-repeat-start=\"color in material.colorNames\">{{color | uppercase}}</span> <span ng-repeat-end=\"\" ng-if=\"!$last\">,</span></p></div><div layout=\"column\" layout-align=\"center center\"><p class=\"md-subhead color-header\">Detected Hex Codes<md-icon class=\"md-primary md-hue-2\">info</md-icon><md-tooltip>Hex Codes automatically detected by Aarida\'s color detection algorithm. If it is not correct, please contact the admin to adjust the values.</md-tooltip></p><div class=\"grey-text md-caption\"><span ng-repeat=\"hexCode in material.hexCodes\" class=\"hex-preview\" ng-style=\"{\'background-color\' : hexCode}\">{{color}}<md-tooltip>{{hexCode}}</md-tooltip></span></div></div><div layout=\"column\" layout-align=\"center center\"><span class=\"md-subhead color-header\">Last Update</span> <span class=\"grey-text md-caption\">{{dateAgo(material.updatedAt)}} | {{material.updatedAt | date : \'medium\'}}</span></div><div layout=\"column\" layout-align=\"center center\"><span class=\"md-subhead color-header\">Created</span> <span class=\"grey-text md-caption\">{{material.createdAt | date : \'medium\'}} by {{material.cachedCreatedBy.name}}</span></div></section></md-card-content></md-card><div layout=\"\" layout-align=\"space-between center\" class=\"md-padding md-margin\"><span class=\"md-subheader\">Batches:</span> <span flex=\"\"></span><md-button class=\"md-accent outline\" ng-click=\"manageProductStocks()\"><md-icon>add</md-icon>Manage Products Stocks</md-button><md-button class=\"outline\" ng-click=\"exportData(material.batches)\"><md-icon>file_download</md-icon><span>Download Barcode</span></md-button><md-button class=\"md-accent outline\" ng-click=\"createBatch(null, null, null)\"><md-icon>add</md-icon>Create New Batch</md-button></div><md-card flex=\"\"><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\">#</th><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\">Barcode</th><th md-column=\"\">Vendor</th><th md-column=\"\" md-numeric=\"\"><span>Pricing</span></th><th md-column=\"\" md-numeric=\"\"><span>Available Stock/Leased</span></th><th md-column=\"\" md-numeric=\"\">Last Update</th><th md-column=\"\"><span>Actions</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"card\" md-auto-select=\"\" style=\"height: 75px\" ng-repeat=\"batch in batches | orderBy : \'-updatedAt\'\"><td md-cell=\"\">{{ $index + 1}}.</td><td md-cell=\"\"><a class=\"pointer\" ng-click=\"openImage($event, batch.image)\"><md-img class=\"product-image\" md-src=\"{{batch.image.urls.thumbnail}}\"></md-img></a></td><td md-cell=\"\" layout=\"\" layout-align=\"center center\"><div md-color-picker=\"\" ng-model=\"batch.hexCode\" ng-change=\"saveColor(batch._id, batch.hexCode)\" class=\"hex-preview\" md-color-clear-button=\"false\" default=\"{{batch.hexCode}}\"></div></td><td md-cell=\"\"><span class=\"md-tiny grey-text\">{{batch.barcode }}</span></td><td md-cell=\"\"><span class=\"md-caption\">{{batch.vendor.name }}</span></td><td md-cell=\"\"><span class=\"md-tiny\">₹{{batch.inRate}} x {{batch.entryStock}} = ₹{{batch.price}}</span></td><td md-cell=\"\"><div layout=\"column\"><a class=\"md-link pointer md-body-1\">{{batch.availableStock}} mtrs<md-tooltip><span>{{batch.availableStock}} of {{batch.entryStock}} remaining.</span></md-tooltip></a> <a class=\"md-caption md-link pointer red-text\" ng-click=\"openUnleaseStockDialog($event, batch, batch.index)\" ng-if=\"batch.leasedQuantity && batch.leasedQuantity > 0\">({{ batch.leasedQuantity + \" mtrs \"}} leased)<md-tooltip class=\"md-tiny\"><span>{{batch.leasedQuantity}}m leased. Click to unlease them.</span></md-tooltip></a></div></td><td md-cell=\"\"><span class=\"md-tiny grey-text\">{{dateAgo(batch.updatedAt)}}</span></td><td md-cell=\"\"><div layout=\"\" layout-align=\"start center\"><md-button class=\"md-warn small outline\" ng-click=\"openDeductStockDialog($event, batch)\"><span class=\"md-tiny\">Adjust Stock</span></md-button><md-button class=\"md-icon-button md-primary\" ng-if=\"currentUser.roleSpec === 0\" ng-click=\"createBatch($event, $index, batch)\"><md-icon>edit</md-icon><md-tooltip>Edit Batch</md-tooltip></md-button><md-button class=\"md-icon-button md-primary\" ng-click=\"showHistory($event, $index, batch)\"><md-icon>history</md-icon><md-tooltip>View Batch History</md-tooltip></md-button><md-button class=\"md-icon-button md-primary\" ng-click=\"exportData([batch])\"><md-icon>print</md-icon><md-tooltip>Print Barcode Label</md-tooltip></md-button><md-button class=\"md-icon-button md-warn\" ng-click=\"deleteBatchById($event, batch.index, batch)\"><md-icon>delete</md-icon><md-tooltip>Delete Batch</md-tooltip></md-button></div></td></tr></tbody></table></md-table-container></md-card></div>");
$templateCache.put("app/modules/scm/materials/details/stockHistoryDialog/stock-history-dialog.html","<md-dialog flex=\"60\" class=\"activateCardModal\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"center center\"><h4>View History</h4></div><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><h4>Updates: ({{stockHistory.length}})</h4><p>Total Stock: {{availableStock}}</p><md-list class=\"md-3-line\"><md-list-item class=\"txn-item\" ng-repeat=\"txn in stockHistory | orderBy: \'-createdAt\'\" ng-class=\"{\'credit\' : txn.updateType === \'inc\', \'debit\' : txn.updateType === \'dec\' || txn.updateType === \'lease\'}\"><div class=\"md-list-item-text\"><p>{{txn.remarks}}</p><span class=\"md-caption grey-text\">{{dateAgo(txn.createdAt)}}</span> <span class=\"md-caption grey-text\">By <span class=\"black-text\">{{txn.cachedCreatedBy.name}}</span></span><div class=\"grey-text md-caption\" layout=\"\" layout-align=\"start center\" ng-if=\"txn.updateType === \'lease\'\"><i>Leased By: {{txn.operatorName}}</i> <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span> <i>Leased On: {{txn.updatedAt | date: \'medium\'}}</i> <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span> <i>Remaining stock after this update: {{txn.availableStock}}</i></div><div class=\"grey-text md-caption\" layout=\"\" layout-align=\"start center\" ng-if=\"txn.prevLeaseName || txn.prevLeaseDate\"><i>Linked Lease By: {{txn.prevLeaseName}}</i> <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span> <i>Linked Leased On: {{txn.prevLeaseDate | date: \'medium\'}}</i></div></div><div class=\"md-secondary\" layout=\"column\" layout-align=\"end center\"><h3 class=\"md-headline\" ng-class=\"{\'red-text\': txn.updateType === \'lease\' || txn.updateType === \'dec\', \'green-text\' : txn.updateType === \'inc\'}\">{{txn.updateType === \'lease\' || txn.updateType === \'dec\' ? \'-\' : \'+\'}}{{txn.quantity}}</h3><span class=\"bold-text md-caption\" ng-if=\"txn.updateType === \'lease\'\">Lease</span></div></md-list-item></md-list></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/scm/materials/modals/material-quickview/material-quickview.dialog.html","<md-dialog flex=\"90\" id=\"quick-view-dialog\" class=\"material-quick-view-dialog\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h3>Quick View</h3><md-button ng-click=\"close();\" class=\"md-icon-button\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content ng-class=\"{\'md-dialog-content\' : !isSmall}\"><div layout=\"column\"><section ng-if=\"!loadingMaterial\" layout-xs=\"column\" layout-gt-sm=\"row\" layout-align=\"center start\" layout-align-xs=\"start center\"><div layout=\"column\" layout-align=\"center center\" flex-gt-sm=\"33\" flex-xs=\"100\" flex-sm=\"100\"><div layout=\"column\" layout-align=\"start center\"><md-img style=\"width: 100%; border-radius: 4px; border-bottom: 4px\" md-src=\"{{selectedImage.urls.large}}\"></md-img><md-content md-scroll-x=\"\" layout=\"\" layout-align=\"start center\" class=\"image-list\"><div ng-repeat=\"media in gallery\" ng-class=\"{\'selected\' : media.active}\" layout=\"column\" layout-align=\"start center\" class=\"single-image\"><md-img class=\"md-margin pointer relative\" md-ink-ripple=\"#c3c3c3\" style=\"width: 75px; height: auto; border-radius: 4px;\" ng-click=\"selectImage(media)\" md-src=\"{{media.image.urls.thumbnail}}\"></md-img><span class=\"md-tiny type\">{{media.type | uppercase}}</span> <span class=\"md-tiny grey-text\" ng-if=\"media.code\">({{media.code}})</span><br ng-if=\"!media.code\"></div></md-content></div></div><div flex=\"\" layout-padding=\"\" layout=\"column\"><h4>{{material.name}}</h4><h5><span>{{material.sku}} |</span> <span class=\"grey-text\">Created By : {{material.cachedCreatedBy.name}}</span></h5><p>{{material.categoryString}}</p><div layout=\"\" class=\"full-width\"><section flex-xs=\"100\" flex-sm=\"80\" flex-gt-sm=\"60\"><md-list><md-list-item><p class=\"bold-text\">Current Stock :</p><span class=\"md-secondary\">{{material.stock}}</span></md-list-item><md-divider></md-divider><md-list-item><p class=\"bold-text\">Leased Stock :</p><span class=\"md-secondary\">{{material.leasedQuantity}}</span></md-list-item><md-divider></md-divider><md-list-item><p class=\"bold-text\">Sale Price :</p><span class=\"md-secondary\">₹ {{material.salePrice}}</span></md-list-item><md-divider></md-divider><md-list-item><p class=\"bold-text\">Last Update :</p><span class=\"md-secondary\">{{dateAgo(material.updatedAt)}}</span></md-list-item><md-divider></md-divider><md-list-item><p class=\"bold-text\">Colors :</p><section class=\"md-secondary\"><div class=\"grey-text md-caption\" layout=\"\"><section ng-repeat=\"hexCode in material.hexCodes\" class=\"hex-preview\" style=\"height: 20px\" ng-style=\"{\'background-color\' : hexCode}\">{{color}}<md-tooltip>{{hexCode}}</md-tooltip></section></div></section></md-list-item><md-divider></md-divider></md-list></section></div><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\">#</th><th md-column=\"\"></th><th md-column=\"\">Barcode</th><th md-column=\"\">Vendor</th><th md-column=\"\" md-numeric=\"\"><span>Pricing</span></th><th md-column=\"\" md-numeric=\"\"><span>Available Stock</span></th><th md-column=\"\" md-numeric=\"\"><span>Leased</span></th><th md-column=\"\" md-numeric=\"\">Last Update</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" style=\"height: 75px\" ng-repeat=\"batch in material.batches | orderBy : \'-updatedAt\'\"><td md-cell=\"\">{{ $index + 1}}.</td><td md-cell=\"\"><md-img class=\"product-image\" md-src=\"{{batch.image.urls.thumbnail}}\"></md-img></td><td md-cell=\"\"><p class=\"md-tiny grey-text\">{{batch.barcode }}</p></td><td md-cell=\"\"><p class=\"md-caption\">{{batch.vendor.name }}</p></td><td md-cell=\"\"><p class=\"md-tiny\">₹{{batch.inRate}} x {{batch.entryStock}} = ₹{{batch.price}}</p></td><td md-cell=\"\">{{batch.availableStock}} m</td><td md-cell=\"\">{{batch.leasedQuantity || 0}} m</td><td md-cell=\"\"><span class=\"md-tiny grey-text\">{{dateAgo(batch.updatedAt)}}</span></td></tr></tbody></table></md-table-container></div></section><section layout=\"\" layout-align=\"center center\" ng-if=\"loadingMaterial\" layout-fill=\"\" flex=\"\" style=\"min-height: calc(100vh - 128px)\"><md-progress-circular md-diameter=\"36\"></md-progress-circular></section></div></md-dialog-content><md-dialog-actions md-colors=\"{\'background\' : \'boring-primary-50-0.4\'}\" ng-disabled=\"loadingProduct\"><div layout=\"\" layout-align=\"space-between center\" flex=\"\"><md-button class=\"md-warn\" ng-click=\"close();\">Close</md-button><md-button class=\"md-primary\" ng-click=\"close();\" ui-sref=\"app.materials.details({materialId : material._id})\">Edit</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/scm/materials/modals/materials-selector/materials-selector.dialog.html","<md-dialog flex=\"80\" class=\"materials-selector-dialog\"><md-toolbar layout=\"\" layout-align=\"center center\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h3 class=\"md-subhead\">Select Materials</h3><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"relative\"><form name=\"materialSelectorForm\" class=\"md-padding md-margin\"><div layout=\"\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"100\" md-no-float=\"\"><md-icon>search</md-icon><textarea autocomplete=\"off\" rows=\"2\" ng-model=\"query.search\" ng-change=\"fetchMaterials()\" placeholder=\"Search for materials\"></textarea></md-input-container></div><md-content md-scroll-x=\"\" class=\"color-selector\" layout=\"\"><section ng-repeat=\"hexCode in hexCodes\" class=\"pointer relative single-color-button\"><a class=\"color\" ng-style=\"{\'background\' : hexCode.color}\" title=\"{{hexCode.color}}\" ng-class=\"{\'selected md-whiteframe-12dp\' : hexCode.selected, \'no-color\' : hexCode.color === \'undefined\'}\" ng-click=\"toggleColor(hexCode)\"></a></section></md-content><md-divider></md-divider><md-content md-scroll-x=\"\" class=\"color-selector\" layout=\"\"><md-button ng-repeat=\"category in categories\" style=\"min-width: 125px\" class=\"md-primary small round\" ng-click=\"toggleCategory(category)\" ng-class=\"{\'outline\' : !category.selected, \'md-raised\' : category.selected}\">{{category.name}}</md-button></md-content><md-divider></md-divider><h4>Materials :</h4><div class=\"info-box slide-up-fade-in\" layout=\"\" layout-align=\"space-between center\" ng-if=\"hasFilters\"><section layout=\"\" layout-align=\"start center\"><md-icon>star_filled</md-icon><span class=\"bold-text\">Showing Filtered Results</span></section><md-button class=\"md-warn small round\" ng-click=\"clearFilters()\"><md-icon>close</md-icon>Clear Filters</md-button></div><div layout=\"\" layout-wrap=\"\" layout-align=\"stretch stretch\" ng-if=\"materials.length\"><section ng-repeat=\"material in materials\" flex=\"20\" flex-sm=\"25\" flex-md=\"25\" class=\"pointer\" ng-click=\"selectMaterial(material)\"><md-card><md-img md-src=\"{{material.image.urls.medium}}\" class=\"md-card-image\"></md-img><md-card-content layout=\"column\" layout-align=\"center center\"><p class=\"md-caption\">{{capitalize(material.name)}}</p><p class=\"md-tiny\">Stock : {{material.stock}}</p><p class=\"md-tiny\">₹ {{material.salePrice}}</p><div layout=\"\" layout-align=\"center center\" class=\"selected-box\"><md-button ng-click=\"selectMaterial(material)\" class=\"small\" ng-class=\"{\'md-primary md-raised\' : material.isSelected,\'md-accent outline\' : !material.isSelected}\">{{material.isSelected ? \'Selected\' : \'Select\'}}</md-button></div></md-card-content></md-card></section></div><div layout=\"column\" layout-align=\"center center\" ng-if=\"!materials.length\"><img src=\"assets/images/blank.svg\" style=\"width: 200px\"><p>No Materials Matching the Filter Criteria Found</p></div><div ng-if=\"selectedMaterials.length\" class=\"selected-materials-panel slide-up-fade-in\" ng-class=\"{\'collapsed\': selectedMaterialsPanelCollapsed}\"><h5 class=\"title\">Selected Materials <i>({{selectedMaterials.length}} selected)</i> :</h5><section class=\"selected-materials-list\" layout=\"\"><div ng-repeat=\"material in selectedMaterials\" class=\"selected-material\" layout=\"column\" layout-align=\"center center\"><section class=\"selected-material-image\" ng-style=\"{\'backgroundImage\' : \'url(\' + mediaUrl + material.image.urls.medium +\')\'}\"></section><p class=\"md-tiny\">{{capitalize(material.materialName)}}</p><p class=\"md-tiny\">₹ {{material.totalPrice}}</p><div layout=\"\" layout-align=\"center center\" class=\"quantity-box\"><md-button class=\"md-icon-button medium md-primary subtract\" ng-click=\"updateStock(material, -0.25, $event, $index)\"><md-icon>remove_circle</md-icon></md-button><input ng-blur=\"checkIfHasToBeRemoved(material, $index)\" class=\"quantity\" min=\"0\" step=\"0.25\" ng-model=\"material.quantity\" type=\"number\"><md-button class=\"md-icon-button medium md-primary add\" ng-click=\"updateStock(material, 0.25, $event, $index)\"><md-icon>add_circle</md-icon></md-button></div><md-button class=\"small md-warn\" ng-click=\"removeMaterial(material, $index)\">Remove</md-button></div></section><div class=\"collapse-button\"><md-button class=\"md-icon-button small\" ng-click=\"selectedMaterialsPanelCollapsed = !selectedMaterialsPanelCollapsed\"><md-icon>{{selectedMaterialsPanelCollapsed ? \'arrow_drop_up\' : \'arrow_drop_down\'}}</md-icon></md-button></div></div></form></md-dialog-content><md-dialog-actions class=\"md-whiteframe-2dp\"><div layout=\"\" layout-align=\"center center\" flex=\"\"><md-button class=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><span flex=\"\"></span><md-button class=\"md-primary outline\" ng-click=\"save()\">Save</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/scm/materials/vendors/partials/vendors.tmpl.html","<div><md-card><md-subheader class=\"md-table-toolbar md-default white\"><div layout=\"row\"><md-input-container md-no-float=\"\" flex=\"40\" class=\"md-block no-error-spacer md-primary\"><md-icon>search</md-icon><input type=\"search\" placeholder=\"Search For Vendors\" ng-model=\"query.q\" ng-model-options=\"{\'debounce\' : 200}\" ng-change=\"fetchVendors()\"></md-input-container><span flex=\"\"></span><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-click=\"showDialog($event, null, null);\"><md-icon>add</md-icon><span class=\"md-caption bold-text\">Add New Vendor</span></md-button></div></div></md-subheader><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.order\" md-on-reorder=\"fetchVendors\"><tr md-row=\"\"><th md-column=\"\"><span>Sl</span></th><th md-column=\"\" md-order-by=\"name\"><span>Name</span></th><th md-column=\"\" md-order-by=\"gstNumber\"><span>Gst Number</span></th><th md-column=\"\" md-order-by=\"createdAt\">Created On</th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"vendor\" md-select-id=\"vendor._id\" md-auto-select=\"\" ng-repeat=\"vendor in vendors\"><td md-cell=\"\">{{$index +1}}.</td><td md-cell=\"\"><a ng-click=\"$event.stopPropagation()\" ui-sref=\"app.vendors.details\" class=\"md-body-2 md-truncate pointer\">{{vendor.name}}</a></td><td md-cell=\"\"><span>{{vendor.gstNumber}}</span></td><td md-cell=\"\"><span class=\"md-caption grey-text\">{{vendor.createdAt | date : \'medium\'}}</span></td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"showDialog($event, vendor, $index);\"><md-icon>edit</md-icon></md-button><md-button class=\"md-icon-button md-warn\" ng-click=\"deleteVendor($event, vendor, $index);\"><md-icon>delete</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5, 25, 50]\" md-page=\"query.page\" md-total=\"{{totalCount}}\" md-on-paginate=\"fetchVendors\" md-page-select=\"\"></md-table-pagination></md-card></div>");
$templateCache.put("app/modules/scm/purchase/models/partials/addPurchaseModel.tmpl.html","<md-dialog flex-xl=\"70\" flex=\"90\" class=\"addPurchaseModal\"><md-toolbar class=\"md-accent md-hue-1\" layout=\"\" layout-align=\"center center\"><div class=\"md-toolbar-tools\"><p class=\"md-subhead\">{{editingPurchase ? \"Edit Purchase\" : \"Add Purchase\"}}</p></div><span flex=\"\"></span><div><md-button class=\"md-icon-button no-margin\" ng-click=\"cancelDialog()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"content\"><form name=\"createPurchaseForm\"><div layout=\"\" layout-align=\"center start\"><div layout=\"column\" flex=\"\"><md-toolbar class=\"md-action md-hue-3\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h4 class=\"center-text\">Add Line Items</h4><span flex=\"\"></span><md-button ng-click=\"addLineItems()\" class=\"md-accent md-raised\"><md-icon>add</md-icon>Add Line Item</md-button></div></md-toolbar><md-divider></md-divider><md-content class=\"md-padding add-purchase-container\"><md-card class=\"single-rule-item\" ng-repeat=\"lineItem in purchase.lineItems track by $index\"><md-card-content layout=\"\"><div layout=\"column\" flex=\"\"><section layout=\"\"><section flex=\"30\" layout=\"\" layout-align=\"center center\"><md-autocomplete md-selected-item=\"selectedMaterial\" md-search-text=\"materialSearchText\" md-min-length=\"3\" md-input-name=\"materialAutoComplete\" required=\"\" flex=\"\" ng-if=\"!lineItem.material\" md-floating-label=\"Select Material\" md-escape-options=\"none\" md-selected-item-change=\"addMaterialToLineItem(selectedMaterial, lineItem)\" md-menu-class=\"material-autocomplete-results\" placeholder=\"Search for Materials\" md-items=\"item in fetchMaterial(materialSearchText)\"><md-item-template><div layout=\"\" layout-align=\"stretch center\"><span md-highlight-text=\"materialSearchText\">{{item.name}}</span></div></md-item-template><md-not-found><a ng-click=\"openAddNewMaterial($event,materialSearchText, lineItem)\">Create a new Material!</a> No materials matching \"{{materialSearchText}}\" were found.</md-not-found><div ng-messages=\"createPurchaseForm.materialAutoComplete.$error\" ng-if=\"createPurchaseForm.materialAutoComplete.$touched\"><div ng-message=\"required\">You <b>must</b> select a material.</div><div ng-message=\"minlength\">Your entry is not long enough.</div></div></md-autocomplete><div layout=\"row\" flex=\"\" layout-align=\"space-between center\" class=\"autocomplete-chip\" ng-if=\"lineItem.material\"><section layout=\"column\"><span class=\"bold-text\">Material : {{lineItem.material.name}}</span></section><md-button class=\"md-icon-button\" ng-click=\"removeMaterialFromItem(lineItem)\"><md-icon>close</md-icon><md-tooltip>Remove Vendor</md-tooltip></md-button></div><md-input ng-model=\"lineItem.material\" hidden=\"\" required=\"\"></md-input></section><md-input-container class=\"md-block\" flex=\"15\" flex-offset=\"5\"><label>Qty</label> <input type=\"number\" ng-required=\"\" ng-disabled=\"editingPurchase && lineItem.isOld\" ng-model=\"lineItem.quantity\" ng-change=\"reCalculateData()\"></md-input-container><md-input-container class=\"md-block\" flex=\"10\" flex-offset=\"5\"><label>Unit</label><md-select ng-model=\"lineItem.unit\" ng-change=\"reCalculateData()\"><md-option ng-value=\"\'gm\'\">Grams</md-option><md-option ng-value=\"\'pieces\'\">Pieces</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"15\" flex-offset=\"5\"><label>Rate</label> <input type=\"number\" ng-required=\"\" ng-model=\"lineItem.rate\" ng-change=\"reCalculateData()\"></md-input-container><md-input-container class=\"md-block\" flex=\"10\" flex-offset=\"5\"><label>Tax %</label><md-select ng-model=\"lineItem.taxString\" ng-change=\"reCalculateData()\"><md-optgroup label=\"GST\"><md-option ng-repeat=\"gstTax in taxGroups.GST\" ng-value=\"gstTax.value\">GST {{gstTax.actualValue}}%</md-option></md-optgroup><md-optgroup label=\"IGST\"><md-option ng-repeat=\"gstTax in taxGroups.IGST\" ng-value=\"gstTax.value\">GST {{gstTax.actualValue}}%</md-option></md-optgroup></md-select></md-input-container></section><section layout=\"\" layout-align=\"end center\"><md-input-container class=\"md-block\"><md-switch ng-change=\"reCalculateData()\" ng-model=\"lineItem.isInclusive\"><div layout=\"\">Tax Inclusive<section><md-icon>info</md-icon><md-tooltip>If tax is inclusive, the tax amount will not be added to the total amount.</md-tooltip></section></div></md-switch></md-input-container><md-input-container class=\"md-block\" flex-offset=\"10\"><label>Amount</label> <input type=\"number\" ng-disabled=\"true\" ng-required=\"\" ng-model=\"lineItem.amount\"></md-input-container></section></div><div layout=\"column\" layout-align=\"center center\" flex=\"10\"><md-button class=\"md-icon-button no-margin\" ng-click=\"addLineItems($index)\"><md-icon>add</md-icon><md-tooltip>Add List Items in next row</md-tooltip></md-button><md-button class=\"md-icon-button no-margin md-warn\" ng-if=\"!editingPurchase ||(editingPurchase && !lineItem.isOld)\" ng-click=\"deleteLineItems($event, $index)\"><md-icon>delete</md-icon><md-tooltip>Delete this Item</md-tooltip></md-button></div></md-card-content></md-card></md-content></div><div md-whiteframe=\"1\" layout=\"column\" class=\"md-padding md-margin\" flex=\"25\"><section class=\"md-margin\" flex=\"100\"><div layout=\"\" layout-align=\"start center\" ng-if=\"!purchase.vendor\"><span><i>Suggestions :</i></span><md-button class=\"md-primary round outline small\" ng-click=\"selectSuggestedVendor(\'NoVendor\')\">No Vendor</md-button></div><md-autocomplete md-selected-item=\"selectedVendor\" ng-if=\"!purchase.vendor\" md-search-text=\"vendorSearchText\" md-min-length=\"3\" md-input-name=\"vendorAutocomplete\" required=\"\" md-floating-label=\"Select Vendor\" md-escape-options=\"none\" md-selected-item-change=\"addVendorToData(selectedVendor)\" md-menu-class=\"vendor-autocomplete-results\" placeholder=\"Search for Vendors by Name\" md-items=\"item in fetchVendor(vendorSearchText)\"><md-item-template><div layout=\"\" layout-align=\"stretch center\"><span md-highlight-text=\"vendorSearchText\">{{item.name}} ({{item.gstNumber}})</span></div></md-item-template><md-not-found><a ng-click=\"createVendor(vendorSearchText)\">Create a new vendor!</a> No vendors matching \"{{vendorSearchText}}\" were found.</md-not-found><div ng-messages=\"createPurchaseForm.vendorAutocomplete.$error\" ng-if=\"createPurchaseForm.vendorAutocomplete.$touched\"><div ng-message=\"required\">You <b>must</b> select a vendor.</div><div ng-message=\"minlength\">Your entry is not long enough.</div></div></md-autocomplete><div layout=\"row\" layout-align=\"space-between center\" class=\"autocomplete-chip\" ng-if=\"purchase.vendor\"><section layout=\"column\"><span class=\"bold-text md-caption\"><span class=\"grey-text\">Vendor :</span> {{purchase.vendor.name}}</span> <span class=\"md-tiny\">{{purchase.vendor.gstNumber}}</span></section><md-button class=\"md-icon-button\" ng-click=\"removeVendor()\"><md-icon>close</md-icon><md-tooltip>Remove Vendor</md-tooltip></md-button></div><md-input ng-change=\"populateGstNumber()\" ng-model=\"purchase.vendor\" hidden=\"\" required=\"\"></md-input></section><div layout=\"\"><md-input-container class=\"md-block\"><label>Total Purchase Tax Amount</label> <input type=\"number\" ng-required=\"\" disabled=\"\" ng-model=\"purchase.totalPurchaseTaxAmount\"></md-input-container><md-input-container class=\"md-block\"><label>Total Purchase Amount</label> <input type=\"number\" ng-required=\"\" disabled=\"\" ng-model=\"purchase.totalPurchaseAmount\"></md-input-container></div><md-input-container class=\"md-block\"><md-datepicker md-max-date=\"maxDate\" placeholder=\"Enter Purchase Date\" ng-model=\"purchase.purchaseDate\"></md-datepicker></md-input-container><md-input-container class=\"md-block\"><label>Bill GST Number</label> <input type=\"text\" disabled=\"\" ng-model=\"purchase.billGstNumber\"></md-input-container><md-input-container class=\"md-block\"><label>Invoice Number</label> <input type=\"text\" ng-model=\"purchase.invoiceNumber\"></md-input-container></div></div></form></md-dialog-content><md-divider></md-divider><md-dialog-actions md-colors=\"{\'background\' : \'primary-100-0.2\'}\"><div layout=\"\" layout-align=\"center center\" flex=\"\"><md-button class=\"md-warn\" ng-click=\"cancelDialog()\">Cancel</md-button><div flex=\"\" layout=\"\" layout-align=\"end center\"><span class=\"red-text\" ng-if=\"!purchase.lineItems || !purchase.lineItems.length\">Please add at lease one line item to save purchase</span></div><md-button class=\"md-primary md-raised\" ng-disabled=\"saving || createPurchaseForm.$invalid || (!purchase.lineItems || !purchase.lineItems.length)\" ng-click=\"createPurchase()\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!saving\">{{editingPurchase ? \"Edit Purchase\" : \"Add Purchase\"}}</span><md-progress-circular md-diameter=\"20\" ng-if=\"saving\"></md-progress-circular></div></md-button></div></md-dialog-actions><div class=\"overlay-loader\" layout=\"\" layout-align=\"center center\" ng-if=\"fetchingPurchase\"><md-progress-circular></md-progress-circular></div></md-dialog>");
$templateCache.put("app/modules/users/details/partials/nested/cart.html","<div><md-card><md-card-content><div layout=\"row\" layout-margin=\"\"><span flex=\"\"></span><md-input-container md-no-float=\"\" flex=\"20\" class=\"md-block\"><md-icon>search</md-icon><input type=\"search\" placeholder=\"Search\" ng-model=\"query.searchTerm\" ng-model-options=\"{\'debounce\' : 200}\" ng-change=\"getAllCarts()\"></md-input-container></div><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.sort\" md-on-reorder=\"fetchCarts\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\"></th><th md-column=\"\">User</th><th md-column=\"\" md-numeric=\"\"><span>Mobile</span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"length\"><span>Prod. #</span></th><th md-column=\"\"><span>Amount</span></th><th md-column=\"\" md-order-by=\"status\"><span>Status</span></th><th md-column=\"\" md-order-by=\"createdAt\"><span>Created</span></th><th md-column=\"\" md-order-by=\"updatedAt\"><span>Last Modified</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"cart\" md-auto-select=\"\" ng-repeat=\"cart in carts\"><td md-cell=\"\">{{$index + 1 }}.</td><td md-cell=\"\">{{user.name }}</td><td md-cell=\"\">{{user.mobile}}</td><td md-cell=\"\"><a class=\"md-link\" ng-click=\"showProductListDialog(cart)\">{{cart.length}}</a></td><td md-cell=\"\">Rs {{cart.amount}}</td><td md-cell=\"\">{{cart.amount}}</td><td md-cell=\"\">{{cart.status}}</td><td md-cell=\"\">{{cart.createdAt | date : \"mediumDate\"}}</td><td md-cell=\"\">{{cart.updatedAt | date : \"mediumDate\"}}</td></tr></tbody></table></md-table-container><md-table-pagination mdboundarylinks=\"\" md-limit=\"query.limit\" md-limit-options=\"[5, 10, 25, 50,100]\" md-page=\"query.page\" md-total=\"{{total}}\" md-on-paginate=\"getAllCarts\" md-page-select=\"\"></md-table-pagination></md-card-content></md-card></div>");
$templateCache.put("app/modules/users/details/partials/nested/home.html","<div layout=\"\" class=\"user-details-home\"><section flex=\"\"><md-card><md-card-content><md-table-container><h2 class=\"center-text\">User Addresses</h2><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\">#</th><th md-column=\"\" md-numeric=\"\">TAG</th><th md-column=\"\" md-numeric=\"\">Name</th><th md-column=\"\" md-numeric=\"\">Street</th><th md-column=\"\" md-numeric=\"\">Landmark</th><th md-column=\"\" md-numeric=\"\">City</th><th md-column=\"\" md-numeric=\"\">State</th><th md-column=\"\" md-numeric=\"\">PinCode</th><th md-column=\"\" md-numeric=\"\">Default</th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"address in userHomeCtrl.addresses\"><td md-cell=\"\">{{$index + 1 }}.</td><td md-cell=\"\"><span class=\"md-tiny\">{{address.addressType | uppercase}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{address.name}}({{address.mobile}})</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{address.streetAddress}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{address.landmark}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{address.city}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{address.state}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{address.pinCode}}</span></td><td md-cell=\"\"><span class=\"md-tiny\">{{address.isDefault}}</span></td><td md-cell=\"\"></td></tr></tbody></table><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5, 25, 50]\" md-page=\"query.page\" md-total=\"{{totalCount}}\" md-on-paginate=\"getAllUsers\" md-page-select=\"\"></md-table-pagination></md-table-container></md-card-content></md-card></section><section flex=\"30\"><md-card class=\"user-info-card\"><md-card-content><div layout=\"\" layout-align=\"space-between center\"><span class=\"md-subhead bold-text\">USER DETAILS</span><md-button class=\"md-icon-button\" ng-click=\"userHomeCtrl.openUserEditDialog($event)\"><md-icon>settings</md-icon></md-button></div><div layout=\"\" layout-align=\"space-between center\"><section layout=\"column\"><h1 class=\"md-headline user-name\">{{userHomeCtrl.user.name}}</h1><h3 class=\"md-body-1 user-email\">{{userHomeCtrl.user.email ? userHomeCtrl.user.email : \'Not Set\' }}</h3><p class=\"user-mobile\">Mobile : {{userHomeCtrl.user.mobile}}</p><p class=\"user-points\">Aarida Cash : ₹ {{userHomeCtrl.user.points}}</p></section><img src=\"assets/images/default.png\" class=\"profile-image\" ng-if=\"userHomeCtrl.user.profileImageURL === \'default.png\'\"><md-img ng-if=\"userHomeCtrl.user.profileImageURL !== \'default.png\'\" class=\"profile-image\" md-src=\"{{userHomeCtrl.user.profileImageURL}}\"></md-img></div></md-card-content></md-card></section></div>");
$templateCache.put("app/modules/users/details/partials/nested/job.html","<div><h3 class=\"center-text\">Job Details</h3><md-card><md-card-content><p>Job Details for {{userJobCtrl.user.name}}</p><form name=\"jobForm\"><div layout=\"\" layout-wrap=\"\" layout-align=\"space-between\"><md-input-container flex=\"45\"><label>Enter Monthly Salary</label> <input ng-disabled=\"userJobCtrl.meta._id\" type=\"number\" name=\"salary\" required=\"\" min=\"0\" ng-model=\"userJobCtrl.meta.monthlySalary\"><div ng-messages=\"jobForm.salary.$error\" ng-if=\"salary.$touched && salary.$invalid && jobForm.salary.$error\"><div ng-message=\"required\">Please enter a Salary</div><div ng-message=\"min\">Please enter a valid Salary</div></div></md-input-container><md-select ng-model=\"userJobCtrl.meta.allowedTaskTypes\" multiple=\"\" flex=\"45\" name=\"allowedTaskTypes\" required=\"\" placeholder=\"Select Allowed Task Types\"><md-option ng-repeat=\"tab in userJobCtrl.tabs\" ng-value=\"tab.value\">{{tab.title}}</md-option></md-select><h4 flex=\"100\">Workforce Settings</h4><md-input-container class=\"no-error-spacer\" flex=\"30\"><md-checkbox ng-model=\"userJobCtrl.meta.canStartTasks\">Can Start Tasks</md-checkbox></md-input-container><md-input-container class=\"no-error-spacer\" flex=\"30\"><md-checkbox ng-model=\"userJobCtrl.meta.canViewTasks\">Can View Tasks Without Starting</md-checkbox></md-input-container><span flex=\"30\"></span></div></form></md-card-content><div layout=\"\" layout-align=\"end\"><md-button ng-disabled=\"jobForm.$invalid || userJobCtrl.saving\" ng-click=\"userJobCtrl.saveMeta()\"><span ng-if=\"!saving\">Save</span><bubble-loader ng-if=\"saving\"></bubble-loader></md-button></div></md-card></div>");
$templateCache.put("app/modules/users/details/partials/nested/offers.html","<div layout=\"\"><section flex=\"70\" layout=\"column\" layout-align=\"start center\"><h2 class=\"md-title md-padding\">Gift Cards</h2><div layout=\"\" layout-wrap=\"\" ng-if=\"cards.length\" class=\"gift-cards-container\" layout-align=\"stretch center\"><section flex-gt-md=\"33\" flex-sm=\"50\" flex-xs=\"100\" ng-repeat=\"card in cards\"><md-card class=\"gift-card\" ng-class=\"{\'pointer dummy-card\' : card.code === \'dummy\'}\" ng-click=\"navigateGiftCard(card)\"><div class=\"bg-energy\" ng-show=\"card.code !== \'dummy\'\"></div><md-card-content ng-if=\"card.code !== \'dummy\'\"><div layout=\"\" layout-align=\"space-between center\"><span class=\"md-caption white-text\">Valid Till : {{card.expiryDate | date: \'mediumDate\'}}</span> <img src=\"assets/images/aarida-logo-white.png\" class=\"logo\" alt=\"logo\"></div><div layout=\"column\" layout-align=\"center start\"><p class=\"bold-text card-number\">{{card.code}}</p><span class=\"md-subhead white-text\">₹ <span class=\"gift-card-balance\">{{card.balance}}</span></span></div></md-card-content><md-card-content ng-if=\"card.code === \'dummy\'\" layout=\"column\" layout-align=\"center center\"><div class=\"add-icon\"><md-icon>add</md-icon></div><span class=\"redeem-text\">Create Gift Card</span></md-card-content></md-card></section></div><section flex=\"\" ng-if=\"!cards.length\" layout=\"column\" layout-align=\"center center\" class=\"empty-state\"><img src=\"assets/images/gift-card.svg\" alt=\"gift card image\"><p class=\"md-padding center-text\" ng-class=\"{\'md-caption\' : isSmall}\">No gift cards created with this account yet</p><md-button class=\"md-accent md-padding outline\" ui-sref=\"app.offers.giftCards.add\"><md-icon>add</md-icon><span>Create New Card</span></md-button></section></section></div>");
$templateCache.put("app/modules/users/details/partials/nested/orders.html","Orders");
$templateCache.put("app/modules/users/details/partials/nested/transactions.html","<div flex=\"\"><md-card><md-card-content><md-table-container><h2 class=\"center-text\">User Transactions</h2><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\">#</th><th md-column=\"\" md-numeric=\"\">TxnId</th><th md-column=\"\" md-numeric=\"\">From</th><th md-column=\"\" md-numeric=\"\">Amount</th><th md-column=\"\" md-numeric=\"\">To</th><th md-column=\"\" md-numeric=\"\">Type</th><th md-column=\"\" md-numeric=\"\">On</th><th md-column=\"\">Description</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"txn in transactions\"><td md-cell=\"\">{{$index + 1 }}.</td><td md-cell=\"\"><span>{{txn.txnId}}</span></td><td md-cell=\"\"><span>Rs. {{txn.from}}</span></td><td md-cell=\"\"><span><span class=\"green-text\" ng-if=\"txn.txnType === \'credit\'\">+</span> <span class=\"red-text\" ng-if=\"txn.txnType === \'debit\'\">-</span> Rs. {{txn.amount}}</span></td><td md-cell=\"\"><span>Rs. {{txn.to}}</span></td><td md-cell=\"\"><span>{{txn.txnType | uppercase}}</span></td><td md-cell=\"\"><span>{{txn.createdAt | date : \"medium\"}}</span></td><td md-cell=\"\"><span class=\"md-caption\">{{txn.description}}</span></td></tr></tbody></table><md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5, 25, 50]\" md-page=\"query.page\" md-total=\"{{totalCount}}\" md-on-paginate=\"getAllUsers\" md-page-select=\"\"></md-table-pagination></md-table-container></md-card-content></md-card></div>");
$templateCache.put("app/modules/users/organisations/addOrg/partials/addOrg.tmpl.html","<md-dialog flex=\"60\" class=\"activateCardModal\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"center center\"><h4>{{editingOrg ? \'Edit\' : \'Add New \'}} Organisation</h4></div><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><form name=\"orgForm\" layout=\"\" layout-wrap=\"\" layout-align=\"space-between center\"><md-input-container flex=\"45\"><label>Org Name</label> <input required=\"\" type=\"text\" ng-model=\"organisation.name\"></md-input-container><md-input-container flex=\"45\" class=\"no-error-spacer\"><label>Org Admin</label><md-select required=\"\" ng-model=\"organisation.adminUser\"><md-option ng-value=\"user._id\" ng-repeat=\"user in users\"><div layout=\"column\" layout-align=\"center start\"><span>{{user.name}}</span> <span class=\"md-caption grey-text\">{{user.mobile}}</span></div></md-option></md-select></md-input-container><md-input-container flex=\"45\"><label>GST Number</label> <input type=\"text\" ng-model=\"organisation.gstNumber\" required=\"\"></md-input-container><md-input-container flex=\"45\" class=\"no-error-spacer\"><label>Status</label><md-select required=\"\" ng-model=\"organisation.status\"><md-option ng-value=\"status\" ng-repeat=\"status in statusList\">{{status | uppercase}}</md-option></md-select></md-input-container><md-input-container flex=\"45\"><md-checkbox ng-model=\"organisation.isVerified\">Is Verified Org?</md-checkbox></md-input-container><md-input-container flex=\"45\"><md-checkbox ng-model=\"organisation.settings.hideAddressForm\">Hide Address Form in Checkout</md-checkbox></md-input-container><md-input-container flex=\"45\"><md-checkbox ng-model=\"organisation.settings.negativeBalanceAllowed\">Allow Negative Balance</md-checkbox></md-input-container><md-input-container flex=\"45\"><md-checkbox ng-model=\"organisation.settings.sendCustomPassword\">Send Custom Password to new User</md-checkbox></md-input-container><div flex=\"100\" layout=\"\" layout-align=\"end-center\"><md-switch ng-model=\"updatePassword\" ng-change=\"clearPassword()\">Update Password</md-switch></div><md-input-container flex=\"45\" ng-if=\"organisation.settings.sendCustomPassword && updatePassword\"><label>Default Password</label> <input type=\"{{defaultPasswordType ? \'password\' : \'text\'}}\" required=\"\" ng-model=\"organisation.settings.defaultPassword\"><md-icon md-ink-ripple=\"\" ng-click=\"defaultPasswordType = !defaultPasswordType\">remove_red_eye</md-icon></md-input-container><md-input-container flex=\"45\" ng-if=\"organisation.settings.sendCustomPassword && updatePassword\"><label>Confirm Default Password</label> <input type=\"{{confirmPasswordType ? \'password\' : \'text\'}}\" required=\"\" ng-pattern=\"{{organisation.settings.defaultPassword}}\" ng-model=\"organisation.settings.confirmPassword\"><md-icon md-ink-ripple=\"\" ng-click=\"confirmPasswordType = !confirmPasswordType\">remove_red_eye</md-icon></md-input-container><md-card class=\"full-width\"><md-card-header flex=\"\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">Address</span><md-button class=\"md-primary outline small\" ng-click=\"openAddressSelector($event)\">Change Address</md-button></md-card-header><md-card-content><div layout=\"column\" ng-if=\"organisation.address\"><p class=\"md-body-1 bold-text\">{{ organisation.address.name }} : {{organisation.address.mobile}}</p><p class=\"md-caption\">{{ organisation.address.streetAddress }}</p><p class=\"md-caption\"><span ng-if=\"organisation.address.landmark\">{{ organisation.address.landmark }},</span> {{organisation.address.city}}, {{organisation.address.state}}-{{organisation.address.pinCode}}</p></div><div layout=\"column\" layout-align=\"center center\" ng-if=\"!organisation.address\"><img src=\"assets/images/blank.svg\" style=\"width: 100px; height: auto\"><p>No Address Set</p><md-button class=\"md-primary outline\" ng-click=\"openAddressSelector($event)\">Select Address</md-button></div></md-card-content></md-card><input type=\"hidden\" ng-model=\"organisation.address\" required=\"\"></form></md-dialog-content><md-dialog-actions><md-button class=\"md-primary md-raised\" ng-disabled=\"orgForm.$invalid || saving\" ng-click=\"createNewOrganisation()\"><md-icon>add</md-icon>{{editingOrg ? \'Edit\' : \'Add New \'}} Organisation</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/workforce/tasks/dialogs/task-history/task-history-dialog.html","<md-dialog flex=\"60\" class=\"activateCardModal\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"center center\"><h4>View History</h4></div><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><md-list class=\"md-3-line\"><md-list-item class=\"note-item\" ng-repeat=\"note in notes | orderBy: \'-date\'\"><div layout=\"column\"><h3 class=\"md-caption\">{{note.description}}</h3><p class=\"md-tiny\">By {{note.creator.name}}</p></div><p class=\"md-secondary md-caption\">{{note.date | date : \'medium\'}}</p></md-list-item></md-list></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/workforce/tasks/dialogs/task-update-time/task-update-time.dialog.html","<md-dialog class=\"edit-measurements-container\" flex=\"70\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-title\">Update Time For Task</span><md-button class=\"md-icon-button\" ng-click=\"cancel();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><h4 class=\"center-text\">Estimated the time incorrectly initially?</h4><p class=\"center-text\">Added extra time to the task to help finish the task correctly.</p><form name=\"updateTimeForm\"><section layout=\"\" layout-align=\"center center\" class=\"md-padding\" style=\"background: #dde3eb\"><span class=\"time-input-label\">Days</span> <input class=\"time-input hours\" ng-model=\"timeUpdate.days\" ng-change=\"updateTimeDuration()\" type=\"number\" min=\"0\" required=\"\"> <span class=\"time-input-label\">Hours</span> <input class=\"time-input hours\" ng-model=\"timeUpdate.hours\" ng-change=\"updateTimeDuration()\" type=\"number\" min=\"0\" max=\"23\" required=\"\"> <span class=\"time-input-label\">Minutes</span> <input class=\"time-input minutes\" ng-model=\"timeUpdate.minutes\" ng-change=\"updateTimeDuration()\" type=\"number\" max=\"59\" required=\"\"></section><div layout=\"\" layout-align=\"space-between center\" class=\"md-padding md-margin\"><h4>Current Allotted Time : {{task.allottedDurationObject.display}}</h4><h4>Updated Time : {{timeUpdate.updatedDurationObject.display}}</h4></div><div style=\"max-width: 60%;margin: 20px auto 0 auto\"><h5 class=\"center-text\">Select Reason For Time Update</h5><md-radio-group ng-model=\"selectedReason\" class=\"md-padding\" required=\"\"><md-list><md-list-item ng-repeat=\"reason in reasons\"><p>{{reason.title}}</p><md-radio-button class=\"md-secondary md-primary\" ng-value=\"reason\"></md-radio-button></md-list-item></md-list></md-radio-group><md-input-container ng-if=\"selectedReason.title === \'Others\'\" class=\"md-block\"><label>Enter Reason for Time Change</label> <textarea rows=\"2\" ng-model=\"selectedReason.value\" required=\"\"></textarea></md-input-container></div></form></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-primary outline\" ng-disabled=\"savingTime || updateTimeForm.$invalid\" ng-click=\"updateTime()\"><bubble-loader ng-if=\"savingTime\"></bubble-loader><span ng-if=\"!savingTime\">Save</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/offers/giftCards/all/activateCard/partials/index.tmpl.html","<md-dialog flex=\"60\" class=\"activate-card-modal\"><md-toolbar layout=\"\" layout-align=\"center center\" class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"center center\"><h4>Activate Cards</h4></div><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></div></md-toolbar><md-divider></md-divider><md-dialog-content><div class=\"relative\"><section class=\"overlay-loader\" ng-if=\"loading\" layout=\"\" layout-align=\"center center\" style=\"z-index: 1;\"><md-progress-circular></md-progress-circular></section><md-card><md-card-content><div layout=\"column\" layout-align=\"center stretch\"><div layout=\"\" layout-align=\"start center\"><p class=\"md-title\">Organisation:</p></div><md-divider></md-divider><div layout=\"\" layout-align=\"space-around center\" class=\"agents-info\"><md-input-container class=\"agent-name\"><label>Organisation</label><md-select ng-model=\"cardDetails.organisation\" ng-change=\"getAgents()\"><md-option ng-value=\"organisation._id\" ng-repeat=\"organisation in organisations track by $index\">{{organisation.name}}</md-option></md-select></md-input-container></div></div></md-card-content></md-card><md-card><md-card-content><div layout=\"column\" layout-align=\"center stretch\"><div layout=\"\" layout-align=\"space-between center\"><p class=\"md-title\">Agent Details:</p><md-switch ng-model=\"editAgentBox\">Edit Agent</md-switch></div><md-divider></md-divider><div layout=\"\" layout-align=\"space-around center\" class=\"agents-info\"><md-input-container class=\"no-error-spacer md-secondary\"><label>Agent Name</label><md-select ng-disabled=\"!editAgentBox\" data-md-container-class=\"selectdemoSelectHeader\" ng-model=\"cardDetails.agent\" ng-change=\"selectAgent()\"><md-select-header class=\"demo-select-header\" md-no-float=\"\"><input ng-model=\"agentSearch\" ng-change=\"getAgents()\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option layout-fill=\"\" ng-if=\"loadingAgents\" value=\"\"><bubble-loader></bubble-loader></md-option><md-option ng-value=\"agent._id\" ng-repeat=\"agent in agents | orderBy : \'name\' track by $index\"><div layout=\"column\"><span>{{agent.name}}</span> <span>{{agent.mobile}}</span></div></md-option></md-select></md-input-container><md-input-container><label>Number</label> <input type=\"text\" ng-disabled=\"!editAgentBox\" ng-model=\"selectedAgent.mobile\"></md-input-container></div></div></md-card-content></md-card><md-card><md-card-content><div layout=\"column\" layout-align=\"center stretch\"><div layout=\"\" layout-align=\"space-between center\"><p class=\"md-title\">Assign Customers:</p><md-switch ng-model=\"editUserBox\">Edit User</md-switch></div><md-divider></md-divider><div layout=\"\" class=\"customers-info\"><div ng-if=\"!editUserBox\" flex=\"40\"><md-input-container><label>Name</label> <input ng-disabled=\"!editUserBox\" type=\"text\" ng-model=\"cardDetails.user.name\"></md-input-container></div><div ng-if=\"editUserBox\" class=\"carDetailsUserName\" flex=\"40\"><md-autocomplete md-no-cache=\"true\" md-selected-item=\"selectedCustomer\" md-search-text=\"searchText\" md-selected-item-change=\"selectedCustomerChange(user)\" md-items=\"user in query(searchText)\" md-min-length=\"2\" md-item-text=\"user.name\" md-floating-label=\"Search user by mobile number\"><md-item-template><div layout=\"\" layout-align=\"stretch center\"><div layout=\"column\"><p md-highlight-text=\"searchText\">{{user.name}} ({{user.mobile}}) - {{user.email}}</p></div><span flex=\"20\"></span></div></md-item-template><md-not-found><a ng-click=\"newCustomerModal($event, searchText)\">Create a new one!</a> No users matching \"{{searchText}}\" were found.</md-not-found></md-autocomplete></div><md-input-container flex=\"30\"><label>Email</label> <input ng-disabled=\"!editUserBox\" type=\"email\" ng-model=\"cardDetails.user.email\"></md-input-container><md-input-container flex=\"30\"><label>Number</label> <input ng-disabled=\"!editUserBox\" type=\"text\" ng-model=\"cardDetails.user.mobile\"></md-input-container></div></div></md-card-content></md-card><md-card><md-card-content><div layout=\"column\" layout-align=\"center stretch\"><div layout=\"\" layout-align=\"start center\"><p class=\"md-title\">Load Amount:</p></div><md-divider></md-divider><div layout=\"\" layout-align=\"space-around center\" class=\"amount-info\"><span>Balance : Rs {{cardDetails.balance}}</span><div layout=\"\" layout-align=\"center center\"><md-input-container class=\"no-error-spacer\"><label>Recharge Amount</label> <input type=\"number\" ng-model=\"cardDetails.rechargeAmount\"></md-input-container></div><md-input-container><label>Status</label><md-select ng-model=\"cardDetails.status\" class=\"no-error-spacer\"><md-option ng-value=\"currentStatus.value\" ng-repeat=\"currentStatus in status\">{{currentStatus.type}}</md-option></md-select></md-input-container></div></div></md-card-content></md-card><md-card ng-if=\"cardDetails.shortLink\"><md-card-content layout=\"column\" layout-align=\"center center\"><h5>Gift Card Short Link</h5><pre>{{cardDetails.shortLink}}</pre></md-card-content></md-card></div></md-dialog-content><md-dialog-actions><md-button class=\"md-primary\" ng-disabled=\"isActivating || !cardDetails\" ng-click=\"checkAndSave()\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!isActivating\">Submit</span><md-progress-circular md-diameter=\"20\" ng-if=\"isActivating\"></md-progress-circular></div></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/offers/giftCards/all/activateCard/partials/newCustomer.tmpl.html","<md-dialog flex=\"50\" class=\"addNewCustomer-modal\"><md-toolbar layout=\"\" layout-align=\"center center\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"center center\"><h4>Add New Customer</h4></div><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></div></md-toolbar><md-dialog-content class=\"md-dialog-content\"><div layout=\"column\" layout-align=\"center center\"><form name=\"newCustomerForm\" class=\"customer-form\"><div layout=\"\" layout-align=\"space-between center\"><md-input-container flex=\"45\" class=\"md-block\"><label class=\"md-required\">Name</label> <input required=\"\" ng-minlength=\"3\" type=\"text\" name=\"name\" ng-model=\"newCustomer.name\"><div ng-messages=\"newCustomerForm.name.$error\" class=\"md-input-messages-animation md-auto-hide\" aria-live=\"assertive\"><div ng-message=\"required\" class=\"md-input-message-animation\">Name is required.</div><div ng-message=\"md-maxlength\" class=\"md-input-message-animation\">The name has to be less than 30 characters long.</div></div></md-input-container><md-input-container flex=\"45\" flex-offset=\"10\" class=\"md-block\"><label class=\"md-required\">Mobile Number</label> <input type=\"tel\" ng-pattern=\"/^[56789][0-9]{9}$/\" name=\"mobile\" md-maxlength=\"10\" ng-minlength=\"10\" ng-maxlength=\"10\" required=\"\" ng-model=\"newCustomer.mobile\"></md-input-container></div><div layout=\"\" layout-align=\"start center\"><md-input-container flex=\"45\" class=\"md-block md-boring-theme\"><label>Email</label> <input md-maxlength=\"40\" type=\"email\" ng-model=\"newCustomer.email\"></md-input-container></div></form></div></md-dialog-content><md-dialog-actions><md-button class=\"md-primary\" ng-click=\"addCustomer()\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!isAdding\">Add</span><md-progress-circular md-diameter=\"20\" ng-if=\"isAdding\"></md-progress-circular></div></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/scm/materials/details/deductStockDialog/partials/deductStock.tmpl.html","<md-dialog flex=\"50\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-subhead\">Deduct Stock</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><div layout=\"\" layout-align=\"center center\"><md-card flex=\"75\"><md-card-title><md-card-title-text><p class=\"md-body-1\">{{material.name}}</p><p class=\"md-caption\">SKU : {{material.sku}}</p><p class=\"md-subhead\">Available Stock: {{stock}}</p></md-card-title-text><md-card-title-media><div class=\"md-media-sm card-media\"><md-img ng-if=\"material.image && material.image.urls\" md-src=\"{{material.image.urls.thumbnail}}\"></md-img></div></md-card-title-media></md-card-title></md-card></div><div layout=\"\" layout-align=\"end center\" class=\"md-padding md-margin\"></div><form name=\"deductStockForm\" layout=\"\" layout-wrap=\"\" layout-align=\"center center\" class=\"md-margin md-padding\"><section layout=\"column\" layout-align=\"center center\" class=\"md-padding md-margin\" flex=\"100\"><md-input-container style=\"width: 250px\"><label>Select Adjust Type</label><md-select ng-model=\"newBatchStock.updateType\" required=\"\" ng-change=\"calculateRemainingStock()\"><md-option value=\"inc\">Add Stock</md-option><md-option value=\"dec\">Deduct Stock</md-option><md-option value=\"lease\">Lease Stock</md-option></md-select></md-input-container><md-input-container ng-if=\"newBatchStock.updateType === \'lease\'\" style=\"width: 250px\"><label>Select Person Leasing To</label><md-select ng-model=\"selectedOperator.details\" ng-change=\"changeOperator()\" required=\"\" name=\"selectedOperator\"><md-option ng-repeat=\"operator in operators | orderBy\" ng-value=\"operator\">{{operator.name}}</md-option></md-select></md-input-container><md-input-container ng-if=\"newBatchStock.updateType === \'dec\' || newBatchStock.updateType === \'lease\'\" style=\"width: 250px\"><label>Select Order to Link</label><md-select data-md-container-class=\"selectdemoSelectHeader\" ng-model=\"newBatchStock.order\" ng-change=\"generateRemark()\"><md-select-header class=\"demo-select-header\" md-no-float=\"\"><input ng-model=\"$parent.orderSearch\" ng-change=\"getOrders()\" placeholder=\"Search for Order by Name or Order Number\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option layout-fill=\"\" ng-if=\"loadingOrders\" value=\"\"><bubble-loader></bubble-loader></md-option><md-option ng-repeat=\"order in orders\" ng-value=\"order\"><p class=\"md-caption\" style=\"margin-bottom: 0;\">{{order.orderNumber}}</p><span class=\"md-tiny\">{{order.fullUser.name}}</span></md-option></md-select></md-input-container></section><div layout=\"\" layout-align=\"space-between center\" flex=\"100\"><md-input-container flex=\"40\"><label>{{newBatchStock.updateType === \'inc\' ? \'Addition \' : \'Subtraction \'}} Quantity</label> <input type=\"number\" min=\"0\" max=\"{{newBatchStock.updateType === \'inc\' ? 99 : stock}}\" ng-change=\"calculateRemainingStock()\" name=\"qty\" ng-model=\"newBatchStock.quantity\" placeholder=\"Amount between 0 and {{newBatchStock.updateType === \'inc\' ? 99 : stock}}\" required=\"\"><div ng-messages=\"deductStockForm.qty.$error\" ng-if=\"deductStockForm.qty.$touched\" role=\"alert\"><div ng-message=\"required\">You <b>must</b> enter a valid number between 0 and {{newBatchStock.updateType === \'inc\' ? 99 : stock}}.</div><div ng-message=\"max\">Value cannot be greater than {{newBatchStock.updateType === \'inc\' ? 99 : stock}}</div></div></md-input-container><p class=\"grey-text\">Updated Stock after saving : <b class=\"black-text\">{{remainingStock}}</b></p><span flex=\"10\"></span></div><div layout=\"\" layout-align=\"stretch center\" flex=\"100\"><md-input-container flex=\"100\"><label>Remarks</label> <textarea ng-model=\"newBatchStock.remarks\" rows=\"3\" required=\"\" name=\"remarks\" placeholder=\"Be detailed for example Deducted for processing the order with Order number {{newBatchStock.order.orderNumber}}\">\n                    </textarea><div ng-messages=\"deductStockForm.remarks.$error\" ng-if=\"deductStockForm.remarks.$touched\" role=\"alert\"><div ng-message=\"required\">You <b>must</b> enter the remarks for this update.</div></div></md-input-container></div></form></md-dialog-content><span flex=\"\"></span><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-accent md-warn\" ng-click=\"closeDialog()\">Cancel</md-button><md-button class=\"md-accent outline\" ng-disabled=\"deductStockForm.$invalid || updatingStock\" ng-click=\"updateStock()\"><span ng-if=\"!updatingStock\">Update Stock</span><bubble-loader ng-if=\"updatingStock\"></bubble-loader></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/scm/materials/details/manageProductStockDialog/partial/make-product-out-of-stock.tmpl.html","<md-dialog class=\"make-product-out-of-stock-dialog\" flex=\"70\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"center center\"><h4>Make Product Out Of Stock</h4></div><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><div layout=\"column\" layout-align=\"center center\"><md-card flex=\"60\" layout=\"\" layout-align=\"stretch center\"><md-card-title><md-card-title-text><p class=\"md-body-1\">{{product.name}}</p><p class=\"md-caption\">SKU : {{product.sku}}</p></md-card-title-text><md-card-title-media><div class=\"md-media-sm card-media\"><md-img md-src=\"{{mediaUrl + product.featured_image.urls.thumbnail}}\"></md-img></div></md-card-title-media></md-card-title></md-card><div layout=\"\" layout-align=\"center centre\"><md-input-container flex=\"50\"><md-select ng-model=\"reason\"><label>Reason</label><md-option>Select reason for making this variation out of stock</md-option><md-option ng-repeat=\"reason in reasons\" ng-value=\"reason\">{{reason.text}}</md-option></md-select></md-input-container></div></div></md-dialog-content><md-divider></md-divider><md-dialog-actions><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-click=\"makeProductVariationOutOfStock()\" ng-diabled=\"makingOutOfStock\"><span ng-if=\"!makingOutOfStock\">Save</span><md-progress-circular class=\"md-primary\" md-diameter=\"10\" ng-if=\"makingOutOfStock\"></md-progress-circular></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/scm/materials/details/manageProductStockDialog/partial/manage-product-stock.tmpl.html","<md-dialog class=\"manage-product-stock-dialog\" flex=\"90\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"center center\"><h4>Product List</h4></div><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><div layout=\"\" layout-align=\"space-between center\" class=\"md-padding md-margin\"><h3 class=\"md-subhead\">Total Available Material Stock: {{totalAvailableStock}}</h3><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-primary small outline\" ng-click=\"openMakeOutOfStockDialog(variation)\">Make Out of Stock</md-button><md-button class=\"md-primary small outline\" ng-click=\"openAddMaterialToPurchaseListDialog()\">Add To List</md-button></div></div><md-table-container><div layout=\"\" layout-align=\"center center\" ng-if=\"!orders && !orders.length\"><md-progress-circular ng-if=\"loadingOrders && !orders\" md-diameter=\"40\" class=\"md-primary\"></md-progress-circular><span class=\"md-caption\" ng-if=\"loadingOrders && !orders\">Loading Orders.....</span></div><div layout=\"\" layout-align=\"stretch center\" ng-if=\"orders && orders.length && !loadingOrders\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\">Sl.</th><th md-column=\"\">Order Number</th><th md-column=\"\">Line Item Image</th><th md-column=\"\">Name</th><th md-column=\"\">Selected Variation</th><th md-column=\"\">Materials Required</th><th md-column=\"\">Stock Before Processing</th><th md-column=\"\">Consumption</th><th md-column=\"\">Remaining Stock</th></tr></thead><md-divider></md-divider><tbody md-body=\"\"><tr md-row=\"\" md-select=\"card\" md-auto-select=\"\" style=\"height: 75px\" ng-repeat=\"order in orders\"><td md-cell=\"\">{{ $index + 1}}.</td><td md-cell=\"\"><div layout=\"\" layout-align=\"center start\"><p ng-class=\"{\'canBeProcessed\': order.canBeProcessed, \'cannotBeProcessed\': !order.canBeProcessed }\" style=\"cursor: pointer\">{{order.orderNumber}}<md-tooltip><span>{{order.canBeProcessed ? \'lineItem can be processed\' : \'Available stock in inventory is not sufficient to process this lineItem. Please notify Merchandiser\'}}</span></md-tooltip></p><md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-click=\"$event.stopPropagation(); showToast(\'Copied Order Number to Clipboard\')\" data-clipboard-text=\"{{order.orderNumber}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy Name</md-tooltip></md-button></div></td><td md-cell=\"\"><md-img class=\"line-item-image\" md-src=\"{{order.image.urls.thumbnail}}\"></md-img></td><td md-cell=\"\"><div layout=\"\" layout-align=\"center center\">{{order.name}}<md-button class=\"md-icon-button small\" ngclipboard=\"\" ng-click=\"$event.stopPropagation(); showToast(\'Copied Product Name to Clipboard\')\" data-clipboard-text=\"{{order.name}}\"><md-icon>content_copy</md-icon><md-tooltip>Copy Name</md-tooltip></md-button></div></td><td md-cell=\"\">{{order.selectedVariationText}}</td><td md-cell=\"\" ng-repeat=\"material in order.variationId.materials\">{{material.consumption}} m.</td><td md-cell=\"\">{{order.currentStock}} m.</td><td md-cell=\"\" ng-repeat=\"material in order.variationId.materials\">{{material.consumption}} m.</td><td md-cell=\"\">{{order.remainingMaterialStock}} m.</td></tr></tbody></table></div></md-table-container></md-dialog-content><md-divide></md-divide><md-dialog-actions><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"close()\">Close</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/scm/materials/details/unleaseStock/partial/unleaseStock.tmpl.html","<md-dialog flex=\"70\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-subhead\">Unlease Stock</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><md-table-container><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\" md-order=\"query.orderBy\" md-on-reorder=\"reorder\"><tr md-row=\"\" md-colors=\"{\'background\' : \'boring-accent-50-0.1\'}\"><th md-column=\"\">Sl</th><th md-column=\"\" md-order-by=\"orderNumber\">Quantity Leased</th><th md-column=\"\" md-order-by=\"status\">Leased By</th><th md-column=\"\" md-order-by=\"createdAt\" md-numeric=\"\"><span>Leased on</span></th><th md-column=\"\">Actions</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"order\" md-auto-select=\"\" ng-repeat=\"item in history track by $index\" style=\"height: 75px;\"><td md-cell=\"\">{{$index + 1}}.</td><td md-cell=\"\" clas=\"md-tiny\">{{item.quantity}}</td><td md-cell=\"\" clas=\"md-tiny\">{{item.operatorName}}</td><td md-cell=\"\" clas=\"md-tiny\">{{item.updatedAt | date: \"medium\"}}</td><td md-cell=\"\"><md-button class=\"md-primary outline small\" ng-click=\"unleaseStock($event, $index, item.quantity, item._id)\">Unlease</md-button></td></tr></tbody></table></md-table-container></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/scm/materials/modals/addBatchDialog/partials/addBatch.tmpl.html","<md-dialog flex=\"50\"><md-toolbar class=\"md-accent md-hue-1\" layout=\"\" layout-align=\"center center\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-subhead\">{{editingBatch ? \"Edit Batch\" : \"Add New Batch\"}}</span><md-button class=\"md-icon-button\" ng-click=\"cancelDialog()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><div layout=\"column\" layout-align=\"center center\"><form name=\"addBatchForm\" class=\"md-padding md-margin\" layout=\"\" layout-wrap=\"\" layout-align=\"stretch center\"><section class=\"md-margin\" flex=\"100\" style=\"margin-bottom: 32px\"><div layout=\"\" layout-align=\"start center\" ng-if=\"!batch.vendor\"><span><i>Suggestions :</i></span><md-button class=\"md-primary round outline small\" ng-click=\"selectSuggestedVendor(\'NoVendor\')\">No Vendor</md-button></div><md-autocomplete md-selected-item=\"selectedVendor\" ng-if=\"!batch.vendor\" md-search-text=\"vendorSearchText\" md-min-length=\"3\" md-input-name=\"vendorAutocomplete\" required=\"\" md-floating-label=\"Select Vendor\" md-escape-options=\"none\" md-selected-item-change=\"addVendorToData(selectedVendor)\" md-menu-class=\"customer-autocomplete-results\" placeholder=\"Search for Vendors by Name\" md-items=\"item in vendorQuery(vendorSearchText)\"><md-item-template><div layout=\"\" layout-align=\"stretch center\"><span md-highlight-text=\"vendorSearchText\">{{item.name}} ({{item.gstNumber}})</span></div></md-item-template><md-not-found><a ng-click=\"createVendor(vendorSearchText)\">Create a new vendor!</a> No vendors matching \"{{vendorSearchText}}\" were found.</md-not-found><div ng-messages=\"addBatchForm.vendorAutocomplete.$error\" ng-if=\"addBatchForm.vendorAutocomplete.$touched\"><div ng-message=\"required\">You <b>must</b> select a vendor.</div><div ng-message=\"minlength\">Your entry is not long enough.</div></div></md-autocomplete><div layout=\"row\" layout-align=\"space-between center\" class=\"autocomplete-chip\" ng-if=\"batch.vendor\"><section layout=\"column\"><span class=\"bold-text\">Vendor : {{batch.vendor.name}}</span> <span class=\"md-caption\">{{batch.vendor.gstNumber}}</span></section><md-button class=\"md-icon-button\" ng-click=\"removeVendor()\"><md-icon>close</md-icon><md-tooltip>Remove Vendor</md-tooltip></md-button></div><md-input ng-model=\"batch.vendor\" hidden=\"\" required=\"\"></md-input></section><md-input-container class=\"md-block\" flex=\"50\"><label>Entry Stock</label> <input required=\"\" type=\"number\" ng-change=\"reCalculateData()\" ng-model=\"batch.entryStock\"></md-input-container><md-input-container class=\"md-block\" flex=\"45\" flex-offset=\"5\"><label>In Rate</label> <input required=\"\" type=\"number\" ng-change=\"reCalculateData()\" ng-model=\"batch.inRate\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Tax %</label><md-select ng-model=\"batch.taxString\" required=\"\" ng-change=\"reCalculateData()\"><md-optgroup label=\"GST\"><md-option ng-repeat=\"gstTax in taxGroups.GST\" ng-value=\"gstTax.value\">GST {{gstTax.actualValue}}%</md-option></md-optgroup><md-optgroup label=\"IGST\"><md-option ng-repeat=\"gstTax in taxGroups.IGST\" ng-value=\"gstTax.value\">GST {{gstTax.actualValue}}%</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"40\" flex-offset=\"10\"><md-switch ng-change=\"reCalculateData()\" ng-model=\"batch.batchTax.isInclusive\">Is Inclusive</md-switch></md-input-container><md-input-container class=\"md-block\" flex=\"40\"><label>Tax Amount</label> <input required=\"\" type=\"number\" ng-model=\"batch.tax\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\" flex-offset=\"10\"><label>Price</label> <input required=\"\" disabled=\"\" type=\"number\" ng-model=\"batch.price\"></md-input-container><div layout=\"\" layout-align=\"center center\" flex=\"100\"><image-selector ng-model=\"batch.image\" placeholder=\"Select Image\"></image-selector></div></form></div></md-dialog-content><md-dialog-actions><div layout=\"\" layout-align=\"center center\" flex=\"\"><md-button class=\"md-warn\" ng-click=\"cancelDialog()\">Cancel</md-button><span flex=\"\"></span><md-button class=\"md-primary\" ng-click=\"saveBatch()\" ng-disabled=\"addBatchForm.$invalid || saving\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!saving\">{{editingBatch ? \"Edit Batch\" : \"Save Batch\"}}</span><md-progress-circular md-diameter=\"20\" ng-if=\"saving\"></md-progress-circular></div></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/scm/materials/modals/addMaterialModel/partials/addMaterial.tmpl.html","<md-dialog flex=\"75\"><form name=\"addMaterialForm\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-subhead\">{{editingMaterial ? \"Edit Material\" : \" Create Material\"}}</span><md-button class=\"md-icon-button\" ng-click=\"cancelDialog()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"relative\"><div layout=\"column\" flex=\"\" layout-align=\"center center\"><div class=\"md-padding md-margin\" layout=\"\" layout-wrap=\"\" layout-align=\"space-between center\"><md-input-container class=\"md-block\" flex=\"50\"><label>Material Name</label> <input required=\"\" ng-minlength=\"3\" name=\"name\" ng-blur=\"detectDuplicates()\" type=\"text\" ng-model=\"material.name\"></md-input-container><md-input-container class=\"md-block\" flex=\"45\" flex-offset=\"5\"><label>Material Sale Price</label> <input required=\"\" name=\"salePrice\" type=\"number\" ng-model=\"material.salePrice\"></md-input-container><section flex=\"100\" layout=\"\" layout-align=\"center center\"><md-input-container class=\"md-block\" flex=\"\"><label>Select Material Categories</label><md-select ng-model=\"material.category\" required=\"\" multiple=\"\" data-md-container-class=\"selectHeader\" name=\"category\"><md-select-header class=\"select-header demo-select-header\"><input ng-model=\"material.categorySearch\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search for a category..\" class=\"header-searchbox md-text\"></md-select-header><md-option ng-value=\"category._id\" ng-repeat=\"category in materialCategories | filter : material.categorySearch\">{{category.name}}</md-option></md-select></md-input-container><div flex=\"5\" class=\"md-caption grey-text\" layout=\"\" layout-align=\"center center\">or</div><md-button class=\"outline\" ng-click=\"openCategoryDialog($event)\"><md-icon>add</md-icon>Add New Category</md-button></section><section flex=\"100\" layout=\"\" layout-align=\"center center\"><image-selector placeholder=\"Select Material Image\" ng-model=\"material.image\"></image-selector></section><md-input-container class=\"md-block hide\" flex=\"45\" flex-offset=\"5\"><label>Material Sku</label> <input name=\"sku\" placeholder=\"Auto Generated\" disabled=\"\" type=\"text\" ng-model=\"material.sku\"></md-input-container></div></div><div class=\"duplicate-panel md-whiteframe-12dp slide-up-fade-in\" ng-if=\"showDuplicateConfirmation\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span>Detected Duplicates</span><md-button class=\"md-icon-button\" ng-click=\"denyDuplicate()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><div layout=\"column\" class=\"md-padding\"><p>Detected {{duplicates.length}} materials with a similar name to the material that you currently adding. Are you sure that the material that you are adding isn\'t already present as one of these materials? If yes, please add a new batch in one of the materials listed below.</p><md-list><md-list-item ng-repeat-start=\"material in duplicates\"><md-img md-src=\"{{material.image.urls.thumbnail}}\" class=\"md-avatar\"></md-img><p>{{material.name}}</p></md-list-item><md-divider ng-repeat-end=\"\"></md-divider></md-list></div><div layout=\"\" layout-align=\"space-between center\" ng-click=\"acceptDuplicate()\"><md-button class=\"md-warn outline\" ng-click=\"\">Yes. It is a duplicate.</md-button><md-button class=\"md-primary outline\" ng-click=\"denyDuplicate()\">No. It is not a duplicate.</md-button></div></div></md-dialog-content><md-dialog-actions><div layout=\"\" layout-align=\"stretch center\" flex=\"\"><md-button class=\"md-warn\" ng-click=\"cancelDialog()\">Cancel</md-button><span flex=\"\"></span><md-button class=\"md-primary\" ng-disabled=\"addMaterialForm.$invalid || savingMaterial\" ng-click=\"saveMaterial()\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!savingMaterial\">{{editingMaterial ? \"Edit Material\" : \" Save Material\"}}</span><md-progress-circular md-diameter=\"20\" ng-if=\"savingMaterial\"></md-progress-circular></div></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/scm/materials/modals/addVendorModel/partials/addVendor.tmpl.html","<md-dialog flex=\"50\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-subhead\">{{editingVendor ? \"Edit Vendor\" : \"Add Vendor\"}}</span><md-button class=\"md-icon-button\" ng-click=\"cancelDialog()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><div layout=\"column\" layout-align=\"stretch center\"><form name=\"addVendorForm\" class=\"md-padding md-margin\" layout=\"\" layout-wrap=\"\" layout-align=\"space-between center\"><md-input-container class=\"md-block\" flex=\"50\"><label>Vendor Name</label> <input required=\"\" ng-minlength=\"3\" name=\"name\" ng-blur=\"capitalize()\" type=\"text\" ng-model=\"vendor.name\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Gst Number</label> <input name=\"gstNumber\" type=\"text\" ng-minlength=\"10\" minlength=\"10\" ng-change=\"vendor.gstNumber = (vendor.gstNumber | uppercase)\" ng-pattern=\"/^\\d{2}[A-Z]{5}\\d{4}[A-Z]{1}[A-Z\\d]{1}[Z]{1}[A-Z\\d]{1}/\" ng-model=\"vendor.gstNumber\"></md-input-container></form></div></md-dialog-content><md-dialog-actions><div layout=\"\" layout-align=\"space-between center\" flex=\"\"><md-button class=\"md-warn\" ng-click=\"cancelDialog()\">cancel</md-button><md-button class=\"md-primary\" ng-click=\"saveVendor()\" ng-disabled=\"addVendorForm.$invalid || saving\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!saving\">{{editingVendor ? \"Edit Vendor\" : \"Save Vendor\"}}</span><md-progress-circular md-diameter=\"20\" ng-if=\"saving\"></md-progress-circular></div></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/scm/materials/modals/addCategoryModel/partials/addCategory.tmpl.html","<md-dialog flex=\"60\"><form name=\"categoryForm\" flex=\"\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\"><h2>{{ editingMode ? \"Edit \" + newCategory.name : \"Add New Category\"}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancelDialog()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><div layout=\"row\" layout-wrap=\"\" class=\"md-padding\"><md-input-container class=\"md-block\" flex=\"50\"><label>Name</label> <input type=\"text\" ng-blur=\"capitalize()\" ng-model=\"newCategory.name\" required=\"\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Parent Category</label><md-select ng-model=\"newCategory.parent\"><md-option value=\"\">Select Parent</md-option><md-option ng-repeat=\"category in parentCategories\" ng-value=\"category._id\"><span>{{category.name}}</span></md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>Description</label> <textarea ng-model=\"newCategory.description\"></textarea></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>PAGE Title</label> <textarea ng-model=\"newCategory.seo.title\"></textarea></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>SEO Description</label> <textarea ng-model=\"newCategory.seo.description\"></textarea></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>SEO Keywords</label> <textarea ng-model=\"newCategory.seo.keywords\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions><div layout=\"row\" flex=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"cancelDialog();\">Cancel</md-button><md-button class=\"md-primary\" ng-click=\"saveCategory();\" ng-disabled=\"categoryForm.$invalid || saving\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!saving\"><md-icon>{{editingMode ? \'edit\' : \'add\'}}</md-icon>{{ editingMode ? \"Update\" : \"Save\" }}</span><md-progress-circular md-diameter=\"20\" ng-if=\"saving\"></md-progress-circular></div></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/scm/materials/details/manageProductStockDialog/addItemToPurchaseList/partials/add-item-to-purchase-list.tmpl.html","<md-dialog class=\"manage-product-stock-dialog\" flex=\"80\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"center center\"><h4>Purchase List</h4></div><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><md-card ng-if=\"newPurchase\"><section layout=\"\" layout-align=\"stretch center\" layout-wrap=\"\" class=\"md-margin md-padding\"><md-input-container flex=\"30\"><label>Select Merchandiser</label><md-select ng-model=\"$parent.addedFor\" ng-change=\"selectMerchandiser(addedFor)\"><md-option ng-repeat=\"merchandiser in merchandisers\" ng-value=\"merchandiser\">{{merchandiser.name}}</md-option></md-select></md-input-container><md-input-container flex=\"30\" flex-offset=\"5\"><label>Select Due date</label><md-datepicker ng-model=\"$parent.dueDate\" md-placeholder=\"Due date\"></md-datepicker></md-input-container><md-input-container flex=\"30\" flex-offset=\"5\"><label>Set Priority</label><md-select ng-model=\"priority\" ng-change=\"setPriority(priority)\"><md-option ng-repeat=\"priority in priorities\" ng-value=\"priority\">{{priority}}</md-option></md-select></md-input-container><md-input-container flex=\"30\"><label>Minimum Quantity</label> <input type=\"number\" ng-model=\"$parent.minimumQuantity\" placeholder=\"Please, state the minimum quantity of material needed\"></md-input-container><md-input-container flex=\"30\"><label>Maximum Quantity</label> <input type=\"number\" ng-model=\"$parent.maximumQuantity\" placeholder=\"Please, state the maximum quantity of material needed\"></md-input-container><md-input-container flex=\"30\" flex-offset=\"10\"><label>Select Vendor</label><md-select data-md-container-class=\"selectdemoSelectHeader\" ng-model=\"$parent.vendor\" ng-change=\"setVendor($parent.vendor)\"><md-select-header class=\"demo-select-header\" md-no-float=\"\"><input ng-model=\"$parent.vendorSearch\" ng-change=\"fetchVendors()\" placeholder=\"Search for Vendor by Name or gstNumber\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option layout-fill=\"\" ng-if=\"loadingVendors\" value=\"\"><bubble-loader></bubble-loader></md-option><md-option ng-repeat=\"vendor in vendors\" ng-value=\"vendor._id\"><p class=\"md-caption\" style=\"margin-bottom: 0;\">{{vendor.name}}</p><span class=\"md-tiny\">{{vendor.gstNumber}}</span></md-option></md-select></md-input-container></section></md-card><div layout=\"column\" layout-align=\"stretch center\" ng-if=\"!newPurchase\"><div layout=\"\" layout-align=\"start center\" class=\"md-margin md-padding\"><h4>Provide the quantity that you need and select the list that needs to br updated.</h4></div><div layout=\"\" layout-align=\"center center\" class=\"md-margin md-padding\"><md-input-container flex=\"20\" flex-offset=\"5\"><label>Minimum Quantity</label> <input type=\"number\" ng-model=\"$parent.minimumQuantity\" placeholder=\"Please, state the minimum quantity of material needed\"></md-input-container><md-input-container flex=\"20\" flex-offset=\"5\"><label>Set Priority</label><md-select ng-model=\"priority\" ng-change=\"setPriority(priority)\"><md-option ng-repeat=\"priority in priorities\" ng-value=\"priority\">{{priority}}</md-option></md-select></md-input-container><md-input-container flex=\"20\" flex-offset=\"5\"><label>Select Vendor</label><md-select data-md-container-class=\"selectdemoSelectHeader\" ng-model=\"$parent.vendor\" ng-change=\"setVendor($parent.vendor)\"><md-select-header class=\"demo-select-header\" md-no-float=\"\"><input ng-model=\"$parent.vendorSearch\" ng-change=\"fetchVendors()\" placeholder=\"Search for Vendor by Name or mobile\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option layout-fill=\"\" ng-if=\"loadingVendors\" value=\"\"><bubble-loader></bubble-loader></md-option><md-option ng-repeat=\"vendor in vendors\" ng-value=\"vendor._id\"><p class=\"md-caption\" style=\"margin-bottom: 0;\">{{vendor.name}}</p><span class=\"md-tiny\">{{vendor.mobile}}</span></md-option></md-select></md-input-container><md-input-container flex=\"20\" flex-offset=\"5\"><label>Select Due date</label><md-datepicker ng-model=\"$parent.dueDate\" md-placeholder=\"Due date\"></md-datepicker></md-input-container></div><div layout=\"\" layout-align=\"stretch center\" ng-if=\"listItems && listItems.length && !fetchingPreviousPurchases\"><md-radio-group flex=\"\" ng-model=\"$parent.$parent.purchaseId\"><table md-table=\"\" md-row-select=\"\" multiple=\"\" ng-model=\"selected\" md-progress=\"promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\">Sl.</th><th md-column=\"\">Merchandiser</th><th md-column=\"\">Minimum Quantity</th><th md-column=\"\">Maximum Quantity</th><th md-column=\"\">Due Date</th><th md-column=\"\">Status</th><th md-column=\"\">Priority</th></tr></thead><md-divider></md-divider><tbody md-body=\"\"><tr md-row=\"\" md-select=\"card\" md-auto-select=\"\" style=\"height: 75px\" ng-repeat=\"item in listItems track by $index\"><td md-cell=\"\"><md-radio-button class=\"md-secondary\" ng-value=\"item._id\"></md-radio-button></td><td md-cell=\"\">{{ $index + 1}}.</td><td md-cell=\"\">{{item.addedFor.name}}</td><td md-cell=\"\">{{item.minimumQuantity}}</td><td md-cell=\"\">{{item.maximumQuantity ? item.maximumQuantity : \'N/A\'}}</td><td md-cell=\"\">{{item.dueDate | date: \'medium\'}}</td><td md-cell=\"\">{{item.status}}</td><td md-cell=\"\">{{item.priority}}</td></tr></tbody></table></md-radio-group></div></div></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"stretch center\"><md-button class=\"md-accent md-raised\" ng-click=\"close()\">Close</md-button><span flex=\"\"></span><md-button class=\"md-primary md-raised\" ng-click=\"addItemToList()\" ng-disabled=\"addingItemToList\"><span ng-if=\"!addingItemToList\">Create</span><md-progress-circular md-diameter=\"10\" class=\"md-primary\" ng-if=\"addingItemToList\"></md-progress-circular></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/scm/materials/details/unleaseStock/stockReturnedBeforeUnleasing/partial/stockReturned.tmpl.html","<md-dialog flex=\"40\"><md-toolbar class=\"md-accent md-hue-1\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-subhead\">Stock\'s Returned</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content><section layout=\"column\" layout-align=\"stretch center\"><div layout=\"\" layout-align=\"start center\" class=\"md-padding oldQuantity\" flex=\"100\"><md-chips><md-chip>Leased Quantity: {{leasedQuantity}}</md-chip></md-chips></div><div layout=\"column\" layout-align=\"center center\"><p class=\"md-tiny\">* Unselect the checkbox if not fully exhausted and provide the left-quantity</p></div><form name=\"updateQuantityAfterReturningStock\" layout=\"\" layout-align=\"space-around center\" class=\"md-margin md-padding\"><div layout=\"\" layout-align=\"space-between center\"><md-input-container flex=\"50\"><input type=\"number\" min=\"0\" max=\"{{leasedQuantity}}\" name=\"newQuantity\" ng-model=\"returnedStock.leftQuantity\" ng-disabled=\"fullyExhausted\" class=\"md-accent\" placeholder=\"Quantity Left\"><div ng-messages=\"updateQuantityAfterReturningStock.newQuantity.$error\" ng-if=\"updateQuantityAfterReturningStock.newQuantity.$touched\" role=\"alert\"><div ng-message=\"required\">You <b>must</b> enter a valid number between 0 and original leased quantity, {{leasedQuantity}}.</div><div ng-message=\"max\">Value cannot be greater than original leased quantity, {{leasedQuantity}}</div></div></md-input-container><md-input-container flex=\"40\" flex-offset=\"10\"><md-checkbox ng-model=\"fullyExhausted\">Fully Exhausted</md-checkbox></md-input-container></div></form></section></md-dialog-content><md-divider></md-divider><md-dialog-actions layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn md-raised\" ng-click=\"closeDialog()\">Cancel</md-button><md-button class=\"md-primary md-raised outline\" ng-disabled=\"updating\" ng-click=\"updateQuantity()\"><span ng-if=\"!updating\">Save</span><bubble-loader ng-if=\"updating\"></bubble-loader></md-button></md-dialog-actions></md-dialog>");}]);